// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../node_modules/react-time-picker/dist/TimePicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../node_modules/react-clock/dist/Clock.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../node_modules/react-datepicker/dist/react-datepicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!./style/datepicker-brand.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/img/theme/sidebar-bg-01.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/img/theme/sidebar-bg-02.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/img/theme/sidebar-bg-03.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/img/theme/sidebar-bg-04.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/assets/img/theme/sidebar-bg-05.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/img/theme/sidebar-bg-06.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/assets/img/theme/pattern-01.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/assets/img/theme/pattern-03.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../public/assets/img/authentication/Login_cover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../public/assets/img/authentication/register-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../public/assets/img/authentication/forgot-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../public/assets/img/authentication/reset-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/****** Utils ******/
/****** Layout ******/
::-webkit-scrollbar {
  width: 5px;
  height: 6px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #898989;
}

::-webkit-scrollbar-thumb {
  background: #e85b28;
}

::-webkit-scrollbar-thumb:hover {
  background: #898989;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FC0027 !important;
}

.text-green {
  color: #5CB85C !important;
}

.input-blocks input[type=text]:focus {
  border-color: #E8E8E8;
}

.input-group .scanner-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #e85b28;
  border-radius: 5px !important;
  width: 40px;
  color: #FFF;
  font-weight: 600;
  padding: 0;
}
.input-group .scanner-set:hover {
  background: #262A2A;
}

::-webkit-scrollbar {
  width: 5px;
  height: 6px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #898989;
}

::-webkit-scrollbar-thumb {
  background: #e85b28;
}

::-webkit-scrollbar-thumb:hover {
  background: #898989;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FC0027 !important;
}

.text-green {
  color: #5CB85C !important;
}

.input-blocks input[type=text]:focus {
  border-color: #E8E8E8;
}

.form-sorts {
  position: relative;
}
.form-sorts > a {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  background: #FFF;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  padding: 9px 21px;
}
@media (max-width: 991.98px) {
  .form-sorts > a {
    padding: 9px 12px;
  }
}
.form-sorts > a i {
  margin-right: 8px;
}
.form-sorts > a:hover {
  color: #262A2A;
}
.form-sorts > a.show {
  border: 1px solid #0092E4;
}
@media (max-width: 575.98px) {
  .form-sorts > a {
    width: 100%;
  }
}
.form-sorts .filter-dropdown-menu {
  padding: 24px;
  border-radius: 5px;
  background: #FFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 24px 0px rgba(188, 188, 188, 0.2509803922);
  position: absolute;
  z-index: 1;
  min-width: 400px;
  right: 0;
  top: 40px;
}
@media (max-width: 767.98px) {
  .form-sorts .filter-dropdown-menu {
    min-width: 270px;
  }
}
@media (max-width: 575.98px) {
  .form-sorts .filter-dropdown-menu {
    right: auto;
    right: initial;
    left: 0;
  }
}
.form-sorts.table-filter-show .filter-dropdown-menu {
  display: block;
  opacity: 1;
}
.form-sorts .filter-set-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 14px;
}
.form-sorts .filter-set-head h4 {
  margin-bottom: 10px;
}
.form-sorts .filter-set-head h4 i {
  margin-right: 8px;
}
@media (max-width: 991.98px) {
  .form-sorts .filter-set-head h4 {
    font-size: 16px;
  }
}
.form-sorts .filter-set-head a {
  color: #4A00E5;
  margin-bottom: 10px;
}
.form-sorts .filter-set-head a:hover {
  color: #e85b28;
}
.form-sorts .filter-set-content {
  margin-bottom: 24px;
}
.form-sorts .filter-set-content .filter-set-content-head a {
  display: flex;
  align-items: center;
  color: #262A2A;
  font-weight: 600;
  position: relative;
  padding-left: 16px;
}
.form-sorts .filter-set-content .filter-set-content-head a::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
}
.form-sorts .filter-set-content .filter-set-content-head a:not(.collapsed) {
  padding-left: 20px;
}
.form-sorts .filter-set-content .filter-set-content-head a:not(.collapsed)::before {
  content: "\\f078";
}
.form-sorts .filter-reset-btns a,
.form-sorts .filter-reset-btns button,
.form-sorts .filter-reset-btns .btn,
.form-sorts .filter-reset-btns .btn-light {
  width: 100%;
  min-height: 38px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #f3c8b8;
  background: #fff6f1;
  color: #bb4d22;
  transition: all 0.2s ease;
}
@media (max-width: 575.98px) {
  .form-sorts .filter-reset-btns a,
  .form-sorts .filter-reset-btns button,
  .form-sorts .filter-reset-btns .btn,
  .form-sorts .filter-reset-btns .btn-light {
    padding: 10px 14px;
  }
}
.form-sorts .filter-reset-btns a:hover, .form-sorts .filter-reset-btns a:focus,
.form-sorts .filter-reset-btns button:hover,
.form-sorts .filter-reset-btns button:focus,
.form-sorts .filter-reset-btns .btn:hover,
.form-sorts .filter-reset-btns .btn:focus,
.form-sorts .filter-reset-btns .btn-light:hover,
.form-sorts .filter-reset-btns .btn-light:focus {
  border-color: #e85b28;
  background: #ffefe8;
  color: #e85b28;
  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);
}
.form-sorts .filter-reset-btns a:disabled,
.form-sorts .filter-reset-btns button:disabled,
.form-sorts .filter-reset-btns .btn:disabled,
.form-sorts .filter-reset-btns .btn-light:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-reset-standard {
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #f3c8b8 !important;
  background: #fff6f1 !important;
  color: #bb4d22 !important;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.btn-reset-standard:hover,
.btn-reset-standard:focus {
  border-color: #e85b28 !important;
  background: #ffefe8 !important;
  color: #e85b28 !important;
  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);
}

.radio-btn-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.radio-btn-items .radio-btn {
  margin: 0 30px 10px 0;
}
.radio-btn-items .radio-btn:last-child {
  margin-right: 0;
}

/* =====================================================
   Global Reset Button Design System (all modules)
   ===================================================== */
:where(.btn-reset-standard,
.hr-clear-btn,
.filter-reset-btns .btn,
.filter-reset-btns a,
button[type=reset],
input[type=reset],
button[title*=Reset],
button[title*="Clear Filters"],
button[title*="Clear filters"]) {
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #f3c8b8 !important;
  background: #fff6f1 !important;
  color: #bb4d22 !important;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  transition: all 0.2s ease;
}

:where(.btn-reset-standard,
.hr-clear-btn,
.filter-reset-btns .btn,
.filter-reset-btns a,
button[type=reset],
input[type=reset],
button[title*=Reset],
button[title*="Clear Filters"],
button[title*="Clear filters"]):hover,
:where(.btn-reset-standard,
.hr-clear-btn,
.filter-reset-btns .btn,
.filter-reset-btns a,
button[type=reset],
input[type=reset],
button[title*=Reset],
button[title*="Clear Filters"],
button[title*="Clear filters"]):focus {
  border-color: #e85b28 !important;
  background: #ffefe8 !important;
  color: #e85b28 !important;
  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);
}

:where(.btn-reset-standard,
.hr-clear-btn,
.filter-reset-btns .btn,
.filter-reset-btns a,
button[type=reset],
input[type=reset],
button[title*=Reset],
button[title*="Clear Filters"],
button[title*="Clear filters"]):disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none;
}

.filter-set-contents .filter-content-list {
  background: #F9F9FC;
  border-radius: 5px;
  padding: 15px;
  margin-top: 15px;
}
.filter-set-contents .filter-content-list .form-wrap {
  margin-bottom: 15px;
}
.filter-set-contents .filter-content-list .form-wrap .form-control {
  max-width: 100%;
}
.filter-set-contents .filter-content-list ul {
  max-height: 150px;
  overflow-y: auto;
  padding: 1px 0;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar {
  width: 3px;
  background: #e85b28;
  height: 1px;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(231, 231, 231);
  border-radius: 4px;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar-thumb {
  background: #e85b28;
  border-radius: 4px;
}
.filter-set-contents .filter-content-list ul li {
  position: relative;
  display: flex;
  margin-bottom: 15px;
}
.filter-set-contents .filter-content-list ul li:last-child {
  margin-bottom: 0;
}
.filter-set-contents .filter-content-list ul li .checkboxs {
  padding-left: 0;
  display: flex;
  align-items: center;
}
.filter-set-contents .filter-content-list ul li .checkboxs .checkmarks {
  position: relative;
  top: 0;
  margin-right: 5px;
  display: flex;
}
.filter-set-contents .filter-content-list ul li .rating {
  margin-left: 0;
}
.filter-set-contents .filter-content-list ul li .rating i {
  color: #E8E8E8;
}
.filter-set-contents .filter-content-list ul li .rating i.filled {
  color: #FDA700;
}
.filter-set-contents .filter-content-list ul li .rating span {
  margin-left: 5px;
}
.filter-set-contents .filter-content-list ul li .collapse-inside-text {
  margin-left: 0;
}
.filter-set-contents .filter-content-list ul li .collapse-inside-text h5 {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
}

.page-wrapper {
  transition: all 0.5s ease;
  margin: 0 0 0 276px;
  padding: 56px 0 0;
  position: relative;
  left: 0;
  transition: all 0.2s ease;
}
@media (max-width: 991.98px) {
  .page-wrapper {
    margin: 0;
    padding: 60px 0 0;
  }
}
.page-wrapper .content {
  padding: 24px;
  padding-bottom: 0;
}
@media (max-width: 991.98px) {
  .page-wrapper .content {
    padding: 15px 15px 0;
  }
}

.header {
  height: 56px;
  z-index: 999;
  background: #FFF;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  transition: all 0.5s ease;
}
.header .flag-nav > a img {
  border-radius: 50%;
  width: 22px;
  height: 22px;
}
.header .searchinputs {
  padding: 0;
  position: relative;
}
.header .searchinputs input {
  width: 335px;
  height: 42px;
  border: 1px solid #F6F6F6;
  background: #F6F6F6;
  padding: 5px 10px;
  padding-right: 35px;
  border-radius: 5px;
  color: #262A2A;
}
@media (max-width: 1199.98px) {
  .header .searchinputs input {
    width: 170px;
  }
}
.header .searchinputs input::placeholder {
  color: #6F6F6F;
}
.header .searchinputs .search-addon button {
  z-index: 9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0;
  color: #262A2A;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
@media (min-width: 992px) {
  .header .dropdown-menu {
    top: 85px;
    right: 0;
    left: auto;
    min-width: 200px;
    visibility: hidden;
    opacity: 0;
    border: 0;
    display: block;
    border-radius: 5px;
    box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
    margin: 0;
    padding: 0;
    transition: all 0.4s ease;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
  }
}
@media (max-width: 991.98px) {
  .header .dropdown-menu {
    transition: none;
  }
}
.header .dropdown-menu.show {
  visibility: visible;
  opacity: 1;
  margin-top: 8px !important;
  transform: translateY(0);
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transition: all 0.4s ease;
}
.header .header-left {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  float: left;
  height: 56px;
  position: relative;
  text-align: center;
  width: 276px;
  z-index: 1;
  background: #FFF;
  padding: 0 15px;
  transition: all 0.5s ease;
}
.header .header-left .logo {
  display: inline-block;
  line-height: 0;
}
.header .header-left .logo img {
  width: 100%;
  display: block;
}
.header .header-left .logo img.white-logo {
  display: none;
}
@media (max-width: 991.98px) {
  .header .header-left .logo {
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header .header-left .logo img {
    width: 140px;
  }
}
.header .header-left .logo-small {
  display: none;
}
@media (max-width: 991.98px) {
  .header .header-left {
    position: absolute;
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .header .header-left #toggle_btn {
    display: none;
  }
}
@media (min-width: 991.98px) {
  .header #toggle_btn {
    font-size: 18px;
    padding: 4px;
    border-radius: 6px;
  }
  .header #toggle_btn .bar-icon {
    display: inline-block;
    width: 21px;
  }
  .header #toggle_btn .bar-icon span {
    background-color: #FFF;
    display: block;
    float: left;
    height: 2px;
    width: 21px;
    margin: 0 0 5px;
    border-radius: 50px;
  }
  .header #toggle_btn .bar-icon span:nth-child(2) {
    width: 15px;
  }
}
.header .bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.header .bar-icon span {
  background-color: #e85b28;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
  transition: all 0.5s;
}
.header .bar-icon span:nth-child(2) {
  width: 16px;
}
.header .menu-opened .slide-nav .bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.header .menu-opened .slide-nav .bar-icon span:first-child {
  position: relative;
  top: 10px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.header .menu-opened .slide-nav .bar-icon span:nth-child(2) {
  display: none;
}
.header .menu-opened .slide-nav .bar-icon span:last-child {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
}
.header .menus-info {
  min-width: 500px;
  border-radius: 5px;
  padding: 8px;
}
@media (max-width: 1199.98px) {
  .header .menus-info {
    min-width: 430px;
  }
}
.header .menus-info .menu-list li {
  margin-bottom: 0;
  margin-right: 0;
}
.header .menus-info .menu-list li a {
  display: block;
  padding: 8px;
  background: #FFF;
  border-radius: 5px;
}
.header .menus-info .menu-list li a:hover {
  background: #F6F6F6;
}
.header .menus-info .menu-list li a .menu-details {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .menus-info .menu-list li a .menu-details .menu-list-icon {
  font-size: 18px;
  color: #FFF;
  width: 36px;
  min-width: 36px;
  height: 36px;
  padding: 5px;
  margin-right: 8px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header .menus-info .menu-list li a .menu-details .menu-details-content p {
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0;
}
.header .menus-info .menu-list li a .menu-details .menu-details-content span {
  font-weight: 400;
  color: #6F6F6F;
}
@media (max-width: 1199.98px) {
  .header .menus-info .menu-list li a .menu-details .menu-details-content span {
    font-size: 13px;
  }
}
.header .profilename {
  padding: 0px;
}
.header .profilename .profileset {
  display: flex;
  padding: 10px 10px 3px;
}
.header .profilename .profileset h6 {
  font-size: 14px;
  color: #FFA201;
  font-weight: 500;
}
.header .profilename .profileset h5 {
  font-size: 14px;
  color: #565E5E;
}
.header .profilename .profileset .profilesets {
  margin-left: 10px;
}
.header .profilename .profileset .user-img img {
  margin-top: 0;
}
.header .show .user-info::after {
  transform: rotate(-140deg);
  top: 10px;
}
.header .user-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
  padding: 0;
}
@media (max-width: 1199.98px) {
  .header .user-info span.user-detail {
    display: none;
  }
}
.header .user-info::after {
  content: "";
  width: 8px;
  height: 8px;
  border-top: 0;
  border-left: 0;
  border-right: 2px solid #1B2950;
  border-bottom: 2px solid #1B2950;
  border-radius: 1px;
  transform: rotate(45deg);
  transition: all 0.5s;
  top: 8px;
  position: absolute;
  right: 12px;
  display: none;
}
@media (max-width: 1199.98px) {
  .header .user-info::after {
    top: 12px;
  }
}
.header .user-info .user-role {
  display: block;
  color: #67748E;
  font-size: 12px;
}
.header .user-info .user-letter {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 15px;
  margin-right: 0;
}
@media (max-width: 1199.98px) {
  .header .user-info .user-letter {
    margin-right: 0;
  }
}
.header .user-info .user-letter img {
  border-radius: 5px;
}
.header .user-info .user-name {
  font-size: 15px;
  font-weight: 600;
  color: #1B2950;
  display: flex;
  align-items: center;
}
.header .user-info .user-name img {
  margin-left: 10px;
}
.header .header-user {
  padding: 15px 24px;
  display: contents;
}
.header .header-user .user-menu {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin: 0;
  position: relative;
  height: 100%;
  border-bottom: 0;
  padding: 0 24px;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .header .header-user .user-menu {
    display: none;
  }
}
.header .header-user .user-menu .status {
  position: absolute;
  content: "";
  background: #e85b28;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  top: 3px;
  right: 3px;
}
.header .header-user .user-menu .header-title h3 {
  font-size: 24px;
  font-weight: 700;
}
.header .header-user .user-menu .header-title h6 {
  font-size: 12px;
  font-weight: 600;
}
.header .header-user .user-menu > li {
  margin-left: 10px;
  margin-inline-end: 0;
}
.header .header-user .user-menu > li:first-child {
  margin-left: 0;
}
@media (max-width: 1199.98px) {
  .header .header-user .user-menu > li {
    margin-left: 8px;
  }
}
.header .header-user .user-menu > li svg {
  width: 18px;
  color: #67748E;
}
.header .header-user .user-menu > li a:hover svg {
  color: #e85b28;
}
.header .header-user .user-menu .dropdown-toggle::after {
  border: 0;
  display: none;
}
.header .header-user .user-menu .nav-searchinputs {
  margin-right: auto;
  margin-left: 25px;
}
.header .header-user .user-menu .nav-item-box > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  color: #262A2A;
  border-radius: 5px;
  width: 36px;
  height: 36px;
  position: relative;
  border: 0;
}
.header .header-user .user-menu .nav-item-box > a:hover {
  background: #EAEAEA;
}
.header .header-user .user-menu .nav-item-email.nav-item-box {
  margin-left: 15px;
}
.header .header-user .user-menu.nav > li > a {
  padding: 0;
  display: flex;
  line-height: normal;
  color: #3E4265;
}
.header .header-user .user-menu.nav > li > a.btn-header-list {
  color: #FFF;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.header .header-user .user-menu.nav > li > a .badge {
  color: #FFF;
  font-weight: 700;
  position: absolute;
  top: 4px;
  right: 4px;
  background: #e85b28;
  width: 15px;
  height: 15px;
  font-size: 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header .header-user .user-menu.nav > li > a i {
  font-size: 18px;
}
.header .header-user .user-menu.nav > li > a .badge-success {
  background: #5CB85C;
  border: 3px solid #FFF;
  padding: 0;
  top: inherit;
  bottom: -3px;
  right: -3px;
}
.header .header-user .user-menu.nav > li.flag-nav a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .header-user .user-menu.nav > li.flag-nav a .dropdown-menu {
  max-height: 150px;
  min-width: 120px;
  overflow-y: auto;
}
.header .header-user .user-menu.nav > li.flag-nav a .dropdown-menu .dropdown-item {
  padding: 5px 15px;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu {
  padding: 15px;
  min-width: 210px;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item {
  padding: 10px 10px;
  color: #67748E;
  border-radius: 10px;
  transition: none;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active {
  color: #FFF;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active, .header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item:hover {
  background: #F7F7F7 no-repeat calc(100% - 12px) center;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu a img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}
.header .page-title-box {
  float: left;
  height: 60px;
  margin-bottom: 0;
  padding: 17px 20px;
  border-radius: 0;
}
@media (max-width: 991.98px) {
  .header .page-title-box {
    display: none;
  }
}
.header .page-title-box a {
  color: #e85b28;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid #e85b28;
  margin: 0;
  padding: 5px;
  border-radius: 5px;
}
.header .page-title-box a:hover {
  background: #e85b28;
  color: #FFF;
}
.header .mobile_btn {
  display: none;
  float: left;
}
@media (max-width: 991.98px) {
  .header .mobile_btn {
    color: #e85b28;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    width: 60px;
    z-index: 10;
    padding: 0 20px;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }
}
.header .responsive-search {
  display: none;
  color: #FFF;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  padding: 0 15px;
}
@media (max-width: 991.98px) {
  .header .responsive-search {
    display: block;
  }
}
.header .top-nav-search form {
  position: relative;
}
@media (max-width: 991.98px) {
  .header .top-nav-search form {
    display: none;
  }
}
.header .top-nav-search form .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  height: 40px;
  padding: 10px 50px 10px 15px;
  border-radius: 50px;
}
.header .top-nav-search form .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.header .top-nav-search form .btn {
  background-color: transparent;
  border-color: transparent;
  color: rgba(255, 255, 255, 0.7);
  min-height: 40px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .top-nav-search.active form {
    display: block;
    position: absolute;
    left: 0;
  }
  .header .top-nav-search.active form .form-control {
    background-color: #FFF;
  }
  .header .top-nav-search.active form .btn {
    background-color: transparent;
    border-color: transparent;
    min-height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 7px 15px;
  }
}
.header .userset {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .userset .usernames {
  line-height: normal;
  line-height: initial;
  text-align: right;
  padding-right: 10px;
}
.header .userset .usernames span {
  display: block;
  line-height: normal;
  line-height: initial;
}
.header .menu-drop-user .dropdown-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
  color: #262A2A;
  padding: 10px;
  border-bottom: 1px solid #F5F5F5;
  border-radius: 0;
}
.header .menu-drop-user .dropdown-item:first-child {
  border-radius: 5px 5px 0 0;
}
.header .menu-drop-user .dropdown-item:last-child {
  border-radius: 0 0 5px 5px;
  border-bottom: 0;
}
.header .menu-drop-user .dropdown-item:hover {
  padding-left: 20px;
  letter-spacing: 0.5px;
}
.header .menu-drop-user .dropdown-item i {
  font-size: 16px;
  margin-right: 8px;
}
@media (max-width: 991.98px) {
  .header .has-arrow .dropdown-toggle > span:nth-child(2) {
    display: none;
  }
  .header .has-arrow .dropdown-toggle:after {
    display: none !important;
  }
}
.header .profilename .user-img .status {
  bottom: 10px;
}
.header .user-img {
  display: inline-block;
  position: relative;
}
.header .user-img img {
  width: 38px;
  border-radius: 50%;
}
.header .user-img .status {
  border: 2px solid #FFF;
  height: 10px;
  width: 10px;
  margin: 0;
  position: absolute;
  right: 0;
  bottom: 30px;
  border-radius: 50%;
  display: inline-block;
  background: #5CB85C;
}
.header .mobile-user-menu {
  color: #FFF;
  display: none;
  float: right;
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  text-align: right;
  width: 60px;
  z-index: 10;
  padding: 0 20px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .mobile-user-menu {
    display: block;
  }
}
.header .mobile-user-menu a {
  color: #e85b28;
  padding: 0;
}
.header .mobile-user-menu a::after {
  display: none;
}
.header .mobile-user-menu .dropdown-menu {
  padding: 0;
}
.header .mobile-user-menu .dropdown-menu a {
  color: #323737;
  line-height: 40px;
  padding: 0 10px;
}

.logo-small img {
  width: 30px;
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .header-left {
    flex-direction: row;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
  }
  .mini-sidebar .header-left {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    width: 80px;
    padding: 0;
    flex-direction: column;
  }
  .mini-sidebar .header-left .logo-small {
    display: block;
    padding: 10px 0 0;
  }
  .mini-sidebar .header-left .logo {
    display: none;
  }
  .mini-sidebar .menu-arrow {
    display: none !important;
  }
  .mini-sidebar .chat-user {
    display: none !important;
  }
  .mini-sidebar .user-menu .badge {
    display: flex !important;
  }
  .mini-sidebar.expand-menu .menu-arrow {
    display: block !important;
  }
  .mini-sidebar.expand-menu .chat-user {
    display: block !important;
  }
  .mini-sidebar.expand-menu .logo-small {
    display: none;
  }
  .mini-sidebar.expand-menu .logo {
    display: block;
  }
  .mini-sidebar.expand-menu #toggle_btn {
    opacity: 1;
  }
  .mini-sidebar.expand-menu .header-left {
    padding: 0 15px;
    display: flex;
  }
  .mini-sidebar .noti-dot:before {
    display: none;
  }
}
.nav-list {
  position: relative;
  padding-right: 15px;
}
.nav-list::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 1px;
  height: 20px;
  background: #E8E8E8;
  z-index: 1;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle {
  width: 66px;
  height: 36px;
  background: #F9F9FC;
  border: 1px solid #E8E8E8;
  font-size: 16px;
  border-radius: 5px;
  padding: 3px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i {
  font-size: 16px;
  color: #262A2A;
  border-radius: 5px;
  line-height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i.light-mode.active {
  color: #FFF;
  background: #5CB85C;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i.dark-mode.active {
  color: #FFF;
  background: #262A2A;
}
.nav-list .nav li {
  margin-right: 10px;
}
.nav-list .nav li:last-child {
  margin-right: 0;
}
.nav-list .nav li .btn {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 36px;
  height: 36px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid transparent;
}
.nav-list .nav li .btn-header-list {
  color: #00918E;
  background: #E0F5D7;
  border: 1px solid #00918E;
}
.nav-list .nav li .btn-header-list:hover {
  color: #FFF;
  background: #00918E;
}
.nav-list .nav li .btn-help {
  color: #3C2371;
  background: #F3EDFF;
}
.nav-list .nav li .btn-help:hover {
  color: #FFF;
  background: #3C2371;
}
.nav-list .nav li .btn-chart-pie {
  color: #FFA201;
  background: #FFF7D8;
}
.nav-list .nav li .btn-chart-pie:hover {
  color: #FFF;
  background: #FFA201;
}

.mobile-show {
  display: none;
}
@media (max-width: 991.98px) {
  .mobile-show {
    display: block;
  }
}

.sidebar {
  display: flex;
  background-color: #FFF;
  margin-top: 0;
  z-index: 1001;
  position: fixed;
  top: 56px;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease;
  width: 276px;
}
@media (max-width: 991.98px) {
  .sidebar {
    margin-left: -575px;
    transition: all 0.4s ease;
    z-index: 1041;
    background: #FFF;
  }
}
@media (max-width: 575.98px) {
  .sidebar {
    width: 100%;
  }
}
.sidebar .slimScrollDiv {
  border-right: 1px solid transparent;
}
@media (max-width: 575.98px) {
  .sidebar .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-menu {
  padding: 15px;
}
.sidebar .sidebar-menu .clinicdropdown {
  margin-bottom: 24px;
}
.sidebar .sidebar-menu .clinicdropdown > a {
  background: #F6F6F6;
  border-radius: 5px;
  padding: 10px;
}
.sidebar .sidebar-menu .clinicdropdown > a img {
  width: 42px;
  height: 42px;
  border-radius: 5px;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names {
  margin-left: 10px;
  flex: 1 1;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names h5 {
  font-size: 16px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 2px;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names h6 {
  font-size: 14px;
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 0;
}
.sidebar .sidebar-menu .submenu-two .subdrop.active {
  background: transparent !important;
}
.sidebar .sidebar-menu > ul > li {
  margin-bottom: 24px;
}
.sidebar .sidebar-menu > ul > li.active a {
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li.active svg {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li svg {
  min-width: 16px;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.sidebar .sidebar-menu > ul > li > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 10px 15px;
  position: relative;
  color: #FFA201;
}
.sidebar .sidebar-menu > ul > li > a svg {
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a img {
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a.active {
  background: rgba(254, 159, 67, 0.08);
  color: #FE9F43;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li > a.active svg {
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li > a.active img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li > a.active span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow {
  background: #FFEDDC;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow::before {
  border-color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a span {
  font-size: 15px;
  font-weight: 500;
  color: #565E5E;
}
.sidebar .sidebar-menu > ul > li.active a {
  background: rgba(254, 159, 67, 0.08);
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li.active a img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li.active a span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li.submenu ul {
  display: none;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a {
  font-weight: 500;
  font-size: 14px;
  position: relative;
  display: block;
  padding: 8px 8px 8px 40px;
  padding-left: 30px;
}
.sidebar .sidebar-menu > ul > li ul {
  display: block;
  margin-bottom: 24px;
}
.sidebar .sidebar-menu > ul > li ul li {
  margin-bottom: 5px;
  border-radius: 5px;
  overflow: hidden;
}
.sidebar .sidebar-menu > ul > li ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #6F6F6F;
  position: relative;
  width: 100%;
  padding: 8px;
}
.sidebar .sidebar-menu > ul > li ul li a i {
  color: #262A2A;
  font-size: 16px;
  background: #F6F6F6;
  border-radius: 5px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar .sidebar-menu > ul > li ul li a span {
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  color: #262A2A;
  margin-left: 10px;
}
.sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
  background: #FCE9E6;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #e85b28;
}
.sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #e85b28;
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #e85b28;
}
.sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #e85b28;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  background: #FFEEEC;
  border-radius: 5px;
  color: #e85b28;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop i {
  color: #FFF;
  background: #e85b28;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #e85b28;
}
.sidebar .sidebar-menu > ul > li .submenu-hdr {
  font-weight: 600;
  font-size: 12px;
  color: #6F6F6F;
  margin: 0 0 14px 0;
  text-transform: uppercase;
}
.sidebar .sidebar-menu > ul > li:first-child h6 {
  margin-top: 0;
}
.sidebar .sidebar-menu > ul > li .submenu ul {
  display: none;
  border: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.sidebar .sidebar-menu > ul li {
  margin-bottom: 5px;
}
.sidebar .sidebar-menu > ul li .submenu > ul {
  margin: 0;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a {
  padding-left: 44px;
  font-size: 14px;
  background: transparent;
  position: relative;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a:after {
  position: absolute;
  content: "";
  background-color: #898989;
  width: 7px;
  height: 7px;
  border-radius: 50px;
  left: 16px;
  top: 14px;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  position: absolute;
  content: "";
  background-color: #898989;
  width: 0.5px;
  height: 8px;
  left: 19px;
  top: 0px;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop {
  background: #F9F9FC;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop i {
  background: #171724;
  color: #FFF;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop.submenu-two {
  background: transparent;
}
.sidebar .sidebar-menu > ul li .submenu > a.active {
  background: #FCE9E6;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul li .submenu > a.active i {
  background: #e85b28;
  color: #FFF;
}
.sidebar .sidebar-menu > ul li .submenu > a.active span {
  color: #e85b28;
}
.sidebar .sidebar-menu > ul li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #e85b28;
  border-bottom: 2px solid #e85b28;
}
.sidebar .sidebar-menu .submenu-open:last-child {
  margin-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open:last-child ul {
  border-bottom: none;
  padding-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two ul li a {
  margin-left: 45px;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two.submenu-three ul li a {
  margin-left: 65px;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a {
  margin-left: 25px;
  padding-bottom: 4px;
  font-size: 14px;
  color: #B8BCC9;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a::after {
  content: "";
  background: rgba(50, 71, 92, 0.38);
  width: 8px;
  height: 8px;
  border: 2px solid #FFF;
  border-radius: 50px;
  position: absolute;
  top: 16px;
  left: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover {
  color: #e85b28;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu .menu-arrow {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  line-height: 16px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 10px;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transition: all 0.2s ease;
}
.sidebar .sidebar-menu .menu-arrow::before {
  height: 8px;
  width: 8px;
  border-top: 0;
  content: "";
  border-left: 0;
  border-right: 2px solid #262A2A;
  border-bottom: 2px solid #262A2A;
  transform: rotate(-45deg);
  position: absolute;
  left: 5px;
  top: 5px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu {
  right: 10px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu.inside-submenu-two {
  right: 60px;
}
.sidebar .sidebar-menu.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  background: #FFEDDC;
}
.sidebar .sidebar-left {
  width: 100px;
  box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.05);
}
.sidebar .sidebar-right {
  width: 250px;
  height: 100%;
  transition: all 0.2s ease;
  display: none;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right {
    width: calc(100% - 70px);
  }
}
.sidebar .sidebar-right .slimScrollDiv {
  width: 250px !important;
  overflow: visible !important;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-right .tab-content {
  padding: 20px 20px 40px;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .tab-content {
    padding: 10px;
  }
}
.sidebar .sidebar-right p {
  font-size: 10px;
  color: #6F7A7A;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 10px;
}
.sidebar .sidebar-right ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar .sidebar-right ul li.active a {
  background: linear-gradient(46.62deg, #e85b28 0%, #676DFF 93.64%);
  color: #FFF;
}
.sidebar .sidebar-right ul li a {
  font-weight: 400;
  font-size: 14px;
  color: #FFA201;
}
.sidebar .sidebar-right ul li a.active {
  color: #e85b28;
}
.sidebar .sidebar-right .menu-arrow {
  transition: transform 0.15s;
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 18px;
  top: 0px;
  position: relative;
  font-weight: 700;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
}
.sidebar .sidebar-right .menu-arrow:before {
  content: "\\f105";
}
.sidebar .sub-menu a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.sidebar li a.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.sidebar .nav-items .nav-link {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  border-bottom: 1px solid #6F6F6F;
  padding: 20px 0;
  transition: all 0.4s ease;
}
.sidebar .nav-items .nav-link:hover {
  box-shadow: 0 0 0 150px #676DFF inset;
  color: #FFF;
}
.sidebar .nav-items .nav-link span {
  margin-top: 15px;
  font-weight: 500;
}
.sidebar .sidemenu a {
  width: 100%;
  font-weight: 500;
  display: block;
  border-radius: 5px;
  margin: 0 0 10px;
  padding: 10px;
}
.sidebar .sidemenu a:hover {
  background: linear-gradient(46.62deg, #e85b28 0%, #676DFF 93.64%);
  color: #FFF;
}
.sidebar .sidemenu a:hover svg {
  color: #FFF;
}
.sidebar .sidemenu a svg {
  stroke-width: 1px;
}

@media (min-width: 991.98px) {
  .mini-sidebar .page-wrapper {
    margin-left: 80px;
  }
  .mini-sidebar .user-names {
    display: none;
  }
  .mini-sidebar .header-left #toggle_btn {
    opacity: 1;
    transform: rotate(180deg);
  }
  .mini-sidebar .header-left #toggle_btn:after {
    border: 0;
  }
  .mini-sidebar .sidebar .sidebar-menu .clinicdropdown > a {
    padding: 5px;
  }
  .mini-sidebar.expand-menu .header-left #toggle_btn {
    opacity: 1;
    transform: rotate(180deg);
  }
  .mini-sidebar.expand-menu .sidebar .sidebar-menu .clinicdropdown > a {
    padding: 10px;
  }
  .mini-sidebar .sidebar-right {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li a span {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li .submenu-hdr {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li svg {
    margin-right: 0;
  }
  .mini-sidebar .sidebar {
    width: 80px;
    overflow: hidden;
  }
  .mini-sidebar.expand-menu .sidebar {
    display: block;
  }
  .expand-menu.mini-sidebar .sidebar .sidebar-menu .submenu-hdr {
    display: block;
  }
  .expand-menu.mini-sidebar .sidebar .user-names {
    display: block;
  }
  .expand-menu .sidebar-right {
    display: block;
    transition: all 0.2s ease;
  }
  .expand-menu .sidebar {
    width: 276px;
  }
  .expand-menu .sidebar .sidebar-menu ul > li > a span {
    display: inline-block;
    line-height: 0;
  }
  .expand-menu .sidebar .sidebar-menu ul > li svg {
    margin-right: 10px;
  }
  .expand-menu .sidebar .sidebar-menu .submenu-hdr {
    display: block;
  }
  .expand-menu .header-left {
    width: 276px;
  }
  #toggle_btn {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    float: left;
  }
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li ul li a {
  justify-content: start;
}

body.mini-sidebar .sidebar .sidebar-menu > ul > li ul li a {
  justify-content: center;
}
body.mini-sidebar .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-weight: 500;
  font-size: 15px;
  color: #67748E;
  position: relative;
  width: 100%;
  padding: 10px;
}
body.mini-sidebar .sidebar .sidebar-menu > ul > li ul > li.active a {
  padding: 10px;
  justify-content: center;
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  justify-content: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  padding-left: 18px;
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li ul > li.active a {
  padding: 10px 15px;
  justify-content: start;
}

.sidebarrightmenu .sidebar-right {
  display: block;
}

.slide-nav .sidebar {
  margin-left: 0;
}

.sidebar-overlay {
  display: none;
  height: 100%;
  width: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 60px;
  left: 0;
}
.sidebar-overlay.opened {
  display: block;
}

.mini-sidebar .active.subdrop ~ ul {
  display: none !important;
}

.mini-sidebar.expand-menu .active.subdrop ~ ul {
  display: block !important;
}

.active.subdrop ~ ul {
  display: block !important;
}

.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {
  margin-left: 30px;
}
.sidebar .sidebar-menu > ul li .submenu.submenu-two.submenu-three > ul li a {
  margin-left: 60px;
}

.mini-sidebar .header #toggle_btn {
  opacity: 0;
  height: 0;
  width: 0;
}

.sidebar .modern-profile, .sidebar .sidebar-header {
  display: none;
}

.mini-sidebar #toggle_btn, .mini-sidebar .header-left #toggle_btn {
  display: flex !important;
  opacity: 1 !important;
  height: 40px !important;
  width: 40px !important;
  align-items: center;
  justify-content: center;
  position: static;
  left: auto;
  left: initial;
  top: auto;
  top: initial;
  z-index: 2000;
  background: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  cursor: pointer;
  margin-left: 0;
}

.layout-box-mode .main-wrapper {
  max-width: 1320px;
  margin: auto;
}
@media (max-width: 1280px) {
  .layout-box-mode .main-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  .layout-box-mode .main-wrapper {
    max-width: 100%;
  }
}

:root {
  --primary-rgb-picr: var(--primary-rgb);
  --sidebar--rgb-picr: var(--sidebar-rgb);
  --topbar--rgb-picr: var(--topbar-rgb);
  --topbarcolor--rgb-picr: var(--topbarcolor-rgb);
}

[data-layout=default][data-width=box] .layout-box-mode .mini-sidebar .header,
[data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar .header {
  max-width: 1320px;
  left: 0;
}
@media (max-width: 1280px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar .header {
    max-width: 100%;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header,
[data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header {
  max-width: 1320px;
  left: 0;
}
@media (max-width: 1280px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header {
    max-width: 100%;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .header,
[data-layout=mini][data-width=box] .layout-box-mode .header {
  margin: auto;
  max-width: 1320px;
  left: 0;
}
@media (max-width: 1280px) {
  [data-layout=default][data-width=box] .layout-box-mode .header,
  [data-layout=mini][data-width=box] .layout-box-mode .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .header,
  [data-layout=mini][data-width=box] .layout-box-mode .header {
    max-width: 100%;
    left: 0;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .header .header-left,
[data-layout=mini][data-width=box] .layout-box-mode .header .header-left {
  display: block;
  padding-left: 24px;
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .header .header-left,
  [data-layout=mini][data-width=box] .layout-box-mode .header .header-left {
    padding-left: 0;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .sidebar,
[data-layout=mini][data-width=box] .layout-box-mode .sidebar {
  left: auto;
  left: initial;
  top: 50px;
}
[data-layout=default][data-width=box] .layout-box-mode .sidebar .sidebar-logo,
[data-layout=mini][data-width=box] .layout-box-mode .sidebar .sidebar-logo {
  display: none;
}
[data-layout=default][data-width=box] .layout-box-mode .sidebar .slimScrollDiv,
[data-layout=mini][data-width=box] .layout-box-mode .sidebar .slimScrollDiv {
  top: 0;
}

[data-layout=twocolumn][data-width=box] .layout-box-mode .sidebar,
[data-layout=modern][data-width=box] .layout-box-mode .sidebar,
[data-layout=stacked][data-width=box] .layout-box-mode .sidebar {
  left: auto;
  left: initial;
}
[data-layout=twocolumn][data-width=box] .layout-box-mode .sidebar .sidebar-logo,
[data-layout=modern][data-width=box] .layout-box-mode .sidebar .sidebar-logo,
[data-layout=stacked][data-width=box] .layout-box-mode .sidebar .sidebar-logo {
  display: none;
}
[data-layout=twocolumn][data-width=box] .layout-box-mode .header,
[data-layout=modern][data-width=box] .layout-box-mode .header,
[data-layout=stacked][data-width=box] .layout-box-mode .header {
  margin: 0 auto;
  max-width: 1068px;
}
@media (min-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode .header,
  [data-layout=modern][data-width=box] .layout-box-mode .header,
  [data-layout=stacked][data-width=box] .layout-box-mode .header {
    left: 252px;
  }
}
@media (max-width: 1280px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode .header,
  [data-layout=modern][data-width=box] .layout-box-mode .header,
  [data-layout=stacked][data-width=box] .layout-box-mode .header {
    max-width: 698px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode .header,
  [data-layout=modern][data-width=box] .layout-box-mode .header,
  [data-layout=stacked][data-width=box] .layout-box-mode .header {
    max-width: 100%;
    left: 0;
  }
}
[data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
[data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
[data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
  max-width: 1248px;
}
@media (min-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
    left: 72px;
  }
}
@media (max-width: 1280px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
    max-width: 878px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
    max-width: 100%;
    left: 0;
  }
}
[data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
[data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
[data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
  max-width: 1068px;
}
@media (min-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
    left: 252px;
  }
}
@media (max-width: 1280px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
    max-width: 698px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
    max-width: 100%;
    left: 0;
  }
}

[data-layout=horizontal][data-width=box] .main-wrapper .header,
[data-layout=horizontal-overlay][data-width=box] .main-wrapper .header {
  margin: auto;
  max-width: 1320px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .main-wrapper .header,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .main-wrapper .header,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper .header {
    max-width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .main-wrapper::before,
[data-layout=horizontal-overlay][data-width=box] .main-wrapper::before {
  width: 1320px;
  margin: 0 auto;
  left: 0;
  right: 0;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::before,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::before {
    width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::before,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::before {
    width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .main-wrapper::after,
[data-layout=horizontal-overlay][data-width=box] .main-wrapper::after {
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::after,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::after {
    width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::after,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::after {
    width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .header,
[data-layout=horizontal-overlay][data-width=box] .header {
  padding: 0 16px;
}
[data-layout=horizontal][data-width=box] .header .main-header,
[data-layout=horizontal-overlay][data-width=box] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .header .main-header,
  [data-layout=horizontal-overlay][data-width=box] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .header .main-header,
  [data-layout=horizontal-overlay][data-width=box] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .header .main-header .user-menu,
[data-layout=horizontal-overlay][data-width=box] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal][data-width=box] .header .header-left,
[data-layout=horizontal-overlay][data-width=box] .header .header-left {
  display: block;
}
[data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal,
[data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 16px !important;
  left: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal,
  [data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal,
  [data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal {
    max-width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal .sidebar-menu .nav-menu > li.submenu > a {
  padding: 8px 30px 8px 8px;
}

[data-layout=horizontal-single][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single][data-width=box] .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-single][data-width=box] .header {
    max-width: 100%;
  }
}
[data-layout=horizontal-single][data-width=box] .header .main-header .user-menu {
  padding-left: 10px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single][data-width=box] .header .main-header .user-menu {
    padding-left: 8px !important;
  }
}
[data-layout=horizontal-single][data-width=box] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  padding: 8px 18px 8px 6px;
}
@media (min-width: 1280px) {
  [data-layout=horizontal-single][data-width=box] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
    padding: 8px 30px 8px 8px;
  }
}

[data-layout=detached][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}

[data-layout=without-header][data-width=box] .sidebar {
  left: auto;
}

[data-layout=transparent][data-width=box] .sidebar {
  left: auto;
}
[data-layout=transparent][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=transparent][data-width=box] .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=transparent][data-width=box] .header {
    max-width: 100%;
  }
}

[data-layout=horizontal-sidemenu][data-width=box] .sidebar {
  left: auto;
}
[data-layout=horizontal-sidemenu][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu][data-width=box] .header {
    max-width: 100%;
  }
}
[data-layout=horizontal-sidemenu][data-width=box] .main-wrapper::before {
  width: 1320px;
  margin: 0 auto;
  left: auto;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu][data-width=box] .main-wrapper::before {
    width: 100%;
  }
}

[data-layout=detached] .main-wrapper {
  margin: 0 auto;
}
@media (min-width: 991.98px) {
  [data-layout=detached] .main-wrapper {
    max-width: 95%;
  }
}
[data-layout=detached] .header {
  left: 0;
}
[data-layout=detached] .header .main-header {
  margin: 0 auto;
}
@media (min-width: 991.98px) {
  [data-layout=detached] .header .main-header {
    max-width: 95%;
  }
}
[data-layout=detached] .expand-menu .header-left {
  width: auto;
}
[data-layout=detached] .expand-menu.mini-sidebar .header {
  left: 0;
}
[data-layout=detached] .expand-menu.mini-sidebar .header .header-left {
  width: auto;
}
[data-layout=detached] .sidebar {
  top: 74px;
  left: auto;
  left: initial;
  bottom: 24px;
}
[data-layout=detached] .sidebar .slimScrollDiv {
  height: 100% !important;
  top: 0;
}
[data-layout=detached] .sidebar .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=detached] .sidebar .slimScrollDiv .sidebar-menu {
  margin-top: 0;
  padding-bottom: 0;
}
[data-layout=detached] .sidebar .sidebar-menu {
  margin-top: 16px;
}
[data-layout=detached] .sidebar .sidebar-logo {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=detached] .sidebar {
    top: 50px;
    bottom: 0;
  }
}
@media (min-width: 991.98px) {
  [data-layout=detached] .page-wrapper {
    padding: 74px 0 0;
  }
}
[data-layout=detached] .page-wrapper .head-icons #collapse-header {
  display: none;
}

[data-layout=twocolumn] .sidebar.navbar-menu {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn] .sidebar.navbar-menu {
    display: block;
  }
}
[data-layout=twocolumn] .sidebar-twocol.sidebar {
  display: flex;
}
[data-layout=twocolumn] #two-col-sidebar {
  display: block;
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn] #two-col-sidebar {
    display: none;
  }
}

[data-layout=horizontal] #horizontal-menu {
  display: block;
}
[data-layout=horizontal] .header {
  left: 0;
}
[data-layout=horizontal] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal] .header .header-left {
  display: block;
}

[data-layout=modern] .header {
  background-color: #FFF;
  border-color: rgba(255, 255, 255, 0.8);
}
[data-layout=modern] .header .bar-icon span {
  background-color: #FFF;
}
@media (max-width: 1280px) {
  [data-layout=modern] .header .input-group {
    width: 200px;
  }
}
[data-layout=modern] .header .header-left {
  display: block;
  padding-left: 24px;
}
[data-layout=modern] .header .header-left .logo {
  display: block;
}
[data-layout=modern] .header .header-left .dark-logo {
  display: none;
}
[data-layout=modern] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=modern] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern] .header .header-user .user-menu .btn-menubar.active {
  background-color: #E8E9EA;
  border-color: #E8E9EA;
  color: #262A2A !important;
}
[data-layout=modern] .sidebar {
  display: block;
}
[data-layout=modern] .sidebar .sidebar-logo {
  display: none;
}
[data-layout=modern] .sidebar .slimScrollDiv {
  top: 0;
  height: calc(100% - 220px) !important;
}
[data-layout=modern] .sidebar .sidebar-inner {
  height: 100% !important;
}
[data-layout=modern] .sidebar .sidebar-menu {
  margin-top: 0;
}
[data-layout=modern] .sidebar .modern-profile {
  display: block;
}
[data-layout=modern] .page-wrapper::before {
  content: "";
  height: 168px;
  background: #FFF;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
[data-layout=modern] .page-wrapper::after {
  content: none;
  height: 168px;
  background-repeat: no-repeat;
  width: 60%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
[data-layout=modern] .mini-sidebar .modern-profile .user-profile {
  padding: 0 !important;
  margin-bottom: 0 !important;
  background: transparent !important;
  border-color: transparent !important;
}
[data-layout=modern] .mini-sidebar .modern-profile .user-profile .avatar {
  width: 40px;
  height: 40px;
}
[data-layout=modern] .mini-sidebar .modern-profile h6, [data-layout=modern] .mini-sidebar .modern-profile p, [data-layout=modern] .mini-sidebar .modern-profile .sidebar-nav {
  display: none;
}
[data-layout=modern] .mini-sidebar .slimScrollDiv {
  height: calc(100% - 70px) !important;
}
[data-layout=modern] .mini-sidebar.expand-menu .modern-profile .user-profile {
  padding: 16px !important;
  margin-bottom: 24px !important;
  background: #FDFDFE !important;
}
[data-layout=modern] .mini-sidebar.expand-menu .modern-profile .user-profile .avatar {
  width: 40px;
  height: 40px;
}
[data-layout=modern] .mini-sidebar.expand-menu .modern-profile h6, [data-layout=modern] .mini-sidebar.expand-menu .modern-profile p, [data-layout=modern] .mini-sidebar.expand-menu .modern-profile .sidebar-nav {
  display: block;
}
[data-layout=modern] .mini-sidebar.expand-menu .slimScrollDiv {
  height: calc(100% - 220px) !important;
}

[data-layout=horizontal-overlay] #horizontal-menu {
  display: block;
}
[data-layout=horizontal-overlay] .header {
  left: 0;
  background-color: #FFF;
  border-color: white;
}
[data-layout=horizontal-overlay] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-overlay] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal-overlay] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal-overlay] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=horizontal-overlay] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay] .mode-toggle {
  color: #424848;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar {
  background-color: #FFF;
  border-bottom: 1px solid white;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar::before {
  content: none;
  height: 100%;
  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #262A2A;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay] .main-wrapper {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-overlay] .main-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .main-wrapper {
    max-width: 100%;
  }
}
[data-layout=horizontal-overlay] .main-wrapper::before {
  content: "";
  height: 168px;
  background: #FFF;
  width: 100%;
  position: absolute;
  top: 96px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .main-wrapper::before {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-overlay] .main-wrapper::after {
  content: "";
  height: 168px;
  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  top: 96px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .main-wrapper::after {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-overlay] .page-breadcrumb h2 {
  color: #FFF;
}

[data-layout=horizontal-box] #horizontal-menu {
  display: block;
}
[data-layout=horizontal-box] .main-wrapper {
  max-width: 1320px;
  margin: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .main-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .main-wrapper {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .main-wrapper .header {
  max-width: 1320px;
  margin: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .main-wrapper .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .main-wrapper .header {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .header {
  left: 0;
  padding: 0 16px;
}
[data-layout=horizontal-box] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal-box] .header .header-left {
  display: block;
}
[data-layout=horizontal-box] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-box] .sidebar.sidebar-horizontal {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 16px !important;
  left: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .sidebar.sidebar-horizontal {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .sidebar.sidebar-horizontal {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .sidebar.sidebar-horizontal .sidebar-menu .nav-menu > li.submenu > a {
  padding: 8px 30px 8px 8px;
}

[data-layout=horizontal-fullwidth] #horizontal-menu {
  display: block;
}
[data-layout=horizontal-fullwidth] .header {
  padding: 0 24px;
}
[data-layout=horizontal-fullwidth] .sidebar-horizontal.sidebar .sidebar-menu {
  max-width: 100%;
  padding: 0 24px !important;
}
[data-layout=horizontal-fullwidth] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  padding: 8px 24px 8px 8px;
}
@media (min-width: 1280px) {
  [data-layout=horizontal-fullwidth] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
    padding: 8px 28px 8px 8px;
  }
}

@media (min-width: 991.98px) {
  [data-layout=without-header] .header {
    width: 60px;
    height: 0;
  }
}
[data-layout=without-header] .header #toggle_btn {
  display: none;
}
[data-layout=without-header] .page-wrapper {
  padding: 0;
}
[data-layout=without-header] .page-wrapper .head-icons {
  display: none;
}
[data-layout=without-header] .modern-profile .user-profile {
  display: none;
}
[data-layout=without-header] .modern-profile, [data-layout=without-header] .sidebar-header {
  display: block;
}
[data-layout=without-header] .sidebar {
  display: block;
}
[data-layout=without-header] .sidebar .sidebar-logo {
  position: relative;
}
[data-layout=without-header] .slimScrollDiv {
  top: 0;
  height: calc(100% - 100px) !important;
}
[data-layout=without-header] .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=without-header] .mini-sidebar .sidebar-nav {
  display: none;
}
[data-layout=without-header] .mini-sidebar .sidebar-header .input-group, [data-layout=without-header] .mini-sidebar .sidebar-header .menu-item {
  display: none !important;
}
[data-layout=without-header] .mini-sidebar .sidebar-profile {
  padding: 0 !important;
  background: transparent !important;
  border-color: transparent !important;
}
[data-layout=without-header] .mini-sidebar .sidebar-profile .sidebar-profile-info {
  display: none;
}
[data-layout=without-header] .mini-sidebar .slimScrollDiv {
  height: calc(100% - 110px) !important;
}
[data-layout=without-header] .mini-sidebar .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-nav {
  display: block;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-header .input-group, [data-layout=without-header] .mini-sidebar.expand-menu .sidebar-header .menu-item {
  display: flex !important;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-profile {
  padding: 8px !important;
  background: #FDFDFE !important;
  border-color: #FDFDFE !important;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-profile .sidebar-profile-info {
  display: block;
}

[data-layout=horizontal-single] #horizontal-menu {
  display: none;
}
[data-layout=horizontal-single] #horizontal-single {
  position: relative;
  top: auto;
  width: auto !important;
  box-shadow: none;
  display: block;
}
[data-layout=horizontal-single] #header-search {
  display: none !important;
}
[data-layout=horizontal-single] .header {
  padding: 5px 24px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .header {
    padding: 0 16px;
  }
}
[data-layout=horizontal-single] .header .header-left {
  width: auto;
  height: 40px;
  display: flex !important;
  align-items: center;
}
[data-layout=horizontal-single] .header .top-nav-search, [data-layout=horizontal-single] .header .dark-mode-list {
  display: none;
}
[data-layout=horizontal-single] .header .nav.user-menu {
  padding: 0;
}
[data-layout=horizontal-single] .sidebar .sidebar-menu .menu-arrow::before {
  top: 3px;
  width: 6px;
  height: 6px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .menu-horizontal .header .main-header .user-menu {
    padding-left: 16px;
  }
}
[data-layout=horizontal-single] .menu-horizontal .page-wrapper {
  padding-top: 50px;
  max-width: 100%;
  margin: 0 24px;
}
[data-layout=horizontal-single] .menu-horizontal .header-collapse .header-user {
  display: block;
}
[data-layout=horizontal-single] .footer {
  margin: 0 -24px;
}
[data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu {
  padding: 0 !important;
  height: 46px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
}
[data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  padding: 8px 21px 8px 8px;
}
@media (min-width: 1280px) {
  [data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
    padding: 8px 30px 8px 8px;
  }
}
[data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li {
  margin-right: 8px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li {
    margin-right: 1px;
  }
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li a .menu-arrow {
    right: 2px;
  }
}
[data-layout=horizontal-single] .sidebar-menu .nav-menu > li {
  margin-right: 8px;
}
[data-layout=horizontal-single] .sidebar-menu .nav-menu > li:last-child {
  margin-right: 0;
}
[data-layout=horizontal-single] .sidebar-menu .nav-menu > li.submenu > ul {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}

@media (min-width: 991.98px) {
  [data-layout=stacked] #sidebar {
    display: none;
  }
}
@media (min-width: 991.98px) {
  [data-layout=stacked] #stacked-sidebar {
    display: block;
  }
}
@media (min-width: 991.98px) {
  [data-layout=stacked] .mini-sidebar .sidebar {
    overflow: visible;
    overflow: initial;
  }
}
[data-layout=stacked] .mini-sidebar .sidebar .sidebar-right {
  display: none !important;
}
[data-layout=stacked] .mini-sidebar.expand-menu .sidebar .sidebar-right {
  display: flex !important;
}

[data-layout=transparent] body, .data-layout-transparent body {
  background-color: #FEF1EB;
}
[data-layout=transparent] .header, .data-layout-transparent .header {
  left: 0;
  border-bottom: 3px solid #e85b28;
}
[data-layout=transparent] .header .header-left, .data-layout-transparent .header .header-left {
  display: block;
  padding-left: 24px;
}
[data-layout=transparent] .sidebar, .data-layout-transparent .sidebar {
  top: 50px;
  background-color: #FEF1EB;
}
[data-layout=transparent] .sidebar .sidebar-logo, .data-layout-transparent .sidebar .sidebar-logo {
  display: none;
}
[data-layout=transparent] .sidebar .sidebar-logo .logo, .data-layout-transparent .sidebar .sidebar-logo .logo {
  display: none;
}
[data-layout=transparent] .sidebar .slimScrollDiv, .data-layout-transparent .sidebar .slimScrollDiv {
  top: 0;
}
@media (min-width: 991.98px) {
  [data-layout=transparent] .mini-sidebar.expand-menu .header, .data-layout-transparent .mini-sidebar.expand-menu .header {
    left: 0;
  }
}
[data-layout=transparent] .page-wrapper .head-icons, .data-layout-transparent .page-wrapper .head-icons {
  display: none;
}

body.data-layout-transparent {
  background-color: #FEF1EB;
}
body.data-layout-transparent .header {
  left: 0;
  border-bottom: 3px solid #e85b28;
}
body.data-layout-transparent .header .header-left {
  display: block;
  padding-left: 24px;
}
body.data-layout-transparent .sidebar {
  top: 50px;
  background-color: #FEF1EB;
}
body.data-layout-transparent .sidebar .sidebar-logo {
  display: none;
}
body.data-layout-transparent .sidebar .sidebar-logo .logo {
  display: none;
}
body.data-layout-transparent .sidebar .slimScrollDiv {
  top: 0;
}
@media (min-width: 991.98px) {
  body.data-layout-transparent .mini-sidebar.expand-menu .header {
    left: 0;
  }
}
body.data-layout-transparent .page-wrapper .head-icons {
  display: none;
}

[data-layout=horizontal-sidemenu] .header {
  left: 0;
  background-color: #262A2A;
  border-color: #323737;
}
[data-layout=horizontal-sidemenu] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-sidemenu] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal-sidemenu] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal-sidemenu] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-sidemenu] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-sidemenu] .header .header-left {
  display: block;
}
[data-layout=horizontal-sidemenu] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-sidemenu] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-sidemenu] .main-wrapper {
  margin: 0 auto;
}
@media (min-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .main-wrapper {
    max-width: 95%;
  }
}
[data-layout=horizontal-sidemenu] .main-wrapper::before {
  content: "";
  height: 168px;
  background: #262A2A;
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .main-wrapper::before {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-sidemenu] .main-wrapper::after {
  content: "";
  height: 168px;
  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .main-wrapper::after {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-sidemenu] .sidebar {
  top: 74px;
  left: auto;
  left: initial;
  bottom: 24px;
}
[data-layout=horizontal-sidemenu] .sidebar .slimScrollDiv {
  height: 100% !important;
  top: 0;
}
[data-layout=horizontal-sidemenu] .sidebar .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=horizontal-sidemenu] .sidebar .slimScrollDiv .sidebar-menu {
  margin-top: 0;
  padding-bottom: 0;
}
[data-layout=horizontal-sidemenu] .sidebar .sidebar-menu {
  margin-top: 16px;
}
[data-layout=horizontal-sidemenu] .sidebar .sidebar-logo {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .sidebar {
    top: 50px;
    bottom: 0;
  }
}
@media (min-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .page-wrapper {
    padding: 74px 0 0;
  }
}
[data-layout=horizontal-sidemenu] .page-wrapper .head-icons {
  display: none;
}
[data-layout=horizontal-sidemenu] .expand-menu.mini-sidebar .header {
  left: 0;
}

[data-sidebar=dark] .sidebar {
  background: #262A2A;
  border-color: #262A2A;
}
[data-sidebar=dark] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=dark] .sidebar .logo {
  display: none;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=dark] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=dark] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right {
  background: #262A2A;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=dark] .sidebar-twocol .twocol-mini {
  background-color: #262A2A;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=dark] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=dark] .sidebar-stacked .stacked-mini {
  background-color: #262A2A;
  border-color: #323737;
}
[data-sidebar=dark] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #262A2A;
}
[data-sidebar=dark] .sidebar-stacked .btn-menubar:hover, [data-sidebar=dark] .sidebar-stacked .btn-menubar.active {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right {
  background: #262A2A;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #262A2A;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar-stacked .nav-link {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=dark] .sidebar-stacked .nav-link p, [data-sidebar=dark] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-stacked .nav-link:hover, [data-sidebar=dark] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=dark] .sidebar-stacked .nav-link:hover p, [data-sidebar=dark] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=darkgreen] .sidebar {
  background: #111926;
  border-color: #111926;
}
[data-sidebar=darkgreen] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=darkgreen] .sidebar .logo {
  display: none;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=darkgreen] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right {
  background: #111926;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgreen] .sidebar-twocol .twocol-mini {
  background-color: #111926;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=darkgreen] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=darkgreen] .sidebar-stacked .stacked-mini {
  background-color: #111926;
  border-color: #323737;
}
[data-sidebar=darkgreen] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #111926;
}
[data-sidebar=darkgreen] .sidebar-stacked .btn-menubar:hover, [data-sidebar=darkgreen] .sidebar-stacked .btn-menubar.active {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right {
  background: #111926;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #111926;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link p, [data-sidebar=darkgreen] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link:hover, [data-sidebar=darkgreen] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link:hover p, [data-sidebar=darkgreen] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=nightblue] .sidebar {
  background: #0F0F41;
  border-color: #0F0F41;
}
[data-sidebar=nightblue] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=nightblue] .sidebar .logo {
  display: none;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=nightblue] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right {
  background: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=nightblue] .sidebar-twocol .twocol-mini {
  background-color: #0F0F41;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=nightblue] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=nightblue] .sidebar-stacked .stacked-mini {
  background-color: #0F0F41;
  border-color: #323737;
}
[data-sidebar=nightblue] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-stacked .btn-menubar:hover, [data-sidebar=nightblue] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right {
  background: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgb(20.7375, 20.7375, 89.8625);
  border-color: rgb(20.7375, 20.7375, 89.8625);
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link p, [data-sidebar=nightblue] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link:hover, [data-sidebar=nightblue] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgb(18.825, 18.825, 81.575);
  border-color: rgb(18.825, 18.825, 81.575);
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link:hover p, [data-sidebar=nightblue] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=royalblue] .sidebar {
  background: #0039C6;
  border-color: #0039C6;
}
[data-sidebar=royalblue] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=royalblue] .sidebar .logo {
  display: none;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover i {
  color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop i {
  color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover i, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover .menu-arrow::before, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=royalblue] .sidebar-twocol.sidebar .nav-link:hover {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right {
  background: #0039C6;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right .sidebar-scroll > h6 {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #424848 !important;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=royalblue] .sidebar-twocol .twocol-mini {
  background-color: #0039C6;
  border-color: #6F6F6F;
}
@media (min-width: 991.98px) {
  [data-sidebar=royalblue] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=royalblue] .sidebar-stacked .stacked-mini {
  background-color: #0039C6;
  border-color: #6F6F6F;
}
[data-sidebar=royalblue] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #0039C6;
}
[data-sidebar=royalblue] .sidebar-stacked .btn-menubar:hover, [data-sidebar=royalblue] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right {
  background: #0039C6;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #0039C6;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgb(0, 65.8090909091, 228.6);
  border-color: rgb(0, 65.8090909091, 228.6);
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link p, [data-sidebar=royalblue] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link:hover, [data-sidebar=royalblue] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgb(0, 62.8727272727, 218.4);
  border-color: rgb(0, 62.8727272727, 218.4);
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link:hover p, [data-sidebar=royalblue] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=darkgray] .sidebar {
  background: #2E2E48;
  border-color: #2E2E48;
}
[data-sidebar=darkgray] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=darkgray] .sidebar .logo {
  display: none;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=darkgray] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right {
  background: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgray] .sidebar-twocol .twocol-mini {
  background-color: #2E2E48;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=darkgray] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=darkgray] .sidebar-stacked .stacked-mini {
  background-color: #2E2E48;
  border-color: #323737;
}
[data-sidebar=darkgray] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-stacked .btn-menubar:hover, [data-sidebar=darkgray] .sidebar-stacked .btn-menubar.active {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right {
  background: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link p, [data-sidebar=darkgray] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link:hover, [data-sidebar=darkgray] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link:hover p, [data-sidebar=darkgray] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=indigo] #sidebar {
  background: #391694;
  border-color: #391694;
}
[data-sidebar=indigo] #sidebar .dark-logo {
  display: block;
}
[data-sidebar=indigo] #sidebar .logo {
  display: none;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #C0C0C0;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li > ul > li > a:hover span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li > ul > li > a:hover i {
  color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #C0C0C0;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop i {
  color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #C0C0C0;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover i, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active i {
  color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover .menu-arrow::before, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=indigo] #sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=indigo] #sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=indigo] #sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=indigo] .sidebar-twocol.sidebar .nav-link:hover {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right {
  background: #391694;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right .sidebar-scroll > h6 {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #C0C0C0;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #424848 !important;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=indigo] .sidebar-twocol .twocol-mini {
  background-color: #391694;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=indigo] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=indigo] .sidebar-stacked .stacked-mini {
  background-color: #391694;
  border-color: #323737;
}
[data-sidebar=indigo] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #391694;
}
[data-sidebar=indigo] .sidebar-stacked .btn-menubar:hover, [data-sidebar=indigo] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right {
  background: #391694;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #391694;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=indigo] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgb(67.26, 25.96, 174.64);
  border-color: rgb(67.26, 25.96, 174.64);
}
[data-sidebar=indigo] .sidebar-stacked .nav-link p, [data-sidebar=indigo] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-stacked .nav-link:hover, [data-sidebar=indigo] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgb(63.84, 24.64, 165.76);
  border-color: rgb(63.84, 24.64, 165.76);
}
[data-sidebar=indigo] .sidebar-stacked .nav-link:hover p, [data-sidebar=indigo] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=all] .sidebar {
  background: rgb(var(--sidebar-rgb));
  background: rgb(var(--sidebar--rgb-picr));
  border-color: rgb(var(--sidebar-rgb));
  border-color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=all] .sidebar .logo {
  display: none;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li > ul > li > a:hover span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li > ul > li > a:hover i {
  color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop i {
  color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover i, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover .menu-arrow::before, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=all] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=all] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=all] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=all] .sidebar-twocol.sidebar .nav-link:hover {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right {
  background: rgb(var(--sidebar-rgb));
  background: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right .sidebar-scroll > h6 {
  color: #FFF;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #424848 !important;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=all] .sidebar-twocol .twocol-mini {
  background-color: rgb(var(--sidebar-rgb));
  background-color: rgb(var(--sidebar--rgb-picr));
  border-color: #6F6F6F;
}
@media (min-width: 991.98px) {
  [data-sidebar=all] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=all] .sidebar-stacked .stacked-mini {
  background-color: rgb(var(--sidebar-rgb));
  background-color: rgb(var(--sidebar--rgb-picr));
  border-color: #6F6F6F;
}
[data-sidebar=all] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: rgb(var(--sidebar-rgb));
  border-color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .btn-menubar:hover, [data-sidebar=all] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-stacked .sidebar-right {
  background: rgb(var(--sidebar-rgb));
  background: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=all] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: rgb(var(--sidebar-rgb));
  color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=all] .sidebar-stacked .sidebar-right a:hover {
  color: rgb(var(--sidebar-rgb));
  color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgba(var(--sidebar-rgb), 0.7);
  background: rgba(var(--sidebar--rgb-picr), 0.7);
  border-color: rgba(var(--sidebar-rgb), 0.7);
  border-color: rgba(var(--sidebar--rgb-picr), 0.7);
}
[data-sidebar=all] .sidebar-stacked .nav-link p, [data-sidebar=all] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=all] .sidebar-stacked .nav-link:hover, [data-sidebar=all] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgba(var(--sidebar-rgb), 0.4);
  background: rgba(var(--sidebar--rgb-picr), 0.4);
  border-color: rgba(var(--sidebar-rgb), 0.4);
  border-color: rgba(var(--sidebar--rgb-picr), 0.4);
}
[data-sidebar=all] .sidebar-stacked .nav-link:hover p, [data-sidebar=all] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-layout=default][data-topbar=darkaqua] .header,
[data-layout=mini][data-topbar=darkaqua] .header,
[data-layout=horizontal][data-topbar=darkaqua] .header,
[data-layout=horizontal-single][data-topbar=darkaqua] .header,
[data-layout=detached][data-topbar=darkaqua] .header,
[data-layout=twocolumn][data-topbar=darkaqua] .header,
[data-layout=stacked][data-topbar=darkaqua] .header,
[data-layout=transparent][data-topbar=darkaqua] .header {
  background: #116D6E;
  border-bottom-color: #116D6E;
}
[data-layout=default][data-topbar=darkaqua] .header .bg-white,
[data-layout=mini][data-topbar=darkaqua] .header .bg-white,
[data-layout=horizontal][data-topbar=darkaqua] .header .bg-white,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .bg-white,
[data-layout=detached][data-topbar=darkaqua] .header .bg-white,
[data-layout=twocolumn][data-topbar=darkaqua] .header .bg-white,
[data-layout=stacked][data-topbar=darkaqua] .header .bg-white,
[data-layout=transparent][data-topbar=darkaqua] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=darkaqua] .header .header-left,
[data-layout=mini][data-topbar=darkaqua] .header .header-left,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-left,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-left,
[data-layout=detached][data-topbar=darkaqua] .header .header-left,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-left,
[data-layout=stacked][data-topbar=darkaqua] .header .header-left,
[data-layout=transparent][data-topbar=darkaqua] .header .header-left {
  background: #116D6E;
  border-color: #116D6E;
}
[data-layout=default][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover, [data-layout=default][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=mini][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=mini][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=detached][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=detached][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=stacked][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=stacked][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=transparent][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=transparent][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active {
  color: #424848;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #116D6E;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #FFF;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  color: #424848;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-layout=default][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=mini][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal-single][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=detached][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=twocolumn][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=stacked][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=transparent][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo {
  display: none;
}
[data-layout=default][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=mini][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal-single][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=detached][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=twocolumn][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=stacked][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=transparent][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo {
  display: block;
}

[data-layout=default][data-topbar=rockblue] .header,
[data-layout=mini][data-topbar=rockblue] .header,
[data-layout=horizontal][data-topbar=rockblue] .header,
[data-layout=horizontal-single][data-topbar=rockblue] .header,
[data-layout=detached][data-topbar=rockblue] .header,
[data-layout=twocolumn][data-topbar=rockblue] .header,
[data-layout=stacked][data-topbar=rockblue] .header,
[data-layout=transparent][data-topbar=rockblue] .header {
  background: #8CB9BD;
  border-bottom-color: #8CB9BD;
}
[data-layout=default][data-topbar=rockblue] .header .bg-white,
[data-layout=mini][data-topbar=rockblue] .header .bg-white,
[data-layout=horizontal][data-topbar=rockblue] .header .bg-white,
[data-layout=horizontal-single][data-topbar=rockblue] .header .bg-white,
[data-layout=detached][data-topbar=rockblue] .header .bg-white,
[data-layout=twocolumn][data-topbar=rockblue] .header .bg-white,
[data-layout=stacked][data-topbar=rockblue] .header .bg-white,
[data-layout=transparent][data-topbar=rockblue] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=rockblue] .header .header-left,
[data-layout=mini][data-topbar=rockblue] .header .header-left,
[data-layout=horizontal][data-topbar=rockblue] .header .header-left,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-left,
[data-layout=detached][data-topbar=rockblue] .header .header-left,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-left,
[data-layout=stacked][data-topbar=rockblue] .header .header-left,
[data-layout=transparent][data-topbar=rockblue] .header .header-left {
  background: #8CB9BD;
  border-color: #8CB9BD;
}
[data-layout=default][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar {
  color: #262A2A;
}
[data-layout=default][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover, [data-layout=default][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=mini][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=mini][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=detached][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=detached][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=stacked][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=stacked][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=transparent][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=transparent][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active {
  background: #FFF;
}
[data-layout=default][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #8CB9BD;
}

[data-layout=default][data-topbar=whiterock] .header,
[data-layout=mini][data-topbar=whiterock] .header,
[data-layout=horizontal][data-topbar=whiterock] .header,
[data-layout=horizontal-single][data-topbar=whiterock] .header,
[data-layout=detached][data-topbar=whiterock] .header,
[data-layout=twocolumn][data-topbar=whiterock] .header,
[data-layout=stacked][data-topbar=whiterock] .header,
[data-layout=transparent][data-topbar=whiterock] .header {
  background: #F0E4D7;
  border-bottom-color: #F0E4D7;
}
[data-layout=default][data-topbar=whiterock] .header .bg-white,
[data-layout=mini][data-topbar=whiterock] .header .bg-white,
[data-layout=horizontal][data-topbar=whiterock] .header .bg-white,
[data-layout=horizontal-single][data-topbar=whiterock] .header .bg-white,
[data-layout=detached][data-topbar=whiterock] .header .bg-white,
[data-layout=twocolumn][data-topbar=whiterock] .header .bg-white,
[data-layout=stacked][data-topbar=whiterock] .header .bg-white,
[data-layout=transparent][data-topbar=whiterock] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=whiterock] .header .header-left,
[data-layout=mini][data-topbar=whiterock] .header .header-left,
[data-layout=horizontal][data-topbar=whiterock] .header .header-left,
[data-layout=horizontal-single][data-topbar=whiterock] .header .header-left,
[data-layout=detached][data-topbar=whiterock] .header .header-left,
[data-layout=twocolumn][data-topbar=whiterock] .header .header-left,
[data-layout=stacked][data-topbar=whiterock] .header .header-left,
[data-layout=transparent][data-topbar=whiterock] .header .header-left {
  background: #F0E4D7;
  border-color: #F0E4D7;
}
[data-layout=default][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar {
  color: #262A2A;
}
[data-layout=default][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #F0E4D7;
}

[data-layout=default][data-topbar=bluehaze] .header,
[data-layout=mini][data-topbar=bluehaze] .header,
[data-layout=horizontal][data-topbar=bluehaze] .header,
[data-layout=horizontal-single][data-topbar=bluehaze] .header,
[data-layout=detached][data-topbar=bluehaze] .header,
[data-layout=twocolumn][data-topbar=bluehaze] .header,
[data-layout=stacked][data-topbar=bluehaze] .header,
[data-layout=transparent][data-topbar=bluehaze] .header {
  background: #B5C0D0;
  border-bottom-color: #B5C0D0;
}
[data-layout=default][data-topbar=bluehaze] .header .bg-white,
[data-layout=mini][data-topbar=bluehaze] .header .bg-white,
[data-layout=horizontal][data-topbar=bluehaze] .header .bg-white,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .bg-white,
[data-layout=detached][data-topbar=bluehaze] .header .bg-white,
[data-layout=twocolumn][data-topbar=bluehaze] .header .bg-white,
[data-layout=stacked][data-topbar=bluehaze] .header .bg-white,
[data-layout=transparent][data-topbar=bluehaze] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=bluehaze] .header .header-left,
[data-layout=mini][data-topbar=bluehaze] .header .header-left,
[data-layout=horizontal][data-topbar=bluehaze] .header .header-left,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .header-left,
[data-layout=detached][data-topbar=bluehaze] .header .header-left,
[data-layout=twocolumn][data-topbar=bluehaze] .header .header-left,
[data-layout=stacked][data-topbar=bluehaze] .header .header-left,
[data-layout=transparent][data-topbar=bluehaze] .header .header-left {
  background: #B5C0D0;
  border-color: #B5C0D0;
}
[data-layout=default][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar {
  color: #262A2A;
}
[data-layout=default][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #B5C0D0;
}

[data-layout=default][data-topbar=orangegradient] .header,
[data-layout=mini][data-topbar=orangegradient] .header,
[data-layout=horizontal][data-topbar=orangegradient] .header,
[data-layout=horizontal-single][data-topbar=orangegradient] .header,
[data-layout=detached][data-topbar=orangegradient] .header,
[data-layout=twocolumn][data-topbar=orangegradient] .header,
[data-layout=stacked][data-topbar=orangegradient] .header,
[data-layout=transparent][data-topbar=orangegradient] .header {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
  border-bottom-color: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
}
[data-layout=default][data-topbar=orangegradient] .header .bg-white,
[data-layout=mini][data-topbar=orangegradient] .header .bg-white,
[data-layout=horizontal][data-topbar=orangegradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .bg-white,
[data-layout=detached][data-topbar=orangegradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=orangegradient] .header .bg-white,
[data-layout=stacked][data-topbar=orangegradient] .header .bg-white,
[data-layout=transparent][data-topbar=orangegradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=orangegradient] .header .header-left,
[data-layout=mini][data-topbar=orangegradient] .header .header-left,
[data-layout=horizontal][data-topbar=orangegradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .header-left,
[data-layout=detached][data-topbar=orangegradient] .header .header-left,
[data-layout=twocolumn][data-topbar=orangegradient] .header .header-left,
[data-layout=stacked][data-topbar=orangegradient] .header .header-left,
[data-layout=transparent][data-topbar=orangegradient] .header .header-left {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
  border-color: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
}
[data-layout=default][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
}

[data-layout=default][data-topbar=purplegradient] .header,
[data-layout=mini][data-topbar=purplegradient] .header,
[data-layout=horizontal][data-topbar=purplegradient] .header,
[data-layout=horizontal-single][data-topbar=purplegradient] .header,
[data-layout=detached][data-topbar=purplegradient] .header,
[data-layout=twocolumn][data-topbar=purplegradient] .header,
[data-layout=stacked][data-topbar=purplegradient] .header,
[data-layout=transparent][data-topbar=purplegradient] .header {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
  border-bottom-color: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
}
[data-layout=default][data-topbar=purplegradient] .header .bg-white,
[data-layout=mini][data-topbar=purplegradient] .header .bg-white,
[data-layout=horizontal][data-topbar=purplegradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .bg-white,
[data-layout=detached][data-topbar=purplegradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=purplegradient] .header .bg-white,
[data-layout=stacked][data-topbar=purplegradient] .header .bg-white,
[data-layout=transparent][data-topbar=purplegradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=purplegradient] .header .header-left,
[data-layout=mini][data-topbar=purplegradient] .header .header-left,
[data-layout=horizontal][data-topbar=purplegradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .header-left,
[data-layout=detached][data-topbar=purplegradient] .header .header-left,
[data-layout=twocolumn][data-topbar=purplegradient] .header .header-left,
[data-layout=stacked][data-topbar=purplegradient] .header .header-left,
[data-layout=transparent][data-topbar=purplegradient] .header .header-left {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
  border-color: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
}
[data-layout=default][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
}

[data-layout=default][data-topbar=bluegradient] .header,
[data-layout=mini][data-topbar=bluegradient] .header,
[data-layout=horizontal][data-topbar=bluegradient] .header,
[data-layout=horizontal-single][data-topbar=bluegradient] .header,
[data-layout=detached][data-topbar=bluegradient] .header,
[data-layout=twocolumn][data-topbar=bluegradient] .header,
[data-layout=stacked][data-topbar=bluegradient] .header,
[data-layout=transparent][data-topbar=bluegradient] .header {
  background: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
  border-bottom-color: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
}
[data-layout=default][data-topbar=bluegradient] .header .bg-white,
[data-layout=mini][data-topbar=bluegradient] .header .bg-white,
[data-layout=horizontal][data-topbar=bluegradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .bg-white,
[data-layout=detached][data-topbar=bluegradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=bluegradient] .header .bg-white,
[data-layout=stacked][data-topbar=bluegradient] .header .bg-white,
[data-layout=transparent][data-topbar=bluegradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=bluegradient] .header .header-left,
[data-layout=mini][data-topbar=bluegradient] .header .header-left,
[data-layout=horizontal][data-topbar=bluegradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .header-left,
[data-layout=detached][data-topbar=bluegradient] .header .header-left,
[data-layout=twocolumn][data-topbar=bluegradient] .header .header-left,
[data-layout=stacked][data-topbar=bluegradient] .header .header-left,
[data-layout=transparent][data-topbar=bluegradient] .header .header-left {
  background: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
  border-color: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
}
[data-layout=default][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
}

[data-layout=default][data-topbar=maroongradient] .header,
[data-layout=mini][data-topbar=maroongradient] .header,
[data-layout=horizontal][data-topbar=maroongradient] .header,
[data-layout=horizontal-single][data-topbar=maroongradient] .header,
[data-layout=detached][data-topbar=maroongradient] .header,
[data-layout=twocolumn][data-topbar=maroongradient] .header,
[data-layout=stacked][data-topbar=maroongradient] .header,
[data-layout=transparent][data-topbar=maroongradient] .header {
  background: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
  border-bottom-color: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
}
[data-layout=default][data-topbar=maroongradient] .header .bg-white,
[data-layout=mini][data-topbar=maroongradient] .header .bg-white,
[data-layout=horizontal][data-topbar=maroongradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .bg-white,
[data-layout=detached][data-topbar=maroongradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=maroongradient] .header .bg-white,
[data-layout=stacked][data-topbar=maroongradient] .header .bg-white,
[data-layout=transparent][data-topbar=maroongradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=maroongradient] .header .header-left,
[data-layout=mini][data-topbar=maroongradient] .header .header-left,
[data-layout=horizontal][data-topbar=maroongradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .header-left,
[data-layout=detached][data-topbar=maroongradient] .header .header-left,
[data-layout=twocolumn][data-topbar=maroongradient] .header .header-left,
[data-layout=stacked][data-topbar=maroongradient] .header .header-left,
[data-layout=transparent][data-topbar=maroongradient] .header .header-left {
  background: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
  border-color: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
}
[data-layout=default][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
}

[data-layout=default][data-topbar=all] .header,
[data-layout=mini][data-topbar=all] .header,
[data-layout=horizontal][data-topbar=all] .header,
[data-layout=horizontal-single][data-topbar=all] .header,
[data-layout=detached][data-topbar=all] .header,
[data-layout=twocolumn][data-topbar=all] .header,
[data-layout=stacked][data-topbar=all] .header,
[data-layout=transparent][data-topbar=all] .header {
  background: rgb(var(--topbar-rgb));
  background: rgb(var(--topbar--rgb-picr));
  border-bottom-color: rgb(var(--topbar-rgb));
  border-bottom-color: rgb(var(--topbar--rgb-picr));
}
[data-layout=default][data-topbar=all] .header .bg-white,
[data-layout=mini][data-topbar=all] .header .bg-white,
[data-layout=horizontal][data-topbar=all] .header .bg-white,
[data-layout=horizontal-single][data-topbar=all] .header .bg-white,
[data-layout=detached][data-topbar=all] .header .bg-white,
[data-layout=twocolumn][data-topbar=all] .header .bg-white,
[data-layout=stacked][data-topbar=all] .header .bg-white,
[data-layout=transparent][data-topbar=all] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=all] .header .header-left,
[data-layout=mini][data-topbar=all] .header .header-left,
[data-layout=horizontal][data-topbar=all] .header .header-left,
[data-layout=horizontal-single][data-topbar=all] .header .header-left,
[data-layout=detached][data-topbar=all] .header .header-left,
[data-layout=twocolumn][data-topbar=all] .header .header-left,
[data-layout=stacked][data-topbar=all] .header .header-left,
[data-layout=transparent][data-topbar=all] .header .header-left {
  background: rgb(var(--topbar-rgb));
  background: rgb(var(--topbar--rgb-picr));
  border-color: rgb(var(--topbar-rgb));
  border-color: rgb(var(--topbar--rgb-picr));
}
[data-layout=default][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=all] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover, [data-layout=default][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=mini][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=mini][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal-single][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-single][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=detached][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=detached][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=twocolumn][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=twocolumn][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=stacked][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=stacked][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=transparent][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=transparent][data-topbar=all] .header .header-user .user-menu .btn-menubar.active {
  color: #424848;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: rgb(var(--topbar-rgb));
  background: rgb(var(--topbar--rgb-picr));
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #FFF;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  color: #424848;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-layout=default][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=mini][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal-single][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=detached][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=twocolumn][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=stacked][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=transparent][data-topbar=all] .menu-horizontal .header .header-left .logo {
  display: none;
}
[data-layout=default][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=mini][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal-single][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=detached][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=twocolumn][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=stacked][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=transparent][data-topbar=all] .menu-horizontal .header .header-left .dark-logo {
  display: block;
}

[data-layout=horizontal-overlay][data-topbarcolor=dark] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header {
  left: 0;
  background-color: #262A2A;
  border-color: #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar {
  background-color: #262A2A;
  border-bottom: 1px solid #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .main-wrapper::before {
  background: #262A2A;
}

[data-layout=horizontal-overlay][data-topbarcolor=primary] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header {
  left: 0;
  background-color: #e85b28;
  border-color: #E94C39;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover {
  background: #EF796A;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar {
  background-color: #e85b28;
  border-bottom: 1px solid #E94C39;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover {
  background: #EF796A;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .main-wrapper::before {
  content: "";
  background: #e85b28;
}

[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header {
  left: 0;
  background-color: #080821;
  border-color: #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar {
  background-color: #080821;
  border-bottom: 1px solid #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .main-wrapper::before {
  content: "";
  background: #080821;
}

[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header {
  left: 0;
  background-color: #710034;
  border-color: rgb(117.59, 0, 54.1122123894);
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar {
  background-color: #710034;
  border-bottom: 1px solid rgb(117.59, 0, 54.1122123894);
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .main-wrapper::before {
  content: "";
  background: #710034;
}

[data-layout=horizontal-overlay][data-topbarcolor=white] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header {
  left: 0;
  background-color: #FFF;
  border-color: white;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .dark-logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .mode-toggle {
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar {
  background-color: #FFF;
  border-bottom: 1px solid white;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .main-wrapper::before {
  content: "";
  background: #FFF;
}

[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header {
  left: 0;
  background-color: #3E1C95;
  border-color: rgb(63.6077966102, 28.7261016949, 152.8638983051);
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar {
  background-color: #3E1C95;
  border-bottom: 1px solid rgb(63.6077966102, 28.7261016949, 152.8638983051);
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .main-wrapper::before {
  content: "";
  background: #3E1C95;
}

[data-layout=horizontal-overlay][data-topbarcolor=all] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header {
  left: 0;
  background-color: rgb(var(--topbarcolor-rgb));
  background-color: rgb(var(--topbarcolor--rgb-picr));
  border-color: rgb(var(--topbarcolor-rgb));
  border-color: rgb(var(--topbarcolor--rgb-picr));
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar {
  background-color: rgb(var(--topbarcolor-rgb));
  background-color: rgb(var(--topbarcolor--rgb-picr));
  border-bottom: 1px solid rgb(var(--topbarcolor-rgb));
  border-bottom: 1px solid rgb(var(--topbarcolor--rgb-picr));
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .main-wrapper::before {
  content: "";
  background: rgb(var(--topbarcolor-rgb));
  background: rgb(var(--topbarcolor--rgb-picr));
}

[data-sidebarbg=sidebarbg1] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg1] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header {
  left: 0;
  background-color: #053333;
  border-color: #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar {
  background-color: #053333;
  border-bottom: 1px solid #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .main-wrapper::before {
  content: "";
  background: #053333;
}

[data-sidebarbg=sidebarbg1] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg1] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

[data-sidebarbg=sidebarbg2] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg2] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg3] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg3] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg4] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg4] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg5] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg5] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg6] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg6] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

[data-sidebar=light] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(17, 25, 38, 0.85);
}

[data-sidebar=nightblue] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(15, 15, 65, 0.85);
}

[data-sidebar=darkgray] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(46, 46, 72, 0.85);
}

[data-sidebar=royalblue] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(0, 57, 198, 0.85);
}

[data-sidebar=indigo] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(57, 22, 148, 0.85);
}

[data-sidebar=all] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(var(--sidebar-rgb), 0.85);
  background: rgba(var(--sidebar--rgb-picr), 0.85);
}

[data-layout=horizontal-overlay] [data-topbarbg=pattern1] .main-wrapper::after,
[data-layout=horizontal-sidemenu] [data-topbarbg=pattern1] .main-wrapper::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

[data-layout=horizontal-overlay] [data-topbarbg=pattern2] .main-wrapper::after,
[data-layout=horizontal-sidemenu] [data-topbarbg=pattern2] .main-wrapper::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

[data-layout=horizontal-overlay] [data-topbarbg=pattern3] .main-wrapper::after,
[data-layout=horizontal-sidemenu] [data-topbarbg=pattern3] .main-wrapper::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

[data-layout=horizontal-overlay][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(113, 0, 52, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(255, 255, 255, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(232, 91, 40, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(8, 8, 33, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(62, 28, 149, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(5, 51, 51, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=modern][data-topbarcolor=white] .header {
  background-color: #FFF;
  border-color: rgba(255, 255, 255, 0.8);
}
[data-layout=modern][data-topbarcolor=white] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar.active {
  background-color: #E8E9EA;
  border-color: #E8E9EA;
  color: #262A2A !important;
}
[data-layout=modern][data-topbarcolor=white] .header .header-left .logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=white] .header .header-left .dark-logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=white] .page-wrapper::before {
  background: #FFF;
}
[data-layout=modern][data-topbarcolor=white] .page-wrapper .head-icons {
  display: none;
}

[data-layout=modern][data-topbarcolor=blue] .header {
  background-color: #FFF;
  border-color: rgba(255, 255, 255, 0.8);
}
[data-layout=modern][data-topbarcolor=blue] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar.active {
  background-color: #E8E9EA;
  border-color: #E8E9EA;
  color: #262A2A !important;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=blue] .page-wrapper::before {
  background: #FFF;
}

[data-layout=modern][data-topbarcolor=primary] .header {
  background-color: #e85b28;
  border-color: #E94C39;
}
[data-layout=modern][data-topbarcolor=primary] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=primary] .page-wrapper::before {
  background: #e85b28;
}

[data-layout=modern][data-topbarcolor=blackpearl] .header {
  background-color: #080821;
  border-color: rgba(8, 8, 33, 0.8);
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=blackpearl] .page-wrapper::before {
  background: #080821;
}

[data-layout=modern][data-topbarcolor=maroon] .header {
  background-color: #710034;
  border-color: rgba(113, 0, 52, 0.8);
}
[data-layout=modern][data-topbarcolor=maroon] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=maroon] .page-wrapper::before {
  background: #710034;
}

[data-layout=modern][data-topbarcolor=bluegem] .header {
  background-color: #3E1C95;
  border-color: rgba(62, 28, 149, 0.8);
}
[data-layout=modern][data-topbarcolor=bluegem] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=bluegem] .page-wrapper::before {
  background: #3E1C95;
}

[data-layout=modern][data-topbarcolor=firefly] .header {
  background-color: #053333;
  border-color: rgba(5, 51, 51, 0.8);
}
[data-layout=modern][data-topbarcolor=firefly] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=firefly] .page-wrapper::before {
  background: #053333;
}

[data-card=borderless] .card {
  border: 0 !important;
  box-shadow: none;
}

[data-card=shadow] .card {
  border: 0 !important;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}

[data-color=primary] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #e85b28;
  border-bottom: 2px solid #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=primary] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #e85b28;
}
[data-color=primary] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=primary] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #e85b28;
}
[data-color=primary] .btn.btn-primary {
  background-color: #e85b28;
  border: 1px solid #e85b28;
}
[data-color=primary] .btn.btn-primary:hover, [data-color=primary] .btn.btn-primary:focus, [data-color=primary] .btn.btn-primary.focus, [data-color=primary] .btn.btn-primary:active, [data-color=primary] .btn.btn-primary.active {
  background-color: rgb(213.4642857143, 73.4714285714, 22.8357142857);
  border: 1px solid rgb(213.4642857143, 73.4714285714, 22.8357142857);
}
[data-color=primary] .btn-check:checked + .btn, [data-color=primary] .btn.active, [data-color=primary] .btn.show, [data-color=primary] .btn.show:hover, [data-color=primary] .btn:first-child:active, [data-color=primary] :not(.btn-check) + .btn:active {
  background-color: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .link-primary {
  color: #e85b28 !important;
}
[data-color=primary] .link-primary:hover, [data-color=primary] .link-primary:focus, [data-color=primary] .link-primary:active {
  color: rgb(213.4642857143, 73.4714285714, 22.8357142857);
}
[data-color=primary] .text-primary {
  color: #e85b28 !important;
}
[data-color=primary] .badge.badge-primary {
  background: #e85b28;
}
[data-color=primary] .dataTables_paginate .pagination li.active a.page-link {
  background: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .bg-primary {
  background-color: #e85b28 !important;
  border: 1px solid #e85b28 !important;
}
[data-color=primary] .border-bottom.border-primary {
  border-color: #e85b28 !important;
}
[data-color=primary] .border-primary {
  border-color: #e85b28 !important;
}
[data-color=primary] .nav-tabs.nav-tabs-bottom li a.active, [data-color=primary] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #e85b28;
  color: #e85b28;
}
[data-color=primary] .badge.badge-soft-primary {
  background: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}
[data-color=primary] a:hover {
  color: #e85b28;
}
[data-color=primary] a.video-expand:hover {
  color: #FFF;
}
[data-color=primary] .btn-outline-primary {
  border: 1px solid #e85b28 !important;
  color: #e85b28 !important;
}
[data-color=primary] .btn-outline-primary:hover, [data-color=primary] .btn-outline-primary:focus, [data-color=primary] .btn-outline-primary.focus, [data-color=primary] .btn-outline-primary:active, [data-color=primary] .btn-outline-primary.active {
  background-color: #e85b28 !important;
  border: 1px solid #e85b28 !important;
  color: #FFF !important;
}
[data-color=primary] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #e85b28;
}
[data-color=primary] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #e85b28;
}
[data-color=primary] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .nav-tabs .nav-link:hover {
  color: #e85b28;
}
[data-color=primary] .form-check-input:checked {
  background-color: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .sidebar-contact .toggle-theme {
  background-color: #e85b28;
}
@media (max-width: 991.98px) {
  [data-color=primary] .sidebar-contact .toggle-theme {
    display: none;
  }
}
[data-color=primary] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #e85b28;
}
[data-color=primary] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #e85b28;
}
[data-color=primary] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=primary] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=primary] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=primary] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #e85b28;
}
[data-color=primary] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=primary] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=primary] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #e85b28;
}
[data-color=primary] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #e85b28;
}
[data-color=primary] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #e85b28;
}
[data-color=primary] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=primary] #chart-bar .c3-target-data2 .c3-bar, [data-color=primary] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #e85b28 !important;
}
[data-color=primary] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #e85b28 !important;
}
[data-color=primary] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #e85b28;
}
[data-color=primary] .nav.tab-style-1 .nav-link.active {
  background-color: #e85b28 !important;
}
[data-color=primary] .table tbody tr td a:hover {
  color: #e85b28;
}
[data-color=primary] .view-icons a.active, [data-color=primary] .view-icons a:hover {
  background: #e85b28;
  color: #FFF;
}

[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=brightblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #4680FF;
  border-bottom: 2px solid #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .nav-link.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=brightblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #4680FF;
}
[data-color=brightblue] .btn.btn-primary {
  background-color: #4680FF;
  border: 1px solid #4680FF;
}
[data-color=brightblue] .btn.btn-primary:hover, [data-color=brightblue] .btn.btn-primary:focus, [data-color=brightblue] .btn.btn-primary.focus, [data-color=brightblue] .btn.btn-primary:active, [data-color=brightblue] .btn.btn-primary.active {
  background-color: rgb(34.3, 103.4924324324, 255);
  border: 1px solid rgb(34.3, 103.4924324324, 255);
}
[data-color=brightblue] .btn-check:checked + .btn, [data-color=brightblue] .btn.active, [data-color=brightblue] .btn.show, [data-color=brightblue] .btn.show:hover, [data-color=brightblue] .btn:first-child:active, [data-color=brightblue] :not(.btn-check) + .btn:active {
  background-color: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .link-primary {
  color: #4680FF !important;
}
[data-color=brightblue] .link-primary:hover, [data-color=brightblue] .link-primary:focus, [data-color=brightblue] .link-primary:active {
  color: rgb(34.3, 103.4924324324, 255);
}
[data-color=brightblue] .text-primary {
  color: #4680FF !important;
}
[data-color=brightblue] .badge.badge-primary {
  background: #4680FF;
}
[data-color=brightblue] .dataTables_paginate .pagination li.active a.page-link {
  background: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .bg-primary {
  background-color: #4680FF !important;
  border: 1px solid #4680FF !important;
}
[data-color=brightblue] .border-bottom.border-primary {
  border-color: #4680FF !important;
}
[data-color=brightblue] .border-primary {
  border-color: #4680FF !important;
}
[data-color=brightblue] .nav-tabs.nav-tabs-bottom li a.active, [data-color=brightblue] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #4680FF;
  color: #4680FF;
}
[data-color=brightblue] .badge.badge-soft-primary {
  background: rgba(70, 128, 255, 0.1);
  color: #4680FF;
}
[data-color=brightblue] a:hover {
  color: #4680FF;
}
[data-color=brightblue] .btn-outline-primary {
  border: 1px solid #4680FF !important;
  color: #4680FF !important;
}
[data-color=brightblue] .btn-outline-primary:hover, [data-color=brightblue] .btn-outline-primary:focus, [data-color=brightblue] .btn-outline-primary.focus, [data-color=brightblue] .btn-outline-primary:active, [data-color=brightblue] .btn-outline-primary.active {
  background-color: #4680FF !important;
  border: 1px solid #4680FF !important;
}
[data-color=brightblue] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #4680FF;
}
[data-color=brightblue] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #4680FF;
}
[data-color=brightblue] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .nav-tabs .nav-link:hover {
  color: #4680FF;
}
[data-color=brightblue] .form-check-input:checked {
  background-color: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .sidebar-contact .toggle-theme {
  background-color: #4680FF;
}
[data-color=brightblue] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #4680FF;
}
[data-color=brightblue] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #4680FF;
}
[data-color=brightblue] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=brightblue] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=brightblue] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=brightblue] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #4680FF;
}
[data-color=brightblue] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=brightblue] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=brightblue] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #4680FF;
}
[data-color=brightblue] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #4680FF;
}
[data-color=brightblue] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #4680FF;
}
[data-color=brightblue] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=brightblue] #chart-bar .c3-target-data2 .c3-bar, [data-color=brightblue] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #4680FF !important;
}
[data-color=brightblue] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #4680FF !important;
}
[data-color=brightblue] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #4680FF;
}
[data-color=brightblue] .nav.tab-style-1 .nav-link.active {
  background-color: #4680FF !important;
}
[data-color=brightblue] .table tbody tr td a:hover {
  color: #4680FF;
}
[data-color=brightblue] .view-icons a.active, [data-color=brightblue] .view-icons a:hover {
  background: #4680FF;
  color: #FFF;
}

[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #365E32;
  border-bottom: 2px solid #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .nav-link.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=lunargreen] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #365E32;
}
[data-color=lunargreen] .btn.btn-primary {
  background-color: #365E32;
  border: 1px solid #365E32;
}
[data-color=lunargreen] .btn.btn-primary:hover, [data-color=lunargreen] .btn.btn-primary:focus, [data-color=lunargreen] .btn.btn-primary.focus, [data-color=lunargreen] .btn.btn-primary:active, [data-color=lunargreen] .btn.btn-primary.active {
  background-color: rgb(40.6125, 70.6958333333, 37.6041666667);
  border: 1px solid rgb(40.6125, 70.6958333333, 37.6041666667);
}
[data-color=lunargreen] .btn-check:checked + .btn, [data-color=lunargreen] .btn.active, [data-color=lunargreen] .btn.show, [data-color=lunargreen] .btn.show:hover, [data-color=lunargreen] .btn:first-child:active, [data-color=lunargreen] :not(.btn-check) + .btn:active {
  background-color: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .link-primary {
  color: #365E32 !important;
}
[data-color=lunargreen] .link-primary:hover, [data-color=lunargreen] .link-primary:focus, [data-color=lunargreen] .link-primary:active {
  color: rgb(40.6125, 70.6958333333, 37.6041666667);
}
[data-color=lunargreen] .text-primary {
  color: #365E32 !important;
}
[data-color=lunargreen] .badge.badge-primary {
  background: #365E32;
}
[data-color=lunargreen] .dataTables_paginate .pagination li.active a.page-link {
  background: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .bg-primary {
  background-color: #365E32 !important;
  border: 1px solid #365E32 !important;
}
[data-color=lunargreen] .border-bottom.border-primary {
  border-color: #365E32 !important;
}
[data-color=lunargreen] .border-primary {
  border-color: #365E32 !important;
}
[data-color=lunargreen] .nav-tabs.nav-tabs-bottom li a.active, [data-color=lunargreen] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #365E32;
  color: #365E32;
}
[data-color=lunargreen] .badge.badge-soft-primary {
  background: rgba(54, 94, 50, 0.1);
  color: #365E32;
}
[data-color=lunargreen] a:hover {
  color: #365E32;
}
[data-color=lunargreen] .btn-outline-primary {
  border: 1px solid #365E32 !important;
  color: #365E32 !important;
}
[data-color=lunargreen] .btn-outline-primary:hover, [data-color=lunargreen] .btn-outline-primary:focus, [data-color=lunargreen] .btn-outline-primary.focus, [data-color=lunargreen] .btn-outline-primary:active, [data-color=lunargreen] .btn-outline-primary.active {
  background-color: #365E32 !important;
  border: 1px solid #365E32 !important;
}
[data-color=lunargreen] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #365E32;
}
[data-color=lunargreen] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #365E32;
}
[data-color=lunargreen] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .nav-tabs .nav-link:hover {
  color: #365E32;
}
[data-color=lunargreen] .form-check-input:checked {
  background-color: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .sidebar-contact .toggle-theme {
  background-color: #365E32;
}
[data-color=lunargreen] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #365E32;
}
[data-color=lunargreen] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #365E32;
}
[data-color=lunargreen] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=lunargreen] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=lunargreen] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=lunargreen] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #365E32;
}
[data-color=lunargreen] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lunargreen] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lunargreen] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #365E32;
}
[data-color=lunargreen] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #365E32;
}
[data-color=lunargreen] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #365E32;
}
[data-color=lunargreen] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=lunargreen] #chart-bar .c3-target-data2 .c3-bar, [data-color=lunargreen] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #365E32 !important;
}
[data-color=lunargreen] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #365E32 !important;
}
[data-color=lunargreen] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #365E32;
}
[data-color=lunargreen] .nav.tab-style-1 .nav-link.active {
  background-color: #365E32 !important;
}
[data-color=lunargreen] .table tbody tr td a:hover {
  color: #365E32;
}
[data-color=lunargreen] .view-icons a.active, [data-color=lunargreen] .view-icons a:hover {
  background: #365E32;
  color: #FFF;
}

[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=lavendar] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #673AB7;
  border-bottom: 2px solid #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .nav-link.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=lavendar] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #673AB7;
}
[data-color=lavendar] .btn.btn-primary {
  background-color: #673AB7;
  border: 1px solid #673AB7;
}
[data-color=lavendar] .btn.btn-primary:hover, [data-color=lavendar] .btn.btn-primary:focus, [data-color=lavendar] .btn.btn-primary.focus, [data-color=lavendar] .btn.btn-primary:active, [data-color=lavendar] .btn.btn-primary.active {
  background-color: rgb(87.7423236515, 49.4082987552, 155.8917012448);
  border: 1px solid rgb(87.7423236515, 49.4082987552, 155.8917012448);
}
[data-color=lavendar] .btn-check:checked + .btn, [data-color=lavendar] .btn.active, [data-color=lavendar] .btn.show, [data-color=lavendar] .btn.show:hover, [data-color=lavendar] .btn:first-child:active, [data-color=lavendar] :not(.btn-check) + .btn:active {
  background-color: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .link-primary {
  color: #673AB7 !important;
}
[data-color=lavendar] .link-primary:hover, [data-color=lavendar] .link-primary:focus, [data-color=lavendar] .link-primary:active {
  color: rgb(87.7423236515, 49.4082987552, 155.8917012448);
}
[data-color=lavendar] .text-primary {
  color: #673AB7 !important;
}
[data-color=lavendar] .badge.badge-primary {
  background: #673AB7;
}
[data-color=lavendar] .dataTables_paginate .pagination li.active a.page-link {
  background: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .bg-primary {
  background-color: #673AB7 !important;
  border: 1px solid #673AB7 !important;
}
[data-color=lavendar] .border-bottom.border-primary {
  border-color: #673AB7 !important;
}
[data-color=lavendar] .border-primary {
  border-color: #673AB7 !important;
}
[data-color=lavendar] .nav-tabs.nav-tabs-bottom li a.active, [data-color=lavendar] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #673AB7;
  color: #673AB7;
}
[data-color=lavendar] .badge.badge-soft-primary {
  background: rgba(103, 58, 183, 0.1);
  color: #673AB7;
}
[data-color=lavendar] a:hover {
  color: #673AB7;
}
[data-color=lavendar] .btn-outline-primary {
  border: 1px solid #673AB7 !important;
  color: #673AB7 !important;
}
[data-color=lavendar] .btn-outline-primary:hover, [data-color=lavendar] .btn-outline-primary:focus, [data-color=lavendar] .btn-outline-primary.focus, [data-color=lavendar] .btn-outline-primary:active, [data-color=lavendar] .btn-outline-primary.active {
  background-color: #673AB7 !important;
  border: 1px solid #673AB7 !important;
}
[data-color=lavendar] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #673AB7;
}
[data-color=lavendar] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #673AB7;
}
[data-color=lavendar] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .nav-tabs .nav-link:hover {
  color: #673AB7;
}
[data-color=lavendar] .form-check-input:checked {
  background-color: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .sidebar-contact .toggle-theme {
  background-color: #673AB7;
}
[data-color=lavendar] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #673AB7;
}
[data-color=lavendar] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #673AB7;
}
[data-color=lavendar] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=lavendar] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=lavendar] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=lavendar] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #673AB7;
}
[data-color=lavendar] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavendar] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavendar] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #673AB7;
}
[data-color=lavendar] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #673AB7;
}
[data-color=lavendar] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #673AB7;
}
[data-color=lavendar] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=lavendar] #chart-bar .c3-target-data2 .c3-bar, [data-color=lavendar] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #673AB7 !important;
}
[data-color=lavendar] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #673AB7 !important;
}
[data-color=lavendar] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #673AB7;
}
[data-color=lavendar] .nav.tab-style-1 .nav-link.active {
  background-color: #673AB7 !important;
}
[data-color=lavendar] .table tbody tr td a:hover {
  color: #673AB7;
}
[data-color=lavendar] .view-icons a.active, [data-color=lavendar] .view-icons a:hover {
  background: #673AB7;
  color: #FFF;
}

[data-color=magenta] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=magenta] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #E83E8C;
  border-bottom: 2px solid #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=magenta] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .nav-link.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=magenta] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #E83E8C;
}
[data-color=magenta] .btn.btn-primary {
  background-color: #E83E8C;
  border: 1px solid #E83E8C;
}
[data-color=magenta] .btn.btn-primary:hover, [data-color=magenta] .btn.btn-primary:focus, [data-color=magenta] .btn.btn-primary.focus, [data-color=magenta] .btn.btn-primary:active, [data-color=magenta] .btn.btn-primary.active {
  background-color: rgb(228.1986111111, 30.1013888889, 120.9930555556);
  border: 1px solid rgb(228.1986111111, 30.1013888889, 120.9930555556);
}
[data-color=magenta] .btn-check:checked + .btn, [data-color=magenta] .btn.active, [data-color=magenta] .btn.show, [data-color=magenta] .btn.show:hover, [data-color=magenta] .btn:first-child:active, [data-color=magenta] :not(.btn-check) + .btn:active {
  background-color: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .link-primary {
  color: #E83E8C !important;
}
[data-color=magenta] .link-primary:hover, [data-color=magenta] .link-primary:focus, [data-color=magenta] .link-primary:active {
  color: rgb(228.1986111111, 30.1013888889, 120.9930555556);
}
[data-color=magenta] .text-primary {
  color: #E83E8C !important;
}
[data-color=magenta] .badge.badge-primary {
  background: #E83E8C;
}
[data-color=magenta] .dataTables_paginate .pagination li.active a.page-link {
  background: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .bg-primary {
  background-color: #E83E8C !important;
  border: 1px solid #E83E8C !important;
}
[data-color=magenta] .border-bottom.border-primary {
  border-color: #E83E8C !important;
}
[data-color=magenta] .border-primary {
  border-color: #E83E8C !important;
}
[data-color=magenta] .nav-tabs.nav-tabs-bottom li a.active, [data-color=magenta] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #E83E8C;
  color: #E83E8C;
}
[data-color=magenta] .badge.badge-soft-primary {
  background: rgba(232, 62, 140, 0.1);
  color: #E83E8C;
}
[data-color=magenta] a:hover {
  color: #E83E8C;
}
[data-color=magenta] .btn-outline-primary {
  border: 1px solid #E83E8C !important;
  color: #E83E8C !important;
}
[data-color=magenta] .btn-outline-primary:hover, [data-color=magenta] .btn-outline-primary:focus, [data-color=magenta] .btn-outline-primary.focus, [data-color=magenta] .btn-outline-primary:active, [data-color=magenta] .btn-outline-primary.active {
  background-color: #E83E8C !important;
  border: 1px solid #E83E8C !important;
}
[data-color=magenta] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #E83E8C;
}
[data-color=magenta] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #E83E8C;
}
[data-color=magenta] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .nav-tabs .nav-link:hover {
  color: #E83E8C;
}
[data-color=magenta] .form-check-input:checked {
  background-color: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .sidebar-contact .toggle-theme {
  background-color: #E83E8C;
}
[data-color=magenta] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #E83E8C;
}
[data-color=magenta] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #E83E8C;
}
[data-color=magenta] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=magenta] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=magenta] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=magenta] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #E83E8C;
}
[data-color=magenta] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=magenta] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=magenta] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #E83E8C;
}
[data-color=magenta] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #E83E8C;
}
[data-color=magenta] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #E83E8C;
}
[data-color=magenta] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=magenta] #chart-bar .c3-target-data2 .c3-bar, [data-color=magenta] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #E83E8C !important;
}
[data-color=magenta] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #E83E8C !important;
}
[data-color=magenta] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #E83E8C;
}
[data-color=magenta] .nav.tab-style-1 .nav-link.active {
  background-color: #E83E8C !important;
}
[data-color=magenta] .table tbody tr td a:hover {
  color: #E83E8C;
}
[data-color=magenta] .view-icons a.active, [data-color=magenta] .view-icons a:hover {
  background: #E83E8C;
  color: #FFF;
}

[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #FF9B04;
  border-bottom: 2px solid #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .nav-link.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=chromeyellow] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .btn.btn-primary {
  background-color: #FF9B04;
  border: 1px solid #FF9B04;
}
[data-color=chromeyellow] .btn.btn-primary:hover, [data-color=chromeyellow] .btn.btn-primary:focus, [data-color=chromeyellow] .btn.btn-primary.focus, [data-color=chromeyellow] .btn.btn-primary:active, [data-color=chromeyellow] .btn.btn-primary.active {
  background-color: rgb(223.3, 134.3358565737, 0);
  border: 1px solid rgb(223.3, 134.3358565737, 0);
}
[data-color=chromeyellow] .btn-check:checked + .btn, [data-color=chromeyellow] .btn.active, [data-color=chromeyellow] .btn.show, [data-color=chromeyellow] .btn.show:hover, [data-color=chromeyellow] .btn:first-child:active, [data-color=chromeyellow] :not(.btn-check) + .btn:active {
  background-color: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .link-primary {
  color: #FF9B04 !important;
}
[data-color=chromeyellow] .link-primary:hover, [data-color=chromeyellow] .link-primary:focus, [data-color=chromeyellow] .link-primary:active {
  color: rgb(223.3, 134.3358565737, 0);
}
[data-color=chromeyellow] .text-primary {
  color: #FF9B04 !important;
}
[data-color=chromeyellow] .badge.badge-primary {
  background: #FF9B04;
}
[data-color=chromeyellow] .dataTables_paginate .pagination li.active a.page-link {
  background: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .bg-primary {
  background-color: #FF9B04 !important;
  border: 1px solid #FF9B04 !important;
}
[data-color=chromeyellow] .border-bottom.border-primary {
  border-color: #FF9B04 !important;
}
[data-color=chromeyellow] .border-primary {
  border-color: #FF9B04 !important;
}
[data-color=chromeyellow] .nav-tabs.nav-tabs-bottom li a.active, [data-color=chromeyellow] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #FF9B04;
  color: #FF9B04;
}
[data-color=chromeyellow] .badge.badge-soft-primary {
  background: rgba(255, 155, 4, 0.1);
  color: #FF9B04;
}
[data-color=chromeyellow] a:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .btn-outline-primary {
  border: 1px solid #FF9B04 !important;
  color: #FF9B04 !important;
}
[data-color=chromeyellow] .btn-outline-primary:hover, [data-color=chromeyellow] .btn-outline-primary:focus, [data-color=chromeyellow] .btn-outline-primary.focus, [data-color=chromeyellow] .btn-outline-primary:active, [data-color=chromeyellow] .btn-outline-primary.active {
  background-color: #FF9B04 !important;
  border: 1px solid #FF9B04 !important;
}
[data-color=chromeyellow] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #FF9B04;
}
[data-color=chromeyellow] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #FF9B04;
}
[data-color=chromeyellow] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .nav-tabs .nav-link:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .form-check-input:checked {
  background-color: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .sidebar-contact .toggle-theme {
  background-color: #FF9B04;
}
[data-color=chromeyellow] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #FF9B04;
}
[data-color=chromeyellow] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=chromeyellow] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=chromeyellow] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=chromeyellow] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #FF9B04;
}
[data-color=chromeyellow] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=chromeyellow] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=chromeyellow] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #FF9B04;
}
[data-color=chromeyellow] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #FF9B04;
}
[data-color=chromeyellow] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #FF9B04;
}
[data-color=chromeyellow] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=chromeyellow] #chart-bar .c3-target-data2 .c3-bar, [data-color=chromeyellow] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #FF9B04 !important;
}
[data-color=chromeyellow] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #FF9B04 !important;
}
[data-color=chromeyellow] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #FF9B04;
}
[data-color=chromeyellow] .nav.tab-style-1 .nav-link.active {
  background-color: #FF9B04 !important;
}
[data-color=chromeyellow] .table tbody tr td a:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .view-icons a.active, [data-color=chromeyellow] .view-icons a:hover {
  background: #FF9B04;
  color: #FFF;
}

[data-color=lavared] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=lavared] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #DC2626;
  border-bottom: 2px solid #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=lavared] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar .nav-link.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=lavared] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #DC2626;
}
[data-color=lavared] .btn.btn-primary {
  background-color: #DC2626;
  border: 1px solid #DC2626;
}
[data-color=lavared] .btn.btn-primary:hover, [data-color=lavared] .btn.btn-primary:focus, [data-color=lavared] .btn.btn-primary.focus, [data-color=lavared] .btn.btn-primary:active, [data-color=lavared] .btn.btn-primary.active {
  background-color: rgb(191.425, 30.875, 30.875);
  border: 1px solid rgb(191.425, 30.875, 30.875);
}
[data-color=lavared] .btn-check:checked + .btn, [data-color=lavared] .btn.active, [data-color=lavared] .btn.show, [data-color=lavared] .btn.show:hover, [data-color=lavared] .btn:first-child:active, [data-color=lavared] :not(.btn-check) + .btn:active {
  background-color: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .link-primary {
  color: #DC2626 !important;
}
[data-color=lavared] .link-primary:hover, [data-color=lavared] .link-primary:focus, [data-color=lavared] .link-primary:active {
  color: rgb(191.425, 30.875, 30.875);
}
[data-color=lavared] .text-primary {
  color: #DC2626 !important;
}
[data-color=lavared] .badge.badge-primary {
  background: #DC2626;
}
[data-color=lavared] .dataTables_paginate .pagination li.active a.page-link {
  background: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .bg-primary {
  background-color: #DC2626 !important;
  border: 1px solid #DC2626 !important;
}
[data-color=lavared] .border-bottom.border-primary {
  border-color: #DC2626 !important;
}
[data-color=lavared] .border-primary {
  border-color: #DC2626 !important;
}
[data-color=lavared] .nav-tabs.nav-tabs-bottom li a.active, [data-color=lavared] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #DC2626;
  color: #DC2626;
}
[data-color=lavared] .badge.badge-soft-primary {
  background: rgba(220, 38, 38, 0.1);
  color: #DC2626;
}
[data-color=lavared] a:hover {
  color: #DC2626;
}
[data-color=lavared] .btn-outline-primary {
  border: 1px solid #DC2626 !important;
  color: #DC2626 !important;
}
[data-color=lavared] .btn-outline-primary:hover, [data-color=lavared] .btn-outline-primary:focus, [data-color=lavared] .btn-outline-primary.focus, [data-color=lavared] .btn-outline-primary:active, [data-color=lavared] .btn-outline-primary.active {
  background-color: #DC2626 !important;
  border: 1px solid #DC2626 !important;
}
[data-color=lavared] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #DC2626;
}
[data-color=lavared] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #DC2626;
}
[data-color=lavared] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .nav-tabs .nav-link:hover {
  color: #DC2626;
}
[data-color=lavared] .form-check-input:checked {
  background-color: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .sidebar-contact .toggle-theme {
  background-color: #DC2626;
}
[data-color=lavared] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #DC2626;
}
[data-color=lavared] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #DC2626;
}
[data-color=lavared] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=lavared] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=lavared] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=lavared] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #DC2626;
}
[data-color=lavared] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavared] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavared] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #DC2626;
}
[data-color=lavared] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #DC2626;
}
[data-color=lavared] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #DC2626;
}
[data-color=lavared] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=lavared] #chart-bar .c3-target-data2 .c3-bar, [data-color=lavared] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #DC2626 !important;
}
[data-color=lavared] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #DC2626 !important;
}
[data-color=lavared] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #DC2626;
}
[data-color=lavared] .nav.tab-style-1 .nav-link.active {
  background-color: #DC2626 !important;
}
[data-color=lavared] .table tbody tr td a:hover {
  color: #DC2626;
}
[data-color=lavared] .view-icons a.active, [data-color=lavared] .view-icons a:hover {
  background: #DC2626;
  color: #FFF;
}

[data-color=all] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=all] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid rgba(var(--primary-rgb), 1);
  border-right: 2px solid rgba(var(--primary-rgb-picr), 1);
  border-bottom: 2px solid rgba(var(--primary-rgb), 1);
  border-bottom: 2px solid rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .nav-link.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=all] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .btn.btn-primary {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border: 1px solid rgba(var(--primary-rgb), 1);
  border: 1px solid rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .btn.btn-primary:hover, [data-color=all] .btn.btn-primary:focus, [data-color=all] .btn.btn-primary.focus, [data-color=all] .btn.btn-primary:active, [data-color=all] .btn.btn-primary.active {
  background-color: rgba(var(--primary-rgb), 2);
  background-color: rgba(var(--primary-rgb-picr), 2);
  border: 1px solid rgba(var(--primary-rgb), 2);
  border: 1px solid rgba(var(--primary-rgb-picr), 2);
}
[data-color=all] .btn-check:checked + .btn, [data-color=all] .btn.active, [data-color=all] .btn.show, [data-color=all] .btn.show:hover, [data-color=all] .btn:first-child:active, [data-color=all] :not(.btn-check) + .btn:active {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .link-primary {
  color: rgba(var(--primary-rgb), 1) !important;
  color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .link-primary:hover, [data-color=all] .link-primary:focus, [data-color=all] .link-primary:active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .text-primary {
  color: rgba(var(--primary-rgb), 1) !important;
  color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .badge.badge-primary {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .dataTables_paginate .pagination li.active a.page-link {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .bg-primary {
  background-color: rgba(var(--primary-rgb), 1) !important;
  background-color: rgba(var(--primary-rgb-picr), 1) !important;
  border: 1px solid rgba(var(--primary-rgb), 1) !important;
  border: 1px solid rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .border-bottom.border-primary {
  border-color: rgba(var(--primary-rgb), 1) !important;
  border-color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .border-primary {
  border-color: rgba(var(--primary-rgb), 1) !important;
  border-color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .nav-tabs.nav-tabs-bottom li a.active, [data-color=all] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: rgba(var(--primary-rgb), 1);
  border-bottom-color: rgba(var(--primary-rgb-picr), 1);
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .badge.badge-soft-primary {
  background: rgba(var(--primary-rgb), 0.1);
  background: rgba(var(--primary-rgb-picr), 0.1);
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] a:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .btn-outline-primary {
  border: 1px solid rgba(var(--primary-rgb), 1) !important;
  border: 1px solid rgba(var(--primary-rgb-picr), 1) !important;
  color: rgba(var(--primary-rgb), 1) !important;
  color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .btn-outline-primary:hover, [data-color=all] .btn-outline-primary:focus, [data-color=all] .btn-outline-primary.focus, [data-color=all] .btn-outline-primary:active, [data-color=all] .btn-outline-primary.active {
  background-color: rgba(var(--primary-rgb), 1) !important;
  background-color: rgba(var(--primary-rgb-picr), 1) !important;
  border: 1px solid rgba(var(--primary-rgb), 1) !important;
  border: 1px solid rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .nav-tabs .nav-link:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .form-check-input:checked {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar-contact .toggle-theme {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=all] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=all] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=all] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=all] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=all] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: rgba(var(--primary-rgb), 1);
  stroke: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=all] #chart-bar .c3-target-data2 .c3-bar, [data-color=all] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: rgba(var(--primary-rgb), 1) !important;
  fill: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: rgba(var(--primary-rgb), 1) !important;
  stroke: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .nav.tab-style-1 .nav-link.active {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .table tbody tr td a:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .view-icons a.active, [data-color=all] .view-icons a:hover {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}

body.layout-mode-rtl {
  direction: rtl;
}
body.layout-mode-rtl .slide-nav .sidebar {
  margin-right: 0;
}
body.layout-mode-rtl .sidebar {
  right: 0;
  left: auto;
  left: initial;
  border-right: 0;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu ul::before {
  right: 14px;
  left: auto;
  left: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu > ul li a {
  padding: 8px 32px 8px 8px;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu > ul li a::before {
  right: 19px;
  left: auto;
  left: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu > ul li a::after {
  right: 16px;
  left: auto;
  left: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li ul li a span {
  margin-right: 10px;
  margin-left: 0;
}
body.layout-mode-rtl .sidebar .sidebar-menu .menu-arrow {
  left: 10px;
  right: auto;
  right: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu-hdr::after {
  margin-right: 8px;
  margin-left: 0;
}
@media (max-width: 991.98px) {
  body.layout-mode-rtl .sidebar {
    margin-right: -575px;
  }
}
body.layout-mode-rtl .header-left {
  float: right;
  border-right: 0;
}
body.layout-mode-rtl .page-wrapper {
  margin-right: 276px;
  margin-left: 0;
}
@media (max-width: 991.98px) {
  body.layout-mode-rtl .page-wrapper {
    margin-right: 0;
  }
}
body.layout-mode-rtl.mini-sidebar .page-wrapper {
  margin-right: 80px;
}
@media (min-width: 991.98px) {
  body.layout-mode-rtl .header {
    right: 0;
    left: 0;
  }
}
body.layout-mode-rtl .header .input-group input {
  border-right: 1px solid #9B9B9B !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  border-left: 0 !important;
  padding: 0.5rem 1.875rem 0.5rem 0.625rem;
}
body.layout-mode-rtl .header .input-group .input-group-text {
  border-right: 0;
  border-radius: 5px !important;
  border-left: 1px solid #9B9B9B;
}
body.layout-mode-rtl .header .input-group .input-group-text:last-child {
  padding-left: 10px;
  padding-right: 0;
}
@media (max-width: 991.98px) {
  body.layout-mode-rtl .header .mobile_btn {
    right: 0;
    left: auto;
    left: initial;
  }
}
body.layout-mode-rtl .header .mobile-user-menu {
  left: 0;
  right: auto;
  text-align: left;
}
body.layout-mode-rtl .input-icon-addon {
  right: 0;
  left: auto;
  left: initial;
}
body.layout-mode-rtl.mini-sidebar .header {
  left: 0;
}
body.layout-mode-rtl.mini-sidebar.expand-menu .header {
  left: 0;
}
body.layout-mode-rtl .input-icon .form-control {
  padding-left: 0;
  padding-right: 30px;
}
body.layout-mode-rtl .nav-list::before {
  left: 0;
  right: auto;
  right: initial;
}
body.layout-mode-rtl .nav-list .nav li {
  margin-left: 10px;
  margin-right: 0;
}
body.layout-mode-rtl .header .header-user .user-menu > li {
  margin-right: 10px;
  margin-inline-end: 0;
}
body.layout-mode-rtl .header .header-user .user-menu .nav-item-email.nav-item-box {
  margin-right: 15px;
  margin-left: 0;
}
body.layout-mode-rtl .header .header-user .user-menu > li:first-child {
  margin-right: 0 !important;
  margin-left: auto;
}
body.layout-mode-rtl .page-header .head-icons a {
  margin-left: 10px;
  margin-right: 0;
}
body.layout-mode-rtl .page-header .head-icons a:last-child {
  margin-left: 0;
}
body.layout-mode-rtl .sidebar .sidebar-menu .clinicdropdown > a .user-names {
  margin-right: 10px;
  margin-left: 0;
}
body.layout-mode-rtl #last-chart text, body.layout-mode-rtl #last-chart-2 text, body.layout-mode-rtl #won-chart text, body.layout-mode-rtl #deals-chart text, body.layout-mode-rtl #contact-report text, body.layout-mode-rtl #leads-chart text {
  text-anchor: start;
}

[data-loader=enable] #global-loader {
  opacity: 1;
}

[data-loader=disable] #global-loader {
  opacity: 0;
  display: none !important;
}

[data-theme=dark] .bg-white {
  background-color: #0D0D0D;
}
[data-theme=dark] body {
  background: #131313;
}
[data-theme=dark] .header {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark] .header .header-user .user-menu .btn-menubar.active {
  background-color: #212324;
  border-color: #212324;
  color: #D8DFEE;
}
[data-theme=dark] .header .header-user .user-menu .profile-dropdown .avatar img {
  border-color: #171717;
}
[data-theme=dark] .header .input-group input {
  border-color: #1F2228 !important;
}
[data-theme=dark] .head-icons a {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .head-icons a:hover {
  background: #e85b28;
}
[data-theme=dark] .sidebar {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .sidebar .sidebar-logo .logo {
  display: none;
}
[data-theme=dark] .sidebar .sidebar-logo .dark-logo {
  display: block;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > a:hover span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > a:hover i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover i, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover span {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover i, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active i, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover .menu-arrow::before, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active .menu-arrow::before, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li.active a {
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > a span {
  color: #4B5563;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #6B7280;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a {
  background: #212324;
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #e85b28;
  border-bottom: 2px solid #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  background: #100601;
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop i {
  color: #0D0D0D;
  background: #0D0D0D;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li .submenu ul::before {
  background: #171717;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li.menu-title {
  color: #9CA3AF;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.subdrop i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.active {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.active i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-theme=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  background: transparent;
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu .menu-arrow::before {
  border-right: 2px solid #D8DFEE;
  border-bottom: 2px solid #D8DFEE;
}
[data-theme=dark] .sidebar .nav-link {
  color: #374151;
}
[data-theme=dark] .sidebar .btn-menubar {
  border: 1px solid #171717;
  color: #6B7280;
}
[data-theme=dark] .sidebar .btn-menubar:hover, [data-theme=dark] .sidebar .btn-menubar:active, [data-theme=dark] .sidebar .btn-menubar.active {
  background-color: #212324;
  border-color: #212324;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .input-group input {
  border-color: #1F2228 !important;
}
[data-theme=dark] .mini-sidebar .sidebar .sidebar-logo .dark-logo {
  display: none;
}
[data-theme=dark] .mini-sidebar.expand-menu .sidebar .sidebar-logo .dark-logo {
  display: block;
}
[data-theme=dark] .mini-sidebar.expand-menu .sidebar .sidebar-logo .logo-small, [data-theme=dark] .mini-sidebar.expand-menu .sidebar .sidebar-logo .logo {
  display: none;
}
[data-theme=dark] .form-control {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .input-group-text {
  background-color: #0D0D0D;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked .stacked-mini {
  border-right: 1px solid #171717;
  background-color: #0B0F14;
}
[data-theme=dark] .sidebar-stacked.sidebar {
  background-color: transparent;
}
[data-theme=dark] .sidebar-stacked.sidebar .nav-link {
  border: 1px solid #171717;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked.sidebar .nav-link.active, [data-theme=dark] .sidebar-stacked.sidebar .nav-link:hover {
  background: #131313;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked.sidebar .nav-link p {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right {
  background: #0D0D0D;
  border-right: 1px solid #1F2228;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right .logo {
  text-align: center;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right .stack-submenu {
  background: #0D0D0D;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.subdrop i {
  color: #374151;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.active {
  background: #212324;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.active i {
  color: #374151;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.active a {
  background: #212324;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #212324;
  color: #6B7280 !important;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #212324;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a:hover {
  background-color: #212324;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a:hover, [data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a.active {
  background-color: #212324;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a .menu-arrow::before {
  border-color: #6B7280;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul ul {
  background-color: #0D0D0D;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.active, [data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.subdrop {
  background-color: #212324;
}
[data-theme=dark] .menu-horizontal .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark] .sidebar-twocol .twocol-mini {
  border-right: 1px solid #1F2228;
  background-color: #0D0D0D;
}
[data-theme=dark] .sidebar-twocol.sidebar {
  background-color: transparent;
}
[data-theme=dark] .sidebar-twocol.sidebar .nav-link {
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .nav-link.active, [data-theme=dark] .sidebar-twocol.sidebar .nav-link:hover {
  background: #131313;
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .nav-link::before {
  background: #5CB85C;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right {
  background: #0D0D0D;
  border-right: 1px solid #1F2228;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .logo {
  display: none;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.menu-title {
  color: #9CA3AF;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop i {
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop:hover {
  color: #6B7280 !important;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.active {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.active i {
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #212324;
  color: #6B7280 !important;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .menu-arrow:before {
  content: "\\f105";
}
[data-theme=dark] .sidebar-nav {
  background: #131313;
}
[data-theme=dark] h1, [data-theme=dark] h2, [data-theme=dark] h3, [data-theme=dark] h4, [data-theme=dark] h5, [data-theme=dark] h6 {
  color: #D8DFEE;
}
[data-theme=dark] .bg-light {
  background-color: #131313 !important;
  border-color: #131313 !important;
}
[data-theme=dark] a {
  color: #D8DFEE;
}
[data-theme=dark] kbd {
  background-color: #212324;
  color: #6B7280;
}
[data-theme=dark] .input-group-flat:focus-within .form-control,
[data-theme=dark] .input-group-flat:focus-within .input-group-text {
  border-color: #1F2228 !important;
}
[data-theme=dark] .card {
  background-color: #0D0D0D;
  border: 1px solid #1F2228;
}
[data-theme=dark] .card .card-title {
  color: #D8DFEE;
}
[data-theme=dark] .card .card-header {
  border-color: #1F2228;
}
[data-theme=dark] .card .card-footer {
  border-color: #1F2228;
}
[data-theme=dark] .alert-light {
  background-color: #131313;
  color: #6B7280;
  border-color: #131313;
}
[data-theme=dark] .alert-light .alert-link {
  color: #6B7280;
}
[data-theme=dark] .alert-light .btn-close {
  color: #6B7280;
}
[data-theme=dark] .custom-alert1 {
  background-color: #0D0D0D;
}
[data-theme=dark] .alert-primary.custom-alert-icon, [data-theme=dark] .alert-secondary.custom-alert-icon, [data-theme=dark] .alert-warning.custom-alert-icon, [data-theme=dark] .alert-danger.custom-alert-icon {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header {
  left: 0;
  background-color: #0D0D0D;
  border-color: rgb(15.295, 15.295, 15.295);
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover {
  background: #212324;
  color: #6B7280;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left {
  display: block;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .logo, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .logo {
  display: none;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .dark-logo, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .mode-toggle, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .mode-toggle {
  color: #6B7280;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar {
  background-color: #0D0D0D;
  border-bottom: 1px solid rgb(15.295, 15.295, 15.295);
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #212324;
  color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .main-wrapper::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .main-wrapper::before {
  content: "";
  background: #0D0D0D;
}
[data-theme=dark] .page-wrapper::before {
  background: #0D0D0D;
}
[data-theme=dark] .accordion-button {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion-button:after {
  content: "\\f078";
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion-body {
  color: #9595b5;
}
[data-theme=dark] .accordion-item {
  color: #6B7280;
  background-color: #0D0D0D;
  border-color: #181818;
}
[data-theme=dark] .accordion.accordion-primary .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-secondary .accordion-button.collapsed {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-primary .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-secondary .accordion-button.collapsed::after {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-solid-primary .accordion-button, [data-theme=dark] .accordion.accordion-solid-secondary .accordion-button, [data-theme=dark] .accordion.accordion-solid-warning .accordion-button, [data-theme=dark] .accordion.accordion-solid-info .accordion-button, [data-theme=dark] .accordion.accordion-solid-success .accordion-button, [data-theme=dark] .accordion.accordion-solid-danger .accordion-button {
  color: #0D0D0D;
}
[data-theme=dark] .accordion.accordion-solid-primary .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-secondary .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-warning .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-info .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-success .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-danger .accordion-button.collapsed {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-solid-primary .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-secondary .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-warning .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-info .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-success .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-danger .accordion-button.collapsed::after {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-border-primary .accordion-button, [data-theme=dark] .accordion.accordion-border-secondary .accordion-button, [data-theme=dark] .accordion.accordion-border-warning .accordion-button, [data-theme=dark] .accordion.accordion-border-info .accordion-button, [data-theme=dark] .accordion.accordion-border-success .accordion-button, [data-theme=dark] .accordion.accordion-border-danger .accordion-button {
  background-color: #0D0D0D;
}
[data-theme=dark] .accordion.accordion-border-primary .accordion-button::after, [data-theme=dark] .accordion.accordion-border-secondary .accordion-button::after, [data-theme=dark] .accordion.accordion-border-warning .accordion-button::after, [data-theme=dark] .accordion.accordion-border-info .accordion-button::after, [data-theme=dark] .accordion.accordion-border-success .accordion-button::after, [data-theme=dark] .accordion.accordion-border-danger .accordion-button::after {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-outline-primary, [data-theme=dark] .bg-outline-secondary, [data-theme=dark] .bg-outline-success,
[data-theme=dark] .bg-outline-danger, [data-theme=dark] .bg-outline-warning, [data-theme=dark] .bg-outline-info, [data-theme=dark] .bg-outline-light, [data-theme=dark] .bg-outline-light {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-outline-light {
  border: 1px solid #131313 !important;
  color: #D8DFEE !important;
}
[data-theme=dark] .border-container {
  background-color: #131313;
}
[data-theme=dark] .border {
  border-color: #1F2228 !important;
}
[data-theme=dark] .border.border-primary {
  border: 1px solid #e85b28 !important;
}
[data-theme=dark] .border.border-secondary {
  border: 1px solid #FFA201 !important;
}
[data-theme=dark] .border.border-success {
  border: 1px solid #5CB85C !important;
}
[data-theme=dark] .border.border-warning {
  border: 1px solid #FDA700 !important;
}
[data-theme=dark] .border.border-danger {
  border: 1px solid #FC0027 !important;
}
[data-theme=dark] .border.border-info {
  border: 1px solid #1ECBE2 !important;
}
[data-theme=dark] .border.border-light {
  border: 1px solid #131313 !important;
}
[data-theme=dark] .border.border-white {
  border: 1px solid #0D0D0D !important;
}
[data-theme=dark] .border-top {
  border-top: 1px solid #1F2228 !important;
}
[data-theme=dark] .border-end {
  border-inline-end: 1px solid #1F2228 !important;
}
[data-theme=dark] .border-bottom {
  border-bottom: 1px solid #1F2228 !important;
}
[data-theme=dark] .border-start {
  border-inline-start: 1px solid #1F2228 !important;
}
[data-theme=dark] .list-group-item {
  background-color: #0D0D0D;
  border-color: #181818 !important;
}
[data-theme=dark] .toast {
  background-color: #0D0D0D;
}
[data-theme=dark] .avatar.online:before, [data-theme=dark] .avatar.offline:before {
  border-color: #0D0D0D !important;
}
[data-theme=dark] .swal2-popup {
  background-color: #0D0D0D;
}
[data-theme=dark] .progress, [data-theme=dark] .progress-stacked {
  background-color: #181818;
}
[data-theme=dark] .popover {
  background-color: #0D0D0D;
  border: 1px solid #1F2228;
  box-shadow: none;
}
[data-theme=dark] .popover .popover-header {
  background-color: #0D0D0D;
  border-block-end: 1px solid #1F2228;
}
[data-theme=dark] .popover .popover-body {
  color: #6B7280;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
[data-theme=dark] .bs-popover-top > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
[data-theme=dark] .bs-popover-top > .popover-arrow::before {
  border-top-color: #131313;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
[data-theme=dark] .bs-popover-end > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
[data-theme=dark] .bs-popover-end > .popover-arrow::before {
  border-right-color: #131313;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
[data-theme=dark] .bs-popover-start > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
[data-theme=dark] .bs-popover-start > .popover-arrow::before {
  border-left-color: #131313;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
[data-theme=dark] .bs-popover-bottom > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
[data-theme=dark] .bs-popover-bottom > .popover-arrow::before,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
[data-theme=dark] .bs-popover-bottom .popover-header::before {
  border-bottom-color: #131313;
}
[data-theme=dark] .page-link {
  color: #6B7280;
  background-color: #0D0D0D;
  border: 1px solid #1F2228;
}
[data-theme=dark] .page-link:focus {
  background-color: #131313;
}
[data-theme=dark] .page-link:hover {
  background-color: #131313;
  border-color: #1F2228;
}
[data-theme=dark] .pagination-style-2 .pagination .page-item.active .page-link {
  background-color: #131313;
}
[data-theme=dark] .pagination-style-1 .pagination .page-item:hover .page-link {
  background-color: #131313;
}
[data-theme=dark] .pagination-style-3 .pagination .page-item:hover .page-link {
  background-color: #131313;
}
[data-theme=dark] .offcanvas {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .modal-content {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .modal-content .modal-header {
  border-color: #1F2228;
}
[data-theme=dark] .modal-content .modal-footer {
  border-color: #1F2228;
}
[data-theme=dark] .figure-caption {
  color: #6B7280;
}
[data-theme=dark] .text-dark {
  color: #D6DADE !important;
}
[data-theme=dark] .nav-tabs li a {
  color: #D8DFEE;
}
[data-theme=dark] .nav-tabs .nav-item.show .nav-link, [data-theme=dark] .nav-tabs .nav-link.active {
  background-color: #0D0D0D;
  color: #D8DFEE;
}
[data-theme=dark] .nav-tabs .nav-link.active {
  border-color: #1F2228;
}
[data-theme=dark] .nav-tabs.nav-tabs-solid {
  background-color: #0D0D0D;
}
[data-theme=dark] .nav.tab-style-1 {
  background-color: #131313;
}
[data-theme=dark] .vertical-tabs-2 .nav-item .nav-link {
  background-color: #131313;
  border-color: #1F2228;
}
[data-theme=dark] .vertical-tabs-2 .nav-item .nav-link.active {
  background-color: #e85b28;
}
[data-theme=dark] .tab-style-2 .nav-item .nav-link i {
  background-color: #131313;
  color: #6B7280;
}
[data-theme=dark] .nav-tabs.nav-tabs-top li a.active {
  border-top-color: #e85b28;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link::after {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link:before {
  background-color: #131313;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link.active:before {
  background-color: #e85b28;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link.active:after {
  border-color: #e85b28;
  color: #e85b28;
}
[data-theme=dark] .tab-style-6 {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-white {
  background-color: #0D0D0D !important;
}
[data-theme=dark] .card.card-bg-primary .card-body, [data-theme=dark] .text-fixed-white {
  color: #0D0D0D;
}
[data-theme=dark] .btn.btn-light {
  background-color: #181818;
  border: 1px solid #181818;
  color: #6B7280;
}
[data-theme=dark] .btn.btn-light:hover, [data-theme=dark] .btn.btn-light:focus, [data-theme=dark] .btn.btn-light.focus, [data-theme=dark] .btn.btn-light:active, [data-theme=dark] .btn.btn-light.active {
  background-color: rgb(16.35, 16.35, 16.35);
  border: 1px solid #181818;
  color: #6B7280;
}
[data-theme=dark] .scroll-demo {
  border-color: #1F2228;
}
[data-theme=dark] .timeline::before {
  background-color: #1F2228;
}
[data-theme=dark] .timeline > li > .timeline-panel {
  border-color: #1F2228;
}
[data-theme=dark] .timeline > li > .timeline-panel::after, [data-theme=dark] .timeline > li > .timeline-panel::before {
  border-color: #1F2228;
}
[data-theme=dark] .callout {
  background-color: #131313;
}
[data-theme=dark] .icons-list li {
  border-color: #1F2228;
  box-shadow: none;
}
[data-theme=dark] .btn-outline-light {
  border: 1px solid #131313 !important;
  color: #374151 !important;
}
[data-theme=dark] .btn-outline-light:hover, [data-theme=dark] .btn-outline-light:focus, [data-theme=dark] .btn-outline-light.focus, [data-theme=dark] .btn-outline-light:active, [data-theme=dark] .btn-outline-light.active {
  background-color: #131313 !important;
  border: 1px solid #131313 !important;
  color: #374151 !important;
}
[data-theme=dark] .bg-dark {
  background-color: #D6DADE !important;
  border-color: #D6DADE !important;
  color: #0D0D0D;
}
[data-theme=dark] .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link::after {
  background-color: #1F2228;
}
[data-theme=dark] .form-check-input {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .alert-outline-primary, [data-theme=dark] .alert-outline-secondary, [data-theme=dark] .alert-outline-warning, [data-theme=dark] .alert-outline-danger,
[data-theme=dark] .alert-outline-info, [data-theme=dark] .alert-outline-dark, [data-theme=dark] .alert-outline-success, [data-theme=dark] .alert-outline-light {
  background-color: #0D0D0D;
}
[data-theme=dark] .text-white {
  color: #0D0D0D !important;
}
[data-theme=dark] .text-light {
  color: #131313 !important;
}
[data-theme=dark] .table thead tr {
  border-color: #1F2228;
}
[data-theme=dark] .table thead tr th {
  border-color: #1F2228;
  background-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .table tbody tr {
  border-color: #1F2228;
}
[data-theme=dark] .table tbody tr th {
  border-color: #1F2228;
  background-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .table tbody tr td {
  background-color: #0D0D0D;
  color: #6B7280;
  border-color: #1F2228;
}
[data-theme=dark] .table .thead-primary th {
  background-color: #e85b28;
}
[data-theme=dark] .table .thead-secondary th {
  background-color: #FFA201;
}
[data-theme=dark] .table .thead-info th {
  background-color: #1ECBE2;
}
[data-theme=dark] .table .thead-warning th {
  background-color: #FDA700;
}
[data-theme=dark] .table .thead-danger th {
  background-color: #FC0027;
}
[data-theme=dark] .table .thead-success th {
  background-color: #5CB85C;
}
[data-theme=dark] .table .thead-dark th {
  background-color: #D6DADE;
}
[data-theme=dark] .table .thead-light th {
  background-color: #101010;
}
[data-theme=dark] table.table.dataTable > tbody > tr {
  border-color: #1F2228;
}
[data-theme=dark] table.table.dataTable > tbody > tr td {
  color: #6B7280;
  border-color: #1F2228;
}
[data-theme=dark] table.table.dataTable > thead > tr {
  border-color: #1F2228;
}
[data-theme=dark] table.table.dataTable > thead > tr th {
  color: #D8DFEE;
}
[data-theme=dark] .dataTables_length label {
  color: #374151;
}
[data-theme=dark] .dataTables_length label .form-select {
  border: 1px solid #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .form-label {
  color: #D8DFEE;
}
[data-theme=dark] .form-control {
  color: #D8DFEE;
}
[data-theme=dark] .form-select {
  background-color: #0D0D0D;
  color: #D8DFEE;
  border-color: #1F2228;
}
[data-theme=dark] .form-select option {
  background-color: #0D0D0D;
}
[data-theme=dark] .select2-container--default .select2-selection--single {
  border-color: #1F2228;
  background: #0D0D0D;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #D8DFEE !important;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #D8DFEE;
}
[data-theme=dark] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  color: #0D0D0D;
}
[data-theme=dark] .select2-container--focus .select2-selection--single {
  background: #0D0D0D !important;
  border-color: #1F2228;
}
[data-theme=dark] .select2-container--classic .select2-selection--single,
[data-theme=dark] .select2-container--default .select2-selection--single,
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered,
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow,
[data-theme=dark] .select2-container--default .select2-selection--multiple,
[data-theme=dark] .select2-container--classic .select2-selection--single .select2-selection__arrow,
[data-theme=dark] .select2-container--classic .select2-selection--single .select2-selection__rendered {
  border-color: #1F2228;
  color: #6B7280;
}
[data-theme=dark] .select2-dropdown {
  border-color: #1F2228;
  background: #0D0D0D;
}
[data-theme=dark] .select2-container--classic .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  color: #0D0D0D;
}
[data-theme=dark] .form-floating > .form-control-plaintext ~ label::after,
[data-theme=dark] .form-floating > .form-control:focus ~ label::after,
[data-theme=dark] .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
[data-theme=dark] .form-floating > .form-select ~ label::after {
  background-color: #0D0D0D;
}
[data-theme=dark] .select2-container--default .select2-selection--multiple {
  background-color: #0D0D0D;
}
[data-theme=dark] .custom-file-container .custom-file-container__custom-file__custom-file-control {
  background-color: #171717;
  border-color: #171717;
}
[data-theme=dark] .dropdown-menu {
  background-color: #0D0D0D;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .dropdown-menu .dropdown-item {
  color: #D8DFEE;
}
[data-theme=dark] .dropdown-menu .dropdown-item:not(.active):hover, [data-theme=dark] .dropdown-menu .dropdown-item:not(.active):focus, [data-theme=dark] .dropdown-menu .dropdown-item:not(.active):active {
  color: #D8DFEE;
  background-color: #0F0F0F;
}
[data-theme=dark] .dropdown-menu .dropdown-item.active {
  background-color: #0F0F0F;
}
[data-theme=dark] .dropdown-divider {
  border-color: #1F2228;
}
[data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg1] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg2] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg3] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg4] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg5] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(13, 13, 13, 0.85);
}
[data-theme=dark] .theme-width input[type=radio]:checked ~ label {
  border-color: #e85b28;
}
[data-theme=dark] .theme-width input[type=radio]:checked ~ label::before {
  border-color: #e85b28;
}
[data-theme=dark] .theme-width label {
  border-color: #1F2228;
  color: #6B7280;
}
[data-theme=dark] .theme-width label::before {
  border-color: #1F2228;
  background: #0D0D0D;
}
[data-theme=dark] .theme-width label::after {
  background: #e85b28;
}
[data-theme=dark] .theme-sidebarcolor input[type=radio]:checked ~ label {
  border-color: #e85b28 !important;
}
[data-theme=dark] .theme-sidebarcolor input[type=radio]:checked ~ label:after {
  color: #e85b28;
}
[data-theme=dark] .theme-sidebarcolor input[type=radio]:checked ~ label.bg-dark:after {
  color: #0D0D0D;
}
[data-theme=dark] .theme-sidebarcolor label {
  border-color: #1F2228;
}
[data-theme=dark] .theme-sidebarbg input[type=radio]:checked ~ label:after {
  color: #e85b28;
  background: #FFF;
  border-color: #1F2228;
}
[data-theme=dark] .theme-sidebarbg label img {
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label {
  outline-color: #e85b28;
}
[data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label:after {
  color: #e85b28;
  background: #FFF;
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label.primary-topbar:after, [data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label.dark-topbar:after {
  color: #0D0D0D;
}
[data-theme=dark] .theme-colorselect label {
  outline-color: #1F2228;
}
[data-theme=dark] .theme-colorselect label.white-topbar {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorselect .pickr-container-background, [data-theme=dark] .theme-colorselect .pickr-topbar, [data-theme=dark] .theme-colorselect .pickr-topbarcolor {
  outline-color: #1F2228;
}
[data-theme=dark] .theme-colorsset label {
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorsset label.primary-clr::before {
  background: #e85b28;
}
[data-theme=dark] .theme-colorsset label.brightblue-clr::before {
  background: #2066FF;
}
[data-theme=dark] .theme-colorsset label.lunargreen-clr::before {
  background: #365E32;
}
[data-theme=dark] .theme-colorsset label.lavendar-clr::before {
  background: #673AB7;
}
[data-theme=dark] .theme-colorsset label.magenta-clr::before {
  background: #E83E8C;
}
[data-theme=dark] .theme-colorsset label.chromeyellow-clr::before {
  background: #FF9B04;
}
[data-theme=dark] .theme-colorsset label.lavared-clr::before {
  background: #DC2626;
}
[data-theme=dark] .theme-colorsset input[type=radio]:checked ~ label:after {
  color: #0D0D0D;
}
[data-theme=dark] .theme-mode input[type=radio]:checked ~ label {
  border-color: #e85b28;
}
[data-theme=dark] .theme-mode input[type=radio]:checked ~ label .avatar {
  color: #FDA700;
  background-color: #FFF9E9;
}
[data-theme=dark] .theme-mode label {
  border-color: #1F2228;
  color: #374151;
}
[data-theme=dark] .theme-mode label .avatar {
  background-color: #212324;
  color: #D6DADE;
}
[data-theme=dark] .theme-mode .pickr-container-primary {
  border-color: #1F2228;
}
[data-theme=dark] .theme-layout.active img {
  border: 1px solid #e85b28;
}
[data-theme=dark] .theme-layout input[type=radio]:checked ~ label .layout-img img {
  border-color: #e85b28;
}
[data-theme=dark] .theme-layout label .layout-img img {
  border-color: #1F2228;
}
[data-theme=dark] .theme-layout label .layout-type {
  color: #D8DFEE;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header {
  background-color: #0D0D0D;
  border-color: rgba(13, 13, 13, 0.8);
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .bar-icon span {
  background-color: #0D0D0D;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar.active {
  background-color: #0D0D0D;
  color: #6B7280 !important;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-left .logo {
  display: none;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .page-wrapper::before {
  background: #0D0D0D;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .bar-icon span {
  background-color: #0D0D0D;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar.active {
  background-color: #0D0D0D;
  color: #6B7280 !important;
}
[data-theme=dark] .policy-upload {
  border-color: #1F2228;
}
[data-theme=dark] .bootstrap-tagsinput {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .note-toolbar, [data-theme=dark] .note-dropdown-menu, [data-theme=dark] .note-modal-content, [data-theme=dark] .note-input {
  background-color: #131313;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .note-btn {
  background-color: #0D0D0D;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .note-modal-header, [data-theme=dark] .file-drop {
  border-color: #1F2228;
}
[data-theme=dark] .close {
  color: #D8DFEE;
}
[data-theme=dark] .video-wrap .video-content {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-black .text-white {
  color: #D8DFEE !important;
}
[data-theme=dark] .bg-transparent-light {
  background: #131313 !important;
}
[data-theme=dark] .contact-grids-tab .nav-underline {
  border-color: #1F2228;
}
[data-theme=dark] .contact-grids-tab .nav-underline .nav-item .nav-link.active, [data-theme=dark] .contact-grids-tab .nav-underline .nav-item .nav-link:hover {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-primary-100 a {
  color: #0D0D0D;
}
[data-theme=dark] .bg-primary-100 a:hover {
  color: #e85b28;
}
[data-theme=dark] .notification-dropdown .dropdown .dropdown-toggle {
  color: #D8DFEE;
}
[data-theme=dark] .notification-dropdown .dropdown .dropdown-toggle.show {
  color: #D8DFEE;
}
[data-theme=dark] .bootstrap-datetimepicker-widget table th {
  color: #D8DFEE;
}
[data-theme=dark] .crm-link {
  color: #D8DFEE;
  background: #131313;
  border: #1F2228;
}

[data-theme=dark] .breadcrumb .breadcrumb-item.active {
  color: #C8D2E0;
}
[data-theme=dark] .table tbody tr td a {
  color: #C8D2E0;
}
[data-theme=dark] .btn.btn-icon.active.bg-white {
  border-color: #1F2228;
  color: #C8D2E0;
}
[data-theme=dark] .custom-datatable-filter {
  background: #0D0D0D;
}
[data-theme=dark] .btn.btn-white {
  background: #0D0D0D;
  border-color: #1F2228;
  color: #C8D2E0;
}
[data-theme=dark] .todo-item .form-check-label {
  color: #C8D2E0;
}
[data-theme=dark] .bg-transparent-secondary, [data-theme=dark] .bg-transparent-dark, [data-theme=dark] .bg-light-500 {
  background: #374151 !important;
}
[data-theme=dark] .text-gray-9, [data-theme=dark] .text-title {
  color: #C8D2E0 !important;
}
[data-theme=dark] .attendance-bg {
  background: #0D0D0D;
  border-color: #1F2228 !important;
}
[data-theme=dark] .chat-wrapper .sidebar-group {
  background: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat-users-wrap .chat-user-list, [data-theme=dark] .chat-wrapper .chat .chat-header, [data-theme=dark] .chat-wrapper .chat {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .search-wrap .input-group-text {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .search-wrap .form-control {
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-footer .footer-form {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-footer .footer-form .chat-footer-wrap {
  background: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-body .messages .chats .chat-content .message-content {
  background: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-header .chat-options > ul > li > a {
  background: #1F2228;
}
[data-theme=dark] #calendar .fc-scroller-harness th {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] #calendar .fc-col-header-cell-cushion, [data-theme=dark] #calendar .fc-daygrid-day-number {
  color: #C8D2E0;
}
[data-theme=dark] #calendar .fc-daygrid-body tbody td {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] #calendar .fc-daygrid .fc-scrolcustom991rid {
  border-color: #1F2228;
}

.menu-horizontal #toggle_btn {
  display: none;
}
.menu-horizontal .page-wrapper {
  margin: 0;
  padding-top: 96px;
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1399.98px) {
  .menu-horizontal .page-wrapper {
    max-width: 1170px;
  }
}
@media (max-width: 1199.98px) {
  .menu-horizontal .page-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  .menu-horizontal .page-wrapper {
    max-width: 100%;
  }
}
.menu-horizontal .page-wrapper .content {
  padding-left: 0;
  padding-right: 0;
}
@media (max-width: 991.98px) {
  .menu-horizontal .page-wrapper .content {
    padding: 20px;
  }
}
@media (min-width: 991.98px) {
  .menu-horizontal #sidebar {
    display: none;
  }
}
.menu-horizontal .header {
  left: 0;
}
.menu-horizontal .header .main-header {
  margin: 0 auto;
}
.menu-horizontal .header .main-header .user-menu {
  padding-right: 0;
}
.menu-horizontal .header .header-left {
  display: block;
}
.menu-horizontal .header .header-left .logo {
  display: block;
}
.menu-horizontal .header .header-left .dark-logo {
  display: none;
}

.sidebar-horizontal {
  margin: 0 auto;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.sidebar-horizontal.sidebar {
  width: 100% !important;
  bottom: inherit;
  top: 50px;
  border-right: 0;
  z-index: 9;
}
.sidebar-horizontal.sidebar .sidebar-logo {
  display: none;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li span {
  display: inline-block !important;
}
.sidebar-horizontal.sidebar .slimScrollDiv {
  top: 0;
  height: auto !important;
  overflow: inherit !important;
  padding: 0;
}
.sidebar-horizontal.sidebar .sidebar-inner {
  height: auto !important;
  overflow: inherit !important;
}
.sidebar-horizontal.sidebar .hidden {
  display: none !important;
}
.sidebar-horizontal.sidebar .sidebar-menu {
  padding: 0 !important;
  height: 46px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
}
.sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li {
  margin-right: 8px;
}
.sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li:last-child {
  margin-right: 0;
}
.sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > ul {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}
.sidebar-horizontal.sidebar .sidebar-menu ul {
  display: flex;
  align-items: center;
  -webkit-align-items: center;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li {
  position: relative;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  font-size: 12px;
  color: #262A2A;
  border-radius: 5px;
  padding: 8px 30px 8px 8px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a i {
  margin-right: 4px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a:hover {
  background-color: #E8E9EA;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu .noti-dot:before {
  display: none;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li.submenu a {
  font-size: 12px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a {
  color: #424848;
  border-radius: 5px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a:hover, .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a.active {
  background-color: #E8E9EA;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu.submenu-two ul {
  max-height: none;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul {
  display: none;
  width: 170px;
  background-color: #FFF;
  position: absolute;
  top: 45px;
  left: 0;
  padding: 8px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul li a .menu-arrow {
  right: 15px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul a {
  padding: 8px 15px;
}
.sidebar-horizontal.sidebar .sidebar-menu .menu-title {
  display: none !important;
}
.sidebar-horizontal.sidebar .sidebar-vertical {
  display: none !important;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li a {
  flex-direction: inherit;
  text-align: left;
  padding: 7px 8px;
  font-size: 12px;
  font-weight: 500;
  display: block;
  position: relative;
}
.sidebar-horizontal.sidebar ul li span {
  display: inline-block !important;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul > li.submenu > ul {
  position: relative;
  top: 0;
  padding: 0;
  width: 100%;
}
.sidebar-horizontal.sidebar ul ul li {
  display: inline-block !important;
  width: 100%;
}
.sidebar-horizontal.sidebar .sidebar-menu {
  max-width: 1320px;
}
@media (max-width: 1399.98px) {
  .sidebar-horizontal.sidebar .sidebar-menu {
    max-width: 1170px;
  }
}
@media (max-width: 1199.98px) {
  .sidebar-horizontal.sidebar .sidebar-menu {
    max-width: 950px;
  }
}
.sidebar-horizontal.sidebar .sidebar-menu .main-menu {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.active, .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.subdrop {
  background-color: #E8E9EA;
}
@media (min-width: 1199.98px) {
  .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
    font-size: 14px;
    padding: 8px 30px 8px 8px;
  }
  .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a i {
    margin-right: 5px;
  }
  .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a .menu-arrow {
    right: 8px;
  }
}
@media (max-width: 991.98px) {
  .sidebar-horizontal.sidebar {
    display: none !important;
  }
}

#horizontal-menu, #horizontal-single,
#two-col-sidebar, #stacked-sidebar {
  display: none;
}

[data-theme=dark] .border, [data-theme=dark] .border-top, [data-theme=dark] .border-bottom, [data-theme=dark] .border-start, [data-theme=dark] .border-end {
  border-color: #393947 !important;
}
[data-theme=dark] .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .dropdown .dropdown-menu {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .bg-white {
  background: #171724 !important;
}
[data-theme=dark] .bg-light-200, [data-theme=dark] .bg-light-300, [data-theme=dark] .bg-light-400 {
  background: #1A1A25;
}
[data-theme=dark] .dropdown .dropdown-menu .dropdown-item {
  background: #1A1A25;
}
[data-theme=dark] .offcanvas {
  background: #171724;
}
[data-theme=dark] .accordion-button:after {
  background: transparent;
}
[data-theme=dark] .bg-success.border {
  border-color: #5CB85C !important;
}
[data-theme=dark] .bg-purple.border {
  border-color: #4A00E5 !important;
}
[data-theme=dark] .bg-warning.border {
  border-color: #FDA700 !important;
}
[data-theme=dark] .bg-danger.border {
  border-color: #FC0027 !important;
}
[data-theme=dark] .btn-close {
  --bs-btn-close-color: \$dark-text;
  color: #FFF;
}
[data-theme=dark] .input-themeselect span {
  color: #FFF;
}

[data-theme=dark] body {
  background-color: #171724;
  color: #a3a6a6;
}
[data-theme=dark] h1, [data-theme=dark] h2, [data-theme=dark] h3, [data-theme=dark] h4, [data-theme=dark] h5, [data-theme=dark] h6, [data-theme=dark] .h1, [data-theme=dark] .h2, [data-theme=dark] .h3, [data-theme=dark] .h4, [data-theme=dark] .h5, [data-theme=dark] .h6 {
  color: #FFF;
}
[data-theme=dark] .header {
  background-color: #171724;
}
[data-theme=dark] .header .header-left {
  background-color: #171724;
}
[data-theme=dark] .header .header-left .logo img {
  display: none;
}
[data-theme=dark] .header .header-left .logo img.white-logo {
  display: block;
}
[data-theme=dark] .header .header-left #toggle_btn {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu {
  background-color: #171724;
  box-shadow: none;
}
[data-theme=dark] .header .dropdown-menu a {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header {
  border-color: #393947;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header .notification-title {
  color: #FFF;
}
[data-theme=dark] .header .menu-drop-user .dropdown-item {
  border-color: #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li {
  border-bottom: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-title {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-details {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li p.noti-time {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon span {
  border: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text p {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text span {
  color: #B5B5B5;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #565E5E;
}
[data-theme=dark] .header .notification-dropdown .topnav-dropdown-footer {
  background: #171724;
}
[data-theme=dark] .header .searchinputs input {
  border-color: #393947;
  background: transparent;
}
[data-theme=dark] .header .searchinputs .search-addon button {
  color: #B5B5B5;
}
[data-theme=dark] .header .menus-info .menu-list li a {
  background: transparent;
  border-radius: 5px;
}
[data-theme=dark] .header .menus-info .menu-list li a:hover {
  background: transparent;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-list-icon {
  color: #FFF;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content p {
  color: #FFF;
  margin-bottom: 0;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content span {
  font-weight: 400;
  color: #B5B5B5;
}
[data-theme=dark] .sidebar {
  background-color: #171724;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #28283E;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu ul > li ul li a span {
  color: #a3a6a6;
}
[data-theme=dark] .sidebar .sidebar-menu .menu-arrow:before {
  border-bottom: 2px solid #a3a6a6;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-head .table-action .action-icon {
  background: #393947;
  color: #FFF;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-footer {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .title-head {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings {
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header h4 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content h6 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect .checkboxs-theme:after {
  border-color: #393947;
}
[data-theme=dark] .form-check-label,
[data-theme=dark] .form-label,
[data-theme=dark] .sub-header {
  color: #a3a6a6;
}
[data-theme=dark] .form-select option {
  background: transparent;
}
[data-theme=dark] .icon-form .form-icon {
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a,
[data-theme=dark] .export-dropdwon > a,
[data-theme=dark] .form-sorts > a {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a:hover,
[data-theme=dark] .export-dropdwon > a:hover,
[data-theme=dark] .form-sorts > a:hover {
  color: #a3a6a6;
}
[data-theme=dark] .manage-dropdwon .dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-sorts .filter-set-content .filter-set-content-head a {
  color: #a3a6a6;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single {
  border-color: #393947;
}
[data-theme=dark] .form-sorts .filter-dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .status-radio:checked + label,
[data-theme=dark] .status-radio:not(:checked) + label {
  color: #a3a6a6;
}
[data-theme=dark] .filter-set-contents .filter-content-list {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .dataTables_length label .form-select,
[data-theme=dark] #dataTables_length label .form-select {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .view-icons {
  border-color: #393947;
}
[data-theme=dark] .toast {
  background-color: #1A1A25;
}
[data-theme=dark] .select2-selection--multiple {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
  color: #a3a6a6;
}
[data-theme=dark] .twitter-bs-wizard .twitter-bs-wizard-nav .step-icon {
  border-color: #FFF;
  color: #FFF;
}
[data-theme=dark] .text-dark {
  color: #a3a6a6 !important;
}
[data-theme=dark] .select2-container--default .select2-selection--single {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered {
  box-shadow: none;
  border: 1px solid #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow {
  box-shadow: none;
}
[data-theme=dark] .toggle-popup .sidebar-layout,
[data-theme=dark] .toggle-popup1 .sidebar-layout,
[data-theme=dark] .toggle-popup2 .sidebar-layout {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .user-accordion-item .accordion-wrap {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .accordion-wrap:hover {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .content-collapse {
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .user-accordion-item,
[data-theme=dark] .files-wrap,
[data-theme=dark] .contact-wrap,
[data-theme=dark] .notes-activity .note-download,
[data-theme=dark] .contact-tab-wrap,
[data-theme=dark] .contact-tab-view,
[data-theme=dark] .calls-box,
[data-theme=dark] .notes-activity .reply-box,
[data-theme=dark] .note-download {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-sidebar, [data-theme=dark] .contact-tab-view {
  background-color: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .action-drop .dropdown-toggle {
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .upcoming-info {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-user p span {
  color: #a3a6a6;
  font-weight: 500;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-toggle {
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  box-shadow: none;
}
[data-theme=dark] .contact-grid {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-grid .grid-head .users-profile .name-user h6 a {
  color: #FFF;
}
[data-theme=dark] .contact-grid .grid-body .address-info p i {
  color: #a3a6a6;
}
[data-theme=dark] .contact-grid .grid-footer {
  border-color: #393947;
}
[data-theme=dark] .company-info li span {
  border-color: #393947;
}
[data-theme=dark] .contacts-action .btn-icon, [data-theme=dark] .contacts-action .btn-icon.rating {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .contacts-action .act-dropdown > a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .social-info li a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .view-header .form-sort .select2-container .select2-selection .select2-selection__rendered {
  color: #a3a6a6;
}
[data-theme=dark] .basic-info li span {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .badge-day {
  color: #a3a6a6;
  background: #3d3d64;
}
[data-theme=dark] .contact-nav li a {
  border-color: transparent;
}
[data-theme=dark] .upcoming-info .dropdown .dropdown-toggle {
  color: #a3a6a6;
}
[data-theme=dark] .contact-sidebar ul, [data-theme=dark] .view-header, [data-theme=dark] .activity-wrap {
  border-color: #393947;
}
[data-theme=dark] .search-section {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default .select2-results__option--selected {
  background: #e85b28;
  color: #FFF;
}
[data-theme=dark] .form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background: transparent;
}
[data-theme=dark] .select2-dropdown {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .select2-dropdown ul li {
  color: #FFF;
}
[data-theme=dark] .btn-outline-light {
  color: #a3a6a6 !important;
}
[data-theme=dark] .page-wrapper {
  background: #151525;
}
[data-theme=dark] .page-wrapper .page-header h3 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header h4 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header .head-icons a {
  border-color: #393947;
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-title {
  color: #FFF;
}
[data-theme=dark] .note-editable.card-block {
  color: #FFF;
}
[data-theme=dark] .accordion-item {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .accordion-item .accordion-body {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .accordion-button {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .seprator-lg {
  border-color: #393947;
}
[data-theme=dark] .card {
  background: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .card.bg-white {
  background: #1E1E2D !important;
}
[data-theme=dark] .card.main-card {
  background: #28283E;
  box-shadow: none;
}
[data-theme=dark] .card.custom-card {
  background: #28283E;
}
[data-theme=dark] .card.custom-card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card.custom-card .card-footer {
  border-color: #393947;
}
[data-theme=dark] .card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card .card-header .card-title {
  color: #FFF;
}
[data-theme=dark] .card .card-header .card-text {
  color: #a3a6a6;
}
[data-theme=dark] .card .card-body {
  color: #a3a6a6;
}
[data-theme=dark] .col-form-label {
  color: #a3a6a6;
}
[data-theme=dark] .custom-table .table-responsive {
  border-color: #393947;
}
[data-theme=dark] .btn-purple-light {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .btn-purple-light:hover {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  background: #171724;
}
[data-theme=dark] .note-btn-group .note-btn {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  border-color: #393947;
}
[data-theme=dark] .table-action .action-icon {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header {
  border-color: #171724;
}
[data-theme=dark] table.table.table-primary {
  background: #171724;
}
[data-theme=dark] table.table thead {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .statistic-header h4 {
  color: #FFF;
}
[data-theme=dark] .statistic-header h4 i {
  color: #B5B5B5;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle {
  color: #FFF;
  border: 1px solid #1A1A25;
  box-shadow: none;
  background: #1A1A25;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle:after {
  border-bottom: 2px solid #B5B5B5;
  border-left: 2px solid #B5B5B5;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu a {
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup1 .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup2 .sidebar-layout .sidebar-header {
  border-color: #393947;
}
[data-theme=dark] .form-control, [data-theme=dark] .form-select {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-control:disabled, [data-theme=dark] .form-select:disabled {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .form-control:focus, [data-theme=dark] .form-select:focus {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .input-group-text {
  background: #393947;
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .radio label, [data-theme=dark] .checkbox label {
  color: #a3a6a6;
}
[data-theme=dark] .apexcharts-text tspan {
  fill: #FFF;
}
[data-theme=dark] a {
  color: #FFF;
}
[data-theme=dark] a.label-add {
  color: #e85b28;
}
[data-theme=dark] .settings-sub-header {
  border-color: #393947;
}
[data-theme=dark] .profile-details {
  border-color: #393947;
}
[data-theme=dark] .profile-upload .profile-upload-img {
  border-color: #393947;
}
[data-theme=dark] .settings-sidebar ul li a {
  color: #B5B5B5;
}
[data-theme=dark] .settings-sidebar ul li a:hover {
  color: #FFF;
}
[data-theme=dark] .settings-sidebar ul li a.active {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light {
  background-color: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light:hover {
  background-color: rgb(3.1186440678, 3.1186440678, 4.8813559322);
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .security-grid {
  border-color: #393947;
  background: #1E1E2D;
}
[data-theme=dark] .security-grid .security-heading h5 {
  color: #FFF;
}
[data-theme=dark] .notification-wrap ul li .security-checkbox .checkboxs {
  color: #FFF;
}
[data-theme=dark] .notificaion-table .table tbody tr td {
  color: #FFF;
}
[data-theme=dark] .integration-grid {
  background: #28283E;
  border-color: #28283E;
}
[data-theme=dark] .integration-grid .integration-content p {
  color: #FFF;
}
[data-theme=dark] .storage-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .storage-icon h6 {
  color: #FFF;
}
[data-theme=dark] .black-text {
  color: #FFF !important;
}
[data-theme=dark] .theme-type-images .theme-image {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .theme-type-images .theme-image span {
  color: #FFF;
}
[data-theme=dark] .table tbody tr td a {
  color: #FFF;
}
[data-theme=dark] .text-black {
  color: #FFF !important;
}
[data-theme=dark] .lang-flag a {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .modal .modal-content {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .modal-header {
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .col-form-label {
  color: #FFF;
}
[data-theme=dark] .drag-attach {
  border-color: #393947;
}
[data-theme=dark] .upload-file {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .lang-type li a {
  background: #171724;
}
[data-theme=dark] .dropdown-menu {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .table-action .dropdown-menu a {
  color: #B5B5B5;
}
[data-theme=dark] .table-action .dropdown-menu a:hover {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn-add {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon {
  background: #1A1A25;
  border-color: #393947;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon:hover {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon::after {
  background: #393947;
}
[data-theme=dark] .mail-wrapper .mail-collapse {
  border-color: #393947;
}
[data-theme=dark] .bank-box {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .bank-box.active::after {
  background-color: #28283E;
}
[data-theme=dark] .bank-box .table-action .action-icon:hover {
  background: #1A1A25;
}
[data-theme=dark] .custom-modal .modal-header .btn-close {
  border-color: #393947;
  background: #1A1A25;
  box-shadow: none;
}
[data-theme=dark] .storage-wrap .storage-icon .system-app-icon {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .setting-gateway a {
  color: #B5B5B5;
}
[data-theme=dark] .ip-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon:hover {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .action-drop .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .action-drop .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .notes-activity .note-download:hover {
  background-color: transparent;
}
[data-theme=dark] .notes-activity .note-download:hover a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .notes-activity .note-download a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .bootstrap-tagsinput .tag {
  background: #28283D;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .profile-pic-upload .profile-pic {
  border-color: #393947;
}
[data-theme=dark] .contact-wrap .contact-profile .avatar.company-avatar {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default.select2-container--focus .select2-selection--multiple,
[data-theme=dark] .select2-container--default .select2-selection--multiple {
  border-color: #393947;
}
[data-theme=dark] .select2-container--classic .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background: #28283D;
  border-color: #393947;
}
[data-theme=dark] .title-name {
  color: #FFF !important;
}
[data-theme=dark] .kanban-list-items {
  border-color: #393947;
}
[data-theme=dark] .kanban-list-items .kanban-list-head {
  background: #28283E;
}
[data-theme=dark] .kanban-list-items .kanban-list-head .kanban-action-btns .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .email-header .btn-white {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .pipeline-list {
  border-color: #393947;
}
[data-theme=dark] .priority-info .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .priority-info .dropdown a {
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-item {
  border-color: #393947;
}
[data-theme=dark] .pipeline-item p {
  color: #FFF;
}
[data-theme=dark] .kanban-card {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-body ul li {
  color: #B5B5B5;
}
[data-theme=dark] .kanban-card .kanban-card-footer {
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-footer span {
  border-color: #393947;
}
[data-theme=dark] .campaign-tab {
  background: #28283E;
}
[data-theme=dark] .campaign-tab ul li a {
  border-color: transparent;
}
[data-theme=dark] .campaign-tab ul li a.active {
  color: #e85b28;
}
[data-theme=dark] .campaign-tab ul li a span {
  border-color: #393947;
}
[data-theme=dark] ul.project-mem li.more-set a {
  background: #28283E;
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-progress span, [data-theme=dark] .task-info p,
[data-theme=dark] .con-sidebar-title p, [data-theme=dark] .task-actions ul li {
  color: #FFF;
}
[data-theme=dark] .contact-grid.project .grid-head {
  background-color: #28283E;
}
[data-theme=dark] .contact-grid.project .grid-head .users-profile .con-avatar {
  background-color: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .access-wrap li:hover {
  background: #28283E;
}
[data-theme=dark] .task-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .rate-icon, [data-theme=dark] .con-sidebar-title.border-line {
  border-color: #393947;
}
[data-theme=dark] .pipeline-list ul li a.bg-gray {
  color: #262A2A;
}
[data-theme=dark] .task-wrapper .task-accordion span {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .task-drops .dropdown-toggle {
  background-color: transparent;
}
[data-theme=dark] .task-wrapper {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card {
  background-color: #1E1E2D;
}
[data-theme=dark] .card.analytics-card .card-header {
  background: transparent;
}
[data-theme=dark] .card.analytics-card .card-header .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .activities-list ul li {
  background: #28283E;
}
[data-theme=dark] .activities-list ul li .activity-name h5 {
  color: #FFF;
}
[data-theme=dark] .campaign-card ul .campaign-wrap {
  background: #28283E;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info {
  border-color: #393947;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info h5 {
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th {
  background: #171724;
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th:first-child, [data-theme=dark] .card.analytics-card .card-body .table th:last-child {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card .card-body .table td:first-child, [data-theme=dark] .card.analytics-card .card-body .table td:last-child {
  border-color: #393947;
}
[data-theme=dark] .active-list ul li a {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .activity-title h4::after {
  background: #393947;
}
[data-theme=dark] .header-set {
  border-color: #393947;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .radio-activity li .active-type input[type=radio] ~ label {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .tab-activity {
  box-shadow: none;
}
[data-theme=dark] .tab-activity ul li a span {
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .report-header {
  border-color: #393947;
}
[data-theme=dark] .location-flag-img {
  border-color: #393947;
}
[data-theme=dark] .table-imgname.flag-image span {
  color: #FFF;
}
[data-theme=dark] .membership-plans .plan-selected h4 {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active {
  background-color: #1E1E2D;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .file-manager aside {
  border-color: #393947;
}
[data-theme=dark] .notes-dash {
  background-color: #28283E;
}
[data-theme=dark] .notes-dash .notes-top-head {
  border-color: #393947;
}
[data-theme=dark] .notes-dash .notes-top-head-submenu {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-card-body .notes-card-details {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .search-set .search-input input[type=search] {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .search-set .search-input input[type=search]::placeholder {
  color: #B5B5B5;
}
[data-theme=dark] .todo-wrapper-list {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-bulk-wrap {
  background-color: #28283E;
  box-shadow: none;
}
[data-theme=dark] .notes-page-wrapper .content .page-add-notes {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-notes-slider {
  border-color: #393947;
}
[data-theme=dark] .fc-day {
  background-color: #28283E;
}
[data-theme=dark] .file-manager .folders {
  border-color: #393947;
  background-color: #28283E;
}
[data-theme=dark] .file-manager .accordion .accordion-item .accordion-body {
  background: transparent;
}
[data-theme=dark] table tbody td.action-table-data a {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat .chat-header {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .left-chat-title {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .chat .chat-header .user-details h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body p {
  color: #B5B5B5;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #B5B5B5 !important;
}
[data-theme=dark] .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li a {
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .last-seen {
  color: #B5B5B5;
}
[data-theme=dark] .daterangepicker {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .daterangepicker.show-ranges.ltr .drp-calendar.left {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons .btn-default {
  color: #B5B5B5;
}

.sidebar-contact {
  position: fixed;
  top: 0%;
  right: -350px;
  transform: translateY(-50%);
  width: 350px;
  height: auto;
  background: #FFF;
  box-sizing: border-box;
  transition: 0.5s;
  z-index: 9999;
}
.sidebar-contact .toggle-theme {
  position: absolute;
  width: 35px;
  text-align: center;
  cursor: pointer;
  background: #e85b28;
  top: 225px;
  right: 350px;
  padding: 6px;
  height: 35px;
  color: #FFF;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.sidebar-contact .toggle-theme .fa-spin {
  animation: fa-spin 2s infinite linear;
}

#theme-settings {
  width: 26px;
  height: 26px;
  border: 1px solid #9B9B9B;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
}

.input-themeselect label {
  width: 100%;
}

.sidebar-themesettings {
  transition: all 0.5s;
  width: 400px !important;
  height: 100vh;
  z-index: 99999;
  overflow: auto;
  max-width: 100%;
}
.sidebar-themesettings.open {
  right: 0;
}
.sidebar-themesettings .offcanvas-header {
  border-bottom: 1px solid #9B9B9B;
  position: relative;
}
.sidebar-themesettings .themesettings-inner .themesettings-content {
  border-bottom: 1px solid #9B9B9B;
  margin-bottom: 15px;
}
.sidebar-themesettings .themesettings-inner .themesettings-content h6 {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 15px;
}
.sidebar-themesettings .input-themeselect {
  background: #F6F6F6;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #9B9B9B;
  margin-bottom: 15px;
}
.sidebar-themesettings .input-themeselect input[type=radio] {
  display: none;
}
.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme:after {
  background-color: #4A00E5;
  border-color: #4A00E5;
  content: "";
}
.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme::before {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  right: 4px;
  position: absolute;
  top: -14px;
  z-index: 9;
}
.sidebar-themesettings .input-themeselect img {
  height: 80px;
}
.sidebar-themesettings .input-themeselect .checkboxs-theme {
  position: relative;
  width: 100%;
  display: block;
}
.sidebar-themesettings .input-themeselect .checkboxs-theme:after {
  position: absolute;
  content: "";
  border: 1px solid #E8E8E8;
  width: 16px;
  height: 16px;
  border-radius: 5px;
  right: 0;
  top: -17px;
}

.sidebar-themeoverlay {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 10000;
}
.sidebar-themeoverlay.open {
  left: 0;
}

.sidebar-themesettings.offcanvas.offcanvas-end {
  width: 400px !important;
}

.theme-colorsset label {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #9B9B9B;
  position: relative;
}
.theme-colorsset label::before {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  content: "";
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.theme-colorsset label.primary-clr::before {
  background: #e85b28;
}
.theme-colorsset label.brightblue-clr::before {
  background: #2066FF;
}
.theme-colorsset label.lunargreen-clr::before {
  background: #365E32;
}
.theme-colorsset label.lavendar-clr::before {
  background: #673AB7;
}
.theme-colorsset label.magenta-clr::before {
  background: #E83E8C;
}
.theme-colorsset label.chromeyellow-clr::before {
  background: #FF9B04;
}
.theme-colorsset label.lavared-clr::before {
  background: #DC2626;
}
.theme-colorsset input[type=radio] {
  display: none;
}
.theme-colorsset input[type=radio]:checked ~ label {
  border-color: #e85b28;
}
.theme-colorsset input[type=radio]:checked ~ label:after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #e85b28;
  font-weight: 700;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 12px;
  height: 12px;
  background: #FFF;
  border: 1px solid #9B9B9B;
  border-radius: 4px;
}
.theme-colorsset .pickr-container-primary {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #9B9B9B;
  padding: 4px;
}
.theme-colorsset .pickr-container-primary .pickr .pcr-button {
  width: 24px;
  height: 24px;
}
.theme-colorsset .pickr-container-primary .pickr .pcr-button::after {
  font-size: 1rem;
}

.theme-colorselect input[type=radio] {
  display: none;
}
.theme-colorselect input[type=radio]:checked ~ label {
  outline-color: #e85b28;
}
.theme-colorselect input[type=radio]:checked ~ label:after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #e85b28;
  font-weight: 700;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 12px;
  height: 12px;
  background: #FFF;
  border: 1px solid #9B9B9B;
  border-radius: 4px;
}
.theme-colorselect input[type=radio]:checked ~ label.primary-topbar:after, .theme-colorselect input[type=radio]:checked ~ label.dark-topbar:after {
  color: #FFF;
}
.theme-colorselect label {
  width: 28px;
  height: 45px;
  border-radius: 5px;
  position: relative;
  outline-offset: 3px;
  outline: 1px solid #9B9B9B;
}
.theme-colorselect label.white-topbar {
  background: #FFF;
  border: 1px solid #FDFDFE;
}
.theme-colorselect label.darkaqua-topbar {
  background: #116D6E;
}
.theme-colorselect label.whiterock-topbar {
  background: #F0E4D7;
}
.theme-colorselect label.rockblue-topbar {
  background: #8CB9BD;
}
.theme-colorselect label.bluehaze-topbar {
  background: #B5C0D0;
}
.theme-colorselect label.primary-topbar {
  background: #e85b28;
}
.theme-colorselect label.blackpearl-topbar {
  background: #080821;
}
.theme-colorselect label.maroon-topbar {
  background: #710034;
}
.theme-colorselect label.bluegem-topbar {
  background: #3E1C95;
}
.theme-colorselect label.firefly-topbar {
  background: #053333;
}
.theme-colorselect label.orange-gradient-topbar {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
}
.theme-colorselect label.purple-gradient-topbar {
  background: linear-gradient(180deg, #667CE8 0%, #754EA7 100%);
}
.theme-colorselect label.blue-gradient-topbar {
  background: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
}
.theme-colorselect label.maroon-gradient-topbar {
  background: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
}
.theme-colorselect .pickr-container-background, .theme-colorselect .pickr-topbar, .theme-colorselect .pickr-topbarcolor {
  width: 28px;
  height: 45px;
  border-radius: 5px;
  outline-offset: 3px;
  outline: 1px solid #9B9B9B;
}
.theme-colorselect .pickr-container-background .pickr .pcr-button, .theme-colorselect .pickr-topbar .pickr .pcr-button, .theme-colorselect .pickr-topbarcolor .pickr .pcr-button {
  width: 28px;
  height: 45px;
  border-radius: 5px;
}
.theme-colorselect .pickr-container-background .pickr .pcr-button::after, .theme-colorselect .pickr-topbar .pickr .pcr-button::after, .theme-colorselect .pickr-topbarcolor .pickr .pcr-button::after {
  font-size: 1rem;
  line-height: 2.5;
}

.theme-layout.active img {
  border: 1px solid #e85b28;
  border-radius: 5px;
}
.theme-layout input[type=radio] {
  display: none;
}
.theme-layout input[type=radio]:checked ~ label .layout-img img {
  border-color: #e85b28;
}
.theme-layout input[type=radio]:checked ~ label .layout-type {
  position: relative;
  padding-left: 16px;
}
.theme-layout input[type=radio]:checked ~ label .layout-type:after {
  content: "\\f00c";
  font-family: "Fontawesome";
  color: #e85b28;
  font-weight: 700;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 2px;
  position: absolute;
  width: 12px;
  height: 12px;
  background: #FFF;
  border: 1px solid #9B9B9B;
  border-radius: 4px;
}
.theme-layout label .layout-img img {
  border: 1px solid #9B9B9B;
  border-radius: 5px;
}
.theme-layout label .layout-type {
  color: #262A2A;
}
.theme-layout label:after {
  display: none;
}
.theme-layout .layout-img img {
  border: 1px solid #9B9B9B;
  border-radius: 5px;
}

.theme-mode input[type=radio] {
  display: none;
}
.theme-mode input[type=radio]:checked ~ label {
  border-color: #e85b28;
}
.theme-mode input[type=radio]:checked ~ label .avatar {
  color: #FDA700;
  background-color: #FFF9E9;
}
.theme-mode label {
  border: 1px solid #9B9B9B;
  color: #424848;
}
.theme-mode label .avatar {
  background-color: #E8E9EA;
  color: #171724;
}

.theme-sidebarbg input[type=radio] {
  display: none;
}
.theme-sidebarbg input[type=radio]:checked ~ label:after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #e85b28;
  font-weight: 700;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 12px;
  height: 12px;
  background: #FFF;
  border: 1px solid #9B9B9B;
  border-radius: 4px;
}
.theme-sidebarbg input[type=radio]:checked ~ label img {
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.theme-sidebarbg label {
  width: 48px;
  height: 55px;
  position: relative;
}
.theme-sidebarbg label img {
  width: 48px;
  height: 55px;
  object-fit: cover;
  border: 1px solid #9B9B9B;
}

.theme-topbarbg input[type=radio] {
  display: none;
}
.theme-topbarbg input[type=radio]:checked ~ label:after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #e85b28;
  font-weight: 700;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 12px;
  height: 12px;
  background: #FFF;
  border: 1px solid #9B9B9B;
  border-radius: 4px;
}
.theme-topbarbg input[type=radio]:checked ~ label img {
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.theme-topbarbg label {
  height: 50px;
  position: relative;
}
.theme-topbarbg label img {
  width: 100px;
  height: 50px;
  object-fit: cover;
  border-radius: 10px;
}

.theme-width input[type=radio] {
  display: none;
}
.theme-width input[type=radio]:checked ~ label {
  border-color: #e85b28;
}
.theme-width input[type=radio]:checked ~ label::before {
  border-color: #e85b28;
}
.theme-width input[type=radio]:checked ~ label::after {
  opacity: 1;
}
.theme-width label {
  border: 1px solid #9B9B9B;
  padding: 10px 10px 10px 32px;
  position: relative;
  color: #424848;
  min-width: 120px;
}
.theme-width label::before {
  content: "";
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #9B9B9B;
  background: #FFF;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
}
.theme-width label::after {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e85b28;
  position: absolute;
  top: 50%;
  left: 18px;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.theme-sidebarcolor input[type=radio] {
  display: none;
}
.theme-sidebarcolor input[type=radio]:checked ~ label {
  border-color: #e85b28 !important;
  position: relative;
}
.theme-sidebarcolor input[type=radio]:checked ~ label:after {
  content: "\\f058";
  font-family: "Fontawesome";
  color: #e85b28;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.theme-sidebarcolor input[type=radio]:checked ~ label.bg-dark:after {
  color: #FFF;
}
.theme-sidebarcolor label {
  width: 29px;
  height: 46px;
  border: 1px solid #9B9B9B;
}

.theme-container-primary button,
.theme-container-background button,
.theme-topbar button, .theme-topbarcolor button {
  display: none;
}

.pcr-app {
  z-index: 99999;
}

.pickr-container-primary .pickr .pcr-button,
.pickr-container-background .pickr .pcr-button,
.pickr-topbar .pickr .pcr-button, .pickr-topbarcolor .pickr .pcr-button {
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border-radius: 50%;
}
.pickr-container-primary .pickr .pcr-button:focus,
.pickr-container-background .pickr .pcr-button:focus,
.pickr-topbar .pickr .pcr-button:focus, .pickr-topbarcolor .pickr .pcr-button:focus {
  box-shadow: none;
}
.pickr-container-primary .pickr .pcr-button::after,
.pickr-container-background .pickr .pcr-button::after,
.pickr-topbar .pickr .pcr-button::after, .pickr-topbarcolor .pickr .pcr-button::after {
  content: "\\eb01";
  font-family: "tabler-icons" !important;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
  font-size: 1.25rem;
}

.custom-btn-close {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #6F7A7A;
  color: #FFF;
  margin: 0;
  padding: 0;
  background-image: none;
}
.custom-btn-close:hover {
  background-color: #FC0027;
}

[data-color=all] .theme-colorsset .pickr-container-primary {
  border-color: #e85b28;
}

[data-topbarcolor=all] .theme-colorselect .pickr-topbarcolor {
  outline-color: #e85b28;
}

[data-topbar=all] .theme-colorselect .pickr-topbar {
  outline-color: #e85b28;
}

[data-sidebar=all] .theme-colorselect .pickr-container-background {
  outline-color: #e85b28;
}

.layout-box-mode .main-wrapper {
  max-width: 1320px;
  margin: auto;
}
@media (max-width: 1280px) {
  .layout-box-mode .main-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  .layout-box-mode .main-wrapper {
    max-width: 100%;
  }
}

:root {
  --primary-rgb-picr: var(--primary-rgb);
  --sidebar--rgb-picr: var(--sidebar-rgb);
  --topbar--rgb-picr: var(--topbar-rgb);
  --topbarcolor--rgb-picr: var(--topbarcolor-rgb);
}

[data-layout=default][data-width=box] .layout-box-mode .mini-sidebar .header,
[data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar .header {
  max-width: 1320px;
  left: 0;
}
@media (max-width: 1280px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar .header {
    max-width: 100%;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header,
[data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header {
  max-width: 1320px;
  left: 0;
}
@media (max-width: 1280px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header,
  [data-layout=mini][data-width=box] .layout-box-mode .mini-sidebar.expand-menu .header {
    max-width: 100%;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .header,
[data-layout=mini][data-width=box] .layout-box-mode .header {
  margin: auto;
  max-width: 1320px;
  left: 0;
}
@media (max-width: 1280px) {
  [data-layout=default][data-width=box] .layout-box-mode .header,
  [data-layout=mini][data-width=box] .layout-box-mode .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .header,
  [data-layout=mini][data-width=box] .layout-box-mode .header {
    max-width: 100%;
    left: 0;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .header .header-left,
[data-layout=mini][data-width=box] .layout-box-mode .header .header-left {
  display: block;
  padding-left: 24px;
}
@media (max-width: 991.98px) {
  [data-layout=default][data-width=box] .layout-box-mode .header .header-left,
  [data-layout=mini][data-width=box] .layout-box-mode .header .header-left {
    padding-left: 0;
  }
}
[data-layout=default][data-width=box] .layout-box-mode .sidebar,
[data-layout=mini][data-width=box] .layout-box-mode .sidebar {
  left: auto;
  left: initial;
  top: 50px;
}
[data-layout=default][data-width=box] .layout-box-mode .sidebar .sidebar-logo,
[data-layout=mini][data-width=box] .layout-box-mode .sidebar .sidebar-logo {
  display: none;
}
[data-layout=default][data-width=box] .layout-box-mode .sidebar .slimScrollDiv,
[data-layout=mini][data-width=box] .layout-box-mode .sidebar .slimScrollDiv {
  top: 0;
}

[data-layout=twocolumn][data-width=box] .layout-box-mode .sidebar,
[data-layout=modern][data-width=box] .layout-box-mode .sidebar,
[data-layout=stacked][data-width=box] .layout-box-mode .sidebar {
  left: auto;
  left: initial;
}
[data-layout=twocolumn][data-width=box] .layout-box-mode .sidebar .sidebar-logo,
[data-layout=modern][data-width=box] .layout-box-mode .sidebar .sidebar-logo,
[data-layout=stacked][data-width=box] .layout-box-mode .sidebar .sidebar-logo {
  display: none;
}
[data-layout=twocolumn][data-width=box] .layout-box-mode .header,
[data-layout=modern][data-width=box] .layout-box-mode .header,
[data-layout=stacked][data-width=box] .layout-box-mode .header {
  margin: 0 auto;
  max-width: 1068px;
}
@media (min-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode .header,
  [data-layout=modern][data-width=box] .layout-box-mode .header,
  [data-layout=stacked][data-width=box] .layout-box-mode .header {
    left: 252px;
  }
}
@media (max-width: 1280px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode .header,
  [data-layout=modern][data-width=box] .layout-box-mode .header,
  [data-layout=stacked][data-width=box] .layout-box-mode .header {
    max-width: 698px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode .header,
  [data-layout=modern][data-width=box] .layout-box-mode .header,
  [data-layout=stacked][data-width=box] .layout-box-mode .header {
    max-width: 100%;
    left: 0;
  }
}
[data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
[data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
[data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
  max-width: 1248px;
}
@media (min-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
    left: 72px;
  }
}
@media (max-width: 1280px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
    max-width: 878px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar .header {
    max-width: 100%;
    left: 0;
  }
}
[data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
[data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
[data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
  max-width: 1068px;
}
@media (min-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
    left: 252px;
  }
}
@media (max-width: 1280px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
    max-width: 698px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=modern][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header,
  [data-layout=stacked][data-width=box] .layout-box-mode.mini-sidebar.expand-menu .header {
    max-width: 100%;
    left: 0;
  }
}

[data-layout=horizontal][data-width=box] .main-wrapper .header,
[data-layout=horizontal-overlay][data-width=box] .main-wrapper .header {
  margin: auto;
  max-width: 1320px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .main-wrapper .header,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .main-wrapper .header,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper .header {
    max-width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .main-wrapper::before,
[data-layout=horizontal-overlay][data-width=box] .main-wrapper::before {
  width: 1320px;
  margin: 0 auto;
  left: 0;
  right: 0;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::before,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::before {
    width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::before,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::before {
    width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .main-wrapper::after,
[data-layout=horizontal-overlay][data-width=box] .main-wrapper::after {
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::after,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::after {
    width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .main-wrapper::after,
  [data-layout=horizontal-overlay][data-width=box] .main-wrapper::after {
    width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .header,
[data-layout=horizontal-overlay][data-width=box] .header {
  padding: 0 16px;
}
[data-layout=horizontal][data-width=box] .header .main-header,
[data-layout=horizontal-overlay][data-width=box] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .header .main-header,
  [data-layout=horizontal-overlay][data-width=box] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .header .main-header,
  [data-layout=horizontal-overlay][data-width=box] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .header .main-header .user-menu,
[data-layout=horizontal-overlay][data-width=box] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal][data-width=box] .header .header-left,
[data-layout=horizontal-overlay][data-width=box] .header .header-left {
  display: block;
}
[data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal,
[data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 16px !important;
  left: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal,
  [data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal,
  [data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal {
    max-width: 100%;
  }
}
[data-layout=horizontal][data-width=box] .sidebar.sidebar-horizontal .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-overlay][data-width=box] .sidebar.sidebar-horizontal .sidebar-menu .nav-menu > li.submenu > a {
  padding: 8px 30px 8px 8px;
}

[data-layout=horizontal-single][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single][data-width=box] .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-single][data-width=box] .header {
    max-width: 100%;
  }
}
[data-layout=horizontal-single][data-width=box] .header .main-header .user-menu {
  padding-left: 10px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single][data-width=box] .header .main-header .user-menu {
    padding-left: 8px !important;
  }
}
[data-layout=horizontal-single][data-width=box] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  padding: 8px 18px 8px 6px;
}
@media (min-width: 1280px) {
  [data-layout=horizontal-single][data-width=box] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
    padding: 8px 30px 8px 8px;
  }
}

[data-layout=detached][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}

[data-layout=without-header][data-width=box] .sidebar {
  left: auto;
}

[data-layout=transparent][data-width=box] .sidebar {
  left: auto;
}
[data-layout=transparent][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=transparent][data-width=box] .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=transparent][data-width=box] .header {
    max-width: 100%;
  }
}

[data-layout=horizontal-sidemenu][data-width=box] .sidebar {
  left: auto;
}
[data-layout=horizontal-sidemenu][data-width=box] .header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu][data-width=box] .header {
    max-width: 100%;
  }
}
[data-layout=horizontal-sidemenu][data-width=box] .main-wrapper::before {
  width: 1320px;
  margin: 0 auto;
  left: auto;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu][data-width=box] .main-wrapper::before {
    width: 100%;
  }
}

[data-layout=detached] .main-wrapper {
  margin: 0 auto;
}
@media (min-width: 991.98px) {
  [data-layout=detached] .main-wrapper {
    max-width: 95%;
  }
}
[data-layout=detached] .header {
  left: 0;
}
[data-layout=detached] .header .main-header {
  margin: 0 auto;
}
@media (min-width: 991.98px) {
  [data-layout=detached] .header .main-header {
    max-width: 95%;
  }
}
[data-layout=detached] .expand-menu .header-left {
  width: auto;
}
[data-layout=detached] .expand-menu.mini-sidebar .header {
  left: 0;
}
[data-layout=detached] .expand-menu.mini-sidebar .header .header-left {
  width: auto;
}
[data-layout=detached] .sidebar {
  top: 74px;
  left: auto;
  left: initial;
  bottom: 24px;
}
[data-layout=detached] .sidebar .slimScrollDiv {
  height: 100% !important;
  top: 0;
}
[data-layout=detached] .sidebar .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=detached] .sidebar .slimScrollDiv .sidebar-menu {
  margin-top: 0;
  padding-bottom: 0;
}
[data-layout=detached] .sidebar .sidebar-menu {
  margin-top: 16px;
}
[data-layout=detached] .sidebar .sidebar-logo {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=detached] .sidebar {
    top: 50px;
    bottom: 0;
  }
}
@media (min-width: 991.98px) {
  [data-layout=detached] .page-wrapper {
    padding: 74px 0 0;
  }
}
[data-layout=detached] .page-wrapper .head-icons #collapse-header {
  display: none;
}

[data-layout=twocolumn] .sidebar.navbar-menu {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn] .sidebar.navbar-menu {
    display: block;
  }
}
[data-layout=twocolumn] .sidebar-twocol.sidebar {
  display: flex;
}
[data-layout=twocolumn] #two-col-sidebar {
  display: block;
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn] #two-col-sidebar {
    display: none;
  }
}

[data-layout=horizontal] #horizontal-menu {
  display: block;
}
[data-layout=horizontal] .header {
  left: 0;
}
[data-layout=horizontal] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal] .header .header-left {
  display: block;
}

[data-layout=modern] .header {
  background-color: #FFF;
  border-color: rgba(255, 255, 255, 0.8);
}
[data-layout=modern] .header .bar-icon span {
  background-color: #FFF;
}
@media (max-width: 1280px) {
  [data-layout=modern] .header .input-group {
    width: 200px;
  }
}
[data-layout=modern] .header .header-left {
  display: block;
  padding-left: 24px;
}
[data-layout=modern] .header .header-left .logo {
  display: block;
}
[data-layout=modern] .header .header-left .dark-logo {
  display: none;
}
[data-layout=modern] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=modern] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern] .header .header-user .user-menu .btn-menubar.active {
  background-color: #E8E9EA;
  border-color: #E8E9EA;
  color: #262A2A !important;
}
[data-layout=modern] .sidebar {
  display: block;
}
[data-layout=modern] .sidebar .sidebar-logo {
  display: none;
}
[data-layout=modern] .sidebar .slimScrollDiv {
  top: 0;
  height: calc(100% - 220px) !important;
}
[data-layout=modern] .sidebar .sidebar-inner {
  height: 100% !important;
}
[data-layout=modern] .sidebar .sidebar-menu {
  margin-top: 0;
}
[data-layout=modern] .sidebar .modern-profile {
  display: block;
}
[data-layout=modern] .page-wrapper::before {
  content: "";
  height: 168px;
  background: #FFF;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
[data-layout=modern] .page-wrapper::after {
  content: none;
  height: 168px;
  background-repeat: no-repeat;
  width: 60%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
[data-layout=modern] .mini-sidebar .modern-profile .user-profile {
  padding: 0 !important;
  margin-bottom: 0 !important;
  background: transparent !important;
  border-color: transparent !important;
}
[data-layout=modern] .mini-sidebar .modern-profile .user-profile .avatar {
  width: 40px;
  height: 40px;
}
[data-layout=modern] .mini-sidebar .modern-profile h6, [data-layout=modern] .mini-sidebar .modern-profile p, [data-layout=modern] .mini-sidebar .modern-profile .sidebar-nav {
  display: none;
}
[data-layout=modern] .mini-sidebar .slimScrollDiv {
  height: calc(100% - 70px) !important;
}
[data-layout=modern] .mini-sidebar.expand-menu .modern-profile .user-profile {
  padding: 16px !important;
  margin-bottom: 24px !important;
  background: #FDFDFE !important;
}
[data-layout=modern] .mini-sidebar.expand-menu .modern-profile .user-profile .avatar {
  width: 40px;
  height: 40px;
}
[data-layout=modern] .mini-sidebar.expand-menu .modern-profile h6, [data-layout=modern] .mini-sidebar.expand-menu .modern-profile p, [data-layout=modern] .mini-sidebar.expand-menu .modern-profile .sidebar-nav {
  display: block;
}
[data-layout=modern] .mini-sidebar.expand-menu .slimScrollDiv {
  height: calc(100% - 220px) !important;
}

[data-layout=horizontal-overlay] #horizontal-menu {
  display: block;
}
[data-layout=horizontal-overlay] .header {
  left: 0;
  background-color: #FFF;
  border-color: white;
}
[data-layout=horizontal-overlay] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-overlay] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal-overlay] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal-overlay] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=horizontal-overlay] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay] .mode-toggle {
  color: #424848;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar {
  background-color: #FFF;
  border-bottom: 1px solid white;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar::before {
  content: none;
  height: 100%;
  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #262A2A;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay] .main-wrapper {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-overlay] .main-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .main-wrapper {
    max-width: 100%;
  }
}
[data-layout=horizontal-overlay] .main-wrapper::before {
  content: "";
  height: 168px;
  background: #FFF;
  width: 100%;
  position: absolute;
  top: 96px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .main-wrapper::before {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-overlay] .main-wrapper::after {
  content: "";
  height: 168px;
  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  top: 96px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-overlay] .main-wrapper::after {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-overlay] .page-breadcrumb h2 {
  color: #FFF;
}

[data-layout=horizontal-box] #horizontal-menu {
  display: block;
}
[data-layout=horizontal-box] .main-wrapper {
  max-width: 1320px;
  margin: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .main-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .main-wrapper {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .main-wrapper .header {
  max-width: 1320px;
  margin: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .main-wrapper .header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .main-wrapper .header {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .header {
  left: 0;
  padding: 0 16px;
}
[data-layout=horizontal-box] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal-box] .header .header-left {
  display: block;
}
[data-layout=horizontal-box] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-box] .sidebar.sidebar-horizontal {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 16px !important;
  left: auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-box] .sidebar.sidebar-horizontal {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-box] .sidebar.sidebar-horizontal {
    max-width: 100%;
  }
}
[data-layout=horizontal-box] .sidebar.sidebar-horizontal .sidebar-menu .nav-menu > li.submenu > a {
  padding: 8px 30px 8px 8px;
}

[data-layout=horizontal-fullwidth] #horizontal-menu {
  display: block;
}
[data-layout=horizontal-fullwidth] .header {
  padding: 0 24px;
}
[data-layout=horizontal-fullwidth] .sidebar-horizontal.sidebar .sidebar-menu {
  max-width: 100%;
  padding: 0 24px !important;
}
[data-layout=horizontal-fullwidth] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  padding: 8px 24px 8px 8px;
}
@media (min-width: 1280px) {
  [data-layout=horizontal-fullwidth] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
    padding: 8px 28px 8px 8px;
  }
}

@media (min-width: 991.98px) {
  [data-layout=without-header] .header {
    width: 60px;
    height: 0;
  }
}
[data-layout=without-header] .header #toggle_btn {
  display: none;
}
[data-layout=without-header] .page-wrapper {
  padding: 0;
}
[data-layout=without-header] .page-wrapper .head-icons {
  display: none;
}
[data-layout=without-header] .modern-profile .user-profile {
  display: none;
}
[data-layout=without-header] .modern-profile, [data-layout=without-header] .sidebar-header {
  display: block;
}
[data-layout=without-header] .sidebar {
  display: block;
}
[data-layout=without-header] .sidebar .sidebar-logo {
  position: relative;
}
[data-layout=without-header] .slimScrollDiv {
  top: 0;
  height: calc(100% - 100px) !important;
}
[data-layout=without-header] .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=without-header] .mini-sidebar .sidebar-nav {
  display: none;
}
[data-layout=without-header] .mini-sidebar .sidebar-header .input-group, [data-layout=without-header] .mini-sidebar .sidebar-header .menu-item {
  display: none !important;
}
[data-layout=without-header] .mini-sidebar .sidebar-profile {
  padding: 0 !important;
  background: transparent !important;
  border-color: transparent !important;
}
[data-layout=without-header] .mini-sidebar .sidebar-profile .sidebar-profile-info {
  display: none;
}
[data-layout=without-header] .mini-sidebar .slimScrollDiv {
  height: calc(100% - 110px) !important;
}
[data-layout=without-header] .mini-sidebar .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-nav {
  display: block;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-header .input-group, [data-layout=without-header] .mini-sidebar.expand-menu .sidebar-header .menu-item {
  display: flex !important;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-profile {
  padding: 8px !important;
  background: #FDFDFE !important;
  border-color: #FDFDFE !important;
}
[data-layout=without-header] .mini-sidebar.expand-menu .sidebar-profile .sidebar-profile-info {
  display: block;
}

[data-layout=horizontal-single] #horizontal-menu {
  display: none;
}
[data-layout=horizontal-single] #horizontal-single {
  position: relative;
  top: auto;
  width: auto !important;
  box-shadow: none;
  display: block;
}
[data-layout=horizontal-single] #header-search {
  display: none !important;
}
[data-layout=horizontal-single] .header {
  padding: 5px 24px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .header {
    padding: 0 16px;
  }
}
[data-layout=horizontal-single] .header .header-left {
  width: auto;
  height: 40px;
  display: flex !important;
  align-items: center;
}
[data-layout=horizontal-single] .header .top-nav-search, [data-layout=horizontal-single] .header .dark-mode-list {
  display: none;
}
[data-layout=horizontal-single] .header .nav.user-menu {
  padding: 0;
}
[data-layout=horizontal-single] .sidebar .sidebar-menu .menu-arrow::before {
  top: 3px;
  width: 6px;
  height: 6px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .menu-horizontal .header .main-header .user-menu {
    padding-left: 16px;
  }
}
[data-layout=horizontal-single] .menu-horizontal .page-wrapper {
  padding-top: 50px;
  max-width: 100%;
  margin: 0 24px;
}
[data-layout=horizontal-single] .menu-horizontal .header-collapse .header-user {
  display: block;
}
[data-layout=horizontal-single] .footer {
  margin: 0 -24px;
}
[data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu {
  padding: 0 !important;
  height: 46px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
}
[data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  padding: 8px 21px 8px 8px;
}
@media (min-width: 1280px) {
  [data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
    padding: 8px 30px 8px 8px;
  }
}
[data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li {
  margin-right: 8px;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li {
    margin-right: 1px;
  }
}
@media (max-width: 1280px) {
  [data-layout=horizontal-single] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li a .menu-arrow {
    right: 2px;
  }
}
[data-layout=horizontal-single] .sidebar-menu .nav-menu > li {
  margin-right: 8px;
}
[data-layout=horizontal-single] .sidebar-menu .nav-menu > li:last-child {
  margin-right: 0;
}
[data-layout=horizontal-single] .sidebar-menu .nav-menu > li.submenu > ul {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}

@media (min-width: 991.98px) {
  [data-layout=stacked] #sidebar {
    display: none;
  }
}
@media (min-width: 991.98px) {
  [data-layout=stacked] #stacked-sidebar {
    display: block;
  }
}
@media (min-width: 991.98px) {
  [data-layout=stacked] .mini-sidebar .sidebar {
    overflow: visible;
    overflow: initial;
  }
}
[data-layout=stacked] .mini-sidebar .sidebar .sidebar-right {
  display: none !important;
}
[data-layout=stacked] .mini-sidebar.expand-menu .sidebar .sidebar-right {
  display: flex !important;
}

[data-layout=transparent] body, .data-layout-transparent body {
  background-color: #FEF1EB;
}
[data-layout=transparent] .header, .data-layout-transparent .header {
  left: 0;
  border-bottom: 3px solid #e85b28;
}
[data-layout=transparent] .header .header-left, .data-layout-transparent .header .header-left {
  display: block;
  padding-left: 24px;
}
[data-layout=transparent] .sidebar, .data-layout-transparent .sidebar {
  top: 50px;
  background-color: #FEF1EB;
}
[data-layout=transparent] .sidebar .sidebar-logo, .data-layout-transparent .sidebar .sidebar-logo {
  display: none;
}
[data-layout=transparent] .sidebar .sidebar-logo .logo, .data-layout-transparent .sidebar .sidebar-logo .logo {
  display: none;
}
[data-layout=transparent] .sidebar .slimScrollDiv, .data-layout-transparent .sidebar .slimScrollDiv {
  top: 0;
}
@media (min-width: 991.98px) {
  [data-layout=transparent] .mini-sidebar.expand-menu .header, .data-layout-transparent .mini-sidebar.expand-menu .header {
    left: 0;
  }
}
[data-layout=transparent] .page-wrapper .head-icons, .data-layout-transparent .page-wrapper .head-icons {
  display: none;
}

body.data-layout-transparent {
  background-color: #FEF1EB;
}
body.data-layout-transparent .header {
  left: 0;
  border-bottom: 3px solid #e85b28;
}
body.data-layout-transparent .header .header-left {
  display: block;
  padding-left: 24px;
}
body.data-layout-transparent .sidebar {
  top: 50px;
  background-color: #FEF1EB;
}
body.data-layout-transparent .sidebar .sidebar-logo {
  display: none;
}
body.data-layout-transparent .sidebar .sidebar-logo .logo {
  display: none;
}
body.data-layout-transparent .sidebar .slimScrollDiv {
  top: 0;
}
@media (min-width: 991.98px) {
  body.data-layout-transparent .mini-sidebar.expand-menu .header {
    left: 0;
  }
}
body.data-layout-transparent .page-wrapper .head-icons {
  display: none;
}

[data-layout=horizontal-sidemenu] .header {
  left: 0;
  background-color: #262A2A;
  border-color: #323737;
}
[data-layout=horizontal-sidemenu] .header .main-header {
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1280px) {
  [data-layout=horizontal-sidemenu] .header .main-header {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .header .main-header {
    max-width: 100%;
  }
}
[data-layout=horizontal-sidemenu] .header .main-header .user-menu {
  padding-right: 0;
}
[data-layout=horizontal-sidemenu] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-sidemenu] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-sidemenu] .header .header-left {
  display: block;
}
[data-layout=horizontal-sidemenu] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-sidemenu] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-sidemenu] .main-wrapper {
  margin: 0 auto;
}
@media (min-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .main-wrapper {
    max-width: 95%;
  }
}
[data-layout=horizontal-sidemenu] .main-wrapper::before {
  content: "";
  height: 168px;
  background: #262A2A;
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .main-wrapper::before {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-sidemenu] .main-wrapper::after {
  content: "";
  height: 168px;
  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  z-index: -1;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .main-wrapper::after {
    top: 50px;
    height: 100px;
  }
}
[data-layout=horizontal-sidemenu] .sidebar {
  top: 74px;
  left: auto;
  left: initial;
  bottom: 24px;
}
[data-layout=horizontal-sidemenu] .sidebar .slimScrollDiv {
  height: 100% !important;
  top: 0;
}
[data-layout=horizontal-sidemenu] .sidebar .slimScrollDiv .sidebar-inner {
  height: 100% !important;
}
[data-layout=horizontal-sidemenu] .sidebar .slimScrollDiv .sidebar-menu {
  margin-top: 0;
  padding-bottom: 0;
}
[data-layout=horizontal-sidemenu] .sidebar .sidebar-menu {
  margin-top: 16px;
}
[data-layout=horizontal-sidemenu] .sidebar .sidebar-logo {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .sidebar {
    top: 50px;
    bottom: 0;
  }
}
@media (min-width: 991.98px) {
  [data-layout=horizontal-sidemenu] .page-wrapper {
    padding: 74px 0 0;
  }
}
[data-layout=horizontal-sidemenu] .page-wrapper .head-icons {
  display: none;
}
[data-layout=horizontal-sidemenu] .expand-menu.mini-sidebar .header {
  left: 0;
}

[data-sidebar=dark] .sidebar {
  background: #262A2A;
  border-color: #262A2A;
}
[data-sidebar=dark] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=dark] .sidebar .logo {
  display: none;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=dark] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=dark] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=dark] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=dark] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right {
  background: #262A2A;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=dark] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=dark] .sidebar-twocol .twocol-mini {
  background-color: #262A2A;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=dark] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=dark] .sidebar-stacked .stacked-mini {
  background-color: #262A2A;
  border-color: #323737;
}
[data-sidebar=dark] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #262A2A;
}
[data-sidebar=dark] .sidebar-stacked .btn-menubar:hover, [data-sidebar=dark] .sidebar-stacked .btn-menubar.active {
  background: #565E5E;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right {
  background: #262A2A;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #262A2A;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=dark] .sidebar-stacked .nav-link {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=dark] .sidebar-stacked .nav-link p, [data-sidebar=dark] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=dark] .sidebar-stacked .nav-link:hover, [data-sidebar=dark] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=dark] .sidebar-stacked .nav-link:hover p, [data-sidebar=dark] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=darkgreen] .sidebar {
  background: #111926;
  border-color: #111926;
}
[data-sidebar=darkgreen] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=darkgreen] .sidebar .logo {
  display: none;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=darkgreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=darkgreen] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=darkgreen] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right {
  background: #111926;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgreen] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgreen] .sidebar-twocol .twocol-mini {
  background-color: #111926;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=darkgreen] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=darkgreen] .sidebar-stacked .stacked-mini {
  background-color: #111926;
  border-color: #323737;
}
[data-sidebar=darkgreen] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #111926;
}
[data-sidebar=darkgreen] .sidebar-stacked .btn-menubar:hover, [data-sidebar=darkgreen] .sidebar-stacked .btn-menubar.active {
  background: #565E5E;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right {
  background: #111926;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #111926;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link p, [data-sidebar=darkgreen] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link:hover, [data-sidebar=darkgreen] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgreen] .sidebar-stacked .nav-link:hover p, [data-sidebar=darkgreen] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=nightblue] .sidebar {
  background: #0F0F41;
  border-color: #0F0F41;
}
[data-sidebar=nightblue] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=nightblue] .sidebar .logo {
  display: none;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=nightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=nightblue] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=nightblue] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right {
  background: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=nightblue] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=nightblue] .sidebar-twocol .twocol-mini {
  background-color: #0F0F41;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=nightblue] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=nightblue] .sidebar-stacked .stacked-mini {
  background-color: #0F0F41;
  border-color: #323737;
}
[data-sidebar=nightblue] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-stacked .btn-menubar:hover, [data-sidebar=nightblue] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right {
  background: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #0F0F41;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgb(20.7375, 20.7375, 89.8625);
  border-color: rgb(20.7375, 20.7375, 89.8625);
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link p, [data-sidebar=nightblue] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link:hover, [data-sidebar=nightblue] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgb(18.825, 18.825, 81.575);
  border-color: rgb(18.825, 18.825, 81.575);
}
[data-sidebar=nightblue] .sidebar-stacked .nav-link:hover p, [data-sidebar=nightblue] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=royalblue] .sidebar {
  background: #0039C6;
  border-color: #0039C6;
}
[data-sidebar=royalblue] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=royalblue] .sidebar .logo {
  display: none;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li > ul > li > a:hover i {
  color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop i {
  color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover i, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active span, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a:hover .menu-arrow::before, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=royalblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=royalblue] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=royalblue] .sidebar-twocol.sidebar .nav-link:hover {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right {
  background: #0039C6;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right .sidebar-scroll > h6 {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #C0C0C0;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #424848 !important;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=royalblue] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=royalblue] .sidebar-twocol .twocol-mini {
  background-color: #0039C6;
  border-color: #6F6F6F;
}
@media (min-width: 991.98px) {
  [data-sidebar=royalblue] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=royalblue] .sidebar-stacked .stacked-mini {
  background-color: #0039C6;
  border-color: #6F6F6F;
}
[data-sidebar=royalblue] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #0039C6;
}
[data-sidebar=royalblue] .sidebar-stacked .btn-menubar:hover, [data-sidebar=royalblue] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right {
  background: #0039C6;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #0039C6;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgb(0, 65.8090909091, 228.6);
  border-color: rgb(0, 65.8090909091, 228.6);
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link p, [data-sidebar=royalblue] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link:hover, [data-sidebar=royalblue] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgb(0, 62.8727272727, 218.4);
  border-color: rgb(0, 62.8727272727, 218.4);
}
[data-sidebar=royalblue] .sidebar-stacked .nav-link:hover p, [data-sidebar=royalblue] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=darkgray] .sidebar {
  background: #2E2E48;
  border-color: #2E2E48;
}
[data-sidebar=darkgray] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=darkgray] .sidebar .logo {
  display: none;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=darkgray] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=darkgray] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=darkgray] .sidebar-twocol.sidebar .nav-link:hover {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right {
  background: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right h6, [data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right p {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right .bg-light {
  background-color: #565E5E !important;
  border-color: #565E5E !important;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #FFF !important;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgray] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #565E5E;
  color: #FFF !important;
}
[data-sidebar=darkgray] .sidebar-twocol .twocol-mini {
  background-color: #2E2E48;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=darkgray] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=darkgray] .sidebar-stacked .stacked-mini {
  background-color: #2E2E48;
  border-color: #323737;
}
[data-sidebar=darkgray] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-stacked .btn-menubar:hover, [data-sidebar=darkgray] .sidebar-stacked .btn-menubar.active {
  background: #565E5E;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right {
  background: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #2E2E48;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link p, [data-sidebar=darkgray] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link:hover, [data-sidebar=darkgray] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: #323737;
  border-color: #323737;
}
[data-sidebar=darkgray] .sidebar-stacked .nav-link:hover p, [data-sidebar=darkgray] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=indigo] #sidebar {
  background: #391694;
  border-color: #391694;
}
[data-sidebar=indigo] #sidebar .dark-logo {
  display: block;
}
[data-sidebar=indigo] #sidebar .logo {
  display: none;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #C0C0C0;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li > ul > li > a:hover span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li > ul > li > a:hover i {
  color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #C0C0C0;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop i {
  color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #C0C0C0;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover i, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active span, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active i {
  color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a:hover .menu-arrow::before, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=indigo] #sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=indigo] #sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=indigo] #sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=indigo] #sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=indigo] #sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=indigo] .sidebar-twocol.sidebar .nav-link:hover {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right {
  background: #391694;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right .sidebar-scroll > h6 {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #C0C0C0;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #424848 !important;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=indigo] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=indigo] .sidebar-twocol .twocol-mini {
  background-color: #391694;
  border-color: #323737;
}
@media (min-width: 991.98px) {
  [data-sidebar=indigo] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=indigo] .sidebar-stacked .stacked-mini {
  background-color: #391694;
  border-color: #323737;
}
[data-sidebar=indigo] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: #391694;
}
[data-sidebar=indigo] .sidebar-stacked .btn-menubar:hover, [data-sidebar=indigo] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right {
  background: #391694;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: #391694;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-stacked .sidebar-right a:hover {
  color: #e85b28;
}
[data-sidebar=indigo] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgb(67.26, 25.96, 174.64);
  border-color: rgb(67.26, 25.96, 174.64);
}
[data-sidebar=indigo] .sidebar-stacked .nav-link p, [data-sidebar=indigo] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=indigo] .sidebar-stacked .nav-link:hover, [data-sidebar=indigo] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgb(63.84, 24.64, 165.76);
  border-color: rgb(63.84, 24.64, 165.76);
}
[data-sidebar=indigo] .sidebar-stacked .nav-link:hover p, [data-sidebar=indigo] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-sidebar=all] .sidebar {
  background: rgb(var(--sidebar-rgb));
  background: rgb(var(--sidebar--rgb-picr));
  border-color: rgb(var(--sidebar-rgb));
  border-color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar .dark-logo {
  display: block;
}
[data-sidebar=all] .sidebar .logo {
  display: none;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li > ul > li > a:hover span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li > ul > li > a:hover i {
  color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a i {
  color: #9B9B9B;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop i {
  color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover i, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active span, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a:hover .menu-arrow::before, [data-sidebar=all] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-color: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li.active a span {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a {
  color: #898989;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a:hover, [data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #9B9B9B;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #898989;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li.active a {
  background: #424848;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #9B9B9B;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a {
  color: #898989;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a.active, [data-sidebar=all] .sidebar .sidebar-menu > ul > li ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-sidebar=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-sidebar=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active, [data-sidebar=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a:hover {
  background: transparent;
}
[data-sidebar=all] .sidebar .sidebar-menu .menu-arrow::before {
  border-color: #9B9B9B;
}
[data-sidebar=all] .sidebar-twocol.sidebar .nav-link {
  color: #FFF;
}
[data-sidebar=all] .sidebar-twocol.sidebar .nav-link.active, [data-sidebar=all] .sidebar-twocol.sidebar .nav-link:hover {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right {
  background: rgb(var(--sidebar-rgb));
  background: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right .sidebar-scroll > h6 {
  color: #FFF;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #FFF;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop {
  background: #C0C0C0;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.subdrop:hover {
  color: #424848 !important;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=all] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #C0C0C0;
  color: #424848 !important;
}
[data-sidebar=all] .sidebar-twocol .twocol-mini {
  background-color: rgb(var(--sidebar-rgb));
  background-color: rgb(var(--sidebar--rgb-picr));
  border-color: #6F6F6F;
}
@media (min-width: 991.98px) {
  [data-sidebar=all] .expand-menu.mini-sidebar .sidebar-twocol.sidebar .logo {
    display: none;
  }
}
[data-sidebar=all] .sidebar-stacked .stacked-mini {
  background-color: rgb(var(--sidebar-rgb));
  background-color: rgb(var(--sidebar--rgb-picr));
  border-color: #6F6F6F;
}
[data-sidebar=all] .sidebar-stacked .btn-menubar {
  color: #FFF;
  border-color: rgb(var(--sidebar-rgb));
  border-color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .btn-menubar:hover, [data-sidebar=all] .sidebar-stacked .btn-menubar.active {
  background: #C0C0C0;
  color: #424848;
}
[data-sidebar=all] .sidebar-stacked .sidebar-right {
  background: rgb(var(--sidebar-rgb));
  background: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .sidebar-right h6 {
  color: #FFF;
}
[data-sidebar=all] .sidebar-stacked .sidebar-right .sidebar-profile h6 {
  color: rgb(var(--sidebar-rgb));
  color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .sidebar-right a {
  color: #FFF;
}
[data-sidebar=all] .sidebar-stacked .sidebar-right a:hover {
  color: rgb(var(--sidebar-rgb));
  color: rgb(var(--sidebar--rgb-picr));
}
[data-sidebar=all] .sidebar-stacked .nav-link {
  color: #FFF;
  background: rgba(var(--sidebar-rgb), 0.7);
  background: rgba(var(--sidebar--rgb-picr), 0.7);
  border-color: rgba(var(--sidebar-rgb), 0.7);
  border-color: rgba(var(--sidebar--rgb-picr), 0.7);
}
[data-sidebar=all] .sidebar-stacked .nav-link p, [data-sidebar=all] .sidebar-stacked .nav-link i {
  color: #FFF;
}
[data-sidebar=all] .sidebar-stacked .nav-link:hover, [data-sidebar=all] .sidebar-stacked .nav-link.active {
  color: #FFF;
  background: rgba(var(--sidebar-rgb), 0.4);
  background: rgba(var(--sidebar--rgb-picr), 0.4);
  border-color: rgba(var(--sidebar-rgb), 0.4);
  border-color: rgba(var(--sidebar--rgb-picr), 0.4);
}
[data-sidebar=all] .sidebar-stacked .nav-link:hover p, [data-sidebar=all] .sidebar-stacked .nav-link.active p {
  color: #FFF;
}

[data-layout=default][data-topbar=darkaqua] .header,
[data-layout=mini][data-topbar=darkaqua] .header,
[data-layout=horizontal][data-topbar=darkaqua] .header,
[data-layout=horizontal-single][data-topbar=darkaqua] .header,
[data-layout=detached][data-topbar=darkaqua] .header,
[data-layout=twocolumn][data-topbar=darkaqua] .header,
[data-layout=stacked][data-topbar=darkaqua] .header,
[data-layout=transparent][data-topbar=darkaqua] .header {
  background: #116D6E;
  border-bottom-color: #116D6E;
}
[data-layout=default][data-topbar=darkaqua] .header .bg-white,
[data-layout=mini][data-topbar=darkaqua] .header .bg-white,
[data-layout=horizontal][data-topbar=darkaqua] .header .bg-white,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .bg-white,
[data-layout=detached][data-topbar=darkaqua] .header .bg-white,
[data-layout=twocolumn][data-topbar=darkaqua] .header .bg-white,
[data-layout=stacked][data-topbar=darkaqua] .header .bg-white,
[data-layout=transparent][data-topbar=darkaqua] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=darkaqua] .header .header-left,
[data-layout=mini][data-topbar=darkaqua] .header .header-left,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-left,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-left,
[data-layout=detached][data-topbar=darkaqua] .header .header-left,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-left,
[data-layout=stacked][data-topbar=darkaqua] .header .header-left,
[data-layout=transparent][data-topbar=darkaqua] .header .header-left {
  background: #116D6E;
  border-color: #116D6E;
}
[data-layout=default][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover, [data-layout=default][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=mini][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=mini][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=detached][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=detached][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=twocolumn][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=stacked][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=stacked][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active,
[data-layout=transparent][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=transparent][data-topbar=darkaqua] .header .header-user .user-menu .btn-menubar.active {
  color: #424848;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #116D6E;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #FFF;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  color: #424848;
}
[data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=default][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=mini][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=detached][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=twocolumn][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=stacked][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=transparent][data-topbar=darkaqua] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-layout=default][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=mini][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal-single][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=detached][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=twocolumn][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=stacked][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo,
[data-layout=transparent][data-topbar=darkaqua] .menu-horizontal .header .header-left .logo {
  display: none;
}
[data-layout=default][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=mini][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal-single][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=detached][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=twocolumn][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=stacked][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo,
[data-layout=transparent][data-topbar=darkaqua] .menu-horizontal .header .header-left .dark-logo {
  display: block;
}

[data-layout=default][data-topbar=rockblue] .header,
[data-layout=mini][data-topbar=rockblue] .header,
[data-layout=horizontal][data-topbar=rockblue] .header,
[data-layout=horizontal-single][data-topbar=rockblue] .header,
[data-layout=detached][data-topbar=rockblue] .header,
[data-layout=twocolumn][data-topbar=rockblue] .header,
[data-layout=stacked][data-topbar=rockblue] .header,
[data-layout=transparent][data-topbar=rockblue] .header {
  background: #8CB9BD;
  border-bottom-color: #8CB9BD;
}
[data-layout=default][data-topbar=rockblue] .header .bg-white,
[data-layout=mini][data-topbar=rockblue] .header .bg-white,
[data-layout=horizontal][data-topbar=rockblue] .header .bg-white,
[data-layout=horizontal-single][data-topbar=rockblue] .header .bg-white,
[data-layout=detached][data-topbar=rockblue] .header .bg-white,
[data-layout=twocolumn][data-topbar=rockblue] .header .bg-white,
[data-layout=stacked][data-topbar=rockblue] .header .bg-white,
[data-layout=transparent][data-topbar=rockblue] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=rockblue] .header .header-left,
[data-layout=mini][data-topbar=rockblue] .header .header-left,
[data-layout=horizontal][data-topbar=rockblue] .header .header-left,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-left,
[data-layout=detached][data-topbar=rockblue] .header .header-left,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-left,
[data-layout=stacked][data-topbar=rockblue] .header .header-left,
[data-layout=transparent][data-topbar=rockblue] .header .header-left {
  background: #8CB9BD;
  border-color: #8CB9BD;
}
[data-layout=default][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar {
  color: #262A2A;
}
[data-layout=default][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover, [data-layout=default][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=mini][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=mini][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-single][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=detached][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=detached][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=twocolumn][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=stacked][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=stacked][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active,
[data-layout=transparent][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=transparent][data-topbar=rockblue] .header .header-user .user-menu .btn-menubar.active {
  background: #FFF;
}
[data-layout=default][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=rockblue] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #8CB9BD;
}

[data-layout=default][data-topbar=whiterock] .header,
[data-layout=mini][data-topbar=whiterock] .header,
[data-layout=horizontal][data-topbar=whiterock] .header,
[data-layout=horizontal-single][data-topbar=whiterock] .header,
[data-layout=detached][data-topbar=whiterock] .header,
[data-layout=twocolumn][data-topbar=whiterock] .header,
[data-layout=stacked][data-topbar=whiterock] .header,
[data-layout=transparent][data-topbar=whiterock] .header {
  background: #F0E4D7;
  border-bottom-color: #F0E4D7;
}
[data-layout=default][data-topbar=whiterock] .header .bg-white,
[data-layout=mini][data-topbar=whiterock] .header .bg-white,
[data-layout=horizontal][data-topbar=whiterock] .header .bg-white,
[data-layout=horizontal-single][data-topbar=whiterock] .header .bg-white,
[data-layout=detached][data-topbar=whiterock] .header .bg-white,
[data-layout=twocolumn][data-topbar=whiterock] .header .bg-white,
[data-layout=stacked][data-topbar=whiterock] .header .bg-white,
[data-layout=transparent][data-topbar=whiterock] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=whiterock] .header .header-left,
[data-layout=mini][data-topbar=whiterock] .header .header-left,
[data-layout=horizontal][data-topbar=whiterock] .header .header-left,
[data-layout=horizontal-single][data-topbar=whiterock] .header .header-left,
[data-layout=detached][data-topbar=whiterock] .header .header-left,
[data-layout=twocolumn][data-topbar=whiterock] .header .header-left,
[data-layout=stacked][data-topbar=whiterock] .header .header-left,
[data-layout=transparent][data-topbar=whiterock] .header .header-left {
  background: #F0E4D7;
  border-color: #F0E4D7;
}
[data-layout=default][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=whiterock] .header .header-user .user-menu .btn-menubar {
  color: #262A2A;
}
[data-layout=default][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=whiterock] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #F0E4D7;
}

[data-layout=default][data-topbar=bluehaze] .header,
[data-layout=mini][data-topbar=bluehaze] .header,
[data-layout=horizontal][data-topbar=bluehaze] .header,
[data-layout=horizontal-single][data-topbar=bluehaze] .header,
[data-layout=detached][data-topbar=bluehaze] .header,
[data-layout=twocolumn][data-topbar=bluehaze] .header,
[data-layout=stacked][data-topbar=bluehaze] .header,
[data-layout=transparent][data-topbar=bluehaze] .header {
  background: #B5C0D0;
  border-bottom-color: #B5C0D0;
}
[data-layout=default][data-topbar=bluehaze] .header .bg-white,
[data-layout=mini][data-topbar=bluehaze] .header .bg-white,
[data-layout=horizontal][data-topbar=bluehaze] .header .bg-white,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .bg-white,
[data-layout=detached][data-topbar=bluehaze] .header .bg-white,
[data-layout=twocolumn][data-topbar=bluehaze] .header .bg-white,
[data-layout=stacked][data-topbar=bluehaze] .header .bg-white,
[data-layout=transparent][data-topbar=bluehaze] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=bluehaze] .header .header-left,
[data-layout=mini][data-topbar=bluehaze] .header .header-left,
[data-layout=horizontal][data-topbar=bluehaze] .header .header-left,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .header-left,
[data-layout=detached][data-topbar=bluehaze] .header .header-left,
[data-layout=twocolumn][data-topbar=bluehaze] .header .header-left,
[data-layout=stacked][data-topbar=bluehaze] .header .header-left,
[data-layout=transparent][data-topbar=bluehaze] .header .header-left {
  background: #B5C0D0;
  border-color: #B5C0D0;
}
[data-layout=default][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=bluehaze] .header .header-user .user-menu .btn-menubar {
  color: #262A2A;
}
[data-layout=default][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=bluehaze] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: #B5C0D0;
}

[data-layout=default][data-topbar=orangegradient] .header,
[data-layout=mini][data-topbar=orangegradient] .header,
[data-layout=horizontal][data-topbar=orangegradient] .header,
[data-layout=horizontal-single][data-topbar=orangegradient] .header,
[data-layout=detached][data-topbar=orangegradient] .header,
[data-layout=twocolumn][data-topbar=orangegradient] .header,
[data-layout=stacked][data-topbar=orangegradient] .header,
[data-layout=transparent][data-topbar=orangegradient] .header {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
  border-bottom-color: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
}
[data-layout=default][data-topbar=orangegradient] .header .bg-white,
[data-layout=mini][data-topbar=orangegradient] .header .bg-white,
[data-layout=horizontal][data-topbar=orangegradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .bg-white,
[data-layout=detached][data-topbar=orangegradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=orangegradient] .header .bg-white,
[data-layout=stacked][data-topbar=orangegradient] .header .bg-white,
[data-layout=transparent][data-topbar=orangegradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=orangegradient] .header .header-left,
[data-layout=mini][data-topbar=orangegradient] .header .header-left,
[data-layout=horizontal][data-topbar=orangegradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .header-left,
[data-layout=detached][data-topbar=orangegradient] .header .header-left,
[data-layout=twocolumn][data-topbar=orangegradient] .header .header-left,
[data-layout=stacked][data-topbar=orangegradient] .header .header-left,
[data-layout=transparent][data-topbar=orangegradient] .header .header-left {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
  border-color: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
}
[data-layout=default][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=orangegradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=orangegradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%);
}

[data-layout=default][data-topbar=purplegradient] .header,
[data-layout=mini][data-topbar=purplegradient] .header,
[data-layout=horizontal][data-topbar=purplegradient] .header,
[data-layout=horizontal-single][data-topbar=purplegradient] .header,
[data-layout=detached][data-topbar=purplegradient] .header,
[data-layout=twocolumn][data-topbar=purplegradient] .header,
[data-layout=stacked][data-topbar=purplegradient] .header,
[data-layout=transparent][data-topbar=purplegradient] .header {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
  border-bottom-color: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
}
[data-layout=default][data-topbar=purplegradient] .header .bg-white,
[data-layout=mini][data-topbar=purplegradient] .header .bg-white,
[data-layout=horizontal][data-topbar=purplegradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .bg-white,
[data-layout=detached][data-topbar=purplegradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=purplegradient] .header .bg-white,
[data-layout=stacked][data-topbar=purplegradient] .header .bg-white,
[data-layout=transparent][data-topbar=purplegradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=purplegradient] .header .header-left,
[data-layout=mini][data-topbar=purplegradient] .header .header-left,
[data-layout=horizontal][data-topbar=purplegradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .header-left,
[data-layout=detached][data-topbar=purplegradient] .header .header-left,
[data-layout=twocolumn][data-topbar=purplegradient] .header .header-left,
[data-layout=stacked][data-topbar=purplegradient] .header .header-left,
[data-layout=transparent][data-topbar=purplegradient] .header .header-left {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
  border-color: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
}
[data-layout=default][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=purplegradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=purplegradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%);
}

[data-layout=default][data-topbar=bluegradient] .header,
[data-layout=mini][data-topbar=bluegradient] .header,
[data-layout=horizontal][data-topbar=bluegradient] .header,
[data-layout=horizontal-single][data-topbar=bluegradient] .header,
[data-layout=detached][data-topbar=bluegradient] .header,
[data-layout=twocolumn][data-topbar=bluegradient] .header,
[data-layout=stacked][data-topbar=bluegradient] .header,
[data-layout=transparent][data-topbar=bluegradient] .header {
  background: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
  border-bottom-color: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
}
[data-layout=default][data-topbar=bluegradient] .header .bg-white,
[data-layout=mini][data-topbar=bluegradient] .header .bg-white,
[data-layout=horizontal][data-topbar=bluegradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .bg-white,
[data-layout=detached][data-topbar=bluegradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=bluegradient] .header .bg-white,
[data-layout=stacked][data-topbar=bluegradient] .header .bg-white,
[data-layout=transparent][data-topbar=bluegradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=bluegradient] .header .header-left,
[data-layout=mini][data-topbar=bluegradient] .header .header-left,
[data-layout=horizontal][data-topbar=bluegradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .header-left,
[data-layout=detached][data-topbar=bluegradient] .header .header-left,
[data-layout=twocolumn][data-topbar=bluegradient] .header .header-left,
[data-layout=stacked][data-topbar=bluegradient] .header .header-left,
[data-layout=transparent][data-topbar=bluegradient] .header .header-left {
  background: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
  border-color: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
}
[data-layout=default][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=bluegradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=bluegradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);
}

[data-layout=default][data-topbar=maroongradient] .header,
[data-layout=mini][data-topbar=maroongradient] .header,
[data-layout=horizontal][data-topbar=maroongradient] .header,
[data-layout=horizontal-single][data-topbar=maroongradient] .header,
[data-layout=detached][data-topbar=maroongradient] .header,
[data-layout=twocolumn][data-topbar=maroongradient] .header,
[data-layout=stacked][data-topbar=maroongradient] .header,
[data-layout=transparent][data-topbar=maroongradient] .header {
  background: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
  border-bottom-color: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
}
[data-layout=default][data-topbar=maroongradient] .header .bg-white,
[data-layout=mini][data-topbar=maroongradient] .header .bg-white,
[data-layout=horizontal][data-topbar=maroongradient] .header .bg-white,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .bg-white,
[data-layout=detached][data-topbar=maroongradient] .header .bg-white,
[data-layout=twocolumn][data-topbar=maroongradient] .header .bg-white,
[data-layout=stacked][data-topbar=maroongradient] .header .bg-white,
[data-layout=transparent][data-topbar=maroongradient] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=maroongradient] .header .header-left,
[data-layout=mini][data-topbar=maroongradient] .header .header-left,
[data-layout=horizontal][data-topbar=maroongradient] .header .header-left,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .header-left,
[data-layout=detached][data-topbar=maroongradient] .header .header-left,
[data-layout=twocolumn][data-topbar=maroongradient] .header .header-left,
[data-layout=stacked][data-topbar=maroongradient] .header .header-left,
[data-layout=transparent][data-topbar=maroongradient] .header .header-left {
  background: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
  border-color: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
}
[data-layout=default][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=maroongradient] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=maroongradient] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);
}

[data-layout=default][data-topbar=all] .header,
[data-layout=mini][data-topbar=all] .header,
[data-layout=horizontal][data-topbar=all] .header,
[data-layout=horizontal-single][data-topbar=all] .header,
[data-layout=detached][data-topbar=all] .header,
[data-layout=twocolumn][data-topbar=all] .header,
[data-layout=stacked][data-topbar=all] .header,
[data-layout=transparent][data-topbar=all] .header {
  background: rgb(var(--topbar-rgb));
  background: rgb(var(--topbar--rgb-picr));
  border-bottom-color: rgb(var(--topbar-rgb));
  border-bottom-color: rgb(var(--topbar--rgb-picr));
}
[data-layout=default][data-topbar=all] .header .bg-white,
[data-layout=mini][data-topbar=all] .header .bg-white,
[data-layout=horizontal][data-topbar=all] .header .bg-white,
[data-layout=horizontal-single][data-topbar=all] .header .bg-white,
[data-layout=detached][data-topbar=all] .header .bg-white,
[data-layout=twocolumn][data-topbar=all] .header .bg-white,
[data-layout=stacked][data-topbar=all] .header .bg-white,
[data-layout=transparent][data-topbar=all] .header .bg-white {
  background: transparent !important;
}
[data-layout=default][data-topbar=all] .header .header-left,
[data-layout=mini][data-topbar=all] .header .header-left,
[data-layout=horizontal][data-topbar=all] .header .header-left,
[data-layout=horizontal-single][data-topbar=all] .header .header-left,
[data-layout=detached][data-topbar=all] .header .header-left,
[data-layout=twocolumn][data-topbar=all] .header .header-left,
[data-layout=stacked][data-topbar=all] .header .header-left,
[data-layout=transparent][data-topbar=all] .header .header-left {
  background: rgb(var(--topbar-rgb));
  background: rgb(var(--topbar--rgb-picr));
  border-color: rgb(var(--topbar-rgb));
  border-color: rgb(var(--topbar--rgb-picr));
}
[data-layout=default][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=mini][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-single][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=detached][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=twocolumn][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=stacked][data-topbar=all] .header .header-user .user-menu .btn-menubar,
[data-layout=transparent][data-topbar=all] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=default][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover, [data-layout=default][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=mini][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=mini][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=horizontal-single][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-single][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=detached][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=detached][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=twocolumn][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=twocolumn][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=stacked][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=stacked][data-topbar=all] .header .header-user .user-menu .btn-menubar.active,
[data-layout=transparent][data-topbar=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=transparent][data-topbar=all] .header .header-user .user-menu .btn-menubar.active {
  color: #424848;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu {
  background: rgb(var(--topbar-rgb));
  background: rgb(var(--topbar--rgb-picr));
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #FFF;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  color: #424848;
}
[data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=default][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=mini][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-single][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=detached][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=twocolumn][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=stacked][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=transparent][data-topbar=all] .header .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #424848;
}
[data-layout=default][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=mini][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=horizontal-single][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=detached][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=twocolumn][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=stacked][data-topbar=all] .menu-horizontal .header .header-left .logo,
[data-layout=transparent][data-topbar=all] .menu-horizontal .header .header-left .logo {
  display: none;
}
[data-layout=default][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=mini][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=horizontal-single][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=detached][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=twocolumn][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=stacked][data-topbar=all] .menu-horizontal .header .header-left .dark-logo,
[data-layout=transparent][data-topbar=all] .menu-horizontal .header .header-left .dark-logo {
  display: block;
}

[data-layout=horizontal-overlay][data-topbarcolor=dark] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header {
  left: 0;
  background-color: #262A2A;
  border-color: #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar {
  background-color: #262A2A;
  border-bottom: 1px solid #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=dark] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=dark] .main-wrapper::before {
  background: #262A2A;
}

[data-layout=horizontal-overlay][data-topbarcolor=primary] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header {
  left: 0;
  background-color: #e85b28;
  border-color: #E94C39;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover {
  background: #EF796A;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar {
  background-color: #e85b28;
  border-bottom: 1px solid #E94C39;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover {
  background: #EF796A;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] .main-wrapper::before {
  content: "";
  background: #e85b28;
}

[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header {
  left: 0;
  background-color: #080821;
  border-color: #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar {
  background-color: #080821;
  border-bottom: 1px solid #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] .main-wrapper::before {
  content: "";
  background: #080821;
}

[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header {
  left: 0;
  background-color: #710034;
  border-color: rgb(117.59, 0, 54.1122123894);
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar {
  background-color: #710034;
  border-bottom: 1px solid rgb(117.59, 0, 54.1122123894);
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] .main-wrapper::before {
  content: "";
  background: #710034;
}

[data-layout=horizontal-overlay][data-topbarcolor=white] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header {
  left: 0;
  background-color: #FFF;
  border-color: white;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .dark-logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .mode-toggle {
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar {
  background-color: #FFF;
  border-bottom: 1px solid white;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] .main-wrapper::before {
  content: "";
  background: #FFF;
}

[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header {
  left: 0;
  background-color: #3E1C95;
  border-color: rgb(63.6077966102, 28.7261016949, 152.8638983051);
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar {
  background-color: #3E1C95;
  border-bottom: 1px solid rgb(63.6077966102, 28.7261016949, 152.8638983051);
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] .main-wrapper::before {
  content: "";
  background: #3E1C95;
}

[data-layout=horizontal-overlay][data-topbarcolor=all] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header {
  left: 0;
  background-color: rgb(var(--topbarcolor-rgb));
  background-color: rgb(var(--topbarcolor--rgb-picr));
  border-color: rgb(var(--topbarcolor-rgb));
  border-color: rgb(var(--topbarcolor--rgb-picr));
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-user .user-menu .btn-menubar:hover {
  background: #E8E9EA;
  color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar {
  background-color: rgb(var(--topbarcolor-rgb));
  background-color: rgb(var(--topbarcolor--rgb-picr));
  border-bottom: 1px solid rgb(var(--topbarcolor-rgb));
  border-bottom: 1px solid rgb(var(--topbarcolor--rgb-picr));
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #E8E9EA;
  color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #262A2A;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=all] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=all] .main-wrapper::before {
  content: "";
  background: rgb(var(--topbarcolor-rgb));
  background: rgb(var(--topbarcolor--rgb-picr));
}

[data-sidebarbg=sidebarbg1] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg1] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header {
  left: 0;
  background-color: #053333;
  border-color: #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-left,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-left {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-left .logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-left .logo {
  display: none;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .header .header-left .dark-logo,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .header .header-left .dark-logo {
  display: block;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .mode-toggle,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .mode-toggle {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar {
  background-color: #053333;
  border-bottom: 1px solid #323737;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background: #565E5E;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #424848;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] .main-wrapper::before {
  content: "";
  background: #053333;
}

[data-sidebarbg=sidebarbg1] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg1] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

[data-sidebarbg=sidebarbg2] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg2] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg3] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg3] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg4] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg4] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg5] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg5] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

[data-sidebarbg=sidebarbg6] #sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebarbg=sidebarbg6] #sidebar::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

[data-sidebar=light] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=light] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=darkgreen] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(17, 25, 38, 0.85);
}

[data-sidebar=nightblue] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=nightblue] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(15, 15, 65, 0.85);
}

[data-sidebar=darkgray] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=darkgray] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(46, 46, 72, 0.85);
}

[data-sidebar=royalblue] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=royalblue] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(0, 57, 198, 0.85);
}

[data-sidebar=indigo] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=indigo] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(57, 22, 148, 0.85);
}

[data-sidebar=all] [data-sidebarbg=sidebarbg1] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg2] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg3] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg4] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg5] #sidebar::before,
[data-sidebar=all] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(var(--sidebar-rgb), 0.85);
  background: rgba(var(--sidebar--rgb-picr), 0.85);
}

[data-layout=horizontal-overlay] [data-topbarbg=pattern1] .main-wrapper::after,
[data-layout=horizontal-sidemenu] [data-topbarbg=pattern1] .main-wrapper::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

[data-layout=horizontal-overlay] [data-topbarbg=pattern2] .main-wrapper::after,
[data-layout=horizontal-sidemenu] [data-topbarbg=pattern2] .main-wrapper::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

[data-layout=horizontal-overlay] [data-topbarbg=pattern3] .main-wrapper::after,
[data-layout=horizontal-sidemenu] [data-topbarbg=pattern3] .main-wrapper::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

[data-layout=horizontal-overlay][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(113, 0, 52, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=maroon] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(255, 255, 255, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=white] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(232, 91, 40, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=primary] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(8, 8, 33, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=blackpearl] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(62, 28, 149, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=bluegem] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=horizontal-overlay][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper::before,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper::before {
  background: rgba(5, 51, 51, 0.85);
  z-index: 1;
}
[data-layout=horizontal-overlay][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper .page-wrapper,
[data-layout=horizontal-sidemenu][data-topbarcolor=firefly] [data-topbarbg=pattern3] .main-wrapper .page-wrapper {
  z-index: 2;
}

[data-layout=modern][data-topbarcolor=white] .header {
  background-color: #FFF;
  border-color: rgba(255, 255, 255, 0.8);
}
[data-layout=modern][data-topbarcolor=white] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar.active {
  background-color: #E8E9EA;
  border-color: #E8E9EA;
  color: #262A2A !important;
}
[data-layout=modern][data-topbarcolor=white] .header .header-left .logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=white] .header .header-left .dark-logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=white] .page-wrapper::before {
  background: #FFF;
}
[data-layout=modern][data-topbarcolor=white] .page-wrapper .head-icons {
  display: none;
}

[data-layout=modern][data-topbarcolor=blue] .header {
  background-color: #FFF;
  border-color: rgba(255, 255, 255, 0.8);
}
[data-layout=modern][data-topbarcolor=blue] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar {
  color: #6F7A7A;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=blue] .header .header-user .user-menu .btn-menubar.active {
  background-color: #E8E9EA;
  border-color: #E8E9EA;
  color: #262A2A !important;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=blue] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=blue] .page-wrapper::before {
  background: #FFF;
}

[data-layout=modern][data-topbarcolor=primary] .header {
  background-color: #e85b28;
  border-color: #E94C39;
}
[data-layout=modern][data-topbarcolor=primary] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=primary] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=primary] .page-wrapper::before {
  background: #e85b28;
}

[data-layout=modern][data-topbarcolor=blackpearl] .header {
  background-color: #080821;
  border-color: rgba(8, 8, 33, 0.8);
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=blackpearl] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=blackpearl] .page-wrapper::before {
  background: #080821;
}

[data-layout=modern][data-topbarcolor=maroon] .header {
  background-color: #710034;
  border-color: rgba(113, 0, 52, 0.8);
}
[data-layout=modern][data-topbarcolor=maroon] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=maroon] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=maroon] .page-wrapper::before {
  background: #710034;
}

[data-layout=modern][data-topbarcolor=bluegem] .header {
  background-color: #3E1C95;
  border-color: rgba(62, 28, 149, 0.8);
}
[data-layout=modern][data-topbarcolor=bluegem] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=bluegem] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=bluegem] .page-wrapper::before {
  background: #3E1C95;
}

[data-layout=modern][data-topbarcolor=firefly] .header {
  background-color: #053333;
  border-color: rgba(5, 51, 51, 0.8);
}
[data-layout=modern][data-topbarcolor=firefly] .header .bar-icon span {
  background-color: #FFF;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar {
  color: #FFF;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover, [data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:active, [data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar.active {
  background-color: #FFF;
  color: #424848 !important;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-left .logo {
  display: none;
}
[data-layout=modern][data-topbarcolor=firefly] .header .header-left .dark-logo {
  display: block;
}
[data-layout=modern][data-topbarcolor=firefly] .page-wrapper::before {
  background: #053333;
}

[data-card=borderless] .card {
  border: 0 !important;
  box-shadow: none;
}

[data-card=shadow] .card {
  border: 0 !important;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}

[data-color=primary] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #e85b28;
  border-bottom: 2px solid #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-color=primary] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=primary] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #e85b28;
}
[data-color=primary] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=primary] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #e85b28;
}
[data-color=primary] .btn.btn-primary {
  background-color: #e85b28;
  border: 1px solid #e85b28;
}
[data-color=primary] .btn.btn-primary:hover, [data-color=primary] .btn.btn-primary:focus, [data-color=primary] .btn.btn-primary.focus, [data-color=primary] .btn.btn-primary:active, [data-color=primary] .btn.btn-primary.active {
  background-color: rgb(213.4642857143, 73.4714285714, 22.8357142857);
  border: 1px solid rgb(213.4642857143, 73.4714285714, 22.8357142857);
}
[data-color=primary] .btn-check:checked + .btn, [data-color=primary] .btn.active, [data-color=primary] .btn.show, [data-color=primary] .btn.show:hover, [data-color=primary] .btn:first-child:active, [data-color=primary] :not(.btn-check) + .btn:active {
  background-color: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .link-primary {
  color: #e85b28 !important;
}
[data-color=primary] .link-primary:hover, [data-color=primary] .link-primary:focus, [data-color=primary] .link-primary:active {
  color: rgb(213.4642857143, 73.4714285714, 22.8357142857);
}
[data-color=primary] .text-primary {
  color: #e85b28 !important;
}
[data-color=primary] .badge.badge-primary {
  background: #e85b28;
}
[data-color=primary] .dataTables_paginate .pagination li.active a.page-link {
  background: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .bg-primary {
  background-color: #e85b28 !important;
  border: 1px solid #e85b28 !important;
}
[data-color=primary] .border-bottom.border-primary {
  border-color: #e85b28 !important;
}
[data-color=primary] .border-primary {
  border-color: #e85b28 !important;
}
[data-color=primary] .nav-tabs.nav-tabs-bottom li a.active, [data-color=primary] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #e85b28;
  color: #e85b28;
}
[data-color=primary] .badge.badge-soft-primary {
  background: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}
[data-color=primary] a:hover {
  color: #e85b28;
}
[data-color=primary] a.video-expand:hover {
  color: #FFF;
}
[data-color=primary] .btn-outline-primary {
  border: 1px solid #e85b28 !important;
  color: #e85b28 !important;
}
[data-color=primary] .btn-outline-primary:hover, [data-color=primary] .btn-outline-primary:focus, [data-color=primary] .btn-outline-primary.focus, [data-color=primary] .btn-outline-primary:active, [data-color=primary] .btn-outline-primary.active {
  background-color: #e85b28 !important;
  border: 1px solid #e85b28 !important;
  color: #FFF !important;
}
[data-color=primary] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #e85b28;
}
[data-color=primary] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #e85b28;
}
[data-color=primary] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .nav-tabs .nav-link:hover {
  color: #e85b28;
}
[data-color=primary] .form-check-input:checked {
  background-color: #e85b28;
  border-color: #e85b28;
}
[data-color=primary] .sidebar-contact .toggle-theme {
  background-color: #e85b28;
}
@media (max-width: 991.98px) {
  [data-color=primary] .sidebar-contact .toggle-theme {
    display: none;
  }
}
[data-color=primary] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #e85b28;
}
[data-color=primary] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=primary] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #e85b28;
}
[data-color=primary] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=primary] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=primary] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=primary] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #e85b28;
}
[data-color=primary] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=primary] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=primary] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #e85b28;
}
[data-color=primary] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #e85b28;
}
[data-color=primary] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #e85b28;
}
[data-color=primary] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=primary] #chart-bar .c3-target-data2 .c3-bar, [data-color=primary] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #e85b28 !important;
}
[data-color=primary] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #e85b28 !important;
}
[data-color=primary] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #e85b28;
}
[data-color=primary] .nav.tab-style-1 .nav-link.active {
  background-color: #e85b28 !important;
}
[data-color=primary] .table tbody tr td a:hover {
  color: #e85b28;
}
[data-color=primary] .view-icons a.active, [data-color=primary] .view-icons a:hover {
  background: #e85b28;
  color: #FFF;
}

[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=brightblue] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #4680FF;
  border-bottom: 2px solid #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=brightblue] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar .nav-link.active {
  color: #4680FF;
}
[data-color=brightblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=brightblue] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #4680FF;
}
[data-color=brightblue] .btn.btn-primary {
  background-color: #4680FF;
  border: 1px solid #4680FF;
}
[data-color=brightblue] .btn.btn-primary:hover, [data-color=brightblue] .btn.btn-primary:focus, [data-color=brightblue] .btn.btn-primary.focus, [data-color=brightblue] .btn.btn-primary:active, [data-color=brightblue] .btn.btn-primary.active {
  background-color: rgb(34.3, 103.4924324324, 255);
  border: 1px solid rgb(34.3, 103.4924324324, 255);
}
[data-color=brightblue] .btn-check:checked + .btn, [data-color=brightblue] .btn.active, [data-color=brightblue] .btn.show, [data-color=brightblue] .btn.show:hover, [data-color=brightblue] .btn:first-child:active, [data-color=brightblue] :not(.btn-check) + .btn:active {
  background-color: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .link-primary {
  color: #4680FF !important;
}
[data-color=brightblue] .link-primary:hover, [data-color=brightblue] .link-primary:focus, [data-color=brightblue] .link-primary:active {
  color: rgb(34.3, 103.4924324324, 255);
}
[data-color=brightblue] .text-primary {
  color: #4680FF !important;
}
[data-color=brightblue] .badge.badge-primary {
  background: #4680FF;
}
[data-color=brightblue] .dataTables_paginate .pagination li.active a.page-link {
  background: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .bg-primary {
  background-color: #4680FF !important;
  border: 1px solid #4680FF !important;
}
[data-color=brightblue] .border-bottom.border-primary {
  border-color: #4680FF !important;
}
[data-color=brightblue] .border-primary {
  border-color: #4680FF !important;
}
[data-color=brightblue] .nav-tabs.nav-tabs-bottom li a.active, [data-color=brightblue] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #4680FF;
  color: #4680FF;
}
[data-color=brightblue] .badge.badge-soft-primary {
  background: rgba(70, 128, 255, 0.1);
  color: #4680FF;
}
[data-color=brightblue] a:hover {
  color: #4680FF;
}
[data-color=brightblue] .btn-outline-primary {
  border: 1px solid #4680FF !important;
  color: #4680FF !important;
}
[data-color=brightblue] .btn-outline-primary:hover, [data-color=brightblue] .btn-outline-primary:focus, [data-color=brightblue] .btn-outline-primary.focus, [data-color=brightblue] .btn-outline-primary:active, [data-color=brightblue] .btn-outline-primary.active {
  background-color: #4680FF !important;
  border: 1px solid #4680FF !important;
}
[data-color=brightblue] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #4680FF;
}
[data-color=brightblue] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #4680FF;
}
[data-color=brightblue] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .nav-tabs .nav-link:hover {
  color: #4680FF;
}
[data-color=brightblue] .form-check-input:checked {
  background-color: #4680FF;
  border-color: #4680FF;
}
[data-color=brightblue] .sidebar-contact .toggle-theme {
  background-color: #4680FF;
}
[data-color=brightblue] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #4680FF;
}
[data-color=brightblue] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=brightblue] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #4680FF;
}
[data-color=brightblue] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=brightblue] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=brightblue] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=brightblue] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #4680FF;
}
[data-color=brightblue] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=brightblue] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=brightblue] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #4680FF;
}
[data-color=brightblue] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #4680FF;
}
[data-color=brightblue] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #4680FF;
}
[data-color=brightblue] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=brightblue] #chart-bar .c3-target-data2 .c3-bar, [data-color=brightblue] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #4680FF !important;
}
[data-color=brightblue] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #4680FF !important;
}
[data-color=brightblue] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #4680FF;
}
[data-color=brightblue] .nav.tab-style-1 .nav-link.active {
  background-color: #4680FF !important;
}
[data-color=brightblue] .table tbody tr td a:hover {
  color: #4680FF;
}
[data-color=brightblue] .view-icons a.active, [data-color=brightblue] .view-icons a:hover {
  background: #4680FF;
  color: #FFF;
}

[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #365E32;
  border-bottom: 2px solid #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=lunargreen] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar .nav-link.active {
  color: #365E32;
}
[data-color=lunargreen] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=lunargreen] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #365E32;
}
[data-color=lunargreen] .btn.btn-primary {
  background-color: #365E32;
  border: 1px solid #365E32;
}
[data-color=lunargreen] .btn.btn-primary:hover, [data-color=lunargreen] .btn.btn-primary:focus, [data-color=lunargreen] .btn.btn-primary.focus, [data-color=lunargreen] .btn.btn-primary:active, [data-color=lunargreen] .btn.btn-primary.active {
  background-color: rgb(40.6125, 70.6958333333, 37.6041666667);
  border: 1px solid rgb(40.6125, 70.6958333333, 37.6041666667);
}
[data-color=lunargreen] .btn-check:checked + .btn, [data-color=lunargreen] .btn.active, [data-color=lunargreen] .btn.show, [data-color=lunargreen] .btn.show:hover, [data-color=lunargreen] .btn:first-child:active, [data-color=lunargreen] :not(.btn-check) + .btn:active {
  background-color: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .link-primary {
  color: #365E32 !important;
}
[data-color=lunargreen] .link-primary:hover, [data-color=lunargreen] .link-primary:focus, [data-color=lunargreen] .link-primary:active {
  color: rgb(40.6125, 70.6958333333, 37.6041666667);
}
[data-color=lunargreen] .text-primary {
  color: #365E32 !important;
}
[data-color=lunargreen] .badge.badge-primary {
  background: #365E32;
}
[data-color=lunargreen] .dataTables_paginate .pagination li.active a.page-link {
  background: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .bg-primary {
  background-color: #365E32 !important;
  border: 1px solid #365E32 !important;
}
[data-color=lunargreen] .border-bottom.border-primary {
  border-color: #365E32 !important;
}
[data-color=lunargreen] .border-primary {
  border-color: #365E32 !important;
}
[data-color=lunargreen] .nav-tabs.nav-tabs-bottom li a.active, [data-color=lunargreen] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #365E32;
  color: #365E32;
}
[data-color=lunargreen] .badge.badge-soft-primary {
  background: rgba(54, 94, 50, 0.1);
  color: #365E32;
}
[data-color=lunargreen] a:hover {
  color: #365E32;
}
[data-color=lunargreen] .btn-outline-primary {
  border: 1px solid #365E32 !important;
  color: #365E32 !important;
}
[data-color=lunargreen] .btn-outline-primary:hover, [data-color=lunargreen] .btn-outline-primary:focus, [data-color=lunargreen] .btn-outline-primary.focus, [data-color=lunargreen] .btn-outline-primary:active, [data-color=lunargreen] .btn-outline-primary.active {
  background-color: #365E32 !important;
  border: 1px solid #365E32 !important;
}
[data-color=lunargreen] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #365E32;
}
[data-color=lunargreen] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #365E32;
}
[data-color=lunargreen] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .nav-tabs .nav-link:hover {
  color: #365E32;
}
[data-color=lunargreen] .form-check-input:checked {
  background-color: #365E32;
  border-color: #365E32;
}
[data-color=lunargreen] .sidebar-contact .toggle-theme {
  background-color: #365E32;
}
[data-color=lunargreen] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #365E32;
}
[data-color=lunargreen] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lunargreen] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #365E32;
}
[data-color=lunargreen] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=lunargreen] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=lunargreen] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=lunargreen] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #365E32;
}
[data-color=lunargreen] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lunargreen] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lunargreen] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #365E32;
}
[data-color=lunargreen] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #365E32;
}
[data-color=lunargreen] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #365E32;
}
[data-color=lunargreen] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=lunargreen] #chart-bar .c3-target-data2 .c3-bar, [data-color=lunargreen] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #365E32 !important;
}
[data-color=lunargreen] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #365E32 !important;
}
[data-color=lunargreen] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #365E32;
}
[data-color=lunargreen] .nav.tab-style-1 .nav-link.active {
  background-color: #365E32 !important;
}
[data-color=lunargreen] .table tbody tr td a:hover {
  color: #365E32;
}
[data-color=lunargreen] .view-icons a.active, [data-color=lunargreen] .view-icons a:hover {
  background: #365E32;
  color: #FFF;
}

[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=lavendar] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #673AB7;
  border-bottom: 2px solid #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=lavendar] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar .nav-link.active {
  color: #673AB7;
}
[data-color=lavendar] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=lavendar] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #673AB7;
}
[data-color=lavendar] .btn.btn-primary {
  background-color: #673AB7;
  border: 1px solid #673AB7;
}
[data-color=lavendar] .btn.btn-primary:hover, [data-color=lavendar] .btn.btn-primary:focus, [data-color=lavendar] .btn.btn-primary.focus, [data-color=lavendar] .btn.btn-primary:active, [data-color=lavendar] .btn.btn-primary.active {
  background-color: rgb(87.7423236515, 49.4082987552, 155.8917012448);
  border: 1px solid rgb(87.7423236515, 49.4082987552, 155.8917012448);
}
[data-color=lavendar] .btn-check:checked + .btn, [data-color=lavendar] .btn.active, [data-color=lavendar] .btn.show, [data-color=lavendar] .btn.show:hover, [data-color=lavendar] .btn:first-child:active, [data-color=lavendar] :not(.btn-check) + .btn:active {
  background-color: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .link-primary {
  color: #673AB7 !important;
}
[data-color=lavendar] .link-primary:hover, [data-color=lavendar] .link-primary:focus, [data-color=lavendar] .link-primary:active {
  color: rgb(87.7423236515, 49.4082987552, 155.8917012448);
}
[data-color=lavendar] .text-primary {
  color: #673AB7 !important;
}
[data-color=lavendar] .badge.badge-primary {
  background: #673AB7;
}
[data-color=lavendar] .dataTables_paginate .pagination li.active a.page-link {
  background: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .bg-primary {
  background-color: #673AB7 !important;
  border: 1px solid #673AB7 !important;
}
[data-color=lavendar] .border-bottom.border-primary {
  border-color: #673AB7 !important;
}
[data-color=lavendar] .border-primary {
  border-color: #673AB7 !important;
}
[data-color=lavendar] .nav-tabs.nav-tabs-bottom li a.active, [data-color=lavendar] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #673AB7;
  color: #673AB7;
}
[data-color=lavendar] .badge.badge-soft-primary {
  background: rgba(103, 58, 183, 0.1);
  color: #673AB7;
}
[data-color=lavendar] a:hover {
  color: #673AB7;
}
[data-color=lavendar] .btn-outline-primary {
  border: 1px solid #673AB7 !important;
  color: #673AB7 !important;
}
[data-color=lavendar] .btn-outline-primary:hover, [data-color=lavendar] .btn-outline-primary:focus, [data-color=lavendar] .btn-outline-primary.focus, [data-color=lavendar] .btn-outline-primary:active, [data-color=lavendar] .btn-outline-primary.active {
  background-color: #673AB7 !important;
  border: 1px solid #673AB7 !important;
}
[data-color=lavendar] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #673AB7;
}
[data-color=lavendar] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #673AB7;
}
[data-color=lavendar] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .nav-tabs .nav-link:hover {
  color: #673AB7;
}
[data-color=lavendar] .form-check-input:checked {
  background-color: #673AB7;
  border-color: #673AB7;
}
[data-color=lavendar] .sidebar-contact .toggle-theme {
  background-color: #673AB7;
}
[data-color=lavendar] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #673AB7;
}
[data-color=lavendar] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavendar] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #673AB7;
}
[data-color=lavendar] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=lavendar] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=lavendar] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=lavendar] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #673AB7;
}
[data-color=lavendar] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavendar] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavendar] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #673AB7;
}
[data-color=lavendar] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #673AB7;
}
[data-color=lavendar] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #673AB7;
}
[data-color=lavendar] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=lavendar] #chart-bar .c3-target-data2 .c3-bar, [data-color=lavendar] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #673AB7 !important;
}
[data-color=lavendar] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #673AB7 !important;
}
[data-color=lavendar] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #673AB7;
}
[data-color=lavendar] .nav.tab-style-1 .nav-link.active {
  background-color: #673AB7 !important;
}
[data-color=lavendar] .table tbody tr td a:hover {
  color: #673AB7;
}
[data-color=lavendar] .view-icons a.active, [data-color=lavendar] .view-icons a:hover {
  background: #673AB7;
  color: #FFF;
}

[data-color=magenta] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=magenta] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #E83E8C;
  border-bottom: 2px solid #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=magenta] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar .nav-link.active {
  color: #E83E8C;
}
[data-color=magenta] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=magenta] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #E83E8C;
}
[data-color=magenta] .btn.btn-primary {
  background-color: #E83E8C;
  border: 1px solid #E83E8C;
}
[data-color=magenta] .btn.btn-primary:hover, [data-color=magenta] .btn.btn-primary:focus, [data-color=magenta] .btn.btn-primary.focus, [data-color=magenta] .btn.btn-primary:active, [data-color=magenta] .btn.btn-primary.active {
  background-color: rgb(228.1986111111, 30.1013888889, 120.9930555556);
  border: 1px solid rgb(228.1986111111, 30.1013888889, 120.9930555556);
}
[data-color=magenta] .btn-check:checked + .btn, [data-color=magenta] .btn.active, [data-color=magenta] .btn.show, [data-color=magenta] .btn.show:hover, [data-color=magenta] .btn:first-child:active, [data-color=magenta] :not(.btn-check) + .btn:active {
  background-color: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .link-primary {
  color: #E83E8C !important;
}
[data-color=magenta] .link-primary:hover, [data-color=magenta] .link-primary:focus, [data-color=magenta] .link-primary:active {
  color: rgb(228.1986111111, 30.1013888889, 120.9930555556);
}
[data-color=magenta] .text-primary {
  color: #E83E8C !important;
}
[data-color=magenta] .badge.badge-primary {
  background: #E83E8C;
}
[data-color=magenta] .dataTables_paginate .pagination li.active a.page-link {
  background: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .bg-primary {
  background-color: #E83E8C !important;
  border: 1px solid #E83E8C !important;
}
[data-color=magenta] .border-bottom.border-primary {
  border-color: #E83E8C !important;
}
[data-color=magenta] .border-primary {
  border-color: #E83E8C !important;
}
[data-color=magenta] .nav-tabs.nav-tabs-bottom li a.active, [data-color=magenta] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #E83E8C;
  color: #E83E8C;
}
[data-color=magenta] .badge.badge-soft-primary {
  background: rgba(232, 62, 140, 0.1);
  color: #E83E8C;
}
[data-color=magenta] a:hover {
  color: #E83E8C;
}
[data-color=magenta] .btn-outline-primary {
  border: 1px solid #E83E8C !important;
  color: #E83E8C !important;
}
[data-color=magenta] .btn-outline-primary:hover, [data-color=magenta] .btn-outline-primary:focus, [data-color=magenta] .btn-outline-primary.focus, [data-color=magenta] .btn-outline-primary:active, [data-color=magenta] .btn-outline-primary.active {
  background-color: #E83E8C !important;
  border: 1px solid #E83E8C !important;
}
[data-color=magenta] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #E83E8C;
}
[data-color=magenta] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #E83E8C;
}
[data-color=magenta] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .nav-tabs .nav-link:hover {
  color: #E83E8C;
}
[data-color=magenta] .form-check-input:checked {
  background-color: #E83E8C;
  border-color: #E83E8C;
}
[data-color=magenta] .sidebar-contact .toggle-theme {
  background-color: #E83E8C;
}
[data-color=magenta] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #E83E8C;
}
[data-color=magenta] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=magenta] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #E83E8C;
}
[data-color=magenta] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=magenta] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=magenta] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=magenta] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #E83E8C;
}
[data-color=magenta] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=magenta] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=magenta] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #E83E8C;
}
[data-color=magenta] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #E83E8C;
}
[data-color=magenta] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #E83E8C;
}
[data-color=magenta] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=magenta] #chart-bar .c3-target-data2 .c3-bar, [data-color=magenta] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #E83E8C !important;
}
[data-color=magenta] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #E83E8C !important;
}
[data-color=magenta] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #E83E8C;
}
[data-color=magenta] .nav.tab-style-1 .nav-link.active {
  background-color: #E83E8C !important;
}
[data-color=magenta] .table tbody tr td a:hover {
  color: #E83E8C;
}
[data-color=magenta] .view-icons a.active, [data-color=magenta] .view-icons a:hover {
  background: #E83E8C;
  color: #FFF;
}

[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #FF9B04;
  border-bottom: 2px solid #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=chromeyellow] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar .nav-link.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=chromeyellow] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #FF9B04;
}
[data-color=chromeyellow] .btn.btn-primary {
  background-color: #FF9B04;
  border: 1px solid #FF9B04;
}
[data-color=chromeyellow] .btn.btn-primary:hover, [data-color=chromeyellow] .btn.btn-primary:focus, [data-color=chromeyellow] .btn.btn-primary.focus, [data-color=chromeyellow] .btn.btn-primary:active, [data-color=chromeyellow] .btn.btn-primary.active {
  background-color: rgb(223.3, 134.3358565737, 0);
  border: 1px solid rgb(223.3, 134.3358565737, 0);
}
[data-color=chromeyellow] .btn-check:checked + .btn, [data-color=chromeyellow] .btn.active, [data-color=chromeyellow] .btn.show, [data-color=chromeyellow] .btn.show:hover, [data-color=chromeyellow] .btn:first-child:active, [data-color=chromeyellow] :not(.btn-check) + .btn:active {
  background-color: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .link-primary {
  color: #FF9B04 !important;
}
[data-color=chromeyellow] .link-primary:hover, [data-color=chromeyellow] .link-primary:focus, [data-color=chromeyellow] .link-primary:active {
  color: rgb(223.3, 134.3358565737, 0);
}
[data-color=chromeyellow] .text-primary {
  color: #FF9B04 !important;
}
[data-color=chromeyellow] .badge.badge-primary {
  background: #FF9B04;
}
[data-color=chromeyellow] .dataTables_paginate .pagination li.active a.page-link {
  background: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .bg-primary {
  background-color: #FF9B04 !important;
  border: 1px solid #FF9B04 !important;
}
[data-color=chromeyellow] .border-bottom.border-primary {
  border-color: #FF9B04 !important;
}
[data-color=chromeyellow] .border-primary {
  border-color: #FF9B04 !important;
}
[data-color=chromeyellow] .nav-tabs.nav-tabs-bottom li a.active, [data-color=chromeyellow] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #FF9B04;
  color: #FF9B04;
}
[data-color=chromeyellow] .badge.badge-soft-primary {
  background: rgba(255, 155, 4, 0.1);
  color: #FF9B04;
}
[data-color=chromeyellow] a:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .btn-outline-primary {
  border: 1px solid #FF9B04 !important;
  color: #FF9B04 !important;
}
[data-color=chromeyellow] .btn-outline-primary:hover, [data-color=chromeyellow] .btn-outline-primary:focus, [data-color=chromeyellow] .btn-outline-primary.focus, [data-color=chromeyellow] .btn-outline-primary:active, [data-color=chromeyellow] .btn-outline-primary.active {
  background-color: #FF9B04 !important;
  border: 1px solid #FF9B04 !important;
}
[data-color=chromeyellow] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #FF9B04;
}
[data-color=chromeyellow] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #FF9B04;
}
[data-color=chromeyellow] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .nav-tabs .nav-link:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .form-check-input:checked {
  background-color: #FF9B04;
  border-color: #FF9B04;
}
[data-color=chromeyellow] .sidebar-contact .toggle-theme {
  background-color: #FF9B04;
}
[data-color=chromeyellow] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=chromeyellow] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #FF9B04;
}
[data-color=chromeyellow] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=chromeyellow] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=chromeyellow] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=chromeyellow] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #FF9B04;
}
[data-color=chromeyellow] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=chromeyellow] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=chromeyellow] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #FF9B04;
}
[data-color=chromeyellow] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #FF9B04;
}
[data-color=chromeyellow] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #FF9B04;
}
[data-color=chromeyellow] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=chromeyellow] #chart-bar .c3-target-data2 .c3-bar, [data-color=chromeyellow] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #FF9B04 !important;
}
[data-color=chromeyellow] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #FF9B04 !important;
}
[data-color=chromeyellow] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #FF9B04;
}
[data-color=chromeyellow] .nav.tab-style-1 .nav-link.active {
  background-color: #FF9B04 !important;
}
[data-color=chromeyellow] .table tbody tr td a:hover {
  color: #FF9B04;
}
[data-color=chromeyellow] .view-icons a.active, [data-color=chromeyellow] .view-icons a:hover {
  background: #FF9B04;
  color: #FFF;
}

[data-color=lavared] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=lavared] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #DC2626;
  border-bottom: 2px solid #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #DC2626;
}
[data-color=lavared] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=lavared] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar .nav-link.active {
  color: #DC2626;
}
[data-color=lavared] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=lavared] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #DC2626;
}
[data-color=lavared] .btn.btn-primary {
  background-color: #DC2626;
  border: 1px solid #DC2626;
}
[data-color=lavared] .btn.btn-primary:hover, [data-color=lavared] .btn.btn-primary:focus, [data-color=lavared] .btn.btn-primary.focus, [data-color=lavared] .btn.btn-primary:active, [data-color=lavared] .btn.btn-primary.active {
  background-color: rgb(191.425, 30.875, 30.875);
  border: 1px solid rgb(191.425, 30.875, 30.875);
}
[data-color=lavared] .btn-check:checked + .btn, [data-color=lavared] .btn.active, [data-color=lavared] .btn.show, [data-color=lavared] .btn.show:hover, [data-color=lavared] .btn:first-child:active, [data-color=lavared] :not(.btn-check) + .btn:active {
  background-color: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .link-primary {
  color: #DC2626 !important;
}
[data-color=lavared] .link-primary:hover, [data-color=lavared] .link-primary:focus, [data-color=lavared] .link-primary:active {
  color: rgb(191.425, 30.875, 30.875);
}
[data-color=lavared] .text-primary {
  color: #DC2626 !important;
}
[data-color=lavared] .badge.badge-primary {
  background: #DC2626;
}
[data-color=lavared] .dataTables_paginate .pagination li.active a.page-link {
  background: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .bg-primary {
  background-color: #DC2626 !important;
  border: 1px solid #DC2626 !important;
}
[data-color=lavared] .border-bottom.border-primary {
  border-color: #DC2626 !important;
}
[data-color=lavared] .border-primary {
  border-color: #DC2626 !important;
}
[data-color=lavared] .nav-tabs.nav-tabs-bottom li a.active, [data-color=lavared] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #DC2626;
  color: #DC2626;
}
[data-color=lavared] .badge.badge-soft-primary {
  background: rgba(220, 38, 38, 0.1);
  color: #DC2626;
}
[data-color=lavared] a:hover {
  color: #DC2626;
}
[data-color=lavared] .btn-outline-primary {
  border: 1px solid #DC2626 !important;
  color: #DC2626 !important;
}
[data-color=lavared] .btn-outline-primary:hover, [data-color=lavared] .btn-outline-primary:focus, [data-color=lavared] .btn-outline-primary.focus, [data-color=lavared] .btn-outline-primary:active, [data-color=lavared] .btn-outline-primary.active {
  background-color: #DC2626 !important;
  border: 1px solid #DC2626 !important;
}
[data-color=lavared] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: #DC2626;
}
[data-color=lavared] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #DC2626;
}
[data-color=lavared] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .nav-tabs .nav-link:hover {
  color: #DC2626;
}
[data-color=lavared] .form-check-input:checked {
  background-color: #DC2626;
  border-color: #DC2626;
}
[data-color=lavared] .sidebar-contact .toggle-theme {
  background-color: #DC2626;
}
[data-color=lavared] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: #DC2626;
}
[data-color=lavared] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=lavared] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: #DC2626;
}
[data-color=lavared] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=lavared] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=lavared] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=lavared] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: #DC2626;
}
[data-color=lavared] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavared] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=lavared] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: #DC2626;
}
[data-color=lavared] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: #DC2626;
}
[data-color=lavared] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: #DC2626;
}
[data-color=lavared] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=lavared] #chart-bar .c3-target-data2 .c3-bar, [data-color=lavared] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: #DC2626 !important;
}
[data-color=lavared] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: #DC2626 !important;
}
[data-color=lavared] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: #DC2626;
}
[data-color=lavared] .nav.tab-style-1 .nav-link.active {
  background-color: #DC2626 !important;
}
[data-color=lavared] .table tbody tr td a:hover {
  color: #DC2626;
}
[data-color=lavared] .view-icons a.active, [data-color=lavared] .view-icons a:hover {
  background: #DC2626;
  color: #FFF;
}

[data-color=all] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul li.active a span, [data-color=all] .sidebar .sidebar-menu > ul > li ul li.active a i {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid rgba(var(--primary-rgb), 1);
  border-right: 2px solid rgba(var(--primary-rgb-picr), 1);
  border-bottom: 2px solid rgba(var(--primary-rgb), 1);
  border-bottom: 2px solid rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-color=all] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar .nav-link.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-color=all] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .btn.btn-primary {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border: 1px solid rgba(var(--primary-rgb), 1);
  border: 1px solid rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .btn.btn-primary:hover, [data-color=all] .btn.btn-primary:focus, [data-color=all] .btn.btn-primary.focus, [data-color=all] .btn.btn-primary:active, [data-color=all] .btn.btn-primary.active {
  background-color: rgba(var(--primary-rgb), 2);
  background-color: rgba(var(--primary-rgb-picr), 2);
  border: 1px solid rgba(var(--primary-rgb), 2);
  border: 1px solid rgba(var(--primary-rgb-picr), 2);
}
[data-color=all] .btn-check:checked + .btn, [data-color=all] .btn.active, [data-color=all] .btn.show, [data-color=all] .btn.show:hover, [data-color=all] .btn:first-child:active, [data-color=all] :not(.btn-check) + .btn:active {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .link-primary {
  color: rgba(var(--primary-rgb), 1) !important;
  color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .link-primary:hover, [data-color=all] .link-primary:focus, [data-color=all] .link-primary:active {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .text-primary {
  color: rgba(var(--primary-rgb), 1) !important;
  color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .badge.badge-primary {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .dataTables_paginate .pagination li.active a.page-link {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .bg-primary {
  background-color: rgba(var(--primary-rgb), 1) !important;
  background-color: rgba(var(--primary-rgb-picr), 1) !important;
  border: 1px solid rgba(var(--primary-rgb), 1) !important;
  border: 1px solid rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .border-bottom.border-primary {
  border-color: rgba(var(--primary-rgb), 1) !important;
  border-color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .border-primary {
  border-color: rgba(var(--primary-rgb), 1) !important;
  border-color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .nav-tabs.nav-tabs-bottom li a.active, [data-color=all] .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: rgba(var(--primary-rgb), 1);
  border-bottom-color: rgba(var(--primary-rgb-picr), 1);
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .badge.badge-soft-primary {
  background: rgba(var(--primary-rgb), 0.1);
  background: rgba(var(--primary-rgb-picr), 0.1);
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] a:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .btn-outline-primary {
  border: 1px solid rgba(var(--primary-rgb), 1) !important;
  border: 1px solid rgba(var(--primary-rgb-picr), 1) !important;
  color: rgba(var(--primary-rgb), 1) !important;
  color: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .btn-outline-primary:hover, [data-color=all] .btn-outline-primary:focus, [data-color=all] .btn-outline-primary.focus, [data-color=all] .btn-outline-primary:active, [data-color=all] .btn-outline-primary.active {
  background-color: rgba(var(--primary-rgb), 1) !important;
  background-color: rgba(var(--primary-rgb-picr), 1) !important;
  border: 1px solid rgba(var(--primary-rgb), 1) !important;
  border: 1px solid rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a.active {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .nav-tabs .nav-link:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .form-check-input:checked {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
  border-color: rgba(var(--primary-rgb), 1);
  border-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .sidebar-contact .toggle-theme {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .header .header-user .user-menu .profile-dropdown .dropdown-item:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #sales-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #revenue-income .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #leads_stage .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #s-col .apexcharts-bar-series .apexcharts-series:nth-child(1) path, [data-color=all] #s-col-stacked .apexcharts-bar-series .apexcharts-series:nth-child(1) path {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #deals_stage .apexcharts-bar-series .apexcharts-series path, [data-color=all] #emp-department .apexcharts-bar-series .apexcharts-series path, [data-color=all] #s-bar .apexcharts-bar-series .apexcharts-series path, [data-color=all] #mixed-chart .apexcharts-bar-series .apexcharts-series path {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #mixed-chart .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=all] #s-col-stacked .apexcharts-legend-series:first-child .apexcharts-legend-marker, [data-color=all] #s-col .apexcharts-legend-series:first-child .apexcharts-legend-marker {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #s-line .apexcharts-line-series .apexcharts-series path {
  stroke: rgba(var(--primary-rgb), 1);
  stroke: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #s-line .apexcharts-line-series .apexcharts-marker {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] #chart-bar-stacked .c3-target-data2 .c3-bar, [data-color=all] #chart-bar .c3-target-data2 .c3-bar, [data-color=all] #chart-bar-rotated .c3-target-data2 .c3-bar {
  fill: rgba(var(--primary-rgb), 1) !important;
  fill: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] #chart-spline-rotated .c3-target-data2 .c3-line {
  stroke: rgba(var(--primary-rgb), 1) !important;
  stroke: rgba(var(--primary-rgb-picr), 1) !important;
}
[data-color=all] #chart-spline-rotated .c3-target-data2 .c3-circle {
  fill: rgba(var(--primary-rgb), 1);
  fill: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .nav.tab-style-1 .nav-link.active {
  background-color: rgba(var(--primary-rgb), 1);
  background-color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .table tbody tr td a:hover {
  color: rgba(var(--primary-rgb), 1);
  color: rgba(var(--primary-rgb-picr), 1);
}
[data-color=all] .view-icons a.active, [data-color=all] .view-icons a:hover {
  background: rgba(var(--primary-rgb), 1);
  background: rgba(var(--primary-rgb-picr), 1);
}

body.layout-mode-rtl {
  direction: rtl;
}
body.layout-mode-rtl .slide-nav .sidebar {
  margin-right: 0;
}
body.layout-mode-rtl .sidebar {
  right: 0;
  left: auto;
  left: initial;
  border-right: 0;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu ul::before {
  right: 14px;
  left: auto;
  left: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu > ul li a {
  padding: 8px 32px 8px 8px;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu > ul li a::before {
  right: 19px;
  left: auto;
  left: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu > ul li a::after {
  right: 16px;
  left: auto;
  left: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li ul li a span {
  margin-right: 10px;
  margin-left: 0;
}
body.layout-mode-rtl .sidebar .sidebar-menu .menu-arrow {
  left: 10px;
  right: auto;
  right: initial;
}
body.layout-mode-rtl .sidebar .sidebar-menu > ul > li .submenu-hdr::after {
  margin-right: 8px;
  margin-left: 0;
}
@media (max-width: 991.98px) {
  body.layout-mode-rtl .sidebar {
    margin-right: -575px;
  }
}
body.layout-mode-rtl .header-left {
  float: right;
  border-right: 0;
}
body.layout-mode-rtl .page-wrapper {
  margin-right: 276px;
  margin-left: 0;
}
@media (max-width: 991.98px) {
  body.layout-mode-rtl .page-wrapper {
    margin-right: 0;
  }
}
body.layout-mode-rtl.mini-sidebar .page-wrapper {
  margin-right: 80px;
}
@media (min-width: 991.98px) {
  body.layout-mode-rtl .header {
    right: 0;
    left: 0;
  }
}
body.layout-mode-rtl .header .input-group input {
  border-right: 1px solid #9B9B9B !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  border-left: 0 !important;
  padding: 0.5rem 1.875rem 0.5rem 0.625rem;
}
body.layout-mode-rtl .header .input-group .input-group-text {
  border-right: 0;
  border-radius: 5px !important;
  border-left: 1px solid #9B9B9B;
}
body.layout-mode-rtl .header .input-group .input-group-text:last-child {
  padding-left: 10px;
  padding-right: 0;
}
@media (max-width: 991.98px) {
  body.layout-mode-rtl .header .mobile_btn {
    right: 0;
    left: auto;
    left: initial;
  }
}
body.layout-mode-rtl .header .mobile-user-menu {
  left: 0;
  right: auto;
  text-align: left;
}
body.layout-mode-rtl .input-icon-addon {
  right: 0;
  left: auto;
  left: initial;
}
body.layout-mode-rtl.mini-sidebar .header {
  left: 0;
}
body.layout-mode-rtl.mini-sidebar.expand-menu .header {
  left: 0;
}
body.layout-mode-rtl .input-icon .form-control {
  padding-left: 0;
  padding-right: 30px;
}
body.layout-mode-rtl .nav-list::before {
  left: 0;
  right: auto;
  right: initial;
}
body.layout-mode-rtl .nav-list .nav li {
  margin-left: 10px;
  margin-right: 0;
}
body.layout-mode-rtl .header .header-user .user-menu > li {
  margin-right: 10px;
  margin-inline-end: 0;
}
body.layout-mode-rtl .header .header-user .user-menu .nav-item-email.nav-item-box {
  margin-right: 15px;
  margin-left: 0;
}
body.layout-mode-rtl .header .header-user .user-menu > li:first-child {
  margin-right: 0 !important;
  margin-left: auto;
}
body.layout-mode-rtl .page-header .head-icons a {
  margin-left: 10px;
  margin-right: 0;
}
body.layout-mode-rtl .page-header .head-icons a:last-child {
  margin-left: 0;
}
body.layout-mode-rtl .sidebar .sidebar-menu .clinicdropdown > a .user-names {
  margin-right: 10px;
  margin-left: 0;
}
body.layout-mode-rtl #last-chart text, body.layout-mode-rtl #last-chart-2 text, body.layout-mode-rtl #won-chart text, body.layout-mode-rtl #deals-chart text, body.layout-mode-rtl #contact-report text, body.layout-mode-rtl #leads-chart text {
  text-anchor: start;
}

[data-loader=enable] #global-loader {
  opacity: 1;
}

[data-loader=disable] #global-loader {
  opacity: 0;
  display: none !important;
}

[data-theme=dark] .bg-white {
  background-color: #0D0D0D;
}
[data-theme=dark] body {
  background: #131313;
}
[data-theme=dark] .header {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark] .header .header-user .user-menu .btn-menubar.active {
  background-color: #212324;
  border-color: #212324;
  color: #D8DFEE;
}
[data-theme=dark] .header .header-user .user-menu .profile-dropdown .avatar img {
  border-color: #171717;
}
[data-theme=dark] .header .input-group input {
  border-color: #1F2228 !important;
}
[data-theme=dark] .head-icons a {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .head-icons a:hover {
  background: #e85b28;
}
[data-theme=dark] .sidebar {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .sidebar .sidebar-logo .logo {
  display: none;
}
[data-theme=dark] .sidebar .sidebar-logo .dark-logo {
  display: block;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > a:hover span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > a:hover i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover i, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li > a:hover span {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover i, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active i, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop span, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a:hover .menu-arrow::before, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.active .menu-arrow::before, [data-theme=dark] .sidebar .sidebar-menu > ul > li > ul > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li.active a {
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li > a span {
  color: #4B5563;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a i {
  color: #6B7280;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a span {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a {
  background: #212324;
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a .menu-arrow::before {
  border-right: 2px solid #e85b28;
  border-bottom: 2px solid #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  background: #100601;
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop i {
  color: #0D0D0D;
  background: #0D0D0D;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul > li .submenu ul::before {
  background: #171717;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li.menu-title {
  color: #9CA3AF;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  background: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.subdrop i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.active {
  background: #212324;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu > a.active i {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.subdrop, [data-theme=dark] .sidebar .sidebar-menu > ul li .submenu.submenu-two a.active {
  background: transparent;
  color: #e85b28;
}
[data-theme=dark] .sidebar .sidebar-menu .menu-arrow::before {
  border-right: 2px solid #D8DFEE;
  border-bottom: 2px solid #D8DFEE;
}
[data-theme=dark] .sidebar .nav-link {
  color: #374151;
}
[data-theme=dark] .sidebar .btn-menubar {
  border: 1px solid #171717;
  color: #6B7280;
}
[data-theme=dark] .sidebar .btn-menubar:hover, [data-theme=dark] .sidebar .btn-menubar:active, [data-theme=dark] .sidebar .btn-menubar.active {
  background-color: #212324;
  border-color: #212324;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar .input-group input {
  border-color: #1F2228 !important;
}
[data-theme=dark] .mini-sidebar .sidebar .sidebar-logo .dark-logo {
  display: none;
}
[data-theme=dark] .mini-sidebar.expand-menu .sidebar .sidebar-logo .dark-logo {
  display: block;
}
[data-theme=dark] .mini-sidebar.expand-menu .sidebar .sidebar-logo .logo-small, [data-theme=dark] .mini-sidebar.expand-menu .sidebar .sidebar-logo .logo {
  display: none;
}
[data-theme=dark] .form-control {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .input-group-text {
  background-color: #0D0D0D;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked .stacked-mini {
  border-right: 1px solid #171717;
  background-color: #0B0F14;
}
[data-theme=dark] .sidebar-stacked.sidebar {
  background-color: transparent;
}
[data-theme=dark] .sidebar-stacked.sidebar .nav-link {
  border: 1px solid #171717;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked.sidebar .nav-link.active, [data-theme=dark] .sidebar-stacked.sidebar .nav-link:hover {
  background: #131313;
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked.sidebar .nav-link p {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right {
  background: #0D0D0D;
  border-right: 1px solid #1F2228;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right .logo {
  text-align: center;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right .stack-submenu {
  background: #0D0D0D;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.subdrop i {
  color: #374151;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.active {
  background: #212324;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li a.active i {
  color: #374151;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.active a {
  background: #212324;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #212324;
  color: #6B7280 !important;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-theme=dark] .sidebar-stacked.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar-stacked.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #212324;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  color: #D8DFEE;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a:hover {
  background-color: #212324;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a:hover, [data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a.active {
  background-color: #212324;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a .menu-arrow::before {
  border-color: #6B7280;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul ul {
  background-color: #0D0D0D;
}
[data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.active, [data-theme=dark] .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.subdrop {
  background-color: #212324;
}
[data-theme=dark] .menu-horizontal .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark] .sidebar-twocol .twocol-mini {
  border-right: 1px solid #1F2228;
  background-color: #0D0D0D;
}
[data-theme=dark] .sidebar-twocol.sidebar {
  background-color: transparent;
}
[data-theme=dark] .sidebar-twocol.sidebar .nav-link {
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .nav-link.active, [data-theme=dark] .sidebar-twocol.sidebar .nav-link:hover {
  background: #131313;
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .nav-link::before {
  background: #5CB85C;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right {
  background: #0D0D0D;
  border-right: 1px solid #1F2228;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .dark-logo {
  display: block;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .sidebar-logo .logo {
  display: none;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.menu-title {
  color: #9CA3AF;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a {
  color: #6B7280;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop i {
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.subdrop:hover {
  color: #6B7280 !important;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.active {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li a.active i {
  color: #374151;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.active a {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu > a:hover {
  background: #212324;
  color: #6B7280 !important;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a:hover, [data-theme=dark] .sidebar-twocol.sidebar .sidebar-right ul li.submenu ul > li > a.active {
  color: #e85b28;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .tab-pane > ul > li > a:hover {
  background: #212324;
}
[data-theme=dark] .sidebar-twocol.sidebar .sidebar-right .menu-arrow:before {
  content: "\\f105";
}
[data-theme=dark] .sidebar-nav {
  background: #131313;
}
[data-theme=dark] h1, [data-theme=dark] h2, [data-theme=dark] h3, [data-theme=dark] h4, [data-theme=dark] h5, [data-theme=dark] h6 {
  color: #D8DFEE;
}
[data-theme=dark] .bg-light {
  background-color: #131313 !important;
  border-color: #131313 !important;
}
[data-theme=dark] a {
  color: #D8DFEE;
}
[data-theme=dark] kbd {
  background-color: #212324;
  color: #6B7280;
}
[data-theme=dark] .input-group-flat:focus-within .form-control,
[data-theme=dark] .input-group-flat:focus-within .input-group-text {
  border-color: #1F2228 !important;
}
[data-theme=dark] .card {
  background-color: #0D0D0D;
  border: 1px solid #1F2228;
}
[data-theme=dark] .card .card-title {
  color: #D8DFEE;
}
[data-theme=dark] .card .card-header {
  border-color: #1F2228;
}
[data-theme=dark] .card .card-footer {
  border-color: #1F2228;
}
[data-theme=dark] .alert-light {
  background-color: #131313;
  color: #6B7280;
  border-color: #131313;
}
[data-theme=dark] .alert-light .alert-link {
  color: #6B7280;
}
[data-theme=dark] .alert-light .btn-close {
  color: #6B7280;
}
[data-theme=dark] .custom-alert1 {
  background-color: #0D0D0D;
}
[data-theme=dark] .alert-primary.custom-alert-icon, [data-theme=dark] .alert-secondary.custom-alert-icon, [data-theme=dark] .alert-warning.custom-alert-icon, [data-theme=dark] .alert-danger.custom-alert-icon {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header {
  left: 0;
  background-color: #0D0D0D;
  border-color: rgb(15.295, 15.295, 15.295);
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover {
  background: #212324;
  color: #6B7280;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left {
  display: block;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .logo, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .logo {
  display: none;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .header .header-left .dark-logo, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .mode-toggle, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .mode-toggle {
  color: #6B7280;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar {
  background-color: #0D0D0D;
  border-bottom: 1px solid rgb(15.295, 15.295, 15.295);
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a {
  color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop {
  background-color: #212324;
  color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.active .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a:hover .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a.subdrop .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > a .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .sidebar-horizontal.sidebar .sidebar-menu .nav-menu .menu-arrow::before {
  border-color: #D8DFEE;
}
[data-theme=dark][data-layout=horizontal-overlay][data-topbarcolor=white] .main-wrapper::before, [data-theme=dark][data-layout=horizontal-sidemenu][data-topbarcolor=white] .main-wrapper::before {
  content: "";
  background: #0D0D0D;
}
[data-theme=dark] .page-wrapper::before {
  background: #0D0D0D;
}
[data-theme=dark] .accordion-button {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion-button:after {
  content: "\\f078";
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion-body {
  color: #9595b5;
}
[data-theme=dark] .accordion-item {
  color: #6B7280;
  background-color: #0D0D0D;
  border-color: #181818;
}
[data-theme=dark] .accordion.accordion-primary .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-secondary .accordion-button.collapsed {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-primary .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-secondary .accordion-button.collapsed::after {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-solid-primary .accordion-button, [data-theme=dark] .accordion.accordion-solid-secondary .accordion-button, [data-theme=dark] .accordion.accordion-solid-warning .accordion-button, [data-theme=dark] .accordion.accordion-solid-info .accordion-button, [data-theme=dark] .accordion.accordion-solid-success .accordion-button, [data-theme=dark] .accordion.accordion-solid-danger .accordion-button {
  color: #0D0D0D;
}
[data-theme=dark] .accordion.accordion-solid-primary .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-secondary .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-warning .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-info .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-success .accordion-button.collapsed, [data-theme=dark] .accordion.accordion-solid-danger .accordion-button.collapsed {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-solid-primary .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-secondary .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-warning .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-info .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-success .accordion-button.collapsed::after, [data-theme=dark] .accordion.accordion-solid-danger .accordion-button.collapsed::after {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .accordion.accordion-border-primary .accordion-button, [data-theme=dark] .accordion.accordion-border-secondary .accordion-button, [data-theme=dark] .accordion.accordion-border-warning .accordion-button, [data-theme=dark] .accordion.accordion-border-info .accordion-button, [data-theme=dark] .accordion.accordion-border-success .accordion-button, [data-theme=dark] .accordion.accordion-border-danger .accordion-button {
  background-color: #0D0D0D;
}
[data-theme=dark] .accordion.accordion-border-primary .accordion-button::after, [data-theme=dark] .accordion.accordion-border-secondary .accordion-button::after, [data-theme=dark] .accordion.accordion-border-warning .accordion-button::after, [data-theme=dark] .accordion.accordion-border-info .accordion-button::after, [data-theme=dark] .accordion.accordion-border-success .accordion-button::after, [data-theme=dark] .accordion.accordion-border-danger .accordion-button::after {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-outline-primary, [data-theme=dark] .bg-outline-secondary, [data-theme=dark] .bg-outline-success,
[data-theme=dark] .bg-outline-danger, [data-theme=dark] .bg-outline-warning, [data-theme=dark] .bg-outline-info, [data-theme=dark] .bg-outline-light, [data-theme=dark] .bg-outline-light {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-outline-light {
  border: 1px solid #131313 !important;
  color: #D8DFEE !important;
}
[data-theme=dark] .border-container {
  background-color: #131313;
}
[data-theme=dark] .border {
  border-color: #1F2228 !important;
}
[data-theme=dark] .border.border-primary {
  border: 1px solid #e85b28 !important;
}
[data-theme=dark] .border.border-secondary {
  border: 1px solid #FFA201 !important;
}
[data-theme=dark] .border.border-success {
  border: 1px solid #5CB85C !important;
}
[data-theme=dark] .border.border-warning {
  border: 1px solid #FDA700 !important;
}
[data-theme=dark] .border.border-danger {
  border: 1px solid #FC0027 !important;
}
[data-theme=dark] .border.border-info {
  border: 1px solid #1ECBE2 !important;
}
[data-theme=dark] .border.border-light {
  border: 1px solid #131313 !important;
}
[data-theme=dark] .border.border-white {
  border: 1px solid #0D0D0D !important;
}
[data-theme=dark] .border-top {
  border-top: 1px solid #1F2228 !important;
}
[data-theme=dark] .border-end {
  border-inline-end: 1px solid #1F2228 !important;
}
[data-theme=dark] .border-bottom {
  border-bottom: 1px solid #1F2228 !important;
}
[data-theme=dark] .border-start {
  border-inline-start: 1px solid #1F2228 !important;
}
[data-theme=dark] .list-group-item {
  background-color: #0D0D0D;
  border-color: #181818 !important;
}
[data-theme=dark] .toast {
  background-color: #0D0D0D;
}
[data-theme=dark] .avatar.online:before, [data-theme=dark] .avatar.offline:before {
  border-color: #0D0D0D !important;
}
[data-theme=dark] .swal2-popup {
  background-color: #0D0D0D;
}
[data-theme=dark] .progress, [data-theme=dark] .progress-stacked {
  background-color: #181818;
}
[data-theme=dark] .popover {
  background-color: #0D0D0D;
  border: 1px solid #1F2228;
  box-shadow: none;
}
[data-theme=dark] .popover .popover-header {
  background-color: #0D0D0D;
  border-block-end: 1px solid #1F2228;
}
[data-theme=dark] .popover .popover-body {
  color: #6B7280;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
[data-theme=dark] .bs-popover-top > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
[data-theme=dark] .bs-popover-top > .popover-arrow::before {
  border-top-color: #131313;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
[data-theme=dark] .bs-popover-end > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
[data-theme=dark] .bs-popover-end > .popover-arrow::before {
  border-right-color: #131313;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
[data-theme=dark] .bs-popover-start > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
[data-theme=dark] .bs-popover-start > .popover-arrow::before {
  border-left-color: #131313;
}
[data-theme=dark] .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
[data-theme=dark] .bs-popover-bottom > .popover-arrow::after,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
[data-theme=dark] .bs-popover-bottom > .popover-arrow::before,
[data-theme=dark] .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
[data-theme=dark] .bs-popover-bottom .popover-header::before {
  border-bottom-color: #131313;
}
[data-theme=dark] .page-link {
  color: #6B7280;
  background-color: #0D0D0D;
  border: 1px solid #1F2228;
}
[data-theme=dark] .page-link:focus {
  background-color: #131313;
}
[data-theme=dark] .page-link:hover {
  background-color: #131313;
  border-color: #1F2228;
}
[data-theme=dark] .pagination-style-2 .pagination .page-item.active .page-link {
  background-color: #131313;
}
[data-theme=dark] .pagination-style-1 .pagination .page-item:hover .page-link {
  background-color: #131313;
}
[data-theme=dark] .pagination-style-3 .pagination .page-item:hover .page-link {
  background-color: #131313;
}
[data-theme=dark] .offcanvas {
  background-color: #0D0D0D;
  color: #6B7280;
}
[data-theme=dark] .modal-content {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .modal-content .modal-header {
  border-color: #1F2228;
}
[data-theme=dark] .modal-content .modal-footer {
  border-color: #1F2228;
}
[data-theme=dark] .figure-caption {
  color: #6B7280;
}
[data-theme=dark] .text-dark {
  color: #D6DADE !important;
}
[data-theme=dark] .nav-tabs li a {
  color: #D8DFEE;
}
[data-theme=dark] .nav-tabs .nav-item.show .nav-link, [data-theme=dark] .nav-tabs .nav-link.active {
  background-color: #0D0D0D;
  color: #D8DFEE;
}
[data-theme=dark] .nav-tabs .nav-link.active {
  border-color: #1F2228;
}
[data-theme=dark] .nav-tabs.nav-tabs-solid {
  background-color: #0D0D0D;
}
[data-theme=dark] .nav.tab-style-1 {
  background-color: #131313;
}
[data-theme=dark] .vertical-tabs-2 .nav-item .nav-link {
  background-color: #131313;
  border-color: #1F2228;
}
[data-theme=dark] .vertical-tabs-2 .nav-item .nav-link.active {
  background-color: #e85b28;
}
[data-theme=dark] .tab-style-2 .nav-item .nav-link i {
  background-color: #131313;
  color: #6B7280;
}
[data-theme=dark] .nav-tabs.nav-tabs-top li a.active {
  border-top-color: #e85b28;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link::after {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link:before {
  background-color: #131313;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link.active:before {
  background-color: #e85b28;
}
[data-theme=dark] .tab-style-3 .nav-item .nav-link.active:after {
  border-color: #e85b28;
  color: #e85b28;
}
[data-theme=dark] .tab-style-6 {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-white {
  background-color: #0D0D0D !important;
}
[data-theme=dark] .card.card-bg-primary .card-body, [data-theme=dark] .text-fixed-white {
  color: #0D0D0D;
}
[data-theme=dark] .btn.btn-light {
  background-color: #181818;
  border: 1px solid #181818;
  color: #6B7280;
}
[data-theme=dark] .btn.btn-light:hover, [data-theme=dark] .btn.btn-light:focus, [data-theme=dark] .btn.btn-light.focus, [data-theme=dark] .btn.btn-light:active, [data-theme=dark] .btn.btn-light.active {
  background-color: rgb(16.35, 16.35, 16.35);
  border: 1px solid #181818;
  color: #6B7280;
}
[data-theme=dark] .scroll-demo {
  border-color: #1F2228;
}
[data-theme=dark] .timeline::before {
  background-color: #1F2228;
}
[data-theme=dark] .timeline > li > .timeline-panel {
  border-color: #1F2228;
}
[data-theme=dark] .timeline > li > .timeline-panel::after, [data-theme=dark] .timeline > li > .timeline-panel::before {
  border-color: #1F2228;
}
[data-theme=dark] .callout {
  background-color: #131313;
}
[data-theme=dark] .icons-list li {
  border-color: #1F2228;
  box-shadow: none;
}
[data-theme=dark] .btn-outline-light {
  border: 1px solid #131313 !important;
  color: #374151 !important;
}
[data-theme=dark] .btn-outline-light:hover, [data-theme=dark] .btn-outline-light:focus, [data-theme=dark] .btn-outline-light.focus, [data-theme=dark] .btn-outline-light:active, [data-theme=dark] .btn-outline-light.active {
  background-color: #131313 !important;
  border: 1px solid #131313 !important;
  color: #374151 !important;
}
[data-theme=dark] .bg-dark {
  background-color: #D6DADE !important;
  border-color: #D6DADE !important;
  color: #0D0D0D;
}
[data-theme=dark] .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link::after {
  background-color: #1F2228;
}
[data-theme=dark] .form-check-input {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .alert-outline-primary, [data-theme=dark] .alert-outline-secondary, [data-theme=dark] .alert-outline-warning, [data-theme=dark] .alert-outline-danger,
[data-theme=dark] .alert-outline-info, [data-theme=dark] .alert-outline-dark, [data-theme=dark] .alert-outline-success, [data-theme=dark] .alert-outline-light {
  background-color: #0D0D0D;
}
[data-theme=dark] .text-white {
  color: #0D0D0D !important;
}
[data-theme=dark] .text-light {
  color: #131313 !important;
}
[data-theme=dark] .table thead tr {
  border-color: #1F2228;
}
[data-theme=dark] .table thead tr th {
  border-color: #1F2228;
  background-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .table tbody tr {
  border-color: #1F2228;
}
[data-theme=dark] .table tbody tr th {
  border-color: #1F2228;
  background-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .table tbody tr td {
  background-color: #0D0D0D;
  color: #6B7280;
  border-color: #1F2228;
}
[data-theme=dark] .table .thead-primary th {
  background-color: #e85b28;
}
[data-theme=dark] .table .thead-secondary th {
  background-color: #FFA201;
}
[data-theme=dark] .table .thead-info th {
  background-color: #1ECBE2;
}
[data-theme=dark] .table .thead-warning th {
  background-color: #FDA700;
}
[data-theme=dark] .table .thead-danger th {
  background-color: #FC0027;
}
[data-theme=dark] .table .thead-success th {
  background-color: #5CB85C;
}
[data-theme=dark] .table .thead-dark th {
  background-color: #D6DADE;
}
[data-theme=dark] .table .thead-light th {
  background-color: #101010;
}
[data-theme=dark] table.table.dataTable > tbody > tr {
  border-color: #1F2228;
}
[data-theme=dark] table.table.dataTable > tbody > tr td {
  color: #6B7280;
  border-color: #1F2228;
}
[data-theme=dark] table.table.dataTable > thead > tr {
  border-color: #1F2228;
}
[data-theme=dark] table.table.dataTable > thead > tr th {
  color: #D8DFEE;
}
[data-theme=dark] .dataTables_length label {
  color: #374151;
}
[data-theme=dark] .dataTables_length label .form-select {
  border: 1px solid #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .form-label {
  color: #D8DFEE;
}
[data-theme=dark] .form-control {
  color: #D8DFEE;
}
[data-theme=dark] .form-select {
  background-color: #0D0D0D;
  color: #D8DFEE;
  border-color: #1F2228;
}
[data-theme=dark] .form-select option {
  background-color: #0D0D0D;
}
[data-theme=dark] .select2-container--default .select2-selection--single {
  border-color: #1F2228;
  background: #0D0D0D;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #D8DFEE !important;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #D8DFEE;
}
[data-theme=dark] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  color: #0D0D0D;
}
[data-theme=dark] .select2-container--focus .select2-selection--single {
  background: #0D0D0D !important;
  border-color: #1F2228;
}
[data-theme=dark] .select2-container--classic .select2-selection--single,
[data-theme=dark] .select2-container--default .select2-selection--single,
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered,
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow,
[data-theme=dark] .select2-container--default .select2-selection--multiple,
[data-theme=dark] .select2-container--classic .select2-selection--single .select2-selection__arrow,
[data-theme=dark] .select2-container--classic .select2-selection--single .select2-selection__rendered {
  border-color: #1F2228;
  color: #6B7280;
}
[data-theme=dark] .select2-dropdown {
  border-color: #1F2228;
  background: #0D0D0D;
}
[data-theme=dark] .select2-container--classic .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  color: #0D0D0D;
}
[data-theme=dark] .form-floating > .form-control-plaintext ~ label::after,
[data-theme=dark] .form-floating > .form-control:focus ~ label::after,
[data-theme=dark] .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
[data-theme=dark] .form-floating > .form-select ~ label::after {
  background-color: #0D0D0D;
}
[data-theme=dark] .select2-container--default .select2-selection--multiple {
  background-color: #0D0D0D;
}
[data-theme=dark] .custom-file-container .custom-file-container__custom-file__custom-file-control {
  background-color: #171717;
  border-color: #171717;
}
[data-theme=dark] .dropdown-menu {
  background-color: #0D0D0D;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .dropdown-menu .dropdown-item {
  color: #D8DFEE;
}
[data-theme=dark] .dropdown-menu .dropdown-item:not(.active):hover, [data-theme=dark] .dropdown-menu .dropdown-item:not(.active):focus, [data-theme=dark] .dropdown-menu .dropdown-item:not(.active):active {
  color: #D8DFEE;
  background-color: #0F0F0F;
}
[data-theme=dark] .dropdown-menu .dropdown-item.active {
  background-color: #0F0F0F;
}
[data-theme=dark] .dropdown-divider {
  border-color: #1F2228;
}
[data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg1] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg2] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg3] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg4] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg5] #sidebar::before, [data-theme=dark][data-sidebar=light] [data-sidebarbg=sidebarbg6] #sidebar::before {
  background: rgba(13, 13, 13, 0.85);
}
[data-theme=dark] .theme-width input[type=radio]:checked ~ label {
  border-color: #e85b28;
}
[data-theme=dark] .theme-width input[type=radio]:checked ~ label::before {
  border-color: #e85b28;
}
[data-theme=dark] .theme-width label {
  border-color: #1F2228;
  color: #6B7280;
}
[data-theme=dark] .theme-width label::before {
  border-color: #1F2228;
  background: #0D0D0D;
}
[data-theme=dark] .theme-width label::after {
  background: #e85b28;
}
[data-theme=dark] .theme-sidebarcolor input[type=radio]:checked ~ label {
  border-color: #e85b28 !important;
}
[data-theme=dark] .theme-sidebarcolor input[type=radio]:checked ~ label:after {
  color: #e85b28;
}
[data-theme=dark] .theme-sidebarcolor input[type=radio]:checked ~ label.bg-dark:after {
  color: #0D0D0D;
}
[data-theme=dark] .theme-sidebarcolor label {
  border-color: #1F2228;
}
[data-theme=dark] .theme-sidebarbg input[type=radio]:checked ~ label:after {
  color: #e85b28;
  background: #FFF;
  border-color: #1F2228;
}
[data-theme=dark] .theme-sidebarbg label img {
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label {
  outline-color: #e85b28;
}
[data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label:after {
  color: #e85b28;
  background: #FFF;
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label.primary-topbar:after, [data-theme=dark] .theme-colorselect input[type=radio]:checked ~ label.dark-topbar:after {
  color: #0D0D0D;
}
[data-theme=dark] .theme-colorselect label {
  outline-color: #1F2228;
}
[data-theme=dark] .theme-colorselect label.white-topbar {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorselect .pickr-container-background, [data-theme=dark] .theme-colorselect .pickr-topbar, [data-theme=dark] .theme-colorselect .pickr-topbarcolor {
  outline-color: #1F2228;
}
[data-theme=dark] .theme-colorsset label {
  border-color: #1F2228;
}
[data-theme=dark] .theme-colorsset label.primary-clr::before {
  background: #e85b28;
}
[data-theme=dark] .theme-colorsset label.brightblue-clr::before {
  background: #2066FF;
}
[data-theme=dark] .theme-colorsset label.lunargreen-clr::before {
  background: #365E32;
}
[data-theme=dark] .theme-colorsset label.lavendar-clr::before {
  background: #673AB7;
}
[data-theme=dark] .theme-colorsset label.magenta-clr::before {
  background: #E83E8C;
}
[data-theme=dark] .theme-colorsset label.chromeyellow-clr::before {
  background: #FF9B04;
}
[data-theme=dark] .theme-colorsset label.lavared-clr::before {
  background: #DC2626;
}
[data-theme=dark] .theme-colorsset input[type=radio]:checked ~ label:after {
  color: #0D0D0D;
}
[data-theme=dark] .theme-mode input[type=radio]:checked ~ label {
  border-color: #e85b28;
}
[data-theme=dark] .theme-mode input[type=radio]:checked ~ label .avatar {
  color: #FDA700;
  background-color: #FFF9E9;
}
[data-theme=dark] .theme-mode label {
  border-color: #1F2228;
  color: #374151;
}
[data-theme=dark] .theme-mode label .avatar {
  background-color: #212324;
  color: #D6DADE;
}
[data-theme=dark] .theme-mode .pickr-container-primary {
  border-color: #1F2228;
}
[data-theme=dark] .theme-layout.active img {
  border: 1px solid #e85b28;
}
[data-theme=dark] .theme-layout input[type=radio]:checked ~ label .layout-img img {
  border-color: #e85b28;
}
[data-theme=dark] .theme-layout label .layout-img img {
  border-color: #1F2228;
}
[data-theme=dark] .theme-layout label .layout-type {
  color: #D8DFEE;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header {
  background-color: #0D0D0D;
  border-color: rgba(13, 13, 13, 0.8);
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .bar-icon span {
  background-color: #0D0D0D;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-user .user-menu .btn-menubar.active {
  background-color: #0D0D0D;
  color: #6B7280 !important;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-left .logo {
  display: none;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .header .header-left .dark-logo {
  display: block;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=white] .page-wrapper::before {
  background: #0D0D0D;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .bar-icon span, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .bar-icon span {
  background-color: #0D0D0D;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar {
  color: #6B7280;
}
[data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=firefly] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=bluegem] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=blackpearl] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=maroon] .header .header-user .user-menu .btn-menubar.active, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:hover, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar:active, [data-theme=dark][data-layout=modern][data-topbarcolor=primary] .header .header-user .user-menu .btn-menubar.active {
  background-color: #0D0D0D;
  color: #6B7280 !important;
}
[data-theme=dark] .policy-upload {
  border-color: #1F2228;
}
[data-theme=dark] .bootstrap-tagsinput {
  background-color: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .note-toolbar, [data-theme=dark] .note-dropdown-menu, [data-theme=dark] .note-modal-content, [data-theme=dark] .note-input {
  background-color: #131313;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .note-btn {
  background-color: #0D0D0D;
  border-color: #1F2228;
  color: #D8DFEE;
}
[data-theme=dark] .note-modal-header, [data-theme=dark] .file-drop {
  border-color: #1F2228;
}
[data-theme=dark] .close {
  color: #D8DFEE;
}
[data-theme=dark] .video-wrap .video-content {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-black .text-white {
  color: #D8DFEE !important;
}
[data-theme=dark] .bg-transparent-light {
  background: #131313 !important;
}
[data-theme=dark] .contact-grids-tab .nav-underline {
  border-color: #1F2228;
}
[data-theme=dark] .contact-grids-tab .nav-underline .nav-item .nav-link.active, [data-theme=dark] .contact-grids-tab .nav-underline .nav-item .nav-link:hover {
  background-color: #0D0D0D;
}
[data-theme=dark] .bg-primary-100 a {
  color: #0D0D0D;
}
[data-theme=dark] .bg-primary-100 a:hover {
  color: #e85b28;
}
[data-theme=dark] .notification-dropdown .dropdown .dropdown-toggle {
  color: #D8DFEE;
}
[data-theme=dark] .notification-dropdown .dropdown .dropdown-toggle.show {
  color: #D8DFEE;
}
[data-theme=dark] .bootstrap-datetimepicker-widget table th {
  color: #D8DFEE;
}
[data-theme=dark] .crm-link {
  color: #D8DFEE;
  background: #131313;
  border: #1F2228;
}

[data-theme=dark] .breadcrumb .breadcrumb-item.active {
  color: #C8D2E0;
}
[data-theme=dark] .table tbody tr td a {
  color: #C8D2E0;
}
[data-theme=dark] .btn.btn-icon.active.bg-white {
  border-color: #1F2228;
  color: #C8D2E0;
}
[data-theme=dark] .custom-datatable-filter {
  background: #0D0D0D;
}
[data-theme=dark] .btn.btn-white {
  background: #0D0D0D;
  border-color: #1F2228;
  color: #C8D2E0;
}
[data-theme=dark] .todo-item .form-check-label {
  color: #C8D2E0;
}
[data-theme=dark] .bg-transparent-secondary, [data-theme=dark] .bg-transparent-dark, [data-theme=dark] .bg-light-500 {
  background: #374151 !important;
}
[data-theme=dark] .text-gray-9, [data-theme=dark] .text-title {
  color: #C8D2E0 !important;
}
[data-theme=dark] .attendance-bg {
  background: #0D0D0D;
  border-color: #1F2228 !important;
}
[data-theme=dark] .chat-wrapper .sidebar-group {
  background: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat-users-wrap .chat-user-list, [data-theme=dark] .chat-wrapper .chat .chat-header, [data-theme=dark] .chat-wrapper .chat {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .search-wrap .input-group-text {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .search-wrap .form-control {
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-footer .footer-form {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-footer .footer-form .chat-footer-wrap {
  background: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-body .messages .chats .chat-content .message-content {
  background: #1F2228;
}
[data-theme=dark] .chat-wrapper .chat .chat-header .chat-options > ul > li > a {
  background: #1F2228;
}
[data-theme=dark] #calendar .fc-scroller-harness th {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] #calendar .fc-col-header-cell-cushion, [data-theme=dark] #calendar .fc-daygrid-day-number {
  color: #C8D2E0;
}
[data-theme=dark] #calendar .fc-daygrid-body tbody td {
  background: #0D0D0D;
  border-color: #1F2228;
}
[data-theme=dark] #calendar .fc-daygrid .fc-scrolcustom991rid {
  border-color: #1F2228;
}

.menu-horizontal #toggle_btn {
  display: none;
}
.menu-horizontal .page-wrapper {
  margin: 0;
  padding-top: 96px;
  max-width: 1320px;
  margin: 0 auto;
}
@media (max-width: 1399.98px) {
  .menu-horizontal .page-wrapper {
    max-width: 1170px;
  }
}
@media (max-width: 1199.98px) {
  .menu-horizontal .page-wrapper {
    max-width: 950px;
  }
}
@media (max-width: 991.98px) {
  .menu-horizontal .page-wrapper {
    max-width: 100%;
  }
}
.menu-horizontal .page-wrapper .content {
  padding-left: 0;
  padding-right: 0;
}
@media (max-width: 991.98px) {
  .menu-horizontal .page-wrapper .content {
    padding: 20px;
  }
}
@media (min-width: 991.98px) {
  .menu-horizontal #sidebar {
    display: none;
  }
}
.menu-horizontal .header {
  left: 0;
}
.menu-horizontal .header .main-header {
  margin: 0 auto;
}
.menu-horizontal .header .main-header .user-menu {
  padding-right: 0;
}
.menu-horizontal .header .header-left {
  display: block;
}
.menu-horizontal .header .header-left .logo {
  display: block;
}
.menu-horizontal .header .header-left .dark-logo {
  display: none;
}

.sidebar-horizontal {
  margin: 0 auto;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.sidebar-horizontal.sidebar {
  width: 100% !important;
  bottom: inherit;
  top: 50px;
  border-right: 0;
  z-index: 9;
}
.sidebar-horizontal.sidebar .sidebar-logo {
  display: none;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li span {
  display: inline-block !important;
}
.sidebar-horizontal.sidebar .slimScrollDiv {
  top: 0;
  height: auto !important;
  overflow: inherit !important;
  padding: 0;
}
.sidebar-horizontal.sidebar .sidebar-inner {
  height: auto !important;
  overflow: inherit !important;
}
.sidebar-horizontal.sidebar .hidden {
  display: none !important;
}
.sidebar-horizontal.sidebar .sidebar-menu {
  padding: 0 !important;
  height: 46px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
}
.sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li {
  margin-right: 8px;
}
.sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li:last-child {
  margin-right: 0;
}
.sidebar-horizontal.sidebar .sidebar-menu .nav-menu > li.submenu > ul {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}
.sidebar-horizontal.sidebar .sidebar-menu ul {
  display: flex;
  align-items: center;
  -webkit-align-items: center;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li {
  position: relative;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
  font-size: 12px;
  color: #262A2A;
  border-radius: 5px;
  padding: 8px 30px 8px 8px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a i {
  margin-right: 4px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a:hover {
  background-color: #E8E9EA;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu .noti-dot:before {
  display: none;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li.submenu a {
  font-size: 12px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a {
  color: #424848;
  border-radius: 5px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a:hover, .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu ul li a.active {
  background-color: #E8E9EA;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu.submenu-two ul {
  max-height: none;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul {
  display: none;
  width: 170px;
  background-color: #FFF;
  position: absolute;
  top: 45px;
  left: 0;
  padding: 8px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul li a .menu-arrow {
  right: 15px;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul a {
  padding: 8px 15px;
}
.sidebar-horizontal.sidebar .sidebar-menu .menu-title {
  display: none !important;
}
.sidebar-horizontal.sidebar .sidebar-vertical {
  display: none !important;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li a {
  flex-direction: inherit;
  text-align: left;
  padding: 7px 8px;
  font-size: 12px;
  font-weight: 500;
  display: block;
  position: relative;
}
.sidebar-horizontal.sidebar ul li span {
  display: inline-block !important;
}
.sidebar-horizontal.sidebar .sidebar-menu ul ul > li.submenu > ul {
  position: relative;
  top: 0;
  padding: 0;
  width: 100%;
}
.sidebar-horizontal.sidebar ul ul li {
  display: inline-block !important;
  width: 100%;
}
.sidebar-horizontal.sidebar .sidebar-menu {
  max-width: 1320px;
}
@media (max-width: 1399.98px) {
  .sidebar-horizontal.sidebar .sidebar-menu {
    max-width: 1170px;
  }
}
@media (max-width: 1199.98px) {
  .sidebar-horizontal.sidebar .sidebar-menu {
    max-width: 950px;
  }
}
.sidebar-horizontal.sidebar .sidebar-menu .main-menu {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.active, .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a.subdrop {
  background-color: #E8E9EA;
}
@media (min-width: 1199.98px) {
  .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a {
    font-size: 14px;
    padding: 8px 30px 8px 8px;
  }
  .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a i {
    margin-right: 5px;
  }
  .sidebar-horizontal.sidebar .sidebar-menu ul li.submenu > a .menu-arrow {
    right: 8px;
  }
}
@media (max-width: 991.98px) {
  .sidebar-horizontal.sidebar {
    display: none !important;
  }
}

#horizontal-menu, #horizontal-single,
#two-col-sidebar, #stacked-sidebar {
  display: none;
}

[data-theme=dark] .border, [data-theme=dark] .border-top, [data-theme=dark] .border-bottom, [data-theme=dark] .border-start, [data-theme=dark] .border-end {
  border-color: #393947 !important;
}
[data-theme=dark] .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .dropdown .dropdown-menu {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .bg-white {
  background: #171724 !important;
}
[data-theme=dark] .bg-light-200, [data-theme=dark] .bg-light-300, [data-theme=dark] .bg-light-400 {
  background: #1A1A25;
}
[data-theme=dark] .dropdown .dropdown-menu .dropdown-item {
  background: #1A1A25;
}
[data-theme=dark] .offcanvas {
  background: #171724;
}
[data-theme=dark] .accordion-button:after {
  background: transparent;
}
[data-theme=dark] .bg-success.border {
  border-color: #5CB85C !important;
}
[data-theme=dark] .bg-purple.border {
  border-color: #4A00E5 !important;
}
[data-theme=dark] .bg-warning.border {
  border-color: #FDA700 !important;
}
[data-theme=dark] .bg-danger.border {
  border-color: #FC0027 !important;
}
[data-theme=dark] .btn-close {
  --bs-btn-close-color: \$dark-text;
  color: #FFF;
}
[data-theme=dark] .input-themeselect span {
  color: #FFF;
}

[data-theme=dark] body {
  background-color: #171724;
  color: #a3a6a6;
}
[data-theme=dark] h1, [data-theme=dark] h2, [data-theme=dark] h3, [data-theme=dark] h4, [data-theme=dark] h5, [data-theme=dark] h6, [data-theme=dark] .h1, [data-theme=dark] .h2, [data-theme=dark] .h3, [data-theme=dark] .h4, [data-theme=dark] .h5, [data-theme=dark] .h6 {
  color: #FFF;
}
[data-theme=dark] .header {
  background-color: #171724;
}
[data-theme=dark] .header .header-left {
  background-color: #171724;
}
[data-theme=dark] .header .header-left .logo img {
  display: none;
}
[data-theme=dark] .header .header-left .logo img.white-logo {
  display: block;
}
[data-theme=dark] .header .header-left #toggle_btn {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu {
  background-color: #171724;
  box-shadow: none;
}
[data-theme=dark] .header .dropdown-menu a {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header {
  border-color: #393947;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header .notification-title {
  color: #FFF;
}
[data-theme=dark] .header .menu-drop-user .dropdown-item {
  border-color: #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li {
  border-bottom: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-title {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-details {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li p.noti-time {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon span {
  border: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text p {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text span {
  color: #B5B5B5;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #565E5E;
}
[data-theme=dark] .header .notification-dropdown .topnav-dropdown-footer {
  background: #171724;
}
[data-theme=dark] .header .searchinputs input {
  border-color: #393947;
  background: transparent;
}
[data-theme=dark] .header .searchinputs .search-addon button {
  color: #B5B5B5;
}
[data-theme=dark] .header .menus-info .menu-list li a {
  background: transparent;
  border-radius: 5px;
}
[data-theme=dark] .header .menus-info .menu-list li a:hover {
  background: transparent;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-list-icon {
  color: #FFF;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content p {
  color: #FFF;
  margin-bottom: 0;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content span {
  font-weight: 400;
  color: #B5B5B5;
}
[data-theme=dark] .sidebar {
  background-color: #171724;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #28283E;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu ul > li ul li a span {
  color: #a3a6a6;
}
[data-theme=dark] .sidebar .sidebar-menu .menu-arrow:before {
  border-bottom: 2px solid #a3a6a6;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-head .table-action .action-icon {
  background: #393947;
  color: #FFF;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-footer {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .title-head {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings {
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header h4 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content h6 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect .checkboxs-theme:after {
  border-color: #393947;
}
[data-theme=dark] .form-check-label,
[data-theme=dark] .form-label,
[data-theme=dark] .sub-header {
  color: #a3a6a6;
}
[data-theme=dark] .form-select option {
  background: transparent;
}
[data-theme=dark] .icon-form .form-icon {
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a,
[data-theme=dark] .export-dropdwon > a,
[data-theme=dark] .form-sorts > a {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a:hover,
[data-theme=dark] .export-dropdwon > a:hover,
[data-theme=dark] .form-sorts > a:hover {
  color: #a3a6a6;
}
[data-theme=dark] .manage-dropdwon .dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-sorts .filter-set-content .filter-set-content-head a {
  color: #a3a6a6;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single {
  border-color: #393947;
}
[data-theme=dark] .form-sorts .filter-dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .status-radio:checked + label,
[data-theme=dark] .status-radio:not(:checked) + label {
  color: #a3a6a6;
}
[data-theme=dark] .filter-set-contents .filter-content-list {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .dataTables_length label .form-select,
[data-theme=dark] #dataTables_length label .form-select {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .view-icons {
  border-color: #393947;
}
[data-theme=dark] .toast {
  background-color: #1A1A25;
}
[data-theme=dark] .select2-selection--multiple {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
  color: #a3a6a6;
}
[data-theme=dark] .twitter-bs-wizard .twitter-bs-wizard-nav .step-icon {
  border-color: #FFF;
  color: #FFF;
}
[data-theme=dark] .text-dark {
  color: #a3a6a6 !important;
}
[data-theme=dark] .select2-container--default .select2-selection--single {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered {
  box-shadow: none;
  border: 1px solid #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow {
  box-shadow: none;
}
[data-theme=dark] .toggle-popup .sidebar-layout,
[data-theme=dark] .toggle-popup1 .sidebar-layout,
[data-theme=dark] .toggle-popup2 .sidebar-layout {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .user-accordion-item .accordion-wrap {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .accordion-wrap:hover {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .content-collapse {
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .user-accordion-item,
[data-theme=dark] .files-wrap,
[data-theme=dark] .contact-wrap,
[data-theme=dark] .notes-activity .note-download,
[data-theme=dark] .contact-tab-wrap,
[data-theme=dark] .contact-tab-view,
[data-theme=dark] .calls-box,
[data-theme=dark] .notes-activity .reply-box,
[data-theme=dark] .note-download {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-sidebar, [data-theme=dark] .contact-tab-view {
  background-color: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .action-drop .dropdown-toggle {
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .upcoming-info {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-user p span {
  color: #a3a6a6;
  font-weight: 500;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-toggle {
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  box-shadow: none;
}
[data-theme=dark] .contact-grid {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-grid .grid-head .users-profile .name-user h6 a {
  color: #FFF;
}
[data-theme=dark] .contact-grid .grid-body .address-info p i {
  color: #a3a6a6;
}
[data-theme=dark] .contact-grid .grid-footer {
  border-color: #393947;
}
[data-theme=dark] .company-info li span {
  border-color: #393947;
}
[data-theme=dark] .contacts-action .btn-icon, [data-theme=dark] .contacts-action .btn-icon.rating {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .contacts-action .act-dropdown > a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .social-info li a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .view-header .form-sort .select2-container .select2-selection .select2-selection__rendered {
  color: #a3a6a6;
}
[data-theme=dark] .basic-info li span {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .badge-day {
  color: #a3a6a6;
  background: #3d3d64;
}
[data-theme=dark] .contact-nav li a {
  border-color: transparent;
}
[data-theme=dark] .upcoming-info .dropdown .dropdown-toggle {
  color: #a3a6a6;
}
[data-theme=dark] .contact-sidebar ul, [data-theme=dark] .view-header, [data-theme=dark] .activity-wrap {
  border-color: #393947;
}
[data-theme=dark] .search-section {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default .select2-results__option--selected {
  background: #e85b28;
  color: #FFF;
}
[data-theme=dark] .form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background: transparent;
}
[data-theme=dark] .select2-dropdown {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .select2-dropdown ul li {
  color: #FFF;
}
[data-theme=dark] .btn-outline-light {
  color: #a3a6a6 !important;
}
[data-theme=dark] .page-wrapper {
  background: #151525;
}
[data-theme=dark] .page-wrapper .page-header h3 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header h4 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header .head-icons a {
  border-color: #393947;
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-title {
  color: #FFF;
}
[data-theme=dark] .note-editable.card-block {
  color: #FFF;
}
[data-theme=dark] .accordion-item {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .accordion-item .accordion-body {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .accordion-button {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .seprator-lg {
  border-color: #393947;
}
[data-theme=dark] .card {
  background: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .card.bg-white {
  background: #1E1E2D !important;
}
[data-theme=dark] .card.main-card {
  background: #28283E;
  box-shadow: none;
}
[data-theme=dark] .card.custom-card {
  background: #28283E;
}
[data-theme=dark] .card.custom-card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card.custom-card .card-footer {
  border-color: #393947;
}
[data-theme=dark] .card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card .card-header .card-title {
  color: #FFF;
}
[data-theme=dark] .card .card-header .card-text {
  color: #a3a6a6;
}
[data-theme=dark] .card .card-body {
  color: #a3a6a6;
}
[data-theme=dark] .col-form-label {
  color: #a3a6a6;
}
[data-theme=dark] .custom-table .table-responsive {
  border-color: #393947;
}
[data-theme=dark] .btn-purple-light {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .btn-purple-light:hover {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  background: #171724;
}
[data-theme=dark] .note-btn-group .note-btn {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  border-color: #393947;
}
[data-theme=dark] .table-action .action-icon {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header {
  border-color: #171724;
}
[data-theme=dark] table.table.table-primary {
  background: #171724;
}
[data-theme=dark] table.table thead {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .statistic-header h4 {
  color: #FFF;
}
[data-theme=dark] .statistic-header h4 i {
  color: #B5B5B5;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle {
  color: #FFF;
  border: 1px solid #1A1A25;
  box-shadow: none;
  background: #1A1A25;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle:after {
  border-bottom: 2px solid #B5B5B5;
  border-left: 2px solid #B5B5B5;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu a {
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup1 .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup2 .sidebar-layout .sidebar-header {
  border-color: #393947;
}
[data-theme=dark] .form-control, [data-theme=dark] .form-select {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-control:disabled, [data-theme=dark] .form-select:disabled {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .form-control:focus, [data-theme=dark] .form-select:focus {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .input-group-text {
  background: #393947;
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .radio label, [data-theme=dark] .checkbox label {
  color: #a3a6a6;
}
[data-theme=dark] .apexcharts-text tspan {
  fill: #FFF;
}
[data-theme=dark] a {
  color: #FFF;
}
[data-theme=dark] a.label-add {
  color: #e85b28;
}
[data-theme=dark] .settings-sub-header {
  border-color: #393947;
}
[data-theme=dark] .profile-details {
  border-color: #393947;
}
[data-theme=dark] .profile-upload .profile-upload-img {
  border-color: #393947;
}
[data-theme=dark] .settings-sidebar ul li a {
  color: #B5B5B5;
}
[data-theme=dark] .settings-sidebar ul li a:hover {
  color: #FFF;
}
[data-theme=dark] .settings-sidebar ul li a.active {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light {
  background-color: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light:hover {
  background-color: rgb(3.1186440678, 3.1186440678, 4.8813559322);
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .security-grid {
  border-color: #393947;
  background: #1E1E2D;
}
[data-theme=dark] .security-grid .security-heading h5 {
  color: #FFF;
}
[data-theme=dark] .notification-wrap ul li .security-checkbox .checkboxs {
  color: #FFF;
}
[data-theme=dark] .notificaion-table .table tbody tr td {
  color: #FFF;
}
[data-theme=dark] .integration-grid {
  background: #28283E;
  border-color: #28283E;
}
[data-theme=dark] .integration-grid .integration-content p {
  color: #FFF;
}
[data-theme=dark] .storage-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .storage-icon h6 {
  color: #FFF;
}
[data-theme=dark] .black-text {
  color: #FFF !important;
}
[data-theme=dark] .theme-type-images .theme-image {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .theme-type-images .theme-image span {
  color: #FFF;
}
[data-theme=dark] .table tbody tr td a {
  color: #FFF;
}
[data-theme=dark] .text-black {
  color: #FFF !important;
}
[data-theme=dark] .lang-flag a {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .modal .modal-content {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .modal-header {
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .col-form-label {
  color: #FFF;
}
[data-theme=dark] .drag-attach {
  border-color: #393947;
}
[data-theme=dark] .upload-file {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .lang-type li a {
  background: #171724;
}
[data-theme=dark] .dropdown-menu {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .table-action .dropdown-menu a {
  color: #B5B5B5;
}
[data-theme=dark] .table-action .dropdown-menu a:hover {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn-add {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon {
  background: #1A1A25;
  border-color: #393947;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon:hover {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon::after {
  background: #393947;
}
[data-theme=dark] .mail-wrapper .mail-collapse {
  border-color: #393947;
}
[data-theme=dark] .bank-box {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .bank-box.active::after {
  background-color: #28283E;
}
[data-theme=dark] .bank-box .table-action .action-icon:hover {
  background: #1A1A25;
}
[data-theme=dark] .custom-modal .modal-header .btn-close {
  border-color: #393947;
  background: #1A1A25;
  box-shadow: none;
}
[data-theme=dark] .storage-wrap .storage-icon .system-app-icon {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .setting-gateway a {
  color: #B5B5B5;
}
[data-theme=dark] .ip-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon:hover {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .action-drop .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .action-drop .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .notes-activity .note-download:hover {
  background-color: transparent;
}
[data-theme=dark] .notes-activity .note-download:hover a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .notes-activity .note-download a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .bootstrap-tagsinput .tag {
  background: #28283D;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .profile-pic-upload .profile-pic {
  border-color: #393947;
}
[data-theme=dark] .contact-wrap .contact-profile .avatar.company-avatar {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default.select2-container--focus .select2-selection--multiple,
[data-theme=dark] .select2-container--default .select2-selection--multiple {
  border-color: #393947;
}
[data-theme=dark] .select2-container--classic .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background: #28283D;
  border-color: #393947;
}
[data-theme=dark] .title-name {
  color: #FFF !important;
}
[data-theme=dark] .kanban-list-items {
  border-color: #393947;
}
[data-theme=dark] .kanban-list-items .kanban-list-head {
  background: #28283E;
}
[data-theme=dark] .kanban-list-items .kanban-list-head .kanban-action-btns .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .email-header .btn-white {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .pipeline-list {
  border-color: #393947;
}
[data-theme=dark] .priority-info .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .priority-info .dropdown a {
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-item {
  border-color: #393947;
}
[data-theme=dark] .pipeline-item p {
  color: #FFF;
}
[data-theme=dark] .kanban-card {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-body ul li {
  color: #B5B5B5;
}
[data-theme=dark] .kanban-card .kanban-card-footer {
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-footer span {
  border-color: #393947;
}
[data-theme=dark] .campaign-tab {
  background: #28283E;
}
[data-theme=dark] .campaign-tab ul li a {
  border-color: transparent;
}
[data-theme=dark] .campaign-tab ul li a.active {
  color: #e85b28;
}
[data-theme=dark] .campaign-tab ul li a span {
  border-color: #393947;
}
[data-theme=dark] ul.project-mem li.more-set a {
  background: #28283E;
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-progress span, [data-theme=dark] .task-info p,
[data-theme=dark] .con-sidebar-title p, [data-theme=dark] .task-actions ul li {
  color: #FFF;
}
[data-theme=dark] .contact-grid.project .grid-head {
  background-color: #28283E;
}
[data-theme=dark] .contact-grid.project .grid-head .users-profile .con-avatar {
  background-color: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .access-wrap li:hover {
  background: #28283E;
}
[data-theme=dark] .task-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .rate-icon, [data-theme=dark] .con-sidebar-title.border-line {
  border-color: #393947;
}
[data-theme=dark] .pipeline-list ul li a.bg-gray {
  color: #262A2A;
}
[data-theme=dark] .task-wrapper .task-accordion span {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .task-drops .dropdown-toggle {
  background-color: transparent;
}
[data-theme=dark] .task-wrapper {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card {
  background-color: #1E1E2D;
}
[data-theme=dark] .card.analytics-card .card-header {
  background: transparent;
}
[data-theme=dark] .card.analytics-card .card-header .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .activities-list ul li {
  background: #28283E;
}
[data-theme=dark] .activities-list ul li .activity-name h5 {
  color: #FFF;
}
[data-theme=dark] .campaign-card ul .campaign-wrap {
  background: #28283E;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info {
  border-color: #393947;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info h5 {
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th {
  background: #171724;
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th:first-child, [data-theme=dark] .card.analytics-card .card-body .table th:last-child {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card .card-body .table td:first-child, [data-theme=dark] .card.analytics-card .card-body .table td:last-child {
  border-color: #393947;
}
[data-theme=dark] .active-list ul li a {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .activity-title h4::after {
  background: #393947;
}
[data-theme=dark] .header-set {
  border-color: #393947;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .radio-activity li .active-type input[type=radio] ~ label {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .tab-activity {
  box-shadow: none;
}
[data-theme=dark] .tab-activity ul li a span {
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .report-header {
  border-color: #393947;
}
[data-theme=dark] .location-flag-img {
  border-color: #393947;
}
[data-theme=dark] .table-imgname.flag-image span {
  color: #FFF;
}
[data-theme=dark] .membership-plans .plan-selected h4 {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active {
  background-color: #1E1E2D;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .file-manager aside {
  border-color: #393947;
}
[data-theme=dark] .notes-dash {
  background-color: #28283E;
}
[data-theme=dark] .notes-dash .notes-top-head {
  border-color: #393947;
}
[data-theme=dark] .notes-dash .notes-top-head-submenu {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-card-body .notes-card-details {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .search-set .search-input input[type=search] {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .search-set .search-input input[type=search]::placeholder {
  color: #B5B5B5;
}
[data-theme=dark] .todo-wrapper-list {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-bulk-wrap {
  background-color: #28283E;
  box-shadow: none;
}
[data-theme=dark] .notes-page-wrapper .content .page-add-notes {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-notes-slider {
  border-color: #393947;
}
[data-theme=dark] .fc-day {
  background-color: #28283E;
}
[data-theme=dark] .file-manager .folders {
  border-color: #393947;
  background-color: #28283E;
}
[data-theme=dark] .file-manager .accordion .accordion-item .accordion-body {
  background: transparent;
}
[data-theme=dark] table tbody td.action-table-data a {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat .chat-header {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .left-chat-title {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .chat .chat-header .user-details h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body p {
  color: #B5B5B5;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #B5B5B5 !important;
}
[data-theme=dark] .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li a {
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .last-seen {
  color: #B5B5B5;
}
[data-theme=dark] .daterangepicker {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .daterangepicker.show-ranges.ltr .drp-calendar.left {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons .btn-default {
  color: #B5B5B5;
}

.topnav-dropdown-header {
  padding: 15px;
  border-bottom: 1px solid #E8E8E8;
}
.topnav-dropdown-header .notification-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin-bottom: 0;
}

.notification-dropdown .noti-content {
  width: 440px;
  height: 390px;
  overflow-y: auto;
  position: relative;
}
.notification-dropdown .notification-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.notification-dropdown .notification-list li {
  margin-top: 0;
  border-bottom: 1px solid #F4F4F4;
  font-size: 14px;
}
.notification-dropdown .notification-list li:last-child {
  border-bottom: 0;
}
.notification-dropdown .notification-list li a {
  display: block;
  padding: 15px;
}
.notification-dropdown .notification-list li .avatar {
  width: 36px;
  height: 36px;
  margin: 0 16px 0 0;
  border-radius: 5px;
  position: relative;
}
.notification-dropdown .notification-list li .avatar img {
  border-radius: 5px;
}
.notification-dropdown .notification-list li .avatar .badge {
  display: inline-block;
  position: absolute;
  top: -7px;
  left: -7px;
  padding: 4px;
}
.notification-dropdown .notification-list li .noti-title {
  color: #323737;
  font-weight: 500;
}
.notification-dropdown .notification-list li .noti-details {
  font-weight: 500;
  color: #6F6F6F;
  margin: 0 0 8px;
}
.notification-dropdown .notification-list li .noti-sub-details {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #6F6F6F;
  position: relative;
  margin: 0 0 8px;
  padding: 0 0 0 15px;
}
.notification-dropdown .notification-list li .noti-sub-details::before {
  content: "";
  position: absolute;
  left: 0;
  width: 4px;
  height: -webkit-fill-available;
  background: #6F6F6F;
  border-radius: 5px;
}
.notification-dropdown .notification-list li p.noti-time {
  font-size: 12px;
  color: #262A2A;
  margin: 0;
}
.notification-dropdown .notification-list li .noti-pdf {
  display: inline-flex;
  align-items: center;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 8px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon {
  margin-right: 10px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #e85b28;
  width: 24px;
  min-width: 24px;
  height: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text {
  line-height: normal;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text p {
  font-size: 12px;
  color: #262A2A;
  margin-bottom: 0;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text span {
  font-size: 12px;
  color: #6F6F6F;
}
.notification-dropdown .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #565E5E;
}
.notification-dropdown .notification-list li .list-item {
  border: 0;
  padding: 0;
  position: relative;
}
.notification-dropdown .notification-list li .list-item .list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}
.notification-dropdown .notification-list li .list-item .list-body {
  padding: 0 0 0 50px;
}
.notification-dropdown .notification-list li .list-item .list-body .message-author {
  color: #323737;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notification-dropdown .notification-list li .list-item .list-body .message-time {
  color: #565E5E;
  float: right;
  font-size: 11px;
}
.notification-dropdown .notification-list li .list-item .list-body .message-content {
  color: #323737;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topnav-dropdown-footer {
  background: #F9F9FC;
  text-align: right;
  padding: 15px;
}
.topnav-dropdown-footer a {
  font-weight: 600;
  margin-right: 15px;
}
.topnav-dropdown-footer a:last-child {
  margin-right: 0;
}
.topnav-dropdown-footer .view-link {
  color: #262A2A;
}
.topnav-dropdown-footer .view-link:hover {
  color: #6F6F6F;
}
.topnav-dropdown-footer .clear-link {
  color: #e85b28;
}
.topnav-dropdown-footer .clear-link:hover {
  color: rgb(199.6428571429, 68.7142857143, 21.3571428571);
}

.list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}

.list-body {
  padding: 0 0 0 50px;
}
.list-body .message-author {
  color: #323737;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-body .message-time {
  color: #565E5E;
  float: right;
  font-size: 11px;
}
.list-body .message-content {
  color: #323737;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity {
  width: 100%;
}
.activity .activity-box {
  position: relative;
}
.activity .activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}
.activity .activity-list li {
  background-color: #FFF;
  position: relative;
  border: 1px solid #6F6F6F;
  margin: 0 0 10px;
  padding: 20px 10px 10px;
  font-size: 15px;
}
.activity .activity-list li .activity-user {
  height: 50px;
  margin: 0;
  padding: 0;
  width: 50px;
  position: absolute;
  top: 12px;
  left: 8px;
}
.activity .activity-list li .activity-content {
  background-color: #FFF;
  position: relative;
  margin: 0 0 0 60px;
  padding: 0;
}
.activity .activity-list li .time {
  color: #6F7A7A;
  display: block;
  font-size: 12px;
  line-height: 1.35;
}
.activity .activity-list li a.name {
  color: #000;
}
.activity .activity-list li a {
  color: #FFA201;
  font-weight: 600;
  font-size: 15px;
}
.activity .activity-list li a img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
}

/******* Components ******/
.avatar {
  position: relative;
  height: 2.625rem;
  width: 2.625rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #FFF;
  font-weight: 500;
}
.avatar a.badge:hover {
  color: #FFF;
}
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.avatar.avatar-rounded {
  border-radius: 50%;
}
.avatar.avatar-rounded img {
  border-radius: 50%;
}
.avatar.avatar-radius-0 {
  border-radius: 0;
}
.avatar.avatar-radius-0 img {
  border-radius: 0;
}
.avatar .avatar-badge {
  position: absolute;
  inset-block-start: -4%;
  inset-inline-end: -0.375rem;
  width: 1.4rem;
  height: 1.4rem;
  font-size: 0.625rem;
  border: 2px solid #FFF;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar.online:before, .avatar.offline:before {
  position: absolute;
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  inset-inline-end: 0;
  inset-block-end: 0;
  border: 2px solid #FFF !important;
  z-index: 1;
}
.avatar.online:before {
  background-color: #5CB85C;
}
.avatar.offline:before {
  background-color: #6F7A7A;
}
.avatar.avatar-xs {
  width: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
  font-size: 0.65rem;
}
.avatar.avatar-xs .avatar-badge {
  padding: 0.25rem;
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.5rem;
  inset-block-start: -25%;
  inset-inline-end: -0.5rem;
}
.avatar.avatar-sm {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 0.65rem;
}
.avatar.avatar-sm .avatar-badge {
  padding: 0.3rem;
  width: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.5rem;
  inset-block-start: -28%;
  inset-inline-end: -0.45rem;
}
.avatar.avatar-sm.online:before, .avatar.avatar-sm.offline:before {
  width: 0.5rem;
  height: 0.5rem;
}
.avatar.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 0.8rem;
}
.avatar.avatar-md .avatar-badge {
  padding: 0.4rem;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.65rem;
  inset-block-start: -6%;
  inset-inline-end: -13%;
}
.avatar.avatar-md.online:before, .avatar.avatar-md.offline:before {
  width: 0.75rem;
  height: 0.75rem;
}
.avatar.avatar-md svg {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar.avatar-lg {
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  font-size: 1rem;
}
.avatar.avatar-lg .avatar-badge {
  inset-block-start: -15%;
  inset-inline-end: -0.25%;
}
.avatar.avatar-lg.online:before, .avatar.avatar-lg.offline:before {
  width: 0.8rem;
  height: 0.8rem;
}
.avatar.avatar-lg svg {
  width: 1.8rem;
  height: 1.8rem;
}
.avatar.avatar-xl {
  width: 4rem;
  height: 4rem;
  line-height: 4rem;
  font-size: 1.25rem;
}
.avatar.avatar-xl .avatar-badge {
  inset-block-start: -8%;
  inset-inline-end: -0.2%;
}
.avatar.avatar-xl.online:before, .avatar.avatar-xl.offline:before {
  width: 0.95rem;
  height: 0.95rem;
}
.avatar.avatar-xxl {
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.5rem;
}
.avatar.avatar-xxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxl.online:before, .avatar.avatar-xxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}
.avatar.avatar-xxl.online.online-sm:before, .avatar.avatar-xxl.offline.online-sm:before {
  width: 10px;
  height: 10px;
  inset-block-end: 0rem;
}
.avatar.avatar-xxxl {
  width: 6rem;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.75rem;
}
.avatar.avatar-xxxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxxl.online:before, .avatar.avatar-xxxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}

.avatar-list-stacked {
  padding: 0;
}
.avatar-list-stacked.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-list-stacked.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-list-stacked.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-list-stacked.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-list-stacked.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-list-stacked.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-list-stacked.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-list-stacked.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}
.avatar-list-stacked.avatar-group-xs .avatar {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar-list-stacked.avatar-group-xs .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-list-stacked .avatar {
  margin-inline-end: -0.875rem !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  vertical-align: middle;
  transition: transform ease 200ms;
}
.avatar-list-stacked .avatar:last-child {
  margin-inline-end: 0 !important;
}
.avatar-list-stacked .avatar:hover {
  z-index: 1;
  transform: translateY(-0.188rem);
}

.avatar-group {
  display: inline-flex;
}
.avatar-group .avatar {
  width: 2.625rem;
  height: 2.625rem;
}
.avatar-group .avatar .avatar-img,
.avatar-group .avatar > .initial-wrap {
  border: 2px solid #FFF;
  font-size: 0.9rem;
}
.avatar-group.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-group.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-group.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-group.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-group.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-group.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-group.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-group.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}

.avatar-xxs {
  width: 16px;
  height: 16px;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #FDA700;
  text-shadow: inherit;
}

.bootstrap-datetimepicker-widget table td.today:before {
  border-bottom-color: #FDA700;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
  background: transparent;
}

.bor-b1 {
  border-bottom: 1px solid #898989;
}

.link-purple {
  color: #4A00E5;
}
.link-purple:hover {
  color: rgb(70.703930131, 0, 218.8);
}

hr {
  border-color: #E8E8E8;
}

.btn-primary {
  color: #FFF;
  background-color: #e85b28;
  border-color: #e85b28;
  font-size: 14px;
  font-size: 14px;
}

.btn-save {
  background: #e85b28;
  color: #FFF;
  font-size: 14px;
  font-size: 14px;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-save:hover {
  background: rgb(199.6428571429, 68.7142857143, 21.3571428571);
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-save {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-reset {
  background: #6F6F6F;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-reset:hover {
  background: #FFA201;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-reset {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-send {
  background: #e85b28;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-send:hover {
  background: rgb(199.6428571429, 68.7142857143, 21.3571428571);
  color: #FFF;
}
.btn-send .send-mail {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-download {
  background: #FFA201;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-download:hover {
  background: #262A2A;
  color: #FFF;
}
.btn-download .download {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-barcode {
  background: #FC0027;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-barcode:hover {
  background: #FC0027;
  color: #FFF;
}
.btn-barcode .print {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-primary.add-em-payroll {
  padding: 9px 11px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.btn-primary.add-em-payroll .me-2 {
  width: 16px;
  height: 16px;
}

.swal2-actions .swal2-confirm.btn:active {
  background-color: #e85b28;
  border-color: #e85b28;
}

.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {
  background-color: #e85b28;
  border-color: #e85b28;
  color: #FFF;
}

.modal .card {
  border: 0;
}

.search-input .btn-searchset:active {
  background-color: transparent;
  border-color: transparent;
}
.search-input .btn-searchset:active svg {
  color: #FFA201;
}

.input-blocks input[type=text].datetimepicker {
  padding-left: 35px;
}

.iti__country-list {
  z-index: 101;
}

button {
  cursor: pointer;
}
button:focus {
  outline: 0;
  box-shadow: none;
}

.btn {
  border-radius: 5px;
  padding: 0.625rem 1.25rem;
  padding: 0.5rem 0.85rem;
  font-size: 0.85rem;
  transition: all 0.5s;
  font-weight: 600;
}
.btn:focus {
  box-shadow: none !important;
}
.btn:hover {
  transition: all 0.5s;
}
.btn.btn-lg {
  padding: 0.65rem 1rem;
  font-size: 0.95rem;
}
.btn.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
.btn.btn-primary {
  background-color: #e85b28;
  border: 1px solid #e85b28;
  color: #FFF;
}
.btn.btn-primary:hover, .btn.btn-primary:focus, .btn.btn-primary.focus, .btn.btn-primary:active, .btn.btn-primary.active {
  background-color: rgb(213.4642857143, 73.4714285714, 22.8357142857);
  border: 1px solid rgb(213.4642857143, 73.4714285714, 22.8357142857);
  color: #FFF;
}
.btn.btn-secondary {
  background-color: #FFA201;
  border: 1px solid #FFA201;
  color: #FFF;
}
.btn.btn-secondary:hover, .btn.btn-secondary:focus, .btn.btn-secondary.focus, .btn.btn-secondary:active, .btn.btn-secondary.active {
  background-color: rgb(220.3, 139.638976378, 0);
  border: 1px solid rgb(220.3, 139.638976378, 0);
  color: #FFF;
}
.btn.btn-success {
  background-color: #5CB85C;
  border: 1px solid #5CB85C;
  color: #FFF;
}
.btn.btn-success:hover, .btn.btn-success:focus, .btn.btn-success.focus, .btn.btn-success:active, .btn.btn-success.active {
  background-color: rgb(72.9115384615, 167.3884615385, 72.9115384615);
  border: 1px solid rgb(72.9115384615, 167.3884615385, 72.9115384615);
  color: #FFF;
}
.btn.btn-info {
  background-color: #1ECBE2;
  border: 1px solid #1ECBE2;
  color: #FFF;
}
.btn.btn-info:hover, .btn.btn-info:focus, .btn.btn-info.focus, .btn.btn-info:active, .btn.btn-info.active {
  background-color: rgb(25.1523622047, 175.1992125984, 195.1476377953);
  border: 1px solid rgb(25.1523622047, 175.1992125984, 195.1476377953);
  color: #FFF;
}
.btn.btn-warning {
  background-color: #FDA700;
  border: 1px solid #FDA700;
  color: #FFF;
}
.btn.btn-warning:hover, .btn.btn-warning:focus, .btn.btn-warning.focus, .btn.btn-warning:active, .btn.btn-warning.active {
  background-color: rgb(217.3, 143.4351778656, 0);
  border: 1px solid rgb(217.3, 143.4351778656, 0);
  color: #FFF;
}
.btn.btn-danger {
  background-color: #FC0027;
  border: 1px solid #FC0027;
  color: #FFF;
}
.btn.btn-danger:hover, .btn.btn-danger:focus, .btn.btn-danger.focus, .btn.btn-danger:active, .btn.btn-danger.active {
  background-color: rgb(216.3, 0, 33.475);
  border: 1px solid rgb(216.3, 0, 33.475);
  color: #FFF;
}
.btn.btn-dark {
  background-color: #171724;
  border: 1px solid #171724;
  color: #FFF;
}
.btn.btn-dark:hover, .btn.btn-dark:focus, .btn.btn-dark.focus, .btn.btn-dark:active, .btn.btn-dark.active {
  background-color: rgb(9.0830508475, 9.0830508475, 14.2169491525);
  border: 1px solid rgb(9.0830508475, 9.0830508475, 14.2169491525);
  color: #FFF;
}
.btn.btn-light {
  background-color: #FDFDFE;
  border: 1px solid #FDFDFE;
  color: #FFF;
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: rgb(229.2, 229.2, 242.1);
  border: 1px solid rgb(229.2, 229.2, 242.1);
  color: #FFF;
}
.btn.btn-black {
  background-color: #000;
  border: 1px solid #000;
  color: #FFF;
}
.btn.btn-black:hover, .btn.btn-black:focus, .btn.btn-black.focus, .btn.btn-black:active, .btn.btn-black.active {
  background-color: black;
  border: 1px solid black;
  color: #FFF;
}
.btn.btn-purple {
  background-color: #4A00E5;
  border: 1px solid #4A00E5;
  color: #FFF;
}
.btn.btn-purple:hover, .btn.btn-purple:focus, .btn.btn-purple.focus, .btn.btn-purple:active, .btn.btn-purple.active {
  background-color: rgb(62.4637554585, 0, 193.3);
  border: 1px solid rgb(62.4637554585, 0, 193.3);
  color: #FFF;
}
.btn.btn-yellow {
  background-color: #ffff00;
  border: 1px solid #ffff00;
  color: #FFF;
}
.btn.btn-yellow:hover, .btn.btn-yellow:focus, .btn.btn-yellow.focus, .btn.btn-yellow:active, .btn.btn-yellow.active {
  background-color: rgb(219.3, 219.3, 0);
  border: 1px solid rgb(219.3, 219.3, 0);
  color: #FFF;
}
.btn.btn-teal {
  background-color: #02a8b5;
  border: 1px solid #02a8b5;
  color: #FFF;
}
.btn.btn-teal:hover, .btn.btn-teal:focus, .btn.btn-teal.focus, .btn.btn-teal:active, .btn.btn-teal.active {
  background-color: rgb(1.6098360656, 135.2262295082, 145.6901639344);
  border: 1px solid rgb(1.6098360656, 135.2262295082, 145.6901639344);
  color: #FFF;
}
.btn.btn-light {
  background-color: #F5F5F5;
  border: 1px solid #E8E8E8;
  color: #262A2A;
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: rgb(237.35, 237.35, 237.35);
  border: 1px solid #E8E8E8;
  color: #262A2A;
}

.btn-group .btn {
  padding: 0.45rem 0.75rem;
}

.btn-group-lg .btn {
  padding: 0.65rem 1rem;
}

.btn-group-sm .btn {
  padding: 0.25rem 0.5rem;
}

.btn.btn-w-xs {
  min-width: 5.625rem;
}
.btn.btn-w-sm {
  min-width: 6.975rem;
}
.btn.btn-w-md {
  min-width: 8.125rem;
}
.btn.btn-w-lg {
  min-width: 9.375rem;
}

.btn-icon i {
  padding: 0rem;
  margin: -0.5rem;
}
.btn-icon.btn-sm {
  width: 1.75rem;
  height: 1.75rem;
  font-size: 0.8rem;
}
.btn-icon.btn-lg {
  width: 2.75rem;
  height: 2.75rem;
  font-size: 1.2rem;
}

.btn-list > button, .btn-list > a {
  margin: 0 0.375rem 0.375rem 0;
}

[dir=rtl] .btn-list button,
[dir=rtl] .btn-list div,
[dir=rtl] .btn-list a,
[dir=rtl] .btn-list input {
  margin: 0 0 0.375rem 0.375rem;
}

.btn-list {
  margin-block-end: -0.5rem;
}

.btn-square {
  border-radius: 0;
}

.btn-group-pill .btn:first-child {
  border-radius: 60px 0 0 60px;
}

.btn-group-pill .btn:last-child {
  border-radius: 0 60px 60px 0;
}

.btn-group-square .btn:first-child {
  border-radius: 0px 0 0 0px;
}

.btn-group-square .btn:last-child {
  border-radius: 0 0px 0px 0;
}

.btn.btn-primary-light {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}
.btn.btn-primary-light:hover, .btn.btn-primary-light:focus, .btn.btn-primary-light:active {
  background-color: #e85b28;
  color: #FFF;
  border-color: #e85b28;
}
.btn.btn-secondary-light {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.btn.btn-secondary-light:hover, .btn.btn-secondary-light:focus, .btn.btn-secondary-light:active {
  background-color: #FFA201;
  color: #FFF;
  border-color: #FFA201;
}
.btn.btn-warning-light {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.btn.btn-warning-light:hover, .btn.btn-warning-light:focus, .btn.btn-warning-light:active {
  background-color: #FDA700;
  color: #FFF;
  border-color: #FDA700;
}
.btn.btn-info-light {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.btn.btn-info-light:hover, .btn.btn-info-light:focus, .btn.btn-info-light:active {
  background-color: #1ECBE2;
  color: #FFF;
  border-color: #1ECBE2;
}
.btn.btn-success-light {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.btn.btn-success-light:hover, .btn.btn-success-light:focus, .btn.btn-success-light:active {
  background-color: #5CB85C;
  color: #FFF;
  border-color: #5CB85C;
}
.btn.btn-danger-light {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.btn.btn-danger-light:hover, .btn.btn-danger-light:focus, .btn.btn-danger-light:active {
  background-color: #FC0027;
  color: #FFF;
  border-color: #FC0027;
}

.btn.btn-primary-ghost {
  background-color: transparent;
  color: #e85b28;
  border: 1px solid #e85b28;
}
.btn.btn-primary-ghost:active {
  color: #e85b28;
  border: 1px solid #e85b28;
  background-color: transparent;
}
.btn.btn-dark {
  background: #131022 !important;
  border-color: #131022 !important;
  box-shadow: none;
  color: #fff;
}
.btn.btn-dark:hover {
  background: #e85b28;
}
.btn.btn-secondary-ghost {
  background-color: transparent;
  color: #FFA201;
  border: 1px solid #FFA201;
}
.btn.btn-secondary-ghost:active {
  color: #FFA201;
  border: 1px solid #FFA201;
  background-color: transparent;
}
.btn.btn-warning-ghost {
  background-color: transparent;
  color: #FDA700;
  border: 1px solid #FDA700;
}
.btn.btn-warning-ghost:active {
  color: #FDA700;
  border: 1px solid #FDA700;
  background-color: transparent;
}
.btn.btn-info-ghost {
  background-color: transparent;
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
}
.btn.btn-info-ghost:active {
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
  background-color: transparent;
}
.btn.btn-success-ghost {
  background-color: transparent;
  color: #5CB85C;
  border: 1px solid #5CB85C;
}
.btn.btn-success-ghost:active {
  color: #5CB85C;
  border: 1px solid #5CB85C;
  background-color: transparent;
}
.btn.btn-danger-ghost {
  background-color: transparent;
  color: #FC0027;
  border: 1px solid #FC0027;
}
.btn.btn-danger-ghost:active {
  color: #FC0027;
  border: 1px solid #FC0027;
  background-color: transparent;
}

.btn-list button {
  margin: 0 0.375rem 0.375rem 0;
}

.btn-outline-primary {
  border: 1px solid #e85b28 !important;
  color: #e85b28 !important;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary.focus, .btn-outline-primary:active, .btn-outline-primary.active {
  background-color: #e85b28 !important;
  border: 1px solid #e85b28 !important;
  box-shadow: 0 3px 10px rgba(232, 91, 40, 0.5);
  color: #FFF !important;
}

.btn-outline-secondary {
  border: 1px solid #FFA201 !important;
  color: #FFA201 !important;
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus, .btn-outline-secondary.focus, .btn-outline-secondary:active, .btn-outline-secondary.active {
  background-color: #FFA201 !important;
  border: 1px solid #FFA201 !important;
  box-shadow: 0 3px 10px rgba(255, 162, 1, 0.5);
  color: #FFF !important;
}

.btn-outline-success {
  border: 1px solid #5CB85C !important;
  color: #5CB85C !important;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success.focus, .btn-outline-success:active, .btn-outline-success.active {
  background-color: #5CB85C !important;
  border: 1px solid #5CB85C !important;
  box-shadow: 0 3px 10px rgba(92, 184, 92, 0.5);
  color: #FFF !important;
}

.btn-outline-danger {
  border: 1px solid #FC0027 !important;
  color: #FC0027 !important;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger.focus, .btn-outline-danger:active, .btn-outline-danger.active {
  background-color: #FC0027 !important;
  border: 1px solid #FC0027 !important;
  box-shadow: 0 3px 10px rgba(252, 0, 39, 0.5);
  color: #FFF !important;
}

.btn-outline-warning {
  border: 1px solid #FDA700 !important;
  color: #FDA700 !important;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning.focus, .btn-outline-warning:active, .btn-outline-warning.active {
  background-color: #FDA700 !important;
  border: 1px solid #FDA700 !important;
  box-shadow: 0 3px 10px rgba(253, 167, 0, 0.5);
  color: #FFF !important;
}

.btn-outline-info {
  border: 1px solid #1ECBE2 !important;
  color: #1ECBE2 !important;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info.focus, .btn-outline-info:active, .btn-outline-info.active {
  background-color: #1ECBE2 !important;
  border: 1px solid #1ECBE2 !important;
  box-shadow: 0 3px 10px rgba(30, 203, 226, 0.5);
  color: #FFF !important;
}

.btn-outline-light {
  border: 1px solid #FDFDFE;
  color: #323737 !important;
}
.btn-outline-light:hover, .btn-outline-light:focus, .btn-outline-light.focus, .btn-outline-light:active, .btn-outline-light.active {
  background-color: #FDFDFE;
  border: 1px solid #FDFDFE;
  color: #171724 !important;
}

.btn-outline-dark {
  border: 1px solid #171724 !important;
  color: #171724 !important;
}
.btn-outline-dark:hover, .btn-outline-dark:focus, .btn-outline-dark.focus, .btn-outline-dark:active, .btn-outline-dark.active {
  background-color: #171724 !important;
  border: 1px solid #171724 !important;
  box-shadow: 0 3px 10px rgba(23, 23, 36, 0.5);
  color: #FFF !important;
}

.btn-soft-primary {
  background-color: #F7BCB5 !important;
  color: #e85b28 !important;
}
.btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary.focus, .btn-soft-primary:active, .btn-soft-primary.active {
  box-shadow: 0 3px 12px rgba(232, 91, 40, 0.2);
  border-color: #e85b28;
}

.btn-soft-secondary {
  background-color: #FFE3B3 !important;
  color: #FFA201 !important;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary.focus, .btn-soft-secondary:active, .btn-soft-secondary.active {
  box-shadow: 0 3px 12px rgba(255, 162, 1, 0.2);
  border-color: #FFA201;
}

.btn-soft-success {
  background-color: #CEEACE !important;
  color: #5CB85C !important;
}
.btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success.focus, .btn-soft-success:active, .btn-soft-success.active {
  box-shadow: 0 3px 12px rgba(92, 184, 92, 0.2);
  border-color: #5CB85C;
}

.btn-soft-danger {
  background-color: #FEB3BE !important;
  color: #FC0027 !important;
}
.btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger.focus, .btn-soft-danger:active, .btn-soft-danger.active {
  box-shadow: 0 3px 12px rgba(252, 0, 39, 0.2);
  border-color: #FC0027;
}

.btn-soft-warning {
  background-color: #FEE5B3 !important;
  color: #FDA700 !important;
}
.btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning.focus, .btn-soft-warning:active, .btn-soft-warning.active {
  box-shadow: 0 3px 12px rgba(253, 167, 0, 0.2);
  border-color: #FDA700;
}

.btn-soft-info {
  background-color: rgba(30, 203, 226, 0.3) !important;
  color: #1ECBE2 !important;
}
.btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info.focus, .btn-soft-info:active, .btn-soft-info.active {
  box-shadow: 0 3px 12px rgba(30, 203, 226, 0.2);
  border-color: #1ECBE2;
}

.btn-soft-light {
  background-color: rgba(253, 253, 254, 0.9) !important;
  color: #6F6F6F !important;
}
.btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light.focus, .btn-soft-light:active, .btn-soft-light.active {
  box-shadow: 0 3px 12px rgba(253, 253, 254, 0.2);
  border-color: #FDFDFE;
  border-color: #6F6F6F;
}

.btn-soft-dark {
  background-color: rgba(23, 23, 36, 0.3) !important;
  color: #FFF !important;
}
.btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark.focus, .btn-soft-dark:active, .btn-soft-dark.active {
  box-shadow: 0 3px 12px rgba(23, 23, 36, 0.2);
  border-color: #171724;
}

.custom-btn-close.btn-close {
  background-image: none;
  transition: 0.5s all;
}
.custom-btn-close.btn-close:hover {
  background: #FC0027;
  color: #FFF;
  border-color: #FC0027 !important;
  transition: 0.5s all;
  transform: rotateZ(360deg);
}

.modal .custom-btn-close.btn-close {
  background-image: none;
  transition: 0.5s all;
  width: auto !important;
  height: auto !important;
}
.modal .custom-btn-close.btn-close:hover {
  background: #FC0027 !important;
  color: #FFF !important;
  border-color: #FC0027 !important;
  transition: 0.5s all;
  transform: rotateZ(360deg);
}

.btn-purple-light {
  background-color: #F3EDFF;
  border-color: #F3EDFF;
  color: #4A00E5;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px;
  padding: 9px 20px;
  transition: all 0.2s ease;
  align-items: center;
  display: inline-flex;
}
@media (max-width: 991.98px) {
  .btn-purple-light {
    padding: 9px 14px;
  }
}

.btn-primary {
  background: #e85b28;
  border: 1px solid #e85b28;
  transition: all 0.2s ease;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.btn-primary:hover, .btn-primary:active, .btn-primary:focus {
  background: rgb(199.6428571429, 68.7142857143, 21.3571428571);
  border-color: rgb(199.6428571429, 68.7142857143, 21.3571428571);
  color: #FFF;
  box-shadow: 0 0 0 0.2rem rgba(232, 91, 40, 0.16);
}
.btn-primary:disabled, .btn-primary.disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}
@media (max-width: 991.98px) {
  .btn-primary {
    min-width: auto;
  }
}

.btn-secondary {
  background: #475569;
  border: 1px solid #475569;
  color: #fff;
  transition: all 0.2s ease;
}
.btn-secondary:hover, .btn-secondary:active, .btn-secondary:focus {
  background: #334155;
  border-color: #334155;
  color: #fff;
  box-shadow: 0 0 0 0.2rem rgba(71, 85, 105, 0.18);
}
.btn-secondary:disabled, .btn-secondary.disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-light {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  color: #64748b;
  border-radius: 10px;
  transition: all 0.2s;
}
.btn-light:hover, .btn-light:focus, .btn-light:active {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #475569;
  box-shadow: none;
}
.btn-light:disabled, .btn-light.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.btn-outline-secondary {
  border: 1.5px solid #cbd5e1 !important;
  color: #64748b !important;
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus, .btn-outline-secondary.focus, .btn-outline-secondary:active, .btn-outline-secondary.active {
  background-color: #f8fafc !important;
  border: 1.5px solid #94a3b8 !important;
  box-shadow: 0 0 0 0.2rem rgba(148, 163, 184, 0.16) !important;
  color: #334155 !important;
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  opacity: 0.45;
  box-shadow: none !important;
}

.btn-primary:focus-visible,
.btn-secondary:focus-visible,
.btn-light:focus-visible,
.btn-success:focus-visible,
.btn-outline-secondary:focus-visible {
  outline: none;
}

/* Shared emp button classes for reusable form components */
.emp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  text-decoration: none;
  outline: none;
}
.emp-btn:focus-visible {
  box-shadow: 0 0 0 0.22rem rgba(232, 91, 40, 0.2);
}
.emp-btn:disabled, .emp-btn.disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.emp-btn--ghost {
  background: #fff;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
}

.emp-btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #475569;
}

.emp-btn--ghost:active:not(:disabled) {
  background: #f1f5f9;
  border-color: #94a3b8;
}

.emp-btn--secondary {
  background: #475569;
  color: #fff;
  box-shadow: 0 4px 14px rgba(71, 85, 105, 0.28);
}

.emp-btn--secondary:hover:not(:disabled) {
  background: #334155;
  box-shadow: 0 6px 18px rgba(51, 65, 85, 0.35);
  transform: translateY(-1px);
}

.emp-btn--secondary:active:not(:disabled) {
  transform: translateY(0);
}

.emp-btn--primary {
  background: linear-gradient(135deg, #e85b28, #f59e0b);
  color: #fff;
  box-shadow: 0 4px 14px rgba(232, 91, 40, 0.3);
}

.emp-btn--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #d4501f, #e85b28);
  box-shadow: 0 6px 18px rgba(232, 91, 40, 0.38);
  transform: translateY(-1px);
}

.emp-btn--success {
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
}

.emp-btn--success:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(5, 150, 105, 0.38);
}

.badge.badge-primary {
  background: rgba(232, 91, 40, 0.1);
  box-shadow: 0 1px 1px rgba(232, 91, 40, 0.5);
  color: #e85b28;
}

.badge.badge-primary {
  background: #e85b28;
  box-shadow: 0 1px 1px rgba(232, 91, 40, 0.5);
  color: #FFF;
}
.badge.badge-soft-primary {
  background: rgba(232, 91, 40, 0.1);
  box-shadow: 0 1px 1px rgba(232, 91, 40, 0.5);
  color: #e85b28;
}

.badge.badge-secondary {
  background: #FFA201;
  box-shadow: 0 1px 1px rgba(255, 162, 1, 0.5);
  color: #FFF;
}
.badge.badge-soft-secondary {
  background: rgba(255, 162, 1, 0.1);
  box-shadow: 0 1px 1px rgba(255, 162, 1, 0.5);
  color: #FFA201;
}

.badge.badge-success {
  background: #5CB85C;
  box-shadow: 0 1px 1px rgba(92, 184, 92, 0.5);
  color: #FFF;
}
.badge.badge-soft-success {
  background: rgba(92, 184, 92, 0.1);
  box-shadow: 0 1px 1px rgba(92, 184, 92, 0.5);
  color: #5CB85C;
}

.badge.badge-info {
  background: #1ECBE2;
  box-shadow: 0 1px 1px rgba(30, 203, 226, 0.5);
  color: #FFF;
}
.badge.badge-soft-info {
  background: rgba(30, 203, 226, 0.1);
  box-shadow: 0 1px 1px rgba(30, 203, 226, 0.5);
  color: #1ECBE2;
}

.badge.badge-warning {
  background: #FDA700;
  box-shadow: 0 1px 1px rgba(253, 167, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-warning {
  background: rgba(253, 167, 0, 0.1);
  box-shadow: 0 1px 1px rgba(253, 167, 0, 0.5);
  color: #FDA700;
}

.badge.badge-danger {
  background: #FC0027;
  box-shadow: 0 1px 1px rgba(252, 0, 39, 0.5);
  color: #FFF;
}
.badge.badge-soft-danger {
  background: rgba(252, 0, 39, 0.1);
  box-shadow: 0 1px 1px rgba(252, 0, 39, 0.5);
  color: #FC0027;
}

.badge.badge-dark {
  background: #171724;
  box-shadow: 0 1px 1px rgba(23, 23, 36, 0.5);
  color: #FFF;
}
.badge.badge-soft-dark {
  background: rgba(23, 23, 36, 0.1);
  box-shadow: 0 1px 1px rgba(23, 23, 36, 0.5);
  color: #171724;
}

.badge.badge-light {
  background: #FDFDFE;
  box-shadow: 0 1px 1px rgba(253, 253, 254, 0.5);
  color: #FFF;
}
.badge.badge-soft-light {
  background: rgba(253, 253, 254, 0.1);
  box-shadow: 0 1px 1px rgba(253, 253, 254, 0.5);
  color: #FDFDFE;
}

.badge.badge-black {
  background: #000;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-black {
  background: rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #000;
}

.badge.badge-purple {
  background: #4A00E5;
  box-shadow: 0 1px 1px rgba(74, 0, 229, 0.5);
  color: #FFF;
}
.badge.badge-soft-purple {
  background: rgba(74, 0, 229, 0.1);
  box-shadow: 0 1px 1px rgba(74, 0, 229, 0.5);
  color: #4A00E5;
}

.badge.badge-yellow {
  background: #ffff00;
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-yellow {
  background: rgba(255, 255, 0, 0.1);
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #ffff00;
}

.badge.badge-teal {
  background: #02a8b5;
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #FFF;
}
.badge.badge-soft-teal {
  background: rgba(2, 168, 181, 0.1);
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #02a8b5;
}

.badge {
  padding: 0.25rem 0.45rem;
  text-transform: capitalize;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 4px;
  color: #262A2A;
}
.badge.badge-xs {
  font-size: 10px;
  padding: 0px 5px;
  line-height: 18px;
}
.badge.badge-sm {
  font-size: 11px;
  padding: 5px 8px;
  line-height: 11px;
}
.badge.badge-md {
  font-size: 12px;
  padding: 5px 12px;
  line-height: 1.5;
}
.badge.badge-lg {
  font-size: 14px;
  padding: 0px 10px;
  line-height: 30px;
}
.badge.badge-xl {
  font-size: 16px;
  padding: 0px 15px;
  line-height: 35px;
}

.badge-soft-purple {
  background: #F3EDFF;
  color: #4A00E5;
}

.bg-light-danger {
  background-color: #FFEEEC !important;
}
.bg-light-danger .badge-dots {
  background-color: #FC1A3D;
}

.bg-light-success {
  background-color: #EFF8EF !important;
}
.bg-light-success .badge-dots {
  background-color: #6CBF6C;
}

.bg-light-info {
  background-color: #E9FAFC !important;
}
.bg-light-info .badge-dots {
  background-color: #35D0E5;
}

.bg-light-warning {
  background-color: #FFF7D8 !important;
}
.bg-light-warning .badge-dots {
  background-color: #FDB01A;
}

.badge-danger-light {
  background-color: #FFEEEC !important;
  color: #FC1A3D;
}

.badge-pending {
  background: #676DFF !important;
  color: #FFF !important;
}

.badge-tertiary {
  background: #3C2371;
  color: #FFF;
}

.badge-status {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 8px;
  min-width: 64px;
  color: #FFF;
}

.badge-tag {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 4px;
  font-weight: 400;
}
.badge-tag.badge-success-light {
  background: #E0F5D7;
  color: #5CB85C;
}
.badge-tag.badge-warning-light {
  background: #FFF7D8;
  color: #FDA700;
}
.badge-tag.badge-purple-light {
  background: #F3EDFF;
  color: #4A00E5;
}
.badge-tag.badge-danger-light {
  background: #FFEEEC;
  color: #FC0027;
}

.border-container {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #FDFDFE;
}

.border {
  border: 1px solid #E8E8E8 !important;
}
.border.border-dashed {
  border-style: dashed !important;
}
.border.border-dotted {
  border-style: dotted !important;
}
.border.border-primary {
  border: 1px solid #e85b28 !important;
  opacity: 1;
}
.border.border-primary.border-opacity-10 {
  border-color: rgba(232, 91, 40, 0.1) !important;
}
.border.border-primary.border-opacity-25 {
  border-color: rgba(232, 91, 40, 0.25) !important;
}
.border.border-primary.border-opacity-50 {
  border-color: rgba(232, 91, 40, 0.5) !important;
}
.border.border-primary.border-opacity-75 {
  border-color: rgba(232, 91, 40, 0.75) !important;
}
.border.border-primary.border-opacity-100 {
  border-color: #e85b28 !important;
}
.border.border-secondary {
  border: 1px solid #FFA201 !important;
  opacity: 1;
}
.border.border-secondary.border-opacity-10 {
  border-color: rgba(255, 162, 1, 0.1) !important;
}
.border.border-secondary.border-opacity-25 {
  border-color: rgba(255, 162, 1, 0.25) !important;
}
.border.border-secondary.border-opacity-50 {
  border-color: rgba(255, 162, 1, 0.5) !important;
}
.border.border-secondary.border-opacity-75 {
  border-color: rgba(255, 162, 1, 0.75) !important;
}
.border.border-secondary.border-opacity-100 {
  border-color: #ffa201 !important;
}
.border.border-info {
  border: 1px solid #1ECBE2 !important;
  opacity: 1;
}
.border.border-info.border-opacity-10 {
  border-color: rgba(30, 203, 226, 0.1) !important;
}
.border.border-info.border-opacity-25 {
  border-color: rgba(30, 203, 226, 0.25) !important;
}
.border.border-info.border-opacity-50 {
  border-color: rgba(30, 203, 226, 0.5) !important;
}
.border.border-info.border-opacity-75 {
  border-color: rgba(30, 203, 226, 0.75) !important;
}
.border.border-info.border-opacity-100 {
  border-color: #1ecbe2 !important;
}
.border.border-success {
  border: 1px solid #5CB85C !important;
  opacity: 1;
}
.border.border-success.border-opacity-10 {
  border-color: rgba(92, 184, 92, 0.1) !important;
}
.border.border-success.border-opacity-25 {
  border-color: rgba(92, 184, 92, 0.25) !important;
}
.border.border-success.border-opacity-50 {
  border-color: rgba(92, 184, 92, 0.5) !important;
}
.border.border-success.border-opacity-75 {
  border-color: rgba(92, 184, 92, 0.75) !important;
}
.border.border-success.border-opacity-100 {
  border-color: #5cb85c !important;
}
.border.border-warning {
  border: 1px solid #FDA700 !important;
  opacity: 1;
}
.border.border-warning.border-opacity-10 {
  border-color: rgba(253, 167, 0, 0.1) !important;
}
.border.border-warning.border-opacity-25 {
  border-color: rgba(253, 167, 0, 0.25) !important;
}
.border.border-warning.border-opacity-50 {
  border-color: rgba(253, 167, 0, 0.5) !important;
}
.border.border-warning.border-opacity-75 {
  border-color: rgba(253, 167, 0, 0.75) !important;
}
.border.border-warning.border-opacity-100 {
  border-color: #fda700 !important;
}
.border.border-danger {
  border: 1px solid #FC0027 !important;
  opacity: 1;
}
.border.border-danger.border-opacity-10 {
  border-color: rgba(252, 0, 39, 0.1) !important;
}
.border.border-danger.border-opacity-25 {
  border-color: rgba(252, 0, 39, 0.25) !important;
}
.border.border-danger.border-opacity-50 {
  border-color: rgba(252, 0, 39, 0.5) !important;
}
.border.border-danger.border-opacity-75 {
  border-color: rgba(252, 0, 39, 0.75) !important;
}
.border.border-danger.border-opacity-100 {
  border-color: #fc0027 !important;
}
.border.border-white {
  border: 1px solid #FFF !important;
  opacity: 1;
}
.border.border-white.border-opacity-10 {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.border.border-white.border-opacity-25 {
  border-color: rgba(255, 255, 255, 0.25) !important;
}
.border.border-white.border-opacity-50 {
  border-color: rgba(255, 255, 255, 0.5) !important;
}
.border.border-white.border-opacity-75 {
  border-color: rgba(255, 255, 255, 0.75) !important;
}
.border.border-white.border-opacity-100 {
  border-color: white !important;
}
.border.border-light {
  border: 1px solid #FDFDFE !important;
  opacity: 1;
}
.border.border-light.border-opacity-10 {
  border-color: rgba(253, 253, 254, 0.1) !important;
}
.border.border-light.border-opacity-25 {
  border-color: rgba(253, 253, 254, 0.25) !important;
}
.border.border-light.border-opacity-50 {
  border-color: rgba(253, 253, 254, 0.5) !important;
}
.border.border-light.border-opacity-75 {
  border-color: rgba(253, 253, 254, 0.75) !important;
}
.border.border-light.border-opacity-100 {
  border-color: #fdfdfe !important;
}
.border.border-dark {
  border: 1px solid #171724 !important;
  opacity: 1;
}
.border.border-dark.border-opacity-10 {
  border-color: rgba(23, 23, 36, 0.1) !important;
}
.border.border-dark.border-opacity-25 {
  border-color: rgba(23, 23, 36, 0.25) !important;
}
.border.border-dark.border-opacity-50 {
  border-color: rgba(23, 23, 36, 0.5) !important;
}
.border.border-dark.border-opacity-75 {
  border-color: rgba(23, 23, 36, 0.75) !important;
}
.border.border-dark.border-opacity-100 {
  border-color: #171724 !important;
}
.border.border-orange {
  border: 1px solid #FF9D0A !important;
  opacity: 1;
}
.border.border-orange.border-opacity-10 {
  border-color: rgba(255, 157, 10, 0.1) !important;
}
.border.border-orange.border-opacity-25 {
  border-color: rgba(255, 157, 10, 0.25) !important;
}
.border.border-orange.border-opacity-50 {
  border-color: rgba(255, 157, 10, 0.5) !important;
}
.border.border-orange.border-opacity-75 {
  border-color: rgba(255, 157, 10, 0.75) !important;
}
.border.border-orange.border-opacity-100 {
  border-color: #ff9d0a !important;
}
.border.border-opacity-10 {
  --bs-border-opacity: 0.1 !important;
}
.border.border-opacity-25 {
  --bs-border-opacity: 0.25 !important;
}
.border.border-opacity-50 {
  --bs-border-opacity: 0.5 !important;
}
.border.border-opacity-75 {
  --bs-border-opacity: 0.75 !important;
}
.border.border-opacity-100 {
  --bs-border-opacity: 1 !important;
}
.border.border-1 {
  border-width: 1px !important;
}
.border.border-2 {
  border-width: 2px !important;
}
.border.border-3 {
  border-width: 3px !important;
}
.border.border-4 {
  border-width: 4px !important;
}
.border.border-5 {
  border-width: 5px !important;
}
.border.border-block-start-dashed {
  border-top-style: dashed;
}
.border.border-block-start-dotted {
  border-top-style: dotted;
}
.border.border-inline-end-dashed {
  border-inline-end-style: dashed;
}
.border.border-inline-end-dotted {
  border-inline-end-style: dotted;
}
.border.border-block-end-dashed {
  border-bottom-style: dashed;
}
.border.border-block-end-dotted {
  border-bottom-style: dotted;
}
.border.border-inline-start-dashed {
  border-inline-start-style: dashed;
}
.border.border-inline-start-dotted {
  border-inline-start-style: dotted;
}
.border.border-0 {
  border: 0 !important;
}
.border.border-top-0 {
  border-block-start: 0 !important;
}
.border.border-end-0 {
  border-inline-end: 0 !important;
}
.border.border-bottom-0 {
  border-block-end: 0 !important;
}
.border.border-start-0 {
  border-inline-start: 0 !important;
}

.border-top {
  border-top: 1px solid #E8E8E8 !important;
}
.border-top.border-block-start-dashed {
  border-top-style: dashed !important;
}
.border-top.border-block-start-dotted {
  border-top-style: dotted !important;
}
.border-top.border-primary {
  border-color: #e85b28 !important;
}
.border-top.border-secondary {
  border-color: #FFA201 !important;
}
.border-top.border-warning {
  border-color: #FDA700 !important;
}
.border-top.border-info {
  border-color: #1ECBE2 !important;
}
.border-top.border-success {
  border-color: #5CB85C !important;
}
.border-top.border-danger {
  border-color: #FC0027 !important;
}
.border-top.border-light {
  border-color: #FDFDFE !important;
}
.border-top.border-dark {
  border-color: #171724 !important;
}

.border-end {
  border-inline-end: 1px solid #E8E8E8 !important;
}
.border-end.border-inline-end-dashed {
  border-inline-end-style: dashed !important;
}
.border-end.border-inline-end-dotted {
  border-inline-end-style: dotted !important;
}
.border-end.border-primary {
  border-color: #e85b28 !important;
}
.border-end.border-secondary {
  border-color: #FFA201 !important;
}
.border-end.border-warning {
  border-color: #FDA700 !important;
}
.border-end.border-info {
  border-color: #1ECBE2 !important;
}
.border-end.border-success {
  border-color: #5CB85C !important;
}
.border-end.border-danger {
  border-color: #FC0027 !important;
}
.border-end.border-light {
  border-color: #FDFDFE !important;
}
.border-end.border-dark {
  border-color: #171724 !important;
}

.border-bottom {
  border-bottom: 1px solid #E8E8E8 !important;
}
.border-bottom.border-block-end-dashed {
  border-bottom-style: dashed !important;
}
.border-bottom.border-block-end-dotted {
  border-bottom-style: dotted !important;
}
.border-bottom.border-primary {
  border-color: #e85b28 !important;
}
.border-bottom.border-secondary {
  border-color: #FFA201 !important;
}
.border-bottom.border-warning {
  border-color: #FDA700 !important;
}
.border-bottom.border-info {
  border-color: #1ECBE2 !important;
}
.border-bottom.border-success {
  border-color: #5CB85C !important;
}
.border-bottom.border-danger {
  border-color: #FC0027 !important;
}
.border-bottom.border-light {
  border-color: #FDFDFE !important;
}
.border-bottom.border-dark {
  border-color: #171724 !important;
}

.border-start {
  border-inline-start: 1px solid #E8E8E8 !important;
}
.border-start.border-inline-start-dashed {
  border-inline-start-style: dashed !important;
}
.border-start.border-inline-start-dotted {
  border-inline-start-style: dotted !important;
}
.border-start.border-primary {
  border-color: #e85b28 !important;
}
.border-start.border-secondary {
  border-color: #FFA201 !important;
}
.border-start.border-warning {
  border-color: #FDA700 !important;
}
.border-start.border-info {
  border-color: #1ECBE2 !important;
}
.border-start.border-success {
  border-color: #5CB85C !important;
}
.border-start.border-danger {
  border-color: #FC0027 !important;
}
.border-start.border-light {
  border-color: #FDFDFE !important;
}
.border-start.border-dark {
  border-color: #171724 !important;
}

.br-1 {
  border-radius: 0.0625rem;
}

.br-2 {
  border-radius: 0.125rem;
}

.br-3 {
  border-radius: 0.1875rem;
}

.br-4 {
  border-radius: 0.25rem;
}

.br-5 {
  border-radius: 0.3125rem;
}

.br-6 {
  border-radius: 0.375rem;
}

.br-7 {
  border-radius: 0.4375rem;
}

.br-8 {
  border-radius: 0.5rem;
}

.br-9 {
  border-radius: 0.5625rem;
}

.br-10 {
  border-radius: 0.625rem;
}

.br-15 {
  border-radius: 0.9375rem;
}

.br-20 {
  border-radius: 1.25rem;
}

.rounded {
  border-radius: 4px !important;
}

.calendar-events {
  border: 1px solid transparent;
  cursor: move;
  padding: 10px 15px;
}

.calendar-events:hover {
  border-color: #898989;
  background-color: #FFF;
}

.calendar-events i {
  margin-right: 8px;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
  font-family: "Roboto", sans-serif;
}

.fc-day {
  background: #FFF;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}

.fc th.fc-widget-header {
  background: #F6F6F6;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #f3f3f3;
}

.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
  padding: 2px 5px;
}

.fc-button {
  background: #f1f1f1;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}

.fc-state-hover {
  background: #f3f3f3;
}

.fc-state-highlight {
  background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #e85b28 !important;
  color: #FFF !important;
  text-shadow: none !important;
}

.fc-cell-overlay {
  background: #f0f0f0;
}

.fc-unthemed .fc-today {
  background: #FFF;
}

.fc-event {
  border-radius: 2px;
  border: none;
  color: #FFF !important;
  cursor: move;
  font-size: 13px;
  margin: 1px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.event-form .input-group .form-control {
  height: 40px;
}

.submit-section {
  text-align: center;
  margin-top: 40px;
}

.submit-btn {
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  min-width: 200px;
  padding: 10px 20px;
}

.apexcharts-legend.apexcharts-align-center.position-right {
  display: none;
}

.apexcharts-toolbar {
  display: none !important;
}

#sales_charts,
.chart-set {
  overflow: hidden;
}

.apexcharts-canvas {
  width: 100% !important;
}

.h-250 {
  height: 250px;
}

.chat-user-actives .call-meet-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FFF;
  border-radius: 5px;
  margin-bottom: 15px;
  padding: 10px;
  transition: all 0.5s ease;
}
.chat-user-actives .call-meet-blk:hover {
  background-color: #000;
  transition: all 0.5s ease;
}
.chat-user-actives .call-meet-blk .meet-border {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  width: 39px;
  height: 39px;
  background: #FFF;
  border: 0.5px solid #898989;
  border-radius: 10px;
  margin-right: 10px;
}
.chat-user-actives .call-meet-blk .meet-border svg {
  width: 16px;
  color: #339DFF;
}
.chat-user-actives .call-meet-blk .recent-user-titles h5 {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-user-actives .call-meet-blk .recent-user-titles p {
  font-size: 10px;
  color: #6F6F6F;
}

.new-join-link .chat-user-actives .meet-border {
  background: gray;
  border: 0;
  border-radius: 6px;
}
.new-join-link .chat-user-actives .meet-border:hover {
  background: #e85b28;
}
.new-join-link .chat-user-actives .meet-border:hover svg {
  color: #FFF;
}
.new-join-link .chat-user-actives .meet-border svg {
  color: #e85b28;
}
.new-join-link .chat-user-actives .recent-user-titles h5 {
  color: #e85b28;
  width: 100%;
  margin-bottom: 0;
  font-size: 15px;
}

.meet-chat-blk .join-call .join-video {
  position: relative;
  margin-bottom: 25px;
}
.meet-chat-blk .join-call .join-video img {
  border-radius: 10px;
}
.meet-chat-blk .join-call .join-video .video-avatar {
  color: #FFF;
  background: #5D5D5D;
  font-size: 50px;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.meet-chat-blk .join-call .join-video .video-avatar.active {
  display: flex;
  position: relative;
  height: 426px;
}
.meet-chat-blk .join-call .join-video .call-icons {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items {
  border-radius: 5px;
  padding: 0;
  margin: 0;
  list-style: none;
  display: inline-flex;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0);
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item {
  display: inline-block;
  text-align: center;
  margin-right: 15px;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item:last-child {
  margin-right: 0px;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a {
  color: #FFF;
  background: #FFF;
  border-radius: 10px;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 20px;
  white-space: nowrap;
}
@media (max-width: 767.98px) {
  .meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a {
    width: 45px;
    height: 45px;
  }
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a i {
  color: #6F6F6F;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a.stop {
  color: #FFF;
  background: #FC0027;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a.stop i {
  color: #FFF;
}
.meet-chat-blk .join-call .join-video .meet-drop ul li i {
  font-size: 18px;
}
.meet-chat-blk .join-call .join-content {
  text-align: center;
  max-width: 500px;
  margin: auto;
}
.meet-chat-blk .join-call .join-content h4 {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}
@media (max-width: 767.98px) {
  .meet-chat-blk .join-call .join-content h4 {
    font-size: 18px;
  }
}
.meet-chat-blk .join-call .join-content .event-user-group {
  margin-bottom: 10px;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar {
  width: 38px;
  height: 38px;
  border: 3px solid #FFF;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar + .avatar {
  margin-left: -20px;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar .avatar-title {
  color: #000;
  font-size: 14px;
  font-weight: 600;
  background: gray;
}
.meet-chat-blk .join-call .join-content p {
  font-size: 13px;
  color: #6F6F6F;
}
.meet-chat-blk .join-call .join-content .btn-join-call .btn-primary {
  background: #e85b28;
  border-radius: 6px 6px 6px 6px;
  color: #FFF;
  font-size: 14px;
  border: 1px solid #e85b28;
  font-weight: 600;
  min-width: 105px;
  padding: 8px 15px;
}
.meet-chat-blk .join-call .join-content .btn-join-call .btn-primary:hover {
  background: #FC0027;
  border: 1px solid gray;
  color: #e85b28;
}

.conference-meet-group {
  display: flex;
}
.conference-meet-group .meeting-list {
  width: 100%;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .meeting-list.add-meeting {
  width: 65%;
  margin-right: 24px;
}
@media (max-width: 767.98px) {
  .conference-meet-group .meeting-list.add-meeting {
    display: none;
    margin-right: 0px;
  }
}
.conference-meet-group .right-user-side {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.right-side-party {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.right-side-party .party-msg-blk .last-call-time .call-recent {
  background: none;
}
.conference-meet-group .right-user-side.right-side-party .party-msg-blk .last-call-time .call-recent svg {
  color: #e85b28;
  width: 14px;
}
.conference-meet-group .right-user-side.chat-rooms {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.chat-rooms .slime-grp {
  padding: 0;
}
.conference-meet-group .right-user-side.chat-rooms .slime-grp .left-chat-title {
  padding: 20px;
  border-bottom: 1px solid #E1E8ED;
  border-radius: 10px 10px 0 0;
}
.conference-meet-group .right-user-side.chat-rooms.open-chats {
  width: 35%;
  opacity: 1;
}
@media (max-width: 767.98px) {
  .conference-meet-group .right-user-side.chat-rooms.open-chats {
    width: 100%;
  }
}
.conference-meet-group .right-user-side.open-message {
  width: 35%;
  opacity: 1;
}
@media (max-width: 767.98px) {
  .conference-meet-group .right-user-side.open-message {
    width: 100%;
  }
}

.meet-drop {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  position: absolute;
  top: 20px;
  right: 20px;
}
.meet-drop ul li .chats-dot a {
  width: 50px;
  height: 50px;
  color: #6B7280;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop ul li .chats-dot a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes {
  background: #e85b28;
  right: inherit;
  left: 20px;
}
.meet-drop.meet-mutes ul li a {
  color: #FFF;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop.meet-mutes ul li a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes-bottom {
  background: #e85b28;
  bottom: 20px;
  border-radius: 50px;
  top: inherit;
}
.meet-drop.meet-mutes-bottom ul li a {
  color: #FFF;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop.meet-mutes-bottom ul li a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes-bottom ul li a i {
  font-size: 20px;
}

.meet-call-menu-blk .video-call-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action {
    display: block;
  }
}
.meet-call-menu-blk .video-call-action ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.meet-call-menu-blk .video-call-action ul li {
  margin-right: 5px;
}
.meet-call-menu-blk .video-call-action ul li:last-child {
  margin-right: 0;
}
.meet-call-menu-blk .video-call-action ul li a {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background: #D9D9D9;
  border: 1px solid #D9D9D9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #000;
  font-size: 18px;
}
.meet-call-menu-blk .video-call-action ul li a.call-end {
  background-color: #FC0027;
  border-color: #FC0027;
  color: #FFF;
  width: 60px;
  height: 60px;
  rotate: 135deg;
  font-size: 20px;
}
.meet-call-menu-blk .video-call-action ul li a.stop {
  color: #FFF;
  background: #FC0027;
  border-color: #FC0027;
}
.meet-call-menu-blk .video-call-action ul li a.stop i {
  color: #FFF;
}
.meet-call-menu-blk .video-call-action ul li.active a {
  background: #e85b28;
  border-color: #e85b28;
  color: #FFF;
}
.meet-call-menu-blk .video-call-action ul li.active a img {
  filter: invert(1) brightness(100);
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action ul {
    margin-bottom: 5px;
    justify-content: center;
  }
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action ul:last-child {
    margin-bottom: 0px;
  }
}

.recession-meet-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head {
    margin-bottom: 5px;
  }
}
.recession-meet-blk .reccession-head h5 {
  font-size: 20px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 0px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head h5 {
    font-size: 18px;
  }
}
.recession-meet-blk .reccession-head ul li {
  font-size: 15px;
  font-weight: 400;
  color: #6F6F6F;
  margin-right: 25px;
}
.recession-meet-blk .reccession-head ul li:last-child {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head ul li {
    margin-bottom: 10px;
  }
}
.recession-meet-blk .partispant-blk {
  display: flex;
}
.recession-meet-blk .partispant-blk .btn-primary {
  background: #1b2950;
  border-radius: 6px;
  color: #FFF;
  border: 1px solid #1b2950;
  margin-right: 10px;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.recession-meet-blk .partispant-blk .btn-primary:hover {
  background: #e85b28;
  border: 1px solid #e85b28;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .partispant-blk .btn-primary {
    font-size: 13px;
  }
}
.recession-meet-blk .partispant-blk .btn-primary:last-child {
  margin-right: 0;
}
.recession-meet-blk .partispant-blk span a {
  width: 42px;
  height: 42px;
  background: #E8E8E8;
  border-radius: 5px;
  color: #6F6F6F;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.recession-meet-blk .partispant-blk span a:hover {
  background: #e85b28;
  color: #FFF;
}

.recording-time {
  position: relative;
  padding-left: 20px;
}
.recording-time::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 4px;
  background-color: #FC0027;
  width: 13px;
  height: 13px;
  border-radius: 50px;
}
.recording-time::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 7px;
  background-color: #FFF;
  width: 7px;
  height: 7px;
  border-radius: 50px;
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}

.page-content {
  width: 100%;
}

.join-call {
  width: 100%;
  margin: 0 auto;
}

.join-video {
  position: relative;
  margin-bottom: 25px;
}
.join-video img {
  border-radius: 10px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.join-video.join-video-front img {
  height: 423px;
}

.video-avatar {
  color: #FFF;
  background: #5D5D5D;
  font-size: 50px;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  justify-content: center;
}
.video-avatar h4 {
  font-weight: 700;
  font-size: 24px;
  color: #FFF;
}

.video-avatar.active {
  display: flex;
}

.join-video.video-hide > img,
.video-wrap.video-hide > video {
  display: none;
}

.join-content p {
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 25px;
  color: #000;
}
.join-content label {
  font-size: 18px;
  margin-bottom: 0;
  color: #000;
  font-weight: 700;
}

.part-name {
  position: absolute;
  top: 20px;
  left: 12px;
  text-align: left;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50px;
  padding: 5px 15px;
}
.part-name h4 {
  font-weight: 500;
  font-size: 15px;
  color: #6F6F6F;
  margin-bottom: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media (max-width: 767.98px) {
  .part-name h4 {
    font-size: 13px;
  }
}
.part-name.sub-part-name {
  background: #FFF;
  bottom: 10px;
  top: inherit;
}
.part-name.sub-part-name h4 {
  color: #262A2A;
  font-size: 12px;
}

.grid-join .part-name {
  background: rgba(0, 0, 0, 0.3);
  top: inherit;
  bottom: 20px;
}
.grid-join .part-name h4 {
  color: #FFF;
}

.join-hover-img {
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.join-hover-img .event-user-group .avatar-group {
  background: rgba(0, 0, 0, 0.3);
  padding: 2px 10px;
  border-radius: 50px;
}
.join-hover-img .event-user-group .avatar-group .avatar {
  width: 26px;
  height: 26px;
  border: 1px solid #FFF;
}
.join-hover-img .event-user-group .avatar-group .avatar + .avatar {
  margin-left: -16px;
}
.join-hover-img .event-user-group .avatar-group .avatar:last-child {
  margin-right: 0px;
}
.join-hover-img .event-user-group .avatar-group .avatar .avatar-title {
  color: #1F2937;
  font-size: 12px;
  font-weight: 600;
  background: #F3F4F6;
}

.more-icon {
  position: absolute;
  bottom: 10px;
  right: 12px;
}
@media (max-width: 767.98px) {
  .more-icon {
    bottom: 8px;
    right: 13px;
  }
}
.more-icon a {
  color: #6F6F6F;
  width: 30px;
  height: 30px;
  background: #FFF;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.more-icon a:hover {
  opacity: 0.8;
}
.more-icon a.other-mic-off.stop i {
  color: #FC0027;
}
.more-icon.audio-more-icon a.other-mic-off.stop {
  background-color: #FC0027 !important;
}
.more-icon.audio-more-icon a.other-mic-off.stop i {
  color: #FFF;
}

.call-recent.recent-part a.other-mic-off.stop, .call-recent.recent-part a.other-video-off.stop {
  background: #FC0027 !important;
}
.call-recent.recent-part a.other-mic-off.stop i, .call-recent.recent-part a.other-video-off.stop i {
  color: #FFF;
}

.meeting .part-name {
  top: 15px;
  left: 15px;
}
.meeting .more-icon {
  top: 15px;
  right: 15px;
  display: flex;
}

.vertical-view .vertical-sec .part-name h4 {
  font-size: 14px;
  font-weight: 400;
}

.horizontal-view .join-video.single-user .part-name h4 {
  font-size: 14px;
  font-weight: 400;
}

.meeting-wrapper, .meeting {
  width: inherit;
  max-width: inherit;
}

.meet-footer {
  position: fixed;
  bottom: 25px;
  width: 100%;
  max-width: 950px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
}

.show-chat-list, .show-invite-list,
.show-chat-list .user-sidebar-right,
.show-invite-list .invite-sidebar-right {
  transition: all 0.8s ease;
}

.user-sidebar-right, .invite-sidebar-right {
  background: #dedede;
  border-radius: 10px;
  width: 410px;
  position: absolute;
  top: 105px;
  bottom: 117px;
  right: 0;
  margin-right: -410px;
  transition: all 0.8s ease;
  overflow: hidden;
  font-size: 13px;
  z-index: 3;
}

.join-contents {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.join-contents.grid-view {
  align-content: center;
}

.ripple {
  width: 114px;
  height: 114px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.multigrid-view .text-box {
  height: 61px;
  width: 61px;
}

.multigrid-view .ripple {
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meeting .join-video {
  margin: 0 5px 10px;
  width: 100%;
}

.join-video.user-active {
  background: #415B6A;
  border-radius: 10px;
  width: 100%;
  height: 370px;
}
.join-video.user-active.audio-calls {
  height: 520px;
}
.join-video.vertical-active {
  margin-right: 24px;
}
.join-video.single-user {
  width: 100%;
  min-height: 230px;
  box-sizing: border-box;
  margin-right: 24px;
  justify-content: space-between;
  text-align: center;
  height: auto;
  background: #415B6A;
  border-radius: 10px;
  padding: 0;
  flex-grow: 1;
}
@media (max-width: 1280px) {
  .join-video.single-user {
    width: 100%;
  }
}
@media (max-width: 1199.98px) {
  .join-video.single-user {
    min-height: 203px;
  }
}
@media (max-width: 991.98px) {
  .join-video.single-user {
    min-height: 230px;
  }
}
.join-video.single-user:nth-child(even) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .join-video.single-user:nth-child(even) {
    margin-right: 10px;
  }
}
@media (max-width: 767.98px) {
  .join-video.single-user {
    width: 100%;
    min-height: 257px;
  }
}

@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user {
    width: 45%;
  }
}
.multi-grid .join-video.single-user:nth-child(even) {
  margin-right: 24px;
}
@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user:nth-child(even) {
    margin-right: 0px;
  }
}
.multi-grid .join-video.single-user:nth-child(4n) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user:nth-child(4n):nth-child(4n) {
    margin-right: 0px;
  }
}

.multigrid-view .join-video.single-user {
  flex-grow: 0;
}

.horizontal-view .join-video.single-user:nth-child(even) {
  margin-right: 24px;
}
.horizontal-view .join-video.single-user:nth-child(5) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .horizontal-view .join-video.single-user:nth-child(3n) {
    margin-right: 0;
  }
}

.text-avatar {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.text-avatar h4 {
  color: #FFF;
}

.text-box {
  height: 86px;
  width: 86px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  font-size: 36px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.more-icon.mic-view .mic-on, .more-icon .mic-off {
  display: none;
}

.more-icon.mic-view .mic-off {
  display: inline-flex;
}

.grid-view .join-video.single-user {
  width: 47%;
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user {
    width: 40%;
  }
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user:nth-child(2n) {
    margin-right: 0px;
  }
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user:nth-child(3n) {
    margin-right: 24px;
  }
}

.join-contents.multigrid-view {
  max-width: 100%;
  justify-content: center;
}

.meeting {
  position: absolute;
  top: 80px;
  bottom: 107px;
  left: 0;
  right: 0;
}

.meeting-list {
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}

.user-active .more-icon .handraise-on {
  display: none;
}
.user-active .more-icon .handraise-on.active {
  display: block;
  animation: mymove 5s;
}

.user-active .more-icon .handraise-on.active .meeting .join-video.user-active::before {
  animation: mymove 5s infinite;
  opacity: 1;
}

@keyframes mymove {
  from {
    color: #0074E0;
  }
  to {
    color: transparent;
  }
}
.join-contents.vertical-view {
  display: flex;
  align-items: center;
  align-content: center;
  max-width: 1300px;
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view {
    display: block;
  }
}
.join-contents.vertical-view .join-video.user-active {
  flex: 1 1;
  margin-bottom: 24px;
}
.join-contents.vertical-view .join-video.single-user {
  width: 97%;
  flex-grow: 1;
  display: flex;
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view .join-video.single-user {
    width: 100%;
  }
}
.join-contents.vertical-view .vertical-sec {
  width: 20%;
}
@media (max-width: 991.98px) {
  .join-contents.vertical-view .vertical-sec {
    width: 30%;
  }
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view .vertical-sec {
    width: 100%;
  }
}
.join-contents.vertical {
  flex-direction: column;
  height: 200px;
}

.meeting .join-contents.vertical .join-video.user-active {
  flex: 1 0 100%;
}

.meeting .join-contents.vertical .join-video.single-user {
  flex: 0 1;
}

.meeting .join-contents.vertical .join-video {
  width: auto;
}

.chat-footer .btn:hover {
  background: #0066c5;
  color: #FFF;
}

.join-contents.show-whiteboard {
  display: none;
}
.join-contents.single-view {
  padding-top: 0;
  margin-top: 25px;
  position: relative;
}
.join-contents.single-view .single-user {
  position: absolute;
  right: 8px;
  top: 40px;
  width: 130px;
  height: 130px;
  min-height: 130px;
}
.join-contents.single-view .single-user img {
  height: 130px;
}

.record-time {
  position: absolute;
  top: 20px;
  z-index: 1;
  position: absolute;
  left: 20px;
}
.record-time span {
  background-color: rgba(255, 255, 255, 0.2);
  display: inline-block;
  border-radius: 130px;
  color: #FFF;
  font-size: 14px;
  font-weight: 600;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 34px;
  position: relative;
  padding-left: 15px;
}
.record-time span:before {
  content: "";
  position: absolute;
  left: 7px;
  top: 7px;
  background-color: #FFF;
  width: 18px;
  height: 18px;
  border-radius: 50px;
}
.record-time span:after {
  content: "";
  position: absolute;
  left: 12px;
  top: 12px;
  background-color: #FC0027;
  width: 8px;
  height: 8px;
  border-radius: 50px;
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
.volume-col {
  position: absolute;
  left: 20px;
  bottom: 20px;
}

.volume-col .inner-volume-col {
  background-color: #898989;
  border-radius: 130px;
  width: 30px;
  height: 120px;
  position: relative;
  z-index: 9;
}

.volume-col #volume {
  position: absolute;
  left: 50%;
  top: 15px;
  margin: 0 auto;
  height: 80px;
  width: 5px;
  background: #FFF;
  border-radius: 15px;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.volume-col #volume .ui-slider-range-min {
  height: 5px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #e85b28;
  border: none;
  border-radius: 10px;
  outline: none;
}

.volume-col #volume .ui-slider-handle {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: #e85b28;
  position: absolute;
  left: 50%;
  margin-top: -8px;
  cursor: pointer;
  outline: none;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.volume-col #player {
  width: auto;
  height: 104px;
  position: relative;
  margin: 0 auto;
  top: 0px;
}

.volume-col #player i {
  position: absolute;
  margin-top: -6px;
  color: #666;
}

.volume-col .volume-icons {
  color: #FFF;
  margin-left: 0px;
  font-size: 18px;
  margin-top: 22px;
}

.chat-msg-blk {
  padding: 15px;
}
.chat-msg-blk .chats {
  max-width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  display: -webkit-flex;
}
@media (max-width: 767.98px) {
  .chat-msg-blk .chats {
    max-width: 100%;
  }
}
.chat-msg-blk .chats .chat-action-btns .chat-user-time .chats-dot a {
  color: #00918E;
}
.chat-msg-blk .chats.chats-right {
  margin-left: auto;
  flex-direction: row-reverse;
}
.chat-msg-blk .chats.chats-right .chat-content {
  order: 1;
  -webkit-order: 1;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content {
  background-color: #E8E8E8;
  border-radius: 8px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .chat-time {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col {
  position: relative;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li {
  margin-right: 8px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li:last-child {
  margin-right: 0px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col {
  position: relative;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download a img {
  filter: blur(1px);
  border-color: #000;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download span {
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download span i {
  color: #FFF;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col img {
  border-radius: 5px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content::before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #E8E8E8;
  border-right: 0;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  right: -4px;
  left: auto;
}
.chat-msg-blk .chats.chats-right .chat-avatar {
  padding: 8px 0px 0 15px;
}
.chat-msg-blk .chats.chats-right .chat-action-btns {
  order: 2;
  -webkit-order: 2;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
}
.chat-msg-blk .chats.chats-right .chat-action-btns .chat-user-time .chats-dot a {
  color: #00918E;
}
.chat-msg-blk .chats .chat-avatar {
  padding: 8px 15px 0 8px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  flex-shrink: 0;
}
.chat-msg-blk .chats .chat-avatar .dreams_chat {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.chat-msg-blk .chats .message-content {
  background-color: #E8E8E8;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  margin-bottom: 5px;
  position: relative;
}
.chat-msg-blk .chats .message-content h4 {
  font-size: 13px;
  color: #262A2A;
  margin-bottom: 0px;
  line-height: 1.4;
  font-weight: 500;
}
.chat-msg-blk .chats .message-content .chat-time {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 10px;
  font-weight: 500;
  color: #00918E;
  margin-bottom: 0;
}
.chat-msg-blk .chats .message-content .chat-time svg {
  width: 10px;
}
.chat-msg-blk .chats .message-content::before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #E8E8E8;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  left: -4px;
  right: auto;
}
.chat-msg-blk .chats .chat-profile-name h6 {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  font-size: 8px;
  font-weight: 500;
  color: #6F6F6F;
}
.chat-msg-blk .chats .chat-profile-name h6 i {
  font-size: 12px;
  color: #008024;
}
.chat-msg-blk .chat-line {
  margin: 0px 0 20px;
  position: relative;
  text-align: center;
  width: 100%;
}
.chat-msg-blk .chat-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background-color: #00918E;
  width: 100%;
  height: 1px;
}
.chat-msg-blk .chat-line .chat-date {
  background-color: #00918E;
  color: #00918E;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 3px;
  display: inline-block;
  font-weight: 600;
  position: relative;
}

.right-user-side.call-user-side .slime-grp .right-sidebar-profile {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-bottom: 0;
  padding-bottom: 10px;
}
.right-user-side.call-user-side .slime-grp .right-sidebar-profile .profile-call-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.right-user-side.call-user-side .slime-grp .right-sidebar-profile .edit-group svg {
  width: 16px;
  color: #00918E;
}
.right-user-side.call-user-side .slime-grp .chat-options {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-bottom: 1px solid #00918E;
  padding-bottom: 20px;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a {
  color: #00918E;
  width: 30px;
  height: 30px;
  background-color: gray;
  padding: 0;
  border-radius: 50px;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a:hover {
  background: #e85b28;
  border-color: #e85b28;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a:hover svg {
  color: #FFF;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a svg {
  width: 15px;
}
.right-user-side.right-side-party .slime-grp {
  padding: 0px;
}
.right-user-side.right-side-party .slime-grp .left-chat-title {
  padding: 20px;
  margin-bottom: 0;
  background-color: #F9F9FC;
  border-radius: 10px 10px 0 0;
}
.right-user-side.right-side-party .slime-grp .left-chat-title h4 {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .left-chat-title h4 span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 25px;
  height: 25px;
  background-color: #FDA700;
  border-radius: 50px;
  font-size: 14px;
  color: #FFF;
  margin-left: 10px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk {
  padding: 20px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list {
  border-radius: 0.25rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 5px;
  display: flex;
  display: -webkit-flex;
  border-radius: 6px;
  background-color: #F6F7F8;
  margin-bottom: 10px;
  border: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item:hover {
  background-color: #F6F7F8;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar {
  margin-right: 0.8rem;
  display: inline-block;
  margin-bottom: 0;
  height: 40px;
  width: 40px;
  position: relative;
  flex-shrink: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar::before {
  top: 0;
  bottom: inherit;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar img {
  border-radius: 0px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-grow: 1;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user {
  display: grid;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user h5 {
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 2px;
  color: #6F6F6F;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user p {
  font-size: 12px;
  color: #FC0027;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user p svg {
  width: 14px;
  height: 14px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .chat-user-time .chats-dot a {
  color: #FC0027;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-chat-time .text-muted {
  font-size: 10px;
  color: #262A2A;
  font-weight: 500;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-chat-time .new-message-count {
  width: 20px;
  height: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  line-height: 0;
  font-size: 11px;
  background-color: #e85b28;
  color: #FFF;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 5px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time .call-recent a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 30px;
  height: 30px;
  background: #B8BCC9;
  color: #262A2A;
  border-radius: 50px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time .call-recent a svg {
  color: #262A2A;
}
.right-user-side .slimScrollDiv {
  height: calc(100vh - 110px) !important;
}
.right-user-side .slimScrollDiv .slimscroll {
  height: calc(100vh - 110px) !important;
}
.right-user-side .slime-grp {
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.4705882353);
  border: 1px solid #E1E8ED;
  border-radius: 10px;
  padding: 15px;
}
.right-user-side .slime-grp .left-chat-title {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
  background-color: #F9F9FC;
}
.right-user-side .slime-grp .left-chat-title .chat-title h4 {
  font-size: 18px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 26px;
  height: 26px;
  background: transparent;
  border-radius: 50px;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile:hover {
  background: #e85b28;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile:hover svg {
  color: #FFF;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile svg {
  width: 16px;
  color: #FC0027;
}
.right-user-side .slime-grp .chat-footer {
  position: sticky;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 15px;
  background: #FFF;
}
.right-user-side .slime-grp .chat-footer form {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  position: relative;
}
.right-user-side .slime-grp .chat-footer form .comman-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.right-user-side .slime-grp .chat-footer form .comman-icon a {
  color: #6F6F6F;
}
.right-user-side .slime-grp .chat-footer form .smile-col {
  right: inherit;
  left: 15px;
}
.right-user-side .slime-grp .chat-footer form .attach-col {
  right: inherit;
  left: 45px;
}
.right-user-side .slime-grp .chat-footer form .micro-col {
  right: 50px;
  left: inherit;
}
.right-user-side .slime-grp .chat-footer form .micro-col a {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.right-user-side .slime-grp .chat-footer form .send-chat {
  right: 5px;
}
.right-user-side .slime-grp .chat-footer form .send-chat a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 34px;
  height: 34px;
  background: #e85b28;
  border-radius: 50px;
}
.right-user-side .slime-grp .chat-footer form .send-chat a:hover {
  background: #1b2950;
}
.right-user-side .slime-grp .chat-footer form .send-chat a:hover svg {
  color: #FFF;
}
.right-user-side .slime-grp .chat-footer form .send-chat a svg {
  width: 14px;
  color: #FFF;
}
.right-user-side .slime-grp .chat-footer form .chat_form {
  border-radius: 20px;
  margin-right: 0px;
  background: #FFF;
  border: 1px solid rgba(145, 158, 171, 0.3);
  border-radius: 6px;
  height: 48px;
  padding: 10px 70px;
}
.right-user-side .slime-grp .chat-footer form .chat_form::placeholder {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.2);
}

.owl-carousel.video-slide .owl-nav.disabled {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}
.owl-carousel.video-slide .owl-nav {
  top: 50%;
  transform: translate(0, -50%);
}
@media (max-width: 1280px) {
  .owl-carousel.video-slide .owl-nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
  }
}
.owl-carousel.video-slide .owl-nav button.owl-next, .owl-carousel.video-slide .owl-nav button.owl-prev {
  background-color: #D9D9D9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.owl-carousel.video-slide .owl-nav button.owl-next:hover, .owl-carousel.video-slide .owl-nav button.owl-prev:hover {
  background-color: #e85b28;
}
.owl-carousel.video-slide .owl-nav button.owl-next:hover i, .owl-carousel.video-slide .owl-nav button.owl-prev:hover i {
  color: #FFF;
}
.owl-carousel.video-slide .owl-nav button.owl-next i, .owl-carousel.video-slide .owl-nav button.owl-prev i {
  color: #6F6F6F;
}

.audio-call-group {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 100%;
}
.audio-call-group ul {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  -webkit-justify-content: space-evenly;
  -ms-flex-pack: space-evenly;
  width: 100%;
}
.audio-call-group ul li {
  position: relative;
}
.audio-call-group ul li.active .avatar::before {
  content: "";
  width: 250px;
  height: 250px;
  position: absolute;
  border: 1px solid #e85b28;
  border-radius: 50%;
  left: -25px;
  top: -25px;
}
@media (max-width: 991.98px) {
  .audio-call-group ul li.active .avatar::before {
    width: 150px;
    height: 150px;
    left: -10px;
    top: -10px;
  }
}
@media (max-width: 767.98px) {
  .audio-call-group ul li.active .avatar::before {
    width: 100px;
    height: 100px;
    left: -5px;
    top: -5px;
  }
}
.audio-call-group ul li .avatar {
  width: 200px;
  height: 200px;
  margin: 0;
  position: relative;
}
@media (max-width: 991.98px) {
  .audio-call-group ul li .avatar {
    width: 130px;
    height: 130px;
  }
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .avatar {
    width: 90px;
    height: 90px;
  }
}
.audio-call-group ul li .avatar img {
  width: 100%;
  position: relative;
}
.audio-call-group ul li .user-audio-call h5 {
  font-size: 14px;
  color: #FFF;
  font-weight: 400;
  text-transform: capitalize;
  text-align: center;
  margin-top: 35px;
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .user-audio-call h5 {
    margin-top: 15px;
  }
}
.audio-call-group ul li .more-icon {
  position: absolute;
  bottom: 10px;
  right: inherit;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .more-icon {
    bottom: 0px;
  }
}
.audio-call-group ul li .more-icon a {
  background-color: #e85b28;
  color: #FFF;
}

.audio-volume {
  position: absolute;
  width: fit-content;
  height: 134px;
  bottom: 20px;
  left: 20px;
  background: #898989;
  border-radius: 50px;
  padding: 10px 14px;
  width: 30px;
  padding-bottom: 30px;
}
.audio-volume .volume-icons a {
  position: absolute;
  bottom: 0;
  width: 30px;
  height: 30px;
  left: 0;
  border-radius: 50px;
  background: #FFF;
  border: 1px solid #FDA700;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.custom-input {
  width: 100%;
  height: 4px;
  width: 3px;
  height: 100%;
  background: #FFF;
  border-radius: 5px;
  writing-mode: vertical-lr;
}

.custom-input::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  background: #e85b28 !important;
  border-radius: 50%;
  cursor: pointer;
}

.custom-input::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: #e85b28 !important;
  border-radius: 50%;
  cursor: pointer;
}

.table-top-head {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575.98px) {
  .table-top-head.low-stock-top-head {
    flex-wrap: wrap;
    justify-content: start;
  }
}
.table-top-head.low-stock-top-head li {
  margin-bottom: 10px;
}
.table-top-head.low-stock-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li {
  margin-right: 10px;
  flex-shrink: 0;
}
.table-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li #collapse-header {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .table-top-head li #collapse-header {
    display: none;
  }
}
.table-top-head li a {
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #898989;
  background: #FFF;
  border-radius: 8px;
  padding: 6px;
}
.table-top-head li a svg {
  color: #262A2A;
}
.table-top-head li a:hover {
  background: #e3e3e3;
}
.table-top-head li a label {
  margin-right: 10px;
}
.table-top-head li a.btn-secondary {
  background-color: #262A2A;
  color: #FFF;
  padding: 10px;
  font-weight: 700;
  font-size: 14px;
}
.table-top-head li a.btn-secondary:hover {
  background-color: #e85b28;
}
.table-top-head li a.btn-secondary svg {
  width: 16px;
  margin-right: 5px;
  color: #FFF;
}
@media (max-width: 767.98px) {
  .table-top-head li a.btn-secondary {
    padding: 5px;
    font-size: 14px;
  }
}
.table-top-head li a .action-edit.sales-action {
  color: #339DFF;
}
.table-top-head li .status-toggle {
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #C0C0C0;
  background: #FFF;
  border-radius: 8px;
  padding: 6px 10px;
}
.table-top-head li .status-toggle label {
  margin-right: 10px;
}

.main-chat-blk .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .slimscroll-active-sidebar a {
  color: #6F6F6F;
}
.main-chat-blk .emoj-group ul {
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group ul li + li {
  margin-left: 10px;
}
.main-chat-blk .emoj-group ul li a {
  width: 34px;
  height: 34px;
  background: #f6f7f8;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .emoj-group ul li a i {
  color: #424242;
}
.main-chat-blk .message-content {
  position: relative;
}
.main-chat-blk .message-content:hover .emoj-group {
  opacity: 1;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group {
  position: absolute;
  top: 50%;
  right: -100px;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  transform: translate(0, -50%);
}
.main-chat-blk .rig-emoji-group {
  position: absolute;
  right: 210px;
}
.main-chat-blk .wrap-emoji-group {
  position: absolute;
  right: 290px;
}
.main-chat-blk .emoj-group-list-foot {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list-foot ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list-foot ul li a {
  padding: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .down-emoji-circle {
  position: absolute;
  left: 10px !important;
  top: -38px !important;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul {
  padding: 10px;
}
.main-chat-blk .down-emoji-circle ul li + li {
  margin-left: 14px;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul li:last-child a {
  width: 34px;
  height: 34px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-page-wrapper .content {
  padding: 24px 0 0 24px;
}
.main-chat-blk .chat-page-wrapper .sidebar {
  position: static;
  position: initial;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat-page-wrapper .sidebar {
    margin-left: 0;
  }
}
.main-chat-blk .chat-page-wrapper .left-chat-title {
  padding: 12px;
  border-bottom: 1px solid #E0E0E0;
  min-height: 72px;
}
.main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  font-size: 18px;
  color: #262A2A;
  font-weight: 700;
}
.main-chat-blk .chat-page-wrapper .chat .slimscroll {
  height: calc(100vh - 135px) !important;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  font-size: 14px;
  cursor: pointer;
  padding: 7px 14px;
  font-weight: 500;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  float: right;
  font-size: 18px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item.active {
  background: none;
  color: inherit;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #e6e6e6;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu {
  background: #FFF;
  border: 1px solid #E5E7EB;
  box-sizing: border-box;
  box-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-width: 173px;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  margin: 0;
  position: relative;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu.chat-drop-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #F8ECFF;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .contact-close_call {
  display: flex;
  align-items: center;
}
@keyframes wave {
  0%, 100%, 60% {
    transform: none;
    transform: initial;
  }
  30% {
    transform: translateY(-5px);
  }
}
.main-chat-blk .chat {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  background: #FFF;
}
.main-chat-blk .chat .chat-header {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 15px 24px;
  align-items: center;
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
  border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: #FFF;
  background: var(--White, #FFF);
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  position: relative;
}
.main-chat-blk .chat .chat-header .user-details {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .user-details figure {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-header .user-details h5 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1;
  color: #262A2A;
}
.main-chat-blk .chat .chat-header .chat-options ul {
  margin-bottom: 0;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a {
  font-size: 14px;
  color: #262A2A;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a i {
  font-size: 20px;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a:not(.no-bg):hover {
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .chat .chat-body {
  flex: 1 1;
  padding: 24px;
  padding-bottom: 40px;
}
.main-chat-blk .chat .chat-body:not(.no-message) {
  overflow: hidden;
}
.main-chat-blk .chat .chat-body .messages {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: flex-start;
  -webkit-align-items: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats {
  max-width: 75%;
  margin-bottom: 1.5rem;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .chats:last-child {
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .avatar {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time h5 {
  font-size: 15px;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time {
  color: #FFF;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i {
  color: rgba(247, 247, 247, 0.5);
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i img {
  width: 14px;
  height: auto;
  margin-left: 2px;
  vertical-align: 0px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content {
  border-radius: 0px 15px 15px 15px;
  background: #F6F7F8;
  background: var(--light-color, #F6F7F8);
  padding: 14px 20px;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.031372549);
}
.main-chat-blk .chat .chat-body .messages .chats .message-content a {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link a {
  color: #262A2A;
  margin-bottom: 2px;
  display: block;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link img {
  border-radius: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.chat-award-link a {
  display: flex;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.fancy-msg-box .image-not-download span {
  position: absolute;
  color: #FFF;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  margin-bottom: 0;
  color: #262A2A;
  font-weight: 600;
  font-size: 15px;
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 span {
  font-size: 12px;
  color: #6F7A7A;
  font-weight: 400;
  padding-left: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right {
  margin-left: auto;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-time {
  justify-content: flex-end;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content {
  border-radius: 15px 0px 15px 15px;
  background: rgba(255, 159, 67, 0.12);
  color: #262A2A;
  padding: 15px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time {
  color: #6F7A7A;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time i {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns {
  order: 2;
  -webkit-order: 2;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-action-col {
  width: 20px;
  text-align: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-read-col {
  display: flex;
  display: -webkit-flex;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  padding-bottom: 22px;
  color: #565E5E;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-content {
  order: 1;
  -webkit-order: 1;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-avatar {
  padding: 8px 0px 0 15px;
}
.main-chat-blk .chat .chat-body .messages .download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col ul {
  list-style: none;
  padding: 0;
  margin: 0 0 5px 0;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .download-col ul li + li {
  margin-left: 5px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col a > img {
  border: 1px solid transparent;
  width: 80px;
  border-radius: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col.image-not-download a > img {
  filter: blur(1px);
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download {
  position: relative;
  background: #E8E8E8;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 7px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
  bottom: 14px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action a {
  color: #FFF;
  font-size: 10px;
  color: #323737;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type {
  width: 54px;
  height: 54px;
  background-color: #FFF;
  border-radius: 4px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type i {
  color: #6F7A7A;
  font-size: 24px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-name {
  color: #262A2A;
  display: inline-block;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-size {
  color: #6F7A7A;
  display: inline-block;
  width: 100%;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul {
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li {
  list-style: none;
  color: #262A2A;
  font-size: 14px;
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li:last-child::before {
  display: none;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li a {
  color: #e85b28;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li + li {
  padding-left: 15px;
}
.main-chat-blk .chat .chat-body.no-message {
  -webkit-user-select: none;
          user-select: none;
}
.main-chat-blk .chat .chat-footer {
  position: relative;
}
.main-chat-blk .chat .chat-footer form {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat .chat-footer form {
    padding-bottom: 15px;
  }
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn {
  margin-left: 0px;
  color: #6F6F6F;
  font-size: 20px;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn:last-child {
  margin-right: 0;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: #e85b28;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #FFF !important;
  margin-left: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover {
  background-color: #FFF;
  border-color: #323737;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover i {
  color: #323737;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:focus {
  box-shadow: none;
}
.main-chat-blk .chat .chat-footer form .specker-col span {
  color: #323737;
  font-size: 25px;
}
.main-chat-blk .chat .chat-footer form .attach-col {
  right: inherit;
  left: 60px;
}
.main-chat-blk .chat .chat-footer form .attach-col i {
  color: #323737;
  font-size: 20px;
}
.main-chat-blk .chat .chat-footer form .smile-col {
  right: inherit;
  left: 15px;
}
.main-chat-blk .chat .chat-footer form .smile-col i {
  color: #323737;
  font-size: 20px;
  font-size: 22px;
}
.main-chat-blk .chat .chat-footer form .smile-foot {
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle {
  width: 38px;
  height: 38px;
  background: #FFF;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle:hover {
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle i {
  color: #262A2A;
  font-size: 18px;
}
.main-chat-blk .chat .chat-footer form .form-control::-webkit-input-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control::-moz-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-ms-input-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-moz-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat-options ul.list-inline .list-inline-item {
  margin-bottom: 0;
}
.main-chat-blk .last-seen {
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .user_callog {
  display: flex;
  margin-top: 0px;
}
.main-chat-blk .calllog_p {
  margin-left: 5px;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a {
  background: #e85b28;
  width: 38px;
  height: 38px;
  border-radius: 50px;
  color: #262A2A;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF !important;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline {
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 0;
  padding-bottom: 15px;
}
.main-chat-blk .last-seen-profile span {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
  display: block;
}
.main-chat-blk .header_button {
  position: absolute;
  right: 5px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  color: #FFF;
  text-align: center;
  background: #ffa977;
  bottom: 40px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .btn-warning:hover {
  color: #FFF;
  background-color: #E94C39;
  border-color: #E73520;
}
.main-chat-blk .right_sidebar_profile {
  margin-top: 0px;
}
.main-chat-blk .account_details {
  background-color: #898989;
  border-color: #6F6F6F;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .security_details {
  background-color: #898989;
  border-color: #6F6F6F;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .close_icon {
  font-size: 18px;
}
.main-chat-blk .button_plus {
  margin-left: 0px;
}
.main-chat-blk .chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #FFF;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat-search input[type=text]:hover {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search input[type=text]:focus {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search input[type=text]:focus-visible {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .form-control-feedback {
  z-index: 2;
  display: block;
  text-align: center;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.main-chat-blk .form-control-feedback i {
  font-size: 16px;
  color: #262A2A;
}
.main-chat-blk .user-chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .user-chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #FFF;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .user-chat-search input[type=text]:hover {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search input[type=text]:focus {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search input[type=text]:focus-visible {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .all-chats {
  position: relative;
}
.main-chat-blk .close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .user-close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .main_content {
  width: 100% !important;
}
.main-chat-blk .avatar-main {
  height: 50px;
  width: 50px;
}
.main-chat-blk .archive-btn {
  border: 1px solid #008024;
  color: #565E5E;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  margin-right: 1.5rem;
}
.main-chat-blk .archive-btn-grey {
  border: 1px solid #909090;
  color: #6F7A7A;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 500;
  padding: 2px 6px;
  margin-top: 0.25rem;
}
.main-chat-blk .right_sidebar_icon {
  list-style: none;
}
.main-chat-blk .btn.btn-outline-light:hover {
  background: #e6e6e6;
}
.main-chat-blk .chat-avatar {
  padding: 8px 15px 0 8px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  flex-shrink: 0;
}
.main-chat-blk .chat-profile-name {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.main-chat-blk .chat-profile-name .chat-action-col a {
  display: flex;
}
.main-chat-blk .delete-pop-btn .btn-primary {
  margin: 0 0 0 10px;
}
.main-chat-blk .delete-model-head {
  padding: 40px;
}
.main-chat-blk .delete-model-head .modal-header {
  padding: 0;
  margin-bottom: 32px;
}
.main-chat-blk .delete-model-head .modal-body {
  padding: 0;
}
.main-chat-blk .delete-chat-notify {
  margin-bottom: 32px;
}
.main-chat-blk .delete-chat-notify .form-check {
  margin-bottom: 14px;
}
.main-chat-blk .chats.chats-right {
  flex-direction: row-reverse;
}
.main-chat-blk .message-star {
  display: flex;
  align-items: center;
}
.main-chat-blk .message-star .avatar {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}
.main-chat-blk .message-star .avatar img {
  width: 100%;
}
.main-chat-blk .message-star h6 {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.main-chat-blk .message-star h6 span i {
  color: #FEC14D;
}
.main-chat-blk .chat-voice-group ul {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat-voice-group ul li span {
  width: 28px;
  height: 28px;
  background: #e85b28;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat-voice-group li {
  margin-bottom: 0;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  list-style: none;
}
.main-chat-blk .chat-voice-group li + li {
  padding-left: 10px;
}
.main-chat-blk .file-download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .file-download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.main-chat-blk .file-download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .file-download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .file-download-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .file-download-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .file-download-col ul li {
  float: left;
  width: 50%;
  padding: 5px;
}
.main-chat-blk .file-download-col ul li .image-download-col {
  position: relative;
}
.main-chat-blk .file-download-col ul li .image-download-col a > img {
  width: 100%;
}
.main-chat-blk .file-download-col ul li.full-width {
  width: 100%;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single {
  border: 0;
  height: 24px;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 40px;
  padding-left: 0px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #6F7A7A;
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
  font-weight: 600;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 24px;
  right: 7px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #424848;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  left: 50%;
  margin-left: -5px;
  margin-top: -5px;
  position: absolute;
  top: 50%;
  width: 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.main-chat-blk .chat-select .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #262A2A;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--multiple {
  border: 1px solid #ddd;
  min-height: 40px;
}
.main-chat-blk .chat-select .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #424848;
  border-width: 2px 0 0 2px;
  padding: 3px;
  margin-top: -5px;
  border-color: #424848;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
}
.main-chat-blk .chat-select .select2-container--default.form-control-sm .select2-selection--single .select2-selection__arrow {
  top: 7px;
}
.main-chat-blk .chat-select .select2-container--open .select2-dropdown--below {
  margin-top: 10px;
}
.main-chat-blk .success-pass {
  margin-bottom: 40px;
  text-align: center;
}
.main-chat-blk .review-files p {
  margin-bottom: 5px;
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-top: 10px;
}
.main-chat-blk .like-chat-grp ul li {
  list-style: none;
}
.main-chat-blk .like-chat-grp ul li a {
  border: 1px solid #E0E0E0;
  border-radius: 50px;
  padding: 3px 12px;
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
  font-weight: 400;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul li a img {
  margin-left: 5px;
}
.main-chat-blk .like-chat-grp ul li + li {
  margin-left: 10px;
}
.main-chat-blk .like-chat-grp ul li.like-chat a {
  background: #FEF6DC;
}
.main-chat-blk .like-chat-grp ul li.comment-chat a {
  background: #FFE8E9;
}
.main-chat-blk .chat-line {
  margin: 0px 0 20px;
  position: relative;
  text-align: center;
  width: 100%;
}
.main-chat-blk .chat-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background-color: #E8E8E8;
  width: 100%;
  height: 1px;
}
.main-chat-blk .chat-date {
  border-radius: 100px;
  background: #E8E8E8;
  color: #262A2A;
  font-size: 14px;
  padding: 4px 20px;
  display: inline-block;
  font-weight: 400;
  position: relative;
  border: 1px solid #E0E0E0;
}
.main-chat-blk .chat + .sidebar-group {
  margin-right: 0px;
}
.main-chat-blk .chat + .sidebar-group .sidebar {
  margin-right: 0px;
}
.main-chat-blk .group-comman-theme {
  padding: 0 24px;
}
.main-chat-blk .group-comman-theme h6 {
  margin-bottom: 15px;
}
.main-chat-blk .group-comman-theme ul {
  padding: 0;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .group-comman-theme ul li {
  display: flex;
  align-items: center;
  list-style: none;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 10px;
}
.main-chat-blk .group-comman-theme ul li:last-child {
  margin-bottom: 0;
}
.main-chat-blk .group-comman-theme ul li .avatar {
  flex-shrink: 0;
  margin-right: 10px;
}
.main-chat-blk .theme-content h6 {
  margin-bottom: 6px;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .theme-content p {
  margin-bottom: 0;
  text-align: start;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .chat-message-grp {
  padding: 24px;
  padding-top: 0;
}
.main-chat-blk .chat-message-grp ul {
  padding: 0;
}
.main-chat-blk .chat-message-grp ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-message-grp ul li:last-child {
  margin-bottom: 0px;
}
.main-chat-blk .chat-message-grp ul li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp ul li a:hover .stared-group h6 {
  color: #323737;
}
.main-chat-blk .stared-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .stared-group span {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  margin-right: 10px;
  background: #F6F7F8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .stared-group span i {
  font-size: 16px;
}
.main-chat-blk .stared-group h6 {
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
  margin-bottom: 0;
}
.main-chat-blk .star-message {
  background: #FEF6DC;
}
.main-chat-blk .star-message i {
  color: #FEC14D;
}
.main-chat-blk .mute-message {
  background: rgba(235, 253, 255, 0.9803921569);
}
.main-chat-blk .mute-message i {
  color: #299cdb;
}
.main-chat-blk .block-message {
  background: #FFE8E9;
}
.main-chat-blk .block-message i {
  color: #4A00E5;
}
.main-chat-blk .report-message {
  background: #F8ECFF;
}
.main-chat-blk .report-message i {
  color: #262A2A;
}
.main-chat-blk .delete-message {
  background: #FFE8E9;
}
.main-chat-blk .delete-message i {
  color: #FD3352;
}
.main-chat-blk .count-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .count-group span {
  width: 16px;
  height: 16px;
  border-radius: 50px;
  color: #FFF;
  font-size: 10px;
  background: #e85b28;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 5px;
}
.main-chat-blk .count-group i {
  color: #424242;
  font-size: 16px;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link {
  font-size: 16px;
  font-weight: bold;
  color: #FFF;
  background-color: transparent;
  border: 0;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link.active {
  font-size: 16px;
  font-weight: bold;
  color: #E94C39;
}
.main-chat-blk .header-top ul li a {
  color: #000;
  font-size: 18px;
}
.main-chat-blk .set-search {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 50px;
  width: 28px;
  height: 28px;
}
.main-chat-blk .set-search:hover {
  background: #F5F5F5;
  border-color: #C0C0C0;
}
.main-chat-blk .header-action {
  list-style: none;
  margin: 0;
  padding: 0;
}
.main-chat-blk .header-action li {
  display: inline-block;
  margin-left: 10px;
}
.main-chat-blk .header-action li a {
  color: #262A2A;
  font-size: 18px;
}
.main-chat-blk .user-list {
  border-radius: 0.25rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.main-chat-blk .user-list li a {
  padding: 17px 20px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  border-radius: 6px;
  margin-bottom: 10px;
  border: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.main-chat-blk .user-list li .avatar {
  margin-right: 0.8rem;
  display: inline-block;
  margin-bottom: 0;
  height: 46px;
  width: 46px;
  border-radius: 50%;
  position: relative;
  z-index: 0;
}
.main-chat-blk .user-list li .avatar .letter-avatar {
  width: 45px;
  height: 45px;
  border-radius: 45px;
  margin-right: 0.8rem;
  margin-bottom: 0;
  position: relative;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  background-color: #6F6F6F;
  font-size: 16px;
  font-weight: 600;
  color: #676DFF;
}
.main-chat-blk .user-list li a.admin-shade {
  box-shadow: none;
}
.main-chat-blk .user-list .avatar > a > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .user-list .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-away::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
  background-color: #ffff00;
}
.main-chat-blk .avatar-offline::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
}
.main-chat-blk .avatar-online::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
  background-color: #00918E;
}
.main-chat-blk .animate-typing-col {
  color: #5CB85C;
}
.main-chat-blk .animate-typing-col .dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  margin-right: -1px;
  background: #0D9B35;
  animation: wave 1.3s linear infinite;
  opacity: 0.6;
}
.main-chat-blk .animate-typing-col .dot:nth-child(2) {
  animation-delay: -1.1s;
}
.main-chat-blk .animate-typing-col .dot:nth-child(3) {
  animation-delay: -0.9s;
}
.main-chat-blk .chat_form {
  border-radius: 20px;
  margin-right: 0px;
  background: #FFF;
  border: 1px solid #C2C2C2;
  box-shadow: 0px 4px 4px #F5F8FF;
  border-radius: 6px;
  height: 40px;
  padding: 10px 10px;
}
.main-chat-blk .contact-close a {
  color: #262A2A;
  opacity: 0.5;
  border-color: #898989;
}
.main-chat-blk .main-wrapper .content .sidebar-group.right-sidebar .sidebar {
  width: 310px;
}
.main-chat-blk .primary-title {
  color: #E94C39;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}
.main-chat-blk .primary-title i {
  font-size: 14px;
}
.main-chat-blk .contact-action {
  padding: 0;
  margin: 0;
  list-style: none;
}
.main-chat-blk .contact-action li {
  padding: 11px 0;
  border-bottom: 1px solid #f1f1f1;
}
.main-chat-blk .contact-action li a {
  color: #262A2A;
  color: #262A2A;
  font-size: 14px;
  font-weight: bold;
}
.main-chat-blk .contact-action li.report-contact a {
  color: #FC0027;
}
.main-chat-blk .contact-action li.delete-chat a {
  color: #FC0027;
}
.main-chat-blk .contact-action li.sign-out a {
  color: #FC0027;
}
.main-chat-blk .left-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
}
.main-chat-blk .left-sidebar-wrap {
  background: #FBFBFB;
  overflow: hidden;
  width: 448px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .right-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  background-color: #FDFDFE;
  opacity: 100%;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  position: relative;
  width: 320px;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap {
  background-color: #FFF;
  border-left: 1px solid #E0E0E0;
  border-radius: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  height: calc(100vh - 0px);
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .sidebar-body {
  padding: 0;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .right-sidebar-profile {
  padding: 24px;
  padding-bottom: 0;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-star {
  color: #FDA700;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-trash {
  color: #FC0027;
}
.main-chat-blk .right-sidebar.video-right-sidebar {
  width: 371px;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat {
  margin-left: 0 !important;
  display: block;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat .chat-body {
  padding-bottom: 110px;
}
.main-chat-blk .video-call-chat .left-chat-title.with-bg {
  background: transparent;
}
.main-chat-blk .video-call-chat .left-chat-title {
  border: 0;
}
.main-chat-blk .video-call-chat .chat-title h4 {
  font-size: 18px;
  font-weight: 600;
  color: #262A2A;
}
.main-chat-blk .video-call-chat .chat-title span {
  font-size: 12px;
  font-weight: 400;
  color: #262A2A;
}
.main-chat-blk .chat.video-call-chat .chat-body {
  background-image: none;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats.chats-right .message-content {
  background: #F8ECFF;
}
.main-chat-blk .member-details {
  margin-bottom: 10px;
}
.main-chat-blk .chat-member-details {
  padding: 0 24px;
}
.main-chat-blk .chat-member-details .member-details ul {
  padding: 0;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .chat-member-details .member-details ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-member-details .member-details ul li h6 {
  font-size: 15px;
  font-weight: 400;
  color: #262A2A;
  margin-bottom: 5px;
}
.main-chat-blk .chat-member-details .member-details ul li h5 {
  font-size: 15px;
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 0px;
}
.main-chat-blk .chat-member-details .member-details ul li span {
  font-size: 16px;
  font-weight: 400;
  color: #262A2A;
}
.main-chat-blk .chat-member-details .member-details ul li a {
  font-size: 15px;
  font-weight: 500;
  color: #323737;
  border-radius: 100px;
  padding: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-member-details .member-details ul li a:hover {
  color: #262A2A;
}
.main-chat-blk .chat-member-details .member-details ul li a + a {
  margin-left: 10px;
}
.main-chat-blk .right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.video-right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.hide-right-sidebar {
  margin-right: -320px;
}
.main-chat-blk .right-sidebar.video-right-sidebar.hide-right-sidebar {
  margin-right: -371px;
}
.main-chat-blk .status-modal .custom-status-close {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .group-description .description-sub h5 span a {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  border-color: #C0C0C0;
}
.main-chat-blk .list_group_notread {
  color: #E94C39 !important;
}
.main-chat-blk .chat-cont-type {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper {
  margin-bottom: 0;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper p {
  color: #6F7A7A;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-type-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-size: 16px;
  font-weight: 400;
  color: #262A2A;
  margin-right: 24px;
}
.main-chat-blk .group-type-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark {
  background-color: #323737;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark:after {
  display: block;
}
.main-chat-blk .group-type-radio .checkmark:after {
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
}
.main-chat-blk .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #FFF;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
}
.main-chat-blk .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.main-chat-blk .pass-login label {
  color: #262A2A;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #323737 !important;
}
.main-chat-blk .right-sidebar-profile > .avatar {
  background: rgba(66, 11, 161, 0.1);
}
.main-chat-blk .group_img {
  position: relative;
  display: inline-block;
}
.main-chat-blk .group-name-search {
  margin-bottom: 14px;
}
.main-chat-blk .parti-wrapper {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.main-chat-blk .group_header {
  width: 38px !important;
  height: 38px !important;
  border: 2px solid #FFF;
}
.main-chat-blk .last-chat-time i.missed-col {
  width: 17px;
  display: inline-block;
  margin-top: 10px;
}
.main-chat-blk .last-chat-time i.missed-col img {
  max-width: 100%;
  height: auto;
}
.main-chat-blk .right-sidebar-head {
  padding: 0px 24px;
}
.main-chat-blk .right-sidebar-head h5 {
  font-size: 15px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .share-media-blk {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 10px;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav-tabs {
  margin-bottom: 15px;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item.active {
  background: #e85b28;
  border-radius: 6px;
  color: #262A2A;
  color: #FFF;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item {
  padding: 2px 10px;
  font-size: 14px;
  color: #262A2A;
  font-weight: 500;
  border: 0;
  margin-right: 10px;
  background: #F9F9FC;
  color: #262A2A;
  border-radius: 6px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item:last-child {
  margin-right: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li {
  margin: 0px 6px 6px 0px;
  position: relative;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li img {
  border-radius: 8px;
  width: 84px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span {
  position: absolute;
  color: #FFF;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span i {
  font-size: 20px;
  color: #FFF;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li:hover span i {
  color: #898989;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li.blur-media img {
  filter: blur(2px);
}
.main-chat-blk .media-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .media-file:last-child {
  margin-bottom: 0;
}
.main-chat-blk .media-doc-blk {
  display: flex;
  align-items: center;
}
.main-chat-blk .media-doc-blk span {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 10px;
}
.main-chat-blk .media-doc-blk span i {
  font-size: 24px;
}
.main-chat-blk .document-detail ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .document-detail ul li {
  list-style: none;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  position: relative;
}
.main-chat-blk .document-detail ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .document-detail ul li:last-child::before {
  display: none;
}
.main-chat-blk .document-detail ul li + li {
  padding-left: 15px;
}
.main-chat-blk .document-detail h6 {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .media-download a {
  color: #262A2A;
}
.main-chat-blk .social-media-col {
  margin-top: 35px;
}
.main-chat-blk .social-media-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .social-media-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .social-media-col ul li {
  float: left;
}
.main-chat-blk .social-media-col ul li a {
  color: #676DFF;
  font-size: 18px;
}
.main-chat-blk .social-media-col ul li + li {
  margin-left: 10px;
}
.main-chat-blk .social-media-col h6 {
  font-weight: 600;
  color: #000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .media-link-grp {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.main-chat-blk .media-link-detail h6 a {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
}
.main-chat-blk .media-link-detail span a {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}
.main-chat-blk .media-link-detail a:hover {
  color: #323737;
}
.main-chat-blk .share-media-blk a {
  color: #323737;
  font-weight: 500;
}
.main-chat-blk .link-img {
  flex-shrink: 0;
}
.main-chat-blk .link-img img {
  border-radius: 4px;
  margin-right: 10px;
}
.main-chat-blk .settings-col {
  margin-top: 35px;
}
.main-chat-blk .settings-col h6 {
  font-weight: 600;
  color: #000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .settings-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .settings-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .settings-col ul li {
  color: #565E5E;
  font-weight: 500;
}
.main-chat-blk .settings-col ul li + li {
  margin-top: 15px;
}
.main-chat-blk .settings-col .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 23px;
  margin-bottom: 0;
  margin-right: 10px;
}
.main-chat-blk .settings-col .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.main-chat-blk .settings-col .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #6F7A7A;
  transition: 0.4s;
}
.main-chat-blk .settings-col .slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 4px;
  background-color: #FFF;
  transition: 0.4s;
}
.main-chat-blk .settings-col input:checked + .slider {
  background-color: #339DFF;
}
.main-chat-blk .settings-col input:checked + .slider:before {
  transform: translateX(16px);
}
.main-chat-blk .settings-col input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
.main-chat-blk .settings-col .slider.round {
  border-radius: 34px;
}
.main-chat-blk .settings-col .slider.round:before {
  border-radius: 50%;
}
.main-chat-blk .report-col {
  margin-top: 35px;
  padding: 12px;
  padding-bottom: 50px;
}
.main-chat-blk .report-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .report-col ul:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul li {
  display: block;
  width: 100%;
  font-weight: 500;
  position: relative;
}
.main-chat-blk .report-col ul li a {
  color: #FC0027;
  padding-left: 25px;
}
.main-chat-blk .report-col ul li a span {
  position: absolute;
  left: 0;
  top: 0px;
  font-size: 16px;
}
.main-chat-blk .report-col ul li + li {
  margin-top: 19px;
}
.main-chat-blk .load-more-btn {
  font-weight: 600;
  margin-top: 10px;
}
.main-chat-blk .load-more-btn i {
  background: #0057FF;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  color: #FFF;
  line-height: 8px;
  font-size: 12px;
  vertical-align: top;
}
.main-chat-blk .chat-message-grp.chat-encrypt {
  padding-bottom: 0;
}
.main-chat-blk .chat-message-grp.chat-encrypt ul {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list {
  padding: 0px 24px;
}
.main-chat-blk .participants-list .participants-list-group h6.parti-search {
  font-size: 20px !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .participants-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .participants-list ul li {
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  background-color: #FFF;
  padding: 10px;
}
.main-chat-blk .participants-list ul li + li {
  margin-top: 10px;
}
.main-chat-blk .participants-list .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
  display: -webkit-flex;
  width: 100%;
}
.main-chat-blk .participants-list .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #262A2A;
}
.main-chat-blk .participants-list .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .participants-list .admin-profiles {
  display: inline-block;
  color: #323737;
  border-radius: 6px;
  font-size: 12px;
  padding: 2px 10px;
  font-weight: 500;
  background: #F8ECFF;
}
.main-chat-blk .participants-list .admin-profiles:hover {
  background: #680A83;
  color: #FFF;
}
.main-chat-blk .participants-list-group {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list-group h6 {
  margin-bottom: 15px;
  font-size: 15px;
  font-weight: 500;
  color: #262A2A;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp.group-exits {
  padding: 0px 24px;
  padding-bottom: 30px;
}
.main-chat-blk .grp-delete .chat-action-col {
  display: flex;
  align-items: center;
  height: 100%;
}
.main-chat-blk .grp-delete .chat-action-col > a {
  color: #6F7A7A;
}
.main-chat-blk .chat-action-col > a {
  color: #262A2A;
}
.main-chat-blk .darkmode-btn {
  width: 35px;
  height: 32px;
  background-color: #339DFF;
  border: 1px solid #FBFBFB;
  border-radius: 5px;
  color: #FFF;
  font-size: 16px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .darkmode-btn:hover {
  color: #FFF;
}
.main-chat-blk .darkmode-btn:focus {
  color: #FFF;
}
.main-chat-blk .add-contacts-btn {
  width: 25px;
  height: 25px;
  border-radius: 30px;
  background-color: #323737;
  color: #FFF;
  font-size: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .add-contacts-btn:hover {
  color: #FFF;
}
.main-chat-blk .add-contacts-btn:focus {
  color: #FFF;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link {
  color: #323737;
  border: 0;
  border-radius: 10px;
  font-weight: 500;
  padding: 6px 25px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link:hover {
  color: #323737;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link + .nav-link {
  margin-left: 10px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link.active {
  background-color: rgba(90, 7, 139, 0.1);
  color: #323737;
}
.main-chat-blk .group-call-tab nav {
  padding: 0 15px 20px;
  position: relative;
}
.main-chat-blk .group-call-tab nav:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #6F6F6F;
  height: 1px;
}
.main-chat-blk .header_image {
  width: 195px;
}
.main-chat-blk .chat_avator_img {
  position: relative;
}
.main-chat-blk .group_img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .dreams_chat {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .voice_pop {
  padding-right: 17px;
}
.main-chat-blk .status_carousel {
  margin-top: 50px;
}
.main-chat-blk .carousel_img {
  width: 650px;
  height: 434px;
}
.main-chat-blk .video_content {
  min-height: 200px;
  margin-top: 70px;
}
.main-chat-blk .voice-call-content {
  min-height: 200px;
}
.main-chat-blk .chatimage img {
  width: 120px;
  height: 120px;
}
.main-chat-blk .send-btn_status {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #FFF !important;
  background-color: #FFA977 !important;
  margin-left: 15px;
  font-size: 22px;
}
.main-chat-blk .status_telegram {
  color: #FFF;
}
.main-chat-blk .media-lists {
  display: flex;
  justify-content: flex-start;
  margin: 0 -5px 0px;
  flex-wrap: wrap;
}
.main-chat-blk .media-lists .media-image {
  margin: 5px;
  flex-basis: 74px;
  min-width: 74px;
}
.main-chat-blk .media-lists .media-image img {
  max-width: 100%;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .list-group-item {
  background-color: inherit;
  border-color: #ebebeb;
}
.main-chat-blk ul.list-inline .list-inline-item {
  margin-bottom: 0.5rem;
}
.main-chat-blk .form-control {
  border-radius: 5px;
}
.main-chat-blk .form-control:focus {
  box-shadow: none;
  border-color: #e6e6e6;
}
.main-chat-blk .custom-control-label {
  line-height: 25px;
}
.main-chat-blk .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #0a80ff;
}
.main-chat-blk .open_drop {
  color: #FFF !important;
}
.main-chat-blk .send-btn_status:focus {
  box-shadow: none !important;
  border-color: #ffa977 !important;
}
.main-chat-blk .avatar {
  display: inline-block;
  margin-bottom: 0;
  height: 48px;
  width: 48px;
  border-radius: 50%;
}
.main-chat-blk .avatar .avatar-title {
  color: #FFF;
  background: #680A83;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 19px;
  font-weight: 600;
}
.main-chat-blk .avatar > a {
  width: 100%;
  height: 100%;
  display: block;
  transition: color 0.3s;
  color: #0a80ff;
}
.main-chat-blk .avatar > a > img,
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar.avatar-sm {
  height: 1.3rem;
  width: 1.3rem;
}
.main-chat-blk .avatar.avatar-sm .avatar-title {
  font-size: 14px;
}
.main-chat-blk .avatar.avatar-lg {
  height: 3.8rem;
  width: 3.8rem;
}
.main-chat-blk .avatar.avatar-lg .avatar-title {
  font-size: 29px;
}
.main-chat-blk .avatar.avatar-xl {
  height: 100px;
  width: 100px;
}
.main-chat-blk .header_drop_icon {
  border-radius: 6px;
}
.main-chat-blk .accordion-col .accordion-title {
  cursor: pointer;
  padding: 15px 0 8px;
}
.main-chat-blk .accordion-col .accordion-title .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.main-chat-blk .accordion-col .accordion-title.active .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
}
.main-chat-blk .accordion-col .accordion-content {
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 15px;
}
.main-chat-blk .accordion-col .accordion-content:last-child {
  border-bottom: 0;
}
.main-chat-blk .accordion-col .accordion-content h6 {
  font-size: 14px;
}
.main-chat-blk .status-right {
  font-weight: 500;
  color: #444444;
  font-size: 16px;
  text-align: center;
}
.main-chat-blk .status-right p {
  margin-top: 20px;
  margin-bottom: 0;
}
.main-chat-blk .star-drop .btn-outline-light {
  color: #424242;
  border: 0;
  padding: 0;
}
.main-chat-blk .star-drop .btn-outline-light i {
  font-size: 20px;
}
.main-chat-blk .star-drop .btn.btn-outline-light:hover {
  background: transparent;
  border: 0;
}
.main-chat-blk .chat.star-chat-group {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats {
  max-width: 100%;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {
  word-break: break-all;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {
  max-width: 100%;
}
.main-chat-blk .chat .chat-body .messages .chats.forward-chat-msg {
  display: none;
}
.main-chat-blk .chats.forward-chat-msg {
  background: #EDEDED;
  border-radius: 15px;
  padding: 20px;
  border-left: 2px solid #680A83;
}
.main-chat-blk .chats.forward-chat-msg .chat-avatar {
  padding: 0;
  padding-right: 15px;
}
.main-chat-blk .chat-title h4 a {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #4B0973;
  margin-bottom: 0;
}
.main-chat-blk .left-chat-title .add-section > a {
  width: 30px;
  height: 30px;
  background-color: #680A83;
  border-radius: 30px;
  color: #FFF;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  font-size: 13px;
}
.main-chat-blk .add-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .add-section ul li {
  float: left;
  border-radius: 50px;
  width: 28px;
  height: 28px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .add-section ul li + li {
  margin-left: 10px;
}
.main-chat-blk .add-section ul li a {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  font-size: 20px;
}
.main-chat-blk .all-chats .add-section ul li:hover {
  background-color: #F5F5F5;
  border-color: #F5F5F5;
}
.main-chat-blk .online {
  color: #008024;
  font-weight: 500;
}
.main-chat-blk .top-online-contacts {
  padding: 24px 24px 0px;
}
.main-chat-blk .fav-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .fav-title h6 {
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.main-chat-blk .fav-title h6 i {
  font-size: 22px;
}
.main-chat-blk .fav-title a {
  margin-bottom: 0;
  color: #e85b28;
  font-weight: 500;
}
.main-chat-blk .fav-title a:hover {
  color: #0A0A0A;
}
.main-chat-blk .top-contacts-box .profile-img {
  position: relative;
  width: 46px;
  height: 46px;
}
.main-chat-blk .top-contacts-box .profile-img img {
  max-width: 100%;
  height: auto;
  border-radius: 50px;
}
.main-chat-blk .profile-name span {
  color: #585858;
  font-size: 12px;
  display: inline-block;
  margin-top: 9px;
}
.main-chat-blk .top-contacts-box .profile-img.online:before {
  content: "";
  position: absolute;
  right: 0;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  top: 0px;
  background-color: #49E073;
  width: 10px;
  height: 10px;
  border: 2px solid #FFF;
  border-radius: 50px;
}
.main-chat-blk .dropdown-menu .dropdown-item span.edit-profile-icon,
.main-chat-blk .dropdown-menu .dropdown-item span.profile-icon-col {
  font-size: 15px;
}
.main-chat-blk .avatar {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
}
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-title {
  width: 100%;
  height: 100%;
  background-color: #650681;
  color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .avatar-away::before,
.main-chat-blk .avatar-offline::before,
.main-chat-blk .avatar-online::before {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #FFF;
}
.main-chat-blk .avatar-online::before {
  background-color: #00e65b;
}
.main-chat-blk .avatar-offline::before {
  background-color: #ff0100;
}
.main-chat-blk .avatar-away::before {
  background-color: #ffbc34;
}
.main-chat-blk .avatar .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar .rounded {
  border-radius: 6px !important;
}
.main-chat-blk .avatar .avatar-title {
  font-size: 18px;
}
.main-chat-blk .avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}
.main-chat-blk .avatar-xs .border {
  border-width: 2px !important;
}
.main-chat-blk .avatar-xs .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-xs .avatar-title {
  font-size: 10px;
}
.main-chat-blk .avatar-xs.avatar-away::before,
.main-chat-blk .avatar-xs.avatar-offline::before,
.main-chat-blk .avatar-xs.avatar-online::before {
  border-width: 1px;
}
.main-chat-blk .avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.main-chat-blk .avatar-sm .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-sm .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-sm .avatar-title {
  font-size: 15px;
}
.main-chat-blk .avatar-sm.avatar-away::before,
.main-chat-blk .avatar-sm.avatar-offline::before,
.main-chat-blk .avatar-sm.avatar-online::before {
  border-width: 2px;
}
.main-chat-blk .avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}
.main-chat-blk .avatar-lg .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-lg .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-lg .avatar-title {
  font-size: 24px;
}
.main-chat-blk .avatar-lg.avatar-away::before,
.main-chat-blk .avatar-lg.avatar-offline::before,
.main-chat-blk .avatar-lg.avatar-online::before {
  border-width: 3px;
}
.main-chat-blk .avatar-xl {
  width: 5rem;
  height: 5rem;
}
.main-chat-blk .avatar-xl .border {
  border-width: 4px !important;
}
.main-chat-blk .avatar-xl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xl .avatar-title {
  font-size: 28px;
}
.main-chat-blk .avatar-xl.avatar-away::before,
.main-chat-blk .avatar-xl.avatar-offline::before,
.main-chat-blk .avatar-xl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
.main-chat-blk .avatar-xxl .border {
  border-width: 6px !important;
}
.main-chat-blk .avatar-xxl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xxl .avatar-title {
  font-size: 30px;
}
.main-chat-blk .avatar-xxl.avatar-away::before,
.main-chat-blk .avatar-xxl.avatar-offline::before,
.main-chat-blk .avatar-xxl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-group {
  display: flex;
  display: -webkit-flex;
  padding-left: 15px;
  margin-left: auto;
  margin-right: 15px;
  cursor: pointer;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .avatar-group .avatar-xs + .avatar-xs {
  margin-left: -15px;
}
.main-chat-blk .avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.625rem;
}
.main-chat-blk .avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1rem;
}
.main-chat-blk .avatar-group .avatar-xl + .avatar-xl {
  margin-left: -1.28125rem;
}
.main-chat-blk .avatar-group .avatar:hover {
  z-index: 1;
}
.main-chat-blk .avatar-group.group-col {
  display: block;
}
.main-chat-blk .avatar-group.group-col > div {
  display: flex;
  display: -webkit-flex;
  padding-bottom: 5px;
}
.main-chat-blk .avatar-group.group-col .avatar {
  margin-right: 0;
}
.main-chat-blk .contact-close {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 5%;
}
.main-chat-blk .status_contactclose {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 1%;
}
.main-chat-blk .status-active {
  border: 4px solid #650681;
}
.main-chat-blk .avatar.avatar-xl .avatar-title {
  font-size: 39px;
}
.main-chat-blk .nav.nav-tabs {
  border: none;
  line-height: 2;
}
.main-chat-blk .badge {
  padding: 5px 10px;
  font-size: 11px;
}
.main-chat-blk .badge.badge-success {
  background: #0abb87;
}
.main-chat-blk .badge.badge-danger {
  background: #fd397a;
}
.main-chat-blk .badge.badge-secondary {
  background: dimgray;
}
.main-chat-blk .badge.badge-info {
  background: #00bcd4;
}
.main-chat-blk .badge.badge-warning {
  background: #ffb822;
}
.main-chat-blk .badge.badge-dark {
  background: #3a3f51;
}
.main-chat-blk .badge.badge-primary {
  background: #0a80ff;
}
.main-chat-blk .badge.badge-light {
  background: #e6e6e6;
}
.main-chat-blk .btn {
  position: relative;
}
.main-chat-blk .btn .badge {
  padding: 2px 6px;
  right: 7px;
  top: -7px;
  position: absolute;
}
.main-chat-blk .input-group .input-group-text {
  font-size: 14px;
}
.main-chat-blk .tooltip > .tooltip-inner {
  text-align: left;
  max-width: 500px;
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip {
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip .arrow {
  display: none;
  background-color: #e85b28;
}
.main-chat-blk .tooltip .tooltip-inner {
  background-color: #e85b28;
}
.main-chat-blk .sticky-top {
  z-index: auto;
}
.main-chat-blk .tab-content {
  padding-top: 30px;
}
.main-chat-blk .tab-content .form-item {
  margin-bottom: 0.8rem;
}
.main-chat-blk .main-wrapper {
  height: 100vh;
  overflow: hidden;
}
.main-chat-blk .main-wrapper .content {
  display: flex;
  display: -webkit-flex;
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content {
    display: block;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  z-index: 99;
  width: 340px;
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content .sidebar-group {
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .main-chat-blk .chats .chat-content {
    width: calc(100% - 55px);
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background: #FFF;
  overflow: hidden;
  width: 340px !important;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  border-right: 1px solid rgb(224, 224, 224);
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
    width: 100% !important;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar:not(.active) {
  display: none;
}
.main-chat-blk .header-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  font-weight: 600;
  background-color: #680A83;
}
.main-chat-blk .header-top .logo {
  margin-top: 0 !important;
}
.main-chat-blk .header-top > span {
  font-size: 22px;
}
.main-chat-blk .header-top ul {
  margin-bottom: 0;
  display: flex;
}
.main-chat-blk .header-top ul.header-action {
  margin-top: 14px !important;
}
.main-chat-blk .chat-header ul {
  margin-bottom: 0;
}
.main-chat-blk .chat-header ul li:not(.list-inline-item) {
  margin-bottom: 0;
  width: 48px;
  margin-right: 15px !important;
}
.main-chat-blk .chat-header ul li:last-child {
  margin-right: 0 !important;
}
.main-chat-blk .sidebar-body {
  flex: 1 1;
  overflow: auto;
  padding: 24px 24px 10px;
  width: 100%;
}
.main-chat-blk .pin-chat img {
  margin-right: 6px;
}
.main-chat-blk .sidebar-body .profile-name {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
  margin-bottom: 0;
}
.main-chat-blk .online-profile {
  position: relative;
}
.main-chat-blk .online-profile span {
  position: relative;
  color: #565656;
  font-size: 13px;
  padding-left: 10px;
}
.main-chat-blk .online-profile span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 7px;
  background-color: #49E073;
  width: 8px;
  height: 8px;
  border-radius: 50px;
}
.main-chat-blk .close_profile4 {
  color: #000;
  border-color: #e6e6e6;
}
.main-chat-blk .sidebar .user-list li a {
  padding: 10px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  margin-bottom: 15px;
  border: 1px solid #E0E0E0;
  box-shadow: none;
  border-radius: 5px;
  position: relative;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li a:hover {
  background-color: rgba(254, 159, 67, 0.08);
  border: 1px solid rgba(254, 159, 67, 0.08);
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li.item-typing {
  background-color: #F1F6FF;
}
.main-chat-blk .sidebar .user-list li figure {
  margin-right: 1rem;
}
.main-chat-blk .sidebar .user-list li .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
}
.main-chat-blk .lock-icon {
  color: #000000;
}
.main-chat-blk .sidebar .user-list li .users-list-body > div:first-child {
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .parti-notify-check {
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .sidebar .user-list li .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #0A0A0A;
}
.main-chat-blk .sidebar .user-list li .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #232323;
  font-size: 14px;
}
.main-chat-blk .sidebar .user-list li .users-list-body p.missed-call-col {
  color: #DE3E44;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time {
  padding-left: 15px;
  position: relative;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #424242 !important;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 5px;
  display: block;
  text-align: right;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {
  color: #680A83;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .new-message-count {
  width: 20px;
  height: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  line-height: 0;
  font-size: 11px;
  background-color: #e85b28;
  color: #FFF;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 10px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0;
  text-align: right;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  width: 18px;
  height: 24px;
}
.main-chat-blk .sidebar .user-list li.unread h5 {
  color: #FFF;
}
.main-chat-blk .sidebar .user-list li.unread p {
  color: #FFF;
}
.main-chat-blk .sidebar .user-list li.unread .text-muted {
  color: rgba(255, 255, 255, 0.4) !important;
}
.main-chat-blk .sidebar .user-list li.user-list-item.item-typing .users-list-body p {
  color: #0D9B35;
}
.main-chat-blk .rightside_tab {
  padding-top: 5px !important;
}
.main-chat-blk .chat-pin {
  display: flex;
  align-items: center;
  justify-content: end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.main-chat-blk .chat-pin .green-check {
  color: #0D9B35;
}
.main-chat-blk .chat-pin img {
  width: 10px;
}
.main-chat-blk .chat-pin .check {
  color: #53BDEB;
}
.main-chat-blk .select-message-box {
  margin-top: 50px;
}
.main-chat-blk .select-message-box h4 {
  margin-bottom: 5px;
}
.main-chat-blk .select-message-box p {
  margin-top: 0;
  margin-bottom: 24px;
  color: #424242;
  font-size: 16px;
  font-weight: 400;
}
.main-chat-blk .select-message-box .btn i {
  font-size: 15px;
}
.main-chat-blk .group-description {
  padding: 0px 24px;
}
.main-chat-blk .group-description .description-sub {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .group-description h5 {
  font-size: 15px;
  font-weight: 500;
  color: #0A0A0A;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .group-description h5 a:hover {
  color: #650681 !important;
}
.main-chat-blk .group-description p {
  color: #424242;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}
.main-chat-blk .group-description p.description-date {
  color: #424242;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0px;
}
.main-chat-blk .encrypted-message p {
  font-size: 12px;
  color: #424242;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-view-all {
  margin-top: 10px;
}
.main-chat-blk .group-view-all a {
  color: #680A83;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .group-view-all a:hover {
  color: #0A0A0A;
}
.main-chat-blk .exit-bg-message {
  background: #FFE8E9;
}
.main-chat-blk .exit-bg-message i {
  color: #DE3E44;
}
.main-chat-blk .disapper-message {
  background: #E7FAF2;
}
.main-chat-blk .disapper-message i {
  color: #1BA345;
}
.main-chat-blk .group-setting-msg {
  background: #F8ECFF;
}
.main-chat-blk .group-setting-msg i {
  color: #680A83;
}
.main-chat-blk .group-setting .stared-group span {
  width: 50px;
  height: 50px;
}
.main-chat-blk .edit-set-details p {
  font-size: 14px;
  font-weight: 400;
  color: #424242;
  margin-bottom: 0;
}
.main-chat-blk .group-send-msg {
  background: #FEF6DC;
}
.main-chat-blk .parcipant-check p a {
  color: #680A83;
}
.main-chat-blk .select-group-chat .dropdown-toggle::after {
  display: none;
}
.main-chat-blk .select-group-chat .dropdown-toggle i {
  margin-left: 15px;
}
.main-chat-blk .select-group-chat .dropdown-toggle:hover {
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-toggle {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
}
.main-chat-blk .select-group-chat .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {
  border-radius: 5px 5px 0 0;
}
.main-chat-blk .select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {
  border-radius: 0 0 5px 5px;
}
.main-chat-blk .dropzone {
  background: #FFF;
  border: 1px dashed #C2C2C2;
  border-radius: 5px;
  padding: 10px;
  min-height: 70px;
  text-align: center;
}
.main-chat-blk .dropzone.dz-clickable .dz-message {
  display: none;
}
.main-chat-blk .dropzone p {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #0A0A0A;
}
.main-chat-blk .dropzone span {
  color: #424242;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .uplaod-image img {
  border-radius: 20px;
}
.main-chat-blk .upload-img-file .modal-body {
  padding: 0;
}
.main-chat-blk .upload-img-file .modal-content {
  position: relative;
}
.main-chat-blk .upload-img-file .modal-header {
  position: absolute;
  top: 0;
  z-index: 9;
  left: 0;
  right: 0;
}
.main-chat-blk .upload-image-list {
  display: flex;
  align-items: center;
}
.main-chat-blk .upload-image-list li + li {
  margin-left: 10px;
}
.main-chat-blk .upload-img-file .modal-header .close {
  background-color: transparent;
  color: #FFF;
}
.main-chat-blk .check-star i {
  color: #FEC001;
}
.main-chat-blk .emoj-group-list {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list ul li a {
  padding: 0;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .chat .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .settings-option {
  display: none;
  text-align: right;
}
.main-chat-blk .settings-option a {
  font-size: 15px;
  font-weight: 500;
  color: #680A83;
}
.main-chat-blk .empty-dark-img {
  display: none;
}
.main-chat-blk .bootstrap-datetimepicker-widget span {
  position: relative;
}

.chat-window .card .card-header {
  background-color: #FFF;
  border-bottom: 1px solid #898989;
}
.chat-window .badge-success {
  background-color: #5CB85C !important;
}

.chat-page .footer {
  display: none;
}

.chat-search .input-group .form-control {
  margin: 0;
  padding: 0 0 0 36px;
  height: 46px;
}
.chat-search .input-group .input-group-prepend {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #424848;
  pointer-events: none;
  z-index: 4;
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
}

.chat-cont-left .chat-scroll {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0;
}
.chat-cont-left .chat-scroll .media {
  border-bottom: 1px solid #898989;
  margin: 0;
  padding: 10px;
  transition: all 0.2s;
}
.chat-cont-left .chat-scroll .media.active {
  background-color: #C0C0C0;
}
.chat-cont-left .chat-scroll .media:hover {
  background-color: #C0C0C0;
}
.chat-cont-left .chat-scroll .media .media-img-wrap {
  margin: 0 15px 0 0;
  position: relative;
}
.chat-cont-left .chat-scroll .media .media-img-wrap .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chat-cont-left .chat-scroll .media .media-body {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.chat-cont-left .chat-scroll .media .media-body .user-name {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #262A2A;
  font-size: 16px;
  font-weight: 700;
}
.chat-cont-left .chat-scroll .media .media-body .user-last-chat {
  color: #323737;
  font-size: 14px;
  line-height: 24px;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-left .chat-scroll .media .media-body .last-chat-time {
  color: #565E5E;
  font-size: 13px;
}
.chat-cont-left .chat-scroll .media .media-body div:last-child {
  text-align: right;
}

.chat-cont-right {
  transition: all 0.4s;
}
.chat-cont-right .chat-scroll {
  max-height: calc(100vh - 293px);
  overflow-y: auto;
}
.chat-cont-right .msg_head .back-user-list {
  display: none;
  margin: 0 0 0 -10px;
  padding: 0 10px;
}
.chat-cont-right .img_cont {
  position: relative;
  height: 45px;
  width: 45px;
}
.chat-cont-right .img_cont .user_img {
  height: 45px;
  min-width: 45px;
  width: 45px;
  border: 1.5px solid #e85b28;
}
.chat-cont-right .user_info {
  margin: 0 auto 0 15px;
  padding: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-right ul.list-unstyled {
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent {
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.sent .avatar {
  order: 3;
  height: 30px;
  width: 30px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin: 0 20px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box {
  margin: 0;
  padding: 0 0 0 50px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box + .msg-box {
  margin: 5px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box p {
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child::before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #e3e3e3;
  border-top: 6px solid #e3e3e3;
  border-right: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 0;
  right: -12px;
  left: auto;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #e3e3e3;
  display: inline-block;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child > div {
  border-radius: 10px 0 10px 10px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.4s;
  color: #FFF;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin: 5px 0 0;
  padding: 0;
  flex-wrap: wrap;
  clear: both;
  flex-direction: row-reverse;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li {
  margin: 0;
  padding: 0 0 0 16px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li:not(:last-child)::after {
  position: absolute;
  top: 50%;
  right: auto;
  left: 8px;
  transform: translate(-50%, -50%);
  background: #e85b28;
  content: "";
  height: 4px;
  width: 4px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info a {
  color: #323737;
}
.chat-cont-right ul.list-unstyled .media.received {
  position: relative;
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.received .media-body {
  position: relative;
  margin: 0 0 0 20px;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body::before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #e85b28;
  border-top: 6px solid #e85b28;
  border-left: 6px solid transparent;
  content: "";
  height: 0;
  position: absolute;
  top: 0px;
  right: auto;
  left: -6px;
  width: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #e85b28;
  display: table;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div p {
  color: #FFF;
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box {
  display: block;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box + .msg-box {
  margin-top: 5px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
  margin: 5px 0 0;
  padding: 0;
  clear: both;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info .chat-time {
  color: rgba(255, 255, 255, 0.8);
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transition: all 0.4s;
  opacity: 0;
  color: #FFF;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .chat-date {
  font-size: 14px;
  margin: 1.875rem 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: capitalize;
}
.chat-cont-right ul.list-unstyled .chat-date:before {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin-right: 28px;
  position: absolute;
  top: 50%;
  right: 50%;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .chat-date:after {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin: 0 0 0 28px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
}

.card-footer {
  background-color: #FFF;
  border-top: 1px solid #898989;
  margin: 0;
  padding: 1rem 1.5rem;
}
.card-footer .type_msg {
  background-color: rgba(0, 0, 0, 0.1) !important;
  border: 0 !important;
  overflow-y: auto;
}

@media (max-width: 992px) {
  .chat-window.chat-slide .chat-cont-right {
    right: 0;
    opacity: 1;
    visibility: visible;
  }
  .chat-cont-right {
    position: absolute;
    right: -100px;
    opacity: 0;
    visibility: hidden;
    z-index: 99;
  }
  .chat-cont-right .msg_head .back-user-list {
    display: flex;
    align-items: center;
  }
}
.page-header .breadcrumb {
  margin-bottom: 0;
}
.page-header h3 {
  font-weight: 700;
  color: #262A2A;
  font-size: 18px;
}
@media (max-width: 991.98px) {
  .page-header h3 {
    font-size: 14px;
  }
}
.page-header h4 {
  font-weight: 700;
  color: #262A2A;
  font-size: 18px;
  margin-bottom: 5px;
}
@media (max-width: 991.98px) {
  .page-header h4 {
    font-size: 18px;
  }
}
.page-header h6 {
  font-size: 14px;
  color: #424848;
  font-weight: 400;
}
@media (max-width: 991.98px) {
  .page-header h6 {
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  .page-header h6 {
    font-size: 12px;
    margin-bottom: 20px;
  }
}
.page-header .btn-filter {
  background: #e85b28;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
}
.page-header .btn-filter:hover {
  background: linear-gradient(46.62deg, #e85b28 0%, #676DFF 93.64%);
}
.page-header .page-btn {
  margin-left: 10px;
}
@media (max-width: 575.98px) {
  .page-header .page-btn {
    margin-left: 0;
    margin-top: 20px;
  }
}
.page-header .btn-added {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #e85b28;
  padding: 8px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  height: 40px;
  border-radius: 5px;
}
.page-header .btn-added:active {
  color: #FFF;
}
.page-header .btn-added img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added {
    padding: 10px 10px;
  }
}
.page-header .btn-added:hover {
  background: #262A2A;
}
.page-header .btn-added .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.downloader {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #262A2A;
  padding: 9px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
  margin: 0 15px 0 15px;
}
.page-header .btn-added.downloader img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.downloader {
    padding: 10px 10px;
  }
}
.page-header .btn-added.downloader:hover {
  background: #e85b28;
}
.page-header .btn-added.downloader .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.printer {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FC0027;
  padding: 9px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.page-header .btn-added.printer img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.printer {
    padding: 10px 10px;
  }
}
.page-header .btn-added.printer:hover {
  background: #262A2A;
}
.page-header .btn-added.printer .me-2 {
  width: 16px;
  height: 16px;
}
@media (max-width: 767.98px) {
  .page-header .add-item {
    display: block !important;
  }
  .page-header .add-item .page-btn {
    margin-left: 0;
  }
}
@media (max-width: 575.98px) {
  .page-header .add-item .page-btn {
    margin-left: 0;
    margin-bottom: 24px;
  }
}
.page-header .add-item .page-title.modal-datail {
  line-height: 2;
}
.page-header .add-item.d-flex {
  margin-right: auto;
}
.page-header .add-item.payslip-list {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}

.page-wrapper.details-blk {
  padding: 0;
  margin: 0;
}

.history-modal-profile .content {
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile {
  background: #F9F9FC;
  border-radius: 8px;
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a {
  background: #e85b28;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF !important;
}
.history-modal-profile .right-sidebar-profile .avatar {
  margin-bottom: 24px;
  width: 150px;
  height: 150px;
}
.history-modal-profile .right-sidebar-profile .avatar img {
  border-radius: 8px;
}

.msg-typing {
  width: auto;
  height: 24px;
  padding-top: 8px;
}
.msg-typing span {
  height: 8px;
  width: 8px;
  float: left;
  background-color: #FFF;
  display: block;
  opacity: 0.4;
  margin: 0 1px;
  border-radius: 50%;
}
.msg-typing span:nth-of-type(1) {
  animation: 1s blink infinite 0.33333s;
}
.msg-typing span:nth-of-type(2) {
  animation: 1s blink infinite 0.66666s;
}
.msg-typing span :nth-of-type(3) {
  animation: 1s blink infinite 0.99999s;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}
.phone-call-icon svg {
  width: 18px;
}
.phone-call-icon .income-success {
  color: #5CB85C;
}
.phone-call-icon .income-success-missed {
  color: #FC0027;
}

.history-modal-profile .content {
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile {
  background: #F9F9FC;
  border-radius: 8px;
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a {
  background: #e85b28;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  color: #FFF !important;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF !important;
}
.history-modal-profile .right-sidebar-profile .avatar {
  margin-bottom: 24px;
  width: 150px;
  height: 150px;
}
.history-modal-profile .right-sidebar-profile .avatar img {
  border-radius: 8px;
}

.modal-profile-detail .modal-userlist li {
  font-size: 14px;
  color: #000;
  margin-bottom: 10px;
}
.modal-profile-detail .modal-userlist li span {
  display: block;
  color: #6F6F6F;
}
.modal-profile-detail .modal-userlist li:last-child {
  margin-bottom: 0;
}

@media (max-width: 991.98px) {
  .chat_sidebar.hide-left-sidebar {
    display: none !important;
  }
}

@media (max-width: 991.98px) {
  .left-sidebar.hide-left-sidebar {
    margin-left: -991px;
  }
}

.img-cropper .dropup .dropdown-toggle::after {
  content: "";
  display: none;
}

.dropdown-auto {
  overflow: auto;
}

.dropdown-divider {
  margin: 0;
}

.dropdown .dropdown-toggle:after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}
.dropdown .dropdown-toggle.btn-primary {
  color: #FFF;
}
.dropdown .dropdown-menu {
  font-family: "Noto Sans", sans-serif;
}

.dropdown > a {
  color: #262A2A;
  border: 1px solid #E8E8E8;
  padding: 9px 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.dropdown-menu {
  border-color: #E8E8E8;
  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);
  font-size: 0.875rem;
  color: #6F6F6F;
  background-color: #FFF;
  padding: 0;
  z-index: 10;
}

.dropdown-divider {
  border-color: #E8E8E8;
}

.dropdown-item-text {
  color: #6F6F6F;
}

.dropdown-header {
  color: #6F6F6F;
}

.dropdown-item {
  color: #6F6F6F;
  white-space: inherit;
  padding: 0.5rem 0.9375rem;
  font-size: 0.8125rem;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6F6F6F;
  opacity: 0.5;
}
.dropdown-item:not(.active):hover, .dropdown-item:not(.active):focus, .dropdown-item:not(.active):active {
  color: #e85b28;
  background-color: rgba(232, 91, 40, 0.05);
}
.dropdown-item.active {
  background-color: #e85b28 !important;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f077";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f053";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.btn.dropdown-toggle-split {
  opacity: 0.85;
}

.dropdown-menu-dark {
  background-color: #171724;
  border-color: rgba(255, 255, 255, 0.1);
}
.dropdown-menu-dark li a {
  color: #FFF;
}

.btn-list a.dropdown-item {
  margin-block-end: 0;
}
.btn-list .btn-soft-success:hover {
  transform: translateY(0);
}
.btn-list .btn-soft-danger:hover {
  transform: translateY(0);
}
.dropdown-menu.dropdown-menu-primary {
  background-color: #e85b28;
}
.dropdown-menu.dropdown-menu-primary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-primary .dropdown-item:hover, .dropdown-menu.dropdown-menu-primary .dropdown-item:focus, .dropdown-menu.dropdown-menu-primary .dropdown-item:active, .dropdown-menu.dropdown-menu-primary .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-secondary {
  background-color: #FFA201;
}
.dropdown-menu.dropdown-menu-secondary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-secondary .dropdown-item:hover, .dropdown-menu.dropdown-menu-secondary .dropdown-item:focus, .dropdown-menu.dropdown-menu-secondary .dropdown-item:active, .dropdown-menu.dropdown-menu-secondary .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-warning {
  background-color: #FDA700;
}
.dropdown-menu.dropdown-menu-warning li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-warning .dropdown-item:hover, .dropdown-menu.dropdown-menu-warning .dropdown-item:focus, .dropdown-menu.dropdown-menu-warning .dropdown-item:active, .dropdown-menu.dropdown-menu-warning .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-info {
  background-color: #1ECBE2;
}
.dropdown-menu.dropdown-menu-info li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-info .dropdown-item:hover, .dropdown-menu.dropdown-menu-info .dropdown-item:focus, .dropdown-menu.dropdown-menu-info .dropdown-item:active, .dropdown-menu.dropdown-menu-info .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-success {
  background-color: #5CB85C;
}
.dropdown-menu.dropdown-menu-success li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-success .dropdown-item:hover, .dropdown-menu.dropdown-menu-success .dropdown-item:focus, .dropdown-menu.dropdown-menu-success .dropdown-item:active, .dropdown-menu.dropdown-menu-success .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-danger {
  background-color: #FC0027;
}
.dropdown-menu.dropdown-menu-danger li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-danger .dropdown-item:hover, .dropdown-menu.dropdown-menu-danger .dropdown-item:focus, .dropdown-menu.dropdown-menu-danger .dropdown-item:active, .dropdown-menu.dropdown-menu-danger .dropdown-item.active {
  color: #FFF;
}

.dropdown-menu.dropmenu-item-primary .dropdown-item:hover, .dropdown-menu.dropmenu-item-primary .dropdown-item:focus, .dropdown-menu.dropmenu-item-primary .dropdown-item:active, .dropdown-menu.dropmenu-item-primary .dropdown-item.active {
  background-color: rgba(232, 91, 40, 0.1) !important;
  color: #e85b28;
}
.dropdown-menu.dropmenu-item-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-item-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-item-secondary .dropdown-item:active, .dropdown-menu.dropmenu-item-secondary .dropdown-item.active {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201;
}
.dropdown-menu.dropmenu-item-warning .dropdown-item:hover, .dropdown-menu.dropmenu-item-warning .dropdown-item:focus, .dropdown-menu.dropmenu-item-warning .dropdown-item:active, .dropdown-menu.dropmenu-item-warning .dropdown-item.active {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700;
}
.dropdown-menu.dropmenu-item-info .dropdown-item:hover, .dropdown-menu.dropmenu-item-info .dropdown-item:focus, .dropdown-menu.dropmenu-item-info .dropdown-item:active, .dropdown-menu.dropmenu-item-info .dropdown-item.active {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2;
}
.dropdown-menu.dropmenu-item-success .dropdown-item:hover, .dropdown-menu.dropmenu-item-success .dropdown-item:focus, .dropdown-menu.dropmenu-item-success .dropdown-item:active, .dropdown-menu.dropmenu-item-success .dropdown-item.active {
  background-color: rgba(var(--success-rgb), 0.1) !important;
  color: #5CB85C;
}
.dropdown-menu.dropmenu-item-danger .dropdown-item:hover, .dropdown-menu.dropmenu-item-danger .dropdown-item:focus, .dropdown-menu.dropmenu-item-danger .dropdown-item:active, .dropdown-menu.dropmenu-item-danger .dropdown-item.active {
  background-color: rgba(var(--danger-rgb), 0.1) !important;
  color: #FC0027;
}

.dropdown-menu.dropmenu-light-primary {
  background-color: rgba(var(#FFA201), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-primary .dropdown-item:hover, .dropdown-menu.dropmenu-light-primary .dropdown-item:focus, .dropdown-menu.dropmenu-light-primary .dropdown-item:active, .dropdown-menu.dropmenu-light-primary .dropdown-item.active {
  color: #FFF;
  background-color: #e85b28 !important;
}
.dropdown-menu.dropmenu-light-secondary {
  background-color: rgba(var(#FFA201), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-light-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-light-secondary .dropdown-item:active, .dropdown-menu.dropmenu-light-secondary .dropdown-item.active {
  color: #FFF;
  background-color: #FFA201 !important;
}
.dropdown-menu.dropmenu-light-info {
  background-color: rgba(30, 203, 226, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-info .dropdown-item:hover, .dropdown-menu.dropmenu-light-info .dropdown-item:focus, .dropdown-menu.dropmenu-light-info .dropdown-item:active, .dropdown-menu.dropmenu-light-info .dropdown-item.active {
  color: #FFF;
  background-color: #1ECBE2 !important;
}
.dropdown-menu.dropmenu-light-warning {
  background-color: rgba(253, 167, 0, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-warning .dropdown-item:hover, .dropdown-menu.dropmenu-light-warning .dropdown-item:focus, .dropdown-menu.dropmenu-light-warning .dropdown-item:active, .dropdown-menu.dropmenu-light-warning .dropdown-item.active {
  color: #FFF;
  background-color: #FDA700 !important;
}
.dropdown-menu.dropmenu-light-success {
  background-color: rgba(92, 184, 92, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-success .dropdown-item:hover, .dropdown-menu.dropmenu-light-success .dropdown-item:focus, .dropdown-menu.dropmenu-light-success .dropdown-item:active, .dropdown-menu.dropmenu-light-success .dropdown-item.active {
  color: #FFF;
  background-color: #5CB85C !important;
}
.dropdown-menu.dropmenu-light-danger {
  background-color: rgba(var(--danger-rgb), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-danger .dropdown-item:hover, .dropdown-menu.dropmenu-light-danger .dropdown-item:focus, .dropdown-menu.dropmenu-light-danger .dropdown-item:active, .dropdown-menu.dropmenu-light-danger .dropdown-item.active {
  color: #FFF;
  background-color: #FC0027 !important;
}

.dropdown-divider {
  margin: 0;
}

.bd-example > .dropdown-menu {
  position: static;
  display: block;
}

.dropdown-md {
  min-width: 315px;
}

.table-action .action-icon {
  width: 33px;
  height: 33px;
  background: #F6F6F6;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #262A2A;
}
.table-action .action-icon:hover {
  color: #262A2A;
}
.table-action .action-icon:hover i {
  color: #262A2A;
}
.table-action .dropdown-toggle::after {
  display: none;
}
.table-action .dropdown-menu a {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  color: #262A2A;
  white-space: nowrap;
}
.table-action .dropdown-menu a i {
  margin-right: 8px;
}
.table-action .dropdown-menu a:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.daterangepicker {
  font-family: "Noto Sans", sans-serif;
}
.daterangepicker .calendar-table th {
  color: #262A2A;
}
.daterangepicker .calendar-table td {
  color: #262A2A;
}

.daterangepicker td.active, .daterangepicker td.active:hover {
  background-color: #e85b28;
  color: #fff;
}

.daterangepicker .ranges li.active {
  background-color: #00918E;
}

.sort-dropdown.drop-down .dropdown-menu li a {
  white-space: nowrap;
}

.drop-down {
  position: relative;
}
.drop-down > a {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  background: #FFF;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 9px 15px;
}
.drop-down > a i {
  margin-right: 8px;
}
.drop-down > a:hover {
  color: #262A2A;
}
.drop-down > a.show {
  border: 1px solid #e85b28;
}
.drop-down > a::after {
  font-size: 14px;
  margin-left: 8px;
}
.drop-down > a[aria-expanded=true]::after {
  transition: all 0.2s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.drop-down .dropdown-menu li a {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
}
.drop-down .dropdown-menu li a i {
  margin-right: 8px;
}
.drop-down .dropdown-menu li a:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.dropdown-menu {
  border: 1px solid #E8E8E8;
  padding: 15px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}

/* ------------------------------------------------------------
   Unified dropdown item styling (website-wide)
   ------------------------------------------------------------ */
.dropdown-menu,
.dropdown-menu.show {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
}

.dropdown-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown-menu .dropdown-item,
.dropdown-menu a.dropdown-item,
.dropdown-menu button.dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 8px;
  padding: 9px 10px;
  color: #334155;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.dropdown-menu .dropdown-item i,
.dropdown-menu a.dropdown-item i,
.dropdown-menu button.dropdown-item i {
  font-size: 15px;
}

.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus,
.dropdown-menu .dropdown-item:active,
.dropdown-menu a.dropdown-item:hover,
.dropdown-menu a.dropdown-item:focus,
.dropdown-menu a.dropdown-item:active,
.dropdown-menu button.dropdown-item:hover,
.dropdown-menu button.dropdown-item:focus,
.dropdown-menu button.dropdown-item:active {
  background: #fff7ed;
  color: #e85b28;
  transform: translateX(1px);
}

.dropdown-menu .dropdown-item:focus-visible,
.dropdown-menu a.dropdown-item:focus-visible,
.dropdown-menu button.dropdown-item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);
}

.dropdown-menu .dropdown-item.active,
.dropdown-menu a.dropdown-item.active,
.dropdown-menu button.dropdown-item.active {
  background: #e85b28;
  color: #fff;
}

.dropdown-menu .dropdown-item.text-danger:hover,
.dropdown-menu a.dropdown-item.text-danger:hover,
.dropdown-menu button.dropdown-item.text-danger:hover {
  background: rgba(239, 68, 68, 0.08);
  color: #dc2626;
}

.dropdown-menu .dropdown-item.disabled,
.dropdown-menu .dropdown-item:disabled,
.dropdown-menu a.dropdown-item.disabled,
.dropdown-menu button.dropdown-item:disabled {
  opacity: 0.48;
  pointer-events: none;
}

.table-action .action-icon {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  color: #64748b;
  transition: all 0.2s ease;
}

.table-action .action-icon:hover,
.table-action .action-icon:focus {
  border-color: #e85b28;
  color: #e85b28;
  box-shadow: 0 6px 16px rgba(232, 91, 40, 0.14);
}

.inbox-menu {
  display: inline-block;
  width: 100%;
  margin: 0 0 20px;
  padding: 0;
}
.inbox-menu li {
  display: inline-block;
  width: 100%;
}
.inbox-menu li a {
  color: #333;
  display: inline-block;
  padding: 10px 15px;
  width: 100%;
  font-weight: 600;
  text-transform: capitalize;
  transition: 0.3s ease;
}
.inbox-menu li a:hover {
  background: rgba(33, 33, 33, 0.05);
}
.inbox-menu li a i {
  font-size: 16px;
  padding-right: 10px;
  color: #878787;
}

.compose-btn {
  margin-bottom: 25px;
}

.top-action-left .btn-group {
  margin-bottom: 5px;
}
.top-action-left .dropdown-toggle {
  height: 40px;
}
.top-action-left .dropdown-toggle::after {
  display: none;
}

.table-inbox .starred.fas.fa-star {
  color: #FDA700;
}
.table-inbox .checked {
  background-color: #898989;
}
.table-inbox th {
  border-color: #F2ECFF;
}
.table-inbox tbody tr td {
  font-size: 14px;
  color: #FFA201;
  border-color: #E8E8E8;
}

.unread .name,
.unread .subject,
.unread .mail-date {
  color: #000;
  font-weight: 700;
}

.email-header .btn-white {
  min-width: auto;
  height: 38px;
  border: 1px solid #E8E8E8;
}
.email-header .btn-white i {
  margin-left: 5px;
}

.file-manager {
  color: #6F6F6F;
}
.file-manager .search-dropdown {
  height: auto;
}
.file-manager .form-sort {
  width: auto;
}
.file-manager .form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-right: 27px;
}
.file-manager .form-sort.owned-by {
  margin-right: 10px;
}
.file-manager.notes-page-wrapper .content .page-add-notes {
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap {
  margin-top: 0;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .form-sort svg.fa-filter {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 15px;
}
.file-manager .page-header .btn-added {
  margin-left: 10px;
}
@media (max-width: 575.98px) {
  .file-manager .page-header .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
  }
}
@media (max-width: 575.98px) {
  .file-manager .page-header .table-top-head {
    margin-bottom: 15px;
  }
}
@media (max-width: 991.98px) {
  .file-manager .page-header .table-top-head li:last-child {
    margin-right: 0;
  }
}
@media (max-width: 767.98px) {
  .file-manager .bulk-action-type {
    align-items: start !important;
  }
}
@media (max-width: 575.98px) {
  .file-manager .bulk-action-type {
    display: block !important;
  }
}
@media (max-width: 767.98px) {
  .file-manager .bulk-action-type .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
    width: 100%;
  }
}
.file-manager aside {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
}
.file-manager aside h5 {
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #C0C0C0;
  margin: 0 0 15px 0;
  padding: 0 0 15px 0;
}
.file-manager aside .btn {
  font-weight: 700;
}
.file-manager aside .dropdown > a {
  width: auto;
  height: 40px;
  color: #FFF;
  border-radius: 5px;
}
.file-manager aside .dropdown > a:hover, .file-manager aside .dropdown > a:focus {
  border-color: #6F6F6F;
  background: #6F6F6F;
}
.file-manager aside .dropdown ul {
  width: 100%;
}
.file-manager aside .dropdown ul li a {
  font-size: 15px;
}
.file-manager aside ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 5px 0;
  padding: 7px 10px;
  border-radius: 5px;
  height: 40px;
}
.file-manager aside ul li a span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  width: auto;
}
.file-manager aside ul li a:hover, .file-manager aside ul li a.active {
  background: #6F6F6F;
  color: #FFF;
}
.file-manager aside span {
  font-size: 13px;
  font-weight: 500;
  width: auto;
  height: auto;
}
.file-manager aside h6 {
  font-size: 16px;
  font-weight: 600;
  position: relative;
  z-index: 2;
}
.file-manager aside .space-manager {
  color: #FFF;
  background: #6F6F6F;
  border-radius: 8px;
  position: relative;
}
.file-manager aside .space-manager img {
  position: absolute;
  top: 0;
  right: 0;
}
.file-manager aside .space-manager h6 a {
  color: #FFF;
}
.file-manager aside .space-manager p {
  color: #B8BCC9;
}
.file-manager .progress {
  height: 6px;
  border-radius: 5px;
}
.file-manager .search-set .search-input input[type=search] {
  width: 170px;
  height: 40px;
}
.file-manager .budgeted-role-notes .search-set .search-input input[type=search] {
  width: 298px;
}
.file-manager h4 {
  font-size: 18px;
  font-weight: 600;
}
.file-manager h6 {
  font-size: 16px;
  font-weight: 600;
}
.file-manager h6 a {
  color: #6F6F6F;
}
.file-manager h6 a:hover {
  color: #e85b28;
}
.file-manager .overview .detail a.bg {
  border-radius: 8px 8px 0 0;
}
.file-manager .overview .detail a.bg span {
  width: 66px;
  height: 66px;
  border-radius: 100%;
}
.file-manager .overview .detail a.bg span img {
  transition: all 0.5s ease;
}
.file-manager .overview .detail a:hover img {
  transform: scale(1.2);
}
.file-manager .info {
  border-radius: 0 0 8px 8px;
  padding: 15px;
  background: #FFF;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
}
.file-manager .info span {
  color: #6F6F6F;
  font-size: 13px;
}
.file-manager .folders {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
  background: #FFF;
}
.file-manager .folders h6 {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 8px;
}
.file-manager .dropdown > a {
  color: #6F6F6F;
  width: 25px;
  height: 25px;
  transition: all 0.5s ease;
  border-radius: 100%;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.file-manager .dropdown > a:hover {
  background: #e85b28;
}
.file-manager .dropdown > a:hover i {
  color: #FFF;
}
.file-manager .project-plan {
  font-size: 13px;
  font-weight: 600;
  margin-top: 10px;
}
.file-manager .project-plan label {
  color: #6F6F6F;
  margin-right: 9px;
  font-size: 13px;
}
.file-manager .project-plan ul li {
  font-size: 13px;
  position: relative;
  padding: 0 9px 0 14px;
  color: #6F6F6F;
}
.file-manager .project-plan ul li:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  width: 5px;
  height: 5px;
  background: #6F6F6F;
  border-radius: 5px;
}
.file-manager .avatar-wrap a svg {
  color: #6F6F6F;
  width: 18px;
}
.file-manager .avatar-wrap a:hover svg {
  color: #e85b28;
}
.file-manager .accordion {
  border: none;
  --bs-accordion-border-width: none;
}
.file-manager .accordion .accordion-item {
  border: none;
  border-bottom: 1px solid #E8E8E8;
  background: none;
}
.file-manager .accordion .accordion-item:last-of-type {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: none;
}
.file-manager .accordion .accordion-item .accordion-button {
  background: none;
  border: none;
  font-size: 18px;
  font-weight: 600;
  color: #6F6F6F;
  padding: 0;
  display: inline-block;
  width: auto;
}
.file-manager .accordion .accordion-item .accordion-button:after {
  transition: all 0.8s ease;
  background-image: none;
  content: "View All";
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #6F6F6F;
  transform: none;
  width: 60px;
  text-align: right;
}
.file-manager .accordion .accordion-item .accordion-button:not(.collapsed)::after {
  content: "Hide";
}
.file-manager .accordion .accordion-item .accordion-button.collapsed {
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-button:hover:after {
  color: #e85b28;
}
.file-manager .accordion .accordion-item .accordion-body {
  border: none;
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-body .head img {
  min-width: 32px;
  width: 32px;
  height: 32px;
}
.file-manager .accordion .accordion-item .accordion-body .owl-carousel {
  padding-top: 15px;
}
.file-manager .owl-carousel .owl-item {
  margin-left: -0.1px !important;
}
.file-manager .owl-carousel .dropdown-menu {
  left: auto !important;
  right: 0 !important;
  top: 27px !important;
  transform: none !important;
  background: #FFF !important;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  z-index: 99999 !important;
}
.file-manager .owl-carousel .owl-nav {
  top: -20px;
  left: 43px;
  display: inline-table;
}
.file-manager .owl-carousel .owl-nav button {
  margin-top: 0;
  margin-bottom: 0;
  background: none;
  cursor: pointer;
}
.file-manager .owl-carousel .owl-nav button.owl-next, .file-manager .owl-carousel .owl-nav button.owl-prev {
  position: relative;
  width: 15px;
}
.file-manager .owl-carousel .owl-nav button.owl-next i, .file-manager .owl-carousel .owl-nav button.owl-prev i {
  color: #6F6F6F;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover, .file-manager .owl-carousel .owl-nav button.owl-prev:hover {
  background: none;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover i, .file-manager .owl-carousel .owl-nav button.owl-prev:hover i {
  color: #e85b28;
}
.file-manager .owl-carousel.folders-carousel .owl-nav {
  left: 75px;
}
.file-manager .owl-carousel.video-section .owl-nav {
  left: 60px;
}
.file-manager .owl-carousel.video-section .info a svg {
  color: #6F6F6F;
  width: 18px;
}
.file-manager .all-files {
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border: none;
}
.file-manager .all-files .btn-grp a {
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575.98px) {
  .file-manager .all-files .btn-grp a {
    margin-bottom: 15px;
    display: inline-block;
  }
}
.file-manager .all-files .btn-grp a.btn-outline-secondary {
  color: #6F6F6F;
  background: #F9F9FC;
  border-color: #F9F9FC;
}
.file-manager .all-files .btn-grp a:hover {
  background: #6F6F6F;
  border-color: #6F6F6F;
  color: #FFF;
}
.file-manager .all-files .table thead tr th {
  border-color: #E8E8E8;
}
.file-manager .all-files .table tbody tr td {
  display: table-cell;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  border-color: #E8E8E8;
}
.file-manager .all-files .table tbody tr td a {
  font-size: 14px;
  font-weight: 500;
}
.file-manager .all-files .table tbody tr td a.product-img img {
  width: 32px;
  height: 32px;
  border: 0;
}
.file-manager #file-delete {
  font-size: 14px;
}

aside {
  padding: 24px;
}

.color-primary {
  color: #6F6F6F;
}

.icon-select {
  position: relative;
  width: 149px;
  height: 38px;
}
.icon-select .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 100;
}
.icon-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
}

.bg-light-orange {
  background: #FAD2CD;
}
.bg-light-orange span {
  background: #FAD2CD;
}

.bg-light-red {
  background: #FECCD4;
}
.bg-light-red span {
  background: #FECCD4;
}

.bg-light-green {
  background: #CEEACE;
}
.bg-light-green span {
  background: #CEEACE;
}

.seprator-sm {
  margin: 0 0 24px 0;
  padding: 0 0 9px 0;
  border-bottom: 1px solid #C0C0C0;
}

.seprator-lg {
  margin: 0 0 24px 0;
  padding: 0 0 24px 0;
  border-bottom: 1px solid #E8E8E8;
}

.group-avatar .avatar {
  position: relative;
  width: 43px;
  height: 43px;
  line-height: 43px;
  margin: 0;
}
.group-avatar .avatar + .avatar {
  margin-left: -1.2rem;
}
.group-avatar .avatar:hover {
  z-index: 1;
}
.group-avatar .count a {
  color: #5CB85C;
  line-height: 27px;
  font-size: 13px;
  font-weight: 500;
}
.group-avatar .count a:hover {
  color: #e85b28;
}
.group-avatar .avatar img {
  display: block;
  border-radius: 100%;
  width: 100%;
  border: 2px solid #FFF;
}

.video-section .item {
  opacity: 0.4;
  transition: 0.4s ease all;
  transform: scale(0.8);
}

@media (max-width: 1000px) {
  .video-section .item {
    margin: 0;
    transform: scale(0.9);
  }
}
.video-section .active .item {
  opacity: 1;
  transform: scale(1);
}

.video-section .owl-item {
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0) scale(1, 1);
}

.video-section video {
  max-width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
}

.delete-alert {
  padding: 10px 20px;
  background: #FECCD4;
  border: none;
  border-radius: 8px;
}
.delete-alert p {
  font-size: 15px;
}
.delete-alert .btn {
  font-weight: 700;
}

.deleted-info {
  display: none;
}
.deleted-info .bin-bg {
  width: 184px;
  height: 184px;
  border-radius: 100%;
  background: #FDFDFE;
  margin: 0 auto;
}

.popup-toggle {
  cursor: pointer;
}

.toggle-sidebar {
  width: 456px;
  padding: 25px;
  position: fixed;
  right: -456px;
  top: 0;
  height: 100%;
  background: #FFF;
  z-index: 100001;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  overflow-y: auto;
  transition: all 0.5s ease;
}
@media (max-width: 575.98px) {
  .toggle-sidebar {
    width: 320px;
    right: -320px;
  }
}
.toggle-sidebar.open-sidebar {
  right: 0;
  transition: all 0.5s ease;
}
.toggle-sidebar .head .color-primary:hover {
  color: #FC0027;
}
.toggle-sidebar h4, .toggle-sidebar h5 {
  font-weight: 700;
}
.toggle-sidebar h4 {
  font-size: 20px;
}
.toggle-sidebar h5 {
  font-size: 18px;
}
.toggle-sidebar h6 {
  font-size: 15px;
  font-weight: 600;
}
.toggle-sidebar .nav-tabs {
  border-bottom: 1px solid #C0C0C0;
}
.toggle-sidebar .nav-tabs .nav-link {
  padding: 8px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  background: #F9F9FC;
  color: #6F6F6F;
}
.toggle-sidebar .nav-tabs .nav-link:hover, .toggle-sidebar .nav-tabs .nav-link.active {
  background: #e85b28;
  color: #FFF;
}
.toggle-sidebar .tab-content .tab-pane ul li h6 {
  margin-bottom: 5px;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location {
  background: #F9F9FC;
  border: 1px solid #C0C0C0;
  border-radius: 5px;
  padding: 5px;
  display: inline-block;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location img {
  width: 20px;
  height: 20px;
}
.toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-airframe .note-statusbar, .toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-frame .note-statusbar {
  border-top: none;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span a {
  display: inline-flex;
  margin-right: 3px;
  padding-right: 3px;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:first-child a {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid #C0C0C0;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:last-child a {
  margin-right: 0;
  padding-right: 0;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add {
  background: #e85b28;
  color: #FFF;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add:hover {
  background: #6F6F6F;
}
.toggle-sidebar p {
  color: #6F6F6F;
  font-size: 15px;
}
.toggle-sidebar .show-all {
  font-weight: 700;
}
.toggle-sidebar .show-all:hover {
  color: #6F6F6F;
}

.text-danger {
  color: #FC0027 !important;
}

.avatar-md {
  width: 45px;
  height: 45px;
  border-radius: 45px;
}

.text-secondary {
  color: #6F6F6F !important;
}

.text-primary {
  color: #e85b28 !important;
}

.text-default {
  color: #6F6F6F;
}

.btn-icon svg {
  width: 18px;
}

.file-manager-modal .modal-header h5 {
  font-size: 18px;
  font-weight: 700;
}
.file-manager-modal#hold-order h2 {
  font-size: 36px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 10px;
  background-color: #F9F9FC;
  border-radius: 10px;
}
.file-manager-modal#hold-order .input-block label {
  margin-bottom: 5px;
}
.file-manager-modal#hold-order p {
  margin-top: 20px;
}
.file-manager-modal#recents .table tbody tr td {
  padding: 10px 15px;
}
.file-manager-modal .badge {
  padding: 5px 10px;
  font-size: 15px;
  font-weight: normal;
}
.file-manager-modal#orders .modal-dialog {
  max-width: 575px;
}
.file-manager-modal#orders .order-body {
  height: 50vh;
  overflow: auto;
}
.file-manager-modal#orders .order-body .default-cover {
  border: 1px solid #C0C0C0;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
}
.file-manager-modal#orders .order-body .record {
  font-size: 15px;
}
.file-manager-modal#orders .order-body .record td {
  padding-bottom: 15px;
}
.file-manager-modal#orders .order-body .record tr:last-child td {
  padding-bottom: 0;
}
.file-manager-modal#orders .order-body .record .colon {
  padding: 0 10px;
  color: #FFA201;
}
.file-manager-modal#orders .order-body .record .text {
  color: #6F6F6F;
  white-space: nowrap;
}
.file-manager-modal#orders .order-body p {
  font-size: 15px;
  background-color: #F9F9FC;
  border-radius: 8px;
}
.file-manager-modal#orders .order-body .search-set .search-input {
  width: 100%;
}
.file-manager-modal#orders .order-body .search-set .search-input label {
  width: 100%;
}
.file-manager-modal#orders .order-body .search-set .search-input label input {
  width: 100%;
}
.file-manager-modal.upload-modal .modal-body .drag-drop {
  position: relative;
  padding: 20px;
  border: 1px dashed #B8BCC9;
}
.file-manager-modal.upload-modal .modal-body .drag-drop input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.file-manager-modal.upload-modal .modal-body span {
  font-size: 13px;
  font-weight: 500;
  color: #6F6F6F;
}
.file-manager-modal.upload-modal .modal-body p {
  font-size: 16px;
  font-weight: 600;
  color: #FFA201;
  margin-bottom: 0;
}
.file-manager-modal.upload-modal .modal-body .progress {
  height: 6px;
  border-radius: 5px;
}
.file-manager-modal.upload-modal .modal-body ul li {
  margin: 0 0 15px 0;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #C0C0C0;
}
.file-manager-modal.upload-modal .modal-body ul li svg {
  width: 18px;
}
.file-manager-modal.upload-modal .modal-body ul li h6 a {
  font-size: 16px;
  font-weight: 600;
  color: #FFA201;
}
.file-manager-modal.upload-modal .modal-body ul li h6 a svg {
  color: #5CB85C;
}
.file-manager-modal.upload-modal .modal-body ul li h6:hover a {
  color: #e85b28;
}
.file-manager-modal.upload-modal .modal-body ul li:last-child {
  margin-bottom: 0;
}
.file-manager-modal#upload-message .modal-dialog {
  position: fixed;
  bottom: 0px;
  right: 24px;
  margin: 0px;
  left: auto;
  top: calc(100% - 300px);
  width: 600px;
}
.file-manager-modal#upload-message .progress {
  height: 6px;
  border-radius: 5px;
}

.datanew tr td svg {
  width: 18px;
}

.icons-list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.icons-list li {
  display: block;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 18px;
  border-radius: 50px;
  border: 1px solid #e6ebf1;
  color: #e85b28;
  margin: 5px;
  box-shadow: 0 2px 3px rgb(215, 197, 255);
}

.ti-spin {
  animation: ti-spin 1s linear infinite;
}

@keyframes ti-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.progress {
  background-color: #E8E8E8;
  height: 0.75rem;
  border-radius: 0.25rem;
}

.progress-stacked {
  background-color: #E8E8E8;
}

.progress-bar {
  color: #FFF;
  background-color: #e85b28;
}

@keyframes progress-animate {
  0% {
    width: 0;
  }
}
.progress-animate {
  position: relative;
  border-radius: 0.625rem;
}
.progress-animate .progress-bar {
  position: relative;
  border-radius: 0.625rem;
  animation: 2s progress-animate;
}

.progress.progress-xs, .progress-stacked.progress-xs {
  height: 0.3125rem;
}
.progress.progress-sm, .progress-stacked.progress-sm {
  height: 0.5rem;
}
.progress.progress-lg, .progress-stacked.progress-lg {
  height: 1rem;
}
.progress.progress-xl, .progress-stacked.progress-xl {
  height: 1.25rem;
}

.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-sm {
  width: 8px;
}
.progress-vertical.progress-xs {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-sm {
  width: 8px;
}
.progress-vertical-bottom.progress-xs {
  width: 5px;
}

.progress-custom {
  overflow: visible;
  position: relative;
}
.progress-custom .progress-bar {
  position: relative;
  overflow: visible;
}
.progress-custom .progress-bar:after {
  content: "";
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 50%;
  box-shadow: 0 0.313rem 0.313rem rgba(232, 91, 40, 0.5);
  background: #FFF;
  position: absolute;
  inset-inline-end: -0.375rem;
  inset-block-start: -0.375rem;
  border: 0.25rem solid #e85b28;
}
.progress-custom .progress-bar.bg-secondary:after {
  border: 0.25rem solid #FFA201;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb), 0.2);
}
.progress-custom .progress-bar.bg-warning:after {
  border: 0.25rem solid #FDA700;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb), 0.2);
}
.progress-custom .progress-bar.bg-info:after {
  border: 0.25rem solid #1ECBE2;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb), 0.2);
}
.progress-custom .progress-bar.bg-success:after {
  border: 0.25rem solid #5CB85C;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb), 0.2);
}
.progress-custom .progress-bar.bg-danger:after {
  border: 0.25rem solid #FC0027;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb), 0.2);
}
.progress-custom .progress-bar-value {
  width: 1.875rem;
  height: 1.25rem;
  line-height: 1.25rem;
  border-radius: 0.188rem;
  background: #e85b28;
  box-shadow: 0 0.313rem 0.313rem rgba(0, 0, 0, 0.4);
  font-size: 0.625rem;
  font-weight: 600;
  color: #FFF;
  text-align: center;
  position: absolute;
  inset-block-end: 1.5rem;
  inset-inline-end: -0.688rem;
}
.progress-custom .progress-bar-value:after {
  content: "";
  border-block-start: 0.438rem solid #e85b28;
  border-inline-start: 0.438rem solid transparent;
  border-inline-end: 0.438rem solid transparent;
  position: absolute;
  inset-block-end: -0.375rem;
  inset-inline-start: 28%;
}
.progress-custom .progress-bar-value.bg-secondary {
  background-color: #FFA201;
}
.progress-custom .progress-bar-value.bg-secondary:after {
  border-block-start: 0.438rem solid #FFA201;
}
.progress-custom .progress-bar-value.bg-success {
  background-color: #5CB85C;
}
.progress-custom .progress-bar-value.bg-success:after {
  border-block-start: 0.438rem solid #5CB85C;
}
.progress-custom .progress-bar-value.bg-warning {
  background-color: #FDA700;
}
.progress-custom .progress-bar-value.bg-warning:after {
  border-block-start: 0.438rem solid #FDA700;
}
.progress-custom .progress-bar-value.bg-danger {
  background-color: #FC0027;
}
.progress-custom .progress-bar-value.bg-danger:after {
  border-block-start: 0.438rem solid #FC0027;
}
.progress-custom .progress-bar-value.bg-info {
  background-color: #1ECBE2;
}
.progress-custom .progress-bar-value.bg-info:after {
  border-block-start: 0.438rem solid #1ECBE2;
}

[dir=rtl] .progress-bar-title {
  border-radius: 0 0.313rem 0.313rem 0;
}

.progress-item-1, .progress-item-2, .progress-item-3 {
  position: absolute;
  margin-block-start: -0.25rem;
  z-index: 1;
  height: 0.938rem;
  width: 0.938rem;
  border-radius: 1.563rem;
  background-color: #FDFDFE;
}

.progress-item-1 {
  inset-inline-start: 25%;
}

.progress-item-2 {
  inset-inline-start: 50%;
}

.progress-item-3 {
  inset-inline-start: 75%;
}

.custom-progress-3 {
  overflow: visible;
  border-radius: 0.625rem;
}
.custom-progress-3 .progress-bar {
  position: relative;
  overflow: visible;
  margin: 0.313rem;
  border-radius: 0.25rem;
}
.custom-progress-3 .progress-bar:before {
  content: "";
  position: absolute;
  width: 0.25rem;
  height: 0.25rem;
  inset-inline-start: 0.125rem;
  background-color: #FFF;
  border-radius: 50%;
}
.custom-progress-3 .progress-bar .progress-bar-value {
  border: 0.125rem solid #e85b28;
  width: 2.5rem;
  height: 1.563rem;
  line-height: 1.313rem;
  border-radius: 3.125rem;
  background: #FFF;
  font-size: 0.625rem;
  font-weight: 600;
  color: #e85b28;
  text-align: center;
  position: absolute;
  inset-inline-end: -0.625rem;
}
.custom-progress-3 .progress-bar .progress-bar-value.secondary {
  border: 0.125rem solid #FFA201;
  color: #FFA201;
}
.custom-progress-3 .progress-bar .progress-bar-value.warning {
  border: 0.125rem solid #FDA700;
  color: #FDA700;
}
.custom-progress-3 .progress-bar .progress-bar-value.info {
  border: 0.125rem solid #1ECBE2;
  color: #1ECBE2;
}
.custom-progress-3 .progress-bar .progress-bar-value.success {
  border: 0.125rem solid #5CB85C;
  color: #5CB85C;
}
.custom-progress-3 .progress-bar .progress-bar-value.danger {
  border: 0.125rem solid #FC0027;
  color: #FC0027;
}

.custom-progress-4.progress {
  background-color: rgba(232, 91, 40, 0.1);
  border-radius: 0.25rem;
}
.custom-progress-4.progress.secondary {
  background-color: rgba(255, 162, 1, 0.1);
}
.custom-progress-4.progress.secondary .progress-bar-label {
  color: #FFA201;
}
.custom-progress-4.progress.warning {
  background-color: rgba(253, 167, 0, 0.1);
}
.custom-progress-4.progress.warning .progress-bar-label {
  color: #FDA700;
}
.custom-progress-4.progress.info {
  background-color: rgba(30, 203, 226, 0.1);
}
.custom-progress-4.progress.info .progress-bar-label {
  color: #1ECBE2;
}
.custom-progress-4.progress.success {
  background-color: rgba(92, 184, 92, 0.1);
}
.custom-progress-4.progress.success .progress-bar-label {
  color: #5CB85C;
}
.custom-progress-4.progress.danger {
  background-color: rgba(252, 0, 39, 0.1);
}
.custom-progress-4.progress.danger .progress-bar-label {
  color: #FC0027;
}
.custom-progress-4.progress .progress-bar {
  border-radius: 0.25rem;
}
.custom-progress-4.progress .progress-bar-label {
  position: absolute;
  inset-inline-end: 0.313rem;
  font-weight: 600;
  font-size: 0.813rem;
  color: #e85b28;
}

.page-link {
  color: #6F6F6F;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}
.page-link:focus {
  box-shadow: none;
  background-color: #FDFDFE;
}
.page-link:hover {
  color: #e85b28;
  background-color: #FDFDFE;
  border-color: #E8E8E8;
}

.page-item.active .page-link {
  color: #FFF;
  background-color: #e85b28;
  border-color: #e85b28;
}

.disabled > .page-link, .page-link.disabled {
  color: #6F6F6F;
  background-color: #FFF;
  border-color: #E8E8E8;
  opacity: 0.7;
}

[dir=rtl] .pagination .page-link .bx-chevron-left::before {
  content: "\\ea50";
}
[dir=rtl] .pagination .page-link .bx-chevron-right::before {
  content: "\\ea4d";
}
[dir=rtl] .pagination .page-link .ri-arrow-right-s-line:before {
  content: "\\ea64";
}
[dir=rtl] .pagination .page-link .ri-arrow-left-s-line:before {
  content: "\\ea6e";
}

.pagination-style-1 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-1 .pagination .page-item .page-link {
  border: 0;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.pagination-style-1 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-1 .pagination .page-item.active .page-link {
  border-radius: 4px;
  background-color: #e85b28;
  color: #FFF;
}
.pagination-style-1 .pagination .page-item.active:hover .page-link {
  border-radius: 4px;
  background-color: #e85b28;
  color: #FFF;
}
.pagination-style-1 .pagination .page-item:hover .page-link {
  background-color: #FDFDFE;
  color: #e85b28;
}

.pagination-style-2 .pagination {
  border-radius: 4px;
}
.pagination-style-2 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-2 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
}
.pagination-style-2 .pagination .page-item.active .page-link {
  background-color: #FFF;
  color: #e85b28;
  position: relative;
  font-weight: bold;
}
.pagination-style-2 .pagination .page-item.active .page-link:before {
  position: absolute;
  content: "";
  inset-block-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #e85b28;
}
.pagination-style-2 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

.pagination-style-3 .pagination {
  border-radius: 50px;
  padding: 0.25rem;
  align-items: center;
}
.pagination-style-3 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-3 .pagination .page-item .page-link {
  border: 0;
  border-radius: 50px;
  font-size: 0.8125rem;
}
.pagination-style-3 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-3 .pagination .page-item.active .page-link {
  background-color: #e85b28;
  color: #FFF;
}
.pagination-style-3 .pagination .page-item.active:hover .page-link {
  background-color: #e85b28;
}
.pagination-style-3 .pagination .page-item:hover .page-link {
  background-color: #FDFDFE;
}

.pagination-style-4 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
  border-radius: 4px;
}
.pagination-style-4 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-4 .pagination .page-item.active .page-link {
  border: 0;
  border-radius: 4px;
  background-color: #e85b28;
  color: #FFF;
}
.pagination-style-4 .pagination .page-item.active:hover .page-link {
  background-color: #e85b28;
}
.pagination-style-4 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: #262A2A;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

h1,
.h1 {
  font-size: 2rem;
}

h2,
.h2 {
  font-size: 1.75rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.125rem;
}

h5,
.h5 {
  font-size: 1rem;
}

h6,
.h6 {
  font-size: 0.875rem;
}

.fs-sm {
  font-size: 0.6875rem;
}

.fs-base {
  font-size: 0.875rem;
}

.fs-lg {
  font-size: 1.125rem;
}

.fs-1 {
  font-size: 0.0625rem;
}

.fs-2 {
  font-size: 0.125rem;
}

.fs-3 {
  font-size: 0.1875rem;
}

.fs-4 {
  font-size: 0.25rem;
}

.fs-5 {
  font-size: 0.3125rem;
}

.fs-6 {
  font-size: 0.375rem;
}

.fs-7 {
  font-size: 0.4375rem;
}

.fs-8 {
  font-size: 0.5rem;
}

.fs-9 {
  font-size: 0.5625rem;
}

.fs-10 {
  font-size: 0.625rem;
}

.fs-11 {
  font-size: 0.6875rem;
}

.fs-12 {
  font-size: 0.75rem;
}

.fs-13 {
  font-size: 0.8125rem;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-15 {
  font-size: 0.9375rem;
}

.fs-16 {
  font-size: 1rem;
}

.fs-17 {
  font-size: 1.0625rem;
}

.fs-18 {
  font-size: 1.125rem;
}

.fs-19 {
  font-size: 1.1875rem;
}

.fs-20 {
  font-size: 1.25rem;
}

.fs-21 {
  font-size: 1.3125rem;
}

.fs-22 {
  font-size: 1.375rem;
}

.fs-23 {
  font-size: 1.4375rem;
}

.fs-24 {
  font-size: 1.5rem;
}

.fs-25 {
  font-size: 1.5625rem;
}

.fs-26 {
  font-size: 1.625rem;
}

.fs-27 {
  font-size: 1.6875rem;
}

.fs-28 {
  font-size: 1.75rem;
}
@media (max-width: 575.98px) {
  .fs-28 {
    font-size: 1.25rem;
  }
}

.fs-29 {
  font-size: 1.8125rem;
}

.fs-30 {
  font-size: 1.875rem;
}

.fs-32 {
  font-size: 2rem;
}

.fs-34 {
  font-size: 2.125rem;
}

.fs-36 {
  font-size: 2.25rem;
}

.fs-38 {
  font-size: 2.375rem;
}

.fs-40 {
  font-size: 2.5rem;
}

.fs-60 {
  font-size: 3.75rem;
}
@media (max-width: 991.98px) {
  .fs-60 {
    font-size: 2.125rem;
  }
}
@media (max-width: 575.98px) {
  .fs-60 {
    font-size: 1.125rem;
  }
}

.text-default {
  color: #6F6F6F !important;
}

.text-muted {
  color: #9595b5 !important;
}

.text-primary {
  color: #e85b28 !important;
  opacity: 1;
}
.text-primary.text-opacity-75 {
  color: rgba(232, 91, 40, 0.75) !important;
}
.text-primary.text-opacity-25 {
  color: rgba(232, 91, 40, 0.25) !important;
}
.text-primary.text-opacity-50 {
  color: rgba(232, 91, 40, 0.5) !important;
}

.text-secondary {
  color: #FFA201 !important;
  opacity: 1;
}

.text-info {
  color: #1ECBE2 !important;
  opacity: 1;
}

.text-success {
  color: #5CB85C !important;
  opacity: 1;
}

.text-warning {
  color: #FDA700 !important;
  opacity: 1;
}

.text-danger {
  color: #FC0027 !important;
  opacity: 1;
}

.text-blue {
  color: #339DFF !important;
}

.text-green {
  color: #00918E !important;
}

.text-pink {
  color: #EA00B7 !important;
}

.text-teal {
  color: #02a8b5 !important;
}

.text-orange {
  color: #FF9D0A !important;
}

.text-indigo {
  color: #391694 !important;
}

.text-purple {
  color: #4A00E5 !important;
}

.text-dark {
  color: #171724 !important;
}

.text-light {
  color: #FDFDFE !important;
}

.text-gray {
  color: #6F7A7A !important;
}

.text-black {
  color: #000 !important;
}

.text-white {
  color: #FFF !important;
}

.text-fixed-white {
  color: #FFF !important;
}

.text-fixed-black {
  color: #000 !important;
}

.text-gray-1 {
  color: #C0C0C0;
}

.text-gray-2 {
  color: #9B9B9B;
}

.text-gray-3 {
  color: #898989;
}

.text-gray-4 {
  color: #6F6F6F;
}

.text-gray-5 {
  color: #6F7A7A;
}

.text-gray-6 {
  color: #565E5E;
}

.text-gray-7 {
  color: #424848;
}

.text-gray-8 {
  color: #323737;
}

.text-gray-9 {
  color: #262A2A;
}

a {
  color: #262A2A;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.5s ease;
}
a:hover {
  color: #e85b28;
  transition: all 0.5s ease;
}
a:focus {
  outline: 0;
}

.link-primary {
  color: #e85b28 !important;
}
.link-primary:hover, .link-primary:focus, .link-primary:active {
  color: #e85b28 !important;
}

.link-secondary {
  color: #FFA201 !important;
}
.link-secondary:hover, .link-secondary:focus, .link-secondary:active {
  color: #FFA201 !important;
}

.link-success {
  color: #5CB85C !important;
}
.link-success:hover, .link-success:focus, .link-success:active {
  color: #5CB85C !important;
}

.link-danger {
  color: #FC0027 !important;
}
.link-danger:hover, .link-danger:focus, .link-danger:active {
  color: #FC0027 !important;
}

.link-warning {
  color: #FDA700 !important;
}
.link-warning:hover, .link-warning:focus, .link-warning:active {
  color: #FDA700 !important;
}

.link-info {
  color: #1ECBE2 !important;
}
.link-info:hover, .link-info:focus, .link-info:active {
  color: #1ECBE2 !important;
}

.link-light {
  color: #FDFDFE !important;
}
.link-light:hover, .link-light:focus, .link-light:active {
  color: #FDFDFE !important;
}

.link-dark {
  color: #171724 !important;
}
.link-dark:hover, .link-dark:focus, .link-dark:active {
  color: #171724 !important;
}

hr.text-danger {
  border-color: #FC0027 !important;
}

.text-purple {
  color: #4A00E5 !important;
}

.blockquote-container {
  padding: 1.25rem;
  border-left: 4px solid #E8E8E8;
  position: relative;
}
.blockquote-container.text-end {
  border-right: 4px solid #E8E8E8;
  border-left: 0;
}

.blockquote.custom-blockquote {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 1rem;
  border-radius: 4px;
  position: relative;
}
.blockquote.custom-blockquote:before {
  content: "\\f10d";
  font-family: "Fontawesome";
  z-index: 0;
  font-size: 2rem;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0.5rem;
}
.blockquote.custom-blockquote.primary {
  background-color: rgba(232, 91, 40, 0.1);
  border-inline-start: 2px solid #e85b28;
}
.blockquote.custom-blockquote.primary:before {
  color: rgba(232, 91, 40, 0.1);
}
.blockquote.custom-blockquote.secondary {
  background-color: rgba(255, 162, 1, 0.1);
  border-inline-start: 2px solid #FFA201;
}
.blockquote.custom-blockquote.secondary:before {
  color: rgba(255, 162, 1, 0.1);
}
.blockquote.custom-blockquote.info {
  background-color: rgba(30, 203, 226, 0.1);
  border-inline-start: 2px solid #1ECBE2;
}
.blockquote.custom-blockquote.info:before {
  color: rgba(30, 203, 226, 0.1);
}
.blockquote.custom-blockquote.warning {
  background-color: rgba(253, 167, 0, 0.1);
  border-inline-start: 2px solid #FDA700;
}
.blockquote.custom-blockquote.warning:before {
  color: rgba(253, 167, 0, 0.1);
}
.blockquote.custom-blockquote.success {
  background-color: rgba(92, 184, 92, 0.1);
  border-inline-start: 2px solid #5CB85C;
}
.blockquote.custom-blockquote.success:before {
  color: rgba(92, 184, 92, 0.1);
}
.blockquote.custom-blockquote.danger {
  background-color: rgba(252, 0, 39, 0.1);
  border-inline-start: 2px solid #FC0027;
}
.blockquote.custom-blockquote.danger:before {
  color: rgba(252, 0, 39, 0.1);
}

[data-theme-mode=dark] .shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow {
  box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow-lg {
  box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;
}

@media screen and (min-width: 576px) {
  .w-sm-auto {
    width: auto;
  }
}
[dir=rtl] .text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.transform-none {
  transform: none !important;
}

.w-9 {
  width: 9px;
}

.h-9 {
  height: 9px;
}

.list-circle {
  list-style: circle;
  padding-left: 2rem;
}

.alert {
  padding: 0.625rem 0.85rem;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.alert.alert-dismissible {
  padding: 0.625rem 2.25rem 0.625rem 0.85rem;
}
.alert i {
  font-size: 20px;
}
.alert .btn-close {
  background-image: none;
  padding: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert .btn-close i {
  font-size: 18px;
  line-height: 18px;
}
.alert:last-child {
  margin-bottom: 0;
}
.alert .alert-link {
  font-weight: 600;
}

[dir=rtl] .alert.alert-dismissible {
  padding: 0.625rem 0.85rem 0.625rem 2.25rem;
}

.alert-warning {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
  border-color: rgba(253, 167, 0, 0.1);
}
.alert-warning .alert-link {
  color: #FDA700;
}
.alert-warning .btn-close {
  color: #FDA700;
}
.alert-warning .btn-close.custom-close {
  background-color: #FDA700;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-primary {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
  border-color: rgba(232, 91, 40, 0.1);
}
.alert-primary .alert-link {
  color: #e85b28;
}
.alert-primary .custom-alert-icon {
  color: #e85b28;
}
.alert-primary .btn-close {
  color: #e85b28;
}
.alert-primary .btn-close.custom-close {
  background-color: #e85b28;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-secondary {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
  border-color: rgba(255, 162, 1, 0.1);
}
.alert-secondary .alert-link {
  color: #FFA201;
}
.alert-secondary .btn-close {
  color: #FFA201;
}
.alert-secondary .btn-close.custom-close {
  background-color: #FFA201;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-success {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
  border-color: rgba(92, 184, 92, 0.1);
}
.alert-success .alert-link {
  color: #5CB85C;
}
.alert-success .btn-close {
  color: #5CB85C;
}
.alert-success .btn-close.custom-close {
  background-color: #5CB85C;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-info {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
  border-color: rgba(30, 203, 226, 0.1);
}
.alert-info .alert-link {
  color: #1ECBE2;
}
.alert-info .btn-close {
  color: #1ECBE2;
}
.alert-info .btn-close.custom-close {
  background-color: #1ECBE2;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-danger {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
  border-color: rgba(252, 0, 39, 0.1);
}
.alert-danger .alert-link {
  color: #FC0027;
}
.alert-danger .btn-close {
  color: #FC0027;
}
.alert-danger .btn-close.custom-close {
  background-color: #FC0027;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border-color: #FDFDFE;
}
.alert-light .alert-link {
  color: #6F6F6F;
}
.alert-light .btn-close {
  color: #6F6F6F;
}
.alert-light .btn-close.custom-close {
  background-color: #FDFDFE;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-dark {
  background-color: rgba(23, 23, 36, 0.1);
  color: #6F6F6F;
  border-color: rgba(23, 23, 36, 0.1);
}
.alert-dark .alert-link {
  color: #6F6F6F;
}
.alert-dark .btn-close {
  color: #FFF;
}
.alert-dark .btn-close.custom-close {
  background-color: #171724;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-solid-primary {
  background-color: #e85b28;
  color: #FFF;
  border-color: #e85b28;
}
.alert-solid-primary .btn-close {
  color: #FFF;
}

.alert-solid-secondary {
  background-color: #FFA201;
  color: #FFF;
  border-color: #FFA201;
}
.alert-solid-secondary .btn-close {
  color: #FFF;
}

.alert-solid-warning {
  background-color: #FDA700;
  color: #FFF;
  border-color: #FDA700;
}
.alert-solid-warning .btn-close {
  color: #FFF;
}

.alert-solid-info {
  background-color: #1ECBE2;
  color: #FFF;
  border-color: #1ECBE2;
}
.alert-solid-info .btn-close {
  color: #FFF;
}

.alert-solid-success {
  background-color: #5CB85C;
  color: #FFF;
  border-color: #5CB85C;
}
.alert-solid-success .btn-close {
  color: #FFF;
}

.alert-solid-danger {
  background-color: #FC0027;
  color: #FFF;
  border-color: #FC0027;
}
.alert-solid-danger .btn-close {
  color: #FFF;
}

.alert-solid-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border-color: #E8E8E8;
}

.alert-solid-dark {
  background-color: #171724;
  color: #FFF;
  border-color: #171724;
}
.alert-solid-dark .btn-close {
  color: #FFF;
}

.alert-outline-primary {
  background-color: #FFF;
  color: #e85b28;
  border-color: #e85b28;
}
.alert-outline-primary .btn-close {
  color: #e85b28;
}

.alert-outline-secondary {
  background-color: #FFF;
  color: #FFA201;
  border-color: #FFA201;
}
.alert-outline-secondary .btn-close {
  color: #FFA201;
}

.alert-outline-info {
  background-color: #FFF;
  color: #1ECBE2;
  border-color: #1ECBE2;
}
.alert-outline-info .btn-close {
  color: #1ECBE2;
}

.alert-outline-warning {
  background-color: #FFF;
  color: #FDA700;
  border-color: #FDA700;
}
.alert-outline-warning .btn-close {
  color: #FDA700;
}

.alert-outline-success {
  background-color: #FFF;
  color: #5CB85C;
  border-color: #5CB85C;
}
.alert-outline-success .btn-close {
  color: #5CB85C;
}

.alert-outline-danger {
  background-color: #FFF;
  color: #FC0027;
  border-color: #FC0027;
}
.alert-outline-danger .btn-close {
  color: #FC0027;
}

.alert-outline-light {
  background-color: #FFF;
  color: #6F6F6F;
  border-color: #FDFDFE;
}

.alert-outline-dark {
  background-color: #FFF;
  color: #171724;
  border-color: #171724;
}
.alert-outline-dark .btn-close {
  color: #171724;
}

.alert-primary.custom-alert-icon {
  border-inline-start: 0.313rem solid #e85b28 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-primary.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-primary.custom-alert-icon > i {
  color: #e85b28;
}

.alert-secondary.custom-alert-icon {
  border-inline-start: 0.313rem solid #FFA201 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-secondary.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-secondary.custom-alert-icon > i {
  color: #FFA201;
}

.alert-warning.custom-alert-icon {
  border-inline-start: 0.313rem solid #FDA700 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-warning.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-warning.custom-alert-icon > i {
  color: #FDA700;
}

.alert-danger.custom-alert-icon {
  border-inline-start: 0.313rem solid #FC0027 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-danger.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-danger.custom-alert-icon > i {
  color: #FC0027;
}

.alert-success.custom-alert-icon {
  border-inline-start: 0.313rem solid #5CB85C !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-success.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-info.custom-alert-icon {
  border-inline-start: 0.313rem solid #1ECBE2 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-info.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-light.custom-alert-icon {
  border-inline-start: 0.313rem solid #FDFDFE !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-light.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-dark.custom-alert-icon {
  border-inline-start: 0.313rem solid #171724 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-dark.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.custom-alert1 {
  margin-block-end: 0;
  background-color: #FFF;
  border: 0;
  padding: 1.25rem;
  color: #6F6F6F;
}
.custom-alert1 p {
  margin-block-end: 2.5rem;
  color: #9595b5;
  font-size: 0.8rem;
}
.custom-alert1 .custom-alert-icon {
  font-size: 40px;
  margin-bottom: 0.85rem;
}
.custom-alert1 .custom-alert-icon i {
  font-size: 40px;
}
.custom-alert1 .btn-close {
  padding: 0;
  margin-block-end: 1rem;
}
.custom-alert1.alert-primary {
  border-block-start: 0.313rem solid #e85b28;
}
.custom-alert1.alert-primary .custom-alert-icon {
  color: #e85b28;
}
.custom-alert1.alert-secondary {
  border-block-start: 0.313rem solid #FFA201;
}
.custom-alert1.alert-secondary .custom-alert-icon {
  color: #FFA201;
}
.custom-alert1.alert-warning {
  border-block-start: 0.313rem solid #FDA700;
}
.custom-alert1.alert-warning .custom-alert-icon {
  color: #FDA700;
}
.custom-alert1.alert-danger {
  border-block-start: 0.313rem solid #FC0027;
}
.custom-alert1.alert-danger .custom-alert-icon {
  color: #FC0027;
}

.alert-img {
  display: flex;
  align-items: center;
}
.alert-img .avatar {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 400px) {
  .btn-close.custom-close {
    margin: 9px 9px 9px 0;
  }
}
.op-1-1 {
  opacity: 1;
}

.op-0 {
  opacity: 0;
}

.op-1 {
  opacity: 0.1;
}

.op-2 {
  opacity: 0.2;
}

.op-3 {
  opacity: 0.3;
}

.op-4 {
  opacity: 0.4;
}

.op-5 {
  opacity: 0.5;
}

.op-6 {
  opacity: 0.6;
}

.op-7 {
  opacity: 0.7;
}

.op-8 {
  opacity: 0.8;
}

.op-9 {
  opacity: 0.9;
}

.custom-popover {
  --bs-popover-max-width: 12.5rem;
  --bs-popover-border-color: #e85b28;
  --bs-popover-header-bg: #e85b28;
  --bs-popover-header-color: #FFF;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 0.5rem;
}

.popover {
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  font-size: 0.8rem;
  border-radius: 4px;
  z-index: 999;
}
.popover .popover-header {
  background-color: #FFF;
  border-block-end: 1px solid #E8E8E8;
}
.popover .popover-body {
  color: #6F6F6F;
}
.popover.only-body {
  border-radius: 0.3rem;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
.bs-popover-top > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
.bs-popover-top > .popover-arrow::before {
  border-top-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
.bs-popover-end > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
.bs-popover-end > .popover-arrow::before {
  border-right-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
.bs-popover-start > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
.bs-popover-start > .popover-arrow::before {
  border-left-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
.bs-popover-bottom > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FDFDFE;
}

.header-primary .popover-header {
  background-color: #e85b28;
  color: #FFF;
}
.header-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #e85b28;
}

.header-secondary .popover-header {
  background-color: #FFA201;
  color: #FFF;
}
.header-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FFA201;
}

.header-warning .popover-header {
  background-color: #FDA700;
  color: #FFF;
}
.header-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FDA700;
}

.header-info .popover-header {
  background-color: #1ECBE2;
  color: #FFF;
}
.header-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #1ECBE2;
}

.header-success .popover-header {
  background-color: #5CB85C;
  color: #FFF;
}
.header-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #5CB85C;
}

.header-danger .popover-header {
  background-color: #FC0027;
  color: #FFF;
}
.header-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FC0027;
}

.popover-primary.popover {
  border: 1px solid #e85b28;
}
.popover-primary.popover .popover-header {
  background-color: #e85b28;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-primary.popover .popover-body {
  background-color: #e85b28;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary.bs-popover-top > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary.bs-popover-top > .popover-arrow::before {
  border-top-color: #e85b28;
}
.popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary.bs-popover-end > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary.bs-popover-end > .popover-arrow::before {
  border-right-color: #e85b28;
}
.popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary.bs-popover-start > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary.bs-popover-start > .popover-arrow::before {
  border-left-color: #e85b28;
}
.popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary.bs-popover-bottom > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary.bs-popover-bottom > .popover-arrow::before, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #e85b28;
}

.popover-secondary.popover {
  border: 1px solid #FFA201;
}
.popover-secondary.popover .popover-header {
  background-color: #FFA201;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-secondary.popover .popover-body {
  background-color: #FFA201;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary.bs-popover-top > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary.bs-popover-top > .popover-arrow::before {
  border-top-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary.bs-popover-end > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary.bs-popover-end > .popover-arrow::before {
  border-right-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary.bs-popover-start > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary.bs-popover-start > .popover-arrow::before {
  border-left-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary.bs-popover-bottom > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary.bs-popover-bottom > .popover-arrow::before, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FFA201;
}

.popover-warning.popover {
  border: 1px solid #FDA700;
}
.popover-warning.popover .popover-header {
  background-color: #FDA700;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-warning.popover .popover-body {
  background-color: #FDA700;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning.bs-popover-top > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning.bs-popover-top > .popover-arrow::before {
  border-top-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning.bs-popover-end > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning.bs-popover-end > .popover-arrow::before {
  border-right-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning.bs-popover-start > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning.bs-popover-start > .popover-arrow::before {
  border-left-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning.bs-popover-bottom > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning.bs-popover-bottom > .popover-arrow::before, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FDA700;
}

.popover-info.popover {
  border: 1px solid #1ECBE2;
}
.popover-info.popover .popover-header {
  background-color: #1ECBE2;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-info.popover .popover-body {
  background-color: #1ECBE2;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info.bs-popover-top > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info.bs-popover-top > .popover-arrow::before {
  border-top-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info.bs-popover-end > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info.bs-popover-end > .popover-arrow::before {
  border-right-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info.bs-popover-start > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info.bs-popover-start > .popover-arrow::before {
  border-left-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info.bs-popover-bottom > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info.bs-popover-bottom > .popover-arrow::before, .popover-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info.bs-popover-bottom .popover-header::before {
  border-bottom-color: #1ECBE2;
}

.popover-success.popover {
  border: 1px solid #5CB85C;
}
.popover-success.popover .popover-header {
  background-color: #5CB85C;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-success.popover .popover-body {
  background-color: #5CB85C;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success.bs-popover-top > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success.bs-popover-top > .popover-arrow::before {
  border-top-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success.bs-popover-end > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success.bs-popover-end > .popover-arrow::before {
  border-right-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success.bs-popover-start > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success.bs-popover-start > .popover-arrow::before {
  border-left-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success.bs-popover-bottom > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success.bs-popover-bottom > .popover-arrow::before, .popover-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success.bs-popover-bottom .popover-header::before {
  border-bottom-color: #5CB85C;
}

.popover-danger.popover {
  border: 1px solid #FC0027;
}
.popover-danger.popover .popover-header {
  background-color: #FC0027;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-danger.popover .popover-body {
  background-color: #FC0027;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger.bs-popover-top > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger.bs-popover-top > .popover-arrow::before {
  border-top-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger.bs-popover-end > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger.bs-popover-end > .popover-arrow::before {
  border-right-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger.bs-popover-start > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger.bs-popover-start > .popover-arrow::before {
  border-left-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger.bs-popover-bottom > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger.bs-popover-bottom > .popover-arrow::before, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FC0027;
}

.popover-purple.popover {
  border: 1px solid #4A00E5;
}
.popover-purple.popover .popover-header {
  background-color: #4A00E5;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-purple.popover .popover-body {
  background-color: #4A00E5;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple.bs-popover-top > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple.bs-popover-top > .popover-arrow::before {
  border-top-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple.bs-popover-end > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple.bs-popover-end > .popover-arrow::before {
  border-right-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple.bs-popover-start > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple.bs-popover-start > .popover-arrow::before {
  border-left-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple.bs-popover-bottom > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple.bs-popover-bottom > .popover-arrow::before, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple.bs-popover-bottom .popover-header::before {
  border-bottom-color: #4A00E5;
}

.popover-teal.popover {
  border: 1px solid #02a8b5;
}
.popover-teal.popover .popover-header {
  background-color: #02a8b5;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-teal.popover .popover-body {
  background-color: #02a8b5;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal.bs-popover-top > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal.bs-popover-top > .popover-arrow::before {
  border-top-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal.bs-popover-end > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal.bs-popover-end > .popover-arrow::before {
  border-right-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal.bs-popover-start > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal.bs-popover-start > .popover-arrow::before {
  border-left-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal.bs-popover-bottom > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal.bs-popover-bottom > .popover-arrow::before, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal.bs-popover-bottom .popover-header::before {
  border-bottom-color: #02a8b5;
}

.popover-primary-light.popover {
  border: 1px solid rgba(232, 91, 40, 0.1);
}
.popover-primary-light.popover .popover-header {
  background-color: rgba(232, 91, 40, 0.1);
  border-block-end: 1px solid rgba(232, 91, 40, 0.1);
  color: #e85b28;
  border-radius: 0;
}
.popover-primary-light.popover .popover-body {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary-light.bs-popover-top > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(232, 91, 40, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary-light.bs-popover-end > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(232, 91, 40, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary-light.bs-popover-start > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(232, 91, 40, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary-light.bs-popover-bottom > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary-light.bs-popover-bottom > .popover-arrow::before, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(232, 91, 40, 0.1);
}

.popover-secondary-light.popover {
  border: 1px solid rgba(255, 162, 1, 0.1);
}
.popover-secondary-light.popover .popover-header {
  background-color: rgba(255, 162, 1, 0.1);
  border-block-end: 1px solid rgba(255, 162, 1, 0.1);
  color: #FFA201;
  border-radius: 0;
}
.popover-secondary-light.popover .popover-body {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary-light.bs-popover-top > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary-light.bs-popover-end > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(255, 162, 1, 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary-light.bs-popover-start > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary-light.bs-popover-bottom > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary-light.bs-popover-bottom > .popover-arrow::before, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--secondary-rgb), 0.1);
}

.popover-warning-light.popover {
  border: 1px solid rgba(253, 167, 0, 0.1);
}
.popover-warning-light.popover .popover-header {
  background-color: rgba(253, 167, 0, 0.1);
  border-block-end: 1px solid rgba(253, 167, 0, 0.1);
  color: #FDA700;
  border-radius: 0;
}
.popover-warning-light.popover .popover-body {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning-light.bs-popover-top > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning-light.bs-popover-end > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning-light.bs-popover-start > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning-light.bs-popover-bottom > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning-light.bs-popover-bottom > .popover-arrow::before, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(253, 167, 0, 0.1);
}

.popover-info-light.popover {
  border: 1px solid rgba(30, 203, 226, 0.1);
}
.popover-info-light.popover .popover-header {
  background-color: rgba(30, 203, 226, 0.1);
  border-block-end: 1px solid rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
  border-radius: 0;
}
.popover-info-light.popover .popover-body {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info-light.bs-popover-top > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info-light.bs-popover-end > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info-light.bs-popover-start > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info-light.bs-popover-bottom > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info-light.bs-popover-bottom > .popover-arrow::before, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(30, 203, 226, 0.1);
}

.popover-success-light.popover {
  border: 1px solid rgba(92, 184, 92, 0.1);
}
.popover-success-light.popover .popover-header {
  background-color: rgba(92, 184, 92, 0.1);
  border-block-end: 1px solid rgba(92, 184, 92, 0.1);
  color: #5CB85C;
  border-radius: 0;
}
.popover-success-light.popover .popover-body {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success-light.bs-popover-top > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success-light.bs-popover-end > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success-light.bs-popover-start > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success-light.bs-popover-bottom > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success-light.bs-popover-bottom > .popover-arrow::before, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(92, 184, 92, 0.1);
}

.popover-danger-light.popover {
  border: 1px solid rgba(252, 0, 39, 0.1);
}
.popover-danger-light.popover .popover-header {
  background-color: rgba(252, 0, 39, 0.1);
  border-block-end: 1px solid rgba(252, 0, 39, 0.1);
  color: #FC0027;
  border-radius: 0;
}
.popover-danger-light.popover .popover-body {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger-light.bs-popover-top > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger-light.bs-popover-end > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger-light.bs-popover-start > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger-light.bs-popover-bottom > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger-light.bs-popover-bottom > .popover-arrow::before, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(252, 0, 39, 0.1);
}

.popover-purple-light.popover {
  border: 1px solid rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.popover .popover-header {
  background-color: rgba(var(--purple-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--purple-rgb), 0.1);
  color: #4A00E5;
  border-radius: 0;
}
.popover-purple-light.popover .popover-body {
  background-color: rgba(var(--purple-rgb), 0.1);
  color: #4A00E5;
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple-light.bs-popover-top > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple-light.bs-popover-end > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple-light.bs-popover-start > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple-light.bs-popover-bottom > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple-light.bs-popover-bottom > .popover-arrow::before, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--purple-rgb), 0.1);
}

.popover-teal-light.popover {
  border: 1px solid rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.popover .popover-header {
  background-color: rgba(var(--teal-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
  border-radius: 0;
}
.popover-teal-light.popover .popover-body {
  background-color: rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal-light.bs-popover-top > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal-light.bs-popover-end > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal-light.bs-popover-start > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal-light.bs-popover-bottom > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal-light.bs-popover-bottom > .popover-arrow::before, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--teal-rgb), 0.1);
}

.timeline {
  position: relative;
  list-style: none;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0 20px;
}
.timeline:before {
  content: " ";
  position: absolute;
  width: 3px;
  margin-left: -1.5px;
  background-color: #898989;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
}
.timeline > li {
  position: relative;
  margin-bottom: 20px;
}
.timeline > li::before, .timeline > li::after {
  content: " ";
  display: table;
}
.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid #6F7A7A;
  border-radius: 0.25rem;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}
.timeline > li > .timeline-panel::before {
  content: " ";
  display: inline-block;
  position: absolute;
  border-top: 8px solid transparent;
  border-right: 0 solid #6F7A7A;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #6F7A7A;
  position: absolute;
  top: 26px;
  right: -8px;
}
.timeline > li > .timeline-panel::after {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -7px;
  border-top: 7px solid transparent;
  border-right: 0 solid #FFF;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #FFF;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-badge {
  z-index: 1;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  text-align: center;
  font-size: 1.4em;
  line-height: 50px;
  color: #FFF;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 50%;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.timeline > li.timeline-inverted > .timeline-panel::before {
  right: auto;
  left: -8px;
  border-right-width: 8px;
  border-left-width: 0;
}
.timeline > li.timeline-inverted > .timeline-panel::after {
  right: auto;
  left: -7px;
  border-right-width: 7px;
  border-left-width: 0;
}

.timeline-badge.primary {
  background-color: #e85b28;
}

.timeline-badge.success {
  background-color: #5CB85C;
}

.timeline-badge.warning {
  background-color: #FDA700;
}

.timeline-badge.danger {
  background-color: #FC0027;
}

.timeline-badge.info {
  background-color: #1ECBE2;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
  font-weight: regular;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

.form-wrap {
  margin-bottom: 24px;
}

.col-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
}

.form-control {
  border-color: #E8E8E8;
  color: #1e293b;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 10px;
  padding: 10px 14px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  min-height: 42px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.form-control:focus {
  border-color: #e85b28;
  background-color: #FFF;
  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08);
  color: #1e293b;
}
.form-control::placeholder {
  color: #94a3b8;
  opacity: 1;
}
.form-control.is-invalid {
  border-color: #ef4444;
}
.form-control.is-invalid:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);
}
.form-control:disabled, .form-control[readonly] {
  border-color: #e2e8f0;
  background-color: #f8fafc;
  color: #94a3b8;
  box-shadow: none;
  cursor: not-allowed;
}

.form-control[type=file] {
  padding: 0.3rem 0.5rem;
  line-height: 2.2;
}
.form-control[type=file].form-control-sm {
  padding: 0.25rem 0.5rem !important;
}
.form-control[type=file].form-control-lg {
  padding: 0.5rem 1rem !important;
}

.col-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
  padding: 0 0 5px;
}

.form-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.1px;
}

.form-text {
  color: #9595b5;
}

.form-control-light {
  background-color: #FDFDFE;
  border: 0;
}
.form-control-light:focus {
  background-color: #FDFDFE;
}

.form-control-primary {
  background-color: rgba(232, 91, 40, 0.1);
  border: 0;
  color: #e85b28;
}
.form-control-primary:focus {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}

.form-input-color {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 4px;
  overflow: hidden;
  padding: 0;
}

.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  color: #9595b5;
}

.form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background-color: transparent;
}

.input-group-text {
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.form-select {
  background-color: #ffffff;
  border: 1.5px solid #e2e8f0;
  color: #1e293b;
  font-size: 14px;
  min-height: 42px;
  border-radius: 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: 1.25rem;
  line-height: 1.6;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  transition: border-color 0.2s, box-shadow 0.2s;
}
.form-select:focus {
  border-color: #e85b28;
  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08);
}
.form-select.is-invalid {
  border-color: #ef4444;
}
.form-select.is-invalid:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);
}
.form-select:disabled {
  border-color: #e2e8f0;
  background-color: #f8fafc;
  color: #94a3b8;
  box-shadow: none;
  cursor: not-allowed;
}
.form-select option {
  background-color: #FFF;
  padding: 0.35rem 0.75rem;
  border-radius: 0.25rem;
  margin-block-end: 0.25rem;
}
.form-select option:last-child {
  margin-block-end: 0;
}
.form-select option:checked,
.form-select option:selected {
  background-color: #e85b28 !important;
  color: #ffffff !important;
}
.form-select option:hover,
.form-select option:focus {
  background-color: #fff7ed !important;
  color: #e85b28 !important;
}

input[type=checkbox] {
  accent-color: #e85b28;
}

.form-check-input {
  width: 1rem;
  height: 1rem;
  background-color: #FFF;
  border: 1.5px solid #e2e8f0;
  transition: all 0.2s;
}
.form-check-input:focus {
  border-color: #e85b28;
  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.12);
}
.form-check-input:checked {
  background-color: #e85b28;
  border-color: #e85b28;
}
.form-check-input.form-checked-outline:checked {
  background-color: transparent;
  border-color: #e85b28;
}
.form-check-input.form-checked-secondary:checked {
  background-color: #FFA201;
  border-color: #FFA201;
}
.form-check-input.form-checked-warning:checked {
  background-color: #FDA700;
  border-color: #FDA700;
}
.form-check-input.form-checked-info:checked {
  background-color: #1ECBE2;
  border-color: #1ECBE2;
}
.form-check-input.form-checked-success:checked {
  background-color: #5CB85C;
  border-color: #5CB85C;
}
.form-check-input.form-checked-danger:checked {
  background-color: #FC0027;
  border-color: #FC0027;
}
.form-check-input.form-checked-light:checked {
  background-color: #FDFDFE;
  border-color: #FDFDFE;
}
.form-check-input.form-checked-dark:checked {
  background-color: #171724;
  border-color: #171724;
}
.form-check-input:focus {
  border-color: #e85b28;
  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.12);
}

.form-check-label {
  color: #475569;
  font-size: 13px;
  font-weight: 500;
}

.form-checked-outline:checked[type=checkbox] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=checkbox]:before {
  content: "\\f633";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #e85b28;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1px;
  inset-inline-start: 0px;
  font-size: 0.688rem;
}
.form-checked-outline:checked[type=checkbox].form-checked-secondary:before {
  color: #FFA201;
}
.form-checked-outline:checked[type=checkbox].form-checked-warning:before {
  color: #FDA700;
}
.form-checked-outline:checked[type=checkbox].form-checked-info:before {
  color: #1ECBE2;
}
.form-checked-outline:checked[type=checkbox].form-checked-success:before {
  color: #5CB85C;
}
.form-checked-outline:checked[type=checkbox].form-checked-danger:before {
  color: #FC0027;
}
.form-checked-outline:checked[type=checkbox].form-checked-light:before {
  color: #FDFDFE;
}
.form-checked-outline:checked[type=checkbox].form-checked-dark:before {
  color: #171724;
}

.form-checked-outline:checked[type=radio] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=radio]:before {
  content: "\\f309";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #e85b28;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1.13rem;
  inset-inline-start: -0.6rem;
  font-size: 2rem;
}
.form-checked-outline:checked[type=radio].form-checked-secondary:before {
  color: #FFA201;
}
.form-checked-outline:checked[type=radio].form-checked-warning:before {
  color: #FDA700;
}
.form-checked-outline:checked[type=radio].form-checked-info:before {
  color: #1ECBE2;
}
.form-checked-outline:checked[type=radio].form-checked-success:before {
  color: #5CB85C;
}
.form-checked-outline:checked[type=radio].form-checked-danger:before {
  color: #FC0027;
}
.form-checked-outline:checked[type=radio].form-checked-light:before {
  color: #FDFDFE;
}
.form-checked-outline:checked[type=radio].form-checked-dark:before {
  color: #171724;
}

fieldset:disabled .btn {
  color: #FFF;
  background-color: #e85b28;
  border-color: #e85b28;
}

.form-select:focus {
  border-color: rgba(var(#e85b28), 0.5);
  outline: 0;
  box-shadow: none;
}

.btn-check:focus + .btn,
.btn:focus {
  background-color: none;
  border-color: none;
  outline: 0;
}

.btn-check:active + .btn:focus,
.btn-check:checked + .btn:focus,
.btn.active:focus,
.btn.show:focus,
.btn:active:focus {
  box-shadow: none;
}

.form-control:disabled,
.form-select:disabled {
  background-color: #FDFDFE;
  color: #6F6F6F;
}

.form-control-plaintext {
  color: #6F6F6F;
}

.form-control::-webkit-file-upload-button {
  color: #6F6F6F;
  background-color: #f7f8f9;
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #f7f8f9;
}

.form-control:focus::-webkit-input-placeholder, .form-control:focus::placeholder {
  padding-inline-start: 0.3rem;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control::-webkit-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.7;
  color: #6F6F6F;
  padding-inline-start: 0px;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control:-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}
.form-control::-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}
.form-control:-ms-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}

.form-control-sm {
  font-size: 0.8rem;
  padding: 0.25rem 0.8rem;
}

.form-control-lg {
  font-size: 1rem;
  padding: 0.5rem 1rem;
}

.form-check-md .form-check-input {
  width: 1.15rem;
  height: 1.15rem;
}
.form-check-md.form-switch .form-check-input {
  width: 2.25rem;
}
.form-check-md label {
  margin-inline-start: 0.5rem;
  font-size: 0.95rem;
  margin-block-start: 3px;
}

.form-check-lg .form-check-input {
  width: 1.35rem;
  height: 1.35rem;
}
.form-check-lg.form-switch .form-check-input {
  width: 2.5rem;
}
.form-check-lg label {
  margin-inline-start: 0.5rem;
  font-size: 1rem;
  margin-block-start: 3px;
}

.toggle {
  width: 3.75rem;
  height: 1.563rem;
  background-color: #FDFDFE;
  margin-inline-start: 0.625rem;
  margin-block-end: 0.313rem;
  padding: 0.125rem;
  border-radius: 0.188rem;
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease;
}
.toggle span {
  position: absolute;
  inset-block-start: 0.188rem;
  inset-block-end: 0.25rem;
  inset-inline-start: 0.188rem;
  display: block;
  width: 1.25rem;
  border-radius: 0.125rem;
  background-color: #FFF;
  box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.2s ease;
}
.toggle span::before {
  content: "on";
  inset-inline-start: -1.563rem;
}
.toggle span::after {
  content: "off";
  inset-inline-end: -1.813rem;
  color: #9595b5;
}
.toggle span::before, .toggle span::after {
  position: absolute;
  font-size: 0.625rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  inset-block-start: 0.188rem;
  line-height: 1.38;
  transition: all 0.2s ease;
}
.toggle.on {
  background-color: rgba(var(#e85b28), 0.3);
}
.toggle.on span {
  background-color: #e85b28;
}
.toggle.on span::before {
  color: #e85b28;
}
.toggle.on.toggle-secondary {
  background-color: rgba(255, 162, 1, 0.4);
}
.toggle.on.toggle-secondary span {
  background-color: #FFA201;
}
.toggle.on.toggle-secondary span::before {
  color: #FFA201;
}
.toggle.on.toggle-warning {
  background-color: rgba(253, 167, 0, 0.4);
}
.toggle.on.toggle-warning span {
  background-color: #FDA700;
}
.toggle.on.toggle-warning span::before {
  color: #FDA700;
}
.toggle.on.toggle-info {
  background-color: rgba(30, 203, 226, 0.4);
}
.toggle.on.toggle-info span {
  background-color: #1ECBE2;
}
.toggle.on.toggle-info span::before {
  color: #1ECBE2;
}
.toggle.on.toggle-success {
  background-color: rgba(92, 184, 92, 0.4);
}
.toggle.on.toggle-success span {
  background-color: #5CB85C;
}
.toggle.on.toggle-success span::before {
  color: #5CB85C;
}
.toggle.on.toggle-danger {
  background-color: rgba(252, 0, 39, 0.4);
}
.toggle.on.toggle-danger span {
  background-color: #FC0027;
}
.toggle.on.toggle-danger span::before {
  color: #FC0027;
}
.toggle.on.toggle-light {
  background-color: rgba(253, 253, 254, 0.4);
}
.toggle.on.toggle-light span {
  background-color: #FDFDFE;
}
.toggle.on.toggle-light span::before, .toggle.on.toggle-light span::after {
  color: #9595b5;
}
.toggle.on.toggle-dark {
  background-color: rgba(23, 23, 36, 0.4);
}
.toggle.on.toggle-dark span {
  background-color: #171724;
}
.toggle.on.toggle-dark span::before {
  color: #FFF;
}
.toggle.on span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span::before {
  inset-block-start: -1px;
  inset-inline-start: -1.563rem;
}
.toggle.on.toggle-lg span {
  inset-inline-start: 2.563rem;
}
.toggle.on.toggle-lg span::before {
  inset-block-start: 0.5rem;
  inset-inline-start: -1.75rem;
}
.toggle.toggle-sm {
  height: 1.063rem;
  width: 3.125rem;
}
.toggle.toggle-sm span {
  width: 0.625rem;
  height: 0.625rem;
}
.toggle.toggle-sm span::after {
  inset-inline-end: -1.875rem;
  inset-block-start: -1px;
}
.toggle.toggle-lg {
  height: 2.125rem;
  width: 4.5rem;
}
.toggle.toggle-lg span {
  width: 1.75rem;
}
.toggle.toggle-lg span::after {
  inset-block-start: 0.5rem;
  inset-inline-end: -1.938rem;
}

.custom-toggle-switch > input[type=checkbox] {
  display: none;
}

.custom-toggle-switch > label {
  cursor: pointer;
  height: 0;
  position: relative;
  width: 2.5rem;
}

.label-primary {
  background: #e85b28;
  color: #FFF;
}

.label-secondary {
  background: #FFA201;
  color: #FFF;
}

.label-warning {
  background: #FDA700;
  color: #FFF;
}

.label-info {
  background: #1ECBE2;
  color: #FFF;
}

.label-success {
  background: #5CB85C;
  color: #FFF;
}

.label-danger {
  background: #FC0027;
  color: #FFF;
}

.label-light {
  background: #FDFDFE;
  color: #FFF;
}

.label-dark {
  background: #171724;
  color: #FFF;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::before {
  background: inherit;
  opacity: 0.5;
}

.custom-toggle-switch > label::before {
  background: #9595b5;
  box-shadow: inset 0px 0px 0.625rem rgba(255, 255, 255, 0.5);
  border-radius: 0.5rem;
  content: "";
  height: 1rem;
  margin-block-start: -0.5rem;
  position: absolute;
  opacity: 0.3;
  transition: all 0.4s ease-in-out;
  width: 2.5rem;
}
.custom-toggle-switch > label::after {
  background: #FFF;
  border-radius: 1rem;
  box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);
  content: "";
  height: 1.5rem;
  inset-inline-start: -0.25rem;
  margin-block-start: -0.5rem;
  position: absolute;
  inset-block-start: -0.25rem;
  transition: all 0.3s ease-in-out;
  width: 1.5rem;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::after {
  background: inherit;
  inset-inline-start: 50%;
}

.custom-toggle-switch.toggle-sm > label::before {
  height: 10px;
  width: 27px;
  border-radius: 10px;
}

.custom-toggle-switch.toggle-sm input[type=checkbox]:checked + label::after {
  inset-inline-start: 13px;
}

.custom-toggle-switch.toggle-sm > label::after {
  height: 17px;
  width: 17px;
  border-radius: 50%;
}

.custom-toggle-switch.toggle-lg > label::before {
  height: 27px;
  width: 55px;
  border-radius: 20px;
}

.custom-toggle-switch.toggle-lg input[type=checkbox]:checked + label::after {
  inset-inline-start: 77%;
}

.custom-toggle-switch.toggle-lg > label::after {
  height: 35px;
  width: 35px;
  margin-block-start: -8px;
  border-radius: 50%;
}

.form-floating > .form-control-plaintext::placeholder,
.form-floating > .form-control::placeholder {
  color: transparent !important;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem - 4px);
}

.form-floating.floating-primary label {
  color: #e85b28;
  opacity: 1;
}
.form-floating.floating-primary input {
  border: 1px solid #e85b28;
}
.form-floating.floating-primary > .form-control:focus ~ label {
  color: #e85b28 !important;
}
.form-floating.floating-secondary label {
  color: #FFA201;
  opacity: 1;
}
.form-floating.floating-secondary input {
  border: 1px solid #FFA201;
}
.form-floating.floating-secondary > .form-control:focus ~ label {
  color: #FFA201 !important;
}
.form-floating.floating-warning label {
  color: #FDA700;
  opacity: 1;
}
.form-floating.floating-warning input {
  border: 1px solid #FDA700;
}
.form-floating.floating-warning > .form-control:focus ~ label {
  color: #FDA700 !important;
}
.form-floating.floating-info label {
  color: #1ECBE2;
  opacity: 1;
}
.form-floating.floating-info input {
  border: 1px solid #1ECBE2;
}
.form-floating.floating-info > .form-control:focus ~ label {
  color: #1ECBE2 !important;
}
.form-floating.floating-success label {
  color: #5CB85C;
  opacity: 1;
}
.form-floating.floating-success input {
  border: 1px solid #5CB85C;
}
.form-floating.floating-success > .form-control:focus ~ label {
  color: #5CB85C !important;
}
.form-floating.floating-danger label {
  color: #FC0027;
  opacity: 1;
}
.form-floating.floating-danger input {
  border: 1px solid #FC0027;
}
.form-floating.floating-danger > .form-control:focus ~ label {
  color: #FC0027 !important;
}

.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-select ~ label::after {
  background-color: #FFF;
  border-radius: 4px;
}

.form-wizard-1 {
  border-bottom: 0;
  border-radius: 50px;
}
.form-wizard-1 .nav-link {
  border: 0;
}
.form-wizard-1.nav-tabs .nav-item {
  margin-inline-end: 1rem;
  position: relative;
}
.form-wizard-1.nav-tabs .nav-link {
  padding: 0.25rem 0.4rem;
  color: #9595b5;
  display: flex;
  align-items: center;
  border-radius: 50px;
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link i {
  font-size: 12px;
  padding: 4px;
  line-height: 1;
  border-radius: 50px;
  border: 2px solid #E8E8E8;
}
.form-wizard-1.nav-tabs .nav-link:focus, .form-wizard-1.nav-tabs .nav-link:hover {
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link.active {
  border: 2px solid #e85b28;
  border-radius: 50px;
  color: #e85b28;
  background-color: transparent;
}
.form-wizard-1.nav-tabs .nav-link.active i {
  border: 2px solid #e85b28;
}
.form-wizard-1 .nav-item:focus-visible {
  outline: none;
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  border-color: #5CB85C;
  box-shadow: none;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #5CB85C;
}

.form-control-color {
  width: 1.75rem;
  height: 1.75rem;
  overflow: hidden;
  padding: 0;
}

.example-picker .pcr-button {
  border-radius: 0.35rem !important;
  overflow: hidden;
}

[dir=rtl] [type=email],
[dir=rtl] [type=number],
[dir=rtl] [type=tel],
[dir=rtl] [type=url] {
  direction: rtl;
}

.form-select.is-invalid:not([multiple]):not([size]) {
  padding-right: 1.125rem;
  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invoice-quantity-container .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: 0;
}

input[type=range]::-webkit-slider-runnable-track {
  background-color: #FDFDFE;
}

[dir=rtl] .form-checked-outline:checked[type=checkbox]:before {
  inset-inline-start: 1px;
}

.is-invalid ~ .invalid-feedback, .is-invalid ~ .invalid-tooltip, .was-validated :invalid ~ .invalid-feedback, .was-validated :invalid ~ .invalid-tooltip {
  display: inline-block;
}

.is-valid ~ .valid-feedback, .is-valid ~ .valid-tooltip, .was-validated :valid ~ .valid-feedback, .was-validated :valid ~ .valid-tooltip {
  display: inline-block;
}

.invalid-tooltip, .valid-tooltip {
  position: relative;
  top: 0;
}

/* ── Global react-select error state ── */
/* Covers classNamePrefix="react-select" and classNamePrefix="select" */
.is-invalid .react-select__control,
.is-invalid .react-select__control:hover,
.is-invalid .select__control,
.is-invalid .select__control:hover {
  border-color: #ef4444 !important;
  box-shadow: none !important;
}

.is-invalid .react-select__control--is-focused,
.is-invalid .select__control--is-focused {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

/* ── Shared emp-select style system ── */
.emp-select__control {
  border: 1.5px solid #e2e8f0 !important;
  border-radius: 10px !important;
  min-height: 42px !important;
  box-shadow: none !important;
  transition: border-color 0.2s, box-shadow 0.2s !important;
}

.emp-select__control:hover {
  border-color: #cbd5e1 !important;
}

.emp-select__control--is-focused {
  border-color: #e85b28 !important;
  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08) !important;
}

.emp-select__menu,
.react-select__menu,
.select2__menu,
.select__menu {
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12) !important;
  z-index: 9999 !important;
}

.emp-select__menu-list,
.react-select__menu-list,
.select2__menu-list,
.select__menu-list {
  padding: 6px !important;
}

.emp-select__option,
.react-select__option,
.select2__option,
.select__option {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  border-radius: 8px !important;
  padding: 9px 10px !important;
  transition: background-color 0.15s ease, color 0.15s ease !important;
}

.emp-select__option--is-focused,
.react-select__option--is-focused,
.select2__option--is-focused,
.select__option--is-focused {
  background: #fff7ed !important;
  color: #e85b28 !important;
}

.emp-select__option--is-selected,
.react-select__option--is-selected,
.select2__option--is-selected,
.select__option--is-selected {
  background: #e85b28 !important;
  color: #fff !important;
}

/* Fallback for react-select instances rendered without classNamePrefix */
[class^=css-][class\$=-menu] {
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12) !important;
  z-index: 9999 !important;
}

[class^=css-][class\$=-menu] > [class^=css-][class\$=-menu-list] {
  padding: 6px !important;
}

[class^=css-][class\$=-menu] > [class^=css-][class\$=-menu-list] > [class^=css-][class\$=-option] {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  border-radius: 8px !important;
  padding: 9px 10px !important;
  transition: background-color 0.15s ease, color 0.15s ease !important;
}

[class^=css-][class\$=-menu] > [class^=css-][class\$=-menu-list] > [class^=css-][class\$=-option][aria-selected=false]:hover {
  background: #fff7ed !important;
  color: #e85b28 !important;
}

[class^=css-][class\$=-menu] > [class^=css-][class\$=-menu-list] > [class^=css-][class\$=-option][aria-selected=true] {
  background: #e85b28 !important;
  color: #fff !important;
}

.emp-select__option--is-disabled,
.react-select__option--is-disabled,
.select2__option--is-disabled,
.select__option--is-disabled {
  color: #cbd5e1 !important;
  cursor: not-allowed !important;
}

.emp-select__indicator,
.react-select__indicator,
.select2__indicator,
.select__indicator {
  color: #94a3b8 !important;
}

.emp-select__indicator:hover,
.react-select__indicator:hover,
.select2__indicator:hover,
.select__indicator:hover {
  color: #e85b28 !important;
}

.emp-select__indicator-separator,
.react-select__indicator-separator,
.select2__indicator-separator,
.select__indicator-separator {
  display: none !important;
}

.react-select__control,
.select2__control,
.select__control {
  border: 1.5px solid #e2e8f0 !important;
  border-radius: 10px !important;
  min-height: 42px !important;
  box-shadow: none !important;
  transition: border-color 0.2s, box-shadow 0.2s !important;
}

.react-select__control:hover,
.select2__control:hover,
.select__control:hover {
  border-color: #cbd5e1 !important;
}

.react-select__control--is-focused,
.select2__control--is-focused,
.select__control--is-focused {
  border-color: #e85b28 !important;
  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08) !important;
}

.emp-select__placeholder {
  color: #cbd5e1 !important;
  font-size: 14px;
}

.emp-select__single-value {
  color: #1e293b !important;
  font-size: 14px;
}

.emp-select__multi-value {
  background: #fff5f2 !important;
  border-radius: 6px !important;
}

.emp-select__multi-value__label {
  color: #e85b28 !important;
  font-size: 13px;
  font-weight: 600;
}

.emp-select__multi-value__remove {
  color: #e85b28 !important;
}

.emp-select__multi-value__remove:hover {
  background: #e85b28 !important;
  color: #fff !important;
}

.is-invalid .emp-select__control,
.is-invalid .emp-select__control:hover,
.is-invalid .select2__control,
.is-invalid .select2__control:hover,
.is-invalid .react-select__control,
.is-invalid .react-select__control:hover,
.is-invalid .select__control,
.is-invalid .select__control:hover {
  border-color: #ef4444 !important;
  box-shadow: none !important;
}

.is-invalid .select2__control--is-focused,
.is-invalid .react-select__control--is-focused,
.is-invalid .select__control--is-focused,
.is-invalid .emp-select__control--is-focused {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08) !important;
}

/* ── Consistent field error message style (app-wide) ── */
.invalid-feedback,
.field-error {
  display: none;
  width: 100%;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #ef4444;
}

.is-invalid ~ .invalid-feedback,
.is-invalid ~ .field-error {
  display: block;
}

/* text-danger used on react-select errors — normalise size */
.text-danger {
  font-size: 12px !important;
  font-weight: 500;
}

.emp-switch input:disabled + .emp-switch-slider {
  opacity: 0.6;
  cursor: not-allowed;
}

.emp-switch input:disabled + .emp-switch-slider::before {
  box-shadow: none;
}

.emp-form-field {
  margin-bottom: 1rem;
}

.emp-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.emp-check-label {
  color: #475569;
  font-size: 13px;
  font-weight: 500;
}

.emp-check input:disabled + .emp-check-label {
  opacity: 0.6;
  cursor: not-allowed;
}

.emp-phone-input {
  width: 100%;
}

.emp-phone-input .emp-phone-field,
.react-tel-input .emp-phone-field {
  width: 100% !important;
  height: 42px !important;
  border: 1.5px solid #e2e8f0 !important;
  border-radius: 10px !important;
  padding-left: 52px !important;
  color: #1e293b !important;
  font-size: 14px !important;
  box-shadow: none !important;
  transition: border-color 0.2s, box-shadow 0.2s !important;
}

.emp-phone-input .emp-phone-field:focus,
.react-tel-input .emp-phone-field:focus {
  border-color: #e85b28 !important;
  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08) !important;
}

.emp-phone-input .emp-phone-btn,
.react-tel-input .emp-phone-btn {
  border: 1.5px solid #e2e8f0 !important;
  border-right: none !important;
  border-radius: 10px 0 0 10px !important;
  background: #fff !important;
}

.emp-phone-input .emp-phone-dropdown,
.react-tel-input .emp-phone-dropdown {
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12) !important;
}

.emp-phone-input .emp-phone-dropdown .country,
.react-tel-input .emp-phone-dropdown .country {
  font-size: 13px !important;
  color: #334155 !important;
}

.emp-phone-input .emp-phone-dropdown .country:hover,
.emp-phone-input .emp-phone-dropdown .country.highlight,
.react-tel-input .emp-phone-dropdown .country:hover,
.react-tel-input .emp-phone-dropdown .country.highlight {
  background: #fff7ed !important;
  color: #e85b28 !important;
}

.emp-phone-input--error .emp-phone-field {
  border-color: #ef4444 !important;
}

.emp-phone-input--error .emp-phone-field:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08) !important;
}

.form-check {
  min-height: inherit !important;
}

.col-form-label-lg,
.col-form-label-sm,
.col-form-label {
  font-weight: 500;
}

#exampleColorInput::-webkit-color-swatch-wrapper {
  direction: rtl;
}

[data-theme-mode=dark] input[type=week]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=month]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=date]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=datetime-local]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=time]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

[dir=rtl] input[type=week], [dir=rtl] input[type=month], [dir=rtl] input[type=date], [dir=rtl] input[type=datetime-local], [dir=rtl] input[type=time] {
  text-align: end;
}

.form-control.form-control-lg {
  height: 46px;
}
.form-control.form-control-sm {
  height: 30px;
  min-height: 30px;
}

.input-group-sm .input-group-text {
  height: 35px;
}
.input-group-sm .form-control {
  height: 35px;
  min-height: 35px;
}

.input-icon-addon {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  color: #515B73;
  pointer-events: none;
  font-size: 1.2em;
}

.icon-form {
  transition: color 0.2s;
}

.icon-form .form-icon,
.input-icon-addon {
  color: #94a3b8;
}

.icon-form:focus-within .form-icon {
  color: #e85b28;
}

.checkboxs {
  display: block;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-left: 25px;
}
.checkboxs input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkboxs input ~ .checkmarks {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}

.checkboxs input:checked ~ .checkmarks {
  background-color: #e85b28;
  border-color: #e85b28;
}

.checkboxs input:checked ~ .checkmarks:after {
  display: block;
}

.checkboxs .checkmarks {
  height: 16px;
  width: 16px;
  position: absolute;
  top: 0;
  left: 0;
}

.checkboxs .checkmarks:after {
  content: "";
  position: absolute;
  display: none;
}

.checkboxs .checkmarks:after {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #FFF;
  font-weight: 600;
  font-size: 10px;
}

.status-radio:checked,
.status-radio:not(:checked) {
  position: absolute;
  left: -9999px;
}

.status-radio:checked + label,
.status-radio:not(:checked) + label {
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  line-height: 16px;
  display: inline-block;
  color: #262A2A;
}

.status-radio:checked + label:before,
.status-radio:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  border: 1px solid #E8E8E8;
  border-radius: 100%;
  background: #FFF;
}

.status-radio:checked + label:before {
  background: #391694;
  border-color: #391694;
}

.status-radio[type=radio]:checked + label:after,
.status-radio[type=radio]:not(:checked) + label:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #FFF;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  transition: all 0.2s ease;
}

[type=radio]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}

[type=radio]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}

.bootstrap-tagsinput {
  border-color: #F6F6F6;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  font-size: 14px;
  color: #6F6F6F;
  min-height: 42px;
  line-height: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-height: 42px;
  overflow-y: auto;
}
.bootstrap-tagsinput .tag {
  background: #F6F6F6;
  color: #6F6F6F;
  padding: 2px 5px;
  line-height: normal;
  border-radius: 5px;
  font-size: 14px;
}

/* Shared emp classes used by reusable form primitives */
.emp-label {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  letter-spacing: 0.1px;
}

.emp-label .req {
  color: #e85b28;
  margin-left: 2px;
}

.emp-label-hint {
  font-weight: 400;
  font-size: 11px;
  color: #94a3b8;
  margin-left: 4px;
}

.emp-input {
  display: block;
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  color: #1e293b;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}

.emp-input::placeholder {
  color: #94a3b8;
  opacity: 1;
}

.emp-input:focus {
  border-color: #e85b28;
  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08);
}

.emp-input.is-invalid {
  border-color: #ef4444;
}

.emp-input.is-invalid:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);
}

.emp-input:disabled,
.emp-input[readonly] {
  border-color: #e2e8f0;
  background-color: #f8fafc;
  color: #94a3b8;
  box-shadow: none;
  cursor: not-allowed;
}

textarea.emp-input {
  resize: vertical;
  min-height: 90px;
}

.emp-field-error {
  font-size: 11.5px;
  color: #e85b28;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.emp-field-error::before {
  content: "⚠";
  font-size: 10px;
}

.emp-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
  margin: 0;
}

.emp-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.emp-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbd5e1;
  border-radius: 24px;
  transition: 0.25s;
}

.emp-switch-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.25s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.emp-switch input:checked + .emp-switch-slider {
  background-color: #e85b28;
}

.emp-switch input:checked + .emp-switch-slider::before {
  transform: translateX(20px);
}

.notes-page-wrapper .content {
  padding: 24px;
}
.notes-page-wrapper .content .page-add-notes {
  border-bottom: 1px solid #E8E8E8;
  padding-bottom: 25px;
  position: relative;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .page-add-notes {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .page-add-notes .notes-tog {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  bottom: -12px;
  border-radius: 30px;
  background: #1B2850;
  color: #FFF;
  width: 24px;
  height: 24px;
  padding: 5px;
}
@media (max-width: 991.98px) {
  .notes-page-wrapper .content .page-add-notes .notes-tog {
    display: none;
  }
}
.notes-page-wrapper .content .section-bulk-wrap {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin: 30px 0 24px 0;
  padding: 20px;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .section-bulk-wrap {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 0;
    flex-direction: column;
    align-items: self-start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 8px;
  height: 40px;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
  background: #6F7A7A;
  padding: 8px 20px;
  color: #FFF;
  font-size: 15px;
  font-weight: 400;
  margin-right: 15px;
  height: 40px;
  line-height: normal;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added:hover {
  background: #e85b28;
}
@media (max-width: 575.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
    margin: 20px 0;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .form-sort .fa-filter {
  z-index: 100 !important;
  position: absolute;
  top: 15px;
  left: 15px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-notes-slider {
  position: relative;
  padding-bottom: 40px;
  border-bottom: 1px solid #E8E8E8;
}
.notes-page-wrapper .content .section-notes-slider .notes-content {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a {
  color: #FC0027;
  font-size: 15px;
  font-weight: 400;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a i {
  margin-right: 6px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card {
  padding: 24px;
  border-radius: 8px;
  background: rgba(255, 159, 67, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.medium {
  background: rgba(116, 41, 248, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.high {
  background: rgba(234, 84, 85, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged {
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.high {
  color: #FC0027;
  border: 1px solid #FC0027;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F7A7A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a.dropdown-item:hover {
  color: #262A2A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a.dropdown-item:hover svg {
  color: #262A2A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content {
  margin: 24px 0;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a {
  margin-bottom: 10px;
  color: #6F7A7A;
  font-size: 16px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a:hover {
  color: #FDA700;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span {
  width: 32px;
  height: 32px;
  display: flex;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square i {
  color: #5CB85C;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square i {
  color: #FDA700;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.medium {
  color: #5CB85C;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.high {
  color: #FDA700;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .fa-star {
  color: #FDA700;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FC0027;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body {
  padding-top: 40px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details {
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  padding: 24px;
  margin-bottom: 24px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.high {
  color: #FC0027;
  border: 1px solid #FC0027;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F7A7A;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span svg {
  width: 14px;
  height: 14px;
  color: #6F6F6F;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item:hover span svg {
  color: #FFF;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content {
  padding: 20px 0;
  border-bottom: 1px solid #E8E8E8;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a {
  color: #6F7A7A;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a:hover {
  color: #FDA700;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal svg {
  margin-right: 5px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget.notes-widget-profile {
  padding-top: 20px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square i {
  color: #5CB85C;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square i {
  color: #FDA700;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p {
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.medium {
  color: #5CB85C;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.high {
  color: #FDA700;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-star {
  color: #6F6F6F;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FC0027;
  width: 16px;
  height: 16px;
}

.notes-card-details .notes-card-body a {
  color: #6F7A7A;
}

.star-todo-inbox svg {
  width: 13px;
  height: 13px;
  color: #6F6F6F;
}

.inbox-call-profile {
  border-radius: 5px;
  background: #E92990;
  border: 1px solid #E92990;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 700;
  color: #FFF;
  margin: 0 20px;
}
.inbox-call-profile:hover {
  color: #E92990;
  background: #FFF;
}

.notes-tog i {
  transform: rotate(180deg);
}
.notes-tog.active i {
  transform: rotate(0deg);
}

.section-bulk-wrap .form-sort {
  position: relative;
}
.section-bulk-wrap .form-sort svg.feather-filter {
  position: absolute;
  z-index: 101;
  width: 16px;
  height: 16px;
  top: 12px;
  left: 10px;
}

.page-add-notes.active svg {
  transform: rotate(0) !important;
}

.dropdown-menu.notes-menu {
  z-index: 99999;
}
.dropdown-menu.notes-menu a.dropdown-item {
  color: #6F7A7A;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
}
.dropdown-menu.notes-menu a.dropdown-item:hover {
  background: #F6F6F6;
  color: #262A2A;
}
.dropdown-menu.notes-menu a.dropdown-item:hover svg {
  color: #262A2A;
}
.dropdown-menu.notes-menu span {
  margin-right: 8px;
}
.dropdown-menu.notes-menu svg {
  width: 14px;
  height: 14px;
  color: #6F6F6F;
}

.edit-note-head a {
  border-radius: 30px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  color: #6F7A7A;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.edit-note-head a:hover {
  border-radius: 20px;
  background: #e85b28;
  color: #FFF;
}

.custom-modal-body .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}

.bulk-con-wrap {
  width: 100%;
}

.section-bulk-widget {
  transition: 0.6s all;
}

.section-notes-dashboard {
  display: none;
  transition: 0.6s all;
}

.notes-tog i {
  transition: 0.5s all;
}

.notes-tag-left .notes-tog i {
  transform: rotate(360deg);
  transition: 0.5s all;
}

.budgeted-role-notes {
  width: 100%;
}

.notes-summernote .card {
  margin-bottom: 0 !important;
}

.dropdown-item:active {
  background: transparent;
}

.notes-summernote p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
}

.budget-role-notes .owl-carousel .owl-nav {
  margin: 0;
  position: absolute;
}

.notes-dash {
  margin-top: 30px;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  transition: 0.6s all;
}
.notes-dash .notes-top-head {
  border-bottom: 1px solid #E8E8E8;
}
.notes-dash .notes-top-head h5 {
  font-size: 18px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head h5 svg {
  width: 19px;
  height: 19px;
  margin-right: 6px;
  color: #6F6F6F;
}
.notes-dash .notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #E8E8E8;
}
.notes-dash .notes-top-head-submenu ul {
  padding: 15px 0;
}
.notes-dash .notes-top-head-submenu ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 10px;
}
.notes-dash .notes-top-head-submenu ul li.active {
  border-radius: 10px;
  background: #6F7A7A;
}
.notes-dash .notes-top-head-submenu ul li.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li.active p {
  color: #FFF;
}
.notes-dash .notes-top-head-submenu ul li p {
  font-size: 15px;
  font-weight: 600;
  color: #6F6F6F;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head-submenu ul li p svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li span {
  display: flex;
  width: 18px;
  height: 18px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #e85b28;
  color: #FFF;
}
.notes-dash .content-submenu-tag {
  margin-top: 15px;
  padding: 10px;
}
.notes-dash .content-submenu-tag h6 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
}
.notes-dash .content-submenu-tag ul {
  padding: 10px 0;
}
.notes-dash .content-submenu-tag ul.tags-list {
  margin-bottom: 24px;
}
.notes-dash .content-submenu-tag ul li {
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.personal span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.personal span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.personal a {
  color: #288EC7;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.social span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.social span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.social a {
  color: #FDA700;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.work span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.work span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.work a {
  color: #5CB85C;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.public span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.public span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.public a {
  color: #A02F7A;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.medium span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.medium span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.medium a {
  color: #4A00E5;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.high span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.high span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.high a {
  color: #FC0027;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.low span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.low span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.low a {
  color: #FDA700;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li + li {
  margin-top: 10px;
}

.notes-logo a {
  display: flex;
  align-items: center;
}
.notes-logo a span {
  width: 32px;
  height: 32px;
}
.notes-logo a span img {
  border-radius: 32px;
}

.notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #6F6F6F;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #6F6F6F;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active {
  border-radius: 5px;
  background: #212B36;
  padding: 10px;
  color: #FFF;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox:hover {
  background: #212B36;
  color: #FFF;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox span {
  display: flex;
  width: 20px;
  height: 20px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #e85b28;
  color: #FFF;
}

.notes-trash-btn {
  background: #FC0027;
  color: #FFF;
  border-radius: 8px;
  margin: 4px 0 20px 0;
  padding: 10px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notes-trash-btn span {
  display: flex;
  align-items: center;
}
.notes-trash-btn span svg {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.delete-popup {
  padding: 24px;
  border-radius: 8px;
  background: #FFF;
}
.delete-popup .delete-image {
  margin-bottom: 20px;
}
.delete-popup .delete-heads {
  text-align: center;
}
.delete-popup .delete-heads h4 {
  color: #6F7A7A;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}
.delete-popup .delete-heads p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.delete-popup .delete-footer {
  text-align: center;
}

.edit-page-title {
  display: flex;
  align-items: center;
}
.edit-page-title h4 {
  font-size: 18px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 0;
  margin-right: 10px;
}
.edit-page-title p {
  font-size: 15px;
  font-weight: 400;
  color: #288EC7;
}

.edit-head-view {
  margin-bottom: 20px;
  border-bottom: rgba(145, 158, 171, 0.3);
}
.edit-head-view h6 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
  margin-bottom: 15px;
}
.edit-head-view p {
  font-size: 15px;
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 15px;
}
.edit-head-view p.badged {
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.edit-head-view p.badged i {
  font-size: 7px;
  margin-right: 7px;
}

.edit-footer-menu a {
  background-color: #FC0027;
}

.edit-noted-head a span i.fa-trash-alt {
  color: #FC0027;
  margin-right: 10px;
}
.edit-noted-head a span i.fa-star {
  color: #FDA700;
}

.edit-head-view p.badged.high {
  border-radius: 8px;
  border: 1px solid #FC0027;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FC0027;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.edit-head-view p.badged.high i {
  font-size: 7px;
  margin-right: 7px;
}

.people-profile-pic {
  border: none !important;
  margin-left: 14px;
  position: relative;
}
.people-profile-pic img {
  border-radius: 10px;
}
.people-profile-pic a {
  position: absolute;
  top: 15px;
  right: 7px;
}
.people-profile-pic a .x-square-add {
  border-radius: 3px;
  background: #FC0027;
  color: #FFF;
}

.people-customer-walk {
  max-width: 35px;
}

.custom-pagination .paginations {
  align-items: center;
}
.custom-pagination .paginations span {
  display: flex;
  align-items: center;
  color: #6F6F6F;
  width: 16px;
  height: 16px;
}
.custom-pagination .paginations span .fa-chevron-left {
  margin-right: 8px;
}
.custom-pagination .paginations .page-wrap li a {
  margin-right: 8px;
  border-radius: 85px;
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 30px;
  height: 30px;
  padding: 5px;
  justify-content: center;
  align-items: center;
}
.custom-pagination .paginations .page-wrap li a.active {
  background: #e85b28;
  color: #FFF;
}
.custom-pagination .paginations .page-wrap li :hover {
  background: #e85b28;
  color: #FFF;
  transition: 0.3s all;
}

.section-notes-slider .notes-slider.owl-carousel .owl-nav {
  top: -42px;
  right: auto;
  right: initial;
  left: 170px;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button {
  background-color: transparent;
  width: 15px;
  height: auto;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button i {
  color: #6F7A7A;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover {
  background-color: transparent;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover i {
  color: #e85b28;
}

.form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
.form-sort span.select2-container.select2-container--default.select2-container--open {
  z-index: 99;
}

.accordion-button:after, .accordion-button:not(.collapsed)::after {
  display: none;
}

.todo-accordion .accordion-item {
  background: transparent;
  margin-bottom: 10px;
  border: 0;
  padding: 0;
}

.search-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.search-set .search-input {
  position: relative;
  margin-right: 15px;
}
.search-set .search-input input[type=search] {
  height: 38px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: #FFF;
  background: var(--White, #FFF);
  width: 298px;
  border-radius: 5px;
  padding: 10px;
}
.search-set .search-input input[type=search]::placeholder {
  color: #000;
}
@media (max-width: 1199.98px) {
  .search-set .search-input input[type=search] {
    width: 220px;
  }
}
@media (max-width: 991.98px) {
  .search-set .search-input input[type=search] {
    width: 200px;
  }
}
@media (max-width: 575.98px) {
  .search-set .search-input input[type=search] {
    width: auto;
  }
}
.search-set .search-input .btn-searchset {
  border-radius: 50px;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
}
.search-set .search-input .btn-searchset .feather-search {
  width: 14px;
  height: 14px;
}

.page-add-notes {
  display: flex;
  flex-wrap: wrap;
}

.todo-inbox-check {
  margin-right: 15px;
}
.todo-inbox-check .checkboxs {
  margin-bottom: 0;
  padding-left: 25px;
  display: flex;
  align-items: center;
}
.todo-inbox-check .checkboxs input ~ .checkmarks {
  border-color: rgba(145, 158, 171, 0.3);
  border-radius: 5px;
  margin-top: 2px;
  width: 20px;
  height: 20px;
}
.todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #e85b28;
  background-color: #e85b28;
}

.btn-cancel {
  background: #565E5E;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  transition: all 0.5s ease;
}
.btn-cancel:hover {
  background: #424b52;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-cancel {
    min-width: auto;
  }
}

.swal2-confirm {
  margin-right: 5px;
}

.btn-submit {
  background: #e85b28;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  transition: all 0.2s ease;
}
.btn-submit:hover {
  background: rgb(199.6428571429, 68.7142857143, 21.3571428571);
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-submit {
    min-width: auto;
  }
}

.sections-notes-slider .accordion-button:after {
  display: none;
}

.todo-wrapper-list-content {
  margin-left: 5px;
}

.notes-header h3 {
  color: #6F7A7A;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 0;
}

.todo-inbox-check .checkboxs .checkmarks:after {
  left: 9px;
  top: 10px;
}

.checkboxs input:checked ~ .checkmarks:after {
  display: block;
}

.todo-widget {
  margin-bottom: 25px;
}

.todo-today-content {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.todo-today-content .todo-drop-down span i {
  color: #6F7A7A;
}
.todo-today-content .todo-today-header {
  display: flex;
  align-items: center;
}
.todo-today-content .todo-today-header span {
  margin-right: 5px;
  display: flex;
  align-items: center;
}
.todo-today-content .todo-today-header span svg {
  width: 16px;
  height: 16px;
  color: #6F6F6F;
}
.todo-today-content .todo-today-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
  margin-bottom: 0;
  margin-right: 5px;
}
.todo-today-content .todo-today-header h6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: #e85b28;
  border-radius: 50px;
  color: #FFF;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 0;
}

.todo-wrapper-list {
  padding: 15px;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list {
    flex-direction: column;
  }
}
.todo-wrapper-list .todo-inbox-check {
  display: flex;
  align-items: center;
}
.todo-wrapper-list .todo-inbox-check .todo-wrapper-list-content h4 {
  font-size: 16px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 5px;
}
.todo-wrapper-list .todo-inbox-check .todo-wrapper-list-content p {
  font-size: 13px;
  font-weight: 500;
  color: #6F6F6F;
  margin-bottom: 0;
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list {
  width: 45%;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list .todo-inbox-check.todo-inbox-check-list {
    width: auto;
  }
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list .checkboxs {
  margin-bottom: 12px;
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list .checkboxs input ~ .checkmarks {
  border-radius: 5px;
  margin-top: 0;
}
.todo-wrapper-list .notes-card-body {
  width: 35%;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list .notes-card-body {
    width: auto;
    margin: 20px 0;
  }
}
.todo-wrapper-list .notes-card-body p {
  display: flex;
  align-items: center;
}
.todo-wrapper-list .notes-card-body p.high {
  border-radius: 8px;
  border: 1px solid #FC0027;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 600;
  color: #FC0027;
  margin-right: 10px;
}
.todo-wrapper-list .notes-card-body p.medium {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #423B93;
  font-size: 14px;
  font-family: 600;
  color: #423B93;
}
.todo-wrapper-list .notes-card-body p.pending {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #288EC7;
  font-size: 14px;
  font-family: 600;
  color: #288EC7;
}
.todo-wrapper-list .notes-card-body p.low {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #FDA700;
  font-size: 14px;
  font-family: 600;
  color: #FDA700;
}
.todo-wrapper-list .notes-card-body p.success {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #5CB85C;
  font-size: 14px;
  font-family: 600;
  color: #5CB85C;
}
.todo-wrapper-list .notes-card-body p i.fa-circle {
  font-size: 7px;
  margin-right: 4px;
}
.todo-wrapper-list .todo-strike-content h4 {
  text-decoration-line: line-through;
}
.todo-wrapper-list .todo-strike-content p {
  text-decoration-line: line-through;
}
.todo-wrapper-list .todo-profile {
  width: 20%;
  justify-content: end;
}
.todo-wrapper-list .todo-profile img {
  border-radius: 30px;
  margin-right: 16px;
  width: 30px;
  height: 30px;
}
.todo-wrapper-list .todo-profile a .fa-ellipsis-v {
  color: #6F7A7A;
}

.datanew tbody {
  border-top: 1px solid #E8E8E8;
}

.form-sort {
  position: relative;
  width: 149px;
  height: 40px;
}
.form-sort .info-img {
  position: absolute;
  top: 52%;
  z-index: 100;
  width: 16px;
  height: 16px;
  left: 0;
  margin-left: 10px;
  color: #6F6F6F;
  transform: translateY(-50%);
  line-height: normal;
}
@media (max-width: 575.98px) {
  .form-sort {
    margin-top: 24px;
  }
}

.todo-calendar .input-groupicon.calender-input input {
  padding-left: 10px;
}

.todo-calendar {
  position: relative;
}
.todo-calendar .calender-input {
  position: relative;
}
.todo-calendar .calender-input .info-img {
  position: absolute;
  top: 11px;
  z-index: 100;
  width: 16px;
  height: 16px;
  right: 5px !important;
  color: #6F6F6F;
}

.todo-accordion .accordion-item {
  background: transparent;
  margin-bottom: 20px;
}
.todo-accordion .accordion-item .accordion-header {
  cursor: pointer;
}
.todo-accordion .accordion-item .accordion-header .accordion-button {
  background: transparent;
  padding: 0;
}
.todo-accordion .accordion-item .accordion-header .accordion-button.collapsed .todo-today-content {
  margin-bottom: 0;
}
.todo-accordion .accordion-item .accordion-header .todo-today-content {
  width: 100%;
}
.todo-accordion .accordion-item .accordion-header .todo-drop-down a span i {
  color: #6F6F6F;
}
.todo-accordion .accordion-item .accordion-body {
  padding: 0;
}
.todo-accordion .accordion-item .todo-widget {
  margin-bottom: 0;
}
.todo-accordion .accordion-item .todo-widget .todo-wrapper-list:last-child {
  margin-bottom: 0;
}

caption {
  color: #9595b5;
}

.table-active {
  --bs-table-color-state: var(--default-text-color);
}

.table {
  color: #6F6F6F;
  border-color: #E8E8E8;
  margin-block-end: 0;
}
.table .checkboxs {
  margin-bottom: 15px;
}
.table tbody tr th {
  font-weight: 500;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  line-height: 1.462;
  font-size: 0.813rem;
  white-space: nowrap;
}
.table thead tr th {
  font-weight: 600;
  font-size: 15px;
}
.table.table-sm > :not(caption) > * > * {
  padding: 0.3rem;
}
.table.table-dark {
  color: #F2ECFF;
  border-color: rgba(255, 255, 255, 0.1);
}
.table .thead-primary th {
  background-color: #e85b28;
  color: #FFF;
}
.table .thead-secondary th {
  background-color: #FFA201;
  color: #FFF;
}
.table .thead-info th {
  background-color: #1ECBE2;
  color: #FFF;
}
.table .thead-warning th {
  background-color: #FDA700;
  color: #FFF;
}
.table .thead-danger th {
  background-color: #FC0027;
  color: #FFF;
}
.table .thead-success th {
  background-color: #5CB85C;
  color: #FFF;
}
.table .thead-dark th {
  background-color: #171724;
  color: #FFF;
}
.table .thead-light th {
  background-color: #FAFAFA;
  color: #171724;
}
.table.table-primary {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.2);
}
.table.table-primary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.2);
  color: #000;
}
.table.table-primary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.4);
  color: #FFF;
}
.table.table-primary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--primary-rgb));
  color: #FFF;
}
.table.table-secondary {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.2);
}
.table.table-secondary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.2);
  color: #000;
}
.table.table-secondary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.4);
  color: #FFF;
}
.table.table-secondary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--secondary-rgb));
  color: #FFF;
}
.table.table-warning {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.2);
}
.table.table-warning.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.2);
  color: #000;
}
.table.table-warning.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.4);
  color: #FFF;
}
.table.table-warning .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--warning-rgb));
  color: #FFF;
}
.table.table-success {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.2);
}
.table.table-success.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.2);
  color: #000;
}
.table.table-success.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.4);
  color: #FFF;
}
.table.table-success .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--success-rgb));
  color: #FFF;
}
.table.table-danger {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.2);
}
.table.table-danger.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.2);
  color: #000;
}
.table.table-danger.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.4);
  color: #FFF;
}
.table.table-danger .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--danger-rgb));
  color: #FFF;
}
.table.table-info {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.2);
}
.table.table-info.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.2);
  color: #000;
}
.table.table-info.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.4);
  color: #FFF;
}
.table.table-info .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--info-rgb));
  color: #FFF;
}
.table.table-light {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.2);
}
.table.table-light.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.2);
  color: #000;
}
.table.table-light.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.4);
  color: #FFF;
}
.table.table-light .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--light-rgb));
  color: #FFF;
}
.table.table-dark {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.2);
}
.table.table-dark.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.2);
  color: #000;
}
.table.table-dark.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.4);
  color: #FFF;
}
.table.table-dark .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--dark-rgb));
  color: #FFF;
}
.table.table-bordered.border-primary tbody,
.table.table-bordered.border-primary td,
.table.table-bordered.border-primary tfoot,
.table.table-bordered.border-primary th,
.table.table-bordered.border-primary thead,
.table.table-bordered.border-primary tr {
  border-color: rgba(232, 91, 40, 0.1);
}
.table.table-bordered.border-info tbody,
.table.table-bordered.border-info td,
.table.table-bordered.border-info tfoot,
.table.table-bordered.border-info th,
.table.table-bordered.border-info thead,
.table.table-bordered.border-info tr {
  border-color: rgba(30, 203, 226, 0.1);
}
.table.table-bordered.border-secondary tbody,
.table.table-bordered.border-secondary td,
.table.table-bordered.border-secondary tfoot,
.table.table-bordered.border-secondary th,
.table.table-bordered.border-secondary thead,
.table.table-bordered.border-secondary tr {
  border-color: rgba(255, 162, 1, 0.1);
}
.table.table-bordered.border-warning tbody,
.table.table-bordered.border-warning td,
.table.table-bordered.border-warning tfoot,
.table.table-bordered.border-warning th,
.table.table-bordered.border-warning thead,
.table.table-bordered.border-warning tr {
  border-color: rgba(253, 167, 0, 0.1);
}
.table.table-bordered.border-success tbody,
.table.table-bordered.border-success td,
.table.table-bordered.border-success tfoot,
.table.table-bordered.border-success th,
.table.table-bordered.border-success thead,
.table.table-bordered.border-success tr {
  border-color: rgba(92, 184, 92, 0.1);
}
.table.table-bordered.border-danger tbody,
.table.table-bordered.border-danger td,
.table.table-bordered.border-danger tfoot,
.table.table-bordered.border-danger th,
.table.table-bordered.border-danger thead,
.table.table-bordered.border-danger tr {
  border-color: rgba(252, 0, 39, 0.1);
}
.table.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);
  color: #6F6F6F;
}
.table.table-striped-columns > :not(caption) > tr > :nth-child(2n) {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);
  color: #6F6F6F;
}
.table tbody.table-group-divider {
  border-top: 1px solid #E8E8E8;
}
.table.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: #f7f8f9;
  color: #6F6F6F;
}
.table .table-active {
  --bs-table-accent-bg: #FDFDFE;
  color: #6F6F6F;
}
.table thead.table-primary {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-secondary {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-warning {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-success {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-danger {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-info {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-light {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-dark {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--primary-rgb), 0.1);
  background-color: #FFF;
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--secondary-rgb), 0.1);
  background-color: #FFF;
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--warning-rgb), 0.1);
  background-color: #FFF;
}

.table-success {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--success-rgb), 0.1);
  background-color: #FFF;
}

.table-info {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--info-rgb), 0.1);
  background-color: #FFF;
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--danger-rgb), 0.1);
  background-color: #FFF;
}

.table-dark {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--dark-rgb), 0.1);
  background-color: #FFF;
}

.table-light {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--light-rgb), 0.1);
  background-color: #FFF;
}

[data-theme-mode=dark] .table-dark {
  border-color: rgba(0, 0, 0, 0.025);
}

[dir=rtl] .table {
  margin-inline-end: 1px;
}

.table {
  margin: 0;
}
.table tbody tr td {
  color: #424848;
  font-size: 14px;
}
.table tbody tr td .product-img img {
  border: 0;
}
.table tbody tr td .userslist-img {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.table tbody tr td .userslist-img img {
  border-radius: 0;
}
.table tbody tr td .userslist-img.bg-img img {
  border: 1px solid #E8EBED;
  border: 1px solid var(--stroke-table, #E8EBED);
}
.table tbody tr td a {
  color: #FFA201;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.table tbody tr td a.product-img {
  margin-right: 5px;
  flex-shrink: 0;
}
.table tbody tr td a .info-img {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.table tbody tr td a:hover {
  color: #e85b28;
}
.table tbody tr td .emp-name {
  line-height: 1;
}
.table tbody tr td .emp-name a {
  color: #FFA201;
}
.table tbody tr td .emp-name p {
  line-height: 2;
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
}
.table tbody tr td .emp-name .role {
  line-height: inherit;
}
.table tbody tr td .product-imgs {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 40px;
  height: 40px;
  background: #FFEBD8;
  font-size: 14px;
  color: #FF9F43 !important;
  font-weight: 500;
  margin-right: 10px;
}
.table tbody tr .data-header {
  font-weight: 600;
  color: #FFA201;
  font-size: 15px;
  border-bottom: none;
}
.table tbody tr .ref-number {
  color: #4A00E5;
}
.table tbody tr.active {
  border-bottom: 0;
}
.table tbody tr.active td {
  font-size: 18px;
  color: #424848;
  font-weight: 600;
  border-bottom: 0;
}
.table tbody .loss-highlight td {
  font-weight: 700;
  color: #FFA201;
  font-size: 14px;
  border-top: 1px solid #898989;
}
.table tbody .userimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.table tbody .userimgname img {
  margin-right: 8px;
  border-radius: 6px;
}
.table tbody .purchase-count td {
  padding-bottom: 20px;
}
.table .Expense-list tr td {
  padding: 15px 17px;
}
.table .Expense-list tr td a {
  margin-bottom: 0;
}
.table .sales-list tr td {
  padding: 20px 17px;
}
.table .Expense-list-blk tr td {
  padding: 20px 17px;
}

.new tbody tr td {
  border-bottom: none;
}

.table-height {
  min-height: 300px;
}
@media (max-width: 991.98px) {
  .table-height {
    min-height: auto;
    margin-bottom: 15px;
  }
}

.max-widthauto {
  max-width: 100% !important;
}

.dataTables_filter + .dataTables_filter {
  display: none;
}

.dataview .dataTables_length,
.dataview .dataTables_info,
.dataview .dataTables_paginate {
  display: none !important;
}

.dataTables_length {
  font-size: 12px;
}

.productimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.productimgname a {
  color: #FFA201;
  font-weight: 500;
}
.productimgname .view-product {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  background: #F8F8F8;
}

.input-blocks .calc-no {
  width: 50px !important;
  text-align: center;
}

.table .input-blocks input[type=text] {
  height: 40px;
}
.table .scanner-set {
  width: 40px;
  height: 40px;
}

.card.table-list-card .card-body {
  padding: 0;
}
.card.table-list-card .table-top {
  padding: 24px 24px 0;
}
.card.table-list-card .table-responsive {
  padding: 24px;
}
.card.table-list-card .table-responsive .dataTables_wrapper {
  border: 0;
  padding: 0;
}
.card.table-list-card .tabs-set .nav-tabs {
  padding: 24px 24px 0;
  margin-bottom: 0;
}

.table.profit-table thead {
  background-color: #FAFBFE;
  border-radius: 8px 8px 0px 0px;
}
.table.profit-table thead tr:hover {
  background-color: #FAFBFE;
}
.table.profit-table tbody td {
  border-bottom: 0;
}
.table.profit-table tbody .profit-table-bg td {
  color: #FFA201;
  font-weight: 700;
  border-top: 1px solid #C0C0C0;
  background-color: #FAFBFE;
}
.table.profit-table tbody .table-heading:hover {
  background-color: #FFF;
}
.table.profit-table tbody .table-heading td {
  color: #FFA201;
  font-weight: 700;
}

.profit-table-top .daterange-wraper {
  margin: 0 10px;
}
.profit-table-top .daterange-wraper input {
  padding-left: 35px;
}

table td .shield {
  width: 14px;
  height: 14px;
}

.paysilp-table-border {
  border: 1px solid #C0C0C0;
}
.paysilp-table-border th {
  border-right: 1px solid #C0C0C0;
  border-left: 1px solid #C0C0C0;
  padding: 15px;
  font-weight: 700;
  font-size: 16px;
}

.paysilp-table-borders td {
  border-right: 1px solid #C0C0C0;
  border-left: 1px solid #C0C0C0;
  padding: 5px 15px;
  color: #6F6F6F;
}

.payslip-border-bottom {
  border: 1px solid #C0C0C0;
}
.payslip-border-bottom th {
  padding: 5px 15px;
  font-weight: 700;
  font-size: 16px;
}
.payslip-border-bottom td {
  color: #6F6F6F;
}

.emp-details {
  margin: 20px 0;
}
.emp-details .pay-slip-salery h6 {
  font-weight: 700 !important;
  margin-bottom: 10px;
  font-size: 18px !important;
}
.emp-details .emp-name-id.pay-slip-salery {
  margin-right: 30px;
}

@media (max-width: 575.98px) {
  .slip-logo {
    flex-shrink: 0;
    margin-right: 15px;
  }
}

.product-name-slip h4 {
  color: #e85b28;
  font-weight: 700;
  font-size: 18px;
}

.pay-slip-box .modal-header {
  border-radius: 8px 8px 0 0;
}
.pay-slip-box .custom-modal-body {
  padding: 0;
}
.pay-slip-box .card {
  border: 0;
  border-radius: 0 0 10px 10px;
}
.pay-slip-box .card .card-body {
  padding: 20px;
}
.pay-slip-box .card .card-body .emp-details.justify-content-start {
  max-width: 760px;
  margin: 20px auto 20px;
}

.table {
  margin: 0;
}
.table tbody tr td {
  color: #424848;
  font-size: 14px;
}
.table tbody tr td .product-img img {
  border: 0;
}
.table tbody tr td .userslist-img {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.table tbody tr td .userslist-img img {
  border-radius: 0;
}
.table tbody tr td .userslist-img.bg-img img {
  border: 1px solid #E8EBED;
  border: 1px solid var(--stroke-table, #E8EBED);
}
.table tbody tr td a {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.table tbody tr td a.product-img {
  margin-right: 5px;
  flex-shrink: 0;
}
.table tbody tr td a .info-img {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.table tbody tr td a:hover {
  color: #e85b28;
}
.table tbody tr td a:hover i {
  color: #e85b28;
}
.table tbody tr td .emp-name {
  line-height: 1;
}
.table tbody tr td .emp-name a {
  color: #FFA201;
}
.table tbody tr td .emp-name p {
  line-height: 2;
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
}
.table tbody tr td .emp-name .role {
  line-height: inherit;
}
.table tbody tr td .product-imgs {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 40px;
  height: 40px;
  background: #FFEBD8;
  font-size: 14px;
  color: #FF9F43 !important;
  font-weight: 500;
  margin-right: 10px;
}
.table tbody tr .data-header {
  font-weight: 600;
  color: #FFA201;
  font-size: 15px;
  border-bottom: none;
}
.table tbody tr .ref-number {
  color: #4A00E5;
}
.table tbody tr.active {
  border-bottom: 0;
}
.table tbody tr.active td {
  font-size: 18px;
  color: #424848;
  font-weight: 600;
  border-bottom: 0;
}
.table tbody .loss-highlight td {
  font-weight: 700;
  color: #FFA201;
  font-size: 14px;
  border-top: 1px solid #898989;
}
.table tbody .userimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.table tbody .userimgname img {
  margin-right: 8px;
  border-radius: 6px;
}
.table tbody .purchase-count td {
  padding-bottom: 20px;
}
.table .Expense-list tr td {
  padding: 15px 17px;
}
.table .Expense-list tr td a {
  margin-bottom: 0;
}
.table .sales-list tr td {
  padding: 20px 17px;
}
.table .Expense-list-blk tr td {
  padding: 20px 17px;
}
.table .userimgname .product-img {
  display: inherit;
  width: 35px;
  height: 35px;
  margin-right: 8px;
}

table tbody td.action-table-data {
  display: flex;
}
table tbody td.action-table-data a {
  border: 1px solid rgba(145, 158, 171, 0.3);
  background-color: #FFF;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 8px;
}
table tbody td.action-table-data a .feather-edit {
  color: #339DFF;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-edit {
  color: #6F6F6F;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-trash-2 {
  color: #FC0027;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-eye {
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-download {
  color: #339DFF;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-eye {
  color: #FFA201;
  width: 14px;
  height: 14px;
}
table tbody .productimgname {
  min-width: 200px;
}
table tbody .productimgname a.stock-img.product-img {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
}
table tbody .productimgname a.stock-img.product-img img {
  width: 50px;
  height: 50px;
  max-width: 100%;
  margin-right: 0;
}
table .edit-delete-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 50px;
}
table .edit-delete-action a {
  padding: 0;
}
table .edit-delete-action.data-view {
  min-height: 52px;
}
table .edit-delete-action.data-row {
  height: auto;
}
table .edit-delete-action.data {
  height: 44px;
}

.custom-table table td ul.social-links li a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  color: #6F6F6F;
}
.custom-table table td ul.social-links li a:hover {
  background: #E8E8E8;
  color: #6F6F6F;
}

.accordion-button {
  background-color: #FFF;
  color: #6F6F6F;
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
}
.accordion-button.accordion-custom-button:after {
  content: "\\f054";
}
.accordion-button.accordion-custom-button:not(.collapsed) {
  color: #6F6F6F;
  background-color: #f7f8f9;
  box-shadow: none;
}
.accordion-button.accordion-custom-button:not(.collapsed):after {
  content: "\\f078";
  display: block;
  transform: none;
}
.accordion-button:not(.collapsed) {
  color: #6F6F6F;
  background-color: #f7f8f9;
  box-shadow: none;
}
.accordion-button:focus {
  border-color: rgba(232, 91, 40, 0.3);
  box-shadow: none;
}
.accordion-button:after, .accordion-button:not(.collapsed)::after {
  background-image: none;
}
.accordion-button:after {
  content: "\\f078";
  font-family: "Fontawesome";
  font-size: 12px;
  line-height: 1;
  background-color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3.125rem;
  color: #6F6F6F;
}

.accordion-body {
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  color: #9595b5;
}

.accordion-item {
  color: #6F6F6F;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}

.accordions-items-seperate .accordion-item:not(:first-of-type) {
  margin-block-start: 0.5rem;
}
.accordions-items-seperate .accordion-item {
  border-block-start: 1px solid #E8E8E8;
  border-radius: 4px;
  overflow: hidden;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: 0.35rem;
  border-bottom-left-radius: 0.35rem;
}

.accordion-item:first-of-type {
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}

.accordion.accordion-primary .accordion-button {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}
.accordion.accordion-primary .accordion-button:after {
  background-color: #e85b28;
  color: #FFF;
}
.accordion.accordion-primary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-secondary .accordion-button {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.accordion.accordion-secondary .accordion-button:after {
  background-color: #FFA201;
  color: #FFF;
}
.accordion.accordion-secondary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-success .accordion-button {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.accordion.accordion-success .accordion-button:after {
  background-color: #5CB85C;
  color: #FFF;
}
.accordion.accordion-success .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-danger .accordion-button {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.accordion.accordion-danger .accordion-button:after {
  background-color: #FC0027;
  color: #FFF;
}
.accordion.accordion-danger .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-warning .accordion-button {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.accordion.accordion-warning .accordion-button:after {
  background-color: #FDA700;
  color: #FFF;
}
.accordion.accordion-warning .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-info .accordion-button {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.accordion.accordion-info .accordion-button:after {
  background-color: #1ECBE2;
  color: #FFF;
}
.accordion.accordion-info .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}

.accordion.accordion-solid-primary .accordion-button {
  background-color: #e85b28;
  color: #FFF;
}
.accordion.accordion-solid-primary .accordion-button:after {
  background-color: #FFF;
  color: #e85b28;
}
.accordion.accordion-solid-primary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-secondary .accordion-button {
  background-color: #FFA201;
  color: #FFF;
}
.accordion.accordion-solid-secondary .accordion-button:after {
  background-color: #FFF;
  color: #FFA201;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-success .accordion-button {
  background-color: #5CB85C;
  color: #FFF;
}
.accordion.accordion-solid-success .accordion-button:after {
  background-color: #FFF;
  color: #5CB85C;
}
.accordion.accordion-solid-success .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-danger .accordion-button {
  background-color: #FC0027;
  color: #FFF;
}
.accordion.accordion-solid-danger .accordion-button:after {
  background-color: #FFF;
  color: #FC0027;
}
.accordion.accordion-solid-danger .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-warning .accordion-button {
  background-color: #FDA700;
  color: #FFF;
}
.accordion.accordion-solid-warning .accordion-button:after {
  background-color: #FFF;
  color: #FDA700;
}
.accordion.accordion-solid-warning .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-info .accordion-button {
  background-color: #1ECBE2;
  color: #FFF;
}
.accordion.accordion-solid-info .accordion-button:after {
  background-color: #FFF;
  color: #1ECBE2;
}
.accordion.accordion-solid-info .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}

.accordion.accordion-border-primary .accordion-item {
  border: 1px solid #e85b28;
}
.accordion.accordion-border-primary .accordion-button {
  background-color: #FFF;
  color: #e85b28;
  border-block-end: 0px;
}
.accordion.accordion-border-primary .accordion-button:after {
  background-color: #FFF;
  color: #e85b28;
  border: 1px solid #e85b28;
}
.accordion.accordion-border-primary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #e85b28;
}
.accordion.accordion-border-secondary .accordion-item {
  border: 1px solid #FFA201;
}
.accordion.accordion-border-secondary .accordion-button {
  background-color: #FFF;
  color: #FFA201;
  border-block-end: 0px;
}
.accordion.accordion-border-secondary .accordion-button:after {
  background-color: #FFF;
  color: #FFA201;
  border: 1px solid #FFA201;
}
.accordion.accordion-border-secondary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FFA201;
}
.accordion.accordion-border-success .accordion-item {
  border: 1px solid #5CB85C;
}
.accordion.accordion-border-success .accordion-button {
  background-color: #FFF;
  color: #5CB85C;
  border-block-end: 0px;
}
.accordion.accordion-border-success .accordion-button:after {
  background-color: #FFF;
  color: #5CB85C;
  border: 1px solid #5CB85C;
}
.accordion.accordion-border-success .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #5CB85C;
}
.accordion.accordion-border-danger .accordion-item {
  border: 1px solid #FC0027;
}
.accordion.accordion-border-danger .accordion-button {
  background-color: #FFF;
  color: #FC0027;
  border-block-end: 0px;
}
.accordion.accordion-border-danger .accordion-button:after {
  background-color: #FFF;
  color: #FC0027;
  border: 1px solid #FC0027;
}
.accordion.accordion-border-danger .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FC0027;
}
.accordion.accordion-border-warning .accordion-item {
  border: 1px solid #FDA700;
}
.accordion.accordion-border-warning .accordion-button {
  background-color: #FFF;
  color: #FDA700;
  border-block-end: 0px;
}
.accordion.accordion-border-warning .accordion-button:after {
  background-color: #FFF;
  color: #FDA700;
  border: 1px solid #FDA700;
}
.accordion.accordion-border-warning .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FDA700;
}
.accordion.accordion-border-info .accordion-item {
  border: 1px solid #1ECBE2;
}
.accordion.accordion-border-info .accordion-button {
  background-color: #FFF;
  color: #1ECBE2;
  border-block-end: 0px;
}
.accordion.accordion-border-info .accordion-button:after {
  background-color: #FFF;
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
}
.accordion.accordion-border-info .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #1ECBE2;
}

.accordion.accordionicon-none .accordion-button:after {
  display: none;
}

.accordion.accordionicon-left .accordion-button {
  padding-inline-start: 2.5rem;
}
.accordion.accordionicon-left .accordion-button:after {
  position: absolute;
  inset-inline-start: 0.625rem;
}

.accordion.accordion-customicon1 .accordion-button:after {
  content: "+";
  font-family: "Fontawesome";
  background-color: #f7f8f9;
}
.accordion.accordion-customicon1 .accordion-button:not(.collapsed)::after {
  content: "\\f068";
  font-family: "Fontawesome";
  background-color: #FFF;
}

.customized-accordion .accordion-item.custom-accordion-primary .accordion-button {
  background-color: rgba(232, 91, 40, 0.1);
  border-inline-start: 0.25rem solid rgba(232, 91, 40, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-button:after {
  background-color: rgba(232, 91, 40, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-body {
  background-color: rgba(232, 91, 40, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(232, 91, 40, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button {
  background-color: rgba(255, 162, 1, 0.1);
  border-inline-start: 0.25rem solid rgba(255, 162, 1, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button:after {
  background-color: rgba(255, 162, 1, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-body {
  background-color: rgba(255, 162, 1, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(255, 162, 1, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button {
  background-color: rgba(253, 167, 0, 0.1);
  border-inline-start: 0.25rem solid rgba(253, 167, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button:after {
  background-color: rgba(253, 167, 0, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-body {
  background-color: rgba(253, 167, 0, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(253, 167, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button {
  background-color: rgba(30, 203, 226, 0.1);
  border-inline-start: 0.25rem solid rgba(30, 203, 226, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button:after {
  background-color: rgba(30, 203, 226, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-body {
  background-color: rgba(30, 203, 226, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(30, 203, 226, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button {
  background-color: rgba(92, 184, 92, 0.1);
  border-inline-start: 0.25rem solid rgba(92, 184, 92, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button:after {
  background-color: rgba(92, 184, 92, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-body {
  background-color: rgba(92, 184, 92, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(92, 184, 92, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button {
  background-color: rgba(252, 0, 39, 0.1);
  border-inline-start: 0.25rem solid rgba(252, 0, 39, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button:after {
  background-color: rgba(252, 0, 39, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-body {
  background-color: rgba(252, 0, 39, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(252, 0, 39, 0.6);
}

.page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: "\\ea65";
  content: var(--bs-breadcrumb-divider, "\\ea65");
  font-family: "tabler-icons" !important;
}

[dir=rtl] .page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: "\\ea64";
  content: var(--bs-breadcrumb-divider, "\\ea64");
  font-family: "tabler-icons" !important;
}

.breadcrumb .breadcrumb-item a {
  color: #9595b5;
}
.breadcrumb .breadcrumb-item.active {
  color: #e85b28;
}

.breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  opacity: 0.4;
}

.breadcrumb-arrow .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f101";
  font-family: "Fontawesome" !important;
}

.breadcrumb-pipe .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f061";
  font-family: "Fontawesome" !important;
}

.breadcrumb-line .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "-";
}

.breadcrumb-dot .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "•";
}

.breadcrumb-divide .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f054";
  font-family: "Fontawesome" !important;
}

.breadcrumb-separatorless .breadcrumb-item + .breadcrumb-item::before {
  content: "";
  display: none;
}

.breadcrumb-colored {
  padding: 12px 15px;
  border-radius: 4px;
}
.breadcrumb-colored li a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item.active {
  color: #FFF;
  opacity: 0.8;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item::before {
  color: #FFF;
}

.embedded-breadcrumb:before {
  opacity: 0.7;
}

[data-theme-mode=dark] .embedded-breadcrumb:before {
  filter: invert(1);
}

.card {
  margin-bottom: 24px;
  background-color: #FFF;
  transition: all 0.5s ease-in-out;
  position: relative;
  border-radius: 5px;
  border: 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  color: inherit;
}
.card .card-body {
  padding: 1rem;
}
.card .card-title {
  font-size: 18px;
  font-weight: 700;
  text-transform: capitalize;
}
.card .card-header {
  border-color: #E8E8E8;
  position: relative;
  background: transparent;
  padding: 1rem;
}
.card .card-header .card-title {
  margin-bottom: 0rem;
}
.card .card-header .subtitle {
  padding-top: 0.3125rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.card .card-footer {
  border-color: #E8E8E8;
  background: transparent;
  padding: 1rem 1.25rem 1rem;
}

.card-group .card {
  margin-bottom: 1.5rem;
}

.card.custom-card {
  border-radius: 4px;
  border: 0;
  background-color: #FFF;
  position: relative;
  margin-block-end: 1.5rem;
  width: 100%;
}
.card.custom-card .card-header {
  padding: 1rem 1.25rem;
  background-color: transparent !important;
  border-block-end: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.card.custom-card .card-header:first-child {
  border-radius: 0.625rem 0.625rem 0 0;
}
.card.custom-card .card-header .card-title {
  position: relative;
  margin-block-end: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  text-transform: capitalize;
}
.card.custom-card .card-header .card-title .subtitle {
  margin-block-end: 0;
  text-transform: none;
  text-transform: initial;
}
.card.custom-card .card-footer {
  background-color: transparent !important;
  border-block-start: 1px solid #E8E8E8;
  padding: 1rem 1.5rem;
  font-size: 14px;
}
.card.custom-card .card-body {
  padding: 1.5rem;
  color: #6F6F6F;
}
.card.custom-card .card-link {
  font-size: 0.75rem;
}
.card .card-text {
  font-size: 0.813rem;
}
.card .footer-card-icon {
  width: 60px;
  height: 60px;
}
.card.overlay-card {
  position: relative;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.9);
}
.card.overlay-card .card-header {
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .card-footer {
  border-block-start: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .over-content-bottom {
  top: auto;
}
.card.overlay-card:before {
  content: "";
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
}
.card.card-bg-primary {
  background-color: #e85b28;
  color: #FFF;
}
.card.card-bg-primary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-primary .card-header:before {
  background-color: #FFF;
}
.card.card-bg-primary .card-body {
  color: #FFF;
}
.card.card-bg-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary {
  background-color: #FFA201;
  color: #FFF;
}
.card.card-bg-secondary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary .card-header:before {
  background-color: #FFF;
}
.card.card-bg-secondary .card-body {
  color: #FFF;
}
.card.card-bg-secondary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning {
  background-color: #FDA700;
  color: #FFF;
}
.card.card-bg-warning .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning .card-header:before {
  background-color: #FFF;
}
.card.card-bg-warning .card-body {
  color: #FFF;
}
.card.card-bg-warning .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info {
  background-color: #1ECBE2;
  color: #FFF;
}
.card.card-bg-info .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info .card-header:before {
  background-color: #FFF;
}
.card.card-bg-info .card-body {
  color: #FFF;
}
.card.card-bg-info .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success {
  background-color: #5CB85C;
  color: #FFF;
}
.card.card-bg-success .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success .card-header:before {
  background-color: #FFF;
}
.card.card-bg-success .card-body {
  color: #FFF;
}
.card.card-bg-success .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger {
  background-color: #FC0027;
  color: #FFF;
}
.card.card-bg-danger .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger .card-header:before {
  background-color: #FFF;
}
.card.card-bg-danger .card-body {
  color: #FFF;
}
.card.card-bg-danger .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
}
.card.card-bg-light .card-header {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #6F6F6F;
  border-block-end: #E8E8E8;
}
.card.card-bg-light .card-body {
  color: #6F6F6F;
}
.card.card-bg-light .card-footer {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #6F6F6F;
  border-block-start: #E8E8E8;
}
.card.card-bg-dark {
  background-color: #171724;
  color: #FFF;
}
.card.card-bg-dark .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-dark .card-header:before {
  background-color: #FFF;
}
.card.card-bg-dark .card-body {
  color: #FFF;
}
.card.card-bg-dark .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card .card-anchor {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
}
.card .collapse-close {
  display: none;
}
.card.card .collapsed .collapse-close {
  display: block;
}
.card.card .collapsed .collapse-open {
  display: none;
}
.card.card-fullscreen {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  inset-inline-start: 0;
  bottom: 0;
  z-index: 9999;
  margin: 0;
}

.cals-icon {
  font-size: 50px;
  color: #6F7A7A;
}

.callout {
  padding: 1.25rem;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  background-color: #FDFDFE;
  border-inline-start: 0.25rem solid #E8E8E8;
}

.callout-info {
  background-color: rgba(30, 203, 226, 0.075);
  border-color: rgba(30, 203, 226, 0.5);
}

.callout-warning {
  background-color: rgba(253, 167, 0, 0.075);
  border-color: rgba(253, 167, 0, 0.5);
}

.callout-danger {
  background-color: rgba(252, 0, 39, 0.075);
  border-color: rgba(252, 0, 39, 0.5);
}

.btn-facebook {
  background-color: #3B5998;
  color: #FFF;
  border: 1px solid #3B5998;
}
.btn-facebook:hover, .btn-facebook:focus, .btn-facebook:active {
  background-color: #3B5998 !important;
  color: #FFF !important;
  border: 1px solid #3B5998 !important;
}

.btn-instagram {
  background: #f09433;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#f09433", endColorstr="#bc1888",GradientType=1 );
  color: #FFF;
  border: 1px solid transparent;
}
.btn-instagram:hover, .btn-instagram:focus, .btn-instagram:active {
  color: #FFF;
  border: 1px solid transparent;
}

.btn-twitter {
  background-color: #00ACEE;
  color: #FFF;
  border: 1px solid #00ACEE;
}
.btn-twitter:hover, .btn-twitter:focus, .btn-twitter:active {
  background-color: #00ACEE !important;
  color: #FFF !important;
  border: 1px solid #00ACEE !important;
}

.btn-icon {
  width: 2.313rem;
  height: 2.313rem;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.btn-wave {
  display: inline-block !important;
}

@media (max-width: 575px) {
  .overlay-card .card-text {
    font-size: 0.613rem !important;
  }
}
@media (max-width: 400px) {
  .overlay-card .card-text {
    font-size: 0.413rem !important;
  }
}
.tooltip.tooltip-primary .tooltip-inner {
  background-color: #e85b28;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #e85b28;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #e85b28;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #e85b28;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #e85b28;
}
.tooltip.tooltip-secondary .tooltip-inner {
  background-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FFA201;
}
.tooltip.tooltip-warning .tooltip-inner {
  background-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FDA700;
}
.tooltip.tooltip-info .tooltip-inner {
  background-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #1ECBE2;
}
.tooltip.tooltip-success .tooltip-inner {
  background-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #5CB85C;
}
.tooltip.tooltip-danger .tooltip-inner {
  background-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FC0027;
}
.tooltip.tooltip-dark .tooltip-inner {
  background-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #171724;
}
.tooltip.tooltip-dark .tooltip-inner {
  color: #FFF;
}
.tooltip.tooltip-light .tooltip-inner {
  background-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FDFDFE;
}
.tooltip.tooltip-light .tooltip-inner {
  color: #6F6F6F;
}

.nav-item {
  margin-inline-end: 0.5rem;
}
.nav-item:last-child {
  margin-inline-end: 0;
}

.nav-link {
  color: #6F6F6F;
  border-radius: 4px;
  font-weight: 600;
}
.nav-link.active {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}

.navbar-brand {
  color: #6F6F6F;
}
.navbar-brand:focus, .navbar-brand:hover {
  color: #6F6F6F;
  opacity: 0.9;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  color: #e85b28;
}

.nav-link.disabled {
  color: #6F6F6F;
  opacity: 0.3;
}

.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: rgba(23, 23, 36, 0.5);
}

.navbar-text {
  color: #6F6F6F;
}

.navbar-dark.bg-dark .nav-link,
.navbar-dark.bg-dark .navbar-brand {
  color: #FFF;
}
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .show > .nav-link {
  color: #FFF;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #FFF;
  background-color: #e85b28;
}

.nav.nav-style-1 {
  border: 0;
}
.nav.nav-style-1 .nav-item {
  margin-inline-end: 0.25rem;
}
.nav.nav-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.nav-style-1 .nav-link.active {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}
.nav.nav-style-1 .nav-link.active:hover {
  background: rgba(232, 91, 40, 0.1);
}
.nav.nav-style-1 .nav-link:hover {
  background: transparent;
  color: #e85b28;
}

.nav.nav-style-2 .nav-item .nav-link {
  border-block-start: 3px solid transparent;
}
.nav.nav-style-2 .nav-item .nav-link.active {
  background-color: rgba(232, 91, 40, 0.1);
  border-block-start: 3px solid #e85b28;
  color: #e85b28;
}

.nav.nav-style-3 .nav-link {
  border-radius: 0;
}
.nav.nav-style-3 .nav-link {
  border-block-end: 3px solid transparent;
}
.nav.nav-style-3 .nav-link.active {
  background-color: transparent;
  border-block-end: 3px solid #e85b28;
  color: #e85b28;
}

.nav.nav-style-4 {
  border: 0;
}
.nav.nav-style-4 .nav-link {
  color: #9595b5;
  border: 0;
}
.nav.nav-style-4 .nav-link {
  margin-bottom: 3px;
}
.nav.nav-style-4 .nav-link.active {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border: 0;
}
.nav.nav-style-4 .nav-link:hover, .nav.nav-style-4 .nav-link:focus {
  border: 0;
}
.nav.nav-style-4 .nav-link:hover {
  background-color: #FDFDFE;
  color: #6F6F6F;
}

.nav-tabs.nav-style-5 {
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link {
  color: #9595b5;
  border: 0;
  margin-bottom: 3px;
}
.nav-tabs.nav-style-5 .nav-link.active {
  background-color: #e85b28;
  color: #FFF;
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link:hover, .nav-tabs.nav-style-5 .nav-link:focus {
  border: 0;
  background-color: #e85b28;
  color: #FFF;
}

.nav-style-6 {
  border: 0;
}
.nav-style-6.nav-pills .nav-link.active {
  border: 1px solid #e85b28;
  border-block-end: 2px solid #e85b28;
  background-color: transparent;
  color: #e85b28;
}

.nav-tabs-header {
  border: 0 !important;
}
.nav-tabs-header .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-header .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-header .nav-item .nav-link {
  border: 1px solid transparent;
  font-size: 0.8rem;
  padding: 0.4rem 0.5rem;
  font-weight: 500;
}
.nav-tabs-header .nav-item .nav-link.active {
  background: rgba(232, 91, 40, 0.1);
  color: #e85b28;
  border: 1px solid transparent;
}
.nav-tabs-header .nav-item .nav-link:hover, .nav-tabs-header .nav-item .nav-link:focus {
  border: 1px solid transparent;
  background-color: transparent;
  color: #e85b28;
}

.nav-tabs-footer {
  border: 0;
}
.nav-tabs-footer .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-footer .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-footer .nav-item .nav-link {
  background-color: transparent;
  color: #e85b28;
  border: 1px solid #e85b28;
  font-size: 0.8rem;
}
.nav-tabs-footer .nav-item .nav-link.active {
  background: #e85b28;
  color: #FFF;
  border: 1px solid #e85b28;
}
.nav-tabs-footer .nav-item .nav-link:hover, .nav-tabs-footer .nav-item .nav-link:focus {
  border: 1px solid #e85b28;
  background-color: transparent;
  color: #e85b28;
}

.vertical-tabs-2 {
  border: 0;
}
.vertical-tabs-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.vertical-tabs-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-2 .nav-item .nav-link {
  min-width: 7.5rem;
  max-width: 7.5rem;
  text-align: center;
  border: 1px solid #E8E8E8;
  margin-bottom: 0.5rem;
  color: #9595b5;
  background-color: #FDFDFE;
}
.vertical-tabs-2 .nav-item .nav-link i {
  font-size: 1rem;
}
.vertical-tabs-2 .nav-item .nav-link.active {
  background-color: #e85b28;
  color: #FFF;
  position: relative;
}
.vertical-tabs-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-end: -0.5rem;
  inset-block-start: 38%;
  transform: rotate(45deg);
  width: 1rem;
  height: 1rem;
  background-color: #e85b28;
}
.vertical-tabs-2 .nav-item .nav-link.active:hover {
  color: #FFF;
}
.vertical-tabs-2 .nav-item .nav-link:hover {
  color: #e85b28;
}

.vertical-tabs-3 {
  border: 0;
}
.vertical-tabs-3 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.vertical-tabs-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-3 .nav-item .nav-link {
  min-width: 160px;
  max-width: 160px;
  border: 1px solid #e85b28;
  padding: 1.3rem;
  margin-block-end: 0.5rem;
}
.vertical-tabs-3 .nav-item .nav-link i {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 1rem;
  background: #e85b28;
  color: #FFF;
  border-radius: 3.125rem;
  font-weight: 500;
}
.vertical-tabs-3 .nav-item .nav-link.active {
  background: #e85b28;
  border: 1px solid #e85b28;
  color: #FFF;
}
.vertical-tabs-3 .nav-item .nav-link.active:hover {
  background: #e85b28;
  border: 1px solid #e85b28;
  color: #FFF;
}
.vertical-tabs-3 .nav-item .nav-link.active i {
  background: #FFF;
  color: #e85b28;
}
.vertical-tabs-3 .nav-item .nav-link:hover, .vertical-tabs-3 .nav-item .nav-link:focus {
  border: 1px solid #e85b28;
  color: #e85b28;
  background: transparent;
}

.nav.tab-style-1 {
  border-block-end: 0;
  padding: 0.65rem;
  background-color: #FDFDFE;
  border-radius: 7px;
  margin-block-end: 1rem;
}
.nav.tab-style-1 .nav-item {
  margin-inline-end: 0.5rem;
}
.nav.tab-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.tab-style-1 .nav-link {
  border-radius: 7px;
  padding: 0.35rem 1rem;
}
.nav.tab-style-1 .nav-link.active {
  background-color: #e85b28 !important;
  color: #FFF !important;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  transition: color 0.15s ease-in;
}

.nav-tabs.tab-style-1 .nav-link:hover {
  background: transparent;
  color: #e85b28;
}

.tab-style-2 {
  border-block-end: 0;
}
.tab-style-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-2 .nav-item .nav-link {
  border: 0;
}
.tab-style-2 .nav-item .nav-link i {
  width: 1.875rem;
  height: 1.875rem;
  padding: 0.4rem;
  border-radius: 50px;
  background-color: #FDFDFE;
  color: #6F6F6F;
  display: inline-block;
}
.tab-style-2 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #e85b28;
}
.tab-style-2 .nav-item .nav-link:hover i {
  color: #e85b28;
}
.tab-style-2 .nav-item .nav-link.active {
  background-color: transparent;
  position: relative;
  border: 0;
  color: #e85b28;
}
.tab-style-2 .nav-item .nav-link.active i {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}
.tab-style-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-end: 0;
  width: 100%;
  height: 0.175rem;
  background-color: #e85b28;
  border-radius: 50px;
}

.tab-style-3 {
  border-block-end: 0;
}
.tab-style-3 .nav-item {
  position: relative;
  margin-inline-end: 0.5rem;
}
.tab-style-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-3 .nav-item .nav-link {
  position: relative;
  border: 0;
  font-size: 0.75rem;
}
.tab-style-3 .nav-item .nav-link:before {
  position: absolute;
  content: "";
  inset-block-end: -1.063rem;
  inset-inline-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #FDFDFE;
  border-radius: 50%;
}
.tab-style-3 .nav-item .nav-link:after {
  position: absolute;
  content: "";
  inset-block-end: -2rem;
  inset-inline-start: 1.75rem;
  inset-inline-end: 0;
  inset-inline-start: 30%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFF;
  border-radius: 50%;
  border: 2px solid #E8E8E8;
}
.tab-style-3 .nav-item .nav-link.home:after {
  content: "1";
}
.tab-style-3 .nav-item .nav-link.about:after {
  content: "2";
}
.tab-style-3 .nav-item .nav-link.services:after {
  content: "3";
}
.tab-style-3 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #e85b28;
}
.tab-style-3 .nav-item .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #e85b28;
}
.tab-style-3 .nav-item .nav-link.active:before {
  background-color: #e85b28;
}
.tab-style-3 .nav-item .nav-link.active:after {
  border-color: #e85b28;
  color: #e85b28;
}

.tab-style-4.nav-tabs {
  border: 0;
}
.tab-style-4.nav-tabs .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-4.nav-tabs .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-4.nav-tabs .nav-link {
  border: 0;
}
.tab-style-4.nav-tabs .nav-link:hover {
  border: 0;
  background: transparent;
  color: #e85b28;
}
.tab-style-4.nav-tabs .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #e85b28;
  position: relative;
  overflow: hidden;
}
.tab-style-4.nav-tabs .nav-link.active::before {
  position: absolute;
  content: "";
  width: 0.75rem;
  inset-block-start: 31px;
  transform: rotate(45deg);
  inset-inline-start: 47%;
  overflow: hidden;
  z-index: 1;
  height: 0.75rem;
  background-color: #e85b28;
  border: 1px solid #e85b28;
}
.tab-style-4.nav-tabs .nav-link.active:after {
  position: absolute;
  content: "";
  width: 40%;
  height: 1px;
  inset-inline-start: 30%;
  inset-block-end: 0;
  background-color: #e85b28;
}

#tab-style-4 .tab-pane.active {
  border: 1px solid #e85b28;
  background-color: #e85b28;
  color: #FFF;
  padding: 16px;
  border-radius: 7px;
}

.tab-style-5 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-5 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-5 .nav-item .nav-link.active {
  background: #e85b28;
}

.tab-style-6 {
  border: 0;
  background-color: #FFF;
  border-radius: 7px;
  color: #e85b28;
  padding: 0.5rem;
}
.tab-style-6 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.tab-style-6 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-6 .nav-item .nav-link {
  color: #e85b28;
  padding: 0.5rem 1rem;
  font-size: 0.813rem;
  border: 0;
  font-weight: 500;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-6 .nav-item .nav-link.active {
  border: 0;
  background-color: #e85b28;
  color: #FFF;
  border: 0;
  box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb), 0.05);
}
.tab-style-6 .nav-item .nav-link:hover, .tab-style-6 .nav-item .nav-link:focus {
  border: 0;
}

.tab-style-7 .nav-link {
  margin-block-end: 0.5rem;
  font-size: 0.813rem;
  color: #9595b5;
  text-align: left;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-7 .nav-link:active, .tab-style-7 .nav-link.active {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}

.nav-style-1 .nav-item .nav-link.active {
  background-color: rgba(232, 91, 40, 0.1);
  color: #e85b28;
}

@media screen and (max-width: 400px) {
  .tab-style-4 .nav-link {
    padding-inline: 0.5rem;
  }
}
.nav-tabs {
  border-bottom: 0;
}
.nav-tabs.nav-tabs-bottom li {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: 0 0;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link.active {
  border-color: #898989;
}
.nav-tabs li a {
  color: #565E5E;
  border-bottom-width: 2px;
}
.nav-tabs li a.active {
  border-color: transparent;
  border-bottom-color: #e85b28;
  background-color: transparent;
  transition: all 0.2s ease;
}

.nav-tabs .nav-tabs-solid {
  background-color: #FFF;
  border: 0;
}
.nav-tabs .nav-tabs-solid .active {
  background-color: #e85b28;
  border-color: #e85b28;
  color: #FFF;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  color: #e85b28;
}
.nav-tabs.nav-tabs-top li a {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top li a.active {
  border-top-color: #e85b28;
  border-radius: 0;
}
.nav-tabs.nav-tabs-top li a:hover {
  border-top-color: #e85b28;
  background-color: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-bottom li a {
  border-width: 0 0 2px 0;
}
.nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #e85b28;
  background: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-solid {
  background-color: #FFF;
  border: 0;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded li a.active {
  background-color: #e85b28;
  border-color: #e85b28;
  color: #FFF;
  border-radius: 50px;
}
.nav-tabs.nav-tabs-solid li a.active {
  background-color: #e85b28;
  border-color: #e85b28;
  color: #FFF;
  border-radius: 0;
}

.nav-link:hover {
  color: #e85b28;
}

.page-menu .nav-tabs li a {
  font-size: 16px;
}

.tabs-set .nav-tabs {
  border-bottom: 0;
  margin-bottom: 20px;
}
.tabs-set .nav-tabs .nav-link {
  color: #FFA201;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: 700;
  border: 0;
  min-width: 120px;
  margin-right: 10px;
  border-radius: 8px;
  background: rgba(145, 158, 171, 0.3);
  background: var(--Stroke, rgba(145, 158, 171, 0.3));
}
.tabs-set .nav-tabs .nav-link:focus {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link:hover {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link.active {
  border: 0;
  border-bottom: 2px solid #e85b28;
  background: #e85b28;
  color: #FFF;
}

.tabs-sets .nav-tabs {
  border-bottom: 0;
  margin: 0 0 40px;
}
.tabs-sets .nav-tabs .nav-link {
  color: #000;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  background: #898989;
  margin-right: 10px;
  padding: 8px 15px;
  border-radius: 8px;
  transition: all 0.5s ease;
}
.tabs-sets .nav-tabs .nav-link:focus, .tabs-sets .nav-tabs .nav-link:hover, .tabs-sets .nav-tabs .nav-link.active {
  background: #e85b28;
  color: #FFF;
}

@media (max-width: 768px) {
  .nav-tabs {
    border-bottom: 0;
    position: relative;
    background-color: #FFF;
    padding: 5px 0;
    border-radius: 3px;
  }
}
.ribbon1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-end: 10px;
  color: #FFF;
  z-index: 1;
}
.ribbon1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FC0027;
}
.ribbon1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbon1 span:before, .ribbon1 span:after {
  position: absolute;
  content: "";
}
.ribbon1 span:before {
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FC0027;
}
.ribbon1 span:after {
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FC0027;
}

.ribbone {
  width: 100%;
  position: relative;
  background-size: cover;
  text-transform: uppercase;
  color: #FFF;
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.ribbone::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone::before {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 3px 0;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #FFF;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
  font-size: 11px;
}

.ribbone1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-start: 10px;
  z-index: 1;
}
.ribbone1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FC0027;
}
.ribbone1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbone1 span:after {
  position: absolute;
  content: "";
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FC0027;
}
.ribbone1 span:before {
  position: absolute;
  content: "";
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FC0027;
}

.arrow-ribbone-left {
  color: #FFF;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-left.bg-purple:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #4A00E5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-danger:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 112px solid transparent;
  border-inline-start: 12px solid #FC0027;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-primary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-secondary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FFA201;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-success:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #e85b28;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-info:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #1ECBE2;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-warning:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FDA700;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-pink:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #EA00B7;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right {
  color: #FFF;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-right.bg-purple:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #4A00E5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-danger:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FC0027;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-primary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-secondary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FFA201;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-success:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #e85b28;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-info:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #1ECBE2;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-warning:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FDA700;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-pink:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #EA00B7;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone2 {
  color: #FFF;
  padding: 3px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: -1px;
  z-index: 6;
  font-size: 30px;
}
.arrow-ribbone2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 24px solid transparent;
  border-block-end: 24px solid transparent;
  width: 0;
}

.power-ribbone {
  width: 56px;
  height: 56px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.power-ribbone span {
  position: absolute;
  display: block;
  width: 82px;
  padding: 8px 0;
  color: #FFF;
  font: 500 16px/1 Lato, sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
}

.power-ribbone-top-left {
  inset-block-start: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-top-left span {
  inset-inline-end: -5px;
  inset-block-start: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-top-left span i {
  transform: rotate(45deg);
  padding-block-start: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-bottom-left {
  inset-block-end: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-bottom-left span {
  inset-inline-end: -5px;
  inset-block-end: 1px;
  transform: rotate(45deg);
}
.power-ribbone-bottom-left span i {
  transform: rotate(-45deg);
  padding-block-end: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-top-right {
  inset-block-start: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-top-right span {
  inset-inline-start: -5px;
  inset-block-start: 1px;
  transform: rotate(45deg);
}
.power-ribbone-top-right span i {
  transform: rotate(-45deg);
  padding-block-start: 2px;
  padding-inline-end: 7px;
}

.power-ribbone-bottom-right {
  inset-block-end: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-bottom-right span {
  inset-inline-start: -5px;
  inset-block-end: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-bottom-right span i {
  transform: rotate(45deg);
  padding-block-end: 2px;
  padding-inline-end: 7px;
}

.ribbone-top-left {
  inset-block-start: -10px;
  inset-inline-start: -10px;
}
.ribbone-top-left::after {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-end: 50px;
  inset-inline-start: 0;
}
.ribbone-top-left::before {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-start: 0;
  inset-inline-end: 50px;
}
.ribbone-top-left span {
  inset-inline-end: 0px;
  inset-block-start: 24px;
  transform: rotate(-45deg);
}

.ribbone-top-right {
  inset-block-start: -10px;
  inset-inline-end: -10px;
}
.ribbone-top-right::after {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-end: 50px;
  inset-inline-end: 0;
}
.ribbone-top-right::before {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-start: 0;
  inset-inline-start: 50px;
}
.ribbone-top-right span {
  inset-inline-start: 0px;
  inset-block-start: 24px;
  transform: rotate(45deg);
}

.ribbone-warning-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #FFF;
}
.ribbone-warning-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FDA700;
  z-index: 6;
}
.ribbone-warning-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FDA700;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-warning-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FDA700;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-warning-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FDA700;
}
.ribbone-warning-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-danger-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #FFF;
}
.ribbone-danger-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FC0027;
  z-index: 6;
}
.ribbone-danger-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-danger-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FC0027;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-danger-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FC0027;
}
.ribbone-danger-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-success-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #FFF;
}
.ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #5CB85C;
  z-index: 6;
}
.ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-success-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #5CB85C;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-success-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #5CB85C;
}
.ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-info-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #FFF;
}
.ribbone-info-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #1ECBE2;
  z-index: 6;
}
.ribbone-info-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #1ECBE2;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-info-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #1ECBE2;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-info-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #1ECBE2;
}
.ribbone-info-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-success-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #FFF;
}
.bookmark-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 18px solid #5CB85C;
  border-inline-end: 18px solid #5CB85C;
  border-block-end: 10px solid transparent;
}
.bookmark-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 13px;
  line-height: 1;
  padding: 12px 3px 20px;
  z-index: 6;
}
.bookmark-ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-danger-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #FFF;
  width: 30px;
}
.bookmark-ribbone-danger-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 15px solid #FC0027;
  border-inline-end: 15px solid #FC0027;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-danger-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 12px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-danger-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-secondary-right {
  position: absolute;
  inset-inline-end: 10px;
  color: #FFF;
  width: 30px;
}
.bookmark-ribbone-secondary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-end: 0;
  border-inline-start: 15px solid #FFA201;
  border-inline-end: 15px solid #FFA201;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-secondary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FFA201;
  font-size: 11px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-secondary-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideleft-ribbone-success-left {
  position: absolute;
  inset-block-start: 10px;
  color: #FFF;
}
.bookmark-sideleft-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-end: -8px;
  border-block-start: 13px solid #5CB85C;
  border-block-end: 13px solid #5CB85C;
  border-inline-end: 8px solid transparent;
}
.bookmark-sideleft-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideleft-ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideright-ribbone-primary-right {
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  color: #FFF;
}
.bookmark-sideright-ribbone-primary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-start: -8px;
  border-block-start: 13px solid #e85b28;
  border-block-end: 13px solid #e85b28;
  border-inline-start: 8px solid transparent;
}
.bookmark-sideright-ribbone-primary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #e85b28;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideright-ribbone-primary-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-1 span:after {
  position: absolute;
  content: "";
}

.arrow-ribbone-2 {
  color: #FFF;
  padding: 3px 8px;
  position: absolute;
  z-index: 6;
  font-size: 20px;
}
.arrow-ribbone-2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 16px solid transparent;
  border-inline-start: 24px solid #4A00E5;
  border-block-end: 16px solid transparent;
  width: 0;
}

.ribbone-card {
  overflow: hidden;
}

.fullwidth-primary-ribbons .bar {
  color: #FFF;
  background-color: #e85b28;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-primary-ribbons .bar span {
  position: absolute;
}
.fullwidth-primary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-color: #e85b28 #e85b28 #e85b28 transparent;
  border-block-start-color: #e85b28;
  border-inline-end-color: #e85b28;
  border-block-end-color: #e85b28;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-primary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #e85b28;
  border-inline-end-color: transparent;
  border-block-end-color: #e85b28;
  border-inline-start-color: #e85b28;
  inset-inline-end: -30px;
}

.fullwidth-secondary-ribbons .bar {
  color: #FFF;
  background-color: #FFA201;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-secondary-ribbons .bar span {
  position: absolute;
}
.fullwidth-secondary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FFA201;
  border-inline-end-color: #FFA201;
  border-block-end-color: #FFA201;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FFA201;
  border-inline-end-color: transparent;
  border-block-end-color: #FFA201;
  border-inline-start-color: #FFA201;
  inset-inline-end: -30px;
}

.fullwidth-arrow-warning-ribbons .bar {
  color: #FFF;
  background-color: #FDA700;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-arrow-warning-ribbons .bar span {
  position: absolute;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FDA700;
  border-inline-end-color: #FDA700;
  border-block-end-color: #FDA700;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-start: 18px solid #FDA700;
  border-block-end: 18px solid transparent;
  border-inline-end: transparent;
  inset-inline-end: -20px;
  inset-block-start: -2px;
}

.fullwidth-arrow-danger-ribbons-right .bar {
  color: #FFF;
  background-color: #FC0027;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-arrow-danger-ribbons-right .bar span {
  position: absolute;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FC0027;
  border-inline-end-color: transparent;
  border-block-end-color: #FC0027;
  border-inline-start-color: #FC0027;
  inset-inline-end: -30px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-end: 18px solid #FC0027;
  border-block-end: 18px solid transparent;
  border-inline-start: transparent;
  inset-inline-start: -20px;
  inset-block-start: -2px;
}

.power-ribbone span svg {
  width: 15px;
  height: 15px;
}

.ribbone-card .card-body {
  padding: 25px;
}

.ribbone-row .feather-zap {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-fullscreen] svg {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-remove] svg {
  width: 15px;
  height: 15px;
}

svg.collapse-open, svg.collapse-close {
  width: 15px;
  height: 15px;
}

.btn-icon.btn-danger-light {
  color: #FC1A3D;
  background: #FFEEEC;
}

.live-rating.badge {
  background: #E0F5D7;
  color: #6CBF6C;
}

@media (min-width: 576px) {
  .mx-sm-7 {
    margin-inline: 3rem !important;
  }
}
[dir=rtl] .power-ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-left span i {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-top-right span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span i {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbon-price .badge {
  transform: rotate(-45deg);
}

.modal-barcode ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.modal-barcode ul li {
  border-radius: 7px;
  width: 25%;
  margin-bottom: 10px;
  padding: 0 5px;
}
@media (max-width: 991.98px) {
  .modal-barcode ul li {
    width: 50%;
  }
}
.modal-barcode ul li a {
  border: 1px solid #6F6F6F;
  border-radius: 10px;
  display: block;
  padding: 10px;
  text-align: center;
}

.modal .modal-content {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border-radius: 5px;
}
.modal .modal-title {
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .modal .modal-title {
    font-size: 16px;
  }
}
.modal .logo-lg img {
  width: 150px;
}
.modal .modal-header {
  border-color: #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  justify-content: space-between;
}
.modal .modal-header .close,
.modal .modal-header .btn-close {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FD4D68;
  opacity: 1;
  font-size: 12px;
  width: 22px;
  height: 22px;
  border: 0;
  font-weight: 700;
  background-color: transparent;
  border-radius: 50px;
}
.modal .modal-header .close:hover,
.modal .modal-header .btn-close:hover {
  background-color: transparent;
  color: #FFF;
}
.modal .modal-footer .btn-print {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #e85b28;
  color: #e85b28;
}
.modal .modal-footer .btn-print img {
  margin-left: 10px;
}
.modal .modal-footer .btn-print:hover {
  background: #e85b28;
  color: #FFF;
}
.modal .modal-footer .btn-print:hover img {
  filter: brightness(0) invert(1);
}
.modal .modal-footer .btn-secondary {
  background: #FFA201;
}
.modal .modal-footer .btn-secondary:hover {
  box-shadow: inset 0 0px 0px 100px #FFF;
  color: #FFA201 !important;
}
.modal .modal-dialog.right-slider-modal {
  margin: 0;
  margin-left: auto;
  max-width: 1102px;
}
.modal .modal-dialog.add-centered {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  max-width: 1192px;
}
.modal .modal-dialog.sales-details-modal {
  max-width: 1192px;
}
.modal .modal-dialog.edit-sales-modal {
  max-width: 1192px;
}
.modal .edit-add.card.edit-expense {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.modal .note-editor.note-frame.card {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.offcanvas.offcanvas-end {
  width: auto !important;
}

.offcanvas.offcanvas-end.em-payrol-add {
  max-width: 1192px !important;
}

.modal.animated .modal-dialog {
  transform: translate(0, 0);
}
.modal.effect-scale .modal-dialog {
  transform: scale(0.7);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-scale.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-slide-in-right .modal-dialog {
  transform: translateX(20%);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.modal.effect-slide-in-right.show .modal-dialog {
  transform: translateX(0);
  opacity: 1;
}
.modal.effect-slide-in-bottom .modal-dialog {
  transform: translateY(20%);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-slide-in-bottom.show .modal-dialog {
  transform: translateY(0);
  opacity: 1;
}
.modal.effect-newspaper .modal-dialog {
  transform: scale(0) rotate(720deg);
  opacity: 0;
}
.modal.effect-newspaper.show ~ .modal-backdrop, .modal.effect-newspaper .modal-dialog {
  transition: all 0.5s;
}
.modal.effect-newspaper.show .modal-dialog {
  transform: scale(1) rotate(0deg);
  opacity: 1;
}
.modal.effect-fall {
  perspective: 1300px;
}
.modal.effect-fall .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(600px) rotateX(20deg);
  opacity: 0;
}
.modal.effect-fall.show .modal-dialog {
  transition: all 0.3s ease-in;
  transform: translateZ(0px) rotateX(0deg);
  opacity: 1;
}
.modal.effect-flip-horizontal {
  perspective: 1300px;
}
.modal.effect-flip-horizontal .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateY(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-horizontal.show .modal-dialog {
  transform: rotateY(0deg);
  opacity: 1;
}
.modal.effect-flip-vertical {
  perspective: 1300px;
}
.modal.effect-flip-vertical .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-vertical.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-super-scaled .modal-dialog {
  transform: scale(2);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-super-scaled.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-sign {
  perspective: 1300px;
}
.modal.effect-sign .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-60deg);
  transform-origin: 50% 0;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-sign.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-bottom {
  perspective: 1300px;
}
.modal.effect-rotate-bottom .modal-dialog {
  transform-style: preserve-3d;
  transform: translateY(100%) rotateX(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s ease-out;
}
.modal.effect-rotate-bottom.show .modal-dialog {
  transform: translateY(0%) rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-left {
  perspective: 1300px;
}
.modal.effect-rotate-left .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(100px) translateX(-30%) rotateY(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-rotate-left.show .modal-dialog {
  transform: translateZ(0px) translateX(0%) rotateY(0deg);
  opacity: 1;
}

.offcanvas-end.offcanvas-large {
  width: 700px !important;
}

.modal {
  z-index: 1050 !important;
}

.modal-backdrop {
  z-index: 1001 !important;
}

.status-toggle.small-toggle-btn {
  float: none;
  float: initial;
}
.status-toggle.small-toggle-btn .label-text {
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 400;
}
.status-toggle.small-toggle-btn .checktoggle {
  width: 24px;
  height: 12px;
}
.status-toggle.small-toggle-btn .checktoggle:after {
  width: 8px;
  height: 8px;
}
.status-toggle.small-toggle-btn .check:checked + .checktoggle:after {
  right: 0;
  width: 8px;
  height: 8px;
}
.status-toggle .check {
  display: block;
  height: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  margin: 0;
  padding: 0;
}
.status-toggle .check:checked + .checktoggle:after {
  left: 100%;
  transform: translate(calc(-100% - 3px), -50%);
  right: 0;
  width: 10px;
  height: 10px;
}
.status-toggle .check:checked + .checktoggle {
  background: #1ABE17;
}
.status-toggle .checktoggle {
  background: #CDCDCD;
  cursor: pointer;
  display: block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
  border-radius: 12px;
  width: 30px;
  height: 14px;
}
.status-toggle .checktoggle:after {
  content: " ";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #FFF;
  transition: all 0.2s ease;
  transform: translate(3px, -50%);
  -webkit-transform: translate(3px, -50%);
  -ms-transform: translate(3px, -50%);
  position: absolute;
  top: 50%;
  left: 0;
  border-radius: 50%;
}

.modal-btn .btn {
  margin: 0 10px 0 0;
  padding: 7px 15px;
}
.modal-btn .btn:last-child {
  margin-right: 0;
}

.custom-modal .modal-header .btn-close {
  margin: 0;
  padding: 0;
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 50%;
  color: #6F6F6F;
  font-weight: 400;
  font-size: 14px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  height: 26px;
  width: 26px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  transition: all 0.7s;
}
.custom-modal .modal-header .btn-close:hover {
  border: 1px solid #e85b28;
  background: #e85b28;
  color: #FFF;
  transition: all 0.7s;
  transform: rotateZ(360deg);
}

.grid-showcase {
  margin-bottom: -10px;
}
.grid-showcase span, .grid-showcase .grid-wrapper {
  display: block;
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-color: rgba(242, 243, 247, 0.7);
}

.grid-align {
  margin-bottom: -16px;
}

.grid-align .row {
  padding: 15px 0;
  min-height: 7rem;
  margin-bottom: 16px;
}

.grid-vertical {
  min-height: 150px;
  padding: 10px;
  color: #000;
}

table.table-bordered thead tr th p {
  margin-bottom: 0;
}

/******* Base *******/
body {
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  color: #6F6F6F;
  line-height: 1.5;
  background-color: #F9F9FC;
  overflow-y: auto;
  overflow-x: hidden;
}

html {
  font-family: "Noto Sans", sans-serif;
}

::selection {
  background: #e85b28;
  color: #FFF;
  text-shadow: none;
}

img {
  max-width: 100%;
  height: auto;
  vertical-align: inherit;
}

* {
  outline: none;
}

button {
  transition: all 0.5s ease;
}
button:focus {
  box-shadow: none !important;
}

p {
  margin-bottom: 20px;
}
p:last-child {
  margin-bottom: 0;
}

strong {
  font-weight: 700;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  color: #262A2A;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

ol, ul {
  list-style: none;
  margin-block-end: 0;
  padding: 0;
}

ul {
  list-style: none;
}
ul.list-disc {
  list-style: disc;
  padding-left: 15px;
}
ul.list-disc ul {
  list-style-type: circle;
}
ul.list-decimal {
  list-style: decimal;
  padding-left: 15px;
}
ul.list-decimal ul {
  list-style-type: decimal;
}
ul.list-icon {
  list-style: none;
  padding-left: 0;
}
ul.list-icon > li {
  padding-left: 1.875rem;
  counter-increment: li;
}
ul.list-icon > li i,
ul.list-icon > li .feather-icon,
ul.list-icon > li .svg-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  text-align: center;
  margin-left: -1.25rem;
  position: relative;
  left: -10px;
  padding: 1px;
  top: -1px;
}
ul.list-icon > li i {
  font-size: 20px;
  top: 5px;
}
ul .btn-primary:not(:disabled):not(.disabled):active:focus, ul .btn-primary:not(:disabled):not(.disabled).active:focus {
  box-shadow: none;
}

.bg-primary {
  background-color: #e85b28 !important;
}

.bg-secondary {
  background-color: #FFA201 !important;
}

.bg-info {
  background-color: #1ECBE2 !important;
}

.bg-success {
  background-color: #5CB85C !important;
  color: #FFF !important;
}

.bg-warning {
  background-color: #FDA700 !important;
  color: #FFF !important;
}

.bg-danger {
  background-color: #FC0027 !important;
  color: #FFF !important;
}

.bg-dark {
  background-color: #171724 !important;
}

.bg-light {
  background-color: #FDFDFE !important;
}

.bg-light-300 {
  background-color: #F6F6F6 !important;
}

.bg-light-400 {
  background: #F5F5F5;
}

.bg-light-600 {
  background-color: #F4F4F4 !important;
}

.bg-white {
  background-color: #FFF !important;
}

.bg-pink {
  background-color: #EA00B7 !important;
}

.bg-purple {
  background-color: #4A00E5 !important;
}

.bg-teal {
  background-color: #02a8b5 !important;
}

.bg-blue {
  background-color: #339DFF !important;
}

.bg-tertiary {
  background-color: #3C2371 !important;
}

.bg-violet {
  background-color: #676DFF !important;
}

.bg-green {
  background-color: #00918E !important;
}

.bg-gray {
  background: #E0E2E7;
}

.bg-darkgreen {
  background-color: #111926 !important;
}

.bg-nightblue {
  background-color: #0F0F41 !important;
}

.bg-royalblue {
  background-color: #0039C6 !important;
}

.bg-darkgray {
  background-color: #2E2E48 !important;
}

.bg-indigo {
  background-color: #391694 !important;
}

.bg-primary {
  background-color: #e85b28 !important;
}
.bg-primary.bg-opacity-10 {
  background-color: rgba(232, 91, 40, 0.1) !important;
}
.bg-primary.bg-opacity-25 {
  background-color: rgba(232, 91, 40, 0.25) !important;
}
.bg-primary.bg-opacity-50 {
  background-color: rgba(232, 91, 40, 0.5) !important;
}
.bg-primary.bg-opacity-75 {
  background-color: rgba(232, 91, 40, 0.75) !important;
}
.bg-primary.bg-opacity-100 {
  background-color: #e85b28 !important;
}

.bg-secondary {
  background-color: #FFA201 !important;
}
.bg-secondary.bg-opacity-10 {
  background-color: rgba(255, 162, 1, 0.1) !important;
}
.bg-secondary.bg-opacity-25 {
  background-color: rgba(255, 162, 1, 0.25) !important;
}
.bg-secondary.bg-opacity-50 {
  background-color: rgba(255, 162, 1, 0.5) !important;
}
.bg-secondary.bg-opacity-75 {
  background-color: rgba(255, 162, 1, 0.75) !important;
}
.bg-secondary.bg-opacity-100 {
  background-color: #ffa201 !important;
}

.bg-info {
  background-color: #1ECBE2 !important;
}
.bg-info.bg-opacity-10 {
  background-color: rgba(30, 203, 226, 0.1) !important;
}
.bg-info.bg-opacity-25 {
  background-color: rgba(30, 203, 226, 0.25) !important;
}
.bg-info.bg-opacity-50 {
  background-color: rgba(30, 203, 226, 0.5) !important;
}
.bg-info.bg-opacity-75 {
  background-color: rgba(30, 203, 226, 0.75) !important;
}
.bg-info.bg-opacity-100 {
  background-color: #1ecbe2 !important;
}

.bg-success {
  background-color: #5CB85C !important;
}
.bg-success.bg-opacity-10 {
  background-color: rgba(92, 184, 92, 0.1) !important;
}
.bg-success.bg-opacity-25 {
  background-color: rgba(92, 184, 92, 0.25) !important;
}
.bg-success.bg-opacity-50 {
  background-color: rgba(92, 184, 92, 0.5) !important;
}
.bg-success.bg-opacity-75 {
  background-color: rgba(92, 184, 92, 0.75) !important;
}
.bg-success.bg-opacity-100 {
  background-color: #5cb85c !important;
}

.bg-warning {
  background-color: #FDA700 !important;
}
.bg-warning.bg-opacity-10 {
  background-color: rgba(253, 167, 0, 0.1) !important;
}
.bg-warning.bg-opacity-25 {
  background-color: rgba(253, 167, 0, 0.25) !important;
}
.bg-warning.bg-opacity-50 {
  background-color: rgba(253, 167, 0, 0.5) !important;
}
.bg-warning.bg-opacity-75 {
  background-color: rgba(253, 167, 0, 0.75) !important;
}
.bg-warning.bg-opacity-100 {
  background-color: #fda700 !important;
}

.bg-danger {
  background-color: #FC0027 !important;
}
.bg-danger.bg-opacity-10 {
  background-color: rgba(252, 0, 39, 0.1) !important;
}
.bg-danger.bg-opacity-25 {
  background-color: rgba(252, 0, 39, 0.25) !important;
}
.bg-danger.bg-opacity-50 {
  background-color: rgba(252, 0, 39, 0.5) !important;
}
.bg-danger.bg-opacity-75 {
  background-color: rgba(252, 0, 39, 0.75) !important;
}
.bg-danger.bg-opacity-100 {
  background-color: #fc0027 !important;
}

.bg-dark {
  background-color: #171724 !important;
}
.bg-dark.bg-opacity-10 {
  background-color: rgba(23, 23, 36, 0.1) !important;
}
.bg-dark.bg-opacity-25 {
  background-color: rgba(23, 23, 36, 0.25) !important;
}
.bg-dark.bg-opacity-50 {
  background-color: rgba(23, 23, 36, 0.5) !important;
}
.bg-dark.bg-opacity-75 {
  background-color: rgba(23, 23, 36, 0.75) !important;
}
.bg-dark.bg-opacity-100 {
  background-color: #171724 !important;
}

.bg-light {
  background-color: #FDFDFE !important;
}
.bg-light.bg-opacity-10 {
  background-color: rgba(253, 253, 254, 0.1) !important;
}
.bg-light.bg-opacity-25 {
  background-color: rgba(253, 253, 254, 0.25) !important;
}
.bg-light.bg-opacity-50 {
  background-color: rgba(253, 253, 254, 0.5) !important;
}
.bg-light.bg-opacity-75 {
  background-color: rgba(253, 253, 254, 0.75) !important;
}
.bg-light.bg-opacity-100 {
  background-color: #fdfdfe !important;
}

.bg-primary {
  background-color: #e85b28 !important;
  border: 1px solid #e85b28 !important;
  color: #FFF;
}

.bg-secondary {
  background-color: #FFA201 !important;
  border: 1px solid #FFA201 !important;
  color: #FFF;
}

.bg-success {
  background-color: #5CB85C !important;
  border: 1px solid #5CB85C !important;
  color: #FFF;
}

.bg-info {
  background-color: #1ECBE2 !important;
  border: 1px solid #1ECBE2 !important;
  color: #FFF;
}

.bg-warning {
  background-color: #FDA700 !important;
  border: 1px solid #FDA700 !important;
  color: #FFF;
}

.bg-danger {
  background-color: #FC0027 !important;
  border: 1px solid #FC0027 !important;
  color: #FFF;
}

.bg-dark {
  background-color: #171724 !important;
  border: 1px solid #171724 !important;
  color: #FFF;
}

.bg-light {
  background-color: #FDFDFE !important;
  border: 1px solid #FDFDFE !important;
  color: #FFF;
}

.bg-black {
  background-color: #000 !important;
  border: 1px solid #000 !important;
  color: #FFF;
}

.bg-purple {
  background-color: #4A00E5 !important;
  border: 1px solid #4A00E5 !important;
  color: #FFF;
}

.bg-yellow {
  background-color: #ffff00 !important;
  border: 1px solid #ffff00 !important;
  color: #FFF;
}

.bg-teal {
  background-color: #02a8b5 !important;
  border: 1px solid #02a8b5 !important;
  color: #FFF;
}

.bg-soft-primary {
  background-color: #F7BCB5;
  color: #e85b28;
}

.bg-soft-secondary {
  background-color: #FFE3B3;
  color: #FFA201;
}

.bg-soft-success {
  background-color: #CEEACE;
  color: #5CB85C;
}

.bg-soft-danger {
  background-color: #FEB3BE;
  color: #FC0027;
}

.bg-soft-warning {
  background-color: #FEE5B3;
  color: #FDA700;
}

.bg-soft-info {
  background-color: rgba(30, 203, 226, 0.3);
  color: #1ECBE2;
}

.bg-soft-light {
  background-color: rgba(253, 253, 254, 0.9);
  color: #6F6F6F;
}

.bg-soft-dark {
  background-color: rgba(23, 23, 36, 0.3);
  color: #FFF;
}

.bg-light {
  color: #6F6F6F;
}

.bg-primary-gradient {
  background: linear-gradient(to right, #e85b28 0%, #8e77fa 100%) !important;
  color: #FFF;
}

.bg-secondary-gradient {
  background: linear-gradient(to right, #FFA201 0%, #28b7f9 100%) !important;
  color: #FFF;
}

.bg-warning-gradient {
  background: linear-gradient(to right, #FDA700 0%, #fbc434 100%) !important;
  color: #FFF;
}

.bg-info-gradient {
  background: linear-gradient(to right, #1ECBE2 0%, #00f2fe 100%) !important;
  color: #FFF;
}

.bg-success-gradient {
  background: linear-gradient(to right, #5CB85C 0%, #5cf9e2 100%) !important;
  color: #FFF;
}

.bg-danger-gradient {
  background: linear-gradient(to right, #FC0027 0%, #fd4a68 100%) !important;
  color: #FFF;
}

.bg-orange-gradient {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%) !important;
  color: #FFF;
}

.bg-purple-gradient {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%) !important;
  color: #FFF;
}

.bg-teal-gradient {
  background: linear-gradient(to right, #02a8b5 0%, #0695DD 100%) !important;
  color: #FFF;
}

.bg-light-gradient {
  background: linear-gradient(to right, #FDFDFE 0%, #D1D6DE 100%) !important;
  color: #000;
}

.bg-dark-gradient {
  background: linear-gradient(to right, #171724 0%, #54505D 100%) !important;
  color: #FFF;
}

.bg-outline-primary {
  background-color: #FFF;
  border: 1px solid #e85b28;
  color: #e85b28;
}

.bg-outline-secondary {
  background-color: #FFF;
  border: 1px solid #FFA201;
  color: #FFA201;
}

.bg-outline-warning {
  background-color: #FFF;
  border: 1px solid #FDA700;
  color: #FDA700;
}

.bg-outline-info {
  background-color: #FFF;
  border: 1px solid #1ECBE2;
  color: #1ECBE2;
}

.bg-outline-success {
  background-color: #FFF;
  border: 1px solid #5CB85C;
  color: #5CB85C;
}

.bg-outline-danger {
  background-color: #FFF;
  border: 1px solid #FC0027;
  color: #FC0027;
}

.bg-outline-dark {
  background-color: #FFF;
  border: 1px solid #171724;
  color: #171724;
}

.bg-outline-light {
  background-color: #FFF;
  border: 1px solid #FDFDFE !important;
  color: #000 !important;
}

.bg-primary-transparent {
  background-color: rgba(232, 91, 40, 0.1) !important;
  color: #e85b28 !important;
}
.bg-primary-transparent:hover {
  background-color: rgba(232, 91, 40, 0.1) !important;
  color: #e85b28 !important;
}

.bg-secondary-transparent {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201 !important;
}
.bg-secondary-transparent:hover {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201 !important;
}

.bg-info-transparent {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2 !important;
}
.bg-info-transparent:hover {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2 !important;
}

.bg-success-transparent {
  background-color: rgba(92, 184, 92, 0.1) !important;
  color: #5CB85C !important;
}
.bg-success-transparent:hover {
  background-color: rgba(92, 184, 92, 0.1) !important;
  color: #5CB85C !important;
}

.bg-warning-transparent {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700 !important;
}
.bg-warning-transparent:hover {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700 !important;
}

.bg-danger-transparent {
  background-color: rgba(252, 0, 39, 0.1) !important;
  color: #FC0027 !important;
}
.bg-danger-transparent:hover {
  background-color: rgba(252, 0, 39, 0.1) !important;
  color: #FC0027 !important;
}

.bg-light-transparent {
  background-color: rgba(253, 253, 254, 0.5) !important;
  color: #FDFDFE !important;
}
.bg-light-transparent:hover {
  background-color: rgba(253, 253, 254, 0.5) !important;
  color: #6F6F6F !important;
}

.bg-gray-100 {
  background-color: #C0C0C0;
}

.bg-gray-200 {
  background-color: #9B9B9B;
}

.bg-gray-300 {
  background-color: #898989;
}

.bg-gray-400 {
  background-color: #6F6F6F;
}

.bg-gray-500 {
  background-color: #6F7A7A;
}

.bg-gray-600 {
  background-color: #565E5E;
}

.bg-gray-700 {
  background-color: #424848;
}

.bg-gray-800 {
  background-color: #323737;
}

.bg-gray-900 {
  background-color: #262A2A;
}

.svg-primary {
  fill: #e85b28;
}

.svg-secondary {
  fill: #FFA201;
}

.svg-success {
  fill: #5CB85C;
}

.svg-danger {
  fill: #FC0027;
}

.svg-warning {
  fill: #FDA700;
}

.svg-white {
  fill: #FFF;
}

.svg-black {
  fill: #000;
}

.svg-pink {
  fill: #EA00B7;
}

.svg-orange {
  fill: #FF9D0A;
}

.svg-purple {
  fill: #4A00E5;
}

.svg-indigo {
  fill: #391694;
}

.svg-info {
  fill: #1ECBE2;
}

.svg-yellow {
  fill: #ffff00;
}

.svg-light {
  fill: #FDFDFE;
}

.svg-dark {
  fill: #171724;
}

.svg-teal {
  fill: #02a8b5;
}

.svg-default {
  fill: #6F6F6F;
}

.color-container {
  width: 5rem;
  height: 5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 3rem;
}

.text-container {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
}

.color-box {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-right: 0.75rem;
  margin-bottom: 0.75rem;
}

.bg-soft-purple {
  background: #F3EDFF !important;
  border-color: #F3EDFF !important;
}

.text-purple {
  color: #4A00E5;
}

.bg-light-200 {
  background: #F9F9FC;
}

.bg-light-100 {
  background: #FAFAFA;
}

.bg-danger-light {
  background: #FFEEEC;
}

.bg-pending {
  background: #676DFF !important;
  color: #FFF !important;
}

.bg-secondary-success {
  background: #00918E !important;
}

.bg-orange {
  background: #FF9D0A;
}

.text-blue {
  color: #4A00E5 !important;
}

.text-blue-light {
  color: #391694 !important;
}

/******* Pages ******/
.page-header {
  margin-bottom: 14px;
}
.page-header .page-title {
  font-weight: 600;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .page-header .page-title {
    font-size: 18px;
  }
}
@media (max-width: 767.98px) {
  .page-header .page-title {
    margin-bottom: 14px;
  }
}
.page-header .page-title .count-title {
  background: #F3EDFF;
  border-radius: 5px;
  margin: 0 0 0 8px;
  padding: 5px;
  color: #FF9D0A;
  font-size: 12px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .page-header .title-head {
    margin-top: 0;
  }
}
.page-header .head-icons {
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .page-header .head-icons {
    display: none;
  }
}
.page-header .head-icons a {
  width: 32px;
  height: 32px;
  background: #FFF;
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin-right: 8px;
}
.page-header .head-icons a.active, .page-header .head-icons a:hover {
  background: #00918E;
  color: #FFF;
}
.page-header .head-icons a:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .page-header .head-icons a {
    margin-right: 4px !important;
  }
  .page-header .head-icons a:last-child {
    margin-right: 0 !important;
  }
}
.page-header .form-sort {
  margin-top: 0;
}

.count-available-member {
  background: #F3EDFF;
  border-radius: 5px;
  margin: 0 0 0 8px;
  padding: 5px;
  color: #FF9D0A;
  font-size: 12px;
  font-weight: 600;
}

.set-star i {
  color: #E8E8E8;
}
.set-star i.filled {
  color: #FF9D0A;
}

.rating-select.filled i {
  color: #FF9D0A;
}

.icon-form {
  position: relative;
}
.icon-form .form-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #262A2A;
}
.icon-form .form-control {
  padding: 8px 15px 8px 35px;
}
.icon-form .form-control:focus {
  padding: 8px 15px 8px 35px;
}

.icon-form-end {
  position: relative;
}
.icon-form-end .form-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  color: #262A2A;
}
.icon-form-end .form-control {
  padding: 8px 34px 8px 15px;
}

.view-icons {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  padding: 2px;
  display: inline-flex;
  align-items: center;
}
.view-icons a {
  width: 34px;
  height: 36px;
  background: #FFF;
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.view-icons a:first-child {
  border-radius: 5px 0 0 5px;
}
.view-icons a:last-child {
  border-radius: 0 5px 5px 0;
}
.view-icons a.active, .view-icons a:hover {
  background: #00918E;
  color: #FFF;
}

.sidebar-popoverlay {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 1003;
}
.sidebar-popoverlay.open {
  left: 0;
}

.sidebar-popoverlay-sign {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 1003;
}
.sidebar-popoverlay-sign.open {
  left: 0;
}

.profile-pic-upload {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.profile-pic-upload .profile-pic {
  border: 2px dashed #E8E8E8;
  margin: 0 15px 10px 0;
  width: 100px;
  height: 100px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
}
.profile-pic-upload .profile-pic span {
  display: flex;
}
.profile-pic-upload .profile-pic img {
  width: 70px;
  height: 70px;
  border-radius: 5px;
}
.profile-pic-upload .profile-pic .close-img {
  background: #FC0027;
  color: #FFF;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  top: 10px;
  right: 10px;
}
.profile-pic-upload .upload-content p {
  margin-bottom: 10px;
}
.profile-pic-upload .upload-btn {
  background: #F3EDFF;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  display: inline-block;
}
.profile-pic-upload .upload-btn span {
  padding: 9px 12px;
  cursor: pointer;
  color: #4A00E5;
  display: inline-block;
}
.profile-pic-upload .upload-btn span i {
  margin-right: 10px;
}
.profile-pic-upload .upload-btn input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}

.user-accordion-item {
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  margin-bottom: 15px;
}
.user-accordion-item .accordion-wrap {
  padding: 10px 25px 10px 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  position: relative;
}
.user-accordion-item .accordion-wrap span {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
}
.user-accordion-item .accordion-wrap:hover {
  color: #262A2A;
}
.user-accordion-item .accordion-wrap::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
}
.user-accordion-item .accordion-wrap:not(.collapsed)::before {
  content: "\\f078";
}
.user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #e85b28;
  color: #FFF;
}
.user-accordion-item .content-collapse {
  border-top: 1px solid #E8E8E8;
  margin: 5px 10px 10px;
  padding: 15px 0 0;
}
.user-accordion-item .accordion-collapse .form-wrap {
  margin-bottom: 24px;
}
.user-accordion-item .accordion-collapse .form-wrap.mb-wrap {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .user-accordion-item .accordion-collapse .form-wrap.mb-wrap {
    margin-bottom: 24px;
  }
}

.submit-button .btn {
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  margin: 0 10px 0 0;
  padding: 7px 15px;
}
.submit-button .btn:last-child {
  margin-right: 0;
}

.radio-wrap .col-form-label {
  padding-bottom: 12px;
}
.radio-wrap .radio-btn {
  margin-right: 15px;
}
.radio-wrap .radio-btn:last-child {
  margin-right: 0;
}

.success-message h3 {
  margin-bottom: 10px;
  font-size: 20px;
}
.success-message .del-info {
  max-width: 300px;
  margin: 0 auto;
}
.success-message p {
  font-size: 16px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .success-message p {
    font-size: 14px;
  }
}
.success-message .modal-btn {
  margin-top: 40px;
}

.success-popup-icon {
  background: #FFEEEC;
  color: #FC0027;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  font-size: 42px;
}
.success-popup-icon.bg-light-blue {
  background: #F3EDFF;
  color: #4A00E5;
}

.access-wrap {
  border-radius: 5px;
  margin: 0 0 20px;
  padding: 10px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.access-wrap li {
  margin: 0 0 5px;
  padding: 0;
}
.access-wrap li.checkbox-checked label {
  background: #F6F6F6;
}
.access-wrap li label {
  width: 100%;
  position: relative;
  padding: 5px;
  background: transparent;
}
.access-wrap li label.checkboxs .checkmarks {
  right: 10px;
  left: auto;
  left: initial;
  top: 50%;
  transform: translatey(-50%);
}
.access-wrap li label.checkboxs input:checked ~ .checkmark {
  background: #e85b28;
  border-color: #e85b28;
}
.access-wrap li label .people-profile {
  display: flex;
  align-items: center;
}
.access-wrap li label .people-profile img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}
.access-wrap li label .people-profile a {
  color: #6F6F6F;
  font-size: 14px;
}
.access-wrap li:hover {
  background-color: #F6F6F6;
}
.access-wrap li:last-child {
  margin-bottom: 0;
}

.load-btn .btn i {
  margin-left: 4px;
  animation: spin 3000ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
  }
}
.img-select {
  position: relative;
}
.img-select .select-box-img {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 10px;
  z-index: 9999;
}
.img-select .select2-selection__rendered {
  padding-left: 40px !important;
}

.users-group ul {
  display: flex;
  align-items: center;
}
.users-group ul li a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  margin-left: -11px;
}
.users-group ul li a img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.users-group ul li a.total-group-member {
  background: #e85b28;
  color: #FFF;
  font-size: 10px;
}
.users-group ul li a:hover {
  position: relative;
}
.users-group ul li:first-child a {
  margin-left: 0;
}

.add-new {
  color: #FC0027;
}

.contact-head {
  margin-bottom: 5px;
}
.contact-head .contact-breadcrumb {
  margin-bottom: 5px;
}
.contact-head .contact-breadcrumb li {
  color: #6F6F6F;
  position: relative;
  display: inline-block;
  margin: 0 2px 5px 0;
  padding: 0 0 0 10px;
}
.contact-head .contact-breadcrumb li a {
  color: #6F6F6F;
}
.contact-head .contact-breadcrumb li a i {
  color: #e85b28;
  margin-right: 8px;
}
.contact-head .contact-breadcrumb li a:hover {
  color: #e85b28;
}
.contact-head .contact-breadcrumb li:last-child {
  margin-right: 0;
}
.contact-head .contact-breadcrumb li:first-child {
  padding-left: 0;
}
.contact-head .contact-breadcrumb li:first-child::before {
  content: none;
}
.contact-head .contact-breadcrumb li::before {
  content: "/";
  position: absolute;
  top: 0;
  left: 0;
}
.contact-head .contact-breadcrumb li.before-none {
  padding-left: 5px;
}
.contact-head .contact-breadcrumb li.before-none::before {
  content: none;
}
.contact-head .contact-breadcrumb li .btn {
  color: #FFF;
}
.contact-head .contact-breadcrumb li .btn i {
  color: #FFF;
}
.contact-head .contact-breadcrumb li .btn:hover {
  color: #FFF;
}
.contact-head .contact-pagination {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-bottom: 10px;
}
.contact-head .contact-pagination p {
  margin: 0 15px 0 0;
}
.contact-head .contact-pagination ul li {
  display: inline-block;
  margin-right: 5px;
}
.contact-head .contact-pagination ul li a {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #FFF;
  color: #262A2A;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.contact-head .contact-pagination ul li a:hover {
  background: #e85b28;
  color: #FFF;
}
.contact-head .contact-pagination ul li:last-child {
  margin-right: 0;
}

.contacts-action {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.contacts-action > a {
  margin: 0 8px 8px 0;
}
.contacts-action > a:last-child {
  margin-right: 0;
}
.contacts-action .badge {
  margin: 0 8px 10px 0;
  padding: 7px 6px;
  font-size: 14px;
  font-weight: 400;
}
.contacts-action .badge.badge-light {
  background: #F4F4F4;
  color: #6F6F6F;
}
.contacts-action .badge i {
  margin-right: 8px;
}
.contacts-action .action-drops {
  margin-bottom: 10px;
}
.contacts-action .action-drops .dropdown-toggle {
  font-weight: 600;
  color: #FFF;
  display: inline-block;
}
.contacts-action .action-drops .dropdown-toggle span {
  display: inline-block;
  border-radius: 5px;
  padding: 4px 10px;
  color: #FFF;
}
.contacts-action .dropdown-toggle {
  margin-right: 0;
  color: #FFAB1A;
}
.contacts-action .dropdown-toggle::after {
  content: none;
}
.contacts-action .btn {
  border-radius: 5px;
  padding: 6px 13px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 15px;
  font-weight: 500;
}
.contacts-action .btn i {
  margin-right: 5px;
}
.contacts-action .btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  border: 1px solid #F6F6F6;
  color: #262A2A;
}
.contacts-action .btn-icon:hover {
  background: #e85b28;
  color: #FFF;
}
.contacts-action .btn-icon.rating {
  border-radius: 50%;
  background: #FFF;
  border: 1px solid #E8E8E8;
  color: #FF9D0A;
}
.contacts-action .act-dropdown {
  margin-bottom: 10px;
}
.contacts-action .act-dropdown > a {
  width: 34px;
  height: 34px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FFF;
  border: 1px solid #E8E8E8;
}
.contacts-action .act-dropdown > a:hover {
  background: #E8E8E8;
  color: #262A2A;
}
.contacts-action .act-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  color: #262A2A;
}
.contacts-action .act-dropdown .dropdown-item i {
  margin-right: 8px;
}
.contacts-action .act-dropdown .dropdown-item:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.basic-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
}
.basic-info li span {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  color: #262A2A;
  margin-right: 10px;
  flex-shrink: 0;
}

.set-info li a {
  color: #6F6F6F;
}
.set-info li a:hover {
  color: #e85b28;
}
.set-info li i {
  margin-right: 5px;
}

.other-info li {
  display: flex;
}
.other-info li .other-title {
  min-width: 110px;
  display: inline-block;
}
.other-info li .avatar-xs {
  width: 16px;
  height: 16px;
  border-radius: 5px;
}

.con-sidebar-title {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
}
.con-sidebar-title a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #4A00E5;
}
.con-sidebar-title a:hover {
  color: #e85b28;
}

.company-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.company-info li span {
  width: 52px;
  height: 52px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  margin-right: 10px;
}
.company-info li h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}
.company-info li p {
  font-size: 14px;
  margin-bottom: 0;
}
.company-info.com-info li span {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  border-radius: 50%;
}
.company-info.com-info li p i {
  margin-right: 5px;
  color: #FDA700;
}

.deals-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.deals-info li img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  margin-right: 10px;
}
.deals-info li p {
  margin-bottom: 0;
}

.social-info li {
  display: inline-block;
}
.social-info li a {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FFF;
  color: #262A2A;
}
.social-info li a:hover {
  background: #262A2A;
  color: #FFF;
}

.tag-info li {
  margin-right: 5px;
  display: inline-block;
}
.tag-info li a {
  font-size: 12px;
  font-weight: 500;
  border-radius: 5px;
  padding: 5px 10px;
  display: inline-block;
}
.tag-info li:last-child {
  margin-right: 0;
}

.star-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  color: #FF9D0A;
}
.star-icon i {
  font-size: 14px;
}

@media (max-width: 575.98px) {
  .contact-nav {
    display: block;
  }
}
.contact-nav li {
  display: inline-block;
  margin: 0 20px 0 0;
}
.contact-nav li a {
  color: #6F6F6F;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 3px solid #FFF;
  text-align: center;
  padding: 5px 5px 10px 5px;
}
.contact-nav li a:hover, .contact-nav li a.active {
  color: #e85b28;
  border-color: #e85b28;
}
.contact-nav li a i {
  margin-right: 5px;
}
@media (max-width: 575.98px) {
  .contact-nav li {
    display: block;
  }
}

.form-sort {
  position: relative;
}
.form-sort i {
  position: absolute;
  z-index: 101;
  width: 16px;
  height: 16px;
  top: 14px;
  left: 7px;
}
.form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
.form-sort span.select2-container.select2-container--default.select2-container--open {
  z-index: 99;
}

.badge-day {
  background: #F3EDFF;
  color: #4A00E5;
  border-radius: 5px;
  display: inline-block;
  font-size: 14px;
  margin: 0 0 20px;
  padding: 4px 8px;
}
.badge-day i {
  margin-right: 5px;
}

.contact-activity ul:last-child .activity-wrap:last-child {
  margin-bottom: 0;
}

.upcoming-info {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin: 10px 0 0;
  padding: 15px 15px 5px;
}
.upcoming-info p {
  font-weight: 500;
  margin-bottom: 8px;
}
.upcoming-info .dropdown {
  margin-bottom: 10px;
}
.upcoming-info .dropdown .dropdown-toggle {
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
}
.upcoming-info .dropdown .dropdown-toggle::after {
  content: none;
}
.upcoming-info .dropdown .avatar-xs {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 10px;
}
.upcoming-info .dropdown .circle {
  font-size: 10px;
}
.upcoming-info .dropdown .dropdown-menu a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
  color: #262A2A;
}

.notes-editor .dropdown-toggle::after {
  content: none;
}

.note-edit-wrap {
  display: none;
  margin-bottom: 15px;
}

.notes-activity .note-download {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  margin: 0 0 15px;
  padding: 15px;
  border-radius: 5px;
}
.notes-activity .note-download .note-info {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-right: 24px;
}
.notes-activity .note-download .note-info h6 {
  font-weight: 500;
  margin-bottom: 5px;
}
.notes-activity .note-download .note-info p {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .notes-activity .note-download .note-info {
    margin-right: 15px;
  }
}
.notes-activity .note-download .note-icon {
  width: 44px;
  height: 44px;
  border-radius: 5px;
  color: #FFF;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
  flex-shrink: 0;
}
.notes-activity .note-download .note-icon img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.notes-activity .note-download:hover {
  background: #F6F6F6;
}
.notes-activity .note-download:hover a {
  background: #FFF;
}
.notes-activity .note-download a {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  color: #262A2A;
  background: #F6F6F6;
}
@media (max-width: 767.98px) {
  .notes-activity .note-download {
    margin: 0 0 15px;
    padding: 10px;
  }
}
.notes-activity .reply-box {
  background: #F9F9FC;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px;
}
.notes-activity .reply-box p {
  margin-bottom: 10px;
}
.notes-activity .reply-box .btn {
  background: #FFF;
  border-color: #FFF;
  border-radius: 5px;
  color: #262A2A;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 5px 10px;
}
.notes-activity .reply-box .btn i {
  margin-right: 3px;
}
.notes-activity .reply-box .btn:hover {
  background: #FAFAFA;
}

.note-btns {
  margin-top: 5px;
}
.note-btns .btn {
  margin: 10px 10px 0 0;
  padding: 7px 15px;
}
.note-btns .btn:last-child {
  margin-right: 0;
}
.note-btns .btn.btn-primary {
  min-width: 110px;
}

.drag-attach {
  border: 1px dashed #E8E8E8;
  border-radius: 5px;
  position: relative;
  text-align: center;
  width: 100%;
  overflow: hidden;
}
.drag-attach input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}
.drag-attach .img-upload {
  background: #F3EDFF;
  color: #4A00E5;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  margin: 24px 0;
  padding: 9px 17px;
  border-radius: 5px;
}
.drag-attach .img-upload i {
  margin-right: 10px;
}

.drag-upload {
  background: #FAFAFA;
  border: 1px dashed #FFECCC;
  border-radius: 5px;
  position: relative;
}
.drag-upload input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}
.drag-upload i {
  font-size: 24px;
  margin-bottom: 10px;
}
.drag-upload p {
  font-size: 14px;
  margin-bottom: 0;
}
.drag-upload .img-upload {
  text-align: center;
  padding: 36px 20px;
}

.upload-file {
  background: #F9F9FC;
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px;
  border-radius: 5px;
}
.upload-file h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}
.upload-file p {
  font-size: 14px;
  margin-bottom: 0;
}
.upload-file p.black-text {
  color: #262A2A;
}
.upload-file .progress {
  height: 3px;
  margin: 15px 0 4px;
}
.upload-file.upload-list {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.form-title {
  font-weight: 600;
  margin-bottom: 15px;
}

.sync-radio .radio-item {
  margin-bottom: 15px;
}
.sync-radio .radio-item label {
  font-size: 14px;
}
.sync-radio .radio-item:last-child {
  margin-bottom: 0;
}

.signature-wrap {
  background: #F2ECFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px 15px 0;
}
.signature-wrap h4,
.signature-wrap p {
  margin-bottom: 15px;
}
.signature-wrap h4 {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .signature-wrap h4 {
    font-size: 16px;
  }
}

.add-sign {
  font-size: 16px;
  color: #FDA700;
}

.sign-item li {
  margin-bottom: 15px;
}
.sign-item li .sign-title {
  display: block;
  font-weight: 500;
  margin-bottom: 3px;
}

.trash-sign {
  color: #FC0027;
}

.send-success {
  border: 1px solid #5CB85C;
  background: #CEEACE;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px;
}
.send-success p {
  color: #262A2A;
  margin-bottom: 0;
}
.send-success p i {
  margin-right: 5px;
}

fieldset {
  display: none;
}
fieldset#first-field-file {
  display: block;
}

.add-details-wizard ul {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
@media (max-width: 575.98px) {
  .add-details-wizard ul {
    flex-direction: column;
  }
}
.add-details-wizard ul li {
  line-height: normal;
  background: #F6F6F6;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
@media (max-width: 575.98px) {
  .add-details-wizard ul li {
    width: 100%;
    margin-bottom: 10px;
  }
}
.add-details-wizard ul li span {
  margin-right: 5px;
}
.add-details-wizard ul li .multi-step-info h6 {
  margin-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  color: #6F6F6F;
}
.add-details-wizard ul li.active {
  background: #e85b28;
  color: #FFF;
}
.add-details-wizard ul li.active h6 {
  color: #FFF;
}

.pipeline-item {
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px 15px 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  position: relative;
}
.pipeline-item::before {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 2px;
  height: 100%;
  background: #FFA201;
}
.pipeline-item p {
  color: #262A2A;
  font-weight: 500;
  margin-bottom: 10px;
}
.pipeline-item .action-pipeline {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.pipeline-item .action-pipeline a {
  margin: 0 15px 10px 0;
}
.pipeline-item .action-pipeline a i {
  margin-right: 5px;
}
.pipeline-item .action-pipeline a:last-child {
  margin-right: 0;
}
.pipeline-item:last-child {
  margin-bottom: 0;
}

.access-item .radio-btn {
  margin-right: 15px;
}
.access-item .radio-btn:last-child {
  margin-right: 0;
}

.access-wrapper {
  margin-top: 20px;
}

.access-view {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px 15px 15px;
  border-radius: 5px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.access-view .access-img {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.access-view .access-img img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  margin-right: 10px;
}
.access-view a {
  font-weight: 600;
  color: #FC0027;
}

.header-collapse .header-user {
  display: none;
  height: 0;
}
.header-collapse .page-wrapper {
  padding-top: 0;
}
.header-collapse .header {
  border-bottom: none;
  background: transparent;
  width: 260px;
}
.header-collapse .header .header-left {
  background: white;
}
.header-collapse #collapse-header i {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

.bootstrap-datetimepicker-widget {
  z-index: 99999;
}
.bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td:hover {
  background-color: #00918E;
}

.note-modal-backdrop {
  z-index: 9;
}

.note-modal-footer {
  height: 57px;
}

.table tbody tr td a.title-name {
  color: #262A2A;
  font-weight: 500;
}
.table tbody tr td a.title-name:hover {
  color: #e85b28;
  text-decoration: underline;
}

.title-name {
  color: #262A2A;
  font-weight: 500;
}

.export-list > ul {
  display: flex;
  align-items: center;
  justify-content: end;
  flex-wrap: wrap;
}
@media (max-width: 575.98px) {
  .export-list > ul {
    justify-content: start;
  }
}

.grid-social-links a:hover {
  background: #FCE9E6 !important;
}

.daterange-picker .form-sort {
  margin-left: 10px;
}
.daterange-picker .form-sort input {
  padding-left: 25px;
  height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single {
  height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single .select2-selection__rendered {
  line-height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single .select2-selection__arrow {
  height: 38px;
}

.card-select ul {
  display: flex;
  align-items: center;
}
.card-select ul li + li {
  margin-left: 12px;
}

.view-icons {
  float: right;
}
@media (max-width: 767.98px) {
  .view-icons {
    margin-right: 0;
  }
}
.view-icons .btn {
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  color: #FFB534;
  font-size: 18px;
  min-width: 40px;
  margin: 0 5px 0 0;
  padding: 7px 0 3px 0;
}
.view-icons .btn.active {
  color: #FFAB1A;
}
@media (max-width: 767.98px) {
  .view-icons .btn {
    min-width: 37px;
    margin: 0 5px 0 0;
    padding: 5px 0 3px 0;
  }
}

@media (max-width: 767.98px) {
  .page-header .view-icons {
    margin-right: 10px;
  }
}
@media (max-width: 575.98px) {
  .page-header .view-icons {
    margin-right: 0;
  }
}

.title-head {
  justify-content: end;
  align-items: center;
}
@media (max-width: 767.98px) {
  .title-head {
    justify-content: start;
    margin-top: 20px;
  }
}
@media (max-width: 575.98px) {
  .title-head {
    flex-direction: column;
    row-gap: 20px;
    align-items: start;
  }
}
.title-head .add-btn {
  margin-left: 10px;
  border-radius: 5px;
}
@media (max-width: 575.98px) {
  .title-head .add-btn {
    margin-left: 0;
  }
}
.title-head .form-sort .list-view {
  padding: 10px 10px 10px 30px;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  color: #FFC767;
  font-size: 14px;
  text-decoration: none;
  line-height: normal;
}

.daterange-picker .form-sort {
  min-width: 200px;
}

.statistic-dropdown .btn-primary {
  padding: 6px 15px;
  height: 35px;
}

td .badge-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.badge-dots {
  width: 12px;
  height: 12px;
  border-radius: 5px;
  margin-right: 5px;
  display: inline-flex;
}

.title-head .daterange-picker .form-sort {
  height: auto;
  min-width: 212px;
}
.title-head .daterange-picker .form-sort i {
  left: 15px;
  top: 9px;
}
.title-head .daterange-picker .form-sort input {
  height: 32px;
  min-height: 32px;
}
.title-head .daterange-picker .bookingrange {
  padding-left: 35px;
}

.error-page {
  background: #FFF;
}

.comming-shapes {
  position: relative;
}
@media (max-width: 991.98px) {
  .comming-shapes {
    display: none;
  }
}
.comming-shapes .comming-right-shape {
  position: fixed;
  top: 0;
  left: 0;
}
.comming-shapes .comming-left-shape {
  position: fixed;
  bottom: -5px;
  right: 0;
}
.comming-shapes img {
  width: 500px;
}

.error-img {
  max-width: 500px;
}

.account-page {
  background: #FFF;
}

.form-wrap .form-wrap-icon {
  position: relative;
}
.form-wrap .form-wrap-icon i {
  font-size: 18px;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}

.form-wrap-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.form-wrap-checkbox .check {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #262A2A;
  margin-bottom: 0;
}
.form-wrap-checkbox .check input {
  display: none;
}
.form-wrap-checkbox .check input:checked + .box {
  background: #FFA201;
}
.form-wrap-checkbox .check input:checked + .box:after {
  top: 0;
}
.form-wrap-checkbox .check .box {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 8px;
  transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
  background: #F9F9FC;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.form-wrap-checkbox .check .box:after {
  width: 12px;
  height: 6px;
  content: "";
  position: absolute;
  border-left: 2px solid;
  border-bottom: 2px solid;
  border-color: #FFF;
  transform: rotate(-45deg) translate3d(0, 0, 0);
  transform-origin: center center;
  transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
  left: 0;
  right: 0;
  top: 200%;
  bottom: 3px;
  margin: auto;
}

.hover-a {
  position: relative;
  color: #4A00E5;
}
.hover-a:after {
  content: "";
  height: 2px;
  width: 100%;
  background: #4A00E5;
  transform: scale(0);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transition: all 0.3s ease;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.hover-a:hover:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}
.hover-a:hover {
  color: #4A00E5;
}

.account-bg-01 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-02 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-03 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-04 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.link-hover {
  position: relative;
  color: #e85b28;
  font-weight: 500;
}
.link-hover:after {
  content: "";
  height: 2px;
  width: 100%;
  background: #e85b28;
  transform: scale(0);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transition: all 0.3s ease;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.link-hover:hover:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}
.link-hover:hover {
  color: #e85b28 !important;
}

.bg-backdrop {
  background: rgba(255, 255, 255, 0.9490196078);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
@media (max-width: 767.98px) {
  .bg-backdrop {
    width: 100% !important;
  }
}

.form-set-login.or-text {
  max-width: 365px;
  margin: auto;
}

.toggle-password {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-password:hover {
  color: #e85b28;
}

.toggle-passwords {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-passwords:hover {
  color: #e85b28;
}

.toggle-password-new {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-password-new:hover {
  color: #e85b28;
}

.pass-group {
  position: relative;
  font-size: 14px;
}

.form-set-login {
  text-align: center;
  position: relative;
  color: #B8BCC9;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 23px;
}
.form-set-login h4 {
  position: relative;
  font-size: 14px;
  color: #6F6F6F;
  font-weight: 700;
}
.form-set-login h4:after {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  left: 200px;
}
@media (max-width: 991.98px) {
  .form-set-login h4:after {
    height: 0px;
  }
}
.form-set-login h4:before {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  right: 200px;
}
@media (max-width: 991.98px) {
  .form-set-login h4:before {
    height: 0px;
  }
}

.mw-450 {
  max-width: 450px;
}

.wh-85 {
  width: 85px;
  height: 85px;
}
@media (max-width: 575.98px) {
  .wh-85 {
    width: 50px;
    height: 50px;
  }
}

.login-shapes {
  position: relative;
}
@media (max-width: 991.98px) {
  .login-shapes {
    display: none;
  }
}
.login-shapes .login-right-shape {
  position: fixed;
  top: 0;
  left: 0;
}
.login-shapes .login-left-shape {
  position: fixed;
  bottom: 0;
  right: 0;
  line-height: 0;
}

.settings-sidebar h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
}
@media (max-width: 767.98px) {
  .settings-sidebar h4 {
    font-size: 16px;
    margin-bottom: 15px;
  }
}
.settings-sidebar a {
  color: #6F6F6F;
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  position: relative;
}
.settings-sidebar a.active {
  background: #F6F6F6;
  color: #262A2A;
}
.settings-sidebar a.active:before {
  position: absolute;
  content: "\\f054";
  font-family: "FontAwesome";
  font-size: 12px;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
.settings-sidebar a:hover {
  color: #262A2A;
}

.profile-upload {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.profile-upload .profile-upload-img {
  width: 100px;
  min-width: 100px;
  height: 100px;
  position: relative;
  margin-right: 15px;
  border-radius: 5px;
  border: 2px dashed #E8E8E8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.profile-upload .profile-upload-img span {
  color: #6F6F6F;
  position: absolute;
}
.profile-upload .profile-upload-content .profile-upload-btn {
  display: inline-flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  color: #4A00E5;
  background: #F3EDFF;
  border: 1px solid #F3EDFF;
  border-radius: 5px;
  padding: 8px 10px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.5s;
}
.profile-upload .profile-upload-content .profile-upload-btn:hover {
  color: #FFF;
  background: #4A00E5;
  border: 1px solid #4A00E5;
  transition: all 0.5s;
}
.profile-upload .profile-upload-content .profile-upload-btn i {
  font-size: 16px;
  margin-right: 8px;
}
.profile-upload .profile-upload-content .profile-upload-btn input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
.profile-upload .profile-upload-content p {
  font-weight: 500;
  color: #6F6F6F;
}
.profile-upload .preview1 {
  display: none;
}
.profile-upload .it {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  display: block;
  position: relative;
  background: #FFF;
  object-fit: cover;
}
.profile-upload .profile-remove {
  display: none;
}
.profile-upload .profile-remove-btn {
  width: 14px;
  height: 14px;
  font-size: 10px;
  color: #FFF;
  background: #FC0027;
  border: 1px solid #FC0027;
  border-radius: 5px;
  padding: 0;
  display: inline-block;
  position: absolute;
  top: 8px;
  right: 8px;
}
.profile-upload .profile-remove-btn:hover {
  background: rgb(201, 0, 31.1071428571);
  border: 1px solid rgb(201, 0, 31.1071428571);
}

.notificaion-table .table thead tr:first-child th {
  padding-top: 0;
}
.notificaion-table .table thead tr th {
  font-size: 16px;
  padding: 10px;
}
.notificaion-table .table tbody tr td {
  font-weight: 500;
  color: #262A2A;
  padding: 10px;
}
.notificaion-table .table tbody tr:last-child td {
  padding-bottom: 0;
}

.mod-toggle .status-toggle {
  margin-right: 20px;
}

.btn-add {
  width: 32px;
  height: 32px;
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
}
.btn-add:hover {
  background: #00918E;
  color: #FFF;
}

.settings-form .setting-title {
  margin-bottom: 15px;
}
.settings-form .setting-title h6 {
  font-size: 14px;
  font-weight: 500;
}
.settings-form .setting-title p {
  font-size: 12px;
}
.settings-form .form-wrap {
  margin-bottom: 15px;
}
.settings-form .submit-button {
  margin-top: 14px;
}

.bank-box {
  background: #F9F9FC;
  border-radius: 5px;
  border: 1px solid #F9F9FC;
  position: relative;
  margin: 0 0 24px;
  padding: 40px;
}
@media (max-width: 991.98px) {
  .bank-box {
    margin: 0 0 24px;
    padding: 20px;
  }
}
.bank-box.active {
  border-color: #5CB85C;
}
.bank-box.active::after {
  position: absolute;
  top: -8px;
  right: -8px;
  content: "\\f058";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: #6CBF6C;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #FFF;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.bank-box .table-action .action-icon {
  background-color: transparent;
}
.bank-box .table-action .action-icon:hover {
  background-color: #F6F6F6;
}

.inv-days .select2-container {
  min-width: 62px !important;
}
.inv-days p {
  color: #000;
  margin-left: 10px;
}

.lang-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.lang-type li {
  margin-right: 5px;
}
.lang-type li a {
  background-color: #F6F6F6;
  border-radius: 5px;
  color: #6F6F6F;
  font-weight: 500;
  padding: 8px 15px;
  display: inline-block;
}
.lang-type li a:hover {
  background-color: #00918E;
  color: #FFF !important;
}

.theme-type-images {
  flex-wrap: wrap;
}
.theme-type-images .theme-image {
  background: #FFF;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  padding: 10px;
  margin: 0 24px 15px 0;
  text-align: center;
}
.theme-type-images .theme-image img {
  width: 150px;
}
@media (max-width: 1399.98px) {
  .theme-type-images .theme-image img {
    width: 130px;
  }
}
.theme-type-images .theme-image:last-child {
  margin-right: 0;
}
.theme-type-images .theme-image span {
  font-weight: 500;
  font-size: 14px;
  color: #262A2A;
  margin-top: 10px;
  display: block;
}
.theme-type-images .theme-image.active {
  border-color: #e85b28;
}
.theme-type-images .theme-image.active span {
  color: #e85b28;
}

.theme-colors ul {
  display: flex;
  align-items: center;
}
.theme-colors ul li {
  margin-right: 10px;
}
.theme-colors ul li span {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #e85b28;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.theme-colors ul li span.active {
  background-color: #FCE9E6;
}
.theme-colors ul li span.active:after {
  content: "";
  width: 25px;
  height: 25px;
  background-color: #e85b28;
  border-radius: 50%;
  opacity: 1;
}
.theme-colors ul li span.theme-secondary {
  background-color: #FFA201;
}
.theme-colors ul li span.theme-secondary.active {
  background-color: #FFF6E6;
}
.theme-colors ul li span.theme-secondary.active:after {
  background-color: #FFA201;
}
.theme-colors ul li span.theme-violet {
  background-color: #3C2371;
}
.theme-colors ul li span.theme-violet.active {
  background-color: rgba(60, 35, 113, 0.1);
}
.theme-colors ul li span.theme-violet.active:after {
  background-color: #3C2371;
}
.theme-colors ul li span.theme-blue {
  background-color: #391694;
}
.theme-colors ul li span.theme-blue.active {
  background-color: #E6F4FC;
}
.theme-colors ul li span.theme-blue.active:after {
  background-color: #391694;
}
.theme-colors ul li span.theme-brown {
  background-color: #4A00E5;
}
.theme-colors ul li span.theme-brown.active {
  background-color: #F3EDFF;
}
.theme-colors ul li span.theme-brown.active:after {
  background-color: #4A00E5;
}
.theme-colors ul li:last-child {
  margin-right: 0;
}

.lang-wrap {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.lang-flag {
  margin-right: 15px;
}
.lang-flag a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  color: #262A2A;
  font-weight: 500;
  padding: 8px 8px;
}
.lang-flag a img {
  margin-right: 8px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.lang-direct li {
  margin: 0 8px 0 0;
}
.lang-direct li a {
  background-color: #9B9B9B;
  color: #262A2A;
  border-radius: 5px;
  padding: 8px 15px;
  display: inline-block;
}
.lang-direct li a:hover, .lang-direct li a.active {
  background-color: #3C2371;
  color: #FFF;
}
.lang-direct li:last-child {
  margin-right: 0;
}

.translate-wrap h6 {
  font-weight: 500;
  margin-bottom: 15px;
}
.translate-wrap .form-wrap {
  margin-bottom: 15px;
}
.translate-wrap.translate-title h6 {
  font-size: 16px;
  font-weight: 600;
}

.translate-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.translate-item .btn, .translate-item .lang-flag {
  margin-bottom: 24px;
}

.lang-flag {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.lang-progress {
  margin-bottom: 24px;
}
.lang-progress p {
  font-weight: 500;
}
.lang-progress .progress {
  min-width: 100px;
  max-width: 150px;
  height: 7px;
}

.black-text {
  color: #262A2A !important;
}

.settings-tab .card-body {
  padding-top: 0;
}
@media (max-width: 767.98px) {
  .settings-tab .card-body {
    padding-top: 16px;
  }
}
.settings-tab .card-body li a {
  padding-top: 24px;
}
@media (max-width: 767.98px) {
  .settings-tab .card-body li a {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}

.payment-img {
  width: 80px;
  height: 40px;
}

.source-report {
  color: #00918E;
  font-weight: 500;
}

.dropdown.table-action .dropdown-toggle::after {
  display: none;
}
.dropdown .dropdown-toggle {
  color: #262A2A;
  border: 1px solid #E8E8E8;
  padding: 9px 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}
.dropdown .dropdown-toggle:after {
  border-top: 0;
  border-left: 0;
  border-bottom: 2px solid #262A2A;
  border-right: 2px solid #262A2A;
  content: "";
  display: inline-block;
  pointer-events: none;
  width: 8px;
  height: 8px;
  vertical-align: 2px;
  transform-origin: 66% 66%;
  -webkit-transform-origin: 66% 66%;
  -ms-transform-origin: 66% 66%;
  transition: all 0.2s ease;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.dropdown .dropdown-toggle[aria-expanded=true]:after {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
}
.dropdown .dropdown-menu {
  padding: 10px;
  background: #FFF;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border: 1px solid #E8E8E8;
}
.dropdown .dropdown-menu .dropdown-item {
  padding: 1px 10px;
  color: #323737;
  background: #FFF;
  border-radius: 5px;
}
.dropdown .dropdown-menu .dropdown-item:hover {
  color: #262A2A;
  background: #F6F6F6;
}

.time-text p {
  font-weight: 500;
  white-space: nowrap;
  margin-left: 15px;
}

.activity-title {
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
}
.activity-title h4 {
  font-weight: 600;
  margin: 0 15px 10px 0;
  padding: 0 15px 0 0;
  position: relative;
}
.activity-title h4::after {
  content: "";
  background-color: #E8E8E8;
  width: 1px;
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 767.98px) {
  .activity-title h4::after {
    content: none;
  }
}
@media (max-width: 767.98px) {
  .activity-title {
    display: block;
  }
}

.active-list ul {
  margin-bottom: 10px;
}
.active-list ul li {
  display: inline-block;
  margin-right: 10px;
}
.active-list ul li a {
  width: 34px;
  height: 34px;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
}
.active-list ul li a:hover, .active-list ul li a.active {
  background-color: #00918E;
  border-color: #00918E;
  color: #FFF;
}
.active-list ul li:last-child {
  margin-right: 0;
}

.radio-activity li {
  display: inline-block;
}
.radio-activity li .active-type input[type=radio] {
  display: none;
}
.radio-activity li .active-type input[type=radio] ~ label {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  margin: 0 10px 5px 0;
  padding: 8px 20px;
  border-radius: 5px;
  color: #262A2A;
  cursor: pointer;
}
.radio-activity li .active-type input[type=radio] ~ label i {
  margin-right: 5px;
}
.radio-activity li .active-type input[type=radio]:checked ~ label {
  border-color: #00918E;
  color: #00918E;
}
.radio-activity li:last-child {
  margin-right: 0;
}

.label-add {
  color: #e85b28;
  margin-bottom: 5px;
  font-weight: 500;
}
.label-add i {
  margin-right: 8px;
}
.label-add:hover {
  color: rgb(199.6428571429, 68.7142857143, 21.3571428571);
}

.tab-activity {
  border-radius: 5px;
  margin: 0 0 20px;
  padding: 15px 15px 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.tab-activity ul li {
  display: inline-block;
  margin-right: 20px;
}
.tab-activity ul li a {
  padding: 10px 5px 10px;
  font-weight: 500;
  border-bottom: 4px solid #FFF;
  display: inline-block;
}
.tab-activity ul li a span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-left: 10px;
  color: #262A2A;
  font-weight: 600;
  font-size: 10px;
}
.tab-activity ul li a.active {
  color: #e85b28;
  border-color: #e85b28;
}

.comment-wrap {
  margin: 0 0 15px;
  padding: 15px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.comment-wrap h6 {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
  color: #6F6F6F;
}
.comment-wrap p span {
  color: #4A00E5;
}
.comment-wrap:last-child {
  margin-bottom: 0;
}

.activity-badge {
  color: #FFF;
  padding: 5px 7px;
  font-size: 12px;
  border-radius: 5px;
}
.activity-badge i {
  margin-right: 5px;
}

.title-head {
  font-weight: 500;
  color: #262A2A;
}

.tasks-activity.tasks > ul {
  margin-top: 15px;
}
.tasks-activity.tasks > ul .task-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
}
.tasks-activity.tasks > ul .task-wrap.pending::before {
  background-color: #676DFF;
}
.tasks-activity.tasks > ul .task-wrap.warning::before {
  background-color: #FDA700;
}
.tasks-activity.tasks > ul .task-wrap.success::before {
  background-color: #5CB85C;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-icon {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-checkbox {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-checkbox .checkboxs .checkmarks {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.tasks-activity.tasks > ul .task-wrap .task-info .set-star {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info p {
  font-weight: 500;
}
.tasks-activity.tasks > ul .task-wrap .task-info .badge {
  font-weight: 600;
  font-size: 12px;
  margin: 0 5px 10px 0;
  padding: 5px 7px;
  color: #FFF;
}
.tasks-activity.tasks > ul .task-wrap .task-info .badge:last-child {
  margin-right: 0;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li {
  margin: 0 10px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li .badge-tag {
  padding: 5px 4px;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li:last-child {
  margin-right: 0;
}

.all-read .checkboxs .checkmarks {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.task-drops .dropdown-toggle {
  border: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 600;
  box-shadow: none;
}
.task-drops .dropdown-toggle.show {
  border: 0;
}
@media (max-width: 767.98px) {
  .task-drops .dropdown-toggle {
    font-size: 16px;
  }
}

.badge-purple-light {
  color: #4A00E5 !important;
  background: #F3EDFF !important;
}

.task-wrapper {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
  padding-bottom: 15px;
}
.task-wrapper .tasks-activity.tasks > ul {
  margin-bottom: 15px;
}
.task-wrapper:last-child {
  padding-bottom: 0;
}
.task-wrapper:last-child .tasks-activity.tasks > ul {
  margin-bottom: 0;
}
.task-wrapper .task-accordion {
  font-size: 18px;
  font-weight: 600;
  position: relative;
  display: block;
}
@media (max-width: 767.98px) {
  .task-wrapper .task-accordion h4 {
    font-size: 16px;
  }
}
.task-wrapper .task-accordion span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-left: 10px;
  color: #262A2A;
  font-weight: 600;
  font-size: 10px;
}
.task-wrapper .task-accordion::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
}
.task-wrapper .task-accordion:not(.collapsed)::before {
  content: "\\f078";
}
.task-wrapper:last-child {
  border: 0;
  margin-bottom: 0;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
.toggle-content-view {
  margin-bottom: 24px;
}
.toggle-content-view h5 {
  font-size: 20px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 5px;
}
.toggle-content-view p {
  color: #6F6F6F;
  font-size: 14px;
}

.details-propsal h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
}
.details-propsal h6 {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
}
.details-propsal h3 {
  color: #3C2371;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.details-propsal span {
  color: #6F6F6F;
  font-size: 14px;
  display: block;
}
.details-propsal.details-propsals ul li {
  width: 33.3%;
}
.details-propsal ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 20px;
}
.details-propsal ul li {
  width: 25%;
  margin-bottom: 10px;
}
.details-propsal ul li h5 {
  color: #565E5E;
  font-weight: 400;
  margin-bottom: 5px;
}
.details-propsal ul li h6 {
  color: #262A2A;
  font-weight: 400;
}
.details-propsal ul li img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 5px;
}
.details-propsal ul li .btn {
  padding: 3px 15px;
}

.attached-div h5 {
  font-size: 16px;
  margin-bottom: 12px;
}

.attached-div {
  padding-bottom: 15px;
}

.attachement-download {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #E8E8E8;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 12px;
}

.attachement-download-icon span {
  background: #e85b28;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #fff;
  border-radius: 5px;
}

.attachement-download-img {
  display: flex;
  align-items: center;
}

.attachement-download-content {
  margin-left: 10px;
}
.attachement-download-content h5 {
  font-size: 14px;
  margin-bottom: 3px;
  font-weight: 600;
}
.attachement-download-content h6 {
  font-size: 14px;
  font-weight: 400;
}

.table-view {
  margin-bottom: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 10px;
}
.table-view th {
  background: #E8E8E8;
}

.table-view {
  margin-bottom: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 10px;
}
.table-view th {
  background: #E8E8E8;
}

.subtotal-div {
  background: #F9F9FC;
  padding: 24px;
}
.subtotal-div ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.subtotal-div ul li h5 {
  font-size: 14px;
  color: #6F6F6F;
  font-weight: 400;
  margin: 0;
}
.subtotal-div ul li h6 {
  font-size: 16px;
  color: #262A2A;
  font-weight: 600;
  margin: 0;
}
.subtotal-div ul li + li {
  margin-top: 15px;
}

.terms-condition {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #E8E8E8;
}
.terms-condition h2 {
  font-size: 14px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 15px;
}
.terms-condition p {
  color: #6F6F6F;
  font-size: 14px;
  padding-bottom: 15px;
}

.contact-type h6 {
  font-weight: 600;
}
.contact-type ul {
  border: 0;
  display: inline;
}
.contact-type ul li {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
}
.contact-type ul li h5 {
  position: relative;
  width: 40%;
  color: #6F6F6F;
  font-size: 14px;
  margin: 0;
}
.contact-type ul li h5:after {
  position: absolute;
  content: ":";
  right: 8px;
  top: 0px;
}
.contact-type ul li h6 {
  position: relative;
  width: 60%;
  color: #262A2A;
  font-size: 14px;
  margin: 0;
}

.renewal-history h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}

.renewal-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #E8E8E8;
  padding: 24px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border-radius: 5px;
  margin-bottom: 15px;
}
.renewal-content .renewal-content-history {
  width: 80%;
}
.renewal-content .contact-type h6 {
  color: #424848;
  margin-bottom: 15px;
}
.renewal-content .contact-type ul {
  flex-wrap: wrap;
  display: flex;
}
.renewal-content .contact-type ul li {
  width: 50%;
}
.renewal-content .contact-type ul li h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.renewal-content .contact-type ul li h5 {
  font-size: 14px;
  font-weight: 400;
}

.toogle-header-select .select2-container {
  min-width: 150px !important;
}
.toogle-header-select .select2-container--default .select2-results__option--selected {
  color: #fff;
}
.toogle-header-select .toggle-btn {
  min-width: 26px;
}

.btn-downloads {
  font-size: 14px !important;
  border: 1px solid #E8E8E8;
  padding: 10px 15px;
  color: #262A2A !important;
  font-weight: 500;
  border-radius: 5px;
}
.btn-downloads:hover {
  background: #e85b28;
  color: #FFF !important;
}

.input-table.input-table-descripition input {
  width: 130px;
}
.input-table input {
  border: 1px solid #E8E8E8;
  height: 30px;
  border-radius: 5px;
  width: 75px;
  padding: 5px;
}
.input-table select {
  border: 1px solid #E8E8E8;
  height: 30px;
  border-radius: 5px;
  width: 75px;
}

.upload-signature {
  position: relative;
}
.upload-signature input {
  width: 100%;
  height: 42px;
  opacity: 0;
  z-index: 9;
}
.upload-signature a {
  border: 1px dashed #E8E8E8;
  border-radius: 5px;
  position: absolute;
  width: 100%;
  height: 42px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #6F6F6F;
  left: 0;
  padding: 10px;
  background: #fff;
}

.toggle-header-popup .btn-dropdowns {
  min-width: 125px;
  border: 1px solid #E8E8E8;
  padding: 8px 12px;
  font-size: 14px !important;
  color: #6F6F6F !important;
}
.toggle-header-popup .btn-dropdowns.dropdown-toggle:after {
  top: -2px;
  position: relative;
  font-size: 12px;
}
.toggle-header-popup .btn-dropdowns.dropdown-toggle-contract {
  min-width: 150px;
}
.toggle-header-popup .btn-dropdowns:hover {
  color: #FFF !important;
  background: #e85b28;
}
.toggle-header-popup .btn-dropdowns:active, .toggle-header-popup .btn-dropdowns:focus {
  color: #FFF !important;
}
.toggle-header-popup .dropdown-item {
  font-size: 14px !important;
  color: #6F6F6F !important;
}

.toggle-popup-sent .sidebar-layout .sidebar-header a, .toggle-popup-draft .sidebar-layout .sidebar-header a, .toggle-popup-declined .sidebar-layout .sidebar-header a {
  font-size: 14px;
  color: #fff;
}

.signature-contant {
  padding: 15px 0;
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
}
.signature-contant p {
  color: #B5B5B5;
  margin: 0;
}

.pay-now .btn {
  height: 42px;
}

.sidebar .sidebar-inner {
  width: 100% !important;
}

.activities-list ul li {
  background: #F6F6F6;
  padding: 15px 10px;
  margin-bottom: 20px;
}
.activities-list ul li:last-child {
  margin-bottom: 0;
}
.activities-list ul li .activity-name h5 {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 5px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.activities-list ul li .activity-name p {
  font-size: 14px;
  margin-bottom: 15px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.activities-list ul li .activity-name .badge {
  color: #FFF;
  padding: 5px 7px;
  font-size: 12px;
  border-radius: 5px;
}
.activities-list ul li .activity-name .badge i {
  margin-right: 5px;
}
.activities-list ul li .user-activity {
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .activities-list ul li .user-activity {
    margin: 20px 0;
  }
}
.activities-list ul li .user-activity span {
  flex-shrink: 0;
  display: inline-flex;
  margin-right: 5px;
}
.activities-list ul li .user-activity span img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.activities-list ul li .user-activity h6 {
  margin-bottom: 0;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

@media (max-width: 575.98px) {
  .card-select ul {
    align-items: start !important;
  }
}

.campaign-card {
  overflow-x: auto;
}
.campaign-card ul {
  width: max-content;
}
.campaign-card ul .campaign-wrap {
  background-color: #F9F9FC;
  margin: 0 0 15px;
  padding: 15px 15px 5px;
}
.campaign-card ul .campaign-wrap .campaign-info {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  white-space: nowrap;
  border-bottom: 1px solid #E8E8E8;
  margin: 0 0 15px 0;
}
.campaign-card ul .campaign-wrap .campaign-info h5 {
  font-weight: 600;
  margin-bottom: 5px;
}
.campaign-card ul .campaign-wrap .campaign-info .campaign-name {
  margin: 0 50px 10px 0;
}
.campaign-card ul .campaign-wrap .campaign-info .list-progress {
  margin-bottom: 10px;
}
.campaign-card ul .campaign-wrap .campaign-action {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  flex-wrap: wrap;
}
.campaign-card ul .campaign-wrap .campaign-action .project-mem {
  margin-bottom: 10px;
}
.campaign-card ul .campaign-wrap .campaign-date {
  margin-bottom: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.campaign-card ul .campaign-wrap .campaign-date .badge {
  margin: 0 15px 0 0;
}
.campaign-card ul .campaign-wrap:last-child {
  margin-bottom: 0;
}

.priority.badge-tag {
  color: #262A2A;
  min-width: 80px;
  text-align: left;
  font-weight: 600;
}
.priority.badge-tag i {
  margin-right: 4px;
}
.priority.badge-tag.badge-danger-light i {
  color: #FC0027;
}
.priority.badge-tag.badge-success-light i {
  color: #5CB85C;
}
.priority.badge-tag.badge-warning-light i {
  color: #FDA700;
}

.task-wrap {
  border: 1px solid #E8E8E8;
  margin: 0 0 10px;
  padding: 15px 15px 5px;
  position: relative;
  border-radius: 5px;
}
.task-wrap::before {
  content: "";
  background-color: #FC0027;
  width: 3px;
  height: 100%;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
}
.task-wrap:last-child {
  margin-bottom: 0;
}

.task-info {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-wrap: wrap;
}
.task-info p {
  display: inline-block;
  margin: 0 24px 10px 0;
  color: #262A2A;
}
.task-info p i {
  color: #6F6F6F;
  margin-right: 10px;
}
.task-info .badge {
  margin: 0 10px 10px 0;
}
.task-info .badge:last-child {
  margin-right: 0;
}
.task-info .badge.badge-pill i {
  margin-right: 5px;
}

.task-actions {
  float: right;
}
.task-actions ul {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-wrap: wrap;
}
.task-actions ul li {
  margin: 0 24px 10px 0;
  color: #262A2A;
}
.task-actions ul li:last-child {
  margin-right: 0;
}
.task-actions ul li.task-time i {
  margin-right: 5px;
}
.task-actions ul li.task-date i {
  margin-right: 5px;
}
.task-actions ul li.task-owner {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.task-actions ul li.task-owner .task-user {
  margin-right: 10px;
  height: 24px;
}
.task-actions ul li.task-owner .task-user img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
@media (max-width: 767.98px) {
  .task-actions {
    float: left;
  }
}

.select-priority {
  position: relative;
}
.select-priority .select-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 99999;
  color: #e85b28;
}
.select-priority .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
}

.project-name {
  margin-bottom: 15px;
}
.project-name p {
  font-weight: 500;
  margin-bottom: 5px;
}
.project-name h4 {
  font-weight: 600;
}

.con-sidebar-title .priority {
  margin-bottom: 15px;
}
.con-sidebar-title p {
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 15px;
}
.con-sidebar-title.border-line {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 20px;
}

.kanban-list-items {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  margin: 0 20px 20px 0;
  padding: 15px;
  width: 100%;
  min-width: 315px;
}
.kanban-list-items:last-child {
  margin-right: 0;
}

.icons-social a {
  width: 30px;
  height: 30px;
  background: #F6F6F6;
  border-radius: 50%;
  color: #262A2A;
}
.icons-social a:hover {
  background: #FFEEEC;
  color: #e85b28;
}

.kanban-drag-wrap > div:last-child .kanban-card {
  margin-bottom: 0;
}

.pipeline-progress .progress {
  background: transparent;
  width: 70px;
  height: 5px;
}
.pipeline-progress .progress .progress-bar {
  width: 70px;
  height: 5px;
  border-radius: 5px;
}
.pipeline-progress .progress .progress-bar.progress-bar-success {
  background: #5CB85C;
}
.pipeline-progress .progress .progress-bar.progress-bar-violet {
  background: #4A00E5;
}
.pipeline-progress .progress .progress-bar.progress-bar-info {
  background: #1ECBE2;
}
.pipeline-progress .progress .progress-bar.progress-bar-warning {
  background: #FDA700;
}
.pipeline-progress .progress .progress-bar.progress-bar-green {
  background: #00918E;
}
.pipeline-progress .progress .progress-bar.progress-bar-danger {
  background: #FC0027;
}
.pipeline-progress span {
  margin-left: 10px;
  color: #262A2A;
  font-weight: 500;
}

.pipe-title .add-stage {
  color: #e85b28;
  font-weight: 500;
  margin-bottom: 15px;
  display: inline-block;
}
.pipe-title .add-stage i {
  margin-right: 8px;
}

.priority-info .dropdown .dropdown-toggle {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  padding: 5px 10px;
  font-weight: 500;
}
.priority-info .dropdown .dropdown-toggle[aria-expanded=true] > i {
  transition: all 0.2s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.priority-info .dropdown .dropdown-toggle::after {
  content: none;
}
.priority-info .dropdown .dropdown-toggle span {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.priority-info .dropdown .dropdown-toggle span i {
  font-size: 10px;
}
.priority-info .dropdown a {
  font-size: 14px;
  color: #262A2A;
}
.priority-info .dropdown a span {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.priority-info .dropdown a span i {
  font-size: 10px;
}
.priority-info .dropdown .dropdown-menu {
  width: 100%;
}

.select-pipeline {
  position: relative;
  margin-right: 8px;
}
.select-pipeline .pipe-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  z-index: 99999;
  transform: translateY(-50%);
  color: #262A2A;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single {
  height: 40px;
  border-radius: 5px;
  color: #262A2A;
  font-weight: 500;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
  line-height: 40px;
  color: #262A2A;
  font-weight: 500;
  padding-right: 30px;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single .select2-selection__arrow {
  height: 40px;
}

.pipeline-list {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.pipeline-list ul {
  margin-bottom: 15px;
}
.pipeline-list ul li {
  display: inline-block;
}
.pipeline-list ul li:first-child a {
  border-radius: 10px 0 0 10px;
}
.pipeline-list ul li:last-child a {
  border-radius: 0;
}
.pipeline-list ul li a {
  margin: 0 0 3px;
  padding: 12px 25px 12px 50px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  text-align: center;
  background: #F6F6F6;
  color: #262A2A;
  position: relative;
  min-width: 185px;
}
.pipeline-list ul li a::after {
  content: "";
  position: absolute;
  top: 0;
  right: -23px;
  width: 45px;
  height: 45px;
  -webkit-transform: scale(0.707) rotate(45deg);
  -ms-transform: scale(0.707) rotate(45deg);
  -moz-transform: scale(0.707) rotate(45deg);
  -transform: scale(0.707) rotate(45deg);
  z-index: 1;
  background: #F6F6F6;
  box-shadow: 2px -2px 0 1px #fff, 3px -3px 0 2px rgba(255, 255, 255, 0.1);
  border-radius: 0 5px 0 50px;
}
.pipeline-list ul li a.bg-info {
  color: #FFF;
}
.pipeline-list ul li a.bg-info::after {
  background: #1ECBE2;
}
.pipeline-list ul li a.bg-info:hover {
  background: #1ECBE2 !important;
}
.pipeline-list ul li a.bg-warning {
  color: #FFF;
}
.pipeline-list ul li a.bg-warning::after {
  background: #FDA700;
}
.pipeline-list ul li a.bg-warning:hover {
  background: #FDA700 !important;
}
.pipeline-list ul li a.bg-pending {
  color: #FFF;
  background: #4A00E5 !important;
}
.pipeline-list ul li a.bg-pending::after {
  background: #4A00E5;
}
.pipeline-list ul li a.bg-pending:hover {
  background: #4A00E5 !important;
}
.pipeline-list ul li a.bg-pink {
  color: #FFF;
}
.pipeline-list ul li a.bg-pink::after {
  background: #EA00B7;
}
.pipeline-list ul li a.bg-pink:hover {
  background: #EA00B7 !important;
}
.pipeline-list ul li a.bg-success {
  color: #FFF;
}
.pipeline-list ul li a.bg-success::after {
  background: #5CB85C;
}
.pipeline-list ul li a.bg-success:hover {
  background: #5CB85C !important;
}
.pipeline-list ul li a.bg-danger {
  color: #FFF;
}
.pipeline-list ul li a.bg-danger::after {
  background: #FC0027;
}
.pipeline-list ul li a.bg-danger:hover {
  background: #FC0027 !important;
}
.pipeline-list ul li a.bg-gray {
  color: #FFF;
  background: #E0E2E7;
}
.pipeline-list ul li a.bg-gray::after {
  background: #E0E2E7;
}
.pipeline-list ul li a.bg-gray:hover {
  background: #E0E2E7 !important;
}
@media (max-width: 575.98px) {
  .pipeline-list ul li a {
    width: calc(100% - 25px);
  }
}
@media (max-width: 575.98px) {
  .pipeline-list ul li {
    display: block;
  }
}

.campaign-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin: 0 0 24px;
  padding: 24px;
  border-radius: 5px;
}
@media (max-width: 1399.98px) {
  .campaign-box {
    margin: 0 0 24px;
    padding: 15px;
  }
}
.campaign-box .campaign-img {
  display: flex;
  align-items: center;
}
.campaign-box .campaign-img span {
  width: 44px;
  height: 44px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF;
  margin-right: 10px;
}
.campaign-box .campaign-img p {
  color: #262A2A;
  font-weight: 500;
}
.campaign-box h2 {
  color: #6F6F6F;
}
@media (max-width: 1399.98px) {
  .campaign-box h2 {
    font-size: 24px;
  }
}
@media (max-width: 991.98px) {
  .campaign-box h2 {
    font-size: 20px;
  }
}
.campaign-box.bg-danger-light {
  background-color: #FFEEEC;
}
.campaign-box.bg-danger-light span {
  background-color: #FC0027;
}
.campaign-box.bg-warning-light {
  background-color: #FFF7D8;
}
.campaign-box.bg-warning-light span {
  background-color: #FFA201;
}
.campaign-box.bg-purple-light {
  background-color: #F3EDFF;
}
.campaign-box.bg-purple-light span {
  background-color: #3C2371;
}
.campaign-box.bg-success-light {
  background-color: #E0F5D7;
}
.campaign-box.bg-success-light span {
  background-color: #00918E;
}

.campaign-tab {
  margin: 0 0 20px;
  padding: 15px 15px 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  background-color: #FFF;
  border-radius: 5px;
}
.campaign-tab ul li {
  margin-right: 15px;
}
.campaign-tab ul li a {
  position: relative;
  font-weight: 500;
  border-bottom: 4px solid #FFF;
  padding: 10px 10px 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.campaign-tab ul li a.active {
  border-color: #e85b28;
}
.campaign-tab ul li a span {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  border-radius: 50%;
  margin-left: 10px;
  font-size: 10px;
  font-weight: 600;
  color: #6F6F6F;
}
.campaign-tab ul li:last-child {
  margin-right: 0;
}

ul.project-mem {
  display: inline-flex;
  align-items: center;
}
ul.project-mem li {
  margin-left: -10px;
  display: inline-flex;
}
ul.project-mem li a {
  width: 24px;
  height: 24px;
}
ul.project-mem li:first-child {
  margin-left: 0;
}
ul.project-mem li a img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #FFF;
}
ul.project-mem li.more-set a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 12px;
  font-weight: 600;
  color: #6F6F6F;
}

.list-progress li {
  display: inline-block;
  margin-right: 15px;
}
.list-progress li h6 {
  font-weight: 600;
}
.list-progress li p {
  font-size: 12px;
  font-weight: 600;
  color: #6F6F6F;
}
.list-progress li:last-child {
  margin-right: 0;
}

.form-wrap .checkmarks.mem-plane-check {
  top: 3px;
}

.table-imgname.flag-image img {
  width: 24px;
  height: 18px;
  border-radius: 5px;
}

.table-imgname.flag-image {
  display: flex;
  align-items: center;
}

.location-flag-img {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.table-imgname.flag-image span {
  font-weight: 500;
  color: #262A2A;
}

#delete_request td span.badge {
  cursor: pointer;
}

.wh-14 {
  width: 14px;
  height: 14px;
}

.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background-color: #FFF;
  font-size: 0.813rem;
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  border-radius: 0.25rem;
  border: 1px dashed rgba(242, 101, 34, 0.3);
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: transparent;
}
.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: #677788;
}

.flatpickr-current-month .numInputWrapper span.arrowDown:after,
.flatpickr-calendar.arrowBottom:before {
  border-top-color: #677788;
}

.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  stroke: #e85b28;
}

.flatpickr-months,
.flatpickr-weekdays {
  background-color: rgba(242, 101, 34, 0.1);
}

.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  inset-block-start: 0;
  padding-block-start: 0.313rem;
  padding-inline: 0.313rem;
  padding-block-end: 0;
  color: #e85b28;
  fill: #e85b28;
}

.flatpickr-months .flatpickr-month {
  color: #e85b28;
  fill: #e85b28;
}

span.flatpickr-weekday {
  color: rgba(242, 101, 34, 0.8);
  font-weight: 700;
}

.flatpickr-day.today {
  border-color: #e85b28;
  background-color: #e85b28;
  color: #FFF;
}

.flatpickr-day {
  border-radius: 4px;
}

.icons-list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.icons-list li {
  display: block;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 18px;
  border-radius: 50px;
  border: 1px solid #9B9B9B;
  margin: 5px;
  box-shadow: 0 2px 3px rgb(215, 197, 255);
}
.icons-list .icons-list-item {
  display: block;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 18px;
  border-radius: 50px;
  border: 1px solid #9B9B9B;
  margin: 5px;
}
.icons-list .icons-list-item:hover {
  background-color: #9B9B9B;
  color: #e85b28;
  font-size: 24px;
}

/* Start:: sortable js */
ul.sortable-list li, ol.sortable-list li {
  background-color: #e85b28;
  margin: 3px 0;
  border: 1px solid #e85b28;
  border-radius: 0.3rem;
  font-weight: 500;
}
ul.sortable-list li.filtered, ol.sortable-list li.filtered {
  background-color: #FC0027;
  color: #FFF;
}
ul.sortable-list li.selected, ol.sortable-list li.selected {
  background-color: #e85b28;
  border: 1px solid #e85b28;
  color: #FFF;
}
ul.sortable-list .list-group-item, ol.sortable-list .list-group-item {
  background-color: rgba(242, 101, 34, 0.05);
}
ul.sortable-list .list-group-item + .list-group-item, ol.sortable-list .list-group-item + .list-group-item {
  border-top-width: 1px;
  background-color: rgba(242, 101, 34, 0.05);
}
ul#shared-right li, ul#cloning-right li, ul#disabling-sorting-right li, ol#shared-right li, ol#cloning-right li, ol#disabling-sorting-right li {
  background-color: rgba(255, 162, 1, 0.05);
  border: 1px solid rgba(255, 162, 1, 0.05);
}
ul .handle, ol .handle {
  cursor: grab;
}

.grid-square {
  width: 100px;
  height: 100px;
  display: inline-block;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 0.5rem;
  margin-block-end: 1.5rem;
  margin-inline-end: 1.5rem;
  padding: 20px;
}

.nested-sortable, .nested-1, .nested-2, .nested-3 {
  margin-top: 5px;
}
.nested-sortable .list-group-item + .list-group-item, .nested-1 .list-group-item + .list-group-item, .nested-2 .list-group-item + .list-group-item, .nested-3 .list-group-item + .list-group-item {
  border-top-width: 1px;
}

.nested-1, .nested-2, .nested-3 {
  border: 1px solid rgba(255, 162, 1, 0.05);
  font-weight: 500;
}

/* End:: sortable js */
/* Start::Leaflet Maps */
#map,
#map1,
#map-popup,
#map-custom-icon,
#interactive-map {
  height: 18.75rem;
  z-index: 10;
}

/* End::Leaflet Maps */
/* Start::Vector Maps */
.jvm-zoom-btn {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border: 1px solid #E8E8E8;
  font-size: 20px;
}

#vector-map,
#marker-map,
#marker-image-map,
#lines-map,
#us-map,
#canada-map,
#spain-map,
#russia-map {
  height: 21.875rem;
}

.jvm-tooltip {
  background-color: #1a1c1e;
}

#vector-map #jvm-regions-group path,
#marker-map #jvm-regions-group path,
#marker-image-map #jvm-regions-group path,
#lines-map #jvm-regions-group path,
#users-map #jvm-regions-group path {
  fill: #f8f9fa;
}

.jvm-zoom-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.jvm-zoom-btn.jvm-zoomin {
  inset-block-start: 5px;
}

#jvm-markers-labels-group text {
  fill: #9595b5;
}

/* End::Vector Maps */
/* Start::Google Maps */
#google-map,
#google-map-overlay,
#map-layers,
#map-markers,
#streetview-map,
#map-geofencing {
  height: 18.75rem;
}

.google-map-overlay {
  display: block;
  text-align: center;
  color: #FFF;
  font-size: 1.25rem;
  line-height: 0.875rem;
  opacity: 0.8;
  background: #e85b28;
  border: solid 0.188rem #e85b28;
  border-radius: 0.25rem;
  padding: 0 0.25rem;
}

.google-overlay_arrow {
  inset-inline-start: 50%;
  margin-inline-start: -1rem;
  width: 0;
  height: 0;
  position: absolute;
}

.google-overlay_arrow.above {
  inset-block-end: -0.938rem;
  border-inline-start: 0.938rem solid transparent;
  border-inline-end: 1rem solid transparent;
  border-block-start: 1rem solid #336699;
}

.google-overlay_arrow.below {
  inset-block-start: -0.938rem;
  border-inline-start: 1rem solid transparent;
  border-inline-end: 1rem solid transparent;
  border-block-end: 1rem solid #336699;
}

/* End::Google Maps */
/* Start:Pickers */
.flatpickr-time .flatpickr-am-pm {
  width: 36%;
}

[dir=rtl] .flatpickr-input {
  text-align: start;
}

.flatpickr-calendar {
  background-color: #FFF;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border: 1px solid #E8E8E8;
  font-size: 14px;
}

.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  color: #000;
  fill: #000;
}

.rangeMode .flatpickr-day {
  margin-top: 4px;
}

.flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px;
}

.flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0;
}

.flatpickr-monthDropdown-months,
.numInput {
  color: #000;
}

.flatpickr-day.today.inRange {
  color: #e85b28;
}

.dayContainer {
  padding: 0.25rem;
}

.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background-color: #FFF;
  font-size: 0.813rem;
}

.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 1.25rem;
  height: 1.25rem;
  padding: 0.25rem;
  fill: #e85b28;
}

.flatpickr-day.inRange {
  box-shadow: none;
}

.flatpickr-calendar.open {
  z-index: 105;
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  border-radius: 0.25rem;
  border: 1px dashed #e85b28;
}

.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: transparent;
}

.flatpickr-current-month .numInputWrapper span.arrowDown:after,
.flatpickr-calendar.arrowBottom:before {
  border-top-color: #9595b5;
}

.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: #9595b5;
}

.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: none;
}

.flatpickr-day {
  color: #565E5E;
  font-weight: 500;
}
.flatpickr-day.nextMonthDay, .flatpickr-day.prevMonthDay {
  opacity: 0.5;
}

.flatpickr-day.today {
  border-color: #e85b28;
  background-color: #e85b28;
  color: #FFF;
}

.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: #e85b28;
  color: #FFF;
  border-color: #e85b28;
}

.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange,
.flatpickr-day:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day:focus,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.nextMonthDay:focus {
  background: #f7f8f9;
  border-color: #E8E8E8;
}

.flatpickr-day.today:hover {
  background-color: #e85b28;
  border-color: #e85b28;
  color: #FFF;
}

.flatpickr-calendar.hasTime .flatpickr-time {
  border-top: 1px solid #E8E8E8;
}

.flatpickr-calendar.arrowTop:after,
.flatpickr-calendar.arrowTop:before {
  border-bottom-color: #E8E8E8;
}

.flatpickr-calendar.arrowBottom:after,
.flatpickr-calendar.arrowBottom:before {
  border-top-color: #E8E8E8;
}

.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus {
  background: #f7f8f9;
}

.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  color: #9595b5;
}

.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {
  inset-inline-start: 0;
}

.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  inset-block-start: 0;
  padding-block-start: 0.313rem;
  padding-inline: 0.313rem;
  padding-block-end: 0;
  color: #e85b28;
  fill: #e85b28;
}

@media (min-width: 420px) {
  .flatpickr-time .flatpickr-am-pm {
    padding: 0 1.875rem 0 0.5rem;
  }
}
.flatpickr-weekdays {
  border-block-end: 1px solid #E8E8E8;
}

.numInputWrapper span.arrowUp {
  top: -0.125rem;
}

.flatpickr-current-month .numInputWrapper {
  width: 3.5rem;
}

.flatpickr-calendar.hasTime {
  width: auto;
}

[dir=rtl] .flatpickr-months .numInputWrapper span {
  left: 0;
  right: inherit;
}

@media (max-width: 575.98) {
  .flatpickr-calendar {
    width: 250px;
  }
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  margin: -1px 2.25rem 0 0;
}

.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-current-month input.cur-year {
  padding-block: 0;
  padding-inline-start: 0;
  padding-inline-end: 0.5ch;
  font-size: 0.875rem;
  font-weight: 500;
}

.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  stroke: #e85b28;
}

.flatpickr-day {
  border-radius: 4;
}

.numInputWrapper:hover {
  background: transparent;
}

.numInputWrapper span {
  border: 0px;
}

.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-block-end-color: #e85b28;
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: #FFF;
}

.numInputWrapper span:hover {
  background: transparent;
}

.numInputWrapper span.arrowUp:after {
  border-inline-start: 0.25rem solid transparent;
  border-inline-end: 0.25rem solid transparent;
  border-block-end: 0.25rem solid #e85b28;
  inset-block-start: 75%;
}

.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-block-start-color: #e85b28;
}

.numInputWrapper span.arrowDown:after {
  border-inline-start: 0.25rem solid transparent;
  border-inline-end: 0.25rem solid transparent;
  border-block-start: 0.25rem solid #e85b28;
  inset-block-start: 15%;
}

span.flatpickr-weekday {
  color: #e85b28;
  font-weight: 700;
}

.flatpickr-months .flatpickr-month {
  color: #e85b28;
  fill: #e85b28;
}

.flatpickr-monthDropdown-months,
.numInput {
  color: #e85b28;
}

.pcr-app {
  background: #FFF;
}

.pcr-app .pcr-interaction .pcr-result {
  color: #565E5E;
  background: #f7f8f9;
}

.theme-container button,
.theme-container1 button,
.theme-container2 button {
  display: none;
}

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview {
  margin-inline-end: 0.75em;
}

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser,
.pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity {
  margin-inline-start: 0.75em;
}

.flatpickr-weekwrapper .flatpickr-weeks {
  box-shadow: 1px 0 0 #E8E8E8;
}

/* End:Pickers */
/* Start:: swiper js */
.swiper {
  border-radius: 5px;
}

[dir=rtl] .swiper {
  direction: ltr;
}
[dir=rtl] .swiper-backface-hidden .swiper-slide {
  direction: rtl;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-button-next,
.swiper-button-prev {
  width: 1.563rem;
  height: 1.563rem;
  color: #FFF;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 0.75rem;
  font-weight: 800;
}

.swiper-horizontal1 .swiper-slide {
  height: auto;
}

.swiper-pagination-bullet {
  width: 1.25rem;
  height: 0.25rem;
  border-radius: 5px;
  background: #FFF;
}

.swiper-pagination-bullet-active {
  background: #FFF;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: #5CB85C;
}

.swiper-pagination {
  color: #FFF;
}

.custom-pagination .swiper-pagination-bullet {
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.188rem;
  background-color: rgba(255, 255, 255, 0.3);
  color: #FFF;
  opacity: 1;
}
.custom-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #FFF;
  color: #000;
}

.swiper-scrollbar {
  background-color: rgba(255, 255, 255, 0.3);
}

.swiper-scrollbar-drag {
  background-color: #FFF;
}

.swiper.vertical {
  height: 21.875rem;
}

.swiper-preview {
  height: 80%;
  width: 100%;
}

.swiper-view {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}

.swiper-view .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.swiper-view .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-preview .swiper-wrapper {
  margin-block-end: 0.65rem;
}

.swiper-thumbs .swiper-slide img {
  border-radius: 5px;
}

/* End:: swiper js */
.files-list a.active {
  background: #FCE9E6;
}

.files-list a {
  border-radius: 5px;
}
.files-list a:hover, .files-list a.active {
  background: #FCE9E6;
  color: #262A2A !important;
}

.social-gallery-slider a, .email-attach a {
  position: relative;
  transition: 0.5s all;
}
.social-gallery-slider a span, .email-attach a span {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translatex(-50%);
  transition: 0.5s all;
  background: #FFF;
  opacity: 0;
}
.social-gallery-slider a span i, .email-attach a span i {
  color: #171724;
  opacity: 1;
}
.social-gallery-slider a:hover, .email-attach a:hover {
  transition: 0.5s all;
}
.social-gallery-slider a:hover span, .email-attach a:hover span {
  top: 50%;
  transform: translate(-50%, -50%);
  transition: 0.5s all;
  opacity: 0.5;
}
.social-gallery-slider a:hover::before, .email-attach a:hover::before {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: #262A2A;
  opacity: 0.8;
  position: absolute;
  transition: 0.5s all;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.social-gallery-slider a img, .email-attach a img {
  transition: 0.5s all;
}

.post-textarea {
  padding-top: 60px;
  padding-left: 68px;
}

.text-area-avatar {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
}

.template-more-links a {
  position: relative;
}
.template-more-links a + a {
  margin-left: 10px;
  padding-left: 10px;
}
.template-more-links a + a::before {
  content: "/";
  position: absolute;
  left: -2px;
  top: 50%;
  transform: translateY(-50%);
}

.custom-nav {
  display: flex;
  align-items: center;
}
.custom-nav button {
  width: 16px;
  height: 16px;
  background: #FFF;
  border: 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-nav button:hover {
  background: #171724;
  color: #FFF;
}

.fs-5 {
  font-size: 5px !important;
}

.fs-6 {
  font-size: 6px !important;
}

.btn.btn-icon:hover {
  background: #EAEAEA;
  color: #171724;
}

.kanban-drag-wrap {
  min-width: 260px;
  min-height: 50px;
}

.dropdown-toggle.btn.btn-white.text-dark {
  color: #171724 !important;
}

.bg-transparent-secondary {
  background: #EDF2F4;
}

.bg-soft-skyblue {
  background: #D3F5FC;
}

.bg-soft-pink {
  background: #FFDBEC;
  color: #FD3995;
}

.bg-skyblue {
  background-color: #0DCAF0 !important;
}

.btn-white {
  background: #FFF;
}

.welcome-wrap {
  padding: 40px 40px 24px;
  background: #3C2371;
  border-radius: 5px;
  position: relative;
  z-index: 1;
}
@media (max-width: 767.98px) {
  .welcome-wrap {
    padding: 20px 20px 4px;
  }
}
.welcome-wrap .welcome-bg-01 {
  position: absolute;
  top: 0;
  left: 0;
}
.welcome-wrap .welcome-bg-01 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.welcome-wrap .welcome-bg-02 {
  position: absolute;
  top: 20%;
  left: 40%;
  z-index: -1;
}
.welcome-wrap .welcome-bg-03 {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
}

#company-chart .apexcharts-bar-series .apexcharts-series path:hover {
  fill: #e85b28;
}

.fs-4 {
  font-size: 4px !important;
}

.pricing-content {
  padding: 15px;
}
.pricing-content .price-hdr {
  margin: 0 0 14px 0;
  display: flex;
  align-items: center;
}
.pricing-content .price-hdr::after {
  content: "";
  width: 90%;
  height: 1px;
  background: #9B9B9B;
}

.timeline-hrline {
  position: relative;
  z-index: 1;
}
.timeline-hrline::before {
  content: "";
  width: 1px;
  height: 100%;
  border-left: 1px solid #9B9B9B;
  position: absolute;
  left: -12px;
  top: 5px;
  z-index: -1;
}

.schedule-timeline > div:last-child .timeline-hrline::before {
  display: none;
}

.timeline-border {
  width: 24px;
  height: 24px;
  border: 1px solid #9B9B9B;
  border-radius: 12px;
}

.timeline-date {
  margin-right: 21px;
}

/******* Vendors ******/
.select2-container {
  min-width: 100% !important;
  z-index: 99;
}
.select2-container .select2-selection--single {
  height: 40px;
}

.select2-container--default .select2-selection--single {
  border: 1px solid rgba(145, 158, 171, 0.3);
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  border-radius: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #6F6F6F;
  line-height: 38px;
  border-radius: 5px;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 400;
  padding-right: 25px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered span {
  display: inline-flex;
  align-items: center;
}
.select2-container--default .select2-selection--single .select2-selection__rendered span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}
.select2-container--default .select2-selection--single .select {
  width: 219px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 40px;
  right: 6px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  position: absolute;
  top: 50%;
  left: 50%;
  border-color: #637381;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  margin-left: -6px;
  margin-top: -3px;
  width: 0;
  transform: rotate(45deg) translateY(-50%);
  -webkit-transform: rotate(45deg) translateY(-50%);
  -ms-transform: rotate(45deg) translateY(-50%);
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #000;
  border-width: 2px 0 0 2px;
  margin-top: 3px;
  padding: 3px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #e85b28;
  color: #FFF;
}

.select2-container--focus .select2-selection--single {
  background: #FFF !important;
  border-color: #e85b28;
}

span.select2-container.select2-container--default.select2-container--open {
  z-index: 9999;
}

.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--multiple {
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.select2-container--classic .select2-selection--single,
.select2-container--default .select2-selection--single,
.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--single .select2-selection__arrow,
.select2-container--default .select2-selection--multiple,
.select2-container--classic .select2-selection--single .select2-selection__arrow,
.select2-container--classic .select2-selection--single .select2-selection__rendered {
  border-color: #E8E8E8;
  color: #6F6F6F;
  height: 40px;
  line-height: 40px;
}

.select2-container--default .select2-selection--multiple {
  line-height: 27px;
  height: auto;
  min-height: 40px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice {
  padding-left: 5px;
  padding-right: 20px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display span {
  display: inline-flex;
  align-items: center;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  right: 0;
  left: auto;
}

.select2-results__option span {
  display: inline-flex;
  align-items: center;
}
.select2-results__option span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}

.select2-container--classic .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background-color: #F6F6F6;
  border-color: #F6F6F6;
  color: #6F6F6F;
  border-radius: 5px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #E8E8E8;
}

table.dataTable {
  margin: 0 !important;
  width: 100% !important;
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  right: 0.5em !important;
  content: "\\f175" !important;
  font-family: "Font Awesome 5 Free";
  bottom: 12px !important;
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
  font-weight: 600;
  line-height: 1px !important;
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  right: 13px !important;
  content: "\\f176" !important;
  font-family: "Font Awesome 5 Free";
  top: 50% !important;
  transform: translateY(-50%);
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
  font-weight: 600;
  line-height: 1px !important;
}

.dataTables_paginate .paging_numbers, #dataTables_paginate .paging_numbers {
  float: right;
}

.dataTables_info {
  padding-right: 15px;
  font-size: 12px;
  color: #424848;
  font-weight: 600;
}

.custom-select {
  min-width: 80px;
}

.dataTables_paginate .pagination, #dataTables_paginate .pagination {
  justify-content: end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.dataTables_paginate .pagination li, #dataTables_paginate .pagination li {
  margin: 0 2px;
}
.dataTables_paginate .pagination li a, #dataTables_paginate .pagination li a {
  background: #FFF;
  border-color: transparent;
  border-radius: 5px !important;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6F6F6F;
}
.dataTables_paginate .pagination li a:hover, #dataTables_paginate .pagination li a:hover {
  background: #00918E;
  color: #FFF;
}
.dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {
  background: #00918E;
  border-color: #00918E;
  border-radius: 5px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dataTables_paginate .pagination li.previous.disabled, .dataTables_paginate .pagination li.previous, #dataTables_paginate .pagination li.previous.disabled, #dataTables_paginate .pagination li.previous {
  width: auto;
  margin: 0 13px 0 0;
}
.dataTables_paginate .pagination li.previous.disabled a, .dataTables_paginate .pagination li.previous a, #dataTables_paginate .pagination li.previous.disabled a, #dataTables_paginate .pagination li.previous a {
  background-color: transparent;
  border: 0;
  width: auto;
  padding: 0;
}
.dataTables_paginate .pagination li.previous.disabled a i, .dataTables_paginate .pagination li.previous a i, #dataTables_paginate .pagination li.previous.disabled a i, #dataTables_paginate .pagination li.previous a i {
  margin-right: 8px;
}
.dataTables_paginate .pagination li.previous.disabled a:hover, .dataTables_paginate .pagination li.previous a:hover, #dataTables_paginate .pagination li.previous.disabled a:hover, #dataTables_paginate .pagination li.previous a:hover {
  color: #00918E;
}
.dataTables_paginate .pagination li.next.disabled, .dataTables_paginate .pagination li.next, #dataTables_paginate .pagination li.next.disabled, #dataTables_paginate .pagination li.next {
  width: auto;
  margin: 0 0 0 13px;
}
.dataTables_paginate .pagination li.next.disabled a, .dataTables_paginate .pagination li.next a, #dataTables_paginate .pagination li.next.disabled a, #dataTables_paginate .pagination li.next a {
  background-color: transparent;
  border: 0;
  width: auto;
  padding: 0;
}
.dataTables_paginate .pagination li.next.disabled a i, .dataTables_paginate .pagination li.next a i, #dataTables_paginate .pagination li.next.disabled a i, #dataTables_paginate .pagination li.next a i {
  margin-left: 8px;
}
.dataTables_paginate .pagination li.next.disabled a:hover, .dataTables_paginate .pagination li.next a:hover, #dataTables_paginate .pagination li.next.disabled a:hover, #dataTables_paginate .pagination li.next a:hover {
  color: #00918E;
}
@media (max-width: 767.98px) {
  .dataTables_paginate .pagination, #dataTables_paginate .pagination {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
}

.dataTables_length, #dataTables_length .dataTables_paginate,
#dataTables_paginate {
  margin-top: 15px !important;
}

.dataTables_length label, #dataTables_length label {
  display: flex;
  align-items: center;
  color: #6F6F6F;
  font-size: 14px;
}
.dataTables_length label .form-select, #dataTables_length label .form-select {
  width: 73px;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  color: #262A2A;
  margin: 0 8px;
}
@media (max-width: 767.98px) {
  .dataTables_length label, #dataTables_length label {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    margin-bottom: 10px;
  }
}

@media (max-width: 767.98px) {
  .datatable-length {
    text-align: center;
  }
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 23px;
}

table.dataTable thead > tr > th.no-sort.sorting_asc:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting_asc::after {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting::after {
  display: none;
}

.custom-table .table-responsive {
  border: 1px solid #E8E8E8;
  border-radius: 6px;
}

table.table.dataTable > tbody > tr {
  border-color: #E8E8E8;
}
table.table.dataTable > tbody > tr td {
  color: #6F6F6F;
}
table.table.dataTable > thead > tr {
  border-color: #E8E8E8;
}
table.table.dataTable > thead > tr th {
  color: #262A2A;
  font-size: 14px;
  font-weight: 500;
}

.active > .page-link, .page-link.active {
  z-index: auto;
  z-index: initial;
}

.modal-backdrop.show {
  opacity: 0.2 !important;
}

/* Custom Checkbox Styling for Permission Tables */
.custom-table input[type=checkbox],
.table-responsive input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
  cursor: pointer;
  accent-color: #e85b28;
  border: 2px solid #dee2e6 !important;
  border-radius: 0 !important;
  margin: 0 !important;
}
.custom-table input[type=checkbox]:hover,
.table-responsive input[type=checkbox]:hover {
  border-color: #e85b28 !important;
}
.custom-table input[type=checkbox]:checked,
.table-responsive input[type=checkbox]:checked {
  background-color: #e85b28 !important;
  border-color: #e85b28 !important;
}
.custom-table input[type=checkbox]:focus,
.table-responsive input[type=checkbox]:focus {
  outline: 2px solid rgba(232, 91, 40, 0.3) !important;
  outline-offset: 2px;
}
.custom-table .checkboxs input[type=checkbox],
.table-responsive .checkboxs input[type=checkbox] {
  position: relative !important;
  opacity: 1 !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 0 !important;
}
.custom-table .checkboxs .checkmarks,
.table-responsive .checkboxs .checkmarks {
  display: none !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #e85b28;
  border-color: #e85b28;
}

.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: #e85b28;
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #e85b28;
}

/**
 * Swiper 11.2.8
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 23, 2025
 */
/* FONT_START */
@font-face {
  font-family: "swiper-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  font-weight: 400;
  font-style: normal;
}
/* FONT_END */
:root {
  --swiper-theme-color: #007aff;
  /*
  --swiper-preloader-color: var(--swiper-theme-color);
  --swiper-wrapper-transition-timing-function: initial;
  */
}

:host {
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
}

.swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
  display: block;
}

.swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  transition-timing-function: initial;
  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
  box-sizing: content-box;
}

.swiper-android .swiper-slide,
.swiper-ios .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-horizontal {
  touch-action: pan-y;
}

.swiper-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
  display: block;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-autoheight,
.swiper-autoheight .swiper-slide {
  height: auto;
}

.swiper-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

.swiper-backface-hidden .swiper-slide {
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 3D Effects */
.swiper-3d.swiper-css-mode .swiper-wrapper {
  perspective: 1200px;
}

.swiper-3d .swiper-wrapper {
  transform-style: preserve-3d;
}

.swiper-3d {
  perspective: 1200px;
}

.swiper-3d .swiper-slide,
.swiper-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}

/* CSS Mode */
.swiper-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}

.swiper-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-css-mode.swiper-horizontal > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-css-mode.swiper-vertical > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

.swiper-css-mode.swiper-free-mode > .swiper-wrapper {
  scroll-snap-type: none;
}

.swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: none;
}

.swiper-css-mode.swiper-centered > .swiper-wrapper::before {
  content: "";
  flex-shrink: 0;
  order: 9999;
}

.swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: center center;
  scroll-snap-stop: always;
}

.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
  margin-inline-start: var(--swiper-centered-offset-before);
}

.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
  height: 100%;
  min-height: 1px;
  width: var(--swiper-centered-offset-after);
}

.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
  margin-block-start: var(--swiper-centered-offset-before);
}

.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before {
  width: 100%;
  min-width: 1px;
  height: var(--swiper-centered-offset-after);
}

/* Slide styles start */
/* 3D Shadows */
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

.swiper-3d .swiper-slide-shadow {
  background: rgba(0, 0, 0, 0.15);
}

.swiper-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-lazy-preloader {
  width: 42px;
  height: 42px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -21px;
  margin-top: -21px;
  z-index: 10;
  transform-origin: 50%;
  box-sizing: border-box;
  border: 4px solid #007aff;
  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
  border-radius: 50%;
  border-top-color: transparent;
}

.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,
.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {
  animation: swiper-preloader-spin 1s infinite linear;
}

.swiper-lazy-preloader-white {
  --swiper-preloader-color: #fff;
}

.swiper-lazy-preloader-black {
  --swiper-preloader-color: #000;
}

@keyframes swiper-preloader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Slide styles end */
.swiper-virtual .swiper-slide {
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
}

.swiper-virtual.swiper-css-mode .swiper-wrapper::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after {
  height: 1px;
  width: var(--swiper-virtual-size);
}

.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after {
  width: 1px;
  height: var(--swiper-virtual-size);
}

:root {
  --swiper-navigation-size: 44px;
  /*
  --swiper-navigation-top-offset: 50%;
  --swiper-navigation-sides-offset: 10px;
  --swiper-navigation-color: var(--swiper-theme-color);
  */
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  top: var(--swiper-navigation-top-offset, 50%);
  width: calc(44px / 44 * 27);
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  height: 44px;
  height: var(--swiper-navigation-size);
  margin-top: calc(0px - 44px / 2);
  margin-top: calc(0px - var(--swiper-navigation-size) / 2);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #007aff;
  color: var(--swiper-navigation-color, var(--swiper-theme-color));
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

.swiper-button-prev.swiper-button-hidden,
.swiper-button-next.swiper-button-hidden {
  opacity: 0;
  cursor: auto;
  pointer-events: none;
}

.swiper-navigation-disabled .swiper-button-prev,
.swiper-navigation-disabled .swiper-button-next {
  display: none !important;
}

.swiper-button-prev svg,
.swiper-button-next svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: center;
}

.swiper-rtl .swiper-button-prev svg,
.swiper-rtl .swiper-button-next svg {
  transform: rotate(180deg);
}

.swiper-button-prev,
.swiper-rtl .swiper-button-next {
  left: 10px;
  left: var(--swiper-navigation-sides-offset, 10px);
  right: auto;
}

.swiper-button-next,
.swiper-rtl .swiper-button-prev {
  right: 10px;
  right: var(--swiper-navigation-sides-offset, 10px);
  left: auto;
}

.swiper-button-lock {
  display: none;
}

/* Navigation font start */
.swiper-button-prev:after,
.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: 44px;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  font-feature-settings: ;
  font-variant: normal;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after {
  content: "prev";
}

.swiper-button-next,
.swiper-rtl .swiper-button-prev {
  right: 10px;
  right: var(--swiper-navigation-sides-offset, 10px);
  left: auto;
}

.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: "next";
}

/* Navigation font end */
:root {
  /*
  --swiper-pagination-color: var(--swiper-theme-color);
  --swiper-pagination-left: auto;
  --swiper-pagination-right: 8px;
  --swiper-pagination-bottom: 8px;
  --swiper-pagination-top: auto;
  --swiper-pagination-fraction-color: inherit;
  --swiper-pagination-progressbar-bg-color: rgba(0,0,0,0.25);
  --swiper-pagination-progressbar-size: 4px;
  --swiper-pagination-bullet-size: 8px;
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-height: 8px;
  --swiper-pagination-bullet-border-radius: 50%;
  --swiper-pagination-bullet-inactive-color: #000;
  --swiper-pagination-bullet-inactive-opacity: 0.2;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  --swiper-pagination-bullet-vertical-gap: 6px;
  */
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}

.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}

.swiper-pagination-disabled > .swiper-pagination,
.swiper-pagination.swiper-pagination-disabled {
  display: none !important;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  bottom: 8px;
  bottom: var(--swiper-pagination-bottom, 8px);
  top: auto;
  top: var(--swiper-pagination-top, auto);
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: scale(0.33);
  position: relative;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.swiper-pagination-bullet {
  width: 8px;
  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
  height: 8px;
  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
  display: inline-block;
  border-radius: 50%;
  border-radius: var(--swiper-pagination-bullet-border-radius, 50%);
  background: #000;
  background: var(--swiper-pagination-bullet-inactive-color, #000);
  opacity: 0.2;
  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
}

button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}

.swiper-pagination-bullet:only-child {
  display: none !important;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  opacity: var(--swiper-pagination-bullet-opacity, 1);
  background: #007aff;
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-vertical > .swiper-pagination-bullets,
.swiper-pagination-vertical.swiper-pagination-bullets {
  right: 8px;
  right: var(--swiper-pagination-right, 8px);
  left: auto;
  left: var(--swiper-pagination-left, auto);
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}

.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 6px 0;
  margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
  display: block;
}

.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}

.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
}

.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

/* Fraction */
.swiper-pagination-fraction {
  color: inherit;
  color: var(--swiper-pagination-fraction-color, inherit);
}

/* Progress */
.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  background: var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, 0.25));
  position: absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: #007aff;
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}

.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}

.swiper-horizontal > .swiper-pagination-progressbar,
.swiper-pagination-progressbar.swiper-pagination-horizontal,
.swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  height: var(--swiper-pagination-progressbar-size, 4px);
  left: 0;
  top: 0;
}

.swiper-vertical > .swiper-pagination-progressbar,
.swiper-pagination-progressbar.swiper-pagination-vertical,
.swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
  width: 4px;
  width: var(--swiper-pagination-progressbar-size, 4px);
  height: 100%;
  left: 0;
  top: 0;
}

.swiper-pagination-lock {
  display: none;
}

:root {
  /*
  --swiper-scrollbar-border-radius: 10px;
  --swiper-scrollbar-top: auto;
  --swiper-scrollbar-bottom: 4px;
  --swiper-scrollbar-left: auto;
  --swiper-scrollbar-right: 4px;
  --swiper-scrollbar-sides-offset: 1%;
  --swiper-scrollbar-bg-color: rgba(0, 0, 0, 0.1);
  --swiper-scrollbar-drag-bg-color: rgba(0, 0, 0, 0.5);
  --swiper-scrollbar-size: 4px;
  */
}

.swiper-scrollbar {
  border-radius: 10px;
  border-radius: var(--swiper-scrollbar-border-radius, 10px);
  position: relative;
  touch-action: none;
  background: rgba(0, 0, 0, 0.1);
  background: var(--swiper-scrollbar-bg-color, rgba(0, 0, 0, 0.1));
}

.swiper-scrollbar-disabled > .swiper-scrollbar,
.swiper-scrollbar.swiper-scrollbar-disabled {
  display: none !important;
}

.swiper-horizontal > .swiper-scrollbar,
.swiper-scrollbar.swiper-scrollbar-horizontal {
  position: absolute;
  left: 1%;
  left: var(--swiper-scrollbar-sides-offset, 1%);
  bottom: 4px;
  bottom: var(--swiper-scrollbar-bottom, 4px);
  top: auto;
  top: var(--swiper-scrollbar-top, auto);
  z-index: 50;
  height: 4px;
  height: var(--swiper-scrollbar-size, 4px);
  width: calc(100% - 2 * 1%);
  width: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));
}

.swiper-vertical > .swiper-scrollbar,
.swiper-scrollbar.swiper-scrollbar-vertical {
  position: absolute;
  left: auto;
  left: var(--swiper-scrollbar-left, auto);
  right: 4px;
  right: var(--swiper-scrollbar-right, 4px);
  top: 1%;
  top: var(--swiper-scrollbar-sides-offset, 1%);
  z-index: 50;
  width: 4px;
  width: var(--swiper-scrollbar-size, 4px);
  height: calc(100% - 2 * 1%);
  height: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));
}

.swiper-scrollbar-drag {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  background: var(--swiper-scrollbar-drag-bg-color, rgba(0, 0, 0, 0.5));
  border-radius: 10px;
  border-radius: var(--swiper-scrollbar-border-radius, 10px);
  left: 0;
  top: 0;
}

.swiper-scrollbar-cursor-drag {
  cursor: move;
}

.swiper-scrollbar-lock {
  display: none;
}

/* Zoom container styles start */
.swiper-zoom-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.swiper-zoom-container > img,
.swiper-zoom-container > svg,
.swiper-zoom-container > canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Zoom container styles end */
.swiper-slide-zoomed {
  cursor: move;
  touch-action: none;
}

/* a11y */
.swiper .swiper-notification {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0;
  z-index: -1000;
}

.swiper-free-mode > .swiper-wrapper {
  transition-timing-function: ease-out;
  margin: 0 auto;
}

.swiper-grid > .swiper-wrapper {
  flex-wrap: wrap;
}

.swiper-grid-column > .swiper-wrapper {
  flex-wrap: wrap;
  flex-direction: column;
}

.swiper-fade.swiper-free-mode .swiper-slide {
  transition-timing-function: ease-out;
}

.swiper-fade .swiper-slide {
  pointer-events: none;
  transition-property: opacity;
}

.swiper-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-fade .swiper-slide-active {
  pointer-events: auto;
}

.swiper-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper.swiper-cube {
  overflow: visible;
}

.swiper-cube .swiper-slide {
  pointer-events: none;
  backface-visibility: hidden;
  z-index: 1;
  visibility: hidden;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
}

.swiper-cube .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-cube.swiper-rtl .swiper-slide {
  transform-origin: 100% 0;
}

.swiper-cube .swiper-slide-active,
.swiper-cube .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper-cube .swiper-slide-active,
.swiper-cube .swiper-slide-next,
.swiper-cube .swiper-slide-prev {
  pointer-events: auto;
  visibility: visible;
}

.swiper-cube .swiper-cube-shadow {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  z-index: 0;
}

.swiper-cube .swiper-cube-shadow:before {
  content: "";
  background: #000;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  filter: blur(50px);
}

.swiper-cube .swiper-slide-next + .swiper-slide {
  pointer-events: auto;
  visibility: visible;
}

/* Cube slide shadows start */
.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-top,
.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-bottom,
.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-left,
.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-right {
  z-index: 0;
  backface-visibility: hidden;
}

/* Cube slide shadows end */
.swiper.swiper-flip {
  overflow: visible;
}

.swiper-flip .swiper-slide {
  pointer-events: none;
  backface-visibility: hidden;
  z-index: 1;
}

.swiper-flip .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-flip .swiper-slide-active,
.swiper-flip .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

/* Flip slide shadows start */
.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-top,
.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-bottom,
.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-left,
.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-right {
  z-index: 0;
  backface-visibility: hidden;
}

/* Flip slide shadows end */
.swiper-creative .swiper-slide {
  backface-visibility: hidden;
  overflow: hidden;
  transition-property: transform, opacity, height;
}

.swiper.swiper-cards {
  overflow: visible;
}

.swiper-cards .swiper-slide {
  transform-origin: center bottom;
  backface-visibility: hidden;
  overflow: hidden;
}

a {
  text-decoration: none;
  color: #262a2a;
}

.ant-tooltip {
  display: none;
}

.data-table-card .ant-table-content .ant-table-tbody tr:nth-of-type(2n + 1) {
  background-color: #fff;
}
.data-table-card .ant-table-content .ant-table-tbody td {
  padding: 0.5rem;
}

.ant-table-cell-row-hover {
  background-color: #fff;
  background: #fff;
}

.ant-pagination-item.ant-pagination-item-active {
  background: #e85b28;
  border-color: #e85b28;
}
.ant-pagination-item.ant-pagination-item-active a,
.ant-pagination-item.ant-pagination-item-active .ant-pagination-item-link {
  color: #fff;
}
.ant-pagination-item.ant-pagination-item-active:hover {
  border-color: #e85b28;
}

h4,
.h4 {
  font-size: 1.125rem;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #e85b28;
  color: #fff;
}

.daterangepicker .calendar-table td.in-range {
  background-color: #fff;
}

.applyBtn.btn.btn-sm.btn-primary {
  color: #fff;
  background-color: #e85b28;
  border: 1px solid #e85b28;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

div .badge-status {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 8px;
  min-width: 64px;
  color: #FFF;
}

div .bg-success {
  background-color: #5CB85C !important;
}
div .bg-success.bg-opacity-10 {
  background-color: rgba(92, 184, 92, 0.1) !important;
}
div .bg-success.bg-opacity-25 {
  background-color: rgba(92, 184, 92, 0.25) !important;
}
div .bg-success.bg-opacity-50 {
  background-color: rgba(92, 184, 92, 0.5) !important;
}
div .bg-success.bg-opacity-75 {
  background-color: rgba(92, 184, 92, 0.75) !important;
}
div .bg-success.bg-opacity-100 {
  background-color: #5cb85c !important;
}

:where(.css-dev-only-do-not-override-djtmh8).ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
  background-color: #fff;
}

.css-1p3m7a8-multiValue {
  background-color: #f6f6f6;
  border-color: #f6f6f6;
  color: #6f6f6f;
  border-radius: 5px;
}

.stickybar {
  top: 0;
  position: sticky;
}

.select-details .css-1dimb5e-singleValue,
.select-details .css-1jqq78o-placeholder {
  padding-left: 15px;
}

div.css-13cymwt-control,
div.css-t3ipsp-control {
  min-width: 120px;
  border-color: #e8e8e8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
}

div.css-t3ipsp-control:hover {
  border-color: transparent;
}

span.p-dropdown-label.p-inputtext span {
  font-family: "Noto Sans", sans-serif;
}

.deals-details.react-datepicker__input-container {
  width: 450px !important;
}

div.react-datepicker-wrapper {
  display: block;
  padding: 0;
  border: 0;
}

span.form-icon {
  z-index: 1;
}

.img-checked {
  padding: 10px;
  background: rgb(49, 132, 199);
  color: white;
  border-radius: 20px;
  font-weight: bolder;
  position: relative;
  /* margin-top: 2px ; */
}

.section-notes-slider .notes-slider .slick-list .slick-slide div {
  margin-left: 12px !important;
}

.page-add-notes {
  display: flex;
  flex-wrap: wrap;
}

.visible .input-blocks .css-b62m3t-container .css-1dimb5e-singleValue {
  margin-left: 25px !important;
}

[data-layout-mode=dark_mode] .css-13cymwt-control {
  background-color: #1d1d42;
  border: 1px solid #67748E;
}

[data-layout-mode=dark_mode] .css-t3ipsp-control {
  background-color: #1d1d42;
}

[data-layout-mode=dark_mode] .css-1nmdiq5-menu {
  background-color: #1d1d42;
}

.form-sorts.dropdown .radio-btn-items {
  margin-top: 10px;
}

.p-dropdown-label.p-inputtext .p-d-flex.p-ai-center img,
.p-dropdown-item-label .p-d-flex.p-ai-center,
.p-dropdown-label.p-inputtext .p-clearfix img,
.p-dropdown-item-label .p-clearfix img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}

.p-d-flex.p-ai-center {
  display: flex;
  align-items: center;
}

.p-dropdown-items-wrapper ul.p-dropdown-items,
.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done {
  z-index: 100000000000 !important;
}

.swiper-container .slick-list {
  margin-left: -236px;
}

.p-dropdown.p-component.p-inputwrapper {
  height: 42px;
  line-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: #e8e8e8;
  color: #6f6f6f;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

div.p-clearfix {
  display: flex;
  align-items: center;
}

div.p-clearfix span,
span.p-dropdown-label.p-inputtext.p-placeholder {
  font-size: 14px;
}

.p-dropdown-trigger svg {
  width: 13px;
}

div.rti--container {
  border-color: #e8e8e8;
  color: #6f6f6f;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

span.rti--tag button {
  font-size: 10px;
}

.filter-dropdown-menu.dropdown-menu.dropdown-menu-md-end.show,
.filter-dropdown-menu.dropdown-menu {
  z-index: 11;
}

span.ant-picker-suffix {
  display: none !important;
}

.stickybar {
  position: sticky;
  top: 0;
}

.right-user-side.chat-rooms.theiaStickySidebar {
  max-height: 500px;
  overflow: auto;
}

.send-chat.comman-icon i.feather.feather-send {
  color: #fff;
}

.chat-footer form {
  background-color: #fff;
}

.nav.flex-column.nav-pills.todo-inbox i {
  margin-right: 10px;
}

.select-priority .css-1jqq78o-placeholder,
.select-priority .css-1dimb5e-singleValue {
  padding-left: 15px;
}

.form-sort .css-1jqq78o-placeholder,
.form-sort .css-1dimb5e-singleValue {
  padding-left: 20px;
}

.form-sort.select-bluk.space-not-select .css-1jqq78o-placeholder,
.form-sort.select-bluk.space-not-select .css-1dimb5e-singleValue {
  padding: 0;
}

.owl-carousel.folders-carousel.owl-theme .slick-slide > div,
.owl-carousel.files-carousel.owl-theme .slick-slide > div {
  margin-right: 10px;
}

[data-theme=dark] .ant-table-content table,
[data-theme=dark] .ant-table-thead tr th,
[data-theme=dark] .ant-pagination.ant-table-pagination.ant-table-pagination-right {
  background-color: #171724;
  color: #a3a6a6;
}

[data-theme=dark] .table tbody tr td .table-avatar a,
[data-theme=dark] td.ant-table-cell {
  color: #a3a6a6;
}

td .badge-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rsw-editor select {
  display: none;
}

.custom-table {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}

.join-contents .slick-slider div.slick-slide > div {
  margin-right: 10px;
}

.custom-react-clr {
  color: #6f6f6f;
}

div.popover {
  z-index: 9999;
}

div.rc-slider-track,
.rc-slider-tracks {
  background-color: #ed5565;
}

div.rc-slider-handle {
  border: solid 2px #ed5565;
}

span.rc-slider-dot-active {
  border-color: #ed5565;
}

div.rc-slider-handle:active {
  border-color: #ed5565;
  box-shadow: 0 0 5px #ed5565;
  cursor: grabbing;
}

.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ed5565;
  box-shadow: 0 0 0 5px #ed5565;
}

div.rc-slider-handle:hover {
  border-color: #ed5565;
}

div.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ed5565;
  box-shadow: 0 0 0 5px #ed5565;
}

[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
  background-color: #171724;
}
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody > tr > th,
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody > tr > td {
  border-color: #393947;
}
[data-theme=dark] :where(.css-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
  background: #171724;
}
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: #171724;
}
[data-theme=dark] .custom-table {
  border: 1px solid #393947;
}
[data-theme=dark] .css-13cymwt-control {
  background-color: #171724;
  border: 1px solid #393947;
}
[data-theme=dark] .react-datepicker__month-container,
[data-theme=dark] .react-datepicker__header {
  background-color: #393947;
}
[data-theme=dark] .css-t3ipsp-control {
  background: #171724;
  border: 1px solid #393947;
  color: #a3a6a6;
}
[data-theme=dark] .css-1dimb5e-singleValue {
  color: #a3a6a6;
}
[data-theme=dark] .css-b62m3t-container div.css-1nmdiq5-menu {
  background-color: #393947 !important;
}
[data-theme=dark] .react-select-29-listbox {
  background-color: #393947;
}
[data-theme=dark] .input-blocks input[type=text] {
  background: #1d1d42 !important;
}
[data-theme=dark] .p-dropdown.p-component.p-inputwrapper {
  background-color: #171724;
  border: 1px solid #393947;
  box-shadow: none;
}
[data-theme=dark] .p-dropdown-item {
  background-color: #171724;
  border: 1px solid #393947;
}
[data-theme=dark] .rti--container {
  background-color: #171724;
  border: 1px solid #393947;
  box-shadow: none;
}
[data-theme=dark] .rti--tag {
  background-color: #171724;
}
[data-theme=dark] .rti--input {
  background-color: #171724;
}

[data-sidebar=green] .clinicdropdown.theme a {
  background-color: #005351;
}

[data-sidebar=blue] .clinicdropdown.theme a {
  background-color: #2f0093;
}

[data-sidebar=dark] .clinicdropdown.theme a {
  background-color: #28283e;
}

[data-theme=dark] .header .header-left .logo img.white-logo {
  display: block;
}

[data-theme=dark] .chat-footer form {
  background-color: #28283e;
}

[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown.theme a {
  background-color: #28283e;
}

[data-theme=dark] .rsw-toolbar {
  background: grey;
}

div.css-b62m3t-container .react-select__option--is-focused {
  background-color: #e85b28;
  color: #fff;
}

div.css-b62m3t-container .react-select__option--is-selected {
  background-color: #e85b28;
  color: #fff;
}

.submenu .ti-ticket:before {
  content: "\\eb3d";
}

.form-icon .ti-search:before {
  content: "\\eb1c";
}

.form-icon .ti-calendar:before {
  content: "\\ea53";
}

i.ti-trash:before {
  content: "\\eb41";
}

[data-theme=dark] .header .header-left #toggle_btn {
  color: #fff;
}

i.ti-lock:before {
  content: "\\eae2";
}

i.ti-bell:before {
  content: "\\ea35";
}

[data-theme=dark] .login-wrapper .form-control {
  background-color: #ffffff;
  border-color: #e8e8e8;
}

[data-theme=dark] div.css-13cymwt-control,
[data-theme=dark] div.css-t3ipsp-control {
  border-color: none;
  box-shadow: none;
}

.mini-sidebar.expand-menu .subdrop ~ ul {
  display: block !important;
}

.mini-sidebar .subdrop ~ ul {
  display: none !important;
}

.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {
  margin-left: 30px;
}

.ti.ti-eye:before {
  content: "\\ea9a";
}

.ti.ti-user:before {
  content: "\\eb4d";
}

div.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme::before {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  right: 4px;
  position: absolute;
  top: -16px;
  z-index: 9;
}

.ti-check:before {
  content: "\\ea5e" !important;
}

.ti-arrow-down:before {
  content: "\\ea16" !important;
}

.select-pipeline .react-select__value-container {
  padding-left: 28px !important;
}

.modal-open .offcanvas.offcanvas-end {
  width: 700px !important;
}

.ant-table {
  font-family: "Noto Sans", sans-serif !important;
}

.ti-shield:before {
  content: "\\eb24" !important;
}

.ant-picker {
  border-color: #E5E7EB;
  color: #111827;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 5px;
  padding: 0.5rem 0.625rem;
  height: 38px;
  transition: all 0.5s;
  width: 100%;
  margin-bottom: 8px;
}

.select-color {
  top: 40%;
  right: 50%;
  transform: translate(50%, -50%);
  z-index: 9;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
}

.theme-colorselect.active .ant-color-picker-trigger {
  border-color: #F26522 !important;
}

.ant-color-picker-trigger .ant-color-picker-color-block {
  width: 26px !important;
  height: 43px !important;
}

i.ti-palette:before {
  content: "\\eb01";
}

.ant-color-picker {
  z-index: 99999999999;
}

.select-theme-color .ant-color-picker-trigger {
  min-width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
}

.ant-color-picker-trigger {
  border: none;
}

.select-theme-color .ant-color-picker-trigger .ant-color-picker-color-block {
  width: 27px !important;
  height: 27px !important;
  border-radius: 50% !important;
}

.slick-slide > div {
  margin-right: 10px;
}

.react-datepicker-popper {
  width: max-content !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/style/scss/main.scss","webpack://./src/style/scss/layout/_common.scss","webpack://./src/style/scss/utils/_variables.scss","webpack://./src/style/scss/utils/_mixins.scss","webpack://./src/style/scss/layout/_content.scss","webpack://./src/style/scss/layout/_header.scss","webpack://./src/style/scss/layout/_sidebar.scss","webpack://./src/style/scss/layout/_theme.scss","webpack://./src/style/scss/layout/_theme-settings.scss","webpack://./src/style/scss/layout/_notification.scss","webpack://./src/style/scss/components/_avatar.scss","webpack://./src/style/scss/components/_boostrap.scss","webpack://./src/style/scss/components/_button.scss","webpack://./src/style/scss/components/_badge.scss","webpack://./src/style/scss/components/_border.scss","webpack://./src/style/scss/components/_calendar.scss","webpack://./src/style/scss/components/_chart.scss","webpack://./src/style/scss/components/_call.scss","webpack://./src/style/scss/components/_chat.scss","webpack://./src/style/scss/components/_dropdown.scss","webpack://./src/style/scss/components/_email.scss","webpack://./src/style/scss/components/_file-manager.scss","webpack://./src/style/scss/components/_icons.scss","webpack://./src/style/scss/components/_progress.scss","webpack://./src/style/scss/components/_pagination.scss","webpack://./src/style/scss/components/_typography.scss","webpack://./src/style/scss/components/_alerts.scss","webpack://./src/style/scss/components/_popovers.scss","webpack://./src/style/scss/components/_forms.scss","webpack://./src/style/scss/components/_notes.scss","webpack://./src/style/scss/components/_todo.scss","webpack://./src/style/scss/components/_tables.scss","webpack://./src/style/scss/components/_accordion.scss","webpack://./src/style/scss/components/_breadcrumb.scss","webpack://./src/style/scss/components/_cards.scss","webpack://./src/style/scss/components/_tooltips.scss","webpack://./src/style/scss/components/_navs-tabs.scss","webpack://./src/style/scss/components/_ribbon.scss","webpack://./src/style/scss/components/_popup.scss","webpack://./src/style/scss/components/_grid.scss","webpack://./src/style/scss/base/_base.scss","webpack://./src/style/scss/base/_background.scss","webpack://./src/style/scss/pages/_contact.scss","webpack://./src/style/scss/pages/_dashboard.scss","webpack://./src/style/scss/pages/_error.scss","webpack://./src/style/scss/pages/_login.scss","webpack://./src/style/scss/pages/_settings.scss","webpack://./src/style/scss/pages/_report.scss","webpack://./src/style/scss/pages/_activity.scss","webpack://./src/style/scss/pages/_tasks.scss","webpack://./src/style/scss/pages/_analytics.scss","webpack://./src/style/scss/pages/_project.scss","webpack://./src/style/scss/pages/_leads.scss","webpack://./src/style/scss/pages/_campaign.scss","webpack://./src/style/scss/pages/_membership-plans.scss","webpack://./src/style/scss/pages/_ui-pages.scss","webpack://./src/style/scss/pages/_social-feed.scss","webpack://./src/style/scss/pages/_super-admin.scss","webpack://./src/style/scss/pages/_pricing.scss","webpack://./src/style/scss/vendors/_select2.scss","webpack://./src/style/scss/vendors/_datatables.scss","webpack://./node_modules/swiper/swiper-bundle.css"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,oBAAA;AAKA,qBAAA;ACLA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AFWJ;;AETA;EACI,mBCiLO;AHrKX;;AEVA;EACI,mBCWM;AHEV;;AEXA;EACI,mBC2KO;AH7JX;;AEXI;EACI,eCmaO;AHrZf;;AEXA;EACI,wBAAA;AFcJ;;AEZA;EAAU,yBAAA;AFgBV;;AEdA;EACI,yBAAA;AFiBJ;;AEbQ;EACI,qBCoJA;AHpIZ;;AEXI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBCzBE;ED0BF,6BAAA;EACA,WAAA;EACA,WCOA;EDNA,gBCtCe;EDuCf,UAAA;AFcR;AEbQ;EACI,mBCmOE;AHpNd;;AEXA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AFcJ;;AEZA;EACI,mBCyHO;AH1GX;;AEbA;EACI,mBC7CM;AH6DV;;AEdA;EACI,mBCmHO;AHlGX;;AEdI;EACI,eC2WO;AH1Vf;;AEdA;EACI,wBAAA;AFiBJ;;AEfA;EACI,yBAAA;AFkBJ;;AEhBA;EACI,yBAAA;AFmBJ;;AEdQ;EACI,qBC0FA;AHzEZ;;AEbA;EACI,kBAAA;AFgBJ;AEfI;EACI,yBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBC3CA;ED4CA,gBCzFa;ED4Fb,oBAAA;EAGA,mBAAA;EEDL,iBFEmC;AFiBtC;AI9EI;EFiDA;IEUD,iBFIuC;EFmBxC;AACF;AElBQ;EACI,iBAAA;AFoBZ;AElBQ;EACI,cCqKE;AHjJd;AElBQ;EACI,yBAAA;AFoBZ;AI5FI;EFiDA;IA0BQ,WAAA;EFqBV;AACF;AEnBI;EACI,aAAA;EACA,kBAAA;EACA,gBCvEA;EDwEA,yBAAA;EACA,8DAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;AFqBR;AI7GI;EF8EA;IAYQ,gBAAA;EFuBV;AACF;AIlHI;EF8EA;IAeQ,WAAA;IAAA,cAAA;IACA,OAAA;EFyBV;AACF;AEtBQ;EACI,cAAA;EACA,UAAA;AFwBZ;AErBI;EAGI,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AFuBR;AEtBQ;EACI,mBAAA;AFwBZ;AEvBY;EACI,iBAAA;AFyBhB;AI9II;EFkHI;IAMQ,eC6QD;EHnPb;AACF;AExBQ;EACI,cChHH;EDiHG,mBAAA;AF0BZ;AEzBY;EACI,cCxJN;AHmLV;AEvBI;EACI,mBAAA;AFyBR;AEvBY;EACI,aAAA;EACA,mBAAA;EACA,cCOL;EDNK,gBC5KO;ED6KP,kBAAA;EACA,kBAAA;AFyBhB;AExBgB;EACI,gBAAA;EACA,kCAAA;EE7FlB,kBF8FoC;EE7FpC,QF6F8C;EE1F9C,OF0F+D;EEnI/D,2BFoIqC;EEnIrC,mCFmIqC;EElIrC,+BFkIqC;EACnB,eCiPL;AHnNf;AE5BgB;EACI,kBAAA;AF8BpB;AE7BoB;EACI,gBAAA;AF+BxB;AExBQ;;;;EAII,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eC6NG;ED5NH,gBCxMW;EDyMX,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AF0BZ;AIzMI;EF8JI;;;;IAmBQ,kBAAA;EF+Bd;AACF;AE7BY;;;;;;;EAEI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,6CAAA;AFoChB;AEjCY;;;;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AFsChB;;AEhCA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;AFmCJ;;AEhCA;;EAEI,gCAAA;EACA,8BAAA;EACA,yBAAA;EACA,6CAAA;AFmCJ;;AEjCA;EAGI,aAAA;EAGA,mBAAA;EACA,eAAA;EACA,mBAAA;AFoCJ;AEnCI;EACI,qBAAA;AFqCR;AEpCQ;EACI,eAAA;AFsCZ;;AEjCA;;0DAAA;AAGA;;;;;;;;;EAWI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;AFkCJ;;AE/BA;;;;;;;;;;;;;;;;;;EAsBI,gCAAA;EACA,8BAAA;EACA,yBAAA;EACA,6CAAA;AF8BJ;;AE3BA;;;;;;;;;EAWI,aAAA;EACA,mBAAA;EACA,gBAAA;AF4BJ;;AEzBI;EACI,mBC3LI;ED4LJ,kBAAA;EACA,aAAA;EACA,gBAAA;AF4BR;AE3BQ;EACI,mBAAA;AF6BZ;AE5BY;EACI,eAAA;AF8BhB;AE3BQ;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AF6BZ;AE5BY;EACI,UAAA;EACA,mBClWN;EDmWM,WAAA;AF8BhB;AE5BY;EACI,4CAAA;EACA,kBAAA;AF8BhB;AE5BY;EACI,mBC1WN;ED2WM,kBAAA;AF8BhB;AE5BY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AF8BhB;AE7BgB;EACI,gBAAA;AF+BpB;AE7BgB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AF+BpB;AE7BgB;EACI,kBAAA;EACA,MAAA;EACA,iBAAA;EACA,aAAA;AF+BpB;AE7BgB;EACI,cAAA;AF+BpB;AE9BoB;EACI,cCpOZ;AHoQZ;AE/BwB;EACI,cC5XlB;AH6ZV;AE9BoB;EACI,gBAAA;AFgCxB;AE7BgB;EACI,cAAA;AF+BpB;AE9BoB;EACI,gBAAA;EACA,eCaT;EDZS,gBC3ZH;AH2brB;;AKpcA;ED2FE,yBC1FsB;EDsGrB,mBCrG0B;EDsG1B,iBCtGuC;ED6FxC,kBC5FoB;EDgGpB,OChG4C;EDwF5C,yBCvFsB;AL6cxB;AIpaI;EC7CJ;IDuGG,SCjG8B;IDkG9B,iBClGkC;ELgdnC;AACF;AK/cI;EDgGD,aC/FmC;EAC9B,iBAAA;ALidR;AI9aI;ECrCA;IDgGD,oBC5FuC;ELmdxC;AACF;;AMheA;EACI,YAAA;EACA,YAAA;EACA,gBHoDI;ECwCN,eE3FoB;EF4FpB,ME5F0B;EF6F1B,QE7F4B;EF+F5B,OE/FmC;EFuFnC,yBEtFsB;ANwexB;AMreY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;ANuehB;AMneI;EFyFD,UExFoC;EAC/B,kBAAA;ANqeR;AMpeQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBHsJA;EGrJA,iBAAA;EACA,mBAAA;EACA,kBHqYO;EGpYP,cHmKD;AHmUX;AIndI;EE3BI;IAUQ,YAAA;ENwed;AACF;AMveY;EACI,cHyJL;AHgVX;AMreY;EACI,UAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EFkFd,kBEjF+B;EACjB,eAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,cH0IL;EC9FT,kBE3CgC;EF4ChC,QE5CyC;EF6CzC,WE7C6C;EFM7C,2BELiC;EFMjC,mCENiC;EFOjC,+BEPiC;AN2enC;AI1gBI;EEmCA;IAEQ,SAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;IACA,cAAA;IACA,kBH2VO;IG1VP,8DHkWI;IC/Tb,SElCiC;IFmCjC,UEnCoC;IFsBrC,yBErB8B;IFZ9B,2BEa6B;IFZ7B,mCEY6B;IFX7B,+BEW6B;EN8e7B;AACF;AIzgBI;EEYA;IAiBQ,gBAAA;ENgfV;AACF;AM9eI;EACI,mBAAA;EACA,UAAA;EACA,0BAAA;EFtBN,wBEuByB;EFtBzB,gCEsByB;EFrBzB,4BEqByB;EFUzB,yBET0B;ANof5B;AMlfI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBH7CA;ECiDL,eEHmC;EFVpC,yBEW0B;ANsf5B;AMrfQ;EACI,qBAAA;EACA,cAAA;ANufZ;AMtfY;EACI,WAAA;EACA,cAAA;ANwfhB;AMvfgB;EACI,aAAA;ANyfpB;AI1jBI;EE0DI;IAWQ,kBAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;ENyfd;EMxfc;IACI,YAAA;EN0flB;AACF;AMvfQ;EACI,aAAA;ANyfZ;AIzkBI;EEuCA;IA4CQ,kBAAA;IACA,WAAA;EN0fV;AACF;AI/kBI;EE0FI;IACI,aAAA;ENwfV;AACF;AI3mBI;EEuHI;IACI,eHqSG;IGpSH,YAAA;IACA,kBAAA;ENufV;EMtfU;IACI,qBAAA;IACA,WAAA;ENwfd;EMvfc;IACI,sBH9FZ;IG+FY,cAAA;IACA,WAAA;IACA,WAAA;IACA,WAAA;IFlDjB,eEmDyC;IF3B1C,mBE4BmC;ENyfnC;EMxfkB;IACI,WAAA;EN0ftB;AACF;AMrfI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;ANufR;AMtfQ;EACI,yBHpJF;EGqJE,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;ANwfZ;AMvfY;EACI,WAAA;ANyfhB;AMnfY;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;ANqfhB;AMnfoB;EACI,kBAAA;EACA,SAAA;EFpItB,wBEqIyC;EFpIzC,gCEoIyC;EFnIzC,4BEmIyC;ANuf3C;AMrfoB;EACG,aAAA;ANufvB;AMrfoB;EF1IlB,yBE2IyC;EF1IzC,iCE0IyC;EFzIzC,6BEyIyC;ANyf3C;AMnfI;EACI,gBAAA;EACA,kBHiNW;EGhNX,YAAA;ANqfR;AItpBI;EE8JA;IAKQ,gBAAA;ENufV;AACF;AMrfY;EACI,gBAAA;EACA,eAAA;ANufhB;AMtfgB;EACI,cAAA;EACA,YAAA;EACA,gBHlKZ;EGmKY,kBHoMD;AHoTnB;AMvfoB;EACI,mBHhDZ;AHyiBZ;AMvfoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ANyfxB;AMxfwB;EACI,eH6Mb;EG5Ma,WHhLpB;EGiLoB,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBHiLT;EG9KS,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AN0f5B;AMvf4B;EACI,gBH/OT;EGgPS,cH9DrB;EG+DqB,gBAAA;ANyfhC;AMvf4B;EACI,gBHtPX;EGuPW,cHsBnB;AHmeb;AI5sBI;EEiNwB;IAIQ,eH6KrB;EH8Ub;AACF;AMnfI;EFnKD,YEoKmC;ANqftC;AMpfQ;EAGI,aAAA;EFxKT,sBEyKuC;ANsf1C;AMrfY;EACI,eH/QC;EGgRD,cH9PJ;EG+PI,gBH3QK;AHkwBrB;AMrfY;EACI,eHpRC;EGqRD,cH/FL;AHslBX;AMrfY;EACI,iBAAA;ANufhB;AMrfY;EACI,aAAA;ANufhB;AMjfY;EACI,0BAAA;EACA,SAAA;ANmfhB;AM9eI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;ANgfR;AI1vBI;EE4QQ;IAEQ,aAAA;ENgflB;AACF;AM7eQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AN+eZ;AI/wBI;EEkRI;IAgBQ,SAAA;ENifd;AACF;AM/eM;EACE,cAAA;EACA,cAAA;EACA,eAAA;ANifR;AM/eM;EAGE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WH1SA;EG2SA,WAAA;EACA,YAAA;EACA,kBH0DW;EGzDX,gBH1Ve;EG2Vf,eH2EO;EG1EP,eAAA;ANifR;AI3yBI;EE0SE;IAkBM,eAAA;ENmfV;AACF;AMlfQ;EACI,kBHkDO;AHkcnB;AMjfM;EACE,eHiEO;EGhEP,gBHtWe;EGuWf,cAAA;EACA,aAAA;EACA,mBAAA;ANmfR;AMjfM;EACE,iBAAA;ANmfR;AMhfI;EACI,kBAAA;EACA,iBAAA;ANkfR;AMjfQ;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EF7SV,yBE8S8B;ANqfhC;AIj1BI;EEgVI;IAcQ,aAAA;ENufd;AACF;AMtfY;EACI,kBAAA;EACA,WAAA;EACA,mBH5XN;EG6XM,WAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;ANwfhB;AMrfgB;EACI,eAAA;EACA,gBAAA;ANufpB;AMrfgB;EACI,eAAA;EACA,gBAAA;ANufpB;AMpfY;EACI,iBAAA;EACA,oBAAA;ANsfhB;AMrfgB;EACI,cAAA;ANufpB;AI/2BI;EEoXQ;IAOQ,gBAAA;ENwflB;AACF;AMvfgB;EACI,WAAA;EACA,cAAA;ANyfpB;AMtfoB;EACI,cH5Zd;AHo5BV;AMnfgB;EACI,SAAA;EACA,aAAA;ANqfpB;AMlfY;EACI,kBAAA;EACA,iBAAA;ANofhB;AMlfY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBH5RJ;EG6RI,cH5QL;EG6QK,kBH5CG;EG6CH,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;ANofhB;AMnfgB;EACI,mBH/RR;AHoxBZ;AMjfgB;EACI,iBAAA;ANmfpB;AM9egB;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ANgfpB;AM/eoB;EACI,WHzahB;EG0agB,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBHxEL;AHyjBnB;AM/eoB;EACI,WHlbhB;EGmbgB,gBH9dL;ECmFjB,kBE4YwC;EF3YxC,QE2YiD;EF1YjD,UE0YqD;EAC/B,mBHxdd;EGydc,WAAA;EACA,YAAA;EACA,eHnET;EGsES,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;ANmfxB;AMjfoB;EACI,eHxET;AH2jBf;AMjfoB;EACI,mBHted;EGuec,sBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;ANmfxB;AM/eqB;EAGG,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ANifxB;AMhfwB;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;ANkf5B;AMjf4B;EF1azB,iBE2a2D;ANmf9D;AM/eoB;EACI,aAAA;EACA,gBAAA;ANifxB;AMhfwB;EFlbrB,kBEmbuD;EAC9B,cAAA;EACA,mBAAA;EACA,gBAAA;ANkf5B;AMjf4B;EACI,WHzexB;AH49BR;AMjf4B;EACI,sDAAA;ANmfhC;AM/e4B;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ANifhC;AMxeI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EF/cL,kBEgdmC;EFzbpC,gBE0buB;AN0ezB;AIt/BI;EEugBA;IAOQ,aAAA;EN4eV;AACF;AM3eQ;EACI,cH1iBF;EG2iBE,eHlJG;EGmJH,gBHpjBO;EGqjBP,yBAAA;EF1dT,SE2diC;EF1djC,YE0doC;EFncrC,kBEoc2B;AN8e7B;AM7eY;EACI,mBHjjBN;EGkjBM,WH/gBR;AH8/BR;AM3eI;EACI,aAAA;EACA,WAAA;AN6eR;AI5gCI;EE6hBA;IAIQ,cH1jBF;IG2jBE,eHzJG;IG0JH,YAAA;IACA,iBAAA;IACA,WAAA;IACA,WAAA;IF3eT,eE4euC;IFrfxC,kBEsf4B;IFrf5B,MEqfqC;IFlfrC,OEkfiD;IACvC,cAAA;ENifV;AACF;AM9eI;EACI,aAAA;EACA,WHriBA;EGsiBA,eHzKO;EG0KP,YAAA;EACA,iBAAA;EFvfL,eEwfmC;ANgftC;AIniCI;EE6iBA;IAQQ,cAAA;ENkfV;AACF;AM/eQ;EACI,kBAAA;ANifZ;AI3iCI;EEyjBI;IAGQ,aAAA;ENmfd;AACF;AMlfY;EACI,0CAAA;EACA,2CAAA;EACA,YAAA;EFtgBb,4BEugB2C;EFhf5C,mBEif+B;ANofjC;AMnfgB;EACI,+BAAA;ANqfpB;AMlfY;EACI,6BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EF1hBd,kBE2hBgC;EF1hBhC,ME0hByC;EFzhBzC,QEyhB2C;ANsf7C;AInkCI;EEklBY;IACI,cAAA;IFjiBlB,kBEkiBoC;IF9hBpC,OE8hB4D;ENqf5D;EMpfkB;IACI,sBH5kBhB;EHkkCN;EMpfkB;IACI,6BAAA;IACA,yBAAA;IACA,gBAAA;IFziBtB,kBE0iBwC;IFziBxC,MEyiBiD;IFxiBjD,QEwiBmD;IFjiBlD,iBEkiBmD;ENwfpD;AACF;AMnfI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ANqfR;AMpfQ;EACI,mBAAA;EAAA,oBAAA;EACA,iBAAA;EACA,mBAAA;ANsfZ;AMrfY;EACI,cAAA;EACA,mBAAA;EAAA,oBAAA;ANufhB;AMlfQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eHzPG;EG0PH,cH7eD;EG8eC,aAAA;EACA,gCAAA;EACA,gBAAA;ANofZ;AMnfY;EACI,0BAAA;ANqfhB;AMnfY;EACI,0BAAA;EACA,gBAAA;ANqfhB;AMnfY;EACI,kBAAA;EACA,qBAAA;ANqfhB;AMnfY;EACI,eHxQD;EGyQC,iBAAA;ANqfhB;AInoCI;EEspBgB;IACI,aAAA;ENgftB;EM7ec;IACI,wBAAA;EN+elB;AACF;AMzeY;EACI,YAAA;AN2ehB;AMveI;EACI,qBAAA;EACA,kBAAA;ANyeR;AMxeQ;EACI,WAAA;EFzlBV,kBE0lB2B;AN0e7B;AMxeQ;EACI,sBAAA;EACA,YAAA;EACA,WAAA;EFvnBT,SEwnBiC;EFhoBlC,kBEioB4B;EF/nB5B,QE+nB0C;EF9nB1C,YE8nB4C;EFjmB5C,kBEkmB2B;EACjB,qBAAA;EACA,mBH3sBF;AHurCV;AMzeI;EACI,WHhrBA;EGirBA,aAAA;EACA,YAAA;EACA,eHpTO;EGqTP,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EFvoBL,eEwoBmC;EFjpBpC,kBEkpBwB;EFjpBxB,MEipBiC;EFhpBjC,QEgpBmC;AN6erC;AIjrCI;EEyrBA;IAaQ,cAAA;EN+eV;AACF;AM9eQ;EACI,cHluBF;EGmuBE,UAAA;ANgfZ;AM/eY;EACI,aAAA;ANifhB;AM9eQ;EACI,UAAA;ANgfZ;AM/eY;EACI,cHnkBL;EGokBK,iBAAA;EFxpBb,eEypB2C;ANif9C;;AM5eA;EACI,WAAA;AN+eJ;;AIhuCI;EEsvBQ;IACI,mBAAA;IACA,8BAAA;IACA,sCAAA;IACA,4BAAA;EN8ed;EM3eM;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;IFrrBT,UEsrBuC;IAC9B,sBAAA;EN6eV;EM5eU;IACI,cAAA;IACA,iBAAA;EN8ed;EM5eU;IACI,aAAA;EN8ed;EM3eM;IACI,wBAAA;EN6eV;EM3eM;IACI,wBAAA;EN6eV;EM1eU;IACI,wBAAA;EN4ed;EMxeU;IACI,yBAAA;EN0ed;EMxeU;IACI,yBAAA;EN0ed;EMxeU;IACI,aAAA;EN0ed;EMxeU;IACI,cAAA;EN0ed;EMxeU;IACG,UAAA;EN0eb;EMxeU;IF3tBT,eE4tB2C;IAC9B,aAAA;EN0ed;EMreU;IACI,aAAA;ENued;AACF;AMneA;EACI,kBAAA;EACA,mBAAA;ANqeJ;AMpeI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBHzqBI;EG0qBJ,UAAA;ANseR;AMleY;EACI,WAAA;EACA,YAAA;EACA,mBHxrBJ;EGyrBI,yBAAA;EACA,eHnbD;EGobC,kBHxcG;EGycH,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;ANoehB;AMnegB;EACI,eHhcL;EGicK,cHtrBT;EGurBS,kBHtdD;EGudC,iBAAA;EACA,WAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;ANqepB;AMpeoB;EACI,WH10BhB;EG20BgB,mBH12Bd;AHg1CV;AMpeoB;EACI,WH90BhB;EG+0BgB,mBHzsBb;AH+qCX;AMjeQ;EACI,kBAAA;ANmeZ;AMleY;EACI,eAAA;ANoehB;AMleY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eH1eD;EG2eC,kBH/fG;EGggBH,6BAAA;ANoehB;AMleY;EACI,cHl2BR;EGm2BQ,mBHttBF;EGutBE,yBAAA;ANoehB;AMnegB;EACI,WH92BZ;EG+2BY,mBHv2BZ;AH40CR;AMleY;EACI,cHv2BL;EGw2BK,mBH/rBH;AHmqCb;AMnegB;EACI,WHt3BZ;EGu3BY,mBH32BT;AHg1CX;AMleY;EACI,cH55BJ;EG65BI,mBHltBF;AHsrCd;AMnegB;EACI,WH93BZ;EG+3BY,mBHh6BR;AHq4CZ;;AM/dA;EACI,aAAA;ANkeJ;AIl3CI;EE+4BJ;IAGQ,cAAA;ENoeN;AACF;;AOp6CA;EAGI,aAAA;EACA,sBJmDI;EIlDJ,aAAA;EACA,aAAA;EHyFF,eGxFoB;EHyFpB,SGzF0B;EH2F1B,SG3FoC;EH4FpC,OG5FsC;EHoFtC,yBGnFsB;EACpB,YAAA;AP46CJ;AIx4CI;EG7CJ;IAWQ,mBAAA;IHgFN,yBG/E0B;IACpB,aAAA;IACA,gBJyCA;EHu4CN;AACF;AIl5CI;EG7CJ;IAiBQ,WAAA;EPk7CN;AACF;AOj7CI;EACI,mCAAA;APm7CR;AI15CI;EG1BA;IAGQ,sBAAA;EPq7CV;AACF;AOn7CI;EH+ED,aG9EmC;APq7CtC;AOp7CQ;EACI,mBAAA;APs7CZ;AOr7CW;EACK,mBJ8IJ;EI7II,kBJ+XG;EI9XH,aAAA;APu7ChB;AOt7CgB;EACI,WAAA;EACA,YAAA;EACA,kBJ0XD;AH8jCnB;AOt7CgB;EACI,iBAAA;EACA,SAAA;APw7CpB;AOv7CoB;EACI,eJwYT;EIvYS,gBJhCD;EIiCC,cJ2OV;EI1OU,kBAAA;APy7CxB;AOv7CoB;EACI,eJgYT;EI/XS,gBJxCH;EIyCG,cJoOX;EInOW,gBAAA;APy7CxB;AOn7CY;EACI,kCAAA;APq7ChB;AOj7CY;EACI,mBAAA;APm7ChB;AOj7CoB;EACI,WJXhB;AH87CR;AOj7CoB;EACI,cAAA;APm7CxB;AOh7CgB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;APk7CpB;AOh7CgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EHoBjB,kBGnB+C;EAC9B,kBAAA;EACA,cJjER;AHm/CZ;AOj7CoB;EACI,cAAA;APm7CxB;AOj7CoB;EACI,cAAA;APm7CxB;AOh7CoB;EACI,oCAAA;EACA,cAAA;EACA,kBAAA;APk7CxB;AOj7CwB;EACI,WJ7CpB;AHg+CR;AOj7CwB;EACI,iGAAA;APm7C5B;AOj7CwB;EACI,cAAA;APm7C5B;AOj7CwB;EACI,mBAAA;APm7C5B;AOl7C4B;EACI,qBAAA;APo7ChC;AOh7CoB;EACI,eJ6TT;EI5TS,gBJ3GH;EI4GG,cJoEb;AH82CX;AO96CoB;EACI,oCAAA;EACA,kBAAA;APg7CxB;AO/6CwB;EACI,iGAAA;APi7C5B;AO/6CwB;EACI,cAAA;APi7C5B;AO56CoB;EACI,aAAA;AP86CxB;AO56C4B;EACG,gBJhIV;EIiIU,eJvId;EIwIc,kBAAA;EACA,cAAA;EHrC5B,yBGsC0D;EAC9B,kBAAA;AP86C/B;AOz6CgB;EACI,cAAA;EACA,mBAAA;AP26CpB;AO16CoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;AP46CxB;AO36CwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBJzJP;EI0JO,eJ6Qb;EI5Qa,cJoBjB;EInBiB,kBAAA;EACA,WAAA;EH9DzB,YG+DuD;AP66C1D;AO56C4B;EACI,cJoBrB;EInBqB,eJwQjB;EIvQiB,mBJCpB;EIAoB,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AP86ChC;AO56C4B;EACI,eJ6PjB;EI5PiB,gBJ3KX;EI4KW,mBAAA;EACA,cJMrB;EILqB,iBAAA;AP86ChC;AO56C4B;EACI,cJvKtB;EIwKsB,mBJrHlB;EIsHkB,kBJiOb;AH6sCnB;AO76CgC;EACI,cJ3K1B;AH0lDV;AO76CgC;EACI,mBJ9K1B;EI+K0B,WJ5I5B;AH2jDR;AO56C4B;EACI,cJnLtB;AHimDV;AO76CgC;EACI,cJrL1B;AHomDV;AOx6C4B;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;AP06ChC;AOz6CgC;EACI,WJ9J5B;EI+J4B,mBAAA;AP26CpC;AOz6CgC;EACI,cAAA;AP26CpC;AOp6CgB;EACI,gBJtNG;EIuNH,eJ4ML;EI3MK,cJ3CT;EI4CS,kBAAA;EACA,yBAAA;APs6CpB;AOn6CoB;EACI,aAAA;APq6CxB;AOj6CoB;EACI,aAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;APm6CxB;AO/5CY;EACI,kBAAA;APi6ChB;AO/5CoB;EACI,SAAA;APi6CxB;AO/5C4B;EACI,kBAAA;EACA,eJzPf;EI0Pe,uBAAA;EACA,kBAAA;APi6ChC;AOh6CgC;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;APk6CpC;AOh6CgC;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;APk6CpC;AO55CwB;EACI,mBJ7GhB;AH2gDZ;AO75C4B;EACI,mBJ1PzB;EI2PyB,WJpOxB;AHmoDR;AO75C4B;EACI,uBAAA;AP+5ChC;AO55CwB;EACI,mBJ3Nd;EI4Nc,kBAAA;AP85C5B;AO75C4B;EACI,mBJjRtB;EIkRsB,WJ/OxB;AH8oDR;AO75C4B;EACI,cJrRtB;AHorDV;AO55CgC;EACI,+BAAA;EACA,gCAAA;AP85CpC;AOn5CY;EACI,gBAAA;APq5ChB;AOp5CgB;EACI,mBAAA;EACA,iBAAA;APs5CpB;AO/4C4B;EACI,iBAAA;APi5ChC;AO14CgC;EACI,iBAAA;AP44CpC;AOp4CwB;EACA,iBAAA;EACA,mBAAA;EACA,eJpVP;EIqVO,cJjEZ;AHu8CZ;AOr4CwB;EACI,WAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EHhO1B,mBGiO2C;EHjQ3C,kBGkQ4C;EHjQ5C,SGiQqD;EH9PrD,OG8PoE;APy4CtE;AOv4C4B;EACI,cJhVtB;AHytDV;AOx4CgC;EACA,mBAAA;EACA,sBAAA;AP04ChC;AOl4CQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eJwDG;EIvDH,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EHhSV,kBGiS4B;EHhS5B,SGgSqC;EH/RrC,WG+R0C;EHtU1C,0BGuU6B;EHtU7B,kCGsU6B;EHrU7B,8BGqU6B;EHtS7B,yBGuS8B;AP04ChC;AOz4CY;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AP24ChB;AOz4CY;EACI,WAAA;AP24ChB;AO14CgB;EACI,WAAA;AP44CpB;AOv4CY;EH9VV,wBG+ViC;EH9VjC,gCG8ViC;EH7VjC,4BG6ViC;EACnB,mBAAA;AP24ChB;AOv4CI;EACI,YAAA;EHpRN,4CAAA;AJgqDF;AOz4CI;EACI,YAAA;EACA,YAAA;EHzUN,yBG0U0B;EACpB,aAAA;AP64CR;AItwDI;EGqXA;IAMQ,wBAAA;EP+4CV;AACF;AO94CQ;EACI,uBAAA;EACA,4BAAA;APg5CZ;AI/wDI;EG6XI;IAIQ,sBAAA;EPk5Cd;AACF;AOh5CQ;EHzUL,uBG0UuC;APk5C1C;AIvxDI;EGoYI;IHzUL,aG4U0C;EPo5C3C;AACF;AOl5CQ;EACI,eJZG;EIaH,cJhQD;EIiQC,yBAAA;EACA,gBJ/aO;EIgbP,mBAAA;APo5CZ;AOl5CQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;APo5CZ;AOj5CoB;EACI,iEAAA;EACA,WJ/YhB;AHkyDR;AOh5CgB;EACI,gBJjcC;EIkcD,eJvcH;EIwcG,cJtbR;AHw0DZ;AOj5CoB;EACI,cJ1bd;AH60DV;AO94CQ;EAGI,2BAAA;EACA,qBAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,eJxCG;EIyCH,mCAAA;EACA,kCAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBJrdO;EC8CjB,0BGwa6B;EHva7B,kCGua6B;EHta7B,8BGsa6B;APk5C/B;AOj5CY;EACI,gBAAA;APm5ChB;AO94CI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;APg5CR;AO54CY;EH5bV,wBG6biC;EH5bjC,gCG4biC;EH3bjC,4BG2biC;APg5CnC;AO34CQ;EAGI,aAAA;EAEA,sBAAA;EHlYV,gBGmY2B;EACjB,gCAAA;EH3ZT,eG4ZuC;EHzaxC,yBG0a8B;AP+4ChC;AO94CY;EACI,qCAAA;EACA,WJjdR;AHi2DR;AO94CY;EACI,gBAAA;EACA,gBJlgBK;AHk5DrB;AO14CQ;EACI,WAAA;EACA,gBJ1gBS;EI2gBT,cAAA;EHtZV,kBGuZ2B;EH/a1B,gBGgbkC;EH/alC,aG+a4C;AP64C/C;AO54CY;EACI,iEAAA;EACA,WJneR;AHi3DR;AO74CgB;EACI,WJreZ;AHo3DR;AO54CY;EACI,iBAAA;AP84ChB;;AIx5DI;EGohBI;IACI,iBAAA;EPw4CV;EOt4CM;IACI,aAAA;EPw4CV;EOr4CU;IACI,UAAA;IACA,yBAAA;EPu4Cd;EOt4Cc;IACG,SAAA;EPw4CjB;EOl4Cc;IACI,YAAA;EPo4ClB;EO93Cc;IACI,UAAA;IACA,yBAAA;EPg4ClB;EO33CkB;IACI,aAAA;EP63CtB;EOx3CM;IACI,aAAA;EP03CV;EOn3C0B;IACI,aAAA;EPq3C9B;EOl3CsB;IACI,aAAA;EPo3C1B;EOl3CsB;IACI,eAAA;EPo3C1B;EO92CM;IACI,WAAA;IACA,gBAAA;EPg3CV;EO72CU;IACI,cAAA;EP+2Cd;EOv2CkB;IACI,cAAA;EPy2CtB;EOt2Cc;IACI,cAAA;EPw2ClB;EOp2CM;IACI,cAAA;IHliBV,yBGmiB8B;EPw2C9B;EOt2CM;IACI,YAAA;EPw2CV;EOn2C0B;IACI,qBAAA;IACA,cAAA;EPq2C9B;EOl2CsB;IACI,kBAAA;EPo2C1B;EOh2Cc;IACI,cAAA;EPk2ClB;EO91CM;IACI,YAAA;EPg2CV;EO71CE;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;EP+1CN;AACF;AO51CI;EACI,sBAAA;AP81CR;;AO11CI;EACI,uBAAA;AP61CR;AO11CQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBJhrBS;EIirBT,eJ1QG;EI2QH,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AP41CZ;AO11CQ;EACI,aAAA;EACA,uBAAA;AP41CZ;AOt1CY;EACI,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;APw1ChB;AOt1CY;EACI,kBAAA;EACA,sBAAA;APw1ChB;;AOj1CI;EACI,cAAA;APo1CR;;AOh1CI;EACI,cAAA;APm1CR;;AOh1CA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EHvoBF,eGwoBoB;EHvoBpB,SGuoB0B;EHpoB1B,OGooByC;APq1C3C;AOp1CI;EACI,cAAA;APs1CR;;AOl1CI;EACI,wBAAA;APq1CR;;AOj1CI;EACI,yBAAA;APo1CR;;AOj1CA;EACI,yBAAA;APo1CJ;;AOz0CgC;EACI,iBAAA;AP40CpC;AOr0CoC;EACI,iBAAA;APu0CxC;;AOzzCQ;EACI,UAAA;EACA,SAAA;EACA,QAAA;AP4zCZ;;AOxzCA;EACI,aAAA;AP2zCJ;;AOvzCA;EACE,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EAAA,aAAA;EACA,SAAA;EAAA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AP0zCF;;AQ7mEI;EACI,iBAAA;EACA,YAAA;ARgnER;AItkEI;EI5CA;IAOQ,gBAAA;ER+mEV;AACF;AI3kEI;EI5CA;IAUQ,eAAA;ERinEV;AACF;;AQ1mEA;EACI,sCAAA;EACA,uCAAA;EACA,qCAAA;EACA,+CAAA;AR6mEJ;;AQvmEY;;EACI,iBAAA;EACA,OAAA;AR2mEhB;AI7lEI;EIhBQ;;IAOQ,gBAAA;ER2mElB;AACF;AInmEI;EIhBQ;;IAUQ,eAAA;ER8mElB;AACF;AQ3mEgB;;EACI,iBAAA;EACA,OAAA;AR8mEpB;AI9mEI;EIFY;;IAOQ,gBAAA;ER8mEtB;AACF;AIpnEI;EIFY;;IAUQ,eAAA;ERinEtB;AACF;AQ7mEQ;;EACI,YAAA;EACA,iBAAA;EACA,OAAA;ARgnEZ;AIhoEI;EIaI;;IAQQ,gBAAA;ERgnEd;AACF;AItoEI;EIaI;;IAWQ,eAAA;IACA,OAAA;ERmnEd;AACF;AQlnEY;;EACI,cAAA;EACA,kBAAA;ARqnEhB;AIlpEI;EI2BQ;;IAIQ,eAAA;ERwnElB;AACF;AQrnEQ;;EACI,UAAA;EAAA,aAAA;EACA,SAAA;ARwnEZ;AQvnEY;;EACI,aAAA;AR0nEhB;AQxnEY;;EACI,MAAA;AR2nEhB;;AQlnEQ;;;EACI,UAAA;EAAA,aAAA;ARunEZ;AQtnEY;;;EACI,aAAA;AR0nEhB;AQvnEQ;;;EACI,cAAA;EACA,iBAAA;AR2nEZ;AI7sEI;EIgFI;;;IAIQ,WAAA;ER+nEd;AACF;AI7rEI;EIyDI;;;IAUQ,gBAAA;ERgoEd;AACF;AIpsEI;EIyDI;;;IAaQ,eAAA;IACA,OAAA;ERooEd;AACF;AQjoEY;;;EAII,iBAAA;ARkoEhB;AIxuEI;EIkGQ;;;IAEQ,UAAA;ER0oElB;AACF;AIxtEI;EI2EQ;;;IASQ,gBAAA;ER0oElB;AACF;AI/tEI;EI2EQ;;;IAYQ,eAAA;IACA,OAAA;ER8oElB;AACF;AQ3oEgB;;;EACI,iBAAA;AR+oEpB;AInwEI;EImHY;;;IAGQ,WAAA;ERmpEtB;AACF;AInvEI;EI4FY;;;IASQ,gBAAA;ERopEtB;AACF;AI1vEI;EI4FY;;;IAYQ,eAAA;IACA,OAAA;ERwpEtB;AACF;;AQ/oEQ;;EACI,YAAA;EACA,iBAAA;ARmpEZ;AIxwEI;EImHI;;IAOQ,gBAAA;ERmpEd;AACF;AI9wEI;EImHI;;IAUQ,eAAA;ERspEd;AACF;AQppEQ;;EACI,aAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;ARupEZ;AI3xEI;EIgII;;IASQ,YAAA;ERupEd;AACF;AIjyEI;EIgII;;IAYQ,WAAA;ER0pEd;AACF;AQxpEQ;;EACI,OAAA;EACA,QAAA;EACA,cAAA;AR2pEZ;AI7yEI;EI+II;;IAQQ,YAAA;ER2pEd;AACF;AInzEI;EI+II;;IAWQ,WAAA;ER8pEd;AACF;AQ3pEI;;EACI,eAAA;AR8pER;AQ7pEQ;;EACI,iBAAA;EACA,cAAA;ARgqEZ;AIl0EI;EIgKI;;IAOQ,gBAAA;ERgqEd;AACF;AIx0EI;EIgKI;;IAUQ,eAAA;ERmqEd;AACF;AQlqEY;;EACI,gBAAA;ARqqEhB;AQlqEQ;;EACI,cAAA;ARqqEZ;AQjqEQ;;EACI,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,UAAA;ARoqEZ;AI71EI;EIqLI;;IASQ,gBAAA;ERoqEd;AACF;AIn2EI;EIqLI;;IAYQ,eAAA;ERuqEd;AACF;AQlqE4B;;EACI,yBAAA;ARqqEhC;;AQ3pEI;EACI,iBAAA;EACA,cAAA;AR8pER;AIl3EI;EIkNA;IAOQ,gBAAA;ER6pEV;AACF;AIv3EI;EIkNA;IAUQ,eAAA;ER+pEV;AACF;AQ7pEY;EACI,kBAAA;AR+pEhB;AI/3EI;EI+NQ;IAGQ,4BAAA;ERiqElB;AACF;AQ3pEY;EACI,yBAAA;AR6pEhB;AI95EI;EIgQQ;IAGQ,yBAAA;ER+pElB;AACF;;AQzpEI;EACI,iBAAA;EACA,cAAA;AR4pER;;AQrpEI;EACI,UAAA;ARwpER;;AQppEI;EACI,UAAA;ARupER;AQrpEI;EACI,iBAAA;EACA,cAAA;ARupER;AI75EI;EIoQA;IAOQ,gBAAA;ERspEV;AACF;AIl6EI;EIoQA;IAUQ,eAAA;ERwpEV;AACF;;AQppEI;EACI,UAAA;ARupER;AQrpEI;EACI,iBAAA;EACA,cAAA;ARupER;AI/6EI;EIsRA;IAOQ,eAAA;ERspEV;AACF;AQlpEQ;EACI,aAAA;EACA,cAAA;EACA,UAAA;ARopEZ;AIz7EI;EIkSI;IAQQ,WAAA;ERmpEd;AACF;;AQ9oEI;EACQ,cAAA;ARipEZ;AIz9EI;EIuUA;IAMQ,cAAA;ERgpEV;AACF;AQ9oEI;EACI,OAAA;ARgpER;AQ/oEQ;EACI,cAAA;ARipEZ;AIp+EI;EIkVI;IAMQ,cAAA;ERgpEd;AACF;AQ5oEQ;EACI,WAAA;AR8oEZ;AQ3oEY;EACI,OAAA;AR6oEhB;AQ5oEgB;EACI,WAAA;AR8oEpB;AQzoEI;EACI,SAAA;EACA,UAAA;EAAA,aAAA;EACA,YAAA;AR2oER;AQ1oEQ;EACI,uBAAA;EACA,MAAA;AR4oEZ;AQ3oEY;EACI,uBAAA;AR6oEhB;AQ3oEY;EACI,aAAA;EACA,iBAAA;AR6oEhB;AQ1oEQ;EACI,gBAAA;AR4oEZ;AQ1oEQ;EACI,aAAA;AR4oEZ;AIj/EI;EIkVA;IAsBQ,SAAA;IACA,SAAA;ER6oEV;AACF;AI9gFI;EImYA;IAEQ,iBAAA;ER6oEV;AACF;AQ3oEY;EACI,aAAA;AR6oEhB;;AQtoEI;EACI,aAAA;ARyoER;AIngFI;EIyXA;IAGQ,cAAA;ER2oEV;AACF;AQzoEI;EAGI,aAAA;AR2oER;AQzoEI;EACI,cAAA;AR2oER;AIhhFI;EIoYA;IAGQ,aAAA;ER6oEV;AACF;;AQzoEI;EACI,cAAA;AR4oER;AQ1oEI;EACI,OAAA;AR4oER;AQ3oEQ;EACI,iBAAA;EACA,cAAA;AR6oEZ;AIhiFI;EIiZI;IAOQ,gBAAA;ER4oEd;AACF;AIriFI;EIiZI;IAUQ,eAAA;ER8oEd;AACF;AQ7oEY;EACI,gBAAA;AR+oEhB;AQ5oEQ;EACI,cAAA;AR8oEZ;;AQzoEI;EACI,sBL9ZA;EK+ZA,sCAAA;AR4oER;AQ1oEY;EACI,sBLlaR;AH8iFR;AIxjFI;EI+aI;IAEQ,YAAA;ER2oEd;AACF;AQzoEQ;EACI,cAAA;EACA,kBAAA;AR2oEZ;AQ1oEY;EACI,cAAA;AR4oEhB;AQ1oEY;EACI,aAAA;AR4oEhB;AQvoEgB;EACI,cLrTT;AH87EX;AQxoEoB;EACI,yBLhcL;EKicK,qBLjcL;EKkcK,yBAAA;AR0oExB;AQpoEI;EACI,cAAA;ARsoER;AQroEQ;EACI,aAAA;ARuoEZ;AQroEQ;EACI,MAAA;EACA,qCAAA;ARuoEZ;AQroEQ;EACI,uBAAA;ARuoEZ;AQroEQ;EACI,aAAA;ARuoEZ;AQroEQ;EACI,cAAA;ARuoEZ;AQnoEQ;EACI,WAAA;EACA,aAAA;EACA,gBLxdJ;EKydI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;ARqoEZ;AQnoEQ;EACI,aAAA;EACA,aAAA;EAEA,4BAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;ARooEZ;AQ/nEY;EACI,qBAAA;EACA,2BAAA;EACA,kCAAA;EACA,oCAAA;ARioEhB;AQhoEgB;EACI,WAAA;EACA,YAAA;ARkoEpB;AQ/nEY;EACI,aAAA;ARioEhB;AQ9nEQ;EACI,oCAAA;ARgoEZ;AQ5nEgB;EACI,wBAAA;EACA,8BAAA;EACA,8BAAA;AR8nEpB;AQ7nEoB;EACI,WAAA;EACA,YAAA;AR+nExB;AQ5nEgB;EACI,cAAA;AR8nEpB;AQ3nEY;EACI,qCAAA;AR6nEhB;;AQvnEI;EACI,cAAA;AR0nER;AQxnEI;EACI,OAAA;EACA,sBLzhBA;EK0hBA,mBAAA;AR0nER;AQznEQ;EACI,iBAAA;EACA,cAAA;AR2nEZ;AIlqFI;EIqiBI;IAOQ,gBAAA;ER0nEd;AACF;AIvqFI;EIqiBI;IAUQ,eAAA;ER4nEd;AACF;AQ3nEY;EACI,gBAAA;AR6nEhB;AQxnEgB;EACI,cL5aT;AHsiFX;AQznEoB;EACI,mBLvjBL;EKwjBK,cL3ab;AHsiFX;AQtnEQ;EACI,cAAA;ARwnEZ;AQvnEY;EACI,aAAA;ARynEhB;AQvnEY;EACI,cAAA;ARynEhB;AQrnEI;EACI,cL7bG;AHojFX;AQpnEQ;EACI,sBLrkBJ;EKskBI,8BAAA;ARsnEZ;AQrnEY;EACI,aAAA;EACA,YAAA;EAEA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;ARsnEhB;AQhnE4B;EACI,cLjdrB;AHmkFX;AQjnEgC;EACI,yBLhmBjB;EKimBiB,cLpdzB;AHukFX;AQjnEwC;EACI,qBLvdjC;AH0kFX;AQ9mEoC;EACI,qBL7d7B;AH6kFX;AQtmEI;EACI,iBAAA;EACA,cAAA;ARwmER;AIjuFI;EIunBA;IAOQ,gBAAA;ERumEV;AACF;AItuFI;EIunBA;IAUQ,eAAA;ERymEV;AACF;AQxmEQ;EACI,WAAA;EACA,aAAA;EACA,gBL5nBJ;EK6nBI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AR0mEZ;AIrvFI;EImoBI;IAUQ,SAAA;IACA,aAAA;ER4mEd;AACF;AQ1mEQ;EACI,WAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AR4mEZ;AIrwFI;EIipBI;IAUQ,SAAA;IACA,aAAA;ER8mEd;AACF;AQ1mEQ;EACI,WLxpBJ;AHowFR;;AQvmEI;EACI,cAAA;AR0mER;AQxmEI;EACI,iBAAA;EACA,YAAA;AR0mER;AItxFI;EI0qBA;IAOQ,gBAAA;ERymEV;AACF;AI3xFI;EI0qBA;IAUQ,eAAA;ER2mEV;AACF;AQ1mEQ;EACI,iBAAA;EACA,YAAA;AR4mEZ;AIpyFI;EIsrBI;IAOQ,gBAAA;ER2mEd;AACF;AIzyFI;EIsrBI;IAUQ,eAAA;ER6mEd;AACF;AQ1mEI;EACI,OAAA;EACA,eAAA;AR4mER;AQ3mEQ;EACI,iBAAA;EACA,cAAA;AR6mEZ;AItzFI;EIusBI;IAOQ,gBAAA;ER4mEd;AACF;AI3zFI;EIusBI;IAUQ,eAAA;ER8mEd;AACF;AQ7mEY;EACI,gBAAA;AR+mEhB;AQ5mEQ;EACI,cAAA;AR8mEZ;AQ7mEY;EACI,cAAA;AR+mEhB;AQ1mEQ;EACI,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,UAAA;AR4mEZ;AI/0FI;EI+tBI;IASQ,gBAAA;ER2mEd;AACF;AIp1FI;EI+tBI;IAYQ,eAAA;ER6mEd;AACF;AQxmE4B;EACI,yBAAA;AR0mEhC;;AQ/lEI;EACI,cAAA;ARkmER;AQhmEI;EACI,eAAA;ARkmER;AQ9lEY;EACI,eAAA;EACA,0BAAA;ARgmEhB;AQ5lE4B;EACI,yBAAA;AR8lEhC;AIj4FI;EIkyBwB;IAMQ,yBAAA;ER6lElC;AACF;;AIt4FI;EImzBA;IAEQ,WAAA;IACA,SAAA;ERslEV;AACF;AQrlEQ;EACI,aAAA;ARulEZ;AQplEI;EACI,UAAA;ARslER;AQrlEQ;EACI,aAAA;ARulEZ;AQnlEQ;EACI,aAAA;ARqlEZ;AQllEI;EACI,cAAA;ARolER;AQllEI;EACI,cAAA;ARolER;AQnlEQ;EACI,kBAAA;ARqlEZ;AQllEI;EACI,MAAA;EACA,qCAAA;ARolER;AQnlEQ;EACI,uBAAA;ARqlEZ;AQjlEQ;EACI,aAAA;ARmlEZ;AQhlEY;EACI,wBAAA;ARklEhB;AQ/kEQ;EACI,qBAAA;EACA,kCAAA;EACA,oCAAA;ARilEZ;AQhlEY;EACI,aAAA;ARklEhB;AQ/kEQ;EACI,qCAAA;ARilEZ;AQhlEY;EACI,uBAAA;ARklEhB;AQ9kEY;EACI,cAAA;ARglEhB;AQ7kEgB;EACI,wBAAA;AR+kEpB;AQ5kEY;EACI,uBAAA;EACA,8BAAA;EACA,gCAAA;AR8kEhB;AQ7kEgB;EACI,cAAA;AR+kEpB;;AQvkEI;EACI,aAAA;AR0kER;AQxkEI;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AR0kER;AQxkEI;EACI,wBAAA;AR0kER;AQxkEI;EACI,iBAAA;AR0kER;AIr8FI;EI03BA;IAGQ,eAAA;ER4kEV;AACF;AQ3kEQ;EACI,WAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AR6kEZ;AQ3kEQ;EACI,aAAA;AR6kEZ;AQ3kEQ;EACI,UAAA;AR6kEZ;AQ1kEI;EACI,QAAA;EACA,UAAA;EACA,WAAA;AR4kER;AI39FI;EIm5BQ;IAEQ,kBAAA;ER0kElB;AACF;AQvkEQ;EACI,iBAAA;EACA,eAAA;EACA,cAAA;ARykEZ;AQtkEY;EACI,cAAA;ARwkEhB;AQpkEI;EACI,eAAA;ARskER;AQnkEQ;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;ARqkEZ;AQpkEY;EACI,yBAAA;ARskEhB;AI7gGI;EIs8BQ;IAGQ,yBAAA;ERwkElB;AACF;AQrkEgB;EACI,iBAAA;ARukEpB;AI9/FI;EIs7BY;IAGQ,iBAAA;ERykEtB;AACF;AIngGI;EI47BoB;IAEQ,UAAA;ERykE9B;AACF;AQhkEY;EACI,iBAAA;ARkkEhB;AQjkEgB;EACI,eAAA;ARmkEpB;AQhkEoB;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;ARkkExB;;AI1iGI;EIm/BA;IAEQ,aAAA;ER0jEV;AACF;AIhjGI;EIw/BA;IAEQ,cAAA;ER0jEV;AACF;AIrjGI;EI8/BI;IAEQ,iBAAA;IAAA,iBAAA;ERyjEd;AACF;AQxjEY;EACI,wBAAA;AR0jEhB;AQrjEgB;EACI,wBAAA;ARujEpB;;AQhjEI;EACI,yBL//Bc;AHkjGtB;AQjjEI;EACI,OAAA;EACA,gCAAA;ARmjER;AQljEQ;EACI,cAAA;EACA,kBAAA;ARojEZ;AQjjEI;EACI,SAAA;EACA,yBL3gCc;AH8jGtB;AQljEQ;EACI,aAAA;ARojEZ;AQnjEY;EACI,aAAA;ARqjEhB;AQljEQ;EACI,MAAA;ARojEZ;AIzlGI;EI2iCY;IACI,OAAA;ERijElB;AACF;AQ5iEQ;EACI,aAAA;AR8iEZ;;AQ1iEA;EACI,yBLtiCkB;AHmlGtB;AQ5iEI;EACI,OAAA;EACA,gCAAA;AR8iER;AQ7iEQ;EACI,cAAA;EACA,kBAAA;AR+iEZ;AQ5iEI;EACI,SAAA;EACA,yBLjjCc;AH+lGtB;AQ7iEQ;EACI,aAAA;AR+iEZ;AQ9iEY;EACI,aAAA;ARgjEhB;AQ7iEQ;EACI,MAAA;AR+iEZ;AI1nGI;EIilCY;IACI,OAAA;ER4iElB;AACF;AQviEQ;EACI,aAAA;ARyiEZ;;AQpiEI;EACI,OAAA;EACA,yBLz7BG;EK07BH,qBL37BG;AHk+FX;AQtiEQ;EACI,iBAAA;EACA,cAAA;ARwiEZ;AIrnGI;EI2kCI;IAOQ,gBAAA;ERuiEd;AACF;AI1nGI;EI2kCI;IAUQ,eAAA;ERyiEd;AACF;AQxiEY;EACI,gBAAA;AR0iEhB;AQriEgB;EACI,WLplCZ;AH2nGR;AQtiEoB;EACI,mBLn9Bb;AH2/FX;AQniEQ;EACI,cAAA;ARqiEZ;AQpiEY;EACI,aAAA;ARsiEhB;AQpiEY;EACI,cAAA;ARsiEhB;AQliEI;EACI,cAAA;ARoiER;AI3qGI;EIsoCA;IAMQ,cAAA;ERmiEV;AACF;AQliEQ;EACI,WAAA;EACA,aAAA;EACA,mBL1+BD;EK2+BC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;ARoiEZ;AInqGI;EIunCI;IAUQ,SAAA;IACA,aAAA;ERsiEd;AACF;AQpiEQ;EACI,WAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;ARsiEZ;AInrGI;EIqoCI;IAUQ,SAAA;IACA,aAAA;ERwiEd;AACF;AQriEI;EACI,SAAA;EACA,UAAA;EAAA,aAAA;EACA,YAAA;ARuiER;AQtiEQ;EACI,uBAAA;EACA,MAAA;ARwiEZ;AQviEY;EACI,uBAAA;ARyiEhB;AQviEY;EACI,aAAA;EACA,iBAAA;ARyiEhB;AQtiEQ;EACI,gBAAA;ARwiEZ;AQtiEQ;EACI,aAAA;ARwiEZ;AI/sGI;EIopCA;IAsBQ,SAAA;IACA,SAAA;ERyiEV;AACF;AI5uGI;EIqsCA;IAEQ,iBAAA;ERyiEV;AACF;AQxiEQ;EACI,aAAA;AR0iEZ;AQriEY;EACI,OAAA;ARuiEhB;;AQjiEI;EACI,mBLhjCG;EKijCH,qBLjjCG;AHqlGX;AQniEQ;EACI,cAAA;ARqiEZ;AQniEQ;EACI,aAAA;ARqiEZ;AQ7hEgC;EACI,mBLlkCzB;AHimGX;AQxhE4B;EACI,cL9kCrB;AHwmGX;AQxhE4B;EACI,mBL7kCrB;AHumGX;AQxhE4B;EACI,mBLhlCrB;AH0mGX;AQphE4B;EACI,cL7vCtB;AHmxGV;AQ9gEqC;EACG,cLtwC9B;AHsxGV;AQ5gE4B;EACI,cLxmCrB;AHsnGX;AQ7gEgC;EACI,cL7wC1B;AH4xGV;AQ7gEgC;EACI,cL9mCzB;AH6nGX;AQ7gEgC;EACI,cLhnCzB;AH+nGX;AQ3gEgC;EACI,mBLjnCzB;AH8nGX;AQ5gEoC;EACI,cLxnC7B;AHsoGX;AQvgEwC;EACI,cL/nCjC;AHwoGX;AQxgE4C;EACI,cLpyCtC;AH8yGV;AQ9/D4B;EACI,uBAAA;ARggEhC;AQz/DgB;EACI,qBLvpCT;AHkpGX;AQp/DY;EACI,WL9xCR;AHoxGR;AQr/DgB;EACI,mBL7pCT;AHopGX;AQp/DY;EACI,mBL9pCL;AHopGX;AQp/DoB;EACI,cAAA;ARs/DxB;AQn/DgB;EACI,WL3yCZ;AHgyGR;AQn/DgB;EACI,oCAAA;EACA,gCAAA;ARq/DpB;AQj/DwB;EACI,WLpzCpB;AHuyGR;AQl/D4B;EACI,mBLnrCrB;AHuqGX;AQj/DwB;EACI,mBLvrCjB;AH0qGX;AQl/D4B;EACI,sBAAA;ARo/DhC;AQh/D4B;EACI,mBL9rCrB;AHgrGX;AQ7+DgC;EACI,mBLpsCzB;EKqsCyB,sBAAA;AR++DpC;AQr+DiC;EACI,mBLhtC1B;EKitC0B,sBAAA;ARu+DrC;AQ99DQ;EACI,yBLxtCD;EKytCC,qBL1tCD;AH0rGX;AIh2GI;EIu4CgB;IAEQ,aAAA;ER29D1B;AACF;AQp9DQ;EACI,yBL3uCD;EK4uCC,qBL7uCD;AHmsGX;AQp9DQ;EACI,WLr3CJ;EKs3CI,qBLhvCD;AHssGX;AQr9DY;EACI,mBLrvCL;AH4sGX;AQp9DQ;EACI,mBLtvCD;AH4sGX;AQr9DY;EACI,WL93CR;AHq1GR;AQp9DgB;EACI,cL5vCT;AHktGX;AQn9DY;EACI,WLt4CR;AH21GR;AQp9DgB;EACI,cL36CV;AHi4GV;AQl9DQ;EACI,WL74CJ;EK84CI,mBLzwCD;EK0wCC,qBL1wCD;AH8tGX;AQn9DY;EACI,WLj5CR;AHs2GR;AQn9DY;EACI,WLp5CR;EKq5CQ,mBLhxCL;EKixCK,qBLjxCL;AHsuGX;AQp9DgB;EACI,WLx5CZ;AH82GR;;AQ/8DI;EACI,mBLnrCK;EKorCL,qBLprCK;AHsoGb;AQj9DQ;EACI,cAAA;ARm9DZ;AQj9DQ;EACI,aAAA;ARm9DZ;AQ38DgC;EACI,mBL5yCzB;AHyvGX;AQt8D4B;EACI,cLxzCrB;AHgwGX;AQt8D4B;EACI,mBLvzCrB;AH+vGX;AQt8D4B;EACI,mBL1zCrB;AHkwGX;AQl8D4B;EACI,cLv+CtB;AH26GV;AQ57DqC;EACG,cLh/C9B;AH86GV;AQ17D4B;EACI,cLl1CrB;AH8wGX;AQ37DgC;EACI,cLv/C1B;AHo7GV;AQ37DgC;EACI,cLx1CzB;AHqxGX;AQ37DgC;EACI,cL11CzB;AHuxGX;AQz7DgC;EACI,mBL31CzB;AHsxGX;AQ17DoC;EACI,cLl2C7B;AH8xGX;AQr7DwC;EACI,cLz2CjC;AHgyGX;AQt7D4C;EACI,cL9gDtC;AHs8GV;AQ56D4B;EACI,uBAAA;AR86DhC;AQv6DgB;EACI,qBLj4CT;AH0yGX;AQl6DY;EACI,WLxgDR;AH46GR;AQn6DgB;EACI,mBLv4CT;AH4yGX;AQl6DY;EACI,mBLjyCH;AHqsGb;AQl6DoB;EACI,cAAA;ARo6DxB;AQj6DgB;EACI,WLrhDZ;AHw7GR;AQj6DgB;EACI,oCAAA;EACA,gCAAA;ARm6DpB;AQ/5DwB;EACI,WL9hDpB;AH+7GR;AQh6D4B;EACI,mBL75CrB;AH+zGX;AQ/5DwB;EACI,mBLj6CjB;AHk0GX;AQh6D4B;EACI,sBAAA;ARk6DhC;AQ95D4B;EACI,mBLx6CrB;AHw0GX;AQ35DgC;EACI,mBL96CzB;EK+6CyB,sBAAA;AR65DpC;AQn5DiC;EACI,mBL17C1B;EK27C0B,sBAAA;ARq5DrC;AQ54DQ;EACI,yBL31CC;EK41CD,qBLp8CD;AHk1GX;AIx/GI;EIinDgB;IAEQ,aAAA;ERy4D1B;AACF;AQl4DQ;EACI,yBL92CC;EK+2CD,qBLv9CD;AH21GX;AQl4DQ;EACI,WL/lDJ;EKgmDI,qBLn3CC;AHuvGb;AQn4DY;EACI,mBL/9CL;AHo2GX;AQl4DQ;EACI,mBLz3CC;AH6vGb;AQn4DY;EACI,WLxmDR;AH6+GR;AQl4DgB;EACI,cL/3CP;AHmwGb;AQj4DY;EACI,WLhnDR;AHm/GR;AQl4DgB;EACI,cLrpDV;AHyhHV;AQh4DQ;EACI,WLvnDJ;EKwnDI,mBLn/CD;EKo/CC,qBLp/CD;AHs3GX;AQj4DY;EACI,WL3nDR;AH8/GR;AQj4DY;EACI,WL9nDR;EK+nDQ,mBL1/CL;EK2/CK,qBL3/CL;AH83GX;AQl4DgB;EACI,WLloDZ;AHsgHR;;AQ73DI;EACI,mBL55CK;EK65CL,qBL75CK;AH6xGb;AQ/3DQ;EACI,cAAA;ARi4DZ;AQ/3DQ;EACI,aAAA;ARi4DZ;AQz3DgC;EACI,mBLthDzB;AHi5GX;AQp3D4B;EACI,cLliDrB;AHw5GX;AQp3D4B;EACI,mBLjiDrB;AHu5GX;AQp3D4B;EACI,mBLpiDrB;AH05GX;AQh3D4B;EACI,cLjtDtB;AHmkHV;AQ12DqC;EACG,cL1tD9B;AHskHV;AQx2D4B;EACI,cL5jDrB;AHs6GX;AQz2DgC;EACI,cLjuD1B;AH4kHV;AQz2DgC;EACI,cLlkDzB;AH66GX;AQz2DgC;EACI,cLpkDzB;AH+6GX;AQv2DgC;EACI,mBLrkDzB;AH86GX;AQx2DoC;EACI,cL5kD7B;AHs7GX;AQn2DwC;EACI,cLnlDjC;AHw7GX;AQp2D4C;EACI,cLxvDtC;AH8lHV;AQ11D4B;EACI,uBAAA;AR41DhC;AQr1DgB;EACI,qBL3mDT;AHk8GX;AQh1DY;EACI,WLlvDR;AHokHR;AQj1DgB;EACI,mBLjnDT;AHo8GX;AQh1DY;EACI,mBL1gDH;AH41Gb;AQh1DoB;EACI,cAAA;ARk1DxB;AQ/0DgB;EACI,WL/vDZ;AHglHR;AQ/0DgB;EACI,oCAAA;EACA,gCAAA;ARi1DpB;AQ70DwB;EACI,WLxwDpB;AHulHR;AQ90D4B;EACI,mBLvoDrB;AHu9GX;AQ70DwB;EACI,mBL3oDjB;AH09GX;AQ90D4B;EACI,sBAAA;ARg1DhC;AQ50D4B;EACI,mBLlpDrB;AHg+GX;AQz0DgC;EACI,mBLxpDzB;EKypDyB,sBAAA;AR20DpC;AQj0DiC;EACI,mBLpqD1B;EKqqD0B,sBAAA;ARm0DrC;AQ1zDQ;EACI,yBLpkDC;EKqkDD,qBL9qDD;AH0+GX;AIhpHI;EI21DgB;IAEQ,aAAA;ERuzD1B;AACF;AQhzDQ;EACI,yBLvlDC;EKwlDD,qBLjsDD;AHm/GX;AQhzDQ;EACI,WLz0DJ;EK00DI,qBL5lDC;AH84Gb;AQjzDY;EACI,mBL9sDL;EK+sDK,cLzsDL;AH4/GX;AQhzDQ;EACI,mBLnmDC;AHq5Gb;AQjzDY;EACI,WLn1DR;AHsoHR;AQhzDgB;EACI,cLzmDP;AH25Gb;AQ/yDY;EACI,WL31DR;AH4oHR;AQhzDgB;EACI,cLh4DV;AHkrHV;AQ9yDQ;EACI,WLl2DJ;EKm2DI,0CAAA;EACA,4CAAA;ARgzDZ;AQ/yDY;EACI,WLt2DR;AHupHR;AQ/yDY;EACI,WLz2DR;EK02DQ,uCAAA;EACA,yCAAA;ARizDhB;AQhzDgB;EACI,WL72DZ;AH+pHR;;AQ3yDI;EACI,mBLroDK;EKsoDL,qBLtoDK;AHo7Gb;AQ7yDQ;EACI,cAAA;AR+yDZ;AQ7yDQ;EACI,aAAA;AR+yDZ;AQvyDgC;EACI,mBLtwDzB;AH+iHX;AQxyDoC;EACI,cLlwD7B;AH4iHX;AQlyD4B;EACI,cLhxDrB;AHojHX;AQlyD4B;EACI,mBLpxDrB;AHwjHX;AQnyDgC;EACI,cLhxDzB;AHqjHX;AQlyDoC;EACI,qBLpxD7B;AHwjHX;AQhyD4B;EACI,mBL/xDrB;AHikHX;AQjyDgC;EACI,cL3xDzB;AH8jHX;AQhyDoC;EACI,qBL/xD7B;AHikHX;AQ1xD4B;EACI,cL/8DtB;AH2uHV;AQpxDqC;EACG,cLx9D9B;AH8uHV;AQlxD4B;EACI,cL1zDrB;AH8kHX;AQnxDgC;EACI,cL/9D1B;AHovHV;AQnxDgC;EACI,cLh0DzB;AHqlHX;AQnxDgC;EACI,cLl0DzB;AHulHX;AQjxDgC;EACI,mBLn0DzB;AHslHX;AQlxDoC;EACI,cL10D7B;AH8lHX;AQ7wDwC;EACI,cLj1DjC;AHgmHX;AQ9wD4C;EACI,cLt/DtC;AHswHV;AQpwD4B;EACI,uBAAA;ARswDhC;AQ/vDgB;EACI,qBLz2DT;AH0mHX;AQ1vDY;EACI,WLh/DR;AH4uHR;AQ3vDgB;EACI,mBLp3DT;EKq3DS,cL/2DT;AH4mHX;AQ1vDY;EACI,mBLvwDH;AHmgHb;AQ1vDoB;EACI,cAAA;AR4vDxB;AQxvDoB;EACI,WL//DhB;AHyvHR;AQrvDwB;EACI,WLrgEpB;AH4vHR;AQtvD4B;EACI,mBLz4DrB;EK04DqB,cLp4DrB;AH4nHX;AQrvDwB;EACI,mBL94DjB;AHqoHX;AQtvD4B;EACI,yBAAA;ARwvDhC;AQpvD4B;EACI,mBLr5DrB;EKs5DqB,cLh5DrB;AHsoHX;AQjvDgC;EACI,mBL55DzB;EK65DyB,yBAAA;ARmvDpC;AQzuDiC;EACI,mBLx6D1B;EKy6D0B,yBAAA;AR2uDrC;AQluDQ;EACI,yBLj0DC;EKk0DD,qBLj7DD;AHqpHX;AIvzHI;EI0lEgB;IAEQ,aAAA;ER+tD1B;AACF;AQxtDQ;EACI,yBLp1DC;EKq1DD,qBLp8DD;AH8pHX;AQxtDQ;EACI,WLxkEJ;EKykEI,qBLz1DC;AHmjHb;AQztDY;EACI,mBL78DL;EK88DK,cLx8DL;AHmqHX;AQxtDQ;EACI,mBLh2DC;AH0jHb;AQztDY;EACI,WLllER;AH6yHR;AQxtDgB;EACI,cLt2DP;AHgkHb;AQvtDY;EACI,WL1lER;AHmzHR;AQxtDgB;EACI,cL/nEV;AHy1HV;AQttDQ;EACI,WLjmEJ;EKkmEI,wCAAA;EACA,0CAAA;ARwtDZ;AQvtDY;EACI,WLrmER;AH8zHR;AQvtDY;EACI,WLxmER;EKymEQ,wCAAA;EACA,0CAAA;ARytDhB;AQxtDgB;EACI,WL5mEZ;AHs0HR;;AQntDI;EACI,mBLr4DI;EKs4DJ,qBLt4DI;AH4lHZ;AQrtDQ;EACI,cAAA;ARutDZ;AQrtDQ;EACI,aAAA;ARutDZ;AQ/sDgC;EACI,mBLhgEzB;AHitHX;AQ1sD4B;EACI,cL5gErB;AHwtHX;AQ1sD4B;EACI,mBL3gErB;AHutHX;AQ1sD4B;EACI,mBL9gErB;AH0tHX;AQtsD4B;EACI,cL3rEtB;AHm4HV;AQhsDqC;EACG,cLpsE9B;AHs4HV;AQ9rD4B;EACI,cLtiErB;AHsuHX;AQ/rDgC;EACI,cL3sE1B;AH44HV;AQ/rDgC;EACI,cL5iEzB;AH6uHX;AQ/rDgC;EACI,cL9iEzB;AH+uHX;AQ7rDgC;EACI,mBL/iEzB;AH8uHX;AQ9rDoC;EACI,cLtjE7B;AHsvHX;AQzrDwC;EACI,cL7jEjC;AHwvHX;AQ1rD4C;EACI,cLluEtC;AH85HV;AQhrD4B;EACI,uBAAA;ARkrDhC;AQ3qDgB;EACI,qBLrlET;AHkwHX;AQtqDY;EACI,WL5tER;AHo4HR;AQvqDgB;EACI,mBL3lET;AHowHX;AQtqDY;EACI,mBLn/DJ;AH2pHZ;AQtqDoB;EACI,cAAA;ARwqDxB;AQrqDgB;EACI,WLzuEZ;AHg5HR;AQrqDgB;EACI,oCAAA;EACA,gCAAA;ARuqDpB;AQnqDwB;EACI,WLlvEpB;AHu5HR;AQpqD4B;EACI,mBLjnErB;AHuxHX;AQnqDwB;EACI,mBLrnEjB;AH0xHX;AQpqD4B;EACI,sBAAA;ARsqDhC;AQlqD4B;EACI,mBL5nErB;AHgyHX;AQ/pDgC;EACI,mBLloEzB;EKmoEyB,sBAAA;ARiqDpC;AQvpDiC;EACI,mBL9oE1B;EK+oE0B,sBAAA;ARypDrC;AQhpDQ;EACI,yBL7iEA;EK8iEA,qBLxpED;AH0yHX;AIh9HI;EIq0EgB;IAEQ,aAAA;ER6oD1B;AACF;AQtoDQ;EACI,yBLhkEA;EKikEA,qBL3qED;AHmzHX;AQtoDQ;EACI,WLnzEJ;EKozEI,qBLrkEA;AH6sHZ;AQvoDY;EACI,mBLnrEL;AH4zHX;AQtoDQ;EACI,mBL3kEA;AHmtHZ;AQvoDY;EACI,WL5zER;AHq8HR;AQtoDgB;EACI,cLjlER;AHytHZ;AQroDY;EACI,WLp0ER;AH28HR;AQtoDgB;EACI,cLz2EV;AHi/HV;AQpoDQ;EACI,WL30EJ;EK40EI,mBLvsED;EKwsEC,qBLxsED;AH80HX;AQroDY;EACI,WL/0ER;AHs9HR;AQroDY;EACI,WLl1ER;EKm1EQ,mBL9sEL;EK+sEK,qBL/sEL;AHs1HX;AQtoDgB;EACI,WLt1EZ;AH89HR;;AQjoDI;EACI,mBL7mEC;EK8mED,qBL9mEC;AHkvHT;AQnoDQ;EACI,cAAA;ARqoDZ;AQnoDQ;EACI,aAAA;ARqoDZ;AQ5nDgC;EACI,mBLhvEzB;AH82HX;AQ7nDoC;EACI,cL5uE7B;AH22HX;AQvnD4B;EACI,cL1vErB;AHm3HX;AQvnD4B;EACI,mBL9vErB;AHu3HX;AQxnDgC;EACI,cL1vEzB;AHo3HX;AQvnDoC;EACI,qBL9vE7B;AHu3HX;AQrnD4B;EACI,mBLzwErB;AHg4HX;AQtnDgC;EACI,cLrwEzB;AH63HX;AQrnDoC;EACI,qBLzwE7B;AHg4HX;AQ/mD4B;EACI,cLz7EtB;AH0iIV;AQzmDqC;EACG,cLl8E9B;AH6iIV;AQvmD4B;EACI,cLpyErB;AH64HX;AQxmDgC;EACI,cLz8E1B;AHmjIV;AQxmDgC;EACI,cL1yEzB;AHo5HX;AQxmDgC;EACI,cL5yEzB;AHs5HX;AQtmDgC;EACI,mBL7yEzB;AHq5HX;AQvmDoC;EACI,cLpzE7B;AH65HX;AQlmDwC;EACI,cL3zEjC;AH+5HX;AQnmD4C;EACI,cLh+EtC;AHqkIV;AQzlD4B;EACI,uBAAA;AR2lDhC;AQplDgB;EACI,qBLn1ET;AHy6HX;AQ/kDY;EACI,WL19ER;AH2iIR;AQhlDgB;EACI,mBL91ET;EK+1ES,cLz1ET;AH26HX;AQ/kDY;EACI,mBLhvEP;AHi0HT;AQ/kDoB;EACI,cAAA;ARilDxB;AQ7kDoB;EACI,WLz+EhB;AHwjIR;AQ1kDwB;EACI,WL/+EpB;AH2jIR;AQ3kD4B;EACI,mBLn3ErB;EKo3EqB,cL92ErB;AH27HX;AQ1kDwB;EACI,mBLx3EjB;AHo8HX;AQ3kD4B;EACI,yBAAA;AR6kDhC;AQzkD4B;EACI,mBL/3ErB;EKg4EqB,cL13ErB;AHq8HX;AQtkDgC;EACI,mBLt4EzB;EKu4EyB,yBAAA;ARwkDpC;AQ9jDiC;EACI,mBLl5E1B;EKm5E0B,yBAAA;ARgkDrC;AQvjDQ;EACI,yBL1yEH;EK2yEG,qBLv5ED;AHg9HX;AItnII;EIokFgB;IAEQ,aAAA;ERojD1B;AACF;AQ7iDQ;EACI,yBL7zEH;EK8zEG,qBL16ED;AHy9HX;AQ7iDQ;EACI,WLljFJ;EKmjFI,qBLl0EH;AHi3HT;AQ9iDY;EACI,mBLv7EL;EKw7EK,cLl7EL;AHk+HX;AQ7iDQ;EACI,mBLz0EH;AHw3HT;AQ9iDY;EACI,WL5jFR;AH4mIR;AQ7iDgB;EACI,cL/0EX;AH83HT;AQ5iDY;EACI,WLpkFR;AHknIR;AQ7iDgB;EACI,cLzmFV;AHwpIV;AQ3iDQ;EACI,WL3kFJ;EK4kFI,qCAAA;EACA,uCAAA;AR6iDZ;AQ5iDY;EACI,WL/kFR;AH6nIR;AQ5iDY;EACI,WLllFR;EKmlFQ,qCAAA;EACA,uCAAA;AR8iDhB;AQ7iDgB;EACI,WLtlFZ;AHqoIR;;AQviDI;EACI,mCAFQ;EAER,yCAFQ;EAGR,qCAHQ;EAGR,2CAHQ;AR6iDhB;AQziDQ;EACI,cAAA;AR2iDZ;AQziDQ;EACI,aAAA;AR2iDZ;AQniDgC;EACI,mBLh/EzB;AHqhIX;AQpiDoC;EACI,cL5+E7B;AHkhIX;AQ9hD4B;EACI,cL1/ErB;AH0hIX;AQ9hD4B;EACI,mBL9/ErB;AH8hIX;AQ/hDgC;EACI,cL1/EzB;AH2hIX;AQ9hDoC;EACI,qBL9/E7B;AH8hIX;AQ5hD4B;EACI,mBLzgFrB;AHuiIX;AQ7hDgC;EACI,cLrgFzB;AHoiIX;AQ5hDoC;EACI,qBLzgF7B;AHuiIX;AQthD4B;EACI,cLzrFtB;AHitIV;AQhhDqC;EACG,cLlsF9B;AHotIV;AQ9gD4B;EACI,cLpiFrB;AHojIX;AQ/gDgC;EACI,cLzsF1B;AH0tIV;AQ/gDgC;EACI,cL1iFzB;AH2jIX;AQ/gDgC;EACI,cL5iFzB;AH6jIX;AQ7gDgC;EACI,mBL7iFzB;AH4jIX;AQ9gDoC;EACI,cLpjF7B;AHokIX;AQzgDwC;EACI,cL3jFjC;AHskIX;AQ1gD4C;EACI,cLhuFtC;AH4uIV;AQhgD4B;EACI,uBAAA;ARkgDhC;AQ3/CgB;EACI,qBLnlFT;AHglIX;AQt/CY;EACI,WL1tFR;AHktIR;AQv/CgB;EACI,mBL9lFT;EK+lFS,cLzlFT;AHklIX;AQt/CY;EACI,mCApIA;EAoIA,yCApIA;AR4nDhB;AQt/CoB;EACI,cAAA;ARw/CxB;AQp/CoB;EACI,WLzuFhB;AH+tIR;AQj/CwB;EACI,WL/uFpB;AHkuIR;AQl/C4B;EACI,mBLnnFrB;EKonFqB,cL9mFrB;AHkmIX;AQj/CwB;EACI,mBLxnFjB;AH2mIX;AQl/C4B;EACI,yBAAA;ARo/ChC;AQh/C4B;EACI,mBL/nFrB;EKgoFqB,cL1nFrB;AH4mIX;AQ7+CgC;EACI,mBLtoFzB;EKuoFyB,yBAAA;AR++CpC;AQr+CiC;EACI,mBLlpF1B;EKmpF0B,yBAAA;ARu+CrC;AQ99CQ;EACI,yCA9LI;EA8LJ,+CA9LI;EA+LJ,qBL3pFD;AH2nIX;AI7xII;EIo0FgB;IAEQ,aAAA;ER29C1B;AACF;AQp9CQ;EACI,yCAjNI;EAiNJ,+CAjNI;EAkNJ,qBL9qFD;AHooIX;AQp9CQ;EACI,WLlzFJ;EKmzFI,qCAtNI;EAsNJ,2CAtNI;AR4qDhB;AQr9CY;EACI,mBLvrFL;EKwrFK,cLlrFL;AHyoIX;AQp9CQ;EACI,mCA7NI;EA6NJ,yCA7NI;ARmrDhB;AQr9CY;EACI,WL5zFR;AHmxIR;AQp9CgB;EACI,8BAnOJ;EAmOI,oCAnOJ;ARyrDhB;AQn9CY;EACI,WLp0FR;AHyxIR;AQp9CgB;EACI,8BAzOJ;EAyOI,oCAzOJ;AR+rDhB;AQl9CQ;EACI,WL30FJ;EK40FI,yCAAA;EAAA,+CAAA;EACA,2CAAA;EAAA,iDAAA;ARo9CZ;AQn9CY;EACI,WL/0FR;AHoyIR;AQn9CY;EACI,WLl1FR;EKm1FQ,yCAAA;EAAA,+CAAA;EACA,2CAAA;EAAA,iDAAA;ARq9ChB;AQp9CgB;EACI,WLt1FZ;AH4yIR;;AQx8CI;;;;;;;;EACI,mBLnnFG;EKonFH,4BLpnFG;AHskIX;AQj9CQ;;;;;;;;EACI,kCAAA;AR09CZ;AQx9CQ;;;;;;;;EACI,mBLznFD;EK0nFC,qBL1nFD;AH2lIX;AQ79CgB;;;;;;;;EACI,WLj3FZ;AHu1IR;AQr+CoB;;;;;;;;;;;;;;;EACI,cL/uFb;AHouIX;AQ/+CY;;;;;;;;EACI,mBLxoFL;AHgoIX;AQr/CwB;;;;;;;;EACI,WL93FpB;AH43IR;AQ5/CgC;;;;;;;;EACI,kBLj4F5B;AHs4IR;AQlgD4B;;;;;;;;;;;;;;;;;;;;;;EACI,cLjwFrB;AH0xIX;AQvhDoC;;;;;;;;;;;;;;;;;;;;;;EACI,qBLpwF7B;AHkzIX;AQjiDgB;;;;;;;;EACI,aAAA;AR0iDpB;AQxiDgB;;;;;;;;EACI,cAAA;ARijDpB;;AQniDI;;;;;;;;EACI,mBLprFG;EKqrFH,4BLrrFG;AHkuIX;AQ5iDQ;;;;;;;;EACI,kCAAA;ARqjDZ;AQnjDQ;;;;;;;;EACI,mBL1rFD;EK2rFC,qBL3rFD;AHuvIX;AQxjDgB;;;;;;;;EACI,cL9yFT;AH+2IX;AQhkDoB;;;;;;;;;;;;;;;EACI,gBLt7FhB;AHsgJR;AQ1kDY;;;;;;;;EACI,mBLzsFL;AH4xIX;;AQtkDI;;;;;;;;EACI,mBLxtFI;EKytFJ,4BLztFI;AHyyIZ;AQ/kDQ;;;;;;;;EACI,kCAAA;ARwlDZ;AQtlDQ;;;;;;;;EACI,mBL9tFA;EK+tFA,qBL/tFA;AH8zIZ;AQ3lDgB;;;;;;;;EACI,cLj1FT;AHq7IX;AQ/lDY;;;;;;;;EACI,mBL1uFJ;AHk1IZ;;AQ3lDI;;;;;;;;EACI,mBLtvFG;EKuvFH,4BLvvFG;AH41IX;AQpmDQ;;;;;;;;EACI,kCAAA;AR6mDZ;AQ3mDQ;;;;;;;;EACI,mBL5vFD;EK6vFC,qBL7vFD;AHi3IX;AQhnDgB;;;;;;;;EACI,cLj3FT;AH0+IX;AQpnDY;;;;;;;;EACI,mBLxwFL;AHq4IX;;AQhnDI;;;;;;;;EACI,+DL/rFU;EKgsFV,wELhsFU;AH0zIlB;AQznDQ;;;;;;;;EACI,kCAAA;ARkoDZ;AQhoDQ;;;;;;;;EACI,+DLrsFM;EKssFN,iELtsFM;AH+0IlB;AQroDgB;;;;;;;;EACI,WLvhGZ;AHqqJR;AQzoDY;;;;;;;;EACI,+DLjtFE;AHm2IlB;;AQroDI;;;;;;;;EACI,+DL9tFU;EK+tFV,wEL/tFU;AH82IlB;AQ9oDQ;;;;;;;;EACI,kCAAA;ARupDZ;AQrpDQ;;;;;;;;EACI,+DLpuFM;EKquFN,iELruFM;AHm4IlB;AQ1pDgB;;;;;;;;EACI,WLvjGZ;AH0tJR;AQ9pDY;;;;;;;;EACI,+DLhvFE;AHu5IlB;;AQ1pDI;;;;;;;;EACI,6DL3vFQ;EK4vFR,sEL5vFQ;AHg6IhB;AQnqDQ;;;;;;;;EACI,kCAAA;AR4qDZ;AQ1qDQ;;;;;;;;EACI,6DLjwFI;EKkwFJ,+DLlwFI;AHq7IhB;AQ/qDgB;;;;;;;;EACI,WLvlGZ;AH+wJR;AQnrDY;;;;;;;;EACI,6DL7wFA;AHy8IhB;;AQ/qDI;;;;;;;;EACI,6DL1xFU;EK2xFV,sEL3xFU;AHo9IlB;AQxrDQ;;;;;;;;EACI,kCAAA;ARisDZ;AQ/rDQ;;;;;;;;EACI,6DLhyFM;EKiyFN,+DLjyFM;AHy+IlB;AQpsDgB;;;;;;;;EACI,WLvnGZ;AHo0JR;AQxsDY;;;;;;;;EACI,6DL5yFE;AH6/IlB;;AQnsDI;;;;;;;;EACI,kCAFM;EAEN,wCAFM;EAGN,2CAHM;EAGN,iDAHM;ARgtDd;AQ5sDQ;;;;;;;;EACI,kCAAA;ARqtDZ;AQntDQ;;;;;;;;EACI,kCARE;EAQF,wCARE;EASF,oCATE;EASF,0CATE;ARquDd;AQxtDgB;;;;;;;;EACI,WLxpGZ;AHy3JR;AQhuDoB;;;;;;;;;;;;;;;EACI,cLthGb;AHswJX;AQ1uDY;;;;;;;;EACI,kCAvBF;EAuBE,wCAvBF;AR0wDd;AQhvDwB;;;;;;;;EACI,WLrqGpB;AH85JR;AQvvDgC;;;;;;;;EACI,kBLxqG5B;AHw6JR;AQ7vD4B;;;;;;;;;;;;;;;;;;;;;;EACI,cLxiGrB;AH4zJX;AQlxDoC;;;;;;;;;;;;;;;;;;;;;;EACI,qBL3iG7B;AHo1JX;AQ5xDgB;;;;;;;;EACI,aAAA;ARqyDpB;AQnyDgB;;;;;;;;EACI,cAAA;AR4yDpB;;AQpyDI;;EACI,OAAA;EACA,yBLpkGG;EKqkGH,qBLtkGG;AH82JX;AQryDgB;;EACI,WL/sGZ;AHu/JR;AQvyDoB;;EACI,mBL9kGb;AHw3JX;AQryDQ;;EACI,cAAA;ARwyDZ;AQvyDY;;EACI,aAAA;AR0yDhB;AQxyDY;;EACI,cAAA;AR2yDhB;AQvyDI;;EACI,WLjuGA;AH2gKR;AQvyDQ;;EACI,yBL/lGD;EKgmGC,gCAAA;AR0yDZ;AQryD4B;;EACI,WL5uGxB;AHohKR;AQvyDgC;;;EACI,mBL3mGzB;AHs5JX;AQxyDoC;;EACI,4BAAA;EACA,6BAAA;AR2yDxC;AQhyDQ;;EACI,mBLznGD;AH45JX;;AQ7xDI;;EACI,OAAA;EACA,yBL1yGE;EK2yGF,qBLjvGM;AHkhKd;AQ9xDgB;;EACI,WL5wGZ;AH6iKR;AQhyDoB;;EACI,mBLzvGV;AH4hKd;AQ9xDQ;;EACI,cAAA;ARiyDZ;AQhyDY;;EACI,aAAA;ARmyDhB;AQjyDY;;EACI,cAAA;ARoyDhB;AQhyDI;;EACI,WL9xGA;AHikKR;AQhyDQ;;EACI,yBLr0GF;EKs0GE,gCAAA;ARmyDZ;AQ9xD4B;;EACI,WLzyGxB;AH0kKR;AQhyDgC;;;EACI,mBLtxGtB;AH0jKd;AQjyDoC;;EACI,4BAAA;EACA,6BAAA;ARoyDxC;AQzxDQ;;EACI,WAAA;EACA,mBLh2GF;AH4nKV;;AQtxDI;;EACI,OAAA;EACA,yBLzkGK;EK0kGL,qBLjsGG;AH29JX;AQvxDgB;;EACI,WL10GZ;AHomKR;AQzxDoB;;EACI,mBLzsGb;AHq+JX;AQvxDQ;;EACI,cAAA;AR0xDZ;AQzxDY;;EACI,aAAA;AR4xDhB;AQ1xDY;;EACI,cAAA;AR6xDhB;AQzxDI;;EACI,WL51GA;AHwnKR;AQzxDQ;;EACI,yBLpmGC;EKqmGD,gCAAA;AR4xDZ;AQvxD4B;;EACI,WLv2GxB;AHioKR;AQzxDgC;;;;EACI,mBLtuGzB;AHogKX;AQ3xDoC;;EACI,4BAAA;EACA,6BAAA;AR8xDxC;AQvxDwB;;EACI,qBLlvGjB;AH4gKX;AQlxDQ;;EACI,WAAA;EACA,mBLpoGC;AHy5Jb;;AQ/wDI;;EACI,OAAA;EACA,yBL3oGC;EK4oGD,2CAAA;ARmxDR;AQhxDgB;;EACI,WL74GZ;AHgqKR;AQlxDoB;;EACI,mBLt5GL;EKu5GK,cL5wGb;AHiiKX;AQhxDQ;;EACI,cAAA;ARmxDZ;AQlxDY;;EACI,aAAA;ARqxDhB;AQnxDY;;EACI,cAAA;ARsxDhB;AQlxDI;;EACI,WLh6GA;AHqrKR;AQlxDQ;;EACI,yBLvqGH;EKwqGG,sDAAA;ARqxDZ;AQhxD4B;;EACI,WL36GxB;AH8rKR;AQlxDgC;;;;EACI,yBLp7GjB;EKq7GiB,cLxyGzB;AH+jKX;AQrxDwC;;;;EACI,qBL3yGjC;AHqkKX;AQrxDoC;;EACI,4BAAA;EACA,6BAAA;ARwxDxC;AQjxDwB;;EACI,qBL5zGjB;AHglKX;AQ5wDQ;;EACI,WAAA;EACA,mBL7sGH;AH49JT;;AQzwDI;;EACI,OAAA;EACA,sBLl9GA;EKm9GA,mBAAA;AR6wDR;AQ1wDgB;;EACI,cLr1GT;AHkmKX;AQ5wDoB;;EACI,mBLh+GL;EKi+GK,cLp1Gb;AHmmKX;AQ1wDQ;;EACI,cAAA;AR6wDZ;AQ5wDY;;EACI,cAAA;AR+wDhB;AQ7wDY;;EACI,aAAA;ARgxDhB;AQ5wDI;;EACI,cLt2GG;AHqnKX;AQ5wDQ;;EACI,sBL9+GJ;EK++GI,8BAAA;AR+wDZ;AQ1wD4B;;EACI,cL/2GrB;AH4nKX;AQ5wDgC;;;;EACI,yBL9/GjB;EK+/GiB,cLl3GzB;AHmoKX;AQ/wDwC;;;;EACI,qBLr3GjC;AHyoKX;AQ/wDoC;;EACI,qBL33G7B;AH6oKX;AQ3wDwB;;EACI,qBLn4GjB;AHipKX;AQtwDQ;;EACI,WAAA;EACA,gBLnhHJ;AH4xKR;;AQnwDI;;EACI,OAAA;EACA,yBL7xGE;EK8xGF,+DAAA;ARuwDR;AQpwDgB;;EACI,WLhiHZ;AHuyKR;AQtwDoB;;EACI,mBLziHL;EK0iHK,cL/5Gb;AHwqKX;AQpwDQ;;EACI,cAAA;ARuwDZ;AQtwDY;;EACI,aAAA;ARywDhB;AQvwDY;;EACI,cAAA;AR0wDhB;AQtwDI;;EACI,WLnjHA;AH4zKR;AQtwDQ;;EACI,yBLzzGF;EK0zGE,0EAAA;ARywDZ;AQpwD4B;;EACI,WL9jHxB;AHq0KR;AQtwDgC;;;;EACI,yBLvkHjB;EKwkHiB,cL37GzB;AHssKX;AQzwDwC;;;;EACI,qBL97GjC;AH4sKX;AQzwDoC;;EACI,4BAAA;EACA,6BAAA;AR4wDxC;AQrwDwB;;EACI,qBL/8GjB;AHutKX;AQhwDQ;;EACI,WAAA;EACA,mBL/1GF;AHkmKV;;AQ5vDI;;EACI,OAAA;EACA,6CAHM;EAGN,mDAHM;EAIN,yCAJM;EAIN,+CAJM;ARowDd;AQ7vDgB;;EACI,WL3mHZ;AH22KR;AQ/vDoB;;EACI,mBLpnHL;EKqnHK,cL1+Gb;AH4uKX;AQ7vDQ;;EACI,cAAA;ARgwDZ;AQ/vDY;;EACI,aAAA;ARkwDhB;AQhwDY;;EACI,cAAA;ARmwDhB;AQ/vDI;;EACI,WL9nHA;AHg4KR;AQ/vDQ;;EACI,6CA/BE;EA+BF,mDA/BE;EAgCF,oDAAA;EAAA,0DAAA;ARkwDZ;AQ7vD4B;;EACI,WLzoHxB;AHy4KR;AQ/vDgC;;;;EACI,yBLlpHjB;EKmpHiB,cLtgHzB;AH0wKX;AQlwDwC;;;;EACI,qBLzgHjC;AHgxKX;AQlwDoC;;EACI,4BAAA;EACA,6BAAA;ARqwDxC;AQ9vDwB;;EACI,qBL1hHjB;AH2xKX;AQzvDQ;;EACI,WAAA;EACA,uCArEE;EAqEF,6CArEE;ARi0Dd;;AQvvDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AR0vDR;AQzvDQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AR2vDZ;;AQrvDI;;EACI,OAAA;EACA,yBLl8GE;EKm8GF,qBL7jHG;AHszKX;AQtvDgB;;EACI,WLtsHZ;AH+7KR;AQxvDoB;;EACI,mBLrkHb;AHg0KX;AQtvDQ;;EACI,cAAA;ARyvDZ;AQxvDY;;EACI,aAAA;AR2vDhB;AQzvDY;;EACI,cAAA;AR4vDhB;AQxvDI;;EACI,WLxtHA;AHm9KR;AQxvDQ;;EACI,yBL79GF;EK89GE,gCAAA;AR2vDZ;AQtvD4B;;EACI,WLnuHxB;AH49KR;AQxvDgC;;;;EACI,mBLlmHzB;AH+1KX;AQ1vDoC;;EACI,4BAAA;EACA,6BAAA;AR6vDxC;AQtvDwB;;EACI,qBL9mHjB;AHu2KX;AQjvDQ;;EACI,WAAA;EACA,mBL7/GF;AHivKV;;AQ/uDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARkvDR;AQjvDQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;ARmvDZ;;AQ9uDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARivDR;AQhvDQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ARkvDZ;;AQ7uDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARgvDR;AQ/uDQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ARivDZ;;AQ5uDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AR+uDR;AQ9uDQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ARgvDZ;;AQ3uDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AR8uDR;AQ7uDQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AR+uDZ;;AQ1uDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AR6uDR;AQ5uDQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;AR8uDZ;;AQnuDO;;;;;;EACC,qCAAA;AR2uDR;;AQhuDO;;;;;;EACC,kCAAA;ARwuDR;;AQ7tDO;;;;;;EACC,kCAAA;ARquDR;;AQ1tDO;;;;;;EACC,kCAAA;ARkuDR;;AQvtDO;;;;;;EACC,kCAAA;AR+tDR;;AQptDO;;;;;;EACC,mCAAA;AR4tDR;;AQjtDO;;;;;;EACC,0CAAA;EAAA,gDAAA;ARytDR;;AQltDQ;;EACI,mDAAA;ARstDZ;;AQ/sDQ;;EACI,mDAAA;ARmtDZ;;AQ5sDQ;;EACI,mDAAA;ARgtDZ;;AQzsDQ;;EACI,kCAAA;EACA,UAAA;AR6sDZ;AQ3sDQ;;EACI,UAAA;AR8sDZ;;AQvsDQ;;EACI,qCAAA;EACA,UAAA;AR2sDZ;AQzsDQ;;EACI,UAAA;AR4sDZ;;AQrsDQ;;EACI,mCAAA;EACA,UAAA;ARysDZ;AQvsDQ;;EACI,UAAA;AR0sDZ;;AQnsDQ;;EACI,gCAAA;EACA,UAAA;ARusDZ;AQrsDQ;;EACI,UAAA;ARwsDZ;;AQjsDQ;;EACI,mCAAA;EACA,UAAA;ARqsDZ;AQnsDQ;;EACI,UAAA;ARssDZ;;AQ/rDQ;;EACI,iCAAA;EACA,UAAA;ARmsDZ;AQjsDQ;;EACI,UAAA;ARosDZ;;AQ/rDI;EACI,sBL9hIA;EK+hIA,sCAAA;ARksDR;AQhsDY;EACI,sBLliIR;AHouLR;AQ7rDgB;EACI,cLt6HT;AHqmLX;AQ9rDoB;EACI,yBLjjIL;EKkjIK,qBLljIL;EKmjIK,yBAAA;ARgsDxB;AQ1rDY;EACI,cAAA;AR4rDhB;AQ1rDY;EACI,aAAA;AR4rDhB;AQvrDQ;EACI,gBL5jIJ;AHqvLR;AQvrDQ;EACI,aAAA;ARyrDZ;;AQprDI;EACI,sBLrkIA;EKskIA,sCAAA;ARurDR;AQrrDY;EACI,sBLzkIR;AHgwLR;AQlrDgB;EACI,cL78HT;AHioLX;AQnrDoB;EACI,yBLxlIL;EKylIK,qBLzlIL;EK0lIK,yBAAA;ARqrDxB;AQ/qDY;EACI,aAAA;ARirDhB;AQ/qDY;EACI,cAAA;ARirDhB;AQ5qDQ;EACI,gBLnmIJ;AHixLR;;AQzqDI;EACI,yBL5oIE;EK6oIF,qBLnlIM;AH+vLd;AQ1qDY;EACI,sBL7mIR;AHyxLR;AQvqDgB;EACI,WLnnIZ;AH4xLR;AQxqDoB;EACI,sBLrnIhB;EKsnIgB,yBAAA;AR0qDxB;AQpqDY;EACI,aAAA;ARsqDhB;AQpqDY;EACI,cAAA;ARsqDhB;AQjqDQ;EACI,mBLzqIF;AH40LV;;AQ9pDI;EACI,yBLh5HK;EKi5HL,iCAAA;ARiqDR;AQ/pDY;EACI,sBLhpIR;AHizLR;AQ5pDgB;EACI,WLtpIZ;AHozLR;AQ7pDoB;EACI,sBLxpIhB;EKypIgB,yBAAA;AR+pDxB;AQzpDY;EACI,aAAA;AR2pDhB;AQzpDY;EACI,cAAA;AR2pDhB;AQtpDQ;EACI,mBL76HC;AHqkLb;;AQnpDI;EACI,yBLl7HC;EKm7HD,mCAAA;ARspDR;AQppDY;EACI,sBLnrIR;AHy0LR;AQjpDgB;EACI,WLzrIZ;AH40LR;AQlpDoB;EACI,sBL3rIhB;EK4rIgB,yBAAA;ARopDxB;AQ9oDY;EACI,aAAA;ARgpDhB;AQ9oDY;EACI,cAAA;ARgpDhB;AQ3oDQ;EACI,mBL/8HH;AH4lLT;;AQxoDI;EACI,yBLp9HE;EKq9HF,oCAAA;AR2oDR;AQzoDY;EACI,sBLttIR;AHi2LR;AQtoDgB;EACI,WL5tIZ;AHo2LR;AQvoDoB;EACI,sBL9tIhB;EK+tIgB,yBAAA;ARyoDxB;AQnoDY;EACI,aAAA;ARqoDhB;AQnoDY;EACI,cAAA;ARqoDhB;AQhoDQ;EACI,mBLj/HF;AHmnLV;;AQ7nDI;EACI,yBLt/HE;EKu/HF,kCAAA;ARgoDR;AQ9nDY;EACI,sBLzvIR;AHy3LR;AQ3nDgB;EACI,WL/vIZ;AH43LR;AQ5nDoB;EACI,sBLjwIhB;EKkwIgB,yBAAA;AR8nDxB;AQxnDY;EACI,aAAA;AR0nDhB;AQxnDY;EACI,cAAA;AR0nDhB;AQrnDQ;EACI,mBLnhIF;AH0oLV;;AQlnDI;EACI,oBAAA;EACA,gBAAA;ARqnDR;;AQjnDI;EACI,oBAAA;EACA,8DLh7HQ;AHoiLhB;;AQzmD4B;EACI,cARlB;ARonDd;AQrmDgC;EACI,+BAAA;EACA,gCAAA;ARumDpC;AQpmD4B;EACI,cArBlB;AR2nDd;AQrmDgC;EACI,cAvBtB;AR8nDd;AQ1lDgC;EACI,cArCtB;ARioDd;AQ1lDgC;EACI,cAxCtB;ARooDd;AQplDwB;EACI,cAjDd;ARuoDd;AQtkDyC;EACI,cAlE/B;AR0oDd;AQ7jDI;EACI,yBA9EM;EA+EN,yBAAA;AR+jDR;AQ9jDQ;EAKI,mEAAA;EACA,mEAAA;AR4jDZ;AQzjDI;EACI,yBA1FM;EA2FN,qBA3FM;ARspDd;AQzjDI;EACI,yBAAA;AR2jDR;AQ1jDQ;EAGE,wDAAA;AR0jDV;AQvjDI;EACI,yBAAA;ARyjDR;AQtjDQ;EACI,mBA1GE;ARkqDd;AQrjDI;EACI,mBA9GM;EA+GN,qBA/GM;ARsqDd;AQrjDI;EACI,oCAAA;EACA,oCAAA;ARujDR;AQrjDI;EACI,gCAAA;ARujDR;AQrjDI;EACI,gCAAA;ARujDR;AQrjDI;EACI,4BA5HM;EA6HN,cA7HM;ARorDd;AQpjDQ;EACI,kCAAA;EACA,cAlIE;ARwrDd;AQjjDQ;EACI,cAxIE;AR2rDd;AQhjDY;EACI,WL/6IR;AHi+LR;AQ9iDI;EACI,oCAAA;EACA,yBAAA;ARgjDR;AQ/iDQ;EAKI,oCAAA;EACA,oCAAA;EACA,sBAAA;AR6iDZ;AQziDQ;EACI,qBA/JE;AR0sDd;AQziDQ;EACI,mBAlKE;AR6sDd;AQviDQ;EACI,yBAvKE;EAwKF,qBAxKE;ARitDd;AQriDQ;EACI,cA7KE;ARotDd;AQniDQ;EACE,yBAlLI;EAmLJ,qBAnLI;ARwtDd;AQliDI;EACI,yBAvLM;AR2tDd;AIxgMI;EIm+IA;IAGQ,aAAA;ERsiDV;AACF;AQliDY;EACI,cA/LF;ARmuDd;AQ9hDY;EACI,aAtMF;ARsuDd;AQ1hDY;EACI,aA7MF;ARyuDd;AQvhDQ;EACI,aAnNE;AR4uDd;AQphDY;EACI,eAzNF;AR+uDd;AQphDY;EACI,aA5NF;ARkvDd;AQjhDQ;EACI,wBAAA;ARmhDZ;AQ/gDQ;EACI,0BAAA;ARihDZ;AQ/gDQ;EACI,aA1OE;AR2vDd;AQ9gDI;EACI,oCAAA;ARghDR;AQ9gDI;EACI,cAjPM;ARiwDd;AQ5gDY;EACI,mBAtPF;EAuPE,WL1hJR;AHwiMR;;AQjgD4B;EACI,cARlB;AR4gDd;AQ//CgC;EACI,cAdtB;AR+gDd;AQz/CgC;EACI,+BAAA;EACA,gCAAA;AR2/CpC;AQx/C4B;EACI,cA5BlB;ARshDd;AQz/CgC;EACI,cA9BtB;ARyhDd;AQ9+CgC;EACI,mBA5CtB;AR4hDd;AQ9+CgC;EACI,cA/CtB;AR+hDd;AQ9+CgC;EACI,cAlDtB;ARkiDd;AQx+CwB;EACI,cA3Dd;ARqiDd;AQn+CY;EACI,cAnEF;ARwiDd;AQx9CyC;EACI,cAjF/B;AR2iDd;AQ/8CI;EACI,yBA7FM;EA8FN,yBAAA;ARi9CR;AQh9CQ;EAKI,gDAAA;EACA,gDAAA;AR88CZ;AQ38CI;EACI,yBAzGM;EA0GN,qBA1GM;ARujDd;AQ38CI;EACI,yBAAA;AR68CR;AQ58CQ;EAGE,qCAAA;AR48CV;AQz8CI;EACI,yBAAA;AR28CR;AQx8CQ;EACI,mBAzHE;ARmkDd;AQv8CI;EACI,mBA7HM;EA8HN,qBA9HM;ARukDd;AQv8CI;EACI,oCAAA;EACA,oCAAA;ARy8CR;AQv8CI;EACI,gCAAA;ARy8CR;AQv8CI;EACI,gCAAA;ARy8CR;AQv8CI;EACI,4BA3IM;EA4IN,cA5IM;ARqlDd;AQt8CQ;EACI,mCAAA;EACA,cAjJE;ARylDd;AQn8CQ;EACI,cAvJE;AR4lDd;AQl8CI;EACI,oCAAA;EACA,yBAAA;ARo8CR;AQn8CQ;EAKI,oCAAA;EACA,oCAAA;ARi8CZ;AQ77CQ;EACI,qBAxKE;ARumDd;AQ77CQ;EACI,mBA3KE;AR0mDd;AQ37CQ;EACI,yBAhLE;EAiLF,qBAjLE;AR8mDd;AQz7CQ;EACI,cAtLE;ARinDd;AQv7CQ;EACE,yBA3LI;EA4LJ,qBA5LI;ARqnDd;AQt7CI;EACI,yBAhMM;ARwnDd;AQp7CY;EACI,cArMF;AR2nDd;AQh7CY;EACI,aA5MF;AR8nDd;AQ56CY;EACI,aAnNF;ARioDd;AQz6CQ;EACI,aAzNE;ARooDd;AQt6CY;EACI,eA/NF;ARuoDd;AQt6CY;EACI,aAlOF;AR0oDd;AQn6CQ;EACI,wBAAA;ARq6CZ;AQj6CQ;EACI,0BAAA;ARm6CZ;AQj6CQ;EACI,aAhPE;ARmpDd;AQh6CI;EACI,oCAAA;ARk6CR;AQh6CI;EACI,cAvPM;ARypDd;AQ95CY;EACI,mBA5PF;EA6PE,WL7xJR;AH6rMR;;AQn5C4B;EACI,cARlB;AR85Cd;AQj5CgC;EACI,cAdtB;ARi6Cd;AQ34CgC;EACI,+BAAA;EACA,gCAAA;AR64CpC;AQ14C4B;EACI,cA5BlB;ARw6Cd;AQ34CgC;EACI,cA9BtB;AR26Cd;AQh4CgC;EACI,mBA5CtB;AR86Cd;AQh4CgC;EACI,cA/CtB;ARi7Cd;AQh4CgC;EACI,cAlDtB;ARo7Cd;AQ13CwB;EACI,cA3Dd;ARu7Cd;AQr3CY;EACI,cAnEF;AR07Cd;AQ12CyC;EACI,cAjF/B;AR67Cd;AQj2CI;EACI,yBA7FM;EA8FN,yBAAA;ARm2CR;AQl2CQ;EAKI,4DAAA;EACA,4DAAA;ARg2CZ;AQ71CI;EACI,yBAzGM;EA0GN,qBA1GM;ARy8Cd;AQ71CI;EACI,yBAAA;AR+1CR;AQ91CQ;EAGE,iDAAA;AR81CV;AQ31CI;EACI,yBAAA;AR61CR;AQ11CQ;EACI,mBAzHE;ARq9Cd;AQz1CI;EACI,mBA7HM;EA8HN,qBA9HM;ARy9Cd;AQz1CI;EACI,oCAAA;EACA,oCAAA;AR21CR;AQz1CI;EACI,gCAAA;AR21CR;AQz1CI;EACI,gCAAA;AR21CR;AQz1CI;EACI,4BA3IM;EA4IN,cA5IM;ARu+Cd;AQx1CQ;EACI,iCAAA;EACA,cAjJE;AR2+Cd;AQr1CQ;EACI,cAvJE;AR8+Cd;AQp1CI;EACI,oCAAA;EACA,yBAAA;ARs1CR;AQr1CQ;EAKI,oCAAA;EACA,oCAAA;ARm1CZ;AQ/0CQ;EACI,qBAxKE;ARy/Cd;AQ/0CQ;EACI,mBA3KE;AR4/Cd;AQ70CQ;EACI,yBAhLE;EAiLF,qBAjLE;ARggDd;AQ30CQ;EACI,cAtLE;ARmgDd;AQz0CQ;EACE,yBA3LI;EA4LJ,qBA5LI;ARugDd;AQx0CI;EACI,yBAhMM;AR0gDd;AQt0CY;EACI,cArMF;AR6gDd;AQl0CY;EACI,aA5MF;ARghDd;AQ9zCY;EACI,aAnNF;ARmhDd;AQ3zCQ;EACI,aAzNE;ARshDd;AQxzCY;EACI,eA/NF;ARyhDd;AQxzCY;EACI,aAlOF;AR4hDd;AQrzCQ;EACI,wBAAA;ARuzCZ;AQnzCQ;EACI,0BAAA;ARqzCZ;AQnzCQ;EACI,aAhPE;ARqiDd;AQlzCI;EACI,oCAAA;ARozCR;AQlzCI;EACI,cAvPM;AR2iDd;AQhzCY;EACI,mBA5PF;EA6PE,WLhiKR;AHk1MR;;AQryC4B;EACI,cARlB;ARgzCd;AQnyCgC;EACI,cAdtB;ARmzCd;AQ7xCgC;EACI,+BAAA;EACA,gCAAA;AR+xCpC;AQ5xC4B;EACI,cA5BlB;AR0zCd;AQ7xCgC;EACI,cA9BtB;AR6zCd;AQlxCgC;EACI,mBA5CtB;ARg0Cd;AQlxCgC;EACI,cA/CtB;ARm0Cd;AQlxCgC;EACI,cAlDtB;ARs0Cd;AQ5wCwB;EACI,cA3Dd;ARy0Cd;AQvwCY;EACI,cAnEF;AR40Cd;AQ5vCyC;EACI,cAjF/B;AR+0Cd;AQnvCI;EACI,yBA7FM;EA8FN,yBAAA;ARqvCR;AQpvCQ;EAKI,mEAAA;EACA,mEAAA;ARkvCZ;AQ/uCI;EACI,yBAzGM;EA0GN,qBA1GM;AR21Cd;AQ/uCI;EACI,yBAAA;ARivCR;AQhvCQ;EAGE,wDAAA;ARgvCV;AQ7uCI;EACI,yBAAA;AR+uCR;AQ5uCQ;EACI,mBAzHE;ARu2Cd;AQ3uCI;EACI,mBA7HM;EA8HN,qBA9HM;AR22Cd;AQ3uCI;EACI,oCAAA;EACA,oCAAA;AR6uCR;AQ3uCI;EACI,gCAAA;AR6uCR;AQ3uCI;EACI,gCAAA;AR6uCR;AQ3uCI;EACI,4BA3IM;EA4IN,cA5IM;ARy3Cd;AQ1uCQ;EACI,mCAAA;EACA,cAjJE;AR63Cd;AQvuCQ;EACI,cAvJE;ARg4Cd;AQtuCI;EACI,oCAAA;EACA,yBAAA;ARwuCR;AQvuCQ;EAKI,oCAAA;EACA,oCAAA;ARquCZ;AQjuCQ;EACI,qBAxKE;AR24Cd;AQjuCQ;EACI,mBA3KE;AR84Cd;AQ/tCQ;EACI,yBAhLE;EAiLF,qBAjLE;ARk5Cd;AQ7tCQ;EACI,cAtLE;ARq5Cd;AQ3tCQ;EACE,yBA3LI;EA4LJ,qBA5LI;ARy5Cd;AQ1tCI;EACI,yBAhMM;AR45Cd;AQxtCY;EACI,cArMF;AR+5Cd;AQptCY;EACI,aA5MF;ARk6Cd;AQhtCY;EACI,aAnNF;ARq6Cd;AQ7sCQ;EACI,aAzNE;ARw6Cd;AQ1sCY;EACI,eA/NF;AR26Cd;AQ1sCY;EACI,aAlOF;AR86Cd;AQvsCQ;EACI,wBAAA;ARysCZ;AQrsCQ;EACI,0BAAA;ARusCZ;AQrsCQ;EACI,aAhPE;ARu7Cd;AQpsCI;EACI,oCAAA;ARssCR;AQpsCI;EACI,cAvPM;AR67Cd;AQlsCY;EACI,mBA5PF;EA6PE,WLnyKR;AHu+MR;;AQvrC4B;EACI,cARlB;ARksCd;AQrrCgC;EACI,cAdtB;ARqsCd;AQ/qCgC;EACI,+BAAA;EACA,gCAAA;ARirCpC;AQ9qC4B;EACI,cA5BlB;AR4sCd;AQ/qCgC;EACI,cA9BtB;AR+sCd;AQpqCgC;EACI,mBA5CtB;ARktCd;AQpqCgC;EACI,cA/CtB;ARqtCd;AQpqCgC;EACI,cAlDtB;ARwtCd;AQ9pCwB;EACI,cA3Dd;AR2tCd;AQzpCY;EACI,cAnEF;AR8tCd;AQ9oCyC;EACI,cAjF/B;ARiuCd;AQroCI;EACI,yBA7FM;EA8FN,yBAAA;ARuoCR;AQtoCQ;EAKI,oEAAA;EACA,oEAAA;ARooCZ;AQjoCI;EACI,yBAzGM;EA0GN,qBA1GM;AR6uCd;AQjoCI;EACI,yBAAA;ARmoCR;AQloCQ;EAGE,yDAAA;ARkoCV;AQ/nCI;EACI,yBAAA;ARioCR;AQ9nCQ;EACI,mBAzHE;ARyvCd;AQ7nCI;EACI,mBA7HM;EA8HN,qBA9HM;AR6vCd;AQ7nCI;EACI,oCAAA;EACA,oCAAA;AR+nCR;AQ7nCI;EACI,gCAAA;AR+nCR;AQ7nCI;EACI,gCAAA;AR+nCR;AQ7nCI;EACI,4BA3IM;EA4IN,cA5IM;AR2wCd;AQ5nCQ;EACI,mCAAA;EACA,cAjJE;AR+wCd;AQznCQ;EACI,cAvJE;ARkxCd;AQxnCI;EACI,oCAAA;EACA,yBAAA;AR0nCR;AQznCQ;EAKI,oCAAA;EACA,oCAAA;ARunCZ;AQnnCQ;EACI,qBAxKE;AR6xCd;AQnnCQ;EACI,mBA3KE;ARgyCd;AQjnCQ;EACI,yBAhLE;EAiLF,qBAjLE;ARoyCd;AQ/mCQ;EACI,cAtLE;ARuyCd;AQ7mCQ;EACE,yBA3LI;EA4LJ,qBA5LI;AR2yCd;AQ5mCI;EACI,yBAhMM;AR8yCd;AQ1mCY;EACI,cArMF;ARizCd;AQtmCY;EACI,aA5MF;ARozCd;AQlmCY;EACI,aAnNF;ARuzCd;AQ/lCQ;EACI,aAzNE;AR0zCd;AQ5lCY;EACI,eA/NF;AR6zCd;AQ5lCY;EACI,aAlOF;ARg0Cd;AQzlCQ;EACI,wBAAA;AR2lCZ;AQvlCQ;EACI,0BAAA;ARylCZ;AQvlCQ;EACI,aAhPE;ARy0Cd;AQtlCI;EACI,oCAAA;ARwlCR;AQtlCI;EACI,cAvPM;AR+0Cd;AQplCY;EACI,mBA5PF;EA6PE,WLtiLR;AH4nNR;;AQzkC4B;EACI,cARlB;ARolCd;AQvkCgC;EACI,cAdtB;ARulCd;AQjkCgC;EACI,+BAAA;EACA,gCAAA;ARmkCpC;AQhkC4B;EACI,cA5BlB;AR8lCd;AQjkCgC;EACI,cA9BtB;ARimCd;AQtjCgC;EACI,mBA5CtB;ARomCd;AQtjCgC;EACI,cA/CtB;ARumCd;AQtjCgC;EACI,cAlDtB;AR0mCd;AQhjCwB;EACI,cA3Dd;AR6mCd;AQ3iCY;EACI,cAnEF;ARgnCd;AQhiCyC;EACI,cAjF/B;ARmnCd;AQvhCI;EACI,yBA7FM;EA8FN,yBAAA;ARyhCR;AQxhCQ;EAKI,+CAAA;EACA,+CAAA;ARshCZ;AQnhCI;EACI,yBAzGM;EA0GN,qBA1GM;AR+nCd;AQnhCI;EACI,yBAAA;ARqhCR;AQphCQ;EAGE,oCAAA;ARohCV;AQjhCI;EACI,yBAAA;ARmhCR;AQhhCQ;EACI,mBAzHE;AR2oCd;AQ/gCI;EACI,mBA7HM;EA8HN,qBA9HM;AR+oCd;AQ/gCI;EACI,oCAAA;EACA,oCAAA;ARihCR;AQ/gCI;EACI,gCAAA;ARihCR;AQ/gCI;EACI,gCAAA;ARihCR;AQ/gCI;EACI,4BA3IM;EA4IN,cA5IM;AR6pCd;AQ9gCQ;EACI,kCAAA;EACA,cAjJE;ARiqCd;AQ3gCQ;EACI,cAvJE;ARoqCd;AQ1gCI;EACI,oCAAA;EACA,yBAAA;AR4gCR;AQ3gCQ;EAKI,oCAAA;EACA,oCAAA;ARygCZ;AQrgCQ;EACI,qBAxKE;AR+qCd;AQrgCQ;EACI,mBA3KE;ARkrCd;AQngCQ;EACI,yBAhLE;EAiLF,qBAjLE;ARsrCd;AQjgCQ;EACI,cAtLE;ARyrCd;AQ//BQ;EACE,yBA3LI;EA4LJ,qBA5LI;AR6rCd;AQ9/BI;EACI,yBAhMM;ARgsCd;AQ5/BY;EACI,cArMF;ARmsCd;AQx/BY;EACI,aA5MF;ARssCd;AQp/BY;EACI,aAnNF;ARysCd;AQj/BQ;EACI,aAzNE;AR4sCd;AQ9+BY;EACI,eA/NF;AR+sCd;AQ9+BY;EACI,aAlOF;ARktCd;AQ3+BQ;EACI,wBAAA;AR6+BZ;AQz+BQ;EACI,0BAAA;AR2+BZ;AQz+BQ;EACI,aAhPE;AR2tCd;AQx+BI;EACI,oCAAA;AR0+BR;AQx+BI;EACI,cAvPM;ARiuCd;AQt+BY;EACI,mBA5PF;EA6PE,WLzyLR;AHixNR;;AQ39B4B;EACI,cARlB;ARs+Bd;AQz9BgC;EACI,cAdtB;ARy+Bd;AQn9BgC;EACI,+BAAA;EACA,gCAAA;ARq9BpC;AQl9B4B;EACI,cA5BlB;ARg/Bd;AQn9BgC;EACI,cA9BtB;ARm/Bd;AQx8BgC;EACI,mBA5CtB;ARs/Bd;AQx8BgC;EACI,cA/CtB;ARy/Bd;AQx8BgC;EACI,cAlDtB;AR4/Bd;AQl8BwB;EACI,cA3Dd;AR+/Bd;AQ77BY;EACI,cAnEF;ARkgCd;AQl7ByC;EACI,cAjF/B;ARqgCd;AQz6BI;EACI,yBA7FM;EA8FN,yBAAA;AR26BR;AQ16BQ;EAKI,8CAAA;EACA,8CAAA;ARw6BZ;AQr6BI;EACI,yBAzGM;EA0GN,qBA1GM;ARihCd;AQr6BI;EACI,yBAAA;ARu6BR;AQt6BQ;EAGE,mCAAA;ARs6BV;AQn6BI;EACI,yBAAA;ARq6BR;AQl6BQ;EACI,mBAzHE;AR6hCd;AQj6BI;EACI,mBA7HM;EA8HN,qBA9HM;ARiiCd;AQj6BI;EACI,oCAAA;EACA,oCAAA;ARm6BR;AQj6BI;EACI,gCAAA;ARm6BR;AQj6BI;EACI,gCAAA;ARm6BR;AQj6BI;EACI,4BA3IM;EA4IN,cA5IM;AR+iCd;AQh6BQ;EACI,kCAAA;EACA,cAjJE;ARmjCd;AQ75BQ;EACI,cAvJE;ARsjCd;AQ55BI;EACI,oCAAA;EACA,yBAAA;AR85BR;AQ75BQ;EAKI,oCAAA;EACA,oCAAA;AR25BZ;AQv5BQ;EACI,qBAxKE;ARikCd;AQv5BQ;EACI,mBA3KE;ARokCd;AQr5BQ;EACI,yBAhLE;EAiLF,qBAjLE;ARwkCd;AQn5BQ;EACI,cAtLE;AR2kCd;AQj5BQ;EACE,yBA3LI;EA4LJ,qBA5LI;AR+kCd;AQh5BI;EACI,yBAhMM;ARklCd;AQ94BY;EACI,cArMF;ARqlCd;AQ14BY;EACI,aA5MF;ARwlCd;AQt4BY;EACI,aAnNF;AR2lCd;AQn4BQ;EACI,aAzNE;AR8lCd;AQh4BY;EACI,eA/NF;ARimCd;AQh4BY;EACI,aAlOF;ARomCd;AQ73BQ;EACI,wBAAA;AR+3BZ;AQ33BQ;EACI,0BAAA;AR63BZ;AQ33BQ;EACI,aAhPE;AR6mCd;AQ13BI;EACI,oCAAA;AR43BR;AQ13BI;EACI,cAvPM;ARmnCd;AQx3BY;EACI,mBA5PF;EA6PE,WL5iMR;AHs6NR;;AQ72B4B;EACI,kCAAA;EAAA,uCAAA;ARg3BhC;AQ32BgC;EACI,kCAAA;EAAA,uCAAA;AR62BpC;AQr2BgC;EACI,mDAAA;EAAA,wDAAA;EACA,oDAAA;EAAA,yDAAA;ARu2BpC;AQp2B4B;EACI,kCAAA;EAAA,uCAAA;ARs2BhC;AQr2BgC;EACI,kCAAA;EAAA,uCAAA;ARu2BpC;AQ11BgC;EACI,uCAAA;EAAA,4CAAA;AR41BpC;AQ11BgC;EACI,kCAAA;EAAA,uCAAA;AR41BpC;AQ11BgC;EACI,kCAAA;EAAA,uCAAA;AR41BpC;AQp1BwB;EACI,kCAAA;EAAA,uCAAA;ARs1B5B;AQ/0BY;EACI,kCAAA;EAAA,uCAAA;ARi1BhB;AQp0ByC;EACI,kCAAA;EAAA,uCAAA;ARs0B7C;AQ3zBI;EACI,6CAAA;EAAA,kDAAA;EACA,6CAAA;EAAA,kDAAA;AR6zBR;AQ5zBQ;EAKI,6CAAA;EAAA,kDAAA;EACD,6CAAA;EAAA,kDAAA;AR0zBX;AQvzBI;EACI,6CAAA;EAAA,kDAAA;EACA,yCAAA;EAAA,8CAAA;ARyzBR;AQvzBI;EACI,6CAAA;EAAA,kDAAA;ARyzBR;AQxzBQ;EAGE,kCAAA;EAAA,uCAAA;ARwzBV;AQrzBI;EACI,6CAAA;EAAA,kDAAA;ARuzBR;AQpzBQ;EACI,uCAAA;EAAA,4CAAA;ARszBZ;AQnzBI;EACI,uCAAA;EAAA,4CAAA;EACA,yCAAA;EAAA,8CAAA;ARqzBR;AQnzBI;EACI,wDAAA;EAAA,6DAAA;EACA,wDAAA;EAAA,6DAAA;ARqzBR;AQnzBI;EACI,oDAAA;EAAA,yDAAA;ARqzBR;AQnzBI;EACI,oDAAA;EAAA,yDAAA;ARqzBR;AQnzBI;EACI,gDAAA;EAAA,qDAAA;EACA,kCAAA;EAAA,uCAAA;ARqzBR;AQlzBQ;EACI,yCAAA;EAAA,8CAAA;EACA,kCAAA;EAAA,uCAAA;ARozBZ;AQ/yBQ;EACI,kCAAA;EAAA,uCAAA;ARizBZ;AQ9yBI;EACI,wDAAA;EAAA,6DAAA;EACA,6CAAA;EAAA,kDAAA;ARgzBR;AQ/yBQ;EAKI,wDAAA;EAAA,6DAAA;EACA,wDAAA;EAAA,6DAAA;AR6yBZ;AQzyBQ;EACI,yCAAA;EAAA,8CAAA;AR2yBZ;AQzyBQ;EACI,uCAAA;EAAA,4CAAA;AR2yBZ;AQvyBQ;EACI,6CAAA;EAAA,kDAAA;EACA,yCAAA;EAAA,8CAAA;ARyyBZ;AQryBQ;EACI,kCAAA;EAAA,uCAAA;ARuyBZ;AQnyBQ;EACE,6CAAA;EAAA,kDAAA;EACA,yCAAA;EAAA,8CAAA;ARqyBV;AQlyBI;EACI,6CAAA;EAAA,kDAAA;ARoyBR;AQhyBY;EACI,kCAAA;EAAA,uCAAA;ARkyBhB;AQ5xBY;EACI,iCAAA;EAAA,sCAAA;AR8xBhB;AQxxBY;EACI,iCAAA;EAAA,sCAAA;AR0xBhB;AQrxBQ;EACI,iCAAA;EAAA,sCAAA;ARuxBZ;AQlxBY;EACI,mCAAA;EAAA,wCAAA;ARoxBhB;AQlxBY;EACI,iCAAA;EAAA,sCAAA;ARoxBhB;AQ/wBQ;EACI,4CAAA;EAAA,iDAAA;ARixBZ;AQ7wBQ;EACI,8CAAA;EAAA,mDAAA;AR+wBZ;AQ7wBQ;EACI,iCAAA;EAAA,sCAAA;AR+wBZ;AQ5wBI;EACI,6CAAA;EAAA,kDAAA;AR8wBR;AQ5wBI;EACI,kCAAA;EAAA,uCAAA;AR8wBR;AQ1wBY;EACI,uCAAA;EAAA,4CAAA;AR4wBhB;;AQtwBI;EACI,cAAA;ARywBR;AQxwBQ;EACI,eAAA;AR0wBZ;AQxwBQ;EACI,QAAA;EACA,UAAA;EAAA,aAAA;EACA,eAAA;AR0wBZ;AQrwB4B;EACI,WAAA;EACA,UAAA;EAAA,aAAA;ARuwBhC;AQlwBgC;EACI,yBAAA;ARowBpC;AQnwBoC;EACI,WAAA;EACA,UAAA;EAAA,aAAA;ARqwBxC;AQnwBoC;EACI,WAAA;EACA,UAAA;EAAA,aAAA;ARqwBxC;AQ/vBoB;EACI,kBAAA;EACA,cAAA;ARiwBxB;AQ9vBgB;EACI,UAAA;EACA,WAAA;EAAA,cAAA;ARgwBpB;AQ9vBgB;EACI,iBAAA;EACA,cAAA;ARgwBpB;AI3mOI;EIm0MI;IA4CQ,oBAAA;ERgwBd;AACF;AQ9vBQ;EACI,YAAA;EACA,eAAA;ARgwBZ;AQ9vBQ;EACI,mBAAA;EACA,cAAA;ARgwBZ;AIxnOI;EIs3MI;IAIQ,eAAA;ERkwBd;AACF;AQ/vBY;EACI,kBAAA;ARiwBhB;AIvpOI;EIy5MI;IAEQ,QAAA;IACA,OAAA;ERgwBd;AACF;AQ9vBgB;EACI,0CAAA;EACA,uCAAA;EACA,0CAAA;EACA,yBAAA;EACA,wCAAA;ARgwBpB;AQ9vBgB;EACI,eAAA;EACA,6BAAA;EACA,8BAAA;ARgwBpB;AQ/vBoB;EACI,kBAAA;EACA,gBAAA;ARiwBxB;AItpOI;EIy5MQ;IAEQ,QAAA;IACA,UAAA;IAAA,aAAA;ER+vBlB;AACF;AQ7vBY;EACI,OAAA;EACA,WAAA;EACA,gBAAA;AR+vBhB;AQ5vBQ;EACI,QAAA;EACA,UAAA;EAAA,aAAA;AR8vBZ;AQ3vBY;EACI,OAAA;AR6vBhB;AQ1vBgB;EACI,OAAA;AR4vBpB;AQxvBQ;EACI,eAAA;EACA,mBAAA;AR0vBZ;AQxvBQ;EACI,OAAA;EACA,WAAA;EAAA,cAAA;AR0vBZ;AQxvBQ;EACI,iBAAA;EACA,eAAA;AR0vBZ;AQxvBQ;EACI,kBAAA;EACA,oBAAA;AR0vBZ;AQxvBQ;EACI,kBAAA;EACA,cAAA;AR0vBZ;AQxvBQ;EACI,0BAAA;EACA,iBAAA;AR0vBZ;AQtvBgB;EACI,iBAAA;EACA,eAAA;ARwvBpB;AQvvBoB;EACI,cAAA;ARyvBxB;AQpvBQ;EACI,kBAAA;EACA,cAAA;ARsvBZ;AQnvBY;EACI,kBAAA;ARqvBhB;;AQ/uBI;EACI,UAAA;ARkvBR;;AQ9uBI;EACG,UAAA;EACA,wBAAA;ARivBP;;AQ1uBI;EACI,yBLzsMS;AHs7NjB;AQ3uBI;EACI,mBL9sMS;AH27NjB;AQ3uBI;EACI,mBL/sMS;EKgtMT,qBLtsMY;AHm7NpB;AQ3uBY;EACI,cAAA;AR6uBhB;AQxuBgB;EACI,cLltMA;AH47NpB;AQzuBoB;EACI,yBLzrMI;EK0rMJ,qBL1rMI;EK2rMJ,cL1tMJ;AHq8NpB;AQvuBoB;EACI,qBLvtMJ;AHg8NpB;AQnuBY;EACI,gCAAA;ARquBhB;AQhuBI;EACI,mBL/uMS;EKgvMT,qBLtuMY;AHw8NpB;AQjuBQ;EACI,mBLnjNF;AHsxOV;AQhuBI;EACI,mBLtvMS;EKuvMT,qBL7uMY;AH+8NpB;AQhuBY;EACI,aAAA;ARkuBhB;AQhuBY;EACI,cAAA;ARkuBhB;AQ1tB4B;EACI,cLnwMZ;AH+9NpB;AQrtBgC;EACI,mBL5uMR;AHm8N5B;AQttBoC;EACI,cL7wMpB;AHq+NpB;AQltBoC;EACI,mBLrvMZ;AHy8N5B;AQntBwC;EACI,cLtxMxB;AH2+NpB;AQltB4C;EACI,qBL1xM5B;AH8+NpB;AQ3sBwB;EACI,WLrkNpB;AHkxOR;AQzsBwB;EACI,cLtyMR;AHi/NpB;AQtsB4B;EACI,cL/yMZ;AHu/NpB;AQvsBgC;EACI,cL7yMhB;AHs/NpB;AQvsBgC;EACI,cLpzMhB;AH6/NpB;AQvsBgC;EACI,cL3nN1B;AHo0OV;AQpsB4B;EACI,mBL9xMJ;EK+xMI,WL/lNxB;AHqyOR;AQpsBoC;EACI,+BAAA;EACA,gCAAA;ARssBxC;AQnsBgC;EACI,mBLhzML;EKizMK,cL3oN1B;AHg1OV;AQpsBoC;EACI,cL50MvB;EK60MuB,mBL70MvB;AHmhOjB;AQpsBoC;EACI,cLjpN9B;AHu1OV;AQ7rB4B;EACI,mBL/0MZ;AH8gOpB;AQzrBoB;EACI,cLz1MJ;AHohOpB;AQtrBgC;EACI,cLh2MhB;AHwhOpB;AQvrBoC;EACI,mBL1qN9B;AHm2OV;AQvrBoC;EACI,cL7qN9B;AHs2OV;AQvrBoC;EACI,cLhrN9B;AHy2OV;AQlrB4B;EACI,mBLr1MJ;AHygO5B;AQnrBgC;EACI,cLt3MhB;AH2iOpB;AQlrB4B;EACI,mBL31MJ;AH+gO5B;AQnrBgC;EACI,cL53MhB;AHijOpB;AQ9qB4B;EACI,uBAAA;EACA,cLzsNtB;AHy3OV;AQxqBgB;EACI,+BAAA;EACA,gCAAA;AR0qBpB;AQtqBQ;EACI,cLl5MQ;AH0jOpB;AQtqBQ;EACI,yBAAA;EACA,cLp5MQ;AH4jOpB;AQvqBY;EACI,yBL33MY;EK43MZ,qBL53MY;EK63MZ,cL55MI;AHqkOpB;AQrqBY;EACI,gCAAA;ARuqBhB;AQhqBgB;EACI,aAAA;ARkqBpB;AQ3pBoB;EACI,cAAA;AR6pBxB;AQ3pBoB;EACI,aAAA;AR6pBxB;AQvpBI;EACI,yBL97MS;EK+7MT,qBLr7MY;AH8kOpB;AQvpBI;EACI,yBLl8MS;EKm8MT,qBLz7MY;EK07MZ,cLj8MY;AH0lOpB;AQtpBQ;EACI,+BAAA;EACA,yBLt6MiB;AH8jO7B;AQtpBQ;EACI,6BAAA;ARwpBZ;AQvpBY;EACI,yBAAA;EACA,cL58MI;AHqmOpB;AQxpBgB;EACI,mBLn9MH;EKo9MG,cL/8MA;AHymOpB;AQxpBgB;EACI,cLl9MA;AH4mOpB;AQvpBY;EACI,mBLz9MC;EK09MD,+BAAA;ARypBhB;AQxpBgB;EACI,kBAAA;AR0pBpB;AQxpBgB;EACI,mBL/9MH;AHynOjB;AQtpBwB;EACI,cL79MR;AHqnOpB;AQvpB4B;EACI,mBLp8MJ;AH6lO5B;AQxpBgC;EACI,cLn+MhB;AH6nOpB;AQvpB4B;EACI,mBL18MJ;AHmmO5B;AQxpBgC;EACI,cLz+MhB;AHmoOpB;AQrpB4B;EACI,mBLl9MJ;AHymO5B;AQlpBgC;EACI,mBLx9MR;EKy9MQ,yBAAA;ARopBpC;AQ9oBwC;EACI,cLn0NlC;AHm9OV;AQpoBgC;EACI,mBL7+MR;AHmnO5B;AQtnB4B;EACI,cL7hNZ;AHqpOpB;AQvnBgC;EACI,yBLhgNR;AHynO5B;AQpnBoC;EACI,cLjiNpB;AHupOpB;AQrnBwC;EACI,yBLxgNhB;AH+nO5B;AQpnB4C;EACI,qBLviN5B;AH6pOpB;AQ9mBoB;EACI,yBLvjNP;AHuqOjB;AQvmBgC;EACI,yBL/hNR;AHwoO5B;AQ7lBgB;EACI,cAAA;AR+lBpB;AQzlBQ;EACI,+BAAA;EACA,yBLtlNK;AHirOjB;AQzlBQ;EACI,6BAAA;AR2lBZ;AQ1lBY;EACI,cLtlNI;AHkrOpB;AQ3lBgB;EACI,mBL/lNH;EKgmNG,cLzlNA;AHsrOpB;AQ3lBgB;EACI,mBL95NV;AH2/OV;AQ1lBY;EACI,mBLrmNC;EKsmND,+BAAA;AR4lBhB;AQ1lBoB;EACI,cAAA;AR4lBxB;AQ1lBoB;EACI,aAAA;AR4lBxB;AQvlBwB;EACI,cL1mNR;AHmsOpB;AQvlBwB;EACI,cL9mNR;AHusOpB;AQxlB4B;EACI,mBLrlNJ;AH+qO5B;AQzlBgC;EACI,cLpnNhB;AH+sOpB;AQzlBgC;EACI,yBAAA;AR2lBpC;AQxlB4B;EACI,mBL9lNJ;AHwrO5B;AQzlBgC;EACI,cL7nNhB;AHwtOpB;AQtlB4B;EACI,mBLtmNJ;AH8rO5B;AQnlBgC;EACI,mBL5mNR;EK6mNQ,yBAAA;ARqlBpC;AQ/kBwC;EACI,cLv9NlC;AHwiPV;AQrkBgC;EACI,mBLjoNR;AHwsO5B;AQ/jBoB;EACI,gBAAA;ARikBxB;AQ3jBI;EACI,mBLrrNS;AHkvOjB;AQ3jBI;EACI,cLnrNY;AHgvOpB;AQ3jBI;EACI,oCAAA;EACA,gCAAA;AR6jBR;AQ3jBI;EACI,cL1rNY;AHuvOpB;AQ3jBI;EACI,yBL9pNoB;EK+pNpB,cL1rNY;AHuvOpB;AQzjBY;;EAEI,gCAAA;AR2jBhB;AQvjBI;EACI,yBL5sNS;EK6sNT,yBAAA;ARyjBR;AQxjBQ;EACI,cL5sNQ;AHswOpB;AQxjBQ;EACI,qBLxsNQ;AHkwOpB;AQxjBQ;EACI,qBL3sNQ;AHqwOpB;AQvjBI;EACI,yBL3tNS;EK4tNT,cLntNY;EKotNZ,qBL7tNS;AHsxOjB;AQxjBQ;EACE,cLttNU;AHgxOpB;AQxjBQ;EACE,cLztNU;AHmxOpB;AQvjBI;EACI,yBLpuNS;AH6xOjB;AQtjBQ;EACI,yBLxuNK;EKyuNL,qBL/tNQ;AHuxOpB;AQnjBQ;EACI,OAAA;EACA,yBLhvNK;EKivNL,yCAAA;ARqjBZ;AQljBoB;EACI,cL9uNJ;AHkyOpB;AQnjBwB;EACI,mBLrtNA;EKstNA,cLjvNR;AHsyOpB;AQhjBY;EACI,cAAA;ARkjBhB;AQjjBgB;EACI,aAAA;ARmjBpB;AQjjBgB;EACI,cAAA;ARmjBpB;AQ/iBQ;EACI,cLjwNQ;AHkzOpB;AQ9iBY;EACI,yBL5wNC;EK6wND,oDAAA;ARgjBhB;AQ3iBgC;EACI,cLhxNhB;AH6zOpB;AQ5iBoC;EACI,yBLnvNZ;EKovNY,cLnxNpB;AHi0OpB;AQ5iB4C;EACI,qBLtxN5B;AHo0OpB;AQziBwC;EACI,qBL5xNxB;AHu0OpB;AQpiB4B;EACI,qBLpyNZ;AH00OpB;AQ9hBY;EACI,WAAA;EACA,mBLjzNC;AHi1OjB;AQ3hBQ;EACI,mBLvzNK;AHo1OjB;AQ1hBI;EACI,yBL3zNS;EK4zNT,cLrzNY;AHi1OpB;AQzhBQ;EACI,gBAAA;EACA,yBLj0NK;EKk0NL,cL3zNQ;AHs1OpB;AQxhBI;EACI,cLh4NK;AH05Ob;AQxhBI;EACI,cLl0NY;EKm0NZ,yBL10NS;EK20NT,qBL7zNa;AHu1OrB;AQthBY;EACI,yBLh1NC;EKi1ND,cL10NI;AHk2OpB;AQvhBgB;EACI,yBLn1NH;EKo1NG,cL70NA;AHs2OpB;AQnhBY;EACI,cL31NC;AHg3OjB;AQphBgB;EACI,yBL71NH;EK81NG,cLv1NA;AH62OpB;AQrhBoB;EACI,yBLh2NP;EKi2NO,cL11NJ;AHi3OpB;AQhhBY;EACI,yBLz2NC;AH23OjB;AQjhBgB;EACI,yBL32NH;AH83OjB;AQ9gBI;;EAEI,yBLl3NS;AHk4OjB;AQ9gBI;EACI,oCAAA;EACA,yBAAA;ARghBR;AQ9gBI;EACI,yBL33NS;AH24OjB;AQ9gBI;EACI,gCAAA;ARghBR;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ/gBQ;EACI,oCAAA;ARihBZ;AQ9gBI;EACI,wCAAA;ARghBR;AQ9gBI;EACI,+CAAA;ARghBR;AQ9gBI;EACI,2CAAA;ARghBR;AQ9gBI;EACI,iDAAA;ARghBR;AQ9gBI;EACI,yBLn6NS;EKo6NT,gCAAA;ARghBR;AQ9gBI;EACI,yBLv6NS;AHu7OjB;AQ9gBI;EACI,gCAAA;ARghBR;AQ9gBI;EACI,yBL76NS;AH67OjB;AQ9gBI;EACI,yBLl6Na;AHk7OrB;AQ9gBI;EACI,yBLn7NS;EKo7NT,yBAAA;EACA,gBAAA;ARghBR;AQ/gBQ;EACE,yBLv7NO;EKw7NP,mCAAA;ARihBV;AQ/gBQ;EACE,cLp7NU;AHq8OpB;AQ9gBM;;;;EAIE,yBLp8NS;AHo9OjB;AQ9gBM;;;;EAIE,2BL18NS;AH09OjB;AQ9gBM;;;;EAIE,0BLh9NS;AHg+OjB;AQ9gBM;;;;;;EAME,4BLx9NS;AHw+OjB;AQ9gBI;EACI,cLl9NY;EKm9NZ,yBL19NS;EK29NT,yBAAA;ARghBR;AQ/gBQ;EACI,yBL/9NK;AHg/OjB;AQ/gBQ;EACI,yBLl+NK;EKm+NL,qBA3xBO;AR4yCnB;AQ9gBI;EACI,yBLv+NS;AHu/OjB;AQ9gBI;EACI,yBL1+NS;AH0/OjB;AQ9gBI;EACI,yBL7+NS;AH6/OjB;AQ9gBI;EACI,yBL9+NS;EK++NT,cLx+NY;AHw/OpB;AQ9gBI;EACI,yBLl/NS;EKm/NT,qBLz+NY;AHy/OpB;AQ/gBQ;EACI,qBL3+NQ;AH4/OpB;AQ/gBQ;EACI,qBL9+NQ;AH+/OpB;AQ9gBI;EACI,cLr/NY;AHqgPpB;AQ9gBI;EACI,yBAAA;ARghBR;AQ9gBI;EACI,cL//NY;AH+gPpB;AQ9gBI;EACI,yBLrgOS;EKsgOT,cLngOY;AHmhPpB;AQ9gBI;EACI,qBL//NY;AH+gPpB;AQ9gBI;EACI,yBL5gOS;AH4hPjB;AQ9gBI;EACI,yBLjhOS;AHiiPjB;AQ9gBI;EACI,yBLphOS;EKqhOT,qBLzgOY;AHyhPpB;AQ/gBQ;EACI,yBLt1OF;AHu2PV;AQ5gBY;EACI,yBL7hOC;EK8hOD,cLrhOI;AHmiPpB;AQvgBgB;EACI,yBLr2OV;AH82PV;AQjgBgB;EACI,yBL7iOH;EK8iOG,qBLpiOA;AHuiPpB;AQjgBgB;EACI,yBLnjOH;AHsjPjB;AQhgBoB;EACI,yBLt3Od;AHw3PV;AQhgBsB;EACE,qBLz3Od;EK03Oc,cL13Od;AH43PV;AQ5fI;EACI,yBLhkOS;AH8jPjB;AQ5fI;EACI,oCAAA;AR8fR;AQ5fI;EACI,cLtkOS;AHokPjB;AQ3fQ;EACI,yBL5jOS;EK6jOT,yBAAA;EACA,cLrkOQ;AHkkPpB;AQ5fY;EAKI,0CAAA;EACA,yBAAA;EACA,cL7kOI;AHukPpB;AQtfI;EACI,qBL/kOY;AHukPpB;AQrfQ;EACI,yBLnlOQ;AH0kPpB;AQpfY;EACI,qBLvlOI;AH6kPpB;AQrfgB;EACI,qBLzlOA;AHglPpB;AQlfI;EACI,yBL3mOS;AH+lPjB;AQjfQ;EACI,qBLnmOQ;EKomOR,gBAAA;ARmfZ;AQhfI;EACI,oCAAA;EACA,yBAAA;ARkfR;AQjfQ;EAKI,oCAAA;EACA,oCAAA;EACA,yBAAA;AR+eZ;AQ5eI;EACI,oCAAA;EACA,gCAAA;EACA,cLjoOS;AH+mPjB;AQ3eQ;EACI,yBL3nOQ;AHwmPpB;AQ1eI;EACI,yBLzoOS;EK0oOT,qBLhoOY;AH4mPpB;AQ1eI;;EAEI,yBL9oOS;AH0nPjB;AQ1eI;EACI,yBAAA;AR4eR;AQ1eI;EACI,yBAAA;AR4eR;AQxeY;EACI,qBL/oOI;AHynPpB;AQzeoB;EACI,qBLjpOJ;EKkpOI,yBLlpOJ;EKmpOI,cL1pOJ;AHqoPpB;AQteY;EACI,qBLzpOI;AHioPpB;AQvegB;EACI,qBL3pOA;EK4pOI,yBL5pOJ;EK6pOI,cLpqOJ;AH6oPpB;AQvegB;EACI,yBL1qOH;EK2qOG,cLpqOA;EKqqOA,qBLlqOA;AH2oPpB;AQreQ;EACI,yBLl/OF;AHy9PV;AQreQ;EACI,yBLn/OA;AH09PZ;AQreQ;EACI,yBLl/OL;AHy9PP;AQreQ;EACI,yBLn/OF;AH09PV;AQreQ;EACI,yBLp/OH;AH29PT;AQreQ;EACI,yBL7/OF;AHo+PV;AQreQ;EACI,yBLpsOI;AH2qPhB;AQreQ;EACI,yBLrrOS;AH4pPrB;AQleY;EACI,qBLlsOI;AHsqPpB;AQnegB;EACI,cLvsOA;EKwsOA,qBLrsOA;AH0qPpB;AQjeQ;EACI,qBL1sOQ;AH6qPpB;AQlegB;EACI,cLntOA;AHurPpB;AQ/dQ;EACI,cLvtOQ;AHwrPpB;AQheY;EACI,yBAAA;EACA,cL5tOI;AH8rPpB;AQ9dI;EACI,cLjuOY;AHisPpB;AQ9dI;EACI,cLpuOY;AHosPpB;AQ9dI;EACI,yBL1uOS;EK2uOT,cLxuOY;EKyuOZ,qBLluOY;AHksPpB;AQ/dQ;EACI,yBL9uOK;AH+sPjB;AQ7dQ;EACI,qBLzuOQ;EK0uOR,mBLpvOK;AHmtPjB;AQ9dY;EACI,yBAAA;ARgehB;AQ7dgB;EACI,qBLvvOA;AHstPpB;AQ3dQ;EACI,cL/vOK;AH4tPjB;AQzdQ;EACI,8BAAA;EACA,qBL3vOQ;AHstPpB;AQxdI;;;;;;;EAOI,qBLrwOY;EKswOZ,cLzwOY;AHmuPpB;AQxdI;EACI,qBLzwOY;EK0wOZ,mBLpxOS;AH8uPjB;AQxdI;;;EAGI,cLzxOS;AHmvPjB;AQxdI;;;;EAII,yBL/xOS;AHyvPjB;AQxdI;EACI,yBLlyOS;AH4vPjB;AQvdQ;EACI,yBL3xOQ;EK4xOR,qBL5xOQ;AHqvPpB;AQtdI;EACI,yBL3yOS;EK4yOT,qBLlyOY;EKmyOZ,cL1yOY;AHkwPpB;AQvdQ;EACI,cL5yOQ;AHqwPpB;AQvdgB;EAGE,cLjzOE;EKkzOF,yBLnyOG;AH0vPrB;AQpdc;EACE,yBLvyOK;AH6vPrB;AQldI;EACI,qBLpzOY;AHwwPpB;AQ3cY;EACI,kCAAA;AR6chB;AQtcgB;EACI,qBLjpPV;AHylQV;AQvcoB;EACI,qBLnpPd;AH4lQV;AQpcQ;EACI,qBL90OQ;EK+0OR,cLl1OQ;AHwxPpB;AQrcY;EACI,qBLj1OI;EKk1OJ,mBL51OC;AHmyPjB;AQrcY;EACI,mBLhqPN;AHumQV;AQhcgB;EACI,gCAAA;ARkcpB;AQjcoB;EACI,cL1qPd;AH6mQV;AQhcwB;EACI,cL72OX;AH+yPjB;AQ5bQ;EACI,qBL12OQ;AHwyPpB;AQvboB;EACI,cL7rPd;EK8rPc,gBL3pPhB;EK4pPgB,qBLp3OJ;AH6yPpB;AQnbY;EACI,qBL33OI;AHgzPpB;AQ9agB;EACI,sBL9sPV;AH8nQV;AQ/aoB;EACI,cLhtPd;EKitPc,gBL9qPhB;EK+qPgB,qBLv4OJ;AHwzPpB;AQ9awB;EACI,cLr5OX;AHq0PjB;AQ1aQ;EACI,sBLl5OQ;AH8zPpB;AQ3aY;EACI,mBL95OC;EK+5OD,qBLr5OI;AHk0PpB;AQ1aQ;EACI,sBLz5OQ;AHq0PpB;AQxaQ;EACI,qBL95OQ;AHw0PpB;AQxagB;EACI,mBL5uPV;AHspQV;AQtagB;EACI,mBLx9ON;AHg4Pd;AQpagB;EACI,mBL59OP;AHk4Pb;AQlagB;EACI,mBLh+OT;AHo4PX;AQhagB;EACI,mBLp+OV;AHs4PV;AQ9ZgB;EACI,mBLx+OL;AHw4Pf;AQ5ZgB;EACI,mBL5+OV;AH04PV;AQvZoB;EACI,cLj9OP;AH02PjB;AQhZgB;EACI,qBL5xPV;AH8qQV;AQjZoB;EACI,cLtxPd;EKuxPc,yBLxwPF;AH2pQtB;AQ9YQ;EACI,qBL19OQ;EK29OR,cLh+OQ;AHg3PpB;AQ/YY;EACI,yBLr8OY;EKs8OZ,cLz+OA;AH03PhB;AQ9YQ;EACI,qBLl+OQ;AHk3PpB;AQ3YY;EACI,yBAAA;AR6YhB;AQtYwB;EACI,qBL3zPlB;AHmsQV;AQhYgB;EACI,qBLz/OA;AH23PpB;AQ/XY;EACI,cLpgPI;AHq4PpB;AQ5XQ;EACI,yBL7gPK;EK8gPL,mCAAA;AR8XZ;AQ5XgB;EACI,yBLjhPH;AH+4PjB;AQzXoB;EACI,cLhhPJ;AH24PpB;AQ1XwB;EACI,yBLzhPX;EK0hPW,yBAAA;AR4X5B;AQtXgB;EACI,aAAA;ARwXpB;AQtXgB;EACI,cAAA;ARwXpB;AQnXY;EACI,mBL1iPC;AH+5PjB;AQ1WgB;EACI,yBLtjPH;AHk6PjB;AQvWoB;EACI,cLrjPJ;AH85PpB;AQxWwB;EACI,yBL9jPX;EK+jPW,yBAAA;AR0W5B;AQnWI;EACI,qBAj4CW;ARsuDnB;AQnWI;EACI,yBL1kPS;EK2kPT,qBAr4CW;AR0uDnB;AQnWI;EACI,yBLhlPS;EKilPT,qBAz4CW;EA04CX,cL7kPY;AHk7PpB;AQnWI;EACI,yBLnlPS;EKolPT,qBA94CW;EA+4CX,cLllPY;AHu7PpB;AQnWI;EACI,qBAl5CW;ARuvDnB;AQnWI;EACI,cLxlPY;AH67PpB;AQlWQ;EACI,yBL/lPK;AHm8PjB;AQhWQ;EACI,yBAAA;ARkWZ;AQ/VI;EACI,8BAAA;ARiWR;AQ/VI;EACI,qBAr6CW;ARswDnB;AQ/VY;EACI,yBL9mPC;AH+8PjB;AQ5VQ;EACI,cLpnPK;AHk9PjB;AQ7VY;EACI,cLv7PN;AHsxQV;AQzVY;EACI,cL1nPI;AHq9PpB;AQ1VgB;EACI,cL5nPA;AHw9PpB;AQrVY;EACI,cLpoPI;AH29PpB;AQnVI;EACI,cLzoPY;EK0oPZ,mBL/oPS;EKgpPT,eAx8CW;AR6xDnB;;AQ/UI;EACI,cLjpPY;AHm+PpB;AQhVI;EACI,cLppPY;AHs+PpB;AQhVI;EACI,qBLjpPY;EKkpPZ,cLxpPY;AH0+PpB;AQhVI;EACI,mBL/pPS;AHi/PjB;AQhVI;EACI,mBLlqPS;EKmqPT,qBLzpPY;EK0pPZ,cLhqPY;AHk/PpB;AQhVI;EACI,cLnqPY;AHq/PpB;AQhVI;EACI,8BAAA;ARkVR;AQhVI;EACI,yBAAA;ARkVR;AQhVI;EACI,mBLhrPS;EKirPT,gCAAA;ARkVR;AQhVI;EACI,mBL1qPY;AH4/PpB;AQhVI;EACI,mBLvrPS;EKwrPT,qBL9qPY;AHggQpB;AQhVI;EACI,mBL3rPS;EK4rPT,qBLlrPY;AHogQpB;AQhVI;EACI,qBLrrPY;AHugQpB;AQhVI;EACI,mBLlsPS;EKmsPT,qBLzrPY;AH2gQpB;AQhVI;EACI,mBL5rPY;AH8gQpB;AQhVI;EACI,mBL/rPY;AHihQpB;AQhVI;EACI,mBLlsPY;AHohQpB;AQ/UQ;EACI,mBLhtPK;EKitPL,qBLvsPQ;AHwhQpB;AQ/UQ;EACI,cLhtPQ;AHiiQpB;AQ/UQ;EACI,mBLvtPK;EKwtPL,qBL9sPQ;AH+hQpB;AQ/UQ;EACI,qBLjtPQ;AHkiQpB;;AQxUI;EACI,aAAA;AR2UR;AQzUI;EACI,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AR2UR;AI91QI;EI+gQA;IAMQ,iBAAA;ER6UV;AACF;AIn2QI;EI+gQA;IASQ,gBAAA;ER+UV;AACF;AIx2QI;EI+gQA;IAYQ,eAAA;ERiVV;AACF;AQhVQ;EACI,eAAA;EACA,gBAAA;ARkVZ;AIj3QI;EI6hQI;IAIQ,aAAA;ERoVd;AACF;AI74QI;EI4jQA;IAEQ,aAAA;ERmVV;AACF;AQhVI;EACI,OAAA;ARkVR;AQjVQ;EACI,cAAA;ARmVZ;AQlVY;EACI,gBAAA;ARoVhB;AQjVQ;EACI,cAAA;ARmVZ;AQlVY;EACI,cAAA;ARoVhB;AQlVY;EACI,aAAA;ARoVhB;;AQ9UA;EACI,cAAA;EACA,8DLxsPY;AHyhQhB;AQhVI;EACI,sBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;ARkVR;AQjVQ;EACI,aAAA;ARmVZ;AQjVQ;EACI,gCAAA;ARmVZ;AQjVQ;EACI,MAAA;EACA,uBAAA;EACA,4BAAA;EACA,UAAA;ARmVZ;AQjVQ;EACI,uBAAA;EACA,4BAAA;ARmVZ;AQjVQ;EACI,wBAAA;ARmVZ;AQjVQ;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;ARmVZ;AQjVgB;EACI,iBAAA;ARmVpB;AQlVoB;EACI,eAAA;ARoVxB;AQjVwB;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;ARmV5B;AQ9UY;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;ARgVhB;AQ/UgB;EACI,kBAAA;ARiVpB;AQ/UwB;EACI,eLxvPb;EKyvPa,cL1+PjB;EC9DT,kBIyiQ2C;EACjB,yBAAA;ARiV5B;AQhV4B;EACI,iBAAA;ARkVhC;AQhV4B;EACI,yBL9nQb;AHg9QnB;AQ9U4B;EACI,aAAA;ARgVhC;AQ1UoC;EACI,eL5wPzB;AHwlQf;AQzUgC;EACI,cLngQzB;EC5DT,kBIgkQmD;AR2UrD;AQ1UoC;EACI,yBLjpQrB;AH69QnB;AQtU4B;EACI,gBAAA;ARwUhC;AQnUgB;EACI,aAAA;EACA,YAAA;EACA,sBLzpQZ;EK0pQY,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;ARqUpB;AQlU4B;EACI,WAAA;ARoUhC;AQhUoB;EACI,iBAAA;ARkUxB;AQ9TY;EACI,wBAAA;ARgUhB;AQ7TQ;EACI,wBAAA;AR+TZ;AQ7TQ;EACI,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eL9zPG;EK+zPH,gBLnuQS;EKouQT,cAAA;EACA,kBAAA;AR+TZ;AQ7TQ;EACI,gCAAA;AR+TZ;AQzTwB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;AR2T5B;AQrTQ;EACI,gCAAA;EACA,WAAA;ARuTZ;AQpTI;EACI,iBAAA;ARsTR;AIjhRI;EI0tQA;IAGQ,iBAAA;ERwTV;AACF;AIthRI;EI0tQA;IAMQ,gBAAA;ER0TV;AACF;AQzTQ;EACI,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AR2TZ;AQrTwB;EACI,yBL1uQT;AHiiRnB;AI3jRI;EIkwQgB;IAKQ,eL72Pb;IK82Pa,yBAAA;ERwT1B;EQvT0B;IACI,iBAAA;ERyT9B;EQvT0B;IACI,UAAA;ERyT9B;AACF;AIhjRI;EIkkQA;IA6LI,wBAAA;ERqTN;AACF;;AQlTA;;EAEI,aAAA;ARqTJ;;AQlTI;EACI,gCAAA;ARqTR;AQnTI;EACI,qBLxxQM;EKyxQN,cLvxQS;AH4kRjB;AQnTI;EACI,mBL7xQD;EK8xQC,qBL7xQM;AHklRd;AQnTI;EACI,8BAAA;ARqTR;AQnTI;EACI,mBL9xQK;AHmlRb;AQnTI;EACI,mBLjyQK;AHslRb;AQnTI;EACI,mBL1yQD;AH+lRP;AQnTI;EACI,uBAAA;ARqTR;AQnTI;EACI,gCAAA;ARqTR;AQnTI;EACI,gCAAA;ARqTR;AQnTI;EACI,gCAAA;ARqTR;AQnTI;EACI,gCAAA;ARqTR;AQnTI;EACI,gCAAA;EACA,WLtyQA;AH2lRR;AQlTQ;EACI,WL1yQJ;AH8lRR;;AQ/SI;EACI,yBLv0QD;EKw0QC,cLt0QI;AHwnRZ;AQhTI;EACI,WLpzQA;AHsmRR;AQhTI;EACI,yBL90QD;AHgoRP;AQjTQ;EACI,yBLh1QL;AHmoRP;AQjTgB;EACI,aAAA;ARmTpB;AQlToB;EACI,cAAA;ARoTxB;AQhTY;EACI,WLn0QR;AHqnRR;AQ/SQ;EACI,yBL91QL;EK+1QK,gBAAA;ARiTZ;AQhTY;EACI,WL10QR;AH4nRR;AQhTY;EACI,qBLn2QF;AHqpRd;AQjTgB;EACI,WL/0QZ;AHkoRR;AQ9SQ;EACI,qBL32QE;AH2pRd;AQ5SgB;EACI,gCAAA;AR8SpB;AQ7SoB;EACI,WL51QhB;AH2oRR;AQ7SoB;EACI,WL/1QhB;AH8oRR;AQ7SoB;EACI,WLl2QhB;AHipRR;AQ3S4B;EACI,yBAAA;AR6ShC;AQzS4B;EACI,WL52QxB;AHupRR;AQzS4B;EACI,cLn4Qf;AH8qRjB;AQvSoB;EACI,eL7/PT;EK8/PS,iBAAA;EACA,cLnvQb;AH4hRX;AQpSY;EACI,mBLn5QT;AHyrRP;AQlSY;EACI,qBLv5QF;EKw5QE,uBAAA;ARoShB;AQlSY;EACI,cLz5QC;AH6rRjB;AQ9RoB;EACI,uBAAA;EACA,kBLtiQL;AHs0QnB;AQ/RwB;EACI,uBAAA;ARiS5B;AQ9R4B;EACI,WLn5QxB;AHmrRR;AQ7RgC;EACI,WLv5Q5B;EKw5Q4B,gBAAA;AR+RpC;AQ7RgC;EACI,gBLz8Qf;EK08Qe,cLh7QnB;AH+sRjB;AQtRI;EACI,yBL77QD;AHqtRP;AQrRgB;EACI,yBAAA;ARuRpB;AQtRoB;EACI,WL56QhB;AHosRR;AQhR4B;EACI,cL18QpB;AH4tRZ;AQ3Qe;EACK,gCAAA;AR6QpB;AQxQI;EACI,mBAAA;EACA,WLp8QA;AH8sRR;AQxQI;EACI,mBAAA;EACA,qBAAA;EACA,WLz8QA;AHmtRR;AQxQI;EACI,WL58QA;AHstRR;AQxQI;EACI,mBLt+QD;AHgvRP;AQzQQ;EACI,qBLv+QE;AHkvRd;AQ1QY;EACI,WLn9QR;AH+tRR;AQzQQ;EACI,mBLv+QF;EKw+QE,qBL9+QE;AHyvRd;AQ1QY;EACI,qBLh/QF;AH4vRd;AQ3QgB;EACI,WL59QZ;AHyuRR;AQzQQ;EACI,qBLv/QE;EKw/QF,mBLz/QL;AHowRP;AQ1QY;EACI,qBL1/QF;AHswRd;AQxQI;;;EAGI,cLhgRI;AH0wRZ;AQvQQ;EACI,uBAAA;ARyQZ;AQrQQ;EACI,cLzgRA;AHgxRZ;AQpQI;;;EAGI,qBLhhRM;EKihRN,gBAAA;EACA,yBAAA;EACA,cLlhRI;AHwxRZ;AQrQQ;;;EACI,cLphRA;AH6xRZ;AQrQQ;EACI,qBL1hRE;EK2hRF,yBAAA;EACA,cL3hRA;EK4hRA,gBAAA;ARuQZ;AQjQgB;EACI,cLniRR;AHsyRZ;AQ7PQ;EACI,qBL3iRE;AH0yRd;AQ3PQ;EACI,qBLhjRE;EKijRF,yBAAA;EACA,cLjjRA;EKkjRA,gBAAA;AR6PZ;AQ1PI;;EAEI,cLvjRI;AHmzRZ;AQzPQ;EACI,qBL5jRE;EK6jRF,yBAAA;EACA,cL7jRA;AHwzRZ;AQxPI;;EAEI,qBLnkRM;EKokRN,gBAAA;EACA,yBAAA;EACA,cLrkRI;AH+zRZ;AQxPI;EACI,qBLzkRM;AHm0Rd;AQxPI;EACI,yBAAA;AR0PR;AQxPI;EACI,qBL/kRM;EKglRN,mBLjlRD;EKklRC,gBAAA;EACA,cLjlRI;AH20RZ;AQvPQ;EACI,kBLhkRJ;EKikRI,WLjkRJ;AH0zRR;AQtPI;EACI,yBAAA;ARwPR;AQrPQ;EACI,qBL/lRE;EKgmRF,mBLjmRL;EKkmRK,gBAAA;ARuPZ;AQtPY;EACI,gBAAA;EACA,yBAAA;EACA,mBLtmRT;EKumRS,cLrmRJ;AH61RZ;AQtPY;EACI,gBAAA;ARwPhB;AQpPI;;;EAGI,qBLhnRM;EKinRN,mBLlnRD;AHw2RP;AQnPQ;EACI,cLpnRA;AHy2RZ;AQpPY;EACI,cLtnRJ;AH42RZ;AQnPQ;EACI,qBL3nRE;AHg3Rd;AQlPI;EACI,mBLhoRD;EKioRC,qBLhoRM;AHo3Rd;AQlPI;;;;;;;;;EAUI,qBL5oRM;EK6oRN,mBL9oRD;EK+oRC,gBAAA;ARmPR;AQjPI;EACI,yBL3oRE;EK4oRF,gBAAA;ARmPR;AQhPQ;EACI,qBLtpRE;EKupRF,cLtpRA;AHw4RZ;AQ/OI;EACI,qBL3pRM;AH44Rd;AQ7OY;EACI,cL/pRJ;EKgqRI,gBAAA;AR+OhB;AQ7OY;EACI,cLnqRJ;EKoqRI,qBLrqRF;AHo5Rd;AQ3OI;EACI,gBAAA;AR6OR;AQ3OI;EACI,cL5qRI;EK6qRJ,qBL9qRM;EK+qRN,mBLhrRD;EKirRC,gBAAA;AR6OR;AQxOwB;EACI,WLhqRpB;AH04RR;AQjOoB;EACI,cL/rRZ;AHk6RZ;AQ9NQ;EACI,qBLtsRE;AHs6Rd;AQ7NI;EACI,qBL1sRM;AHy6Rd;AQ5NQ;EACI,cL7sRA;EK8sRA,qBL/sRE;EKgtRF,mBLjtRL;AH+6RP;AQ5NQ;EACI,cLltRA;EKmtRA,qBLptRE;EKqtRF,mBLttRL;AHo7RP;AQ3NI;EACI,cLxtRI;EKytRJ,qBL1tRM;EK2tRN,mBL5tRD;AHy7RP;AQvNoB;EACI,cLjuRZ;AH07RZ;AQnNI;EACI,cLxuRI;EKyuRJ,qBL1uRM;EK2uRN,mBL5uRD;AHi8RP;AQnNI;EACI,cL7uRI;EK8uRJ,mBAAA;ARqNR;AQnNI;EACI,yBAAA;ARqNR;AQnNI;EACI,cLpvRI;AHy8RZ;AQnNI;EACI,qBLxvRM;AH68Rd;AQnNI;EACI,qBL3vRM;AHg9Rd;AQnNI;EACI,mBL3wRE;EK4wRF,WLzuRA;AH87RR;AQnNI;EACI,uBAAA;ARqNR;AQnNI;EACI,qBLrwRM;EKswRN,mBLvwRD;AH49RP;AQlNY;EACI,WLpvRR;AHw8RR;AQhNI;EACI,yBAAA;ARkNR;AQhNI;EACI,mBAAA;ARkNR;AQhNY;EACI,WL/vRR;AHi9RR;AQhNY;EACI,WLlwRR;AHo9RR;AQhNY;EACI,qBL3xRF;EK4xRE,uBAAA;EACA,WLvwRR;AHy9RR;AQ/MQ;EACI,WL3wRJ;AH49RR;AQ9MI;EACI,WL/wRA;AH+9RR;AQ9MI;EACI,qBLxyRM;EKyyRN,mBL1yRD;AH0/RP;AQ/MQ;EACI,qBL3yRE;EK4yRF,mBAAA;ARiNZ;AQ9MI;EACI,qBLhzRM;EKizRN,mBAAA;ARgNR;AQ9MI;EACI,qBLpzRM;AHogSd;AQ9MI;EACI,mBLjzRE;EKkzRF,gBAAA;ARgNR;AQ/MQ;EACI,8BAAA;ARiNZ;AQ/MQ;EACI,mBAAA;EACA,gBAAA;ARiNZ;AQ/MQ;EACI,mBAAA;ARiNZ;AQhNY;EACI,qBLn0RF;AHqhSd;AQhNY;EACI,qBLt0RF;AHwhSd;AQ/MQ;EACI,qBL10RE;AH2hSd;AQhNY;EACI,WLtzRR;AHwgSR;AQhNY;EACI,cL90RJ;AHgiSZ;AQ/MQ;EACI,cLl1RA;AHmiSZ;AQ9MI;EACI,cLt1RI;AHsiSZ;AQ7MQ;EACI,qBL31RE;AH0iSd;AQ5MI;EACI,mBLh2RD;EKi2RC,qBLh2RM;EKi2RN,cLh2RI;AH8iSZ;AQ7MQ;EACI,mBLp2RL;EKq2RK,qBLp2RE;EKq2RF,cLp2RA;AHmjSZ;AQ5MI;EACI,mBL12RD;AHwjSP;AQ5MI;EACI,mBL72RD;EK82RC,qBL72RM;EK82RN,cL72RI;AH2jSZ;AQ5MI;EACI,qBLj3RM;AH+jSd;AQ3MQ;EACI,mBLt3RL;EKu3RK,qBLt3RE;EKu3RF,WLj2RJ;AH8iSR;AQ5MY;EACQ,mBLp3RP;EKq3RO,WLp2RZ;AHkjSR;AQ7MoB;EACI,WLt2RhB;AHqjSR;AQzMQ;EACI,qBLp4RL;AH+kSP;AQrMY;EACI,mBL34RT;AHklSP;AQrMa;EACG,qBL74RF;AHolSd;AQtMiB;EACG,qBL/4RN;AHulSd;AQvMoB;EACI,mBLl5RjB;EKm5RiB,WL53RhB;EK63RgB,qBLn5RV;AH4lSd;AQnMoB;EACI,mBL35RjB;EK45RiB,cLz5RP;EK05RO,qBL55RV;AHimSd;AQjMY;EACI,qBLj6RF;AHomSd;AQlMgB;EACI,qBLn6RN;AHumSd;AQnMoB;EACI,qBLr6RV;AH0mSd;AQpMwB;EACI,mBLx6RrB;EKy6RqB,WLl5RpB;EKm5RoB,qBLz6Rd;AH+mSd;AQhMwB;EACI,mBLj7RrB;EKk7RqB,cL/6RX;EKg7RW,qBLl7Rd;AHonSd;AQ1LQ;EAII,WLx6RJ;AHimSR;AQ5LY;EACI,cAAA;AR8LhB;AQzLY;EACI,WL56RR;EK66RQ,yBAAA;EACA,gBAAA;EACA,mBAAA;AR2LhB;AQ1LgB;EACI,gCAAA;EACA,8BAAA;AR4LpB;AQzLY;EACI,qBL58RF;EK68RE,mBL98RT;AHyoSP;AQ1LgB;EACI,uBAAA;EACA,WL17RZ;AHsnSR;AQvLI;;;EAGI,qBLx9RM;AHipSd;AQvLI;EACI,qBL39RM;EK49RN,mBL79RD;EK89RC,cL59RI;EK69RJ,gBAAA;ARyLR;AQxLQ;EACI,qBLh+RE;EKi+RF,mBLl+RL;EKm+RK,cLj+RA;AH2pSZ;AQxLQ;EACI,qBLr+RE;EKs+RF,mBLv+RL;EKw+RK,cLt+RA;AHgqSZ;AQvLI;EACI,mBL3+RM;EK4+RN,cL3+RI;EK4+RJ,qBL7+RM;AHsqSd;AQtLQ;EACI,cLh/RA;AHwqSZ;AQrLI;EACI,UL/9RA;AHspSR;AQrLI;EACI,WLl+RA;AHypSR;AQtLQ;EACI,cLvgSF;AH+rSV;AQrLI;EACI,qBL9/RM;AHqrSd;AQrLI;EACI,qBLjgSM;AHwrSd;AQrLI;EACI,qBLpgSM;AH2rSd;AQlLgB;EACI,cLxgSH;AH4rSjB;AQnLoB;EACI,WLt/RhB;AH2qSR;AQnLoB;EACI,mBL3gSP;EK4gSO,WL1/RhB;AH+qSR;AQ9KQ;EACI,yBLnhSC;EKohSD,qBLzhSE;EK0hSF,WLpgSJ;AHorSR;AQ/KY;EACI,+DLzhSH;EK0hSG,qBL7hSF;EK8hSE,WLxgSR;AHyrSR;AQ5KI;EACI,qBLpiSM;EKqiSN,mBL/hSE;AH6sSV;AQ5KY;EACI,WLlhSR;AHgsSR;AQtKoB;EACI,WL3hShB;AHmsSR;AQ/JgB;EACI,WLriSZ;AHssSR;AQ5JI;EACI,mBL9iSE;EK+iSF,qBL/iSE;AH6sSV;AQ5JY;EACI,WL/iSR;AH6sSR;AQ1JI;EACI,mBLvjSE;EKwjSF,qBL3kSM;AHuuSd;AQ1JY;EACI,WLxjSR;AHotSR;AQxJI;EACI,sBAAA;AR0JR;AQvJQ;EACI,mBLxlSL;EKylSK,qBLxlSE;AHivSd;AQxJY;EACI,WLpkSR;AH8tSR;AQtJI;EACI,WLzkSA;AHiuSR;AQtJI;EACI,sBAAA;ARwJR;AQrJQ;EACI,qBLtmSE;EKumSF,WLjlSJ;AHwuSR;AQnJQ;EACI,mBLtmSF;EKumSE,qBL7mSE;AHkwSd;AQpJY;EACK,qBL/mSH;AHqwSd;AQpJY;EACI,WL5lSR;AHkvSR;AQlJI;EACI,qBLvnSM;AH2wSd;AQlJI;EACI,qBL1nSM;EK2nSN,mBL5nSD;AHgxSP;AQjJQ;EACI,mBLhoSL;AHmxSP;AQhJI;EACI,mBL7nSE;EK8nSF,qBLpoSM;AHsxSd;AQ/IQ;EACI,cLtoSK;AHuxSjB;AQhJY;EACI,mBLtoSC;EKuoSD,WLrnSR;AHuwSR;AQ9II;EACI,mBL3oSK;EK4oSL,qBLjpSM;EKkpSN,WL5nSA;AH4wSR;AQ5IY;EACI,mBLlpSH;EKmpSG,qBLxpSF;AHsySd;AQ7IgB;EACI,mBLrpSP;EKspSO,WLroSZ;AHoxSR;AQ9IoB;EACI,WLvoShB;AHuxSR;AQ1II;EACI,mBLjpSE;EKkpSF,qBLrqSM;AHizSd;AQzIgB;EACI,WLnpSZ;AH8xSR;AQzIgB;EACI,mBL5qSN;AHuzSd;AQvIQ;EACK,qBLjrSC;AH0zSd;AQtII;EACI,mBLlqSE;EKmqSF,qBLtrSM;AH8zSd;AQtIY;EACI,yBLtqSN;AH8ySV;AQnIgB;EACI,mBL1rSP;AH+zSb;AQ9HY;EACI,qBLvsSF;EKwsSE,mBLnsSH;EKosSG,gBAAA;ARgIhB;AQ1HY;EACI,mBL1sSN;EK2sSM,qBLjtSF;AH60Sd;AQxHY;EACI,cLptSC;AH80SjB;AQtHI;EACI,mBLxsSE;EKysSF,qBL5tSM;AHo1Sd;AQtHY;EACK,mBL5sSP;EK6sSO,qBLhuSH;AHw1Sd;AQvHiB;EACG,mBL/sSV;EKgtSU,qBLnuSN;AH41Sd;AQnHQ;EACI,cLxuSK;AH61SjB;AQpHY;EACI,mBLztSN;EK0tSM,WLvtSR;AH60SR;AQjHQ;EACI,6BAAA;ARmHZ;AQlHY;EACI,mBLjvSC;EKkvSD,cLpvSC;AHw2SjB;AQjHQ;EACI,mBLtvSK;EKuvSL,cLzvSK;AH42SjB;AQhHI;EACI,qBL/vSM;AHi3Sd;AQhHa;EACG,mBL/uSN;EKgvSM,WL7uSR;AH+1SR;AQ9GI;EACI,mBLpwSS;AHo3SjB;AQ9GI;EACI,cLzwSS;AHy3SjB;AQ/GS;EACG,mBL1vSF;EK2vSE,WLxvSJ;AHy2SR;AQ9GI;EACI,qBLlxSM;AHk4Sd;AQ7GQ;EACI,qBLtxSE;AHq4Sd;AQ3GI;;EAEI,qBL5xSM;AHy4Sd;AQ3GI;;;EAGI,mBL7xSS;EK8xST,qBLlySM;AH+4Sd;AQ3GI;EACI,sBAAA;AR6GR;AQ3GI;EACI,qBLxySM;AHq5Sd;AQ5GQ;EACI,mBLvxSF;AHq4SV;AQ7GY;EACI,mBLzxSN;EK0xSM,qBL7ySF;AH45Sd;AQ1GI;EACI,qBLnzSM;EKozSN,WL9xSA;AH04SR;AQ1GI;EACI,qBLvzSM;AHm6Sd;AQ1GI;EACI,qBL1zSM;EK2zSN,cLzzSS;AHq6SjB;AQ1GI;EACI,cL5zSS;AHw6SjB;AQ1GI;EACI,qBLj0SM;AH66Sd;AQ3GQ;EACI,WL7ySJ;AH05SR;AQ1GI;EACI,mBLpzSE;EKqzSF,qBLx0SM;AHo7Sd;AQ3GQ;EACI,cLx0SK;AHq7SjB;AQ3GQ;EACI,qBL70SE;AH07Sd;AQ5GY;EACI,qBL/0SF;AH67Sd;AQ1GI;EACI,mBLj0SE;AH66SV;AQzGgB;EACI,yBAAA;AR2GpB;AQ1GoB;EACI,cLv2Sd;AHm9SV;AQ1GoB;EACK,qBL71SX;AHy8Sd;AQtGI;EACI,mBLj1SE;EKk1SF,qBLr2SM;EKs2SN,cLp2SS;AH48SjB;AQtGI;;EAEI,WLp1SA;AH47SR;AQrGQ;EACI,yBL31SF;AHk8SV;AQtGY;EACI,yBL12SN;EK22SM,qBLj3SF;AHy9Sd;AQpGI;EACI,mBLn2SE;AHy8SV;AQpGI;EACI,mBLt2SE;EKu2SF,qBL13SM;AHg+Sd;AQpGI;EACI,qBL73SM;AHm+Sd;AQpGI;EACI,cL1oSM;AHgvSd;AQpGI;EACI,qBLn4SM;EKo4SN,cLl4SS;AHw+SjB;AQpGI;EACI,6BAAA;ARsGR;AQpGI;EACI,qBL14SM;AHg/Sd;AQpGI;EACI,yBLv4SE;AH6+SV;AQrGQ;EACI,uBAAA;ARuGZ;AQrGgB;EACI,WL53SZ;AHm+SR;AQlGI;EACI,mBLr4SE;AHy+SV;AQnGQ;EACI,WLp4SJ;AHy+SR;AQlGI;EACI,mBL34SE;AH++SV;AQnGQ;EACI,qBLh6SE;AHqgTd;AQpGY;EACI,WL54SR;AHk/SR;AQjGQ;EACI,mBLz6SL;EK06SK,WLn5SJ;AHs/SR;AQlGY;EACI,qBL36SF;AH+gTd;AQhGY;EACI,qBLh7SF;AHkhTd;AQ7FQ;EACI,mBLj7SC;EKk7SD,qBLv7SE;EKw7SF,WLl6SJ;AHigTR;AQ5FI;EACI,mBL57SM;AH0hTd;AQ5FI;EACI,qBL/7SM;AH6hTd;AQ7FQ;EACI,WL36SJ;AH0gTR;AQ5FI;EACI,mBLh8SK;EKi8SL,qBLt8SM;EKu8SN,WLj7SA;AH+gTR;AQ5FI;EACI,gBAAA;AR8FR;AQ7FQ;EACI,cL18SK;EK28SL,qBL78SE;AH4iTd;AQ5FI;EACI,qBLj9SM;AH+iTd;AQ5FI;EACI,qBLp9SM;AHkjTd;AQ3FQ;EACI,WLl8SJ;AH+hTR;AQ1FI;EACI,WLt8SA;AHkiTR;AQ1FI;EACI,yBL58SE;EK68SF,qBLh+SM;AH4jTd;AQ3FQ;EACI,qBLl+SE;AH+jTd;AQ5FY;EACI,WL98SR;AH4iTR;AQ3FQ;EACI,WLl9SJ;AH+iTR;AQ3FQ;EACI,yBLr+SF;AHkkTV;AQ5FY;EACI,qBL7+SF;AH2kTd;AQ7FgB;EACI,WLz9SZ;AHwjTR;AQ5FY;EACI,WL79SR;AH2jTR;AQ1FI;EACI,qBLx/SM;AHolTd;AQ1FI;EACI,yBLx+SE;AHokTV;AQ3FQ;EACI,qBL7/SE;AH0lTd;AQ3FQ;EACI,qBLhgTE;AH6lTd;AQ1FI;EACI,yBLj/SE;EKk/SF,qBLrgTM;EKsgTN,gBAAA;AR4FR;AQ1FI;EACI,yBLt/SE;EKu/SF,qBL1gTM;AHsmTd;AQ3FQ;EACI,cL1gTK;AHumTjB;AQ1FI;EACI,yBL7/SE;EK8/SF,qBLjhTM;AH6mTd;AQzFQ;EACI,yBLlgTF;EKmgTE,gBAAA;AR2FZ;AQzFQ;EACI,qBLzhTE;AHonTd;AQzFQ;EACI,qBL5hTE;AHunTd;AQxFI;EACI,yBL7gTE;AHumTV;AQxFI;EACI,qBLniTM;EKoiTN,yBLjhTE;AH2mTV;AQxFI;EACI,uBAAA;AR0FR;AQxFI;EACI,yBLvhTE;AHinTV;AQxFI;EACI,yBL1hTE;AHonTV;AQxFI;EACI,yBL7hTE;EK8hTF,qBLjjTM;EKkjTN,gBAAA;AR0FR;AQxFI;EACI,yBLliTE;AH4nTV;AQxFI;EACI,yBLriTE;EKsiTF,qBLzjTM;AHmpTd;AQxFI;EACI,WLtiTA;AHgoTR;AQvFQ;EACI,WL1iTJ;AHmoTR;AQvFQ;EACI,cLjkTK;AH0pTjB;AQtFI;EACI,WLjjTA;AHyoTR;AQtFI;EACI,yBAAA;ARwFR;AQtFI;EACI,WLvjTA;AH+oTR;AQtFI;EACI,qBLhlTM;AHwqTd;AQtFI;EACK,cLjlTQ;AHyqTjB;AQtFI;EACI,yBLnkTE;EKokTF,qBLvlTM;AH+qTd;AQvFQ;EACI,qBLzlTE;AHkrTd;AQvFQ;EACI,qBL5lTE;AHqrTd;AQxFY;EACI,cL5lTC;AHsrTjB;;ASztTA;EACI,eAAA;EACA,OAAA;EACA,aAAA;EACC,2BAAA;EACD,YAAA;EACA,YAAA;EACA,gBNgDI;EM/CJ,sBAAA;EACA,gBAAA;EACA,aAAA;AT4tTJ;AS3tTI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBNIE;EMHF,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,WNkCA;EMjCA,2BAAA;EACA,8BAAA;AT6tTR;AS5tTQ;EAEI,qCAAA;AT8tTZ;;ASztTA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AT4tTJ;;AS1tTA;EACI,WAAA;AT6tTJ;;AS1tTA;EACI,oBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AT6tTJ;AS5tTI;EACI,QAAA;AT8tTR;AS5tTI;EACI,gCAAA;EACA,kBAAA;AT8tTR;AS3tTQ;EACI,gCAAA;EACA,mBAAA;AT6tTZ;AS5tTY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AT8tThB;AS1tTI;EACI,mBNuGI;EMtGJ,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AT4tTR;AS3tTQ;EACI,aAAA;AT6tTZ;ASztTwB;EACI,yBNzBnB;EM0BmB,qBN1BnB;EM2BmB,WAAA;AT2tT5B;ASztTwB;EACI,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AT2tT5B;ASrtTQ;EACI,YAAA;ATutTZ;ASrtTQ;EACI,kBAAA;EACA,WAAA;EACA,cAAA;ATutTZ;ASttTY;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;ATwtThB;;ASntTA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;ATstTJ;ASrtTI;EACI,OAAA;ATutTR;;ASptTA;EACI,uBAAA;ATutTJ;;ASptTI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;ATutTR;ASttTQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;ATwtTZ;ASrtTY;EACI,mBNxIN;AH+1TV;ASntTY;EACI,mBN4IF;AHykTd;ASjtTY;EACI,mBNwIH;AH2kTb;AS/sTY;EACI,mBNoIL;AH6kTX;AS7sTY;EACI,mBNgIN;AH+kTV;AS3sTY;EACI,mBN4HD;AHilTf;ASzsTY;EACI,mBNwHN;AHmlTV;ASvsTI;EACI,aAAA;ATysTR;ASvsTY;EACI,qBN9KN;AHu3TV;ASxsTgB;EACI,gBAAA;EACA,kCAAA;EACA,cNlLV;EMmLU,gBAAA;EACA,cNkON;EMjOM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBN3JZ;EM4JY,yBAAA;ELpFlB,kBKqFmC;AT0sTrC;ASrsTI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;ATusTR;ASrsTY;EACI,WAAA;EACA,YAAA;ATusThB;AStsTgB;EACI,eAAA;ATwsTpB;;ASjsTI;EACI,aAAA;ATosTR;ASlsTY;EACI,sBN3NN;AH+5TV;ASnsTgB;EACI,gBAAA;EACA,kCAAA;EACA,cN/NV;EMgOU,gBAAA;EACA,cNqLN;EMpLM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBNxMZ;EMyMY,yBAAA;ELjIlB,kBKkImC;ATqsTrC;ASlsToB;EACI,WN9MhB;AHk5TR;AS9rTI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;ATgsTR;AS/rTQ;EACI,gBN5NJ;EM6NI,yBAAA;ATisTZ;AS/rTQ;EACI,mBNkBD;AH+qTX;AS/rTQ;EACI,mBNgBA;AHirTZ;AS/rTQ;EACI,mBNcD;AHmrTX;AS/rTQ;EACI,mBNYD;AHqrTX;AS/rTQ;EACI,mBN/QF;AHg9TV;AS/rTQ;EACI,mBNaC;AHorTb;AS/rTQ;EACI,mBNWH;AHsrTT;AS/rTQ;EACI,mBNSF;AHwrTV;AS/rTQ;EACI,mBNOF;AH0rTV;AS/rTQ;EACI,+DNiFM;AHgnTlB;AS/rTQ;EACI,6DNoFM;AH6mTlB;AS/rTQ;EACI,6DN+EI;AHknThB;AS/rTQ;EACI,6DN6EM;AHonTlB;AS9rTI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;ATgsTR;AS9rTY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;ATgsThB;AS/rTgB;EACI,eAAA;EACA,gBAAA;ATisTpB;;ASzrTQ;EACI,yBAAA;ELrNV,kBKsN2B;AT4rT7B;ASzrTI;EACI,aAAA;AT2rTR;ASvrToB;EACI,qBN1Ud;AHmgUV;AStrTgB;EACI,kBAAA;EACA,kBAAA;ATwrTpB;ASvrToB;EACI,gBAAA;EACA,0BAAA;EACA,cNnVd;EMoVc,gBAAA;EACA,cNiEV;EMhEU,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBN3ThB;EM4TgB,yBAAA;ELpPtB,kBKqPuC;ATyrTzC;ASjrTY;EACI,yBAAA;EL9Pd,kBK+P+B;ATmrTjC;AShrTQ;EACI,cNrMD;AHu3TX;AShrTQ;EACI,aAAA;ATkrTZ;AS9qTQ;EACI,yBAAA;EL3QV,kBK4Q2B;ATgrT7B;;AS3qTI;EACI,aAAA;AT8qTR;AS5qTY;EACI,qBNhYN;AH8iUV;AS7qTgB;EACI,cN1XV;EM2XU,yBN5WE;AH2hUtB;AS1qTI;EACI,yBAAA;EACA,cNnOG;AH+4TX;AS3qTQ;EACI,yBNhXO;EMiXP,cNjYL;AH8iUP;;ASxqTI;EACI,aAAA;AT2qTR;ASxqTgB;EACI,gBAAA;EACA,kCAAA;EACA,cNzZV;EM0ZU,gBAAA;EACA,cNLN;EMMM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBNlYZ;EMmYY,yBAAA;EL3TlB,kBK4TmC;AT0qTrC;ASxqTgB;EACI,8DNxBJ;AHksThB;ASrqTI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;ATuqTR;AStqTQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;ATwqTZ;;ASlqTI;EACI,aAAA;ATqqTR;ASlqTgB;EACI,gBAAA;EACA,kCAAA;EACA,cNpcV;EMqcU,gBAAA;EACA,cNhDN;EMiDM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBN7aZ;EM8aY,yBAAA;ELtWlB,kBKuWmC;AToqTrC;ASlqTgB;EACI,8DNnEJ;AHuuThB;AS/pTI;EACI,YAAA;EACA,kBAAA;ATiqTR;AShqTQ;EACI,YAAA;EACA,YAAA;EACA,iBAAA;ELrXV,mBKsX2B;ATkqT7B;;AS7pTI;EACI,aAAA;ATgqTR;AS9pTY;EACI,qBN1eN;AH0oUV;AS/pTgB;EACI,qBN5eV;AH6oUV;AS/pTgB;EACI,UAAA;ATiqTpB;AS5pTI;EACI,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,cNjVG;EMkVH,gBAAA;AT8pTR;AS7pTQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;ELlZV,kBKmZ2B;EACjB,yBAAA;EACA,gBN7dJ;EM8dI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;AT+pTZ;AS7pTQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EL9ZV,kBK+Z2B;EACjB,mBN3gBF;EM4gBE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;EACA,UAAA;AT+pTZ;;AS1pTI;EACI,aAAA;AT6pTR;AS3pTY;EACI,gCAAA;EACA,kBAAA;AT6pThB;AS5pTgB;EACI,gBAAA;EACA,0BAAA;EACA,cN9hBV;EM+hBU,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AT8pTpB;AS3pToB;EACI,WNxgBhB;AHqqUR;ASvpTI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;ATypTR;;ASnpTI;;;EACI,aAAA;ATwpTR;;ASrpTA;EACI,cAAA;ATwpTJ;;ASlpTQ;;;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;ATupTZ;AStpTY;;;EACI,gBAAA;AT0pThB;ASxpTY;;;EACI,gBAAA;EACA,sCAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AT4pThB;;ASvpTA;EACI,WAAA;EACA,YAAA;EL9eF,kBK+emB;EACjB,yBNtbO;EMubP,WNzjBI;EM0jBJ,SAAA;EACA,UAAA;EACA,sBAAA;AT0pTJ;ASzpTI;EACI,yBNvlBC;AHkvUT;;AStpTQ;EACI,qBNvmBF;AHgwUV;;ASnpTQ;EACI,sBN9mBF;AHowUV;;AShpTQ;EACI,sBNrnBF;AHwwUV;;AS7oTQ;EACI,sBN5nBF;AH4wUV;;AQ/xUI;EACI,iBAAA;EACA,YAAA;ARkyUR;AIxvUI;EI5CA;IAOQ,gBAAA;ERiyUV;AACF;AI7vUI;EI5CA;IAUQ,eAAA;ERmyUV;AACF;;AQ5xUA;EACI,sCAAA;EACA,uCAAA;EACA,qCAAA;EACA,+CAAA;AR+xUJ;;AQzxUY;;EACI,iBAAA;EACA,OAAA;AR6xUhB;AI/wUI;EIhBQ;;IAOQ,gBAAA;ER6xUlB;AACF;AIrxUI;EIhBQ;;IAUQ,eAAA;ERgyUlB;AACF;AQ7xUgB;;EACI,iBAAA;EACA,OAAA;ARgyUpB;AIhyUI;EIFY;;IAOQ,gBAAA;ERgyUtB;AACF;AItyUI;EIFY;;IAUQ,eAAA;ERmyUtB;AACF;AQ/xUQ;;EACI,YAAA;EACA,iBAAA;EACA,OAAA;ARkyUZ;AIlzUI;EIaI;;IAQQ,gBAAA;ERkyUd;AACF;AIxzUI;EIaI;;IAWQ,eAAA;IACA,OAAA;ERqyUd;AACF;AQpyUY;;EACI,cAAA;EACA,kBAAA;ARuyUhB;AIp0UI;EI2BQ;;IAIQ,eAAA;ER0yUlB;AACF;AQvyUQ;;EACI,UAAA;EAAA,aAAA;EACA,SAAA;AR0yUZ;AQzyUY;;EACI,aAAA;AR4yUhB;AQ1yUY;;EACI,MAAA;AR6yUhB;;AQpyUQ;;;EACI,UAAA;EAAA,aAAA;ARyyUZ;AQxyUY;;;EACI,aAAA;AR4yUhB;AQzyUQ;;;EACI,cAAA;EACA,iBAAA;AR6yUZ;AI/3UI;EIgFI;;;IAIQ,WAAA;ERizUd;AACF;AI/2UI;EIyDI;;;IAUQ,gBAAA;ERkzUd;AACF;AIt3UI;EIyDI;;;IAaQ,eAAA;IACA,OAAA;ERszUd;AACF;AQnzUY;;;EAII,iBAAA;ARozUhB;AI15UI;EIkGQ;;;IAEQ,UAAA;ER4zUlB;AACF;AI14UI;EI2EQ;;;IASQ,gBAAA;ER4zUlB;AACF;AIj5UI;EI2EQ;;;IAYQ,eAAA;IACA,OAAA;ERg0UlB;AACF;AQ7zUgB;;;EACI,iBAAA;ARi0UpB;AIr7UI;EImHY;;;IAGQ,WAAA;ERq0UtB;AACF;AIr6UI;EI4FY;;;IASQ,gBAAA;ERs0UtB;AACF;AI56UI;EI4FY;;;IAYQ,eAAA;IACA,OAAA;ER00UtB;AACF;;AQj0UQ;;EACI,YAAA;EACA,iBAAA;ARq0UZ;AI17UI;EImHI;;IAOQ,gBAAA;ERq0Ud;AACF;AIh8UI;EImHI;;IAUQ,eAAA;ERw0Ud;AACF;AQt0UQ;;EACI,aAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;ARy0UZ;AI78UI;EIgII;;IASQ,YAAA;ERy0Ud;AACF;AIn9UI;EIgII;;IAYQ,WAAA;ER40Ud;AACF;AQ10UQ;;EACI,OAAA;EACA,QAAA;EACA,cAAA;AR60UZ;AI/9UI;EI+II;;IAQQ,YAAA;ER60Ud;AACF;AIr+UI;EI+II;;IAWQ,WAAA;ERg1Ud;AACF;AQ70UI;;EACI,eAAA;ARg1UR;AQ/0UQ;;EACI,iBAAA;EACA,cAAA;ARk1UZ;AIp/UI;EIgKI;;IAOQ,gBAAA;ERk1Ud;AACF;AI1/UI;EIgKI;;IAUQ,eAAA;ERq1Ud;AACF;AQp1UY;;EACI,gBAAA;ARu1UhB;AQp1UQ;;EACI,cAAA;ARu1UZ;AQn1UQ;;EACI,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,UAAA;ARs1UZ;AI/gVI;EIqLI;;IASQ,gBAAA;ERs1Ud;AACF;AIrhVI;EIqLI;;IAYQ,eAAA;ERy1Ud;AACF;AQp1U4B;;EACI,yBAAA;ARu1UhC;;AQ70UI;EACI,iBAAA;EACA,cAAA;ARg1UR;AIpiVI;EIkNA;IAOQ,gBAAA;ER+0UV;AACF;AIziVI;EIkNA;IAUQ,eAAA;ERi1UV;AACF;AQ/0UY;EACI,kBAAA;ARi1UhB;AIjjVI;EI+NQ;IAGQ,4BAAA;ERm1UlB;AACF;AQ70UY;EACI,yBAAA;AR+0UhB;AIhlVI;EIgQQ;IAGQ,yBAAA;ERi1UlB;AACF;;AQ30UI;EACI,iBAAA;EACA,cAAA;AR80UR;;AQv0UI;EACI,UAAA;AR00UR;;AQt0UI;EACI,UAAA;ARy0UR;AQv0UI;EACI,iBAAA;EACA,cAAA;ARy0UR;AI/kVI;EIoQA;IAOQ,gBAAA;ERw0UV;AACF;AIplVI;EIoQA;IAUQ,eAAA;ER00UV;AACF;;AQt0UI;EACI,UAAA;ARy0UR;AQv0UI;EACI,iBAAA;EACA,cAAA;ARy0UR;AIjmVI;EIsRA;IAOQ,eAAA;ERw0UV;AACF;AQp0UQ;EACI,aAAA;EACA,cAAA;EACA,UAAA;ARs0UZ;AI3mVI;EIkSI;IAQQ,WAAA;ERq0Ud;AACF;;AQh0UI;EACQ,cAAA;ARm0UZ;AI3oVI;EIuUA;IAMQ,cAAA;ERk0UV;AACF;AQh0UI;EACI,OAAA;ARk0UR;AQj0UQ;EACI,cAAA;ARm0UZ;AItpVI;EIkVI;IAMQ,cAAA;ERk0Ud;AACF;AQ9zUQ;EACI,WAAA;ARg0UZ;AQ7zUY;EACI,OAAA;AR+zUhB;AQ9zUgB;EACI,WAAA;ARg0UpB;AQ3zUI;EACI,SAAA;EACA,UAAA;EAAA,aAAA;EACA,YAAA;AR6zUR;AQ5zUQ;EACI,uBAAA;EACA,MAAA;AR8zUZ;AQ7zUY;EACI,uBAAA;AR+zUhB;AQ7zUY;EACI,aAAA;EACA,iBAAA;AR+zUhB;AQ5zUQ;EACI,gBAAA;AR8zUZ;AQ5zUQ;EACI,aAAA;AR8zUZ;AInqVI;EIkVA;IAsBQ,SAAA;IACA,SAAA;ER+zUV;AACF;AIhsVI;EImYA;IAEQ,iBAAA;ER+zUV;AACF;AQ7zUY;EACI,aAAA;AR+zUhB;;AQxzUI;EACI,aAAA;AR2zUR;AIrrVI;EIyXA;IAGQ,cAAA;ER6zUV;AACF;AQ3zUI;EAGI,aAAA;AR6zUR;AQ3zUI;EACI,cAAA;AR6zUR;AIlsVI;EIoYA;IAGQ,aAAA;ER+zUV;AACF;;AQ3zUI;EACI,cAAA;AR8zUR;AQ5zUI;EACI,OAAA;AR8zUR;AQ7zUQ;EACI,iBAAA;EACA,cAAA;AR+zUZ;AIltVI;EIiZI;IAOQ,gBAAA;ER8zUd;AACF;AIvtVI;EIiZI;IAUQ,eAAA;ERg0Ud;AACF;AQ/zUY;EACI,gBAAA;ARi0UhB;AQ9zUQ;EACI,cAAA;ARg0UZ;;AQ3zUI;EACI,sBL9ZA;EK+ZA,sCAAA;AR8zUR;AQ5zUY;EACI,sBLlaR;AHguVR;AI1uVI;EI+aI;IAEQ,YAAA;ER6zUd;AACF;AQ3zUQ;EACI,cAAA;EACA,kBAAA;AR6zUZ;AQ5zUY;EACI,cAAA;AR8zUhB;AQ5zUY;EACI,aAAA;AR8zUhB;AQzzUgB;EACI,cLrTT;AHgnVX;AQ1zUoB;EACI,yBLhcL;EKicK,qBLjcL;EKkcK,yBAAA;AR4zUxB;AQtzUI;EACI,cAAA;ARwzUR;AQvzUQ;EACI,aAAA;ARyzUZ;AQvzUQ;EACI,MAAA;EACA,qCAAA;ARyzUZ;AQvzUQ;EACI,uBAAA;ARyzUZ;AQvzUQ;EACI,aAAA;ARyzUZ;AQvzUQ;EACI,cAAA;ARyzUZ;AQrzUQ;EACI,WAAA;EACA,aAAA;EACA,gBLxdJ;EKydI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;ARuzUZ;AQrzUQ;EACI,aAAA;EACA,aAAA;EAEA,4BAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;ARszUZ;AQjzUY;EACI,qBAAA;EACA,2BAAA;EACA,kCAAA;EACA,oCAAA;ARmzUhB;AQlzUgB;EACI,WAAA;EACA,YAAA;ARozUpB;AQjzUY;EACI,aAAA;ARmzUhB;AQhzUQ;EACI,oCAAA;ARkzUZ;AQ9yUgB;EACI,wBAAA;EACA,8BAAA;EACA,8BAAA;ARgzUpB;AQ/yUoB;EACI,WAAA;EACA,YAAA;ARizUxB;AQ9yUgB;EACI,cAAA;ARgzUpB;AQ7yUY;EACI,qCAAA;AR+yUhB;;AQzyUI;EACI,cAAA;AR4yUR;AQ1yUI;EACI,OAAA;EACA,sBLzhBA;EK0hBA,mBAAA;AR4yUR;AQ3yUQ;EACI,iBAAA;EACA,cAAA;AR6yUZ;AIp1VI;EIqiBI;IAOQ,gBAAA;ER4yUd;AACF;AIz1VI;EIqiBI;IAUQ,eAAA;ER8yUd;AACF;AQ7yUY;EACI,gBAAA;AR+yUhB;AQ1yUgB;EACI,cL5aT;AHwtVX;AQ3yUoB;EACI,mBLvjBL;EKwjBK,cL3ab;AHwtVX;AQxyUQ;EACI,cAAA;AR0yUZ;AQzyUY;EACI,aAAA;AR2yUhB;AQzyUY;EACI,cAAA;AR2yUhB;AQvyUI;EACI,cL7bG;AHsuVX;AQtyUQ;EACI,sBLrkBJ;EKskBI,8BAAA;ARwyUZ;AQvyUY;EACI,aAAA;EACA,YAAA;EAEA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;ARwyUhB;AQlyU4B;EACI,cLjdrB;AHqvVX;AQnyUgC;EACI,yBLhmBjB;EKimBiB,cLpdzB;AHyvVX;AQnyUwC;EACI,qBLvdjC;AH4vVX;AQhyUoC;EACI,qBL7d7B;AH+vVX;AQxxUI;EACI,iBAAA;EACA,cAAA;AR0xUR;AIn5VI;EIunBA;IAOQ,gBAAA;ERyxUV;AACF;AIx5VI;EIunBA;IAUQ,eAAA;ER2xUV;AACF;AQ1xUQ;EACI,WAAA;EACA,aAAA;EACA,gBL5nBJ;EK6nBI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AR4xUZ;AIv6VI;EImoBI;IAUQ,SAAA;IACA,aAAA;ER8xUd;AACF;AQ5xUQ;EACI,WAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AR8xUZ;AIv7VI;EIipBI;IAUQ,SAAA;IACA,aAAA;ERgyUd;AACF;AQ5xUQ;EACI,WLxpBJ;AHs7VR;;AQzxUI;EACI,cAAA;AR4xUR;AQ1xUI;EACI,iBAAA;EACA,YAAA;AR4xUR;AIx8VI;EI0qBA;IAOQ,gBAAA;ER2xUV;AACF;AI78VI;EI0qBA;IAUQ,eAAA;ER6xUV;AACF;AQ5xUQ;EACI,iBAAA;EACA,YAAA;AR8xUZ;AIt9VI;EIsrBI;IAOQ,gBAAA;ER6xUd;AACF;AI39VI;EIsrBI;IAUQ,eAAA;ER+xUd;AACF;AQ5xUI;EACI,OAAA;EACA,eAAA;AR8xUR;AQ7xUQ;EACI,iBAAA;EACA,cAAA;AR+xUZ;AIx+VI;EIusBI;IAOQ,gBAAA;ER8xUd;AACF;AI7+VI;EIusBI;IAUQ,eAAA;ERgyUd;AACF;AQ/xUY;EACI,gBAAA;ARiyUhB;AQ9xUQ;EACI,cAAA;ARgyUZ;AQ/xUY;EACI,cAAA;ARiyUhB;AQ5xUQ;EACI,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,UAAA;AR8xUZ;AIjgWI;EI+tBI;IASQ,gBAAA;ER6xUd;AACF;AItgWI;EI+tBI;IAYQ,eAAA;ER+xUd;AACF;AQ1xU4B;EACI,yBAAA;AR4xUhC;;AQjxUI;EACI,cAAA;ARoxUR;AQlxUI;EACI,eAAA;ARoxUR;AQhxUY;EACI,eAAA;EACA,0BAAA;ARkxUhB;AQ9wU4B;EACI,yBAAA;ARgxUhC;AInjWI;EIkyBwB;IAMQ,yBAAA;ER+wUlC;AACF;;AIxjWI;EImzBA;IAEQ,WAAA;IACA,SAAA;ERwwUV;AACF;AQvwUQ;EACI,aAAA;ARywUZ;AQtwUI;EACI,UAAA;ARwwUR;AQvwUQ;EACI,aAAA;ARywUZ;AQrwUQ;EACI,aAAA;ARuwUZ;AQpwUI;EACI,cAAA;ARswUR;AQpwUI;EACI,cAAA;ARswUR;AQrwUQ;EACI,kBAAA;ARuwUZ;AQpwUI;EACI,MAAA;EACA,qCAAA;ARswUR;AQrwUQ;EACI,uBAAA;ARuwUZ;AQnwUQ;EACI,aAAA;ARqwUZ;AQlwUY;EACI,wBAAA;ARowUhB;AQjwUQ;EACI,qBAAA;EACA,kCAAA;EACA,oCAAA;ARmwUZ;AQlwUY;EACI,aAAA;ARowUhB;AQjwUQ;EACI,qCAAA;ARmwUZ;AQlwUY;EACI,uBAAA;ARowUhB;AQhwUY;EACI,cAAA;ARkwUhB;AQ/vUgB;EACI,wBAAA;ARiwUpB;AQ9vUY;EACI,uBAAA;EACA,8BAAA;EACA,gCAAA;ARgwUhB;AQ/vUgB;EACI,cAAA;ARiwUpB;;AQzvUI;EACI,aAAA;AR4vUR;AQ1vUI;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AR4vUR;AQ1vUI;EACI,wBAAA;AR4vUR;AQ1vUI;EACI,iBAAA;AR4vUR;AIvnWI;EI03BA;IAGQ,eAAA;ER8vUV;AACF;AQ7vUQ;EACI,WAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AR+vUZ;AQ7vUQ;EACI,aAAA;AR+vUZ;AQ7vUQ;EACI,UAAA;AR+vUZ;AQ5vUI;EACI,QAAA;EACA,UAAA;EACA,WAAA;AR8vUR;AI7oWI;EIm5BQ;IAEQ,kBAAA;ER4vUlB;AACF;AQzvUQ;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AR2vUZ;AQxvUY;EACI,cAAA;AR0vUhB;AQtvUI;EACI,eAAA;ARwvUR;AQrvUQ;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;ARuvUZ;AQtvUY;EACI,yBAAA;ARwvUhB;AI/rWI;EIs8BQ;IAGQ,yBAAA;ER0vUlB;AACF;AQvvUgB;EACI,iBAAA;ARyvUpB;AIhrWI;EIs7BY;IAGQ,iBAAA;ER2vUtB;AACF;AIrrWI;EI47BoB;IAEQ,UAAA;ER2vU9B;AACF;AQlvUY;EACI,iBAAA;ARovUhB;AQnvUgB;EACI,eAAA;ARqvUpB;AQlvUoB;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;ARovUxB;;AI5tWI;EIm/BA;IAEQ,aAAA;ER4uUV;AACF;AIluWI;EIw/BA;IAEQ,cAAA;ER4uUV;AACF;AIvuWI;EI8/BI;IAEQ,iBAAA;IAAA,iBAAA;ER2uUd;AACF;AQ1uUY;EACI,wBAAA;AR4uUhB;AQvuUgB;EACI,wBAAA;ARyuUpB;;AQluUI;EACI,yBL//Bc;AHouWtB;AQnuUI;EACI,OAAA;EACA,gCAAA;ARquUR;AQpuUQ;EACI,cAAA;EACA,kBAAA;ARsuUZ;AQnuUI;EACI,SAAA;EACA,yBL3gCc;AHgvWtB;AQpuUQ;EACI,aAAA;ARsuUZ;AQruUY;EACI,aAAA;ARuuUhB;AQpuUQ;EACI,MAAA;ARsuUZ;AI3wWI;EI2iCY;IACI,OAAA;ERmuUlB;AACF;AQ9tUQ;EACI,aAAA;ARguUZ;;AQ5tUA;EACI,yBLtiCkB;AHqwWtB;AQ9tUI;EACI,OAAA;EACA,gCAAA;ARguUR;AQ/tUQ;EACI,cAAA;EACA,kBAAA;ARiuUZ;AQ9tUI;EACI,SAAA;EACA,yBLjjCc;AHixWtB;AQ/tUQ;EACI,aAAA;ARiuUZ;AQhuUY;EACI,aAAA;ARkuUhB;AQ/tUQ;EACI,MAAA;ARiuUZ;AI5yWI;EIilCY;IACI,OAAA;ER8tUlB;AACF;AQztUQ;EACI,aAAA;AR2tUZ;;AQttUI;EACI,OAAA;EACA,yBLz7BG;EK07BH,qBL37BG;AHopWX;AQxtUQ;EACI,iBAAA;EACA,cAAA;AR0tUZ;AIvyWI;EI2kCI;IAOQ,gBAAA;ERytUd;AACF;AI5yWI;EI2kCI;IAUQ,eAAA;ER2tUd;AACF;AQ1tUY;EACI,gBAAA;AR4tUhB;AQvtUgB;EACI,WLplCZ;AH6yWR;AQxtUoB;EACI,mBLn9Bb;AH6qWX;AQrtUQ;EACI,cAAA;ARutUZ;AQttUY;EACI,aAAA;ARwtUhB;AQttUY;EACI,cAAA;ARwtUhB;AQptUI;EACI,cAAA;ARstUR;AI71WI;EIsoCA;IAMQ,cAAA;ERqtUV;AACF;AQptUQ;EACI,WAAA;EACA,aAAA;EACA,mBL1+BD;EK2+BC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;ARstUZ;AIr1WI;EIunCI;IAUQ,SAAA;IACA,aAAA;ERwtUd;AACF;AQttUQ;EACI,WAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;ARwtUZ;AIr2WI;EIqoCI;IAUQ,SAAA;IACA,aAAA;ER0tUd;AACF;AQvtUI;EACI,SAAA;EACA,UAAA;EAAA,aAAA;EACA,YAAA;ARytUR;AQxtUQ;EACI,uBAAA;EACA,MAAA;AR0tUZ;AQztUY;EACI,uBAAA;AR2tUhB;AQztUY;EACI,aAAA;EACA,iBAAA;AR2tUhB;AQxtUQ;EACI,gBAAA;AR0tUZ;AQxtUQ;EACI,aAAA;AR0tUZ;AIj4WI;EIopCA;IAsBQ,SAAA;IACA,SAAA;ER2tUV;AACF;AI95WI;EIqsCA;IAEQ,iBAAA;ER2tUV;AACF;AQ1tUQ;EACI,aAAA;AR4tUZ;AQvtUY;EACI,OAAA;ARytUhB;;AQntUI;EACI,mBLhjCG;EKijCH,qBLjjCG;AHuwWX;AQrtUQ;EACI,cAAA;ARutUZ;AQrtUQ;EACI,aAAA;ARutUZ;AQ/sUgC;EACI,mBLlkCzB;AHmxWX;AQ1sU4B;EACI,cL9kCrB;AH0xWX;AQ1sU4B;EACI,mBL7kCrB;AHyxWX;AQ1sU4B;EACI,mBLhlCrB;AH4xWX;AQtsU4B;EACI,cL7vCtB;AHq8WV;AQhsUqC;EACG,cLtwC9B;AHw8WV;AQ9rU4B;EACI,cLxmCrB;AHwyWX;AQ/rUgC;EACI,cL7wC1B;AH88WV;AQ/rUgC;EACI,cL9mCzB;AH+yWX;AQ/rUgC;EACI,cLhnCzB;AHizWX;AQ7rUgC;EACI,mBLjnCzB;AHgzWX;AQ9rUoC;EACI,cLxnC7B;AHwzWX;AQzrUwC;EACI,cL/nCjC;AH0zWX;AQ1rU4C;EACI,cLpyCtC;AHg+WV;AQhrU4B;EACI,uBAAA;ARkrUhC;AQ3qUgB;EACI,qBLvpCT;AHo0WX;AQtqUY;EACI,WL9xCR;AHs8WR;AQvqUgB;EACI,mBL7pCT;AHs0WX;AQtqUY;EACI,mBL9pCL;AHs0WX;AQtqUoB;EACI,cAAA;ARwqUxB;AQrqUgB;EACI,WL3yCZ;AHk9WR;AQrqUgB;EACI,oCAAA;EACA,gCAAA;ARuqUpB;AQnqUwB;EACI,WLpzCpB;AHy9WR;AQpqU4B;EACI,mBLnrCrB;AHy1WX;AQnqUwB;EACI,mBLvrCjB;AH41WX;AQpqU4B;EACI,sBAAA;ARsqUhC;AQlqU4B;EACI,mBL9rCrB;AHk2WX;AQ/pUgC;EACI,mBLpsCzB;EKqsCyB,sBAAA;ARiqUpC;AQvpUiC;EACI,mBLhtC1B;EKitC0B,sBAAA;ARypUrC;AQhpUQ;EACI,yBLxtCD;EKytCC,qBL1tCD;AH42WX;AIlhXI;EIu4CgB;IAEQ,aAAA;ER6oU1B;AACF;AQtoUQ;EACI,yBL3uCD;EK4uCC,qBL7uCD;AHq3WX;AQtoUQ;EACI,WLr3CJ;EKs3CI,qBLhvCD;AHw3WX;AQvoUY;EACI,mBLrvCL;AH83WX;AQtoUQ;EACI,mBLtvCD;AH83WX;AQvoUY;EACI,WL93CR;AHugXR;AQtoUgB;EACI,cL5vCT;AHo4WX;AQroUY;EACI,WLt4CR;AH6gXR;AQtoUgB;EACI,cL36CV;AHmjXV;AQpoUQ;EACI,WL74CJ;EK84CI,mBLzwCD;EK0wCC,qBL1wCD;AHg5WX;AQroUY;EACI,WLj5CR;AHwhXR;AQroUY;EACI,WLp5CR;EKq5CQ,mBLhxCL;EKixCK,qBLjxCL;AHw5WX;AQtoUgB;EACI,WLx5CZ;AHgiXR;;AQjoUI;EACI,mBLnrCK;EKorCL,qBLprCK;AHwzWb;AQnoUQ;EACI,cAAA;ARqoUZ;AQnoUQ;EACI,aAAA;ARqoUZ;AQ7nUgC;EACI,mBL5yCzB;AH26WX;AQxnU4B;EACI,cLxzCrB;AHk7WX;AQxnU4B;EACI,mBLvzCrB;AHi7WX;AQxnU4B;EACI,mBL1zCrB;AHo7WX;AQpnU4B;EACI,cLv+CtB;AH6lXV;AQ9mUqC;EACG,cLh/C9B;AHgmXV;AQ5mU4B;EACI,cLl1CrB;AHg8WX;AQ7mUgC;EACI,cLv/C1B;AHsmXV;AQ7mUgC;EACI,cLx1CzB;AHu8WX;AQ7mUgC;EACI,cL11CzB;AHy8WX;AQ3mUgC;EACI,mBL31CzB;AHw8WX;AQ5mUoC;EACI,cLl2C7B;AHg9WX;AQvmUwC;EACI,cLz2CjC;AHk9WX;AQxmU4C;EACI,cL9gDtC;AHwnXV;AQ9lU4B;EACI,uBAAA;ARgmUhC;AQzlUgB;EACI,qBLj4CT;AH49WX;AQplUY;EACI,WLxgDR;AH8lXR;AQrlUgB;EACI,mBLv4CT;AH89WX;AQplUY;EACI,mBLjyCH;AHu3Wb;AQplUoB;EACI,cAAA;ARslUxB;AQnlUgB;EACI,WLrhDZ;AH0mXR;AQnlUgB;EACI,oCAAA;EACA,gCAAA;ARqlUpB;AQjlUwB;EACI,WL9hDpB;AHinXR;AQllU4B;EACI,mBL75CrB;AHi/WX;AQjlUwB;EACI,mBLj6CjB;AHo/WX;AQllU4B;EACI,sBAAA;ARolUhC;AQhlU4B;EACI,mBLx6CrB;AH0/WX;AQ7kUgC;EACI,mBL96CzB;EK+6CyB,sBAAA;AR+kUpC;AQrkUiC;EACI,mBL17C1B;EK27C0B,sBAAA;ARukUrC;AQ9jUQ;EACI,yBL31CC;EK41CD,qBLp8CD;AHogXX;AI1qXI;EIinDgB;IAEQ,aAAA;ER2jU1B;AACF;AQpjUQ;EACI,yBL92CC;EK+2CD,qBLv9CD;AH6gXX;AQpjUQ;EACI,WL/lDJ;EKgmDI,qBLn3CC;AHy6Wb;AQrjUY;EACI,mBL/9CL;AHshXX;AQpjUQ;EACI,mBLz3CC;AH+6Wb;AQrjUY;EACI,WLxmDR;AH+pXR;AQpjUgB;EACI,cL/3CP;AHq7Wb;AQnjUY;EACI,WLhnDR;AHqqXR;AQpjUgB;EACI,cLrpDV;AH2sXV;AQljUQ;EACI,WLvnDJ;EKwnDI,mBLn/CD;EKo/CC,qBLp/CD;AHwiXX;AQnjUY;EACI,WL3nDR;AHgrXR;AQnjUY;EACI,WL9nDR;EK+nDQ,mBL1/CL;EK2/CK,qBL3/CL;AHgjXX;AQpjUgB;EACI,WLloDZ;AHwrXR;;AQ/iUI;EACI,mBL55CK;EK65CL,qBL75CK;AH+8Wb;AQjjUQ;EACI,cAAA;ARmjUZ;AQjjUQ;EACI,aAAA;ARmjUZ;AQ3iUgC;EACI,mBLthDzB;AHmkXX;AQtiU4B;EACI,cLliDrB;AH0kXX;AQtiU4B;EACI,mBLjiDrB;AHykXX;AQtiU4B;EACI,mBLpiDrB;AH4kXX;AQliU4B;EACI,cLjtDtB;AHqvXV;AQ5hUqC;EACG,cL1tD9B;AHwvXV;AQ1hU4B;EACI,cL5jDrB;AHwlXX;AQ3hUgC;EACI,cLjuD1B;AH8vXV;AQ3hUgC;EACI,cLlkDzB;AH+lXX;AQ3hUgC;EACI,cLpkDzB;AHimXX;AQzhUgC;EACI,mBLrkDzB;AHgmXX;AQ1hUoC;EACI,cL5kD7B;AHwmXX;AQrhUwC;EACI,cLnlDjC;AH0mXX;AQthU4C;EACI,cLxvDtC;AHgxXV;AQ5gU4B;EACI,uBAAA;AR8gUhC;AQvgUgB;EACI,qBL3mDT;AHonXX;AQlgUY;EACI,WLlvDR;AHsvXR;AQngUgB;EACI,mBLjnDT;AHsnXX;AQlgUY;EACI,mBL1gDH;AH8gXb;AQlgUoB;EACI,cAAA;ARogUxB;AQjgUgB;EACI,WL/vDZ;AHkwXR;AQjgUgB;EACI,oCAAA;EACA,gCAAA;ARmgUpB;AQ//TwB;EACI,WLxwDpB;AHywXR;AQhgU4B;EACI,mBLvoDrB;AHyoXX;AQ//TwB;EACI,mBL3oDjB;AH4oXX;AQhgU4B;EACI,sBAAA;ARkgUhC;AQ9/T4B;EACI,mBLlpDrB;AHkpXX;AQ3/TgC;EACI,mBLxpDzB;EKypDyB,sBAAA;AR6/TpC;AQn/TiC;EACI,mBLpqD1B;EKqqD0B,sBAAA;ARq/TrC;AQ5+TQ;EACI,yBLpkDC;EKqkDD,qBL9qDD;AH4pXX;AIl0XI;EI21DgB;IAEQ,aAAA;ERy+T1B;AACF;AQl+TQ;EACI,yBLvlDC;EKwlDD,qBLjsDD;AHqqXX;AQl+TQ;EACI,WLz0DJ;EK00DI,qBL5lDC;AHgkXb;AQn+TY;EACI,mBL9sDL;EK+sDK,cLzsDL;AH8qXX;AQl+TQ;EACI,mBLnmDC;AHukXb;AQn+TY;EACI,WLn1DR;AHwzXR;AQl+TgB;EACI,cLzmDP;AH6kXb;AQj+TY;EACI,WL31DR;AH8zXR;AQl+TgB;EACI,cLh4DV;AHo2XV;AQh+TQ;EACI,WLl2DJ;EKm2DI,0CAAA;EACA,4CAAA;ARk+TZ;AQj+TY;EACI,WLt2DR;AHy0XR;AQj+TY;EACI,WLz2DR;EK02DQ,uCAAA;EACA,yCAAA;ARm+ThB;AQl+TgB;EACI,WL72DZ;AHi1XR;;AQ79TI;EACI,mBLroDK;EKsoDL,qBLtoDK;AHsmXb;AQ/9TQ;EACI,cAAA;ARi+TZ;AQ/9TQ;EACI,aAAA;ARi+TZ;AQz9TgC;EACI,mBLtwDzB;AHiuXX;AQ19ToC;EACI,cLlwD7B;AH8tXX;AQp9T4B;EACI,cLhxDrB;AHsuXX;AQp9T4B;EACI,mBLpxDrB;AH0uXX;AQr9TgC;EACI,cLhxDzB;AHuuXX;AQp9ToC;EACI,qBLpxD7B;AH0uXX;AQl9T4B;EACI,mBL/xDrB;AHmvXX;AQn9TgC;EACI,cL3xDzB;AHgvXX;AQl9ToC;EACI,qBL/xD7B;AHmvXX;AQ58T4B;EACI,cL/8DtB;AH65XV;AQt8TqC;EACG,cLx9D9B;AHg6XV;AQp8T4B;EACI,cL1zDrB;AHgwXX;AQr8TgC;EACI,cL/9D1B;AHs6XV;AQr8TgC;EACI,cLh0DzB;AHuwXX;AQr8TgC;EACI,cLl0DzB;AHywXX;AQn8TgC;EACI,mBLn0DzB;AHwwXX;AQp8ToC;EACI,cL10D7B;AHgxXX;AQ/7TwC;EACI,cLj1DjC;AHkxXX;AQh8T4C;EACI,cLt/DtC;AHw7XV;AQt7T4B;EACI,uBAAA;ARw7ThC;AQj7TgB;EACI,qBLz2DT;AH4xXX;AQ56TY;EACI,WLh/DR;AH85XR;AQ76TgB;EACI,mBLp3DT;EKq3DS,cL/2DT;AH8xXX;AQ56TY;EACI,mBLvwDH;AHqrXb;AQ56ToB;EACI,cAAA;AR86TxB;AQ16ToB;EACI,WL//DhB;AH26XR;AQv6TwB;EACI,WLrgEpB;AH86XR;AQx6T4B;EACI,mBLz4DrB;EK04DqB,cLp4DrB;AH8yXX;AQv6TwB;EACI,mBL94DjB;AHuzXX;AQx6T4B;EACI,yBAAA;AR06ThC;AQt6T4B;EACI,mBLr5DrB;EKs5DqB,cLh5DrB;AHwzXX;AQn6TgC;EACI,mBL55DzB;EK65DyB,yBAAA;ARq6TpC;AQ35TiC;EACI,mBLx6D1B;EKy6D0B,yBAAA;AR65TrC;AQp5TQ;EACI,yBLj0DC;EKk0DD,qBLj7DD;AHu0XX;AIz+XI;EI0lEgB;IAEQ,aAAA;ERi5T1B;AACF;AQ14TQ;EACI,yBLp1DC;EKq1DD,qBLp8DD;AHg1XX;AQ14TQ;EACI,WLxkEJ;EKykEI,qBLz1DC;AHquXb;AQ34TY;EACI,mBL78DL;EK88DK,cLx8DL;AHq1XX;AQ14TQ;EACI,mBLh2DC;AH4uXb;AQ34TY;EACI,WLllER;AH+9XR;AQ14TgB;EACI,cLt2DP;AHkvXb;AQz4TY;EACI,WL1lER;AHq+XR;AQ14TgB;EACI,cL/nEV;AH2gYV;AQx4TQ;EACI,WLjmEJ;EKkmEI,wCAAA;EACA,0CAAA;AR04TZ;AQz4TY;EACI,WLrmER;AHg/XR;AQz4TY;EACI,WLxmER;EKymEQ,wCAAA;EACA,0CAAA;AR24ThB;AQ14TgB;EACI,WL5mEZ;AHw/XR;;AQr4TI;EACI,mBLr4DI;EKs4DJ,qBLt4DI;AH8wXZ;AQv4TQ;EACI,cAAA;ARy4TZ;AQv4TQ;EACI,aAAA;ARy4TZ;AQj4TgC;EACI,mBLhgEzB;AHm4XX;AQ53T4B;EACI,cL5gErB;AH04XX;AQ53T4B;EACI,mBL3gErB;AHy4XX;AQ53T4B;EACI,mBL9gErB;AH44XX;AQx3T4B;EACI,cL3rEtB;AHqjYV;AQl3TqC;EACG,cLpsE9B;AHwjYV;AQh3T4B;EACI,cLtiErB;AHw5XX;AQj3TgC;EACI,cL3sE1B;AH8jYV;AQj3TgC;EACI,cL5iEzB;AH+5XX;AQj3TgC;EACI,cL9iEzB;AHi6XX;AQ/2TgC;EACI,mBL/iEzB;AHg6XX;AQh3ToC;EACI,cLtjE7B;AHw6XX;AQ32TwC;EACI,cL7jEjC;AH06XX;AQ52T4C;EACI,cLluEtC;AHglYV;AQl2T4B;EACI,uBAAA;ARo2ThC;AQ71TgB;EACI,qBLrlET;AHo7XX;AQx1TY;EACI,WL5tER;AHsjYR;AQz1TgB;EACI,mBL3lET;AHs7XX;AQx1TY;EACI,mBLn/DJ;AH60XZ;AQx1ToB;EACI,cAAA;AR01TxB;AQv1TgB;EACI,WLzuEZ;AHkkYR;AQv1TgB;EACI,oCAAA;EACA,gCAAA;ARy1TpB;AQr1TwB;EACI,WLlvEpB;AHykYR;AQt1T4B;EACI,mBLjnErB;AHy8XX;AQr1TwB;EACI,mBLrnEjB;AH48XX;AQt1T4B;EACI,sBAAA;ARw1ThC;AQp1T4B;EACI,mBL5nErB;AHk9XX;AQj1TgC;EACI,mBLloEzB;EKmoEyB,sBAAA;ARm1TpC;AQz0TiC;EACI,mBL9oE1B;EK+oE0B,sBAAA;AR20TrC;AQl0TQ;EACI,yBL7iEA;EK8iEA,qBLxpED;AH49XX;AIloYI;EIq0EgB;IAEQ,aAAA;ER+zT1B;AACF;AQxzTQ;EACI,yBLhkEA;EKikEA,qBL3qED;AHq+XX;AQxzTQ;EACI,WLnzEJ;EKozEI,qBLrkEA;AH+3XZ;AQzzTY;EACI,mBLnrEL;AH8+XX;AQxzTQ;EACI,mBL3kEA;AHq4XZ;AQzzTY;EACI,WL5zER;AHunYR;AQxzTgB;EACI,cLjlER;AH24XZ;AQvzTY;EACI,WLp0ER;AH6nYR;AQxzTgB;EACI,cLz2EV;AHmqYV;AQtzTQ;EACI,WL30EJ;EK40EI,mBLvsED;EKwsEC,qBLxsED;AHggYX;AQvzTY;EACI,WL/0ER;AHwoYR;AQvzTY;EACI,WLl1ER;EKm1EQ,mBL9sEL;EK+sEK,qBL/sEL;AHwgYX;AQxzTgB;EACI,WLt1EZ;AHgpYR;;AQnzTI;EACI,mBL7mEC;EK8mED,qBL9mEC;AHo6XT;AQrzTQ;EACI,cAAA;ARuzTZ;AQrzTQ;EACI,aAAA;ARuzTZ;AQ9yTgC;EACI,mBLhvEzB;AHgiYX;AQ/yToC;EACI,cL5uE7B;AH6hYX;AQzyT4B;EACI,cL1vErB;AHqiYX;AQzyT4B;EACI,mBL9vErB;AHyiYX;AQ1yTgC;EACI,cL1vEzB;AHsiYX;AQzyToC;EACI,qBL9vE7B;AHyiYX;AQvyT4B;EACI,mBLzwErB;AHkjYX;AQxyTgC;EACI,cLrwEzB;AH+iYX;AQvyToC;EACI,qBLzwE7B;AHkjYX;AQjyT4B;EACI,cLz7EtB;AH4tYV;AQ3xTqC;EACG,cLl8E9B;AH+tYV;AQzxT4B;EACI,cLpyErB;AH+jYX;AQ1xTgC;EACI,cLz8E1B;AHquYV;AQ1xTgC;EACI,cL1yEzB;AHskYX;AQ1xTgC;EACI,cL5yEzB;AHwkYX;AQxxTgC;EACI,mBL7yEzB;AHukYX;AQzxToC;EACI,cLpzE7B;AH+kYX;AQpxTwC;EACI,cL3zEjC;AHilYX;AQrxT4C;EACI,cLh+EtC;AHuvYV;AQ3wT4B;EACI,uBAAA;AR6wThC;AQtwTgB;EACI,qBLn1ET;AH2lYX;AQjwTY;EACI,WL19ER;AH6tYR;AQlwTgB;EACI,mBL91ET;EK+1ES,cLz1ET;AH6lYX;AQjwTY;EACI,mBLhvEP;AHm/XT;AQjwToB;EACI,cAAA;ARmwTxB;AQ/vToB;EACI,WLz+EhB;AH0uYR;AQ5vTwB;EACI,WL/+EpB;AH6uYR;AQ7vT4B;EACI,mBLn3ErB;EKo3EqB,cL92ErB;AH6mYX;AQ5vTwB;EACI,mBLx3EjB;AHsnYX;AQ7vT4B;EACI,yBAAA;AR+vThC;AQ3vT4B;EACI,mBL/3ErB;EKg4EqB,cL13ErB;AHunYX;AQxvTgC;EACI,mBLt4EzB;EKu4EyB,yBAAA;AR0vTpC;AQhvTiC;EACI,mBLl5E1B;EKm5E0B,yBAAA;ARkvTrC;AQzuTQ;EACI,yBL1yEH;EK2yEG,qBLv5ED;AHkoYX;AIxyYI;EIokFgB;IAEQ,aAAA;ERsuT1B;AACF;AQ/tTQ;EACI,yBL7zEH;EK8zEG,qBL16ED;AH2oYX;AQ/tTQ;EACI,WLljFJ;EKmjFI,qBLl0EH;AHmiYT;AQhuTY;EACI,mBLv7EL;EKw7EK,cLl7EL;AHopYX;AQ/tTQ;EACI,mBLz0EH;AH0iYT;AQhuTY;EACI,WL5jFR;AH8xYR;AQ/tTgB;EACI,cL/0EX;AHgjYT;AQ9tTY;EACI,WLpkFR;AHoyYR;AQ/tTgB;EACI,cLzmFV;AH00YV;AQ7tTQ;EACI,WL3kFJ;EK4kFI,qCAAA;EACA,uCAAA;AR+tTZ;AQ9tTY;EACI,WL/kFR;AH+yYR;AQ9tTY;EACI,WLllFR;EKmlFQ,qCAAA;EACA,uCAAA;ARguThB;AQ/tTgB;EACI,WLtlFZ;AHuzYR;;AQztTI;EACI,mCAFQ;EAER,yCAFQ;EAGR,qCAHQ;EAGR,2CAHQ;AR+tThB;AQ3tTQ;EACI,cAAA;AR6tTZ;AQ3tTQ;EACI,aAAA;AR6tTZ;AQrtTgC;EACI,mBLh/EzB;AHusYX;AQttToC;EACI,cL5+E7B;AHosYX;AQhtT4B;EACI,cL1/ErB;AH4sYX;AQhtT4B;EACI,mBL9/ErB;AHgtYX;AQjtTgC;EACI,cL1/EzB;AH6sYX;AQhtToC;EACI,qBL9/E7B;AHgtYX;AQ9sT4B;EACI,mBLzgFrB;AHytYX;AQ/sTgC;EACI,cLrgFzB;AHstYX;AQ9sToC;EACI,qBLzgF7B;AHytYX;AQxsT4B;EACI,cLzrFtB;AHm4YV;AQlsTqC;EACG,cLlsF9B;AHs4YV;AQhsT4B;EACI,cLpiFrB;AHsuYX;AQjsTgC;EACI,cLzsF1B;AH44YV;AQjsTgC;EACI,cL1iFzB;AH6uYX;AQjsTgC;EACI,cL5iFzB;AH+uYX;AQ/rTgC;EACI,mBL7iFzB;AH8uYX;AQhsToC;EACI,cLpjF7B;AHsvYX;AQ3rTwC;EACI,cL3jFjC;AHwvYX;AQ5rT4C;EACI,cLhuFtC;AH85YV;AQlrT4B;EACI,uBAAA;ARorThC;AQ7qTgB;EACI,qBLnlFT;AHkwYX;AQxqTY;EACI,WL1tFR;AHo4YR;AQzqTgB;EACI,mBL9lFT;EK+lFS,cLzlFT;AHowYX;AQxqTY;EACI,mCApIA;EAoIA,yCApIA;AR8yThB;AQxqToB;EACI,cAAA;AR0qTxB;AQtqToB;EACI,WLzuFhB;AHi5YR;AQnqTwB;EACI,WL/uFpB;AHo5YR;AQpqT4B;EACI,mBLnnFrB;EKonFqB,cL9mFrB;AHoxYX;AQnqTwB;EACI,mBLxnFjB;AH6xYX;AQpqT4B;EACI,yBAAA;ARsqThC;AQlqT4B;EACI,mBL/nFrB;EKgoFqB,cL1nFrB;AH8xYX;AQ/pTgC;EACI,mBLtoFzB;EKuoFyB,yBAAA;ARiqTpC;AQvpTiC;EACI,mBLlpF1B;EKmpF0B,yBAAA;ARypTrC;AQhpTQ;EACI,yCA9LI;EA8LJ,+CA9LI;EA+LJ,qBL3pFD;AH6yYX;AI/8YI;EIo0FgB;IAEQ,aAAA;ER6oT1B;AACF;AQtoTQ;EACI,yCAjNI;EAiNJ,+CAjNI;EAkNJ,qBL9qFD;AHszYX;AQtoTQ;EACI,WLlzFJ;EKmzFI,qCAtNI;EAsNJ,2CAtNI;AR81ThB;AQvoTY;EACI,mBLvrFL;EKwrFK,cLlrFL;AH2zYX;AQtoTQ;EACI,mCA7NI;EA6NJ,yCA7NI;ARq2ThB;AQvoTY;EACI,WL5zFR;AHq8YR;AQtoTgB;EACI,8BAnOJ;EAmOI,oCAnOJ;AR22ThB;AQroTY;EACI,WLp0FR;AH28YR;AQtoTgB;EACI,8BAzOJ;EAyOI,oCAzOJ;ARi3ThB;AQpoTQ;EACI,WL30FJ;EK40FI,yCAAA;EAAA,+CAAA;EACA,2CAAA;EAAA,iDAAA;ARsoTZ;AQroTY;EACI,WL/0FR;AHs9YR;AQroTY;EACI,WLl1FR;EKm1FQ,yCAAA;EAAA,+CAAA;EACA,2CAAA;EAAA,iDAAA;ARuoThB;AQtoTgB;EACI,WLt1FZ;AH89YR;;AQ1nTI;;;;;;;;EACI,mBLnnFG;EKonFH,4BLpnFG;AHwvYX;AQnoTQ;;;;;;;;EACI,kCAAA;AR4oTZ;AQ1oTQ;;;;;;;;EACI,mBLznFD;EK0nFC,qBL1nFD;AH6wYX;AQ/oTgB;;;;;;;;EACI,WLj3FZ;AHygZR;AQvpToB;;;;;;;;;;;;;;;EACI,cL/uFb;AHs5YX;AQjqTY;;;;;;;;EACI,mBLxoFL;AHkzYX;AQvqTwB;;;;;;;;EACI,WL93FpB;AH8iZR;AQ9qTgC;;;;;;;;EACI,kBLj4F5B;AHwjZR;AQprT4B;;;;;;;;;;;;;;;;;;;;;;EACI,cLjwFrB;AH48YX;AQzsToC;;;;;;;;;;;;;;;;;;;;;;EACI,qBLpwF7B;AHo+YX;AQntTgB;;;;;;;;EACI,aAAA;AR4tTpB;AQ1tTgB;;;;;;;;EACI,cAAA;ARmuTpB;;AQrtTI;;;;;;;;EACI,mBLprFG;EKqrFH,4BLrrFG;AHo5YX;AQ9tTQ;;;;;;;;EACI,kCAAA;ARuuTZ;AQruTQ;;;;;;;;EACI,mBL1rFD;EK2rFC,qBL3rFD;AHy6YX;AQ1uTgB;;;;;;;;EACI,cL9yFT;AHiiZX;AQlvToB;;;;;;;;;;;;;;;EACI,gBLt7FhB;AHwrZR;AQ5vTY;;;;;;;;EACI,mBLzsFL;AH88YX;;AQxvTI;;;;;;;;EACI,mBLxtFI;EKytFJ,4BLztFI;AH29YZ;AQjwTQ;;;;;;;;EACI,kCAAA;AR0wTZ;AQxwTQ;;;;;;;;EACI,mBL9tFA;EK+tFA,qBL/tFA;AHg/YZ;AQ7wTgB;;;;;;;;EACI,cLj1FT;AHumZX;AQjxTY;;;;;;;;EACI,mBL1uFJ;AHogZZ;;AQ7wTI;;;;;;;;EACI,mBLtvFG;EKuvFH,4BLvvFG;AH8gZX;AQtxTQ;;;;;;;;EACI,kCAAA;AR+xTZ;AQ7xTQ;;;;;;;;EACI,mBL5vFD;EK6vFC,qBL7vFD;AHmiZX;AQlyTgB;;;;;;;;EACI,cLj3FT;AH4pZX;AQtyTY;;;;;;;;EACI,mBLxwFL;AHujZX;;AQlyTI;;;;;;;;EACI,+DL/rFU;EKgsFV,wELhsFU;AH4+YlB;AQ3yTQ;;;;;;;;EACI,kCAAA;ARozTZ;AQlzTQ;;;;;;;;EACI,+DLrsFM;EKssFN,iELtsFM;AHigZlB;AQvzTgB;;;;;;;;EACI,WLvhGZ;AHu1ZR;AQ3zTY;;;;;;;;EACI,+DLjtFE;AHqhZlB;;AQvzTI;;;;;;;;EACI,+DL9tFU;EK+tFV,wEL/tFU;AHgiZlB;AQh0TQ;;;;;;;;EACI,kCAAA;ARy0TZ;AQv0TQ;;;;;;;;EACI,+DLpuFM;EKquFN,iELruFM;AHqjZlB;AQ50TgB;;;;;;;;EACI,WLvjGZ;AH44ZR;AQh1TY;;;;;;;;EACI,+DLhvFE;AHykZlB;;AQ50TI;;;;;;;;EACI,6DL3vFQ;EK4vFR,sEL5vFQ;AHklZhB;AQr1TQ;;;;;;;;EACI,kCAAA;AR81TZ;AQ51TQ;;;;;;;;EACI,6DLjwFI;EKkwFJ,+DLlwFI;AHumZhB;AQj2TgB;;;;;;;;EACI,WLvlGZ;AHi8ZR;AQr2TY;;;;;;;;EACI,6DL7wFA;AH2nZhB;;AQj2TI;;;;;;;;EACI,6DL1xFU;EK2xFV,sEL3xFU;AHsoZlB;AQ12TQ;;;;;;;;EACI,kCAAA;ARm3TZ;AQj3TQ;;;;;;;;EACI,6DLhyFM;EKiyFN,+DLjyFM;AH2pZlB;AQt3TgB;;;;;;;;EACI,WLvnGZ;AHs/ZR;AQ13TY;;;;;;;;EACI,6DL5yFE;AH+qZlB;;AQr3TI;;;;;;;;EACI,kCAFM;EAEN,wCAFM;EAGN,2CAHM;EAGN,iDAHM;ARk4Td;AQ93TQ;;;;;;;;EACI,kCAAA;ARu4TZ;AQr4TQ;;;;;;;;EACI,kCARE;EAQF,wCARE;EASF,oCATE;EASF,0CATE;ARu5Td;AQ14TgB;;;;;;;;EACI,WLxpGZ;AH2iaR;AQl5ToB;;;;;;;;;;;;;;;EACI,cLthGb;AHw7ZX;AQ55TY;;;;;;;;EACI,kCAvBF;EAuBE,wCAvBF;AR47Td;AQl6TwB;;;;;;;;EACI,WLrqGpB;AHglaR;AQz6TgC;;;;;;;;EACI,kBLxqG5B;AH0laR;AQ/6T4B;;;;;;;;;;;;;;;;;;;;;;EACI,cLxiGrB;AH8+ZX;AQp8ToC;;;;;;;;;;;;;;;;;;;;;;EACI,qBL3iG7B;AHsgaX;AQ98TgB;;;;;;;;EACI,aAAA;ARu9TpB;AQr9TgB;;;;;;;;EACI,cAAA;AR89TpB;;AQt9TI;;EACI,OAAA;EACA,yBLpkGG;EKqkGH,qBLtkGG;AHgiaX;AQv9TgB;;EACI,WL/sGZ;AHyqaR;AQz9ToB;;EACI,mBL9kGb;AH0iaX;AQv9TQ;;EACI,cAAA;AR09TZ;AQz9TY;;EACI,aAAA;AR49ThB;AQ19TY;;EACI,cAAA;AR69ThB;AQz9TI;;EACI,WLjuGA;AH6raR;AQz9TQ;;EACI,yBL/lGD;EKgmGC,gCAAA;AR49TZ;AQv9T4B;;EACI,WL5uGxB;AHssaR;AQz9TgC;;;EACI,mBL3mGzB;AHwkaX;AQ19ToC;;EACI,4BAAA;EACA,6BAAA;AR69TxC;AQl9TQ;;EACI,mBLznGD;AH8kaX;;AQ/8TI;;EACI,OAAA;EACA,yBL1yGE;EK2yGF,qBLjvGM;AHosad;AQh9TgB;;EACI,WL5wGZ;AH+taR;AQl9ToB;;EACI,mBLzvGV;AH8sad;AQh9TQ;;EACI,cAAA;ARm9TZ;AQl9TY;;EACI,aAAA;ARq9ThB;AQn9TY;;EACI,cAAA;ARs9ThB;AQl9TI;;EACI,WL9xGA;AHmvaR;AQl9TQ;;EACI,yBLr0GF;EKs0GE,gCAAA;ARq9TZ;AQh9T4B;;EACI,WLzyGxB;AH4vaR;AQl9TgC;;;EACI,mBLtxGtB;AH4uad;AQn9ToC;;EACI,4BAAA;EACA,6BAAA;ARs9TxC;AQ38TQ;;EACI,WAAA;EACA,mBLh2GF;AH8yaV;;AQx8TI;;EACI,OAAA;EACA,yBLzkGK;EK0kGL,qBLjsGG;AH6oaX;AQz8TgB;;EACI,WL10GZ;AHsxaR;AQ38ToB;;EACI,mBLzsGb;AHupaX;AQz8TQ;;EACI,cAAA;AR48TZ;AQ38TY;;EACI,aAAA;AR88ThB;AQ58TY;;EACI,cAAA;AR+8ThB;AQ38TI;;EACI,WL51GA;AH0yaR;AQ38TQ;;EACI,yBLpmGC;EKqmGD,gCAAA;AR88TZ;AQz8T4B;;EACI,WLv2GxB;AHmzaR;AQ38TgC;;;;EACI,mBLtuGzB;AHsraX;AQ78ToC;;EACI,4BAAA;EACA,6BAAA;ARg9TxC;AQz8TwB;;EACI,qBLlvGjB;AH8raX;AQp8TQ;;EACI,WAAA;EACA,mBLpoGC;AH2kab;;AQj8TI;;EACI,OAAA;EACA,yBL3oGC;EK4oGD,2CAAA;ARq8TR;AQl8TgB;;EACI,WL74GZ;AHk1aR;AQp8ToB;;EACI,mBLt5GL;EKu5GK,cL5wGb;AHmtaX;AQl8TQ;;EACI,cAAA;ARq8TZ;AQp8TY;;EACI,aAAA;ARu8ThB;AQr8TY;;EACI,cAAA;ARw8ThB;AQp8TI;;EACI,WLh6GA;AHu2aR;AQp8TQ;;EACI,yBLvqGH;EKwqGG,sDAAA;ARu8TZ;AQl8T4B;;EACI,WL36GxB;AHg3aR;AQp8TgC;;;;EACI,yBLp7GjB;EKq7GiB,cLxyGzB;AHivaX;AQv8TwC;;;;EACI,qBL3yGjC;AHuvaX;AQv8ToC;;EACI,4BAAA;EACA,6BAAA;AR08TxC;AQn8TwB;;EACI,qBL5zGjB;AHkwaX;AQ97TQ;;EACI,WAAA;EACA,mBL7sGH;AH8oaT;;AQ37TI;;EACI,OAAA;EACA,sBLl9GA;EKm9GA,mBAAA;AR+7TR;AQ57TgB;;EACI,cLr1GT;AHoxaX;AQ97ToB;;EACI,mBLh+GL;EKi+GK,cLp1Gb;AHqxaX;AQ57TQ;;EACI,cAAA;AR+7TZ;AQ97TY;;EACI,cAAA;ARi8ThB;AQ/7TY;;EACI,aAAA;ARk8ThB;AQ97TI;;EACI,cLt2GG;AHuyaX;AQ97TQ;;EACI,sBL9+GJ;EK++GI,8BAAA;ARi8TZ;AQ57T4B;;EACI,cL/2GrB;AH8yaX;AQ97TgC;;;;EACI,yBL9/GjB;EK+/GiB,cLl3GzB;AHqzaX;AQj8TwC;;;;EACI,qBLr3GjC;AH2zaX;AQj8ToC;;EACI,qBL33G7B;AH+zaX;AQ77TwB;;EACI,qBLn4GjB;AHm0aX;AQx7TQ;;EACI,WAAA;EACA,gBLnhHJ;AH88aR;;AQr7TI;;EACI,OAAA;EACA,yBL7xGE;EK8xGF,+DAAA;ARy7TR;AQt7TgB;;EACI,WLhiHZ;AHy9aR;AQx7ToB;;EACI,mBLziHL;EK0iHK,cL/5Gb;AH01aX;AQt7TQ;;EACI,cAAA;ARy7TZ;AQx7TY;;EACI,aAAA;AR27ThB;AQz7TY;;EACI,cAAA;AR47ThB;AQx7TI;;EACI,WLnjHA;AH8+aR;AQx7TQ;;EACI,yBLzzGF;EK0zGE,0EAAA;AR27TZ;AQt7T4B;;EACI,WL9jHxB;AHu/aR;AQx7TgC;;;;EACI,yBLvkHjB;EKwkHiB,cL37GzB;AHw3aX;AQ37TwC;;;;EACI,qBL97GjC;AH83aX;AQ37ToC;;EACI,4BAAA;EACA,6BAAA;AR87TxC;AQv7TwB;;EACI,qBL/8GjB;AHy4aX;AQl7TQ;;EACI,WAAA;EACA,mBL/1GF;AHoxaV;;AQ96TI;;EACI,OAAA;EACA,6CAHM;EAGN,mDAHM;EAIN,yCAJM;EAIN,+CAJM;ARs7Td;AQ/6TgB;;EACI,WL3mHZ;AH6hbR;AQj7ToB;;EACI,mBLpnHL;EKqnHK,cL1+Gb;AH85aX;AQ/6TQ;;EACI,cAAA;ARk7TZ;AQj7TY;;EACI,aAAA;ARo7ThB;AQl7TY;;EACI,cAAA;ARq7ThB;AQj7TI;;EACI,WL9nHA;AHkjbR;AQj7TQ;;EACI,6CA/BE;EA+BF,mDA/BE;EAgCF,oDAAA;EAAA,0DAAA;ARo7TZ;AQ/6T4B;;EACI,WLzoHxB;AH2jbR;AQj7TgC;;;;EACI,yBLlpHjB;EKmpHiB,cLtgHzB;AH47aX;AQp7TwC;;;;EACI,qBLzgHjC;AHk8aX;AQp7ToC;;EACI,4BAAA;EACA,6BAAA;ARu7TxC;AQh7TwB;;EACI,qBL1hHjB;AH68aX;AQ36TQ;;EACI,WAAA;EACA,uCArEE;EAqEF,6CArEE;ARm/Td;;AQz6TI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AR46TR;AQ36TQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AR66TZ;;AQv6TI;;EACI,OAAA;EACA,yBLl8GE;EKm8GF,qBL7jHG;AHw+aX;AQx6TgB;;EACI,WLtsHZ;AHinbR;AQ16ToB;;EACI,mBLrkHb;AHk/aX;AQx6TQ;;EACI,cAAA;AR26TZ;AQ16TY;;EACI,aAAA;AR66ThB;AQ36TY;;EACI,cAAA;AR86ThB;AQ16TI;;EACI,WLxtHA;AHqobR;AQ16TQ;;EACI,yBL79GF;EK89GE,gCAAA;AR66TZ;AQx6T4B;;EACI,WLnuHxB;AH8obR;AQ16TgC;;;;EACI,mBLlmHzB;AHihbX;AQ56ToC;;EACI,4BAAA;EACA,6BAAA;AR+6TxC;AQx6TwB;;EACI,qBL9mHjB;AHyhbX;AQn6TQ;;EACI,WAAA;EACA,mBL7/GF;AHm6aV;;AQj6TI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARo6TR;AQn6TQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;ARq6TZ;;AQh6TI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARm6TR;AQl6TQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ARo6TZ;;AQ/5TI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARk6TR;AQj6TQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ARm6TZ;;AQ95TI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARi6TR;AQh6TQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ARk6TZ;;AQ75TI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARg6TR;AQ/5TQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ARi6TZ;;AQ55TI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AR+5TR;AQ95TQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;ARg6TZ;;AQr5TO;;;;;;EACC,qCAAA;AR65TR;;AQl5TO;;;;;;EACC,kCAAA;AR05TR;;AQ/4TO;;;;;;EACC,kCAAA;ARu5TR;;AQ54TO;;;;;;EACC,kCAAA;ARo5TR;;AQz4TO;;;;;;EACC,kCAAA;ARi5TR;;AQt4TO;;;;;;EACC,mCAAA;AR84TR;;AQn4TO;;;;;;EACC,0CAAA;EAAA,gDAAA;AR24TR;;AQp4TQ;;EACI,mDAAA;ARw4TZ;;AQj4TQ;;EACI,mDAAA;ARq4TZ;;AQ93TQ;;EACI,mDAAA;ARk4TZ;;AQ33TQ;;EACI,kCAAA;EACA,UAAA;AR+3TZ;AQ73TQ;;EACI,UAAA;ARg4TZ;;AQz3TQ;;EACI,qCAAA;EACA,UAAA;AR63TZ;AQ33TQ;;EACI,UAAA;AR83TZ;;AQv3TQ;;EACI,mCAAA;EACA,UAAA;AR23TZ;AQz3TQ;;EACI,UAAA;AR43TZ;;AQr3TQ;;EACI,gCAAA;EACA,UAAA;ARy3TZ;AQv3TQ;;EACI,UAAA;AR03TZ;;AQn3TQ;;EACI,mCAAA;EACA,UAAA;ARu3TZ;AQr3TQ;;EACI,UAAA;ARw3TZ;;AQj3TQ;;EACI,iCAAA;EACA,UAAA;ARq3TZ;AQn3TQ;;EACI,UAAA;ARs3TZ;;AQj3TI;EACI,sBL9hIA;EK+hIA,sCAAA;ARo3TR;AQl3TY;EACI,sBLliIR;AHs5bR;AQ/2TgB;EACI,cLt6HT;AHuxbX;AQh3ToB;EACI,yBLjjIL;EKkjIK,qBLljIL;EKmjIK,yBAAA;ARk3TxB;AQ52TY;EACI,cAAA;AR82ThB;AQ52TY;EACI,aAAA;AR82ThB;AQz2TQ;EACI,gBL5jIJ;AHu6bR;AQz2TQ;EACI,aAAA;AR22TZ;;AQt2TI;EACI,sBLrkIA;EKskIA,sCAAA;ARy2TR;AQv2TY;EACI,sBLzkIR;AHk7bR;AQp2TgB;EACI,cL78HT;AHmzbX;AQr2ToB;EACI,yBLxlIL;EKylIK,qBLzlIL;EK0lIK,yBAAA;ARu2TxB;AQj2TY;EACI,aAAA;ARm2ThB;AQj2TY;EACI,cAAA;ARm2ThB;AQ91TQ;EACI,gBLnmIJ;AHm8bR;;AQ31TI;EACI,yBL5oIE;EK6oIF,qBLnlIM;AHi7bd;AQ51TY;EACI,sBL7mIR;AH28bR;AQz1TgB;EACI,WLnnIZ;AH88bR;AQ11ToB;EACI,sBLrnIhB;EKsnIgB,yBAAA;AR41TxB;AQt1TY;EACI,aAAA;ARw1ThB;AQt1TY;EACI,cAAA;ARw1ThB;AQn1TQ;EACI,mBLzqIF;AH8/bV;;AQh1TI;EACI,yBLh5HK;EKi5HL,iCAAA;ARm1TR;AQj1TY;EACI,sBLhpIR;AHm+bR;AQ90TgB;EACI,WLtpIZ;AHs+bR;AQ/0ToB;EACI,sBLxpIhB;EKypIgB,yBAAA;ARi1TxB;AQ30TY;EACI,aAAA;AR60ThB;AQ30TY;EACI,cAAA;AR60ThB;AQx0TQ;EACI,mBL76HC;AHuvbb;;AQr0TI;EACI,yBLl7HC;EKm7HD,mCAAA;ARw0TR;AQt0TY;EACI,sBLnrIR;AH2/bR;AQn0TgB;EACI,WLzrIZ;AH8/bR;AQp0ToB;EACI,sBL3rIhB;EK4rIgB,yBAAA;ARs0TxB;AQh0TY;EACI,aAAA;ARk0ThB;AQh0TY;EACI,cAAA;ARk0ThB;AQ7zTQ;EACI,mBL/8HH;AH8wbT;;AQ1zTI;EACI,yBLp9HE;EKq9HF,oCAAA;AR6zTR;AQ3zTY;EACI,sBLttIR;AHmhcR;AQxzTgB;EACI,WL5tIZ;AHshcR;AQzzToB;EACI,sBL9tIhB;EK+tIgB,yBAAA;AR2zTxB;AQrzTY;EACI,aAAA;ARuzThB;AQrzTY;EACI,cAAA;ARuzThB;AQlzTQ;EACI,mBLj/HF;AHqybV;;AQ/yTI;EACI,yBLt/HE;EKu/HF,kCAAA;ARkzTR;AQhzTY;EACI,sBLzvIR;AH2icR;AQ7yTgB;EACI,WL/vIZ;AH8icR;AQ9yToB;EACI,sBLjwIhB;EKkwIgB,yBAAA;ARgzTxB;AQ1yTY;EACI,aAAA;AR4yThB;AQ1yTY;EACI,cAAA;AR4yThB;AQvyTQ;EACI,mBLnhIF;AH4zbV;;AQpyTI;EACI,oBAAA;EACA,gBAAA;ARuyTR;;AQnyTI;EACI,oBAAA;EACA,8DLh7HQ;AHstbhB;;AQ3xT4B;EACI,cARlB;ARsyTd;AQvxTgC;EACI,+BAAA;EACA,gCAAA;ARyxTpC;AQtxT4B;EACI,cArBlB;AR6yTd;AQvxTgC;EACI,cAvBtB;ARgzTd;AQ5wTgC;EACI,cArCtB;ARmzTd;AQ5wTgC;EACI,cAxCtB;ARszTd;AQtwTwB;EACI,cAjDd;ARyzTd;AQxvTyC;EACI,cAlE/B;AR4zTd;AQ/uTI;EACI,yBA9EM;EA+EN,yBAAA;ARivTR;AQhvTQ;EAKI,mEAAA;EACA,mEAAA;AR8uTZ;AQ3uTI;EACI,yBA1FM;EA2FN,qBA3FM;ARw0Td;AQ3uTI;EACI,yBAAA;AR6uTR;AQ5uTQ;EAGE,wDAAA;AR4uTV;AQzuTI;EACI,yBAAA;AR2uTR;AQxuTQ;EACI,mBA1GE;ARo1Td;AQvuTI;EACI,mBA9GM;EA+GN,qBA/GM;ARw1Td;AQvuTI;EACI,oCAAA;EACA,oCAAA;ARyuTR;AQvuTI;EACI,gCAAA;ARyuTR;AQvuTI;EACI,gCAAA;ARyuTR;AQvuTI;EACI,4BA5HM;EA6HN,cA7HM;ARs2Td;AQtuTQ;EACI,kCAAA;EACA,cAlIE;AR02Td;AQnuTQ;EACI,cAxIE;AR62Td;AQluTY;EACI,WL/6IR;AHmpcR;AQhuTI;EACI,oCAAA;EACA,yBAAA;ARkuTR;AQjuTQ;EAKI,oCAAA;EACA,oCAAA;EACA,sBAAA;AR+tTZ;AQ3tTQ;EACI,qBA/JE;AR43Td;AQ3tTQ;EACI,mBAlKE;AR+3Td;AQztTQ;EACI,yBAvKE;EAwKF,qBAxKE;ARm4Td;AQvtTQ;EACI,cA7KE;ARs4Td;AQrtTQ;EACE,yBAlLI;EAmLJ,qBAnLI;AR04Td;AQptTI;EACI,yBAvLM;AR64Td;AI1rcI;EIm+IA;IAGQ,aAAA;ERwtTV;AACF;AQptTY;EACI,cA/LF;ARq5Td;AQhtTY;EACI,aAtMF;ARw5Td;AQ5sTY;EACI,aA7MF;AR25Td;AQzsTQ;EACI,aAnNE;AR85Td;AQtsTY;EACI,eAzNF;ARi6Td;AQtsTY;EACI,aA5NF;ARo6Td;AQnsTQ;EACI,wBAAA;ARqsTZ;AQjsTQ;EACI,0BAAA;ARmsTZ;AQjsTQ;EACI,aA1OE;AR66Td;AQhsTI;EACI,oCAAA;ARksTR;AQhsTI;EACI,cAjPM;ARm7Td;AQ9rTY;EACI,mBAtPF;EAuPE,WL1hJR;AH0tcR;;AQnrT4B;EACI,cARlB;AR8rTd;AQjrTgC;EACI,cAdtB;ARisTd;AQ3qTgC;EACI,+BAAA;EACA,gCAAA;AR6qTpC;AQ1qT4B;EACI,cA5BlB;ARwsTd;AQ3qTgC;EACI,cA9BtB;AR2sTd;AQhqTgC;EACI,mBA5CtB;AR8sTd;AQhqTgC;EACI,cA/CtB;ARitTd;AQhqTgC;EACI,cAlDtB;ARotTd;AQ1pTwB;EACI,cA3Dd;ARutTd;AQrpTY;EACI,cAnEF;AR0tTd;AQ1oTyC;EACI,cAjF/B;AR6tTd;AQjoTI;EACI,yBA7FM;EA8FN,yBAAA;ARmoTR;AQloTQ;EAKI,gDAAA;EACA,gDAAA;ARgoTZ;AQ7nTI;EACI,yBAzGM;EA0GN,qBA1GM;ARyuTd;AQ7nTI;EACI,yBAAA;AR+nTR;AQ9nTQ;EAGE,qCAAA;AR8nTV;AQ3nTI;EACI,yBAAA;AR6nTR;AQ1nTQ;EACI,mBAzHE;ARqvTd;AQznTI;EACI,mBA7HM;EA8HN,qBA9HM;ARyvTd;AQznTI;EACI,oCAAA;EACA,oCAAA;AR2nTR;AQznTI;EACI,gCAAA;AR2nTR;AQznTI;EACI,gCAAA;AR2nTR;AQznTI;EACI,4BA3IM;EA4IN,cA5IM;ARuwTd;AQxnTQ;EACI,mCAAA;EACA,cAjJE;AR2wTd;AQrnTQ;EACI,cAvJE;AR8wTd;AQpnTI;EACI,oCAAA;EACA,yBAAA;ARsnTR;AQrnTQ;EAKI,oCAAA;EACA,oCAAA;ARmnTZ;AQ/mTQ;EACI,qBAxKE;ARyxTd;AQ/mTQ;EACI,mBA3KE;AR4xTd;AQ7mTQ;EACI,yBAhLE;EAiLF,qBAjLE;ARgyTd;AQ3mTQ;EACI,cAtLE;ARmyTd;AQzmTQ;EACE,yBA3LI;EA4LJ,qBA5LI;ARuyTd;AQxmTI;EACI,yBAhMM;AR0yTd;AQtmTY;EACI,cArMF;AR6yTd;AQlmTY;EACI,aA5MF;ARgzTd;AQ9lTY;EACI,aAnNF;ARmzTd;AQ3lTQ;EACI,aAzNE;ARszTd;AQxlTY;EACI,eA/NF;ARyzTd;AQxlTY;EACI,aAlOF;AR4zTd;AQrlTQ;EACI,wBAAA;ARulTZ;AQnlTQ;EACI,0BAAA;ARqlTZ;AQnlTQ;EACI,aAhPE;ARq0Td;AQllTI;EACI,oCAAA;ARolTR;AQllTI;EACI,cAvPM;AR20Td;AQhlTY;EACI,mBA5PF;EA6PE,WL7xJR;AH+2cR;;AQrkT4B;EACI,cARlB;ARglTd;AQnkTgC;EACI,cAdtB;ARmlTd;AQ7jTgC;EACI,+BAAA;EACA,gCAAA;AR+jTpC;AQ5jT4B;EACI,cA5BlB;AR0lTd;AQ7jTgC;EACI,cA9BtB;AR6lTd;AQljTgC;EACI,mBA5CtB;ARgmTd;AQljTgC;EACI,cA/CtB;ARmmTd;AQljTgC;EACI,cAlDtB;ARsmTd;AQ5iTwB;EACI,cA3Dd;ARymTd;AQviTY;EACI,cAnEF;AR4mTd;AQ5hTyC;EACI,cAjF/B;AR+mTd;AQnhTI;EACI,yBA7FM;EA8FN,yBAAA;ARqhTR;AQphTQ;EAKI,4DAAA;EACA,4DAAA;ARkhTZ;AQ/gTI;EACI,yBAzGM;EA0GN,qBA1GM;AR2nTd;AQ/gTI;EACI,yBAAA;ARihTR;AQhhTQ;EAGE,iDAAA;ARghTV;AQ7gTI;EACI,yBAAA;AR+gTR;AQ5gTQ;EACI,mBAzHE;ARuoTd;AQ3gTI;EACI,mBA7HM;EA8HN,qBA9HM;AR2oTd;AQ3gTI;EACI,oCAAA;EACA,oCAAA;AR6gTR;AQ3gTI;EACI,gCAAA;AR6gTR;AQ3gTI;EACI,gCAAA;AR6gTR;AQ3gTI;EACI,4BA3IM;EA4IN,cA5IM;ARypTd;AQ1gTQ;EACI,iCAAA;EACA,cAjJE;AR6pTd;AQvgTQ;EACI,cAvJE;ARgqTd;AQtgTI;EACI,oCAAA;EACA,yBAAA;ARwgTR;AQvgTQ;EAKI,oCAAA;EACA,oCAAA;ARqgTZ;AQjgTQ;EACI,qBAxKE;AR2qTd;AQjgTQ;EACI,mBA3KE;AR8qTd;AQ//SQ;EACI,yBAhLE;EAiLF,qBAjLE;ARkrTd;AQ7/SQ;EACI,cAtLE;ARqrTd;AQ3/SQ;EACE,yBA3LI;EA4LJ,qBA5LI;ARyrTd;AQ1/SI;EACI,yBAhMM;AR4rTd;AQx/SY;EACI,cArMF;AR+rTd;AQp/SY;EACI,aA5MF;ARksTd;AQh/SY;EACI,aAnNF;ARqsTd;AQ7+SQ;EACI,aAzNE;ARwsTd;AQ1+SY;EACI,eA/NF;AR2sTd;AQ1+SY;EACI,aAlOF;AR8sTd;AQv+SQ;EACI,wBAAA;ARy+SZ;AQr+SQ;EACI,0BAAA;ARu+SZ;AQr+SQ;EACI,aAhPE;ARutTd;AQp+SI;EACI,oCAAA;ARs+SR;AQp+SI;EACI,cAvPM;AR6tTd;AQl+SY;EACI,mBA5PF;EA6PE,WLhiKR;AHogdR;;AQv9S4B;EACI,cARlB;ARk+Sd;AQr9SgC;EACI,cAdtB;ARq+Sd;AQ/8SgC;EACI,+BAAA;EACA,gCAAA;ARi9SpC;AQ98S4B;EACI,cA5BlB;AR4+Sd;AQ/8SgC;EACI,cA9BtB;AR++Sd;AQp8SgC;EACI,mBA5CtB;ARk/Sd;AQp8SgC;EACI,cA/CtB;ARq/Sd;AQp8SgC;EACI,cAlDtB;ARw/Sd;AQ97SwB;EACI,cA3Dd;AR2/Sd;AQz7SY;EACI,cAnEF;AR8/Sd;AQ96SyC;EACI,cAjF/B;ARigTd;AQr6SI;EACI,yBA7FM;EA8FN,yBAAA;ARu6SR;AQt6SQ;EAKI,mEAAA;EACA,mEAAA;ARo6SZ;AQj6SI;EACI,yBAzGM;EA0GN,qBA1GM;AR6gTd;AQj6SI;EACI,yBAAA;ARm6SR;AQl6SQ;EAGE,wDAAA;ARk6SV;AQ/5SI;EACI,yBAAA;ARi6SR;AQ95SQ;EACI,mBAzHE;ARyhTd;AQ75SI;EACI,mBA7HM;EA8HN,qBA9HM;AR6hTd;AQ75SI;EACI,oCAAA;EACA,oCAAA;AR+5SR;AQ75SI;EACI,gCAAA;AR+5SR;AQ75SI;EACI,gCAAA;AR+5SR;AQ75SI;EACI,4BA3IM;EA4IN,cA5IM;AR2iTd;AQ55SQ;EACI,mCAAA;EACA,cAjJE;AR+iTd;AQz5SQ;EACI,cAvJE;ARkjTd;AQx5SI;EACI,oCAAA;EACA,yBAAA;AR05SR;AQz5SQ;EAKI,oCAAA;EACA,oCAAA;ARu5SZ;AQn5SQ;EACI,qBAxKE;AR6jTd;AQn5SQ;EACI,mBA3KE;ARgkTd;AQj5SQ;EACI,yBAhLE;EAiLF,qBAjLE;ARokTd;AQ/4SQ;EACI,cAtLE;ARukTd;AQ74SQ;EACE,yBA3LI;EA4LJ,qBA5LI;AR2kTd;AQ54SI;EACI,yBAhMM;AR8kTd;AQ14SY;EACI,cArMF;ARilTd;AQt4SY;EACI,aA5MF;ARolTd;AQl4SY;EACI,aAnNF;ARulTd;AQ/3SQ;EACI,aAzNE;AR0lTd;AQ53SY;EACI,eA/NF;AR6lTd;AQ53SY;EACI,aAlOF;ARgmTd;AQz3SQ;EACI,wBAAA;AR23SZ;AQv3SQ;EACI,0BAAA;ARy3SZ;AQv3SQ;EACI,aAhPE;ARymTd;AQt3SI;EACI,oCAAA;ARw3SR;AQt3SI;EACI,cAvPM;AR+mTd;AQp3SY;EACI,mBA5PF;EA6PE,WLnyKR;AHypdR;;AQz2S4B;EACI,cARlB;ARo3Sd;AQv2SgC;EACI,cAdtB;ARu3Sd;AQj2SgC;EACI,+BAAA;EACA,gCAAA;ARm2SpC;AQh2S4B;EACI,cA5BlB;AR83Sd;AQj2SgC;EACI,cA9BtB;ARi4Sd;AQt1SgC;EACI,mBA5CtB;ARo4Sd;AQt1SgC;EACI,cA/CtB;ARu4Sd;AQt1SgC;EACI,cAlDtB;AR04Sd;AQh1SwB;EACI,cA3Dd;AR64Sd;AQ30SY;EACI,cAnEF;ARg5Sd;AQh0SyC;EACI,cAjF/B;ARm5Sd;AQvzSI;EACI,yBA7FM;EA8FN,yBAAA;ARyzSR;AQxzSQ;EAKI,oEAAA;EACA,oEAAA;ARszSZ;AQnzSI;EACI,yBAzGM;EA0GN,qBA1GM;AR+5Sd;AQnzSI;EACI,yBAAA;ARqzSR;AQpzSQ;EAGE,yDAAA;ARozSV;AQjzSI;EACI,yBAAA;ARmzSR;AQhzSQ;EACI,mBAzHE;AR26Sd;AQ/ySI;EACI,mBA7HM;EA8HN,qBA9HM;AR+6Sd;AQ/ySI;EACI,oCAAA;EACA,oCAAA;ARizSR;AQ/ySI;EACI,gCAAA;ARizSR;AQ/ySI;EACI,gCAAA;ARizSR;AQ/ySI;EACI,4BA3IM;EA4IN,cA5IM;AR67Sd;AQ9ySQ;EACI,mCAAA;EACA,cAjJE;ARi8Sd;AQ3ySQ;EACI,cAvJE;ARo8Sd;AQ1ySI;EACI,oCAAA;EACA,yBAAA;AR4ySR;AQ3ySQ;EAKI,oCAAA;EACA,oCAAA;ARyySZ;AQrySQ;EACI,qBAxKE;AR+8Sd;AQrySQ;EACI,mBA3KE;ARk9Sd;AQnySQ;EACI,yBAhLE;EAiLF,qBAjLE;ARs9Sd;AQjySQ;EACI,cAtLE;ARy9Sd;AQ/xSQ;EACE,yBA3LI;EA4LJ,qBA5LI;AR69Sd;AQ9xSI;EACI,yBAhMM;ARg+Sd;AQ5xSY;EACI,cArMF;ARm+Sd;AQxxSY;EACI,aA5MF;ARs+Sd;AQpxSY;EACI,aAnNF;ARy+Sd;AQjxSQ;EACI,aAzNE;AR4+Sd;AQ9wSY;EACI,eA/NF;AR++Sd;AQ9wSY;EACI,aAlOF;ARk/Sd;AQ3wSQ;EACI,wBAAA;AR6wSZ;AQzwSQ;EACI,0BAAA;AR2wSZ;AQzwSQ;EACI,aAhPE;AR2/Sd;AQxwSI;EACI,oCAAA;AR0wSR;AQxwSI;EACI,cAvPM;ARigTd;AQtwSY;EACI,mBA5PF;EA6PE,WLtiLR;AH8ydR;;AQ3vS4B;EACI,cARlB;ARswSd;AQzvSgC;EACI,cAdtB;ARywSd;AQnvSgC;EACI,+BAAA;EACA,gCAAA;ARqvSpC;AQlvS4B;EACI,cA5BlB;ARgxSd;AQnvSgC;EACI,cA9BtB;ARmxSd;AQxuSgC;EACI,mBA5CtB;ARsxSd;AQxuSgC;EACI,cA/CtB;ARyxSd;AQxuSgC;EACI,cAlDtB;AR4xSd;AQluSwB;EACI,cA3Dd;AR+xSd;AQ7tSY;EACI,cAnEF;ARkySd;AQltSyC;EACI,cAjF/B;ARqySd;AQzsSI;EACI,yBA7FM;EA8FN,yBAAA;AR2sSR;AQ1sSQ;EAKI,+CAAA;EACA,+CAAA;ARwsSZ;AQrsSI;EACI,yBAzGM;EA0GN,qBA1GM;ARizSd;AQrsSI;EACI,yBAAA;ARusSR;AQtsSQ;EAGE,oCAAA;ARssSV;AQnsSI;EACI,yBAAA;ARqsSR;AQlsSQ;EACI,mBAzHE;AR6zSd;AQjsSI;EACI,mBA7HM;EA8HN,qBA9HM;ARi0Sd;AQjsSI;EACI,oCAAA;EACA,oCAAA;ARmsSR;AQjsSI;EACI,gCAAA;ARmsSR;AQjsSI;EACI,gCAAA;ARmsSR;AQjsSI;EACI,4BA3IM;EA4IN,cA5IM;AR+0Sd;AQhsSQ;EACI,kCAAA;EACA,cAjJE;ARm1Sd;AQ7rSQ;EACI,cAvJE;ARs1Sd;AQ5rSI;EACI,oCAAA;EACA,yBAAA;AR8rSR;AQ7rSQ;EAKI,oCAAA;EACA,oCAAA;AR2rSZ;AQvrSQ;EACI,qBAxKE;ARi2Sd;AQvrSQ;EACI,mBA3KE;ARo2Sd;AQrrSQ;EACI,yBAhLE;EAiLF,qBAjLE;ARw2Sd;AQnrSQ;EACI,cAtLE;AR22Sd;AQjrSQ;EACE,yBA3LI;EA4LJ,qBA5LI;AR+2Sd;AQhrSI;EACI,yBAhMM;ARk3Sd;AQ9qSY;EACI,cArMF;ARq3Sd;AQ1qSY;EACI,aA5MF;ARw3Sd;AQtqSY;EACI,aAnNF;AR23Sd;AQnqSQ;EACI,aAzNE;AR83Sd;AQhqSY;EACI,eA/NF;ARi4Sd;AQhqSY;EACI,aAlOF;ARo4Sd;AQ7pSQ;EACI,wBAAA;AR+pSZ;AQ3pSQ;EACI,0BAAA;AR6pSZ;AQ3pSQ;EACI,aAhPE;AR64Sd;AQ1pSI;EACI,oCAAA;AR4pSR;AQ1pSI;EACI,cAvPM;ARm5Sd;AQxpSY;EACI,mBA5PF;EA6PE,WLzyLR;AHm8dR;;AQ7oS4B;EACI,cARlB;ARwpSd;AQ3oSgC;EACI,cAdtB;AR2pSd;AQroSgC;EACI,+BAAA;EACA,gCAAA;ARuoSpC;AQpoS4B;EACI,cA5BlB;ARkqSd;AQroSgC;EACI,cA9BtB;ARqqSd;AQ1nSgC;EACI,mBA5CtB;ARwqSd;AQ1nSgC;EACI,cA/CtB;AR2qSd;AQ1nSgC;EACI,cAlDtB;AR8qSd;AQpnSwB;EACI,cA3Dd;ARirSd;AQ/mSY;EACI,cAnEF;ARorSd;AQpmSyC;EACI,cAjF/B;ARurSd;AQ3lSI;EACI,yBA7FM;EA8FN,yBAAA;AR6lSR;AQ5lSQ;EAKI,8CAAA;EACA,8CAAA;AR0lSZ;AQvlSI;EACI,yBAzGM;EA0GN,qBA1GM;ARmsSd;AQvlSI;EACI,yBAAA;ARylSR;AQxlSQ;EAGE,mCAAA;ARwlSV;AQrlSI;EACI,yBAAA;ARulSR;AQplSQ;EACI,mBAzHE;AR+sSd;AQnlSI;EACI,mBA7HM;EA8HN,qBA9HM;ARmtSd;AQnlSI;EACI,oCAAA;EACA,oCAAA;ARqlSR;AQnlSI;EACI,gCAAA;ARqlSR;AQnlSI;EACI,gCAAA;ARqlSR;AQnlSI;EACI,4BA3IM;EA4IN,cA5IM;ARiuSd;AQllSQ;EACI,kCAAA;EACA,cAjJE;ARquSd;AQ/kSQ;EACI,cAvJE;ARwuSd;AQ9kSI;EACI,oCAAA;EACA,yBAAA;ARglSR;AQ/kSQ;EAKI,oCAAA;EACA,oCAAA;AR6kSZ;AQzkSQ;EACI,qBAxKE;ARmvSd;AQzkSQ;EACI,mBA3KE;ARsvSd;AQvkSQ;EACI,yBAhLE;EAiLF,qBAjLE;AR0vSd;AQrkSQ;EACI,cAtLE;AR6vSd;AQnkSQ;EACE,yBA3LI;EA4LJ,qBA5LI;ARiwSd;AQlkSI;EACI,yBAhMM;ARowSd;AQhkSY;EACI,cArMF;ARuwSd;AQ5jSY;EACI,aA5MF;AR0wSd;AQxjSY;EACI,aAnNF;AR6wSd;AQrjSQ;EACI,aAzNE;ARgxSd;AQljSY;EACI,eA/NF;ARmxSd;AQljSY;EACI,aAlOF;ARsxSd;AQ/iSQ;EACI,wBAAA;ARijSZ;AQ7iSQ;EACI,0BAAA;AR+iSZ;AQ7iSQ;EACI,aAhPE;AR+xSd;AQ5iSI;EACI,oCAAA;AR8iSR;AQ5iSI;EACI,cAvPM;ARqySd;AQ1iSY;EACI,mBA5PF;EA6PE,WL5iMR;AHwleR;;AQ/hS4B;EACI,kCAAA;EAAA,uCAAA;ARkiShC;AQ7hSgC;EACI,kCAAA;EAAA,uCAAA;AR+hSpC;AQvhSgC;EACI,mDAAA;EAAA,wDAAA;EACA,oDAAA;EAAA,yDAAA;ARyhSpC;AQthS4B;EACI,kCAAA;EAAA,uCAAA;ARwhShC;AQvhSgC;EACI,kCAAA;EAAA,uCAAA;ARyhSpC;AQ5gSgC;EACI,uCAAA;EAAA,4CAAA;AR8gSpC;AQ5gSgC;EACI,kCAAA;EAAA,uCAAA;AR8gSpC;AQ5gSgC;EACI,kCAAA;EAAA,uCAAA;AR8gSpC;AQtgSwB;EACI,kCAAA;EAAA,uCAAA;ARwgS5B;AQjgSY;EACI,kCAAA;EAAA,uCAAA;ARmgShB;AQt/RyC;EACI,kCAAA;EAAA,uCAAA;ARw/R7C;AQ7+RI;EACI,6CAAA;EAAA,kDAAA;EACA,6CAAA;EAAA,kDAAA;AR++RR;AQ9+RQ;EAKI,6CAAA;EAAA,kDAAA;EACD,6CAAA;EAAA,kDAAA;AR4+RX;AQz+RI;EACI,6CAAA;EAAA,kDAAA;EACA,yCAAA;EAAA,8CAAA;AR2+RR;AQz+RI;EACI,6CAAA;EAAA,kDAAA;AR2+RR;AQ1+RQ;EAGE,kCAAA;EAAA,uCAAA;AR0+RV;AQv+RI;EACI,6CAAA;EAAA,kDAAA;ARy+RR;AQt+RQ;EACI,uCAAA;EAAA,4CAAA;ARw+RZ;AQr+RI;EACI,uCAAA;EAAA,4CAAA;EACA,yCAAA;EAAA,8CAAA;ARu+RR;AQr+RI;EACI,wDAAA;EAAA,6DAAA;EACA,wDAAA;EAAA,6DAAA;ARu+RR;AQr+RI;EACI,oDAAA;EAAA,yDAAA;ARu+RR;AQr+RI;EACI,oDAAA;EAAA,yDAAA;ARu+RR;AQr+RI;EACI,gDAAA;EAAA,qDAAA;EACA,kCAAA;EAAA,uCAAA;ARu+RR;AQp+RQ;EACI,yCAAA;EAAA,8CAAA;EACA,kCAAA;EAAA,uCAAA;ARs+RZ;AQj+RQ;EACI,kCAAA;EAAA,uCAAA;ARm+RZ;AQh+RI;EACI,wDAAA;EAAA,6DAAA;EACA,6CAAA;EAAA,kDAAA;ARk+RR;AQj+RQ;EAKI,wDAAA;EAAA,6DAAA;EACA,wDAAA;EAAA,6DAAA;AR+9RZ;AQ39RQ;EACI,yCAAA;EAAA,8CAAA;AR69RZ;AQ39RQ;EACI,uCAAA;EAAA,4CAAA;AR69RZ;AQz9RQ;EACI,6CAAA;EAAA,kDAAA;EACA,yCAAA;EAAA,8CAAA;AR29RZ;AQv9RQ;EACI,kCAAA;EAAA,uCAAA;ARy9RZ;AQr9RQ;EACE,6CAAA;EAAA,kDAAA;EACA,yCAAA;EAAA,8CAAA;ARu9RV;AQp9RI;EACI,6CAAA;EAAA,kDAAA;ARs9RR;AQl9RY;EACI,kCAAA;EAAA,uCAAA;ARo9RhB;AQ98RY;EACI,iCAAA;EAAA,sCAAA;ARg9RhB;AQ18RY;EACI,iCAAA;EAAA,sCAAA;AR48RhB;AQv8RQ;EACI,iCAAA;EAAA,sCAAA;ARy8RZ;AQp8RY;EACI,mCAAA;EAAA,wCAAA;ARs8RhB;AQp8RY;EACI,iCAAA;EAAA,sCAAA;ARs8RhB;AQj8RQ;EACI,4CAAA;EAAA,iDAAA;ARm8RZ;AQ/7RQ;EACI,8CAAA;EAAA,mDAAA;ARi8RZ;AQ/7RQ;EACI,iCAAA;EAAA,sCAAA;ARi8RZ;AQ97RI;EACI,6CAAA;EAAA,kDAAA;ARg8RR;AQ97RI;EACI,kCAAA;EAAA,uCAAA;ARg8RR;AQ57RY;EACI,uCAAA;EAAA,4CAAA;AR87RhB;;AQx7RI;EACI,cAAA;AR27RR;AQ17RQ;EACI,eAAA;AR47RZ;AQ17RQ;EACI,QAAA;EACA,UAAA;EAAA,aAAA;EACA,eAAA;AR47RZ;AQv7R4B;EACI,WAAA;EACA,UAAA;EAAA,aAAA;ARy7RhC;AQp7RgC;EACI,yBAAA;ARs7RpC;AQr7RoC;EACI,WAAA;EACA,UAAA;EAAA,aAAA;ARu7RxC;AQr7RoC;EACI,WAAA;EACA,UAAA;EAAA,aAAA;ARu7RxC;AQj7RoB;EACI,kBAAA;EACA,cAAA;ARm7RxB;AQh7RgB;EACI,UAAA;EACA,WAAA;EAAA,cAAA;ARk7RpB;AQh7RgB;EACI,iBAAA;EACA,cAAA;ARk7RpB;AI7xeI;EIm0MI;IA4CQ,oBAAA;ERk7Rd;AACF;AQh7RQ;EACI,YAAA;EACA,eAAA;ARk7RZ;AQh7RQ;EACI,mBAAA;EACA,cAAA;ARk7RZ;AI1yeI;EIs3MI;IAIQ,eAAA;ERo7Rd;AACF;AQj7RY;EACI,kBAAA;ARm7RhB;AIz0eI;EIy5MI;IAEQ,QAAA;IACA,OAAA;ERk7Rd;AACF;AQh7RgB;EACI,0CAAA;EACA,uCAAA;EACA,0CAAA;EACA,yBAAA;EACA,wCAAA;ARk7RpB;AQh7RgB;EACI,eAAA;EACA,6BAAA;EACA,8BAAA;ARk7RpB;AQj7RoB;EACI,kBAAA;EACA,gBAAA;ARm7RxB;AIx0eI;EIy5MQ;IAEQ,QAAA;IACA,UAAA;IAAA,aAAA;ERi7RlB;AACF;AQ/6RY;EACI,OAAA;EACA,WAAA;EACA,gBAAA;ARi7RhB;AQ96RQ;EACI,QAAA;EACA,UAAA;EAAA,aAAA;ARg7RZ;AQ76RY;EACI,OAAA;AR+6RhB;AQ56RgB;EACI,OAAA;AR86RpB;AQ16RQ;EACI,eAAA;EACA,mBAAA;AR46RZ;AQ16RQ;EACI,OAAA;EACA,WAAA;EAAA,cAAA;AR46RZ;AQ16RQ;EACI,iBAAA;EACA,eAAA;AR46RZ;AQ16RQ;EACI,kBAAA;EACA,oBAAA;AR46RZ;AQ16RQ;EACI,kBAAA;EACA,cAAA;AR46RZ;AQ16RQ;EACI,0BAAA;EACA,iBAAA;AR46RZ;AQx6RgB;EACI,iBAAA;EACA,eAAA;AR06RpB;AQz6RoB;EACI,cAAA;AR26RxB;AQt6RQ;EACI,kBAAA;EACA,cAAA;ARw6RZ;AQr6RY;EACI,kBAAA;ARu6RhB;;AQj6RI;EACI,UAAA;ARo6RR;;AQh6RI;EACG,UAAA;EACA,wBAAA;ARm6RP;;AQ55RI;EACI,yBLzsMS;AHwmejB;AQ75RI;EACI,mBL9sMS;AH6mejB;AQ75RI;EACI,mBL/sMS;EKgtMT,qBLtsMY;AHqmepB;AQ75RY;EACI,cAAA;AR+5RhB;AQ15RgB;EACI,cLltMA;AH8mepB;AQ35RoB;EACI,yBLzrMI;EK0rMJ,qBL1rMI;EK2rMJ,cL1tMJ;AHunepB;AQz5RoB;EACI,qBLvtMJ;AHknepB;AQr5RY;EACI,gCAAA;ARu5RhB;AQl5RI;EACI,mBL/uMS;EKgvMT,qBLtuMY;AH0nepB;AQn5RQ;EACI,mBLnjNF;AHw8eV;AQl5RI;EACI,mBLtvMS;EKuvMT,qBL7uMY;AHioepB;AQl5RY;EACI,aAAA;ARo5RhB;AQl5RY;EACI,cAAA;ARo5RhB;AQ54R4B;EACI,cLnwMZ;AHipepB;AQv4RgC;EACI,mBL5uMR;AHqne5B;AQx4RoC;EACI,cL7wMpB;AHupepB;AQp4RoC;EACI,mBLrvMZ;AH2ne5B;AQr4RwC;EACI,cLtxMxB;AH6pepB;AQp4R4C;EACI,qBL1xM5B;AHgqepB;AQ73RwB;EACI,WLrkNpB;AHo8eR;AQ33RwB;EACI,cLtyMR;AHmqepB;AQx3R4B;EACI,cL/yMZ;AHyqepB;AQz3RgC;EACI,cL7yMhB;AHwqepB;AQz3RgC;EACI,cLpzMhB;AH+qepB;AQz3RgC;EACI,cL3nN1B;AHs/eV;AQt3R4B;EACI,mBL9xMJ;EK+xMI,WL/lNxB;AHu9eR;AQt3RoC;EACI,+BAAA;EACA,gCAAA;ARw3RxC;AQr3RgC;EACI,mBLhzML;EKizMK,cL3oN1B;AHkgfV;AQt3RoC;EACI,cL50MvB;EK60MuB,mBL70MvB;AHqsejB;AQt3RoC;EACI,cLjpN9B;AHygfV;AQ/2R4B;EACI,mBL/0MZ;AHgsepB;AQ32RoB;EACI,cLz1MJ;AHssepB;AQx2RgC;EACI,cLh2MhB;AH0sepB;AQz2RoC;EACI,mBL1qN9B;AHqhfV;AQz2RoC;EACI,cL7qN9B;AHwhfV;AQz2RoC;EACI,cLhrN9B;AH2hfV;AQp2R4B;EACI,mBLr1MJ;AH2re5B;AQr2RgC;EACI,cLt3MhB;AH6tepB;AQp2R4B;EACI,mBL31MJ;AHise5B;AQr2RgC;EACI,cL53MhB;AHmuepB;AQh2R4B;EACI,uBAAA;EACA,cLzsNtB;AH2ifV;AQ11RgB;EACI,+BAAA;EACA,gCAAA;AR41RpB;AQx1RQ;EACI,cLl5MQ;AH4uepB;AQx1RQ;EACI,yBAAA;EACA,cLp5MQ;AH8uepB;AQz1RY;EACI,yBL33MY;EK43MZ,qBL53MY;EK63MZ,cL55MI;AHuvepB;AQv1RY;EACI,gCAAA;ARy1RhB;AQl1RgB;EACI,aAAA;ARo1RpB;AQ70RoB;EACI,cAAA;AR+0RxB;AQ70RoB;EACI,aAAA;AR+0RxB;AQz0RI;EACI,yBL97MS;EK+7MT,qBLr7MY;AHgwepB;AQz0RI;EACI,yBLl8MS;EKm8MT,qBLz7MY;EK07MZ,cLj8MY;AH4wepB;AQx0RQ;EACI,+BAAA;EACA,yBLt6MiB;AHgve7B;AQx0RQ;EACI,6BAAA;AR00RZ;AQz0RY;EACI,yBAAA;EACA,cL58MI;AHuxepB;AQ10RgB;EACI,mBLn9MH;EKo9MG,cL/8MA;AH2xepB;AQ10RgB;EACI,cLl9MA;AH8xepB;AQz0RY;EACI,mBLz9MC;EK09MD,+BAAA;AR20RhB;AQ10RgB;EACI,kBAAA;AR40RpB;AQ10RgB;EACI,mBL/9MH;AH2yejB;AQx0RwB;EACI,cL79MR;AHuyepB;AQz0R4B;EACI,mBLp8MJ;AH+we5B;AQ10RgC;EACI,cLn+MhB;AH+yepB;AQz0R4B;EACI,mBL18MJ;AHqxe5B;AQ10RgC;EACI,cLz+MhB;AHqzepB;AQv0R4B;EACI,mBLl9MJ;AH2xe5B;AQp0RgC;EACI,mBLx9MR;EKy9MQ,yBAAA;ARs0RpC;AQh0RwC;EACI,cLn0NlC;AHqofV;AQtzRgC;EACI,mBL7+MR;AHqye5B;AQxyR4B;EACI,cL7hNZ;AHu0epB;AQzyRgC;EACI,yBLhgNR;AH2ye5B;AQtyRoC;EACI,cLjiNpB;AHy0epB;AQvyRwC;EACI,yBLxgNhB;AHize5B;AQtyR4C;EACI,qBLviN5B;AH+0epB;AQhyRoB;EACI,yBLvjNP;AHy1ejB;AQzxRgC;EACI,yBL/hNR;AH0ze5B;AQ/wRgB;EACI,cAAA;ARixRpB;AQ3wRQ;EACI,+BAAA;EACA,yBLtlNK;AHm2ejB;AQ3wRQ;EACI,6BAAA;AR6wRZ;AQ5wRY;EACI,cLtlNI;AHo2epB;AQ7wRgB;EACI,mBL/lNH;EKgmNG,cLzlNA;AHw2epB;AQ7wRgB;EACI,mBL95NV;AH6qfV;AQ5wRY;EACI,mBLrmNC;EKsmND,+BAAA;AR8wRhB;AQ5wRoB;EACI,cAAA;AR8wRxB;AQ5wRoB;EACI,aAAA;AR8wRxB;AQzwRwB;EACI,cL1mNR;AHq3epB;AQzwRwB;EACI,cL9mNR;AHy3epB;AQ1wR4B;EACI,mBLrlNJ;AHi2e5B;AQ3wRgC;EACI,cLpnNhB;AHi4epB;AQ3wRgC;EACI,yBAAA;AR6wRpC;AQ1wR4B;EACI,mBL9lNJ;AH02e5B;AQ3wRgC;EACI,cL7nNhB;AH04epB;AQxwR4B;EACI,mBLtmNJ;AHg3e5B;AQrwRgC;EACI,mBL5mNR;EK6mNQ,yBAAA;ARuwRpC;AQjwRwC;EACI,cLv9NlC;AH0tfV;AQvvRgC;EACI,mBLjoNR;AH03e5B;AQjvRoB;EACI,gBAAA;ARmvRxB;AQ7uRI;EACI,mBLrrNS;AHo6ejB;AQ7uRI;EACI,cLnrNY;AHk6epB;AQ7uRI;EACI,oCAAA;EACA,gCAAA;AR+uRR;AQ7uRI;EACI,cL1rNY;AHy6epB;AQ7uRI;EACI,yBL9pNoB;EK+pNpB,cL1rNY;AHy6epB;AQ3uRY;;EAEI,gCAAA;AR6uRhB;AQzuRI;EACI,yBL5sNS;EK6sNT,yBAAA;AR2uRR;AQ1uRQ;EACI,cL5sNQ;AHw7epB;AQ1uRQ;EACI,qBLxsNQ;AHo7epB;AQ1uRQ;EACI,qBL3sNQ;AHu7epB;AQzuRI;EACI,yBL3tNS;EK4tNT,cLntNY;EKotNZ,qBL7tNS;AHw8ejB;AQ1uRQ;EACE,cLttNU;AHk8epB;AQ1uRQ;EACE,cLztNU;AHq8epB;AQzuRI;EACI,yBLpuNS;AH+8ejB;AQxuRQ;EACI,yBLxuNK;EKyuNL,qBL/tNQ;AHy8epB;AQruRQ;EACI,OAAA;EACA,yBLhvNK;EKivNL,yCAAA;ARuuRZ;AQpuRoB;EACI,cL9uNJ;AHo9epB;AQruRwB;EACI,mBLrtNA;EKstNA,cLjvNR;AHw9epB;AQluRY;EACI,cAAA;ARouRhB;AQnuRgB;EACI,aAAA;ARquRpB;AQnuRgB;EACI,cAAA;ARquRpB;AQjuRQ;EACI,cLjwNQ;AHo+epB;AQhuRY;EACI,yBL5wNC;EK6wND,oDAAA;ARkuRhB;AQ7tRgC;EACI,cLhxNhB;AH++epB;AQ9tRoC;EACI,yBLnvNZ;EKovNY,cLnxNpB;AHm/epB;AQ9tR4C;EACI,qBLtxN5B;AHs/epB;AQ3tRwC;EACI,qBL5xNxB;AHy/epB;AQttR4B;EACI,qBLpyNZ;AH4/epB;AQhtRY;EACI,WAAA;EACA,mBLjzNC;AHmgfjB;AQ7sRQ;EACI,mBLvzNK;AHsgfjB;AQ5sRI;EACI,yBL3zNS;EK4zNT,cLrzNY;AHmgfpB;AQ3sRQ;EACI,gBAAA;EACA,yBLj0NK;EKk0NL,cL3zNQ;AHwgfpB;AQ1sRI;EACI,cLh4NK;AH4kfb;AQ1sRI;EACI,cLl0NY;EKm0NZ,yBL10NS;EK20NT,qBL7zNa;AHygfrB;AQxsRY;EACI,yBLh1NC;EKi1ND,cL10NI;AHohfpB;AQzsRgB;EACI,yBLn1NH;EKo1NG,cL70NA;AHwhfpB;AQrsRY;EACI,cL31NC;AHkifjB;AQtsRgB;EACI,yBL71NH;EK81NG,cLv1NA;AH+hfpB;AQvsRoB;EACI,yBLh2NP;EKi2NO,cL11NJ;AHmifpB;AQlsRY;EACI,yBLz2NC;AH6ifjB;AQnsRgB;EACI,yBL32NH;AHgjfjB;AQhsRI;;EAEI,yBLl3NS;AHojfjB;AQhsRI;EACI,oCAAA;EACA,yBAAA;ARksRR;AQhsRI;EACI,yBL33NS;AH6jfjB;AQhsRI;EACI,gCAAA;ARksRR;AQjsRQ;EACI,oCAAA;ARmsRZ;AQjsRQ;EACI,oCAAA;ARmsRZ;AQjsRQ;EACI,oCAAA;ARmsRZ;AQjsRQ;EACI,oCAAA;ARmsRZ;AQjsRQ;EACI,oCAAA;ARmsRZ;AQjsRQ;EACI,oCAAA;ARmsRZ;AQjsRQ;EACI,oCAAA;ARmsRZ;AQjsRQ;EACI,oCAAA;ARmsRZ;AQhsRI;EACI,wCAAA;ARksRR;AQhsRI;EACI,+CAAA;ARksRR;AQhsRI;EACI,2CAAA;ARksRR;AQhsRI;EACI,iDAAA;ARksRR;AQhsRI;EACI,yBLn6NS;EKo6NT,gCAAA;ARksRR;AQhsRI;EACI,yBLv6NS;AHymfjB;AQhsRI;EACI,gCAAA;ARksRR;AQhsRI;EACI,yBL76NS;AH+mfjB;AQhsRI;EACI,yBLl6Na;AHomfrB;AQhsRI;EACI,yBLn7NS;EKo7NT,yBAAA;EACA,gBAAA;ARksRR;AQjsRQ;EACE,yBLv7NO;EKw7NP,mCAAA;ARmsRV;AQjsRQ;EACE,cLp7NU;AHunfpB;AQhsRM;;;;EAIE,yBLp8NS;AHsofjB;AQhsRM;;;;EAIE,2BL18NS;AH4ofjB;AQhsRM;;;;EAIE,0BLh9NS;AHkpfjB;AQhsRM;;;;;;EAME,4BLx9NS;AH0pfjB;AQhsRI;EACI,cLl9NY;EKm9NZ,yBL19NS;EK29NT,yBAAA;ARksRR;AQjsRQ;EACI,yBL/9NK;AHkqfjB;AQjsRQ;EACI,yBLl+NK;EKm+NL,qBA3xBO;AR89SnB;AQhsRI;EACI,yBLv+NS;AHyqfjB;AQhsRI;EACI,yBL1+NS;AH4qfjB;AQhsRI;EACI,yBL7+NS;AH+qfjB;AQhsRI;EACI,yBL9+NS;EK++NT,cLx+NY;AH0qfpB;AQhsRI;EACI,yBLl/NS;EKm/NT,qBLz+NY;AH2qfpB;AQjsRQ;EACI,qBL3+NQ;AH8qfpB;AQjsRQ;EACI,qBL9+NQ;AHirfpB;AQhsRI;EACI,cLr/NY;AHurfpB;AQhsRI;EACI,yBAAA;ARksRR;AQhsRI;EACI,cL//NY;AHisfpB;AQhsRI;EACI,yBLrgOS;EKsgOT,cLngOY;AHqsfpB;AQhsRI;EACI,qBL//NY;AHisfpB;AQhsRI;EACI,yBL5gOS;AH8sfjB;AQhsRI;EACI,yBLjhOS;AHmtfjB;AQhsRI;EACI,yBLphOS;EKqhOT,qBLzgOY;AH2sfpB;AQjsRQ;EACI,yBLt1OF;AHyhgBV;AQ9rRY;EACI,yBL7hOC;EK8hOD,cLrhOI;AHqtfpB;AQzrRgB;EACI,yBLr2OV;AHgigBV;AQnrRgB;EACI,yBL7iOH;EK8iOG,qBLpiOA;AHytfpB;AQnrRgB;EACI,yBLnjOH;AHwufjB;AQlrRoB;EACI,yBLt3Od;AH0igBV;AQlrRsB;EACE,qBLz3Od;EK03Oc,cL13Od;AH8igBV;AQ9qRI;EACI,yBLhkOS;AHgvfjB;AQ9qRI;EACI,oCAAA;ARgrRR;AQ9qRI;EACI,cLtkOS;AHsvfjB;AQ7qRQ;EACI,yBL5jOS;EK6jOT,yBAAA;EACA,cLrkOQ;AHovfpB;AQ9qRY;EAKI,0CAAA;EACA,yBAAA;EACA,cL7kOI;AHyvfpB;AQxqRI;EACI,qBL/kOY;AHyvfpB;AQvqRQ;EACI,yBLnlOQ;AH4vfpB;AQtqRY;EACI,qBLvlOI;AH+vfpB;AQvqRgB;EACI,qBLzlOA;AHkwfpB;AQpqRI;EACI,yBL3mOS;AHixfjB;AQnqRQ;EACI,qBLnmOQ;EKomOR,gBAAA;ARqqRZ;AQlqRI;EACI,oCAAA;EACA,yBAAA;ARoqRR;AQnqRQ;EAKI,oCAAA;EACA,oCAAA;EACA,yBAAA;ARiqRZ;AQ9pRI;EACI,oCAAA;EACA,gCAAA;EACA,cLjoOS;AHiyfjB;AQ7pRQ;EACI,yBL3nOQ;AH0xfpB;AQ5pRI;EACI,yBLzoOS;EK0oOT,qBLhoOY;AH8xfpB;AQ5pRI;;EAEI,yBL9oOS;AH4yfjB;AQ5pRI;EACI,yBAAA;AR8pRR;AQ5pRI;EACI,yBAAA;AR8pRR;AQ1pRY;EACI,qBL/oOI;AH2yfpB;AQ3pRoB;EACI,qBLjpOJ;EKkpOI,yBLlpOJ;EKmpOI,cL1pOJ;AHuzfpB;AQxpRY;EACI,qBLzpOI;AHmzfpB;AQzpRgB;EACI,qBL3pOA;EK4pOI,yBL5pOJ;EK6pOI,cLpqOJ;AH+zfpB;AQzpRgB;EACI,yBL1qOH;EK2qOG,cLpqOA;EKqqOA,qBLlqOA;AH6zfpB;AQvpRQ;EACI,yBLl/OF;AH2ogBV;AQvpRQ;EACI,yBLn/OA;AH4ogBZ;AQvpRQ;EACI,yBLl/OL;AH2ogBP;AQvpRQ;EACI,yBLn/OF;AH4ogBV;AQvpRQ;EACI,yBLp/OH;AH6ogBT;AQvpRQ;EACI,yBL7/OF;AHspgBV;AQvpRQ;EACI,yBLpsOI;AH61fhB;AQvpRQ;EACI,yBLrrOS;AH80frB;AQppRY;EACI,qBLlsOI;AHw1fpB;AQrpRgB;EACI,cLvsOA;EKwsOA,qBLrsOA;AH41fpB;AQnpRQ;EACI,qBL1sOQ;AH+1fpB;AQppRgB;EACI,cLntOA;AHy2fpB;AQjpRQ;EACI,cLvtOQ;AH02fpB;AQlpRY;EACI,yBAAA;EACA,cL5tOI;AHg3fpB;AQhpRI;EACI,cLjuOY;AHm3fpB;AQhpRI;EACI,cLpuOY;AHs3fpB;AQhpRI;EACI,yBL1uOS;EK2uOT,cLxuOY;EKyuOZ,qBLluOY;AHo3fpB;AQjpRQ;EACI,yBL9uOK;AHi4fjB;AQ/oRQ;EACI,qBLzuOQ;EK0uOR,mBLpvOK;AHq4fjB;AQhpRY;EACI,yBAAA;ARkpRhB;AQ/oRgB;EACI,qBLvvOA;AHw4fpB;AQ7oRQ;EACI,cL/vOK;AH84fjB;AQ3oRQ;EACI,8BAAA;EACA,qBL3vOQ;AHw4fpB;AQ1oRI;;;;;;;EAOI,qBLrwOY;EKswOZ,cLzwOY;AHq5fpB;AQ1oRI;EACI,qBLzwOY;EK0wOZ,mBLpxOS;AHg6fjB;AQ1oRI;;;EAGI,cLzxOS;AHq6fjB;AQ1oRI;;;;EAII,yBL/xOS;AH26fjB;AQ1oRI;EACI,yBLlyOS;AH86fjB;AQzoRQ;EACI,yBL3xOQ;EK4xOR,qBL5xOQ;AHu6fpB;AQxoRI;EACI,yBL3yOS;EK4yOT,qBLlyOY;EKmyOZ,cL1yOY;AHo7fpB;AQzoRQ;EACI,cL5yOQ;AHu7fpB;AQzoRgB;EAGE,cLjzOE;EKkzOF,yBLnyOG;AH46frB;AQtoRc;EACE,yBLvyOK;AH+6frB;AQpoRI;EACI,qBLpzOY;AH07fpB;AQ7nRY;EACI,kCAAA;AR+nRhB;AQxnRgB;EACI,qBLjpPV;AH2wgBV;AQznRoB;EACI,qBLnpPd;AH8wgBV;AQtnRQ;EACI,qBL90OQ;EK+0OR,cLl1OQ;AH08fpB;AQvnRY;EACI,qBLj1OI;EKk1OJ,mBL51OC;AHq9fjB;AQvnRY;EACI,mBLhqPN;AHyxgBV;AQlnRgB;EACI,gCAAA;ARonRpB;AQnnRoB;EACI,cL1qPd;AH+xgBV;AQlnRwB;EACI,cL72OX;AHi+fjB;AQ9mRQ;EACI,qBL12OQ;AH09fpB;AQzmRoB;EACI,cL7rPd;EK8rPc,gBL3pPhB;EK4pPgB,qBLp3OJ;AH+9fpB;AQrmRY;EACI,qBL33OI;AHk+fpB;AQhmRgB;EACI,sBL9sPV;AHgzgBV;AQjmRoB;EACI,cLhtPd;EKitPc,gBL9qPhB;EK+qPgB,qBLv4OJ;AH0+fpB;AQhmRwB;EACI,cLr5OX;AHu/fjB;AQ5lRQ;EACI,sBLl5OQ;AHg/fpB;AQ7lRY;EACI,mBL95OC;EK+5OD,qBLr5OI;AHo/fpB;AQ5lRQ;EACI,sBLz5OQ;AHu/fpB;AQ1lRQ;EACI,qBL95OQ;AH0/fpB;AQ1lRgB;EACI,mBL5uPV;AHw0gBV;AQxlRgB;EACI,mBLx9ON;AHkjgBd;AQtlRgB;EACI,mBL59OP;AHojgBb;AQplRgB;EACI,mBLh+OT;AHsjgBX;AQllRgB;EACI,mBLp+OV;AHwjgBV;AQhlRgB;EACI,mBLx+OL;AH0jgBf;AQ9kRgB;EACI,mBL5+OV;AH4jgBV;AQzkRoB;EACI,cLj9OP;AH4hgBjB;AQlkRgB;EACI,qBL5xPV;AHg2gBV;AQnkRoB;EACI,cLtxPd;EKuxPc,yBLxwPF;AH60gBtB;AQhkRQ;EACI,qBL19OQ;EK29OR,cLh+OQ;AHkigBpB;AQjkRY;EACI,yBLr8OY;EKs8OZ,cLz+OA;AH4igBhB;AQhkRQ;EACI,qBLl+OQ;AHoigBpB;AQ7jRY;EACI,yBAAA;AR+jRhB;AQxjRwB;EACI,qBL3zPlB;AHq3gBV;AQljRgB;EACI,qBLz/OA;AH6igBpB;AQjjRY;EACI,cLpgPI;AHujgBpB;AQ9iRQ;EACI,yBL7gPK;EK8gPL,mCAAA;ARgjRZ;AQ9iRgB;EACI,yBLjhPH;AHikgBjB;AQ3iRoB;EACI,cLhhPJ;AH6jgBpB;AQ5iRwB;EACI,yBLzhPX;EK0hPW,yBAAA;AR8iR5B;AQxiRgB;EACI,aAAA;AR0iRpB;AQxiRgB;EACI,cAAA;AR0iRpB;AQriRY;EACI,mBL1iPC;AHilgBjB;AQ5hRgB;EACI,yBLtjPH;AHolgBjB;AQzhRoB;EACI,cLrjPJ;AHglgBpB;AQ1hRwB;EACI,yBL9jPX;EK+jPW,yBAAA;AR4hR5B;AQrhRI;EACI,qBAj4CW;ARw5TnB;AQrhRI;EACI,yBL1kPS;EK2kPT,qBAr4CW;AR45TnB;AQrhRI;EACI,yBLhlPS;EKilPT,qBAz4CW;EA04CX,cL7kPY;AHomgBpB;AQrhRI;EACI,yBLnlPS;EKolPT,qBA94CW;EA+4CX,cLllPY;AHymgBpB;AQrhRI;EACI,qBAl5CW;ARy6TnB;AQrhRI;EACI,cLxlPY;AH+mgBpB;AQphRQ;EACI,yBL/lPK;AHqngBjB;AQlhRQ;EACI,yBAAA;ARohRZ;AQjhRI;EACI,8BAAA;ARmhRR;AQjhRI;EACI,qBAr6CW;ARw7TnB;AQjhRY;EACI,yBL9mPC;AHiogBjB;AQ9gRQ;EACI,cLpnPK;AHoogBjB;AQ/gRY;EACI,cLv7PN;AHw8gBV;AQ3gRY;EACI,cL1nPI;AHuogBpB;AQ5gRgB;EACI,cL5nPA;AH0ogBpB;AQvgRY;EACI,cLpoPI;AH6ogBpB;AQrgRI;EACI,cLzoPY;EK0oPZ,mBL/oPS;EKgpPT,eAx8CW;AR+8TnB;;AQjgRI;EACI,cLjpPY;AHqpgBpB;AQlgRI;EACI,cLppPY;AHwpgBpB;AQlgRI;EACI,qBLjpPY;EKkpPZ,cLxpPY;AH4pgBpB;AQlgRI;EACI,mBL/pPS;AHmqgBjB;AQlgRI;EACI,mBLlqPS;EKmqPT,qBLzpPY;EK0pPZ,cLhqPY;AHoqgBpB;AQlgRI;EACI,cLnqPY;AHuqgBpB;AQlgRI;EACI,8BAAA;ARogRR;AQlgRI;EACI,yBAAA;ARogRR;AQlgRI;EACI,mBLhrPS;EKirPT,gCAAA;ARogRR;AQlgRI;EACI,mBL1qPY;AH8qgBpB;AQlgRI;EACI,mBLvrPS;EKwrPT,qBL9qPY;AHkrgBpB;AQlgRI;EACI,mBL3rPS;EK4rPT,qBLlrPY;AHsrgBpB;AQlgRI;EACI,qBLrrPY;AHyrgBpB;AQlgRI;EACI,mBLlsPS;EKmsPT,qBLzrPY;AH6rgBpB;AQlgRI;EACI,mBL5rPY;AHgsgBpB;AQlgRI;EACI,mBL/rPY;AHmsgBpB;AQlgRI;EACI,mBLlsPY;AHssgBpB;AQjgRQ;EACI,mBLhtPK;EKitPL,qBLvsPQ;AH0sgBpB;AQjgRQ;EACI,cLhtPQ;AHmtgBpB;AQjgRQ;EACI,mBLvtPK;EKwtPL,qBL9sPQ;AHitgBpB;AQjgRQ;EACI,qBLjtPQ;AHotgBpB;;AQ1/QI;EACI,aAAA;AR6/QR;AQ3/QI;EACI,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AR6/QR;AIhhhBI;EI+gQA;IAMQ,iBAAA;ER+/QV;AACF;AIrhhBI;EI+gQA;IASQ,gBAAA;ERigRV;AACF;AI1hhBI;EI+gQA;IAYQ,eAAA;ERmgRV;AACF;AQlgRQ;EACI,eAAA;EACA,gBAAA;ARogRZ;AInihBI;EI6hQI;IAIQ,aAAA;ERsgRd;AACF;AI/jhBI;EI4jQA;IAEQ,aAAA;ERqgRV;AACF;AQlgRI;EACI,OAAA;ARogRR;AQngRQ;EACI,cAAA;ARqgRZ;AQpgRY;EACI,gBAAA;ARsgRhB;AQngRQ;EACI,cAAA;ARqgRZ;AQpgRY;EACI,cAAA;ARsgRhB;AQpgRY;EACI,aAAA;ARsgRhB;;AQhgRA;EACI,cAAA;EACA,8DLxsPY;AH2sgBhB;AQlgRI;EACI,sBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;ARogRR;AQngRQ;EACI,aAAA;ARqgRZ;AQngRQ;EACI,gCAAA;ARqgRZ;AQngRQ;EACI,MAAA;EACA,uBAAA;EACA,4BAAA;EACA,UAAA;ARqgRZ;AQngRQ;EACI,uBAAA;EACA,4BAAA;ARqgRZ;AQngRQ;EACI,wBAAA;ARqgRZ;AQngRQ;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;ARqgRZ;AQngRgB;EACI,iBAAA;ARqgRpB;AQpgRoB;EACI,eAAA;ARsgRxB;AQngRwB;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;ARqgR5B;AQhgRY;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;ARkgRhB;AQjgRgB;EACI,kBAAA;ARmgRpB;AQjgRwB;EACI,eLxvPb;EKyvPa,cL1+PjB;EC9DT,kBIyiQ2C;EACjB,yBAAA;ARmgR5B;AQlgR4B;EACI,iBAAA;ARogRhC;AQlgR4B;EACI,yBL9nQb;AHkohBnB;AQhgR4B;EACI,aAAA;ARkgRhC;AQ5/QoC;EACI,eL5wPzB;AH0wgBf;AQ3/QgC;EACI,cLngQzB;EC5DT,kBIgkQmD;AR6/QrD;AQ5/QoC;EACI,yBLjpQrB;AH+ohBnB;AQx/Q4B;EACI,gBAAA;AR0/QhC;AQr/QgB;EACI,aAAA;EACA,YAAA;EACA,sBLzpQZ;EK0pQY,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;ARu/QpB;AQp/Q4B;EACI,WAAA;ARs/QhC;AQl/QoB;EACI,iBAAA;ARo/QxB;AQh/QY;EACI,wBAAA;ARk/QhB;AQ/+QQ;EACI,wBAAA;ARi/QZ;AQ/+QQ;EACI,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eL9zPG;EK+zPH,gBLnuQS;EKouQT,cAAA;EACA,kBAAA;ARi/QZ;AQ/+QQ;EACI,gCAAA;ARi/QZ;AQ3+QwB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;AR6+Q5B;AQv+QQ;EACI,gCAAA;EACA,WAAA;ARy+QZ;AQt+QI;EACI,iBAAA;ARw+QR;AInshBI;EI0tQA;IAGQ,iBAAA;ER0+QV;AACF;AIxshBI;EI0tQA;IAMQ,gBAAA;ER4+QV;AACF;AQ3+QQ;EACI,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AR6+QZ;AQv+QwB;EACI,yBL1uQT;AHmthBnB;AI7uhBI;EIkwQgB;IAKQ,eL72Pb;IK82Pa,yBAAA;ER0+Q1B;EQz+Q0B;IACI,iBAAA;ER2+Q9B;EQz+Q0B;IACI,UAAA;ER2+Q9B;AACF;AIluhBI;EIkkQA;IA6LI,wBAAA;ERu+QN;AACF;;AQp+QA;;EAEI,aAAA;ARu+QJ;;AQp+QI;EACI,gCAAA;ARu+QR;AQr+QI;EACI,qBLxxQM;EKyxQN,cLvxQS;AH8vhBjB;AQr+QI;EACI,mBL7xQD;EK8xQC,qBL7xQM;AHowhBd;AQr+QI;EACI,8BAAA;ARu+QR;AQr+QI;EACI,mBL9xQK;AHqwhBb;AQr+QI;EACI,mBLjyQK;AHwwhBb;AQr+QI;EACI,mBL1yQD;AHixhBP;AQr+QI;EACI,uBAAA;ARu+QR;AQr+QI;EACI,gCAAA;ARu+QR;AQr+QI;EACI,gCAAA;ARu+QR;AQr+QI;EACI,gCAAA;ARu+QR;AQr+QI;EACI,gCAAA;ARu+QR;AQr+QI;EACI,gCAAA;EACA,WLtyQA;AH6whBR;AQp+QQ;EACI,WL1yQJ;AHgxhBR;;AQj+QI;EACI,yBLv0QD;EKw0QC,cLt0QI;AH0yhBZ;AQl+QI;EACI,WLpzQA;AHwxhBR;AQl+QI;EACI,yBL90QD;AHkzhBP;AQn+QQ;EACI,yBLh1QL;AHqzhBP;AQn+QgB;EACI,aAAA;ARq+QpB;AQp+QoB;EACI,cAAA;ARs+QxB;AQl+QY;EACI,WLn0QR;AHuyhBR;AQj+QQ;EACI,yBL91QL;EK+1QK,gBAAA;ARm+QZ;AQl+QY;EACI,WL10QR;AH8yhBR;AQl+QY;EACI,qBLn2QF;AHu0hBd;AQn+QgB;EACI,WL/0QZ;AHozhBR;AQh+QQ;EACI,qBL32QE;AH60hBd;AQ99QgB;EACI,gCAAA;ARg+QpB;AQ/9QoB;EACI,WL51QhB;AH6zhBR;AQ/9QoB;EACI,WL/1QhB;AHg0hBR;AQ/9QoB;EACI,WLl2QhB;AHm0hBR;AQ79Q4B;EACI,yBAAA;AR+9QhC;AQ39Q4B;EACI,WL52QxB;AHy0hBR;AQ39Q4B;EACI,cLn4Qf;AHg2hBjB;AQz9QoB;EACI,eL7/PT;EK8/PS,iBAAA;EACA,cLnvQb;AH8shBX;AQt9QY;EACI,mBLn5QT;AH22hBP;AQp9QY;EACI,qBLv5QF;EKw5QE,uBAAA;ARs9QhB;AQp9QY;EACI,cLz5QC;AH+2hBjB;AQh9QoB;EACI,uBAAA;EACA,kBLtiQL;AHw/gBnB;AQj9QwB;EACI,uBAAA;ARm9Q5B;AQh9Q4B;EACI,WLn5QxB;AHq2hBR;AQ/8QgC;EACI,WLv5Q5B;EKw5Q4B,gBAAA;ARi9QpC;AQ/8QgC;EACI,gBLz8Qf;EK08Qe,cLh7QnB;AHi4hBjB;AQx8QI;EACI,yBL77QD;AHu4hBP;AQv8QgB;EACI,yBAAA;ARy8QpB;AQx8QoB;EACI,WL56QhB;AHs3hBR;AQl8Q4B;EACI,cL18QpB;AH84hBZ;AQ77Qe;EACK,gCAAA;AR+7QpB;AQ17QI;EACI,mBAAA;EACA,WLp8QA;AHg4hBR;AQ17QI;EACI,mBAAA;EACA,qBAAA;EACA,WLz8QA;AHq4hBR;AQ17QI;EACI,WL58QA;AHw4hBR;AQ17QI;EACI,mBLt+QD;AHk6hBP;AQ37QQ;EACI,qBLv+QE;AHo6hBd;AQ57QY;EACI,WLn9QR;AHi5hBR;AQ37QQ;EACI,mBLv+QF;EKw+QE,qBL9+QE;AH26hBd;AQ57QY;EACI,qBLh/QF;AH86hBd;AQ77QgB;EACI,WL59QZ;AH25hBR;AQ37QQ;EACI,qBLv/QE;EKw/QF,mBLz/QL;AHs7hBP;AQ57QY;EACI,qBL1/QF;AHw7hBd;AQ17QI;;;EAGI,cLhgRI;AH47hBZ;AQz7QQ;EACI,uBAAA;AR27QZ;AQv7QQ;EACI,cLzgRA;AHk8hBZ;AQt7QI;;;EAGI,qBLhhRM;EKihRN,gBAAA;EACA,yBAAA;EACA,cLlhRI;AH08hBZ;AQv7QQ;;;EACI,cLphRA;AH+8hBZ;AQv7QQ;EACI,qBL1hRE;EK2hRF,yBAAA;EACA,cL3hRA;EK4hRA,gBAAA;ARy7QZ;AQn7QgB;EACI,cLniRR;AHw9hBZ;AQ/6QQ;EACI,qBL3iRE;AH49hBd;AQ76QQ;EACI,qBLhjRE;EKijRF,yBAAA;EACA,cLjjRA;EKkjRA,gBAAA;AR+6QZ;AQ56QI;;EAEI,cLvjRI;AHq+hBZ;AQ36QQ;EACI,qBL5jRE;EK6jRF,yBAAA;EACA,cL7jRA;AH0+hBZ;AQ16QI;;EAEI,qBLnkRM;EKokRN,gBAAA;EACA,yBAAA;EACA,cLrkRI;AHi/hBZ;AQ16QI;EACI,qBLzkRM;AHq/hBd;AQ16QI;EACI,yBAAA;AR46QR;AQ16QI;EACI,qBL/kRM;EKglRN,mBLjlRD;EKklRC,gBAAA;EACA,cLjlRI;AH6/hBZ;AQz6QQ;EACI,kBLhkRJ;EKikRI,WLjkRJ;AH4+hBR;AQx6QI;EACI,yBAAA;AR06QR;AQv6QQ;EACI,qBL/lRE;EKgmRF,mBLjmRL;EKkmRK,gBAAA;ARy6QZ;AQx6QY;EACI,gBAAA;EACA,yBAAA;EACA,mBLtmRT;EKumRS,cLrmRJ;AH+giBZ;AQx6QY;EACI,gBAAA;AR06QhB;AQt6QI;;;EAGI,qBLhnRM;EKinRN,mBLlnRD;AH0hiBP;AQr6QQ;EACI,cLpnRA;AH2hiBZ;AQt6QY;EACI,cLtnRJ;AH8hiBZ;AQr6QQ;EACI,qBL3nRE;AHkiiBd;AQp6QI;EACI,mBLhoRD;EKioRC,qBLhoRM;AHsiiBd;AQp6QI;;;;;;;;;EAUI,qBL5oRM;EK6oRN,mBL9oRD;EK+oRC,gBAAA;ARq6QR;AQn6QI;EACI,yBL3oRE;EK4oRF,gBAAA;ARq6QR;AQl6QQ;EACI,qBLtpRE;EKupRF,cLtpRA;AH0jiBZ;AQj6QI;EACI,qBL3pRM;AH8jiBd;AQ/5QY;EACI,cL/pRJ;EKgqRI,gBAAA;ARi6QhB;AQ/5QY;EACI,cLnqRJ;EKoqRI,qBLrqRF;AHskiBd;AQ75QI;EACI,gBAAA;AR+5QR;AQ75QI;EACI,cL5qRI;EK6qRJ,qBL9qRM;EK+qRN,mBLhrRD;EKirRC,gBAAA;AR+5QR;AQ15QwB;EACI,WLhqRpB;AH4jiBR;AQn5QoB;EACI,cL/rRZ;AHoliBZ;AQh5QQ;EACI,qBLtsRE;AHwliBd;AQ/4QI;EACI,qBL1sRM;AH2liBd;AQ94QQ;EACI,cL7sRA;EK8sRA,qBL/sRE;EKgtRF,mBLjtRL;AHimiBP;AQ94QQ;EACI,cLltRA;EKmtRA,qBLptRE;EKqtRF,mBLttRL;AHsmiBP;AQ74QI;EACI,cLxtRI;EKytRJ,qBL1tRM;EK2tRN,mBL5tRD;AH2miBP;AQz4QoB;EACI,cLjuRZ;AH4miBZ;AQr4QI;EACI,cLxuRI;EKyuRJ,qBL1uRM;EK2uRN,mBL5uRD;AHmniBP;AQr4QI;EACI,cL7uRI;EK8uRJ,mBAAA;ARu4QR;AQr4QI;EACI,yBAAA;ARu4QR;AQr4QI;EACI,cLpvRI;AH2niBZ;AQr4QI;EACI,qBLxvRM;AH+niBd;AQr4QI;EACI,qBL3vRM;AHkoiBd;AQr4QI;EACI,mBL3wRE;EK4wRF,WLzuRA;AHgniBR;AQr4QI;EACI,uBAAA;ARu4QR;AQr4QI;EACI,qBLrwRM;EKswRN,mBLvwRD;AH8oiBP;AQp4QY;EACI,WLpvRR;AH0niBR;AQl4QI;EACI,yBAAA;ARo4QR;AQl4QI;EACI,mBAAA;ARo4QR;AQl4QY;EACI,WL/vRR;AHmoiBR;AQl4QY;EACI,WLlwRR;AHsoiBR;AQl4QY;EACI,qBL3xRF;EK4xRE,uBAAA;EACA,WLvwRR;AH2oiBR;AQj4QQ;EACI,WL3wRJ;AH8oiBR;AQh4QI;EACI,WL/wRA;AHipiBR;AQh4QI;EACI,qBLxyRM;EKyyRN,mBL1yRD;AH4qiBP;AQj4QQ;EACI,qBL3yRE;EK4yRF,mBAAA;ARm4QZ;AQh4QI;EACI,qBLhzRM;EKizRN,mBAAA;ARk4QR;AQh4QI;EACI,qBLpzRM;AHsriBd;AQh4QI;EACI,mBLjzRE;EKkzRF,gBAAA;ARk4QR;AQj4QQ;EACI,8BAAA;ARm4QZ;AQj4QQ;EACI,mBAAA;EACA,gBAAA;ARm4QZ;AQj4QQ;EACI,mBAAA;ARm4QZ;AQl4QY;EACI,qBLn0RF;AHusiBd;AQl4QY;EACI,qBLt0RF;AH0siBd;AQj4QQ;EACI,qBL10RE;AH6siBd;AQl4QY;EACI,WLtzRR;AH0riBR;AQl4QY;EACI,cL90RJ;AHktiBZ;AQj4QQ;EACI,cLl1RA;AHqtiBZ;AQh4QI;EACI,cLt1RI;AHwtiBZ;AQ/3QQ;EACI,qBL31RE;AH4tiBd;AQ93QI;EACI,mBLh2RD;EKi2RC,qBLh2RM;EKi2RN,cLh2RI;AHguiBZ;AQ/3QQ;EACI,mBLp2RL;EKq2RK,qBLp2RE;EKq2RF,cLp2RA;AHquiBZ;AQ93QI;EACI,mBL12RD;AH0uiBP;AQ93QI;EACI,mBL72RD;EK82RC,qBL72RM;EK82RN,cL72RI;AH6uiBZ;AQ93QI;EACI,qBLj3RM;AHiviBd;AQ73QQ;EACI,mBLt3RL;EKu3RK,qBLt3RE;EKu3RF,WLj2RJ;AHguiBR;AQ93QY;EACQ,mBLp3RP;EKq3RO,WLp2RZ;AHouiBR;AQ/3QoB;EACI,WLt2RhB;AHuuiBR;AQ33QQ;EACI,qBLp4RL;AHiwiBP;AQv3QY;EACI,mBL34RT;AHowiBP;AQv3Qa;EACG,qBL74RF;AHswiBd;AQx3QiB;EACG,qBL/4RN;AHywiBd;AQz3QoB;EACI,mBLl5RjB;EKm5RiB,WL53RhB;EK63RgB,qBLn5RV;AH8wiBd;AQr3QoB;EACI,mBL35RjB;EK45RiB,cLz5RP;EK05RO,qBL55RV;AHmxiBd;AQn3QY;EACI,qBLj6RF;AHsxiBd;AQp3QgB;EACI,qBLn6RN;AHyxiBd;AQr3QoB;EACI,qBLr6RV;AH4xiBd;AQt3QwB;EACI,mBLx6RrB;EKy6RqB,WLl5RpB;EKm5RoB,qBLz6Rd;AHiyiBd;AQl3QwB;EACI,mBLj7RrB;EKk7RqB,cL/6RX;EKg7RW,qBLl7Rd;AHsyiBd;AQ52QQ;EAII,WLx6RJ;AHmxiBR;AQ92QY;EACI,cAAA;ARg3QhB;AQ32QY;EACI,WL56RR;EK66RQ,yBAAA;EACA,gBAAA;EACA,mBAAA;AR62QhB;AQ52QgB;EACI,gCAAA;EACA,8BAAA;AR82QpB;AQ32QY;EACI,qBL58RF;EK68RE,mBL98RT;AH2ziBP;AQ52QgB;EACI,uBAAA;EACA,WL17RZ;AHwyiBR;AQz2QI;;;EAGI,qBLx9RM;AHm0iBd;AQz2QI;EACI,qBL39RM;EK49RN,mBL79RD;EK89RC,cL59RI;EK69RJ,gBAAA;AR22QR;AQ12QQ;EACI,qBLh+RE;EKi+RF,mBLl+RL;EKm+RK,cLj+RA;AH60iBZ;AQ12QQ;EACI,qBLr+RE;EKs+RF,mBLv+RL;EKw+RK,cLt+RA;AHk1iBZ;AQz2QI;EACI,mBL3+RM;EK4+RN,cL3+RI;EK4+RJ,qBL7+RM;AHw1iBd;AQx2QQ;EACI,cLh/RA;AH01iBZ;AQv2QI;EACI,UL/9RA;AHw0iBR;AQv2QI;EACI,WLl+RA;AH20iBR;AQx2QQ;EACI,cLvgSF;AHi3iBV;AQv2QI;EACI,qBL9/RM;AHu2iBd;AQv2QI;EACI,qBLjgSM;AH02iBd;AQv2QI;EACI,qBLpgSM;AH62iBd;AQp2QgB;EACI,cLxgSH;AH82iBjB;AQr2QoB;EACI,WLt/RhB;AH61iBR;AQr2QoB;EACI,mBL3gSP;EK4gSO,WL1/RhB;AHi2iBR;AQh2QQ;EACI,yBLnhSC;EKohSD,qBLzhSE;EK0hSF,WLpgSJ;AHs2iBR;AQj2QY;EACI,+DLzhSH;EK0hSG,qBL7hSF;EK8hSE,WLxgSR;AH22iBR;AQ91QI;EACI,qBLpiSM;EKqiSN,mBL/hSE;AH+3iBV;AQ91QY;EACI,WLlhSR;AHk3iBR;AQx1QoB;EACI,WL3hShB;AHq3iBR;AQj1QgB;EACI,WLriSZ;AHw3iBR;AQ90QI;EACI,mBL9iSE;EK+iSF,qBL/iSE;AH+3iBV;AQ90QY;EACI,WL/iSR;AH+3iBR;AQ50QI;EACI,mBLvjSE;EKwjSF,qBL3kSM;AHy5iBd;AQ50QY;EACI,WLxjSR;AHs4iBR;AQ10QI;EACI,sBAAA;AR40QR;AQz0QQ;EACI,mBLxlSL;EKylSK,qBLxlSE;AHm6iBd;AQ10QY;EACI,WLpkSR;AHg5iBR;AQx0QI;EACI,WLzkSA;AHm5iBR;AQx0QI;EACI,sBAAA;AR00QR;AQv0QQ;EACI,qBLtmSE;EKumSF,WLjlSJ;AH05iBR;AQr0QQ;EACI,mBLtmSF;EKumSE,qBL7mSE;AHo7iBd;AQt0QY;EACK,qBL/mSH;AHu7iBd;AQt0QY;EACI,WL5lSR;AHo6iBR;AQp0QI;EACI,qBLvnSM;AH67iBd;AQp0QI;EACI,qBL1nSM;EK2nSN,mBL5nSD;AHk8iBP;AQn0QQ;EACI,mBLhoSL;AHq8iBP;AQl0QI;EACI,mBL7nSE;EK8nSF,qBLpoSM;AHw8iBd;AQj0QQ;EACI,cLtoSK;AHy8iBjB;AQl0QY;EACI,mBLtoSC;EKuoSD,WLrnSR;AHy7iBR;AQh0QI;EACI,mBL3oSK;EK4oSL,qBLjpSM;EKkpSN,WL5nSA;AH87iBR;AQ9zQY;EACI,mBLlpSH;EKmpSG,qBLxpSF;AHw9iBd;AQ/zQgB;EACI,mBLrpSP;EKspSO,WLroSZ;AHs8iBR;AQh0QoB;EACI,WLvoShB;AHy8iBR;AQ5zQI;EACI,mBLjpSE;EKkpSF,qBLrqSM;AHm+iBd;AQ3zQgB;EACI,WLnpSZ;AHg9iBR;AQ3zQgB;EACI,mBL5qSN;AHy+iBd;AQzzQQ;EACK,qBLjrSC;AH4+iBd;AQxzQI;EACI,mBLlqSE;EKmqSF,qBLtrSM;AHg/iBd;AQxzQY;EACI,yBLtqSN;AHg+iBV;AQrzQgB;EACI,mBL1rSP;AHi/iBb;AQhzQY;EACI,qBLvsSF;EKwsSE,mBLnsSH;EKosSG,gBAAA;ARkzQhB;AQ5yQY;EACI,mBL1sSN;EK2sSM,qBLjtSF;AH+/iBd;AQ1yQY;EACI,cLptSC;AHggjBjB;AQxyQI;EACI,mBLxsSE;EKysSF,qBL5tSM;AHsgjBd;AQxyQY;EACK,mBL5sSP;EK6sSO,qBLhuSH;AH0gjBd;AQzyQiB;EACG,mBL/sSV;EKgtSU,qBLnuSN;AH8gjBd;AQryQQ;EACI,cLxuSK;AH+gjBjB;AQtyQY;EACI,mBLztSN;EK0tSM,WLvtSR;AH+/iBR;AQnyQQ;EACI,6BAAA;ARqyQZ;AQpyQY;EACI,mBLjvSC;EKkvSD,cLpvSC;AH0hjBjB;AQnyQQ;EACI,mBLtvSK;EKuvSL,cLzvSK;AH8hjBjB;AQlyQI;EACI,qBL/vSM;AHmijBd;AQlyQa;EACG,mBL/uSN;EKgvSM,WL7uSR;AHihjBR;AQhyQI;EACI,mBLpwSS;AHsijBjB;AQhyQI;EACI,cLzwSS;AH2ijBjB;AQjyQS;EACG,mBL1vSF;EK2vSE,WLxvSJ;AH2hjBR;AQhyQI;EACI,qBLlxSM;AHojjBd;AQ/xQQ;EACI,qBLtxSE;AHujjBd;AQ7xQI;;EAEI,qBL5xSM;AH2jjBd;AQ7xQI;;;EAGI,mBL7xSS;EK8xST,qBLlySM;AHikjBd;AQ7xQI;EACI,sBAAA;AR+xQR;AQ7xQI;EACI,qBLxySM;AHukjBd;AQ9xQQ;EACI,mBLvxSF;AHujjBV;AQ/xQY;EACI,mBLzxSN;EK0xSM,qBL7ySF;AH8kjBd;AQ5xQI;EACI,qBLnzSM;EKozSN,WL9xSA;AH4jjBR;AQ5xQI;EACI,qBLvzSM;AHqljBd;AQ5xQI;EACI,qBL1zSM;EK2zSN,cLzzSS;AHuljBjB;AQ5xQI;EACI,cL5zSS;AH0ljBjB;AQ5xQI;EACI,qBLj0SM;AH+ljBd;AQ7xQQ;EACI,WL7ySJ;AH4kjBR;AQ5xQI;EACI,mBLpzSE;EKqzSF,qBLx0SM;AHsmjBd;AQ7xQQ;EACI,cLx0SK;AHumjBjB;AQ7xQQ;EACI,qBL70SE;AH4mjBd;AQ9xQY;EACI,qBL/0SF;AH+mjBd;AQ5xQI;EACI,mBLj0SE;AH+ljBV;AQ3xQgB;EACI,yBAAA;AR6xQpB;AQ5xQoB;EACI,cLv2Sd;AHqojBV;AQ5xQoB;EACK,qBL71SX;AH2njBd;AQxxQI;EACI,mBLj1SE;EKk1SF,qBLr2SM;EKs2SN,cLp2SS;AH8njBjB;AQxxQI;;EAEI,WLp1SA;AH8mjBR;AQvxQQ;EACI,yBL31SF;AHonjBV;AQxxQY;EACI,yBL12SN;EK22SM,qBLj3SF;AH2ojBd;AQtxQI;EACI,mBLn2SE;AH2njBV;AQtxQI;EACI,mBLt2SE;EKu2SF,qBL13SM;AHkpjBd;AQtxQI;EACI,qBL73SM;AHqpjBd;AQtxQI;EACI,cL1oSM;AHk6iBd;AQtxQI;EACI,qBLn4SM;EKo4SN,cLl4SS;AH0pjBjB;AQtxQI;EACI,6BAAA;ARwxQR;AQtxQI;EACI,qBL14SM;AHkqjBd;AQtxQI;EACI,yBLv4SE;AH+pjBV;AQvxQQ;EACI,uBAAA;ARyxQZ;AQvxQgB;EACI,WL53SZ;AHqpjBR;AQpxQI;EACI,mBLr4SE;AH2pjBV;AQrxQQ;EACI,WLp4SJ;AH2pjBR;AQpxQI;EACI,mBL34SE;AHiqjBV;AQrxQQ;EACI,qBLh6SE;AHurjBd;AQtxQY;EACI,WL54SR;AHoqjBR;AQnxQQ;EACI,mBLz6SL;EK06SK,WLn5SJ;AHwqjBR;AQpxQY;EACI,qBL36SF;AHisjBd;AQlxQY;EACI,qBLh7SF;AHosjBd;AQ/wQQ;EACI,mBLj7SC;EKk7SD,qBLv7SE;EKw7SF,WLl6SJ;AHmrjBR;AQ9wQI;EACI,mBL57SM;AH4sjBd;AQ9wQI;EACI,qBL/7SM;AH+sjBd;AQ/wQQ;EACI,WL36SJ;AH4rjBR;AQ9wQI;EACI,mBLh8SK;EKi8SL,qBLt8SM;EKu8SN,WLj7SA;AHisjBR;AQ9wQI;EACI,gBAAA;ARgxQR;AQ/wQQ;EACI,cL18SK;EK28SL,qBL78SE;AH8tjBd;AQ9wQI;EACI,qBLj9SM;AHiujBd;AQ9wQI;EACI,qBLp9SM;AHoujBd;AQ7wQQ;EACI,WLl8SJ;AHitjBR;AQ5wQI;EACI,WLt8SA;AHotjBR;AQ5wQI;EACI,yBL58SE;EK68SF,qBLh+SM;AH8ujBd;AQ7wQQ;EACI,qBLl+SE;AHivjBd;AQ9wQY;EACI,WL98SR;AH8tjBR;AQ7wQQ;EACI,WLl9SJ;AHiujBR;AQ7wQQ;EACI,yBLr+SF;AHovjBV;AQ9wQY;EACI,qBL7+SF;AH6vjBd;AQ/wQgB;EACI,WLz9SZ;AH0ujBR;AQ9wQY;EACI,WL79SR;AH6ujBR;AQ5wQI;EACI,qBLx/SM;AHswjBd;AQ5wQI;EACI,yBLx+SE;AHsvjBV;AQ7wQQ;EACI,qBL7/SE;AH4wjBd;AQ7wQQ;EACI,qBLhgTE;AH+wjBd;AQ5wQI;EACI,yBLj/SE;EKk/SF,qBLrgTM;EKsgTN,gBAAA;AR8wQR;AQ5wQI;EACI,yBLt/SE;EKu/SF,qBL1gTM;AHwxjBd;AQ7wQQ;EACI,cL1gTK;AHyxjBjB;AQ5wQI;EACI,yBL7/SE;EK8/SF,qBLjhTM;AH+xjBd;AQ3wQQ;EACI,yBLlgTF;EKmgTE,gBAAA;AR6wQZ;AQ3wQQ;EACI,qBLzhTE;AHsyjBd;AQ3wQQ;EACI,qBL5hTE;AHyyjBd;AQ1wQI;EACI,yBL7gTE;AHyxjBV;AQ1wQI;EACI,qBLniTM;EKoiTN,yBLjhTE;AH6xjBV;AQ1wQI;EACI,uBAAA;AR4wQR;AQ1wQI;EACI,yBLvhTE;AHmyjBV;AQ1wQI;EACI,yBL1hTE;AHsyjBV;AQ1wQI;EACI,yBL7hTE;EK8hTF,qBLjjTM;EKkjTN,gBAAA;AR4wQR;AQ1wQI;EACI,yBLliTE;AH8yjBV;AQ1wQI;EACI,yBLriTE;EKsiTF,qBLzjTM;AHq0jBd;AQ1wQI;EACI,WLtiTA;AHkzjBR;AQzwQQ;EACI,WL1iTJ;AHqzjBR;AQzwQQ;EACI,cLjkTK;AH40jBjB;AQxwQI;EACI,WLjjTA;AH2zjBR;AQxwQI;EACI,yBAAA;AR0wQR;AQxwQI;EACI,WLvjTA;AHi0jBR;AQxwQI;EACI,qBLhlTM;AH01jBd;AQxwQI;EACK,cLjlTQ;AH21jBjB;AQxwQI;EACI,yBLnkTE;EKokTF,qBLvlTM;AHi2jBd;AQzwQQ;EACI,qBLzlTE;AHo2jBd;AQzwQQ;EACI,qBL5lTE;AHu2jBd;AQ1wQY;EACI,cL5lTC;AHw2jBjB;;AU34jBA;ENwGG,aMvG+B;EAC9B,gCAAA;AV84jBJ;AU74jBI;EACI,eP+aO;EO9aP,gBPMe;EOLf,WPkDA;EOjDA,gBAAA;AV+4jBR;;AU34jBI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AV84jBR;AU54jBI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AV84jBR;AU74jBQ;EACI,aAAA;EACA,gCAAA;EACA,ePpBK;AHm6jBjB;AU94jBY;EACI,gBAAA;AVg5jBhB;AU94jBY;EACI,cAAA;EN2Eb,aM1E2C;AVg5jB9C;AU94jBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBP0XG;EOzXH,kBAAA;AVg5jBhB;AU/4jBgB;EACI,kBPuXD;AH0hjBnB;AU/4jBgB;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AVi5jBpB;AU94jBY;EACI,cP0IL;EOzIK,gBPzCK;AHy7jBrB;AU94jBY;EACI,gBP5CK;EO6CL,cPiIL;ECjFR,eM/CqC;AVg5jBxC;AU94jBY;EACI,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,cPwHL;EOvHK,kBAAA;ENsCb,eMrCqC;ENsCrC,mBMtC8C;AVi5jBjD;AUh5jBgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,8BAAA;EACA,mBP+GT;EO9GS,kBPoVD;AH8jjBnB;AU/4jBY;EACI,ePgWD;EO/VC,cP8GL;ECtFR,SMvBqC;AVi5jBxC;AU/4jBY;EAGI,oBAAA;EAGA,mBAAA;EACA,yBAAA;EACA,kBPoUG;EOnUH,aAAA;EACA,kBAAA;AVi5jBhB;AUh5jBgB;EACI,kBAAA;AVk5jBpB;AUj5jBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cPrFd;EOsFc,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBPgTL;AHmmjBnB;AUh5jBgB;EACI,mBAAA;AVk5jBpB;AUj5jBoB;EACI,eP0TT;EOzTS,cPwEb;EOvEa,gBAAA;AVm5jBxB;AUj5jBoB;EACI,ePqTT;EOpTS,cP4JX;AHuvjBb;AU/4jBY;EACI,eP+SD;EO9SC,iBAAA;EACA,cPyDL;AHw1jBX;AU/4jBY;EACI,SAAA;EACA,UAAA;EACA,kBAAA;AVi5jBhB;AUh5jBgB;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AVk5jBpB;AUh5jBgB;ENpCb,mBMqC+C;AVk5jBlD;AUj5jBoB;EACI,cP6Cb;EO5Ca,WAAA;EACA,gBPvIH;EOwIG,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVm5jBxB;AUj5jBoB;EACI,cPgCb;EO/Ba,YAAA;EACA,ePiRT;AHkojBf;AUj5jBoB;EACI,cP6Bb;EO5Ba,eP+QT;EO9QS,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVm5jBxB;;AU54jBA;EACI,mBPFQ;EOGR,iBAAA;ENtED,aMuE+B;AV+4jBlC;AU94jBI;EACI,gBPtKe;EOuKf,kBAAA;AVg5jBR;AU/4jBQ;EACI,eAAA;AVi5jBZ;AU94jBI;EACI,cPKG;AH24jBX;AU/4jBQ;EACI,cPFD;AHm5jBX;AU94jBI;EACI,cP1KE;AH0jkBV;AU/4jBQ;EACI,wDAAA;AVi5jBZ;;AU74jBA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AVg5jBJ;;AU94jBA;ENjGG,mBMkG+B;AVi5jBlC;AUh5jBI;EACI,cPhBG;EOiBH,WAAA;EACA,gBPpMa;EOqMb,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVk5jBR;AUh5jBI;EACI,cP7BG;EO8BH,YAAA;EACA,ePoNO;AH8rjBf;AUh5jBI;EACI,cPhCG;EOiCH,ePkNO;EOjNP,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVk5jBR;;AU/4jBA;EACI,WAAA;AVk5jBJ;AUj5jBI;EACI,kBAAA;AVm5jBR;AUj5jBI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AVm5jBR;AUl5jBQ;EACI,sBPzLJ;EO0LI,kBAAA;EACA,yBAAA;EN3IT,gBM4IiC;EN3IjC,uBM2I6C;EACpC,eP6LG;AHwtjBf;AUp5jBY;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EN1Jd,kBM2JgC;EN1JhC,SM0JyC;ENvJzC,SMuJwD;AVw5jB1D;AUt5jBY;EACI,sBPtMR;EOuMQ,kBAAA;ENvJb,kBMwJqC;ENvJrC,UMuJiD;AVy5jBpD;AUv5jBY;EACI,cPzEL;EO0EK,cAAA;EACA,eP0KD;EOzKC,iBAAA;AVy5jBhB;AUv5jBY;EACI,WPhNR;AHymkBR;AUv5jBY;EACI,cPrPJ;EOsPI,gBPjQO;EOkQP,ePoKD;AHqvjBf;AUx5jBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AV05jBpB;;AC5pkBA,0BAAA;AUfA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBRqZY;EQpZZ,WR+CI;EQ9CJ,gBRCiB;AH8qkBrB;AW9qkBI;EACI,WR4CA;AHookBR;AW9qkBI;EACI,WAAA;EACA,YAAA;EACA,kBR4YQ;AHoyjBhB;AW9qkBI;EACI,kBAAA;AXgrkBR;AW/qkBQ;EACI,kBAAA;AXirkBZ;AW9qkBI;EACI,gBAAA;AXgrkBR;AW/qkBQ;EACI,gBAAA;AXirkBZ;AW9qkBI;EACI,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXgrkBR;AW7qkBQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,UAAA;AX+qkBZ;AW5qkBI;EACI,yBRjCE;AH+skBV;AW5qkBI;EACI,yBR6HG;AHijkBX;AW5qkBI;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AX8qkBR;AW7qkBQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;AX+qkBZ;AW5qkBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AX8qkBR;AW7qkBQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;AX+qkBZ;AW5qkBY;EACI,aAAA;EACA,cAAA;AX8qkBhB;AW1qkBI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AX4qkBR;AW3qkBQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AX6qkBZ;AW1qkBY;EACI,cAAA;EACA,eAAA;AX4qkBhB;AWzqkBQ;EACI,aAAA;EACA,cAAA;AX2qkBZ;AWxqkBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AX0qkBR;AWzqkBQ;EACI,uBAAA;EACA,wBAAA;AX2qkBZ;AWxqkBY;EACI,aAAA;EACA,cAAA;AX0qkBhB;AWvqkBQ;EACI,aAAA;EACA,cAAA;AXyqkBZ;AWtqkBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXwqkBR;AWvqkBQ;EACI,sBAAA;EACA,uBAAA;AXyqkBZ;AWtqkBY;EACI,cAAA;EACA,eAAA;AXwqkBhB;AWpqkBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AXsqkBR;AWrqkBQ;EACI,sBAAA;EACA,sBAAA;AXuqkBZ;AWpqkBY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;AXsqkBhB;AWnqkBgB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AXqqkBpB;AWhqkBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXkqkBR;AWjqkBQ;EACI,sBAAA;EACA,sBAAA;AXmqkBZ;AWhqkBY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;AXkqkBhB;;AW7pkBA;EACI,UAAA;AXgqkBJ;AW9pkBQ;EACI,uBAAA;AXgqkBZ;AW/pkBY;EACI,UAAA;AXiqkBhB;AW5pkBQ;EACI,cAAA;EACA,eAAA;AX8pkBZ;AW7pkBY;EACI,kBAAA;AX+pkBhB;AW5pkBQ;EACI,mBAAA;AX8pkBZ;AW1pkBQ;EACI,WAAA;EACA,YAAA;AX4pkBZ;AW3pkBY;EACI,iBAAA;AX6pkBhB;AW1pkBQ;EACI,uBAAA;AX4pkBZ;AWxpkBQ;EACI,aAAA;EACA,cAAA;AX0pkBZ;AWzpkBY;EACI,iBAAA;AX2pkBhB;AWvpkBI;EACI,uCAAA;EACA,qCAAA;EACA,sBAAA;EACA,gCAAA;AXypkBR;AWxpkBQ;EACI,+BAAA;AX0pkBZ;AWxpkBQ;EACI,UAAA;EACA,gCAAA;AX0pkBZ;;AWtpkBA;EAGC,oBAAA;AXypkBD;AWxpkBC;EACC,eAAA;EACA,gBAAA;AX0pkBF;AWzpkBE;;EAEC,sBAAA;EACA,iBAAA;AX2pkBH;AWvpkBE;EACC,uBAAA;AXypkBH;AWxpkBG;EACC,UAAA;AX0pkBJ;AWrpkBE;EACC,cAAA;EACA,eAAA;AXupkBH;AWtpkBG;EACC,kBAAA;AXwpkBJ;AWrpkBE;EACC,mBAAA;AXupkBH;AWnpkBE;EACC,WAAA;EACA,YAAA;AXqpkBH;AWppkBG;EACC,iBAAA;AXspkBJ;AWnpkBE;EACC,uBAAA;AXqpkBH;;AWjpkBA;EACI,WAAA;EACA,YAAA;AXopkBJ;;AYt8kBA;;EAEC,yBT0BS;ESzBT,oBAAA;AZy8kBD;;AYv8kBA;EACC,4BTsBS;AHo7kBV;;AYx8kBA;EACI,uBAAA;AZ28kBJ;;AYz8kBA;EACI,gCAAA;AZ48kBJ;;AYz8kBA;EACC,cTyCQ;AHm6kBT;AY38kBC;EACE,kCAAA;AZ68kBH;;AY18kBA;EACC,qBT4JW;AHizkBZ;;Aan+kBA;EACI,WVsDI;EUrDJ,yBVkBM;EUjBN,qBViBM;EUhBN,eV4aW;EU3aX,eV2aW;AH2jkBf;;Aap+kBA;EACI,mBVYM;EUXN,WV8CI;EU7CJ,eVsaW;EUraX,eVqaW;EUpaX,kBAAA;ET4FD,iBS3F+B;ET8EhC,yBS7EsB;Aby+kBxB;Aax+kBI;EACI,6DVKQ;EUJR,WVsCA;AHo8kBR;AI98kBI;EStCJ;IAaQ,eAAA;IACA,gBAAA;Eb2+kBN;AACF;;Aaz+kBA;EACI,mBV6PS;EU5PT,WV6BI;EU5BJ,eVqZW;EUpZX,gBVhBe;EUiBf,kBAAA;ET2ED,iBS1E+B;ET6DhC,yBS5DsB;Ab8+kBxB;Aa7+kBI;EACI,mBVXI;EUYJ,WVqBA;AH09kBR;AIp+kBI;ESrBJ;IAaQ,eAAA;IACA,gBAAA;Ebg/kBN;AACF;;Aa9+kBA;EACI,mBVtBM;ECoFP,iBS7D+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBV1Ce;EU2Cf,eVyXW;EUxXX,kBAAA;EACA,kBAAA;Abi/kBJ;Aah/kBI;EACI,6DVtCQ;EUuCR,WVLA;AHu/kBR;Aah/kBI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Abk/kBR;;Aa/+kBA;EACI,mBV/CQ;ECkFT,iBSlC+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBVrEe;EUsEf,eV8VW;EU7VX,kBAAA;EACA,kBAAA;Abk/kBJ;Aaj/kBI;EACI,mBVuGG;EUtGH,WVhCA;AHmhlBR;Aaj/kBI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Abm/kBR;;Aah/kBA;EACI,mBVlEK;EC0EN,iBSP+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBVhGe;EUiGf,eVmUW;EUlUX,kBAAA;EACA,kBAAA;Abm/kBJ;Aal/kBI;EACI,mBVnFC;EUoFD,WV3DA;AH+ilBR;Aal/kBI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Abo/kBR;;Aah/kBA;EACI,iBAAA;EACA,WAAA;EACA,gBVlHe;EUmHf,eViTW;EUhTX,kBAAA;Abm/kBJ;Aal/kBI;EACI,WAAA;EACA,YAAA;Abo/kBR;;Aaj/kBA;EACI,yBVnHM;EUoHN,qBVpHM;AHwmlBV;;Aal/kBA;EACI,yBVvHM;EUwHN,qBVxHM;EUyHN,WVtFI;AH2klBR;;Aal/kBI;EACI,SAAA;Abq/kBR;;Aah/kBQ;EACI,6BAAA;EACA,yBAAA;Abm/kBZ;Aal/kBY;EACI,cVpIJ;AHwnlBZ;;Aa7+kBQ;EACI,kBAAA;Abg/kBZ;;Aa5+kBA;EACI,YAAA;Ab++kBJ;;Aa7+kBA;EACI,eAAA;Abg/kBJ;Aa/+kBI;EACI,UAAA;EACA,gBAAA;Abi/kBR;;Aa9+kBA;EACI,kBV6Oe;EU5Of,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBV3KmB;AH4plBvB;Aah/kBI;EACI,2BAAA;Abk/kBR;Aah/kBI;EACI,oBAAA;Abk/kBR;Aah/kBI;EACI,qBAAA;EACA,kBAAA;Abk/kBR;Aah/kBI;EACI,uBAAA;EACA,kBAAA;Abk/kBR;Aa9+kBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AHmolBR;Aa/+kBY;EAKI,mEAAA;EACA,mEAAA;EACA,WV3JR;AHwolBR;Aax/kBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AH6olBR;Aaz/kBY;EAKI,8CAAA;EACA,8CAAA;EACA,WV3JR;AHkplBR;AalglBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AHuplBR;AanglBY;EAKI,mEAAA;EACA,mEAAA;EACA,WV3JR;AH4plBR;Aa5glBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AHiqlBR;Aa7glBY;EAKI,oEAAA;EACA,oEAAA;EACA,WV3JR;AHsqlBR;AathlBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AH2qlBR;AavhlBY;EAKI,+CAAA;EACA,+CAAA;EACA,WV3JR;AHgrlBR;AahilBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AHqrlBR;AajilBY;EAKI,uCAAA;EACA,uCAAA;EACA,WV3JR;AH0rlBR;Aa1ilBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AH+rlBR;Aa3ilBY;EAKI,gEAAA;EACA,gEAAA;EACA,WV3JR;AHoslBR;AapjlBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AHyslBR;AarjlBY;EAKI,0CAAA;EACA,0CAAA;EACA,WV3JR;AH8slBR;Aa9jlBQ;EACI,sBAAA;EACA,sBAAA;EACA,WVnJJ;AHmtlBR;Aa/jlBY;EAKI,uBAAA;EACA,uBAAA;EACA,WV3JR;AHwtlBR;AaxklBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AH6tlBR;AazklBY;EAKI,8CAAA;EACA,8CAAA;EACA,WV3JR;AHkulBR;AalllBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AHuulBR;AanllBY;EAKI,sCAAA;EACA,sCAAA;EACA,WV3JR;AH4ulBR;Aa5llBQ;EACI,yBAAA;EACA,yBAAA;EACA,WVnJJ;AHivlBR;Aa7llBY;EAKI,mEAAA;EACA,mEAAA;EACA,WV3JR;AHsvlBR;AavllBI;EACI,yBV1CI;EU2CJ,yBAAA;EACA,cV5BG;AHqnlBX;AaxllBQ;EAKI,6CAAA;EACA,yBAAA;EACA,cVpCD;AH0nlBX;;AahllBI;EACE,wBAAA;AbmllBN;;Aa/klBI;EACE,qBAAA;AbkllBN;;Aa9klBI;EACE,uBAAA;AbillBN;;Aa7klBI;EACE,mBAAA;AbgllBN;Aa9klBI;EACE,mBAAA;AbgllBN;Aa9klBI;EACE,mBAAA;AbgllBN;Aa9klBI;EACE,mBAAA;AbgllBN;;Aa5klBI;EACE,aAAA;EACA,eAAA;Ab+klBN;Aa7klBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;Ab+klBN;Aa7klBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;Ab+klBN;;Aa3klBI;EACE,6BAAA;Ab8klBN;;AazklBM;;;;EAIE,6BAAA;Ab4klBR;;AavklBE;EACE,yBAAA;Ab0klBJ;;AaxklBE;EACE,gBAAA;Ab2klBJ;;AazklBA;EACI,4BAAA;Ab4klBJ;;Aa1klBE;EACE,4BAAA;Ab6klBJ;;Aa1klBE;EACE,0BAAA;Ab6klBJ;;Aa3klBE;EACE,0BAAA;Ab8klBJ;;Aa3klBE;EACE,wCAAA;EACA,cVrSM;AHm3lBV;Aa7klBI;EAGE,yBVzSI;EU0SJ,WVvQE;EUwQF,qBV3SI;AHw3lBV;AazklBE;EACE,wCAAA;EACA,cV/SQ;AH03lBZ;Aa1klBI;EAGE,yBVnTM;EUoTN,WVnRE;EUoRF,qBVrTM;AH+3lBZ;AavklBE;EACE,wCAAA;EACA,cVpTM;AH63lBV;AaxklBI;EAGE,yBVxTI;EUyTJ,WV9RE;EU+RF,qBV1TI;AHk4lBV;AarklBE;EACE,yCAAA;EACA,cVjUG;AHw4lBP;AatklBI;EAGE,yBVrUC;EUsUD,WVzSE;EU0SF,qBVvUC;AH64lBP;AanklBE;EACE,wCAAA;EACA,cV9UM;AHm5lBV;AapklBI;EAGE,yBVlVI;EUmVJ,WVpTE;EUqTF,qBVpVI;AHw5lBV;AajklBE;EACE,uCAAA;EACA,cVnVK;AHs5lBT;AalklBI;EAGE,yBVvVG;EUwVH,WV/TE;EUgUF,qBVzVG;AH25lBT;;Aa7jlBE;EACE,6BAAA;EACA,cV1WM;EU2WN,yBAAA;AbgklBJ;Aa/jlBI;EACE,cV7WI;EU8WJ,yBAAA;EACA,6BAAA;AbiklBN;Aa9jlBE;EACE,8BAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;AbgklBJ;Aa/jlBI;EACE,mBVxXI;AHy7lBV;Aa9jlBE;EACE,6BAAA;EACA,cV3XQ;EU4XR,yBAAA;AbgklBJ;Aa/jlBI;EACE,cV9XM;EU+XN,yBAAA;EACA,6BAAA;AbiklBN;Aa9jlBE;EACE,6BAAA;EACA,cV/XM;EUgYN,yBAAA;AbgklBJ;Aa/jlBI;EACE,cVlYI;EUmYJ,yBAAA;EACA,6BAAA;AbiklBN;Aa9jlBE;EACE,6BAAA;EACA,cV3YG;EU4YH,yBAAA;AbgklBJ;Aa/jlBI;EACE,cV9YC;EU+YD,yBAAA;EACA,6BAAA;AbiklBN;Aa9jlBE;EACE,6BAAA;EACA,cVvZM;EUwZN,yBAAA;AbgklBJ;Aa/jlBI;EACE,cV1ZI;EU2ZJ,yBAAA;EACA,6BAAA;AbiklBN;Aa9jlBE;EACE,6BAAA;EACA,cV3ZK;EU4ZL,yBAAA;AbgklBJ;Aa/jlBI;EACE,cV9ZG;EU+ZH,yBAAA;EACA,6BAAA;AbiklBN;;Aa5jlBE;EACE,6BAAA;Ab+jlBJ;;Aa5jlBA;EACI,oCAAA;EACA,yBAAA;Ab+jlBJ;Aa9jlBI;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;Ab4jlBR;;AazjlBA;EACI,oCAAA;EACA,yBAAA;Ab4jlBJ;Aa3jlBI;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;AbyjlBR;;AatjlBA;EACI,oCAAA;EACA,yBAAA;AbyjlBJ;AaxjlBI;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;AbsjlBR;;AanjlBA;EACI,oCAAA;EACA,yBAAA;AbsjlBJ;AarjlBI;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;AbmjlBR;;AahjlBA;EACI,oCAAA;EACA,yBAAA;AbmjlBJ;AaljlBI;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;AbgjlBR;;Aa7ilBA;EACI,oCAAA;EACA,yBAAA;AbgjlBJ;Aa/ilBI;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,sBAAA;Ab6ilBR;;Aa1ilBA;EACI,yBAAA;EACA,yBAAA;Ab6ilBJ;Aa5ilBI;EAKI,yBV9eA;EU+eA,yBAAA;EACA,yBAAA;Ab0ilBR;;AavilBA;EACI,oCAAA;EACA,yBAAA;Ab0ilBJ;AazilBI;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;AbuilBR;;AapilBA;EACI,oCAAA;EACA,yBAAA;AbuilBJ;AatilBI;EAKG,6CAAA;EACA,qBV3iBG;AH+kmBV;;AajilBA;EACI,oCAAA;EACA,yBAAA;AboilBJ;AanilBI;EAKG,6CAAA;EACA,qBVrjBK;AHslmBZ;;Aa9hlBA;EACI,oCAAA;EACA,yBAAA;AbiilBJ;AahilBI;EAKG,6CAAA;EACA,qBV/jBG;AH6lmBV;;Aa3hlBA;EACI,oCAAA;EACA,yBAAA;Ab8hlBJ;Aa7hlBI;EAKG,4CAAA;EACA,qBVrkBE;AHgmmBT;;AaxhlBA;EACI,oCAAA;EACA,yBAAA;Ab2hlBJ;Aa1hlBI;EAKG,6CAAA;EACA,qBVnlBG;AH2mmBV;;AarhlBA;EACI,oDAAA;EACA,yBAAA;AbwhlBJ;AavhlBI;EAKG,8CAAA;EACA,qBVjmBA;AHsnmBP;;AalhlBA;EACI,qDAAA;EACA,yBAAA;AbqhlBJ;AaphlBI;EAKG,+CAAA;EACA,qBVllBC;EUmlBD,qBVlXM;AHo4lBb;;Aa/glBA;EACI,kDAAA;EACA,sBAAA;AbkhlBJ;AajhlBI;EAKG,4CAAA;EACA,qBVpnBA;AHmomBP;;Aa3glBE;EACE,sBAAA;EACA,oBAAA;Ab8glBJ;Aa7glBI;EACE,mBV9nBG;EU+nBH,WVtmBE;EUumBF,gCAAA;EACA,oBAAA;EACA,0BAAA;Ab+glBN;;AazglBI;EACE,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;Ab4glBN;Aa3glBM;EACE,8BAAA;EACA,sBAAA;EACA,gCAAA;EACA,oBAAA;EACA,0BAAA;Ab6glBR;;AaxglBA;EACE,yBV1cW;EU2cX,qBV3cW;EU4cX,cV/nBO;EUgoBP,eVzQa;EU0Qb,gBVhrBmB;EUirBnB,kBAAA;ETnlBC,iBSolB6B;ETjmB9B,yBSkmBoB;EAGpB,mBAAA;EAGA,oBAAA;Ab6glBF;AInqmBI;ESwoBJ;IT7kBG,iBS6lBiC;Eb+glBlC;AACF;;Aa7glBA;EACE,mBVrrBQ;EUsrBR,yBAAA;ET/mBA,yBSgnBoB;EAGpB,mBAAA;EAGA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AbkhlBF;AajhlBE;EAGI,6DVnsBU;EUosBV,+DVpsBU;EUqsBV,WVnqBE;EUoqBF,gDAAA;AbihlBN;Aa9glBE;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;Ab+glBJ;AIpsmBI;ES2pBJ;IA8BM,eAAA;Eb+glBJ;AACF;;Aa5glBA;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;Ab+glBF;Aa7glBE;EAGE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gDAAA;Ab6glBJ;Aa1glBE;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;Ab2glBJ;;AavglBA;EACE,gBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;Ab0glBF;AaxglBE;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AbwglBJ;AarglBE;EAEE,aAAA;EACA,mBAAA;AbsglBJ;;AalglBA;EACE,sCAAA;EACA,yBAAA;AbqglBF;AanglBE;EAKE,oCAAA;EACA,sCAAA;EACA,6DAAA;EACA,yBAAA;AbiglBJ;Aa9/kBE;EAEE,aAAA;EACA,2BAAA;Ab+/kBJ;;Aa3/kBA;;;;;EAKE,aAAA;Ab8/kBF;;Aa3/kBA,2DAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;Ab8/kBF;Aa5/kBE;EACE,gDAAA;Ab8/kBJ;Aa3/kBE;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;Ab4/kBJ;;Aax/kBA;EACE,gBAAA;EACA,cAAA;EACA,2BAAA;Ab2/kBF;;Aax/kBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;Ab2/kBF;;Aax/kBA;EACE,mBAAA;EACA,qBAAA;Ab2/kBF;;Aax/kBA;EACE,mBAAA;EACA,WAAA;EACA,8CAAA;Ab2/kBF;;Aax/kBA;EACE,mBAAA;EACA,6CAAA;EACA,2BAAA;Ab2/kBF;;Aax/kBA;EACE,wBAAA;Ab2/kBF;;Aax/kBA;EACE,qDAAA;EACA,WAAA;EACA,6CAAA;Ab2/kBF;;Aax/kBA;EACE,qDAAA;EACA,8CAAA;EACA,2BAAA;Ab2/kBF;;Aax/kBA;EACE,6DAAA;EACA,WAAA;EACA,6CAAA;Ab2/kBF;;Aax/kBA;EACE,2BAAA;EACA,8CAAA;Ab2/kBF;;Acl4mBI;EACI,kCAAA;EACA,4CAAA;EACA,cXgBE;AHq3mBV;;Ac/3mBQ;EACI,mBAAA;EACA,4CAAA;EACA,WX0CJ;AHw1mBR;Ach4mBQ;EACI,kCAAA;EACA,4CAAA;EACA,cXqPG;AH6omBf;;Ac14mBQ;EACI,mBAAA;EACA,4CAAA;EACA,WX0CJ;AHm2mBR;Ac34mBQ;EACI,kCAAA;EACA,4CAAA;EACA,cXqPG;AHwpmBf;;Acr5mBQ;EACI,mBAAA;EACA,4CAAA;EACA,WX0CJ;AH82mBR;Act5mBQ;EACI,kCAAA;EACA,4CAAA;EACA,cXqPG;AHmqmBf;;Ach6mBQ;EACI,mBAAA;EACA,6CAAA;EACA,WX0CJ;AHy3mBR;Acj6mBQ;EACI,mCAAA;EACA,6CAAA;EACA,cXqPG;AH8qmBf;;Ac36mBQ;EACI,mBAAA;EACA,4CAAA;EACA,WX0CJ;AHo4mBR;Ac56mBQ;EACI,kCAAA;EACA,4CAAA;EACA,cXqPG;AHyrmBf;;Act7mBQ;EACI,mBAAA;EACA,2CAAA;EACA,WX0CJ;AH+4mBR;Acv7mBQ;EACI,iCAAA;EACA,2CAAA;EACA,cXqPG;AHosmBf;;Acj8mBQ;EACI,mBAAA;EACA,2CAAA;EACA,WX0CJ;AH05mBR;Acl8mBQ;EACI,iCAAA;EACA,2CAAA;EACA,cXqPG;AH+smBf;;Ac58mBQ;EACI,mBAAA;EACA,8CAAA;EACA,WX0CJ;AHq6mBR;Ac78mBQ;EACI,oCAAA;EACA,8CAAA;EACA,cXqPG;AH0tmBf;;Acv9mBQ;EACI,gBAAA;EACA,wCAAA;EACA,WX0CJ;AHg7mBR;Acx9mBQ;EACI,8BAAA;EACA,wCAAA;EACA,WXqPG;AHqumBf;;Acl+mBQ;EACI,mBAAA;EACA,2CAAA;EACA,WX0CJ;AH27mBR;Acn+mBQ;EACI,iCAAA;EACA,2CAAA;EACA,cXqPG;AHgvmBf;;Ac7+mBQ;EACI,mBAAA;EACA,4CAAA;EACA,WX0CJ;AHs8mBR;Ac9+mBQ;EACI,kCAAA;EACA,4CAAA;EACA,cXqPG;AH2vmBf;;Acx/mBQ;EACI,mBAAA;EACA,4CAAA;EACA,WX0CJ;AHi9mBR;Acz/mBQ;EACI,kCAAA;EACA,4CAAA;EACA,cXqPG;AHswmBf;;Acv/mBA;EACI,wBAAA;EACA,0BAAA;EACA,gBXdmB;EWenB,qBAAA;EACA,kBXiYY;EWhYZ,cXiKO;AHy1mBX;Acz/mBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;Ad2/mBR;Acz/mBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;Ad2/mBR;Acz/mBI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;Ad2/mBR;Acz/mBI;EACI,eXmYO;EWlYP,iBAAA;EACA,iBAAA;Ad2/mBR;Acz/mBI;EACI,eXgYO;EW/XP,iBAAA;EACA,iBAAA;Ad2/mBR;;Acv/mBA;EACI,mBXmLS;EWlLT,cXDK;AH2/mBT;;Acv/mBA;EACI,oCAAA;Ad0/mBJ;Acz/mBI;EACI,yBX8JK;AH61mBb;;Acx/mBA;EACI,oCAAA;Ad2/mBJ;Ac1/mBI;EACI,yBX6IM;AH+2mBd;;Acz/mBA;EACI,oCAAA;Ad4/mBJ;Ac3/mBI;EACI,yBX4HG;AHi4mBX;;Ac1/mBA;EACI,oCAAA;Ad6/mBJ;Ac5/mBI;EACI,yBXuJM;AHu2mBd;;Ac3/mBA;EACI,oCAAA;EACA,cXuIS;AHu3mBb;;Ac5/mBA;EACC,8BAAA;EACG,sBAAA;Ad+/mBJ;;Ac7/mBA;EACI,mBX3BO;EW4BP,WXxCI;AHwinBR;;Ac9/mBA;EACI,kBAAA;EACA,eX2UW;EW1UX,gBAAA;EACA,eAAA;EACA,WX/CI;AHgjnBR;;Ac//mBA;EACI,kBAAA;EACA,eXoUW;EWnUX,gBAAA;EACA,gBXnGiB;AHqmnBrB;AcjgnBI;EACI,mBX8FM;EW7FN,cXvFE;AH0lnBV;AcjgnBI;EACI,mBX+GM;EW9GN,cXvFE;AH0lnBV;AcjgnBI;EACI,mBXsHK;EWrHL,cX9DC;AHiknBT;AcjgnBI;EACI,mBX4FK;EW3FL,cX7FC;AHgmnBT;;Ae9nnBA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBZgDI;AHilnBR;;Ae/nnBA;EACI,oCAAA;AfkonBJ;AejonBI;EACI,+BAAA;AfmonBR;AejonBI;EACI,+BAAA;AfmonBR;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,8CAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,8CAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,iCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,kDAAA;AfoonBZ;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,kDAAA;AfoonBZ;AelonBQ;EACI,8BAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,kDAAA;AfoonBZ;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,kDAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,8CAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,8CAAA;AfoonBZ;AelonBQ;EACI,+CAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,oCAAA;EACA,UAAA;AfmonBR;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,gDAAA;AfoonBZ;AelonBQ;EACI,iDAAA;AfoonBZ;AelonBQ;EACI,gCAAA;AfoonBZ;AejonBI;EACI,mCAAA;AfmonBR;AejonBI;EACI,oCAAA;AfmonBR;AejonBI;EACI,mCAAA;AfmonBR;AejonBI;EACI,oCAAA;AfmonBR;AejonBI;EACI,iCAAA;AfmonBR;AejonBI;EACI,4BAAA;AfmonBR;AejonBI;EACI,4BAAA;AfmonBR;AejonBI;EACI,4BAAA;AfmonBR;AejonBI;EACI,4BAAA;AfmonBR;AejonBI;EACI,4BAAA;AfmonBR;AejonBI;EACI,wBAAA;AfmonBR;AejonBI;EACI,wBAAA;AfmonBR;AejonBI;EACI,+BAAA;AfmonBR;AejonBI;EACI,+BAAA;AfmonBR;AejonBI;EACI,2BAAA;AfmonBR;AejonBI;EACI,2BAAA;AfmonBR;AejonBI;EACI,iCAAA;AfmonBR;AejonBI;EACI,iCAAA;AfmonBR;AejonBI;EACI,oBAAA;AfmonBR;AejonBI;EACI,gCAAA;AfmonBR;AejonBI;EACI,+BAAA;AfmonBR;AejonBI;EACI,8BAAA;AfmonBR;AejonBI;EACI,iCAAA;AfmonBR;;AehonBA;EACI,wCAAA;AfmonBJ;AelonBI;EACI,mCAAA;AfoonBR;AelonBI;EACI,mCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;AelonBI;EACI,gCAAA;AfoonBR;;AejonBA;EACI,+CAAA;AfoonBJ;AenonBI;EACI,0CAAA;AfqonBR;AenonBI;EACI,0CAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;AenonBI;EACI,gCAAA;AfqonBR;;AelonBA;EACI,2CAAA;AfqonBJ;AeponBI;EACI,sCAAA;AfsonBR;AeponBI;EACI,sCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;AeponBI;EACI,gCAAA;AfsonBR;;AenonBA;EACI,iDAAA;AfsonBJ;AeronBI;EACI,4CAAA;AfuonBR;AeronBI;EACI,4CAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;AeronBI;EACI,gCAAA;AfuonBR;;AeponBA;EACI,wBAAA;AfuonBJ;;AeronBA;EACI,uBAAA;AfwonBJ;;AetonBA;EACI,wBAAA;AfyonBJ;;AevonBA;EACI,sBAAA;Af0onBJ;;AexonBA;EACI,wBAAA;Af2onBJ;;AezonBA;EACI,uBAAA;Af4onBJ;;Ae1onBA;EACI,wBAAA;Af6onBJ;;Ae3onBA;EACI,qBAAA;Af8onBJ;;Ae5onBA;EACI,wBAAA;Af+onBJ;;Ae7onBA;EACI,uBAAA;AfgpnBJ;;Ae9onBA;EACI,wBAAA;AfipnBJ;;Ae/onBA;EACI,sBAAA;AfkpnBJ;;AehpnBA;EACI,6BAAA;AfmpnBJ;;AgB/koBA;EACI,6BAAA;EACA,YAAA;EZsGD,kBYrG4B;AhBkloB/B;;AgBhloBA;EACC,qBbiLU;EahLP,sBbgDI;AHmioBR;;AgBjloBA;EACI,iBAAA;AhBoloBJ;;AgBlloBA;EACC,WAAA;EACA,gBAAA;AhBqloBD;;AgBnloBA;EACI,qBAAA;AhBsloBJ;;AgBploBA;EACC,gBAAA;AhBuloBD;;AgBrloBA;EACC,eb4Zc;Ea3Zd,gBbbsB;EactB,iCAAA;EACA,iBAAA;EACA,yBAAA;AhBwloBD;;AgBtloBA;EACC,iCAAA;AhByloBD;;AgBvloBA;EACC,gBbsBO;AHokoBR;;AgBxloBA;;;;;EAKC,UAAA;AhB2loBD;;AgBzloBA;EACC,mBbmIW;EalIX,eboYc;EanYd,iBAAA;EACA,eAAA;EACA,yBAAA;AhB4loBD;;AgB1loBA;;;;;;;EAOC,qBAAA;AhB6loBD;;AgB3loBA;;EAEI,gBAAA;AhB8loBJ;;AgB5loBA;EACC,mBAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,uBAAA;AhB+loBD;;AgB7loBA;EACC,oBAAA;EACA,ebuWc;AHyvnBf;;AgB9loBA;EACC,mBAAA;AhBimoBD;;AgB/loBA;EACC,mBAAA;AhBkmoBD;;AgBhmoBA;;;EAGC,oCAAA;EACA,sBAAA;EACA,4BAAA;AhBmmoBD;;AgBjmoBA;EACC,mBAAA;AhBomoBD;;AgBlmoBA;EACC,gBbvCO;AH4ooBR;;AgBnmoBA;EACC,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AhBsmoBD;;AgBpmoBA;EACC,kBAAA;EACA,gBbhGkB;EaiGlB,iCAAA;AhBumoBD;;AgBrmoBA;EACC,kBAAA;EACA,gBbrGkB;EasGlB,iCAAA;AhBwmoBD;;AgBtmoBA;EACC,YAAA;AhBymoBD;;AgBvmoBA;EACC,kBAAA;EACA,gBAAA;AhB0moBD;;AgBxmoBA;EACI,mBAAA;EACA,ebsTW;EarTX,gBbnHmB;EaoHnB,gBAAA;EACA,kBAAA;AhB2moBJ;;AiB3uoBA;EACI,aAAA;AjB8uoBJ;;AiB5uoBA;EACI,wBAAA;AjB+uoBJ;;AiB7uoBA;;EAEI,gBAAA;AjBgvoBJ;;AiB9uoBA;EACI,sBAAA;AjBivoBJ;;AiB/uoBA;EACI,aAAA;AjBkvoBJ;;AkB/voBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBf+CA;Ee9CA,kBAAA;EACA,mBAAA;EACA,aAAA;EdgFN,yBc/E0B;AlBowoB5B;AkBnwoBQ;EACI,sBf0CJ;ECmCN,yBc5E8B;AlBuwoBhC;AkBrwoBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBf6BJ;Ee5BI,2BAAA;EACA,mBAAA;EACA,kBAAA;AlBuwoBZ;AkBtwoBY;EACI,WAAA;EACA,cf2BT;AH6uoBP;AkBpwoBY;EACI,efjCC;EekCD,gBf3BO;Ee4BP,WfiBR;EehBQ,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AlBswoBhB;AkBpwoBY;EACI,ef6XD;Ee5XC,cfsOH;AHgioBb;;AkB/voBQ;EACI,gBAAA;EACA,SAAA;EACA,kBAAA;AlBkwoBZ;AkBjwoBY;EACI,mBfxCN;AH2yoBV;AkBlwoBgB;EACI,WfPZ;AH2woBR;AkBjwoBY;EACI,cf9CN;AHizoBV;AkB/voBY;EACI,cfnDN;EeoDM,WAAA;EACA,gBAAA;EACA,efuWD;AH05nBf;;AkB1voBQ;EACI,kBAAA;EACA,mBAAA;AlB6voBZ;AkB5voBY;EACI,mBAAA;AlB8voBhB;AkB5voBY;EACI,WfjCR;EekCQ,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB8voBhB;AkB7voBgB;EAGI,aAAA;EACA,kBAAA;EACA,aAAA;AlB+voBpB;AkB5voBY;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;AlB8voBhB;AkB7voBgB;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EAGA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;AlB+voBpB;AkB9voBoB;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;AlBgwoBxB;AkB/voBwB;EACI,iBAAA;AlBiwoB5B;AkB/voBwB;EACI,WfnFpB;EeoFoB,gBfpFpB;EeqFoB,mBAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,ef4Rb;Ee3Ra,mBAAA;AlBiwoB5B;AI72oBI;Ec4FoB;IAkBQ,WAAA;IACA,YAAA;ElBmwoB9B;AACF;AkBlwoB4B;EACI,cfuHnB;AH6ooBb;AkBlwoB4B;EACI,Wf3GxB;Ee4GwB,mBfrIvB;AHy4oBT;AkBnwoBgC;EACI,Wf9G5B;AHm3oBR;AkB3voBwB;EACI,efmQb;AH0/nBf;AkBtvoBQ;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;AlBwvoBZ;AkBvvoBY;EACI,efyPD;EexPC,gBflLO;EemLP,mBAAA;AlByvoBhB;AI14oBI;Ec8IQ;IAKQ,efmPL;EHwgoBb;AACF;AkBzvoBY;EACI,mBAAA;AlB2voBhB;AkBzvoBoB;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AlB2voBxB;AkB1voBwB;EACI,kBAAA;AlB4voB5B;AkB1voBwB;EACI,WftJpB;EeuJoB,ef3MX;Ee4MW,gBfrML;EesMK,gBAAA;AlB4voB5B;AkBvvoBY;EACI,efwND;EevNC,cf8DH;AH2roBb;AkBtvoBgB;EACI,mBfxMV;EeyMU,8BAAA;EACA,WfvKZ;EewKY,ef3NH;Ee4NG,yBAAA;EACA,gBftNG;EeuNH,gBAAA;EACA,iBAAA;AlBwvoBpB;AkBvvoBoB;EACI,mBfvMf;EewMe,sBAAA;EACA,cfnNd;AH48oBV;;AkBlvoBA;EAGI,aAAA;AlBqvoBJ;AkBpvoBI;EACI,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlBsvoBR;AkBrvoBQ;EACI,UAAA;EACA,kBAAA;AlBuvoBZ;AIr8oBI;Ec4MI;IAIQ,aAAA;IACA,iBAAA;ElByvoBd;AACF;AkBtvoBI;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlBwvoBR;AkBvvoBQ;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlByvoBZ;AkBtvoBoB;EACI,gBAAA;AlBwvoBxB;AkBvvoBwB;EACI,cfnQlB;EeoQkB,WAAA;AlByvoB5B;AkBnvoBQ;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlBqvoBZ;AkBpvoBY;EACI,UAAA;AlBsvoBhB;AkBrvoBgB;EACI,aAAA;EACA,gCAAA;EACA,4BAAA;AlBuvoBpB;AkBpvoBY;EACI,UAAA;EACA,UAAA;AlBsvoBhB;AIz/oBI;EciQQ;IAIQ,WAAA;ElBwvoBlB;AACF;AkBrvoBQ;EACI,UAAA;EACA,UAAA;AlBuvoBZ;AIlgpBI;EcyQI;IAIQ,WAAA;ElByvoBd;AACF;;AkBrvoBA;EACI,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AlBwvoBJ;AkBpvoBgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBsvoBpB;AI7hpBI;Ec2RY;IAcQ,WAAA;IACA,YAAA;ElBwvoBtB;AACF;AkBnvoBI;EACI,mBf1UE;Ee2UF,cAAA;EACA,UAAA;AlBqvoBR;AkBlvoBgB;EACI,Wf7SZ;Ee8SY,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBovoBpB;AItjpBI;EcsTY;IAcQ,WAAA;IACA,YAAA;ElBsvoBtB;AACF;AkBjvoBI;EACI,mBfrWE;EesWF,YAAA;EACA,mBAAA;EACA,YAAA;AlBmvoBR;AkBhvoBgB;EACI,WfzUZ;Ee0UY,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBkvoBpB;AIhlpBI;EckVY;IAcQ,WAAA;IACA,YAAA;ElBovoBtB;AACF;AkBnvoBoB;EACI,efmCT;AHktoBf;;AkB7uoBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBgvoBR;AIrmpBI;Ec4WA;IAWQ,cAAA;ElBkvoBV;AACF;AkBjvoBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBmvoBZ;AkBlvoBY;EACI,iBAAA;AlBovoBhB;AkBnvoBgB;EACI,eAAA;AlBqvoBpB;AkBnvoBgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,Wf5YZ;Ee6YH,eflBU;AHuwoBf;AkBpvoBoB;EACI,yBfzaf;Ee0ae,qBf1af;Ee2ae,WflZhB;EemZF,WAAA;EACe,YAAA;EACf,cAAA;EACA,efzBS;AH+woBf;AkBpvoBoB;EACI,WfzZhB;Ee0ZgB,mBfnbf;Eeobe,qBfpbf;AH0qpBT;AkBrvoBwB;EACI,Wf7ZpB;AHoppBR;AkBlvoBoB;EACI,mBftcd;Eeucc,qBfvcd;Eewcc,WfrahB;AHyppBR;AkBnvoBwB;EACI,iCAAA;AlBqvoB5B;AItqpBI;EcyXI;IA8DQ,kBAAA;IACA,uBAAA;ElBmvoBd;AACF;AI5qpBI;Ec0bQ;IAEQ,kBAAA;ElBovoBlB;AACF;;AkB/uoBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EAGA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AlBkvoBJ;AIjspBI;EckcJ;IAeQ,cAAA;ElBovoBN;AACF;AItspBI;EcmdA;IAEQ,kBAAA;ElBqvoBV;AACF;AkBpvoBQ;EACI,efjFG;EekFH,gBf1fO;Ee2fhB,cf1UQ;Ee2UC,kBAAA;AlBsvoBZ;AIjtpBI;EcudI;IAMQ,efvFD;EH+0oBb;AACF;AkBrvoBY;EACI,ef9FD;Ee+FC,gBfvgBK;EewgBL,cf3PH;Ee4PG,kBAAA;AlBuvoBhB;AkBtvoBgB;EACI,iBAAA;AlBwvoBpB;AI/tpBI;EcieQ;IASQ,mBAAA;ElByvoBlB;AACF;AkBrvoBI;EAGI,aAAA;AlBuvoBR;AkBtvoBQ;EACI,mBAAA;EACA,kBAAA;EACA,Wf5eJ;Ee6eI,yBAAA;EACA,kBAAA;EACA,gBf1hBO;Ee2hBP,efniBK;Ee6iBL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBivoBZ;AkB7voBG;EACC,mBfrhBM;EeshBN,yBAAA;AlB+voBJ;AI5vpBI;EcmfI;IAaQ,ef9HD;EH83oBb;AACF;AkBzvoBY;EACI,eAAA;AlB2voBhB;AkBvvoBY;EACI,WAAA;EACA,YAAA;EACA,mBf3YJ;Ee4YI,kBAAA;EACA,cfzSH;Ee0ST,ef7IW;EegJC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlByvoBhB;AkBxvoBI;EACC,mBfvjBK;EewjBL,WfrhBG;AH+wpBR;;AkBpvoBA;EACI,kBAAA;EACA,kBAAA;AlBuvoBJ;AkBtvoBI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,yBf5jBC;Ee6jBD,WAAA;EACA,YAAA;EACA,mBAAA;AlBwvoBR;AkBtvoBI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBf7iBA;Ee8iBA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;AlBwvoBR;;AkBpvoBA;EACC,WAAA;AlBuvoBD;;AkBrvoBA;EACI,WAAA;EACA,cAAA;AlBwvoBJ;;AkBtvoBA;EACC,kBAAA;EACA,mBAAA;AlByvoBD;AkBxvoBI;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlB0voBR;AkBvvoBQ;EACI,aAAA;AlByvoBZ;;AkBrvoBA;EACI,Wf7kBI;Ee8kBJ,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlBwvoBJ;AkBvvoBI;EACI,gBfzoBW;Ee0oBX,efhOO;EeiOP,WfhmBA;AHy1pBR;;AkBtvoBA;EAGI,aAAA;AlByvoBJ;;AkBvvoBA;;EAEI,aAAA;AlB0voBJ;;AkBvvoBI;EACI,gBf5pBa;Ee6pBb,eftPO;EeuPP,mBAAA;EACA,WfhnBA;AH02pBR;AkBxvoBI;EACI,efxPO;EeyPP,gBAAA;EACA,WfrnBA;EesnBA,gBflqBW;AH45pBnB;;AkBvvoBA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACG,oCAAA;EACA,mBAAA;EACA,iBAAA;AlB0voBJ;AkBzvoBI;EACI,gBfhrBa;EeirBb,ef1QO;Ee2QP,cftaK;EeuaL,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AlB2voBR;AI94pBI;Ec4oBA;IASQ,efnRG;EHghpBb;AACF;AkB3voBI;EACI,gBf/oBA;EegpBA,YAAA;EACA,YAAA;AlB6voBR;AkB5voBQ;EACI,cf7gBD;Ee8gBC,ef7RG;AH2hpBf;;AkBzvoBI;EACI,8BAAA;EACA,YAAA;EACA,YAAA;AlB4voBR;AkB3voBQ;EACI,Wf9pBJ;AH25pBR;;AkBzvoBA;EACI,kBAAA;EdxpBF,kBAAA;EAcE,QAAA;EACA,SAAA;EAGA,gCAAA;AJw4pBJ;AkB/voBQ;EACI,8BAAA;EACA,iBAAA;EACA,mBAAA;AlBiwoBZ;AkBhwoBY;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AlBkwoBhB;AkBjwoBgB;EACI,kBAAA;AlBmwoBpB;AkBjwoBgB;EACI,iBAAA;AlBmwoBpB;AkBjwoBgB;EACI,cAAA;EACA,eAAA;EACA,gBfnuBG;EeouBH,mBAAA;AlBmwoBpB;;AkB7voBA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;AlBgwoBD;AI38pBI;EcwsBJ;IAKQ,WAAA;IACA,WAAA;ElBkwoBN;AACF;AkBjwoBI;EACI,cfxeK;EeyeL,WAAA;EACA,YAAA;EACA,gBf1sBA;Ee2sBA,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBmwoBR;AkBlwoBQ;EACI,YAAA;AlBowoBZ;AkBhwoBgB;EACI,cfpvBX;AHs/pBT;AkB1voBgB;EACI,oCAAA;AlB4voBpB;AkB3voBoB;EACI,WftuBhB;AHm+pBR;;AkBlvoBgB;EACI,8BAAA;AlBqvoBpB;AkBpvoBoB;EACI,WfpvBhB;AH0+pBR;;AkB9uoBI;EACI,SAAA;EACA,UAAA;AlBivoBR;AkB/uoBI;EACI,SAAA;EACA,WAAA;EAGA,aAAA;AlBivoBR;;AkB3uoBY;EACI,efnZD;EeoZF,gBf3zBQ;AHyiqBrB;;AkBtuoBY;EACI,ef7ZD;Ee8ZC,gBfr0BK;AH8iqBrB;;AkBpuoBA;EACC,cAAA;EACA,kBAAA;AlBuuoBD;;AkBruoBA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACG,6BAAA;EACH,UAAA;AlBwuoBD;;AkBtuoBA;;;EAGI,yBAAA;AlByuoBJ;;AkBvuoBA;EACI,mBAAA;EACH,mBAAA;EACG,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACH,UAAA;AlB0uoBD;;AkBxuoBA;EAGC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AlB2uoBD;AkB1uoBI;EACI,qBAAA;AlB4uoBR;;AkBzuoBA;EACC,YAAA;EACG,aAAA;EACA,8BAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlB4uoBJ;;AkBzuoBI;EACI,YAAA;EACA,WAAA;AlB4uoBR;;AkBxuoBI;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlB2uoBR;;AkBvuoBI;EACI,kBAAA;EACA,WAAA;AlB0uoBR;;AkBtuoBI;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AlByuoBR;AkBxuoBQ;EACI,aAAA;AlB0uoBZ;AkBvuoBI;EACI,kBAAA;AlByuoBR;AkBvuoBI;EACI,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAGA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AlByuoBR;AInoqBI;Ec64BA;IAeQ,WAAA;ElB2uoBV;AACF;AIxoqBI;Ec64BA;IAkBQ,iBAAA;ElB6uoBV;AACF;AI7oqBI;Ec64BA;IAqBQ,iBAAA;ElB+uoBV;AACF;AkB9uoBQ;EACI,iBAAA;AlBgvoBZ;AIrpqBI;Eco6BI;IAGQ,kBAAA;ElBkvoBd;AACF;AI1pqBI;Ec64BA;IA8BQ,WAAA;IACA,iBAAA;ElBmvoBV;AACF;;AIhqqBI;Eck7BA;IAEO,UAAA;ElBivoBT;AACF;AkBhvoBQ;EACI,kBAAA;AlBkvoBZ;AIzqqBI;Ecs7BI;IAGQ,iBAAA;ElBovoBd;AACF;AkBlvoBQ;EACI,iBAAA;AlBovoBZ;AIjrqBI;Ec+7BY;IACI,iBAAA;ElBqvoBlB;AACF;;AkB9uoBQ;EACI,YAAA;AlBivoBZ;;AkB3uoBQ;EACI,kBAAA;AlB8uoBZ;AkB5uoBQ;EACI,iBAAA;AlB8uoBZ;AIjsqBI;Ecq9BI;IAEQ,eAAA;ElB8uoBd;AACF;;AkB1uoBA;EACC,Wfn9BO;Eeo9BJ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AlB6uoBJ;AkB5uoBI;EACI,Wfz9BA;AHusqBR;;AkB3uoBA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,ef5lBW;Ee6lBd,gBf7gCkB;EeghCf,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlB8uoBJ;;AkB5uoBA;EACC,aAAA;AlB+uoBD;;AkB7uoBA;EACI,oBAAA;AlBgvoBJ;;AkB9uoBA;EACI,UAAA;AlBivoBJ;AI/uqBI;Ec6/BJ;IAGQ,UAAA;ElBmvoBN;AACF;AIpvqBI;EckgCA;IAEQ,iBAAA;ElBovoBV;AACF;AIzvqBI;EcugCA;IAEQ,kBAAA;ElBovoBV;AACF;;AkBhvoBA;EACC,eAAA;EACA,uBAAA;AlBmvoBD;;AkBjvoBA;EACC,kBAAA;EACA,SAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;AlBovoBD;;AkBlvoBA;EACC,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AlBqvoBD;;AkBjvoBQ;EACI,aAAA;AlBovoBZ;AkBnvoBY;EACI,cAAA;EACA,oBAAA;AlBqvoBhB;;AkBhvoBA;EACC,6BAAA;EACA,UAAA;AlBmvoBD;;AkBjvoBA;EACC;IAAM,cAAA;ElBqvoBL;EkBpvoBD;IAAI,kBAAA;ElBuvoBH;AACF;AkBrvoBI;EAGI,aAAA;EAGA,mBAAA;EACA,qBAAA;EACA,iBAAA;AlBuvoBR;AIlzqBI;EcmjCA;IAUQ,cAAA;ElByvoBV;AACF;AkBvvoBY;EACI,SAAA;EACA,mBAAA;AlByvoBhB;AkBvvoBY;EACI,UAAA;EACA,YAAA;EACA,aAAA;AlByvoBhB;AIh0qBI;EcokCQ;IAKQ,WAAA;ElB2voBlB;AACF;AkBxvoBQ;EACI,UAAA;AlB0voBZ;AIx0qBI;Ec6kCI;IAGQ,UAAA;ElB4voBd;AACF;AI70qBI;Ec6kCI;IAMQ,WAAA;ElB8voBd;AACF;AkB3voBI;EACI,sBAAA;EACA,aAAA;AlB6voBR;;AkB1voBA;EACC,cAAA;AlB6voBD;;AkB3voBA;EACC,SAAA;AlB8voBD;;AkB5voBA;EACC,WAAA;AlB+voBD;;AkB7voBA;EACC,mBAAA;EACA,Wf7lCO;AH61qBR;;AkB7voBI;EACI,aAAA;AlBgwoBR;AkB9voBI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AlBgwoBR;AkB/voBQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AlBiwoBZ;AkBhwoBY;EACI,aAAA;AlBkwoBhB;;AkB7voBA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AlBgwoBJ;AkB/voBC;EACC,0CAAA;EACA,qBAAA;EACA,oBAAA;EACA,Wf9nCM;Ee+nCN,eftwBa;EeuwBb,gBf5qCqB;Ee6qCrB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AlBiwoBF;AkBhwoBE;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBf5oCK;Ee6oCL,WAAA;EACA,YAAA;EACA,mBAAA;AlBkwoBH;AkBhwoBE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,yBf/qCM;EegrCN,UAAA;EACA,WAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;AlBkwoBH;;AkB7voBA;EACC;IACC,kBAAA;ElBgwoBA;AACF;AkBxvoBA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;AlB+voBD;;AkB7voBA;EACC,yBfjjCU;EekjCP,oBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AlBgwoBJ;;AkB9voBA;EACC,kBAAA;EACG,SAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,gBf/rCI;EegsCJ,mBAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBiwoBJ;;AkB/voBA;EACC,WAAA;EACG,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBf7uCM;Ee8uCN,YAAA;EACA,mBAAA;EACA,aAAA;AlBkwoBJ;;AkBhwoBA;EACC,WAAA;EACG,YAAA;EACA,mBAAA;EACA,mBftvCM;EeuvCN,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBmwoBJ;;AkBjwoBA;EACC,WAAA;EACG,aAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;AlBowoBJ;;AkBjwoBA;EACC,kBAAA;EACA,gBAAA;EACA,WAAA;AlBowoBD;;AkBjwoBA;EACC,Wf5uCO;Ee6uCP,gBAAA;EACA,efl3Bc;Eem3Bd,gBAAA;AlBowoBD;;AkBlwoBA;EACI,aAAA;AlBqwoBJ;AkBpwoBI;EACI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AlBswoBR;AIvgrBI;Ec6vCA;IAMQ,eAAA;ElBwwoBV;AACF;AkBpwoBoB;EACI,cfvvChB;AH6/qBR;AkBjwoBQ;EACI,iBAAA;EACA,2BAAA;AlBowoBZ;AkBlwoBY;EACI,QAAA;EACA,gBAAA;AlBowoBhB;AkBnwoBgB;EACI,yBfjpCR;EekpCQ,kBAAA;AlBqwoBpB;AkBpwoBoB;EACI,2BAAA;EACA,mCAAA;AlBswoBxB;AkBpwoBoB;EACI,kBAAA;AlBswoBxB;AkBpwoB4B;EACI,iBAAA;AlBswoBhC;AkBrwoBgC;EACI,iBAAA;AlBuwoBpC;AkBrwoBgC;EACI,kBAAA;AlBuwoBpC;AkBpwoB4C;EAEI,iBAAA;EACA,kBfhyCxC;AHsirBR;AkBnwoBwC;EACI,kBAAA;Ed1xC1C,kBAAA;EAcE,QAAA;EACA,SAAA;EAGA,gCAAA;AJmhrBJ;AkBzwoB4C;EACI,WfxyCxC;AHmjrBR;AkBvwoBoC;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AlBywoBxC;AkBxwoBwC;EACI,WflzCpC;EemzCoC,eAAA;AlB0woB5C;AkBvwoBoC;EACI,kBAAA;AlBywoBxC;AkBnwoBoB;EACI,oCAAA;EACA,8BAAA;EACA,eAAA;EACA,iCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AlBqwoBxB;AkBjwoBY;EACI,uBAAA;AlBmwoBhB;AkBjwoBY;EACI,QAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;AlBmwoBhB;AkBhwoBwB;EACI,cfn1CpB;AHqlrBR;AkB5voBQ;EACI,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AlB8voBZ;AkB7voBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AlB+voBhB;AkB5voBQ;EACI,yBfpvCA;EeqvCA,kBAAA;EACA,kBAAA;EACA,gBf/5CS;Eeg6CT,kBAAA;EACA,kBAAA;AlB8voBZ;AkB7voBY;EACI,ef9/BD;Ee+/BC,cfjvCL;EekvCK,kBAAA;EACA,gBAAA;EACA,gBfv6CK;AHsqrBrB;AkB7voBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,efjhCD;EekhCC,gBfp7CK;Eeq7CL,cfh4CR;Eei4CQ,gBAAA;AlB+voBhB;AkB9voBgB;EACI,WAAA;AlBgwoBpB;AkB7voBY;EACI,oCAAA;EACA,+BAAA;EACA,iCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AlB+voBhB;AkB3voBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBfp9CK;Eeq9CL,cfzsCH;AHs8qBb;AkB5voBI;EACC,eAAA;EACA,cAAA;AlB8voBL;AkBzvoBI;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AlB2voBR;AkB1voBQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,yBfr7CJ;Ees7CI,WAAA;EACA,WAAA;AlB4voBZ;AkB1voBQ;EACI,yBf17CJ;Ee27CI,cf37CJ;Ee47CI,ef5kCG;Ee6kCH,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBfp/CW;Eeq/CX,kBAAA;AlB4voBZ;;AkBrvoBY;EACI,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;AlBwvoBhB;AkBvvoBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlByvoBpB;AkBtvoBoB;EACI,WAAA;EACA,cf59ChB;AHotrBR;AkBpvoBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gCAAA;EACA,oBAAA;AlBsvoBhB;AkBnvoBwB;EACI,cf/+CpB;Eeg/CoB,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AlBqvoB5B;AkBpvoB4B;EACI,mBfjiDtB;EekiDsB,qBfliDtB;AHwxrBV;AkBrvoBgC;EACI,WfjgD5B;AHwvrBR;AkBpvoB4B;EACI,WAAA;AlBsvoBhC;AkB7uoBQ;EACI,YAAA;AlB+uoBZ;AkB9uoBY;EACI,aAAA;EACA,gBAAA;EACA,yBfjzCN;EekzCM,4BAAA;AlBgvoBhB;AkB/uoBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBivoBpB;AkBhvoBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBfnkDd;EeokDc,mBAAA;EACA,efjrCT;EekrCS,Wf3iDhB;Ee4iDgB,iBAAA;AlBkvoBxB;AkB9uoBY;EACI,aAAA;AlBgvoBhB;AkB/uoBgB;EACI,sBAAA;EACA,aAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;AlBivoBpB;AkBhvoBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AlBkvoBxB;AkBjvoBwB;EACI,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AlBmvoB5B;AkBjvoBwB;EACI,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AlBmvoB5B;AkBlvoB4B;EACI,MAAA;EACA,eAAA;AlBovoBhC;AkBlvoB4B;EACI,kBAAA;AlBovoBhC;AkBjvoBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,YAAA;AlBmvoB5B;AkBlvoB4B;EACI,aAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBovoBhC;AkBnvoBgC;EACI,efxvCrB;EeyvCqB,gBfjqDf;EekqDe,kBAAA;EACA,cft5CvB;Eeu5CuB,mBAAA;EACA,gBAAA;EACA,uBAAA;AlBqvoBpC;AkBnvoBgC;EACI,efpwCrB;EeqwCqB,cfrpD3B;EewpD2B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBqvoBpC;AkBpvoBoC;EACI,WAAA;EACA,YAAA;AlBsvoBxC;AkBhvoBoC;EACI,cfrqD/B;AHu5rBT;AkB7uoBgC;EACI,ef7xCrB;Ee8xCqB,cf7gDzB;Ee8gDyB,gBfjsDf;AHg7rBrB;AkB7uoBgC;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,yBfpsD1B;EeqsD0B,WflqD5B;EemqD4B,kBAAA;EACA,iBAAA;EACA,eAAA;AlB+uoBpC;AkB5uoB4B;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlB8uoBhC;AkB5uoBoC;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cfvjD7B;EewjD6B,mBAAA;AlB8uoBxC;AkB7uoBwC;EACI,cf1jDjC;AHyyrBX;AkBpuoBI;EACI,sCAAA;AlBsuoBR;AkBruoBQ;EACI,sCAAA;AlBuuoBZ;AkBpuoBI;EACI,gBfltDA;EemtDN,8DAAA;EACA,yBAAA;EACM,mBAAA;EACA,aAAA;AlBsuoBR;AkBruoBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACT,yBfhgDO;AHuurBV;AkBruoBgB;EACI,efz2CL;Ee02CK,gBflxDG;EemxDH,cfjmDT;EekmDS,gBAAA;AlBuuoBpB;AkBnuoBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AlBquoBpB;AkBpuoBoB;EACI,mBf9xDd;AHogsBV;AkBruoBwB;EACI,Wf7vDpB;AHo+rBR;AkBpuoBoB;EACI,WAAA;EACA,cf3xDf;AHigsBT;AkBjuoBE;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBf7wDK;AHg/rBR;AkBluoBG;EAGa,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACZ,kBAAA;AlBouoBJ;AkBnuoBI;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBquoBL;AkBpuoBK;EACC,cf9jDO;AHoyrBb;AkBnuoBI;EACC,cAAA;EACA,UAAA;AlBquoBL;AkBnuoBI;EACC,cAAA;EACA,UAAA;AlBquoBL;AkBnuoBI;EACC,WAAA;EACA,aAAA;AlBquoBL;AkBpuoBK;EAGC,aAAA;EAGA,mBAAA;EACA,efv7CS;AH6prBf;AkBnuoBI;EACC,UAAA;AlBquoBL;AkBpuoBK;EAGmB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAClB,WAAA;EACA,YAAA;EACA,mBft2DI;Eeu2DJ,mBAAA;AlBsuoBN;AkBruoBM;EACC,mBAAA;AlBuuoBP;AkBtuoBO;EACC,Wfx0DA;AHgjsBR;AkBruoBM;EACC,WAAA;EACA,Wf70DC;AHojsBR;AkBnuoBI;EACC,mBAAA;EACA,iBAAA;EACA,gBfp1DG;Eeq1DH,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AlBquoBL;AkBpuoBK;EACC,ef74DW;Ee84DX,yBAAA;AlBsuoBN;;AkB9toBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;AlBiuoBR;AkB/toBI;EACI,QAAA;EAGA,6BAAA;AlBiuoBR;AI9lsBI;Ecy3DA;IAMQ,WAAA;IAGA,aAAA;IACA,8BAAA;IACA,sCAAA;IACA,4BAAA;ElBmuoBV;AACF;AkBluoBQ;EACI,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBouoBZ;AkBnuoBY;EACI,yBf56DN;AHipsBV;AkBpuoBgB;EACI,Wf34DZ;AHinsBR;AkBnuoBY;EACI,cfhrDH;AHq5rBb;;AkBhuoBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AlBmuoBJ;AkBluoBI;EAGI,aAAA;EAGA,mBAAA;EACA,6BAAA;EACA,qCAAA;EACA,2BAAA;EACA,WAAA;AlBouoBR;AkBnuoBQ;EACI,kBAAA;AlBquoBZ;AkBluoBoB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AlBouoBxB;AIpqsBI;Ecw7DgB;IAUQ,YAAA;IACA,aAAA;IACA,WAAA;IACA,UAAA;ElBsuoB1B;AACF;AI5qsBI;Ecw7DgB;IAgBQ,YAAA;IACA,aAAA;IACA,UAAA;IACA,SAAA;ElBwuoB1B;AACF;AkBpuoBY;EACI,YAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AlBsuoBhB;AI1rsBI;Ecg9DQ;IAMQ,YAAA;IACA,aAAA;ElBwuoBlB;AACF;AIhssBI;Ecg9DQ;IAUQ,WAAA;IACA,YAAA;ElB0uoBlB;AACF;AkBzuoBgB;EACI,WAAA;EACA,kBAAA;AlB2uoBpB;AkBvuoBgB;EACI,efjmDL;EekmDK,Wf39DZ;Ee49DY,gBf1gEC;Ee2gED,0BAAA;EACA,kBAAA;EACA,gBAAA;AlByuoBpB;AIltsBI;Ecm+DY;IAQQ,gBAAA;ElB2uoBtB;AACF;AkBxuoBY;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EAGA,gCAAA;EACA,UAAA;AlB0uoBhB;AIjusBI;Ec++DQ;IAUQ,WAAA;ElB4uoBlB;AACF;AkB3uoBgB;EACI,yBfrhEV;EeshEU,Wfn/DZ;AHgusBR;;AkBvuoBA;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBf/3DO;Eeg4DP,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;AlB0uoBJ;AkBxuoBQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,mBAAA;EACA,gBf5gEJ;Ee6gEI,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB0uoBZ;;AkBtuoBA;EACI,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBf/hEI;EegiEJ,kBAAA;EACA,yBAAA;AlByuoBJ;;AkBvuoBA;EAEI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AlB0uoBJ;;AkBxuoBA;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AlB2uoBJ;;AkBxuoBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB2uoBJ;AIlzsBI;EcwkEA;IAEQ,eAAA;IACD,sBAAA;ElB4uoBT;AACF;AkB3uoBQ;EACI,mBAAA;AlB6uoBZ;AkB5uoBY;EACI,eAAA;AlB8uoBhB;AkB1uoBI;EACI,kBAAA;EACA,cAAA;AlB4uoBR;AkB3uoBQ;EACI,eAAA;AlB6uoBZ;AkB3uoBQ;EACI,eAAA;AlB6uoBZ;AIx0sBI;Ec0lEI;IAGQ,aAAA;ElB+uoBd;AACF;AkB7uoBQ;EACI,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBflmEJ;EemmEI,kBAAA;EACA,YAAA;AlB+uoBZ;AkB9uoBY;EACI,cfh+DL;AHgtsBX;AkB9uoBY;EACI,mBAAA;AlBgvoBhB;AkB9uoBY;EACI,kBAAA;AlBgvoBhB;AkB9uoBY;EACI,yBfz+DL;Ee0+DK,WfhnER;EeinEQ,aAAA;EACA,gBf7pEG;Ee8pEH,eftqEC;AHs5sBjB;AkB/uoBgB;EACI,yBfxpEV;AHy4sBV;AkB/uoBgB;EACI,WAAA;EACA,iBAAA;EACA,Wf1nEZ;AH22sBR;AIr3sBI;EcwnEQ;IAeQ,YAAA;IACA,efjrEH;EHm6sBf;AACF;AkBhvoBY;EACI,cf9nET;AHg3sBP;AkB/uoBQ;EACI,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBfjpEJ;EekpEI,kBAAA;EACA,iBAAA;AlBivoBZ;AkBhvoBY;EACI,kBAAA;AlBkvoBhB;;AmB77sBI;EACF,qCAAA;AnBg8sBF;AmB77sBQ;EACI,chBgRC;AH+qsBb;AmB37sBI;EAGI,aAAA;EAGA,mBAAA;AnB67sBR;AmB37sBI;EACI,iBAAA;AnB67sBR;AmB37sBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnB67sBR;AmB37sBI;EACI,cAAA;AnB67sBR;AmB37sBI;EACI,kBAAA;AnB67sBR;AmB37sBI;EACI,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnB67sBR;AmB17sBI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;EAGA,6BAAA;AnB47sBR;AmB17sBI;EACI,kBAAA;EACA,YAAA;AnB47sBR;AmB17sBI;EACI,kBAAA;EACA,YAAA;AnB47sBR;AmB17sBI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnB47sBR;AmB17sBI;EAGI,aAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnB47sBR;AmB17sBI;EACI,UAAA;EACN,aAAA;EACA,mBAAA;AnB47sBF;AmB17sBI;EACI,mBAAA;AnB47sBR;AmB17sBI;EACI,ehB4UO;EgB3UP,cAAA;AnB47sBR;AmBz7sBI;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;AnB27sBR;AmBz7sBI;EACI,aAAA;AnB27sBR;AmBz7sBI;EACI,iBAAA;AnB27sBR;AmBz7sBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnB27sBR;AmBx7sBE;EACC,sBAAA;AnB07sBH;AmBx7sBE;EACC,gBAAA;EAAA,iBAAA;AnB07sBH;AIjhtBI;EesFF;IAGE,cAAA;EnB47sBF;AACF;AmB17sBE;EACC,aAAA;EACA,gCAAA;EACA,gBAAA;AnB47sBH;AmBz7sBG;EACC,ehBmSW;EgBlSX,chB4CO;EgB3CP,gBhBtIe;AHiktBnB;AmBx7sBE;EACC,sCAAA;AnB07sBH;AmBx7sBE;EACC,ehBuRY;EgBtRZ,eAAA;EACA,iBAAA;EACA,gBhBlJkB;EgBmJlB,cAAA;AnB07sBH;AmBx7sBE;EACC,ehBkRY;EgBjRZ,cAAA;AnB07sBH;AmBv7sBE;EACC,YAAA;EACA,ehB6QY;EgB5QZ,cAAA;AnBy7sBH;AmBt7sBE;EACC,gBAAA;EACA,cAAA;AnBw7sBH;AmBr7sBE;;;EAGC,yBAAA;AnBu7sBH;AmBr7sBE;EACC,gBhB9HK;EgB+HL,yBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;AnBu7sBH;AmBp7sBE;EACC,SAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;AnBs7sBH;AmBp7sBE;EACC,ehB0OY;EgBzOZ,cAAA;AnBs7sBH;AmBp7sBE;;;EAGC,yBAAA;AnBs7sBH;AmBp7sBE;EACC,kBAAA;EAGA,aAAA;EAGA,mBAAA;AnBs7sBH;AmBp7sBE;EAGC,aAAA;EAGA,mBAAA;AnBs7sBH;AmBx6sBA;EACC;IAEC,eAAA;IAAA,kBAAA;EnBo7sBA;EmBl7sBD;IAEC,2BAAA;EnBo7sBA;AACF;AmBl7sBA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,gBhBvMO;AH2ntBR;AmBn7sBC;EACC,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACM,iDAAA;EAAA,gEAAA;EACA,gBAAA;EAAA,8BAAA;EACA,sDAAA;EACN,kBAAA;AnBq7sBF;AmBp7sBE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnBs7sBH;AmBr7sBG;EACC,kBAAA;AnBu7sBJ;AmBr7sBG;EACC,ehB8JW;EgB7JX,gBhBzQmB;EgB0QnB,kBAAA;EACA,cAAA;EACA,chB1FO;AHihtBX;AmBn7sBG;EACC,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnBq7sBJ;AmBn7sBK;EACC,ehB6IS;EgB5IT,chBvGK;EgBwGL,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;AnBq7sBN;AmBp7sBM;EACC,ehBmIQ;AHmzsBf;AmBn7sBO;EACC,yBhBhIG;EgBiIH,qBhBjIG;AHsjtBX;AmB76sBC;EACC,SAAA;EACA,aAAA;EACA,oBAAA;AnB+6sBF;AmB96sBE;EACC,gBAAA;AnBg7sBH;AmB96sBE;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,+BAAA;AnBg7sBH;AmB/6sBG;EACC,cAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AnBi7sBJ;AmBh7sBI;EACC,gBAAA;AnBk7sBL;AmBh7sBI;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AnBk7sBL;AmBj7sBK;EACC,kBAAA;AnBm7sBN;AmBj7sBK;EACC,ehBmFS;EgBlFT,gBAAA;AnBm7sBN;AmBj7sBK;EACC,WhB3SE;EgB4SF,eAAA;EACA,eAAA;EACA,gBhB5Ve;AH+wtBrB;AmBl7sBM;EACC,+BAAA;AnBo7sBP;AmBn7sBO;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AnBq7sBR;AmBh7sBI;EACC,iCAAA;EACe,mBAAA;EAAA,uCAAA;EACf,kBAAA;EACA,chBxLM;EgByLN,ehB0DU;EgBzDV,gBhB9WgB;EgB+WhB,uDAAA;AnBk7sBL;AmBj7sBK;EACC,chB5TC;AH+utBP;AmB/6sBK;EACC,chBlMK;EgBmML,kBAAA;EACA,cAAA;AnBi7sBN;AmB/6sBK;EACC,mBAAA;AnBi7sBN;AmB76sBK;EACC,aAAA;AnB+6sBN;AmB16sBM;EACC,kBAAA;EACA,WhBzVC;EgB0VD,eAAA;EACA,gBhBxYc;EgByYd,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AnB46sBP;AmBt6sBI;EACC,gBAAA;EACA,chBnOM;EgBoON,gBhBtZkB;EgBuZlB,ehBeU;AHy5sBf;AmBv6sBK;EACC,eAAA;EACA,chB5OK;EgB6OL,gBhB7Ze;EgB8Zf,kBAAA;AnBy6sBN;AmBr6sBG;EACC,iBAAA;AnBu6sBJ;AmBt6sBI;EACC,yBAAA;AnBw6sBL;AmBt6sBI;EACC,iCAAA;EACe,oCAAA;EACf,chBtPM;EgBuPN,aAAA;AnBw6sBL;AmBv6sBK;EACC,2BAAA;EACA,mCAAA;AnBy6sBN;AmBx6sBM;EACC,chBhQI;AH0qtBX;AmBz6sBO;EACC,chB7XD;AHwytBP;AmBt6sBI;EACC,QAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;AnBw6sBL;AmBv6sBK;EACC,WAAA;EACA,kBAAA;AnBy6sBN;AmBv6sBK;EACC,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oBAAA;EACA,chBzRK;AHkstBX;AmBt6sBI;EACC,QAAA;EACA,gBAAA;AnBw6sBL;AmBt6sBI;EACC,uBAAA;AnBw6sBL;AmBr6sBG;EACC,kBAAA;AnBu6sBJ;AmBt6sBI;EACC,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;AnBw6sBL;AmBv6sBK;EACC,gBAAA;AnBy6sBN;AmBt6sBI;EACC,kBAAA;AnBw6sBL;AmBt6sBM;EACC,6BAAA;EACA,WAAA;EACA,kBAAA;AnBw6sBP;AmBl6sBM;EAEC,iBAAA;AnBo6sBP;AmBh6sBI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AnBk6sBL;AmBj6sBK;EACC,WhB3cE;EgB4cF,eAAA;AnBm6sBN;AmBj6sBK;EACC,gBAAA;AnBm6sBN;AmBh6sBM;EACC,WAAA;AnBk6sBP;AmB75sBG;EAqBC,kBAAA;EACA,mBhBnXQ;EgBoXR,mBAAA;EACA,aAAA;EACA,kBAAA;AnB24sBJ;AmBn6sBI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AnBq6sBL;AmBp6sBK;EACC,WhBheE;EgBieF,eAAA;EACA,chB7VK;AHmwtBX;AmBp6sBK;EACC,gBAAA;AnBs6sBN;AmBn6sBM;EACC,WAAA;AnBq6sBP;AmB55sBI;EACC,WAAA;EACA,YAAA;EACA,sBhBrfG;EgBsfH,kBAAA;AnB85sBL;AmB75sBK;EACC,chBtXK;EgBuXL,ehB1HS;AHyhtBf;AmB35sBK;EACC,chBxXK;EgByXL,qBAAA;EACA,WAAA;EACA,ehBvIS;EgBwIT,gBhB/iBe;AH48tBrB;AmB35sBK;EACC,chBnYK;EgBoYL,qBAAA;EACA,WAAA;AnB65sBN;AmB35sBK;EAGC,aAAA;EAGA,mBAAA;EACA,UAAA;EACA,gBAAA;AnB65sBN;AmB55sBM;EACC,gBAAA;EACA,chB9YI;EgB+YJ,ehB5JQ;EgB6JR,kBAAA;AnB85sBP;AmB75sBO;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AnB+5sBR;AmB55sBQ;EACC,aAAA;AnB85sBT;AmB35sBO;EACC,chBzkBE;AHs+tBV;AmB15sBM;EACC,kBAAA;AnB45sBP;AmBr5sBC;EACC,yBAAA;UAAA,iBAAA;AnBu5sBF;AmBr5sBC;EACC,kBAAA;AnBu5sBF;AmBt5sBE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AnBw5sBH;AIj+tBI;EegkBF;IAWE,oBAAA;EnB05sBF;AACF;AmBx5sBI;EACC,gBAAA;EACA,chBrcM;EgBscN,ehB1MU;EgB2MV,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AnB05sBL;AmBz5sBK;EACC,eAAA;AnB25sBN;AmBx5sBI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACe,mBhB3nBV;EgB4nBL,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AnB05sBL;AmBz5sBK;EACC,sBhB/lBE;EgBgmBF,qBhB3dK;AHs3tBX;AmB15sBM;EACC,chB7dI;AHy3tBX;AmBz5sBK;EACC,gBAAA;AnB25sBN;AmBt5sBI;EACC,chBveM;EgBweN,eAAA;AnBw5sBL;AmBr5sBG;EAKC,cAAA;EACA,UAAA;AnBm5sBJ;AmBx5sBI;EACC,chB7eM;EgB8eN,ehBtPU;AHgptBf;AmBr5sBG;EAMC,cAAA;EACA,UAAA;AnBk5sBJ;AmBx5sBI;EACC,chBrfM;EgBsfN,ehB9PU;EgB+PV,ehB9PU;AHwptBf;AmBr5sBG;EACC,kBAAA;AnBu5sBJ;AmBt5sBI;EACC,WAAA;EACA,YAAA;EACA,gBhBtoBG;EgBuoBH,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBw5sBL;AmBv5sBK;EACC,yBhBphBK;EgBqhBL,qBhBrhBK;AH86tBX;AmBv5sBK;EACC,chBhhBK;EgBihBL,ehB3RS;AHortBf;AmBp5sBI;EACC,chBvhBM;EgBwhBN,UAAA;AnBs5sBL;AmBp5sBI;EACC,chB3hBM;EgB4hBN,UAAA;AnBs5sBL;AmBp5sBI;EACC,chB/hBM;EgBgiBN,UAAA;AnBs5sBL;AmBp5sBI;EACC,chBniBM;EgBoiBN,UAAA;AnBs5sBL;AmB74sBE;EACC,gBAAA;AnB+4sBH;AmB34sBA;EACC,chBnjBU;EgBojBV,ehBjUc;AH8stBf;AmB34sBA;EACC,aAAA;EACA,eAAA;AnB64sBD;AmB34sBA;EACC,gBAAA;AnB64sBD;AmBz4sBE;EACC,mBhBzuBO;EgB0uBP,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBpkBQ;EgBqkBR,UAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,sBAAA;AnB24sBH;AmB14sBG;EACC,mBAAA;EACA,WhBxtBI;AHomuBR;AmBx4sBC;EACC,gCAAA;EACA,gBAAA;EACA,oBAAA;AnB04sBF;AmBt4sBC;EACC,chB9lBS;EgB+lBT,ehB5Wa;EgB6Wb,gBhBpxBmB;EgBqxBnB,mBAAA;EACA,cAAA;AnBw4sBF;AmBr4sBA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,ehBxXc;EgByXd,WhBlvBO;EgBmvBP,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;AnBu4sBD;AmBp4sBC;EACC,WhB/vBM;EgBgwBN,yBhBzuBY;EgB0uBZ,qBhBzuBY;AH+muBd;AmBn4sBA;EACC,eAAA;AnBq4sBD;AmBn4sBA;EACC,yBhBxoBU;EgByoBV,qBhBxoBU;EgByoBV,6BAAA;EACA,2BAAA;AnBq4sBD;AmBn4sBA;EACC,yBhB9oBU;EgB+oBV,qBhB9oBU;EgB+oBV,6BAAA;EACA,2BAAA;AnBq4sBD;AmBn4sBA;EACC,ehBxZc;AH6xtBf;AmBn4sBA;EACC,gBAAA;AnBq4sBD;AmBn4sBA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AnBq4sBD;AmBp4sBC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,sBhB1yBM;EgB2yBN,chBrqBS;EgBsqBT,ehBlba;EgBmbb,gBhB11BmB;AHguuBrB;AmBr4sBE;EACC,qBhBhrBQ;AHujuBX;AmBr4sBE;EACC,qBhBnrBQ;AH0juBX;AmBr4sBE;EACC,qBhBtrBQ;AH6juBX;AmBn4sBA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;AnBq4sBD;AmBn4sBA;EACC,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AnBq4sBD;AmBp4sBC;EACC,ehBpda;EgBqdb,chB1sBS;AHgluBX;AmBn4sBA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AnBq4sBD;AmBp4sBC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,sBhBp2BM;EgBq2BN,chB/tBS;EgBguBT,ehB5ea;EgB6eb,gBhBp5BmB;AH0xuBrB;AmBr4sBE;EACC,qBhB1uBQ;AHinuBX;AmBr4sBE;EACC,qBhB7uBQ;AHonuBX;AmBr4sBE;EACC,qBhBhvBQ;AHunuBX;AmBn4sBA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;AnBq4sBD;AmBn4sBA;EACC,kBAAA;AnBq4sBD;AmBn4sBA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chB7vBU;EgB8vBV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AnBq4sBD;AmBn4sBA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chB7wBU;EgB8wBV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AnBq4sBD;AmBn4sBA;EACC,sBAAA;AnBq4sBD;AmBn4sBA;EACC,YAAA;EACA,WAAA;AnBq4sBD;AmBn4sBA;EACC,yBAAA;EACA,chBryBU;EgBsyBV,kBAAA;EACA,eAAA;EACA,gBhBx9BoB;EgBy9BpB,gBAAA;EACA,oBAAA;AnBq4sBD;AmBn4sBA;EACC,yBAAA;EACA,chB/yBU;EgBgzBV,kBAAA;EACA,cAAA;EACA,gBhBj+BoB;EgBk+BpB,gBAAA;EACA,mBAAA;AnBq4sBD;AmBn4sBA;EACC,gBAAA;AnBq4sBD;AmBl4sBC;EACC,mBAAA;AnBo4sBF;AmBj4sBA;EACC,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnBm4sBD;AmBj4sBA;EAGC,aAAA;EAGA,mBAAA;EACA,kBAAA;AnBm4sBD;AmBj4sBE;EAGC,aAAA;AnBm4sBH;AmB93sBC;EACC,kBAAA;AnBg4sBF;AmB73sBA;EACC,aAAA;AnB+3sBD;AmB93sBC;EACC,UAAA;EACA,mBAAA;AnBg4sBF;AmB93sBC;EACC,UAAA;AnBg4sBF;AmB73sBA;EACC,mBAAA;AnB+3sBD;AmB93sBC;EACC,mBAAA;AnBg4sBF;AmB73sBA;EACC,2BAAA;AnBg4sBD;AmB73sBA;EAGC,aAAA;EAGA,mBAAA;AnB+3sBD;AmB93sBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AnBg4sBF;AmB/3sBE;EACC,WAAA;AnBi4sBH;AmB93sBC;EACC,chB33BS;EgB43BT,ehBxoBa;EgByoBb,gBhBhjCmB;EgBijCnB,gBAAA;AnBg4sBF;AmB93sBG;EACC,chBv1BU;AHutuBd;AmB13sBC;EAGC,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;AnB43sBF;AmB13sBG;EACC,WAAA;EACA,YAAA;EACA,mBhBhkCM;EgBikCN,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnB43sBJ;AmBx3sBC;EACC,gBAAA;EACA,chBv6BS;EgBw6BT,ehBrrBa;EgBsrBb,gBhB7lCmB;EgB8lCnB,gBAAA;AnB03sBF;AmBx3sBC;EACC,kBAAA;AnB03sBF;AmBt3sBC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AnBw3sBF;AmBv3sBE;EACC,WhB7jCK;EgB8jCL,eAAA;AnBy3sBH;AmBv3sBE;EACC,gBAAA;AnBy3sBH;AmBt3sBG;EACC,WAAA;AnBw3sBJ;AmBp3sBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnBs3sBF;AmBp3sBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBs3sBF;AmBr3sBE;EACC,WAAA;EACA,UAAA;EACA,YAAA;AnBu3sBH;AmBt3sBG;EACC,kBAAA;AnBw3sBJ;AmBt3sBK;EACC,WAAA;AnBw3sBN;AmBn3sBE;EACC,WAAA;AnBq3sBH;AmB/2sBE;EACC,SAAA;EACA,YAAA;AnBi3sBH;AmBh3sBG;EACC,mBAAA;EACA,iBAAA;AnBk3sBJ;AmB52sBG;EACC,chBh/BO;EgBi/BP,ehBvvBW;EgBwvBX,mBAAA;EACA,iBAAA;EACA,gBhBlqCmB;AHghvBvB;AmB52sBG;EACC,YAAA;EACA,UAAA;AnB82sBJ;AmB72sBI;EACC,qBhBx/BM;EgBy/BN,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,wBAAA;EACA,gCAAA;AnB+2sBL;AmB32sBE;EACC,yBhBvgCQ;AHo3uBX;AmB32sBE;EACC,sBAAA;EACA,gBAAA;AnB62sBH;AmBv2sBI;EACC,qBhBphCM;EgBqhCN,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBhBxhCM;EgByhCN,mBAAA;EACA,yBAAA;EACA,YAAA;AnBy2sBL;AmBl2sBG;EACC,QAAA;AnBo2sBJ;AmB/1sBE;EACC,gBAAA;AnBi2sBH;AmB71sBA;EACC,mBAAA;EACA,kBAAA;AnB+1sBD;AmB51sBC;EACC,kBAAA;EACA,chBljCS;EgBmjCT,ehBh0Ba;AH8puBf;AmB11sBC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AnB41sBF;AmB31sBE;EACC,gBAAA;AnB61sBH;AmB51sBG;EACC,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,chBhlCO;EgBilCP,gBhBrwCiB;EgBswCjB,ehB/1BW;AH6ruBf;AmB71sBI;EACC,gBAAA;AnB+1sBL;AmB31sBE;EACC,iBAAA;AnB61sBH;AmB11sBG;EACC,mBAAA;AnB41sBJ;AmBx1sBG;EACC,mBAAA;AnB01sBJ;AmBr1sBA;EACC,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AnBu1sBD;AmBt1sBC;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,yBhB/nCU;EgBgoCV,WAAA;EACA,WAAA;AnBw1sBF;AmBr1sBA;EACC,oBAAA;EACG,mBhBtoCQ;EgBuoCX,chB5nCU;EgB6nCV,ehB14Bc;EgB24Bd,iBAAA;EACA,qBAAA;EACA,gBhBpzCoB;EgBqzCpB,kBAAA;EACA,yBAAA;AnBu1sBD;AmBr1sBA;EACC,iBAAA;AnBu1sBD;AmBt1sBC;EACC,iBAAA;AnBw1sBF;AmBr1sBA;EACC,eAAA;AnBu1sBD;AmBt1sBC;EACC,mBAAA;AnBw1sBF;AmBt1sBC;EACC,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AnBw1sBF;AmBv1sBE;EAGC,aAAA;EAGA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AnBy1sBH;AmBx1sBG;EACC,gBAAA;AnB01sBJ;AmBx1sBG;EACC,cAAA;EACA,kBAAA;AnB01sBJ;AmBp1sBC;EACC,kBAAA;EACA,chB7qCS;EgB8qCT,ehB17Ba;EgB27Bb,gBhBl2CmB;AHwrvBrB;AmBp1sBC;EACC,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,chBzrCS;EgB0rCT,ehBv8Ba;AH6xuBf;AmBn1sBA;EACC,aAAA;EACA,cAAA;AnBq1sBD;AmBp1sBC;EACC,UAAA;AnBs1sBF;AmBr1sBE;EACC,gBAAA;EACA,mBAAA;AnBu1sBH;AmBt1sBG;EACC,kBAAA;AnBw1sBJ;AmBt1sBG;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnBw1sBJ;AmBr1sBM;EACC,chBttCI;AH6ivBX;AmB/0sBA;EAGC,aAAA;EAGA,mBAAA;AnBi1sBD;AmBh1sBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBk1sBF;AmBj1sBE;EACC,ehB//BY;AHk1uBf;AmBh1sBC;EACC,ehBpgCa;EgBqgCb,gBhB56CmB;EgB66CnB,chBjqCW;EgBkqCX,gBAAA;AnBk1sBF;AmB/0sBA;EACC,mBAAA;AnBi1sBD;AmBh1sBC;EACC,chBvtCY;AHyivBd;AmB/0sBA;EACC,6CAAA;AnBi1sBD;AmBh1sBC;EACC,chBt4CK;AHwtvBP;AmB/0sBA;EACC,mBAAA;AnBi1sBD;AmBh1sBC;EACC,chBj5CO;AHmuvBT;AmB/0sBA;EACC,mBAAA;AnBi1sBD;AmBh1sBC;EACC,chBnxCS;AHqmvBX;AmB/0sBA;EACC,mBAAA;AnBi1sBD;AmBh1sBC;EACC,chBzvCW;AH2kvBb;AmB/0sBA;EAGC,aAAA;EAGA,mBAAA;AnBi1sBD;AmBh1sBC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WhB76CM;EgB86CN,eAAA;EACA,mBhBl9CQ;EgBq9CR,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AnBk1sBF;AmBh1sBC;EACC,cAAA;EACA,ehBlkCa;AHo5uBf;AmB70sBE;EACC,ehBxkCY;EgBykCZ,iBAAA;EACA,WhBr8CK;EgBs8CL,6BAAA;EACA,SAAA;AnB+0sBH;AmB70sBE;EACC,ehB/kCY;EgBglCZ,iBAAA;EACA,chBr7CW;AHowvBd;AmBx0sBG;EACC,WhBn9CI;EgBo9CJ,ehBzlCW;AHm6uBf;AmBr0sBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,ehBnmCc;EgBomCd,mBAAA;EACA,WAAA;EACA,YAAA;AnBu0sBD;AmBt0sBC;EACC,mBAAA;EACA,qBhBt2CS;AH8qvBX;AmBr0sBA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AnBu0sBD;AmBt0sBC;EACC,qBAAA;EACA,iBAAA;AnBw0sBF;AmBv0sBE;EACC,chBz2CQ;EgB02CR,ehBpnCY;AH67uBf;AmBr0sBA;EACC,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,eAAA;EACA,gBAAA;AnBu0sBD;AmBr0sBE;EACC,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;AnBu0sBH;AmBr0sBE;EACC,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AnBu0sBH;AmBt0sBG;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,yBhB55CO;EgB65CP,ehBnqCW;EgBoqCX,gBhB3kDmB;EgB4kDnB,chB1hDK;AHk2vBT;AmBr0sBE;EACC,gBAAA;AnBu0sBH;AmBl0sBG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnBo0sBJ;AmBj0sBE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnBm0sBH;AmB9zsBC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,yBhBrjDO;AHq3vBT;AmB5zsBC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;AnB8zsBF;AmB1zsBC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,yBhBvlDM;AHm5vBR;AmBzzsBA;EACC,chBloDS;AH67vBV;AmB1zsBC;EACC,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,YAAA;AnB4zsBF;AmB3zsBE;EAEC,sBAAA;AnB6zsBH;AmB3zsBE;EAEC,sBAAA;AnB6zsBH;AmBzzsBA;EACC,mBAAA;EACA,iBAAA;EACA,gBhB3nDO;EgB4nDP,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AnB2zsBD;AmBxzsBC;EACC,chB9/CS;EgB+/CT,YAAA;EACA,qBhBtgDS;AHg0vBX;AmBpzsBG;EACC,YAAA;AnBszsBJ;AmBjzsBA;EACC,chB5nDa;EgB6nDb,ehB3xCc;EgB4xCd,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AnBmzsBD;AmBlzsBC;EACC,ehBjyCa;AHqlvBf;AmBjzsBA;EACC,UAAA;EACA,SAAA;EACA,gBAAA;AnBmzsBD;AmBlzsBC;EACC,eAAA;EACA,gCAAA;AnBozsBF;AmBnzsBE;EACC,chB/hDQ;EgBgiDR,chBhiDQ;EgBiiDR,ehB9yCY;EgB+yCZ,iBAAA;AnBqzsBH;AmBjzsBE;EACC,chBtsDM;AHy/vBT;AmB/ysBE;EACC,chB3sDM;AH4/vBT;AmB7ysBE;EACC,chBhtDM;AH+/vBT;AmB3ysBA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnB6ysBD;AmB3ysBA;EACC,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,SAAA;AnB6ysBD;AmB3ysBA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBhBrtDO;EgBstDP,aAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AnB6ysBD;AmB5ysBC;EACC,sBhB3tDM;EgB4tDN,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AnB8ysBF;AmB7ysBE;EACC,UAAA;AnB+ysBH;AmB7ysBE;EACC,aAAA;EACA,iBAAA;EACA,mBAAA;AnB+ysBH;AmB3ysBE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBzmDQ;EgB0mDR,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;AnB6ysBH;AmB5ysBG;EACC,chBlxDM;AHgkwBV;AmB5ysBG;EACC,chBnxDK;AHikwBT;AmBzysBA;EACC,YAAA;AnB2ysBD;AmB1ysBC;EAIC,yBAAA;EACA,cAAA;AnByysBF;AmB7ysBE;EACC,qBAAA;AnB+ysBH;AmBxysBC;EACC,uBAAA;AnB0ysBF;AmBxysBC;EACC,SAAA;AnB0ysBF;AmBvysBE;EACC,ehBt5CY;EgBu5CZ,gBhB/zDoB;EgBg0DpB,chB9oDQ;AHu7vBX;AmBvysBE;EACC,eAAA;EACA,gBhBt0DkB;EgBu0DlB,chBnpDQ;AH47vBX;AmBpysBC;EACC,sBAAA;AnBsysBF;AmBnysBI;EACC,mBAAA;AnBqysBL;AmBjysBI;EACC,mBAAA;AnBmysBL;AmB7xsBA;EACC,mBAAA;AnB+xsBD;AmB7xsBA;EACC,eAAA;AnB+xsBD;AmB7xsBE;EACC,UAAA;EACA,gCAAA;AnB+xsBH;AmB9xsBG;EACC,gBAAA;EACA,mBAAA;AnBgysBJ;AmB/xsBI;EACC,ehBj8CU;EgBk8CV,gBhB12DgB;EgB22DhB,chBvrDM;EgBwrDN,kBAAA;AnBiysBL;AmB/xsBI;EACC,ehBv8CU;EgBw8CV,gBhB/2DgB;EgBg3DhB,chB7rDM;EgB8rDN,kBAAA;AnBiysBL;AmB/xsBI;EACC,ehB58CU;EgB68CV,gBhBt3DgB;EgBu3DhB,chBnsDM;AHo+vBX;AmB/xsBI;EACC,ehBl9CU;EgBm9CV,gBhB13DgB;EgB23DhB,chBzsDM;EgB0sDN,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnBiysBL;AmBhysBK;EACC,chBhtDK;AHk/vBX;AmB/xsBI;EACC,iBAAA;AnBiysBL;AmB3xsBA;EACC,eAAA;AnB6xsBD;AmB3xsBA;EACC,eAAA;AnB6xsBD;AmB3xsBA;EACC,oBAAA;AnB6xsBD;AmB3xsBA;EACC,oBAAA;AnB6xsBD;AmB1xsBC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chB3uDS;EgB4uDT,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBhB1vDS;EgB2vDT,qBhB3vDS;AHuhwBX;AmBrxsBI;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chB9vDM;EgB+vDN,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBhB7wDM;AHoiwBX;AmBjxsBA;EACC,yBAAA;AnBmxsBD;AmBjxsBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AnBmxsBD;AmBlxsBC;EACC,gBAAA;AnBoxsBF;AmBnxsBE;EACC,chBzxDQ;EgB0xDR,eAAA;EACA,gBhB38DkB;EgB48DlB,gBAAA;AnBqxsBH;AmBjxsBA;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,ehBziDc;EgB0iDd,yBAAA;EAGA,iBAAA;EACA,ehBjjDc;EgBkjDd,gBhB39DoB;EgB49DpB,chBxyDU;EgByyDV,kBAAA;AnBmxsBD;AmBlxsBC;EACC,kBAAA;EACA,UAAA;EACA,eAAA;AnBoxsBF;AmBjxsBI;EACC,yBhBlzDM;AHqkwBX;AmBlxsBK;EACC,cAAA;AnBoxsBN;AmB7wsBE;EACC,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AnB+wsBH;AmB3wsBA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBhBh9DO;EgBi9DP,yBAAA;EACA,kBAAA;AnB6wsBD;AmB5wsBC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;AnB8wsBF;AmB1wsBC;EACC,chBr1DS;EgBs1DT,ehBnmDa;EgBomDb,gBhB1gEmB;AHsxwBrB;AmBxwsBC;EACC,oCAAA;AnB0wsBF;AmBtwsBC;EACC,kCAAA;AnBwwsBF;AmBrwsBA;EACC,kBAAA;EACA,qBAAA;AnBuwsBD;AmBrwsBA;EACC,mBAAA;AnBuwsBD;AmBrwsBA;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;AnBuwsBD;AmBrwsBA;EACC,sBAAA;EACA,uBAAA;EACA,sBAAA;AnBuwsBD;AmBpwsBC;EACC,WAAA;EACA,qBAAA;EACA,gBAAA;AnBswsBF;AmBrwsBE;EACC,eAAA;EACA,YAAA;AnBuwsBH;AmBnwsBA;EACC,iBAAA;AnBqwsBD;AmBpwsBC;EACC,ehB/oDa;EgBgpDb,gBhBtjEqB;EgBujErB,chBr4DS;EgBs4DT,kBAAA;AnBswsBF;AmBlwsBC;EACC,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnBowsBF;AmBlwsBC;EAQC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnB6vsBF;AmBtwsBE;EACC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AnBwwsBH;AmBlwsBG;EACC,mBhB5kEM;EgB6kEN,kBAAA;EACA,chBr6DO;EgBs6DP,WhB5iEI;AHgzwBR;AmBlwsBG;EACC,iBAAA;EACA,ehBvrDW;EgBwrDX,chB36DO;EgB46DP,gBhB/lEiB;EgBgmEjB,SAAA;EACA,kBAAA;EACA,mBhBn1DM;EgBo1DN,chBh7DO;EgBi7DP,kBAAA;AnBowsBJ;AmBnwsBI;EACC,iBAAA;AnBqwsBL;AmBhwsBG;EACC,uBAAA;EACA,kBAAA;AnBkwsBJ;AmBjwsBI;EACC,kBAAA;EACA,WAAA;AnBmwsBL;AmBjwsBI;EAKC,kBAAA;EACA,WhB3kEG;EgB4kEH,eAAA;EACA,gBhB1nEgB;EgB2nEhB,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AnB+vsBL;AmB5wsBK;EACC,ehB1sDS;EgB2sDT,WhBxkEE;AHs1wBR;AmB/vsBM;EACC,chBx9DI;AHytwBX;AmB3vsBI;EACC,iBAAA;AnB6vsBL;AmBvvsBA;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AnByvsBD;AmBxvsBC;EACC,gBAAA;AnB0vsBF;AmBvvsBA;EAGC,aAAA;EAGA,mBAAA;AnByvsBD;AmBxvsBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;AnB0vsBF;AmBzvsBE;EACC,ehB5wDY;AHugwBf;AmBtvsBC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EAGA,mBAAA;AnBwvsBF;AmBvvsBE;EACC,gBAAA;EACA,chBrhEQ;EgBshER,ehBnyDY;EgBoyDZ,gBhB3sEkB;EgB4sElB,kBAAA;AnByvsBH;AmBxvsBG;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AnB0vsBJ;AmBvvsBI;EACC,aAAA;AnByvsBL;AmBrvsBE;EACC,kBAAA;AnBuvsBH;AmBpvsBC;EACC,chB7iES;EgB8iET,ehB1zDa;EgB2zDb,gBhBluEmB;AHw9wBrB;AmBlvsBC;EACC,chBpjES;AHwywBX;AmBjvsBA;EACC,gBAAA;AnBmvsBD;AmBlvsBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnBovsBF;AmBlvsBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBovsBF;AmBnvsBE;EACC,WAAA;AnBqvsBH;AmBpvsBG;EACC,chBrsEK;EgBssEL,ehBh1DW;AHskwBf;AmBnvsBE;EACC,iBAAA;AnBqvsBH;AmBlvsBC;EACC,gBhBhwEqB;EgBiwErB,WhBptEM;EgBqtEN,ehB51Da;EgB61Db,mBAAA;AnBovsBF;AmBjvsBA;EAGC,aAAA;EAGA,mBAAA;EACA,mBAAA;AnBmvsBD;AmB/usBE;EACC,chBhmEQ;EgBimER,ehB72DY;EgB82DZ,gBhBrxEkB;EgBsxElB,kBAAA;AnBivsBH;AmB7usBE;EACC,chBxmEQ;EgBymER,ehBt3DY;EgBu3DZ,gBhB9xEkB;EgB+xElB,qBAAA;AnB+usBH;AmB3usBE;EACC,chBjnEQ;AH81wBX;AmBxusBC;EACC,chBvnES;EgBwnET,gBhB1yEmB;AHohxBrB;AmBvusBA;EACC,cAAA;AnByusBD;AmBxusBC;EACC,kBAAA;EACA,kBAAA;AnB0usBF;AmBvusBA;EAOC,gBAAA;AnBmusBD;AmBzusBC;EACC,gBhBrzEqB;EgBszErB,WhBzwEM;EgB0wEN,ehBj5Da;EgBk5Db,mBAAA;AnB2usBF;AmBxusBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB0usBF;AmBxusBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB0usBF;AmBzusBE;EACC,chBtpEQ;EgBupER,gBhBv0EkB;AHkjxBrB;AmBzusBE;EACC,gBAAA;AnB2usBH;AmBxusBC;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AnB0usBF;AmBzusBE;EACC,UAAA;EACA,QAAA;EACA,SAAA;AnB2usBH;AmBxusBC;EACC,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBhBlrES;EgBorET,gBAAA;AnB0usBF;AmBzusBE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,sBhB9zEK;EgBg0EL,gBAAA;AnB2usBH;AmBvusBE;EACC,yBhBj0EI;AH0ixBP;AmBxusBG;EAGC,2BAAA;AnB0usBJ;AmBvusBE;EACC,2BAAA;AnByusBH;AmBtusBC;EACC,mBAAA;AnBwusBF;AmBvusBE;EACC,kBAAA;AnByusBH;AmBrusBA;EACC,gBAAA;EACA,aAAA;EACA,oBAAA;AnBuusBD;AmBtusBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnBwusBF;AmBtusBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBwusBF;AmBvusBE;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnByusBH;AmBvusBE;EACC,cAAA;EACA,WAAA;EACA,gBhBz5EkB;EgB05ElB,kBAAA;AnByusBH;AmBxusBG;EACC,chBx4EK;EgBy4EL,kBAAA;AnB0usBJ;AmBzusBI;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,ehB1/DU;AHquwBf;AmBvusBE;EACC,gBAAA;AnByusBH;AmBrusBA;EACC,gBhB36EsB;EgB46EtB,gBAAA;AnBuusBD;AmBtusBC;EACC,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WhBt4EM;EgBu4EN,gBAAA;EACA,eAAA;EACA,mBAAA;AnBwusBF;AmBrusBA;EACC,iBAAA;AnBuusBD;AmBtusBC;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnBwusBF;AmBrusBA;EACC,iBAAA;AnBuusBD;AmBrusBE;EACC,0BAAA;EACA,aAAA;EACA,mBAAA;AnBuusBH;AmBpusBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBsusBF;AmBrusBE;EACC,yBAAA;EACA,kBAAA;EACA,sBhBp6EK;EgBq6EL,aAAA;AnBuusBH;AmBrusBE;EACC,gBAAA;AnBuusBH;AmBpusBC;EAmBC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;AnBotsBF;AmB3usBE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ehBtjEY;EgBujEZ,gBhB99EkB;EgB+9ElB,kBAAA;EACA,chB7yEQ;AH0hxBX;AmB3usBE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,chBpzEQ;EgBqzER,ehBlkEY;EgBmkEZ,gBhB1+EkB;AHutxBrB;AmBpusBC;EACC,qBAAA;EACA,chBl0ES;EgBm0ET,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBhBx/EmB;EgBy/EnB,mBAAA;AnBsusBF;AmBrusBE;EACC,mBAAA;EACA,WhB/8EK;AHsrxBR;AmBnusBA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnBqusBD;AmBpusBC;EACC,mBAAA;EACA,ehB/lEa;EgBgmEb,gBhBvgFmB;EgBwgFnB,chBr1ES;EgBw1ET,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnBsusBF;AmBnusBA;EACC,iBAAA;EACA,oBAAA;AnBqusBD;AmBlusBC;EACC,aAAA;EACA,mBAAA;EACA,YAAA;AnBousBF;AmBnusBE;EACC,chB/2EQ;AHolxBX;AmBhusBC;EACC,chBj3ES;AHmlxBX;AmB/tsBA;EACC,WAAA;EACA,YAAA;EACA,yBhBz/EM;EgB0/EN,yBAAA;EACA,kBAAA;EACA,WhBhgFO;EgBigFP,ehBtoEc;EgBuoEd,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnBiusBD;AmBhusBC;EACC,WhB1gFM;AH4uxBR;AmBhusBC;EACC,WhB7gFM;AH+uxBR;AmB/tsBA;EAOC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBhBr5EU;EgBs5EV,WhB3hFO;EgB4hFP,eAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnB2tsBD;AmB7usBC;EACC,WhBlhFM;AHiwxBR;AmB7usBC;EACC,WhBrhFM;AHowxBR;AmB7tsBE;EACC,chBn6EQ;EgBo6ER,SAAA;EACA,mBAAA;EACA,gBhBxlFkB;EgBylFlB,iBAAA;AnB+tsBH;AmB9tsBG;EACC,chBz6EO;AHyoxBX;AmB7tsBE;EACC,iBAAA;AnB+tsBH;AmB7tsBE;EACC,uCAAA;EACA,chBj7EQ;AHgpxBX;AmB5tsBC;EACC,oBAAA;EACA,kBAAA;AnB8tsBF;AmB7tsBE;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,yBhBj8EQ;EgBk8ER,WAAA;AnB+tsBH;AmB1tsBA;EACC,YAAA;AnB4tsBD;AmBztsBA;EACC,kBAAA;AnB2tsBD;AmBxtsBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnB0tsBD;AmBvtsBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnBytsBD;AmBttsBA;EACC,mBAAA;AnBwtsBD;AmBrtsBA;EACC,gBAAA;AnButsBD;AmBptsBA;EACC,YAAA;EACA,aAAA;AnBstsBD;AmBntsBA;EACC,iBAAA;EACA,gBAAA;AnBqtsBD;AmBltsBA;EACC,iBAAA;AnBotsBD;AmBjtsBA;EACC,YAAA;EACA,aAAA;AnBmtsBD;AmBhtsBA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,iBAAA;EACA,ehBnwEc;AHq9wBf;AmB/ssBA;EACC,WhBroFO;AHs1xBR;AmB9ssBA;EACC,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AnBgtsBD;AmB7ssBA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;AnB+ssBD;AmB5ssBA;EACC,eAAA;AnB8ssBD;AmB3ssBA;EACC,qBAAA;AnB6ssBD;AmB1ssBA;EACC,yBAAA;EACA,qBAAA;AnB4ssBD;AmBzssBA;EACC,qBAAA;AnB2ssBD;AmBxssBA;EACC,kBAAA;AnB0ssBD;AmBvssBA;EACC,gBAAA;EACA,qBAAA;AnByssBD;AmBtssBA;EACC,iBAAA;AnBwssBD;AmBrssBA;EACC,yBAAA;AnBussBD;AmBpssBA;EACC,sBAAA;AnBsssBD;AmBnssBA;EACC,2BAAA;EACA,gCAAA;AnBqssBD;AmBlssBA;EACC,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AnBossBD;AmBjssBA;EACC,WhBzsFO;EgB0sFP,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBhB9vFsB;AHi8xBvB;AmBhssBA;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AnBkssBD;AmB/rsBA;;EAEC,WAAA;EACA,YAAA;EACA,iBAAA;AnBissBD;AmB9rsBA;EACC,cAAA;EACA,aAAA;AnBgssBD;AmB7rsBA;EACC,ehBj3Ec;AHgjxBf;AmB5rsBA;EACC,cAAA;EACA,aAAA;AnB8rsBD;AmB3rsBA;EACC,eAAA;AnB6rsBD;AmB1rsBA;EACC,aAAA;EACA,YAAA;AnB4rsBD;AmBzrsBA;EACC,kBAAA;AnB2rsBD;AmBxrsBA;EACC,eAAA;EACA,mBAAA;AnB0rsBD;AmBvrsBA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,wBAAA;EACA,gCAAA;EACA,4BAAA;AnByrsBD;AmBtrsBA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnBwrsBD;AmBrrsBA;EACC,gCAAA;EACA,oBAAA;AnBursBD;AmBprsBA;EACC,gBAAA;AnBsrsBD;AmBnrsBA;EACC,ehBv6Ec;AH4lxBf;AmBhrsBA;EACC,gBhBn1FoB;EgBo1FpB,cAAA;EACA,ehB76Ec;EgB86Ed,kBAAA;AnBkrsBD;AmB/qsBA;EACC,gBAAA;EACA,gBAAA;AnBirsBD;AmB9qsBA;EACC,cAAA;EACA,SAAA;EACA,UAAA;AnBgrsBD;AmB7qsBA;EACC,ehB37Ec;AH0mxBf;AmB5qsBA;EACC,uBAAA;EACA,SAAA;AnB8qsBD;AmB3qsBA;EACC,sBAAA;AnB6qsBD;AmB1qsBA;EACC,sBAAA;AnB4qsBD;AmBzqsBA;EACI,eAAA;AnB2qsBJ;AmBxqsBA;EACC,mBAAA;AnB0qsBD;AmBvqsBA;EACI,qBAAA;AnByqsBJ;AmBtqsBA;EACI,eAAA;AnBwqsBJ;AmBtqsBA;EACC,aAAA;AnBwqsBD;AmBtqsBA;EACC,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AnBwqsBD;AmBtqsBA;EACC,UAAA;EACA,mBAAA;AnBwqsBD;AmBrqsBA;EACC,ehB7+Ec;EgB8+Ed,gBhBl5FkB;EgBm5FlB,yBAAA;EACA,cAAA;EACA,gBAAA;AnBuqsBD;AmBpqsBA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,WhBl3FO;EgBm3FP,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;AnBsqsBD;AmBnqsBA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBqqsBD;AmBlqsBA;EACC,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACG,uBAAA;EACA,+BAAA;AnBoqsBJ;AmBjqsBA;EACC,iBAAA;AnBmqsBD;AmBhqsBA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,ehB3hFc;AH6rxBf;AmBhqsBA;EACE,yBAAA;EACA,qBAAA;AnBkqsBF;AmB/psBA;EACC,cAAA;EACA,gBhB98FoB;AH+myBrB;AmB9psBA;EACC,sBAAA;AnBgqsBD;AmB9psBA;EAGI,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AnBgqsBD;AmB9psBA;EACC,gBAAA;EACA,ehBzjFc;EgB0jFd,gBhBl+FsB;EgBq+FnB,aAAA;EAGH,mBAAA;AnBgqsBD;AmB9psBA;EACC,ehBjkFc;AHiuxBf;AmB9psBA;EACC,gBAAA;EACA,chBt+FS;EgBu+FT,gBhBj/FoB;AHipyBrB;AmB9psBA;EACC,cAAA;AnBgqsBD;AmB7psBA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AnB+psBD;AmB5psBA;EACC,eAAA;EACA,YAAA;EACA,mBAAA;AnB8psBD;AmB3psBA;EACC,cAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AnB6psBD;AmB1psBA;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AnB4psBD;AmBzpsBA;;EAEC,ehBpnFc;AH+wxBf;AmBxpsBA;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AnB0psBD;AmBvpsBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnBypsBD;AmBtpsBA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,WhBngGO;EgBogGP,aAAA;EACA,mBAAA;EACA,uBAAA;AnBwpsBD;AmBrpsBA;;;EAGC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AnBupsBD;AmBppsBA;EACC,yBAAA;AnBspsBD;AmBnpsBA;EACC,yBAAA;AnBqpsBD;AmBlpsBA;EACC,yBAAA;AnBopsBD;AmBjpsBA;EACC,4BAAA;AnBmpsBD;AmBhpsBA;EACC,6BAAA;AnBkpsBD;AmB/osBA;EACC,ehB/qFc;AHg0xBf;AmB9osBA;EACC,cAAA;EACA,eAAA;AnBgpsBD;AmB7osBA;EACC,4BAAA;AnB+osBD;AmB5osBA;EACC,6BAAA;AnB8osBD;AmB3osBA;EACC,eAAA;AnB6osBD;AmB1osBA;;;EAGC,iBAAA;AnB4osBD;AmBzosBA;EACC,aAAA;EACA,cAAA;AnB2osBD;AmBxosBA;EACC,4BAAA;AnB0osBD;AmBvosBA;EACC,6BAAA;AnByosBD;AmBtosBA;EACC,ehBztFc;AHi2xBf;AmBrosBA;;;EAGC,iBAAA;AnBuosBD;AmBposBA;EACC,cAAA;EACA,eAAA;AnBsosBD;AmBnosBA;EACC,4BAAA;AnBqosBD;AmBlosBA;EACC,6BAAA;AnBoosBD;AmBjosBA;EACC,ehB3uFc;AH82xBf;AmBhosBA;;;EAGC,iBAAA;AnBkosBD;AmB/nsBA;EACC,WAAA;EACA,YAAA;AnBiosBD;AmB9nsBA;EACC,4BAAA;AnBgosBD;AmB7nsBA;EACC,6BAAA;AnB+nsBD;AmB5nsBA;EACC,ehBhwFc;AH83xBf;AmB3nsBA;;;EAGC,iBAAA;AnB6nsBD;AmB1nsBA;EACC,eAAA;EACA,gBAAA;AnB4nsBD;AmBznsBA;EACC,4BAAA;AnB2nsBD;AmBxnsBA;EACC,6BAAA;AnB0nsBD;AmBvnsBA;EACC,ehBtxFc;AH+4xBf;AmBtnsBA;;;EAGC,iBAAA;AnBwnsBD;AmBrnsBA;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AnBunsBD;AmBpnsBA;EACC,qBAAA;AnBsnsBD;AmBnnsBA;EACC,kBAAA;AnBqnsBD;AmBlnsBA;EACC,sBAAA;AnBonsBD;AmBjnsBA;EACC,kBAAA;AnBmnsBD;AmBhnsBA;EACC,wBAAA;AnBknsBD;AmB/msBA;EACC,UAAA;AnBinsBD;AmB9msBA;EACC,cAAA;AnBgnsBD;AmB7msBA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;AnB+msBD;AmB5msBA;EACC,eAAA;AnB8msBD;AmB3msBA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AnB6msBD;AmB1msBA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AnB4msBD;AmBzmsBA;EACC,yBAAA;AnB2msBD;AmBxmsBA;EACC,eAAA;AnB0msBD;AmBvmsBA;EACC,YAAA;EACA,cAAA;AnBymsBD;AmBtmsBA;EACC,iBAAA;EACA,eAAA;AnBwmsBD;AmBrmsBA;EACC,mBAAA;AnBumsBD;AmBpmsBA;EACC,mBAAA;AnBsmsBD;AmBnmsBA;EACC,mBAAA;AnBqmsBD;AmBlmsBA;EACC,mBAAA;AnBomsBD;AmBjmsBA;EACC,mBAAA;AnBmmsBD;AmBhmsBA;EACC,mBAAA;AnBkmsBD;AmB/lsBA;EACC,mBAAA;AnBimsBD;AmB9lsBA;EACC,mBAAA;AnBgmsBD;AmB7lsBA;EACC,kBAAA;AnB+lsBD;AmB5lsBA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AnB8lsBD;AmB3lsBA;EACC,ehBr6Fc;AHkgyBf;AmB1lsBA;EACI,gBAAA;EACA,gBAAA;EACA,yBAAA;AnB4lsBJ;AmB1lsBA;EACI,yBAAA;AnB4lsBJ;AmB1lsBA;EACC,aAAA;EACA,yBhB90GS;AH06yBV;AmB1lsBA;EACC,yBhBj1GS;AH66yBV;AmBzlsBA;EACC,aAAA;AnB2lsBD;AmBxlsBA;EACC,iBAAA;AnB0lsBD;AmBvlsBA;EACC,qBAAA;AnBylsBD;AmBtlsBA;EACC,aAAA;EACA,gBAAA;AnBwlsBD;AmBrlsBA;EACC,aAAA;EACA,qBAAA;AnBulsBD;AIr6yBI;Ee40GJ;IAIE,cAAA;EnBylsBA;AACF;AmBtlsBA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AnBwlsBD;AIl7yBI;Eeo1GJ;IAQE,WAAA;EnB0lsBA;AACF;AIv7yBI;Eei2GH;IAEE,wBAAA;EnBwlsBD;AACF;AmBrlsBA;EACC,gBhB91GO;EgB+1GP,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,0CAAA;AnBulsBD;AIr8yBI;Eeu2GJ;IASE,sBAAA;EnBylsBA;AACF;AmBtlsBA;EACC,aAAA;AnBwlsBD;AmBrlsBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBhB95GsB;EgB+5GtB,yBAAA;AnBulsBD;AmBplsBA;EACC,wBAAA;AnBslsBD;AmBnlsBA;EACC,ehB7/Fc;AHklyBf;AmBllsBA;EACC,gBAAA;EACA,aAAA;AnBolsBD;AmBjlsBA;EACC,2BAAA;AnBmlsBD;AmBhlsBA;EACC,gBAAA;AnBklsBD;AmB/ksBA;EACC,gBAAA;EACA,WAAA;EACA,6BAAA;AnBilsBD;AmB9ksBA;EACC,0BAAA;AnBglsBD;AmB7ksBA;EACC,SAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;AnB+ksBD;AmB7ksBA;EACC,iBAAA;AnB+ksBD;AmB7ksBA;EACC,gBhB38GsB;EgB48GtB,cAAA;EACA,ehBriGc;EgBsiGd,gBAAA;AnB+ksBD;AmB5ksBA;EACC,kBAAA;AnB8ksBD;AmB3ksBA;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AnB6ksBD;AmB1ksBA;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AnB4ksBD;AmBzksBA;EACC,WhB37GO;EgB47GP,qBAAA;AnB2ksBD;AmBxksBA;EACC,aAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnB0ksBD;AmBvksBA;EACC,0CAAA;EACA,0CAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnByksBD;AmBtksBA;EACC,yBAAA;AnBwksBD;AmBrksBA;EACC,kBAAA;AnBuksBD;AmBpksBA;EACC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AnBsksBD;AmBnksBA;EACC,cAAA;AnBqksBD;AmBlksBA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AnBoksBD;AmBlksBA;EACC,2BAAA;EACA,aAAA;EACA,mBAAA;AnBoksBD;AmBjksBA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ehBhoGc;EgBioGd,gBhBxiHoB;EgByiHpB,kBAAA;EACA,cAAA;AnBmksBD;AmBhksBA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,ehB7oGc;AH+syBf;AmBhksBA;EACC,cAAA;AnBkksBD;AmBhksBA;EACC,kBAAA;EACA,kBAAA;AnBkksBD;AmB/jsBA;EACC,yBAAA;EACA,gBhBhkHoB;EgBikHpB,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AnBiksBD;AmB/jsBA;EACC,cAAA;AnBiksBD;AmB9jsBA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,yBhB1kHS;EgB2kHT,WhBxiHO;EgByiHP,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AnBgksBD;AmB7jsBA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AnB+jsBD;AmB5jsBA;EACC,WhB/jHO;AH6nzBR;AmB3jsBA;EACC,WhBnkHO;AHgozBR;AmB1jsBA;EACC,0CAAA;AnB4jsBD;AmBzjsBA;EACC,cAAA;AnB2jsBD;AmBxjsBA;EACC,2BAAA;AnB0jsBD;AmBxjsBA;EAGI,aAAA;EAGH,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,kBAAA;AnB0jsBD;AmBzjsBC;EACC,cAAA;AnB2jsBF;AmBxjsBA;EACC,WAAA;AnB0jsBD;AmBxjsBA;EACC,cAAA;AnB0jsBD;AmBxjsBA;EACC,gBAAA;AnB0jsBD;AmBxjsBA;EACC,kBAAA;AnB0jsBD;AmBxjsBA;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,ehBpvGc;EgBqvGd,gBhB9pHoB;AHwtzBrB;AmBxjsBA;EACC,ehBzvGc;AHmzyBf;AmBvjsBA;EACC,iBAAA;AnByjsBD;AmBvjsBA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnByjsBD;AmBvjsBA;EACC,ehBrwGc;EgBswGd,gBhB7qHoB;EgB8qHpB,cAAA;EACA,mBAAA;EAGG,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnByjsBD;AmBvjsBA;EACC,yBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;EACA,ehBvxGc;EgBwxGd,gBhBjsHoB;EgBksHpB,mBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;EACA,eAAA;EACA,gBhBvsHoB;EgBwsHpB,kBAAA;AnByjsBD;AmBvjsBA;EACC,eAAA;EACA,cAAA;EACA,gBhB7sHoB;EgB8sHpB,gBAAA;AnByjsBD;AmBvjsBA;EACC,gBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;EACA,ehB9yGc;EgB+yGd,gBhBrtHoB;AH8wzBrB;AmBvjsBA;EACC,cAAA;AnByjsBD;AmBvjsBA;EACC,mBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;AnByjsBD;AmBvjsBA;EACC,mBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;AnByjsBD;AmBvjsBA;EACC,mBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;AnByjsBD;AmBvjsBA;EACC,WAAA;EACA,YAAA;AnByjsBD;AmBvjsBA;EACC,ehB30Gc;EgB40Gd,gBhBnvHoB;EgBovHpB,cAAA;EACA,gBAAA;AnByjsBD;AmBvjsBA;EACC,mBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;AnByjsBD;AmBvjsBA;EACC,aAAA;AnByjsBD;AmBvjsBA;EACC,iBAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;AnByjsBD;AmBvjsBA;EACC,gBhBrwHsB;EgBswHtB,cAAA;EACA,ehB/1Gc;AHw5yBf;AmBvjsBA;EACC,ehBr2Gc;EgBs2Gd,gBhB7wHoB;EgB8wHpB,cAAA;AnByjsBD;AmBvjsBA;EACC,0BAAA;AnByjsBD;AmBvjsBA;EACC,0BAAA;AnByjsBD;AmBvjsBA;EACC,gBhBzuHO;EgB0uHP,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AnByjsBD;AmBvjsBA;EACC,aAAA;AnByjsBD;AmBvjsBA;EACC,mBAAA;EACA,ehB13Gc;EgB23Gd,gBhBnyHoB;EgBoyHpB,cAAA;AnByjsBD;AmBvjsBA;EACC,cAAA;EACA,ehBl4Gc;EgBm4Gd,gBhB1yHoB;AHm2zBrB;AmBvjsBA;EACC,mBAAA;AnByjsBD;AmBvjsBA;EACC,UAAA;AnByjsBD;AmBvjsBA;EACC,kBAAA;AnByjsBD;AmBvjsBA;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;AnByjsBD;AmBvjsBA;EAGI,aAAA;EAGH,mBAAA;AnByjsBD;AmBvjsBA;EACC,iBAAA;AnByjsBD;AmBvjsBA;EACC,6BAAA;EACA,WhB3xHO;AHo1zBR;AmBvjsBA;EACC,cAAA;AnByjsBD;AmBvjsBA;EACC,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACG,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnByjsBJ;AmBvjsBA;EAGI,aAAA;EAGH,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnByjsBD;AmBvjsBA;EACC,UAAA;AnByjsBD;AmBvjsBA;EACC,mBAAA;AnByjsBD;AmBvjsBA;EACC,ehBh8Gc;EgBi8Gd,cAAA;AnByjsBD;AmBvjsBA;EACC,qCAAA;AnByjsBD;AmBvjsBA;EACC,aAAA;EACA,iBAAA;AnByjsBD;AmBvjsBA;EACC,ehB98Gc;EgB+8Gd,gBhBt3HoB;EgBu3HpB,cAAA;AnByjsBD;AmBvjsBA;EACC,aAAA;AnByjsBD;AmBvjsBA;EACC,kBAAA;AnByjsBD;;AmBnjsBQ;EACI,sBhBv1HJ;EgBw1HI,gCAAA;AnBsjsBZ;AmBnjsBI;EACI,oCAAA;AnBqjsBR;;AmBjjsBI;EACI,aAAA;AnBojsBR;;AmB/isBQ;EftzHL,SeuzHiC;EftzHjC,mBeszHmC;EAC1B,YAAA;AnBmjsBZ;AmBjjsBQ;EAGL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACS,chB7uHD;EgB8uHC,oBAAA;EACA,UAAA;Ef30HV,kBe40H4B;Ef30H5B,Me20HqC;Ef10HrC,We00HuC;Efz0HvC,Sey0H4C;AnBsjsB9C;;AmBjjsBI;EACI,+BAAA;EACA,gBAAA;EACA,UAAA;AnBojsBR;AmBnjsBQ;EACI,gCAAA;Ef90HT,Se+0HiC;Ef90HjC,ae80HmC;Ef31HpC,oBe41H8B;AnBwjsBhC;AmBvjsBY;EACI,yBhBpwHL;AH6zzBX;AmBvjsBY;EACI,yBhBvwHL;AHg0zBX;AmBvjsBY;Efv1HT,kBew1HqC;EACxB,kBAAA;AnByjsBhB;AmBxjsBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AnB0jsBpB;AmBvjsBY;EAGF,aAAA;EACA,8BAAA;EACH,sCAAA;EACA,4BAAA;AnByjsBP;AmBxjsBgB;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,chBtxHT;EgBuxHS,ehBliHL;EgBmiHK,gBhBz8HD;AHmg0BnB;AmBxjsBgB;EACI,chB5xHT;EgB6xHS,ehBr9HH;EgBs9HG,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnB0jsBpB;AmBxjsBgB;EACI,chBvyHT;EgBwyHS,ehBnjHL;AH6mzBf;AmBvjsBoB;EACI,iBAAA;AnByjsBxB;;AmBjjsBA;Efn5HE,oBeo5HsB;AnBsjsBxB;AmBrjsBI;EACI,+BAAA;EACA,gBAAA;AnBujsBR;AmBnjsBQ;EACI,aAAA;Efh5HT,mBei5HiC;Efh5HjC,eeg5H8C;AnBsjsBjD;AmBnjsBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AnBqjsBR;AmBpjsBQ;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;AnBsjsBZ;AmBnjsBI;Ef/5HD,qBeg6H6B;Ef/5H7B,Ue+5H2C;EACtC,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnBsjsBR;AmBpjsBI;Eft6HD,ceu6H6B;Eft6H7B,Ues6HoC;EAC/B,WAAA;AnBujsBR;AmBrjsBY;EACI,mBAAA;AnBujsBhB;AmBtjsBgB;EACI,QAAA;EACA,YAAA;EACA,WAAA;AnBwjsBpB;AmBtjsBgB;EAGL,aAAA;EAGJ,qBAAA;EAEA,sBAAA;Efz7HJ,kBe07HyC;Efz7HzC,Uey7HqD;AnByjsBxD;AmBxjsBoB;Ef37HjB,Se47H6C;Ef37H7C,mBe27H+C;EAC1B,kBAAA;AnB2jsBxB;AmB1jsBwB;Ef97HrB,ee+7HiD;Ef97HjD,Ue87HyD;AnB6jsB5D;AmB3jsBwB;Efj8HrB,Sek8HiD;Efj8HjD,Uei8HmD;AnB8jsBtD;AmB5jsBwB;EACI,oCAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;Efn9H1B,kBeo9H4C;Efn9H5C,Mem9HqD;Efl9HrD,Yek9HuD;Efh9HvD,Ueg9HkE;AnBiksBpE;AmB/jsBuB;Ef98HpB,Se+8HiD;Ef98HjD,kBe88HmD;Efv7HpD,mBew7H2C;EACjB,yBAAA;EACA,qBAAA;EACA,kBAAA;AnBkksB5B;AmBhksBwB;Ef77HtB,+Be87H2C;AnBkksB7C;AmB/jsBoB;EAGR,aAAA;Ef59HT,ce69H6C;Ef59H7C,ce49HoD;EAC/B,WAAA;AnBkksBxB;AmBjksBwB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AnBmksB5B;AmBlksB4B;Ef3+H1B,kBe4+HgD;Ef3+HhD,Me2+HyD;Ef1+HzD,Qe0+H2D;Efz+H3D,Sey+H6D;Efx+H7D,Oew+H+D;EACjC,gBhBphIxB;EgBqhIwB,WAAA;EACA,YAAA;Efn/H9B,oBeo/HkD;AnB0ksBpD;AmBvksBgC;EACI,UAAA;AnByksBpC;AmBrksBuB;EACK,aAAA;AnBuksB5B;AmBpksBwB;EACI,eAAA;AnBsksB5B;AmBpksBwB;Ef//HtB,kBeggI4C;Ef//H5C,Qe+/HqD;Ef5/HrD,Se4/HmE;EACzC,gCAAA;EACA,UAAA;EftgI1B,oBeugI8C;EACpB,WhB5iIpB;EgB6iIoB,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AnB0ksB5B;AmBvksBoB;EAGZ,aAAA;EACa,mBAAA;EACb,yBAAA;EACA,sBAAA;EfzgIL,ee0gI6C;EfzgI7C,UeygIqD;EAEhD,eAAA;EACgB,WAAA;EACA,2BAAA;EACA,gBAAA;AnB0ksBxB;AmBzksBwB;EfhhIrB,SeihIiD;EfhhIjD,mBeghImD;EAC1B,kBAAA;AnB4ksB5B;AmB1ksB4B;Ef5hI1B,kBe6hIgD;Ef5hIhD,Qe4hIyD;Ef3hIzD,We2hI6D;EfzhI7D,SeyhIuE;EACzC,gCAAA;EACA,mBhB1mItB;EgB2mIsB,WAAA;EACA,WAAA;EACA,UAAA;AnB+ksBhC;AmB5ksBwB;EACI,4BAAA;AnB8ksB5B;AmB5ksBwB;EACI,chB58HjB;AH0h0BX;AmBzksBY;EACI,kBAAA;EACA,mBAAA;AnB2ksBhB;AmB1ksBgB;EACI,kBAAA;Ef1iIjB,kBe2iIyC;Ef1iIzC,Ue0iIoD;AnB6ksBvD;AmB5ksBoB;EACI,oCAAA;EACA,+BAAA;EACA,6BAAA;EACA,kCAAA;EACA,WAAA;EACA,SAAA;Ef1jItB,kBe2jIwC;Ef1jIxC,Qe0jIiD;EfzjIjD,WeyjIqD;EfvjIrD,UeujI+D;EACzC,QAAA;AnBilsBxB;AmB/ksBoB;EftjIjB,SeujI6C;EftjI7C,kBesjI+C;Ef/hIhD,mBegiIuC;EACjB,yBhB5oId;EgB6oIc,cAAA;EACA,kBAAA;AnBklsBxB;AmBjlsBwB;EACI,WhB7mIpB;ECgDL,Se8jIiD;Ef7jIjD,Ue6jImD;AnBolsBtD;AmBhlsBgB;EACI,cAAA;AnBklsBpB;AmBjlsBoB;EACI,eAAA;AnBmlsBxB;AmB/ksBY;EAGR,aAAA;EACM,mBAAA;EACN,yBAAA;EACA,sBAAA;EAEE,eAAA;EfjlIH,eeklIqC;EfjlIrC,UeilI6C;EAChC,WAAA;EACA,gBAAA;AnBklsBhB;AmBjlsBgB;EACI,+BAAA;AnBmlsBpB;AmBhlsBY;EAGR,aAAA;Ef5lID,ce6lIqC;Ef5lIrC,ce4lI4C;EAC/B,WAAA;AnBmlsBhB;AmBllsBgB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AnBolsBpB;AmBnlsBoB;Ef3mIlB,kBe4mIwC;Ef3mIxC,Me2mIiD;Ef1mIjD,Qe0mImD;EfzmInD,SeymIqD;EfxmIrD,OewmIuD;EACjC,gBhBppIhB;EgBqpIgB,WAAA;EACA,YAAA;EfnnItB,oBeonI0C;AnB2lsB5C;AmBxlsBwB;EACI,UAAA;AnB0lsB5B;AmBtlsBe;EACK,aAAA;AnBwlsBpB;AmBrlsBgB;EACI,eAAA;AnBulsBpB;AmBrlsBgB;Ef/nId,kBegoIoC;Ef/nIpC,Qe+nI6C;Ef5nI7C,Se4nI2D;EfrqI3D,gCesqIqC;EfrqIrC,wCeqqIqC;EfpqIrC,oCeoqIqC;EfroIrC,oBesoIsC;EACpB,UAAA;EACA,WhB5qIZ;EgB6qIY,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AnB6lsBpB;AmBvlsBQ;EACI,ehB1uIK;EgB2uIL,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AnBylsBZ;AmBxlsBY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EfzpId,kBe0pIgC;EfzpIhC,QeypIyC;EfxpIzC,UewpI6C;EAC/B,WAAA;AnB4lsBhB;AmB1lsBY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EfxpIb,kBeypIqC;EfjqItC,kBekqIgC;EfjqIhC,QeiqIyC;Ef9pIzC,Se8pIuD;EACzC,WAAA;AnB8lsBhB;;AmBxlsBA;EACI,sBhBltII;EgBmtIJ,6BAAA;EfnqID,SeoqIyB;EfnqIzB,oBemqI2B;AnB4lsB9B;AmB3lsBI;EACI,+CAAA;EACA,oBAAA;EACA,gBAAA;AnB6lsBR;;AI/z0BI;EesuIA;IACI,QAAA;IACA,UAAA;IACA,mBAAA;EnB6lsBN;EmB1lsBE;If1rIF,kBe2rIwB;IfzrIxB,aeyrIwC;IAClC,UAAA;IACA,kBAAA;IACA,WAAA;EnB6lsBN;EmB3lsBE;IACI,aAAA;IACA,mBAAA;EnB6lsBN;AACF;AmB1lsBI;EACI,gBAAA;AnB4lsBR;AmB1lsBI;EACI,gBhB7xIW;EgB8xIX,chB7mIG;EgB8mIH,ehBx3HO;AHo9zBf;AI110BI;Ee2vIA;IAKQ,ehBzyIK;EHu40Bf;AACF;AmB5lsBI;EACI,gBhBryIW;EgBsyIX,chBrnIG;EgBsnIH,ehBh4HO;EgBi4HP,kBAAA;AnB8lsBR;AIr20BI;EemwIA;IAMQ,ehBn4HG;EHm+zBb;AACF;AmB9lsBI;EACI,ehBtzIS;EgBuzIT,chBhoIG;EgBioIH,gBhBnzIa;AHm50BrB;AI/20BI;Ee4wIA;IAKQ,ehBh5HG;EHk/zBb;AACF;AIp30BI;Ee4wIA;IAQQ,ehBn5HG;IgBo5HH,mBAAA;EnBomsBV;AACF;AmBlmsBI;EACI,mBhBlzIE;EgBmzIF,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;AnBomsBR;AmBnmsBQ;EACI,iEAAA;AnBqmsBZ;AmBlmsBI;EACI,iBAAA;AnBomsBR;AI/40BI;Ee0yIA;IAGQ,cAAA;IACA,gBAAA;EnBsmsBV;AACF;AmBpmsBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBj1IE;EgBk1IF,iBAAA;EACA,WhBhzIA;EgBizIA,gBhB51IW;EgB61IX,ehBz7HO;EgB07Hb,YAAA;EACM,kBAAA;AnBsmsBR;AmBrmsBQ;EACI,WhBtzIJ;AH650BR;AmBrmsBQ;EACI,+BAAA;AnBumsBZ;AI160BI;EeizIA;IAqBQ,kBAAA;EnBwmsBV;AACF;AmBvmsBQ;EACI,mBhB/lIE;AHws0Bd;AmBvmsBQ;EACI,WAAA;EACA,YAAA;AnBymsBZ;AmBtmsBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBvsIG;EgBwsIH,iBAAA;EACA,WhB/0IA;EgBg1IA,gBhB33IW;EgB43IX,ehBx9HO;EgBy9HP,kBAAA;EACA,qBAAA;AnBwmsBR;AmBvmsBQ;EACI,+BAAA;AnBymsBZ;AIx80BI;Eeg1IA;IAkBQ,kBAAA;EnB0msBV;AACF;AmBzmsBQ;EACI,mBhB93IF;AHy+0BV;AmBzmsBQ;EACI,WAAA;EACA,YAAA;AnB2msBZ;AmBxmsBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBl4IC;EgBm4ID,iBAAA;EACA,WhB32IA;EgB42IA,gBhBv5IW;EgBw5IX,ehBp/HO;EgBq/HP,kBAAA;AnB0msBR;AmBzmsBQ;EACI,+BAAA;AnB2msBZ;AIr+0BI;Ee42IA;IAiBQ,kBAAA;EnB4msBV;AACF;AmB3msBQ;EACI,mBhBhvID;AH610BX;AmB3msBQ;EACI,WAAA;EACA,YAAA;AnB6msBZ;AIj/0BI;Eeu4IA;IAEQ,yBAAA;EnB4msBV;EmB3msBU;IACI,cAAA;EnB6msBd;AACF;AIz/0BI;Ee84II;IAES,cAAA;IACA,mBAAA;EnB6msBf;AACF;AmB3msBQ;EACI,cAAA;AnB6msBZ;AmB1msBI;EACI,kBAAA;AnB4msBR;AmB1msBI;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;AnB4msBR;;AmBzmsBA;EACI,UAAA;EACA,SAAA;AnB4msBJ;;AmBzmsBC;EACC,aAAA;AnB4msBF;AmB1msBC;EACC,mBhBlsIQ;EgBmsIR,kBAAA;EACA,aAAA;AnB4msBF;AmB1msBG;EACC,mBhB58IM;EgB68IN,WAAA;EACA,YAAA;EACA,mBAAA;EAGY,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnB4msBhB;AmB3msBI;EACC,mBAAA;EACA,sBAAA;AnB6msBL;AmBzmsBE;EACC,mBAAA;EACA,YAAA;EACA,aAAA;AnB2msBH;AmB1msBG;EACC,kBAAA;AnB4msBJ;;AmBvmsBA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AnB0msBJ;AmBzmsBC;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBhB98IM;EgB+8IN,cAAA;EACA,YAAA;Efh6IC,aei6IuB;Efz4IxB,kBe04IiB;AnB2msBnB;AmB1msBE;EACC,qCAAA;AnB4msBH;AmB1msBE;EACC,qCAAA;AnB4msBH;AmB1msBE;EACC,qCAAA;AnB4msBH;;AmBxmsBA;EACC;IACC,UAAA;EnB2msBA;AACF;AmBvmsBC;EACC,WAAA;AnBymsBF;AmBvmsBC;EACC,chBxgJQ;AHin1BV;AmBvmsBC;EACC,chBrgJO;AH8m1BT;;AmBrmsBC;EACC,aAAA;AnBwmsBF;AmBtmsBC;EACC,mBhBlxIQ;EgBmxIR,kBAAA;EACA,aAAA;AnBwmsBF;AmBtmsBG;EACC,mBhB5hJM;EgB6hJN,WAAA;EACA,YAAA;EACA,mBAAA;EAGY,aAAA;EACA,mBAAA;EACZ,sBAAA;EACY,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBwmsBhB;AmBvmsBI;EACC,mBAAA;EACA,sBAAA;AnBymsBL;AmBrmsBE;EACC,mBAAA;EACA,YAAA;EACA,aAAA;AnBumsBH;AmBtmsBG;EACC,kBAAA;AnBwmsBJ;;AmBjmsBE;EACC,ehBjqIY;EgBkqIZ,WhB1hJK;EgB2hJL,mBAAA;AnBomsBH;AmBnmsBG;EACC,cAAA;EACA,chBh0IS;AHq60Bb;AmBnmsBG;EACC,gBAAA;AnBqmsBJ;;AIjp1BI;EeijJJ;IAEG,wBAAA;EnBmmsBD;AACF;;AIvp1BI;EesjJJ;IAEG,mBAAA;EnBomsBD;AACF;;AoBvs1BG;EACC,WAAA;EACA,aAAA;ApB0s1BJ;;AoBrs1BA;EACC,cAAA;ApBws1BD;;AoBts1BA;EACC,SAAA;ApBys1BD;;AoBps1BE;EACI,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBhBiB;AHut1BvB;AoBps1BE;EACC,WjBwBK;AH8q1BR;AoBns1BC;EACC,oCjBnBoB;AHwt1BtB;;AoBjs1BE;EACI,cjBqJK;EiBpJL,yBAAA;EACA,iBAAA;EACA,kBjBmXa;EiBlXb,aAAA;EACA,mBAAA;EACA,6DAAA;ApBos1BN;;AoBjs1BA;EACE,qBjBgIU;EiB/HV,qDAAA;EACA,mBAAA;EACA,cjBiOW;EiBhOX,sBjBCM;EiBAN,UAAA;EACA,WAAA;ApBos1BF;;AoBls1BA;EACE,qBjBuHU;AH8k1BZ;;AoBls1BA;EACE,cjBuNW;AH8+0Bb;;AoBns1BA;EACE,cjBoNW;AHk/0Bb;;AoBps1BA;EACE,cjBiNW;EiBhNX,oBAAA;EACA,yBAAA;EACA,oBAAA;ApBus1BF;AoBrs1BE;EAEE,cjB0MS;EiBzMT,YAAA;ApBss1BJ;AoBns1BI;EAGE,cjB/DI;EiBgEJ,yCAAA;ApBms1BN;AoBhs1BE;EACE,oCAAA;ApBks1BJ;;AoB/r1BA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBxFqB;AH0x1BvB;;AoBhs1BA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBlGqB;AHqy1BvB;;AoBhs1BA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjB7GqB;AHgz1BvB;;AoBjs1BA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBvHqB;AH2z1BvB;;AoBls1BA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBjIqB;AHs01BvB;;AoBns1BA;EACE,aAAA;ApBss1BF;;AoBns1BA;EACE,yBjBnHK;EiBoHL,sCAAA;ApBss1BF;AoBrs1BE;EACE,WjB/FI;AHsy1BR;;AoBns1BC;EACC,mBAAA;ApBss1BF;AoBns1BE;EACC,wBAAA;ApBqs1BH;AoBjs1BE;EACC,wBAAA;ApBms1BH;AoB5q1BE;EAbE,yBjB1JM;AHs11BV;AoB3r1BI;EACE,+BAAA;ApB6r1BN;AoB1r1BM;EAIE,WjBhIA;AHyz1BR;AoBlr1BE;EAhBE,yBjBxJQ;AH611BZ;AoBps1BI;EACE,+BAAA;ApBss1BN;AoBns1BM;EAIE,WjBhIA;AHk01BR;AoBxr1BE;EAnBE,yBjBlJM;AHg21BV;AoB7s1BI;EACE,+BAAA;ApB+s1BN;AoB5s1BM;EAIE,WjBhIA;AH201BR;AoB9r1BE;EAtBE,yBjBpJG;AH221BP;AoBtt1BI;EACE,+BAAA;ApBwt1BN;AoBrt1BM;EAIE,WjBhIA;AHo11BR;AoBps1BE;EAzBE,yBjBtJM;AHs31BV;AoB/t1BI;EACE,+BAAA;ApBiu1BN;AoB9t1BM;EAIE,WjBhIA;AH611BR;AoB1s1BE;EA5BE,yBjBhJK;AHy31BT;AoBxu1BI;EACE,+BAAA;ApB0u1BN;AoBvu1BM;EAIE,WjBhIA;AHs21BR;;AoB5s1BM;EAIE,mDAAA;EACA,cjBlME;AH841BV;AoBts1BM;EAIE,mDAAA;EACA,cjB3MI;AHg51BZ;AoB/r1BM;EAIE,mDAAA;EACA,cjBhNE;AH841BV;AoBxr1BM;EAIE,oDAAA;EACA,cjB7ND;AHo51BP;AoBjr1BM;EAIE,0DAAA;EACA,cjB1OE;AH051BV;AoB1q1BM;EAIE,yDAAA;EACA,cjB/OC;AHw51BT;;AoBvp1BE;EACE,yCAAA;EAZA,mCAAA;UAAA,2BAAA;ApBuq1BJ;AoBrq1BM;EAIE,WjBnOA;EiBoOA,oCAAA;ApBoq1BR;AoB5p1BE;EACE,yCAAA;EAhBA,mCAAA;UAAA,2BAAA;ApB+q1BJ;AoB7q1BM;EAIE,WjBnOA;EiBoOA,oCAAA;ApB4q1BR;AoBhq1BE;EACE,yCAAA;EApBA,mCAAA;UAAA,2BAAA;ApBur1BJ;AoBrr1BM;EAIE,WjBnOA;EiBoOA,oCAAA;ApBor1BR;AoBpq1BE;EACE,wCAAA;EAxBA,mCAAA;UAAA,2BAAA;ApB+r1BJ;AoB7r1BM;EAIE,WjBnOA;EiBoOA,oCAAA;ApB4r1BR;AoBxq1BE;EACE,wCAAA;EA5BA,mCAAA;UAAA,2BAAA;ApBus1BJ;AoBrs1BM;EAIE,WjBnOA;EiBoOA,oCAAA;ApBos1BR;AoB5q1BE;EACE,8CAAA;EAhCA,mCAAA;UAAA,2BAAA;ApB+s1BJ;AoB7s1BM;EAIE,WjBnOA;EiBoOA,oCAAA;ApB4s1BR;;AoB/q1BA;EACE,SAAA;ApBkr1BF;;AoBhr1BA;EACE,gBAAA;EACA,cAAA;ApBmr1BF;;AoBhr1BA;EACE,gBAAA;ApBmr1BF;;AoBhr1BE;EACI,WAAA;EACA,YAAA;EACA,mBjB3JM;EiB4JN,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cjBhJK;AHm01BX;AoBlr1BM;EACI,cjBlJC;AHs01BX;AoBnr1BU;EACI,cjBpJH;AHy01BX;AoBhr1BM;EACI,aAAA;ApBkr1BV;AoB9q1BU;EAGI,aAAA;EAGA,mBAAA;EhBzPX,YgB0PyC;EAC9B,kBAAA;EACA,cjB7EA;EiB8EA,mBAAA;ApBgr1Bd;AoB/q1Bc;EACI,iBAAA;ApBir1BlB;AoB/q1Bc;EACI,mBjB9LN;EiB+LM,cjBpFJ;AHqw1Bd;;AoB5q1BA;EACE,oCjBjWoB;AHgh2BtB;AoB7q1BM;EACI,cjBvLC;AHs21BX;AoB7q1BM;EACI,cjB1LC;AHy21BX;;AoB1q1BA;EACE,yBAAA;EACA,WAAA;ApB6q1BF;;AoB3q1BA;EACE,yBjBlUM;AHg/1BR;;AoB3q1BE;EACI,mBAAA;ApB8q1BN;;AoB3q1BA;EACE,kBAAA;ApB8q1BF;AoB7q1BE;EACI,yBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBjBvVE;EiBwVF,gBjBrYe;EiBwYf,oBAAA;EAGA,mBAAA;EACA,gBAAA;EhB9SH,iBgB+SiC;ApB+q1BpC;AoB9q1BM;EACI,iBAAA;ApBgr1BV;AoB9q1BM;EACI,cjBrII;AHqz1Bd;AoB9q1BM;EACI,yBAAA;ApBgr1BV;AoB9q1BM;EACI,ejBcK;EiBbL,gBAAA;ApBgr1BV;AoB7q1BU;EhB3UR,yBgB4UgC;EhB7WhC,yBgB8W+B;EhB7W/B,iCgB6W+B;EhB5W/B,6BgB4W+B;ApBmr1BjC;AoB7q1BU;EAGI,aAAA;EAGA,mBAAA;EhB5UX,YgB6UyC;EAC9B,kBAAA;ApB+q1Bd;AoB9q1Bc;EACI,iBAAA;ApBgr1BlB;AoB9q1Bc;EACI,mBjB/QN;EiBgRM,cjBrKJ;AHq11Bd;;AoB1q1BA;EACE,yBAAA;EACA,aAAA;EACA,8DjB/Bc;AH4s1BhB;;AoB1q1BA;;iEAAA;AAGA;;EAEE,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,8CAAA;ApB6q1BF;;AoB1q1BA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;ApB6q1BF;;AoB1q1BA;;;EAGE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,+EAAA;ApB6q1BF;;AoB1q1BA;;;EAGE,eAAA;ApB6q1BF;;AoB1q1BA;;;;;;;;;EASE,mBAAA;EACA,cAAA;EACA,0BAAA;ApB6q1BF;;AoB1q1BA;;;EAGE,aAAA;EACA,6CAAA;ApB6q1BF;;AoB1q1BA;;;EAGE,mBAAA;EACA,WAAA;ApB6q1BF;;AoB1q1BA;;;EAGE,mCAAA;EACA,cAAA;ApB6q1BF;;AoB1q1BA;;;;EAIE,aAAA;EACA,oBAAA;ApB6q1BF;;AoB1q1BA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;ApB6q1BF;;AoB1q1BA;;EAEE,qBAAA;EACA,cAAA;EACA,8CAAA;ApB6q1BF;;AqBpt2BA;EACI,qBAAA;EAEA,WAAA;EjBoGD,gBiBnGyB;EjBoGzB,UiBpGkC;ArBut2BrC;AqBtt2BI;EACI,qBAAA;EACA,WAAA;ArBwt2BR;AqBvt2BQ;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBlBFW;EkBGX,0BAAA;EAGA,qBAAA;ArByt2BZ;AqBxt2BY;EACI,kCAAA;ArB0t2BhB;AqBxt2BY;EACI,elB4ZD;EkB3ZC,mBAAA;EACA,cAAA;ArB0t2BhB;;AqBrt2BA;EACI,mBAAA;ArBwt2BJ;;AqBrt2BI;EACI,kBAAA;ArBwt2BR;AqBtt2BI;EACI,YAAA;ArBwt2BR;AqBvt2BQ;EACI,aAAA;ArByt2BZ;;AqBpt2BI;EACI,clBjBE;AHwu2BV;AqBrt2BI;EACI,yBlBuIG;AHgl2BX;AqBrt2BI;EACI,qBlB6HI;AH0l2BZ;AqBnt2BY;EACI,elBwXD;EkBvXC,clBnCJ;EkBoCI,qBlBwHJ;AH6l2BZ;;AqB/s2BI;;;EAGI,WlBXA;EkBYA,gBlBxDW;AH0w2BnB;;AqB9s2BI;EACI,eAAA;EACA,YAAA;EACA,yBAAA;ArBit2BR;AqBht2BQ;EACI,gBAAA;ArBkt2BZ;;AsB/x2BA;EACI,cnBqRS;AH6g2Bb;AsBjy2BI;EACI,YAAA;AtBmy2BR;AsBjy2BI;EACI,WAAA;AtBmy2BR;AsBly2BQ;EACI,mBAAA;AtBoy2BZ;AsBly2BQ;EACI,kBAAA;AtBoy2BZ;AsB/x2BY;EACI,oBAAA;EACA,mBAAA;AtBiy2BhB;AsB/x2BY;EACI,aAAA;AtBiy2BhB;AsB9x2BwB;EACI,QAAA;ElBiC1B,2BkBhC6C;ElBiC7C,mCkBjC6C;ElBkC7C,+BkBlC6C;AtBky2B/C;AsB7x2BoB;EACI,kBAAA;AtB+x2BxB;AsBxx2BQ;EACI,iBAAA;AtB0x2BZ;AIrx2BI;EkBHI;IAEQ,aAAA;IACA,mBAAA;EtB0x2Bd;AACF;AI3x2BI;EkBGI;IAEQ,mBAAA;EtB0x2Bd;AACF;AIhy2BI;EkBQY;IAEQ,eAAA;EtB0x2BtB;AACF;AIry2BI;EkBgBA;IAEQ,6BAAA;EtBux2BV;AACF;AI1y2BI;EkBgBA;IAKQ,yBAAA;EtByx2BV;AACF;AI/y2BI;EkBwBQ;IACI,aAAA;IACA,mBAAA;IACA,WAAA;EtB0x2Bd;AACF;AsBvx2BI;EACI,yBAAA;EACA,8DnBuVK;ECtSX,kBkBhDuB;AtByx2BzB;AsBxx2BQ;EACI,enBkWG;EmBjWH,gBnBtEO;EmBuEP,gCAAA;ElBoBT,kBkBnBiC;ElBoBjC,mBkBpB6C;AtB2x2BhD;AsBzx2BQ;EACI,gBnB3EO;AHs22BnB;AsBxx2BY;EACI,WAAA;EACA,YAAA;EACA,WnBtCR;ECwEN,kBkBjC+B;AtB0x2BjC;AsBzx2BgB;EACI,qBnBwFT;EmBvFS,mBnBuFT;AHos2BX;AsBxx2BY;EACI,WAAA;AtB0x2BhB;AsBxx2BoB;EACI,enByUT;AHi91Bf;AsBnx2BgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cnBgKP;EmB/JO,enBnHH;EmBoHG,gBnB7GG;EC4FpB,iBkBkByC;ElBjBzC,iBkBiBoD;ElBMrD,kBkBLmC;EACjB,YAAA;AtBsx2BpB;AsBrx2BoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;AtBux2BxB;AsBrx2BoB;EACI,mBnBkDb;EmBjDa,WnBhFhB;AHu22BR;AsBlx2BQ;EACI,enBkSG;EmBjSH,gBnBpIS;EmBqIT,WAAA;EACA,YAAA;AtBox2BZ;AsBlx2BQ;EACI,enB+RG;EmB9RH,gBnBzIW;EmB0IX,kBAAA;EACA,UAAA;AtBox2BZ;AsBlx2BQ;EACI,WnBlGJ;EmBmGI,mBnB8BD;ECzDT,kBkB4B2B;EACjB,kBAAA;AtBox2BZ;AsBnx2BY;ElB9DV,kBkB+DgC;ElB9DhC,MkB8DyC;ElB7DzC,QkB6D2C;AtBux2B7C;AsBpx2BgB;EACI,WnB3GZ;AHi42BR;AsBnx2BY;EACI,cnBkHJ;AHmq2BZ;AsBjx2BI;EACI,WAAA;ElB5CN,kBkB6CuB;AtBmx2BzB;AsB/w2BY;EACI,YAAA;EACA,YAAA;AtBix2BhB;AsBxw2BgB;EACI,YAAA;AtB0w2BpB;AsBrw2BI;EACI,enBiPO;EmBhPP,gBnBxLe;AH+72BvB;AsBrw2BI;EACI,enB4OO;EmB3OP,gBnB5Le;AHm82BvB;AsBtw2BQ;EACI,cnBjBD;AHyx2BX;AsBvw2BY;EACI,cnBvLN;AHg82BV;AsBlw2BgB;ElBnFd,0BkBoFmC;AtBow2BrC;AsBnw2BoB;EACI,WAAA;EACA,YAAA;ElBvFtB,mBkBwFuC;AtBqw2BzC;AsBpw2BwB;ElB7HtB,yBkB8H8C;AtBww2BhD;AsBnw2BoB;EACI,qBAAA;AtBqw2BxB;AsB/v2BI;ElBtGF,0BkBuGuB;EACjB,aAAA;EACA,gBnBjLA;EmBkLA,8DnB4LK;AHqk2Bb;AsBhw2BQ;EACI,cnB2CC;EmB1CD,enBmMG;AH+j2Bf;AsB/v2BI;EACI,yBAAA;EACA,8DnBoLK;ECtSX,kBkBmHuB;EACjB,gBnB5LA;AH672BR;AsBhw2BQ;EACI,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AtBkw2BZ;AsB7v2BQ;EACI,cnBvED;EmBwEC,WAAA;EACA,YAAA;ElBtKV,yBkBuK8B;ElBnI9B,mBkBoI2B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AtBiw2BZ;AsBhw2BY;EACI,mBnB1PN;AH4/2BV;AsBjw2BgB;EACI,WnBzNZ;AH492BR;AsB9v2BI;EACI,enByJO;EmBxJP,gBnB5Qe;EmB6Qf,gBAAA;AtBgw2BR;AsB/v2BQ;EACI,cnBlGD;EmBmGC,iBAAA;EACA,enBmJG;AH8m2Bf;AsB9v2BY;EACI,enB+ID;EmB9IC,kBAAA;EACA,qBAAA;EACA,cnBbH;AH6w2Bb;AsB/v2BgB;EACI,WAAA;ElBtMlB,kBkBuMoC;ElBtMpC,QkBsM6C;ElBnM7C,OkBmM2D;ElB5O3D,2BkB6OqC;ElB5OrC,mCkB4OqC;ElB3OrC,+BkB2OqC;EACnB,UAAA;EACA,WAAA;EACA,mBnBlHT;ECzDT,kBkB4KmC;AtBqw2BrC;AsB9v2BY;EACI,cnB7BH;EmB8BG,WAAA;AtBgw2BhB;AsB7v2BgB;EACI,cnBpSV;AHmi3BV;AsBzv2BI;EACI,YAAA;EACA,iCAAA;AtB2v2BR;AsB1v2BQ;EACI,YAAA;EACA,gCAAA;EACA,gBAAA;AtB4v2BZ;AsB3v2BY;EACI,6BAAA;EACA,4BAAA;EACA,mBAAA;AtB6v2BhB;AsB3v2BY;EACI,gBAAA;EACA,YAAA;EACA,enBsGD;EmBrGC,gBnBnUO;EmBoUP,cnBvJL;EmBwJK,UAAA;EACA,qBAAA;EACA,WAAA;AtB6v2BhB;AsB5v2BgB;ElBxPd,yBkByPsC;EACpB,sBAAA;EACA,mBAAA;EACA,iCAAA;EACA,enBpVH;EmBqVG,gBnB7UD;EmB8UC,cnBpEP;EmBqEO,eAAA;EACA,WAAA;EACA,iBAAA;AtBgw2BpB;AsB9v2BgB;EACI,eAAA;AtBgw2BpB;AsB9v2BgB;EACI,UAAA;AtBgw2BpB;AsB7v2BoB;EACI,cnBnVd;AHkl3BV;AsB3v2BY;EACI,YAAA;EACA,UAAA;AtB6v2BhB;AsB3v2BoB;EACI,eAAA;EACA,WAAA;EACA,YAAA;AtB6v2BxB;AsB1v2BgB;EACI,iBAAA;AtB4v2BpB;AsBrv2BQ;EACI,8BAAA;AtBuv2BZ;AsBrv2BQ;EACI,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8DnB+BC;EmB9BD,yBAAA;AtBuv2BZ;AsBrv2BQ;EACI,UAAA;EACA,UAAA;EACA,qBAAA;AtBuv2BZ;AsBtv2BY;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AtBwv2BhB;AsBvv2BgB;EACI,kBAAA;EACA,WAAA;AtByv2BpB;AsBxv2BoB;EACI,cnBhIX;AH032Bb;AsBxv2BoB;EACI,gBAAA;AtB0v2BxB;AsBzv2BwB;EACG,cnBvYjB;AHko3BV;AsBpv2BW;EACK,UAAA;AtBsv2BhB;AsBlv2BY;EACI,UAAA;AtBov2BhB;AsBhv2BoB;EACI,cnBvJX;EmBwJW,WAAA;AtBkv2BxB;AsB5u2BI;EACI,8DnBhBK;EmBiBL,YAAA;AtB8u2BR;AsB5u2BY;EACI,gBAAA;ElB1Td,kBkB2T+B;EACjB,eAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AtB8u2BhB;AIro3BI;EkB2YQ;IAcQ,mBAAA;IACA,qBAAA;EtBgv2BlB;AACF;AsB/u2BgB;EACI,cnBpLP;EmBqLO,mBnBlLV;EmBmLU,qBnBnLV;AHo62BV;AsB/u2BgB;EACI,mBnBvRT;EmBwRS,qBnBxRT;EmByRS,WnB1ZZ;AH2o3BR;AsB1u2BoB;EACI,qBnBvSZ;AHmh3BZ;AsBtu2BoB;EACI,mBAAA;EACA,enB7dP;EmB8dO,gBnBxdH;EmBydG,mBAAA;EACA,qBnBlTZ;AH0h3BZ;AsBvu2BwB;EACI,enBleX;EmBmeW,gBnB7dP;AHss3BrB;AsBvu2BgC;EACI,WAAA;EACA,YAAA;EACA,SAAA;AtByu2BpC;AsBhu2BI;EACI,enBlfS;AHot3BjB;;AsB/t2BA;EACI,aAAA;AtBku2BJ;;AsBhu2BA;EACI,cnBvOS;AH082Bb;;AsBju2BA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AtBou2BJ;AsBlu2BI;ElBraF,kBkBsawB;ElBraxB,QkBqaiC;ElBlajC,UkBka+C;ElB3c/C,2BkB4cyB;ElB3czB,mCkB2cyB;ElB1czB,+BkB0cyB;EACnB,YAAA;AtBwu2BR;AsBtu2BI;EACI,kBAAA;AtBwu2BR;;AsBru2BA;EACI,mBnBtcU;AH8q3Bd;AsBvu2BI;EACI,mBnBxcM;AHir3Bd;;AsBtu2BA;EACI,mBnB7TS;AHsi3Bb;AsBxu2BI;EACI,mBnB/TK;AHyi3Bb;;AsBvu2BA;EACI,mBnB7UU;AHuj3Bd;AsBzu2BI;EACI,mBnB/UM;AH0j3Bd;;AsBxu2BA;ElBxbG,kBkBybyB;ElBxbzB,kBkBwbqC;EACpC,gCAAA;AtB4u2BJ;;AsB1u2BA;ElB5bG,kBkB6byB;ElB5bzB,mBkB4bqC;EACpC,gCAAA;AtB8u2BJ;;AsB3u2BI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;AtB8u2BR;AsB5u2BS;EACG,oBAAA;AtB8u2BZ;AsB5u2BQ;EACI,UAAA;AtB8u2BZ;AsB1u2BQ;EACI,cnBhiBF;EmBiiBE,iBAAA;EACA,enB3IG;EmB4IH,gBnBjjBS;AH6x3BrB;AsB3u2BY;EACI,cnBziBN;AHsx3BV;AsBzu2BI;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AtB2u2BN;;AsBvu2BA;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;AtB0u2BF;;AsBvu2BA;EACE;IAAqB,SAAA;IAAU,qBAAA;EtB4u2B/B;AACF;AsB1u2BA;EACE,UAAA;EACA,mBAAA;AtB4u2BF;;AsBzu2BA;EACI,mCAAA;EACA,4CAAA;AtB4u2BJ;;AsBzu2BA;EACE,eAAA;EACA,YAAA;ElBheA,4BkBieiB;AtB4u2BnB;;AsB1u2BA;EACI,kBAAA;EACA,mBnB7YS;EmB8YT,YAAA;ElBteF,kBkBuemB;AtB6u2BrB;AsB5u2BI;EACI,enBvLO;AHq62Bf;AsB5u2BI;EACI,gBnB/lBW;AH603BnB;;AsB3u2BA;EACI,aAAA;AtB8u2BJ;AsB7u2BI;EACI,YAAA;EACA,aAAA;ElBnfN,mBkBofuB;EACjB,mBnB/jBA;EmBgkBA,cAAA;AtB+u2BR;;AsB5u2BA;EACI,eAAA;AtB+u2BJ;;AsB7u2BA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,YAAA;EACA,gBnB3kBI;EmB4kBJ,eAAA;EACA,4BAAA;EACA,+BAAA;EACA,2FAAA;EACA,gBAAA;ElB5iBF,yBkB6iBsB;AtBkv2BxB;AI703BI;EkB8kBJ;IAeQ,YAAA;IACA,aAAA;EtBov2BN;AACF;AsBnv2BI;EACI,QAAA;ElBnjBN,yBkBojB0B;AtBuv2B5B;AsBnv2BY;EACI,cnBtnBP;AH223BT;AsBjv2BI;EACI,gBnB7oBW;AHg43BnB;AsBjv2BI;EACI,enBxOO;AH292Bf;AsBjv2BI;EACI,enB5OO;AH+92Bf;AsBjv2BI;EACK,enBjPM;EmBkPP,gBnBxpBe;AH243BvB;AsBjv2BI;EACI,gCAAA;AtBmv2BR;AsBlv2BQ;EACI,iBAAA;EACA,enBvPG;EmBwPH,gBnB/pBW;ECoHrB,kBkB4iB2B;EACjB,YAAA;EACA,mBnBpZF;EmBqZE,cnBtfD;AH0u3BX;AsBnv2BY;EACI,mBnB5pBN;EmB6pBM,WnB1nBR;AH+23BR;AsB7u2BoB;EACI,kBAAA;AtB+u2BxB;AsB5u2BwB;EACI,mBnBralB;EmBsakB,yBAAA;ElBhkB1B,kBkBikB2C;EACjB,YAAA;EACA,qBAAA;AtB8u2B5B;AsB7u2B4B;EACI,WAAA;EACA,YAAA;AtB+u2BhC;AsB3u2BoB;EACI,gBAAA;AtB6u2BxB;AsBvu2BoB;EACI,oBAAA;EACA,iBAAA;EACA,kBAAA;AtByu2BxB;AsBtu2BwB;EACI,kBAAA;EACA,mBAAA;EACA,+BAAA;AtBwu2B5B;AsBpu2BwB;EACI,eAAA;EACA,gBAAA;AtBsu2B5B;AsBnu2BoB;EACI,mBnB/sBd;EmBgtBc,WnB7qBhB;AHk53BR;AsBpu2BwB;EACI,mBnB9iBjB;AHox3BX;AsB/t2BI;EACI,cnBxdK;EmBydL,enB9TO;AH+h3Bf;AsB/t2BI;EACI,gBnBtuBW;AHu83BnB;AsBhu2BQ;EACI,cnB5jBD;AH8x3BX;;AsB7t2BA;EACI,yBAAA;AtBgu2BJ;;AsB9t2BA;EACI,WAAA;EACA,YAAA;ElB/nBF,mBkBgoBmB;AtBiu2BrB;;AsB/t2BA;EACI,yBAAA;AtBku2BJ;;AsBhu2BA;EACI,yBAAA;AtBmu2BJ;;AsBju2BA;EACI,cnBlfS;AHst3Bb;;AsBju2BI;EACI,WAAA;AtBou2BR;;AsB9t2BQ;EACI,enBhWG;EmBiWH,gBnBxwBO;AHy+3BnB;AsB7t2BQ;EACI,enB7VG;EmB8VH,gBnB9wBO;EmB+wBP,cnB9lBD;EmB+lBC,mBAAA;EACA,yBnBpgBF;EC1JR,mBkB+pB2B;AtB+t2B7B;AsB5t2BY;EACI,kBAAA;AtB8t2BhB;AsB3t2BQ;EACI,gBAAA;AtB6t2BZ;AsBtt2BoB;EACI,kBAAA;AtBwt2BxB;AsBjt2BI;EACI,iBAAA;EACA,enBtYO;EmBuYP,mBAAA;AtBmt2BR;AsBht2BQ;EACI,gBAAA;AtBkt2BZ;AsBht2BQ;EACI,YAAA;EACA,cAAA;AtBkt2BZ;AsBjt2BY;EACI,yBAAA;EACA,8DnB9ZH;ECtSX,kBkBqsB+B;AtBmt2BjC;AsBjt2BY;EACI,enBtZD;AHym3Bf;AsBlt2BgB;EACI,oBAAA;AtBot2BpB;AsBht2BwB;EACI,iBAAA;AtBkt2B5B;AsB9s2BgB;EACI,eAAA;EACA,cnB9zBR;AH8g4BZ;AsB9s2BgB;EACI,cnBjkBP;EmBkkBO,mBAAA;AtBgt2BpB;AsB7s2BY;EACI,enB3aD;EmB4aC,yBnBpkBN;EC1JR,kBkB+tB+B;AtB+s2BjC;AsB5s2BgB;EACI,WAAA;AtB8s2BpB;AsB7s2BoB;EACI,WAAA;AtB+s2BxB;AsB9s2BwB;EACI,WAAA;AtBgt2B5B;AsBvs2BY;EACI,kBAAA;EACA,aAAA;EACA,0BAAA;AtBys2BhB;AsBxs2BgB;ElBpxBd,kBkBqxBoC;ElBpxBpC,MkBoxB6C;ElBnxB7C,QkBmxB+C;ElBjxB/C,OkBixBsD;EACpC,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AtB6s2BpB;AsB1s2BY;EACI,enB7cD;EmB8cC,gBnBn3BK;EmBo3BL,cnBxmBH;AHoz3Bb;AsB1s2BY;EACI,enB/cD;EmBgdC,gBnBv3BO;EmBw3BP,cnB72BJ;EmB82BI,gBAAA;AtB4s2BhB;AsB1s2BY;EACI,WAAA;ElBxwBd,kBkBywB+B;AtB4s2BjC;AsBzs2BgB;ElBpyBb,kBkBqyByC;ElBpyBzC,akBoyBqD;ElB7wBtD,kBkB8wBmC;EACjB,yBAAA;AtB4s2BpB;AsB3s2BoB;EACI,WAAA;AtB6s2BxB;AsB1s2BwB;EACI,enBleb;EmBmea,gBnB14BL;EmB24BK,cnBh4BhB;AH4k4BZ;AsB3s2B4B;EACI,cnBh4BtB;AH6k4BV;AsBzs2B4B;EACI,cnBz4BtB;AHol4BV;AsBvs2BoB;EACI,gBAAA;AtBys2BxB;AsBls2BQ;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AtBos2BZ;AsBls2BQ;EACI,WAAA;ElBpzBV,kBkBqzB2B;AtBos2B7B;;AsB7r2BY;EACI,WAAA;AtBgs2BhB;;AuB5n4BA;EACI,UAAA;EAGE,aAAA;EAEA,eAAA;AvB+n4BN;AuB9n4BM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,epB+ZO;ECpTb,mBmB1GuB;EACjB,yBAAA;EACA,cpBHE;ECmFP,WmB/E6B;EnBmH9B,wCAAA;AJgh4BF;;AuB7n4BA;EACE,qCAAA;AvBgo4BF;;AuB7n4BA;EACE;IACE,uBAAA;EvBgo4BF;EuB9n4BA;IACE,yBAAA;EvBgo4BF;AACF;AwBxq4BA;EACI,yBrBiLQ;EqBhLR,eAAA;EACA,sBAAA;AxB0q4BJ;;AwBxq4BA;EACI,yBrB4KQ;AH+/3BZ;;AwBzq4BA;EACI,WrB8CI;EqB7CJ,yBrBUM;AHkq4BV;;AwBzq4BA;EACI;IACI,QAAA;ExB4q4BN;AACF;AwB1q4BA;EACI,kBAAA;EACA,uBAAA;AxB4q4BJ;AwB3q4BI;EACI,kBAAA;EACA,uBAAA;EACA,8BAAA;AxB6q4BR;;AwBzq4BI;EACI,iBAAA;AxB4q4BR;AwB1q4BI;EACI,cAAA;AxB4q4BR;AwB1q4BI;EACI,YAAA;AxB4q4BR;AwB1q4BI;EACI,eAAA;AxB4q4BR;;AwBzq4BA;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AxB4q4BJ;AwB1q4BI;EACI,WAAA;AxB4q4BR;AwBzq4BI;EACI,WAAA;AxB2q4BR;AwBxq4BI;EACI,WAAA;AxB0q4BR;AwBvq4BI;EACI,UAAA;AxByq4BR;AwBtq4BI;EACI,UAAA;AxBwq4BR;;AwBrq4BA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AxBwq4BJ;AwBtq4BI;EACI,WAAA;EACA,SAAA;EACA,kBAAA;AxBwq4BR;AwBrq4BI;EACI,WAAA;AxBuq4BR;AwBpq4BI;EACI,WAAA;AxBsq4BR;AwBnq4BI;EACI,UAAA;AxBqq4BR;AwBlq4BI;EACI,UAAA;AxBoq4BR;;AwBjq4BA;EACI,iBAAA;EACA,kBAAA;AxBoq4BJ;AwBnq4BI;EACI,kBAAA;EACA,iBAAA;AxBqq4BR;AwBpq4BQ;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sDAAA;EACA,gBrB1DJ;EqB2DI,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;AxBsq4BZ;AwBpq4BQ;EACI,6BAAA;EACA,+DAAA;AxBsq4BZ;AwBpq4BQ;EACI,6BAAA;EACA,6DAAA;AxBsq4BZ;AwBpq4BQ;EACI,6BAAA;EACA,0DAAA;AxBsq4BZ;AwBpq4BQ;EACI,6BAAA;EACA,6DAAA;AxBsq4BZ;AwBpq4BQ;EACI,6BAAA;EACA,4DAAA;AxBsq4BZ;AwBnq4BI;EACI,eAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBrB7HE;EqB8HF,kDAAA;EACA,mBAAA;EACA,gBrBzIe;EqB0If,WrB9FA;EqB+FA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AxBqq4BR;AwBpq4BQ;EACI,WAAA;EACA,0CAAA;EACA,+CAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;AxBsq4BZ;AwBpq4BQ;EACI,yBrB9IA;AHoz4BZ;AwBrq4BY;EACI,0CAAA;AxBuq4BhB;AwBpq4BQ;EACI,yBrBlJF;AHwz4BV;AwBrq4BY;EACI,0CAAA;AxBuq4BhB;AwBpq4BQ;EACI,yBrBpJF;AH0z4BV;AwBrq4BY;EACI,0CAAA;AxBuq4BhB;AwBpq4BQ;EACI,yBrBxJH;AH8z4BT;AwBrq4BY;EACI,0CAAA;AxBuq4BhB;AwBpq4BQ;EACI,yBrBlKL;AHw04BP;AwBrq4BY;EACI,0CAAA;AxBuq4BhB;;AwBjq4BI;EACI,oCAAA;AxBoq4BR;;AwBjq4BA;EACI,kBAAA;EACH,4BAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACG,yBrB1JI;AH8z4BR;;AwBlq4BA;EACC,uBAAA;AxBqq4BD;;AwBnq4BA;EACC,uBAAA;AxBsq4BD;;AwBpq4BA;EACC,uBAAA;AxBuq4BD;;AwBrq4BA;EACI,iBAAA;EACA,uBAAA;AxBwq4BJ;AwBvq4BI;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AxByq4BR;AwBxq4BQ;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,sBrBjLJ;EqBkLI,kBAAA;AxB0q4BZ;AwBxq4BQ;EACI,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBrB1LJ;EqB2LI,mBAAA;EACA,gBrBxOW;EqByOX,crBhOF;EqBiOE,kBAAA;EACA,kBAAA;EACA,2BAAA;AxB0q4BZ;AwBzq4BY;EACI,8BAAA;EACA,crBpOJ;AH+44BZ;AwBzq4BY;EACI,8BAAA;EACA,crBlON;AH644BV;AwBzq4BY;EACI,8BAAA;EACA,crBxOT;AHm54BP;AwBzq4BY;EACI,8BAAA;EACA,crB9ON;AHy54BV;AwBzq4BY;EACI,8BAAA;EACA,crB5OP;AHu54BT;;AwBrq4BI;EACI,wCAAA;EACA,sBAAA;AxBwq4BR;AwBvq4BQ;EACI,wCAAA;AxByq4BZ;AwBxq4BY;EACI,crBhQJ;AH064BZ;AwBvq4BQ;EACI,wCAAA;AxByq4BZ;AwBxq4BY;EACI,crBhQN;AH064BV;AwBvq4BQ;EACI,yCAAA;AxByq4BZ;AwBxq4BY;EACI,crBxQT;AHk74BP;AwBvq4BQ;EACI,wCAAA;AxByq4BZ;AwBxq4BY;EACI,crBhRN;AH074BV;AwBvq4BQ;EACI,uCAAA;AxByq4BZ;AwBxq4BY;EACI,crBhRP;AH074BT;AwBvq4BQ;EACI,sBAAA;AxByq4BZ;AwBvq4BQ;EACI,kBAAA;EACA,0BAAA;EACA,gBrB5SW;EqB6SX,mBAAA;EACA,crBrSF;AH884BV;;AyBl+4BA;EACI,ctBqRS;EsBpRT,sBtBqDI;EsBpDJ,yBAAA;AzBq+4BJ;AyBp+4BI;EACI,gBAAA;EACA,yBtB+CA;AHu74BR;AyBp+4BI;EACI,ctBWE;EsBVF,yBtB2CA;EsB1CA,qBtBuKI;AH+z4BZ;;AyBn+4BA;EACI,WtBwCI;EsBvCJ,yBtBIM;EsBHN,qBtBGM;AHm+4BV;;AyBp+4BA;EACI,ctBkQS;EsBjQT,sBtBkCI;EsBjCJ,qBtB4JQ;EsB3JR,YAAA;AzBu+4BJ;;AyBj+4BY;EACI,gBAAA;AzBo+4BhB;AyBl+4BY;EACI,gBAAA;AzBo+4BhB;AyBl+4BY;EACI,gBAAA;AzBo+4BhB;AyBl+4BY;EACI,gBAAA;AzBo+4BhB;;AyB994BI;EACI,iBAAA;AzBi+4BR;AyBh+4BQ;EACI,SAAA;EACA,kBtB2WI;EsB1WJ,oBAAA;AzBk+4BZ;AyBj+4BY;EACI,gBtBzCO;AH4g5BvB;AyB/94BY;EACI,kBtBmWA;EsBlWA,yBtBtCN;EsBuCM,WtBJR;AHq+4BR;AyB994BgB;EACI,kBtB6VJ;EsB5VI,yBtB5CV;EsB6CU,WtBVZ;AH0+4BR;AyB394BY;EACI,yBtBlBR;EsBmBQ,ctBpDN;AHih5BV;;AyBx94BA;EACI,kBtB8UY;AH6o4BhB;AyB194BI;EACI,iBAAA;AzB494BR;AyB394BQ;EACI,oBAAA;EACA,oBAAA;AzB694BZ;AyB194BY;EACI,sBtBhCR;EsBiCQ,ctBpEN;EsBqEM,kBAAA;EACA,iBAAA;AzB494BhB;AyB394BgB;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBtB9EV;AH2i5BV;AyBx94BY;EACI,6BAAA;AzB094BhB;;AyBr94BA;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;AzBw94BJ;AyBv94BI;EACI,iBAAA;AzBy94BR;AyBx94BQ;EACI,SAAA;EACA,mBAAA;EACA,oBAAA;AzB094BZ;AyBz94BY;EACI,gBtB7GO;AHwk5BvB;AyBv94BY;EACI,yBtBzGN;EsB0GM,WtBvER;AHgi5BR;AyBt94BgB;EACI,yBtB9GV;AHsk5BV;AyBn94BY;EACI,yBtBnFR;AHwi5BR;;AyB984BQ;EACI,oBAAA;EACA,oBAAA;EACA,kBtB0QI;AHus4BhB;AyBh94BY;EACI,gBtBzIO;AH2l5BvB;AyB984BY;EACI,SAAA;EACA,kBtBkQA;EsBjQA,yBtBvIN;EsBwIM,WtBrGR;AHqj5BR;AyB784BgB;EACI,yBtB5IV;AH2l5BV;AyB184BY;EACI,6BAAA;AzB484BhB;;A0Bln5BA;;;;;;;;;;;;EAYE,cvB2QY;EuB1QZ,oCvBGoB;EuBFpB,gBvBFiB;EuBGjB,gBAAA;A1Bqn5BF;;A0Bnn5BA;;EAEE,eAAA;A1Bsn5BF;;A0Bpn5BA;;EAEE,kBAAA;A1Bun5BF;;A0Brn5BA;;EAEE,iBAAA;A1Bwn5BF;;A0Btn5BA;;EAEE,mBAAA;A1Byn5BF;;A0Bvn5BA;;EAEE,eAAA;A1B0n5BF;;A0Bxn5BA;;EAEE,mBAAA;A1B2n5BF;;A0Bzn5BA;EACE,oBAAA;A1B4n5BF;;A0B1n5BA;EACE,mBAAA;A1B6n5BF;;A0B3n5BA;EACE,mBAAA;A1B8n5BF;;A0B1n5BA;EACE,oBAAA;A1B6n5BF;;A0B3n5BA;EACE,mBAAA;A1B8n5BF;;A0B5n5BA;EACE,oBAAA;A1B+n5BF;;A0B7n5BA;EACE,kBAAA;A1Bgo5BF;;A0B9n5BA;EACE,oBAAA;A1Bio5BF;;A0B/n5BA;EACE,mBAAA;A1Bko5BF;;A0Bho5BA;EACE,oBAAA;A1Bmo5BF;;A0Bjo5BA;EACE,iBAAA;A1Boo5BF;;A0Blo5BA;EACE,oBAAA;A1Bqo5BF;;A0Bno5BA;EACE,mBAAA;A1Bso5BF;;A0Bpo5BA;EACE,oBAAA;A1Buo5BF;;A0Bro5BA;EACE,kBAAA;A1Bwo5BF;;A0Bto5BA;EACE,oBAAA;A1Byo5BF;;A0Bvo5BA;EACE,mBAAA;A1B0o5BF;;A0Bxo5BA;EACE,oBAAA;A1B2o5BF;;A0Bzo5BA;EACE,eAAA;A1B4o5BF;;A0B1o5BA;EACE,oBAAA;A1B6o5BF;;A0B3o5BA;EACE,mBAAA;A1B8o5BF;;A0B5o5BA;EACE,oBAAA;A1B+o5BF;;A0B7o5BA;EACE,kBAAA;A1Bgp5BF;;A0B9o5BA;EACE,oBAAA;A1Bip5BF;;A0B/o5BA;EACE,mBAAA;A1Bkp5BF;;A0Bhp5BA;EACE,oBAAA;A1Bmp5BF;;A0Bjp5BA;EACE,iBAAA;A1Bop5BF;;A0Blp5BA;EACE,oBAAA;A1Bqp5BF;;A0Bnp5BA;EACE,mBAAA;A1Bsp5BF;;A0Bpp5BA;EACE,oBAAA;A1Bup5BF;;A0Brp5BA;EACE,kBAAA;A1Bwp5BF;AIjv5BI;EsBwFJ;IAGI,kBAAA;E1B0p5BF;AACF;;A0Bxp5BA;EACE,oBAAA;A1B2p5BF;;A0Bxp5BA;EACE,mBAAA;A1B2p5BF;;A0Bzp5BA;EACE,eAAA;A1B4p5BF;;A0B1p5BA;EACE,mBAAA;A1B6p5BF;;A0B3p5BA;EACE,kBAAA;A1B8p5BF;;A0B5p5BA;EACE,mBAAA;A1B+p5BF;;A0B7p5BA;EACE,iBAAA;A1Bgq5BF;;A0B9p5BA;EACE,kBAAA;A1Biq5BF;AItx5BI;EsBoHJ;IAGI,mBAAA;E1Bmq5BF;AACF;AI3x5BI;EsBoHJ;IAMI,mBAAA;E1Bqq5BF;AACF;;A0Bnq5BA;EACE,yBAAA;A1Bsq5BF;;A0Bpq5BA;EACE,yBAAA;A1Buq5BF;;A0Brq5BA;EACE,yBAAA;EACA,UAAA;A1Bwq5BF;A0Bvq5BE;EACE,yCAAA;A1Byq5BJ;A0Bvq5BE;EACE,yCAAA;A1Byq5BJ;A0Bvq5BE;EACE,wCAAA;A1Byq5BJ;;A0Btq5BA;EACE,yBAAA;EACA,UAAA;A1Byq5BF;;A0Bvq5BA;EACE,yBAAA;EACA,UAAA;A1B0q5BF;;A0Bxq5BA;EACE,yBAAA;EACA,UAAA;A1B2q5BF;;A0Bzq5BA;EACE,yBAAA;EACA,UAAA;A1B4q5BF;;A0B1q5BA;EACE,yBAAA;EACA,UAAA;A1B6q5BF;;A0B3q5BA;EACE,yBAAA;A1B8q5BF;;A0B5q5BA;EACE,yBAAA;A1B+q5BF;;A0B7q5BA;EACE,yBAAA;A1Bgr5BF;;A0B9q5BA;EACE,yBAAA;A1Bir5BF;;A0B/q5BA;EACE,yBAAA;A1Bkr5BF;;A0Bhr5BA;EACE,yBAAA;A1Bmr5BF;;A0Bjr5BA;EACE,yBAAA;A1Bor5BF;;A0Blr5BA;EACE,yBAAA;A1Bqr5BF;;A0Bnr5BA;EACE,yBAAA;A1Bsr5BF;;A0Bpr5BA;EACE,yBAAA;A1Bur5BF;;A0Brr5BA;EACE,sBAAA;A1Bwr5BF;;A0Btr5BA;EACE,sBAAA;A1Byr5BF;;A0Bvr5BA;EACE,sBAAA;A1B0r5BF;;A0Bxr5BA;EACE,sBAAA;A1B2r5BF;;A0Bzr5BA;EACE,cvBvES;AHmw5BX;;A0B1r5BA;EACE,cvBzES;AHsw5BX;;A0B3r5BA;EACE,cvB3ES;AHyw5BX;;A0B5r5BA;EACE,cvB7ES;AH4w5BX;;A0B7r5BA;EACE,cvB/ES;AH+w5BX;;A0B9r5BA;EACE,cvBjFS;AHkx5BX;;A0B/r5BA;EACE,cvBnFS;AHqx5BX;;A0Bhs5BA;EACE,cvBrFS;AHwx5BX;;A0Bjs5BA;EACE,cvBvFS;AH2x5BX;;A0Bls5BA;EACE,cvB1FS;EuB2FT,eAAA;EACA,qBAAA;EtB9LA,yBsB+LoB;A1Bus5BtB;A0Bts5BE;EACE,cvBxQM;ECuER,yBsBkMsB;A1B0s5BxB;A0Bxs5BE;EACE,UAAA;A1B0s5BJ;;A0Bvs5BA;EACE,yBAAA;A1B0s5BF;A0Bzs5BE;EAGE,yBAAA;A1Bys5BJ;;A0Bts5BA;EACE,yBAAA;A1Bys5BF;A0Bxs5BE;EAGE,yBAAA;A1Bws5BJ;;A0Brs5BA;EACE,yBAAA;A1Bws5BF;A0Bvs5BE;EAGE,yBAAA;A1Bus5BJ;;A0Bps5BA;EACE,yBAAA;A1Bus5BF;A0Bts5BE;EAGE,yBAAA;A1Bss5BJ;;A0Bns5BA;EACE,yBAAA;A1Bss5BF;A0Brs5BE;EAGE,yBAAA;A1Bqs5BJ;;A0Bls5BA;EACE,yBAAA;A1Bqs5BF;A0Bps5BE;EAGE,yBAAA;A1Bos5BJ;;A0Bjs5BA;EACE,yBAAA;A1Bos5BF;A0Bns5BE;EAGE,yBAAA;A1Bms5BJ;;A0Bhs5BA;EACE,yBAAA;A1Bms5BF;A0Bls5BE;EAGE,yBAAA;A1Bks5BJ;;A0B9r5BE;EACE,gCAAA;A1Bis5BJ;;A0B7r5BA;EACE,yBAAA;A1Bgs5BF;;A0B9r5BA;EACE,gBAAA;EACA,8BAAA;EACA,kBAAA;A1Bis5BF;A0Bhs5BE;EACE,+BAAA;EACA,cAAA;A1Bks5BJ;;A0B/r5BA;EACE,kBAAA;EACA,gBvB5WqB;EuB6WrB,aAAA;EACA,kBvBmCc;EuBlCd,kBAAA;A1Bks5BF;A0Bjs5BE;EACE,gBAAA;EACA,0BvB5WW;EuB6WX,UAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;A1Bms5BJ;A0Bjs5BE;EACE,wCAAA;EACA,sCAAA;A1Bms5BJ;A0Bls5BI;EACE,6BAAA;A1Bos5BN;A0Bjs5BE;EACE,wCAAA;EACA,sCAAA;A1Bms5BJ;A0Bls5BI;EACE,6BAAA;A1Bos5BN;A0Bjs5BE;EACE,yCAAA;EACA,sCAAA;A1Bms5BJ;A0Bls5BI;EACE,8BAAA;A1Bos5BN;A0Bjs5BE;EACE,wCAAA;EACA,sCAAA;A1Bms5BJ;A0Bls5BI;EACE,6BAAA;A1Bos5BN;A0Bjs5BE;EACE,wCAAA;EACA,sCAAA;A1Bms5BJ;A0Bls5BI;EACE,6BAAA;A1Bos5BN;A0Bjs5BE;EACE,uCAAA;EACA,sCAAA;A1Bms5BJ;A0Bls5BI;EACE,4BAAA;A1Bos5BN;;A0B9r5BE;EACE,+DAAA;A1Bis5BJ;A0B/r5BE;EACE,0DAAA;A1Bis5BJ;A0B/r5BE;EACE,wDAAA;A1Bis5BJ;;A0B7r5BA;EACE;IACE,WAAA;E1Bgs5BF;AACF;A0B5r5BE;EACE,gCAAA;EACA,iCAAA;A1B8r5BJ;;A0B3r5BA;EACE,0BAAA;A1B8r5BF;;A0B5r5BA;EACE,UAAA;A1B+r5BF;;A0B7r5BA;EACE,WAAA;A1Bgs5BF;;A0B9r5BA;EACI,kBAAA;EACA,kBAAA;A1Bis5BJ;;A2Bpp6BA;EACE,yBAAA;EACA,kBxB0Zc;EwBzZd,oBAAA;A3Bup6BF;A2Btp6BE;EACE,0CAAA;A3Bwp6BJ;A2Btp6BE;EACE,exB4aW;AH4u5Bf;A2Btp6BE;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A3Bwp6BJ;A2Bvp6BI;EACE,exBkaS;EwBjaT,iBAAA;A3Byp6BN;A2Btp6BE;EACE,gBAAA;A3Bwp6BJ;A2Btp6BE;EACE,gBxBdmB;AHsq6BvB;;A2Bpp6BE;EACE,0CAAA;A3Bup6BJ;;A2B5o6BA;EACE,wCAAA;EACA,cxBfQ;EwBgBR,oCAAA;A3B+o6BF;A2B9o6BE;EACE,cxBlBM;AHkq6BV;A2B9o6BE;EACE,cxBrBM;AHqq6BV;A2B/o6BI;EAhBF,yBxBNQ;EwBOR,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3Bkq6BF;;A2Blp6BA;EACE,wCAAA;EACA,cxBrCQ;EwBsCR,oCAAA;A3Bqp6BF;A2Bpp6BE;EACE,cxBxCM;AH8r6BV;A2Bpp6BE;EACD,cxB3CS;AHis6BV;A2Bpp6BE;EACE,cxB9CM;AHos6BV;A2Brp6BI;EAjCF,yBxBdQ;EwBeR,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3Byr6BF;;A2Bxp6BA;EACE,wCAAA;EACA,cxBpDU;EwBqDV,oCAAA;A3B2p6BF;A2B1p6BE;EACE,cxBvDQ;AHmt6BZ;A2B1p6BE;EACE,cxB1DQ;AHst6BZ;A2B3p6BI;EA/CF,yBxBZU;EwBaV,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3B6s6BF;;A2B9p6BA;EACE,wCAAA;EACA,cxBhEQ;EwBiER,oCAAA;A3Biq6BF;A2Bhq6BE;EACE,cxBnEM;AHqu6BV;A2Bhq6BE;EACE,cxBtEM;AHwu6BV;A2Bjq6BI;EA7DF,yBxBVQ;EwBWR,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3Biu6BF;;A2Bpq6BA;EACE,yCAAA;EACA,cxB5EK;EwB6EL,qCAAA;A3Buq6BF;A2Btq6BE;EACE,cxB/EG;AHuv6BP;A2Btq6BE;EACE,cxBlFG;AH0v6BP;A2Bvq6BI;EA3EF,yBxBRK;EwBSL,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3Bqv6BF;;A2B1q6BA;EACE,uCAAA;EACA,cxBtFO;EwBuFP,mCAAA;A3B6q6BF;A2B5q6BE;EACE,cxBzFK;AHuw6BT;A2B5q6BE;EACE,cxB5FK;AH0w6BT;A2B7q6BI;EAzFF,yBxBJO;EwBKP,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3Byw6BF;;A2Bhr6BA;EACE,yBxB5EM;EwB6EN,cxBoJW;EwBnJX,qBxB9EM;AHiw6BR;A2Blr6BE;EACE,cxBiJS;AHmi6Bb;A2Blr6BE;EACE,cxB8IS;AHsi6Bb;A2Bnr6BI;EAvGF,yBxBmBM;EwBlBN,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3B6x6BF;;A2Btr6BA;EACE,uCAAA;EACA,cxBsIW;EwBrIX,mCAAA;A3Byr6BF;A2Bxr6BE;EACE,cxBmIS;AHuj6Bb;A2Bxr6BE;EACE,WxB/FI;AHyx6BR;A2Bzr6BI;EArHF,yBxBFK;EwBGL,WxBoBM;EwBnBN,UAAA;EACA,mBAAA;EACA,8DxB+XW;EwB9XX,gBAAA;A3Biz6BF;;A2Bpr6BA;EAPE,yBxBzIQ;EwB0IR,WxBvGM;EwBwGN,qBxB3IQ;AH006BV;A2B9r6BE;EACE,WxB1GI;AH0y6BR;;A2B1r6BA;EAVE,yBxBvIU;EwBwIV,WxBvGM;EwBwGN,qBxBzIU;AHi16BZ;A2Bvs6BE;EACE,WxB1GI;AHmz6BR;;A2Bhs6BA;EAbE,yBxBjIQ;EwBkIR,WxBvGM;EwBwGN,qBxBnIQ;AHo16BV;A2Bht6BE;EACE,WxB1GI;AH4z6BR;;A2Bts6BA;EAhBE,yBxBnIK;EwBoIL,WxBvGM;EwBwGN,qBxBrIK;AH+16BP;A2Bzt6BE;EACE,WxB1GI;AHq06BR;;A2B5s6BA;EAnBE,yBxBrIQ;EwBsIR,WxBvGM;EwBwGN,qBxBvIQ;AH026BV;A2Blu6BE;EACE,WxB1GI;AH806BR;;A2Blt6BA;EAtBE,yBxB/HO;EwBgIP,WxBvGM;EwBwGN,qBxBjIO;AH626BT;A2B3u6BE;EACE,WxB1GI;AHu16BR;;A2Bxt6BA;EACE,yBxBlIM;EwBmIN,cxB8FW;EwB7FX,qBxBPU;AHku6BZ;;A2Bzt6BA;EA9BE,yBxB7HK;EwB8HL,WxBvGM;EwBwGN,qBxB/HK;AH036BP;A2B1v6BE;EACE,WxB1GI;AHs26BR;;A2Bvt6BA;EAPE,sBxBxIM;EwByIN,cxB5KQ;EwB6KR,qBxB7KQ;AH+46BV;A2Bju6BE;EACE,cxB/KM;AHk56BV;;A2B7t6BA;EAVE,sBxBxIM;EwByIN,cxB1KU;EwB2KV,qBxB3KU;AHs56BZ;A2B1u6BE;EACE,cxB7KQ;AHy56BZ;;A2Bnu6BA;EAbE,sBxBxIM;EwByIN,cxBtKK;EwBuKL,qBxBvKK;AH256BP;A2Bnv6BE;EACE,cxBzKG;AH856BP;;A2Bzu6BA;EAhBE,sBxBxIM;EwByIN,cxBpKQ;EwBqKR,qBxBrKQ;AHk66BV;A2B5v6BE;EACE,cxBvKM;AHq66BV;;A2B/u6BA;EAnBE,sBxBxIM;EwByIN,cxBxKQ;EwByKR,qBxBzKQ;AH+66BV;A2Brw6BE;EACE,cxB3KM;AHk76BV;;A2Brv6BA;EAtBE,sBxBxIM;EwByIN,cxBlKO;EwBmKP,qBxBnKO;AHk76BT;A2B9w6BE;EACE,cxBrKK;AHq76BT;;A2B3v6BA;EACE,sBxBlKM;EwBmKN,cxB4DW;EwB3DX,qBxBtKM;AHo66BR;;A2B5v6BA;EA9BE,sBxBxIM;EwByIN,cxBhKK;EwBiKL,qBxBjKK;AH+76BP;A2B7x6BE;EACE,cxBnKG;AHk86BP;;A2Bxv6BA;EATE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3Bqw6BF;A2Bpw6BE;EACE,cxB+CS;AHut6Bb;A2Bjw6BE;EACD,cxBzNS;AH496BV;;A2Bhw6BA;EAfE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3Bmx6BF;A2Blx6BE;EACE,cxB+CS;AHqu6Bb;A2Bzw6BE;EACD,cxB7NW;AHw+6BZ;;A2Bxw6BA;EArBE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3Biy6BF;A2Bhy6BE;EACE,cxB+CS;AHmv6Bb;A2Bjx6BE;EACD,cxB7NS;AHg/6BV;;A2Bhx6BA;EA3BE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3B+y6BF;A2B9y6BE;EACE,cxB+CS;AHiw6Bb;A2Bzx6BE;EACD,cxBjOQ;AH4/6BT;;A2Bxx6BA;EAjCE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3B6z6BF;A2B5z6BE;EACE,cxB+CS;AH+w6Bb;;A2Bhy6BA;EApCE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3Bw06BF;A2Bv06BE;EACE,cxB+CS;AH0x6Bb;;A2Bxy6BA;EAvCE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3Bm16BF;A2Bl16BE;EACE,cxB+CS;AHqy6Bb;;A2Bhz6BA;EA1CE,sDAAA;EACA,cxByDW;EwBxDX,sBxB5KM;EwB6KN,yBAAA;EACA,mBAAA;A3B816BF;A2B716BE;EACE,cxB+CS;AHgz6Bb;;A2Bxz6BA;EACE,mBAAA;EACA,sBxBzNM;EwB0NN,SAAA;EACA,gBAAA;EACA,cxBGW;AHwz6Bb;A2B1z6BE;EACE,wBAAA;EACA,cxBKS;EwBJT,iBAAA;A3B4z6BJ;A2B1z6BE;EACD,exBmKc;EwBlKX,sBAAA;A3B4z6BJ;A2B3z6BC;EACC,exBgKa;AH6p6Bf;A2B1z6BE;EACE,UAAA;EACA,sBAAA;A3B4z6BJ;A2B1z6BE;EACE,0CAAA;A3B4z6BJ;A2B3z6BC;EACC,cxBnRQ;AHgl7BV;A2B1z6BE;EACE,0CAAA;A3B4z6BJ;A2B3z6BC;EACC,cxBvRU;AHol7BZ;A2B1z6BE;EACE,0CAAA;A3B4z6BJ;A2B3z6BC;EACC,cxBvRQ;AHol7BV;A2B1z6BE;EACE,0CAAA;A3B4z6BJ;A2B3z6BC;EACC,cxB3RO;AHwl7BT;;A2Bzz6BA;EACE,aAAA;EACA,mBAAA;A3B4z6BF;A2B3z6BE;EACE,oCAAA;A3B6z6BJ;;A2B1z6BA;EACE;IACE,qBAAA;E3B6z6BF;AACF;A2B3z6BA;EACI,UAAA;A3B6z6BJ;;A2B3z6BA;EACI,UAAA;A3B8z6BJ;;A2B5z6BA;EACI,YAAA;A3B+z6BJ;;A2B7z6BA;EACI,YAAA;A3Bg06BJ;;A2B9z6BA;EACI,YAAA;A3Bi06BJ;;A2B/z6BA;EACI,YAAA;A3Bk06BJ;;A2Bh06BA;EACI,YAAA;A3Bm06BJ;;A2Bj06BA;EACI,YAAA;A3Bo06BJ;;A2Bl06BA;EACI,YAAA;A3Bq06BJ;;A2Bn06BA;EACI,YAAA;A3Bs06BJ;;A2Bp06BA;EACI,YAAA;A3Bu06BJ;;A4B/q7BA;EACE,+BAAA;EACA,kCAAA;EACA,+BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mCAAA;A5Bkr7BF;;A4Bhr7BA;EACE,sBzB8CM;EyB7CN,yBAAA;EACA,8DzB0ZW;EyBzZX,iBAAA;EACA,kBzB+Yc;EyB9Yd,YAAA;A5Bmr7BF;A4Blr7BE;EACE,sBzBuCI;EyBtCJ,mCAAA;A5Bor7BJ;A4Blr7BE;EACE,czBkQS;AHk76Bb;A4Blr7BE;EACE,qBAAA;A5Bor7BJ;;A4Bjr7BA;;;;EAIE,yBzBuBM;AH6p7BR;;A4Blr7BA;;;;EAIE,2BzBiBM;AHoq7BR;;A4Bnr7BA;;;;EAIE,0BzBWM;AH2q7BR;;A4Bpr7BA;;;;;;EAME,4BzBGM;AHor7BR;;A4Bnr7BE;EACE,yBzBnCM;EyBoCN,WzBDI;AHur7BR;A4Bpr7BE;EAEE,4BzBxCM;AH6t7BV;;A4B3r7BE;EACE,yBzBjCQ;EyBkCR,WzBDI;AH+r7BR;A4B5r7BE;EAEE,4BzBtCQ;AHmu7BZ;;A4Bns7BE;EACE,yBzB3BM;EyB4BN,WzBDI;AHus7BR;A4Bps7BE;EAEE,4BzBhCM;AHqu7BV;;A4B3s7BE;EACE,yBzB7BG;EyB8BH,WzBDI;AH+s7BR;A4B5s7BE;EAEE,4BzBlCG;AH+u7BP;;A4Bnt7BE;EACE,yBzB/BM;EyBgCN,WzBDI;AHut7BR;A4Bpt7BE;EAEE,4BzBpCM;AHyv7BV;;A4B3t7BE;EACE,yBzBzBK;EyB0BL,WzBDI;AH+t7BR;A4B5t7BE;EAEE,4BzB9BK;AH2v7BT;;A4Bvs7BE;EACI,yBAAA;A5B0s7BN;A4Bzs7BI;EACE,yBzBjEI;EyBkEJ,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5B2s7BN;A4Bzs7BI;EACE,yBzBvEI;EyBwEJ,WzBrCE;EyBsCF,gCAAA;A5B2s7BN;A4Bxs7BE;EAIE,yBzBhFM;AHux7BV;A4Brs7BE;EAIE,2BzBtFM;AH0x7BV;A4Bls7BE;EAIE,0BzB5FM;AH6x7BV;A4B/r7BE;EAME,4BzBpGM;AHgy7BV;;A4Blu7BE;EACI,yBAAA;A5Bqu7BN;A4Bpu7BI;EACE,yBzB/DM;EyBgEN,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5Bsu7BN;A4Bpu7BI;EACE,yBzBrEM;EyBsEN,WzBrCE;EyBsCF,gCAAA;A5Bsu7BN;A4Bnu7BE;EAIE,yBzB9EQ;AHgz7BZ;A4Bhu7BE;EAIE,2BzBpFQ;AHmz7BZ;A4B7t7BE;EAIE,0BzB1FQ;AHsz7BZ;A4B1t7BE;EAME,4BzBlGQ;AHyz7BZ;;A4B7v7BE;EACI,yBAAA;A5Bgw7BN;A4B/v7BI;EACE,yBzBzDI;EyB0DJ,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5Biw7BN;A4B/v7BI;EACE,yBzB/DI;EyBgEJ,WzBrCE;EyBsCF,gCAAA;A5Biw7BN;A4B9v7BE;EAIE,yBzBxEM;AHq07BV;A4B3v7BE;EAIE,2BzB9EM;AHw07BV;A4Bxv7BE;EAIE,0BzBpFM;AH207BV;A4Brv7BE;EAME,4BzB5FM;AH807BV;;A4Bxx7BE;EACI,yBAAA;A5B2x7BN;A4B1x7BI;EACE,yBzB3DC;EyB4DD,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5B4x7BN;A4B1x7BI;EACE,yBzBjEC;EyBkED,WzBrCE;EyBsCF,gCAAA;A5B4x7BN;A4Bzx7BE;EAIE,yBzB1EG;AHk27BP;A4Btx7BE;EAIE,2BzBhFG;AHq27BP;A4Bnx7BE;EAIE,0BzBtFG;AHw27BP;A4Bhx7BE;EAME,4BzB9FG;AH227BP;;A4Bnz7BE;EACI,yBAAA;A5Bsz7BN;A4Brz7BI;EACE,yBzB7DI;EyB8DJ,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5Buz7BN;A4Brz7BI;EACE,yBzBnEI;EyBoEJ,WzBrCE;EyBsCF,gCAAA;A5Buz7BN;A4Bpz7BE;EAIE,yBzB5EM;AH+37BV;A4Bjz7BE;EAIE,2BzBlFM;AHk47BV;A4B9y7BE;EAIE,0BzBxFM;AHq47BV;A4B3y7BE;EAME,4BzBhGM;AHw47BV;;A4B907BE;EACI,yBAAA;A5Bi17BN;A4Bh17BI;EACE,yBzBvDG;EyBwDH,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5Bk17BN;A4Bh17BI;EACE,yBzB7DG;EyB8DH,WzBrCE;EyBsCF,gCAAA;A5Bk17BN;A4B/07BE;EAIE,yBzBtEK;AHo57BT;A4B507BE;EAIE,2BzB5EK;AHu57BT;A4Bz07BE;EAIE,0BzBlFK;AH057BT;A4Bt07BE;EAME,4BzB1FK;AH657BT;;A4Bz27BE;EACI,yBAAA;A5B427BN;A4B327BI;EACE,yBzB5BG;EyB6BH,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5B627BN;A4B327BI;EACE,yBzBlCG;EyBmCH,WzBrCE;EyBsCF,gCAAA;A5B627BN;A4B127BE;EAIE,yBzB3CK;AHo57BT;A4Bv27BE;EAIE,2BzBjDK;AHu57BT;A4Bp27BE;EAIE,0BzBvDK;AH057BT;A4Bj27BE;EAME,4BzB/DK;AH657BT;;A4Bp47BE;EACI,yBAAA;A5Bu47BN;A4Bt47BI;EACE,yBzBzBC;EyB0BD,oDAAA;EACA,WzBhCE;EyBiCF,gCAAA;A5Bw47BN;A4Bt47BI;EACE,yBzB/BC;EyBgCD,WzBrCE;EyBsCF,gCAAA;A5Bw47BN;A4Br47BE;EAIE,yBzBxCG;AH467BP;A4Bl47BE;EAIE,2BzB9CG;AH+67BP;A4B/37BE;EAIE,0BzBpDG;AHk77BP;A4B537BE;EAME,4BzB5DG;AHq77BP;;A4B517BI;EACI,wCAAA;A5B+17BR;A4B917BM;EACE,wCAAA;EACA,kDAAA;EACA,czBtIE;EyBuIF,gBAAA;A5Bg27BR;A4B917BM;EACE,wCAAA;EACA,czB3IE;AH2+7BV;A4B717BI;EAIE,wCAAA;A5B417BN;A4B117BI;EAIE,0CAAA;A5By17BN;A4Bv17BI;EAIE,yCAAA;A5Bs17BN;A4Bp17BI;EAME,2CAAA;A5Bi17BN;;A4B707BI;EACI,wCAAA;A5Bg17BR;A4B/07BM;EACE,wCAAA;EACA,kDAAA;EACA,czB7KI;EyB8KJ,gBAAA;A5Bi17BR;A4B/07BM;EACE,wCAAA;EACA,czBlLI;AHmg8BZ;A4B907BI;EAIE,iDAAA;A5B607BN;A4B307BI;EAIE,0CAAA;A5B007BN;A4Bx07BI;EAIE,kDAAA;A5Bu07BN;A4Br07BI;EAME,oDAAA;A5Bk07BN;;A4B9z7BI;EACI,wCAAA;A5Bi07BR;A4Bh07BM;EACE,wCAAA;EACA,kDAAA;EACA,czBhNE;EyBiNF,gBAAA;A5Bk07BR;A4Bh07BM;EACE,wCAAA;EACA,czBrNE;AHuh8BV;A4B/z7BI;EAIE,wCAAA;A5B8z7BN;A4B5z7BI;EAIE,0CAAA;A5B2z7BN;A4Bzz7BI;EAIE,yCAAA;A5Bwz7BN;A4Btz7BI;EAME,2CAAA;A5Bmz7BN;;A4B/y7BI;EACI,yCAAA;A5Bkz7BR;A4Bjz7BM;EACE,yCAAA;EACA,mDAAA;EACA,czB3PD;EyB4PC,gBAAA;A5Bmz7BR;A4Bjz7BM;EACE,yCAAA;EACA,czBhQD;AHmj8BP;A4Bhz7BI;EAIE,yCAAA;A5B+y7BN;A4B7y7BI;EAIE,2CAAA;A5B4y7BN;A4B1y7BI;EAIE,0CAAA;A5Byy7BN;A4Bvy7BI;EAME,4CAAA;A5Boy7BN;;A4Bhy7BI;EACI,wCAAA;A5Bmy7BR;A4Bly7BM;EACE,wCAAA;EACA,kDAAA;EACA,czBtSE;EyBuSF,gBAAA;A5Boy7BR;A4Bly7BM;EACE,wCAAA;EACA,czB3SE;AH+k8BV;A4Bjy7BI;EAIE,wCAAA;A5Bgy7BN;A4B9x7BI;EAIE,0CAAA;A5B6x7BN;A4B3x7BI;EAIE,yCAAA;A5B0x7BN;A4Bxx7BI;EAME,2CAAA;A5Bqx7BN;;A4Bjx7BI;EACI,uCAAA;A5Box7BR;A4Bnx7BM;EACE,uCAAA;EACA,iDAAA;EACA,czBzUC;EyB0UD,gBAAA;A5Bqx7BR;A4Bnx7BM;EACE,uCAAA;EACA,czB9UC;AHmm8BT;A4Blx7BI;EAIE,uCAAA;A5Bix7BN;A4B/w7BI;EAIE,yCAAA;A5B8w7BN;A4B5w7BI;EAIE,wCAAA;A5B2w7BN;A4Bzw7BI;EAME,0CAAA;A5Bsw7BN;;A4Blw7BI;EACI,8CAAA;A5Bqw7BR;A4Bpw7BM;EACE,8CAAA;EACA,wDAAA;EACA,czBvVC;EyBwVD,gBAAA;A5Bsw7BR;A4Bpw7BM;EACE,8CAAA;EACA,czB5VC;AHkm8BT;A4Bnw7BI;EAIE,8CAAA;A5Bkw7BN;A4Bhw7BI;EAIE,gDAAA;A5B+v7BN;A4B7v7BI;EAIE,+CAAA;A5B4v7BN;A4B1v7BI;EAME,iDAAA;A5Buv7BN;;A4Bnv7BI;EACI,4CAAA;A5Bsv7BR;A4Brv7BM;EACE,4CAAA;EACA,sDAAA;EACA,czB7XD;EyB8XC,gBAAA;A5Buv7BR;A4Brv7BM;EACE,4CAAA;EACA,czBlYD;AHyn8BP;A4Bpv7BI;EAIE,4CAAA;A5Bmv7BN;A4Bjv7BI;EAIE,8CAAA;A5Bgv7BN;A4B9u7BI;EAIE,6CAAA;A5B6u7BN;A4B3u7BI;EAME,+CAAA;A5Bwu7BN;;A4Bru7BA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;ExBxXD,cwByXyB;ExBxXzB,oBwBwXiC;A5Byu7BpC;A4Bxu7BI;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBzB/SK;ECxFT,kBwBwYwB;ExBvYxB,MwBuYiC;ExBrYjC,SwBqYwC;ExBpYxC,SwBoY0C;A5B6u7B5C;A4B3u7BI;EACE,kBAAA;EACA,mBAAA;A5B6u7BN;A4B5u7BM;EACI,YAAA;EACD,cAAA;A5B8u7BT;A4B5u7BM;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;ExBtXR,sBwBuX2B;ExB3W3B,yCAAA;AJ4l8BF;A4B/u7BY;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;ExBhad,kBwBiakC;ExBhalC,SwBga2C;ExB/Z3C,WwB+ZgD;A5Bmv7BlD;A4Bjv7Bc;EACI,YAAA;EACA,qBAAA;ExBrahB,kBwBsaoC;ExBrapC,SwBqa6C;ExBpa7C,WwBoakD;EAClC,iCAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;A5Bqv7BlB;;A4Bhv7BA;EACE,WAAA;A5Bmv7BF;;A4Bjv7BA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WzBleM;EyBmeN,gBAAA;ExB3ZA,kBwB4ZmB;ExB5bnB,kBwB6boB;ExB5bpB,SwB4b6B;ExBzb7B,SwByb4C;A5Bsv7B9C;;A4Bpv7BA;EACE,YAAA;A5Buv7BF;A4Btv7BE;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A5Bwv7BN;A4Btv7BI;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A5Bwv7BR;;A4Brv7BA;EACE,yBzB1hBQ;AHkx8BV;;A4Btv7BA;EACE,yBzBzhBQ;AHkx8BV;;A4Bvv7BA;EACE,yBzBxhBQ;AHkx8BV;;A4Bxv7BA;EACE,yBzBzhBO;AHox8BT;;A4Bzv7BA;EACE,yBzBhiBK;AH4x8BP;;A4B1v7BA;EACE,aAAA;EACA,cAAA;EACA,oBAAA;A5B6v7BF;;A4B3v7BA;;EAEE,gBAAA;A5B8v7BF;;A4B5v7BA;EACE,eAAA;A5B+v7BF;;A6Br08BA;EACI,mBAAA;A7Bw08BJ;;A6Bt08BA;EACI,e1B4aW;E0B3aX,gB1BKiB;E0BJjB,c1BiRU;AHwj8Bd;;A6Bv08BA;EACE,qB1ByKU;E0BxKV,cAAA;EACA,yB1BuRgB;E0BtRhB,eAAA;EACA,gB1BJmB;E0BKnB,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBAAA;EACA,8CAAA;A7B008BF;A6Bz08BE;EACE,qBAAA;EACA,sB1BiCI;E0BhCJ,6CAAA;EACA,cAAA;A7B208BJ;A6Bx08BE;EACE,cAAA;EACA,UAAA;A7B008BJ;A6Bv08BE;EACE,qBAAA;A7By08BJ;A6Bt08BE;EACE,6CAAA;A7Bw08BJ;A6Br08BE;EAEE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;A7Bs08BJ;;A6Bn08BA;EACE,sBAAA;EACA,gBAAA;A7Bs08BF;A6Br08BE;EACE,kCAAA;A7Bu08BJ;A6Br08BE;EACE,+BAAA;A7Bu08BJ;;A6Bp08BA;EACI,e1BoXW;E0BnXX,gB1BnDiB;E0BoDjB,c1ByNU;EC/KX,gByBzC+B;A7Bu08BlC;;A6Br08BA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;A7Bw08BF;;A6Bt08BA;EACE,c1BmNW;AHsn8Bb;;A6Bt08BA;EACE,yB1BvBM;E0BwBN,SAAA;A7By08BF;A6Bv08BE;EACE,yB1B3BI;AHo28BR;;A6Bt08BA;EACE,wCAAA;EACA,SAAA;EACA,c1BlEQ;AH248BV;A6Bv08BE;EACE,wCAAA;EACA,c1BtEM;AH+48BV;;A6Bt08BA;EACE,eAAA;EACA,cAAA;EACA,kB1B4Tc;E0B3Td,gBAAA;EACA,UAAA;A7By08BF;;A6Bv08BA;;;;EAIE,c1BmLW;AHup8Bb;;A6Bx08BA;EACE,6BAAA;A7B208BF;;A6Bz08BA;EACE,6DAAA;A7B408BF;;A6B108BA;EACE,yB1BiLgB;E0BhLhB,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yDAAA;EACA,wBAAA;EACA,gBAAA;EACA,6DAAA;EACA,8CAAA;A7B608BF;A6B308BE;EACE,qBAAA;EACA,6CAAA;A7B608BJ;A6B108BE;EACE,qBAAA;A7B408BJ;A6Bz08BE;EACE,6CAAA;A7B208BJ;A6Bx08BE;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;A7B008BJ;A6Bv08BE;EACE,sB1B5FI;E0B6FJ,wBAAA;EACA,sBAAA;EACA,yBAAA;A7By08BJ;A6Bx08BI;EACE,mBAAA;A7B008BN;A6Bv08BE;;EAEE,oCAAA;EACA,yBAAA;A7By08BJ;A6Bv08BE;;EAEE,oCAAA;EACA,yBAAA;A7By08BJ;;A6Bt08BA;EACE,qB1BnJQ;AH498BV;;A6Bt08BA;EACE,WAAA;EACA,YAAA;EACA,sB1BtHM;E0BuHN,2BAAA;EACA,oBAAA;A7By08BF;A6Bv08BE;EACE,qB1B9JM;E0B+JN,6CAAA;A7By08BJ;A6Bt08BE;EACE,yB1BnKM;E0BoKN,qB1BpKM;AH4+8BV;A6Br08BI;EACE,6BAAA;EACA,qB1BzKI;AHg/8BV;A6Bn08BI;EACE,yB1B5KM;E0B6KN,qB1B7KM;AHk/8BZ;A6Bj08BI;EACE,yB1B5KI;E0B6KJ,qB1B7KI;AHg/8BV;A6B/z8BI;EACE,yB1BpLC;E0BqLD,qB1BrLC;AHs/8BP;A6B7z8BI;EACE,yB1B5LI;E0B6LJ,qB1B7LI;AH4/8BV;A6B3z8BI;EACE,yB1B5LG;E0B6LH,qB1B7LG;AH0/8BT;A6Bzz8BI;EACE,yB1B3KE;E0B4KF,qB1B5KE;AHu+8BR;A6Bvz8BI;EACE,yB1BtMC;E0BuMD,qB1BvMC;AHgg9BP;A6Btz8BE;EACE,qB1BvNM;E0BwNN,6CAAA;A7Bwz8BJ;;A6Bpz8BA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A7Buz8BF;;A6Brz8BA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;A7Bwz8BF;A6Btz8BE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,c1B1OM;E0B2ON,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;A7Bwz8BJ;A6Bpz8BI;EACE,c1BlPM;AHwi9BZ;A6Bjz8BI;EACE,c1BlPI;AHqi9BV;A6B9y8BI;EACE,c1B1PC;AH0i9BP;A6B3y8BI;EACE,c1BlQI;AH+i9BV;A6Bxy8BI;EACE,c1BlQG;AH4i9BT;A6Bry8BI;EACE,c1BjPE;AHwh9BR;A6Bly8BI;EACE,c1B5QC;AHgj9BP;;A6Bhy8BA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;A7Bmy8BF;A6Bjy8BE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,c1BrSM;E0BsSN,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;A7Bmy8BJ;A6B/x8BI;EACE,c1B7SM;AH8k9BZ;A6B5x8BI;EACE,c1B7SI;AH2k9BV;A6Bzx8BI;EACE,c1BrTC;AHgl9BP;A6Btx8BI;EACE,c1B7TI;AHql9BV;A6Bnx8BI;EACE,c1B7TG;AHkl9BT;A6Bhx8BI;EACE,c1B5SE;AH8j9BR;A6B7w8BI;EACE,c1BvUC;AHsl9BP;;A6B3w8BA;EACE,W1BrTM;E0BsTN,yB1BzVQ;E0B0VR,qB1B1VQ;AHwm9BV;;A6B5w8BA;EACE,qCAAA;EACA,UAAA;EACA,gBAAA;A7B+w8BF;;A6B7w8BA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;A7Bgx8BF;;A6B9w8BA;;;;;EAKE,gBAAA;A7Bix8BF;;A6B7w8BI;;EACE,yB1BhVE;E0BiVF,c1BhHO;AHi48Bb;;A6B9w8BA;EACE,c1BpHW;AHq48Bb;;A6B/w8BA;EACE,c1BvHW;E0BwHX,yB1BlHmB;AHo48BrB;;A6Bhx8BA;EACE,yB1BrHmB;AHw48BrB;;A6B/w8BI;EAEE,4BAAA;EACA,qDAAA;EAAA,6CAAA;A7Bix8BN;A6B9w8BE;EACE,iBAAA;EACA,gB1BnZiB;E0BoZjB,YAAA;EACA,c1BzIS;E0B0IT,yBAAA;EACA,qDAAA;EAAA,6CAAA;A7Bgx8BJ;A6B9w8BE;EACE,iBAAA;EACA,gB1B3ZiB;E0B4ZjB,YAAA;EACA,c1BjJS;AHi68Bb;A6B9w8BE;EACE,iBAAA;EACA,gB1BjaiB;E0BkajB,YAAA;EACA,c1BvJS;AHu68Bb;A6B9w8BE;EACE,iBAAA;EACA,gB1BvaiB;E0BwajB,YAAA;EACA,c1B7JS;AH668Bb;;A6B7w8BA;EACE,iBAAA;EACA,uBAAA;A7Bgx8BF;;A6B9w8BA;EACE,eAAA;EACA,oBAAA;A7Bix8BF;;A6B7w8BE;EACE,cAAA;EACA,eAAA;A7Bgx8BJ;A6B5w8BI;EACE,cAAA;A7B8w8BN;A6B1w8BE;EACE,2BAAA;EACA,kBAAA;EACA,uBAAA;A7B4w8BJ;;A6Bvw8BE;EACE,cAAA;EACA,eAAA;A7B0w8BJ;A6Btw8BI;EACE,aAAA;A7Bww8BN;A6Bpw8BE;EACE,2BAAA;EACA,eAAA;EACA,uBAAA;A7Bsw8BJ;;A6Bnw8BA;EACE,cAAA;EACA,gBAAA;EACA,yB1BlbM;E0BmbN,6BAAA;EACA,0BAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;A7Bsw8BF;A6Bpw8BE;EACE,kBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,sB1BjcI;E0BkcJ,qDAAA;EACA,eAAA;EACA,yBAAA;A7Bsw8BJ;A6Bpw8BI;EACE,aAAA;EACA,6BAAA;A7Bsw8BN;A6Bnw8BI;EACE,cAAA;EACA,2BAAA;EACA,c1B1OO;AH++8Bb;A6Blw8BI;EAEE,kBAAA;EACA,mBAAA;EACA,gB1BlgBe;E0BmgBf,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;A7Bmw8BN;A6B/v8BE;EACE,yCAAA;A7Biw8BJ;A6B/v8BI;EACE,yB1BrgBI;AHsw9BV;A6B/v8BM;EACE,c1BxgBE;AHyw9BV;A6B7v8BI;EACE,wCAAA;A7B+v8BN;A6B7v8BM;EACE,yB1B9gBI;AH6w9BZ;A6B7v8BQ;EACE,c1BjhBE;AHgx9BZ;A6B1v8BI;EACE,wCAAA;A7B4v8BN;A6B1v8BM;EACE,yB1BphBE;AHgx9BV;A6B1v8BQ;EACE,c1BvhBA;AHmx9BV;A6Bvv8BI;EACE,yCAAA;A7Byv8BN;A6Bvv8BM;EACE,yB1BliBD;AH2x9BP;A6Bvv8BQ;EACE,c1BriBH;AH8x9BP;A6Bpv8BI;EACE,wCAAA;A7Bsv8BN;A6Bpv8BM;EACE,yB1BhjBE;AHsy9BV;A6Bpv8BQ;EACE,c1BnjBA;AHyy9BV;A6Bjv8BI;EACE,uCAAA;A7Bmv8BN;A6Bjv8BM;EACE,yB1BtjBC;AHyy9BT;A6Bjv8BQ;EACE,c1BzjBD;AH4y9BT;A6B9u8BI;EACE,0CAAA;A7Bgv8BN;A6B9u8BM;EACE,yB1B3iBA;AH2x9BR;A6B9u8BQ;EAEE,c1BzUG;AHwj9Bb;A6B1u8BI;EACE,uCAAA;A7B4u8BN;A6B1u8BM;EACE,yB1B7kBD;AHyz9BP;A6B1u8BQ;EACE,W1BzjBF;AHqy9BR;A6Bvu8BI;EACE,4BAAA;A7Byu8BN;A6Btu8BI;EACE,4BAAA;A7Bwu8BN;A6Btu8BM;EACE,uBAAA;EACA,6BAAA;A7Bwu8BR;A6Bpu8BI;EACE,4BAAA;A7Bsu8BN;A6Bpu8BM;EACE,yBAAA;EACA,4BAAA;A7Bsu8BR;A6Bju8BE;EACE,gBAAA;EACA,eAAA;A7Bmu8BJ;A6Bju8BI;EACE,eAAA;EACA,gBAAA;A7Bmu8BN;A6Bju8BM;EACE,2BAAA;EACA,uBAAA;A7Bmu8BR;A6B9t8BE;EACE,gBAAA;EACA,aAAA;A7Bgu8BJ;A6B9t8BI;EACE,cAAA;A7Bgu8BN;A6B9t8BM;EACE,yBAAA;EACA,2BAAA;A7Bgu8BR;;A6B3t8BA;EACE,aAAA;A7B8t8BF;;A6B5t8BA;EACE,eAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;A7B+t8BF;;A6B5t8BA;EACE,mB1BhqBQ;E0BiqBR,W1B9nBM;AH619BR;;A6B5t8BA;EACE,mB1BnqBU;E0BoqBV,W1BnoBM;AHk29BR;;A6B5t8BA;EACE,mB1BlqBQ;E0BmqBR,W1BxoBM;AHu29BR;;A6B5t8BA;EACE,mB1BzqBK;E0B0qBL,W1B7oBM;AH429BR;;A6B5t8BA;EACE,mB1BhrBQ;E0BirBR,W1BlpBM;AHi39BR;;A6B5t8BA;EACE,mB1B/qBO;E0BgrBP,W1BvpBM;AHs39BR;;A6B5t8BA;EACE,mB1B7pBM;E0B8pBN,W1B5pBM;AH239BR;;A6B5t8BA;EACE,mB1BvrBK;E0BwrBL,W1BjqBM;AHg49BR;;A6B5t8BA;EACE,mBAAA;EACA,YAAA;A7B+t8BF;;A6B5t8BE;EACE,mB1BtcS;E0BucT,2DAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;A7B+t8BJ;A6B5t8BE;EACE,gB1BvrBI;E0BwrBJ,mBAAA;EACA,iDAAA;EACA,WAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,2BAAA;EACA,gCAAA;EACA,aAAA;A7B8t8BJ;;A6B3t8BA;EACE,mBAAA;EACA,uBAAA;A7B8t8BF;;A6B3t8BA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;A7B8t8BF;;A6B3t8BA;EACE,wBAAA;A7B8t8BF;;A6B3t8BA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;A7B8t8BF;;A6B3t8BA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;A7B8t8BF;;A6B3t8BA;EACE,uBAAA;A7B8t8BF;;A6B3t8BA;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;A7B8t8BF;;A6Bzt8BI;;EACE,6BAAA;A7B6t8BN;;A6Bzt8BA;;;EAGE,0BAAA;A7B4t8BF;;A6Bxt8BI;EACE,c1B5xBI;E0B6xBJ,UAAA;A7B2t8BN;A6Bxt8BI;EACE,yBAAA;A7B0t8BN;A6Bxt8BI;EACE,yBAAA;A7B0t8BN;A6Brt8BI;EACE,c1BxyBM;E0ByyBN,UAAA;A7But8BN;A6Bpt8BI;EACE,yBAAA;A7Bst8BN;A6Bpt8BI;EACE,yBAAA;A7Bst8BN;A6Bjt8BI;EACE,c1BhzBI;E0BizBJ,UAAA;A7Bmt8BN;A6Bht8BI;EACE,yBAAA;A7Bkt8BN;A6Bht8BI;EACE,yBAAA;A7Bkt8BN;A6B7s8BI;EACE,c1Bh0BC;E0Bi0BD,UAAA;A7B+s8BN;A6B5s8BI;EACE,yBAAA;A7B8s8BN;A6B5s8BI;EACE,yBAAA;A7B8s8BN;A6Bzs8BI;EACE,c1Bh1BI;E0Bi1BJ,UAAA;A7B2s8BN;A6Bxs8BI;EACE,yBAAA;A7B0s8BN;A6Bxs8BI;EACE,yBAAA;A7B0s8BN;A6Brs8BI;EACE,c1Bx1BG;E0By1BH,UAAA;A7Bus8BN;A6Bps8BI;EACE,yBAAA;A7Bss8BN;A6Bps8BI;EACE,yBAAA;A7Bss8BN;;A6Bls8BA;;;;EAIE,sB1B/0BM;E0Bg1BN,kB1B3ec;AHgr9BhB;;A6Bns8BA;EACE,gBAAA;EACA,mBAAA;A7Bss8BF;A6Bps8BE;EACE,SAAA;A7Bss8BJ;A6Bls8BI;EACE,uBAAA;EACA,kBAAA;A7Bos8BN;A6Bjs8BI;EACE,uBAAA;EACA,c1B9nBO;E0B+nBP,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;A7Bms8BN;A6Bjs8BM;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;A7Bms8BR;A6Bhs8BM;EAEE,6BAAA;A7Bis8BR;A6B9r8BM;EACE,yBAAA;EACA,mBAAA;EACA,c1B35BE;E0B45BF,6BAAA;A7Bgs8BR;A6B9r8BQ;EACE,yBAAA;A7Bgs8BV;A6B1r8BE;EACE,aAAA;A7B4r8BJ;;A6Bzr8BA;;EAEE,qB1Bv6BQ;E0Bw6BR,gBAAA;A7B4r8BF;;A6B1r8BA;;EAEE,qB1B56BQ;AHym+BV;;A6B3r8BA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;A7B8r8BF;;A6B3r8BE;EACE,iCAAA;EACA,gBAAA;A7B8r8BJ;;A6B1r8BE;;;;EAIE,cAAA;A7B6r8BJ;;A6B1r8BA;EACE,uBAAA;EACA,2EAAA;A7B6r8BF;;A6B3r8BA;EAKE,cAAA;A7B0r8BF;;A6Bxr8BA;EACE,yB1Bj7BM;AH4m+BR;;A6Bxr8BE;EACE,uBAAA;A7B2r8BJ;;A6Bvr8BA;EACE,qBAAA;A7B0r8BF;;A6Bxr8BA;EACE,qBAAA;A7B2r8BF;;A6Bzr8BA;EACE,kBAAA;EACA,MAAA;A7B4r8BF;;A6Bzr8BA,0CAAA;AACA,uEAAA;AACA;;;;EAIE,gCAAA;EACA,2BAAA;A7B4r8BF;;A6B1r8BA;;EAEE,gCAAA;EACA,uDAAA;A7B6r8BF;;A6B1r8BA,yCAAA;AACA;EACE,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yDAAA;A7B6r8BF;;A6B1r8BA;EACE,gCAAA;A7B6r8BF;;A6B1r8BA;EACE,gCAAA;EACA,wDAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,yDAAA;EACA,wBAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,uBAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,oEAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,8BAAA;EACA,yBAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,8BAAA;EACA,sBAAA;A7B6r8BF;;A6B1r8BA,yEAAA;AACA;EACE,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,yDAAA;EACA,wBAAA;A7B6r8BF;;A6B1r8BA;EACE,uBAAA;A7B6r8BF;;A6B1r8BA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,oEAAA;A7B6r8BF;;A6B1r8BA;EACE,8BAAA;EACA,yBAAA;A7B6r8BF;;A6B1r8BA;EACE,8BAAA;EACA,sBAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,yBAAA;EACA,8BAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,yBAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,yBAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,wBAAA;A7B6r8BF;;A6B1r8BA;;;EAGE,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yDAAA;A7B6r8BF;;A6B1r8BA;;;EAGE,gCAAA;A7B6r8BF;;A6B1r8BA;;;EAGE,gCAAA;EACA,wDAAA;A7B6r8BF;;A6B1r8BA;EACE,yBAAA;EACA,eAAA;A7B6r8BF;;A6B1r8BA;EACE,yBAAA;EACA,eAAA;A7B6r8BF;;A6B1r8BA;EACE,8BAAA;EACA,6BAAA;A7B6r8BF;;A6B1r8BA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;A7B6r8BF;;A6B1r8BA;EACE,yBAAA;A7B6r8BF;;A6B1r8BA;EACE,8BAAA;EACA,sBAAA;A7B6r8BF;;A6B1r8BA;;;;;;;;EAQE,gCAAA;EACA,2BAAA;A7B6r8BF;;A6B1r8BA;;;;EAIE,gCAAA;EACA,wDAAA;A7B6r8BF;;A6B1r8BA,0DAAA;AACA;;EAEE,aAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A7B6r8BF;;A6B3r8BA;;EAEE,cAAA;A7B8r8BF;;A6B5r8BA,6DAAA;AACA;EACE,0BAAA;EACA,gBAAA;A7B+r8BF;;A6B5r8BA;EACE,YAAA;EACA,mBAAA;A7B+r8BF;;A6B5r8BA;EACE,gBAAA;A7B+r8BF;;A6B5r8BA;EACE,mBAAA;A7B+r8BF;;A6B5r8BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;A7B+r8BF;;A6B5r8BA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A7B+r8BF;;A6B5r8BA;EACE,YAAA;EACA,mBAAA;A7B+r8BF;;A6B5r8BA;EACE,WAAA;A7B+r8BF;;A6B5r8BA;;EAEE,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yDAAA;A7B+r8BF;;A6B5r8BA;;EAEE,gCAAA;EACA,wDAAA;A7B+r8BF;;A6B5r8BA;;EAEE,sCAAA;EACA,6BAAA;EACA,uCAAA;EACA,2BAAA;A7B+r8BF;;A6B5r8BA;;EAEE,oCAAA;EACA,8BAAA;EACA,yDAAA;A7B+r8BF;;A6B5r8BA;;EAEE,0BAAA;EACA,yBAAA;A7B+r8BF;;A6B5r8BA;;;;EAIE,8BAAA;EACA,yBAAA;A7B+r8BF;;A6B5r8BA;EACE,gCAAA;A7B+r8BF;;A6B5r8BA;EACE,wDAAA;A7B+r8BF;;A6B7r8BA;EACE,8BAAA;A7Bgs8BF;;A6B9r8BA;;;EAGE,gB1BxzCmB;AHy/+BrB;;A6B/r8BA;EACE,cAAA;A7Bks8BF;;A6Bzr8BM;EACE,iBAAA;A7B4r8BR;;A6Brr8BI;EAKE,eAAA;A7Bor8BN;;A6B/q8BE;EACE,YAAA;A7Bkr8BJ;A6Bhr8BE;EACE,YAAA;EACA,gBAAA;A7Bkr8BJ;;A6B9q8BE;EACE,YAAA;A7Bir8BJ;A6B/q8BE;EACE,YAAA;EACA,gBAAA;A7Bir8BJ;;A6B9q8BA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;A7Bir8BF;;A6B9q8BA;EACE,sBAAA;A7Bir8BF;;A6B9q8BA;;EAEE,cAAA;A7Bir8BF;;A6B9q8BA;EACE,cAAA;A7Bir8BF;;A6B/q8BA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,kBAAA;A7Bkr8BF;A6Bjr8BE;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;A7Bmr8BN;;A6Bhr8BA;EACE,yBAAA;EACA,kBAAA;A7Bmr8BF;;A6Bjr8BA;EACE,yB1B14CQ;E0B24CR,qB1B34CQ;AH+j/BV;;A6Blr8BI;EACE,cAAA;A7Bqr8BN;;A6Bnr8BI;EACE,YAAA;EACA,WAAA;EzBv0CJ,kByBw0CsB;EzBv0CtB,MyBu0CgC;EzBp0ChC,OyBo0C+C;A7Bwr8BjD;;A6Btr8BI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;A7Byr8BN;;A6Bvr8BI;EACE,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,kCAAA;EACA,W1B73CE;E0B83CF,gB1B16CiB;E0B26CjB,eAAA;A7B0r8BN;;A6Bxr8BA;;EAEE,kBAAA;EACA,aAAA;A7B2r8BF;;A6Bzr8BA;;EAGE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,c1BxwCS;AHm8+BX;;A6Bzr8BA;;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gB1B15CM;AHsl/BR;;A6B1r8BA;EACE,mB1B5qCO;E0B6qCP,qB1B7qCO;AH02+BT;;A6B3r8BA;;EAEE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gB1Br6CM;E0Bs6CN,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;A7B8r8BF;;A6B5r8BA;EACE,UAAA;EAEA,mBAAA;A7B+r8BF;;A6B7r8BA;EACE,UAAA;EAEA,mBAAA;A7Bgs8BF;;A6B9r8BA;EACE,qB1Bn0CU;E0Bo0CV,6DAAA;EACA,kBAAA;EACA,e1BlkCa;E0BmkCb,c1B7tCW;E0B8tCX,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;A7Bis8BF;A6Bhs8BE;EACI,mB1Bh1CM;E0Bi1CN,c1BvuCO;E0BwuCP,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,e1BjlCS;AHmx+Bf;;A6B9r8BA,wDAAA;AACA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;A7Bis8BF;;A6B9r8BA;EACE,cAAA;EACA,gBAAA;A7Bis8BF;;A6B9r8BA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;A7Bis8BF;;A6B9r8BA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;A7Bis8BF;;A6B9r8BA;EACE,cAAA;EACA,UAAA;A7Bis8BF;;A6B9r8BA;EACE,qBAAA;EACA,6CAAA;A7Bis8BF;;A6B9r8BA;EACE,qBAAA;A7Bis8BF;;A6B9r8BA;EACE,6CAAA;A7Bis8BF;;A6B9r8BA;;EAEE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;A7Bis8BF;;A6B9r8BA;EACE,gBAAA;EACA,gBAAA;A7Bis8BF;;A6B9r8BA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;A7Bis8BF;;A6B9r8BA;EACE,YAAA;EACA,eAAA;A7Bis8BF;;A6B9r8BA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;A7Bis8BF;;A6B9r8BA;EACE,UAAA;EACA,QAAA;EACA,SAAA;A7Bis8BF;;A6B9r8BA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;A7Bis8BF;;A6B9r8BA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yCAAA;A7Bis8BF;;A6B9r8BA;EACE,yBAAA;A7Bis8BF;;A6B9r8BA;EACE,2BAAA;A7Bis8BF;;A8Bn0/BI;EACI,aAAA;A9Bs0/BR;A8Br0/BQ;EACI,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;A9Bu0/BZ;AIjy/BI;E0B1CI;IAMQ,sBAAA;IACA,kBAAA;E9By0/Bd;AACF;A8Bx0/BY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,W3B6BR;E2B5BQ,WAAA;EACA,YAAA;EACA,YAAA;A9B00/BhB;AI1z/BI;E0BjCQ;IAmBQ,aAAA;E9B40/BlB;AACF;A8Bz0/BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gB3BOJ;E2BNI,sDAAA;A9B20/BZ;AI/0/BI;E0BVI;IAgBQ,sBAAA;IACA,kBAAA;E9B60/Bd;AACF;A8B50/BY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9B80/BhB;AI71/BI;E0BSQ;IAQQ,mBAAA;E9Bg1/BlB;AACF;AIl2/BI;E0BSQ;IAWQ,gBAAA;IACA,sBAAA;IACA,uBAAA;E9Bk1/BlB;AACF;A8Bj1/BgB;EACI,iBAAA;EACA,YAAA;A9Bm1/BpB;A8B/0/BgC;EACI,6BAAA;A9Bi1/BpC;A8B10/BgB;EACI,mB3BqGT;E2BpGS,iBAAA;EACA,W3B/BZ;E2BgCY,e3B0VL;E2BzVK,gB3B/EC;E2BgFD,kBAAA;EACA,YAAA;EACA,mBAAA;A9B40/BpB;A8B30/BoB;EACI,mB3BzEd;AHs5/BV;AI73/BI;E0BsCY;IAaQ,cAAA;E9B80/BtB;AACF;A8B10/BgB;EACI,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;A9B40/BpB;A8Bx0/BQ;EACI,kBAAA;EACA,oBAAA;EACA,gCAAA;A9B00/BZ;A8Bz0/BY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A9B20/BhB;A8Bz0/BoB;EACI,c3BlGf;E2BmGe,e3BgTT;E2B/SS,gB3BzHH;AHo8/BrB;A8B10/BwB;EACI,iBAAA;A9B40/B5B;A8Bv0/BY;EACI,aAAA;EACA,kBAAA;EACA,oCAAA;A9By0/BhB;A8Bx0/BgB;EACI,oCAAA;A9B00/BpB;A8Bx0/BgB;EACI,mCAAA;A9B00/BpB;A8Bx0/BgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9B00/BpB;A8Bx0/BwB;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BvIlB;E2BwIkB,e3BhKX;E2BiKW,gB3B1JL;E2B2JK,aAAA;EACA,mBAAA;A9B00/B5B;A8Bz0/B4B;EACI,cAAA;EACA,iBAAA;A9B20/BhC;A8Bz0/B4B;EACI,cAAA;EACA,yBAAA;A9B20/BhC;A8Bz0/B4B;EACI,c3BnJvB;E2BoJuB,yBAAA;A9B20/BhC;A8Bv0/BoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c3BJb;AH60/BX;A8Bv0/B4B;EACI,c3BHrB;AH40/BX;A8Bx0/BgC;EACI,c3BLzB;AH+0/BX;A8Bn0/BgB;EACI,cAAA;A9Bq0/BpB;A8Bn0/BwB;EACI,mBAAA;EACA,c3BrBjB;E2BsBiB,e3BmOb;E2BlOa,gB3BrML;E2BsMK,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bq0/B5B;A8Bp0/B4B;EACI,c3B1LtB;AHgggCV;A8Bl0/BoB;EACI,c3B2DX;E2B1DW,e3BqNT;E2BpNS,gB3BpNH;E2BqNG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bo0/BxB;A8Bj0/BgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9Bm0/BpB;A8Bl0/BoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bo0/BxB;A8Bn0/BwB;EACI,kBAAA;A9Bq0/B5B;A8Bp0/B4B;EACI,WAAA;EACA,YAAA;EACA,aAAA;A9Bs0/BhC;A8Br0/BgC;EACI,oBAAA;A9Bu0/BpC;A8Bj0/B4B;EACI,iBAAA;A9Bm0/BhC;A8Bl0/BgC;EACI,c3B9O1B;E2B+O0B,wBAAA;EACA,eAAA;A9Bo0/BpC;A8Bj0/B4B;EACI,iBAAA;A9Bm0/BhC;A8Bl0/BgC;EACI,c3BlP1B;E2BmP0B,wBAAA;EACA,eAAA;A9Bo0/BpC;A8Bj0/B4B;EACI,iBAAA;A9Bm0/BhC;A8Bl0/BgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;A9Bo0/BpC;A8Bh0/BwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,e3B6Ib;E2B5Ia,gB3B5RP;E2B6RO,kBAAA;A9Bk0/B5B;A8Bh0/BgC;EACI,iBAAA;A9Bk0/BpC;A8B/z/B4B;EACI,c3BrRtB;AHslgCV;A8B/z/B4B;EACI,c3BpRtB;AHqlgCV;A8B7z/BoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9B+z/BxB;A8B7z/B4B;EACI,c3BjStB;E2BkSsB,WAAA;EACA,YAAA;EACA,kBAAA;A9B+z/BhC;A8B7z/B4B;EACI,c3BrSvB;E2BsSuB,WAAA;EACA,YAAA;A9B+z/BhC;A8Bxz/BQ;EACI,iBAAA;A9B0z/BZ;A8Bzz/BY;EACI,kBAAA;EACA,0CAAA;EACA,gB3B1RR;E2B2RQ,sDAAA;EACA,aAAA;EACA,mBAAA;A9B2z/BhB;A8B1z/BgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9B4z/BpB;A8B1z/BwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3B/UlB;E2BgVkB,e3BxWX;E2ByWW,gB3BlWL;AH8pgCvB;A8B3z/B4B;EACI,cAAA;EACA,iBAAA;A9B6z/BhC;A8B3z/B4B;EACI,cAAA;EACA,yBAAA;A9B6z/BhC;A8B3z/B4B;EACI,c3BzVvB;E2B0VuB,yBAAA;A9B6z/BhC;A8Bxz/BwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c3B3MjB;AHqggCX;A8Bzz/B4B;EACI,WAAA;EACA,YAAA;EACA,c3BlHnB;AH66/Bb;A8Btz/BgC;EACI,W3BvV5B;AH+ogCR;A8Blz/BgB;EACI,eAAA;EACA,gCAAA;A9Boz/BpB;A8Blz/BwB;EACI,c3BhOjB;E2BiOiB,e3BwBb;E2BvBa,gB3BhZL;E2BiZK,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Boz/B5B;A8Bnz/B4B;EACI,c3BtYtB;AH2rgCV;A8Bjz/BoB;EACI,c3BjJX;E2BkJW,e3BST;E2BRS,gB3BhaH;E2BiaG,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bmz/BxB;A8Blz/BwB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;A9Boz/B5B;A8Bjz/BoB;EACI,c3BlKX;E2BmKW,e3BRT;E2BSS,gB3BjbH;E2BkbG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bmz/BxB;A8Bhz/BgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9Bkz/BpB;A8Bjz/BoB;EACI,iBAAA;A9Bmz/BxB;A8Bjz/BoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bmz/BxB;A8Blz/BwB;EACI,kBAAA;A9Boz/B5B;A8Blz/BgC;EACI,oBAAA;A9Boz/BpC;A8B/y/B4B;EACI,iBAAA;A9Biz/BhC;A8Bhz/BgC;EACI,c3B1c1B;E2B2c0B,wBAAA;EACA,eAAA;A9Bkz/BpC;A8B/y/B4B;EACI,iBAAA;A9Biz/BhC;A8Bhz/BgC;EACI,c3B9c1B;E2B+c0B,wBAAA;EACA,eAAA;A9Bkz/BpC;A8B/y/B4B;EACI,iBAAA;A9Biz/BhC;A8Bhz/BgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;A9Bkz/BpC;A8B9y/BwB;EACI,cAAA;EACA,e3BzEb;E2B0Ea,gB3BlfP;E2BmfO,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bgz/B5B;A8B9y/BgC;EACI,iBAAA;A9Bgz/BpC;A8B7y/B4B;EACI,c3BjftB;AHgygCV;A8B7y/B4B;EACI,c3BhftB;AH+xgCV;A8B3y/BoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9B6y/BxB;A8B3y/B4B;EACI,c3BnQnB;E2BoQmB,WAAA;EACA,YAAA;EACA,kBAAA;A9B6y/BhC;A8B3y/B4B;EACI,c3BjgBvB;E2BkgBuB,WAAA;EACA,YAAA;A9B6y/BhC;;A8Bly/BQ;EACI,c3BpXD;AHypgCX;;A8B/x/BI;EACI,WAAA;EACA,YAAA;EACA,c3BhSK;AHkkgCb;;A8B/x/BA;EACI,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,e3B9IW;E2B+IX,gB3BnjBe;E2BojBf,W3BzgBI;E2B0gBJ,cAAA;A9Bky/BJ;A8Bjy/BI;EACI,cAAA;EACA,gB3B7gBA;AHgzgCR;;A8B/x/BI;EACI,yBAAA;A9Bky/BR;A8B/x/BQ;EACI,uBAAA;A9Biy/BZ;;A8B5x/BI;EACI,kBAAA;A9B+x/BR;A8B7x/BY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;A9B+x/BhB;;A8Bxx/BA;EACI,+BAAA;A9B2x/BJ;;A8Bxx/BI;EACI,cAAA;A9B2x/BR;A8Bzx/BY;EACI,c3BjbL;E2BkbK,e3B1LD;E2B2LC,gB3BnmBK;E2BomBL,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;A9B2x/BhB;A8B1x/BgB;EACI,mB3BtcR;E2BucQ,c3BtbT;AHktgCX;A8B3x/BoB;EACI,c3Bxbb;AHqtgCX;A8Bvx/BQ;EACI,iBAAA;A9Byx/BZ;A8Bvx/BQ;EACI,WAAA;EACA,YAAA;EACA,c3B3WC;AHoogCb;;A8Bpx/BI;EACI,mBAAA;EACA,0CAAA;EACA,gB3BllBA;E2BmlBA,c3BjdG;E2BkdH,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;A9Bux/BR;A8Btx/BQ;EACI,mBAAA;EACA,mB3B/nBF;E2BgoBE,W3B7lBJ;AHq3gCR;;A8Bhx/BgB;EACI,6BAAA;A9Bmx/BpB;;A8B5w/BA;EACI,WAAA;A9B+w/BJ;;A8B7w/BA;EACI,oBAAA;A9Bgx/BJ;;A8B9w/BA;EACI,aAAA;EACA,oBAAA;A9Bix/BJ;;A8B9w/BI;EACI,oBAAA;A9Bix/BR;;A8B5w/BQ;EACI,yBAAA;EACA,oBAAA;A9B+w/BZ;;A8B3w/BA;EACI,WAAA;A9B8w/BJ;;A8B5w/BA;EACI,2BAAA;A9B+w/BJ;;A8B7w/BA;EACI,uBAAA;A9Bgx/BJ;;A8B9w/BA;EACI,c3B/aS;E2BgbT,e3BrRW;E2BsRX,gB3B9rBiB;AH+8gCrB;;A8B9w/BI;EACI,SAAA;EACA,kBAAA;A9Bix/BR;;A8B9w/BA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gB3B7pBI;E2B8pBJ,oBAAA;A9Bix/BJ;A8Bhx/BI;EACI,gCAAA;A9Bkx/BR;A8Bjx/BQ;EACI,e3BtSG;E2BuSH,gB3B9sBO;E2B+sBP,c3BliBD;E2BmiBC,mBAAA;EACA,aAAA;EACA,mBAAA;A9Bmx/BZ;A8Blx/BY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,c3B7cH;AHiugCb;A8Bhx/BI;EACI,eAAA;EACA,gCAAA;A9Bkx/BR;A8Bjx/BQ;EACI,eAAA;A9Bmx/BZ;A8Blx/BY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,aAAA;A9Box/BhB;A8Bnx/BgB;EACI,mBAAA;EACA,mB3BhkBT;AHq1gCX;A8Bpx/BoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9Bsx/BxB;A8Bpx/BoB;EACI,W3BzsBhB;AH+9gCR;A8Blx/BgB;EACI,e3BpVL;E2BqVK,gB3B3vBG;E2B4vBH,c3BjfP;E2BkfO,gBAAA;EACA,aAAA;EACA,mBAAA;A9Box/BpB;A8Bnx/BoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9Bqx/BxB;A8Blx/BgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mB3BrwBV;E2BswBU,W3BnuBZ;AHu/gCR;A8B9w/BI;EACI,gBAAA;EACA,aAAA;A9Bgx/BR;A8B/w/BQ;EACI,e3BlXG;E2BmXH,gB3B1xBW;E2B2xBX,c3B7mBD;AH83gCX;A8B/w/BQ;EACI,eAAA;A9Bix/BZ;A8Bhx/BY;EACI,mBAAA;A9Bkx/BhB;A8Bhx/BY;EA0GO,e3BteJ;E2BueI,gB3B/4BE;E2Bg5BF,aAAA;EACA,mBAAA;A9Byq/BnB;A8Bpx/BoB;EACI,iBAAA;A9Bsx/BxB;A8Brx/BwB;EACI,wBAAA;EACA,eAAA;A9Bux/B5B;A8Bpx/BoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;A9Bsx/BxB;A8Bjx/BoB;EACI,iBAAA;A9Bmx/BxB;A8Blx/BwB;EACI,wBAAA;EACA,eAAA;A9Box/B5B;A8Bjx/BoB;EACI,c3B1yBd;E2B2yBc,aAAA;EACA,mBAAA;A9Bmx/BxB;A8B9w/BoB;EACI,iBAAA;A9Bgx/BxB;A8B/w/BwB;EACI,wBAAA;EACA,eAAA;A9Bix/B5B;A8B9w/BoB;EACI,c3B7zBd;E2B8zBc,aAAA;EACA,mBAAA;A9Bgx/BxB;A8B3w/BoB;EACI,iBAAA;A9B6w/BxB;A8B5w/BwB;EACI,wBAAA;EACA,eAAA;A9B8w/B5B;A8B3w/BqB;EACG,cAAA;EACA,aAAA;EACA,mBAAA;A9B6w/BxB;A8Bxw/BoB;EACI,iBAAA;A9B0w/BxB;A8Bzw/BwB;EACI,wBAAA;EACA,eAAA;A9B2w/B5B;A8Bxw/BqB;EACG,c3B1zBf;E2B2zBe,aAAA;EACA,mBAAA;A9B0w/BxB;A8Brw/BoB;EACI,iBAAA;A9Buw/BxB;A8Btw/BwB;EACI,wBAAA;EACA,eAAA;A9Bww/B5B;A8Brw/BoB;EACI,c3Bp2Bf;E2Bq2Be,aAAA;EACA,mBAAA;A9Buw/BxB;A8Blw/BoB;EACI,iBAAA;A9Bow/BxB;A8Bnw/BwB;EACI,wBAAA;EACA,eAAA;A9Bqw/B5B;A8Blw/BoB;EACI,c3Br3Bd;E2Bs3Bc,aAAA;EACA,mBAAA;A9Bow/BxB;A8B5v/BgB;EACI,gBAAA;A9B8v/BpB;;A8Bvv/BI;EACI,aAAA;EACA,mBAAA;A9B0v/BR;A8Bzv/BQ;EACI,WAAA;EACA,YAAA;A9B2v/BZ;A8B1v/BY;EACI,mBAAA;A9B4v/BhB;;A8Bvv/BA;EACI,eAAA;EACA,gCAAA;A9B0v/BJ;A8Bvv/BY;EACG,aAAA;EACA,sBAAA;EACA,mBAAA;EACC,aAAA;EACA,e3BxgBD;E2BygBC,gB3B/6BO;E2Bg7BP,c3BrqBH;E2BsqBG,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9Byv/BhB;A8Bxv/BgB;EACI,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,W3B94BZ;AHwohCR;A8Bzv/BoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9B2v/BxB;A8Bxv/BgB;EACI,mBAAA;EACA,W3Bv5BZ;AHiphCR;A8Bvv/BgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9Byv/BpB;A8Bvv/BgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mB3B18BV;E2B28BU,W3Bx6BZ;AHiqhCR;;A8Bjv/BA;EACI,mB3B18BK;E2B28BL,W3Bl7BI;E2Bm7BJ,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A9Bov/BJ;A8Bnv/BI;EACI,aAAA;EACA,mBAAA;A9Bqv/BR;A8Bpv/BQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A9Bsv/BZ;;A8Blv/BA;EACI,aAAA;EACA,kBAAA;EACA,gB3Bv8BI;AH4rhCR;A8Bpv/BI;EACI,mBAAA;A9Bsv/BR;A8Bpv/BI;EACI,kBAAA;A9Bsv/BR;A8Brv/BQ;EACI,c3B50BD;E2B60BC,e3BllBG;E2BmlBH,gB3B3/BO;E2B4/BP,kBAAA;A9Buv/BZ;A8Brv/BQ;EACI,c3BrvBC;E2BsvBD,e3B3lBG;E2B4lBH,gB3BpgCS;E2BqgCT,kBAAA;A9Buv/BZ;A8Bpv/BI;EACI,kBAAA;A9Bsv/BR;;A8Bnv/BA;EACI,aAAA;EACA,mBAAA;A9Bsv/BJ;A8Brv/BI;EACI,e3BtmBO;E2BumBP,gB3B9gCW;E2B+gCX,c3Bl2BG;E2Bm2BH,gBAAA;EACA,kBAAA;A9Buv/BR;A8Brv/BI;EACI,e3B/mBO;E2BgnBP,gB3BxhCa;E2ByhCb,cAAA;A9Buv/BR;;A8Bpv/BA;EACI,mBAAA;EACA,uCAAA;A9Buv/BJ;A8Btv/BI;EACI,e3BvnBO;E2BwnBP,gB3B/hCe;E2BgiCf,c3Bl3BG;E2Bm3BH,mBAAA;A9Bwv/BR;A8Btv/BI;EACI,e3B9nBO;E2B+nBP,gB3BviCa;E2BwiCb,c3B3xBK;E2B4xBL,mBAAA;A9Bwv/BR;A8Brv/BQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BliCF;E2BmiCE,e3B/oBG;E2BgpBH,gB3BrjCW;E2BsjCX,oBAAA;EACA,mBAAA;A9Bmv/BZ;A8B/v/BY;EACI,cAAA;EACA,iBAAA;A9Biw/BhB;;A8Bnv/BA;EACI,yB3BziCK;AH+xhCT;;A8Bhv/BiB;EACG,c3BhjCX;E2BijCW,kBAAA;A9Bmv/BpB;A8Bjv/BiB;EACG,c3BtjCV;AHyyhCV;;A8B3u/BQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BrkCH;E2BskCG,e3BprBG;E2BqrBH,gB3B1lCW;E2B2lCX,oBAAA;EACA,mBAAA;A9B0u/BZ;A8Btv/BY;EACI,cAAA;EACA,iBAAA;A9Bwv/BhB;;A8B1u/BA;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;A9B6u/BJ;A8B5u/BI;EACI,mBAAA;A9B8u/BR;A8B5u/BI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;A9B8u/BR;A8B7u/BQ;EACI,kBAAA;EACA,mB3B1lCH;E2B2lCG,W3BlkCJ;AHizhCR;;A8B1u/BA;EACI,eAAA;A9B6u/BJ;;A8B1u/BI;EACI,mBAAA;A9B6u/BR;A8B5u/BQ;EACI,aAAA;EACA,mBAAA;EACA,c3Bj3BC;E2Bk3BD,WAAA;EACA,YAAA;A9B8u/BZ;A8B7u/BY;EACI,iBAAA;A9B+u/BhB;A8B1u/BgB;EACI,iBAAA;EACA,mBAAA;EACA,c3B73BP;E2B83BO,e3BhpCH;E2BipCG,gB3B3oCC;E2B4oCD,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;A9B4u/BpB;A8B3u/BoB;EACI,mB3BzoCd;E2B0oCc,W3BvmChB;AHo1hCR;A8B1u/BgB;EACI,mB3B9oCV;E2B+oCU,W3B5mCZ;E2B6mCY,oBAAA;A9B4u/BpB;;A8Bnu/BY;EACI,UAAA;EACA,WAAA;EAAA,cAAA;EACA,WAAA;A9Bsu/BhB;A8Bru/BgB;EACI,6BAAA;EACA,WAAA;EACA,YAAA;A9Buu/BpB;A8Btu/BoB;EACI,c3B7/Bb;AHquhCX;A8Btu/BoB;EACI,6BAAA;A9Bwu/BxB;A8Bvu/BwB;EACI,c3BvqClB;AHg5hCV;;A8Bhu/BI;EACI,kBAAA;A9Bmu/BR;A8Bju/BI;EACI,WAAA;A9Bmu/BR;;A8Bhu/BA;EACI,aAAA;A9Bmu/BJ;;A8Bju/BA;EACI,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;A9Bou/BJ;;A8Blu/BA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bqu/BJ;A8Bpu/BI;EACI,kBAAA;EACA,kBAAA;A9Bsu/BR;A8Bru/BQ;EACI,YAAA;EACA,0CAAA;EAAA,yDAAA;EACA,gBAAA;EAAA,8BAAA;EACA,YAAA;E1BnmCV,kB0BomC2B;EACjB,aAAA;A9Buu/BZ;A8Btu/BY;EACI,W3B9qCR;AHs5hCR;AIj6hCI;E0BirCI;IAWQ,YAAA;E9Byu/Bd;AACF;AIt6hCI;E0BirCI;IAcQ,YAAA;E9B2u/Bd;AACF;AI36hCI;E0BirCI;IAiBQ,WAAA;E9B6u/Bd;AACF;A8B3u/BQ;E1BnnCN,mB0BqnC2B;E1BrpC3B,kB0BspC4B;E1BrpC5B,M0BqpCqC;E1BppCrC,Q0BopCuC;EAC7B,SAAA;A9B8u/BZ;A8B7u/BY;EACI,WAAA;EACA,YAAA;A9B+u/BhB;;A8B1u/BA;EACI,aAAA;EACA,eAAA;A9B6u/BJ;;A+B7+hCA;EACI,kBAAA;A/Bg/hCJ;A+B/+hCI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A/Bi/hCR;A+Bh/hCQ;EACI,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;A/Bk/hCZ;A+B9+hCgB;EACI,qB5BGV;E4BFU,yB5BEV;AH8+hCV;;A+B1+hCA;EACI,mB5BiKO;E4BhKP,W5B6BI;E4B5BJ,e5BqZW;E4BpZX,gB5BhBe;E4BiBf,kBAAA;E3B8DF,yB2B7DsB;A/B++hCxB;A+B9+hCI;EACI,mBAAA;EACA,W5BsBA;AH09hCR;AIp+hCI;E2BrBJ;IAYQ,eAAA;E/Bi/hCN;AACF;;A+B/+hCA;EACI,iBAAA;A/Bk/hCJ;;A+Bh/hCA;EACI,mB5BvBM;E4BwBN,W5BWI;E4BVJ,e5BmYW;E4BlYX,gB5BlCe;E4BmCf,kBAAA;E3B4CF,yB2B3CsB;A/Bq/hCxB;A+Bp/hCI;EACI,6D5B7BQ;E4B8BR,W5BIA;AHk/hCR;AI5/hCI;E2BHJ;IAYQ,eAAA;E/Bu/hCN;AACF;;A+Bp/hCI;EACI,aAAA;A/Bu/hCR;;A+Bp/hCA;EACI,gBAAA;A/Bu/hCJ;;A+Br/hCA;EACI,c5BuHO;E4BtHP,e5BgXW;E4B/WX,gB5BxDe;E4ByDf,gBAAA;A/Bw/hCJ;;A+Bt/hCA;EACI,SAAA;EACA,SAAA;A/By/hCJ;;A+Bv/hCA;EACI,cAAA;A/B0/hCJ;;A+Bx/hCA;EACI,mBAAA;A/B2/hCJ;;A+Bz/hCA;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;A/B4/hCJ;A+Bz/hCY;EACI,c5BgGL;AH25hCX;A+Bv/hCI;EACI,aAAA;EACA,mBAAA;A/By/hCR;A+Bx/hCQ;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;A/B0/hCZ;A+Bz/hCY;EACI,WAAA;EACA,YAAA;EACA,c5B+KH;AH40hCb;A+Bx/hCQ;EACI,e5BuUG;E4BtUH,gB5BjGW;E4BkGX,c5B4ED;E4B3EC,gBAAA;EACA,iBAAA;A/B0/hCZ;A+Bx/hCQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yB5BnGF;E4BoGE,mBAAA;EACA,W5BlEJ;E4BmEI,eAAA;EACA,gB5BhHW;E4BiHX,gBAAA;A/B0/hCZ;;A+Bt/hCA;EACI,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gB5B7EI;E4B8EJ,aAAA;EACA,mBAAA;EACA,mBAAA;A/By/hCJ;AInliCI;E2BmFJ;IASQ,sBAAA;E/B2/hCN;AACF;A+B1/hCI;EACI,aAAA;EACA,mBAAA;A/B4/hCR;A+B1/hCY;EACI,e5BkSD;E4BjSC,gB5BrIG;E4BsIH,c5BuCL;E4BtCK,kBAAA;A/B4/hChB;A+B1/hCY;EACI,eAAA;EACA,gB5B7IK;E4B8IL,c5B8HH;E4B7HG,gBAAA;A/B4/hChB;A+Bz/hCQ;EACI,UAAA;A/B2/hCZ;AI3miCI;E2B+GI;IAGQ,WAAA;E/B6/hCd;AACF;A+B5/hCY;EACI,mBAAA;A/B8/hChB;A+B7/hCgB;EACI,kBAAA;EACA,aAAA;A/B+/hCpB;A+B1/hCI;EACI,UAAA;A/B4/hCR;AI1niCI;E2B6HA;IAGQ,WAAA;IACA,cAAA;E/B8/hCV;AACF;A+B7/hCQ;EACI,aAAA;EACA,mBAAA;A/B+/hCZ;A+B9/hCY;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,e5ByPD;E4BxPC,gB5B7KO;E4B8KP,c5B3JP;E4B4JO,kBAAA;A/BggiChB;A+B9/hCY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BgPD;E4B/OC,gB5BtLO;E4BuLP,cAAA;A/BggiChB;A+B9/hCY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BwOD;E4BvOC,gB5B9LO;E4B+LP,cAAA;A/BggiChB;A+B9/hCY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BgOD;E4B/NC,gB5BtMO;E4BuMP,c5BtLN;AHsriCV;A+B9/hCY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BwND;E4BvNC,gB5B9MO;E4B+MP,c5BlMN;AHksiCV;A+B7/hCgB;EACI,cAAA;EACA,iBAAA;A/B+/hCpB;A+Bx/hCQ;EACI,kCAAA;A/B0/hCZ;A+Bx/hCQ;EACI,kCAAA;A/B0/hCZ;A+Bv/hCI;EACI,UAAA;EACA,oBAAA;A/By/hCR;A+Bx/hCQ;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A/B0/hCZ;A+Bv/hCY;EACI,c5B/DL;AHwjiCX;;A+Bn/hCI;EACI,6BAAA;A/Bs/hCR;;A+Bn/hCA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;A/Bs/hCJ;A+Br/hCI;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;EACA,c5BQK;E4BPL,2BAAA;EACA,mBAAA;A/Bu/hCR;AI1tiCI;E2BqNJ;IAiBQ,gBAAA;E/Bw/hCN;AACF;;A+Bt/hCA;EACI,kBAAA;A/By/hCJ;;A+Bv/hCA;EACI,kBAAA;A/B0/hCJ;A+Bz/hCI;EACI,kBAAA;A/B2/hCR;A+B1/hCQ;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,c5BdC;AH0giCb;;A+Bv/hCI;EACI,uBAAA;EACA,mBAAA;A/B0/hCR;A+Bz/hCQ;EACI,eAAA;A/B2/hCZ;A+B1/hCY;EACI,uBAAA;EACA,UAAA;A/B4/hChB;A+B1/hCoB;EACI,gBAAA;A/B4/hCxB;A+Bx/hCY;EACI,WAAA;A/B0/hChB;A+Br/hCwB;EACI,c5BxCf;AH+hiCb;A+Bj/hCQ;EACI,UAAA;A/Bm/hCZ;A+Bj/hCQ;EACI,gBAAA;A/Bm/hCZ;A+Bj/hCgB;EACI,gBAAA;A/Bm/hCpB;;AgCpyiCA;EACE,c7BgQW;AHuiiCb;;AgCryiCA;EACE,iDAAA;AhCwyiCF;;AgCzwiCA;EACE,c7BwNW;E6BvNX,qB7BmHU;E6BlHV,mBAAA;AhC4wiCF;AgC3wiCE;EACE,mBAAA;AhC6wiCJ;AgCzwiCM;EACE,gB7B7Da;AHw0iCrB;AgCvwiCE;;EAEE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AhCywiCJ;AgCvwiCE;EACE,gB7BzEmB;E6B0EnB,eAAA;AhCywiCJ;AgCvwiCE;EACE,eAAA;AhCywiCJ;AgCvwiCE;EACE,c7BqFQ;E6BpFR,sCAAA;AhCywiCJ;AgCvwiCE;EACI,yB7B3EI;E6B4EJ,W7BzCE;AHkziCR;AgCvwiCE;EACI,yB7B7EM;E6B8EN,W7B7CE;AHsziCR;AgCvwiCE;EACI,yB7B7EC;E6B8ED,W7BjDE;AH0ziCR;AgCvwiCE;EACI,yB7B/EI;E6BgFJ,W7BrDE;AH8ziCR;AgCvwiCE;EACI,yB7BjFG;E6BkFH,W7BzDE;AHk0iCR;AgCvwiCE;EACI,yB7B3FI;E6B4FJ,W7B7DE;AHs0iCR;AgCvwiCE;EACI,yB7BvFC;E6BwFD,W7BjEE;AH00iCR;AgCvwiCE;EACI,yB7B+CM;E6B9CN,c7B5FC;AHq2iCP;AgCvwiCE;EA7HA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhCu4iCF;AgCt4iCE;EACE,2CAAA;EACA,mDAAA;EACA,W7B2CI;AH61iCR;AgCt4iCE;EACE,2CAAA;EACA,mDAAA;EACA,W7BqCI;AHm2iCR;AgCt4iCE;EACE,2CAAA;EACA,6CAAA;EACA,W7BgCI;AHw2iCR;AgC9xiCE;EAhIA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,8CAAA;EACA,yDAAA;EACA,sDAAA;EACA,qDAAA;EACA,oDAAA;AhCi6iCF;AgCh6iCE;EACE,2CAAA;EACA,qDAAA;EACA,W7B2CI;AHu3iCR;AgCh6iCE;EACE,2CAAA;EACA,qDAAA;EACA,W7BqCI;AH63iCR;AgCh6iCE;EACE,2CAAA;EACA,+CAAA;EACA,W7BgCI;AHk4iCR;AgCrziCE;EAnIA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhC27iCF;AgC17iCE;EACE,2CAAA;EACA,mDAAA;EACA,W7B2CI;AHi5iCR;AgC17iCE;EACE,2CAAA;EACA,mDAAA;EACA,W7BqCI;AHu5iCR;AgC17iCE;EACE,2CAAA;EACA,6CAAA;EACA,W7BgCI;AH45iCR;AgC50iCE;EAtIA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhCq9iCF;AgCp9iCE;EACE,2CAAA;EACA,mDAAA;EACA,W7B2CI;AH26iCR;AgCp9iCE;EACE,2CAAA;EACA,mDAAA;EACA,W7BqCI;AHi7iCR;AgCp9iCE;EACE,2CAAA;EACA,6CAAA;EACA,W7BgCI;AHs7iCR;AgCn2iCE;EAzIA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,2CAAA;EACA,sDAAA;EACA,mDAAA;EACA,kDAAA;EACA,iDAAA;AhC++iCF;AgC9+iCE;EACE,2CAAA;EACA,kDAAA;EACA,W7B2CI;AHq8iCR;AgC9+iCE;EACE,2CAAA;EACA,kDAAA;EACA,W7BqCI;AH28iCR;AgC9+iCE;EACE,2CAAA;EACA,4CAAA;EACA,W7BgCI;AHg9iCR;AgC13iCE;EA5IA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;AhCygjCF;AgCxgjCE;EACE,2CAAA;EACA,gDAAA;EACA,W7B2CI;AH+9iCR;AgCxgjCE;EACE,2CAAA;EACA,gDAAA;EACA,W7BqCI;AHq+iCR;AgCxgjCE;EACE,2CAAA;EACA,0CAAA;EACA,W7BgCI;AH0+iCR;AgCj5iCE;EA/IA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,0CAAA;EACA,qDAAA;EACA,kDAAA;EACA,iDAAA;EACA,gDAAA;AhCmijCF;AgClijCE;EACE,2CAAA;EACA,iDAAA;EACA,W7B2CI;AHy/iCR;AgClijCE;EACE,2CAAA;EACA,iDAAA;EACA,W7BqCI;AH+/iCR;AgClijCE;EACE,2CAAA;EACA,2CAAA;EACA,W7BgCI;AHogjCR;AgCx6iCE;EAlJA,sB7BsDM;E6BrDN,W7BsDM;E6BrDN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;AhC6jjCF;AgC5jjCE;EACE,2CAAA;EACA,gDAAA;EACA,W7B2CI;AHmhjCR;AgC5jjCE;EACE,2CAAA;EACA,gDAAA;EACA,W7BqCI;AHyhjCR;AgC5jjCE;EACE,2CAAA;EACA,0CAAA;EACA,W7BgCI;AH8hjCR;AgC77iCM;;;;;;EAME,oCAAA;AhC+7iCR;AgC37iCM;;;;;;EAME,qCAAA;AhC67iCR;AgCz7iCM;;;;;;EAME,oCAAA;AhC27iCR;AgCv7iCM;;;;;;EAME,oCAAA;AhCy7iCR;AgCr7iCM;;;;;;EAME,oCAAA;AhCu7iCR;AgCn7iCM;;;;;;EAME,mCAAA;AhCq7iCR;AgCj7iCE;EACE,kDAAA;EACA,c7BgES;AHm3iCb;AgCj7iCE;EACE,iDAAA;EACA,c7B4DS;AHu3iCb;AgCj7iCE;EACE,6BAAA;AhCm7iCJ;AgCj7iCE;EACE,6BAAA;EACA,c7BqDS;AH83iCb;AgCj7iCE;EACE,6BAAA;EACA,c7BiDS;AHk4iCb;AgCh7iCI;EAvMF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhC0njCF;AgC37iCI;EA1MF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,8BAAA;EACA,qDAAA;EACA,oDAAA;EACA,4BAAA;EACA,0CAAA;AhCwojCF;AgCt8iCI;EA7MF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhCspjCF;AgCj9iCI;EAhNF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhCoqjCF;AgC59iCI;EAnNF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,8BAAA;EACA,kDAAA;EACA,iDAAA;EACA,4BAAA;EACA,0CAAA;AhCkrjCF;AgCv+iCI;EAtNF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;AhCgsjCF;AgCl/iCI;EAzNF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,gDAAA;EACA,4BAAA;EACA,0CAAA;AhC8sjCF;AgC7/iCI;EA5NF,sB7BsBM;E6BrBN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;AhC4tjCF;;AgCtgjCA;EAnNE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhC6tjCF;;AgCnhjCA;EAtNE,sBAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,8BAAA;EACA,qDAAA;EACA,6BAAA;EACA,oDAAA;EACA,4BAAA;EACA,WAAA;EACA,6CAAA;EACA,sBAAA;AhC6ujCF;;AgChijCA;EAzNE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhC6vjCF;;AgC7ijCA;EA5NE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhC6wjCF;;AgC1jjCA;EA/NE,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,+CAAA;EACA,4BAAA;EACA,WAAA;EACA,wCAAA;EACA,sBAAA;AhC6xjCF;;AgCvkjCA;EAlOE,sBAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,8BAAA;EACA,kDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EACA,WAAA;EACA,0CAAA;EACA,sBAAA;AhC6yjCF;;AgCpljCA;EArOE,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,+CAAA;EACA,4BAAA;EACA,WAAA;EACA,wCAAA;EACA,sBAAA;AhC6zjCF;;AgCjmjCA;EAxOE,sBAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EACA,WAAA;EACA,yCAAA;EACA,sBAAA;AhC60jCF;;AgC7mjCE;EACE,kCAAA;AhCgnjCJ;;AgC5mjCE;EACE,sBAAA;AhC+mjCJ;;AgC5mjCA;EACI,SAAA;AhC+mjCJ;AgC5mjCY;EACI,c7B9GL;E6B+GK,e7BsID;AHw+iCf;AgC5mjCoB;EACI,SAAA;AhC8mjCxB;AgC3mjCgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhC6mjCpB;AgC5mjCoB;EACI,gBAAA;AhC8mjCxB;AgC1mjCoB;EACI,yBAAA;EAAA,8CAAA;AhC4mjCxB;AgCxmjCgB;EACI,c7BzSR;E6B0SQ,e7BgHL;E6B/GK,gB7BxTC;E6ByTD,mBAAA;AhC0mjCpB;AgCzmjCoB;EACI,iBAAA;EACA,cAAA;AhC2mjCxB;AgCzmjCoB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AhC2mjCxB;AgCzmjCoB;EACI,c7BzTd;AHo6jCV;AgCxmjCgB;EACI,cAAA;AhC0mjCpB;AgCzmjCoB;EACI,c7B7TZ;AHw6jCZ;AgCzmjCoB;EACI,cAAA;EACA,e7B0FT;E6BzFS,gB7B9UH;E6B+UG,c7BnEX;AH8qjCb;AgCzmjCoB;EACI,oBAAA;AhC2mjCxB;AgCxmjCgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,e7BoEL;E6BnEK,yBAAA;EACA,gB7BpWC;E6BqWD,kBAAA;AhC0mjCpB;AgCvmjCY;EACI,gB7BxWO;E6ByWP,c7B9VJ;E6B+VI,e7B4DD;E6B3DC,mBAAA;AhCymjChB;AgCvmjCY;EACI,c7BhUP;AHy6jCT;AgCvmjCY;EACI,gBAAA;AhCymjChB;AgCxmjCgB;EACI,e7BqDL;E6BpDK,c7BpMT;E6BqMS,gB7BrXG;E6BsXH,gBAAA;AhC0mjCpB;AgCrmjCY;EACI,gB7B3XG;E6B4XH,c7BlXJ;E6BmXI,e7BrYC;E6BsYD,6BAAA;AhCumjChB;AgCpmjCQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCsmjCZ;AgCrmjCY;EACI,iBAAA;EACA,kBAAA;AhCumjChB;AgClmjCY;EACI,oBAAA;AhComjChB;AgC7ljCQ;EACI,kBAAA;AhC+ljCZ;AgC9ljCY;EACI,gBAAA;AhCgmjChB;AgCzljCY;EACI,kBAAA;AhC2ljChB;AgCrljCY;EACI,kBAAA;AhCuljChB;;AgC7kjCY;EACI,mBAAA;AhCgljChB;;AgC3kjCA;EACI,iBAAA;AhC8kjCJ;AIv+jCI;E4BwZJ;IAGQ,gBAAA;IACA,mBAAA;EhCgljCN;AACF;;AgC9kjCA;EACI,0BAAA;AhCiljCJ;;AgC9kjCI;EACI,aAAA;AhCiljCR;;AgC7kjCI;;;EAGI,wBAAA;AhCgljCR;;AgC7kjCA;EACI,e7B9CW;AH8njCf;;AgC9kjCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCiljCJ;AgChljCI;EACI,c7BhdI;E6BidJ,gB7B7da;AH+ikCrB;AgChljCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AhCkljCR;;AgC9kjCI;EACI,sBAAA;EACA,kBAAA;AhCiljCR;;AgC5kjCQ;EACI,YAAA;AhC+kjCZ;AgC5kjCI;EACI,WAAA;EACA,YAAA;AhC8kjCR;;AgC1kjCI;EACI,UAAA;AhC6kjCR;AgC3kjCI;EACI,oBAAA;AhC6kjCR;AgC3kjCI;EACI,aAAA;AhC6kjCR;AgC5kjCQ;EACI,SAAA;EACA,UAAA;AhC8kjCZ;AgC1kjCQ;EACI,oBAAA;EACA,gBAAA;AhC4kjCZ;;AgCvkjCI;EACI,yBAAA;EACA,8BAAA;AhC0kjCR;AgCxkjCY;EACI,yBAAA;AhC0kjChB;AgCpkjCQ;EACI,gBAAA;AhCskjCZ;AgCnkjCY;EACI,c7B1hBJ;E6B2hBI,gB7BriBG;E6BsiBH,6BAAA;EACA,yBAAA;AhCqkjChB;AgCjkjCY;EACI,sB7BjgBR;AHokkCR;AgCjkjCY;EACI,c7BriBJ;E6BsiBI,gB7BhjBG;AHmnkCnB;;AgC7jjCI;EACI,cAAA;AhCgkjCR;AgC/jjCQ;EACI,kBAAA;AhCikjCZ;;AgC3jjCQ;EACI,WAAA;EACA,YAAA;AhC8jjCZ;;AgC1jjCA;EACI,yBAAA;AhC6jjCJ;AgC5jjCI;EACI,+BAAA;EACA,8BAAA;EACA,aAAA;EACA,gB7B3kBW;E6B4kBX,e7BtKO;AHoujCf;;AgC1jjCI;EACI,+BAAA;EACA,8BAAA;EACA,iBAAA;EACA,c7B1UK;AHu4jCb;;AgC1jjCA;EACI,yBAAA;AhC6jjCJ;AgC5jjCI;EACI,iBAAA;EACA,gB7B3lBW;E6B4lBX,e7BtLO;AHovjCf;AgC5jjCI;EACI,c7BrVK;AHm5jCb;;AgC3jjCA;EACI,cAAA;AhC8jjCJ;AgC5jjCQ;EACI,2BAAA;EACA,mBAAA;EACA,0BAAA;AhC8jjCZ;AgC3jjCI;EACI,kBAAA;AhC6jjCR;;AIxokCI;E4B8kBJ;IAEQ,cAAA;IACA,kBAAA;EhC6jjCN;AACF;;AgC1jjCI;EACI,c7B/mBE;E6BgnBF,gB7BxnBW;E6BynBX,e7BlNO;AH+wjCf;;AgCzjjCI;EACI,0BAAA;AhC4jjCR;AgC1jjCI;EACI,UAAA;AhC4jjCR;AgC1jjCI;EACI,SAAA;EACA,4BAAA;AhC4jjCR;AgC3jjCQ;EACI,aAAA;AhC6jjCZ;AgC5jjCY;EACI,gBAAA;EACA,sBAAA;AhC8jjChB;;AgCzjjCA;EACE,SAAA;AhC4jjCF;AgCzjjCU;EACI,c7BreH;E6BseG,e7BjPC;AH4yjCf;AgCzjjCkB;EACI,SAAA;AhC2jjCtB;AgCxjjCc;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhC0jjClB;AgCzjjCkB;EACI,gBAAA;AhC2jjCtB;AgCvjjCkB;EACI,yBAAA;EAAA,8CAAA;AhCyjjCtB;AgCrjjCc;EACI,c7B/ZJ;E6BgaI,e7BvQH;E6BwQG,gB7B/qBG;E6BgrBH,mBAAA;AhCujjClB;AgCtjjCkB;EACI,iBAAA;EACA,cAAA;AhCwjjCtB;AgCtjjCkB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AhCwjjCtB;AgCtjjCkB;EACI,c7BhrBZ;AHwukCV;AgCvjjCsB;EACI,c7BlrBhB;AH2ukCV;AgCrjjCc;EACI,cAAA;AhCujjClB;AgCtjjCkB;EACI,c7BvrBV;AH+ukCZ;AgCtjjCkB;EACI,cAAA;EACA,e7BhSP;E6BiSO,gB7BxsBD;E6BysBC,c7B7bT;AHq/jCb;AgCtjjCkB;EACI,oBAAA;AhCwjjCtB;AgCrjjCc;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,e7BtTH;E6BuTG,yBAAA;EACA,gB7B9tBG;E6B+tBH,kBAAA;AhCujjClB;AgCpjjCU;EACI,gB7BluBS;E6BmuBT,c7BxtBF;E6BytBE,e7B9TC;E6B+TD,mBAAA;AhCsjjCd;AgCpjjCU;EACI,c7B1rBL;AHgvkCT;AgCpjjCU;EACI,gBAAA;AhCsjjCd;AgCrjjCc;EACI,e7BrUH;E6BsUG,c7B9jBP;E6B+jBO,gB7B/uBK;E6BgvBL,gBAAA;AhCujjClB;AgCljjCU;EACI,gB7BrvBK;E6BsvBL,c7B5uBF;E6B6uBE,e7B/vBG;E6BgwBH,6BAAA;AhCojjCd;AgCjjjCM;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCmjjCV;AgCljjCU;EACI,iBAAA;EACA,kBAAA;AhCojjCd;AgC/ijCU;EACI,oBAAA;AhCijjCd;AgC1ijCM;EACI,kBAAA;AhC4ijCV;AgC3ijCU;EACI,gBAAA;AhC6ijCd;AgCtijCU;EACI,kBAAA;AhCwijCd;AgClijCU;EACI,kBAAA;AhCoijCd;AgChijCE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AhCkijCJ;;AgC3hjCU;EAGI,aAAA;AhC8hjCd;AgC7hjCc;EACI,0CAAA;EACV,sB7B7wBA;E6B8wBU,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AhC+hjClB;AgC9hjCkB;EACI,c7BtxBf;E6BuxBe,WAAA;EACA,YAAA;AhCgijCtB;AgC9hjCkB;EACG,c7BhkBR;E6BikBQ,WAAA;EACC,YAAA;AhCgijCtB;AgC9hjCkB;EACI,c7B7zBb;E6B8zBa,WAAA;EACA,YAAA;AhCgijCtB;AgC9hjCkB;EACI,WAAA;EACA,YAAA;AhCgijCtB;AgC9hjCkB;EACI,c7BzyBf;E6B0yBe,WAAA;EACA,YAAA;AhCgijCtB;AgC7hjCkB;EACI,c7Bp1BV;E6Bq1BU,WAAA;EACA,YAAA;AhC+hjCtB;AgCzhjCM;EACI,gBAAA;AhC2hjCV;AgCzhjCc;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AhC2hjClB;AgC1hjCkB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AhC4hjCtB;AgCthjCE;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AhCwhjCN;AgCvhjCM;EACI,UAAA;AhCyhjCV;AgCrhjCE;EACI,gBAAA;AhCuhjCN;AgCrhjCE;EACI,YAAA;AhCuhjCN;AgCrhjCE;EACI,YAAA;AhCuhjCN;;AgC9gjCwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,c7B5pBf;AH6qkCb;AgChhjC4B;EACI,mB7BlwBpB;E6BmwBoB,c7B/pBnB;AHirkCb;;AiCv8kCA;EACI,sB9BsDI;E8BrDJ,c9BoRS;E8BnRT,qBAAA;EACA,kBAAA;EACA,gB9BKiB;AHq8kCrB;AiCx8kCQ;EACI,gBAAA;AjC08kCZ;AiCx8kCQ;EACI,c9B2QC;E8B1QD,yB9BgRS;E8B/QT,gBAAA;AjC08kCZ;AiCz8kCY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AjC28kChB;AiCv8kCI;EACI,c9BgQK;E8B/PL,yB9BqQa;E8BpQb,gBAAA;AjCy8kCR;AiCv8kCI;EACI,oCAAA;EACA,gBAAA;AjCy8kCR;AiCv8kCI;EACI,sBAAA;AjCy8kCR;AiCv8kCI;EACI,gBAAA;EACA,0B9BlBO;E8BmBP,e9B0YO;E8BzYP,cAAA;EACA,sB9BiBA;E8BhBA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,c9B2OK;AH8tkCb;;AiCt8kCA;EACI,qBAAA;EACA,oBAAA;EACA,c9B0OS;AH+tkCb;;AiCv8kCA;EACI,c9BkOS;E8BjOT,sB9BEI;E8BDJ,yBAAA;AjC08kCJ;;AiCv8kCI;EACI,0BAAA;AjC08kCR;AiCx8kCI;EACI,qCAAA;EACA,kB9B8VQ;E8B7VR,gBAAA;AjC08kCR;;AiCv8kCA;EACI,mCAAA;EACA,kCAAA;AjC08kCJ;;AiCx8kCA;EACI,+BAAA;EACA,gCAAA;AjC28kCJ;;AiCv8kCQ;EACI,wCAAA;EACA,c9B1DF;AHoglCV;AiCz8kCY;EACI,yB9B5DN;E8B6DM,W9B1BR;AHq+kCR;AiCz8kCY;EACI,sB9B7BR;E8B8BQ,c9BiMH;AH0wkCb;AiC18kCgB;EACI,yB9BqMC;E8BpMD,c9B8LP;AH8wkCb;AiCt8kCQ;EACI,wCAAA;EACA,c9B1EA;AHkhlCZ;AiCv8kCY;EACI,yB9B5EJ;E8B6EI,W9B5CR;AHq/kCR;AiCv8kCY;EACI,sB9B/CR;E8BgDQ,c9B+KH;AH0xkCb;AiCx8kCgB;EACI,yB9BmLC;E8BlLD,c9B4KP;AH8xkCb;AiCp8kCQ;EACI,wCAAA;EACA,c9B1FF;AHgilCV;AiCr8kCY;EACI,yB9B5FN;E8B6FM,W9B9DR;AHqglCR;AiCr8kCY;EACI,sB9BjER;E8BkEQ,c9B6JH;AH0ykCb;AiCt8kCgB;EACI,yB9BiKC;E8BhKD,c9B0JP;AH8ykCb;AiCl8kCQ;EACI,uCAAA;EACA,c9BtGH;AH0ilCT;AiCn8kCY;EACI,yB9BxGP;E8ByGO,W9BhFR;AHqhlCR;AiCn8kCY;EACI,sB9BnFR;E8BoFQ,c9B2IH;AH0zkCb;AiCp8kCgB;EACI,yB9B+IC;E8B9ID,c9BwIP;AH8zkCb;AiCh8kCQ;EACI,wCAAA;EACA,c9B1HF;AH4jlCV;AiCj8kCY;EACI,yB9B5HN;E8B6HM,W9BlGR;AHqilCR;AiCj8kCY;EACI,sB9BrGR;E8BsGQ,c9ByHH;AH00kCb;AiCl8kCgB;EACI,yB9B6HC;E8B5HD,c9BsHP;AH80kCb;AiC97kCQ;EACI,yCAAA;EACA,c9B9IL;AH8klCP;AiC/7kCY;EACI,yB9BhJT;E8BiJS,W9BpHR;AHqjlCR;AiC/7kCY;EACI,sB9BvHR;E8BwHQ,c9BuGH;AH01kCb;AiCh8kCgB;EACI,yB9B2GC;E8B1GD,c9BoGP;AH81kCb;;AiC17kCQ;EACI,yB9BvKF;E8BwKE,W9BrIJ;AHkklCR;AiC57kCY;EACI,sB9BvIR;E8BwIQ,c9B3KN;AHymlCV;AiC57kCY;EACI,sB9B3IR;E8B4IQ,c9BmFH;AH22kCb;AiC77kCgB;EACI,yB9BuFC;E8BtFD,c9BgFP;AH+2kCb;AiCz7kCQ;EACI,yB9BvLA;E8BwLA,W9BvJJ;AHkllCR;AiC17kCY;EACI,sB9BzJR;E8B0JQ,c9B3LJ;AHunlCZ;AiC17kCY;EACI,sB9B7JR;E8B8JQ,c9BiEH;AH23kCb;AiC37kCgB;EACI,yB9BqEC;E8BpED,c9B8DP;AH+3kCb;AiCv7kCQ;EACI,yB9BvMF;E8BwME,W9BzKJ;AHkmlCR;AiCx7kCY;EACI,sB9B3KR;E8B4KQ,c9B3MN;AHqolCV;AiCx7kCY;EACI,sB9B/KR;E8BgLQ,c9B+CH;AH24kCb;AiCz7kCgB;EACI,yB9BmDC;E8BlDD,c9B4CP;AH+4kCb;AiCr7kCQ;EACI,yB9BnNH;E8BoNG,W9B3LJ;AHknlCR;AiCt7kCY;EACI,sB9B7LR;E8B8LQ,c9BvNP;AH+olCT;AiCt7kCY;EACI,sB9BjMR;E8BkMQ,c9B6BH;AH25kCb;AiCv7kCgB;EACI,yB9BiCC;E8BhCD,c9B0BP;AH+5kCb;AiCn7kCQ;EACI,yB9BvOF;E8BwOE,W9B7MJ;AHkolCR;AiCp7kCY;EACI,sB9B/MR;E8BgNQ,c9B3ON;AHiqlCV;AiCp7kCY;EACI,sB9BnNR;E8BoNQ,c9BWH;AH26kCb;AiCr7kCgB;EACI,yB9BeC;E8BdD,c9BQP;AH+6kCb;AiCj7kCQ;EACI,yB9B3PL;E8B4PK,W9B/NJ;AHkplCR;AiCl7kCY;EACI,sB9BjOR;E8BkOQ,c9B/PT;AHmrlCP;AiCl7kCY;EACI,sB9BrOR;E8BsOQ,c9BPH;AH27kCb;AiCn7kCgB;EACI,yB9BHC;E8BID,c9BVP;AH+7kCb;;AiC76kCQ;EACI,yBAAA;AjCg7kCZ;AiC96kCQ;EACI,sB9BrPJ;E8BsPI,c9BzRF;E8B0RE,qBAAA;AjCg7kCZ;AiC/6kCY;EACI,sB9BzPR;E8B0PQ,c9B7RN;E8B8RM,yBAAA;AjCi7kChB;AiC/6kCY;EACI,mCAAA;AjCi7kChB;AiC56kCQ;EACI,yBAAA;AjC86kCZ;AiC56kCQ;EACI,sB9BvQJ;E8BwQI,c9BzSA;E8B0SA,qBAAA;AjC86kCZ;AiC76kCY;EACI,sB9B3QR;E8B4QQ,c9B7SJ;E8B8SI,yBAAA;AjC+6kChB;AiC76kCY;EACI,mCAAA;AjC+6kChB;AiC16kCQ;EACI,yBAAA;AjC46kCZ;AiC16kCQ;EACI,sB9BzRJ;E8B0RI,c9BzTF;E8B0TE,qBAAA;AjC46kCZ;AiC36kCY;EACI,sB9B7RR;E8B8RQ,c9B7TN;E8B8TM,yBAAA;AjC66kChB;AiC36kCY;EACI,mCAAA;AjC66kChB;AiCx6kCQ;EACI,yBAAA;AjC06kCZ;AiCx6kCQ;EACI,sB9B3SJ;E8B4SI,c9BrUH;E8BsUG,qBAAA;AjC06kCZ;AiCz6kCY;EACI,sB9B/SR;E8BgTQ,c9BzUP;E8B0UO,yBAAA;AjC26kChB;AiCz6kCY;EACI,mCAAA;AjC26kChB;AiCt6kCQ;EACI,yBAAA;AjCw6kCZ;AiCt6kCQ;EACI,sB9B7TJ;E8B8TI,c9BzVF;E8B0VE,qBAAA;AjCw6kCZ;AiCv6kCY;EACI,sB9BjUR;E8BkUQ,c9B7VN;E8B8VM,yBAAA;AjCy6kChB;AiCv6kCY;EACI,mCAAA;AjCy6kChB;AiCp6kCQ;EACI,yBAAA;AjCs6kCZ;AiCp6kCQ;EACI,sB9B/UJ;E8BgVI,c9B7WL;E8B8WK,qBAAA;AjCs6kCZ;AiCr6kCY;EACI,sB9BnVR;E8BoVQ,c9BjXT;E8BkXS,yBAAA;AjCu6kChB;AiCr6kCY;EACI,mCAAA;AjCu6kChB;;AiCh6kCQ;EACI,aAAA;AjCm6kCZ;;AiC75kCQ;EACI,4BAAA;AjCg6kCZ;AiC/5kCY;EACI,kBAAA;EACA,4BAAA;AjCi6kChB;;AiCz5kCY;EACI,YAAA;EACA,0B9B1ZD;E8B2ZC,yB9BhJK;AH4ilCrB;AiC15kCY;EACI,gBAAA;EACZ,0B9B/ZW;E8BgaC,sB9B1XR;AHsxlCR;;AiCp5kCY;EACI,wCAAA;EACA,yDAAA;AjCu5kChB;AiCt5kCgB;EACI,wCAAA;EACA,W9BvYZ;AH+xlCR;AiCr5kCY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCu5kChB;AiCn5kCY;EACI,wCAAA;EACA,yDAAA;AjCq5kChB;AiCp5kCgB;EACI,wCAAA;EACA,W9BtZZ;AH4ylCR;AiCn5kCY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCq5kChB;AiCj5kCY;EACI,wCAAA;EACA,yDAAA;AjCm5kChB;AiCl5kCgB;EACI,wCAAA;EACA,W9BraZ;AHyzlCR;AiCj5kCY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCm5kChB;AiC/4kCY;EACI,yCAAA;EACA,0DAAA;AjCi5kChB;AiCh5kCgB;EACI,yCAAA;EACA,W9BpbZ;AHs0lCR;AiC/4kCY;EACI,yCAAA;EACA,sBAAA;EACA,0DAAA;AjCi5kChB;AiC74kCY;EACI,wCAAA;EACA,yDAAA;AjC+4kChB;AiC94kCgB;EACI,wCAAA;EACA,W9BncZ;AHm1lCR;AiC74kCY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjC+4kChB;AiC34kCY;EACI,uCAAA;EACA,wDAAA;AjC64kChB;AiC54kCgB;EACI,uCAAA;EACA,W9BldZ;AHg2lCR;AiC34kCY;EACI,uCAAA;EACA,sBAAA;EACA,wDAAA;AjC64kChB;;AkC35lCE;EACE,gBAAA;EAAA,8CAAA;EACA,sCAAA;AlC85lCJ;;AkCz5lCI;EACE,gBAAA;EAAA,8CAAA;EACA,sCAAA;AlC45lCN;;AkCt5lCI;EACE,c/B0QO;AH+olCb;AkCt5lCI;EACE,c/BDI;AHy5lCV;;AkCp5lCA;EACE,c/BiQW;E+BhQX,YAAA;AlCu5lCF;;AkCp5lCE;EACE,c/B4PS;E+B3PT,gBAAA;EACA,qCAAA;AlCu5lCJ;;AkCn5lCE;EACE,c/BqPS;E+BpPT,gBAAA;EACA,qCAAA;AlCs5lCJ;;AkCl5lCE;EACE,c/B8OS;E+B7OT,YAAA;AlCq5lCJ;;AkCj5lCE;EACE,c/BwOS;E+BvOT,YAAA;AlCo5lCJ;;AkCh5lCE;EACE,c/BkOS;E+BjOT,gBAAA;EACA,qCAAA;AlCm5lCJ;;AkC/4lCE;EACE,WAAA;EACA,aAAA;AlCk5lCJ;;AkC/4lCA;EACE,kBAAA;EACA,kB/BsVc;AH4jlChB;AkCh5lCE;EACC,W/BlBK;AHo6lCR;AkC94lCI;EACD,W/BvBK;AHu6lCR;AkC94lCE;EACC,W/B1BK;E+B2BL,YAAA;AlCg5lCH;AkC74lCM;EACE,W/B/BA;AH86lCR;AkC74lCG;EACC,W/BlCI;AHi7lCR;;AkC14lCA;EACE,YAAA;AlC64lCF;;AkC14lCE;EACE,iBAAA;AlC64lCJ;;AmCh/lCA;EACI,mBAAA;EACA,sBhCqDI;EgCpDJ,gCAAA;EACA,kBAAA;EACA,kBhCyZe;EgCxZf,SAAA;EACA,8DhC+ZY;EgC9ZZ,cAAA;AnCm/lCJ;AmCl/lCI;EACI,aAAA;AnCo/lCR;AmCl/lCI;EACI,ehCsaO;EgCraP,gBhCFW;EgCGX,0BAAA;AnCo/lCR;AmCl/lCI;EACI,qBhCgKI;EgC/JJ,kBAAA;EACA,uBAAA;EACA,aAAA;AnCo/lCR;AmCn/lCQ;EACI,mBAAA;AnCq/lCZ;AmCn/lCQ;EACI,sBAAA;EACA,mBAAA;EACA,gBAAA;AnCq/lCZ;AmCl/lCI;EACI,qBhCkJI;EgCjJJ,uBAAA;EACA,0BAAA;AnCo/lCR;;AmCh/lCE;EACI,qBAAA;AnCm/lCN;;AmC/+lCE;EACA,kBhCgXc;EgC/Wd,SAAA;EACA,sBhCSM;EgCRN,kBAAA;EACA,wBAAA;EACA,WAAA;AnCk/lCF;AmCj/lCE;EACE,qBAAA;EACA,wCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AnCm/lCJ;AmCl/lCI;EACE,oCAAA;AnCo/lCN;AmCl/lCI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBhCtDa;EgCuDb,0BAAA;AnCo/lCN;AmCn/lCM;EACE,mBAAA;EACA,oBAAA;EAAA,uBAAA;AnCq/lCR;AmCj/lCE;EACE,wCAAA;EACA,qCAAA;EACA,oBAAA;EACA,ehC1Ea;AH6jmCjB;AmCj/lCE;EACE,eAAA;EACA,chCoMS;AH+ylCb;AmCj/lCE;EACE,kBAAA;AnCm/lCJ;AmCh/lCE;EACE,mBAAA;AnCk/lCJ;AmCh/lCE;EACE,WAAA;EACA,YAAA;AnCk/lCJ;AmCh/lCE;EACE,kBAAA;EACA,gBAAA;EACA,+BAAA;AnCk/lCJ;AmCj/lCI;EACE,oDAAA;AnCm/lCN;AmCj/lCI;EACE,sDAAA;AnCm/lCN;AmCj/lCI;EACE,SAAA;AnCm/lCN;AmCj/lCI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AnCm/lCN;AmCh/lCE;EACE,yBhCnGM;EgCoGN,WhCjEI;AHmjmCR;AmCj/lCI;EACE,qDAAA;EACA,WhCpEE;EgCqEF,oDAAA;AnCm/lCN;AmCl/lCM;EACE,sBhCvEA;AH2jmCR;AmCj/lCI;EACE,WhC3EE;AH8jmCR;AmCj/lCI;EACE,qDAAA;EACA,WhC/EE;EgCgFF,sDAAA;AnCm/lCN;AmCh/lCE;EACE,yBhCrHQ;EgCsHR,WhCrFI;AHukmCR;AmCj/lCI;EACE,qDAAA;EACA,WhCxFE;EgCyFF,oDAAA;AnCm/lCN;AmCl/lCM;EACE,sBhC3FA;AH+kmCR;AmCj/lCI;EACE,WhC/FE;AHklmCR;AmCj/lCI;EACE,qDAAA;EACA,WhCnGE;EgCoGF,sDAAA;AnCm/lCN;AmCh/lCE;EACE,yBhCnIM;EgCoIN,WhCzGI;AH2lmCR;AmCj/lCI;EACE,qDAAA;EACA,WhC5GE;EgC6GF,oDAAA;AnCm/lCN;AmCl/lCM;EACE,sBhC/GA;AHmmmCR;AmCj/lCI;EACE,WhCnHE;AHsmmCR;AmCj/lCI;EACE,qDAAA;EACA,WhCvHE;EgCwHF,sDAAA;AnCm/lCN;AmCh/lCE;EACE,yBhCzJG;EgC0JH,WhC7HI;AH+mmCR;AmCj/lCI;EACE,qDAAA;EACA,WhChIE;EgCiIF,oDAAA;AnCm/lCN;AmCl/lCM;EACE,sBhCnIA;AHunmCR;AmCj/lCI;EACE,WhCvIE;AH0nmCR;AmCj/lCI;EACE,qDAAA;EACA,WhC3IE;EgC4IF,sDAAA;AnCm/lCN;AmCh/lCE;EACE,yBhC/KM;EgCgLN,WhCjJI;AHmomCR;AmCj/lCI;EACE,qDAAA;EACA,WhCpJE;EgCqJF,oDAAA;AnCm/lCN;AmCl/lCM;EACE,sBhCvJA;AH2omCR;AmCj/lCI;EACE,WhC3JE;AH8omCR;AmCj/lCI;EACE,qDAAA;EACA,WhC/JE;EgCgKF,sDAAA;AnCm/lCN;AmCh/lCE;EACE,yBhC7LK;EgC8LL,WhCrKI;AHupmCR;AmCj/lCI;EACE,qDAAA;EACA,WhCxKE;EgCyKF,oDAAA;AnCm/lCN;AmCl/lCM;EACE,sBhC3KA;AH+pmCR;AmCj/lCI;EACE,WhC/KE;AHkqmCR;AmCj/lCI;EACE,qDAAA;EACA,WhCnLE;EgCoLF,sDAAA;AnCm/lCN;AmCh/lCE;EACE,yBhC1LI;EgC2LJ,chCsCS;AH48lCb;AmCj/lCI;EACE,gDAAA;EACA,chCmCO;EgClCP,yBhClEM;AHqjmCZ;AmCj/lCI;EACE,chC+BO;AHo9lCb;AmCj/lCI;EACE,gDAAA;EACA,chC2BO;EgC1BP,2BhC1EM;AH6jmCZ;AmCh/lCE;EACE,yBhChOG;EgCiOH,WhC1MI;AH4rmCR;AmCj/lCI;EACE,qDAAA;EACA,WhC7ME;EgC8MF,oDAAA;AnCm/lCN;AmCl/lCM;EACE,sBhChNA;AHosmCR;AmCj/lCI;EACE,WhCpNE;AHusmCR;AmCj/lCI;EACE,qDAAA;EACA,WhCxNE;EgCyNF,sDAAA;AnCm/lCN;AmCh/lCE;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AnCk/lCJ;AmCh/lCE;EACE,aAAA;AnCk/lCJ;AmC/+lCI;EACE,cAAA;AnCi/lCN;AmC/+lCI;EACE,aAAA;AnCi/lCN;AmC9+lCE;EACE,eAAA;EACA,MAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;EACA,SAAA;AnCg/lCJ;;AmC7+lCA;EACI,ehC4IW;EgC3IX,chC3HO;AH2mmCX;;AmC9+lCA;EACE,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBhCrQM;EgCsQN,0CAAA;AnCi/lCF;;AmC/+lCA;EACE,2CAAA;EACA,qCAAA;AnCk/lCF;;AmCh/lCA;EACE,0CAAA;EACA,oCAAA;AnCm/lCF;;AmCj/lCA;EACE,yCAAA;EACA,mCAAA;AnCo/lCF;;AmCl/lCA;EACE,yBhCjBS;EgCkBT,WhCpRM;EgCqRN,yBAAA;AnCq/lCF;AmCp/lCE;EAGE,oCAAA;EACA,sBAAA;EACA,oCAAA;AnCo/lCJ;;AmCj/lCA;EACE,mBAAA;EAiBA,mGAAA;EAQA,mHAAA;EACA,WhCzTM;EgC0TN,6BAAA;AnC+9lCF;AmC99lCE;EAGE,WhC9TI;EgC+TJ,6BAAA;AnC89lCJ;;AmC39lCA;EACE,yBhChEQ;EgCiER,WhCpUM;EgCqUN,yBAAA;AnC89lCF;AmC79lCE;EAGE,oCAAA;EACA,sBAAA;EACA,oCAAA;AnC69lCJ;;AmC19lCA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AnC69lCJ;;AmC39lCA;EACI,gCAAA;AnC89lCJ;;AmC39lCA;EAEM;IACI,8BAAA;EnC69lCR;AACF;AmC19lCA;EAEM;IACI,8BAAA;EnC29lCR;AACF;AoCn3mCI;EACE,yBjCiBI;AHo2mCV;AoCn3mCI;EAEE,yBjCaI;AHu2mCV;AoCl3mCI;EAEE,2BjCSI;AH02mCV;AoCj3mCI;EAEE,0BjCKI;AH62mCV;AoCh3mCI;EAEE,4BjCCI;AHg3mCV;AoCl4mCI;EACE,yBjCmBM;AHi3mCZ;AoCl4mCI;EAEE,yBjCeM;AHo3mCZ;AoCj4mCI;EAEE,2BjCWM;AHu3mCZ;AoCh4mCI;EAEE,0BjCOM;AH03mCZ;AoC/3mCI;EAEE,4BjCGM;AH63mCZ;AoCj5mCI;EACE,yBjCyBI;AH03mCV;AoCj5mCI;EAEE,yBjCqBI;AH63mCV;AoCh5mCI;EAEE,2BjCiBI;AHg4mCV;AoC/4mCI;EAEE,0BjCaI;AHm4mCV;AoC94mCI;EAEE,4BjCSI;AHs4mCV;AoCh6mCI;EACE,yBjCuBC;AH24mCP;AoCh6mCI;EAEE,yBjCmBC;AH84mCP;AoC/5mCI;EAEE,2BjCeC;AHi5mCP;AoC95mCI;EAEE,0BjCWC;AHo5mCP;AoC75mCI;EAEE,4BjCOC;AHu5mCP;AoC/6mCI;EACE,yBjCqBI;AH45mCV;AoC/6mCI;EAEE,yBjCiBI;AH+5mCV;AoC96mCI;EAEE,2BjCaI;AHk6mCV;AoC76mCI;EAEE,0BjCSI;AHq6mCV;AoC56mCI;EAEE,4BjCKI;AHw6mCV;AoC97mCI;EACE,yBjC2BG;AHq6mCT;AoC97mCI;EAEE,yBjCuBG;AHw6mCT;AoC77mCI;EAEE,2BjCmBG;AH26mCT;AoC57mCI;EAEE,0BjCeG;AH86mCT;AoC37mCI;EAEE,4BjCWG;AHi7mCT;AoC78mCI;EACE,yBjC6BC;AHk7mCP;AoC78mCI;EAEE,yBjCyBC;AHq7mCP;AoC58mCI;EAEE,2BjCqBC;AHw7mCP;AoC38mCI;EAEE,0BjCiBC;AH27mCP;AoC18mCI;EAEE,4BjCaC;AH87mCP;AoCp7mCI;EACE,WjCYE;AH06mCR;AoC/9mCI;EACE,yBjCkDE;AH+6mCR;AoC/9mCI;EAEE,yBjC8CE;AHk7mCR;AoC99mCI;EAEE,2BjC0CE;AHq7mCR;AoC79mCI;EAEE,0BjCsCE;AHw7mCR;AoC59mCI;EAEE,4BjCkCE;AH27mCR;AoCh8mCI;EACE,cjCqOO;AH6tmCb;;AqCn/mCA;EACE,yBAAA;ArCs/mCF;AqCr/mCE;EACE,oBAAA;ArCu/mCJ;;AqCp/mCA;EACE,clC+QW;EkC9QX,kBlCoZc;EkCnZd,gBlCEqB;AHq/mCvB;AqCt/mCE;EACE,wCAAA;EACA,clCQM;AHg/mCV;;AqCr/mCA;EACE,clCsQW;AHkvmCb;AqCv/mCE;EACE,clCoQS;EkCnQT,YAAA;ArCy/mCJ;;AqCt/mCA;;EAEE,clCJQ;AH6/mCV;;AqCv/mCA;EACE,clC2PW;EkC1PX,YAAA;ArC0/mCF;;AqCx/mCA;EACE,4BAAA;ArC2/mCF;;AqCz/mCA;EACE,clCoPW;AHwwmCb;;AqCx/mCI;;EAEE,WlCeE;AH4+mCR;AqCx/mCE;;EAEE,WlCUI;AHg/mCR;;AqCv/mCA;;EAEE,WlCKM;EkCJN,yBlC/BQ;AHyhnCV;;AqCv/mCA;EACA,SAAA;ArC0/mCA;AqCz/mCA;EACE,0BAAA;ArC2/mCF;AqC1/mCE;EACE,oBAAA;ArC4/mCJ;AqCx/mCE;EACI,wCAAA;EACA,clC7CI;AHuinCV;AqCz/mCM;EACE,kCAAA;ArC2/mCR;AqCx/mCE;EACI,uBAAA;EACA,clCpDI;AH8inCV;;AqCr/mCA;EACE,yCAAA;ArCw/mCF;AqCv/mCE;EACE,wCAAA;EACA,qCAAA;EACA,clC9DM;AHujnCV;;AqCp/mCA;EACE,gBAAA;ArCu/mCF;AqCr/mCA;EACE,uCAAA;ArCu/mCF;AqCr/mCA;EACE,6BAAA;EACA,mCAAA;EACA,clC5EQ;AHmknCV;;AqCp/mCA;EACA,SAAA;ArCu/mCA;AqCt/mCA;EACE,clCqLW;EkCpLX,SAAA;ArCw/mCF;AqCt/mCA;EACE,kBAAA;ArCw/mCF;AqCv/mCE;EACE,yBlCvDI;EkCwDJ,clCyKS;EkCxKT,SAAA;ArCy/mCJ;AqCv/mCE;EAEE,SAAA;ArCw/mCJ;AqCt/mCE;EACI,yBlChEE;EkCiEF,clCgKO;AHw1mCb;;AqCp/mCA;EACA,SAAA;ArCu/mCA;AqCt/mCA;EACE,clC8JW;EkC7JX,SAAA;EACA,kBAAA;ArCw/mCF;AqCr/mCE;EACE,yBlC/GM;EkCgHN,WlC7EI;EkC8EJ,SAAA;ArCu/mCJ;AqCr/mCE;EAEE,SAAA;EACA,yBlCtHM;EkCuHN,WlCpFI;AH0knCR;;AqCl/mCA;EACA,SAAA;ArCq/mCA;AqCn/mCE;EACE,yBAAA;EACA,mCAAA;EACA,6BAAA;EACA,clClIM;AHunnCV;;AqCj/mCA;EACA,oBAAA;ArCo/mCA;AqCn/mCA;EACE,yBAAA;ArCq/mCF;AqCp/mCE;EACE,oBAAA;ArCs/mCJ;AqCp/mCE;EACE,6BAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBlC3JiB;AHipnCrB;AqCr/mCI;EACE,kCAAA;EACA,clCpJI;EkCqJJ,6BAAA;ArCu/mCN;AqCr/mCI;EACE,6BAAA;EACA,6BAAA;EACA,clC1JI;AHipnCV;;AqCl/mCA;EACA,SAAA;ArCq/mCA;AqCp/mCA;EACE,yBAAA;ArCs/mCF;AqCr/mCE;EACE,oBAAA;ArCu/mCJ;AqCr/mCE;EACE,6BAAA;EACA,clCxKM;EkCyKN,yBAAA;EACA,iBAAA;ArCu/mCJ;AqCt/mCI;EACE,mBlC5KI;EkC6KJ,WlC1IE;EkC2IF,yBAAA;ArCw/mCN;AqCt/mCI;EACE,yBAAA;EACA,6BAAA;EACC,clCnLG;AH2qnCV;;AqCn/mCA;EACA,SAAA;ArCs/mCA;AqCr/mCA;EACE,yBAAA;ArCu/mCF;AqCt/mCE;EACE,oBAAA;ArCw/mCJ;AqCt/mCE;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,clCkES;EkCjET,yBlCrKI;AH6pnCR;AqCv/mCI;EACE,eAAA;ArCy/mCN;AqCv/mCI;EACE,yBlC3MI;EkC4MJ,WlCzKE;EkC0KF,kBAAA;ArCy/mCN;AqCx/mCM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,yBlCtNE;AHgtnCV;AqCx/mCM;EACE,WlCtLA;AHgrnCR;AqCv/mCI;EACE,clC7NI;AHstnCV;;AqCp/mCA;EACA,SAAA;ArCu/mCA;AqCt/mCA;EACE,SAAA;EACA,yBAAA;ArCw/mCF;AqCv/mCE;EACE,oBAAA;ArCy/mCJ;AqCv/mCE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,wBAAA;ArCy/mCJ;AqCx/mCI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBlCtPI;EkCuPJ,WlCpNE;EkCqNF,uBAAA;EACA,gBlCnQe;AH6vnCrB;AqCx/mCI;EACE,mBlC5PI;EkC6PJ,yBAAA;EACA,WlC3NE;AHqtnCR;AqCz/mCM;EACE,mBlChQE;EkCiQF,yBAAA;EACA,WlC/NA;AH0tnCR;AqCz/mCM;EACE,gBlClOA;EkCmOA,clCtQE;AHiwnCV;AqCx/mCI;EACE,yBAAA;EACA,clC3QI;EkC4QF,uBAAA;ArC0/mCR;;AqCr/mCA;EACA,mBAAA;EACA,gBAAA;EACA,yBlCnPQ;EkCoPR,kBAAA;EACA,sBAAA;ArCw/mCA;AqCv/mCA;EACE,yBAAA;ArCy/mCF;AqCx/mCE;EACE,oBAAA;ArC0/mCJ;AqCv/mCA;EACE,kBAAA;EACA,qBAAA;ArCy/mCF;AqCx/mCE;EACE,oCAAA;EACA,sBAAA;EACA,8DlC8GS;EkC7GT,+BAAA;ArC0/mCJ;;AqCp/mCM;EACA,uBAAA;EACA,clC5SI;AHmynCV;;AqCj/mCA;EACA,mBAAA;ArCo/mCA;AqCn/mCA;EACE,yBAAA;ArCq/mCF;AqCp/mCE;EACE,oBAAA;ArCs/mCJ;AqCp/mCE;EACE,SAAA;ArCs/mCJ;AqCr/mCI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBlC/RE;EkCgSF,clC/DO;EkCgEP,qBAAA;ArCu/mCN;AqCr/mCI;EACE,SAAA;EACA,uBAAA;EACA,clCvUI;AH8znCV;AqCt/mCM;EACE,clCzUE;AHi0nCV;AqCr/mCI;EACE,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,clChVI;AHu0nCV;AqCt/mCM;EACE,wCAAA;EACA,clCnVE;AH20nCV;AqCt/mCM;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBlC7VE;EkC8VF,mBAAA;ArCw/mCR;;AqCl/mCA;EACA,mBAAA;ArCq/mCA;AqCp/mCA;EACE,kBAAA;EACA,yBAAA;ArCs/mCF;AqCr/mCE;EACE,oBAAA;ArCu/mCJ;AqCr/mCE;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;ArCu/mCJ;AqCt/mCI;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBlCvVE;EkCwVF,kBAAA;ArCw/mCN;AqCt/mCI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBlCpWE;EkCqWF,kBAAA;EACA,yBAAA;ArCw/mCN;AqCt/mCI;EACE,YAAA;ArCw/mCN;AqCt/mCI;EACE,YAAA;ArCw/mCN;AqCt/mCI;EACE,YAAA;ArCw/mCN;AqCt/mCI;EACE,SAAA;EACA,uBAAA;EACA,clCvZI;AH+4nCV;AqCt/mCI;EACE,6BAAA;EACA,SAAA;EACA,clC5ZI;AHo5nCV;AqCv/mCM;EACE,yBlC9ZE;AHu5nCV;AqCv/mCM;EACE,qBlCjaE;EkCkaF,clClaE;AH25nCV;;AqCl/mCA;EACE,SAAA;ArCq/mCF;AqCp/mCE;EACE,yBAAA;ArCs/mCJ;AqCr/mCI;EACE,oBAAA;ArCu/mCN;AqCp/mCE;EACE,SAAA;ArCs/mCJ;AqCr/mCI;EACE,SAAA;EACA,uBAAA;EACA,clCtbI;AH66nCV;AqCr/mCI;EACE,6BAAA;EACA,SAAA;EACA,clC3bI;EkC4bJ,kBAAA;EACA,gBAAA;ArCu/mCN;AqCt/mCM;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,yBlCxcE;EkCycF,yBAAA;ArCw/mCR;AqCt/mCM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBlCldE;AH08nCV;;AqCl/mCA;EACA,yBAAA;EACA,yBlC1dU;EkC2dV,WlCxbQ;EkCybR,aAAA;EACE,kBAAA;ArCq/mCF;;AqCl/mCA;EACE,yBAAA;ArCq/mCF;AqCp/mCE;EACE,oBAAA;ArCs/mCJ;AqCp/mCE;EACE,mBlCteM;AH49nCV;;AqCl/mCA;EACA,SAAA;EACA,sBlCzcQ;EkC0cR,kBAAA;EACA,clC9eU;EkC+eV,eAAA;ArCq/mCA;AqCp/mCA;EACE,SAAA;EACA,yBAAA;ArCs/mCF;AqCr/mCE;EACE,oBAAA;ArCu/mCJ;AqCr/mCE;EACE,clCvfM;EkCwfN,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBlCrgBiB;EkCwgBjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArCu/mCJ;AqCt/mCI;EACE,SAAA;EACA,yBlCpgBI;EkCqgBJ,WlCleE;EkCmeF,SAAA;EACA,wDAAA;ArCw/mCN;AqCt/mCI;EAEE,SAAA;ArCu/mCN;;AqCj/mCA;EACE,wBAAA;EACA,mBAAA;EACA,clC7QW;EkC8QX,gBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArCo/mCF;AqCn/mCE;EAEE,wCAAA;EACA,clC/hBM;AHmhoCV;;AqC7+mCI;EACE,wCAAA;EACA,clCxiBI;AHwhoCV;;AqC3+mCA;EAEE;IACE,sBAAA;ErC6+mCF;AACF;AqCz+mCA;EACE,gBAAA;ArC2+mCF;AqCz+mCM;EACI,mBAAA;ArC2+mCV;AqCx+mCE;EACI,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;ArC0+mCN;AqCz+mCM;EACE,qBlChaG;AH24nCX;AqCv+mCM;EACI,clClaC;EkCmaD,wBAAA;ArCy+mCV;AqCx+mCU;EACI,yBAAA;EACA,4BlC5kBJ;EkC6kBI,6BAAA;EjCtgBZ,yBiCugBgC;ArC4+mClC;;AqCt+mCE;EACI,sBlCljBE;EkCmjBF,SAAA;ArCy+mCN;AqCx+mCM;EACI,yBlCxlBA;EkCylBA,qBlCzlBA;EkC0lBA,WlCvjBF;AHiioCR;;AqCp+mCM;EACI,yBAAA;EACA,clClmBA;AHykoCV;AqCl+mCU;EACI,uBAAA;ArCo+mCd;AqCn+mCc;EACI,yBlC1mBR;EC2GR,gBiCggBiC;ArCq+mCnC;AqCn+mCc;EACI,yBlC9mBR;EkC+mBQ,6BAAA;EjCpgBhB,gBiCqgBiC;ArCq+mCnC;AqC99mCU;EACI,uBAAA;ArCg+mCd;AqC/9mCc;EACI,4BlC1nBR;EkC2nBQ,uBAAA;EjChhBhB,gBiCihBiC;ArCi+mCnC;AqC59mCE;EACI,sBlC/lBE;EkCgmBF,SAAA;ArC89mCN;AqC19mCkB;EACI,yBlCxoBZ;EkCyoBY,qBlCzoBZ;EkC0oBY,WlCvmBd;ECwEN,mBiCgiBqC;ArC49mCvC;AqCr9mCc;EACI,yBlCnpBR;EkCopBQ,qBlCppBR;EkCqpBQ,WlClnBV;ECwEN,gBiC2iBiC;ArCu9mCnC;;AqCh9mCE;EACI,clC9pBI;AHinoCV;;AqC78mCU;EACI,elCvQC;AHutnCf;;AqC18mCE;EACI,gBAAA;EACA,mBAAA;ArC68mCN;AqC58mCM;EACI,clC7qBE;ECkFT,iBiC4lBqC;EAC9B,elCnRK;EkCoRL,gBlC1rBS;EkC2rBT,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EAAA,mDAAA;ArC88mCV;AqC58mCU;EACI,yBAAA;ArC88mCd;AqC58mCU;EACI,yBAAA;ArC88mCd;AqC58mCU;EACI,SAAA;EACA,gCAAA;EACA,mBlClsBJ;EkCmsBI,WlChqBN;AH8moCR;;AqCx8mCE;EACI,gBAAA;EjCvnBH,gBiCwnB2B;ArC28mC9B;AqC18mCM;EACI,WlCzqBF;EkC0qBE,elC9tBO;EkC+tBP,gBlCvtBS;EkCwtBT,SAAA;EACA,mBlC9iBC;EkC+iBD,kBAAA;EjC9nBP,iBiC+nBqC;EjCxmBtC,kBiCymByB;EjC7oBzB,yBiC8oB4B;ArC88mC9B;AqC78mCU;EACI,mBlCvtBJ;EkCwtBI,WlCrrBN;AHoooCR;;AI9ooCI;EiCqsBF;IACI,gBAAA;IACA,kBAAA;IACA,sBlC9rBE;ICiDL,ciC8oBiC;IjCvnBlC,kBiCwnBqB;ErC68mCrB;AACF;AsCrsoCA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WnCmDM;EmClDN,UAAA;AtCusoCF;AsCtsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;AtCwsoCJ;AsCtsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCWK;EmCVL,enC4ZW;EmC3ZX,cAAA;EACA,sBAAA;EACA,4BAAA;AtCwsoCJ;AsCvsoCI;EAEE,kBAAA;EACA,WAAA;AtCwsoCN;AsCtsoCI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBnCJG;AH4soCT;AsCtsoCI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBnCZG;AHotoCT;;AsCpsoCA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WnCIM;EmCHN,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AtCusoCF;AsCtsoCE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AtCwsoCJ;AsCtsoCE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AtCwsoCJ;AsCtsoCE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,WnCtBI;EmCuBJ,yCAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AtCwsoCJ;;AsCrsoCA;EACE,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;AtCwsoCF;AsCvsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;AtCysoCJ;AsCvsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCxEK;EmCyEL,enCyUW;EmCxUX,cAAA;EACA,sBAAA;EACA,4BAAA;AtCysoCJ;AsCxsoCI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBnCrFG;AH+xoCT;AsCxsoCI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBnC9FG;AHwyoCT;;AsCtsoCA;EACE,WnC1EM;EmC2EN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AtCysoCF;;AsCtsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCysoCJ;;AsCrsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCwsoCJ;;AsCpsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtCusoCJ;;AsCnsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCssoCJ;;AsClsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCqsoCJ;;AsCjsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCosoCJ;;AsChsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCmsoCJ;;AsC/roCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCksoCJ;;AsC9roCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCisoCJ;;AsC9roCA;EACE,WnChNM;EmCiNN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AtCisoCF;;AsC9roCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCisoCJ;;AsC7roCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCgsoCJ;;AsC5roCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtC+roCJ;;AsC3roCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC8roCJ;;AsC1roCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC6roCJ;;AsCzroCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC4roCJ;;AsCxroCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC2roCJ;;AsCvroCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC0roCJ;;AsCtroCE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCyroCJ;;AsCtroCA;EACE,WnCtVM;EmCuVN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;EACA,enCsCa;AHmpoCf;AsCxroCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtC0roCJ;;AsCvroCA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AtC0roCF;AsCzroCE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,WnCpXI;EmCqXJ,iCAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;AtC2roCJ;;AsCxroCA;EACE,uBAAA;EACA,wBAAA;AtC2roCF;AsC1roCE;EACE,sBAAA;EACA,sBAAA;EACA,yBAAA;AtC4roCJ;AsC3roCI;EACE,wBAAA;EACA,wBAAA;EACA,yBAAA;AtC6roCN;;AsCzroCA;EACE,qBAAA;EACA,wBAAA;AtC4roCF;AsC3roCE;EACE,sBAAA;EACA,oBAAA;EACA,wBAAA;AtC6roCJ;AsC5roCI;EACE,yBAAA;EACA,sBAAA;EACA,yBAAA;AtC8roCN;;AsC1roCA;EACE,uBAAA;EACA,sBAAA;AtC6roCF;AsC5roCE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AtC8roCJ;AsC7roCI;EACE,yBAAA;EACA,wBAAA;EACA,uBAAA;AtC+roCN;;AsC3roCA;EACE,qBAAA;EACA,sBAAA;AtC8roCF;AsC7roCE;EACE,wBAAA;EACA,oBAAA;EACA,yBAAA;AtC+roCJ;AsC9roCI;EACE,wBAAA;EACA,sBAAA;EACA,uBAAA;AtCgsoCN;;AsC5roCA;EACE,wBAAA;EACA,yBAAA;AtC+roCF;AsC9roCE;EACE,qCAAA;EACA,sCAAA;EACA,qBAAA;EACA,qBAAA;AtCgsoCJ;AsC9roCE;EACE,qCAAA;EACA,sCAAA;EACA,oBAAA;EACA,sBAAA;AtCgsoCJ;AsC9roCE;EACE,qBAAA;EACA,uBAAA;EACA,yBAAA;AtCgsoCJ;;AsC7roCA;EACE,wBAAA;EACA,uBAAA;AtCgsoCF;AsC/roCE;EACE,qCAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;AtCisoCJ;AsC/roCE;EACE,qCAAA;EACA,oCAAA;EACA,oBAAA;EACA,wBAAA;AtCisoCJ;AsC/roCE;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;AtCisoCJ;;AsC9roCA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WnCjeM;AHkqpCR;AsChsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCksoCJ;AsChsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC3gBM;EmC4gBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;AtCksoCJ;AsCjsoCI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnCrhBI;EmCshBJ,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;AtCmsoCN;AsCjsoCI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBnCtiBI;AHyupCV;AsChsoCE;EACE,WnC/gBI;EmCghBJ,enCrJW;EmCsJX,yBAAA;EACA,uBAAA;AtCksoCJ;;AsC/roCA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WnCzhBM;AH2tpCR;AsCjsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCmsoCJ;AsCjsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCjkBK;EmCkkBL,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;AtCmsoCJ;AsClsoCI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnC3kBG;EmC4kBH,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;AtCosoCN;AsClsoCI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBnC5lBG;AHgypCT;AsCjsoCE;EACE,WnCvkBI;EmCwkBJ,enC7MW;EmC8MX,yBAAA;EACA,uBAAA;AtCmsoCJ;;AsChsoCA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WnCjlBM;AHoxpCR;AsClsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCosoCJ;AsClsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC/nBM;EmCgoBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;AtCosoCJ;AsCnsoCI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnCzoBI;EmC0oBJ,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;AtCqsoCN;AsCnsoCI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBnC1pBI;AH+1pCV;AsClsoCE;EACE,WnC/nBI;EmCgoBJ,enCrQW;EmCsQX,yBAAA;EACA,uBAAA;AtCosoCJ;;AsCjsoCA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WnCzoBM;AH60pCR;AsCnsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCqsoCJ;AsCnsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCrrBG;EmCsrBH,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;AtCqsoCJ;AsCpsoCI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnC/rBC;EmCgsBD,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;AtCssoCN;AsCpsoCI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBnChtBC;AHs5pCP;AsCnsoCE;EACE,WnCvrBI;EmCwrBJ,enC7TW;EmC8TX,yBAAA;EACA,uBAAA;AtCqsoCJ;;AsClsoCA;EACE,kBAAA;EACA,wBAAA;EACA,WnChsBM;AHq4pCR;AsCpsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,wCAAA;AtCssoCJ;AsCpsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC/uBM;EmCgvBN,eAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;AtCssoCJ;AsCpsoCE;EACE,WnCvtBI;EmCwtBJ,enC7VW;EmC8VX,yBAAA;EACA,uBAAA;AtCssoCJ;;AsCnsoCA;EACE,kBAAA;EACA,wBAAA;EACA,WnChuBM;EmCiuBN,WAAA;AtCssoCF;AsCrsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;AtCusoCJ;AsCrsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC1wBK;EmC2wBL,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AtCusoCJ;AsCrsoCE;EACE,WnCxvBI;EmCyvBJ,enC9XW;EmC+XX,yBAAA;EACA,uBAAA;AtCusoCJ;;AsCpsoCA;EACE,kBAAA;EACA,sBAAA;EACA,WnCjwBM;EmCkwBN,WAAA;AtCusoCF;AsCtsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;AtCwsoCJ;AsCtsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCnzBQ;EmCozBR,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AtCwsoCJ;AsCtsoCE;EACE,WnCzxBI;EmC0xBJ,enC/ZW;EmCgaX,yBAAA;EACA,uBAAA;AtCwsoCJ;;AsCrsoCA;EACE,kBAAA;EACA,uBAAA;EACA,WnClyBM;AH0+pCR;AsCvsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;AtCysoCJ;AsCvsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCl1BM;EmCm1BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AtCysoCJ;AsCvsoCE;EACE,WnC1zBI;EmC2zBJ,enChcW;EmCicX,yBAAA;EACA,uBAAA;AtCysoCJ;;AsCtsoCA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WnCp0BM;AH6gqCR;AsCxsoCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;AtC0soCJ;AsCxsoCE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCx3BM;EmCy3BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AtC0soCJ;AsCxsoCE;EACE,WnC51BI;EmC61BJ,enCleW;EmCmeX,yBAAA;EACA,uBAAA;AtC0soCJ;;AsCrsoCI;EACE,kBAAA;EACA,WAAA;AtCwsoCN;;AsCpsoCA;EACE,WnC32BM;EmC42BN,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,enClfa;AHyrpCf;AsCtsoCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCwsoCJ;;AsCrsoCA;EACE,gBAAA;AtCwsoCF;;AsCrsoCE;EACE,WnCl4BI;EmCm4BJ,yBnCt6BM;EmCu6BN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCwsoCJ;AsCvsoCI;EACE,kBAAA;AtCysoCN;AsCxsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtC0soCR;AsCxsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtC0soCR;AsCxsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iDAAA;EACA,iCnCp8BE;EmCq8BF,gCnCr8BE;EmCs8BF,+BnCt8BE;EmCu8BF,sCAAA;EACA,yBAAA;AtC0soCR;AsCxsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnC/8BE;EmCg9BF,oCAAA;EACA,+BnCj9BE;EmCk9BF,kCnCl9BE;EmCm9BF,uBAAA;AtC0soCR;;AsCpsoCE;EACE,WnCv7BI;EmCw7BJ,yBnCz9BQ;EmC09BR,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCusoCJ;AsCtsoCI;EACE,kBAAA;AtCwsoCN;AsCvsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtCysoCR;AsCvsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtCysoCR;AsCvsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCt/BI;EmCu/BJ,gCnCv/BI;EmCw/BJ,+BnCx/BI;EmCy/BJ,sCAAA;EACA,yBAAA;AtCysoCR;AsCvsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCjgCI;EmCkgCJ,oCAAA;EACA,+BnCngCI;EmCogCJ,kCnCpgCI;EmCqgCJ,uBAAA;AtCysoCR;;AsCnsoCE;EACE,WnC3+BI;EmC4+BJ,yBnCvgCM;EmCwgCN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCssoCJ;AsCrsoCI;EACE,kBAAA;AtCusoCN;AsCtsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtCwsoCR;AsCtsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtCwsoCR;AsCtsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCpiCE;EmCqiCF,gCnCriCE;EmCsiCF,+BnCtiCE;EmCuiCF,sCAAA;EACA,yBAAA;AtCwsoCR;AsCtsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;AtCwsoCR;;AsClsoCE;EACE,WnChiCI;EmCiiCJ,yBnC1jCK;EmC2jCL,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCqsoCJ;AsCpsoCI;EACE,kBAAA;AtCssoCN;AsCrsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtCusoCR;AsCrsoCM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtCusoCR;AsCrsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCvlCC;EmCwlCD,oCAAA;EACA,+BnCzlCC;EmC0lCD,kCnC1lCC;EmC2lCD,uBAAA;AtCusoCR;AsCrsoCM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,gCAAA;EACA,yBAAA;EACA,uBAAA;AtCusoCR;;AsChsoCI;EACE,WAAA;EACA,YAAA;AtCmsoCN;;AsC9roCE;EACE,aAAA;AtCisoCJ;;AsC7roCE;EACE,WAAA;EACA,YAAA;AtCgsoCJ;;AsC5roCE;EACE,WAAA;EACA,YAAA;AtC+roCJ;;AsC3roCE;EACE,WAAA;EACA,YAAA;AtC8roCJ;;AsC1roCE;EACE,WAAA;EACA,YAAA;AtC6roCJ;;AsCzroCE;EACE,cnCn9BS;EmCo9BT,mBnC59BS;AHwpqCb;;AsCxroCE;EACE,mBnC3+BU;EmC4+BV,cnCr+BU;AHgqqCd;;AsCxroCA;EACE;IACE,8BAAA;EtC2roCF;AACF;AsCxroCE;EACE,wBAAA;AtC0roCJ;AsCvroCE;EACE,yBAAA;AtCyroCJ;AsCtroCE;EACE,yBAAA;AtCwroCJ;AsCrroCE;EACE,wBAAA;AtCuroCJ;AsCproCE;EACE,yBAAA;AtCsroCJ;AsCnroCE;EACE,wBAAA;AtCqroCJ;AsClroCE;EACE,wBAAA;AtCoroCJ;AsCjroCE;EACE,yBAAA;AtCmroCJ;AsChroCE;EACE,wBAAA;AtCkroCJ;AsC/qoCE;EACE,yBAAA;AtCiroCJ;AsC9qoCE;EACE,yBAAA;AtCgroCJ;;AuCz5qCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;AvC45qCR;AuC35qCQ;EnCqHN,kBmCpH2B;EACjB,UAAA;EACA,mBAAA;EACA,cAAA;AvC65qCZ;AI93qCI;EmCnCI;IAMQ,UAAA;EvC+5qCd;AACF;AuC95qCY;EACI,yBAAA;EnC4Gd,mBmC3G+B;EACjB,cAAA;EACA,aAAA;EACA,kBAAA;AvCg6qChB;;AuCz5qCI;EACI,yBAAA;EACA,8DAAA;EACA,kBAAA;AvC45qCR;AuC15qCI;EACI,gBpCxBW;AHo7qCnB;AIn5qCI;EmCVA;IAGQ,epC4YG;EHkhqCb;AACF;AuC35qCE;EACC,YAAA;AvC65qCH;AuC15qCI;EACI,qBpCmII;EoClIJ,gCAAA;EACA,8BAAA;AvC45qCR;AuC35qCQ;;EAII,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cpC+JC;EoC9JD,UAAA;EACA,epC+WG;EoC9WH,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBpCvDO;EoCwDP,6BAAA;EnC2DV,mBmC1D2B;AvC65qC7B;AuC55qCY;;EACI,6BAAA;EACA,WpCjBR;AHg7qCR;AuC15qCQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cpCpEF;AHg+qCV;AuC35qCY;EACI,iBAAA;AvC65qChB;AuC35qCY;EACI,mBpCzEN;EoC0EM,WpCvCR;AHo8qCR;AuC55qCgB;EACI,+BAAA;AvC85qCpB;AuC15qCQ;EACI,mBpC/EA;AH2+qCZ;AuC35qCY;EnCqCV,sCAAA;EmCnCc,yBAAA;AvC+5qChB;AuC15qCI;EACI,SAAA;EACA,iBAAA;EACA,iBAAA;AvC45qCR;AuCz5qCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AvC25qCR;AuCz5qCI;EACI,iBAAA;AvC25qCR;AuCz5qCI;EACI,iBAAA;AvC25qCR;AuCz5qCI;EACI,oCAAA;AvC25qCR;AuCz5qCI;EACI,+CAAA;AvC25qCR;;AuCx5qCA;EACI,sBAAA;AvC25qCJ;;AuCz5qCA;EACI,4BAAA;AvC45qCJ;;AuCx5qCI;EACI,0BAAA;AvC25qCR;AuCx5qCQ;EACI,qBAAA;EACA,UAAA;EACA,oBAAA;AvC05qCZ;AuCx5qCQ;EACI,mBAAA;EACA,UAAA;AvC05qCZ;AuCt5qCQ;EACI,0BAAA;EACA,UAAA;EACA,sDAAA;AvCw5qCZ;AuCt5qCQ;EACI,wBAAA;EACA,UAAA;AvCw5qCZ;AuCp5qCQ;EACI,0BAAA;EACA,UAAA;EACA,oBAAA;AvCs5qCZ;AuCp5qCQ;EACI,wBAAA;EACA,UAAA;AvCs5qCZ;AuCl5qCQ;EACI,kCAAA;EACA,UAAA;AvCo5qCZ;AuCl5qCQ;EACI,oBAAA;AvCo5qCZ;AuCl5qCQ;EACI,gCAAA;EACA,UAAA;AvCo5qCZ;AuCj5qCI;EAGI,mBAAA;AvCm5qCR;AuCl5qCQ;EAEI,4BAAA;EACA,2CAAA;EACA,UAAA;AvCo5qCZ;AuCl5qCQ;EACI,4BAAA;EACA,wCAAA;EACA,UAAA;AvCo5qCZ;AuCj5qCI;EACI,mBAAA;AvCm5qCR;AuCl5qCQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;AvCo5qCZ;AuCl5qCQ;EACI,wBAAA;EACA,UAAA;AvCo5qCZ;AuCj5qCI;EACI,mBAAA;AvCm5qCR;AuCl5qCQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;AvCo5qCZ;AuCl5qCQ;EACI,wBAAA;EACA,UAAA;AvCo5qCZ;AuCh5qCQ;EACI,mBAAA;EACA,UAAA;EACA,oBAAA;AvCk5qCZ;AuCh5qCQ;EACI,mBAAA;EACA,UAAA;AvCk5qCZ;AuC/4qCI;EACI,mBAAA;AvCi5qCR;AuCh5qCQ;EAEI,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;AvCk5qCZ;AuCh5qCQ;EACI,wBAAA;EACA,UAAA;AvCk5qCZ;AuC/4qCI;EACI,mBAAA;AvCi5qCR;AuCh5qCQ;EAEI,4BAAA;EACA,0CAAA;EACA,wBAAA;EACA,UAAA;EACA,6BAAA;AvCk5qCZ;AuCh5qCQ;EACI,uCAAA;EACA,UAAA;AvCk5qCZ;AuC/4qCI;EACI,mBAAA;AvCi5qCR;AuCh5qCQ;EAEI,4BAAA;EACA,4DAAA;EACA,wBAAA;EACA,UAAA;EACA,oBAAA;AvCk5qCZ;AuCh5qCQ;EACI,uDAAA;EACA,UAAA;AvCk5qCZ;;AuC94qCA;EACI,uBAAA;AvCi5qCJ;;AuC/4qCA;EACI,wBAAA;AvCk5qCJ;;AuCh5qCA;EACI,wBAAA;AvCm5qCJ;;AuCh5qCI;EACI,WAAA;EAAA,cAAA;AvCm5qCR;AuCl5qCQ;EACI,cpCjCC;EoCkCD,epCwHG;EoCvHH,gBpChTS;AHosrCrB;AuCl5qCQ;EACI,WAAA;EACA,YAAA;AvCo5qCZ;AuCn5qCY;EACI,UAAA;EACA,WAAA;AvCq5qChB;AuC/4qCoB;EACI,QAAA;EACA,UAAA;EACA,WAAA;AvCi5qCxB;AuC14qCI;EACI,cAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AvC44qCR;AuC34qCQ;EACI,UAAA;EACA,6CAAA;EACC,QAAA;EACD,WAAA;EACA,YAAA;AvC64qCZ;AuC34qCQ;EACI,mBAAA;AvC64qCZ;AuC14qCG;EACK,mBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AvC44qCR;AuC34qCQ;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAGA,yBAAA;EACA,+BAAA;EACA,uCAAA;EACA,mCAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,kBAAA;AvC64qCZ;;AuCx4qCI;EnC3RD,kBmC4R6B;EnC3R7B,iBmC2RyC;AvC44qC5C;AuC34qCQ;EACI,eAAA;AvC64qCZ;;AuCv4qCQ;EnCpSL,SmCqSiC;EnCpSjC,UmCoSoC;EAC3B,gBpCtVJ;EoCuVI,yBAAA;EACA,kBAAA;EACA,cpCxND;EoCyNC,gBpCxYS;EoCyYT,epC8BG;EoC7BH,6DAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EAIA,oBAAA;AvC24qCZ;AuC14qCY;EACI,yBAAA;EACA,mBpC9YN;EoC+YM,WpC5WR;EoCgXQ,oBAAA;EAGA,0BAAA;AvC44qChB;;AwCtzrCA;EACE,oBAAA;AxCyzrCF;AwCxzrCE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;AxC0zrCJ;;AwCvzrCA;EACE,oBAAA;AxC0zrCF;;AwCxzrCA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AxC2zrCF;;AwCzzrCA;EACE,iBAAA;EACA,aAAA;EACA,WrCmCM;AHyxrCR;;AwC1zrCA;EACE,gBAAA;AxC6zrCF;;ACryrCA,qBAAA;AwChDA;EACC,oCtCeqB;EsCdrB,etC8ac;EsC7ad,ctCmRY;EsClRZ,gBAAA;EACA,yBtCoRS;EsCnRT,gBAAA;EACA,kBAAA;AzCy1rCD;;AyCv1rCA;EACC,oCtCMqB;AHo1rCtB;;AyCx1rCA;EACE,mBtCOQ;EsCNR,WtCyCM;EsCxCN,iBAAA;AzC21rCF;;AyCz1rCA;EACC,eAAA;EACA,YAAA;EACA,uBAAA;AzC41rCD;;AyC11rCA;EACC,aAAA;AzC61rCD;;AyC31rCA;ErCkEE,yBqCjEmB;AzCg2rCrB;AyC/1rCC;EACC,2BAAA;AzCi2rCF;;AyC91rCA;EACC,mBAAA;AzCi2rCD;AyCh2rCC;EACC,gBAAA;AzCk2rCF;;AyC/1rCA;EACC,gBtC1BkB;AH43rCnB;;AyCh2rCA;EACG,ctC8OW;EsC7OX,oCtC1BmB;EsC2BrB,gBtC/BkB;EsCgChB,gBAAA;AzCm2rCH;;AyCj2rCA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AzCo2rCF;;AyCl2rCA;EACE,gBAAA;AzCq2rCF;AyCp2rCC;EACE,gBAAA;EACA,kBAAA;AzCs2rCH;AyCr2rCG;EACE,uBAAA;AzCu2rCL;AyCp2rCC;EACE,mBAAA;EACA,kBAAA;AzCs2rCH;AyCr2rCG;EACE,wBAAA;AzCu2rCL;AyCp2rCC;EACE,gBAAA;EACA,eAAA;AzCs2rCH;AyCr2rCG;EACE,sBAAA;EACA,qBAAA;AzCu2rCL;AyCt2rCK;;;EAGE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AzCw2rCP;AyCr2rCK;EACE,etC4VQ;EsC3VR,QAAA;AzCu2rCP;AyC91rCe;EACI,gBAAA;AzCg2rCnB;;A0Cn8rCA;EACI,oCAAA;A1Cs8rCJ;;A0Cp8rCA;EACI,oCAAA;A1Cu8rCJ;;A0Cr8rCA;EACI,oCAAA;A1Cw8rCJ;;A0Ct8rCA;EACI,oCAAA;EACA,sBAAA;A1Cy8rCJ;;A0Cv8rCA;EACI,oCAAA;EACA,sBAAA;A1C08rCJ;;A0Cx8rCA;EACI,oCAAA;EACA,sBAAA;A1C28rCJ;;A0Cz8rCA;EACI,oCAAA;A1C48rCJ;;A0C18rCA;EACI,oCAAA;A1C68rCJ;;A0C38rCA;EACI,oCAAA;A1C88rCJ;;A0C58rCA;EACI,mBvC8IQ;AHi0rCZ;;A0C78rCA;EACI,oCAAA;A1Cg9rCJ;;A0C98rCA;EACI,iCAAA;A1Ci9rCJ;;A0C/8rCA;EACI,oCAAA;A1Ck9rCJ;;A0Ch9rCA;EACI,oCAAA;A1Cm9rCJ;;A0Cj9rCA;EACI,oCAAA;A1Co9rCJ;;A0Cl9rCA;EACI,oCAAA;A1Cq9rCJ;;A0Cn9rCA;EACI,oCAAA;A1Cs9rCJ;;A0Cp9rCA;EACI,oCAAA;A1Cu9rCJ;;A0Cr9rCA;EACI,oCAAA;A1Cw9rCJ;;A0Ct9rCA;EACI,mBvCsOW;AHmvrCf;;A0Cv9rCA;EACI,oCAAA;A1C09rCJ;;A0Cx9rCA;EACI,oCAAA;A1C29rCJ;;A0Cz9rCA;EACI,oCAAA;A1C49rCJ;;A0C19rCA;EACI,oCAAA;A1C69rCJ;;A0C39rCA;EACI,oCAAA;A1C89rCJ;;A0C59rCA;EACI,oCAAA;A1C+9rCJ;A0C99rCI;EACI,mDAAA;A1Cg+rCR;A0C99rCI;EACI,oDAAA;A1Cg+rCR;A0C99rCI;EACI,mDAAA;A1Cg+rCR;A0C99rCI;EACI,oDAAA;A1Cg+rCR;A0C99rCI;EACI,oCAAA;A1Cg+rCR;;A0C79rCA;EACI,oCAAA;A1Cg+rCJ;A0C/9rCI;EACI,mDAAA;A1Ci+rCR;A0C/9rCI;EACI,oDAAA;A1Ci+rCR;A0C/9rCI;EACI,mDAAA;A1Ci+rCR;A0C/9rCI;EACI,oDAAA;A1Ci+rCR;A0C/9rCI;EACI,oCAAA;A1Ci+rCR;;A0C99rCA;EACI,oCAAA;A1Ci+rCJ;A0Ch+rCI;EACI,oDAAA;A1Ck+rCR;A0Ch+rCI;EACI,qDAAA;A1Ck+rCR;A0Ch+rCI;EACI,oDAAA;A1Ck+rCR;A0Ch+rCI;EACI,qDAAA;A1Ck+rCR;A0Ch+rCI;EACI,oCAAA;A1Ck+rCR;;A0C/9rCA;EACI,oCAAA;A1Ck+rCJ;A0Cj+rCI;EACI,mDAAA;A1Cm+rCR;A0Cj+rCI;EACI,oDAAA;A1Cm+rCR;A0Cj+rCI;EACI,mDAAA;A1Cm+rCR;A0Cj+rCI;EACI,oDAAA;A1Cm+rCR;A0Cj+rCI;EACI,oCAAA;A1Cm+rCR;;A0Ch+rCA;EACI,oCAAA;A1Cm+rCJ;A0Cl+rCI;EACI,mDAAA;A1Co+rCR;A0Cl+rCI;EACI,oDAAA;A1Co+rCR;A0Cl+rCI;EACI,mDAAA;A1Co+rCR;A0Cl+rCI;EACI,oDAAA;A1Co+rCR;A0Cl+rCI;EACI,oCAAA;A1Co+rCR;;A0Cj+rCA;EACI,oCAAA;A1Co+rCJ;A0Cn+rCI;EACI,kDAAA;A1Cq+rCR;A0Cn+rCI;EACI,mDAAA;A1Cq+rCR;A0Cn+rCI;EACI,kDAAA;A1Cq+rCR;A0Cn+rCI;EACI,mDAAA;A1Cq+rCR;A0Cn+rCI;EACI,oCAAA;A1Cq+rCR;;A0Cl+rCA;EACI,oCAAA;A1Cq+rCJ;A0Cp+rCI;EACI,kDAAA;A1Cs+rCR;A0Cp+rCI;EACI,mDAAA;A1Cs+rCR;A0Cp+rCI;EACI,kDAAA;A1Cs+rCR;A0Cp+rCI;EACI,mDAAA;A1Cs+rCR;A0Cp+rCI;EACI,oCAAA;A1Cs+rCR;;A0Cn+rCA;EACI,oCAAA;A1Cs+rCJ;A0Cr+rCI;EACI,qDAAA;A1Cu+rCR;A0Cr+rCI;EACI,sDAAA;A1Cu+rCR;A0Cr+rCI;EACI,qDAAA;A1Cu+rCR;A0Cr+rCI;EACI,sDAAA;A1Cu+rCR;A0Cr+rCI;EACI,oCAAA;A1Cu+rCR;;A0Cl+rCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AHipsCR;;A0Cx+rCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AHupsCR;;A0C9+rCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AH6psCR;;A0Cp/rCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AHmqsCR;;A0C1/rCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AHyqsCR;;A0ChgsCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AH+qsCR;;A0CtgsCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AHqrsCR;;A0C5gsCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AH2rsCR;;A0ClhsCI;EACI,iCAAA;EACA,iCAAA;EACA,WvC5KA;AHissCR;;A0CxhsCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AHussCR;;A0C9hsCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AH6ssCR;;A0CpisCI;EACI,oCAAA;EACA,oCAAA;EACA,WvC5KA;AHmtsCR;;A0CpisCA;EACI,yBvC9JU;EuC+JV,cvCpNM;AH2vsCV;;A0CrisCA;EACI,yBvCvJY;EuCwJZ,cvCtNQ;AH8vsCZ;;A0CtisCA;EACI,yBvClCU;EuCmCV,cvCxNM;AHiwsCV;;A0CvisCA;EACI,yBvC3BS;EuC4BT,cvCtNK;AHgwsCT;;A0CxisCA;EACI,yBvCpBU;EuCqBV,cvC5NM;AHuwsCV;;A0CzisCA;EACI,yCAAA;EACA,cvClOG;AH8wsCP;;A0C1isCA;EACI,0CAAA;EACA,cvCsBS;AHuhsCb;;A0C3isCA;EACI,uCAAA;EACA,WvC7MI;AH2vsCR;;A0C5isCA;EACE,cvCeW;AHgisCb;;A0C5isCA;EACE,0EAAA;EACA,WvCrNM;AHowsCR;;A0C7isCA;EACE,0EAAA;EACA,WvCzNM;AHywsCR;;A0C9isCA;EACE,0EAAA;EACA,WvC7NM;AH8wsCR;;A0C/isCA;EACE,0EAAA;EACA,WvCjOM;AHmxsCR;;A0ChjsCA;EACE,0EAAA;EACA,WvCrOM;AHwxsCR;;A0CjjsCA;EACE,0EAAA;EACA,WvCzOM;AH6xsCR;;A0CljsCA;EACE,0EAAA;EACA,WvC7OM;AHkysCR;;A0CnjsCA;EACE,0EAAA;EACA,WvCjPM;AHuysCR;;A0CpjsCA;EACE,0EAAA;EACA,WvCrPM;AH4ysCR;;A0CrjsCA;EACE,0EAAA;EACA,WvCxPM;AHgzsCR;;A0CtjsCA;EACE,0EAAA;EACA,WvC7PM;AHszsCR;;A0CvjsCA;EACE,sBvChQM;EuCiQN,yBAAA;EACA,cvCrSQ;AH+1sCV;;A0CxjsCA;EACE,sBvCrQM;EuCsQN,yBAAA;EACA,cvCxSU;AHm2sCZ;;A0CzjsCA;EACE,sBvC1QM;EuC2QN,yBAAA;EACA,cvCvSQ;AHm2sCV;;A0C1jsCA;EACE,sBvC/QM;EuCgRN,yBAAA;EACA,cvC9SK;AH22sCP;;A0C3jsCA;EACE,sBvCpRM;EuCqRN,yBAAA;EACA,cvCrTQ;AHm3sCV;;A0C5jsCA;EACE,sBvCzRM;EuC0RN,yBAAA;EACA,cvCpTO;AHm3sCT;;A0C7jsCA;EACE,sBvC9RM;EuC+RN,yBAAA;EACA,cvCvTK;AHu3sCP;;A0C9jsCA;EACE,sBvCnSM;EuCoSN,oCAAA;EACA,sBAAA;A1CiksCF;;A0C/jsCA;EACI,mDAAA;EACA,yBAAA;A1CkksCJ;A0CjksCI;EACI,mDAAA;EACA,yBAAA;A1CmksCR;;A0ChksCA;EACI,mDAAA;EACA,yBAAA;A1CmksCJ;A0ClksCI;EACI,mDAAA;EACA,yBAAA;A1CoksCR;;A0CjksCA;EACI,oDAAA;EACA,yBAAA;A1CoksCJ;A0CnksCI;EACI,oDAAA;EACA,yBAAA;A1CqksCR;;A0ClksCA;EACI,mDAAA;EACA,yBAAA;A1CqksCJ;A0CpksCI;EACI,mDAAA;EACA,yBAAA;A1CsksCR;;A0CnksCA;EACI,mDAAA;EACA,yBAAA;A1CsksCJ;A0CrksCI;EACI,mDAAA;EACA,yBAAA;A1CuksCR;;A0CpksCA;EACI,kDAAA;EACA,yBAAA;A1CuksCJ;A0CtksCI;EACI,kDAAA;EACA,yBAAA;A1CwksCR;;A0CrksCA;EACI,qDAAA;EACA,yBAAA;A1CwksCJ;A0CvksCI;EACI,qDAAA;EACA,yBAAA;A1CyksCR;;A0CtksCA;EACI,yBvClOO;AH2ysCX;;A0CvksCA;EACI,yBvCpOO;AH8ysCX;;A0CxksCA;EACI,yBvCtOO;AHizsCX;;A0CzksCA;EACI,yBvCxOO;AHozsCX;;A0C1ksCA;EACI,yBvC1OO;AHuzsCX;;A0C3ksCA;EACI,yBvC5OO;AH0zsCX;;A0C5ksCA;EACI,yBvC9OO;AH6zsCX;;A0C7ksCA;EACI,yBvChPO;AHg0sCX;;A0C9ksCA;EACI,yBvClPO;AHm0sCX;;A0C/ksCA;EACI,avC9ZM;AHg/sCV;;A0ChlsCA;EACI,avC/ZQ;AHk/sCZ;;A0CjlsCA;EACI,avChaM;AHo/sCV;;A0CllsCA;EACI,avC7ZK;AHk/sCT;;A0CnlsCA;EACI,avClaM;AHw/sCV;;A0CplsCA;EACI,UvC1YI;AHi+sCR;;A0CrlsCA;EACI,UvC5YI;AHo+sCR;;A0CtlsCA;EACI,avC7YG;AHs+sCP;;A0CvlsCA;EACI,avC1YK;AHo+sCT;;A0CxlsCA;EACI,avCpZK;AH++sCT;;A0CzlsCA;EACI,avCxKK;AHowsCT;;A0C1lsCA;EACI,avCzbG;AHshtCP;;A0C3lsCA;EACI,avClZK;AHg/sCT;;A0C5lsCA;EACE,avCpaM;AHmgtCR;;A0C7lsCA;EACE,avC5bK;AH4htCP;;A0C9lsCA;EACE,avCnaK;AHogtCP;;A0C/lsCA;EACE,avC5MW;AH8ysCb;;A0ChmsCA;EACE,WAAA;EACA,YAAA;EACA,kBvC3Ec;EuC4Ed,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;A1CmmsCF;;A0CjmsCA;EACE,uBAAA;EACA,kBvCnFc;EuCoFd,8DvC3EW;AH+qsCb;;A0ClmsCA;EACI,WAAA;EACA,YAAA;EACA,kBvCzFY;EuC0FZ,qBAAA;EACA,sBAAA;A1CqmsCJ;;A0CnmsCA;EACI,8BAAA;EACA,gCAAA;A1CsmsCJ;;A0CpmsCA;EACI,cvCrcK;AH4itCT;;A0CrmsCA;EACI,mBvCtVQ;AH87sCZ;;A0CtmsCA;EACI,mBvC1VQ;AHm8sCZ;;A0CvmsCA;EACI,mBvCjTS;AH25sCb;;A0CxmsCA;EACI,8BAAA;EACA,sBAAA;A1C2msCJ;;A0CzmsCA;EACI,8BAAA;A1C4msCJ;;A0C1msCA;EACI,mBvCjdK;AH8jtCT;;A0C3msCA;EACI,yBAAA;A1C8msCJ;;A0C5msCA;EACI,yBAAA;A1C+msCJ;;ACjltCA,qBAAA;A0CrDA;EACI,mBAAA;A3C0otCJ;A2CxotCI;EACI,gBxCOe;EwCNf,mBAAA;A3C0otCR;AIlmtCI;EuC1CA;IAKQ,exC2aG;EHgusCb;AACF;AIvmtCI;EuC1CA;IASQ,mBAAA;E3C4otCV;AACF;A2C1otCQ;EACI,mBAAA;EACA,kBAAA;EvCsFT,iBuCrFiC;EvCsFjC,YuCtF4C;EACnC,cxC6CH;EwC5CG,exC0ZG;EwCzZH,gBxCVW;AHuptCvB;AIrntCI;EuCpBA;IAEQ,aAAA;E3C2otCV;AACF;A2CxotCI;EACI,mBAAA;A3C0otCR;AI7ntCI;EuCdA;IAIQ,aAAA;E3C2otCV;AACF;A2CzotCQ;EACI,WAAA;EACA,YAAA;EACA,gBxCcJ;EwCbI,cxCmJD;EwChJC,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;A3C2otCZ;A2CzotCY;EAEI,mBxCKR;EwCJQ,WxCJR;AH8otCR;A2CvotCY;EACI,eAAA;A3CyotChB;AI3ptCI;EuCPI;IA6BQ,4BAAA;E3CyotCd;E2CvotCc;IACI,0BAAA;E3CyotClB;AACF;A2CpotCI;EACI,aAAA;A3CsotCR;;A2ClotCA;EACI,mBAAA;EACA,kBAAA;EvCoBD,iBuCnByB;EvCoBzB,YuCpBoC;EACnC,cxCrBK;EwCsBL,exCwVW;EwCvVX,gBxC5EmB;AHkttCvB;;A2ClotCI;EACI,cxCsFI;AH+itCZ;A2CnotCQ;EACI,cxC/BH;AHoqtCT;;A2C9ntCQ;EACI,cxCvCH;AHwqtCT;;A2C5ntCA;EACI,kBAAA;A3C+ntCJ;A2C7ntCI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cxCyEG;AHsjtCX;A2C5ntCI;EvCfD,0BuCgBmC;A3C8ntCtC;A2C5ntCQ;EvClBL,0BuCmBuC;A3C8ntC1C;;A2CzntCA;EACI,kBAAA;A3C4ntCJ;A2C1ntCI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,cxCqDG;AHuktCX;A2CzntCI;EvCnCD,0BuCoCmC;A3C2ntCtC;;A2CvntCA;EACI,yBAAA;EACA,kBAAA;EvC1CD,YuC2C+B;EAG9B,oBAAA;EAGA,mBAAA;A3C0ntCJ;A2CxntCI;EACI,WAAA;EACA,YAAA;EACA,gBxCvGA;EwCwGA,cxC8BG;EwC3BH,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3C0ntCR;A2CxntCQ;EACI,0BAAA;A3C0ntCZ;A2CvntCQ;EACI,0BAAA;A3CyntCZ;A2CtntCQ;EAEI,mBxCrHJ;EwCsHI,WxC9HJ;AHqvtCR;;A2ClntCA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A3CqntCJ;A2CnntCI;EACI,OAAA;A3CqntCR;;A2CjntCA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A3ContCJ;A2ClntCI;EACI,OAAA;A3ContCR;;A2ChntCA;EAGI,aAAA;EAGA,mBAAA;EACA,kBAAA;A3CmntCJ;A2CjntCI;EACI,0BAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;A3CmntCR;A2CjntCQ;EAGI,aAAA;A3CmntCZ;A2ChntCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CkntCZ;A2C/mtCQ;EACI,mBxC/NH;EwCgOG,WxCvMJ;EwCwMI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EvC5KV,kBuC6K4B;EvC5K5B,SuC4KsC;EvC3KtC,WuC2K4C;A3CmntC9C;A2C9mtCQ;EACI,mBAAA;A3CgntCZ;A2C5mtCI;EACI,mBxC3CK;EwC4CL,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;A3C8mtCR;A2C5mtCQ;EvCrLL,iBuCsLuC;EAC9B,eAAA;EACA,cxCvOH;EwCwOG,qBAAA;A3C8mtCZ;A2C5mtCY;EACI,kBAAA;A3C8mtChB;A2C1mtCQ;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3C4mtCZ;;A2CvmtCA;EACI,gBxC7PI;EwC8PJ,yBAAA;EACA,kBAAA;EACA,8DAAA;EACA,mBAAA;A3C0mtCJ;A2CxmtCI;EvClND,4BuCmNmC;EAC9B,gBxClTa;EwCqTb,aAAA;EAGA,mBAAA;EACA,kBAAA;A3C0mtCR;A2CxmtCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;A3C0mtCZ;A2CvmtCQ;EACI,cxCzJD;AHkwtCX;A2CtmtCQ;EACI,gBAAA;EACA,kCAAA;EvC5PV,kBuC6P4B;EvC5P5B,QuC4PsC;EvC3PtC,WuC2P2C;EvClS3C,2BuCmS6B;EvClS7B,mCuCkS6B;EvCjS7B,+BuCiS6B;EACnB,exCkFG;EwCjFH,gBxCpVW;AHg8tCvB;A2CxmtCY;EACI,gBAAA;A3C0mtChB;A2CvmtCY;EACI,mBxCpVN;EwCqVM,WxClTR;AH25tCR;A2CpmtCI;EACI,6BAAA;EvCxQL,qBuCyQ6B;EvCxQ7B,iBuCwQ4C;A3CumtC/C;A2CnmtCQ;EACI,mBAAA;A3CqmtCZ;A2CnmtCY;EACI,gBAAA;A3CqmtChB;AIh7tCI;EuC0UQ;IAIQ,mBAAA;E3CsmtClB;AACF;;A2C/ltCI;EACI,exC4CO;EwC3CP,gBxC1Xe;EwC2Xf,kBxCwBW;ECvThB,kBuCgS6B;EvC/R7B,iBuC+RyC;A3CmmtC5C;A2CjmtCQ;EACI,eAAA;A3CmmtCZ;;A2C7ltCI;EACI,oBAAA;A3CgmtCR;A2C7ltCI;EACI,kBAAA;A3C+ltCR;A2C7ltCQ;EACI,eAAA;A3C+ltCZ;;A2CzltCI;EACI,mBAAA;EACA,exCoBO;AHwktCf;A2CzltCI;EACI,gBAAA;EvC7TL,cuC8T6B;A3C2ltChC;A2CxltCI;EACI,exCSO;EwCRP,gBAAA;A3C0ltCR;AIv9tCI;EuC2XA;IAKQ,exCGG;EHwltCb;AACF;A2CxltCI;EACI,gBAAA;A3C0ltCR;;A2CtltCA;EACI,mBxCjOS;EwCkOT,cxC1ZK;EwC2ZL,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,exCNW;AH+ltCf;A2CvltCI;EACI,mBxC3NK;EwC4NL,cxC/YC;AHw+tCT;;A2CrltCA;EACI,kBAAA;EvCtWD,gBuCuWyB;EvCtWzB,auCsWmC;EAClC,8DxCzCY;AHkotChB;A2CvltCI;EvC1WD,euC2W6B;EvC1W7B,UuC0WsC;A3C0ltCzC;A2CvltCY;EACI,mBxC1SJ;AHm4tCZ;A2CrltCQ;EACI,WAAA;EACA,kBAAA;EvCpXT,YuCqXuC;EAC9B,uBAAA;A3CultCZ;A2CpltCgB;EACI,WAAA;EACA,UAAA;EAAA,aAAA;EACA,QAAA;EACA,2BAAA;A3CsltCpB;A2CnltCgB;EACI,mBxCrdV;EwCsdU,qBxCtdV;AH2iuCV;A2CjltCY;EAGI,aAAA;EAGA,mBAAA;A3CmltChB;A2CjltCgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3CmltCpB;A2ChltCgB;EACI,cxCxOP;EwCyOO,exC/EL;AHiqtCf;A2C7ktCQ;EACI,yBxCzVA;AHw6tCZ;A2C5ktCQ;EACI,gBAAA;A3C8ktCZ;;A2CvktCQ;EACI,gBAAA;EACA,sCAAA;A3C0ktCZ;;A2CrktCA;EACI;IvC9dF,yBuC+dyB;IvC9dzB,iCuC8dyB;IvC7dzB,6BuC6dyB;E3C0ktCzB;AACF;A2CvktCA;EACI,kBAAA;A3CyktCJ;A2CvktCI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;A3CyktCR;A2CtktCI;EACI,6BAAA;A3CwktCR;;A2CnktCI;EACI,aAAA;EACA,mBAAA;A3CsktCR;A2CnktCY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A3CqktChB;A2CnktCgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CqktCpB;A2ClktCgB;EACI,mBxCljBV;EwCmjBU,WxChhBZ;EwCihBY,exC5JL;AHgutCf;A2CjktCgB;EACI,kBAAA;A3CmktCpB;A2C9jtCgB;EACI,cAAA;A3CgktCpB;;A2CzjtCA;EACI,cxC5jBK;AHwnuCT;;A2CzjtCA;EACI,kBAAA;A3C4jtCJ;A2C1jtCI;EACI,kBAAA;A3C4jtCR;A2C1jtCQ;EACI,cxC9UC;EwC+UD,kBAAA;EACA,qBAAA;EvC/fT,mBuCggBiC;EvC/fjC,mBuC+f8C;A3C6jtCjD;A2C3jtCY;EACI,cxCpVH;AHi5tCb;A2C3jtCgB;EACI,cxCzlBV;EwC0lBU,iBAAA;A3C6jtCpB;A2C1jtCgB;EACI,cxC9lBV;AH0puCV;A2CxjtCY;EACI,eAAA;A3C0jtChB;A2CvjtCY;EACI,eAAA;A3CyjtChB;A2CvjtCgB;EACI,aAAA;A3CyjtCpB;A2CrjtCY;EACI,YAAA;EvCpiBd,kBuCqiBgC;EvCpiBhC,MuCoiB0C;EvCjiB1C,OuCiiByD;A3CyjtC3D;A2CtjtCY;EACI,iBAAA;A3CwjtChB;A2CtjtCgB;EACI,aAAA;A3CwjtCpB;A2CpjtCY;EAKI,WxC7lBR;AH+ouCR;A2CtjtCgB;EACI,WxC1lBZ;AHkpuCR;A2CnjtCgB;EACI,WxChmBZ;AHqpuCR;A2C/itCI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;A3CijtCR;A2C/itCQ;EvC/jBL,kBuCgkBiC;A3CijtCpC;A2C7itCY;EACI,qBAAA;EACA,iBAAA;A3C+itChB;A2C7itCgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBxC5nBZ;EwC6nBY,cxC7ZN;EwCgaM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3C+itCpB;A2C7itCoB;EACI,mBxC5qBd;EwC6qBc,WxC1oBhB;AHyruCR;A2C3itCgB;EACI,eAAA;A3C6itCpB;;A2CtitCA;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;A3CyitCJ;A2CvitCI;EACI,mBAAA;A3CyitCR;A2CvitCQ;EACI,eAAA;A3CyitCZ;A2CritCI;EvCvnBD,oBuCwnB6B;EvCvnB7B,gBuCunB2C;EACtC,exChTO;EwCiTP,gBxCxtBa;AHgwuCrB;A2CtitCQ;EACI,mBxCrjBA;EwCsjBA,cxC7iBD;AHqluCX;A2CritCQ;EACI,iBAAA;A3CuitCZ;A2CnitCI;EACI,mBAAA;A3CqitCR;A2CnitCQ;EACI,gBxCtuBW;EwCuuBX,WxC3rBJ;EwC4rBI,qBAAA;A3CqitCZ;A2CnitCY;EACI,qBAAA;EACA,kBAAA;EvC/oBb,iBuCgpB2C;EAC9B,WxClsBR;AHuuuCR;A2ChitCI;EACI,eAAA;EACA,cxCtqBQ;AHwsuChB;A2ChitCQ;EACI,aAAA;A3CkitCZ;A2C9htCI;EACI,kBAAA;EACA,iBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exC/VO;EwCgWP,gBxCvwBa;AHuyuCrB;A2C9htCQ;EACI,iBAAA;A3CgitCZ;A2C5htCI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBxCznBI;EwC0nBJ,yBAAA;EACA,cxChhBM;AH8iuCd;A2C5htCQ;EACI,mBxCtxBF;EwCuxBE,WxCpvBJ;AHkxuCR;A2C3htCQ;EACI,kBAAA;EACA,gBxCzvBJ;EwC0vBI,yBAAA;EACA,cxClvBH;AH+wuCT;A2CzhtCI;EACI,mBAAA;A3C2htCR;A2CzhtCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBxC/wBJ;EwCgxBI,yBAAA;A3C2htCZ;A2CzhtCY;EACI,mBxCxpBJ;EwCypBI,cxC9oBL;AHyquCX;A2CvhtCQ;EAGI,aAAA;EAGA,mBAAA;EvC7uBT,YuC8uBuC;EAC9B,kBAAA;EACA,cxCjkBE;AH0luCd;A2CvhtCY;EACI,iBAAA;A3CyhtChB;A2CthtCY;EACI,mBxCnrBJ;EwCorBI,cxCzkBF;AHimuCd;;A2ClhtCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exC7bW;AHk9tCf;A2CnhtCI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBxChtBI;EwCitBJ,cxCtmBM;EwCumBN,kBAAA;EACA,cAAA;A3CqhtCR;;A2C/gtCQ;EACI,cxC9sBD;AHguuCX;A2ChhtCY;EACI,cxCr3BN;AHu4uCV;A2C9gtCQ;EACI,iBAAA;A3CghtCZ;;A2C1gtCI;EAGI,aAAA;A3C6gtCR;A2C3gtCQ;EACI,gBAAA;EACA,qBAAA;A3C6gtCZ;A2C1gtCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3C4gtCZ;;A2CvgtCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;A3C0gtCJ;A2CxgtCI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cxCh4BC;AH04uCT;A2CxgtCQ;EACI,cxCx6BF;AHk7uCV;;A2CpgtCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3CugtCR;A2CrgtCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;A3CugtCZ;A2CpgtCQ;EACI,exC5iBG;EwC6iBH,gBxCn9BS;EwCo9BT,kBAAA;A3CsgtCZ;A2ClgtCQ;EACI,exCnjBG;EwCojBH,gBAAA;A3CogtCZ;A2C9/sCY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;A3CggtChB;A2C5/sCgB;EACI,iBAAA;EACA,cxCx9BV;AHs9uCV;;A2Ct/sCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3Cy/sCR;A2Cv/sCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3Cy/sCZ;A2Ct/sCQ;EACI,gBAAA;A3Cw/sCZ;;A2Cl/sCI;EACI,qBAAA;A3Cq/sCR;A2Cn/sCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBxC3+BJ;EwC4+BI,cxCt2BD;AH21uCX;A2Cn/sCY;EACI,mBxCz2BL;EwC02BK,WxCh/BR;AHq+uCR;;A2C9+sCI;EACI,iBAAA;EACA,qBAAA;A3Ci/sCR;A2C/+sCQ;EACI,exCroBG;EwCsoBH,gBxC1iCS;EwC2iCT,kBAAA;EvC78BT,iBuC88BuC;EAC9B,qBAAA;A3Ci/sCZ;A2C9+sCQ;EACI,eAAA;A3Cg/sCZ;;A2C3+sCA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cxC9gCK;AH4/uCT;A2C5+sCI;EACI,exCjqBO;AH+ouCf;;AIlhvCI;EuCwiCJ;IAEQ,cAAA;E3C6+sCN;AACF;A2C3+sCI;EACI,qBAAA;EvCp/BL,kBuCq/B6B;A3C6+sChC;A2C3+sCQ;EACI,cxCv6BD;EwC06BC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,exCzrBG;EwC0rBH,gBxChmCS;EwCimCT,6BAAA;EACA,kBAAA;EvCpgCT,yBuCqgCuC;A3C6+sC1C;A2C3+sCY;EAEI,cxC7lCN;EwC8lCM,qBxC9lCN;AH0kvCV;A2Cz+sCY;EACI,iBAAA;A3C2+sChB;AIpjvCI;EuC6iCA;IAiCQ,cAAA;E3C0+sCV;AACF;;A2Ct+sCA;EACI,kBAAA;A3Cy+sCJ;A2Cv+sCI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;A3Cy+sCR;A2Ct+sCI;EACI,kBAAA;A3Cw+sCR;A2Cr+sCI;EACI,WAAA;A3Cu+sCR;;A2Cn+sCA;EACI,mBxC16BS;EwC26BT,cxC9lCK;EwC+lCL,kBAAA;EACA,qBAAA;EACA,exC1uBW;ECzUZ,gBuCojCyB;EvCnjCzB,gBuCmjCmC;A3Cu+sCtC;A2Cr+sCI;EACI,iBAAA;A3Cu+sCR;;A2C/9sCgB;EACI,gBAAA;A3Ck+sCpB;;A2C39sCA;EACI,yBAAA;EACA,kBAAA;EvCzkCD,gBuC0kCyB;EvCzkCzB,sBuCykCmC;A3C+9sCtC;A2C79sCI;EACI,gBxC1qCa;EwC2qCb,kBAAA;A3C+9sCR;A2C59sCI;EACI,mBAAA;A3C89sCR;A2C59sCQ;EACI,cxC//BD;EwCkgCC,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exCnxBG;AHivuCf;A2C59sCY;EACI,aAAA;A3C89sChB;A2C19sCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C49sCZ;A2Cz9sCQ;EACI,eAAA;A3C29sCZ;A2Cv9sCY;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exC7yBD;EwC8yBC,cxCjiCL;AH0/uCX;;A2Cl9sCI;EACI,aAAA;A3Cq9sCR;;A2Cj9sCA;EACI,aAAA;EACA,mBAAA;A3Co9sCJ;;A2Ch9sCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6DAAA;EvCppCL,gBuCqpC6B;EvCppC7B,auCopCuC;EAClC,kBAAA;A3Co9sCR;A2Cl9sCQ;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;A3Co9sCZ;A2Cl9sCY;EACI,gBxClwCK;EwCmwCL,kBAAA;A3Co9sChB;A2Cj9sCY;EACI,gBAAA;A3Cm9sChB;AIvrvCI;EuCktCI;IAsBQ,kBAAA;E3Cm9sCd;AACF;A2Ch9sCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WxCtuCJ;EwCyuCI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;A3Ck9sCZ;A2Ch9sCY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3Ck9sChB;A2C98sCQ;EACI,mBxCtoCA;AHslvCZ;A2C98sCY;EACI,gBxC9vCR;AH8svCR;A2C58sCQ;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,cxC/iCE;EwCgjCF,mBxC3pCA;AHymvCZ;AIxuvCI;EuCmsCA;IvCzoCD,gBuCouCiC;IvCnuCjC,auCmuC2C;E3C+8sC5C;AACF;A2C58sCI;EACI,mBxCrqCI;EwCsqCJ,kBAAA;EvC1uCL,gBuC2uC6B;EvC1uC7B,auC0uCuC;A3C+8sC1C;A2C78sCQ;EACI,mBAAA;A3C+8sCZ;A2C58sCQ;EACI,gBxClyCJ;EwCmyCI,kBxCnyCJ;EwCoyCI,kBAAA;EACA,cxC/pCD;EwCgqCC,exC36BG;EwC46BH,gBxCr1CS;EC8FlB,SuCwvCiC;EvCvvCjC,iBuCuvCoC;A3C+8sCvC;A2C78sCY;EACI,iBAAA;A3C+8sChB;A2C58sCY;EACI,mBxC5rCJ;AH0ovCZ;;A2Cx8sCA;EACI,eAAA;A3C28sCJ;A2Cz8sCI;EvCxwCD,qBuCywC6B;EvCxwC7B,iBuCwwC4C;A3C48sC/C;A2C18sCQ;EACI,eAAA;A3C48sCZ;A2Cz8sCQ;EACI,gBAAA;A3C28sCZ;;A2Ct8sCA;EACI,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;A3Cy8sCJ;A2Cv8sCI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3Cy8sCR;A2Ct8sCI;EACI,mBxClqCK;EwCmqCL,cxCt1CC;EwCu1CD,exCh+BO;EwCi+BP,qBAAA;EACA,kBAAA;EvC3yCL,cuC4yC6B;EvC3yC7B,iBuC2yCqC;EAChC,kBAAA;A3Cy8sCR;A2Cv8sCQ;EACI,kBAAA;A3Cy8sCZ;;A2Cp8sCA;EACI,mBxCnvCQ;EwCovCR,0BAAA;EACA,kBAAA;EACA,kBAAA;A3Cu8sCJ;A2Cr8sCI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3Cu8sCR;A2Cp8sCI;EACI,exCt/BO;EwCu/BP,mBAAA;A3Cs8sCR;A2Cn8sCI;EACI,exCjgCO;EwCkgCP,gBAAA;A3Cq8sCR;A2Cl8sCI;EACI,kBAAA;EvC90CL,kBuC+0CmC;A3Co8sCtC;;A2Ch8sCA;EACI,mBxCjxCQ;EwCkxCR,yBAAA;EvCt1CD,euCu1CyB;EvCt1CzB,auCs1CkC;EACjC,kBAAA;A3Co8sCJ;A2Cl8sCI;EACI,exClhCO;EwCmhCP,gBxCz7Ca;EwC07Cb,kBAAA;A3Co8sCR;A2Cj8sCI;EACI,exCxhCO;EwCyhCP,gBAAA;A3Cm8sCR;A2Cj8sCQ;EACI,cxC/wCD;AHktvCX;A2C/7sCI;EACI,WAAA;EvC12CL,kBuC22C6B;A3Ci8sChC;A2C97sCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A3Cg8sCR;;A2C57sCA;EACI,gBxCx9CmB;EwCy9CnB,mBAAA;A3C+7sCJ;;A2C37sCI;EACI,mBAAA;A3C87sCR;A2C57sCQ;EACI,exC5jCG;AH0/uCf;A2C37sCQ;EACI,gBAAA;A3C67sCZ;;A2Cx7sCA;EACI,mBxCt0CQ;EwCu0CR,yBAAA;EACA,kBAAA;EvCj5CD,gBuCk5CyB;EvCj5CzB,oBuCi5CmC;A3C47sCtC;A2C17sCI;;EAEI,mBAAA;A3C47sCR;A2Cz7sCI;EACI,gBxCt/Ce;AHi7vCvB;AI/4vCI;EuCm9CA;IAIQ,exCllCG;EH8gvCb;AACF;;A2Cx7sCA;EACI,exCxlCW;EwCylCX,cxC/+CM;AH06vCV;;A2Cv7sCI;EACI,mBAAA;A3C07sCR;A2Cx7sCQ;EACI,cAAA;EACA,gBxC1gDS;EwC2gDT,kBAAA;A3C07sCZ;;A2Cr7sCA;EACI,cxC7/CK;AHq7vCT;;A2Cr7sCA;EACI,yBAAA;EACA,mBxCn1CU;EwCo1CV,kBAAA;EvC17CD,gBuC27CyB;EvC17CzB,auC07CmC;A3Cy7sCtC;A2Cv7sCI;EACI,cxCx2CG;EwCy2CH,gBAAA;A3Cy7sCR;A2Cv7sCQ;EACI,iBAAA;A3Cy7sCZ;;A2Cp7sCA;EACI,aAAA;A3Cu7sCJ;A2Cr7sCI;EACI,cAAA;A3Cu7sCR;;A2Cl7sCI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;A3Cq7sCR;AIl8vCI;EuC0gDA;IAMQ,sBAAA;E3Cs7sCV;AACF;A2Cp7sCQ;EACI,mBAAA;EACA,mBxCt5CA;EwCu5CA,kBAAA;EACA,aAAA;EACA,mBAAA;A3Cs7sCZ;AI98vCI;EuCmhDI;IAQQ,WAAA;IACA,mBAAA;E3Cu7sCd;AACF;A2Cr7sCY;EACI,iBAAA;A3Cu7sChB;A2Cn7sCgB;EACI,gBAAA;EACA,gBxCzkDC;EwC0kDD,exCpqCL;EwCqqCK,cxC75CT;AHk1vCX;A2Cj7sCY;EACI,mBxCtkDN;EwCukDM,WxCpiDR;AHu9vCR;A2Cj7sCgB;EACI,WxCviDZ;AH09vCR;;A2C56sCA;EACI,yBAAA;EvC//CD,euCggDyB;EvC//CzB,sBuC+/CkC;EACjC,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;A3Cg7sCJ;A2C96sCI;EvCrhDF,kBuCshDwB;EvCrhDxB,MuCqhDkC;EvClhDlC,OuCkhDiD;EAC3C,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBxCnmDI;AHqhwCZ;A2C/6sCI;EACI,cxCh8CG;EwCi8CH,gBxCpnDa;EwCqnDb,mBAAA;A3Ci7sCR;A2C96sCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;A3Cg7sCR;A2C96sCQ;EvCpiDL,qBuCqiDiC;A3Cg7sCpC;A2C96sCY;EACI,iBAAA;A3Cg7sChB;A2C76sCY;EACI,eAAA;A3C+6sChB;A2C16sCI;EACI,gBAAA;A3C46sCR;;A2Cv6sCI;EACI,kBAAA;A3C06sCR;A2Cx6sCQ;EACI,eAAA;A3C06sCZ;;A2Cr6sCA;EACI,gBAAA;A3Cw6sCJ;;A2Cr6sCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EvC3kDD,euC4kDyB;EvC3kDzB,uBuC2kDkC;EACjC,kBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A3Cy6sCJ;A2Cv6sCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3Cy6sCR;A2Cv6sCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3Cy6sCZ;A2Cr6sCI;EACI,gBxC/rDe;EwCgsDf,cxC7qDC;AHolwCT;;A2Cl6sCI;EACI,aAAA;EACA,SAAA;A3Cq6sCR;A2Cl6sCI;EACI,cAAA;A3Co6sCR;A2Cj6sCI;EACI,mBAAA;EACA,uBAAA;EACA,YAAA;A3Cm6sCR;A2Cj6sCQ;EACI,iBAAA;A3Cm6sCZ;A2C95sCQ;EACI,yBAAA;EACA,iCAAA;EACA,6BAAA;A3Cg6sCZ;;A2C35sCA;EACI,cAAA;A3C85sCJ;A2Cz5sCY;EAEI,yBxCrrDR;AH+kwCR;;A2Cp5sCA;EACI,UAAA;A3Cu5sCJ;;A2Cp5sCA;EACI,YAAA;A3Cu5sCJ;;A2Cn5sCI;EACI,cxCvkDG;EwCwkDH,gBxC3vDa;AHipwCrB;A2Cp5sCQ;EACI,cxCpvDF;EwCqvDE,0BAAA;A3Cs5sCZ;;A2Cj5sCA;EACI,cxCllDO;EwCmlDP,gBxCtwDiB;AH0pwCrB;;A2Ch5sCI;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;A3Cm5sCR;AI9nwCI;EuCuuDA;IAOQ,sBAAA;E3Co5sCV;AACF;;A2C94sCQ;EACI,8BAAA;A3Ci5sCZ;;A4CnrwCI;EACI,iBAAA;A5CsrwCR;A4CrrwCO;EACK,kBAAA;EACA,YAAA;A5CurwCZ;A4CprwCY;EACI,YAAA;A5CsrwChB;A4CrrwCgB;EACI,iBAAA;A5CurwCpB;A4CrrwCgB;EACI,YAAA;A5CurwCpB;;A4C/qwCI;EACI,aAAA;EACA,mBAAA;A5CkrwCR;A4ChrwCY;EACI,iBAAA;A5CkrwChB;;A4C5qwCA;EACI,YAAA;A5C+qwCJ;AIpqwCI;EwCZJ;IAGQ,eAAA;E5CirwCN;AACF;A4ChrwCI;EACI,sBzCgBA;EyCfA,yBAAA;EACA,czCgDQ;EyC/CR,ezCyYO;EyCxYP,eAAA;ExC4DL,iBwC3D6B;ExC4D7B,oBwC5DwC;A5CmrwC3C;A4ClrwCQ;EACI,czC4CI;AHwowChB;AIrrwCI;EwCPA;IAWQ,eAAA;IxCsDT,iBwCrDiC;IxCsDjC,oBwCtD4C;E5CsrwC7C;AACF;;AI5rwCI;EwCUA;IAEQ,kBAAA;E5CqrwCV;AACF;AIlswCI;EwCUA;IAKQ,eAAA;E5CurwCV;AACF;;A4CprwCA;EACI,oBAAA;EACA,mBAAA;A5CurwCJ;AI5swCI;EwCmBJ;IAIQ,sBAAA;IACA,gBAAA;E5CyrwCN;AACF;AIltwCI;EwCmBJ;IAQQ,sBAAA;IACA,aAAA;IACA,kBAAA;E5C2rwCN;AACF;A4C1rwCI;EACI,iBAAA;EACA,kBAAA;A5C4rwCR;AI7twCI;EwC+BA;IAIQ,cAAA;E5C8rwCV;AACF;A4C3rwCQ;EACI,4BAAA;EACA,sBzC/BJ;EyCgCI,yBAAA;EACA,czCDI;EyCEJ,ezCuVG;EyCtVH,qBAAA;EACA,mBAAA;A5C6rwCZ;;A4CxrwCI;EACI,gBAAA;A5C2rwCR;;A4CvrwCI;EACI,iBAAA;EACA,YAAA;A5C0rwCR;;A4CtrwCI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;A5CyrwCR;;A4CtrwCA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;A5CyrwCJ;;A4CrrwCQ;EACI,YAAA;EACA,gBAAA;A5CwrwCZ;A4CvrwCY;EACI,UAAA;EACA,QAAA;A5CyrwChB;A4CvrwCY;EACI,YAAA;EACA,gBAAA;A5CyrwChB;A4CtrwCQ;EACI,kBAAA;A5CwrwCZ;;A6C/zwCA;EACI,gB1CsDI;AH4wwCR;;A6Ch0wCA;EACI,kBAAA;A7Cm0wCJ;AI1xwCI;EyC1CJ;IAGQ,aAAA;E7Cq0wCN;AACF;A6Cp0wCI;EACI,eAAA;EACA,MAAA;EACA,OAAA;A7Cs0wCR;A6Cp0wCI;EACI,eAAA;EACA,YAAA;EACA,QAAA;A7Cs0wCR;A6Cp0wCI;EACI,YAAA;A7Cs0wCR;;A6Cn0wCA;EACI,gBAAA;A7Cs0wCJ;;A8C71wCA;EACI,gB3CsDI;AH0ywCR;;A8C71wCI;EACI,kBAAA;A9Cg2wCR;A8C/1wCQ;EACI,e3C4aG;ECpVb,kB0CvF4B;E1CwF5B,Q0CxFqC;E1CyFrC,W0CzFyC;EAC/B,2BAAA;A9Cm2wCZ;;A8C/1wCA;EACI,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A9Ck2wCJ;A8Cj2wCI;EAGI,oBAAA;EAGA,mBAAA;EACA,eAAA;EACA,c3C4JG;E2C3JH,gBAAA;A9Cm2wCR;A8Cl2wCQ;EACI,aAAA;A9Co2wCZ;A8Cn2wCY;EACI,mB3ChBJ;AHq3wCZ;A8Cp2wCgB;EACI,MAAA;A9Cs2wCpB;A8Cl2wCQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,mB3CyHA;E2CxHA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kB3CuWO;AH6/vCnB;A8Cn2wCY;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kB3CRR;E2CSQ,8CAAA;EACA,+BAAA;EACA,mDAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;A9Cq2wChB;;A8Ch2wCA;EACI,kBAAA;EACA,c3CrBK;AHw3wCT;A8Cl2wCI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB3C1BC;ECCP,mB0C0ByB;E1CzBzB,2B0CyByB;E1CxBzB,uB0CwByB;E1COzB,yB0CN0B;E1CU1B,kB0CTwB;E1CYxB,Y0CZ2C;E1Ca3C,O0CbgD;A9C02wClD;A8Cx2wCI;E1C9BF,mB0C+ByB;E1C9BzB,2B0C8ByB;E1C7BzB,uB0C6ByB;A9C42wC3B;A8C12wCI;EACI,c3CnCC;AH+4wCT;;A8Cz2wCA;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9C42wCJ;;A8C12wCA;EACI,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9C62wCJ;;A8C32wCA;EACI,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9C82wCJ;;A8C52wCA;EACI,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9C+2wCJ;;A8C72wCA;EACI,kBAAA;EACA,c3CrGM;E2CsGN,gB3ChHiB;AHg+wCrB;A8C/2wCI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB3C3GE;ECsCR,mB0CsEyB;E1CrEzB,2B0CqEyB;E1CpEzB,uB0CoEyB;E1CrCzB,yB0CsC0B;E1ClC1B,kB0CmCwB;E1ChCxB,Y0CgC2C;E1C/B3C,O0C+BgD;A9Cu3wClD;A8Cr3wCI;E1C1EF,mB0C2EyB;E1C1EzB,2B0C0EyB;E1CzEzB,uB0CyEyB;A9Cy3wC3B;A8Cv3wCI;EACI,yBAAA;A9Cy3wCR;;A8Ct3wCA;EACI,6CAAA;EACA,mCAAA;UAAA,2BAAA;A9Cy3wCJ;AIz9wCI;E0C8FJ;IAIQ,sBAAA;E9C23wCN;AACF;;A8Cz3wCA;EACI,gBAAA;EACC,YAAA;A9C43wCL;;A8C13wCA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CmCO;E2ClCP,e3CwRW;E2CrRX,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1CrCF,kB0CsCmB;E1C3GnB,2B0C4GqB;E1C3GrB,mC0C2GqB;E1C1GrB,+B0C0GqB;E1CvErB,kB0CwEoB;E1CvEpB,Q0CuE6B;E1CtE7B,W0CsEiC;A9Ci4wCnC;A8Ch4wCI;EACI,c3CrJE;AHuhxCV;;A8C/3wCA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CaO;E2CZP,e3CkQW;E2C/PX,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1C3DF,kB0C4DmB;E1CjInB,2B0CkIqB;E1CjIrB,mC0CiIqB;E1ChIrB,+B0CgIqB;E1C7FrB,kB0C8FoB;E1C7FpB,Q0C6F6B;E1C5F7B,W0C4FiC;A9Cs4wCnC;A8Cr4wCI;EACI,c3C3KE;AHkjxCV;;A8Cp4wCA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CTO;E2CUP,e3C4OW;E2CzOX,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1CjFF,kB0CkFmB;E1CvJnB,2B0CwJqB;E1CvJrB,mC0CuJqB;E1CtJrB,+B0CsJqB;E1CnHrB,kB0CoHoB;E1CnHpB,Q0CmH6B;E1ClH7B,W0CkHiC;A9C24wCnC;A8C14wCI;EACI,c3CjME;AH6kxCV;;A8Cz4wCA;EACI,kBAAA;EACA,e3CtNa;AHkmxCjB;;A8C14wCA;EACI,kBAAA;EACA,kBAAA;EACA,c3CyDQ;E2CxDR,e3C5Na;E2C6Nb,gB3CxNiB;E2CyNjB,mBAAA;A9C64wCJ;A8C54wCI;EACI,kBAAA;EACA,e3CjOS;E2CkOT,c3CgDK;E2C/CL,gB3C3NW;AHymxCnB;A8C74wCQ;EACI,WAAA;EACA,mB3C8CA;E2C7CA,WAAA;EACA,WAAA;E1C7IV,kB0C8I4B;E1C7I5B,S0C6IqC;E1C1IrC,W0C0IoD;A9Ci5wCtD;AIjlxCI;E0C2LI;IAOQ,WAAA;E9Cm5wCd;AACF;A8Cj5wCQ;EACI,WAAA;EACA,mB3CoCA;E2CnCA,WAAA;EACA,WAAA;E1CvJV,kB0CwJ4B;E1CvJ5B,S0CuJqC;E1CtJrC,Y0CsJ0C;A9Cq5wC5C;AI/lxCI;E0CqMI;IAOQ,WAAA;E9Cu5wCd;AACF;;A8Cn5wCA;EACI,gBAAA;A9Cs5wCJ;;A8Cp5wCA;EACI,WAAA;EACA,YAAA;A9Cu5wCJ;AI7mxCI;E0CoNJ;IAIQ,WAAA;IACA,YAAA;E9Cy5wCN;AACF;;A8Cv5wCA;EACI,kBAAA;A9C05wCJ;AIvnxCI;E0C4NJ;IAGQ,aAAA;E9C45wCN;AACF;A8C35wCI;EACI,eAAA;EACA,MAAA;EACA,OAAA;A9C65wCR;A8C35wCI;EACI,eAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;A9C65wCR;;A+CnrxCI;EACI,e5CibO;E4ChbP,gB5CQe;E4CPf,mBAAA;A/CsrxCR;AI7oxCI;E2C5CA;IAKQ,e5C4aG;I4C3aF,mBAAA;E/CwrxCX;AACF;A+CtrxCI;EACI,c5C6KG;E4C1KH,oBAAA;EAGA,mBAAA;EACA,kB5C4YW;E4C3YX,aAAA;EACA,WAAA;EACA,kBAAA;A/CwrxCR;A+CvrxCQ;EACI,mB5CqJA;E4CpJA,c5CqKD;AHohxCX;A+CxrxCY;EACI,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,e5CiZD;E4ChZC,QAAA;EACA,2BAAA;EACA,WAAA;A/C0rxChB;A+CvrxCQ;EACI,c5CyJD;AHgixCX;;A+CrrxCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/CwrxCJ;A+CvrxCI;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kB5CyWW;E4CxWX,0BAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A/CyrxCR;A+CxrxCQ;EACI,c5CuHD;E4CtHC,kBAAA;A/C0rxCZ;A+CtrxCQ;EAGI,oBAAA;EAGA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,c5CtBH;E4CuBG,mB5C4JC;E4C3JD,yBAAA;EACA,kB5C4UO;E4C3UP,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;A/CwrxCZ;A+CvrxCY;EACI,W5CjCR;E4CkCQ,mB5ChCP;E4CiCO,yBAAA;EACA,oBAAA;A/CyrxChB;A+CvrxCY;EACI,e5CoVD;E4CnVC,iBAAA;A/CyrxChB;A+CvrxCY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;A/CyrxChB;A+CtrxCQ;EACI,gB5CtGS;E4CuGT,c5CuED;AHinxCX;A+CrrxCI;EACI,aAAA;A/CurxCR;A+CrrxCI;EACI,WAAA;EACA,YAAA;EACA,kB5CoSW;E4CnSX,cAAA;EACA,kBAAA;EACA,gB5CtEA;E4CuEA,iBAAA;A/CurxCR;A+CrrxCI;EACI,aAAA;A/CurxCR;A+CrrxCI;EACI,WAAA;EACA,YAAA;EACA,e5CsSO;E4CrSP,W5ChFA;E4CiFA,mB5C1GC;E4C2GD,yBAAA;EACA,kB5CoRW;E4CnRX,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A/CurxCR;A+CrrxCI;EACI,sC5CnHO;E4CoHP,4CAAA;A/CurxCR;;A+C/qxCoB;EACI,cAAA;A/CkrxCxB;A+C/qxCgB;EACI,e5CkRL;E4CjRK,aAAA;A/CirxCpB;A+C3qxCgB;EACI,gB5C9JC;E4C+JD,c5CoBT;E4CnBS,aAAA;A/C6qxCpB;A+C1qxCoB;EACI,iBAAA;A/C4qxCxB;;A+CpqxCI;EACI,kBAAA;A/CuqxCR;;A+CpqxCA;EACI,WAAA;EACA,YAAA;EACA,gB5CtII;E4CuIJ,yBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c5CZO;AHmrxCX;A+CtqxCI;EACI,mB5C5IA;E4C6IA,W5CrJA;AH6zxCR;;A+CpqxCI;EACI,mBAAA;A/CuqxCR;A+CtqxCQ;EACI,e5C6NG;E4C5NH,gB5C1MS;AHk3xCrB;A+CtqxCQ;EACI,e5CuNG;AHi9wCf;A+CrqxCI;EACI,mBAAA;A/CuqxCR;A+CrqxCI;EACI,gBAAA;A/CuqxCR;;A+CpqxCA;EACI,mB5CvDQ;E4CwDR,kBAAA;EACA,yBAAA;EACA,kBAAA;E3C9HD,gB2C+HyB;E3C9HzB,a2C8HmC;A/CwqxCtC;AIj2xCI;E2CoLJ;I3C1HG,gB2CiI6B;I3ChI7B,a2CgIuC;E/C2qxCxC;AACF;A+C1qxCI;EACI,qB5CnNE;AH+3xCV;A+C3qxCQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,c5ChCE;E4CiCF,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sB5ChMJ;E4CmMI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A/C6qxCZ;A+CzqxCQ;EACI,6BAAA;A/C2qxCZ;A+C1qxCY;EACI,yB5C3FJ;AHuwxCZ;;A+CtqxCI;EACI,0BAAA;A/CyqxCR;A+CvqxCI;EACI,W5CzNA;E4C0NA,iBAAA;A/CyqxCR;;A+CtqxCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/CyqxCJ;A+CxqxCI;EACI,iBAAA;A/C0qxCR;A+CzqxCQ;EACI,yB5CnHA;EC7CV,kB2CiK2B;EACjB,c5CzGD;E4C0GC,gB5CxRS;EC8FlB,iB2C2LuC;EAC9B,qBAAA;A/C2qxCZ;A+C1qxCY;EACI,yB5CvOR;E4CwOQ,sBAAA;A/C4qxChB;;A+CvqxCA;EACI,eAAA;A/C0qxCJ;A+CzqxCI;EACI,gB5CxPA;E4CyPA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;A/C2qxCR;A+C1qxCQ;EACI,YAAA;A/C4qxCZ;AIr7xCI;E2CwQI;IAGO,YAAA;E/C8qxCb;AACF;A+C5qxCQ;EACI,eAAA;A/C8qxCZ;A+C5qxCQ;EACI,gB5CrTS;E4CsTT,e5CgHG;E4C/GH,c5CpID;E4CqIC,gBAAA;EACA,cAAA;A/C8qxCZ;A+C5qxCQ;EACI,qB5ClTF;AHg+xCV;A+C7qxCY;EACI,c5CpTN;AHm+xCV;;A+CzqxCI;EACI,aAAA;EACA,mBAAA;A/C4qxCR;A+C3qxCQ;EACI,kBAAA;A/C6qxCZ;A+C5qxCY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yB5CnUN;E4CoUM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;A/C8qxChB;A+C7qxCgB;EACI,yB5CvRN;AHs8xCd;A+C9qxCoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yB5C/Ud;E4CgVc,kBAAA;EACA,UAAA;A/CgrxCxB;A+C7qxCgB;EACI,yB5CnVR;AHkgyCZ;A+C9qxCoB;EACI,yB5CzRR;AHy8xChB;A+C/qxCwB;EACI,yB5CvVhB;AHwgyCZ;A+C7qxCgB;EACI,yB5C/ST;AH89xCX;A+C9qxCoB;EACI,wCAAA;A/CgrxCxB;A+C/qxCwB;EACI,yB5CnTjB;AHo+xCX;A+C7qxCgB;EACI,yB5CnFX;AHkwxCT;A+C9qxCoB;EACI,yB5C9NX;AH84xCb;A+C/qxCwB;EACI,yB5CvFnB;AHwwxCT;A+C7qxCgB;EACI,yB5C3UX;AH0/xCT;A+C9qxCoB;EACI,yB5C1JX;AH00xCb;A+C/qxCwB;EACI,yB5C/UnB;AHggyCT;A+C5qxCY;EACI,eAAA;A/C8qxChB;;A+CzqxCA;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C4qxCJ;;A+C1qxCA;EACI,kBAAA;A/C6qxCJ;A+C5qxCI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;E3CrSN,kB2CsSuB;EACjB,c5CzOG;E4C0OH,gB5C7Za;EC8FlB,gB2CgUmC;A/C8qxCtC;A+C7qxCQ;EACI,iBAAA;E3C3SV,kB2C4S2B;EACjB,WAAA;EACA,YAAA;A/C+qxCZ;;A+C1qxCI;E3C3UD,iB2C4U6B;A/C6qxChC;A+C5qxCQ;EACI,yB5C/PD;E4CgQC,c5CzPD;EC9DT,kB2CwT2B;E3C/U1B,iB2CgVuC;EAC9B,qBAAA;A/C8qxCZ;A+C7qxCY;EACI,yB5CxXL;E4CyXK,W5CrYR;AHojyCR;A+C5qxCQ;EACI,eAAA;A/C8qxCZ;;A+CzqxCI;EACI,gB5C5ba;E4C6bb,mBAAA;A/C4qxCR;A+C1qxCI;EACI,mBAAA;A/C4qxCR;A+CzqxCQ;EACI,e5C5BG;E4C6BH,gB5CpcW;AH+myCvB;;A+CvqxCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;A/C0qxCJ;A+CzqxCI;EACI,mBAAA;A/C2qxCR;;A+CxqxCA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C2qxCJ;;A+CzqxCA;EACI,mBAAA;A/C4qxCJ;A+C3qxCI;EACI,gB5Cpea;AHipyCrB;A+C3qxCI;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;A/C6qxCR;;A+C1qxCA;EACI,yBAAA;A/C6qxCJ;;A+C1qxCI;EACI,cAAA;A/C6qxCR;AI3nyCI;E2C6cA;IAGQ,iBAAA;E/C+qxCV;AACF;A+C7qxCY;EACI,iBAAA;A/C+qxChB;AInoyCI;E2CmdQ;IAGS,gBAAA;IACA,mBAAA;E/CirxCnB;AACF;;A+C5qxCA;EACI,WAAA;EACA,YAAA;A/C+qxCJ;;AgD3ryCA;EACI,cAAA;EACA,gBAAA;AhD8ryCJ;;AgDxryCY;EACI,aAAA;AhD2ryChB;AgDvryCI;EACI,c7C+KG;E6C9KH,yBAAA;EACA,iBAAA;EACA,kB7C6YW;E6C5YX,aAAA;EACA,mBAAA;EACA,6DAAA;AhDyryCR;AgDxryCQ;EACI,aAAA;EACA,cAAA;EACA,gCAAA;EACA,+BAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;E5CoGV,yB4CnGoC;E5CoGpC,iC4CpGoC;E5CqGpC,6B4CrGoC;E5C2DpC,yB4C1D8B;E5CyB9B,wB4CxB6B;E5CyB7B,gC4CzB6B;E5C0B7B,4B4C1B6B;AhDgsyC/B;AgD9ryCQ;E5CsBN,0B4CrB6B;E5CsB7B,kC4CtB6B;E5CuB7B,8B4CvB6B;AhDksyC/B;AgD/ryCI;EACI,aAAA;EACA,gB7CaA;E6CZA,6C7C4XQ;E6C3XR,yBAAA;AhDisyCR;AgDhsyCQ;EACI,iBAAA;EACA,c7C6ID;E6C5IC,gB7COJ;E6CNI,kB7C6WO;AHq1xCnB;AgDjsyCY;EACI,c7C0IL;E6CzIK,mB7CwHJ;AH2kyCZ;;AiDtvyCC;EACC,gB9CQmB;E8CPnB,mBAAA;EACA,iBAAA;AjDyvyCF;;AiDtvyCA;EACC,mBAAA;EAGA,oBAAA;EAGA,mBAAA;AjDyvyCD;AiDxvyCC;EACC,gB9CLqB;EC4FpB,qB6CtFuB;E7CuFvB,mB6CvFsC;EACvC,kBAAA;AjD2vyCF;AiD1vyCE;EACC,WAAA;EACA,yB9C6JS;E8C5JT,UAAA;EACA,YAAA;E7CwED,kB6CvEmB;E7CwEnB,M6CxE6B;E7CyE7B,Q6CzEgC;AjD8vyClC;AIzuyCI;E6C1BF;IAOE,aAAA;EjDgwyCF;AACF;AI9uyCI;E6CtCJ;IAwBE,cAAA;EjDgwyCA;AACF;;AiD7vyCC;EACC,mBAAA;AjDgwyCF;AiD/vyCE;EACC,qBAAA;EACA,kBAAA;AjDiwyCH;AiDhwyCG;EACC,WAAA;EACA,YAAA;E7CqFF,kB6CpFmB;EACjB,yBAAA;EAGS,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c9CuIF;AH2nyCX;AiDjwyCa;EACC,yB9CON;E8CNM,qB9CMN;E8CLM,W9CHN;AHswyCR;AiDhwyCG;EACC,eAAA;AjDkwyCJ;;AiD5vyCE;EACC,qBAAA;AjD+vyCH;AiD7vyCI;EACC,aAAA;AjD+vyCL;AiD9vyCK;EACC,yBAAA;EACA,6DAAA;E7C4BH,oB6C3B2B;E7C4B3B,iB6C5ByC;E7CmD1C,kB6ClDqB;EACjB,c9C+GK;E8C9GL,eAAA;AjDiwyCN;AiDhwyCM;EACC,iBAAA;AjDkwyCP;AiD9vyCM;EACC,qB9CvBC;E8CwBD,c9CxBC;AHwxyCR;AiD3vyCG;EACC,eAAA;AjD6vyCJ;;AiDzvyCA;EACC,c9C9ES;E8C+ET,kBAAA;EACA,gB9C1FoB;AHs1yCrB;AiD3vyCC;EACC,iBAAA;AjD6vyCF;AiD3vyCC;EACC,wD9CpFc;AHi1yChB;;AiD1vyCA;E7CmBE,kB6ClBgB;E7CNf,gB6COsB;E7CNtB,oB6CMgC;EAClC,8DAAA;AjD8vyCD;AiD5vyCE;EACC,qBAAA;EACA,kBAAA;AjD8vyCH;AiD7vyCG;E7CZA,sB6Ca+B;EAC9B,gB9C5GiB;E8C6GjB,6BAAA;EACA,qBAAA;AjD+vyCJ;AiD9vyCI;EACC,WAAA;EACA,YAAA;E7CIH,kB6CHoB;EAChB,yBAAA;EAGQ,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,c9CqDH;E8CpDG,gB9C9HS;E8C+HT,e9CkSC;AH89xCf;AiD9vyCI;EACC,c9CzHK;E8C0HL,qB9C1HK;AH03yCV;;AiD1vyCA;E7C7CG,gB6C8CsB;E7C7CtB,a6C6CgC;EAClC,8DAAA;EACA,yBAAA;E7CxBC,kB6CyBgB;AjD8vyClB;AiD7vyCC;EACC,e9CwRa;E8CvRb,gB9ClJmB;E8CmJnB,mBAAA;EACA,c9C2BS;AHouyCX;AiD5vyCE;EACC,c9CxGM;AHs2yCT;AiD3vyCC;EACC,gBAAA;AjD6vyCF;;AiD1vyCA;EACC,W9ClHO;ECiDL,gB6CkE4B;EAC9B,e9CmQc;EC/Sb,kB6C6CgB;AjD6vyClB;AiD5vyCC;EACC,iBAAA;AjD8vyCF;;AiD3vyCA;EACC,gB9CxKoB;E8CyKpB,c9CUU;AHovyCX;;AkD/6yCE;EACC,gBAAA;AlDk7yCH;AkDj7yCG;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;AlDm7yCJ;AkDj7yCK;EACC,yB/C4CG;AHu4yCT;AkD/6yCK;EACC,yB/CMI;AH26yCV;AkD76yCK;EACC,yB/CHI;AHk7yCV;AkD36yCK;EACC,qBAAA;AlD66yCN;AkD36yCK;EACC,qBAAA;AlD66yCN;AkD56yCM;EACC,QAAA;E9CqBL,2B8CpBwB;E9CqBxB,mC8CrBwB;E9CsBxB,+B8CtBwB;AlDg7yC1B;AkD76yCK;EACC,qBAAA;AlD+6yCN;AkD76yCK;EACC,gB/CnCe;AHk9yCrB;AkD76yCK;EACC,gB/CrCiB;E+CsCjB,e/C6XS;ECvUZ,oB8CrD2B;E9CsD3B,gB8CtDyC;EACtC,W/CIE;AH46yCR;AkD/6yCM;EACC,eAAA;AlDi7yCP;AkD36yCM;E9C4CH,qB8C3C4B;AlD66yC/B;AkD56yCO;EACC,gBAAA;AlD86yCR;AkD56yCO;EACC,eAAA;AlD86yCR;;AkDn6yCE;EACC,QAAA;E9CnBD,2B8CoBoB;E9CnBpB,mC8CmBoB;E9ClBpB,+B8CkBoB;AlDw6yCtB;;AkDn6yCC;EACC,SAAA;EACA,UAAA;EACA,e/C6Va;E+C5Vb,gB/C5EqB;E+C6ErB,gBAAA;AlDs6yCF;AkDr6yCE;EACC,SAAA;AlDu6yCH;AIp9yCI;E8CsCH;IAUE,e/CqVY;EHmlyCb;AACF;;AkDr6yCA;EACC,yBAAA;EACA,8BAAA;AlDw6yCD;;AkDt6yCA;EACC,gCAAA;EACA,mBAAA;EACA,oBAAA;AlDy6yCD;AkDt6yCI;EACC,mBAAA;AlDw6yCL;AkDp6yCC;EACC,iBAAA;AlDs6yCF;AkDn6yCI;EACC,gBAAA;AlDq6yCL;AkDh6yCC;EACC,e/CwTa;E+CvTb,gB/CjHqB;E+CkHrB,kBAAA;EACA,cAAA;AlDk6yCF;AIn/yCI;E8CkFF;IAEE,e/CiTW;EHknyCb;AACF;AkDj6yCE;EACC,WAAA;EACA,YAAA;E9CPD,kB8CQkB;EACjB,yBAAA;EAGA,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,c/C0CQ;E+CzCR,gB/CzIoB;E+C0IpB,e/CuRY;AH4oyCf;AkDj6yCE;EACU,gBAAA;EACA,kCAAA;E9C1DV,kB8C2D4B;E9C1D5B,Q8C0DsC;E9CzDtC,W8CyD2C;E9ChG3C,2B8CiG6B;E9ChG7B,mC8CgG6B;E9C/F7B,+B8C+F6B;EACnB,e/CoRG;E+CnRH,gB/ClJW;AHyjzCvB;AkDp6yCY;EACI,gBAAA;AlDs6yChB;AkDl6yCC;EACC,SAAA;EACA,gBAAA;AlDo6yCF;;AkDt3yCE;EACD;IAAO,yBAAA;ElD03yCN;AACF;AkDx3yCA;EACI,mBAAA;AlD03yCJ;AkDz3yCC;EACC,eAAA;EACA,gBAAA;EACA,c/CjCS;E+CkCT,kBAAA;AlD23yCF;AkDz3yCC;EACC,c/C1CS;E+C2CT,eAAA;AlD23yCF;;AkDv3yCC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlD03yCF;AkDx3yCC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlD03yCF;AkDx3yCC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AlD03yCF;AkDx3yCC;EACC,cAAA;EACA,eAAA;EACA,cAAA;AlD03yCF;AkDt3yCG;EACC,YAAA;AlDw3yCJ;AkDp3yCC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AlDs3yCF;AkDr3yCE;EACC,UAAA;EACA,mBAAA;AlDu3yCH;AkDt3yCG;EACC,c/CnFO;E+CoFP,gBAAA;EACA,kBAAA;AlDw3yCJ;AkDt3yCG;EAEC,c/CtFO;E+CuFP,gBAAA;AlDu3yCJ;AkDr3yCG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AlDu3yCJ;AkDr3yCG;EACC,iBAAA;AlDu3yCJ;;AkDj3yCC;EACC,eAAA;EACA,mBAAA;AlDo3yCF;;AkDj3yCA;EACC,oBAAA;AlDo3yCD;;AkDl3yCA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACH,mBAAA;AlDq3yCD;;AkDl3yCC;EACC,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AlDq3yCF;;AkDl3yCA;EACI,aAAA;EACA,mBAAA;AlDq3yCJ;;AkDn3yCA;EACI,iBAAA;AlDs3yCJ;AkDr3yCC;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;AlDu3yCF;AkDr3yCC;EACC,eAAA;EACA,gBAAA;AlDu3yCF;;AkDn3yCA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;AlDs3yCJ;AkDr3yCC;EACC,mBAAA;AlDu3yCF;;AkDp3yCA;EACC,mBAAA;EACG,yBAAA;EACA,mBAAA;AlDu3yCJ;AkDt3yCC;EACC,mBAAA;AlDw3yCF;;AkDr3yCA;EACI,mBAAA;EACA,aAAA;AlDw3yCJ;AkDt3yCE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AlDw3yCH;AkDv3yCG;EACC,eAAA;EACA,c/CpLO;E+CqLP,gBAAA;EACA,SAAA;AlDy3yCJ;AkDv3yCG;EACC,eAAA;EACA,c/CrLO;E+CsLP,gBAAA;EACA,SAAA;AlDy3yCJ;AkDv3yCG;EACC,gBAAA;AlDy3yCJ;;AkDp3yCA;EACC,gBAAA;EACA,iBAAA;EACA,6BAAA;AlDu3yCD;AkDt3yCC;EACC,eAAA;EACA,gBAAA;EACA,c/CtMS;E+CuMT,mBAAA;AlDw3yCF;AkDt3yCC;EACC,c/C/MS;E+CgNT,eAAA;EACA,oBAAA;AlDw3yCF;;AkDp3yCC;EACC,gBAAA;AlDu3yCF;AkDr3yCC;EACC,SAAA;EACA,eAAA;AlDu3yCF;AkDt3yCE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AlDw3yCH;AkDv3yCG;EACC,kBAAA;EACA,UAAA;EACA,c/CnOO;E+CoOP,eAAA;EACA,SAAA;AlDy3yCJ;AkDx3yCI;EACC,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;AlD03yCL;AkDv3yCG;EACC,kBAAA;EACA,UAAA;EACA,c/C3OO;E+C4OP,eAAA;EACA,SAAA;AlDy3yCJ;;AkDn3yCC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlDs3yCF;;AkDn3yCA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,8DAAA;EACA,kBAAA;EACH,mBAAA;AlDs3yCD;AkDr3yCC;EACC,UAAA;AlDu3yCF;AkDp3yCE;EACC,c/C1QQ;E+C2QR,mBAAA;AlDs3yCH;AkDp3yCE;EACC,eAAA;EACA,aAAA;AlDs3yCH;AkDr3yCG;EACC,UAAA;AlDu3yCJ;AkDt3yCI;EACC,SAAA;EACA,eAAA;EACA,gBAAA;AlDw3yCL;AkDt3yCI;EACC,eAAA;EACA,gBAAA;AlDw3yCL;;AkDj3yCC;EACC,2BAAA;AlDo3yCF;AkDl3yCC;EACC,WAAA;AlDo3yCF;AkDl3yCC;EACC,eAAA;AlDo3yCF;;AkDj3yCA;EACC,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AlDo3yCD;AkDn3yCC;EACC,mB/CzdQ;E+C0dR,sBAAA;AlDq3yCF;;AkD/2yCE;EACC,YAAA;AlDk3yCH;AkD/2yCC;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AlDi3yCF;AkD/2yCC;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AlDi3yCF;;AkD92yCA;EACC,kBAAA;AlDi3yCD;AkDh3yCC;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AlDk3yCF;AkDh3yCC;EACC,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,c/C/VS;E+CgWT,OAAA;EACA,aAAA;EACA,gBAAA;AlDk3yCF;;AkD92yCC;EACC,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;AlDi3yCF;AkDh3yCE;EACC,SAAA;EACA,kBAAA;EACA,eAAA;AlDk3yCH;AkDh3yCE;EACC,gBAAA;AlDk3yCH;AkDh3yCE;EACC,sBAAA;EACA,mB/C1hBO;AH44zCV;AkDh3yCE;EACC,sBAAA;AlDk3yCH;AkD/2yCC;EACC,0BAAA;EACA,yBAAA;AlDi3yCF;;AkD52yCC;EACC,eAAA;EACA,WAAA;AlD+2yCF;;AkD32yCA;EACC,eAAA;EACA,6BAAA;EACA,gCAAA;AlD82yCD;AkD72yCC;EACC,cAAA;EACA,SAAA;AlD+2yCF;;AkD32yCC;EACC,YAAA;AlD82yCF;;AkD12yCC;EACC,sBAAA;AlD62yCF;;AmD57zCQ;EACI,mBhDyKA;EgDxKA,kBAAA;EACA,mBAAA;AnD+7zCZ;AmD97zCY;EACI,gBAAA;AnDg8zChB;AmD77zCgB;EACI,ehDqaL;EgDpaK,gBhDFC;EgDGD,chDgLT;EgD/KS,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnD+7zCpB;AmD77zCgB;EACI,ehD0ZL;EgDzZK,mBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnD+7zCpB;AmD77zCgB;EACI,WhDwBZ;ECiDL,gB+CxE+C;EAC9B,ehD6YL;EC/Sb,kB+C7FmC;AnD+7zCrC;AmD97zCoB;EACI,iBAAA;AnDg8zCxB;AmD57zCY;EACI,aAAA;EACA,mBAAA;AnD87zChB;AI37zCI;E+CLQ;IAIQ,cAAA;EnDg8zClB;AACF;AmD97zCgB;EACI,cAAA;EACA,oBAAA;EACA,iBAAA;AnDg8zCpB;AmD/7zCoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AnDi8zCxB;AmD97zCgB;EACI,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnDg8zCpB;;AIl9zCI;E+CyBA;IAEQ,6BAAA;EnD47zCV;AACF;;AmDz7zCA;EACI,gBAAA;AnD47zCJ;AmD37zCI;EACI,kBAAA;AnD67zCR;AmD57zCQ;EACI,yBhD0FA;ECpET,gB+CrBiC;E/CsBjC,sB+CtB2C;AnD+7zC9C;AmD97zCY;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,sCAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AnDg8zChB;AmD/7zCgB;EACI,gBhDnFG;EgDoFH,kBAAA;AnDi8zCpB;AmD/7zCgB;EACI,qBAAA;AnDi8zCpB;AmD/7zCgB;EACI,mBAAA;AnDi8zCpB;AmD97zCY;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,sCAAA;EACA,eAAA;AnDg8zChB;AmD/7zCgB;EACI,mBAAA;AnDi8zCpB;AmD97zCY;EACI,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnDg8zChB;AmD/7zCgB;EACI,kBAAA;AnDi8zCpB;AmD97zCY;EACI,gBAAA;AnDg8zChB;;AoD9j0CC;EACC,cjD2LS;EiD1LT,eAAA;EACA,gBAAA;EACA,gBjDMqB;AH2j0CvB;AoDhk0CE;EACC,iBAAA;ApDkk0CH;AoD/j0CG;EACC,cjDmBK;AH8i0CT;AoD7j0CG;EACC,cjDQM;AHuj0CV;AoD3j0CG;EACC,cjDOM;AHsj0CV;;AoDxj0CA;EACC,yBAAA;EhD4EE,gBgD3EsB;EhD4EtB,sBgD5EgC;EAClC,kBAAA;EhDkGC,kBgDjGgB;ApD4j0ClB;AoD3j0CC;EACC,WAAA;EACA,yBjDHO;EiDIP,UAAA;EACA,YAAA;EhD4FA,kBgD3FiB;EhD2DjB,kBgD1DkB;EhD2DlB,MgD3D4B;EhD8D5B,OgD9D2C;ApD+j0C7C;AoD7j0CC;EACC,gBAAA;ApD+j0CF;;AoD5j0CA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;ApD+j0CD;AoD9j0CC;EACC,qBAAA;EACA,qBAAA;EAKC,cjDqIQ;AHu7zCX;AoDhk0CE;EACC,cjDmIQ;EiDlIR,kBAAA;ApDkk0CH;AoD9j0CC;EACC,qBAAA;ApDgk0CF;AoD/j0CE;EACC,eAAA;ApDik0CH;AoD9j0CG;EACC,iBAAA;ApDgk0CJ;;AoD3j0CA;EACC,YAAA;ApD8j0CD;AoD7j0CC;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;ApD+j0CF;AoD9j0CE;EACC,qBAAA;EACA,cjD6GQ;AHm9zCX;AoD/j0CG;EACC,eAAA;ApDik0CJ;AoD9j0CI;EACC,iBAAA;ApDgk0CL;AoD5j0CI;EACC,iBAAA;ApD8j0CL;AoD1j0CG;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;ApD4j0CJ;AoD3j0CI;EACC,kBAAA;EACA,YAAA;ApD6j0CL;AoD5j0CK;EACC,WAAA;EACA,YAAA;EhDsBJ,kBgDrBqB;ApD8j0CvB;AI3n0CI;EgDyBJ;IA2CE,WAAA;EpD2j0CA;AACF;;AoDzj0CA;EACC,kBAAA;ApD4j0CD;AoD3j0CC;EhDvBC,kBgDwBkB;EhDvBlB,QgDuB4B;EhDpB5B,UgDoB6C;EhD7D7C,2BgD8DmB;EhD7DnB,mCgD6DmB;EhD5DnB,+BgD4DmB;EACnB,cAAA;EACA,cjDtGQ;AHuq0CV;AoD/j0CC;EACC,kBAAA;ApDik0CF;;AoD9j0CA;EACC,mBAAA;ApDik0CD;AoDhk0CC;EACC,gBjDzHmB;EiD0HnB,kBAAA;ApDkk0CF;AoDhk0CC;EACC,gBjD5HqB;AH8r0CvB;;AoD9j0CC;EACC,mBAAA;ApDik0CF;AoD/j0CC;EACC,gBjDrImB;EiDsInB,cjD6CS;EiD5CT,mBAAA;ApDik0CF;AoD/j0CC;EACC,gCAAA;EACA,mBAAA;ApDik0CF;;AqDtt0CA;EACI,yBAAA;EACA,6DAAA;EACA,kBAAA;EjDoGD,qBiDnGyB;EjDoGzB,aiDpGwC;EACvC,WAAA;EACA,gBAAA;ArD0t0CJ;AqDzt0CI;EACI,eAAA;ArD2t0CR;;AqDvt0CI;EACI,WAAA;EACA,YAAA;EACA,mBlD+JI;EkD9JJ,kBAAA;EACA,clDsQM;AHo9zCd;AqDzt0CQ;EACI,mBlDmMC;EkDlMD,cAAA;ArD2t0CZ;;AqDpt0CY;EACI,gBAAA;ArDut0ChB;;AqDht0CI;EACI,uBAAA;EACA,WAAA;EACA,WAAA;ArDmt0CR;AqDlt0CQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;ArDot0CZ;AqDnt0CY;EACI,mBlDpBN;AHyu0CV;AqDnt0CY;EACI,mBlDUP;AH2s0CT;AqDnt0CY;EACI,mBlDxBT;AH6u0CP;AqDnt0CY;EACI,mBlDzBN;AH8u0CV;AqDnt0CY;EACI,mBlDOR;AH8s0CR;AqDnt0CY;EACI,mBlD7BP;AHkv0CT;AqDjt0CI;EACI,iBAAA;EACA,clD4HG;EkD3HH,gBlDxDa;AH2w0CrB;;AqD/s0CI;EACI,clDnDE;EkDoDF,gBlD9Da;EkD+Db,mBAAA;EACA,qBAAA;ArDkt0CR;AqDjt0CQ;EACI,iBAAA;ArDmt0CZ;;AqD7s0CQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6DAAA;EACA,kBAAA;EjDUT,iBiDTuC;EAC9B,gBlDtFS;AHsy0CrB;AqD9s0CgB;EjDPd,yBiDQsC;EjDzCtC,yBiD0CqC;EjDzCrC,iCiDyCqC;EjDxCrC,6BiDwCqC;ArDot0CvC;AqDjt0CY;EACI,aAAA;ArDmt0ChB;AqDjt0CY;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArDmt0ChB;AqDlt0CgB;EACI,elD0TL;AH05zCf;AqDht0CQ;EACI,elDyTG;EkDxTH,clDqED;AH6o0CX;AqDjt0CY;EAGG,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArDmt0Cf;AqDlt0Ce;EACI,eAAA;ArDot0CnB;AqDht0CQ;EACI,WAAA;ArDkt0CZ;;AqD9s0CA;EACI,kBAAA;EACA,iBAAA;ArDit0CJ;AqDht0CI;EjD9CF,kBiD+CwB;EjD9CxB,QiD8CkC;EjD3ClC,UiD2CmD;EAC7C,cAAA;EACA,2BAAA;EACA,clD4CG;AHwq0CX;AqDht0CY;EACI,YAAA;EACA,kBAAA;EACA,clDqCL;EkDpCK,gBlD/IK;AHi20CrB;AqDjt0CgB;EACI,kBAAA;EACA,iBAAA;EACA,clDgCT;EkD/BS,gBlDpJC;EkDqJD,mBAAA;ArDmt0CpB;AqDjt0CgB;EACI,YAAA;ArDmt0CpB;;AqD7s0CA;EACI,gCAAA;EACA,mBAAA;ArDgt0CJ;AqD/s0CI;EACI,mBAAA;ArDit0CR;AqDht0CQ;EACI,qBAAA;ArDkt0CZ;AqDht0CgB;EACI,4BAAA;ArDkt0CpB;AqD9s0CgB;EACI,gBAAA;ArDgt0CpB;AqD7s0CY;EjDlFT,eiDmFqC;EjDlFrC,4BiDkF8C;EACjC,elDqPD;EkDpPC,gBlDlLK;EkDmLL,qBAAA;EACA,kBAAA;EACA,mBlDnBJ;EkDoBI,clDuFF;EkDtFE,kBAAA;EACA,gBAAA;ArDgt0ChB;AqD/s0CgB;EACI,WAAA;EjDrGlB,kBiDsGoC;EjDrGpC,MiDqG8C;EjDpG9C,YiDoGgD;EAC9B,WAAA;EACA,YAAA;EACA,6CAAA;EACA,yCAAA;EACA,0CAAA;EACA,sCAAA;EACA,UAAA;EACA,mBlDjCR;EkDmCQ,wEAAA;EACA,2BAAA;ArDmt0CpB;AqDjt0CgB;EACI,WlD5JZ;AH+20CR;AqDlt0CoB;EACI,mBlD3LjB;AH+40CP;AqDlt0CoB;EACI,8BAAA;ArDot0CxB;AqDjt0CgB;EACI,WlDrKZ;AHw30CR;AqDlt0CoB;EACI,mBlDlMd;AHs50CV;AqDlt0CoB;EACI,8BAAA;ArDot0CxB;AqDjt0CgB;EACI,WlD9KZ;EkD+KY,8BAAA;ArDmt0CpB;AqDlt0CoB;EACI,mBlD/Kf;AHm40CT;AqDlt0CoB;EACI,8BAAA;ArDot0CxB;AqDjt0CgB;EACI,WlDxLZ;AH240CR;AqDlt0CoB;EACI,mBlDvLjB;AH240CP;AqDlt0CoB;EACI,8BAAA;ArDot0CxB;AqDjt0CgB;EACI,WlDjMZ;AHo50CR;AqDlt0CoB;EACI,mBlDlOd;AHs70CV;AqDlt0CoB;EACI,8BAAA;ArDot0CxB;AqDjt0CgB;EACI,WlD1MZ;AH650CR;AqDlt0CoB;EACI,mBlDrOf;AHy70CT;AqDlt0CoB;EACI,8BAAA;ArDot0CxB;AqDjt0CgB;EACI,WlDnNZ;EkDoNY,mBlDwBL;AH2r0Cf;AqDlt0CoB;EACI,mBlDsBT;AH8r0Cf;AqDlt0CoB;EACI,8BAAA;ArDot0CxB;AIv70CI;EiD4IQ;IA2FQ,wBAAA;ErDot0ClB;AACF;AI570CI;EiDgII;IA2GQ,cAAA;ErDqt0Cd;AACF;;AsD9+0CA;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;ElD8FE,gBkD7FsB;ElD8FtB,akD9FgC;ElDqHjC,kBkDpHgB;AtDk/0ClB;AIh90CI;EkD7CJ;IlDuGG,gBkD1FuB;IlD2FvB,akD3FiC;EtDq/0ClC;AACF;AsDp/0CC;EAGC,aAAA;EAGA,mBAAA;AtDs/0CF;AsDr/0CE;EACC,WAAA;EACA,YAAA;ElDuGD,kBkDtGkB;EAGjB,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WnDoBK;EmDnBL,kBAAA;AtDu/0CH;AsDr/0CE;EACC,cnDsJQ;EmDrJR,gBnD9BkB;AHqh1CrB;AsDp/0CC;EACC,cnD4IS;AH020CX;AIr/0CI;EkDFH;IAGE,enDwYY;EHgn0Cb;AACF;AI1/0CI;EkDFH;IAME,enDmYY;EHun0Cb;AACF;AsDx/0CC;EACC,yBnDiKW;AHy10Cb;AsDz/0CE;EACC,yBnDzBM;AHoh1CT;AsDx/0CC;EACC,yBnDsKY;AHo10Cd;AsDz/0CE;EACC,yBnDvCS;AHki1CZ;AsDx/0CC;EACC,yBnD2KW;AH+00Cb;AsDz/0CE;EACC,yBAAA;AtD2/0CH;AsDx/0CC;EACC,yBnDqIY;AHq30Cd;AsDz/0CE;EACC,yBnDVK;AHqg1CR;;AsDv/0CA;ElD0BG,gBkDzBsB;ElD0BtB,oBkD1BgC;EAClC,8DAAA;EACA,sBnDzBO;ECwEN,kBkD9CgB;AtD2/0ClB;AsDz/0CE;EACC,kBAAA;AtD2/0CH;AsD1/0CG;EACC,kBAAA;EACA,gBnD7EiB;EmD8EjB,6BAAA;ElDgBD,uBkDf+B;EAGrB,oBAAA;EAGN,mBAAA;EACH,uBAAA;EACG,+BAAA;EACA,qBAAA;AtD4/0CP;AsD3/0CI;EACC,qBnDhFK;AH6k1CV;AsD3/0CI;EACC,WAAA;EACA,YAAA;EAGS,oBAAA;EAGH,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;ElDaT,kBkDZ0B;EACjB,iBAAA;EACA,enDuTI;EmDtTJ,gBnD3GY;EmD4GZ,cnDiEA;AH470CX;AsD1/0CG;EACC,eAAA;AtD4/0CJ;;AsDv/0CA;EAGC,oBAAA;EAGA,mBAAA;AtD0/0CD;AsDz/0CG;EACC,kBAAA;EACF,oBAAA;AtD2/0CF;AsD1/0CE;EACC,WAAA;EACA,YAAA;AtD4/0CH;AsD1/0CI;EACC,cAAA;AtD4/0CL;AsDz/0CK;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AtD2/0CN;AsDv/0CK;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBnDvGE;EmDwGF,yBAAA;EAGF,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,enDqQW;EmDpQX,gBnD/JmB;EmDgKnB,cnDaO;AH4+0CX;;AsDn/0CC;EACC,qBAAA;EACA,kBAAA;AtDs/0CF;AsDr/0CE;EACC,gBnD1KoB;AHiq1CvB;AsDr/0CE;EACC,eAAA;EACA,gBnD9KoB;EmD+KpB,cnDFQ;AHy/0CX;AsDr/0CE;EACC,eAAA;AtDu/0CH;;AuDnr1CC;EACC,QAAA;AvDsr1CF;;AuDnr1CA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AvDsr1CD;;AuDpr1CA;EACC,aAAA;EACA,mBAAA;AvDur1CD;;AuDpr1CA;EACC,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AvDur1CD;;AuDrr1CA;EACC,gBAAA;EACA,cAAA;AvDwr1CD;;AuDnr1CG;EACC,eAAA;AvDsr1CJ;;AuDjr1CA;EACC,WAAA;EACA,YAAA;AvDor1CD;;AwD1t1CE;EACC,sBAAA;EACA,mBAAA;AxD6t1CH;;AwDxt1CC;EACC,sBAAA;EACA,0CAAA;AxD2t1CF;AwD1t1CE;EACC,uBAAA;AxD4t1CH;AwDtt1CI;EACC,4BAAA;AxDwt1CL;;AwDlt1CA;;EAEC,yBAAA;AxDqt1CD;;AwDlt1CA;;EAEC,erDbS;AHku1CV;;AwDnt1CA;;EAEE,yCAAA;AxDst1CF;;AwDpt1CA;;EAEC,oBAAA;EACA,6BAAA;EACA,wBAAA;EACA,oBAAA;EACA,crDzBS;EqD0BT,arD1BS;AHiv1CV;;AwDrt1CA;EACI,crD7BM;EqD8BN,arD9BM;AHsv1CV;;AwDtt1CE;EACE,8BAAA;EACA,gBAAA;AxDyt1CJ;;AwDvt1CA;EACI,qBrDrCM;EqDsCN,yBrDtCM;EqDuCN,WAAA;AxD0t1CJ;;AwDxt1CA;EACI,kBAAA;AxD2t1CJ;;AwDzt1CA;EACI,UAAA;EAGE,aAAA;EAEA,eAAA;AxD4t1CN;AwD3t1CM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,erD+VO;ECpTb,mBoD1CuB;EACjB,yBAAA;EACA,WAAA;EpDoDN,wCAAA;AJ4q1CF;AwD7t1CI;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,erD2US;ECpTb,mBoDtBqB;EACjB,yBAAA;EACA,WAAA;AxD8t1CN;AwD7t1CQ;EACI,yBrDyED;EqDxEC,crD1FF;EqD2FE,eAAA;AxD+t1CZ;;AwDzt1CA,wBAAA;AAGM;EACE,yBrDrGE;EqDsGF,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AxD0t1CR;AwDzt1CQ;EACE,yBrDjGD;EqDkGC,WrDzEF;AHoy1CR;AwDzt1CQ;EACE,yBrD/GA;EqDgHA,yBAAA;EACA,WrD9EF;AHyy1CR;AwDxt1CM;EACE,0CAAA;AxD0t1CR;AwDxt1CM;EACE,qBAAA;EACA,0CAAA;AxD0t1CR;AwDtt1CM;EACE,yCAAA;EACA,yCAAA;AxDwt1CR;AwDrt1CI;EACE,YAAA;AxDut1CN;;AwDpt1CE;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBrDvGI;EqDwGJ,yBAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;AxDut1CJ;;AwDrt1CE;EACE,eAAA;AxDwt1CJ;AwDvt1CI;EACE,qBAAA;AxDyt1CN;;AwDtt1CE;EACE,yCAAA;EACA,gBAAA;AxDyt1CJ;;AwDvt1CE,sBAAA;AAGA,wBAAA;AACA;;;;;EAKE,gBAAA;EACA,WAAA;AxDwt1CJ;;AwDrt1CE,sBAAA;AAEA,uBAAA;AACA;EACE,yBrD3II;EqD4IJ,crDqFS;EqDpFT,yBAAA;EACA,eAAA;AxDut1CJ;;AwDrt1CE;;;;;;;;EAQE,iBAAA;AxDwt1CJ;;AwDrt1CE;EACE,yBAAA;AxDwt1CJ;;AwDht1CI;;;;;EACE,aAAA;AxDut1CN;;AwDnt1CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AxDst1CJ;;AwDnt1CE;EACE,sBAAA;AxDst1CJ;;AwDnt1CE;EACE,arD+CS;AHuq1Cb;;AwDnt1CE,qBAAA;AAEA,uBAAA;AACA;;;;;;EAME,gBAAA;AxDqt1CJ;;AwDlt1CE;EACE,cAAA;EACA,kBAAA;EACA,WrDvMI;EqDwMJ,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBrD9OM;EqD+ON,8BAAA;EACA,sBAAA;EACA,kBAAA;AxDqt1CJ;;AwDlt1CE;EACE,uBAAA;EACA,0BAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AxDqt1CJ;;AwDlt1CE;EACE,0BAAA;EACA,+CAAA;EACA,yCAAA;EACA,sCAAA;AxDqt1CJ;;AwDlt1CE;EACE,4BAAA;EACA,2CAAA;EACA,yCAAA;EACA,oCAAA;AxDqt1CJ;;AwDlt1CE,qBAAA;AAGA,kBAAA;AACA;EACE,UAAA;AxDmt1CJ;;AwDht1CI;EACE,iBAAA;AxDmt1CN;;AwD/s1CE;EACE,sBrDrPI;EqDsPJ,8DrDwHS;EqDvHT,yBAAA;EACA,erD3Sa;AH6/1CjB;;AwD/s1CE;;EAEE,WrD5PI;EqD6PJ,UrD7PI;AH+81CR;;AwDht1CE;EACE,eAAA;AxDmt1CJ;;AwDjt1CE;EACE,4BAAA;AxDot1CJ;;AwDlt1CE;EACE,4BAAA;AxDqt1CJ;;AwDnt1CE;;EAEE,WrD1QI;AHg+1CR;;AwDnt1CE;EACE,crDlTM;AHwg2CV;;AwDnt1CE;EACE,gBAAA;AxDst1CJ;;AwDnt1CE;EACE,sBrDvRI;EqDwRJ,mBAAA;AxDst1CJ;;AwDnt1CE;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,arDnUM;AHyh2CV;;AwDnt1CE;EACE,gBAAA;AxDst1CJ;;AwDnt1CE;EACE,YAAA;AxDst1CJ;;AwDnt1CE;EACE,sBAAA;EACA,0BAAA;AxDst1CJ;;AwDnt1CE;EACE,uBAAA;AxDst1CJ;;AwDnt1CE;;EAEE,yBrDlFS;AHwy1Cb;;AwDnt1CE;EACE,4BrDtFS;AH4y1Cb;;AwDnt1CE;;;EAGE,gBAAA;AxDst1CJ;;AwDnt1CE;EACE,crDjMO;EqDkMP,gBAAA;AxDst1CJ;AwDpt1CI;EAEE,YAAA;AxDqt1CN;;AwDjt1CE;EACE,qBrDjXM;EqDkXN,yBrDlXM;EqDmXN,WrDhVI;AHoi2CR;;AwDjt1CE;;;;;;;;;;;;;;;;;;EAkBE,mBrDxYM;EqDyYN,WrDtWI;EqDuWJ,qBrD1YM;AH8l2CV;;AwDjt1CE;;;;;;;;;;;;EAYE,mBrDjJiB;EqDkJjB,qBrD5PQ;AHg91CZ;;AwDjt1CE;EACE,yBrD9ZM;EqD+ZN,qBrD/ZM;EqDgaN,WrD7XI;AHil2CR;;AwDjt1CE;EACE,6BAAA;AxDot1CJ;;AwDjt1CE;;EAEE,4BrD3QQ;AH+91CZ;;AwDjt1CE;;EAEE,yBrDhRQ;AHo+1CZ;;AwDjt1CE;;;;EAIE,mBrD7KiB;AHi41CrB;;AwDjt1CE;;EAEE,crDnLS;AHu41Cb;;AwDjt1CE;EACE,qBAAA;AxDot1CJ;;AwDht1CE;;EAEE,oBAAA;EACA,6BAAA;EACA,wBAAA;EACA,oBAAA;EACA,crDxcM;EqDycN,arDzcM;AH4p2CV;;AwDht1CE;EACE;IACE,4BAAA;ExDmt1CJ;AACF;AwDht1CE;EACE,mCAAA;AxDkt1CJ;;AwD/s1CE;EACE,cAAA;AxDkt1CJ;;AwD/s1CE;EACE,aAAA;AxDkt1CJ;;AwD/s1CE;EACE,WAAA;AxDkt1CJ;;AwD7s1CM;EACE,OAAA;EACA,cAAA;AxDgt1CR;;AwD3s1CE;EACE;IACE,YAAA;ExD8s1CJ;AACF;AwD3s1CE;EACE,wBAAA;AxD6s1CJ;;AwD1s1CE;;EAEE,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AxD6s1CJ;;AwD1s1CE;;EAEE,erDhgBM;AH6s2CV;;AwD1s1CE;EACE,gBAAA;AxD6s1CJ;;AwD1s1CE;EACE,uBAAA;AxD6s1CJ;;AwD1s1CE;EACE,WAAA;AxD6s1CJ;;AwD1s1CE;EACE,+BrDhhBM;AH6t2CV;;AwD1s1CE;;EAEE,UrDlfI;AH+r2CR;;AwD1s1CE;EACE,uBAAA;AxD6s1CJ;;AwD1s1CE;EACE,8CAAA;EACA,4CAAA;EACA,uCAAA;EACA,sBAAA;AxD6s1CJ;;AwD1s1CE;EACE,iCrDpiBM;AHiv2CV;;AwD1s1CE;EACE,8CAAA;EACA,4CAAA;EACA,yCAAA;EACA,sBAAA;AxD6s1CJ;;AwD1s1CE;EACE,crD/iBM;EqDgjBN,gBAAA;AxD6s1CJ;;AwD1s1CE;EACE,crDpjBM;EqDqjBN,arDrjBM;AHkw2CV;;AwD1s1CE;;EAEE,crD1jBM;AHuw2CV;;AwD1s1CE;EACE,gBrD3hBI;AHwu2CR;;AwD1s1CE;EACE,crD5ZO;EqD6ZP,mBrD3TiB;AHwg2CrB;;AwDvs1CI;;;EACE,aAAA;AxD4s1CN;;AwDxs1CE;EACE,yBAAA;AxD2s1CJ;;AwDxs1CE;;EAEE,2BAAA;AxD2s1CJ;;AwDxs1CE;EACE,2BAAA;AxD2s1CJ;;AwDxs1CE,gBAAA;AAEA,sBAAA;AACF;EACI,kBAAA;AxD0s1CJ;;AwDts1CI;EACE,cAAA;AxDys1CN;AwDts1CI;EACE,cAAA;AxDws1CN;;AwDps1CE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AxDus1CJ;;AwDps1CE;;EAEE,eAAA;EACA,gBAAA;EACA,WrDplBI;EqDqlBJ,0CAAA;EACA,kBAAA;AxDus1CJ;;AwDps1CE;;EAEE,kBAAA;EACA,gBAAA;AxDus1CJ;;AwDps1CE;EACE,YAAA;AxDus1CJ;;AwDps1CE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBrDvmBI;AH8y2CR;;AwDps1CE;EACE,gBrD3mBI;AHkz2CR;;AwDps1CE;EACE,mBrD9oBM;AHq12CV;;AwDps1CE;EACE,WrDnnBI;AH0z2CR;;AwDns1CI;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,0CAAA;EACA,WrD5nBE;EqD6nBF,UAAA;AxDss1CN;AwDps1CM;EACE,sBrDhoBA;EqDioBA,WrDhoBA;AHs02CR;;AwDjs1CE;EACE,0CAAA;AxDos1CJ;;AwDjs1CE;EACE,sBrD3oBI;AH+02CR;;AwDjs1CE;EACE,iBAAA;AxDos1CJ;;AwDjs1CE;EACE,WAAA;EACA,WAAA;AxDos1CJ;;AwDjs1CE;EACE,WAAA;EACA,sBAAA;EACA,eAAA;AxDos1CJ;;AwDjs1CE;EACE,UAAA;EACA,YAAA;EACA,YAAA;AxDos1CJ;;AwDjs1CE;EACE,UAAA;AxDos1CJ;;AwDjs1CE;EACE,yBAAA;AxDos1CJ;;AwDjs1CE;EACE,kBAAA;AxDos1CJ;;AwDjs1CE,oBAAA;ACruBE;EACE,mBtDqEQ;AHq22Cd;;AyDt62CI;ErDyHF,kBqDxHuB;AzDy62CzB;AyDx62CQ;EACI,mBtD8DE;EsD7DF,yBAAA;AzD062CZ;;AyDr62CI;EACI,kBAAA;EACA,oBAAA;AzDw62CR;AyDv62CQ;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,oBAAA;EACA,gBtD+BA;EsD9BA,UAAA;AzDy62CR;AyDx62CQ;EACI,ctDKL;EsDJK,UAAA;AzD062CZ;AyDv62CQ;EACA,oBAAA;AzDy62CR;AyDx62CQ;EACI,QAAA;EACA,gCAAA;EACA,oBAAA;EACA,YAAA;AzD062CZ;AyDv62CQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBtDgJD;EsD/IC,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AzDy62CZ;AyDt62CQ;EACA,oBAAA;AzDw62CR;;AyDp62CA;EACI,iBAAA;EACA,kBAAA;AzDu62CJ;;AyDr62CA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;AzDw62CJ;;AyDr62CI;EACE,kBAAA;AzDw62CN;AyDv62CM;EACE,iBAAA;EACA,kBAAA;AzDy62CR;AyDx62CQ;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AzD062CV;;AyDr62CA;EACI,aAAA;EACA,mBAAA;AzDw62CJ;AyDv62CI;EACE,WAAA;EACA,YAAA;EACA,gBtDrCE;EsDsCF,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzDy62CN;AyDx62CM;EACE,mBtDnED;EsDoEC,WtD7CA;AHu92CR;;AyDt62CA;EACI,yBAAA;AzDy62CJ;;AyDv62CA;EACI,yBAAA;AzD062CJ;;AyDx62CA;EACI,mBtDkEQ;EsDjER,ctDhFG;AH2/2CP;;AyDz62CA;EACI,gBAAA;EACA,gBAAA;AzD462CJ;;AyD162CA;EACI,yBAAA;AzD662CJ;;AyD362CA;EACI,mBAAA;AzD862CJ;;AyD562CA;EACI,mBAAA;AzD+62CJ;;AyD762CA;EACI,mBAAA;EACA,cAAA;AzDg72CJ;;AyD962CA;EACI,oCAAA;AzDi72CJ;;AyD/62CA;EACI,gBtDhFI;AHkg3CR;;A0Dzj3CA;EACI,uBAAA;EACA,mBvDiEO;EC4DT,kBsD5HmB;EACjB,kBAAA;EACA,UAAA;A1D4j3CJ;AIph3CI;EsD7CJ;IAOQ,sBAAA;E1D8j3CN;AACF;A0D7j3CI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;A1D+j3CR;A0D7j3CI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;A1D+j3CR;A0D7j3CI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;A1D+j3CR;A0D7j3CI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;A1D+j3CR;;A0Dzj3CY;EACI,avDjBN;AH6k3CV;;A0Dvj3CA;EACI,yBAAA;A1D0j3CJ;;A2Drm3CA;EACI,aAAA;A3Dwm3CJ;A2Dvm3CI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;A3Dym3CR;A2Dxm3CQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBxD4KD;AH872CX;;A2Dtm3CA;EACI,kBAAA;EACA,UAAA;A3Dym3CJ;A2Dxm3CI;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;A3D0m3CR;;A2Dnm3CgB;EACI,aAAA;A3Dsm3CpB;;A2Dhm3CA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;A3Dmm3CJ;;A2Djm3CA;EACI,kBAAA;A3Dom3CJ;;ACzk3CA,uBAAA;A2DzEA;EACI,0BAAA;EACA,WAAA;A5Dsp3CJ;A4Drp3CI;EACI,YAAA;A5Dup3CR;;A4Dnp3CI;EACI,0CAAA;EAAA,yDAAA;ExDsHN,kBwDrHuB;A5Dsp3CzB;A4Drp3CQ;EACI,czD0QC;EyDzQD,iBAAA;ExDkHV,kBwDjH2B;EACjB,kBAAA;EACA,ezDgaG;EyD/ZH,gBzDRS;EyDST,mBAAA;A5Dup3CZ;A4Dtp3Ca;EAGG,oBAAA;EAGA,mBAAA;A5Dwp3ChB;A4Dvp3CgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A5Dyp3CpB;A4Drp3CQ;EACI,YAAA;A5Dup3CZ;A4Drp3CQ;EACI,YAAA;EACA,UAAA;A5Dup3CZ;;A4Dnp3CA;ExDoDE,kBwDnDoB;ExDoDpB,QwDpD6B;ExDuD7B,SwDvD2C;EACzC,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;ExDMF,yCwDLqB;ExDMrB,iDwDNqB;ExDOrB,6CwDPqB;A5D0p3CvB;;A4Dxp3CA;EACI,kBAAA;EACA,yBAAA;EACA,eAAA;ExD8CD,YwD7C+B;A5D2p3ClC;;A4Dzp3CA;EACI,mBzD1CM;EyD2CN,WzDRI;AHoq3CR;;A4Dzp3CI;EACI,2BAAA;EACA,qBzDhDE;AH4s3CV;;A4Dzp3CA;EACI,aAAA;A5D4p3CJ;;A4D1p3CA;;EAEI,6DAAA;A5D6p3CJ;;A4D3p3CA;;;;;;;EAOI,qBzD6FQ;EyD5FR,czDgMS;EyD/LT,YAAA;EACA,iBAAA;A5D8p3CJ;;A4D5p3CA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;A5D+p3CJ;A4D9p3CI;EACI,iBAAA;EACA,mBAAA;A5Dgq3CR;A4D7p3CQ;EAGI,oBAAA;EAGA,mBAAA;A5D+p3CZ;A4D9p3CY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A5Dgq3ChB;A4D5p3CI;EACI,QAAA;EACA,UAAA;A5D8p3CR;;A4D1p3CI;EAGQ,oBAAA;EAGA,mBAAA;A5D6p3CZ;A4D5p3CY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A5D8p3ChB;;A4D1p3CA;;;EAGI,yBzDkCQ;EyDjCR,qBzDiCQ;EyDhCR,czD4CO;EyD3CP,kBAAA;A5D6p3CJ;;A4D3p3CA;EACI,qBzDkCQ;AH4n3CZ;;A6D9y3CA;EACI,oBAAA;EACA,sBAAA;A7Diz3CJ;;A6D/y3CA;;;;;EAKI,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gB1DNmB;E0DOnB,2BAAA;A7Dkz3CJ;;A6Dhz3CA;;;;;EAKI,sBAAA;EACA,2BAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gB1DvBmB;E0DwBnB,2BAAA;A7Dmz3CJ;;A6Dhz3CI;EACI,YAAA;A7Dmz3CR;;A6Dhz3CA;EACI,mBAAA;EACA,e1DkYW;E0DjYX,c1D8IO;E0D7IP,gB1DnCmB;AHs13CvB;;A6Djz3CA;EACI,eAAA;A7Doz3CJ;;A6Dhz3CI;EACI,oBAAA;EACA,4BAAA;EACA,kBAAA;A7Dmz3CR;A6Dlz3CQ;EzD8CL,ayD7CiC;A7Doz3CpC;A6Dnz3CY;EACI,gB1DLR;E0DMQ,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,c1DoHL;AHis3CX;A6Dpz3CgB;EACI,mB1DPZ;E0DQY,W1DhBZ;AHs03CR;A6Dnz3CY;EACI,mB1DZR;E0DaQ,qB1DbR;ECgEN,kByDlD+B;EACjB,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A7Dqz3ChB;A6Dnz3CY;EACI,WAAA;EACA,kBAAA;A7Dqz3ChB;A6Dpz3CgB;EACI,6BAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;A7Dsz3CpB;A6Drz3CoB;EACI,iBAAA;A7Duz3CxB;A6Drz3CoB;EACI,c1DjChB;AHw13CR;A6Dnz3CY;EACI,WAAA;EACA,kBAAA;A7Dqz3ChB;A6Dpz3CgB;EACI,6BAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;A7Dsz3CpB;A6Drz3CoB;EACI,gBAAA;A7Duz3CxB;A6Drz3CoB;EACI,c1DjDhB;AHw23CR;AI133CI;EyDQA;IAiEQ,uBAAA;IACA,+BAAA;IACA,qBAAA;E7Dqz3CV;AACF;;A6Dlz3CA;;EAEI,2BAAA;A7Dqz3CJ;;A6Dlz3CI;EAGI,aAAA;EAGA,mBAAA;EACA,c1D8IK;E0D7IL,e1DuSO;AH8g3Cf;A6Dpz3CQ;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,c1D+CD;E0D9CC,aAAA;A7Dsz3CZ;AIx53CI;EyDoFA;IAiBQ,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,mBAAA;E7Duz3CV;AACF;;AIh63CI;EyD4GJ;IAEQ,kBAAA;E7Duz3CN;AACF;;A6Dpz3CA;EACI,iBAAA;A7Duz3CJ;;A6Drz3CA;EACI,aAAA;A7Dwz3CJ;;A6Dtz3CA;EACI,aAAA;A7Dyz3CJ;;A6Dvz3CA;EACI,aAAA;A7D0z3CJ;;A6Dxz3CA;EACI,aAAA;A7D2z3CJ;;A6Dzz3CA;EACI,yBAAA;EACA,kBAAA;A7D4z3CJ;;A6Dxz3CQ;EACI,qB1DHA;AH8z3CZ;A6D1z3CY;EACI,c1DCL;AH2z3CX;A6Dxz3CI;EACI,qB1DVI;AHo03CZ;A6Dzz3CY;EACI,c1DDL;E0DEK,e1DiPD;E0DhPC,gB1DtLK;AHi/3CrB;;A6Dvz3CA;EACI,aAAA;EAAA,gBAAA;A7D0z3CJ;;ACj73CA;EACE,uBAAA;ADo73CF;;ACj73CA,kDAAA;AAGE;;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBErEM;EFsEN,oCAAA;EACA,2BAAA;EACA,oBAAA;ADm73CJ;ACj73CI;;EACE,gCAAA;ADo73CN;ACj73CI;;EACE,oCAAA;EACA,gCAAA;ADo73CN;ACj73CI;;EACE,oDAAA;EACA,mBAAA;ADo73CN;AC963CI;;EACE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;ADi73CN;AC763CI;;EACE,wBAAA;ADg73CN;;AC163CA;EACE,yBE5GQ;EF6GR,qBE7GQ;AH0h4CV;;AC163CA;EACE,yBEjHQ;AH8h4CV;;AC163CA;;;EAGE,qBEvHQ;AHoi4CV;;A8Dxj4CA;;;;;;;;;;EAAA;AAYA,eAAA;AACA;EACE,2BAAA;EACA,6CAAA;EACA,gBAAA;EACA,kBAAA;A9D0j4CF;A8Dxj4CA,aAAA;AACA;EACE,6BAAA;EACA;;;GAAA;A9D6j4CF;;A8Dxj4CA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;A9D2j4CF;;A8Dzj4CA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;EACA,cAAA;A9D4j4CF;;A8D1j4CA;EACE,sBAAA;A9D6j4CF;;A8D3j4CA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,mCAAA;EAAA,qFAAA;EACA,uBAAA;A9D8j4CF;;A8D5j4CA;;;EAGE,iCAAA;A9D+j4CF;;A8D7j4CA;EACE,mBAAA;A9Dgk4CF;;A8D9j4CA;EACE,mBAAA;A9Dik4CF;;A8D/j4CA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,cAAA;A9Dkk4CF;;A8Dhk4CA;EACE,kBAAA;A9Dmk4CF;;A8Djk4CA,gBAAA;AACA;;EAEE,YAAA;A9Dok4CF;;A8Dlk4CA;EACE,uBAAA;EACA,sCAAA;A9Dqk4CF;;A8Dnk4CA;EACE,wBAAA;EAEQ,2BAAA;A9Dsk4CV;;A8Dpk4CA,eAAA;AACA;EACE,mBAAA;A9Duk4CF;;A8Drk4CA;EACE,4BAAA;A9Dwk4CF;;A8Dtk4CA;EACE,mBAAA;A9Dyk4CF;;A8Dvk4CA;;EAEE,4BAAA;A9D0k4CF;;A8Dxk4CA,aAAA;AACA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mCAAA;A9D2k4CF;;A8Dzk4CA;EACE,aAAA;A9D4k4CF;;A8D1k4CA;EACE,8BAAA;A9D6k4CF;;A8D3k4CA;EACE,6BAAA;A9D8k4CF;;A8D5k4CA;EACE,6BAAA;A9D+k4CF;;A8D7k4CA;EACE,sBAAA;A9Dgl4CF;;A8D9k4CA;EACE,uBAAA;A9Dil4CF;;A8D/k4CA;EACE,WAAA;EACA,cAAA;EACA,WAAA;A9Dkl4CF;;A8Dhl4CA;EACE,gCAAA;EACA,wBAAA;A9Dml4CF;;A8Djl4CA;EACE,yDAAA;A9Dol4CF;;A8Dll4CA;EACE,YAAA;EACA,eAAA;EACA,0CAAA;A9Dql4CF;;A8Dnl4CA;EACE,wDAAA;A9Dsl4CF;;A8Dpl4CA;EACE,WAAA;EACA,cAAA;EACA,2CAAA;A9Dul4CF;;A8Drl4CA,uBAAA;AACA,eAAA;AACA;;;;;;;;;;EAUE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;A9Dwl4CF;;A8Dtl4CA;EACE,+BAAA;A9Dyl4CF;;A8Dvl4CA;EACE,gFAAA;A9D0l4CF;;A8Dxl4CA;EACE,iFAAA;A9D2l4CF;;A8Dzl4CA;EACE,+EAAA;A9D4l4CF;;A8D1l4CA;EACE,kFAAA;A9D6l4CF;;A8D3l4CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EAAA,0EAAA;EACA,kBAAA;EACA,6BAAA;A9D8l4CF;;A8D5l4CA;;EAEE,mDAAA;A9D+l4CF;;A8D7l4CA;EACE,8BAAA;A9Dgm4CF;;A8D9l4CA;EACE,8BAAA;A9Dim4CF;;A8D/l4CA;EACE;IACE,uBAAA;E9Dkm4CF;E8Dhm4CA;IACE,yBAAA;E9Dkm4CF;AACF;A8Dhm4CA,qBAAA;AACA;EACE,mCAAA;EACA,wBAAA;A9Dkm4CF;;A8Dhm4CA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,oBAAA;A9Dmm4CF;;A8Djm4CA;EACE,WAAA;EACA,iCAAA;A9Dom4CF;;A8Dlm4CA;EACE,UAAA;EACA,kCAAA;A9Dqm4CF;;A8Dnm4CA;EACE,8BAAA;EACA;;;;GAAA;A9D0m4CF;;A8Dpm4CA;;EAEE,kBAAA;EACA,QAAA;EAAA,6CAAA;EACA,2BAAA;EAAA,oDAAA;EACA,YAAA;EAAA,qCAAA;EACA,gCAAA;EAAA,yDAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EAAA,gEAAA;A9Dum4CF;;A8Drm4CA;;EAEE,aAAA;EACA,YAAA;EACA,oBAAA;A9Dwm4CF;;A8Dtm4CA;;EAEE,UAAA;EACA,YAAA;EACA,oBAAA;A9Dym4CF;;A8Dvm4CA;;EAEE,wBAAA;A9D0m4CF;;A8Dxm4CA;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;A9D2m4CF;;A8Dzm4CA;;EAEE,yBAAA;A9D4m4CF;;A8D1m4CA;;EAEE,UAAA;EAAA,iDAAA;EACA,WAAA;A9D6m4CF;;A8D3m4CA;;EAEE,WAAA;EAAA,kDAAA;EACA,UAAA;A9D8m4CF;;A8D5m4CA;EACE,aAAA;A9D+m4CF;;A8D7m4CA,0BAAA;AACA;;EAEE,yBAAA;EACA,eAAA;EAAA,wCAAA;EACA,+BAAA;EACA,iBAAA;EACA,uBAAA;EAAA,oBAAA;EAAA,qBAAA;EACA,cAAA;A9Dgn4CF;;A8D9m4CA;;EAEE,eAAA;A9Din4CF;;A8D/m4CA;;EAEE,WAAA;EAAA,kDAAA;EACA,UAAA;A9Dkn4CF;;A8Dhn4CA;;EAEE,eAAA;A9Dmn4CF;;A8Djn4CA,wBAAA;AACA;EACE;;;;;;;;;;;;;;;;;;GAAA;A9Dso4CF;;A8Dln4CA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;A9Dqn4CF;;A8Dnn4CA;EACE,UAAA;A9Dsn4CF;;A8Dpn4CA;;EAEE,wBAAA;A9Dun4CF;;A8Drn4CA,kBAAA;AACA;;;;EAIE,WAAA;EAAA,4CAAA;EACA,SAAA;EAAA,uCAAA;EACA,OAAA;EACA,WAAA;A9Dwn4CF;;A8Dtn4CA,YAAA;AACA;EACE,gBAAA;EACA,YAAA;A9Dyn4CF;;A8Dvn4CA;EACE,sBAAA;EACA,kBAAA;A9D0n4CF;;A8Dxn4CA;EACE,mBAAA;A9D2n4CF;;A8Dzn4CA;EACE,mBAAA;A9D4n4CF;;A8D1n4CA;EACE,sBAAA;A9D6n4CF;;A8D3n4CA;EACE,sBAAA;A9D8n4CF;;A8D5n4CA;EACE,sBAAA;A9D+n4CF;;A8D7n4CA;EACE,sBAAA;A9Dgo4CF;;A8D9n4CA;EACE,UAAA;EAAA,uFAAA;EACA,WAAA;EAAA,yFAAA;EACA,qBAAA;EACA,kBAAA;EAAA,iEAAA;EACA,gBAAA;EAAA,gEAAA;EACA,YAAA;EAAA,8DAAA;A9Dio4CF;;A8D/n4CA;EACE,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EAEQ,gBAAA;A9Dko4CV;;A8Dho4CA;EACE,eAAA;A9Dmo4CF;;A8Djo4CA;EACE,wBAAA;A9Doo4CF;;A8Dlo4CA;EACE,UAAA;EAAA,mDAAA;EACA,mBAAA;EAAA,qEAAA;A9Dqo4CF;;A8Dno4CA;;EAEE,UAAA;EAAA,0CAAA;EACA,UAAA;EAAA,yCAAA;EACA,QAAA;EACA,oCAAA;A9Dso4CF;;A8Dpo4CA;;EAEE,aAAA;EAAA,2DAAA;EACA,cAAA;A9Duo4CF;;A8Dro4CA;;EAEE,QAAA;EACA,2BAAA;EACA,UAAA;A9Dwo4CF;;A8Dto4CA;;EAEE,qBAAA;EACA,sCAAA;A9Dyo4CF;;A8Dto4CA;;EAEE,aAAA;EAAA,6DAAA;A9Dyo4CF;;A8Dvo4CA;;EAEE,SAAA;EACA,2BAAA;EACA,mBAAA;A9D0o4CF;;A8Dxo4CA;;EAEE,uCAAA;A9D2o4CF;;A8Dxo4CA;EACE,wCAAA;A9D2o4CF;;A8Dxo4CA,aAAA;AACA;EACE,cAAA;EAAA,uDAAA;A9D2o4CF;;A8Dzo4CA,aAAA;AACA;EACE,+BAAA;EAAA,8EAAA;EACA,kBAAA;A9D4o4CF;;A8D1o4CA;EACE,mBAAA;EAAA,qEAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;A9D6o4CF;;A8D3o4CA;EACE,2BAAA;A9D8o4CF;;A8D5o4CA;;;;EAIE,WAAA;EACA,WAAA;EAAA,sDAAA;EACA,OAAA;EACA,MAAA;A9D+o4CF;;A8D7o4CA;;;;EAIE,UAAA;EAAA,qDAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;A9Dgp4CF;;A8D9o4CA;EACE,aAAA;A9Dip4CF;;A8D/o4CA;EACE;;;;;;;;;;GAAA;A9D4p4CF;;A8Dhp4CA;EACE,mBAAA;EAAA,0DAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EAAA,gEAAA;A9Dmp4CF;;A8Djp4CA;;EAEE,wBAAA;A9Dop4CF;;A8Dlp4CA;;EAEE,kBAAA;EACA,QAAA;EAAA,8CAAA;EACA,WAAA;EAAA,2CAAA;EACA,SAAA;EAAA,sCAAA;EACA,WAAA;EACA,WAAA;EAAA,yCAAA;EACA,0BAAA;EAAA,gEAAA;A9Dqp4CF;;A8Dnp4CA;;EAEE,kBAAA;EACA,UAAA;EAAA,wCAAA;EACA,UAAA;EAAA,yCAAA;EACA,OAAA;EAAA,6CAAA;EACA,WAAA;EACA,UAAA;EAAA,wCAAA;EACA,2BAAA;EAAA,iEAAA;A9Dsp4CF;;A8Dpp4CA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EAAA,qEAAA;EACA,mBAAA;EAAA,0DAAA;EACA,OAAA;EACA,MAAA;A9Dup4CF;;A8Drp4CA;EACE,YAAA;A9Dwp4CF;;A8Dtp4CA;EACE,aAAA;A9Dyp4CF;;A8Dvp4CA,gCAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A9D0p4CF;;A8Dxp4CA;;;EAGE,eAAA;EACA,gBAAA;EACA,mBAAA;A9D2p4CF;;A8Dzp4CA,8BAAA;AACA;EACE,YAAA;EACA,kBAAA;A9D4p4CF;;A8D1p4CA,SAAA;AACA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;A9D6p4CF;;A8D3p4CA;EACE,oCAAA;EACA,cAAA;A9D8p4CF;;A8D5p4CA;EACE,eAAA;A9D+p4CF;;A8D7p4CA;EACE,eAAA;EACA,sBAAA;A9Dgq4CF;;A8D9p4CA;EACE,oCAAA;A9Diq4CF;;A8D/p4CA;EACE,oBAAA;EACA,4BAAA;A9Dkq4CF;;A8Dhq4CA;EACE,oBAAA;A9Dmq4CF;;A8Djq4CA;EACE,oBAAA;A9Doq4CF;;A8Dlq4CA;EACE,oBAAA;A9Dqq4CF;;A8Dnq4CA;EACE,iBAAA;A9Dsq4CF;;A8Dpq4CA;EACE,oBAAA;EAEQ,2BAAA;EACR,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;A9Duq4CF;;A8Drq4CA;EACE,oBAAA;A9Dwq4CF;;A8Dtq4CA;EACE,wBAAA;A9Dyq4CF;;A8Dvq4CA;;EAEE,oBAAA;A9D0q4CF;;A8Dxq4CA;;;EAGE,oBAAA;EACA,mBAAA;A9D2q4CF;;A8Dzq4CA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;A9D4q4CF;;A8D1q4CA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;A9D6q4CF;;A8D3q4CA;EACE,oBAAA;EACA,mBAAA;A9D8q4CF;;A8D5q4CA,6BAAA;AACA;;;;EAIE,UAAA;EAEQ,2BAAA;A9D+q4CV;;A8D7q4CA,2BAAA;AACA;EACE,iBAAA;A9Dgr4CF;;A8D9q4CA;EACE,oBAAA;EAEQ,2BAAA;EACR,UAAA;A9Dir4CF;;A8D/q4CA;EACE,oBAAA;A9Dkr4CF;;A8Dhr4CA;;EAEE,oBAAA;A9Dmr4CF;;A8Djr4CA,6BAAA;AACA;;;;EAIE,UAAA;EAEQ,2BAAA;A9Dor4CV;;A8Dlr4CA,2BAAA;AACA;EAEU,2BAAA;EACR,gBAAA;EACA,+CAAA;A9Dqr4CF;;A8Dnr4CA;EACE,iBAAA;A9Dsr4CF;;A8Dpr4CA;EACE,+BAAA;EAEQ,2BAAA;EACR,gBAAA;A9Dur4CF;;AA745CA;EACE,qBAAA;EACA,cAAA;AAg55CF;;AA745CA;EACE,aAAA;AAg55CF;;AAz45CQ;EACE,sBAAA;AA445CV;AAx45CM;EACE,eAAA;AA045CR;;AAp45CA;EACE,sBAAA;EACA,gBAAA;AAu45CF;;AAn45CA;EACE,mBAAA;EACA,qBAAA;AAs45CF;AAp45CE;;EAEE,WAAA;AAs45CJ;AAn45CE;EACE,qBAAA;AAq45CJ;;AAh45CA;;EAEE,mBAAA;AAm45CF;;AA/35CA;;EAEE,yBAAA;EACA,WAAA;AAk45CF;;AA/35CA;EACE,sBAAA;AAk45CF;;AA/35CA;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;AAk45CF;;AA935CA;EACE,aAAA;AAi45CF;;AA735CA;EACE,kBAAA;EACA,eG2Va;EH1Vb,gBAAA;EACA,eAAA;EACA,WG/BM;AH+55CR;;AA735CA;EACE,oCAAA;AAg45CF;AA935CE;EACE,mDAAA;AAg45CJ;AA735CE;EACE,oDAAA;AA+35CJ;AA535CE;EACE,mDAAA;AA835CJ;AA335CE;EACE,oDAAA;AA635CJ;AA135CE;EACE,oCAAA;AA435CJ;;AAp35CA;EACE,sBAAA;AAu35CF;;AAr25CA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAw25CF;;AAr25CA;EACE,MAAA;EACA,gBAAA;AAw25CF;;AAp25CA;;EAEE,kBAAA;AAu25CF;;AAp25CA;;EAEE,gBAAA;EACA,qBAAA;EACA,6DAAA;EACA,kBAAA;AAu25CF;;AAp25CA;EACE,yBAAA;AAu25CF;;AAp25CA;EACE,oCAAA;AAu25CF;;AAn25CA;EACE,uBAAA;AAs25CF;;AAn25CA;EACE,cAAA;EACA,UAAA;EACA,SAAA;AAs25CF;;AAn25CA;EACE,UAAA;AAs25CF;;AAn25CA;EACE,aAAA;EAEA,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAq25CF;;AAl25CA;EACE,4BAAA;AAq25CF;;AAl25CA;EACE,aAAA;EACA,eAAA;AAq25CF;;AAl25CA;EACE,4BAAA;AAq25CF;;AAl25CA;EACE,yBAAA;EACA,yBAAA;AAq25CF;;AAl25CA;EACE,yBAAA;AAq25CF;;AAl25CA;EACE,yBAAA;AAq25CF;;AA/15CA;EACE,gBAAA;AAk25CF;;AA115CA;;;;EAIE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA615CF;;AA115CA;EACE,aAAA;EACA,mBAAA;AA615CF;;AA115CA;;EAEE,gCAAA;AA615CF;;AA115CA;EACE,mBAAA;AA615CF;;AA115CA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,6DAAA;AA615CF;;AA115CA;EACE,aAAA;EACA,mBAAA;AA615CF;;AA115CA;;EAEE,eAAA;AA615CF;;AA115CA;EACE,WAAA;AA615CF;;AA115CA;EACE,qBAAA;EACA,cAAA;EACA,6DAAA;AA615CF;;AA115CA;EACE,eAAA;AA615CF;;AA115CA;;EAEE,WAAA;AA615CF;;AA115CA;EACE,wBAAA;AA615CF;;AA115CA;EACE,gBAAA;EACA,MAAA;AA615CF;;AA115CA;EACE,iBAAA;EACA,cAAA;AA615CF;;AA115CA;EACE,WAAA;AA615CF;;AA115CA;EACE,sBAAA;AA615CF;;AA115CA;EACE,kBAAA;AA615CF;;AA115CA;;EAEE,kBAAA;AA615CF;;AA115CA;;EAEE,kBAAA;AA615CF;;AA115CA;;EAEE,UAAA;AA615CF;;AA115CA;;EAEE,kBAAA;AA615CF;;AA115CA;;;EAGE,yBAAA;EACA,cAAA;AA615CF;;AA115CA;;EAEE,cAAA;AA615CF;;AAv15CA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AA015CF;;AAv15CA;EACE,aAAA;AA015CF;;AAv15CA;EACE,yBAAA;EACA,kBAAA;AA015CF;;AAv15CA;EACE,kBAAA;AA015CF;;AAv15CA;EACE,cAAA;AA015CF;;AAv15CA;EACE,aAAA;AA015CF;;AAv15CA;;EAEE,yBAAA;AA015CF;;AAv15CA;EACE,yBAAA;AA015CF;;AAv15CA;EACE,qBAAA;AA015CF;;AAv15CA;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;AA015CF;;AAv15CA;EACE,qBAAA;EACA,6BAAA;AA015CF;;AAv15CA;EACE,qBAAA;AA015CF;;AAv15CA;EACE,qBAAA;EACA,6BAAA;AA015CF;;AAt15CE;EACE,yBAAA;AAy15CJ;AAt15CE;;EAEE,qBAAA;AAw15CJ;AAr15CE;EACE,mBAAA;AAu15CJ;AAn15CE;EACE,mBAAA;AAq15CJ;AAl15CE;EACE,yBAAA;AAo15CJ;AAj15CE;EACE,yBAAA;EACA,yBAAA;AAm15CJ;AAh15CE;;EAEE,yBAAA;AAk15CJ;AA/05CE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAi15CJ;AA905CE;EACE,cAAA;AAg15CJ;AA705CE;EACE,oCAAA;AA+05CJ;AA505CE;EACE,yBAAA;AA805CJ;AA305CE;EACE,8BAAA;AA605CJ;AA105CE;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AA405CJ;AAz05CE;EACE,yBAAA;EACA,yBAAA;AA205CJ;AAx05CE;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AA005CJ;AAv05CE;EACE,yBAAA;AAy05CJ;AAt05CE;EACE,yBAAA;AAw05CJ;;AAl05CI;EACE,yBAAA;AAq05CN;;AA9z5CI;EACE,yBAAA;AAi05CN;;AA1z5CI;EACE,yBAAA;AA6z5CN;;AAxz5CA;EACE,cAAA;AA2z5CF;;AAxz5CA;EACE,yBAAA;AA2z5CF;;AAxz5CA;EACE,yBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,yBAAA;EACA,WAAA;AA2z5CF;;AAxz5CA;EACE,yBAAA;EACA,WAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,WAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,yBAAA;EACA,qBAAA;AA2z5CF;;AAxz5CA;;EAEE,kBAAA;EACA,gBAAA;AA2z5CF;;AAxz5CA;EACE,yBAAA;AA2z5CF;;AAxz5CA;EACE,wBAAA;AA2z5CF;;AAxz5CA;EACE,iBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;AA2z5CF;;AAxz5CA;EACE,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AA2z5CF;;AAxz5CA;EACE,2BAAA;AA2z5CF;;AAxz5CA;EACE,2BAAA;AA2z5CF;;AAxz5CA;EACE,6BAAA;AA2z5CF;;AAxz5CA;EACE,uBAAA;AA2z5CF;;AAxz5CA;EACE,+CAAA;AA2z5CF;;AAxz5CA;EACE,2BAAA;AA2z5CF;;AAxz5CA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,oBAAA;EAEA,WAAA;EACA,kBAAA;AA0z5CF;;AAvz5CA;EACE,QAAA;EACA,UAAA;EACA,+BAAA;EACA,UAAA;EACA,+BAAA;EACA,eAAA;AA0z5CF;;AAvz5CA;EACE,gCAAA;AA0z5CF;;AAvz5CA;EACE,sBAAA;EACA,uBAAA;AA0z5CF;;AAvz5CA;EACE,gBAAA;AA0z5CF;;AAvz5CA;EACE,oBAAA;AA0z5CF;;AAvz5CA;EACE,0BAAA;EACA,uBAAA;EACA,6BAAA;AA0z5CF;;AAvz5CA;EACE,YAAA;AA0z5CF;;AAvz5CA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;AA0z5CF;;AAvz5CA;EACE,kBAAA;AA0z5CF;;AAvz5CA;EACE,6BAAA;AA0z5CF","sourcesContent":["@import \"./style/scss/main.scss\";\n@import \"react-time-picker/dist/TimePicker.css\";\n@import \"react-clock/dist/Clock.css\";\n@import 'react-datepicker/dist/react-datepicker.css';\n@import './style/datepicker-brand.css';\n@import 'swiper/css/bundle';\n\na {\n  text-decoration: none;\n  color: #262a2a;\n}\n\n.ant-tooltip {\n  display: none;\n}\n\n.data-table-card {\n  .ant-table-content {\n    .ant-table-tbody {\n      tr {\n        &:nth-of-type(2n + 1) {\n          background-color: #fff;\n        }\n      }\n\n      td {\n        padding: 0.5rem;\n      }\n    }\n  }\n}\n\n.ant-table-cell-row-hover {\n  background-color: #fff;\n  background: #fff;\n}\n\n// ant datatable pagination\n.ant-pagination-item.ant-pagination-item-active {\n  background: #e85b28;\n  border-color: #e85b28;\n\n  a,\n  .ant-pagination-item-link {\n    color: #fff;\n  }\n\n  &:hover {\n    border-color: #e85b28;\n  }\n}\n\n// manage columns in datatable page\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\n\n// date range picker\n.daterangepicker td.active,\n.daterangepicker td.active:hover {\n  background-color: #e85b28;\n  color: #fff;\n}\n\n.daterangepicker .calendar-table td.in-range {\n  background-color: #fff;\n}\n\n.applyBtn.btn.btn-sm.btn-primary {\n  color: #fff;\n  background-color: #e85b28;\n  border: 1px solid #e85b28;\n}\n\n// react-select plugin\n.css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n//compaign data table\ndiv .badge-status {\n  border-radius: 5px;\n  font-size: $font-size-12;\n  padding: 4px 8px;\n  min-width: 64px;\n  color: $white;\n}\n\ndiv .bg-success {\n  background-color: $success !important;\n\n  &.bg-opacity-10 {\n    background-color: rgba($success, 0.1) !important;\n  }\n\n  &.bg-opacity-25 {\n    background-color: rgba($success, 0.25) !important;\n  }\n\n  &.bg-opacity-50 {\n    background-color: rgba($success, 0.5) !important;\n  }\n\n  &.bg-opacity-75 {\n    background-color: rgba($success, 0.75) !important;\n  }\n\n  &.bg-opacity-100 {\n    background-color: rgba($success, 1) !important;\n  }\n}\n\n// compaign page datatable\n// .list-progress {\n//   width: 380px;\n// }\n:where(.css-dev-only-do-not-override-djtmh8).ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected>.ant-table-cell {\n  background-color: #fff;\n}\n\n// multi-select\n// .css-1xc3v61-indicatorContainer svg {\n//   display: none;\n// }\n\n// .css-15lsz6c-indicatorContainer svg {\n//   display: none;\n// }\n\n// .css-tj5bde-Svg {\n//   background-color: #F6F6F6;\n//   border-color: #F6F6F6;\n//   color: #6F6F6F;\n//   border-radius: 5px;\n// }\n.css-1p3m7a8-multiValue {\n  background-color: #f6f6f6;\n  border-color: #f6f6f6;\n  color: #6f6f6f;\n  border-radius: 5px;\n}\n\n.stickybar {\n  top: 0;\n  position: sticky;\n}\n\n// select\n.select-details .css-1dimb5e-singleValue,\n.select-details .css-1jqq78o-placeholder {\n  padding-left: 15px;\n}\n\ndiv.css-13cymwt-control,\ndiv.css-t3ipsp-control {\n  min-width: 120px;\n  border-color: #e8e8e8;\n  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);\n  border-radius: 5px;\n}\n\ndiv.css-t3ipsp-control:hover {\n  border-color: transparent;\n}\n\nspan.p-dropdown-label.p-inputtext span {\n  font-family: \"Noto Sans\", sans-serif;\n}\n\n// datepicker\n.deals-details.react-datepicker__input-container {\n  width: 450px !important;\n}\n\ndiv.react-datepicker-wrapper {\n  display: block;\n  padding: 0;\n  border: 0;\n}\n\nspan.form-icon {\n  z-index: 1;\n}\n\n.img-checked {\n  padding: 10px;\n  // width: 30px;\n  background: rgb(49, 132, 199);\n  color: white;\n  border-radius: 20px;\n  font-weight: bolder;\n  position: relative;\n  /* margin-top: 2px ; */\n}\n\n.section-notes-slider .notes-slider .slick-list .slick-slide div {\n  margin-left: 12px !important;\n}\n\n.page-add-notes {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.visible .input-blocks .css-b62m3t-container .css-1dimb5e-singleValue {\n  margin-left: 25px !important;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-13cymwt-control {\n  background-color: #1d1d42;\n  border: 1px solid#67748E;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-t3ipsp-control {\n  background-color: #1d1d42;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-1nmdiq5-menu {\n  background-color: #1d1d42;\n}\n\n// .bx-microphone:before {\n//   content: \"\\eb89\";\n// }\n.form-sorts.dropdown .radio-btn-items {\n  margin-top: 10px;\n}\n\n\n\n// .slick-slide {\n//   margin-right: 5px;\n// }\n.p-dropdown-label.p-inputtext .p-d-flex.p-ai-center img,\n.p-dropdown-item-label .p-d-flex.p-ai-center,\n.p-dropdown-label.p-inputtext .p-clearfix img,\n.p-dropdown-item-label .p-clearfix img {\n  width: 16px;\n  height: 16px;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n\n.p-d-flex.p-ai-center {\n  display: flex;\n  align-items: center;\n}\n\n.p-dropdown-items-wrapper ul.p-dropdown-items,\n.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done {\n  z-index: 100000000000 !important;\n}\n\n.swiper-container .slick-list {\n  margin-left: -236px;\n}\n\n.p-dropdown.p-component.p-inputwrapper {\n  height: 42px;\n  line-height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-color: #e8e8e8;\n  color: #6f6f6f;\n  box-shadow: 0px 4px 4px 0px #dbdbdb40;\n}\n\ndiv.p-clearfix {\n  display: flex;\n  align-items: center;\n}\n\ndiv.p-clearfix span,\nspan.p-dropdown-label.p-inputtext.p-placeholder {\n  font-size: 14px;\n}\n\n.p-dropdown-trigger svg {\n  width: 13px;\n}\n\ndiv.rti--container {\n  border-color: #e8e8e8;\n  color: #6f6f6f;\n  box-shadow: 0px 4px 4px 0px #dbdbdb40;\n}\n\nspan.rti--tag button {\n  font-size: 10px;\n}\n\n.filter-dropdown-menu.dropdown-menu.dropdown-menu-md-end.show,\n.filter-dropdown-menu.dropdown-menu {\n  z-index: 11;\n}\n\nspan.ant-picker-suffix {\n  display: none !important;\n}\n\n.stickybar {\n  position: sticky;\n  top: 0;\n}\n\n.right-user-side.chat-rooms.theiaStickySidebar {\n  max-height: 500px;\n  overflow: auto;\n}\n\n.send-chat.comman-icon i.feather.feather-send {\n  color: #fff;\n}\n\n.chat-footer form {\n  background-color: #fff;\n}\n\n.nav.flex-column.nav-pills.todo-inbox i {\n  margin-right: 10px;\n}\n\n.select-priority .css-1jqq78o-placeholder,\n.select-priority .css-1dimb5e-singleValue {\n  padding-left: 15px;\n}\n\n.form-sort .css-1jqq78o-placeholder,\n.form-sort .css-1dimb5e-singleValue {\n  padding-left: 20px;\n}\n\n.form-sort.select-bluk.space-not-select .css-1jqq78o-placeholder,\n.form-sort.select-bluk.space-not-select .css-1dimb5e-singleValue {\n  padding: 0;\n}\n\n.owl-carousel.folders-carousel.owl-theme .slick-slide>div,\n.owl-carousel.files-carousel.owl-theme .slick-slide>div {\n  margin-right: 10px;\n}\n\n[data-theme=\"dark\"] .ant-table-content table,\n[data-theme=\"dark\"] .ant-table-thead tr th,\n[data-theme=\"dark\"] .ant-pagination.ant-table-pagination.ant-table-pagination-right {\n  background-color: #171724;\n  color: #a3a6a6;\n}\n\n[data-theme=\"dark\"] .table tbody tr td .table-avatar a,\n[data-theme=\"dark\"] td.ant-table-cell {\n  color: #a3a6a6;\n}\n\n// a#theme-settings i {\n//   color: #262a2a;\n// }\ntd .badge-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rsw-editor select {\n  display: none;\n}\n\n.custom-table {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n}\n\n.join-contents .slick-slider div.slick-slide>div {\n  margin-right: 10px;\n}\n\n.custom-react-clr {\n  color: #6f6f6f;\n}\n\ndiv.popover {\n  z-index: 9999;\n}\n\ndiv.rc-slider-track,\n.rc-slider-tracks {\n  background-color: #ed5565;\n}\n\ndiv.rc-slider-handle {\n  border: solid 2px #ed5565;\n}\n\nspan.rc-slider-dot-active {\n  border-color: #ed5565;\n}\n\ndiv.rc-slider-handle:active {\n  border-color: #ed5565;\n  box-shadow: 0 0 5px #ed5565;\n  cursor: grabbing;\n}\n\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #ed5565;\n  box-shadow: 0 0 0 5px #ed5565;\n}\n\ndiv.rc-slider-handle:hover {\n  border-color: #ed5565;\n}\n\ndiv.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #ed5565;\n  box-shadow: 0 0 0 5px #ed5565;\n}\n\n[data-theme=\"dark\"] {\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row>.ant-table-cell-row-hover {\n    background-color: #171724;\n  }\n\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody>tr>th,\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody>tr>td {\n    border-color: #393947;\n  }\n\n  :where(.css-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row>.ant-table-cell-row-hover {\n    background: #171724;\n    ;\n  }\n\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {\n    background: #171724;\n  }\n\n  .custom-table {\n    border: 1px solid #393947;\n  }\n\n  .css-13cymwt-control {\n    background-color: #171724;\n    border: 1px solid #393947;\n  }\n\n  .react-datepicker__month-container,\n  .react-datepicker__header {\n    background-color: #393947;\n  }\n\n  .css-t3ipsp-control {\n    background: #171724;\n    border: 1px solid #393947;\n    color: #a3a6a6;\n  }\n\n  .css-1dimb5e-singleValue {\n    color: #a3a6a6;\n  }\n\n  .css-b62m3t-container div.css-1nmdiq5-menu {\n    background-color: #393947 !important;\n  }\n\n  .react-select-29-listbox {\n    background-color: #393947;\n  }\n\n  .input-blocks input[type=\"text\"] {\n    background: #1d1d42 !important;\n  }\n\n  .p-dropdown.p-component.p-inputwrapper {\n    background-color: #171724;\n    border: 1px solid #393947;\n    box-shadow: none;\n  }\n\n  .p-dropdown-item {\n    background-color: #171724;\n    border: 1px solid #393947;\n  }\n\n  .rti--container {\n    background-color: #171724;\n    border: 1px solid #393947;\n    box-shadow: none;\n  }\n\n  .rti--tag {\n    background-color: #171724;\n  }\n\n  .rti--input {\n    background-color: #171724;\n  }\n}\n\n[data-sidebar=\"green\"] {\n  .clinicdropdown.theme {\n    a {\n      background-color: #005351;\n    }\n  }\n}\n\n[data-sidebar=\"blue\"] {\n  .clinicdropdown.theme {\n    a {\n      background-color: #2f0093;\n    }\n  }\n}\n\n[data-sidebar=\"dark\"] {\n  .clinicdropdown.theme {\n    a {\n      background-color: #28283e;\n    }\n  }\n}\n\n[data-theme=\"dark\"] .header .header-left .logo img.white-logo {\n  display: block;\n}\n\n[data-theme=\"dark\"] .chat-footer form {\n  background-color: #28283e;\n}\n\n[data-theme=\"dark\"] .sidebar .sidebar-menu .clinicdropdown.theme a {\n  background-color: #28283e;\n}\n\n[data-theme=\"dark\"] .rsw-toolbar {\n  background: grey;\n}\n\ndiv.css-b62m3t-container .react-select__option--is-focused {\n  background-color: #e85b28;\n  color: #fff;\n}\n\ndiv.css-b62m3t-container .react-select__option--is-selected {\n  background-color: #e85b28;\n  color: #fff;\n}\n\n.submenu .ti-ticket:before {\n  content: \"\\eb3d\";\n}\n\n.form-icon .ti-search:before {\n  content: \"\\eb1c\";\n}\n\n.form-icon .ti-calendar:before {\n  content: \"\\ea53\";\n}\n\ni.ti-trash:before {\n  content: \"\\eb41\";\n}\n\n[data-theme=\"dark\"] .header .header-left #toggle_btn {\n  color: #fff;\n}\n\ni.ti-lock:before {\n  content: \"\\eae2\";\n}\n\ni.ti-bell:before {\n  content: \"\\ea35\";\n}\n\n[data-theme=\"dark\"] .login-wrapper .form-control {\n  background-color: #ffffff;\n  border-color: #e8e8e8;\n}\n\n[data-theme=\"dark\"] div.css-13cymwt-control,\n[data-theme=\"dark\"] div.css-t3ipsp-control {\n  border-color: none;\n  box-shadow: none;\n}\n\n.mini-sidebar.expand-menu .subdrop~ul {\n  display: block !important;\n}\n\n.mini-sidebar .subdrop~ul {\n  display: none !important;\n}\n\n.sidebar .sidebar-menu>ul li .submenu.submenu-two>ul li a {\n  margin-left: 30px;\n}\n\n.ti.ti-eye:before {\n  content: \"\\ea9a\";\n}\n\n.ti.ti-user:before {\n  content: \"\\eb4d\";\n}\n\ndiv.sidebar-themesettings .input-themeselect input[type=\"radio\"]:checked~label .checkboxs-theme::before {\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  color: #fff;\n  font-weight: 700;\n  font-size: 10px;\n  right: 4px;\n  position: absolute;\n  top: -16px;\n  z-index: 9;\n}\n\n.ti-check:before {\n  content: \"\\ea5e\" !important;\n}\n\n.ti-arrow-down:before {\n  content: \"\\ea16\" !important;\n}\n\n.select-pipeline .react-select__value-container {\n  padding-left: 28px !important;\n}\n\n.modal-open .offcanvas.offcanvas-end {\n  width: 700px !important;\n}\n\n.ant-table {\n  font-family: \"Noto Sans\", sans-serif !important;\n}\n\n.ti-shield:before {\n  content: \"\\eb24\" !important;\n}\n\n.ant-picker {\n  border-color: #E5E7EB;\n  color: #111827;\n  background-color: #ffffff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.6;\n  border-radius: 5px;\n  padding: 0.5rem 0.625rem;\n  height: 38px;\n  transition: all 0.5s;\n  // display: block;\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.select-color {\n  top: 40%;\n  right: 50%;\n  transform: translate(50%, -50%);\n  z-index: 9;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 16px;\n}\n\n.theme-colorselect.active .ant-color-picker-trigger {\n  border-color: #F26522 !important;\n}\n\n.ant-color-picker-trigger .ant-color-picker-color-block {\n  width: 26px !important;\n  height: 43px !important;\n}\n\ni.ti-palette:before {\n  content: \"\\eb01\";\n}\n\n.ant-color-picker {\n  z-index: 99999999999;\n}\n\n.select-theme-color .ant-color-picker-trigger {\n  min-width: 30px !important;\n  height: 30px !important;\n  border-radius: 50% !important;\n}\n\n.ant-color-picker-trigger {\n  border: none;\n}\n\n.select-theme-color .ant-color-picker-trigger .ant-color-picker-color-block {\n  width: 27px !important;\n  height: 27px !important;\n  border-radius: 50% !important;\n}\n\n.slick-slide>div {\n  margin-right: 10px;\n}\n\n.react-datepicker-popper {\n  width: max-content !important;\n}","/****** Utils ******/\n@import \"utils/variables\";\n@import \"utils/mixins\";\n\n\n/****** Layout ******/\n@import \"layout/common\";\n@import \"layout/content\";\n@import \"layout/header\";\n@import \"layout/sidebar\";\n@import \"layout/theme\";\n@import \"layout/theme-settings\";\n@import \"layout/theme\";\n@import \"layout/notification\";\n\n/******* Components ******/\n@import \"components/avatar\";\n@import \"components/boostrap\";\n@import \"components/button\";\n@import \"components/badge\";\n@import \"components/border\";\n@import \"components/calendar\";\n@import \"components/chart\";\n@import \"components/call\";\n@import \"components/chat\";\n@import \"components/dropdown\";\n@import \"components/email\";\n@import \"components/file-manager\";\n@import \"components/icons\";\n@import \"components/progress\";\n@import \"components/pagination\";\n@import \"components/font\";\n@import \"components/typography\";\n@import \"components/alerts\";\n@import \"components/popovers\";\n@import \"components/forms\";\n@import \"components/notes\";\n@import \"components/todo\";\n@import \"components/tables\";\n@import \"components/accordion\";\n@import \"components/breadcrumb\";\n@import \"components/cards\";\n@import \"components/tooltips\";\n@import \"components/navs-tabs\";\n@import \"components/ribbon\";\n@import \"components/popup\";\n@import \"components/grid\";\n\n/******* Base *******/\n@import \"base/base\";\n@import \"base/background\";\n\n\n/******* Pages ******/\n@import \"pages/contact\";\n@import \"pages/dashboard\";\n@import \"pages/error\";\n@import \"pages/login\";\n@import \"pages/settings\";\n@import \"pages/report\";\n@import \"pages/activity\";\n@import \"pages/tasks\";\n@import \"pages/analytics\";\n@import \"pages/project\";\n@import \"pages/leads\";\n@import \"pages/campaign\";\n@import \"pages/membership-plans\";\n@import \"pages/ui-pages\";\n@import \"pages/social-feed\";\n@import \"pages/super-admin\";\n@import \"pages/pricing\";\n\n\n/******* Vendors ******/\n@import \"vendors/select2\";\n@import \"vendors/datatables\";\n\n// Make Bootstrap modal backdrop lighter\n.modal-backdrop.show {\n  opacity: 0.2 !important; // Default is 0.5, lower is less dim\n}\n\n/* Custom Checkbox Styling for Permission Tables */\n.custom-table,\n.table-responsive {\n  input[type=\"checkbox\"] {\n    width: 16px !important;\n    height: 16px !important;\n    cursor: pointer;\n    accent-color: $primary;\n    border: 2px solid #dee2e6 !important;\n    border-radius: 0 !important;\n    margin: 0 !important;\n\n    &:hover {\n      border-color: $primary !important;\n    }\n\n    &:checked {\n      background-color: $primary !important;\n      border-color: $primary !important;\n    }\n\n    &:focus {\n      outline: 2px solid rgba($primary, 0.3) !important;\n      outline-offset: 2px;\n    }\n  }\n\n  // Override .checkboxs custom styling\n  .checkboxs {\n    input[type=\"checkbox\"] {\n      position: relative !important;\n      opacity: 1 !important;\n      width: 16px !important;\n      height: 16px !important;\n      margin-right: 0 !important;\n    }\n\n    // Hide the custom checkmark span\n    .checkmarks {\n      display: none !important;\n    }\n  }\n}\n\n// Keep Ant Design table-selection checkboxes on the application brand color.\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: $primary;\n  border-color: $primary;\n}\n\n.ant-checkbox-indeterminate .ant-checkbox-inner::after {\n  background-color: $primary;\n}\n\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: $primary;\n}\n","::-webkit-scrollbar {\n    width: 5px;\n    height: 6px;\n    border-radius: 50px !important;\n}\n::-webkit-scrollbar-track {\n    background: $gray-300;\n}\n::-webkit-scrollbar-thumb {\n    background: $primary;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: $gray-300;\n}\n.swal2-header{\n    .swal2-title{\n        font-size: $font-size-18;\n    }\n}\n.none{\n    display: none !important;\n}\n.text-red{color: $danger !important;\n}\n.text-green{\n    color: $success !important;\n}\n.input-blocks{\n    input[type=text]{\n        &:focus{\n            border-color: $input-border;\n        }\n    }\n}\n.input-group{\n    .scanner-set {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $primary;\n        border-radius: 5px !important;\n        width: 40px;\n        color: $white;\n        font-weight: $font-weight-semibold;\n        padding: 0;\n        &:hover{\n            background: $title-color;\n        }\n    }\n}\n::-webkit-scrollbar {\n    width: 5px;\n    height: 6px;\n    border-radius: 50px !important;\n}\n::-webkit-scrollbar-track {\n    background: $gray-300;\n}\n::-webkit-scrollbar-thumb {\n    background: $primary;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: $gray-300;\n}\n.swal2-header{\n    .swal2-title{\n        font-size: $font-size-18;\n    }\n}\n.none{\n    display: none !important;\n}\n.text-red{\n    color: $danger !important;\n}\n.text-green{\n    color: $success !important; \n}\n\n.input-blocks{\n    input[type=text]{\n        &:focus{\n            border-color: $input-border;\n        }\n    }\n}\n.form-sorts {\n    position: relative;\n    & > a {\n        border: 1px solid $light-900;\n        border-radius: 5px;\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\n        background: $white;\n        font-weight: $font-weight-medium;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        @include margin-padding(null, 9px 21px);               \n        @include respond-below(custom991) {\n            @include margin-padding(null, 9px 12px);\n        }\n        i {\n            margin-right: 8px;\n        }   \n        &:hover {\n            color: $title-color;\n        }\n        &.show {\n            border: 1px solid #0092E4;\n        }  \n        @include respond-below(custom575) {\n            width: 100%;\n        }  \n    }\n    .filter-dropdown-menu {\n        padding: 24px;\n        border-radius: 5px;\n        background: $white;\n        border: 1px solid $light-900;\n        box-shadow: 0px 4px 24px 0px #BCBCBC40;\n        position: absolute;\n        z-index: 1;\n        min-width: 400px;\n        right: 0;\n        top: 40px;\n        @include respond-below(custom767) {\n            min-width: 270px;\n        }\n        @include respond-below(custom575) {\n            right: unset;\n            left: 0;\n        }\n    }\n    &.table-filter-show {\n        .filter-dropdown-menu {\n            display: block;\n            opacity: 1;\n        }\n    }\n    .filter-set-head {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        margin-bottom: 14px;\n        h4 {\n            margin-bottom: 10px;\n            i {\n                margin-right: 8px;\n            }\n            @include respond-below(custom991) {\n                font-size: $font-size-16;\n            }\n        }\n        a {\n            color: $purple;\n            margin-bottom: 10px;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .filter-set-content {\n        margin-bottom: 24px;\n        .filter-set-content-head {\n            a {\n                display: flex;\n                align-items: center;\n                color: $gray-900;\n                font-weight: $font-weight-semibold;\n                position: relative;\n                padding-left: 16px;\n                &::before {\n                    content: \"\\f054\";\n                    font-family: 'Font Awesome 5 Free';\n                    @include position(absolute, 50%, null, null, 0);\n                    @include transform(translateY(-50%));\n                    font-size: $font-size-14;\n                } \n                &:not(.collapsed) {  \n                    padding-left: 20px;                  \n                    &::before {\n                        content: \"\\f078\";\n                    }\n                }\n            }\n        }\n    }\n    .filter-reset-btns {\n        a,\n        button,\n        .btn,\n        .btn-light {\n            width: 100%;\n            min-height: 38px;\n            padding: 8px 14px;\n            font-size: $font-size-13;\n            font-weight: $font-weight-semibold;\n            border-radius: 8px;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            gap: 6px;\n            border: 1px solid #f3c8b8;\n            background: #fff6f1;\n            color: #bb4d22;\n            transition: all 0.2s ease;\n            @include respond-below(custom575) {\n                padding: 10px 14px;\n            }\n\n            &:hover,\n            &:focus {\n                border-color: #e85b28;\n                background: #ffefe8;\n                color: #e85b28;\n                box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);\n            }\n\n            &:disabled {\n                opacity: 0.65;\n                cursor: not-allowed;\n                box-shadow: none;\n            }\n        }\n    }\n}\n\n.btn-reset-standard {\n    min-height: 38px;\n    padding: 8px 14px;\n    border-radius: 8px;\n    border: 1px solid #f3c8b8 !important;\n    background: #fff6f1 !important;\n    color: #bb4d22 !important;\n    font-size: 13px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: all 0.2s ease;\n}\n\n.btn-reset-standard:hover,\n.btn-reset-standard:focus {\n    border-color: #e85b28 !important;\n    background: #ffefe8 !important;\n    color: #e85b28 !important;\n    box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);\n}\n.radio-btn-items {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-bottom: 14px;\n    .radio-btn {\n        margin: 0 30px 10px 0;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n\n/* =====================================================\n   Global Reset Button Design System (all modules)\n   ===================================================== */\n:where(\n    .btn-reset-standard,\n    .hr-clear-btn,\n    .filter-reset-btns .btn,\n    .filter-reset-btns a,\n    button[type=\"reset\"],\n    input[type=\"reset\"],\n    button[title*=\"Reset\"],\n    button[title*=\"Clear Filters\"],\n    button[title*=\"Clear filters\"]\n) {\n    min-height: 38px;\n    padding: 8px 14px;\n    border-radius: 8px;\n    border: 1px solid #f3c8b8 !important;\n    background: #fff6f1 !important;\n    color: #bb4d22 !important;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.2;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    white-space: nowrap;\n    transition: all 0.2s ease;\n}\n\n:where(\n    .btn-reset-standard,\n    .hr-clear-btn,\n    .filter-reset-btns .btn,\n    .filter-reset-btns a,\n    button[type=\"reset\"],\n    input[type=\"reset\"],\n    button[title*=\"Reset\"],\n    button[title*=\"Clear Filters\"],\n    button[title*=\"Clear filters\"]\n):hover,\n:where(\n    .btn-reset-standard,\n    .hr-clear-btn,\n    .filter-reset-btns .btn,\n    .filter-reset-btns a,\n    button[type=\"reset\"],\n    input[type=\"reset\"],\n    button[title*=\"Reset\"],\n    button[title*=\"Clear Filters\"],\n    button[title*=\"Clear filters\"]\n):focus {\n    border-color: #e85b28 !important;\n    background: #ffefe8 !important;\n    color: #e85b28 !important;\n    box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);\n}\n\n:where(\n    .btn-reset-standard,\n    .hr-clear-btn,\n    .filter-reset-btns .btn,\n    .filter-reset-btns a,\n    button[type=\"reset\"],\n    input[type=\"reset\"],\n    button[title*=\"Reset\"],\n    button[title*=\"Clear Filters\"],\n    button[title*=\"Clear filters\"]\n):disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n.filter-set-contents {\n    .filter-content-list {\n        background: $light-200;\n        border-radius: 5px;\n        padding: 15px;\n        margin-top: 15px;\n        .form-wrap {\n            margin-bottom: 15px;\n            .form-control {\n                max-width: 100%;\n            }\n        }\n        ul {\n            max-height: 150px;\n            overflow-y: auto;\n            padding: 1px 0;\n            &::-webkit-scrollbar {\n                width: 3px;\n                background: $primary;\n                height: 1px;\n            }\n            &::-webkit-scrollbar-track {\n                box-shadow: inset 0 0 5px rgb(231, 231, 231); \n                border-radius: 4px;\n            }\n            &::-webkit-scrollbar-thumb {\n                background: $primary; \n                border-radius: 4px;\n            }\n            li {\n                position: relative;\n                display: flex;\n                margin-bottom: 15px;\n                &:last-child {\n                    margin-bottom: 0;\n                }\n                .checkboxs {\n                    padding-left: 0;\n                    display: flex;\n                    align-items: center;\n                }\n                .checkboxs .checkmarks {\n                    position: relative;\n                    top: 0;\n                    margin-right: 5px;\n                    display: flex;\n                }\n                .rating {\n                    margin-left: 0;\n                    i {\n                        color: $light-900;\n                        &.filled {\n                            color: $warning;\n                        }\n                    }\n                    span {\n                        margin-left: 5px;\n                    }\n                }\n                .collapse-inside-text {\n                    margin-left: 0;\n                    h5 {\n                        margin-bottom: 0;\n                        font-size: $font-size-14;\n                        font-weight: $font-weight-normal;\n                    }\n                }\n            }\n        }\n    }\n}\n\n","// Font import\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap');\n\n// Base Font\n$font-size-base: 14px;\n$font-size-sm: $font-size-base * .875;\n$font-size-lg: $font-size-base * 1.25;\n$font-weight-lighter: lighter;\n$font-weight-light: 300;\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n$font-weight-bolder: bolder;\n\n// Font Family\n$font-family-primary: \"Noto Sans\", sans-serif;\n$font-awesome: \"Fontawesome\";\n\t\n// Theme Colors Variables\n$primary: #e85b28;\n$primary-hover: darken($primary, 10%);\n$secondary: #FFA201;\n$secondary-hover: darken($secondary, 10%);\n$success: #5CB85C;\n$success-hover: darken($success, 10%);\n$info: #1ECBE2;\n$info-hover: darken($info, 10%);\n$warning: #FDA700;\n$warning-hover: darken($warning, 10%);\n$danger: #FC0027;\n$danger-hover: darken($danger, 10%);\n$dark: #171724;\n$dark-border: #393947;\n$dark-text: #a3a6a6;\n$dark-textcolor: #B5B5B5;\n$dark-hover: darken($dark, 10%);\n$darkmode-hover: #28283D;\n$dark-input: #1A1A25;\n$dark-bg: #1E1E2D;\n$primary-transparent: #FEF1EB;\n$secondary-transparent: #EDF2F4;\n$success-transparent: #E8FAF0;\n$warning-transparent: #FFF9E9;\n$danger-transparent: #FAE7E7;\n$info-transparent: #EBF4FF;\n$pink-transparent: #FFEDF6;\n$light-transparent: #F9FAFE;\n$dark-transparent: #E8E9EA;\n$teal-transparent: #E6F9FF;\n$purple-transparent: #F7EEF9;\n$skyblue-transparent: #E9FAFE;\n$gray-bg: #28283E;\n$light: #FDFDFE;\n$light-hover: darken($light, 10%);\n$white: #FFF;\n$black: #000;\n$purple: #4A00E5;\n$pink: #EA00B7;\n$blue: #339DFF;\n$teal: #02a8b5;\n$violet: #676DFF;\n$cyan: #299cdb;\n$green: #00918E;\n$orange: #FF9D0A;\n$indigo: #0092E4;\n$indigo-hover: darken($indigo, 10%);\n$tertiary: #3C2371;\n$yellow: #ffff00;\n\n// Primary\n$primary-100: #FCE9E6;\n$primary-200: #FAD2CD;\n$primary-300: #F7BCB5;\n$primary-400: #F4A59C;\n$primary-500: #F28F83;\n$primary-600: #EF796A;\n$primary-700: #EC6251;\n$primary-800: #E94C39;\n$primary-900: #E73520;\n\n// Secondary\n$secondary-100: #FFF6E6;\n$secondary-200: #FFECCC;\n$secondary-300: #FFE3B3;\n$secondary-400: #FFDA99;\n$secondary-500: #FFD180;\n$secondary-600: #FFC767;\n$secondary-700: #FFBE4D;\n$secondary-800: #FFB534;\n$secondary-900: #FFAB1A;\n\n// Tertiary\n$tertiary-100: #ECE9F1;\n$tertiary-200: #D8D3E3;\n$tertiary-300: #C5BDD4;\n$tertiary-400: #B1A7C6;\n$tertiary-500: #9E91B8;\n$tertiary-600: #8A7BAA;\n$tertiary-700: #77659C;\n$tertiary-800: #634F8D;\n$tertiary-900: #50397F;\n\n// Green\n$green-100: #E6F4F4;\n$green-200: #CCE9E8;\n$green-300: #B3DEDD;\n$green-400: #99D3D2;\n$green-500: #80C8C7;\n$green-600: #66BDBB;\n$green-700: #4DB2B0;\n$green-800: #33A7A5;\n$green-900: #1A9C99;\n\n// Blue\n$blue-100: #EBF5FF;\n$blue-200: #D6EBFF;\n$blue-300: #C2E2FF;\n$blue-400: #ADD8FF;\n$blue-500: #99CEFF;\n$blue-600: #85C4FF;\n$blue-700: #70BAFF;\n$blue-800: #5CB1FF;\n$blue-900: #47A7FF;\n\n// Orange\n$orange-100: #FFF5E7;\n$orange-200: #FFEBCE;\n$orange-300: #FFE2B6;\n$orange-400: #FFD89D;\n$orange-500: #FFCE85;\n$orange-600: #FFC46C;\n$orange-700: #FFBA54;\n$orange-800: #FFB13B;\n$orange-900: #FFA723;\n\n// Pink\n$pink-100: #FDE6F8;\n$pink-200: #FBCCF0;\n$pink-300: #F9B3E9;\n$pink-400: #F799E2;\n$pink-500: #F580DB;\n$pink-600: #F266D3;\n$pink-700: #F04DCC;\n$pink-800: #EE33C5;\n$pink-900: #EC1ABD;\n\n// Violet\n$violet-100: #F0F0FF;\n$violet-200: #E1E2FF;\n$violet-300: #D1D3FF;\n$violet-400: #C2C5FF;\n$violet-500: #B3B6FF;\n$violet-600: #A4A7FF;\n$violet-700: #9599FF;\n$violet-800: #858AFF;\n$violet-900: #767CFF;\n\n// Indigo\n$indigo-100: #E6F4FC;\n$indigo-200: #CCE9FA;\n$indigo-300: #B3DEF7;\n$indigo-400: #99D3F4;\n$indigo-500: #80C9F2;\n$indigo-600: #66BEEF;\n$indigo-700: #4DB3EC;\n$indigo-800: #33A8E9;\n$indigo-900: #1A9DE7;\n\n// Light\n$light-100: #FAFAFA;\n$light-200: #F9F9FC;\n$light-300: #F6F6F6;\n$light-400: #F5F5F5;\n$light-500: #F6F6F6;\n$light-600: #F4F4F4;\n$light-700: #F2ECFF;\n$light-800: #EAEAEA;\n$light-900: #E8E8E8;\n\n// Gray\n$gray-100: #C0C0C0;\n$gray-200: #9B9B9B;\n$gray-300: #898989;\n$gray-400: #6F6F6F;\n$gray-500: #6F7A7A;\n$gray-600: #565E5E;\n$gray-700: #424848;\n$gray-800: #323737;\n$gray-900: #262A2A;\n\n// Info\n$info-100: #E9FAFC;\n$info-200: #D2F5F9;\n$info-300: #BCEFF6;\n$info-400: #A5EAF3;\n$info-500: #8FE5F1;\n$info-600: #78E0EE;\n$info-700: #62DBEB;\n$info-800: #4BD5E8;\n$info-900: #35D0E5;\n\n// Success\n$success-100: #EFF8EF;\n$success-200: #E0F5D7;\n$success-300: #CEEACE;\n$success-400: #BEE3BE;\n$success-500: #AEDCAE;\n$success-600: #9DD49D;\n$success-700: #8DCD8D;\n$success-800: #7DC67D;\n$success-900: #6CBF6C;\n\n// Danger\n$danger-100: #FFEEEC;\n$danger-200: #FECCD4;\n$danger-300: #FEB3BE;\n$danger-400: #FE99A9;\n$danger-500: #FE8093;\n$danger-600: #FD667D;\n$danger-700: #FD4D68;\n$danger-800: #FD3352;\n$danger-900: #FC1A3D;\n\n// Warning\n$warning-100: #FFF7D8;\n$warning-200: #FFEDCC;\n$warning-300: #FEE5B3;\n$warning-400: #FEDC99;\n$warning-500: #FED380;\n$warning-600: #FECA66;\n$warning-700: #FEC14D;\n$warning-800: #FDB933;\n$warning-900: #FDB01A;\n\n// Purple\n$purple-100: #F3EDFF;\n$purple-200: #DBCCFA;\n$purple-300: #C9B3F7;\n$purple-400: #B799F5;\n$purple-500: #A580F2;\n$purple-600: #9266EF;\n$purple-700: #804DED;\n$purple-800: #6E33EA;\n$purple-900: #5C1AE8;\n\n\n\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n\n$theme-colors: (\n    \"primary\": $primary,\n    \"secondary\": $secondary,\n    \"success\": $success,\n    \"info\": $info,\n    \"warning\": $warning,\n    \"danger\": $danger,\n    \"dark\": $dark,\n    \"light\": $light,\n    \"black\": $black,\n    \"purple\": $purple,\n    \"yellow\": $yellow,\n    \"teal\": $teal\n);\n\n$text-color: #6F6F6F;\n$title-color: #262A2A;\n$sub-title: #B8BCC9;\n$body-bg: #F9F9FC;\n$wrapper-bg: #f1f5f6;\n$text-muted: #9595b5;\n$default-background: #f7f8f9;\n$black-bg: #141432;\n$card-dark-bg: #1d1d42;\n$navy: #353570;\n$theme-title: #97A2D2;\n$input-bg: #2c2c50;\n$form-control-bg: #ffffff;\n$background-3: #E0E2E7;\n$dark-green: #111926;\n$night-blue: #0F0F41;\n$dark-gray: #2E2E48;\n$royal-blue: #0039C6;\n$indigo: #391694;\n$darkaqua: #116D6E;\n$whiterock: #F0E4D7;\n$rockblue: #8CB9BD;\n$bluehaze: #B5C0D0;\n$brightblue:  #2066FF;\n$lunargreen: #365E32;\n$lavendar: #673AB7;\n$magenta: #E83E8C;\n$chromeyellow: #FF9B04;\n$lavared: #DC2626;\n$blackpearl: #080821;\n$maroon: #710034;\n$bluegem: #3E1C95;\n$firefly: #053333;\n\n// Social Icons Colors\n$facebook: #3B5998;\n$twitter: #00ACEE;\n$google: #DD4B39;\n$telegram: #0088CC;\n$linkedin: #0E76A8;\n$youtube: #C4302B;\n$instagram: #3F729B;\n$reddit: #C6C6C6;\n$pinterest: #cc2127;\n$vk: #2B587A;\n$rss: #EE802F;\n$skype: #00AFF0;\n$xing: #126567;\n$tumblr: #34526F;\n$email: #6567A5;\n$delicious: #205CC0;\n$stumbleupon: #F74425;\n$digg: #191919;\n$blogger: #FC4F08;\n$flickr: #FF0084;\n$vimeo: #86C9EF;\n$yahoo: #720E9E;\n$gplus: #DD4B39;\n$appstore: #000;\n\n// Darkmode Base\n$darkmode-light: #131313;\n$darkmode-dark: #D6DADE;\n$darkmode-white: #0D0D0D;\n\n// Darkmode Gray\n$darkmode-gray-900: #D8DFEE;\n$darkmode-gray-800: #C8D2E0;\n$darkmode-gray-700: #374151;\n$darkmode-gray-600: #4B5563;\n$darkmode-gray-500: #6B7280;\n$darkmode-gray-400: #9CA3AF;\n$darkmode-gray-300: #2F343C;\n$darkmode-gray-200: #1F2228;\n$darkmode-gray-100: #171717;\n\n// Darkmode Light\n$darkmode-light-900: #181818;\n$darkmode-light-800: #121212;\n$darkmode-light-700: #111111;\n$darkmode-light-600: #101010;\n$darkmode-light-500: #0F0F0F;\n$darkmode-light-400: #0E0E0E;\n$darkmode-light-300: #0C0C0C;\n$darkmode-light-200: #0B0B0B;\n$darkmode-light-100: #0A0A0A;\n\n// Darkmode Transparent\n$darkmode-primary-transparent: #100601;\n$darkmode-secondary-transparent: #030D11;\n$darkmode-success-transparent: #04150C;\n$darkmode-warning-transparent: #171203;\n$darkmode-danger-transparent: #240505;\n$darkmode-info-transparent: #050C15;\n$darkmode-purple-transparent: #17051B;\n$darkmode-skyblue-transparent: #03191E;\n$darkmode-pink-transparent: #240917;\n$darkmode-dark-transparent: #212324;\n$darkmode-light-transparent: #0B0F14;\n\n// Gradient Variables\n$primary-gradient: linear-gradient(to right, $primary 0%, #8e77fa 100%);\n$secondary-gradient: linear-gradient(to right, $secondary 0%, #28b7f9 100%);\n$success-gradient: linear-gradient(to right,$success 0%, #5cf9e2 100%);\n$warning-gradient: linear-gradient(to right, $warning 0%, #fbc434 100%);\n$danger-gradient: linear-gradient(to right,$danger 0%, #fd4a68  100%);\n$info-gradient: linear-gradient(to right, $info 0%, #00f2fe  100%);\n$pink-gradient: linear-gradient(to right, $pink 0%, #FFA795 100%);\n$teal-gradient: linear-gradient(to right, $teal 0%, #0695DD 100%);\n$orange-gradient: linear-gradient(to right,$orange 0%,#FBB034 100%);\n$purple-gradient: linear-gradient(to right, $purple 0%, #9b25b7 100%);\n$light-gradient: linear-gradient(to right, $light 0%, #D1D6DE 100%);\n$dark-gradient: linear-gradient(to right, $dark 0%, #54505D 100%);\n$blue-gradient: linear-gradient(180deg, #00C0F9 0%, #0257CE 100%);\n$maroon-gradient: linear-gradient(180deg, #EF3B4A 0%, #513A8F 100%);\n$gradient-purple: linear-gradient(180deg, #667CE8 0%, #754EA7 100%);\n\n\n// Style Anchor Elements\n$link-color: $primary;\n$link-decoration: none;\n$link-shade-percentage: 20%;\n$link-hover-color: darken($link-color, 10%);\n$link-hover-decoration: null;\n$spacer: 1rem;\n\n// Border\n$border-width: 1px;\n$border-style: solid;\n$border-color: $light-900;\n$default-border: $light-900;\n$input-border: $light-900;\n\n// Border Radius\n$border-radius: 4px;\n$border-radius-sm: 3px;\n$border-radius-lg: 5px;\n$border-radius-xl: 8px;\n$border-radius-xxl: 12px;\n$rounded: 50%;\n$rounded-pill: 1.5rem;\n\n// Box Shadow\n$box-shadow: 0px 4px 54px 0px #E0E0E040;\n$box-shadow-sm: 0px 4px 74px 0px #D0D0D040;\n$box-shadow-lg: 0 5px 10px rgba(30, 32, 37, 0.12);\n\n// Font Size\n$font-size-8: 8px;\n$font-size-9: 9px;\n$font-size-10: 10px;\n$font-size-11: 11px;\n$font-size-12: 12px;\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-15: 15px;\n$font-size-16: 16px;\n$font-size-18: 18px;\n$font-size-20: 20px;\n$font-size-22: 22px;\n$font-size-24: 24px;\n$font-size-26: 26px;\n$font-size-28: 28px;\n$font-size-30: 30px;\n$font-size-32: 32px;\n$font-size-34: 34px;\n$font-size-36: 36px;\n$font-size-40: 40px;\n$font-size-42: 42px;\n$font-size-50: 50px;\n$font-size-54: 54px;\n$font-size-60: 60px;\n\n$h1-font-size: 28px;\n$h2-font-size: 24px;\n$h3-font-size: 20px;\n$h4-font-size: 18px;\n$h5-font-size: 16px;\n$h6-font-size: 14px;\n\n","$breakpoints: (\n  custom575: 575.98px,\n  custom767: 767.98px,\n  custom768: 768px,\n  custom991: 991.98px,\n  custom992: 992px,\n  custom1199: 1199.98px,\n  custom1399: 1399.98px,\n  custom1280: 1280px,\n);\n\n// Respond Above\n\n@mixin respond-above($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (min-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n// Respond Above\n\n@mixin respond-below($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (max-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n@mixin transform($property) {\n  transform: $property;\n  -webkit-transform: $property;\n  -ms-transform: $property;\n}\n\n// Define vertical, horizontal, or both position\n\n@mixin position-alignment($position) {\n  position: absolute;\n  @if $position == 'vertical' {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n  }\n  @else if $position == 'horizontal' {\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translate(-50%);\n  }\n  @else if $position == 'both' {\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n  }\n}\n\n@mixin transition($property) {\n  -webkit-transition: $property;\n  -ms-transition: $property;\n  transition: $property;\n}\n\n@mixin position($position-value,$top-value,$right-value,$bottom-value,$left-value){\n  position: $position-value;\n  top: $top-value;\n  right: $right-value;\n  bottom: $bottom-value;\n  left: $left-value;\n}\n\n@mixin margin-padding($margin, $padding) {\n   margin: $margin;\n   padding:$padding;\n}\n\n@mixin placeholder-color($color) {\n  &::-webkit-input-placeholder { /* WebKit browsers */\n      color: $color;\n      opacity: 1;\n  }\n  &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */\n      color: $color;\n      opacity: 1;\n  }\n  &::-moz-placeholder { /* Mozilla Firefox 19+ */\n      color: $color;\n      opacity: 1;\n  }\n  &:-ms-input-placeholder { /* Internet Explorer 10+ */\n      color: $color;\n      opacity: 1;\n  }\n}\n\n@mixin rounded($unit) {\n  border-radius: $unit;\n}\n\n@mixin transform-origin($property) {\n  transform-origin: $property;\n  -webkit-transform-origin: $property;\n  -ms-transform-origin: $property;\n}\n\n@mixin box-shadow($inset:inset,$horizontaloffset:10px,$verticaloffset:10px,$blur:10px,$spread:10px,$color: #000000) {\n  -webkit-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n  -moz-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n  box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n}\n\n%animation-effect {   \n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  transition: all 0.5s;\n}\n",".page-wrapper {\n    @include transition(all 0.5s ease);\n    @include margin-padding( 0 0 0 276px, 56px 0 0);\n    @include position(relative,null,null,null,0);\n    @include transition(all 0.2s ease);\n    @include respond-below(custom991) {\n        @include margin-padding( 0 , 60px 0 0);\n    }\n    .content {\n        @include margin-padding(null, 24px);\n        padding-bottom: 0;\n        @include respond-below(custom991) {\n            @include margin-padding(null, 15px 15px 0);\n        }\n    }\n}\n",".header {\n    height: 56px;\n    z-index: 999;\n    background: $white;\n    @include position(fixed,0,0,null,0);\n    @include transition(all 0.5s ease);\n    .flag-nav {\n        > a {\n            img {\n                border-radius: 50%;\n                width: 22px;\n                height: 22px;\n            }\n        }\n    }\n    .searchinputs {\n        @include margin-padding(null,  0);\n        position: relative;\n        input {\n            width: 335px;\n            height: 42px;\n            border: 1px solid $light-300;\n            background: $light-300;\n            padding: 5px 10px;\n            padding-right: 35px;\n            border-radius: $border-radius-lg;\n            color: $gray-900;\n            @include respond-below(custom1199) {\n                width: 170px;\n            }\n            &::placeholder {\n                color: $gray-400;\n            }\n        }   \n        .search-addon {\n            button {\n                z-index: 9;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                @include rounded(5px);\n                cursor: pointer;\n                background: transparent;\n                border: 0;\n                padding: 0;\n                color: $gray-900;\n                @include position(absolute,50%,16px,null,null);\n                @include transform(translateY(-50%));\n            }\n        }\n    }\n    .dropdown-menu {\n        @include respond-above(custom992) {\n            top: 85px;\n            right: 0;\n            left: auto;\n            min-width: 200px;\n            visibility: hidden;\n            opacity: 0;\n            border: 0;\n            display: block;\n            border-radius: $border-radius-lg;\n            box-shadow: $box-shadow-sm;\n            @include margin-padding(0, 0);\n            @include transition(all 0.4s ease);\n            @include transform(translateY(20px));\n        }\n        @include respond-below(custom991) {\n            transition: none;\n        }\n    }\n    .dropdown-menu.show {\n        visibility: visible;\n        opacity: 1;\n        margin-top: 8px !important;\n        @include transform(translateY(0));\n        @include transition(all 0.4s ease);\n    }\n    .header-left {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        float: left;\n        height: 56px;\n        position: relative;\n        text-align: center;\n        width: 276px;\n        z-index: 1;\n        background: $white;\n        @include margin-padding(null, 0 15px);\n        @include transition(all 0.5s ease);\n        .logo {\n            display: inline-block;\n            line-height: 0;\n            img{\n                width: 100%;\n                display: block;\n                &.white-logo{\n                    display: none;\n                }\n            }\n            @include respond-below(custom991) {\n                text-align: center;\n                width: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                img{\n                    width: 140px;\n                }\n            }\n        }\n        .logo-small{\n            display: none;\n        }\n        @include respond-below(custom991) {\n            position: absolute;\n            width:100%;\n        }\n    }\n\n    @include respond-below(custom991) {\n       .header-left {\n        #toggle_btn {\n            display: none;\n        }\n       }\n    }\n    @include respond-above(custom991) {\n        #toggle_btn {\n            font-size: $font-size-18;\n            padding: 4px;\n            border-radius:6px;\n            .bar-icon {\n                display: inline-block;\n                width: 21px;\n                span {\n                    background-color: $white;\n                    display: block;\n                    float: left;\n                    height: 2px;\n                    width: 21px;\n                    @include margin-padding(0 0 5px, null);\n                    @include rounded(50px);\n                    &:nth-child(2) {\n                        width: 15px;\n                    }\n                }\n            }\n        }\n    }\n    .bar-icon {\n        display: inline-block;\n        width: 31px;\n        margin-top: 20px;\n        span {\n            background-color: $primary;\n            display: block;\n            float: left;\n            height: 3px;\n            margin-bottom: 7px;\n            width: 31px;\n            border-radius: 2px;\n            transition: all 0.5s;\n            &:nth-child(2) {\n                width: 16px;\n            }\n        }\n    }\n    .menu-opened{\n        .slide-nav{\n            .bar-icon {\n                display: inline-block;\n                width: 31px;\n                margin-top: 20px;\n                span {\n                    &:first-child {\n                        position: relative;\n                        top: 10px;\n                        @include transform(rotate(45deg));\n                     }\n                    &:nth-child(2) {\n                       display:none;\n                    }\n                    &:last-child {\n                        @include transform(rotate(135deg));\n                     }\n                }\n            } \n        }\n    }\n    .menus-info {\n        min-width: 500px;\n        border-radius: $border-radius-lg;\n        padding: 8px;\n        @include respond-below(custom1199) {\n            min-width: 430px;\n        }\n        .menu-list {\n            li {\n                margin-bottom: 0;\n                margin-right: 0;\n                a {\n                    display: block;\n                    padding: 8px;\n                    background: $white;\n                    border-radius: $border-radius-lg;\n                    &:hover {\n                        background: $light-300;\n                    }\n                    .menu-details {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        .menu-list-icon {\n                            font-size: $font-size-18;\n                            color: $white;\n                            width: 36px;\n                            min-width: 36px;\n                            height: 36px;\n                            padding: 5px;\n                            margin-right: 8px;\n                            border-radius: $border-radius-lg;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            justify-content: center;\n                            -webkit-justify-content: center;\n                            -ms-flex-pack: center;\n                        }\n                        .menu-details-content {\n                            p {\n                                font-weight: $font-weight-semibold;\n                                color: $gray-900;\n                                margin-bottom: 0;\n                            }\n                            span {\n                                font-weight: $font-weight-normal;\n                                color: $text-color;\n                                @include respond-below(custom1199) {\n                                    font-size: $font-size-13;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .profilename {\n        @include margin-padding(null, 0px);\n        .profileset {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            @include margin-padding(null, 10px 10px 3px);\n            h6 {\n                font-size: $font-size-base;\n                color: $secondary;\n                font-weight: $font-weight-medium;\n            }\n            h5 {\n                font-size: $font-size-base;\n                color: $gray-600;\n            }\n            .profilesets {\n                margin-left: 10px;\n            }\n            .user-img img {\n                margin-top: 0;\n            }\n        }\n    }\n    .show{\n        .user-info {\n            &::after{\n                transform: rotate(-140deg);\n                top: 10px;\n            }  \n        }\n    }\n    \n    .user-info {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        position: relative;\n        padding: 0;\n        span {\n            &.user-detail {\n                @include respond-below(custom1199) {\n                    display: none;\n                }\n            }\n        }\n        &::after {\n            content: \"\";\n            width: 8px;\n            height: 8px;\n            border-top: 0;\n            border-left: 0;\n            border-right: 2px solid #1B2950;\n            border-bottom: 2px solid #1B2950;\n            border-radius: 1px;\n            transform: rotate(45deg);\n            transition: all 0.5s;\n            top: 8px;\n            position: absolute;\n            right: 12px;\n            display: none;\n            @include respond-below(custom1199) {\n                top:  12px;\n            }\n        }\n      .user-role {\n        display: block;\n        color: #67748E;\n        font-size: 12px;\n      }\n      .user-letter {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        color: $white;\n        width: 36px;\n        height: 36px;\n        border-radius: $border-radius-lg;\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-15;\n        margin-right: 0;\n        @include respond-below(custom1199) {\n            margin-right: 0;\n        }\n        img {\n            border-radius: $border-radius-lg;\n        }\n      }\n      .user-name {\n        font-size: $font-size-15;\n        font-weight: $font-weight-semibold;\n        color: #1B2950;\n        display: flex;\n        align-items: center;\n      }\n      .user-name img {\n        margin-left: 10px;\n      }\n    }\n    .header-user {\n        padding: 15px 24px;\n        display: contents;\n        .user-menu {\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin: 0;\n            position: relative;\n            height: 100%;\n            border-bottom: 0;\n            padding:0 24px;\n            @include transition(all 0.5s ease);\n            @include respond-below(custom991) {\n                display: none;\n            }\n            .status {\n                position: absolute;\n                content: \"\";\n                background: $primary;\n                width: 10px;\n                height: 10px;\n                border-radius: 50px;\n                top: 3px;\n                right: 3px;\n            }\n            .header-title{\n                h3{\n                    font-size: 24px;\n                    font-weight: 700;\n                }\n                h6{\n                    font-size: 12px;\n                    font-weight: 600;\n                }\n            }\n            > li {\n                margin-left: 10px;\n                margin-inline-end: 0;\n                &:first-child{\n                    margin-left:0;\n                }\n                @include respond-below(custom1199) {\n                    margin-left: 8px;\n                }\n                svg {\n                    width: 18px;\n                    color: #67748E;            \n                }\n                a:hover{\n                    svg {\n                        color: $primary;\n                    }\n                }\n            }\n            .dropdown-toggle{\n                &::after {\n                    border: 0;\n                    display: none;\n                }\n            }\n            .nav-searchinputs {\n                margin-right: auto;\n                margin-left: 25px;\n            }\n            .nav-item-box > a {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                background: $light-300;\n                color: $gray-900;\n                border-radius: $border-radius-lg;\n                width: 36px;\n                height: 36px;\n                position: relative;\n                border: 0;\n                &:hover {\n                    background: $light-800;\n                }\n            }\n            .nav-item-email {\n                &.nav-item-box {\n                    margin-left: 15px;\n                }\n            }\n            &.nav{\n               > li{\n                >  a{\n                    padding: 0;\n                    display: flex;\n                    line-height: normal;\n                    color: #3E4265;\n                    &.btn-header-list{\n                        color: $white;\n                        width: 36px;\n                        height: 36px;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        border-radius: $border-radius-lg;\n                    }\n                    .badge {\n                        color: $white;\n                        font-weight: $font-weight-bold;\n                        @include position(absolute,4px,4px,null,null);\n                        background: $primary;\n                        width: 15px;\n                        height: 15px;\n                        font-size: $font-size-10;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                    }\n                    i {\n                        font-size: $font-size-18;\n                    }\n                    .badge-success {\n                        background: $success;\n                        border: 3px solid #FFF;\n                        padding: 0;\n                        top: inherit;\n                        bottom: -3px;\n                        right: -3px;\n                    }\n                }\n                &.flag-nav{\n                     a{\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        .dropdown-menu {\n                            max-height: 150px;\n                            min-width: 120px;\n                            overflow-y: auto;\n                            .dropdown-item {\n                                @include margin-padding(null, 5px 15px);\n                            }\n                        }\n                    }\n                    .dropdown-menu {\n                        padding: 15px;\n                        min-width: 210px;\n                        .dropdown-item {\n                            @include margin-padding(null, 10px 10px);\n                            color: #67748E;                    \n                            border-radius: 10px;\n                            transition: none;\n                            &.active{\n                                color: $white;\n                            }\n                            &.active,&:hover{\n                                background: #F7F7F7  no-repeat calc(100% - 12px) center;\n                            }\n                        }\n                        a{\n                            img{\n                                width: 20px;\n                                height: 20px;\n                                border-radius: 50%;\n                                margin-right: 10px;\n                            }\n                        }\n                    }\n                }\n                }\n            }\n        }\n    }\n    .page-title-box {\n        float: left;\n        height: 60px;\n        margin-bottom: 0;\n        @include margin-padding(null, 17px 20px);\n        @include rounded(0);\n        @include respond-below(custom991) {\n            display: none;\n        }\n        a {\n            color: $primary;\n            font-size: $font-size-11;\n            font-weight: $font-weight-bold;\n            border: 1px solid $primary;\n            @include margin-padding(0, 5px);\n            @include rounded(5px);\n            &:hover{\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n    .mobile_btn {\n        display: none;\n        float: left;\n        @include respond-below(custom991) {\n            color: $primary;\n            font-size: $font-size-24;\n            height: 60px;\n            line-height: 60px;\n            width: 60px;\n            z-index: 10;\n            @include margin-padding(null, 0 20px);\n            @include position(absolute,0,null,null,0);\n            display: block;\n        }\n       \n    }\n    .responsive-search {\n        display: none;\n        color: $white;\n        font-size: $font-size-20;\n        height: 60px;\n        line-height: 60px;\n        @include margin-padding(null, 0 15px);\n        @include respond-below(custom991) {\n            display: block;\n        }\n    }\n    .top-nav-search {\n        form {\n            position: relative;\n            @include respond-below(custom991) {\n                display: none;\n            }\n            .form-control {\n                background-color: rgba(255, 255, 255, 0.1);\n                border: 1px solid rgba(255, 255, 255, 0.15);\n                height: 40px;\n                @include margin-padding(null, 10px 50px 10px 15px);\n                @include rounded(50px);\n                &::-webkit-input-placeholder {\n                    color: rgba(255, 255, 255, 0.7);\n                }\n            }\n            .btn {\n                background-color: transparent;\n                border-color: transparent;\n                color: rgba(255, 255, 255, 0.7);\n                min-height: 40px;\n                @include position(absolute,0,0,null,null);\n            }\n        }\n        @include respond-below(custom991) {\n            &.active{\n                form {\n                    display: block;\n                    @include position(absolute,null,null,null,0);\n                    .form-control {\n                        background-color: $white;\n                    }\n                    .btn {\n                        background-color: transparent;\n                        border-color: transparent;\n                        min-height: 40px;\n                        @include position(absolute,0,0,null,null);\n                        @include margin-padding(null, 7px 15px);\n                    }\n                }\n            }\n        }\n    }\n    .userset {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        .usernames{\n            line-height: initial;\n            text-align: right;\n            padding-right: 10px;\n            span {\n                display: block;\n                line-height: initial;\n            }\n        } \n    }\n    .menu-drop-user {\n        .dropdown-item {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            font-size: $font-size-14;\n            color: $gray-900;\n            padding: 10px;\n            border-bottom: 1px solid $light-400;\n            border-radius: 0;\n            &:first-child {\n                border-radius: 5px 5px 0 0;\n            }\n            &:last-child {\n                border-radius: 0 0 5px 5px;\n                border-bottom: 0;\n            }\n            &:hover {\n                padding-left: 20px;\n                letter-spacing: 0.5px;\n            }\n            i {\n                font-size: $font-size-16;\n                margin-right: 8px;\n            }\n        }\n    }\n    .has-arrow{\n        .dropdown-toggle{\n            @include respond-below(custom991) {\n                > span{\n                    &:nth-child(2) {\n                        display: none;\n                    }\n                }\n                &:after{\n                    display: none !important;\n                }\n            }\n        }\n    }\n    .profilename {\n        .user-img {\n            .status {\n                bottom: 10px;\n            }\n        }\n    }\n    .user-img {\n        display: inline-block;\n        position: relative;\n        img {\n            width: 38px;\n            @include rounded(50%);\n        }\n        .status {\n            border: 2px solid $white;\n            height: 10px;\n            width: 10px;\n            @include margin-padding(0, null);\n            @include position(absolute,null,0,30px,null);\n            @include rounded(50%);\n            display: inline-block;\n            background: $success;\n        }\n    }\n    .mobile-user-menu {\n        color: $white;\n        display: none;\n        float: right;\n        font-size: $font-size-24;\n        height: 60px;\n        line-height: 60px;\n        text-align: right;\n        width: 60px;\n        z-index: 10;\n        @include margin-padding(null, 0 20px);\n        @include position(absolute,0,0,null,null);\n        @include respond-below(custom991) {\n            display: block;\n        }\n        a{\n            color: $primary;\n            padding: 0;\n            &::after{\n                display: none;\n            }\n        }\n        .dropdown-menu{\n            padding: 0;\n            a{\n                color:$gray-800;\n                line-height: 40px; \n                @include margin-padding(null, 0 10px);\n            }\n        }\n    }\n}\n.logo-small img {\n    width: 30px;\n}\n@include respond-above(custom992) {\n    .mini-sidebar{\n        &.expand-menu{\n            .header-left {\n                flex-direction:row;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n            }\n        }\n        .header-left {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            width: 80px;\n            @include margin-padding(null, 0);\n            flex-direction:column;\n            .logo-small{\n                display: block;\n                padding: 10px 0 0;\n            }\n            .logo{\n                display: none;\n            }\n        }\n        .menu-arrow{\n            display: none !important;\n        }\n        .chat-user{\n            display: none !important;\n        }\n        .user-menu{\n            .badge{\n                display: flex !important;\n            }  \n        }\n        &.expand-menu{\n            .menu-arrow{\n                display: block !important;\n            }\n            .chat-user{\n                display: block !important;\n            }\n            .logo-small{\n                display: none;\n            }\n            .logo{\n                display: block;\n            }\n            #toggle_btn{\n               opacity: 1;\n            }\n            .header-left{\n                @include margin-padding(null, 0 15px);\n                display: flex;\n            }\n            \n        }\n        .noti-dot{\n            &:before{\n                display: none;\n            }\n        }\n    }\n}\n.nav-list {\n    position: relative;\n    padding-right: 15px;\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 0;\n        width: 1px;\n        height: 20px;\n        background: $light-900;\n        z-index: 1;\n    }\n    .nav {\n        .dark-mode-list {\n            .dark-mode-toggle {\n                width: 66px;\n                height: 36px;\n                background: $light-200;\n                border: 1px solid $light-900;\n                font-size: $font-size-16;\n                border-radius: $border-radius-lg;\n                padding: 3px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n                i {\n                    font-size: $font-size-16;\n                    color: $gray-900;\n                    border-radius: $border-radius-lg;\n                    line-height: 26px;\n                    width: 26px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    &.light-mode.active {\n                        color: $white;\n                        background: $success;\n                    }\n                    &.dark-mode.active {\n                        color: $white;\n                        background: $gray-900;\n                    }\n                }\n            }\n        }\n        li {\n            margin-right: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n            .btn {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                width: 36px;\n                height: 36px;\n                font-size: $font-size-16;\n                border-radius: $border-radius-lg;\n                border: 1px solid transparent;\n            }\n            .btn-header-list {\n                color: $green;\n                background: $success-200;\n                border: 1px solid $green;\n                &:hover {\n                    color: $white;\n                    background: $green;\n                }\n            }\n            .btn-help {\n                color: $tertiary;\n                background: $purple-100;\n                &:hover {\n                    color: $white;\n                    background: $tertiary;\n                }\n            }\n            .btn-chart-pie {\n                color: $secondary;\n                background: $warning-100;\n                &:hover {\n                    color: $white;\n                    background: $secondary;\n                }\n            }\n        }\n    }\n}       \n.mobile-show {\n    display: none;\n    @include respond-below(custom991) {\n        display: block;\n    }\n}\n",".sidebar {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    background-color: $white;\n    margin-top: 0;\n    z-index: 1001;\n    @include position(fixed,56px,null,0,0);\n    @include transition(all 0.5s ease);\n    width: 276px;\n    @include respond-below(custom991) {\n        margin-left: -575px;\n        @include transition(all 0.4s ease);\n        z-index: 1041;\n        background: $white;\n    }\n    @include respond-below(custom575) {\n        width: 100%;\n    }\n    .slimScrollDiv {\n        border-right: 1px solid transparent;\n        @include respond-below(custom575) {\n            width: 100% !important;\n        }\n    }\n    .sidebar-menu{\n        @include margin-padding(null, 15px);\n        .clinicdropdown{\n            margin-bottom: 24px;\n           > a {\n                background: $light-300;\n                border-radius: $border-radius-lg;\n                padding: 10px;\n                img{\n                    width: 42px;\n                    height: 42px;\n                    border-radius: $border-radius-lg;\n                }\n                .user-names{\n                    margin-left: 10px;\n                    flex: 1;\n                    h5{\n                        font-size: $font-size-16;\n                        font-weight: $font-weight-semibold;\n                        color: $title-color;\n                        margin-bottom: 2px;\n                    }\n                    h6 {\n                        font-size: $font-size-14;\n                        font-weight: $font-weight-normal;\n                        color: $text-color;\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n        .submenu-two{\n            .subdrop.active{\n                background: transparent !important;\n            }    \n        }\n        > ul{\n            > li{\n                margin-bottom: 24px;\n                &.active{\n                    a{\n                        color: $white;\n                    }\n                    svg {\n                        color: #FE9F43\n                    }\n                }\n                svg {\n                    min-width: 16px;\n                    width:  16px;\n                    height:  16px;\n                    margin-right: 10px;\n                }\n                > a{\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    @include margin-padding(null, 10px 15px);\n                    position: relative;\n                    color: $secondary;\n                    svg{\n                        color: #637381;\n                    }\n                    img{\n                        color: #637381;\n                    }\n                    \n                    &.active{\n                        background: rgba(254, 159, 67, 0.08);\n                        color: #FE9F43;\n                        border-radius: 5px;\n                        svg{\n                            color: $white;\n                        }\n                        img {\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\n                        }\n                        span{\n                            color: #FE9F43;\n                        }\n                        .menu-arrow{\n                            background: #FFEDDC;\n                            &::before{\n                                border-color: #FE9F43;\n                            }\n                        }\n                    }\n                    span {\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-medium;\n                        color: $gray-600;\n                    }\n                }\n                &.active {\n                    a {\n                        background: rgba(254, 159, 67, 0.08);\n                        border-radius: 5px;\n                        img{\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\n                        }\n                        span{\n                            color: #FE9F43;\n                        }\n                    }\n                }\n                &.submenu {\n                    ul {\n                        display: none;\n                       li {\n                            a {\n                               font-weight: $font-weight-medium;\n                               font-size: $font-size-base;\n                               position: relative;\n                               display: block;\n                               @include margin-padding(null, 8px 8px 8px 40px);\n                               padding-left: 30px;\n                           }\n                       }\n                    }\n                }\n                ul {\n                    display: block;\n                    margin-bottom: 24px;\n                    li {\n                        margin-bottom: 5px;\n                        border-radius: 5px;\n                        overflow: hidden;\n                        a {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            font-weight: $font-weight-normal;\n                            font-size: $font-size-14;\n                            color: $gray-400;\n                            position: relative;\n                            width: 100%;\n                            @include margin-padding(null, 8px);\n                            i {\n                                color: $gray-900;\n                                font-size: $font-size-16;\n                                background: $light-300;\n                                border-radius: 5px;\n                                width: 26px;\n                                height: 26px;\n                                display: flex;\n                                align-items: center;\n                                justify-content: center;\n                            }\n                            span {\n                                font-size: $font-size-15;\n                                font-weight: $font-weight-medium;\n                                white-space: nowrap;\n                                color: $gray-900;\n                                margin-left: 10px;\n                            }\n                            &.active {\n                                color: $primary;\n                                background: $primary-100;\n                                border-radius: $border-radius-lg;\n                                span {\n                                    color: $primary;\n                                }\n                                i {\n                                    background: $primary;\n                                    color: $white;\n                                }\n                            }\n                            &:hover{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                }\n                            }\n                        }  \n                    }\n                    > li {\n                        &.active a{\n                            &.subdrop{\n                                background: #FFEEEC;\n                                border-radius: 5px;\n                                color: #e85b28;\n                                i{\n                                    color:$white;\n                                    background:#e85b28;\n                                }\n                                span {\n                                    color: #e85b28;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu-hdr {\n                    font-weight: $font-weight-semibold;\n                    font-size: $font-size-12;\n                    color: $gray-400;\n                    margin: 0 0 14px 0;\n                    text-transform: uppercase;\n                }\n                &:first-child {\n                    h6 {\n                        margin-top: 0;\n                    }\n                }\n                .submenu {\n                    ul {\n                        display: none;\n                        border: 0;\n                        padding-top: 0;\n                        padding-bottom: 0;\n                    }\n                }\n            }\n            li {\n                margin-bottom: 5px;\n                .submenu > {\n                    ul {\n                        margin: 0;\n                        li {\n                            a {\n                                padding-left: 44px;\n                                font-size: $font-size-base;\n                                background: transparent;\n                                position: relative;\n                                &:after{\n                                    position: absolute;\n                                    content: \"\";\n                                    background-color: #898989;\n                                    width: 7px;\n                                    height: 7px;\n                                    border-radius: 50px;\n                                    left: 16px;\n                                    top: 14px;\n                                }\n                                &:before{\n                                    position: absolute;\n                                    content: \"\";\n                                    background-color: #898989;\n                                    width: 0.5px;\n                                    height: 8px;\n                                    left: 19px;\n                                    top: 0px;\n                                }\n                            }\n                        }\n                    }\n                    a {\n                        &.subdrop {\n                            background: $light-200;\n                            i {\n                                background: $dark;\n                                color: $white;\n                            }\n                            &.submenu-two{\n                                background: transparent;\n                            }\n                        }\n                        &.active {\n                            background: $primary-100;\n                            border-radius: 5px;\n                            i {\n                                background: $primary;\n                                color: $white;\n                            }\n                            span {\n                                color: $primary;\n                            }\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                \n            }\n\n        }\n        .submenu-open {\n            &:last-child {\n                margin-bottom: 0;\n                ul {\n                    border-bottom: none;\n                    padding-bottom: 0;\n                }\n            }\n            .submenu {\n                &.submenu-two {\n                    ul {\n                        li {\n                            a {\n                                margin-left: 45px;\n                            }\n                        }\n                    }\n                    &.submenu-three {\n                        ul {\n                            li {\n                                a {\n                                    margin-left: 65px;\n                                }\n                            }\n                        }\n                    }\n                }\n                ul {\n                    li {\n                        a {\n                        margin-left: 25px;\n                        padding-bottom: 4px;\n                        font-size: $font-size-base;\n                        color: $sub-title;\n                        &::after{\n                            content: \"\";\n                            background: rgba(50, 71, 92, 0.38);\n                            width: 8px;\n                            height: 8px;\n                            border: 2px solid $white;\n                            @include rounded(50px);\n                            @include position(absolute,16px,null,null,0);\n                            }\n                            &:hover{\n                                color:$primary;\n                                &:after{\n                                background: #FE9F43;\n                                border: 2px solid #FDB;\n                                }\n                            }\n                        }\n                    }\n                } \n            } \n        }               \n        .menu-arrow {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            text-rendering: auto;\n            line-height: 40px;\n            font-size: $font-size-18;\n            line-height: 16px;\n            width: 16px;\n            height: 16px;\n            border-radius: 50%;\n            @include position(absolute,12px,10px,null,null);\n            @include transform(translate(0, 0));\n            @include transition(all 0.2s ease);\n            &::before {\n                height: 8px;\n                width: 8px;\n                border-top: 0;\n                content: \"\";\n                border-left: 0;\n                border-right: 2px solid $gray-900;\n                border-bottom: 2px solid $gray-900;\n                transform: rotate(-45deg);\n                position: absolute;\n                left: 5px;\n                top: 5px;\n            }\n            &.inside-submenu {\n                right: 10px;\n                &.inside-submenu-two {\n                    right: 60px;\n                }\n            }\n        }\n        &.subdrop{\n            .menu-arrow {\n                @include transform(rotate(90deg));                            \n                background: #FFEDDC;\n            }\n        }\n    }\n    .sidebar-left {\n        width: 100px;\n        @include box-shadow(null, 5px, 0px, 15px, null, rgba(0, 0, 0, .05));\n    }\n    .sidebar-right {\n        width: 250px;\n        height: 100%;\n        @include transition(all 0.2s ease);\n        display: none;\n        @include respond-below(custom991) {\n            width: calc(100% - 70px);\n        }\n        .slimScrollDiv {\n            width: 250px !important;\n            overflow: visible !important;\n            @include respond-below(custom991) {\n                width: 100% !important;\n            }\n        }\n        .tab-content {\n            @include margin-padding(null, 20px 20px 40px);\n            @include respond-below(custom991) {\n                @include margin-padding(null,10px);\n            }\n        }\n        p {\n            font-size: $font-size-10;\n            color: $gray-500;\n            text-transform: uppercase;\n            font-weight: $font-weight-bold;\n            margin-bottom: 10px;\n        }\n        ul {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n            li {\n                &.active{\n                    a{\n                        background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n                        color: $white;\n                    }\n                }\n                a {\n                    font-weight: $font-weight-normal;\n                    font-size: $font-size-base;\n                    color: $secondary;\n                    &.active {\n                        color: $primary;\n                    }\n                }\n            }\n        }\n        .menu-arrow {\n            -webkit-transition: -webkit-transform 0.15s;\n            -o-transition: -o-transform 0.15s;\n            transition: transform .15s;\n            display: inline-block;\n            font-family: 'Font Awesome 5 Free';\n            text-rendering: auto;\n            line-height: 40px;\n            font-size: $font-size-18;\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            line-height: 18px;\n            top: 0px;\n            position: relative;\n            font-weight: $font-weight-bold;\n            @include transform(translate(0, 0));\n            &:before {\n                content: \"\\f105\";\n                \n            }\n        }\n    }\n    .sub-menu a {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n    }\n    li {\n        a.subdrop {\n            .menu-arrow {\n                @include transform(rotate(90deg));\n            }\n        }\n    }\n    .nav-items{\n        .nav-link {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-direction: column;\n            flex-direction: column;\n            @include rounded(0);\n            border-bottom: 1px solid $gray-400;\n            @include margin-padding(null, 20px 0);\n            @include transition(all 0.4s ease);\n            &:hover{\n                box-shadow: 0  0 0 150px $violet inset;\n                color: $white;\n            }  \n            span{\n                margin-top: 15px;\n                font-weight:$font-weight-medium;\n            }\n        }\n       \n    }\n    .sidemenu {\n        a {\n            width: 100%;\n            font-weight: $font-weight-medium;\n            display: block;\n            @include rounded(5px);\n            @include margin-padding( 0 0 10px, 10px);\n            &:hover{\n                background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n                color: $white;\n                svg{\n                    color:$white;\n                }\n            }\n            svg {\n                stroke-width: 1px;\n            }\n           \n        }\n    }\n}\n\n\n@include respond-above(custom991) {\n    .mini-sidebar {\n        .page-wrapper {\n            margin-left: 80px;\n        }\n        .user-names{\n            display: none;\n        }\n        .header-left {\n            #toggle_btn{\n                opacity: 1;\n                transform: rotate(180deg);\n                &:after {\n                   border:0;\n                }\n            }\n        }\n        .sidebar {\n            .sidebar-menu {\n                .clinicdropdown > a {\n                    padding: 5px;\n                }\n            }\n        }\n        &.expand-menu{\n            .header-left {\n                #toggle_btn{\n                    opacity: 1;\n                    transform: rotate(180deg);\n                }\n            }  \n            .sidebar {\n                .sidebar-menu{\n                    .clinicdropdown > a {\n                        padding: 10px ;\n                    }\n                }\n            }\n        }\n        .sidebar-right {\n            display: none;\n        }\n        .sidebar {\n            .sidebar-menu{\n                  ul{\n                    li{\n                        a {\n                            span{\n                                display:none;\n                            }\n                        }\n                        .submenu-hdr {\n                            display:none;\n                        }                                                       \n                        svg {\n                            margin-right:0;\n                        }\n                    }\n                }\n            } \n        }\n        .sidebar{\n            width: 80px;\n            overflow: hidden;\n        }\n        &.expand-menu{\n            .sidebar {\n                display:block\n            }\n        }\n    }\n    .expand-menu{\n        &.mini-sidebar{\n            .sidebar{\n                .sidebar-menu{\n                    .submenu-hdr {\n                        display:block;\n                    }\n                }\n                .user-names{\n                    display: block;\n                }\n            }\n        }\n        .sidebar-right {\n            display: block;\n            @include transition(all 0.2s ease);\n        }\n        .sidebar {\n            width: 276px;\n            .sidebar-menu{\n               ul{\n                   > li{\n                        > a {\n                            span{\n                                display:inline-block;\n                                line-height: 0;\n                            }\n                        }                        \n                        svg {\n                            margin-right:10px;\n                        }\n                    }\n                }\n                .submenu-hdr {\n                    display:block;\n                }\n            }\n        }\n        .header-left{\n            width: 276px;\n        }\n    }\n    #toggle_btn {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        float: left;\n    }\n}\nbody.mini-sidebar.expand-menu{\n    .sidebar .sidebar-menu > ul > li ul li a{\n        justify-content: start;\n    }\n}\nbody.mini-sidebar{\n    .sidebar .sidebar-menu > ul > li ul li a{\n        justify-content: center;\n    }\n    .sidebar {\n        .sidebar-menu > ul > li.submenu-open ul li a {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            font-weight: $font-weight-medium;\n            font-size: $font-size-15;\n            color: #67748E;\n            position: relative;\n            width: 100%;\n            padding: 10px;\n        }\n        .sidebar-menu > ul > li ul > li.active a{\n            padding: 10px;\n            justify-content: center;\n        }\n    }\n     \n    &.expand-menu {\n        .sidebar {\n            .sidebar-menu > ul > li.submenu-open ul li a {\n                justify-content: left;\n                -webkit-justify-content: left;\n                -ms-flex-pack: left;\n                padding-left:  18px;\n            }\n            .sidebar-menu > ul > li ul > li.active a{\n                padding: 10px 15px;\n                justify-content: start;\n            }\n        }\n    }\n}\n\n.sidebarrightmenu{\n    .sidebar-right{\n        display: block;\n    }\n}\n.slide-nav{\n    .sidebar {\n        margin-left: 0;\n    }\n}\n.sidebar-overlay {\n    display: none;\n    height: 100%;\n    width: 100%;\n    z-index: 99;\n    background-color: rgba(0, 0, 0, 0.6);\n    @include position(fixed,60px,null,null,0);\n    &.opened {\n        display: block;\n    }\n}\n.mini-sidebar{\n    .active.subdrop ~ ul{\n        display: none !important;\n    }\n}\n.mini-sidebar.expand-menu{\n    .active.subdrop ~ ul{\n        display: block !important;\n    }\n}\n.active.subdrop ~ ul{\n    display: block !important;\n}\n\n.sidebar {\n\t.sidebar-menu {\n\t\t>ul {\n\t\t\tli {\n\t\t\t\t.submenu {\n                    &.submenu-two {\n                        >ul {\n                            li {\n                                a {\n                                    margin-left: 30px;\n                                }\n                            }\n                        }\n                        &.submenu-three {\n                            >ul {\n                                li {\n                                    a {\n                                        margin-left: 60px;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                \n\t\t\t}\n\t\t}\n\t}\n}\n.mini-sidebar {\n    .header {\n        #toggle_btn {\n            opacity: 0;\n            height: 0;\n            width: 0;\n        }\n    }\n}\n.sidebar .modern-profile, .sidebar .sidebar-header {\n    display: none;\n}\n\n// Always show the sidebar toggle button in mini-sidebar mode\n.mini-sidebar #toggle_btn, .mini-sidebar .header-left #toggle_btn {\n  display: flex !important;\n  opacity: 1 !important;\n  height: 40px !important;\n  width: 40px !important;\n  align-items: center;\n  justify-content: center;\n  position: static;\n  left: unset;\n  top: unset;\n  z-index: 2000;\n  background: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  cursor: pointer;\n  margin-left: 0;\n}",".layout-box-mode {\n    .main-wrapper {\n        max-width: 1320px;\n        margin: auto;\n        @include respond-below(custom1440) {\n            max-width: 1170px;\n        }\n        @include respond-below(custom1280) {\n            max-width: 950px;\n        }\n        @include respond-below(custom991) {\n            max-width: 100%;\n        }\n    }\n}\n\n@mixin use-css-variable($variable-name) {\n    #{$variable-name}: var(#{$variable-name});\n}\n:root {\n    --primary-rgb-picr: var(--primary-rgb);\n    --sidebar--rgb-picr: var(--sidebar-rgb);\n    --topbar--rgb-picr: var(--topbar-rgb);\n    --topbarcolor--rgb-picr: var(--topbarcolor-rgb);\n}\n[data-layout=\"default\"][data-width=\"box\"],\n[data-layout=\"mini\"][data-width=\"box\"] {\n    .layout-box-mode {\n        .mini-sidebar {\n            .header {\n                max-width: 1320px;\n                left: 0;\n                @include respond-below(custom1440) {\n                    max-width: 1170px;\n                }\n                @include respond-below(custom1280) {\n                    max-width: 950px;\n                }\n                @include respond-below(custom991) {\n                    max-width: 100%;\n                }\n            }\n            &.expand-menu {\n                .header {\n                    max-width: 1320px;\n                    left: 0;\n                    @include respond-below(custom1440) {\n                        max-width: 1170px;\n                    }\n                    @include respond-below(custom1280) {\n                        max-width: 950px;\n                    }\n                    @include respond-below(custom991) {\n                        max-width: 100%;\n                    }\n                }\n            }\n        }        \n        .header {\n            margin: auto;\n            max-width: 1320px;\n            left: 0;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n                left: 0;\n            }\n            .header-left {\n                display: block;\n                padding-left: 24px;\n                @include respond-below(custom991) {\n                    padding-left: 0;\n                }\n            }\n        }\n        .sidebar {\n            left: unset;\n            top: 50px;\n            .sidebar-logo {\n                display: none;\n            }\n            .slimScrollDiv {\n                top: 0;\n            }\n        }\n    }\n}\n[data-layout=\"twocolumn\"][data-width=\"box\"],\n[data-layout=\"modern\"][data-width=\"box\"],\n[data-layout=\"stacked\"][data-width=\"box\"] {\n    .layout-box-mode {\n        .sidebar {\n            left: unset;\n            .sidebar-logo {\n                display: none;\n            }\n        }\n        .header {\n            margin: 0 auto;\n            max-width: calc(1320px - 252px);\n            @include respond-above(custom991) {\n                left: 252px;\n            }\n            @include respond-below(custom1440) {\n                max-width: calc(1170px - 252px);\n            }\n            @include respond-below(custom1280) {\n                max-width: calc(950px - 252px);\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n                left: 0;\n            }\n        }\n        &.mini-sidebar {\n            .header {\n                @include respond-above(custom991) {\n                    left: 72px;\n                }\n                max-width: calc(1320px - 72px);\n                @include respond-below(custom1440) {\n                    max-width: calc(1170px - 72px);\n                }\n                @include respond-below(custom1280) {\n                    max-width: calc(950px - 72px);\n                }\n                @include respond-below(custom991) {\n                    max-width: 100%;\n                    left: 0;\n                }\n            }\n            &.expand-menu {\n                .header {\n                    max-width: calc(1320px - 252px);\n                    @include respond-above(custom991) {\n                        left: 252px;\n                    }\n                    @include respond-below(custom1440) {\n                        max-width: calc(1170px - 252px);\n                    }\n                    @include respond-below(custom1280) {\n                        max-width: calc(950px - 252px);\n                    }\n                    @include respond-below(custom991) {\n                        max-width: 100%;\n                        left: 0;\n                    }\n                }\n            }\n        }\n    }\n}\n[data-layout=\"horizontal\"][data-width=\"box\"],\n[data-layout=\"horizontal-overlay\"][data-width=\"box\"] {\n    .main-wrapper {\n        .header {\n            margin: auto;\n            max-width: 1320px;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n        }\n        &::before {            \n            width: 1320px;\n            margin: 0 auto;\n            left: 0;\n            right: 0;\n            @include respond-below(custom1440) {\n                width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                width: 950px;\n            }\n            @include respond-below(custom991) {\n                width: 100%;\n            }\n        }\n        &::after { \n            left: 0;\n            right: 0;\n            margin: 0 auto;\n            @include respond-below(custom1440) {\n                width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                width: 950px;\n            }\n            @include respond-below(custom991) {\n                width: 100%;\n            }\n        }\n    }\n    .header {\n        padding: 0 16px;\n        .main-header {\n            max-width: 1320px;\n            margin: 0 auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n            .user-menu {\n                padding-right: 0;\n            }\n        }\n        .header-left {\n            display: block;\n        }\n    }     \n    .sidebar {\n        &.sidebar-horizontal {\n            max-width: 1320px;\n            margin: 0 auto;\n            padding: 0 16px !important;\n            left: auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n            .sidebar-menu {\n                .nav-menu {\n                    > li {\n                        &.submenu {\n                            & > a {\n                                padding: 8px 30px 8px 8px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n[data-layout=\"horizontal-single\"][data-width=\"box\"] {\n    .header {\n        max-width: 1320px;\n        margin: 0 auto;\n        @include respond-below(custom1440) {\n            max-width: 1170px;\n        }\n        @include respond-below(custom1280) {\n            max-width: 950px;\n        }\n        @include respond-below(custom991) {\n            max-width: 100%;\n        }\n        .main-header {\n            .user-menu {\n                padding-left: 10px;\n                @include respond-below(custom1280) {\n                    padding-left: 8px !important;\n                }\n            }\n        }\n    }  \n    .sidebar-horizontal.sidebar {\n        .sidebar-menu {\n            ul li.submenu > a {\n                padding: 8px 18px 8px 6px;\n                @include respond-above(custom1280) {\n                    padding: 8px 30px 8px 8px;\n                }\n            }\n        } \n    }\n}\n[data-layout=\"detached\"][data-width=\"box\"] {\n    .header {\n        max-width: 1320px;\n        margin: 0 auto;\n        @include respond-below(custom1440) {\n            max-width: 95%;\n        }\n    } \n}\n[data-layout=\"without-header\"][data-width=\"box\"] {\n    .sidebar {\n        left: auto;\n    }\n}\n[data-layout=\"transparent\"][data-width=\"box\"] {\n    .sidebar {\n        left: auto;\n    }\n    .header {\n        max-width: 1320px;\n        margin: 0 auto;\n        @include respond-below(custom1440) {\n            max-width: 1170px;\n        }\n        @include respond-below(custom1280) {\n            max-width: 950px;\n        }\n        @include respond-below(custom991) {\n            max-width: 100%;\n        }\n    }  \n}\n[data-layout=\"horizontal-sidemenu\"][data-width=\"box\"] {\n    .sidebar {\n        left: auto;\n    }\n    .header {\n        max-width: 1320px;\n        margin: 0 auto;\n        @include respond-below(custom1440) {\n            max-width: 95%;\n        }\n        @include respond-below(custom991) {\n            max-width: 100%;\n        }\n    }  \n    .main-wrapper {\n        \n        &::before {            \n            width: 1320px;\n            margin: 0 auto;\n            left: auto;\n            @include respond-below(custom1440) {\n                width: 95%;\n            }\n            @include respond-below(custom991) {\n                width: 100%;\n            }\n        }\n    }\n}\n[data-layout=detached] {\n    .main-wrapper {\n            margin: 0 auto;\n        @include respond-above(custom1440) {\n            max-width: 1320px;\n        }\n        @include respond-above(custom991) {\n            max-width: 95%;\n        }\n    }\n    .header {\n        left: 0;\n        .main-header {\n            margin: 0 auto;\n            @include respond-above(custom1440) {\n                max-width: 1320px;\n            }\n            @include respond-above(custom991) {\n                max-width: 95%;\n            }\n        }\n    }\n    .expand-menu{\n        .header-left {\n            width: auto;\n        }\n        &.mini-sidebar{\n            .header {\n                left: 0;\n                .header-left {\n                    width: auto;\n                }\n            }\n        }\n    }\n    .sidebar {\n        top: 74px;\n        left: unset;\n        bottom: 24px;\n        .slimScrollDiv {\n            height: 100% !important;\n            top: 0;\n            .sidebar-inner {\n                height: 100% !important;\n            }\n            .sidebar-menu {\n                margin-top: 0;\n                padding-bottom: 0;\n            }\n        }\n        .sidebar-menu {\n            margin-top: 16px;\n        }\n        .sidebar-logo {\n            display: none;\n        }\n        @include respond-below(custom991) {\n            top: 50px;\n            bottom: 0;\n        }\n    }\n    .page-wrapper {\n        @include respond-above(custom991) {\n            padding: 74px 0 0;\n        }\n        .head-icons{\n            #collapse-header {\n                display: none;\n            }\n        }\n    }\n\n}\n[data-layout=twocolumn] {\n    .sidebar.navbar-menu {\n        display: none;\n        @include respond-below(custom991) {\n            display: block;\n        }\n    }   \n    .sidebar-twocol.sidebar {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n    #two-col-sidebar {\n        display: block;\n        @include respond-below(custom991) {\n            display: none;\n        }\n    }  \n}\n[data-layout=horizontal] {   \n    #horizontal-menu {\n        display: block;\n    }\n    .header {\n        left: 0;\n        .main-header {\n            max-width: 1320px;\n            margin: 0 auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n            .user-menu {\n                padding-right: 0;\n            }\n        }\n        .header-left {\n            display: block;\n        }\n    }  \n}\n[data-layout=\"modern\"] {\n    .header {\n        background-color: $white;\n        border-color: rgba($white, 0.8);\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .input-group {\n            @include respond-below(custom1280) {\n                width: 200px;\n            }\n        }\n        .header-left {\n            display: block;\n            padding-left: 24px;\n            .logo {\n                display: block;\n            }\n            .dark-logo {\n                display: none;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-500;\n                    &:hover, &:active, &.active {\n                        background-color: $dark-transparent;\n                        border-color: $dark-transparent;\n                        color: $gray-900 !important;\n                    }\n                }\n            }\n        }\n    }\n    .sidebar {\n        display: block;\n        .sidebar-logo {\n            display: none;\n        }\n        .slimScrollDiv {\n            top: 0;\n            height: calc(100% - 220px) !important;            \n        }\n        .sidebar-inner {\n            height: 100% !important;\n        }\n        .sidebar-menu {\n            margin-top: 0;\n        }\n        .modern-profile {\n            display: block;\n        }\n    }\n    .page-wrapper {\n        &::before {\n            content: \"\";\n            height: 168px;\n            background: $white;\n            width: 100%;\n            position: absolute;\n            top: 0;\n            left: 0;\n            z-index: -1;\n        }\n        &::after {\n            content: none;\n            height: 168px;\n            // background: url('../../../../public/assets/img/bg/modern-bg.png');\n            background-repeat: no-repeat;\n            width: 60%;\n            position: absolute;\n            top: 0;\n            right: 0;\n            z-index: -1;\n        }\n    }\n    .mini-sidebar {\n        .modern-profile {\n            .user-profile {\n                padding: 0 !important;\n                margin-bottom: 0 !important;\n                background: transparent !important;\n                border-color: transparent !important;\n                .avatar {\n                    width: 40px;\n                    height: 40px;\n                }\n            }\n            h6, p, .sidebar-nav {\n                display: none;\n            }\n        }\n        .slimScrollDiv {\n            height: calc(100% - 70px) !important;\n        }\n        &.expand-menu {            \n            .modern-profile {\n                .user-profile {\n                    padding: 16px !important;\n                    margin-bottom: 24px !important;\n                    background: $light !important;\n                    .avatar {\n                        width: 40px;\n                        height: 40px;\n                    }\n                }\n                h6, p, .sidebar-nav {\n                    display: block;\n                }\n            }\n            .slimScrollDiv {\n                height: calc(100% - 220px) !important;\n            }\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"] {   \n    #horizontal-menu {\n        display: block;\n    }\n    .header {\n        left: 0;\n        background-color: $white;\n        border-color: lighten($white, 0.9);\n        .main-header {\n            max-width: 1320px;\n            margin: 0 auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n            .user-menu {\n                padding-right: 0;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-500;\n                    &:hover {\n                        background: $dark-transparent;\n                        color: $gray-900;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $gray-700;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $white;\n            border-bottom: 1px solid lighten($white, 0.9);\n            &::before {\n                content: none;\n                height: 100%;\n                // background: url('../../../../public/assets/img/bg/overlay-bg.png');\n                background-repeat: no-repeat;\n                width: 100%;\n                position: absolute;\n                top: 0;\n                left: 0;\n                z-index: -1;\n            }\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $gray-900;\n                                &.active, &:hover,  &.subdrop {\n                                    background-color: $dark-transparent;\n                                    color: $gray-900;\n                                    .menu-arrow {\n                                        &::before {\n                                            border-color: $gray-900;\n                                        }\n                                    }\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-900;;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        max-width: 1320px;\n        margin: 0 auto;\n        @include respond-below(custom1440) {\n            max-width: 1170px;\n        }\n        @include respond-below(custom1280) {\n            max-width: 950px;\n        }\n        @include respond-below(custom991) {\n            max-width: 100%;\n        }\n        &::before {\n            content: \"\";\n            height: 168px;\n            background: $white;\n            width: 100%;\n            position: absolute;\n            top: 96px;\n            left: 0;\n            z-index: -1;\n            @include respond-below(custom991) {\n                top: 50px;\n                height: 100px;\n            }\n        }\n        &::after {\n            content: \"\";\n            height: 168px;\n            background-repeat: no-repeat;\n            width: 100%;\n            position: absolute;\n            top: 96px;\n            left: 0;\n            z-index: -1;\n            @include respond-below(custom991) {\n                top: 50px;\n                height: 100px;\n            }\n        }\n    }\n    .page-breadcrumb {\n        h2 {\n            color: $white;\n        }\n    }\n}\n[data-layout=\"horizontal-box\"] {\n    #horizontal-menu {\n        display: block;\n    }\n    .main-wrapper {\n        max-width: 1320px;\n        margin: auto;\n        @include respond-below(custom1440) {\n            max-width: 1170px;\n        }\n        @include respond-below(custom1280) {\n            max-width: 950px;\n        }\n        @include respond-below(custom991) {\n            max-width: 100%;\n        }\n        .header {\n            max-width: 1320px;\n            margin: auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n        }\n    }\n    .header {\n        left: 0;\n        padding: 0 16px;\n        .main-header {\n            max-width: 1320px;\n            margin: 0 auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n            .user-menu {\n                padding-right: 0;\n            }\n        }\n        .header-left {\n            display: block;\n            .dark-logo {\n                display: block;\n            }\n        }\n    }     \n    .sidebar {\n        &.sidebar-horizontal {\n            max-width: 1320px;\n            margin: 0 auto;\n            padding: 0 16px !important;\n            left: auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n            .sidebar-menu {\n                .nav-menu {\n                    > li {\n                        &.submenu {\n                            & > a {\n                                padding: 8px 30px 8px 8px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal-fullwidth\"] {     \n    #horizontal-menu {\n        display: block;\n    }\n    .header {\n        padding: 0 24px;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            .sidebar-menu {\n                max-width: 100%;\n                padding: 0 24px !important;\n                .nav-menu {\n                    > li {\n                        &.submenu {\n                            & > a {\n                                padding: 8px 24px 8px 8px;\n                                @include respond-above(custom1440) {\n                                    padding: 8px 30px 8px 8px;\n                                }\n                                @include respond-above(custom1280) {\n                                    padding: 8px 28px 8px 8px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n[data-layout=\"without-header\"] { \n    .header {\n        @include respond-above(custom991) {\n            width: 60px;\n            height: 0;\n        }\n        #toggle_btn {\n            display: none;\n        }\n    }\n    .page-wrapper {\n        padding: 0;\n        .head-icons{\n            display: none;\n        }\n    }\n    .modern-profile {\n        .user-profile {\n            display: none;\n        }\n    }\n    .modern-profile, .sidebar-header {\n        display: block;\n    }\n    .sidebar {\n        display: block;\n        .sidebar-logo {\n            position: relative;\n        }\n    }\n    .slimScrollDiv {\n        top: 0;\n        height: calc(100% - 100px) !important;\n        .sidebar-inner {\n            height: 100% !important;\n        }\n    }\n    .mini-sidebar {\n        .sidebar-nav {\n            display: none;\n        }\n        .sidebar-header {\n            .input-group, .menu-item  {\n                display: none !important;\n            }\n        }\n        .sidebar-profile {\n            padding: 0 !important;\n            background: transparent !important;\n            border-color: transparent !important;;\n            .sidebar-profile-info {\n                display: none;\n            }\n        }\n        .slimScrollDiv {\n            height: calc(100% - 110px) !important;\n            .sidebar-inner {\n                height: 100% !important;\n            }\n        }\n        &.expand-menu {\n            .sidebar-nav {\n                display: block;\n            }\n            .sidebar-header {\n                .input-group, .menu-item  {\n                    display: flex !important;\n                }\n            }\n            .sidebar-profile {\n                padding: 8px !important;\n                background: $light !important;\n                border-color: $light !important;;\n                .sidebar-profile-info {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal-single\"] { \n    #horizontal-menu {\n        display: none;\n    }\n    #horizontal-single {\n        position: relative;\n        top: auto;\n        width: auto !important;\n        box-shadow: none;\n        display: block;\n    }\n    #header-search {\n        display: none !important;\n    }\n    .header {\n        padding: 5px 24px;\n        @include respond-below(custom1280) {\n            padding: 0 16px;\n        }\n        .header-left {\n            width: auto;\n            height: 40px;\n            display: flex !important;\n            align-items: center;\n        }\n        .top-nav-search,.dark-mode-list {\n            display: none;\n        }\n        .nav.user-menu {\n            padding: 0;\n        }\n    }\n    .sidebar .sidebar-menu .menu-arrow::before {\n        top: 3px;\n        width: 6px;\n        height: 6px;\n    }\n    .menu-horizontal {\n        .header {\n            .main-header .user-menu {\n                @include respond-below(custom1280) {\n                    padding-left: 16px;\n                }\n            }\n        }\n        .page-wrapper {\n            padding-top: 50px;    \n            max-width: 100%;\n            margin: 0 24px;\n        }\n        .header-collapse{\n            .header-user{\n                display: block;\n            }\n        }\n    }\n    .footer {\n        margin: 0 -24px;\n    }\n    .sidebar-horizontal.sidebar {\n        .sidebar-menu {\n            padding:  0 !important;\n            height: 46px;\n            display: flex;\n            align-items: center;\n            margin: 0 auto;\n            width: 100%;\n            ul li.submenu > a {\n                padding: 8px 21px 8px 8px;\n                @include respond-above(custom1280) {\n                    padding: 8px 30px 8px 8px;\n                }\n            }\n            .nav-menu {\n                & > li {\n                    margin-right: 8px;     \n                    @include respond-below(custom1280) {\n                        margin-right: 1px;\n                    }\n                    a {\n                        .menu-arrow {\n                            @include respond-below(custom1280) {\n                                right: 2px;\n                            }                            \n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-menu {\n        .nav-menu {\n            & > li {\n                margin-right: 8px;  \n                &:last-child {\n                    margin-right: 0;\n                }\n                &.submenu {\n                    > ul {\n                        max-height: 350px;\n                        overflow-x: hidden;\n                        overflow-y: auto;\n                    }\n                }\n                @include respond-below(custom1440) {\n                    margin-right: 2px;\n                }\n            }\n        }\n    }\n}\n[data-layout=\"stacked\"] { \n    #sidebar {\n        @include respond-above(custom991) {\n            display: none;\n        }\n    }  \n    #stacked-sidebar { \n        @include respond-above(custom991) {\n            display: block;\n        }\n    }\n    .mini-sidebar {\n        .sidebar {\n            @include respond-above(custom991) {\n                overflow: unset;\n            }\n            .sidebar-right {\n                display: none !important;\n            }\n        }\n        &.expand-menu {\n            .sidebar {\n                .sidebar-right {\n                    display: flex !important;\n                }\n            }\n        }\n    }\n}\n[data-layout=\"transparent\"],.data-layout-transparent { \n    body {\n        background-color: $primary-transparent;\n    }\n    .header {\n        left: 0;\n        border-bottom: 3px solid $primary;\n        .header-left {\n            display: block;\n            padding-left: 24px;\n        }\n    }\n    .sidebar {\n        top: 50px;\n        background-color: $primary-transparent;\n        .sidebar-logo {\n            display: none;\n            .logo {\n                display: none;\n            }\n        }\n        .slimScrollDiv {\n            top: 0;\n        }\n    }\n    .mini-sidebar {\n        &.expand-menu {\n            @include respond-above(custom991) {\n                .header {\n                    left: 0;\n                }\n            }\n        }\n    }\n    .page-wrapper{\n        .head-icons{\n            display: none;\n        }\n    }\n}\nbody.data-layout-transparent {\n    background-color: $primary-transparent;\n    .header {\n        left: 0;\n        border-bottom: 3px solid $primary;\n        .header-left {\n            display: block;\n            padding-left: 24px;\n        }\n    }\n    .sidebar {\n        top: 50px;\n        background-color: $primary-transparent;\n        .sidebar-logo {\n            display: none;\n            .logo {\n                display: none;\n            }\n        }\n        .slimScrollDiv {\n            top: 0;\n        }\n    }\n    .mini-sidebar {\n        &.expand-menu {\n            @include respond-above(custom991) {\n                .header {\n                    left: 0;\n                }\n            }\n        }\n    }\n    .page-wrapper{\n        .head-icons{\n            display: none;\n        }\n    }\n}\n[data-layout=\"horizontal-sidemenu\"] { \n    .header {\n        left: 0;\n        background-color: $gray-900;\n        border-color: $gray-800;\n        .main-header {\n            max-width: 1320px;\n            margin: 0 auto;\n            @include respond-below(custom1440) {\n                max-width: 1170px;\n            }\n            @include respond-below(custom1280) {\n                max-width: 950px;\n            }\n            @include respond-below(custom991) {\n                max-width: 100%;\n            }\n            .user-menu {\n                padding-right: 0;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $gray-600;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }   \n    .main-wrapper {\n        margin: 0 auto;\n        @include respond-above(custom1440) {\n            max-width: 1320px;\n        }\n        @include respond-above(custom991) {\n            max-width: 95%;\n        }\n        &::before {\n            content: \"\";\n            height: 168px;\n            background: $gray-900;\n            width: 100%;\n            position: absolute;\n            top: 50px;\n            left: 0;\n            z-index: -1;\n            @include respond-below(custom991) {\n                top: 50px;\n                height: 100px;\n            }\n        }\n        &::after {\n            content: \"\";\n            height: 168px;\n            background-repeat: no-repeat;\n            width: 100%;\n            position: absolute;\n            top: 50px;\n            left: 0;\n            z-index: -1;\n            @include respond-below(custom991) {\n                top: 50px;\n                height: 100px;\n            }\n        }\n    }  \n    .sidebar {\n        top: 74px;\n        left: unset;\n        bottom: 24px;\n        .slimScrollDiv {\n            height: 100% !important;\n            top: 0;\n            .sidebar-inner {\n                height: 100% !important;\n            }\n            .sidebar-menu {\n                margin-top: 0;\n                padding-bottom: 0;\n            }\n        }\n        .sidebar-menu {\n            margin-top: 16px;\n        }\n        .sidebar-logo {\n            display: none;\n        }\n        @include respond-below(custom991) {\n            top: 50px;\n            bottom: 0;\n        }\n    }\n    .page-wrapper {\n        @include respond-above(custom991) {\n            padding: 74px 0 0;\n        }\n        .head-icons{\n            display: none;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .header {\n                left: 0;\n            }\n        }\n    }\n}\n[data-sidebar=\"dark\"]{\n    .sidebar {\n        background: $gray-900;\n        border-color: $gray-900;\n        .dark-logo {\n            display: block;\n        }\n        .logo {\n            display: none;\n        }\n        .sidebar-menu {\n            > ul {\n                > li {\n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $gray-600;\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        > a {\n                            i {\n                                color: $gray-200;\n                            }\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                            &:hover, &.active {\n                                background: $gray-600;\n                            }\n                        }\n                    }\n                    &.active {\n                        a {\n                            span {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    ul {\n                        li {\n                            &.active {\n                                a {\n                                     i {\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                            a {\n                                color: $gray-300;\n                                &:hover, &.active{\n                                    color:$primary;\n                                }\n                                i {\n                                    color: $gray-200;\n                                }\n                                span {\n                                    color: $gray-300;\n                                }\n                            }\n                            &.active {\n                                a {\n                                    background: $gray-700;\n                                    i {\n                                        color: $gray-200;\n                                    }\n                                }\n                            }\n                            .submenu {\n                                > ul {\n                                    li {\n                                        a {\n                                            color: $gray-300;\n                                            &.active, &:hover {\n                                                color: $primary;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                li {                    \n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active, &:hover {\n                                background: transparent;\n                             }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                &::before {\n                    border-color: $gray-200;\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .nav-link { \n                color: $white;\n                &.active, &:hover {\n                    background: $gray-600;\n                }\n            }\n            .sidebar-right {\n                background: $gray-900;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                }\n                h6, p {\n                    color: $white;\n                }\n                .bg-light {\n                    background-color: $gray-600 !important;\n                    border-color: $gray-600 !important;\n                }\n                ul {\n                    li {\n                        a {\n                            color: $white;\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                        }\n                        &.subdrop {\n                            background: $gray-600;\n                            &:hover {\n                                color: $white !important;\n                            }\n                        }\n                        &.active{\n                            a {\n                                background: $gray-600;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $gray-600;\n                                    color: $white !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                    & > ul {                \n                         & > li {\n                             > a {\n                                 &:hover {\n                                     background: $gray-600;\n                                     color: $white !important;\n                                 }\n                             }\n                         }\n                     }\n     \n                 }\n            }\n        }\n        .twocol-mini {\n            background-color: $gray-900;\n            border-color: $gray-800;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .sidebar-twocol {\n                &.sidebar {\n                    .logo {\n                        @include respond-above(custom991) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            background-color: $gray-900;\n            border-color: $gray-800;\n        }\n        .btn-menubar {\n            color: $white;\n            border-color: $gray-900;\n            &:hover, &.active {\n                background: $gray-600;\n            }\n        }\n        .sidebar-right {\n            background: $gray-900;\n            h6 {\n                color: $white;\n            }\n            .sidebar-profile {\n                h6 {\n                    color: $gray-900;\n                }\n            }\n            a {\n                color: $white;\n                &:hover {\n                    color: $primary;\n                }\n            }\n        }\n        .nav-link {\n            color: $white;\n            background: $gray-800;\n            border-color: $gray-800;\n            p, i {\n                color: $white;\n            }\n            &:hover, &.active {\n                color: $white;\n                background: $gray-800;\n                border-color: $gray-800;\n                p {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n[data-sidebar=\"darkgreen\"]{\n    .sidebar {\n        background: $dark-green;\n        border-color: $dark-green;\n        .dark-logo {\n            display: block;\n        }\n        .logo {\n            display: none;\n        }\n        .sidebar-menu {\n            > ul {\n                > li {\n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $gray-600;\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        > a {\n                            i {\n                                color: $gray-200;\n                            }\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                            &:hover, &.active {\n                                background: $gray-600;\n                            }\n                        }\n                    }\n                    &.active {\n                        a {\n                            span {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    ul {\n                        li {\n                            &.active {\n                                a {\n                                     i {\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                            a {\n                                color: $gray-300;\n                                &:hover, &.active{\n                                    color:$primary;\n                                }\n                                i {\n                                    color: $gray-200;\n                                }\n                                span {\n                                    color: $gray-300;\n                                }\n                            }\n                            &.active {\n                                a {\n                                    background: $gray-700;\n                                    i {\n                                        color: $gray-200;\n                                    }\n                                }\n                            }\n                            .submenu {\n                                > ul {\n                                    li {\n                                        a {\n                                            color: $gray-300;\n                                            &.active, &:hover {\n                                                color: $primary;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                li {                    \n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active, &:hover {\n                                background: transparent;\n                             }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                &::before {\n                    border-color: $gray-200;\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .nav-link { \n                color: $white;\n                &.active, &:hover {\n                    background: $gray-600;\n                }\n            }\n            .sidebar-right {\n                background: $dark-green;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                }\n                h6, p {\n                    color: $white;\n                }\n                .bg-light {\n                    background-color: $gray-600 !important;\n                    border-color: $gray-600 !important;\n                }\n                ul {\n                    li {\n                        a {\n                            color: $white;\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                        }\n                        &.subdrop {\n                            background: $gray-600;\n                            &:hover {\n                                color: $white !important;\n                            }\n                        }\n                        &.active{\n                            a {\n                                background: $gray-600;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $gray-600;\n                                    color: $white !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                    & > ul {                \n                         & > li {\n                             > a {\n                                 &:hover {\n                                     background: $gray-600;\n                                     color: $white !important;\n                                 }\n                             }\n                         }\n                     }\n     \n                 }\n            }\n        }\n        .twocol-mini {\n            background-color: $dark-green;\n            border-color: $gray-800;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .sidebar-twocol {\n                &.sidebar {\n                    .logo {\n                        @include respond-above(custom991) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            background-color: $dark-green;\n            border-color: $gray-800;\n        }\n        .btn-menubar {\n            color: $white;\n            border-color: $dark-green;\n            &:hover, &.active {\n                background: $gray-600;\n            }\n        }\n        .sidebar-right {\n            background: $dark-green;\n            h6 {\n                color: $white;\n            }\n            .sidebar-profile {\n                h6 {\n                    color: $dark-green;\n                }\n            }\n            a {\n                color: $white;\n                &:hover {\n                    color: $primary;\n                }\n            }\n        }\n        .nav-link {\n            color: $white;\n            background: $gray-800;\n            border-color: $gray-800;\n            p, i {\n                color: $white;\n            }\n            &:hover, &.active {\n                color: $white;\n                background: $gray-800;\n                border-color: $gray-800;\n                p {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n[data-sidebar=\"nightblue\"]{\n    .sidebar {\n        background: $night-blue;\n        border-color: $night-blue;\n        .dark-logo {\n            display: block;\n        }\n        .logo {\n            display: none;\n        }\n        .sidebar-menu {\n            > ul {\n                > li {\n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $gray-600;\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        > a {\n                            i {\n                                color: $gray-200;\n                            }\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                            &:hover, &.active {\n                                background: $gray-600;\n                            }\n                        }\n                    }\n                    &.active {\n                        a {\n                            span {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    ul {\n                        li {\n                            &.active {\n                                a {\n                                     i {\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                            a {\n                                color: $gray-300;\n                                &:hover, &.active{\n                                    color:$primary;\n                                }\n                                i {\n                                    color: $gray-200;\n                                }\n                                span {\n                                    color: $gray-300;\n                                }\n                            }\n                            &.active {\n                                a {\n                                    background: $gray-700;\n                                    i {\n                                        color: $gray-200;\n                                    }\n                                }\n                            }\n                            .submenu {\n                                > ul {\n                                    li {\n                                        a {\n                                            color: $gray-300;\n                                            &.active, &:hover {\n                                                color: $primary;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                li {                    \n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active, &:hover {\n                                background: transparent;\n                             }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                &::before {\n                    border-color: $gray-200;\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .nav-link { \n                color: $white;\n                &.active, &:hover {\n                    background: $gray-600;\n                }\n            }\n            .sidebar-right {\n                background: $night-blue;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                }\n                h6, p {\n                    color: $white;\n                }\n                .bg-light {\n                    background-color: $gray-600 !important;\n                    border-color: $gray-600 !important;\n                }\n                ul {\n                    li {\n                        a {\n                            color: $white;\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                        }\n                        &.subdrop {\n                            background: $gray-600;\n                            &:hover {\n                                color: $white !important;\n                            }\n                        }\n                        &.active{\n                            a {\n                                background: $gray-600;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $gray-600;\n                                    color: $white !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                    & > ul {                \n                         & > li {\n                             > a {\n                                 &:hover {\n                                     background: $gray-600;\n                                     color: $white !important;\n                                 }\n                             }\n                         }\n                     }\n     \n                 }\n            }\n        }\n        .twocol-mini {\n            background-color: $night-blue;\n            border-color: $gray-800;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .sidebar-twocol {\n                &.sidebar {\n                    .logo {\n                        @include respond-above(custom991) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            background-color: $night-blue;\n            border-color: $gray-800;\n        }\n        .btn-menubar {\n            color: $white;\n            border-color: $night-blue;\n            &:hover, &.active {\n                background: $gray-100;\n                color: $gray-700;\n            }\n        }\n        .sidebar-right {\n            background: $night-blue;\n            h6 {\n                color: $white;\n            }\n            .sidebar-profile {\n                h6 {\n                    color: $night-blue;\n                }\n            }\n            a {\n                color: $white;\n                &:hover {\n                    color: $primary;\n                }\n            }\n        }\n        .nav-link {\n            color: $white;\n            background: lighten($night-blue, 6%);\n            border-color: lighten($night-blue, 6%);\n            p, i {\n                color: $white;\n            }\n            &:hover, &.active {\n                color: $white;\n                background: lighten($night-blue, 4%);\n                border-color: lighten($night-blue, 4%);\n                p {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n[data-sidebar=\"royalblue\"]{\n    .sidebar {\n        background: $royal-blue;\n        border-color: $royal-blue;\n        .dark-logo {\n            display: block;\n        }\n        .logo {\n            display: none;\n        }\n        .sidebar-menu {\n            > ul {\n                > li {\n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $gray-100;\n                                    span, i {\n                                        color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        > a {\n                            i {\n                                color: $gray-200;\n                            }\n                            &.subdrop {\n                                background: $gray-100;\n                                span, i {\n                                    color: $gray-700;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                            &:hover, &.active {\n                                background: $gray-100;\n                                span, i {\n                                    color: $gray-700;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    &.active {\n                        a {\n                            span {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    ul {\n                        li {\n                            &.active {\n                                a {\n                                     i {\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                            a {\n                                color: $gray-300;\n                                &:hover, &.active{\n                                    color:$primary;\n                                }\n                                i {\n                                    color: $gray-200;\n                                }\n                                span {\n                                    color: $gray-300;\n                                }\n                            }\n                            &.active {\n                                a {\n                                    background: $gray-700;\n                                    i {\n                                        color: $gray-200;\n                                    }\n                                }\n                            }\n                            .submenu {\n                                > ul {\n                                    li {\n                                        a {\n                                            color: $gray-300;\n                                            &.active, &:hover {\n                                                color: $primary;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                li {                    \n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active, &:hover {\n                                background: transparent;\n                             }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                &::before {\n                    border-color: $gray-200;\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .nav-link { \n                color: $white;\n                &.active, &:hover {\n                    background: $gray-100;\n                    color: $gray-700;\n                }\n            }\n            .sidebar-right {\n                background: $royal-blue;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                }\n                .sidebar-scroll {\n                    & > h6 {\n                        color: $white;\n                    }\n                }\n                ul {\n                    li {\n                        a {\n                            color: $white;\n                            &.subdrop {\n                                background: $gray-100;\n                                color: $gray-700;\n                            }\n                        }\n                        &.subdrop {\n                            background: $gray-100;\n                            &:hover {\n                                color: $gray-700 !important;\n                            }\n                        }\n                        &.active{\n                            a {\n                                background: $gray-100;\n                                color: $gray-700;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $gray-100;\n                                    color: $gray-700 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                    & > ul {                \n                         & > li {\n                             > a {\n                                 &:hover {\n                                     background: $gray-100;\n                                     color: $gray-700 !important;\n                                 }\n                             }\n                         }\n                     }\n     \n                 }\n            }\n        }\n        .twocol-mini {\n            background-color: $royal-blue;\n            border-color: $gray-400;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .sidebar-twocol {\n                &.sidebar {\n                    .logo {\n                        @include respond-above(custom991) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            background-color: $royal-blue;\n            border-color: $gray-400;\n        }\n        .btn-menubar {\n            color: $white;\n            border-color: $royal-blue;\n            &:hover, &.active {\n                background: $gray-100;\n                color: $gray-700;\n            }\n        }\n        .sidebar-right {\n            background: $royal-blue;\n            h6 {\n                color: $white;\n            }\n            .sidebar-profile {\n                h6 {\n                    color: $royal-blue;\n                }\n            }\n            a {\n                color: $white;\n                &:hover {\n                    color: $primary;\n                }\n            }\n        }\n        .nav-link {\n            color: $white;\n            background: lighten($royal-blue, 6%);\n            border-color: lighten($royal-blue, 6%);\n            p, i {\n                color: $white;\n            }\n            &:hover, &.active {\n                color: $white;\n                background: lighten($royal-blue, 4%);\n                border-color: lighten($royal-blue, 4%);\n                p {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n[data-sidebar=\"darkgray\"]{\n    .sidebar {\n        background: $dark-gray;\n        border-color: $dark-gray;\n        .dark-logo {\n            display: block;\n        }\n        .logo {\n            display: none;\n        }\n        .sidebar-menu {\n            > ul {\n                > li {\n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $gray-600;\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        > a {\n                            i {\n                                color: $gray-200;\n                            }\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                            &:hover, &.active {\n                                background: $gray-600;\n                            }\n                        }\n                    }\n                    &.active {\n                        a {\n                            span {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    ul {\n                        li {\n                            &.active {\n                                a {\n                                     i {\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                            a {\n                                color: $gray-300;\n                                &:hover, &.active{\n                                    color:$primary;\n                                }\n                                i {\n                                    color: $gray-200;\n                                }\n                                span {\n                                    color: $gray-300;\n                                }\n                            }\n                            &.active {\n                                a {\n                                    background: $gray-700;\n                                    i {\n                                        color: $gray-200;\n                                    }\n                                }\n                            }\n                            .submenu {\n                                > ul {\n                                    li {\n                                        a {\n                                            color: $gray-300;\n                                            &.active, &:hover {\n                                                color: $primary;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                li {                    \n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active, &:hover {\n                                background: transparent;\n                             }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                &::before {\n                    border-color: $gray-200;\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .nav-link { \n                color: $white;\n                &.active, &:hover {\n                    background: $gray-600;\n                }\n            }\n            .sidebar-right {\n                background: $dark-gray;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                }\n                h6, p {\n                    color: $white;\n                }\n                .bg-light {\n                    background-color: $gray-600 !important;\n                    border-color: $gray-600 !important;\n                }\n                ul {\n                    li {\n                        a {\n                            color: $white;\n                            &.subdrop {\n                                background: $gray-600;\n                            }\n                        }\n                        &.subdrop {\n                            background: $gray-600;\n                            &:hover {\n                                color: $white !important;\n                            }\n                        }\n                        &.active{\n                            a {\n                                background: $gray-600;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $gray-600;\n                                    color: $white !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                    & > ul {                \n                         & > li {\n                             > a {\n                                 &:hover {\n                                     background: $gray-600;\n                                     color: $white !important;\n                                 }\n                             }\n                         }\n                     }\n     \n                 }\n            }\n        }\n        .twocol-mini {\n            background-color: $dark-gray;\n            border-color: $gray-800;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .sidebar-twocol {\n                &.sidebar {\n                    .logo {\n                        @include respond-above(custom991) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            background-color: $dark-gray;\n            border-color: $gray-800;\n        }\n        .btn-menubar {\n            color: $white;\n            border-color: $dark-gray;\n            &:hover, &.active {\n                background: $gray-600;\n            }\n        }\n        .sidebar-right {\n            background: $dark-gray;\n            h6 {\n                color: $white;\n            }\n            .sidebar-profile {\n                h6 {\n                    color: $dark-gray;\n                }\n            }\n            a {\n                color: $white;\n                &:hover {\n                    color: $primary;\n                }\n            }\n        }\n        .nav-link {\n            color: $white;\n            background: $gray-800;\n            border-color: $gray-800;\n            p, i {\n                color: $white;\n            }\n            &:hover, &.active {\n                color: $white;\n                background: $gray-800;\n                border-color: $gray-800;\n                p {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n[data-sidebar=\"indigo\"]{\n    #sidebar {\n        background: $indigo;\n        border-color: $indigo;\n        .dark-logo {\n            display: block;\n        }\n        .logo {\n            display: none;\n        }\n        .sidebar-menu {\n            > ul {\n                > li {\n                    \n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $gray-100;\n                                    span, i {\n                                        color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        > a {\n                            i {\n                                color: $gray-200;\n                            }\n                            &.subdrop {\n                                background: $gray-100;\n                                span, i {\n                                    color: $gray-700;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                            &:hover, &.active {\n                                background: $gray-100;\n                                span, i {\n                                    color: $gray-700;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    &.active {\n                        a {\n                            span {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    ul {\n                        li {\n                            &.active {\n                                a {\n                                     i {\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                            a {\n                                color: $gray-300;\n                                &:hover, &.active{\n                                    color:$primary;\n                                }\n                                i {\n                                    color: $gray-200;\n                                }\n                                span {\n                                    color: $gray-300;\n                                }\n                            }\n                            &.active {\n                                a {\n                                    background: $gray-700;\n                                    i {\n                                        color: $gray-200;\n                                    }\n                                }\n                            }\n                            .submenu {\n                                > ul {\n                                    li {\n                                        a {\n                                            color: $gray-300;\n                                            &.active, &:hover {\n                                                color: $primary;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                li {                    \n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active, &:hover {\n                                background: transparent;\n                             }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                &::before {\n                    border-color: $gray-200;\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .nav-link { \n                color: $white;\n                &.active, &:hover {\n                    background: $gray-100;\n                    color: $gray-700;\n                }\n            }\n            .sidebar-right {\n                background: $indigo;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                }\n                .sidebar-scroll {\n                    & > h6 {\n                        color: $white;\n                    }\n                }\n                ul {\n                    li {\n                        a {\n                            color: $white;\n                            &.subdrop {\n                                background: $gray-100;\n                                color: $gray-700;\n                            }\n                        }\n                        &.subdrop {\n                            background: $gray-100;\n                            &:hover {\n                                color: $gray-700 !important;\n                            }\n                        }\n                        &.active{\n                            a {\n                                background: $gray-100;\n                                color: $gray-700;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $gray-100;\n                                    color: $gray-700 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                    & > ul {                \n                         & > li {\n                             > a {\n                                 &:hover {\n                                     background: $gray-100;\n                                     color: $gray-700 !important;\n                                 }\n                             }\n                         }\n                     }\n     \n                }\n            }\n        }\n        .twocol-mini {\n            background-color: $indigo;\n            border-color: $gray-800;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .sidebar-twocol {\n                &.sidebar {\n                    .logo {\n                        @include respond-above(custom991) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            background-color: $indigo;\n            border-color: $gray-800;\n        }\n        .btn-menubar {\n            color: $white;\n            border-color: $indigo;\n            &:hover, &.active {\n                background: $gray-100;\n                color: $gray-700;\n            }\n        }\n        .sidebar-right {\n            background: $indigo;\n            h6 {\n                color: $white;\n            }\n            .sidebar-profile {\n                h6 {\n                    color: $indigo;\n                }\n            }\n            a {\n                color: $white;\n                &:hover {\n                    color: $primary;\n                }\n            }\n        }\n        .nav-link {\n            color: $white;\n            background: lighten($indigo, 6%);\n            border-color: lighten($indigo, 6%);\n            p, i {\n                color: $white;\n            }\n            &:hover, &.active {\n                color: $white;\n                background: lighten($indigo, 4%);\n                border-color: lighten($indigo, 4%);\n                p {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n[data-sidebar=\"all\"]{\n    $primarybg: rgb(var(--sidebar--rgb-picr));\n    .sidebar {\n        background: $primarybg;\n        border-color: $primarybg;\n        .dark-logo {\n            display: block;\n        }\n        .logo {\n            display: none;\n        }\n        .sidebar-menu {\n            > ul {\n                > li {\n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $gray-100;\n                                    span, i {\n                                        color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        > a {\n                            i {\n                                color: $gray-200;\n                            }\n                            &.subdrop {\n                                background: $gray-100;\n                                span, i {\n                                    color: $gray-700;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                            &:hover, &.active {\n                                background: $gray-100;\n                                span, i {\n                                    color: $gray-700;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    &.active {\n                        a {\n                            span {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    ul {\n                        li {\n                            &.active {\n                                a {\n                                     i {\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                            a {\n                                color: $gray-300;\n                                &:hover, &.active{\n                                    color:$primary;\n                                }\n                                i {\n                                    color: $gray-200;\n                                }\n                                span {\n                                    color: $gray-300;\n                                }\n                            }\n                            &.active {\n                                a {\n                                    background: $gray-700;\n                                    i {\n                                        color: $gray-200;\n                                    }\n                                }\n                            }\n                            .submenu {\n                                > ul {\n                                    li {\n                                        a {\n                                            color: $gray-300;\n                                            &.active, &:hover {\n                                                color: $primary;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                li {                    \n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active, &:hover {\n                                background: transparent;\n                             }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                &::before {\n                    border-color: $gray-200;\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .nav-link { \n                color: $white;\n                &.active, &:hover {\n                    background: $gray-100;\n                    color: $gray-700;\n                }\n            }\n            .sidebar-right {\n                background: $primarybg;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                }\n                .sidebar-scroll {\n                    & > h6 {\n                        color: $white;\n                    }\n                }\n                ul {\n                    li {\n                        a {\n                            color: $white;\n                            &.subdrop {\n                                background: $gray-100;\n                                color: $gray-700;\n                            }\n                        }\n                        &.subdrop {\n                            background: $gray-100;\n                            &:hover {\n                                color: $gray-700 !important;\n                            }\n                        }\n                        &.active{\n                            a {\n                                background: $gray-100;\n                                color: $gray-700;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $gray-100;\n                                    color: $gray-700 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                    & > ul {                \n                         & > li {\n                             > a {\n                                 &:hover {\n                                     background: $gray-100;\n                                     color: $gray-700 !important;\n                                 }\n                             }\n                         }\n                     }\n     \n                 }\n            }\n        }\n        .twocol-mini {\n            background-color: $primarybg;\n            border-color: $gray-400;\n        }\n    }\n    .expand-menu {\n        &.mini-sidebar {\n            .sidebar-twocol {\n                &.sidebar {\n                    .logo {\n                        @include respond-above(custom991) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            background-color: $primarybg;\n            border-color: $gray-400;\n        }\n        .btn-menubar {\n            color: $white;\n            border-color: $primarybg;\n            &:hover, &.active {\n                background: $gray-100;\n                color: $gray-700;\n            }\n        }\n        .sidebar-right {\n            background: $primarybg;\n            h6 {\n                color: $white;\n            }\n            .sidebar-profile {\n                h6 {\n                    color: $primarybg;\n                }\n            }\n            a {\n                color: $white;\n                &:hover {\n                    color: $primarybg;\n                }\n            }\n        }\n        .nav-link {\n            color: $white;\n            background: rgba(var(--sidebar--rgb-picr), 0.7);\n            border-color: rgba(var(--sidebar--rgb-picr), 0.7);\n            p, i {\n                color: $white;\n            }\n            &:hover, &.active {\n                color: $white;\n                background: rgba(var(--sidebar--rgb-picr), 0.4);\n                border-color: rgba(var(--sidebar--rgb-picr), 0.4);\n                p {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"darkaqua\"],\n[data-layout=\"mini\"][data-topbar=\"darkaqua\"],\n[data-layout=\"horizontal\"][data-topbar=\"darkaqua\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"darkaqua\"],\n[data-layout=\"detached\"][data-topbar=\"darkaqua\"],\n[data-layout=\"twocolumn\"][data-topbar=\"darkaqua\"],\n[data-layout=\"stacked\"][data-topbar=\"darkaqua\"],\n[data-layout=\"transparent\"][data-topbar=\"darkaqua\"] {\n    .header {\n        background: $darkaqua;\n        border-bottom-color: $darkaqua;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $darkaqua;\n            border-color: $darkaqua;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover, &.active {\n                        color: $gray-700;\n                    }\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $darkaqua;\n                .nav-menu {\n                    & > li.submenu {\n                        & > a {\n                            color: $white;\n                            .menu-arrow {\n                                &::before {\n                                    border-color: $white;\n                                }\n                            }\n                            &:hover, &.active, &.subdrop {\n                                color: $gray-700;\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                } \n            }\n        }\n    }\n    .menu-horizontal {\n        .header {\n            .header-left {\n                .logo {\n                    display: none;\n                }\n                .dark-logo {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"rockblue\"],\n[data-layout=\"mini\"][data-topbar=\"rockblue\"],\n[data-layout=\"horizontal\"][data-topbar=\"rockblue\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"rockblue\"],\n[data-layout=\"detached\"][data-topbar=\"rockblue\"],\n[data-layout=\"twocolumn\"][data-topbar=\"rockblue\"],\n[data-layout=\"stacked\"][data-topbar=\"rockblue\"],\n[data-layout=\"transparent\"][data-topbar=\"rockblue\"] {\n    .header {\n        background: $rockblue;\n        border-bottom-color: $rockblue;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $rockblue;\n            border-color: $rockblue;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-900;\n                    &:hover, &.active {\n                        background: $white;\n                    }\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $rockblue;\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"whiterock\"],\n[data-layout=\"mini\"][data-topbar=\"whiterock\"],\n[data-layout=\"horizontal\"][data-topbar=\"whiterock\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"whiterock\"],\n[data-layout=\"detached\"][data-topbar=\"whiterock\"],\n[data-layout=\"twocolumn\"][data-topbar=\"whiterock\"],\n[data-layout=\"stacked\"][data-topbar=\"whiterock\"],\n[data-layout=\"transparent\"][data-topbar=\"whiterock\"] {\n    .header {\n        background: $whiterock;\n        border-bottom-color: $whiterock;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $whiterock;\n            border-color: $whiterock;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-900;\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $whiterock;\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"bluehaze\"],\n[data-layout=\"mini\"][data-topbar=\"bluehaze\"],\n[data-layout=\"horizontal\"][data-topbar=\"bluehaze\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"bluehaze\"],\n[data-layout=\"detached\"][data-topbar=\"bluehaze\"],\n[data-layout=\"twocolumn\"][data-topbar=\"bluehaze\"],\n[data-layout=\"stacked\"][data-topbar=\"bluehaze\"],\n[data-layout=\"transparent\"][data-topbar=\"bluehaze\"] {\n    .header {\n        background: $bluehaze;\n        border-bottom-color: $bluehaze;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $bluehaze;\n            border-color: $bluehaze;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-900;\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $bluehaze;\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"orangegradient\"],\n[data-layout=\"mini\"][data-topbar=\"orangegradient\"],\n[data-layout=\"horizontal\"][data-topbar=\"orangegradient\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"orangegradient\"],\n[data-layout=\"detached\"][data-topbar=\"orangegradient\"],\n[data-layout=\"twocolumn\"][data-topbar=\"orangegradient\"],\n[data-layout=\"stacked\"][data-topbar=\"orangegradient\"],\n[data-layout=\"transparent\"][data-topbar=\"orangegradient\"] {\n    .header {\n        background: $orange-gradient;\n        border-bottom-color: $orange-gradient;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $orange-gradient;\n            border-color: $orange-gradient;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $orange-gradient;\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"purplegradient\"],\n[data-layout=\"mini\"][data-topbar=\"purplegradient\"],\n[data-layout=\"horizontal\"][data-topbar=\"purplegradient\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"purplegradient\"],\n[data-layout=\"detached\"][data-topbar=\"purplegradient\"],\n[data-layout=\"twocolumn\"][data-topbar=\"purplegradient\"],\n[data-layout=\"stacked\"][data-topbar=\"purplegradient\"],\n[data-layout=\"transparent\"][data-topbar=\"purplegradient\"] {\n    .header {\n        background: $purple-gradient;\n        border-bottom-color: $purple-gradient;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $purple-gradient;\n            border-color: $purple-gradient;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $purple-gradient;\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"bluegradient\"],\n[data-layout=\"mini\"][data-topbar=\"bluegradient\"],\n[data-layout=\"horizontal\"][data-topbar=\"bluegradient\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"bluegradient\"],\n[data-layout=\"detached\"][data-topbar=\"bluegradient\"],\n[data-layout=\"twocolumn\"][data-topbar=\"bluegradient\"],\n[data-layout=\"stacked\"][data-topbar=\"bluegradient\"],\n[data-layout=\"transparent\"][data-topbar=\"bluegradient\"] {\n    .header {\n        background: $blue-gradient;\n        border-bottom-color: $blue-gradient;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $blue-gradient;\n            border-color: $blue-gradient;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $blue-gradient;\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"maroongradient\"],\n[data-layout=\"mini\"][data-topbar=\"maroongradient\"],\n[data-layout=\"horizontal\"][data-topbar=\"maroongradient\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"maroongradient\"],\n[data-layout=\"detached\"][data-topbar=\"maroongradient\"],\n[data-layout=\"twocolumn\"][data-topbar=\"maroongradient\"],\n[data-layout=\"stacked\"][data-topbar=\"maroongradient\"],\n[data-layout=\"transparent\"][data-topbar=\"maroongradient\"] {\n    .header {\n        background: $maroon-gradient;\n        border-bottom-color: $maroon-gradient;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $maroon-gradient;\n            border-color: $maroon-gradient;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $maroon-gradient;\n            }\n        }\n    }\n}\n[data-layout=\"default\"][data-topbar=\"all\"],\n[data-layout=\"mini\"][data-topbar=\"all\"],\n[data-layout=\"horizontal\"][data-topbar=\"all\"],\n[data-layout=\"horizontal-single\"][data-topbar=\"all\"],\n[data-layout=\"detached\"][data-topbar=\"all\"],\n[data-layout=\"twocolumn\"][data-topbar=\"all\"],\n[data-layout=\"stacked\"][data-topbar=\"all\"],\n[data-layout=\"transparent\"][data-topbar=\"all\"] {\n    $primary: rgb(var(--topbar--rgb-picr));\n    .header {\n        background: $primary;\n        border-bottom-color: $primary;\n        .bg-white {\n            background: transparent  !important;\n        }\n        .header-left {\n            background: $primary;\n            border-color: $primary;\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover, &.active {\n                        color: $gray-700;\n                    }\n                }\n            }\n        }\n        .sidebar-horizontal.sidebar {\n            .sidebar-menu {\n                background: $primary;\n                .nav-menu {\n                    & > li.submenu {\n                        & > a {\n                            color: $white;\n                            .menu-arrow {\n                                &::before {\n                                    border-color: $white;\n                                }\n                            }\n                            &:hover, &.active, &.subdrop {\n                                color: $gray-700;\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-700;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                } \n            }\n        }\n    }\n    .menu-horizontal {\n        .header {\n            .header-left {\n                .logo {\n                    display: none;\n                }\n                .dark-logo {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"dark\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"dark\"]  {   \n    .header {\n        left: 0;\n        background-color: $gray-900;\n        border-color: $gray-800;\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $gray-600;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $white;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $gray-900;\n            border-bottom: 1px solid $gray-800;\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $white;\n                                &.active, &:hover {\n                                    background: $gray-600;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $white;\n                                        border-bottom: 2px solid $white;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            background: $gray-900;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"primary\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"primary\"] {\n    .header {\n        left: 0;\n        background-color: $primary;\n        border-color: $primary-800;\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $primary-600;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $white;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $primary;\n            border-bottom: 1px solid $primary-800;\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $white;\n                                &.active, &:hover {\n                                    background: $primary-600;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $white;\n                                        border-bottom: 2px solid $white;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            content: \"\";\n            background: $primary;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"blackpearl\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"blackpearl\"] {\n    .header {\n        left: 0;\n        background-color: $blackpearl;\n        border-color: $gray-800;\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $gray-600;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $white;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $blackpearl;\n            border-bottom: 1px solid $gray-800;\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $white;\n                                &.active, &:hover,  &.subdrop {\n                                    background: $gray-600;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $white;\n                                        border-bottom: 2px solid $white;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-arrow {\n                        &::before {\n                            border-color: $gray-700;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            content: \"\";\n            background: $blackpearl;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"maroon\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"maroon\"] {\n    .header {\n        left: 0;\n        background-color: $maroon;\n        border-color: lighten($maroon, 0.9);\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $dark-transparent;\n                        color: $gray-700;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $white;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $maroon;\n            border-bottom: 1px solid lighten($maroon, 0.9);\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $white;\n                                &.active, &:hover,  &.subdrop {\n                                    background-color: $dark-transparent;\n                                    color: $gray-900;\n                                    .menu-arrow {\n                                        &::before {\n                                            border-color: $gray-900;\n                                        }\n                                    }\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $white;\n                                        border-bottom: 2px solid $white;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-arrow {\n                        &::before {\n                            border-color: $gray-700;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            content: \"\";\n            background: $maroon;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"white\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"white\"] {\n    .header {\n        left: 0;\n        background-color: $white;\n        border-color: lighten($white, 0.9);\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-500;\n                    &:hover {\n                        background: $dark-transparent;\n                        color: $gray-900;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: block;\n            }\n            .dark-logo {\n                display: none;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $gray-700;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $white;\n            border-bottom: 1px solid lighten($white, 0.9);\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $gray-900;\n                                &.active, &:hover,  &.subdrop {\n                                    background-color: $dark-transparent;\n                                    color: $gray-900;\n                                    .menu-arrow {\n                                        &::before {\n                                            border-color: $gray-900;\n                                        }\n                                    }\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $gray-900;;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-arrow {\n                        &::before {\n                            border-color: $gray-900;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            content: \"\";\n            background: $white;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"bluegem\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"bluegem\"] {\n    .header {\n        left: 0;\n        background-color: $bluegem;\n        border-color: lighten($bluegem, 0.9);\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $dark-transparent;\n                        color: $gray-700;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $white;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $bluegem;\n            border-bottom: 1px solid lighten($bluegem, 0.9);\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $white;\n                                &.active, &:hover,  &.subdrop {\n                                    background-color: $dark-transparent;\n                                    color: $gray-900;\n                                    .menu-arrow {\n                                        &::before {\n                                            border-color: $gray-900;\n                                        }\n                                    }\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $white;\n                                        border-bottom: 2px solid $white;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-arrow {\n                        &::before {\n                            border-color: $gray-700;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            content: \"\";\n            background: $bluegem;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"all\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"all\"]  {\n    $primary: rgb(var(--topbarcolor--rgb-picr));   \n    .header {\n        left: 0;\n        background-color: $primary;\n        border-color: $primary;\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $dark-transparent;\n                        color: $gray-700;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $white;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $primary;\n            border-bottom: 1px solid $primary;\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $white;\n                                &.active, &:hover,  &.subdrop {\n                                    background-color: $dark-transparent;\n                                    color: $gray-900;\n                                    .menu-arrow {\n                                        &::before {\n                                            border-color: $gray-900;\n                                        }\n                                    }\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $white;\n                                        border-bottom: 2px solid $white;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-arrow {\n                        &::before {\n                            border-color: $gray-700;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            content: \"\";\n            background: $primary;\n        }\n    }\n}\n[data-sidebarbg=\"sidebarbg1\"]{\n    #sidebar {\n        background-image: url(../../../../public/assets/img/theme/sidebar-bg-01.svg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        &::before  {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"firefly\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"firefly\"] {\n    .header {\n        left: 0;\n        background-color: $firefly;\n        border-color: $gray-800;\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover {\n                        background: $gray-600;\n                    }\n                }\n            }\n        }\n        .header-left {\n            display: block;\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }      \n    .mode-toggle {\n        color: $white;\n    }\n    .sidebar-horizontal {\n        &.sidebar {\n            background-color: $firefly;\n            border-bottom: 1px solid $gray-800;\n            .sidebar-menu {\n                .nav-menu {\n                    > li {     \n                        &.submenu {\n                            & > a {\n                                color: $white;\n                                &.active, &:hover,  &.subdrop {\n                                    background: $gray-600;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $white;\n                                        border-bottom: 2px solid $white;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-arrow {\n                        &::before {\n                            border-color: $gray-700;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .main-wrapper {\n        &::before {\n            content: \"\";\n            background: $firefly;\n        }\n    }\n}\n[data-sidebarbg=\"sidebarbg1\"]{\n    #sidebar {\n        background-image: url(../../../../public/assets/img/theme/sidebar-bg-01.svg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        &::before  {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;    \n            z-index: -1;\n        }\n    }\n}\n[data-sidebarbg=\"sidebarbg2\"]{\n    #sidebar {\n        background-image: url(../../../../public/assets/img/theme/sidebar-bg-02.svg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        &::before  {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n        }\n    }\n}\n[data-sidebarbg=\"sidebarbg3\"]{\n    #sidebar {\n        background-image: url(../../../../public/assets/img/theme/sidebar-bg-03.svg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        &::before  {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n        }\n    }\n}\n[data-sidebarbg=\"sidebarbg4\"]{\n    #sidebar {\n        background-image: url(../../../../public/assets/img/theme/sidebar-bg-04.svg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        &::before  {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n        }\n    }\n}\n[data-sidebarbg=\"sidebarbg5\"]{\n    #sidebar {\n        background-image: url(../../../../public/assets/img/theme/sidebar-bg-05.svg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        &::before  {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n        }\n    }\n}\n[data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n        background-image: url(../../../../public/assets/img/theme/sidebar-bg-06.svg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        &::before  {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n            z-index: -1;\n        }\n    }\n}\n[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg1\"],\n[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg2\"],\n[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg3\"],\n[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg4\"],\n[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg5\"],\n[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n       &::before  {\n        background: rgba($white, 0.85);\n       }\n    }\n}\n[data-sidebar=\"darkgreen\"] [data-sidebarbg=\"sidebarbg1\"],\n[data-sidebar=\"darkgreen\"] [data-sidebarbg=\"sidebarbg2\"],\n[data-sidebar=\"darkgreen\"] [data-sidebarbg=\"sidebarbg3\"],\n[data-sidebar=\"darkgreen\"] [data-sidebarbg=\"sidebarbg4\"],\n[data-sidebar=\"darkgreen\"] [data-sidebarbg=\"sidebarbg5\"],\n[data-sidebar=\"darkgreen\"] [data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n       &::before  {\n        background: rgba($dark-green, 0.85);\n       }\n    }\n}\n[data-sidebar=\"nightblue\"] [data-sidebarbg=\"sidebarbg1\"],\n[data-sidebar=\"nightblue\"] [data-sidebarbg=\"sidebarbg2\"],\n[data-sidebar=\"nightblue\"] [data-sidebarbg=\"sidebarbg3\"],\n[data-sidebar=\"nightblue\"] [data-sidebarbg=\"sidebarbg4\"],\n[data-sidebar=\"nightblue\"] [data-sidebarbg=\"sidebarbg5\"],\n[data-sidebar=\"nightblue\"] [data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n       &::before  {\n        background: rgba($night-blue, 0.85);\n       }\n    }\n}\n[data-sidebar=\"darkgray\"] [data-sidebarbg=\"sidebarbg1\"],\n[data-sidebar=\"darkgray\"] [data-sidebarbg=\"sidebarbg2\"],\n[data-sidebar=\"darkgray\"] [data-sidebarbg=\"sidebarbg3\"],\n[data-sidebar=\"darkgray\"] [data-sidebarbg=\"sidebarbg4\"],\n[data-sidebar=\"darkgray\"] [data-sidebarbg=\"sidebarbg5\"],\n[data-sidebar=\"darkgray\"] [data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n       &::before  {\n        background: rgba($dark-gray, 0.85);\n       }\n    }\n}\n[data-sidebar=\"royalblue\"] [data-sidebarbg=\"sidebarbg1\"],\n[data-sidebar=\"royalblue\"] [data-sidebarbg=\"sidebarbg2\"],\n[data-sidebar=\"royalblue\"] [data-sidebarbg=\"sidebarbg3\"],\n[data-sidebar=\"royalblue\"] [data-sidebarbg=\"sidebarbg4\"],\n[data-sidebar=\"royalblue\"] [data-sidebarbg=\"sidebarbg5\"],\n[data-sidebar=\"royalblue\"] [data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n       &::before  {\n        background: rgba($royal-blue, 0.85);\n       }\n    }\n}\n[data-sidebar=\"indigo\"] [data-sidebarbg=\"sidebarbg1\"],\n[data-sidebar=\"indigo\"] [data-sidebarbg=\"sidebarbg2\"],\n[data-sidebar=\"indigo\"] [data-sidebarbg=\"sidebarbg3\"],\n[data-sidebar=\"indigo\"] [data-sidebarbg=\"sidebarbg4\"],\n[data-sidebar=\"indigo\"] [data-sidebarbg=\"sidebarbg5\"],\n[data-sidebar=\"indigo\"] [data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n       &::before  {\n        background: rgba($indigo, 0.85);\n       }\n    }\n}\n[data-sidebar=\"all\"] [data-sidebarbg=\"sidebarbg1\"],\n[data-sidebar=\"all\"] [data-sidebarbg=\"sidebarbg2\"],\n[data-sidebar=\"all\"] [data-sidebarbg=\"sidebarbg3\"],\n[data-sidebar=\"all\"] [data-sidebarbg=\"sidebarbg4\"],\n[data-sidebar=\"all\"] [data-sidebarbg=\"sidebarbg5\"],\n[data-sidebar=\"all\"] [data-sidebarbg=\"sidebarbg6\"] {\n    #sidebar {\n       &::before  {\n        background: rgba(var(--sidebar--rgb-picr), 0.85);\n       }\n    }\n}\n[data-layout=\"horizontal-overlay\"] [data-topbarbg=\"pattern1\"],\n[data-layout=\"horizontal-sidemenu\"] [data-topbarbg=\"pattern1\"] {\n    .main-wrapper {\n        &::after {\n            background: url('../../../../public/assets/img/theme/pattern-01.png');\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"] [data-topbarbg=\"pattern2\"],\n[data-layout=\"horizontal-sidemenu\"] [data-topbarbg=\"pattern2\"] {\n    .main-wrapper {\n        &::after {\n            background: url('../../../../public/assets/img/theme/pattern-01.png');\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"] [data-topbarbg=\"pattern3\"],\n[data-layout=\"horizontal-sidemenu\"] [data-topbarbg=\"pattern3\"] {\n    .main-wrapper {\n        &::after {\n            background: url('../../../../public/assets/img/theme/pattern-03.png');\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"maroon\"] [data-topbarbg=\"pattern3\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"maroon\"] [data-topbarbg=\"pattern3\"] {\n    .main-wrapper {\n        &::before {\n            background: rgba($maroon, 0.85);\n            z-index: 1;\n        }\n        .page-wrapper {\n            z-index: 2;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"white\"] [data-topbarbg=\"pattern3\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"white\"] [data-topbarbg=\"pattern3\"] {\n    .main-wrapper {\n        &::before {\n            background: rgba($white, 0.85);\n            z-index: 1;\n        }\n        .page-wrapper {\n            z-index: 2;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"primary\"] [data-topbarbg=\"pattern3\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"primary\"] [data-topbarbg=\"pattern3\"] {\n    .main-wrapper {\n        &::before {\n            background: rgba($primary, 0.85);\n            z-index: 1;\n        }\n        .page-wrapper {\n            z-index: 2;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"blackpearl\"] [data-topbarbg=\"pattern3\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"blackpearl\"] [data-topbarbg=\"pattern3\"] {\n    .main-wrapper {\n        &::before {\n            background: rgba($blackpearl, 0.85);\n            z-index: 1;\n        }\n        .page-wrapper {\n            z-index: 2;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"bluegem\"] [data-topbarbg=\"pattern3\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"bluegem\"] [data-topbarbg=\"pattern3\"] {\n    .main-wrapper {\n        &::before {\n            background: rgba($bluegem, 0.85);\n            z-index: 1;\n        }\n        .page-wrapper {\n            z-index: 2;\n        }\n    }\n}\n[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"firefly\"] [data-topbarbg=\"pattern3\"],\n[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"firefly\"] [data-topbarbg=\"pattern3\"] {\n    .main-wrapper {\n        &::before {\n            background: rgba($firefly, 0.85);\n            z-index: 1;\n        }\n        .page-wrapper {\n            z-index: 2;\n        }\n    }\n}\n[data-layout=\"modern\"][data-topbarcolor=\"white\"] {\n    .header {\n        background-color: $white;\n        border-color: rgba($white, 0.8);\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-500;\n                    &:hover, &:active, &.active {\n                        background-color: $dark-transparent;\n                        border-color: $dark-transparent;\n                        color: $gray-900 !important;\n                    }\n                }\n            }\n        }\n        .header-left {\n            .logo {\n                display: block;\n            }\n            .dark-logo {\n                display: none;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $white;\n        }\n        .head-icons{\n            display: none;\n        }\n    }    \n}\n[data-layout=\"modern\"][data-topbarcolor=\"blue\"] {\n    .header {\n        background-color: $white;\n        border-color: rgba($white, 0.8);\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $gray-500;\n                    &:hover, &:active, &.active {\n                        background-color: $dark-transparent;\n                        border-color: $dark-transparent;\n                        color: $gray-900 !important;\n                    }\n                }\n            }\n        }\n        .header-left {\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $white;\n        }\n    }    \n}\n[data-layout=\"modern\"][data-topbarcolor=\"primary\"] {\n    .header {\n        background-color: $primary;\n        border-color: $primary-800;\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover, &:active, &.active {\n                        background-color: $white;\n                        color: $gray-700 !important;\n                    }\n                }\n            }\n        }\n        .header-left {\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $primary;\n        }\n    }    \n}\n[data-layout=\"modern\"][data-topbarcolor=\"blackpearl\"] {\n    .header {\n        background-color: $blackpearl;\n        border-color: rgba($blackpearl, 0.8);\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover, &:active, &.active {\n                        background-color: $white;\n                        color: $gray-700 !important;\n                    }\n                }\n            }\n        }\n        .header-left {\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $blackpearl;\n        }\n    }    \n}\n[data-layout=\"modern\"][data-topbarcolor=\"maroon\"] {\n    .header {\n        background-color: $maroon;\n        border-color: rgba($maroon, 0.8);\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover, &:active, &.active {\n                        background-color: $white;\n                        color: $gray-700 !important;\n                    }\n                }\n            }\n        }\n        .header-left {\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $maroon;\n        }\n    }    \n}\n[data-layout=\"modern\"][data-topbarcolor=\"bluegem\"] {\n    .header {\n        background-color: $bluegem;\n        border-color: rgba($bluegem, 0.8);\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover, &:active, &.active {\n                        background-color: $white;\n                        color: $gray-700 !important;\n                    }\n                }\n            }\n        }\n        .header-left {\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $bluegem;\n        }\n    }    \n}\n[data-layout=\"modern\"][data-topbarcolor=\"firefly\"] {\n    .header {\n        background-color: $firefly;\n        border-color: rgba($firefly, 0.8);\n        .bar-icon {\n            span {\n                background-color: $white;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $white;\n                    &:hover, &:active, &.active {\n                        background-color: $white;\n                        color: $gray-700 !important;\n                    }\n                }\n            }\n        }\n        .header-left {\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $firefly;\n        }\n    }    \n}\n[data-card=\"borderless\"] {\n    .card {\n        border: 0 !important;;\n        box-shadow: none;\n    }\n}\n[data-card=\"shadow\"] {\n    .card {\n        border: 0 !important;\n        box-shadow: $box-shadow-sm;\n    }\n}\n[data-color=\"primary\"]{\n    $primary: #e85b28;\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                            &.subdrop{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &.active {\n                                    color: $primary;\n                                }\n                                &:hover {                                    \n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: $primary;\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($primary, 7%);\n            border: 1px solid darken($primary, 7%);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .link-primary {\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: darken($primary, 7%);\n        }\n    }\n    .text-primary {\n        color: $primary !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: $primary;\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: $primary;\n        border-color: $primary;\n    }\n    .bg-primary {\n        background-color: $primary !important;\n        border: 1px solid $primary !important;\n    }\n    .border-bottom.border-primary {\n        border-color: $primary !important;\n    }\n    .border-primary {\n        border-color: $primary !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: $primary;\n        color: $primary;\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: $primary;\n\n        }\n    }\n    a {\n        &:hover {\n            color: $primary;\n        }\n        &.video-expand { \n            &:hover {\n                color: $white;\n            }\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $primary !important;\n            border:1px solid $primary !important;\n            color: $white !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: $primary;\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: $primary;\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: $primary;\n            border-color: $primary;\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: $primary;\n          border-color: $primary;\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: $primary;\n        @include respond-below(custom991) {\n            display: none;\n        }\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: $primary;\n            }\n        }\n    }  \n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: $primary;\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: $primary;\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: $primary; \n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: $primary;\n            }\n            .apexcharts-marker {\n                fill: $primary;\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: $primary !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: $primary !important;\n        } \n        .c3-circle {\n            fill: $primary; \n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: $primary !important;\n    }\n    .table tbody tr td a:hover {\n        color: $primary;\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n[data-color=\"brightblue\"]{\n    $primary: #4680FF;\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: $primary;\n                            }\n                        }\n                        &.active {                \n                            a {\n                                span, i {\n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                            &.subdrop{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &:before {\n                                    background: $primary;\n                                }\n                                &.active {\n                                    color: $primary;\n                                }\n                                &:hover {                                    \n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        .nav-link {\n            &.active {\n                color: $primary;\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: $primary;\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($primary, 7%);\n            border: 1px solid darken($primary, 7%);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .link-primary {\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: darken($primary, 7%);\n        }\n    }\n    .text-primary {\n        color: $primary !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: $primary;\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: $primary;\n        border-color: $primary;\n    }\n    .bg-primary {\n        background-color: $primary !important;\n        border: 1px solid $primary !important;\n    }\n    .border-bottom.border-primary {\n        border-color: $primary !important;\n    }\n    .border-primary {\n        border-color: $primary !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: $primary;\n        color: $primary;\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: $primary;\n\n        }\n    }\n    a {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $primary !important;\n            border:1px solid $primary !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: $primary;\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: $primary;\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: $primary;\n            border-color: $primary;\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: $primary;\n          border-color: $primary;\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: $primary;\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: $primary;\n            }\n        }\n    }\n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: $primary;\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: $primary;\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: $primary; \n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: $primary;\n            }\n            .apexcharts-marker {\n                fill: $primary;\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: $primary !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: $primary !important;\n        } \n        .c3-circle {\n            fill: $primary; \n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: $primary !important;\n    }\n    .table tbody tr td a:hover {\n        color: $primary;\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n[data-color=\"lunargreen\"]{\n    $primary: #365E32;\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: $primary;\n                            }\n                        }\n                        &.active {                \n                            a {\n                                span, i {\n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                            &.subdrop{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &:before {\n                                    background: $primary;\n                                }\n                                &.active {\n                                    color: $primary;\n                                }\n                                &:hover {                                    \n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        .nav-link {\n            &.active {\n                color: $primary;\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: $primary;\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($primary, 7%);\n            border: 1px solid darken($primary, 7%);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .link-primary {\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: darken($primary, 7%);\n        }\n    }\n    .text-primary {\n        color: $primary !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: $primary;\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: $primary;\n        border-color: $primary;\n    }\n    .bg-primary {\n        background-color: $primary !important;\n        border: 1px solid $primary !important;\n    }\n    .border-bottom.border-primary {\n        border-color: $primary !important;\n    }\n    .border-primary {\n        border-color: $primary !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: $primary;\n        color: $primary;\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: $primary;\n\n        }\n    }\n    a {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $primary !important;\n            border:1px solid $primary !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: $primary;\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: $primary;\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: $primary;\n            border-color: $primary;\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: $primary;\n          border-color: $primary;\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: $primary;\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: $primary;\n            }\n        }\n    }\n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: $primary;\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: $primary;\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: $primary; \n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: $primary;\n            }\n            .apexcharts-marker {\n                fill: $primary;\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: $primary !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: $primary !important;\n        } \n        .c3-circle {\n            fill: $primary; \n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: $primary !important;\n    }\n    .table tbody tr td a:hover {\n        color: $primary;\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n[data-color=\"lavendar\"]{\n    $primary: #673AB7;\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: $primary;\n                            }\n                        }\n                        &.active {                \n                            a {\n                                span, i {\n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                            &.subdrop{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &:before {\n                                    background: $primary;\n                                }\n                                &.active {\n                                    color: $primary;\n                                }\n                                &:hover {                                    \n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        .nav-link {\n            &.active {\n                color: $primary;\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: $primary;\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($primary, 7%);\n            border: 1px solid darken($primary, 7%);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .link-primary {\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: darken($primary, 7%);\n        }\n    }\n    .text-primary {\n        color: $primary !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: $primary;\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: $primary;\n        border-color: $primary;\n    }\n    .bg-primary {\n        background-color: $primary !important;\n        border: 1px solid $primary !important;\n    }\n    .border-bottom.border-primary {\n        border-color: $primary !important;\n    }\n    .border-primary {\n        border-color: $primary !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: $primary;\n        color: $primary;\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: $primary;\n\n        }\n    }\n    a {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $primary !important;\n            border:1px solid $primary !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: $primary;\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: $primary;\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: $primary;\n            border-color: $primary;\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: $primary;\n          border-color: $primary;\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: $primary;\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: $primary;\n            }\n        }\n    }\n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: $primary;\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: $primary;\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: $primary; \n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: $primary;\n            }\n            .apexcharts-marker {\n                fill: $primary;\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: $primary !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: $primary !important;\n        } \n        .c3-circle {\n            fill: $primary; \n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: $primary !important;\n    }\n    .table tbody tr td a:hover {\n        color: $primary;\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n[data-color=\"magenta\"]{\n    $primary: #E83E8C;\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: $primary;\n                            }\n                        }\n                        &.active {                \n                            a {\n                                span, i {\n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                            &.subdrop{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &:before {\n                                    background: $primary;\n                                }\n                                &.active {\n                                    color: $primary;\n                                }\n                                &:hover {                                    \n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        .nav-link {\n            &.active {\n                color: $primary;\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: $primary;\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($primary, 7%);\n            border: 1px solid darken($primary, 7%);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .link-primary {\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: darken($primary, 7%);\n        }\n    }\n    .text-primary {\n        color: $primary !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: $primary;\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: $primary;\n        border-color: $primary;\n    }\n    .bg-primary {\n        background-color: $primary !important;\n        border: 1px solid $primary !important;\n    }\n    .border-bottom.border-primary {\n        border-color: $primary !important;\n    }\n    .border-primary {\n        border-color: $primary !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: $primary;\n        color: $primary;\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: $primary;\n\n        }\n    }\n    a {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $primary !important;\n            border:1px solid $primary !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: $primary;\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: $primary;\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: $primary;\n            border-color: $primary;\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: $primary;\n          border-color: $primary;\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: $primary;\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: $primary;\n            }\n        }\n    }\n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: $primary;\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: $primary;\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: $primary; \n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: $primary;\n            }\n            .apexcharts-marker {\n                fill: $primary;\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: $primary !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: $primary !important;\n        } \n        .c3-circle {\n            fill: $primary; \n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: $primary !important;\n    }\n    .table tbody tr td a:hover {\n        color: $primary;\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n[data-color=\"chromeyellow\"]{\n    $primary: #FF9B04;\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: $primary;\n                            }\n                        }\n                        &.active {                \n                            a {\n                                span, i {\n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                            &.subdrop{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &:before {\n                                    background: $primary;\n                                }\n                                &.active {\n                                    color: $primary;\n                                }\n                                &:hover {                                    \n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        .nav-link {\n            &.active {\n                color: $primary;\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: $primary;\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($primary, 7%);\n            border: 1px solid darken($primary, 7%);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .link-primary {\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: darken($primary, 7%);\n        }\n    }\n    .text-primary {\n        color: $primary !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: $primary;\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: $primary;\n        border-color: $primary;\n    }\n    .bg-primary {\n        background-color: $primary !important;\n        border: 1px solid $primary !important;\n    }\n    .border-bottom.border-primary {\n        border-color: $primary !important;\n    }\n    .border-primary {\n        border-color: $primary !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: $primary;\n        color: $primary;\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: $primary;\n\n        }\n    }\n    a {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $primary !important;\n            border:1px solid $primary !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: $primary;\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: $primary;\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: $primary;\n            border-color: $primary;\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: $primary;\n          border-color: $primary;\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: $primary;\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: $primary;\n            }\n        }\n    }\n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: $primary;\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: $primary;\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: $primary; \n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: $primary;\n            }\n            .apexcharts-marker {\n                fill: $primary;\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: $primary !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: $primary !important;\n        } \n        .c3-circle {\n            fill: $primary; \n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: $primary !important;\n    }\n    .table tbody tr td a:hover {\n        color: $primary;\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n[data-color=\"lavared\"]{\n    $primary: #DC2626;\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: $primary;\n                            }\n                        }\n                        &.active {                \n                            a {\n                                span, i {\n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                            &.subdrop{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &:before {\n                                    background: $primary;\n                                }\n                                &.active {\n                                    color: $primary;\n                                }\n                                &:hover {                                    \n                                    color: $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        .nav-link {\n            &.active {\n                color: $primary;\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: $primary;\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($primary, 7%);\n            border: 1px solid darken($primary, 7%);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .link-primary {\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: darken($primary, 7%);\n        }\n    }\n    .text-primary {\n        color: $primary !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: $primary;\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: $primary;\n        border-color: $primary;\n    }\n    .bg-primary {\n        background-color: $primary !important;\n        border: 1px solid $primary !important;\n    }\n    .border-bottom.border-primary {\n        border-color: $primary !important;\n    }\n    .border-primary {\n        border-color: $primary !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: $primary;\n        color: $primary;\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: $primary;\n\n        }\n    }\n    a {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $primary !important;\n            border:1px solid $primary !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: $primary;\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: $primary;\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: $primary;\n            border-color: $primary;\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: $primary;\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: $primary;\n          border-color: $primary;\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: $primary;\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: $primary;\n            }\n        }\n    }\n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: $primary;\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: $primary;\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: $primary; \n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: $primary;\n            }\n            .apexcharts-marker {\n                fill: $primary;\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: $primary !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: $primary !important;\n        } \n        .c3-circle {\n            fill: $primary; \n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: $primary !important;\n    }\n    .table tbody tr td a:hover {\n        color: $primary;\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n[data-color=\"all\"]{\n    $primary: var(--primary-rgb-picr);\n    .sidebar {\n        .sidebar-menu > ul {\n            &  > li {\n                ul {\n                    li {\n                        a {\n                            &.active {\n                                color: rgba($primary, 1);\n                            }\n                        }\n                        &.active {                \n                            a {\n                                span, i {\n                                    color: rgba($primary, 1);\n                                }\n                            }\n                        }\n                    }\n                    & > li {\n                        &.active a{\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid rgba($primary, 1);\n                                    border-bottom: 2px solid rgba($primary, 1);\n                                }\n                            }\n                            &.subdrop{\n                                color: rgba($primary, 1);\n                                span {\n                                    color: rgba($primary, 1);\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            li {\n                .submenu > {\n                    ul{\n                        li{\n                            a{\n                                &:before {\n                                    background: rgba($primary, 1);\n                                }\n                                &.active {\n                                    color: rgba($primary, 1);\n                                }\n                                &:hover {                                    \n                                    color: rgba($primary, 1);\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu.submenu-two {\n                    a {\n                        &.subdrop, &.active {\n                            color: rgba($primary, 1);\n                        }\n                    }\n                }\n            }\n        }\n        .nav-link {\n            &.active {\n                color: rgba($primary, 1);\n            }\n        }\n    }\n    .sidebar-twocol {\n        &.sidebar {\n            .sidebar-right {\n                ul {\n                    li {\n                        &.submenu {    \n                            ul {\n                                & > li {\n                                    & > a{\n                                         &:hover, &.active {\n                                             color: rgba($primary, 1);\n                                         }\n                                     }\n                                 }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .btn.btn-primary {\n        background-color: rgba($primary, 1);\n        border: 1px solid rgba($primary, 1);\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: rgba($primary, 2);\n           border: 1px solid rgba($primary, 2);\n        }\n    }\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn.show:hover, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        background-color: rgba($primary, 1);\n        border-color: rgba($primary, 1);\n    }\n    .link-primary {\n        color: rgba($primary, 1) !important;\n        &:hover,\n        &:focus,\n        &:active {\n          color: rgba($primary, 1);\n        }\n    }\n    .text-primary {\n        color: rgba($primary, 1) !important;\n    }\n    .badge {\n        &.badge-primary {\n            background: rgba($primary, 1);\n        }\n    }\n    .dataTables_paginate .pagination li.active a.page-link {\n        background: rgba($primary, 1);\n        border-color: rgba($primary, 1);\n    }\n    .bg-primary {\n        background-color: rgba($primary, 1) !important;\n        border: 1px solid rgba($primary, 1) !important;\n    }\n    .border-bottom.border-primary {\n        border-color: rgba($primary, 1) !important;\n    }\n    .border-primary {\n        border-color: rgba($primary, 1) !important;\n    }\n    .nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {\n        border-bottom-color: rgba($primary, 1);\n        color: rgba($primary, 1);\n    }\n    .badge {\n        &.badge-soft-primary {\n            background: rgba($primary, 0.1);\n            color: rgba($primary, 1);\n\n        }\n    }\n    a {\n        &:hover {\n            color: rgba($primary, 1);\n        }\n    }\n    .btn-outline-primary {\n        border: 1px solid rgba($primary, 1) !important;\n        color: rgba($primary, 1) !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: rgba($primary, 1) !important;\n            border:1px solid rgba($primary, 1) !important;\n        }\n    }\n    .select2-container--default {\n        &.select2-container--open.select2-container--below .select2-selection--single {\n            border-color: rgba($primary, 1);\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            background: rgba($primary, 1);\n        }\n    }\n    .nav-tabs.nav-tabs-solid.nav-tabs-rounded-fill li a {\n        &.active {\n            background-color: rgba($primary, 1);\n            border-color: rgba($primary, 1);\n        }\n    }\n    .nav-tabs .nav-link {\n        &:hover {\n            color: rgba($primary, 1);\n        }\n    }\n    .form-check-input {\n        &:checked {\n          background-color: rgba($primary, 1);\n          border-color: rgba($primary, 1);\n        }\n    }\n    .sidebar-contact .toggle-theme {\n        background-color: rgba($primary, 1);\n    }\n    .header .header-user .user-menu {\n        .profile-dropdown {\n            .dropdown-item:hover {\n                color: rgba($primary, 1);\n            }\n        }\n    }\n    #sales-income,  #revenue-income,  #leads_stage, #s-col, #s-col-stacked {\n        .apexcharts-bar-series {\n            .apexcharts-series:nth-child(1) path {\n                fill: rgba($primary, 1);\n            }\n        }\n    }\n    #deals_stage, #emp-department, #s-bar, #mixed-chart  {\n        .apexcharts-bar-series {\n            .apexcharts-series path {\n                fill: rgba($primary, 1);\n            }\n        }\n    }\n    #mixed-chart, #s-col-stacked, #s-col {\n        .apexcharts-legend-series:first-child .apexcharts-legend-marker {\n            fill: rgba($primary, 1);\n        }\n    }\n    #s-line  {\n        .apexcharts-line-series {\n            .apexcharts-series path {\n                stroke: rgba($primary, 1);\n            }\n            .apexcharts-marker {\n                fill: rgba($primary, 1);\n            }\n        }\n    }\n    #chart-bar-stacked, #chart-bar, #chart-bar-rotated {\n        .c3-target-data2 .c3-bar {\n            fill: rgba($primary, 1) !important; \n        }\n    }\n    #chart-spline-rotated .c3-target-data2 {\n        .c3-line {\n            stroke: rgba($primary, 1) !important;\n        } \n        .c3-circle {\n            fill: rgba($primary, 1);\n        }\n    }  \n    .nav.tab-style-1 .nav-link.active {\n        background-color: rgba($primary, 1);\n    }\n    .table tbody tr td a:hover {\n        color: rgba($primary, 1);\n    }\n    .view-icons {\n        a {\n            &.active, &:hover {\n                background: rgba($primary, 1);\n            }\n        }\n    }\n}\nbody {\n    &.layout-mode-rtl {\n        direction: rtl;\n        .slide-nav .sidebar {\n            margin-right: 0;\n        }\n        .sidebar {\n            right: 0;\n            left: unset;\n            border-right: 0;\n            .sidebar-menu {\n                > ul > li {\n                    .submenu {\n                        ul {\n                            &::before {\n                                right: 14px;\n                                left: unset;\n                            }                            \n                        }\n                        > ul {\n                            li {\n                                a {\n                                    padding: 8px 32px 8px 8px;\n                                    &::before {\n                                        right: 19px;\n                                        left: unset;\n                                    }   \n                                    &::after {\n                                        right: 16px;\n                                        left: unset;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    ul li a span  {\n                        margin-right: 10px;\n                        margin-left: 0;\n                    }\n                }\n                .menu-arrow {\n                    left: 10px;\n                    right: unset;\n                }\n                > ul > li .submenu-hdr::after {\n                    margin-right: 8px;\n                    margin-left: 0;\n                }\n            }\n            @include respond-below(custom991) {\n                margin-right: -575px;\n            }\n        }\n        .header-left {\n            float: right;\n            border-right: 0;\n        }\n        .page-wrapper {\n            margin-right: 276px;\n            margin-left: 0;\n            @include respond-below(custom991) {\n                margin-right: 0;\n            }\n        }\n        &.mini-sidebar {\n            .page-wrapper {\n                margin-right: 80px;\n            }\n        }\n        .header {\n            @include respond-above(custom991) {\n                right: 0;\n                left: 0;\n            }\n            .input-group {\n                input {\n                    border-right: 1px solid $gray-200 !important;\n                    border-top-right-radius: 5px !important;\n                    border-bottom-right-radius: 5px !important;\n                    border-left: 0 !important;\n                    padding: 0.5rem 1.875rem 0.5rem 0.625rem;\n                }\n                .input-group-text {\n                    border-right: 0;\n                    border-radius: 5px !important;\n                    border-left: 1px solid $gray-200;\n                    &:last-child {\n                        padding-left: 10px;\n                        padding-right: 0;\n                    }\n                }\n            }\n            .mobile_btn {\n                @include respond-below(custom991) {\n                    right: 0;\n                    left: unset;\n                }\n            }\n            .mobile-user-menu {\n                left: 0;\n                right: auto;\n                text-align: left;\n            }\n        }\n        .input-icon-addon {\n            right: 0;\n            left: unset;\n        }\n        &.mini-sidebar {\n            .header {\n                left: 0;\n            }\n            &.expand-menu {\n                .header {\n                    left: 0;\n                }\n            }\n        }\n        .input-icon .form-control {\n            padding-left: 0;\n            padding-right: 30px;\n        }\n        .nav-list::before {\n            left: 0;\n            right: unset;\n        }\n        .nav-list .nav li {\n            margin-left: 10px;\n            margin-right: 0;\n        }\n        .header .header-user .user-menu  > li {\n            margin-right: 10px;\n            margin-inline-end: 0;\n        }\n        .header .header-user .user-menu .nav-item-email.nav-item-box {\n            margin-right: 15px;\n            margin-left: 0;\n        }\n        .header .header-user .user-menu  > li:first-child {\n            margin-right: 0 !important;\n            margin-left: auto;\n        }\n        .page-header {\n            .head-icons {\n                a {\n                    margin-left: 10px;\n                    margin-right: 0;\n                    &:last-child {\n                        margin-left: 0;\n                    }\n                }\n            }\n        } \n        .sidebar .sidebar-menu .clinicdropdown > a .user-names {\n            margin-right: 10px;\n            margin-left: 0;\n        }\n        #last-chart,#last-chart-2,#won-chart,#deals-chart,#contact-report,#leads-chart {\n            text {\n                text-anchor: start;\n            }\n        }\n    }\n}\n[data-loader=\"enable\"]{\n    #global-loader {\n        opacity: 1;\n    }\n}\n[data-loader=\"disable\"]{\n    #global-loader {\n       opacity: 0;\n       display: none !important;\n    }\n}\n[data-theme=\"dark\"] {\n    $text-color: $darkmode-gray-500;    \n    $border-color: #1F2228;\n    $default-border: #1F2228;\n    .bg-white {\n        background-color: $darkmode-white;\n    }\n    body {\n        background: $darkmode-light;\n    }\n    .header {\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200;        \n        .header-left {\n            .dark-logo {\n                display: block;\n            }\n        }\n        .header-user {\n            .user-menu {\n                .btn-menubar {\n                    color: $darkmode-gray-500;\n                    &:hover, &:active, &.active {\n                        background-color: $darkmode-dark-transparent;\n                        border-color: $darkmode-dark-transparent;\n                        color: $darkmode-gray-900;\n                    }\n                }\n                .profile-dropdown {\n                    .avatar img {\n                        border-color: $darkmode-gray-100;\n                    }\n                }\n            }\n        }\n        .input-group {\n            input {\n                border-color: $darkmode-gray-200 !important;\n            }\n        }\n        \n    }\n    .head-icons a{\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200;\n        &:hover{\n            background: $primary;\n        }\n    }\n    .sidebar {\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200;\n        .sidebar-logo {\n            .logo {\n                display: none;\n            }\n            .dark-logo {\n                display: block;\n            }\n        }\n        .sidebar-menu{\n            > ul{\n                > li{\n                    & > a {\n                        &:hover {\n                            span, i {\n                                color: $darkmode-gray-900;\n                            }\n                        }\n                    }\n                    > ul {\n                        > li {\n                            > a {\n                                &:hover {\n                                    background: $darkmode-dark-transparent;\n                                    i, span {\n                                        color: $darkmode-gray-900;\n                                    }\n                                }\n                            }\n                            &.submenu {\n                                > a {\n                                    &:hover, &.active, &.subdrop {\n                                        background: $darkmode-dark-transparent;\n                                        span, i {\n                                            color: $darkmode-gray-900;\n                                        }\n                                        .menu-arrow {\n                                            &::before {\n                                                border-color: $darkmode-gray-900;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    &.active{\n                        a{\n                            color: $white;\n                        }\n                    }\n                    > a{\n                        span{\n                            color: $darkmode-gray-600;\n                        }\n                    }\n                    ul{\n                        li{\n                            a {\n                                color: $darkmode-gray-900;\n                                i{\n                                    color: $darkmode-gray-500;\n                                }\n                                span {\n                                    color: $darkmode-gray-900;\n                                }\n                                &.active{\n                                    color: $primary;\n                                }\n                            }  \n                        }\n                        & > li {\n                            &.active a{\n                                background: $darkmode-dark-transparent;\n                                color: $white;\n                                .menu-arrow {\n                                    &::before {\n                                        border-right: 2px solid $primary;\n                                        border-bottom: 2px solid $primary;\n                                    }\n                                }\n                                &.subdrop{\n                                    background: $darkmode-primary-transparent;\n                                    color: $primary;\n                                    i{\n                                        color:$darkmode-white;\n                                        background:$darkmode-white;\n                                    }\n                                    span {\n                                        color: $primary;\n                                        \n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .submenu {\n                        ul {\n                            &::before {\n                                background: $darkmode-gray-100;\n                            }\n                        }\n                    }\n                }\n                li {              \n                    &.menu-title {\n                        color: $darkmode-gray-400;\n                    }\n                    .submenu > {\n                        ul{\n                            li{\n                                a{\n                                    color: $darkmode-gray-500;\n                                    &:before {\n                                        background: $primary;\n                                    }\n                                    &.active {\n                                        color: $primary;\n                                    }\n                                    &:hover {                                    \n                                        color: $primary;\n                                    }\n                                }\n                            }\n                        }\n                        \n                        a {\n                            &.subdrop {\n                                background: $darkmode-dark-transparent;\n                                i {\n                                    color: $darkmode-gray-900;\n                                }\n                            }\n                            &.active {\n                                background: $darkmode-dark-transparent;\n                                i {\n                                    color: $darkmode-gray-900;\n                                }\n                            }\n                        }\n                    }\n                    .submenu.submenu-two {\n                        a {\n                            &.subdrop, &.active {\n                                background: transparent;\n                                color: $primary;\n                            }\n                        }\n                    }\n                }\n    \n            }            \n            .menu-arrow {\n                &::before {\n                    border-right: 2px solid $darkmode-gray-900;\n                    border-bottom: 2px solid $darkmode-gray-900;\n                }\n            }\n        }\n        .nav-link {\n            color: $darkmode-gray-700;\n        }\n        .btn-menubar { \n            border: 1px solid $darkmode-gray-100;   \n            color: $darkmode-gray-500;\n            &:hover, &:active, &.active {\n                background-color: $darkmode-dark-transparent;\n                border-color: $darkmode-dark-transparent;\n                color: $darkmode-gray-900;\n            }\n        }\n        .input-group {\n            input {\n                border-color: $darkmode-gray-200 !important;\n            }\n        }\n    }\n    .mini-sidebar {\n        .sidebar {\n            .sidebar-logo {\n                .dark-logo  {\n                    display: none;\n                }\n            }\n        }\n        &.expand-menu {\n            .sidebar {\n                .sidebar-logo {\n                    .dark-logo  {\n                        display: block;\n                    }\n                    .logo-small, .logo {\n                        display: none;\n                    }\n                }\n            }\n        }\n    }\n    .form-control {\n        background-color: $darkmode-white;\n        border-color: $darkmode-gray-200;\n    }\n    .input-group-text {\n        background-color: $darkmode-white;\n        border-color: $darkmode-gray-200;\n        color: $darkmode-gray-900;\n    }\n    .sidebar-stacked {\n        .stacked-mini {\n            border-right: 1px solid $darkmode-gray-100;\n            background-color: $darkmode-light-transparent;\n        }\n        &.sidebar {\n            background-color: transparent;\n            .nav-link {\n                border: 1px solid $darkmode-gray-100;\n                color: $darkmode-gray-900;\n                &.active, &:hover {\n                    background: $darkmode-light;\n                    color: $darkmode-gray-900;\n                }\n                p {\n                    color: $darkmode-gray-900;\n                }\n            }\n            .sidebar-right {\n                background: $darkmode-white;\n                border-right: 1px solid $darkmode-gray-200;\n                .logo {\n                    text-align: center;\n                }\n                .stack-submenu {\n                    background: $darkmode-white;\n                }\n                ul {\n                    li {\n                        a {\n                            color: $darkmode-gray-500;\n                            &.subdrop {\n                                background: $darkmode-dark-transparent;\n                                i {\n                                    color: $darkmode-gray-700;\n                                }\n                            }\n                            &.active {\n                                background: $darkmode-dark-transparent;\n                                i {\n                                    color: $darkmode-gray-700;\n                                }\n                            }\n                        }                    \n                        &.active{\n                            a {\n                                background: $darkmode-dark-transparent;\n                            }\n                        }\n                        &.submenu {\n                            > a {\n                                &:hover {\n                                    background: $darkmode-dark-transparent;\n                                    color: $darkmode-gray-500 !important;\n                                }\n                            }\n                            ul {\n                                & > li {\n                                   & > a{\n                                        &:hover, &.active {\n                                            color: $primary;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                   & > ul {                \n                        & > li {\n                            > a {\n                                &:hover {\n                                    background: $darkmode-dark-transparent;\n                                }\n                            }\n                        }\n                    }\n    \n                }\n            }\n        }\n    }   \n    .sidebar-horizontal {\n        &.sidebar {\n            .sidebar-menu {\n                ul {\n                    li {\n                        &.submenu  {\n                            & > a {\n                                color: $darkmode-gray-900;\n                                &:hover {\n                                    background-color: $darkmode-dark-transparent;\n                                }\n                            }\n                            ul {\n                                li {\n                                    a {\n                                        color: $darkmode-gray-500;\n                                        &:hover, &.active {\n                                            background-color: $darkmode-dark-transparent;\n                                        }\n                                        .menu-arrow {\n                                            &::before {\n                                                border-color: $darkmode-gray-500;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }                    \n                    }\n                    ul {\n                        background-color: $darkmode-white;\n                    }\n                }\n            }     \n            .sidebar-menu {\n                    ul {\n                        li {\n                            &.submenu  {\n                            & > a {\n                                &.active, &.subdrop {\n                                    background-color: $darkmode-dark-transparent;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .menu-horizontal {\n        .header {\n            .header-left {\n                .dark-logo {\n                    display: block;\n                }\n            }\n        }\n    }\n    .sidebar-twocol{\n        .twocol-mini {\n            border-right: 1px solid $darkmode-gray-200;\n            background-color: $darkmode-white;\n        }\n        &.sidebar {\n            background-color: transparent;\n            .nav-link {\n                color: $darkmode-gray-700;\n                &.active, &:hover {\n                    background: $darkmode-light;\n                    color: $darkmode-gray-700;\n                }\n                &::before {\n                    background: $success;\n                }\n            }\n            .sidebar-right {\n                background: $darkmode-white;\n                border-right: 1px solid $darkmode-gray-200;\n                .sidebar-logo {\n                    .dark-logo {\n                        display: block;\n                    }\n                    .logo {\n                        display: none;\n                    }\n                }\n                ul {\n                    li {\n                        &.menu-title {\n                            color: $darkmode-gray-400;\n                        }\n                        a {\n                            color: $darkmode-gray-500;\n                            &.subdrop {\n                                background: $darkmode-dark-transparent;\n                                i {\n                                    color: $darkmode-gray-700;\n                                }\n                                &:hover {\n                                    color: $darkmode-gray-500 !important;\n                                }\n                            }\n                            &.active {\n                                background: $darkmode-dark-transparent;\n                                i {\n                                    color: $darkmode-gray-700;\n                                }\n                            }\n                        }                    \n                        &.active{\n                            a {\n                                background: $darkmode-dark-transparent;\n                            }\n                        }\n                        &.submenu {                        \n                            & > a {\n                                &:hover {\n                                    background: $darkmode-dark-transparent;\n                                    color: $darkmode-gray-500 !important;\n                                }\n                            }\n                            ul {\n                                & > li {\n                                   & > a{\n                                        &:hover, &.active {\n                                            color: $primary;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                .tab-pane {\n                   & > ul {                \n                        & > li {\n                            > a {\n                                &:hover {\n                                    background: $darkmode-dark-transparent;\n                                }\n                            }\n                        }\n                    }\n    \n                }\n                .menu-arrow {\n                    &:before {\n                        content: \"\\f105\";\n                    }\n                }\n            }\n        }\n    }   \n    .sidebar-nav {\n        background: $darkmode-light;\n    }\n    h1, h2, h3, h4, h5, h6 {\n        color: $darkmode-gray-900;\n    }\n    .bg-light {\n        background-color: $darkmode-light !important;\n        border-color: $darkmode-light !important;\n    }\n    a {\n        color: $darkmode-gray-900;\n    }\n    kbd {\n        background-color: $darkmode-dark-transparent;\n        color: $darkmode-gray-500;\n    }\n    .input-group-flat {\n        &:focus-within {      \n            .form-control,\n            .input-group-text {\n                border-color: $darkmode-gray-200 !important;\n            }\n        }\n    }\n    .card {\n        background-color: $darkmode-white;\n        border:1px solid $darkmode-gray-200;    \n        .card-title {  \n            color: $darkmode-gray-900;   \n        }\n        .card-header {\n            border-color: $darkmode-gray-200;\n        }\n        .card-footer {\n            border-color: $darkmode-gray-200;\n        }    \n    }\n    .alert-light {\n        background-color: $darkmode-light;\n        color: $text-color;\n        border-color: $darkmode-light;\n        .alert-link {\n          color: $text-color;\n        }\n        .btn-close {\n          color: $text-color;\n        }\n    }\n    .custom-alert1 {\n        background-color: $darkmode-white;\n    }\n    .alert-primary, .alert-secondary, .alert-warning, .alert-danger  {\n        &.custom-alert-icon {\n            background-color: $darkmode-white;\n            border-color: $darkmode-gray-200;\n        }\n    }\n    &[data-layout=\"horizontal-overlay\"][data-topbarcolor=\"white\"],\n    &[data-layout=\"horizontal-sidemenu\"][data-topbarcolor=\"white\"]  {   \n        .header {\n            left: 0;\n            background-color: $darkmode-white;\n            border-color: lighten($darkmode-white, 0.9);\n            .header-user {\n                .user-menu {\n                    .btn-menubar {\n                        color: $darkmode-gray-500;\n                        &:hover {\n                            background: $darkmode-dark-transparent;\n                            color: $darkmode-gray-500;\n                        }\n                    }\n                }\n            }\n            .header-left {\n                display: block;\n                .logo {\n                    display: none;\n                }\n                .dark-logo {\n                    display: block;\n                }\n            }\n        }      \n        .mode-toggle {\n            color: $darkmode-gray-500;\n        }\n        .sidebar-horizontal {\n            &.sidebar {\n                background-color: $darkmode-white;\n                border-bottom: 1px solid lighten($darkmode-white, 0.9);\n                .sidebar-menu {\n                    .nav-menu {\n                        > li {     \n                            &.submenu {\n                                & > a {\n                                    color: $darkmode-gray-900;\n                                    &.active, &:hover,  &.subdrop {\n                                        background-color: $darkmode-dark-transparent;\n                                        color: $darkmode-gray-900;\n                                        .menu-arrow {\n                                            &::before {\n                                                border-color: $darkmode-gray-900;\n                                            }\n                                        }\n                                    }\n                                    .menu-arrow {\n                                        &::before {\n                                            border-color: $darkmode-gray-900;;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                        .menu-arrow {\n                            &::before {\n                                border-color: $darkmode-gray-900;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .main-wrapper {\n            &::before {\n                content: \"\";\n                background: $darkmode-white;\n            }\n        }\n    }\n    .page-wrapper {\n        &::before {\n            background: $darkmode-white;\n        }\n    }\n    .accordion-button {\n        background-color: $darkmode-white;\n        color: $text-color;\n        &:not(.collapsed) {\n        }\n        &:after {\n            content: \"\\f078\";\n            background-color: $darkmode-white;\n            color: $text-color;\n        }\n    }  \n    .accordion-body {\n        color: $text-muted;\n    }\n    .accordion-item {\n        color: $text-color;\n        background-color: $darkmode-white;\n        border-color: $darkmode-light-900;\n    }\n    .accordion {\n        &.accordion-primary, &.accordion-secondary {\n            .accordion-button.collapsed {\n                background-color: $darkmode-white;\n                color: $text-color;\n                &::after {\n                    background-color: $darkmode-white;\n                    color: $text-color;\n                }\n            }\n        }\n        &.accordion-solid-primary, &.accordion-solid-secondary,\n        &.accordion-solid-warning, &.accordion-solid-info, &.accordion-solid-success, &.accordion-solid-danger {\n            .accordion-button {\n                color: $darkmode-white;;\n                &.collapsed {\n                    background-color: $darkmode-white;\n                    color: $text-color;\n                    &::after {\n                        background-color: $darkmode-white;\n                        color: $text-color;\n                    }\n                }\n            }   \n        }\n        &.accordion-border-primary, &.accordion-border-secondary,\n        &.accordion-border-warning, &.accordion-border-info, &.accordion-border-success, &.accordion-border-danger {\n            .accordion-button {\n                background-color: $darkmode-white;\n                &::after {\n                    background-color: $darkmode-white;\n                }\n            }\n        }\n    }\n    .bg-outline-primary, .bg-outline-secondary, .bg-outline-success,\n    .bg-outline-danger, .bg-outline-warning, .bg-outline-info, .bg-outline-light, .bg-outline-light {\n        background-color: $darkmode-white;\n    }    \n    .bg-outline-light {\n        border: 1px solid $darkmode-light !important;\n        color: $darkmode-gray-900 !important;\n    }\n    .border-container {\n        background-color: $darkmode-light;\n    }\n    .border {\n        border-color: $border-color !important;\n        &.border-primary {\n            border: 1px solid $primary !important;\n        }\n        &.border-secondary {\n            border: 1px solid $secondary !important;\n        }\n        &.border-success {\n            border: 1px solid $success !important;\n        }\n        &.border-warning {\n            border: 1px solid $warning !important;\n        }\n        &.border-danger {\n            border: 1px solid $danger !important;\n        }\n        &.border-info {\n            border: 1px solid $info !important;\n        }\n        &.border-light {\n            border: 1px solid $darkmode-light !important;\n        }\n        &.border-white {\n            border: 1px solid $darkmode-white !important;\n        }\n    }\n    .border-top {\n        border-top: 1px solid $border-color !important;\n    }\n    .border-end {   \n        border-inline-end: 1px solid $border-color !important;\n    }\n    .border-bottom {\n        border-bottom: 1px solid $border-color !important;\n    }\n    .border-start {\n        border-inline-start: 1px solid $border-color !important;\n    }\n    .list-group-item {\n        background-color: $darkmode-white;\n        border-color: $darkmode-light-900 !important;\n    }\n    .toast {\n        background-color: $darkmode-white;\n    }\n    .avatar.online:before, .avatar.offline:before {\n        border-color: $darkmode-white !important;\n    }\n    .swal2-popup {\n        background-color: $darkmode-white;\n    }\n    .progress, .progress-stacked {\n        background-color: $darkmode-light-900;\n    }\n    .popover {\n        background-color: $darkmode-white;\n        border: 1px solid $default-border;\n        box-shadow: none;\n        .popover-header {\n          background-color: $darkmode-white;\n          border-block-end: 1px solid $default-border;\n        }\n        .popover-body {\n          color: $text-color;\n        }\n      }\n      .bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n      .bs-popover-top > .popover-arrow::after,\n      .bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n      .bs-popover-top > .popover-arrow::before {\n        border-top-color: $darkmode-light;\n      }\n      .bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n      .bs-popover-end > .popover-arrow::after,\n      .bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n      .bs-popover-end > .popover-arrow::before {\n        border-right-color: $darkmode-light;\n      }\n      .bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n      .bs-popover-start > .popover-arrow::after,\n      .bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n      .bs-popover-start > .popover-arrow::before {\n        border-left-color: $darkmode-light;\n      }\n      .bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n      .bs-popover-bottom > .popover-arrow::after,\n      .bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n      .bs-popover-bottom > .popover-arrow::before,\n      .bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n      .bs-popover-bottom .popover-header::before {\n        border-bottom-color: $darkmode-light;\n    }\n    .page-link {\n        color: $text-color;\n        background-color: $darkmode-white;\n        border: 1px solid $border-color;\n        &:focus {\n            background-color: $darkmode-light;\n        }\n        &:hover {\n            background-color: $darkmode-light;\n            border-color: $border-color;\n        }\n    }\n    .pagination-style-2 .pagination .page-item.active .page-link {\n        background-color: $darkmode-light;\n    }\n    .pagination-style-1 .pagination .page-item:hover .page-link {\n        background-color: $darkmode-light;\n    }\n    .pagination-style-3 .pagination .page-item:hover .page-link {\n        background-color: $darkmode-light;\n    }\n    .offcanvas {\n        background-color: $darkmode-white;\n        color: $text-color;\n    }\n    .modal-content {\n        background-color: $darkmode-white;\n        border-color: $darkmode-gray-200;\n        .modal-header {\n            border-color: $darkmode-gray-200;\n        }\n        .modal-footer {\n            border-color: $darkmode-gray-200;\n        }\n    }\n    .figure-caption {\n        color: $text-color;\n    }\n    .text-dark {\n        color: $darkmode-dark !important;\n    }\n    .nav-tabs li a {\n        color: $darkmode-gray-900;\n    }\n    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n        background-color: $darkmode-white;\n        color:  $darkmode-gray-900;\n    }\n    .nav-tabs .nav-link.active {\n        border-color: $darkmode-gray-200;\n    }\n    .nav-tabs.nav-tabs-solid {\n        background-color: $darkmode-white;\n    }\n    .nav.tab-style-1 {\n        background-color: $darkmode-light;\n    }\n    .vertical-tabs-2 .nav-item .nav-link {\n        background-color: $darkmode-light;\n        border-color: $darkmode-gray-200;\n        &.active {\n            background-color: $primary;\n        }\n    }\n    .tab-style-2 {\n        .nav-item .nav-link {            \n            i {\n                background-color: $darkmode-light;\n                color: $darkmode-gray-500;\n            }\n        }\n    }\n    .nav-tabs.nav-tabs-top {\n        li{\n            a{\n                &.active{\n                    border-top-color: $primary;      \n                }\n            }\n        }\n    }\n    .tab-style-3 {\n        .nav-item {\n            .nav-link {\n                &::after {\n                    background-color: $darkmode-white;\n                    border-color: $darkmode-gray-200;\n                }\n                &:before { \n                    background-color: $darkmode-light;\n                }\n                &.active{\n                    &:before {\n                        background-color: $primary;\n                      }\n                      &:after {\n                        border-color: $primary;\n                        color: $primary;\n                      }\n                }\n            }\n        }\n    }\n    .tab-style-6 {\n        background-color: $darkmode-white;\n    }\n    .bg-white {\n        background-color: $darkmode-white !important;\n    }\n    .card.card-bg-primary .card-body, .text-fixed-white {\n        color: $darkmode-white;\n    }\n    .btn {\n        &.btn-light {\n            background-color: $darkmode-light-900;\n            border: 1px solid $darkmode-light-900;\n            color: $darkmode-gray-500;\n            &:hover,\n            &:focus,\n            &.focus,\n            &:active,\n            &.active {\n                background-color: darken($darkmode-light-900, 3%);\n                border: 1px solid $darkmode-light-900;\n                color: $darkmode-gray-500;\n            }\n        }\n    }\n    .scroll-demo {\n        border-color: $darkmode-gray-200;\n    }\n    .timeline  {\n        &::before {\n            background-color: $darkmode-gray-200;\n        }\n        & > li {\n            & > .timeline-panel {\n                border-color: $darkmode-gray-200;\n                &::after, &::before { \n                    border-color: $darkmode-gray-200;\n                }\n            }\n        }\n    }\n    .callout {\n        background-color: $darkmode-light;\n    }\n    .icons-list {\n        li {\n            border-color: $darkmode-gray-200;\n            box-shadow: none;\n        }\n    }\n    .btn-outline-light {\n        border: 1px solid $darkmode-light !important;\n        color: $darkmode-gray-700 !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $darkmode-light !important;\n            border: 1px solid $darkmode-light !important;\n            color: $darkmode-gray-700 !important;\n        }\n    }\n    .bg-dark {\n        background-color: $darkmode-dark !important;\n        border-color: $darkmode-dark !important;\n        color: $darkmode-white;\n    }\n    .twitter-bs-wizard .twitter-bs-wizard-nav {\n        .nav-link::after {\n            background-color: $darkmode-gray-200;\n        }\n    }\n    .form-check-input {\n        background-color: $darkmode-white;\n        border-color: $darkmode-gray-200;\n    }\n    .alert-outline-primary, .alert-outline-secondary, .alert-outline-warning, .alert-outline-danger,\n    .alert-outline-info, .alert-outline-dark, .alert-outline-success, .alert-outline-light {\n        background-color: $darkmode-white;\n    }\n    .text-white {\n        color: $darkmode-white !important;\n    }\n    .text-light {\n        color: $darkmode-light !important;\n      }\n    .table {\n        thead {\n            tr {\n                border-color: $darkmode-gray-200;\n                    th {\n                        border-color: $darkmode-gray-200;\n                        background-color: $darkmode-gray-200;\n                        color: $darkmode-gray-900;\n                    }\n            }\n        }\n        tbody {\n            tr {\n                border-color: $darkmode-gray-200;\n                th {\n                    border-color: $darkmode-gray-200;\n                        background-color: $darkmode-gray-200;\n                        color: $darkmode-gray-900;\n                }\n                td {\n                    background-color: $darkmode-white;\n                    color: $darkmode-gray-500;\n                    border-color: $darkmode-gray-200;\n                }\n            }\n        }\n        .thead-primary th {\n            background-color: $primary;\n        }\n        .thead-secondary th {\n            background-color: $secondary;\n        }\n        .thead-info th {\n            background-color: $info;\n        }\n        .thead-warning th {\n            background-color: $warning;\n        }\n        .thead-danger th {\n            background-color: $danger;\n        }\n        .thead-success th {\n            background-color: $success;\n        }\n        .thead-dark th {\n            background-color: $darkmode-dark;\n        }\n        .thead-light th {\n            background-color: $darkmode-light-600;\n        }\n    }\n    table.table.dataTable {\n        & > tbody {\n            > tr {\n                border-color: $darkmode-gray-200;\n                td {\n                    color: $darkmode-gray-500;                \n                    border-color: $darkmode-gray-200;\n                }\n            } \n        }\n        & > thead > tr {\n            border-color: $darkmode-gray-200;\n                th {\n                    color: $darkmode-gray-900;\n                }\n        }\n    }\n    .dataTables_length {\n        label {\n            color: $darkmode-gray-700;    \n            .form-select {\n                border: 1px solid $darkmode-gray-200;\n                color: $darkmode-gray-900;\n            }\n        }\n    }\n    .form-label {\n        color: $darkmode-gray-900;\n    }\n    .form-control {\n        color: $darkmode-gray-900;\n    }\n    .form-select {\n        background-color: $darkmode-white;\n        color: $darkmode-gray-900;\n        border-color: $darkmode-gray-200;\n        option {\n            background-color: $darkmode-white;\n        }\n    }\n    .select2-container--default {\n        .select2-selection--single {\n            border-color: $darkmode-gray-200;\n            background: $darkmode-white;\n            .select2-selection__rendered {\n                color: $darkmode-gray-900 !important;\n            }\n            .select2-selection__arrow {\n                b {\n                    border-color: $darkmode-gray-900;\n                }\n            }\n        }\n        .select2-results__option--highlighted[aria-selected] {\n            color: $darkmode-white;\n        }\n    }\n    .select2-container--focus  {\n        .select2-selection--single{\n            background: $darkmode-white !important;\n            border-color: $darkmode-gray-200;\n        }\n    }\n    .select2-container--classic .select2-selection--single,\n    .select2-container--default .select2-selection--single,\n    .select2-container--default .select2-selection--single .select2-selection__rendered,\n    .select2-container--default .select2-selection--single .select2-selection__arrow,\n    .select2-container--default .select2-selection--multiple,\n    .select2-container--classic .select2-selection--single .select2-selection__arrow,\n    .select2-container--classic .select2-selection--single .select2-selection__rendered {\n        border-color: $darkmode-gray-200;\n        color: $darkmode-gray-500;\n    }\n    .select2-dropdown {\n        border-color: $darkmode-gray-200;\n        background: $darkmode-white;\n    }\n    .select2-container--classic .select2-selection--multiple .select2-selection__choice,\n    .select2-container--default .select2-selection--multiple .select2-selection__choice,\n    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n        color: $darkmode-white;\n    }\n    .form-floating > .form-control-plaintext ~ label::after, \n    .form-floating > .form-control:focus ~ label::after, \n    .form-floating > .form-control:not(:placeholder-shown) ~ label::after, \n    .form-floating > .form-select ~ label::after {\n        background-color: $darkmode-white;\n    }\n    .select2-container--default .select2-selection--multiple {\n        background-color: $darkmode-white;\n    }\n    .custom-file-container {\n        .custom-file-container__custom-file__custom-file-control {\n            background-color: $darkmode-gray-100;\n            border-color: $darkmode-gray-100;\n        }\n    }\n    .dropdown-menu {\n        background-color: $darkmode-white;\n        border-color: $darkmode-gray-200;\n        color: $darkmode-gray-900;\n        .dropdown-item {\n            color: $darkmode-gray-900;\n            &:not(.active) {\n                &:hover,\n                &:focus,\n                &:active {\n                  color: $darkmode-gray-900;\n                  background-color: $darkmode-light-500;\n                }\n              }\n              &.active {\n                background-color: $darkmode-light-500;\n              }\n        }\n    }\n    .dropdown-divider {\n        border-color: $darkmode-gray-200;\n    }\n    &[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg1\"],\n    &[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg2\"],\n    &[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg3\"],\n    &[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg4\"],\n    &[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg5\"],\n    &[data-sidebar=\"light\"] [data-sidebarbg=\"sidebarbg6\"] {\n        #sidebar {\n            &::before  {\n                background: rgba($darkmode-white, 0.85);\n            }\n        }\n    }\n    .theme-width {\n        input[type=\"radio\"]{\n            &:checked{\n                ~ label{\n                    border-color: $primary;\n                    &::before {\n                        border-color: $primary;\n                    }\n                }\n            }\n        }\n        label {\n            border-color: $darkmode-gray-200;\n            color: $darkmode-gray-500;\n            &::before {\n                border-color: $darkmode-gray-200;\n                background: $darkmode-white;\n            }\n            &::after {\n                background: $primary;\n            }\n        }\n    }\n    .theme-sidebarcolor {\n        input[type=\"radio\"]{\n            &:checked{\n                ~ label{                \n                    border-color: $primary !important;\n                    &:after{\n                        color: $primary;\n                    }\n                    &.bg-dark {\n                        &:after{\n                            color: $darkmode-white;\n                        }\n                    }\n                }\n            }\n        }\n        label {        \n            border-color: $darkmode-gray-200;\n        }\n    }\n    .theme-sidebarbg {\n        input[type=\"radio\"]{\n            &:checked{\n                ~ label{\n                    &:after{\n                        color: $primary;\n                        background: $white;\n                        border-color: $darkmode-gray-200;\n                    }      \n                }\n            }\n        }\n        label { \n            img { \n                border-color: $darkmode-gray-200;\n            }\n        }\n    }\n    .theme-colorselect {\n        input[type=\"radio\"]{\n            &:checked{\n                ~ label{\n                    outline-color: $primary;\n                    &:after{\n                        color: $primary;\n                        background: $white;\n                        border-color: $darkmode-gray-200;\n                    }\n                    &.primary-topbar,   &.dark-topbar {\n                        &:after{\n                            color: $darkmode-white;\n                        }\n                    }\n                }\n            }\n        }\n        label {\n            outline-color: $darkmode-gray-200;\n            &.white-topbar {\n                background: $darkmode-white;\n                border-color: $darkmode-gray-200;\n            }\n        }\n        .pickr-container-background, .pickr-topbar, .pickr-topbarcolor { \n            outline-color: $darkmode-gray-200;\n        }\n    }\n    .theme-colorsset{\n        label{\n            border-color: $darkmode-gray-200;\n            &.primary-clr{\n                &::before {\n                    background: $primary;\n                }\n            }\n            &.brightblue-clr{\n                &::before {\n                    background: $brightblue;\n                }\n            }\n            &.lunargreen-clr{\n                &::before {\n                    background: $lunargreen;\n                }\n            }\n            &.lavendar-clr{\n                &::before {\n                    background: $lavendar;\n                }\n            }\n            &.magenta-clr{\n                &::before {\n                    background: $magenta;\n                }\n            }\n            &.chromeyellow-clr{\n                &::before {\n                    background: $chromeyellow;\n                }\n            }\n            &.lavared-clr{\n                &::before {\n                    background: $lavared;\n                }\n            }\n        }\n        input[type=\"radio\"]{\n            &:checked{\n                ~ label{\n                    &:after{\n                        color: $darkmode-white;\n                    }\n                }\n            }\n        }\n    }    \n    .theme-mode {\n        input[type=\"radio\"]{\n            &:checked{\n                ~ label{\n                    border-color: $primary;\n                    .avatar {\n                        color: $warning;\n                        background-color: $warning-transparent;\n                    }\n                }\n            }\n        }\n        label {\n            border-color: $darkmode-gray-200;\n            color: $darkmode-gray-700;\n            .avatar {\n                background-color: $darkmode-dark-transparent;\n                color: $darkmode-dark;\n            }\n        }        \n        .pickr-container-primary {\n            border-color: $darkmode-gray-200;\n        }\n    }\n    .theme-layout {\n        &.active {\n            img {\n                border: 1px solid $primary;\n            }\n        }\n        input[type=\"radio\"]{\n            &:checked{\n                ~ label{\n                    .layout-img {\n                        img {\n                            border-color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        label {\n            .layout-img {\n                img {\n                    border-color: $darkmode-gray-200;\n                }\n            }            \n            .layout-type { \n                color: $darkmode-gray-900;\n            }\n        }\n    }\n    &[data-layout=modern][data-topbarcolor=white] {\n        .header {\n            background-color: $darkmode-white;\n            border-color: rgba($darkmode-white, 0.8);\n            .bar-icon {\n                span {\n                    background-color: $darkmode-white;\n                }\n            }\n            .header-user {\n                .user-menu {\n                    .btn-menubar {\n                        color: $darkmode-gray-500;\n                        &:hover, &:active, &.active {\n                            background-color: $darkmode-white;\n                            color: $darkmode-gray-500 !important;\n                        }\n                    }\n                }\n            }\n            .header-left {\n                .logo {\n                    display: none;\n                }\n                .dark-logo {\n                    display: block;\n                }\n            }\n        }\n        .page-wrapper {\n            &::before {\n                background: $darkmode-white;\n            }\n        }   \n    }\n    &[data-layout=\"modern\"][data-topbarcolor=\"firefly\"],\n    &[data-layout=\"modern\"][data-topbarcolor=\"bluegem\"],\n    &[data-layout=\"modern\"][data-topbarcolor=\"blackpearl\"],\n    &[data-layout=\"modern\"][data-topbarcolor=\"maroon\"],\n    &[data-layout=\"modern\"][data-topbarcolor=\"primary\"]     {\n        .header {\n            .bar-icon {\n                span {\n                    background-color: $darkmode-white;\n                }\n            }\n            .header-user {\n                .user-menu {\n                    .btn-menubar {\n                        color: $darkmode-gray-500;\n                        &:hover, &:active, &.active {\n                            background-color: $darkmode-white;\n                            color: $darkmode-gray-500 !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .policy-upload {\n        border-color: $border-color;\n    }\n    .bootstrap-tagsinput {\n        background-color: $darkmode-white;\n        border-color: $border-color;\n    }\n    .note-toolbar, .note-dropdown-menu, .note-modal-content, .note-input {\n        background-color: $darkmode-light;\n        border-color: $border-color;\n        color: $darkmode-gray-900;\n    }\n    .note-btn {\n        background-color: $darkmode-white;\n        border-color: $border-color;\n        color: $darkmode-gray-900;\n    }\n    .note-modal-header, .file-drop {\n        border-color: $border-color;\n    }\n    .close {\n        color: $darkmode-gray-900;\n    }\n    .video-wrap {\n        .video-content {\n            background-color: $darkmode-white;\n        }\n    }\n    .bg-black {\n        .text-white {\n            color: $darkmode-gray-900 !important;\n        }\n    }\n    .bg-transparent-light {\n        background: $darkmode-light !important;\n    }\n    .contact-grids-tab .nav-underline {\n        border-color: $border-color;\n        .nav-item .nav-link {\n            &.active, &:hover {\n                background-color: $darkmode-white;\n            }\n        }\n    }\n    .bg-primary-100 {\n        a {\n            color: $darkmode-white;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .notification-dropdown {\n        .dropdown {\n            .dropdown-toggle {\n                color: $darkmode-gray-900;\n                &.show {\n                    color: $darkmode-gray-900;\n                }\n            }\n        }\n    }\n    .bootstrap-datetimepicker-widget {\n        table {\n            th {\n                color: $darkmode-gray-900;\n            }\n        }\n    }\n    .crm-link {\n        color: $darkmode-gray-900;\n        background: $darkmode-light;\n        border: $border-color;\n\n    }\n}\n\n[data-theme=\"dark\"] {\n    .breadcrumb .breadcrumb-item.active {\n        color: $darkmode-gray-800;\n    }\n    .table tbody tr td a {\n        color: $darkmode-gray-800;\n    }\n    .btn.btn-icon.active.bg-white {\n        border-color: $darkmode-gray-200;\n        color: $darkmode-gray-800;\n    }\n    .custom-datatable-filter {\n        background: $darkmode-white;\n    }\n    .btn.btn-white {\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200;\n        color: $darkmode-gray-800;\n    }\n    .todo-item .form-check-label {\n        color: $darkmode-gray-800;\n    }\n    .bg-transparent-secondary,.bg-transparent-dark,.bg-light-500 {\n        background: $darkmode-gray-700 !important;\n    }\n    .text-gray-9, .text-title {\n        color: $darkmode-gray-800 !important;\n    }\n    .attendance-bg {\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200 !important;\n    }\n    .chat-wrapper .sidebar-group {\n        background: $darkmode-gray-200;\n    }\n    .chat-wrapper .chat-users-wrap .chat-user-list,.chat-wrapper .chat .chat-header,.chat-wrapper .chat {\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200;\n    }\n    .chat-wrapper .search-wrap .input-group-text {\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200\n    }\n    .chat-wrapper .search-wrap .form-control {\n        border-color: $darkmode-gray-200\n    }\n    .chat-wrapper .chat .chat-footer .footer-form {\n        background: $darkmode-white;\n        border-color: $darkmode-gray-200;\n    }\n    .chat-wrapper .chat .chat-footer .footer-form .chat-footer-wrap {\n        background: $darkmode-gray-200;\n    }\n    .chat-wrapper .chat .chat-body .messages .chats .chat-content .message-content {\n        background: $darkmode-gray-200;\n    }\n    .chat-wrapper .chat .chat-header .chat-options > ul > li > a {\n        background: $darkmode-gray-200;\n    }\n    #calendar {\n        .fc-scroller-harness th {\n            background: $darkmode-white;\n            border-color: $darkmode-gray-200;\n        }\n        .fc-col-header-cell-cushion,.fc-daygrid-day-number {\n            color: $darkmode-gray-800;\n        }\n        .fc-daygrid-body tbody td {\n            background: $darkmode-white;\n            border-color: $darkmode-gray-200;\n        }\n        .fc-daygrid .fc-scrolcustom991rid {\n            border-color: $darkmode-gray-200;\n        }\n    }\n}\n\n.menu-horizontal {    \n    .header {\n\n    }\n    #toggle_btn{\n        display: none;\n    }\n    .page-wrapper {\n        margin: 0;\n        padding-top: 96px;\n        max-width: 1320px;\n        margin: 0 auto;\n        @include respond-below(custom1399) {\n            max-width: 1170px;\n        }\n        @include respond-below(custom1199) {\n            max-width: 950px;\n        }\n        @include respond-below(custom991) {\n            max-width: 100%;\n        }\n        .content {\n            padding-left: 0;\n            padding-right: 0;\n            @include respond-below(custom991) {\n                padding: 20px;\n            }\n        }\n    }\n    #sidebar {\n        @include respond-above(custom991) {\n            display: none;\n        }\n    }\n    \n    .header {\n        left: 0;\n        .main-header {\n            margin: 0 auto;\n            .user-menu {\n                padding-right: 0;\n            }\n        }\n        .header-left {\n            display: block;\n            .logo { \n                display: block;\n            }\n            .dark-logo {\n                display: none;\n            }\n        }\n    }  \n} \n\n.sidebar-horizontal {\n    margin: 0 auto;\n    box-shadow: $box-shadow-sm;\n    &.sidebar {\n        width: 100% !important;\n        bottom: inherit;\n        top: 50px;\n        border-right: 0;\n        z-index: 9;\n        .sidebar-logo {\n            display: none;\n        }\n        .sidebar-menu ul li span {\n            display: inline-block !important;\n        }\n        .slimScrollDiv {\n            top: 0;\n            height: auto !important;\n            overflow: inherit !important;\n            padding: 0;\n        }\n        .sidebar-inner {\n            height: auto !important;\n            overflow: inherit !important;\n        }\n        .hidden{\n            display: none !important;\n        }\n        .sidebar-menu {\n            padding:  0 !important;\n            height: 46px;\n            display: flex;\n            align-items: center;\n            margin: 0 auto;\n            width: 100%;\n            .nav-menu {\n                & > li {\n                    margin-right: 8px;\n                    &:last-child {\n                        margin-right: 0;\n                    }\n                    &.submenu {\n                        > ul {\n                            max-height: 350px;\n                            overflow-x: hidden;\n                            overflow-y: auto;\n                        }\n                    }\n                }\n            }\n            ul {\n                display: flex;\n                align-items: center;\n                -webkit-align-items: center;\n                li {\n                    position: relative;\n                    &.submenu  {\n                        & > a {\n                            font-size: $font-size-12;\n                            color: $gray-900;\n                            @include rounded(5px);\n                            padding: 8px 30px 8px 8px;\n                            i {\n                                margin-right: 4px;\n                            }\n                            &:hover {\n                                background-color: $dark-transparent;\n                            }\n                        }\n                        .noti-dot {\n                            &:before {\n                                display: none;\n                            }\n                        }\n                        ul {\n                            li {\n                                &.submenu {\n                                    a {\n                                        font-size: $font-size-12;\n                                    }\n                                }\n                                a {\n                                    color: $gray-700;\n                                    @include rounded(5px);\n                                    &:hover, &.active {\n                                        background-color: $dark-transparent;\n                                    }\n                                }\n                            }\n                        }\n                        &.submenu-two {\n                            ul {\n                                max-height: none;\n                            }\n                        }\n                    }                    \n                }\n                ul {\n                    display: none;\n                    width: 170px;\n                    background-color: $white;\n                    position: absolute;\n                    top: 45px;\n                    left: 0;\n                    padding: 8px;\n                    li {\n                        a {\n                            .menu-arrow {\n                                right: 15px;\n                            }\n                        } \n                    }\n                    a {\n                        padding: 8px 15px;\n                    }\n                }\n            }\n            .menu-title{\n                display: none !important;\n            }\n        }\n        .sidebar-vertical{\n            display: none !important;\n        }\n        .sidebar-menu ul li a {\n            flex-direction: inherit;\n            text-align: left;\n            padding: 7px 8px;\n            font-size: $font-size-12;\n            font-weight: $font-weight-medium;\n            display: block;\n            position: relative; \n        }\n        ul li span {\n            display: inline-block !important;\n        }           \n        .sidebar-menu ul {\n            ul {\n                & > li {\n                    &.submenu {\n                        & > ul {\n                            position: relative;\n                            top: 0;\n                            padding: 0;\n                            width: 100%;\n                        }\n                    }\n                }\n            }\n        }\n        ul ul li {\n            display: inline-block !important;\n            width:100%;\n        }\n    \n    .sidebar-menu {\n        max-width: 1320px;\n        @include respond-below(custom1399) {\n            max-width: 1170px;\n        }             \n        @include respond-below(custom1199) {\n            max-width: 950px;\n        }\n        .main-menu {\n            display: flex !important;\n            align-items: center;\n            justify-content: space-between;\n            width: 100%;\n        }\n            ul {\n                li {\n                    &.submenu  {\n                    & > a {\n                        &.active, &.subdrop {\n                            background-color: $dark-transparent;\n                        }\n                        @include respond-above(custom1199) {\n                            font-size: $font-size-14;\n                            padding: 8px 30px 8px 8px;\n                            i {\n                                margin-right: 5px;\n                            }\n                            .menu-arrow {\n                                right: 8px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @include respond-below(custom991) {\n        display: none !important;\n        }\n    }\n}\n#horizontal-menu, #horizontal-single,\n#two-col-sidebar, #stacked-sidebar {\n    display: none;\n}\n[data-theme=\"dark\"]{\n    .border,.border-top,.border-bottom,.border-start,.border-end {\n        border-color: $dark-border !important;\n    }\n    .dropdown .dropdown-toggle {\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .dropdown .dropdown-menu {\n        background: $dark;\n        border-color: $dark-border;\n    }\n    .bg-white {\n        background: $dark !important;\n    }\n    .bg-light-200,.bg-light-300,.bg-light-400 {\n        background: $dark-input;\n    }\n    .dropdown .dropdown-menu .dropdown-item {\n        background: $dark-input;\n    }\n    .offcanvas {\n        background: $dark;\n    }\n    .accordion-button:after {\n        background: transparent;\n    }\n    .bg-success.border {\n        border-color: $success !important;\n    }\n    .bg-purple.border {\n        border-color: $purple !important;\n    }\n    .bg-warning.border {\n        border-color: $warning !important;\n    }\n    .bg-danger.border {\n        border-color: $danger !important;\n    }\n    .btn-close {\n        --bs-btn-close-color: $dark-text;\n        color: $white;\n    }\n    .input-themeselect{\n        span{\n            color: $white;\n        }\n    }\n}\n[data-theme=\"dark\"]{\n    body{\n        background-color:$dark;\n        color: $dark-text;\n    }\n    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\n        color: $white;\n    }\n    .header{\n        background-color:$dark;\n        .header-left{\n            background-color:$dark;\n            .logo{\n                img{\n                    display: none;\n                    &.white-logo{\n                        display: block;\n                    }\n                }\n            }\n            #toggle_btn{\n                color: $white;\n            }\n        }\n        .dropdown-menu{\n            background-color:$dark;\n            box-shadow: none;\n            a{\n                color: $white;\n            }\n            .topnav-dropdown-header {\n                border-color: $dark-border;\n                .notification-title{\n                    color: $white;\n                }\n                \n            }\n        }\n        .menu-drop-user .dropdown-item{\n            border-color: $dark-border;\n        }\n        .notification-dropdown {\n            .notification-list {\n                li {\n                    border-bottom: 1px solid $dark-border;\n                    .noti-title {\n                        color: $white;\n                    }\n                    .noti-details {\n                        color: $white;\n                    }\n                    p.noti-time {\n                        color: $white;\n                    }\n                    .noti-pdf {\n                        .noti-pdf-icon {\n                            span {\n                                border: 1px solid $dark-border;\n                            }\n                        }\n                        .noti-pdf-text {\n                            p {\n                                color: $white;\n                            }\n                            span {\n                                color: $dark-textcolor;\n                            }\n                        }\n                    }\n                    .notification-time {\n                        font-size: $font-size-12;\n                        line-height: 1.35;\n                        color: $gray-600;\n                    }\n                    \n                }\n            }\n            .topnav-dropdown-footer{\n                background: $dark;\n            }\n        }\n        .searchinputs {\n            input{\n                border-color: $dark-border;\n                background: transparent;\n            }\n            .search-addon button{\n                color: $dark-textcolor;\n            }\n        }\n        .menus-info {\n            .menu-list {\n                li {\n                    a {\n                        background: transparent;\n                        border-radius: $border-radius-lg;\n                        &:hover {\n                            background: transparent;\n                        }\n                        .menu-details {\n                            .menu-list-icon {\n                                color: $white;\n                            }\n                            .menu-details-content {\n                                p {\n                                    color: $white;\n                                    margin-bottom: 0;\n                                }\n                                span {\n                                    font-weight: $font-weight-normal;\n                                    color: $dark-textcolor;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar {\n        background-color:$dark;\n        .sidebar-menu {\n            .clinicdropdown {\n                a{\n                    background-color:#28283E;\n                    .user-names h5{\n                        color: $white;\n                    }\n                }\n            }\n            ul{\n                > li {\n                    ul {\n                        li a {\n                            span{\n                                color: $dark-text;\n                            }\n                        }\n                    }\n                }\n            }\n            .menu-arrow{\n               &:before{\n                    border-bottom: 2px solid $dark-text;\n               }\n            }\n        }\n    }\n    .contact-grid.proposals-grid .grid-head .table-action .action-icon{\n        background: #393947;\n        color: $white;\n    }\n    .contact-grid.proposals-grid .grid-footer {\n        background: #171724;\n        border-color: #393947;\n        color: $white;\n    }\n    .title-head {\n        color: $white;\n    }\n    .sidebar-themesettings {\n        background: $dark;\n        .themesettings-header {\n            border-color: $dark-border;\n            h4 {\n                color: $white;\n            }\n        } \n        .themesettings-inner {\n            background: $dark-bg;\n            border-color: $dark-border;\n            .themesettings-content {\n                border-color: $dark-border;\n                h6 {\n                    color: $white;\n                }\n            }\n        }\n        .input-themeselect {\n            border-color: $dark-border;\n            background: $dark;\n            .checkboxs-theme:after {\n                border-color: $dark-border;\n            }\n        }\n    }\n    .form-check-label,\n    .form-label,\n    .sub-header{\n        color: $dark-text;\n    }\n    .form-select {\n        option{\n            background: transparent;\n        }\n    }\n    .icon-form{\n        .form-icon {\n            color: $dark-text;\n        }\n    }\n    .drop-down > a,\n    .export-dropdwon > a,\n    .form-sorts > a{\n        border-color: $dark-border;\n        box-shadow: none;\n        background-color: #1A1A25;\n        color: $dark-text;\n        &:hover{\n            color: $dark-text;\n        }\n    }\n    .manage-dropdwon {\n        .dropdown-menu{\n            border-color: $dark-border;\n            background-color: #1A1A25;\n            color: $dark-text;\n            box-shadow: none;\n        }\n    }\n    .form-sorts {\n        .filter-set-content {\n            .filter-set-content-head {\n                a{\n                    color: $dark-text;\n                }\n            }\n        }\n    }\n    .header-set .select2-container--default {\n        .select2-selection--single {\n            border-color: $dark-border;\n        }\n    }\n    .form-sorts {\n        .filter-dropdown-menu{\n            border-color: $dark-border;\n            background-color: #1A1A25;\n            color: $dark-text;\n            box-shadow: none;\n        }\n    }\n    .status-radio:checked + label, \n    .status-radio:not(:checked) + label{\n        color: $dark-text;\n    }\n    .filter-set-contents {\n        .filter-content-list{\n            border-color: $dark-border;\n            background-color: #1A1A25;\n            color: $dark-text;\n        }\n    }\n    .dataTables_length label .form-select,\n     #dataTables_length label .form-select{\n        border-color: $dark-border;\n        box-shadow: none;\n        background-color: #1A1A25;\n        color: $dark-text;\n    }\n    .view-icons{\n        border-color: $dark-border;\n    }\n    .toast {\n        background-color: #1A1A25;\n    }\n    .select2-selection--multiple{\n        border-color: $dark-border;\n        background: $dark;\n        box-shadow: none;\n        color: $dark-text;\n    }\n    .twitter-bs-wizard {\n        .twitter-bs-wizard-nav .step-icon{\n            border-color: $white;\n            color: $white;\n        }\n    }\n    .text-dark {\n        color: $dark-text !important;\n    }\n    .select2-container--default {\n        .select2-selection--single{\n            border-color: $dark-border;\n            background: $dark;\n            box-shadow: none;\n            .select2-selection__rendered{\n                box-shadow: none;\n                border:1px solid $dark-border;\n                background: $dark;\n                color: $dark-text;\n            }\n            .select2-selection__arrow{\n                box-shadow: none;\n            }\n        }\n    }\n    .toggle-popup .sidebar-layout, \n    .toggle-popup1 .sidebar-layout, \n    .toggle-popup2 .sidebar-layout{\n        border-color: $dark-border;\n        background: $dark;\n    }\n    .user-accordion-item {\n        .accordion-wrap{\n            color: $dark-text;\n            &:hover {\n                color: $dark-text;\n            }\n        }\n        .content-collapse {\n            border-color: $dark-border;\n        }\n    }\n    .bootstrap-tagsinput{\n        background: $dark;\n        border-color: $dark-border;\n    }\n    .user-accordion-item,\n    .files-wrap,\n    .contact-wrap,\n    .notes-activity .note-download,\n    .contact-tab-wrap,\n    .contact-tab-view,\n    .calls-box,\n    .notes-activity .reply-box ,\n    .note-download\n    {\n        border-color: $dark-border;\n        background: $dark;\n        box-shadow: none;\n    }\n    .contact-sidebar, .contact-tab-view {\n        background-color: $dark-bg;\n        box-shadow: none;\n    }\n    .action-drop{\n        .dropdown-toggle{\n            border-color: $dark-border;\n            color: $dark-text;\n        }\n    }\n    .upcoming-info{\n        border-color: $dark-border;\n    }\n    .calls-box {\n        .caller-info {\n            .calls-user p span {\n                color: $dark-text;\n                font-weight: 500;\n            }\n            .calls-action .dropdown-toggle{\n                color: $dark-text;\n                border-color: $dark-border;\n            }\n        }\n    }\n    .bootstrap-tagsinput{\n        box-shadow: none;\n    }\n    .contact-grid {\n        color: $dark-text;\n        border-color: $dark-border;\n        background: $dark;\n        box-shadow: none;\n        .grid-head {\n            .users-profile {\n                .name-user {\n                    h6 {\n                        a{\n                            color: $white;\n                        }\n                    }\n                }\n            }\n        }\n        .grid-body{\n            .address-info{\n                p{\n                    i{\n                        color: $dark-text; \n                    }\n                }\n            }\n        }\n        .grid-footer{\n            border-color: $dark-border; \n        }\n    }\n    .company-info li span{\n        border-color: $dark-border; \n    }\n    .contacts-action{\n        .btn-icon,.btn-icon.rating{\n            color: $dark-text;\n            border-color: $dark-border;\n            background: $dark;\n        }\n        .act-dropdown > a{\n            color: $dark-text;\n            border-color: $dark-border;\n            background: $dark;\n        }\n    }\n    .social-info li a{\n        color: $dark-text;\n        border-color: $dark-border;\n        background: $dark; \n    }\n    .view-header {\n        .form-sort{\n            .select2-container {\n                .select2-selection {\n                    .select2-selection__rendered{\n                        color: $dark-text; \n                    }\n                }\n            }\n        }\n    }\n    .basic-info li span{\n        color: $dark-text;\n        border-color: $dark-border;\n        background: $dark; \n    }\n    .badge-day{\n        color: $dark-text;\n        background: #3d3d64; \n    }\n    .contact-nav li a {\n        border-color: transparent;\n    }\n    .upcoming-info .dropdown .dropdown-toggle{\n        color: $dark-text;\n    }\n    .contact-sidebar ul,.view-header,.activity-wrap{\n        border-color: $dark-border;\n    }\n    .search-section{\n        border-color: $dark-border;\n    }\n    .select2-container--default .select2-results__option--selected{\n        background: $primary;\n        color: $white;\n    }\n    .form-floating > .form-control:not(:placeholder-shown) ~ label::after{\n        background: transparent;\n    }\n    .select2-dropdown{\n        border-color: $dark-border;\n        background: $dark;\n       \n        ul{\n            li{\n                color: $white;\n            }\n        }\n    }\n    .btn-outline-light{\n        color: $dark-text !important;\n    }\n    .page-wrapper {\n        background: #151525;\n        .page-header{\n            h3{\n                color: $white;\n            }\n            h4{\n                color: $white;\n            }\n            .head-icons a{\n                border-color: $dark-border;\n                background: transparent;\n                color: $white;\n            }\n        }\n        .page-title{\n            color: $white;\n        }\n    }\n    .note-editable.card-block{\n        color: $white;\n    }\n    .accordion-item{\n        border-color: $dark-border;\n        background: $dark;\n        .accordion-body{\n            border-color: $dark-border;\n            background: #28283E;\n        }\n    }\n    .accordion-button{\n        border-color: $dark-border;\n        background: #28283E;\n    }\n    .seprator-lg {\n        border-color: $dark-border;\n    }\n    .card{\n        background: $dark-bg;\n        box-shadow: none;\n        &.bg-white {\n            background: $dark-bg !important;\n        }\n        &.main-card{\n            background: #28283E;\n            box-shadow: none;\n        }\n        &.custom-card{\n            background: #28283E;\n            .card-header{\n                border-color: $dark-border;\n            }\n            .card-footer{\n                border-color: $dark-border;\n            }\n        }\n        .card-header {\n            border-color: $dark-border;\n            .card-title{\n                color: $white;\n            }\n            .card-text{\n                color: $dark-text;\n            }\n        }\n        .card-body{\n            color: $dark-text;\n        }\n    }\n    .col-form-label{\n        color: $dark-text;\n    }\n    .custom-table{\n        .table-responsive{\n            border-color: $dark-border;\n        }\n    }\n    .btn-purple-light{\n        background:$dark;\n        border-color: $dark-border;\n        color: $dark-text;\n        &:hover{\n            background:$dark;\n            border-color: $dark-border;\n            color: $dark-text;\n        }\n    }\n    .note-toolbar{\n        background:$dark;\n    }\n    .note-btn-group .note-btn{\n        background:$dark;\n        border-color: $dark-border;\n        color: $dark-text;\n    }\n    .note-toolbar{\n        border-color: $dark-border;\n    }\n    .table-action {\n        .action-icon{\n            background:$dark;\n            border-color: $dark-border;\n            color: $white;\n            &:hover {\n                    background: $dark-input;\n                    color: $white;\n                    i {\n                        color: $white;\n                    }\n                }\n        }\n    }\n    .toggle-popup {\n        .sidebar-layout .sidebar-header{\n            border-color: $dark;\n        }\n    }\n    table{\n        \n        &.table{\n            &.table-primary{\n                background:$dark;\n            }\n             thead  {\n                border-color: $dark-border;\n                 tr {\n                    border-color: $dark-border;\n                    th{\n                        background: $dark;\n                        color: $white;\n                        border-color: $dark-border;\n                    }\n                }\n            }\n            tbody{\n                tr{\n                    td{\n                        background:$dark;\n                        color: $dark-textcolor;\n                        border-color: $dark-border;\n                    }\n                }\n            }\n            &.dataTable {\n                border-color: $dark-border;\n                > thead  {\n                    border-color: $dark-border;\n                    >  tr {\n                        border-color: $dark-border;\n                        th{\n                            background: $dark;\n                            color: $white;\n                            border-color: $dark-border;\n                        }\n                    }\n                }\n                tbody{\n                    tr{\n                        td{\n                            background:$dark;\n                            color: $dark-textcolor;\n                            border-color: $dark-border;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .statistic-header {\n        h4{\n            i{\n                color:#B5B5B5;\n            }\n            color: $white;\n        }\n        .statistic-dropdown {\n            .dropdown-toggle {\n                color: $white;\n                border: 1px solid #1A1A25;\n                box-shadow: none;\n                background:  #1A1A25;\n                &:after{\n                    border-bottom: 2px solid #B5B5B5;\n                    border-left: 2px solid #B5B5B5;\n                }\n            }\n            .dropdown-menu{\n                border-color: $dark-border;\n                background: $dark;\n                a{\n                    background: transparent;\n                    color: $white;\n                }\n            }\n        }\n    }\n    .toggle-popup .sidebar-layout .sidebar-header, \n    .toggle-popup1 .sidebar-layout .sidebar-header, \n    .toggle-popup2 .sidebar-layout .sidebar-header {\n        border-color:$dark-border;\n    }\n    .form-control,.form-select{\n        border-color:$dark-border;\n        background: $dark;\n        color: $dark-text;\n        box-shadow: none; \n        &:disabled{\n            border-color:$dark-border;\n            background: $dark;\n            color: $dark-text;\n        }\n        &:focus{\n            border-color:$dark-border;\n            background: $dark;\n            color: $dark-text;\n        }\n    }\n    .input-group-text{\n        background:$dark-border;\n        color: $dark-text;\n        border-color:$dark-border;\n    }\n    .radio,.checkbox{\n        label{\n            color: $dark-text;\n        }\n    }\n    .apexcharts-text tspan{\n        fill: $white;\n    }\n    a {\n        color: $white;\n        &.label-add {\n            color: $primary;\n        }\n    }\n    .settings-sub-header {\n        border-color: $dark-border;\n    }\n    .profile-details {\n        border-color: $dark-border;\n    }\n    .profile-upload .profile-upload-img {\n        border-color: $dark-border; \n    }\n    .settings-sidebar {\n        ul {\n            li {\n                a {\n                    color: $dark-textcolor;\n                    &:hover {\n                        color: $white;\n                    }\n                    &.active {\n                        background: $darkmode-hover;    \n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    .btn {\n        &.btn-light {\n            background-color: $dark-input;\n            border-color: $dark-border;\n            color: $white;\n            &:hover {\n                background-color: $dark-hover;\n                border-color: $dark-border;\n                color: $white;\n            }\n            \n        }       \n    }\n    .security-grid {\n        border-color: $dark-border;\n        background: $dark-bg;\n        .security-heading {\n            h5 {\n                color: $white;\n            }\n        }\n    }\n    .notification-wrap {\n        ul {\n            li {\n                .security-checkbox {\n                    .checkboxs {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    .notificaion-table .table {\n         tbody {\n            tr {\n                td { \n                    color: $white;\n                }\n            }\n        }\n    }\n    .integration-grid {\n        background: $gray-bg;\n        border-color: $gray-bg;\n        .integration-content { \n            p {\n                color: $white;\n            }\n        }\n    }\n    .storage-wrap {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .storage-icon {\n            h6 {\n                color: $white;\n            }\n        }\n    }\n    .black-text {\n        color: $white !important;\n    }\n    .theme-type-images {\n        .theme-image {\n            background: $dark;  \n            border-color: $dark-border;\n            span {\n                color: $white;\n            }\n        }\n    }\n    .table tbody tr td a {\n        color: $white;\n    }\n    .text-black {\n        color: $white !important;\n    }\n    .lang-flag {\n        a {\n            border-color: $dark-border;\n            color: $white;\n        }\n    }\n    .modal {\n        .modal-content {\n            background: $dark-bg;\n            border-color: $dark-border;\n            .modal-header {\n                 border-color: $dark-border;\n            }\n            .col-form-label {\n                color: $white;\n            }\n        }\n    }\n    .drag-attach {\n        border-color: $dark-border;\n    }\n    .upload-file {\n        border-color: $dark-border;\n        background: $dark;  \n    }\n    .lang-type li {\n        a {\n            background: $dark;  \n        }\n    }\n    .dropdown-menu {\n        background: $dark-bg;\n        border-color: $dark-border;\n    }\n    .table-action .dropdown-menu {\n        a {\n            color: $dark-textcolor;\n            &:hover {\n                background: $darkmode-hover;\n                color: $white;\n            }\n        }\n    }\n    .btn-add {\n        background: $dark-input;\n        border-color: $dark-border;\n        color: $white;\n    }\n    .settings-sub-header.setting-item {\n        .table-action {\n            .action-icon {\n                background: $dark-input;\n                border-color: $dark-border;\n                &:hover {\n                    background: $dark-input;\n                    color: $white;\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    .mail-wrapper {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .mail-wrap {\n            .email-action .info-icon {\n                &:hover {\n                    color: $white;\n                }\n                &::after {\n                    background: $dark-border;\n                }\n            }\n        }\n        .mail-collapse {\n             border-color: $dark-border;\n         }\n    }\n    .bank-box {\n        background: $gray-bg;\n        border-color: $dark-border;\n        &.active {\n            &::after {\n                background-color: $gray-bg;\n            }\n        }\n        .table-action {\n            .action-icon {\n                &:hover {\n                    background: $dark-input;\n                }\n            }\n        }\n    }\n    .custom-modal {\n        .modal-header {\n            .btn-close {\n                border-color: $dark-border;\n                background: $dark-input;\n                box-shadow: none;\n            }\n        }\n    }\n    .storage-wrap {\n        .storage-icon {\n            .system-app-icon {\n                background: $dark-bg;\n                border-color: $dark-border;\n            }\n        }\n        .setting-gateway {\n            a {\n                color: $dark-textcolor;\n            }\n        }\n    }\n    .ip-wrap {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .table-action {\n            .action-icon {\n                 background: $gray-bg;\n                 border-color: $dark-border;\n                 &:hover {\n                    background: $gray-bg;\n                    border-color: $dark-border;\n                 }\n            }\n        }\n    }\n    .action-drop {\n        .dropdown-item {\n            color: $dark-textcolor;\n            &:hover {\n                background: $gray-bg;\n                color: $white;\n            }\n        }\n    }\n    .notes-activity .note-download {\n        &:hover {\n            background-color: transparent;\n            a {\n                background: $darkmode-hover;\n                color: $dark-textcolor;\n            }\n        }\n        a {\n            background: $darkmode-hover;\n            color: $dark-textcolor;\n        }\n    }\n    .calls-box .caller-info .calls-action .dropdown-menu {\n        border-color: $dark-border;\n        .dropdown-item {\n             &:hover {\n                background: $gray-bg;\n                color: $white;\n            }\n        }\n    }\n    .bootstrap-tagsinput .tag {\n        background: $darkmode-hover;\n    }\n    .contacts-action .act-dropdown .dropdown-item {\n        color: $dark-textcolor;\n         &:hover {\n            background: $gray-bg;\n            color: $white;\n        }\n    }\n    .profile-pic-upload .profile-pic {\n        border-color: $dark-border;\n    }\n    .contact-wrap .contact-profile {\n        .avatar.company-avatar {\n            border-color: $dark-border;\n        }\n\n    }\n    .select2-container--default.select2-container--focus .select2-selection--multiple,\n    .select2-container--default .select2-selection--multiple {\n        border-color: $dark-border;\n    }\n    .select2-container--classic .select2-selection--multiple .select2-selection__choice, \n    .select2-container--default .select2-selection--multiple .select2-selection__choice, \n    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n        background: $darkmode-hover;\n        border-color: $dark-border;\n    }\n    .title-name {\n        color: $white !important;\n    }\n    .kanban-list-items {\n        border-color: $dark-border;\n        .kanban-list-head {\n            background: $gray-bg;\n            .kanban-action-btns .table-action .action-icon {\n                background: $gray-bg;\n                border-color: $dark-border;\n            }\n\n        }\n    }\n    .email-header .btn-white {\n        border-color: $dark-border;\n        color: $white;\n    }\n    .pipeline-list {\n        border-color: $dark-border;\n    }\n    .priority-info .dropdown .dropdown-toggle {\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .priority-info .dropdown a {\n        color: $dark-textcolor;\n    }\n    .pipeline-item {\n        border-color: $dark-border;\n        p {\n            color: $white;\n        }\n    }\n    .kanban-card {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .kanban-card-body ul li {\n            color: $dark-textcolor;\n        }\n        .kanban-card-footer {\n            border-color: $dark-border;\n            span {\n                border-color: $dark-border;\n            }\n        }\n    }\n    .campaign-tab {\n        background: $gray-bg;\n        ul {\n            li {\n                a {\n                    border-color: transparent;\n                    &.active {\n                        color: $primary;\n                    }\n                    span {\n                         border-color: $dark-border;\n                    }\n                }\n            }\n        }\n    }\n    ul.project-mem li.more-set a {\n        background: $gray-bg;\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .pipeline-progress span, .task-info p,\n    .con-sidebar-title p, .task-actions ul li {\n        color: $white;\n    }\n    .contact-grid.project {\n        .grid-head {\n            background-color: $gray-bg;\n            .users-profile .con-avatar {\n                background-color: $dark-bg;\n                border-color: $dark-border;\n            }\n        }\n    }\n    .access-wrap li:hover {\n        background: $gray-bg;\n    }\n    .task-wrap {\n        background: $gray-bg;\n        border-color: $dark-border;\n    }\n    .rate-icon, .con-sidebar-title.border-line {\n        border-color: $dark-border;\n    }\n    .pipeline-list ul li a.bg-gray {\n        color: $title-color;\n    }\n    .task-wrapper .task-accordion span {\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .task-drops .dropdown-toggle {\n        background-color: transparent;\n    }\n    .task-wrapper {\n        border-color: $dark-border;\n    }\n    .card.analytics-card {\n        background-color: $dark-bg;\n        .card-header {\n            background: transparent;\n            .select2-container--default .select2-selection--single {\n                .select2-selection__rendered {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .activities-list ul li {\n        background: $gray-bg;\n        .activity-name h5 {\n            color: $white;\n        }\n    }\n    .campaign-card ul .campaign-wrap {\n        background: $gray-bg;\n        .campaign-info {\n            border-color: $dark-border;\n            h5 {\n                color: $white;\n            } \n        }\n    }\n    .card.analytics-card .card-body .table {\n        th {\n            background: $dark;\n            color: $white;\n            &:first-child,&:last-child {\n                border-color: $dark-border;\n            }\n        }\n        td {\n            &:first-child, &:last-child  {\n                border-color: $dark-border;\n            }\n        }\n    }\n    .active-list ul li {\n        a {\n            background: $dark-input;\n            border-color: $dark-border;\n            color: $white;\n        }\n    }\n    .activity-title h4::after {\n        background: $dark-border;\n    }\n    .header-set {\n        border-color: $dark-border;\n        .select2-container--default .select2-selection--single .select2-selection__rendered {\n            color: $white;\n        }\n    }\n    .radio-activity li .active-type input[type=radio] ~ label {\n        background: $dark-input;\n        border-color: $dark-border;\n        color: $white;\n    }\n    .tab-activity {\n        box-shadow: none;\n        ul li a span {\n            color: $dark-textcolor;\n            border-color: $dark-border;\n        }\n    }\n    .report-header {\n        border-color: $dark-border;\n    }\n    .location-flag-img {\n        border-color: $dark-border;        \n    }\n    .table-imgname.flag-image {\n        span {\n            color: $white;\n        }\n    }\n    .membership-plans .plan-selected h4 {\n        color: $white;\n    }\n    .membership-plan-grid {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        .plan-price-head {\n            border-color: $dark-border;\n            .plan-type {\n                color: $white;\n            }\n        }\n        .plans-features ul li {\n            color: $white;\n        }\n        &.active {\n            background-color: $dark-bg;\n            .plan-price-head {\n                border-color: $dark-border;\n                .plan-type {\n                    color: $white;\n                }\n            }\n            .plans-features ul li {\n                color: $white;\n            }\n        }\n    }\n    .file-manager aside {\n        border-color: $dark-border;\n    }\n    .notes-dash {\n        background-color: $gray-bg;\n        .notes-top-head {\n            border-color: $dark-border;\n        }\n        .notes-top-head-submenu {\n            border-color: $dark-border;\n        }\n    }\n    .notes-page-wrapper .content .section-card-body .notes-card-details {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        box-shadow: none;\n    }\n    .search-set .search-input input[type=search] {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        &::placeholder {\n            color: $dark-textcolor;\n        }\n    }\n    .todo-wrapper-list {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n    }\n    .notes-page-wrapper .content {\n        .section-bulk-wrap {\n            background-color: $gray-bg;\n            box-shadow: none;\n        }\n        .page-add-notes {\n            border-color: $dark-border;\n        }\n        .section-notes-slider {\n            border-color: $dark-border;\n        }\n    }\n    .fc-day {\n        background-color: $gray-bg;\n    }\n    .file-manager .folders {\n        border-color: $dark-border;\n        background-color: $gray-bg;\n    }\n    .file-manager .accordion .accordion-item .accordion-body {\n        background: transparent;\n    }\n    table tbody td.action-table-data a {\n        background-color: $gray-bg;\n    }\n    .main-chat-blk .chat {\n        background-color: $gray-bg;\n    }\n    .main-chat-blk .chat .chat-header {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        box-shadow: none;\n    }\n    .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {\n        background-color: $gray-bg;\n    }\n    .main-chat-blk .chat-page-wrapper .left-chat-title {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n    }\n    .main-chat-blk .chat .chat-header .user-details h5 {\n        color: $white;\n    }\n    .main-chat-blk .sidebar .user-list li .users-list-body {\n        h5 {\n            color: $white;\n        }\n        p {\n            color: $dark-textcolor;\n        }\n    }\n    .main-chat-blk .chat-page-wrapper .setting-title-head h4 {\n        color: $white;\n    }\n    .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {\n        color: $dark-textcolor !important;\n    }\n    .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {\n        color: $white;\n    }\n    .main-chat-blk .sidebar .user-list li a {\n        border-color: $dark-border;\n    }\n    .main-chat-blk .last-seen {\n         color: $dark-textcolor;\n    }\n    .daterangepicker {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        &.show-ranges.ltr .drp-calendar.left {\n            border-color: $dark-border;\n        }\n        .drp-buttons {\n            border-color: $dark-border;\n            .btn-default {\n                color: $dark-textcolor;\n            }\n        }\n    } \n}",".sidebar-contact {\n    position: fixed;\n    top: 0%;\n    right: -350px;\n     transform: translateY(-50%); \n    width: 350px;\n    height: auto;\n    background: $white;\n    box-sizing: border-box;\n    transition: 0.5s;\n    z-index: 9999;\n    .toggle-theme {\n        position: absolute;\n        width: 35px;\n        text-align: center;\n        cursor: pointer;\n        background: $primary;\n        top: 225px;\n        right: 350px;\n        padding: 6px;\n        height: 35px;\n        color: $white;\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n        .fa-spin {\n            -webkit-animation: fa-spin 2s infinite linear;\n            animation: fa-spin 2s infinite linear;\n        }\n    }\n    \n}  \n#theme-settings{\n    width: 26px;\n    height: 26px;\n    border: 1px solid $gray-200;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n} \n.input-themeselect label {\n    width: 100%;\n}      \n                                                        \n.sidebar-themesettings{\n    transition: all 0.5s;\n    width: 400px !important;\n    height: 100vh;\n    z-index: 99999;\n    overflow: auto;\n    max-width: 100%;\n    &.open{\n        right: 0; \n    }\n    .offcanvas-header{\n        border-bottom: 1px solid $gray-200;\n        position: relative;\n    }\n    .themesettings-inner{\n        .themesettings-content{\n            border-bottom: 1px solid $gray-200;\n            margin-bottom: 15px;\n            h6{\n                font-size: 14px;\n                font-weight: 600;\n                color: #000; \n                margin-bottom: 15px;\n            }\n        }\n    }\n    .input-themeselect{\n        background: $light-500;\n        padding: 10px;\n        border-radius: 10px;\n        border:1px solid $gray-200;\n        margin-bottom: 15px;\n        input[type=\"radio\"]{\n            display: none;\n            &:checked{\n                ~ label{\n                    .checkboxs-theme{\n                        &:after{\n                            background-color: $purple;\n                            border-color: $purple;\n                            content: \"\";\n                        }\n                        &::before{\n                            content: \"\\f00c\";\n                            font-family: \"Font Awesome 5 Free\";\n                            color: #fff;\n                            font-weight: 700;\n                            font-size: 10px;\n                            right: 4px;\n                            position: absolute;\n                            top: -14px;\n                            z-index: 9;\n                        }\n                    } \n                }\n            }\n        }\n        img{\n            height: 80px;\n        }\n        .checkboxs-theme{\n            position: relative;\n            width: 100%;\n            display: block;\n            &:after{\n                position: absolute;\n                content: \"\";\n                border: 1px solid #E8E8E8;\n                width: 16px;\n                height: 16px;\n                border-radius: 5px;\n                right: 0;\n                top: -17px;\n            }\n        }\n    }\n}\n.sidebar-themeoverlay{\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0,0,0,0.75);\n    top: 0;\n    left: -100%;\n    z-index: 10000;\n    &.open{\n        left: 0;\n    }\n}\n.sidebar-themesettings.offcanvas.offcanvas-end{\n    width: 400px !important;\n} \n.theme-colorsset{\n    label{\n        width: 34px;\n        height: 34px;\n        border-radius: 50%;\n        position: relative;\n        border: 1px solid $gray-200;\n        position: relative;\n        &::before {\n            width: 24px;\n            height: 24px;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            content: \"\";\n            transform: translate(-50%, -50%);\n            border-radius: 50%;\n        }\n        &.primary-clr{\n            &::before {\n                background: $primary;\n            }\n        }\n        &.brightblue-clr{\n            &::before {\n                background: $brightblue;\n            }\n        }\n        &.lunargreen-clr{\n            &::before {\n                background: $lunargreen;\n            }\n        }\n        &.lavendar-clr{\n            &::before {\n                background: $lavendar;\n            }\n        }\n        &.magenta-clr{\n            &::before {\n                background: $magenta;\n            }\n        }\n        &.chromeyellow-clr{\n            &::before {\n                background: $chromeyellow;\n            }\n        }\n        &.lavared-clr{\n            &::before {\n                background: $lavared;\n            }\n        }\n    }\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{\n                border-color: $primary;\n                &:after{\n                    content: \"\\f00c\";\n                    font-family: \"Font Awesome 5 Free\";\n                    color: $primary;\n                    font-weight: 700;\n                    font-size: $font-size-8;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%,-50%);\n                    position: absolute;\n                    width: 12px;\n                    height: 12px;\n                    background: $white;\n                    border: 1px solid $gray-200;\n                    @include rounded(4px);\n                }\n            }\n        }\n    }\n    .pickr-container-primary {\n        width: 34px;\n        height: 34px;\n        border-radius: 50%;\n        border: 1px solid $gray-200;\n        padding: 4px;\n        .pickr {\n            .pcr-button {\n                width: 24px;\n                height: 24px;\n                &::after {\n                    font-size: 1rem;\n                }\n            }\n        }\n    }\n}\n.theme-colorselect {\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{\n                outline-color: $primary;\n                &:after{\n                    content: \"\\f00c\";\n                    font-family: \"Font Awesome 5 Free\";\n                    color: $primary;\n                    font-weight: 700;\n                    font-size: $font-size-8;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%,-50%);\n                    position: absolute;\n                    width: 12px;\n                    height: 12px;\n                    background: $white;\n                    border: 1px solid $gray-200;\n                    @include rounded(4px);\n                }\n                &.primary-topbar,   &.dark-topbar {\n                    &:after{\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    label {\n        width: 28px;\n        height: 45px;\n        border-radius: 5px;\n        position: relative;\n        outline-offset: 3px;\n        outline: 1px solid $gray-200;\n        &.white-topbar {\n            background: $white;\n            border: 1px solid $light;\n        }\n        &.darkaqua-topbar {\n            background: $darkaqua;\n        }\n        &.whiterock-topbar {\n            background: $whiterock;\n        }\n        &.rockblue-topbar {\n            background: $rockblue;\n        }\n        &.bluehaze-topbar {\n            background: $bluehaze;\n        }\n        &.primary-topbar {\n            background: $primary;\n        }\n        &.blackpearl-topbar {\n            background: $blackpearl;\n        }\n        &.maroon-topbar {\n            background: $maroon;\n        }\n        &.bluegem-topbar {\n            background: $bluegem;\n        }\n        &.firefly-topbar {\n            background: $firefly;\n        }\n        &.orange-gradient-topbar {\n            background: $orange-gradient;\n        }\n        &.purple-gradient-topbar {\n            background: $gradient-purple;\n        }\n        &.blue-gradient-topbar {\n            background: $blue-gradient;\n        }\n        &.maroon-gradient-topbar {\n            background: $maroon-gradient;\n        }\n    }\n    .pickr-container-background, .pickr-topbar, .pickr-topbarcolor {\n        width: 28px;\n        height: 45px;\n        border-radius: 5px;\n        outline-offset: 3px;\n        outline: 1px solid $gray-200;\n        .pickr {\n            .pcr-button {\n                width: 28px;\n                height: 45px;\n                border-radius: 5px;\n                &::after {\n                    font-size: 1rem;\n                    line-height: 2.5;\n                }\n            }\n        }\n    }\n}\n.theme-layout {\n    &.active {\n        img {\n            border: 1px solid $primary;\n            @include rounded(5px);\n        }\n    }\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{\n                .layout-img {\n                    img {\n                        border-color: $primary;\n                    }\n                }\n                .layout-type {\n                    position: relative;\n                    padding-left: 16px;\n                    &:after{\n                        content: \"\\f00c\";\n                        font-family: \"Fontawesome\";\n                        color: $primary;\n                        font-weight: 700;\n                        font-size: $font-size-8;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        left: 0;\n                        top: 2px;\n                        position: absolute;\n                        width: 12px;\n                        height: 12px;\n                        background: $white;\n                        border: 1px solid $gray-200;\n                        @include rounded(4px);\n                    }\n                }\n            }\n        }\n    }\n    label {\n        .layout-img {\n            img {\n                border: 1px solid $gray-200;\n                @include rounded(5px);\n            }\n        }\n        .layout-type { \n            color: $gray-900;\n        }\n        &:after {\n            display: none;\n        }\n    }\n    .layout-img {\n        img {\n            border: 1px solid $gray-200;\n            @include rounded(5px);\n        }\n    }\n}\n.theme-mode {\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{\n                border-color: $primary;\n                .avatar {\n                    color: $warning;\n                    background-color: $warning-transparent;\n                }\n            }\n        }\n    }\n    label {\n        border: 1px solid $gray-200;\n        color: $gray-700;\n        .avatar {\n            background-color: $dark-transparent;\n            color: $dark;\n        }\n    }\n}\n.theme-sidebarbg {\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{\n                &:after{\n                    content: \"\\f00c\";\n                    font-family: \"Font Awesome 5 Free\";\n                    color: $primary;\n                    font-weight: 700;\n                    font-size: $font-size-8;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%,-50%);\n                    position: absolute;\n                    width: 12px;\n                    height: 12px;\n                    background: $white;\n                    border: 1px solid $gray-200;\n                    @include rounded(4px);\n                }   \n                img {        \n                    box-shadow: $box-shadow-sm;\n                }     \n            }\n        }\n    }\n    label { \n        width: 48px;\n        height: 55px;     \n        position: relative; \n        img { \n            width: 48px;\n            height: 55px;\n            object-fit: cover;\n            border: 1px solid $gray-200;\n        }\n    }\n}\n\n.theme-topbarbg {\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{\n                &:after{\n                    content: \"\\f00c\";\n                    font-family: \"Font Awesome 5 Free\";\n                    color: $primary;\n                    font-weight: 700;\n                    font-size: $font-size-8;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%,-50%);\n                    position: absolute;\n                    width: 12px;\n                    height: 12px;\n                    background: $white;\n                    border: 1px solid $gray-200;\n                    @include rounded(4px);\n                }   \n                img {        \n                    box-shadow: $box-shadow-sm;\n                }     \n            }\n        }\n    }\n    label { \n        height: 50px;     \n        position: relative; \n        img { \n            width: 100px;\n            height: 50px;\n            object-fit: cover;\n            @include rounded(10px);\n        }\n    }\n}\n.theme-width {\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{\n                border-color: $primary;\n                &::before {\n                    border-color: $primary;\n                }\n                &::after {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n    label {\n        border: 1px solid $gray-200;\n        padding: 10px 10px 10px 32px;\n        position: relative;\n        color: $gray-700;\n        min-width: 120px;\n        &::before {\n            content: \"\";\n            width: 16px;\n            height: 16px;\n            @include rounded(50%);\n            border: 1px solid $gray-200;\n            background: $white;\n            position: absolute;\n            top: 50%;\n            left: 10px;\n            transform: translateY(-50%);\n        }\n        &::after {\n            content: \"\";\n            width: 6px;\n            height: 6px;\n            @include rounded(50%);\n            background: $primary;\n            position: absolute;\n            top: 50%;\n            left: 18px;\n            transform: translate(-50%, -50%);\n            opacity: 0;\n        }\n    }\n}\n.theme-sidebarcolor {\n    input[type=\"radio\"]{\n        display: none;\n        &:checked{\n            ~ label{                \n                border-color: $primary !important;\n                position: relative;\n                &:after{\n                    content: \"\\f058\";\n                    font-family: \"Fontawesome\";\n                    color: $primary;\n                    font-weight: 700;\n                    font-size: 12px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%,-50%);\n                    position: absolute;\n                }\n                &.bg-dark {\n                    &:after{\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    label {        \n        width: 29px;\n        height: 46px;\n        border: 1px solid $gray-200;\n    }\n}\n.theme-container-primary,\n.theme-container-background,\n.theme-topbar, .theme-topbarcolor {\n    button {\n        display: none;\n    }\n}\n.pcr-app {\n    z-index: 99999;\n}\n.pickr-container-primary,\n.pickr-container-background,\n.pickr-topbar, .pickr-topbarcolor {    \n    .pickr {\n        .pcr-button {\n            width: 2rem;\n            height: 2rem;\n            overflow: hidden;\n            border-radius: 50%;\n            &:focus {\n                box-shadow: none;\n            }\n            &::after {\n                content: \"\\eb01\";\n                font-family: \"tabler-icons\" !important;\n                color: rgba(255, 255, 255, 0.7);\n                line-height: 1.5;\n                font-size: 1.25rem;\n            }\n        }\n    } \n}\n.custom-btn-close {\n    width: 20px;\n    height: 20px;\n    @include rounded(50%);\n    background-color: $gray-500;\n    color: $white;\n    margin: 0;\n    padding: 0;\n    background-image: none;\n    &:hover {\n        background-color: $danger;\n    }\n}\n[data-color=all] {\n    .theme-colorsset {\n        .pickr-container-primary {\n            border-color: $primary;\n        }\n    }\n}\n[data-topbarcolor=all] {\n    .theme-colorselect {\n        .pickr-topbarcolor {\n            outline-color: $primary;\n        }\n    }\n}\n[data-topbar=all] {\n    .theme-colorselect {\n        .pickr-topbar {\n            outline-color: $primary;\n        }\n    }\n}\n[data-sidebar=all] {\n    .theme-colorselect {\n        .pickr-container-background {\n            outline-color: $primary;\n        }\n    }\n}\n",".topnav-dropdown-header {\n    @include margin-padding(null, 15px);\n    border-bottom: 1px solid $light-900;\n    .notification-title {\n        font-size: $font-size-18;\n        font-weight: $font-weight-semibold;\n        color: $black;\n        margin-bottom: 0;\n    }\n}\n.notification-dropdown {\n    .noti-content {\n        width: 440px;\n        height: 390px;\n        overflow-y: auto;\n        position: relative;\n    }\n    .notification-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        li {\n            margin-top: 0;\n            border-bottom: 1px solid $light-600;\n            font-size: $font-size-base;\n            &:last-child {\n                border-bottom: 0;\n            }\n            a {\n                display: block;\n                @include margin-padding(null, 15px);\n            }\n            .avatar {\n                width: 36px;\n                height: 36px;\n                margin: 0 16px 0 0;\n                border-radius: $border-radius-lg;\n                position: relative;\n                img {\n                    border-radius: $border-radius-lg;\n                }\n                .badge {\n                    display: inline-block;\n                    position: absolute;\n                    top: -7px;\n                    left: -7px;\n                    padding: 4px;\n                }\n            }\n            .noti-title {\n                color: $gray-800;\n                font-weight: $font-weight-medium;\n            }\n            .noti-details {\n                font-weight: $font-weight-medium;\n                color: $gray-400;\n                @include margin-padding(0 0 8px, null);\n            }\n            .noti-sub-details {\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                display: -webkit-box;\n                color: $gray-400;\n                position: relative;\n                @include margin-padding(0 0 8px, 0 0 0 15px);\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    left: 0;\n                    width: 4px;\n                    height: -webkit-fill-available;\n                    background: $gray-400;\n                    border-radius: $border-radius-lg;\n                } \n            }\n            p.noti-time {\n                font-size: $font-size-12;\n                color: $gray-900;\n                @include margin-padding(0, null);\n            }\n            .noti-pdf {\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n                border: 1px solid $light-900;\n                border-radius: $border-radius-lg;\n                padding: 10px;\n                margin-bottom: 8px;\n                .noti-pdf-icon {\n                    margin-right: 10px;\n                    span {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                        color: $primary;\n                        width: 24px;\n                        min-width: 24px;\n                        height: 24px;\n                        border: 1px solid $light-900;\n                        border-radius: $border-radius-lg;\n                    }\n                }\n                .noti-pdf-text {\n                    line-height: normal;\n                    p {\n                        font-size: $font-size-12;\n                        color: $gray-900;\n                        margin-bottom: 0;\n                    }\n                    span {\n                        font-size: $font-size-12;\n                        color: $text-color;\n                    }\n                }\n            }\n            .notification-time {\n                font-size: $font-size-12;\n                line-height: 1.35;\n                color: $gray-600;\n            }\n            .list-item {\n                border: 0;\n                padding: 0;\n                position: relative;\n                .list-left {\n                    height: 48px;\n                    position: absolute;\n                    width: 48px;\n                }\n                .list-body {\n                    @include margin-padding(null, 0 0 0 50px);\n                    .message-author {\n                        color: $gray-800;\n                        float: left;\n                        font-weight: $font-weight-medium;\n                        width: 175px;\n                        display: block;\n                        max-width: 100%;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        white-space: nowrap;\n                    }\n                    .message-time {\n                        color: $gray-600;\n                        float: right;\n                        font-size: $font-size-11;\n                    }\n                    .message-content {\n                        color: $gray-800;\n                        font-size: $font-size-13;\n                        display: block;\n                        max-width: 100%;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        white-space: nowrap;\n                    }\n                }\n            }\n        }\n    }\n}\n.topnav-dropdown-footer {\n    background: $light-200;\n    text-align: right;\n    @include margin-padding(null, 15px);\n    a {\n        font-weight: $font-weight-semibold;\n        margin-right: 15px;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n    .view-link {\n        color: $gray-900;\n        &:hover {\n            color: $gray-400;\n        }\n    }\n    .clear-link {\n        color: $primary;\n        &:hover {\n            color: darken($primary, 10%);\n        }\n    }\n}\n.list-left {\n    height: 48px;\n    position: absolute;\n    width: 48px;\n}\n.list-body {\n    @include margin-padding(null, 0 0 0 50px);\n    .message-author {\n        color: $gray-800;\n        float: left;\n        font-weight: $font-weight-medium;\n        width: 175px;\n        display: block;\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .message-time {\n        color: $gray-600;\n        float: right;\n        font-size: $font-size-11;\n    }\n    .message-content {\n        color: $gray-800;\n        font-size: $font-size-13;\n        display: block;\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n}\n.activity {\n    width: 100%;\n    .activity-box {\n        position: relative;\n    }\n    .activity-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        position: relative;\n        li {\n            background-color: $white;\n            position: relative;\n            border: 1px solid $gray-400;\n            @include margin-padding(0  0 10px,  20px 10px 10px);\n            font-size: $font-size-15;\n            .activity-user {\n                height: 50px;\n                margin: 0;\n                padding: 0;\n                width: 50px;\n                @include position(absolute,12px,null,null,8px);\n            }\n            .activity-content {\n                background-color: $white;\n                position: relative;\n                @include margin-padding(0 0 0 60px, 0);\n            }\n            .time {\n                color: $gray-500;\n                display: block;\n                font-size: $font-size-12;\n                line-height: 1.35;\n            }\n            a.name {\n                color: $black;;\n            }\n            a {\n                color: $secondary;\n                font-weight: $font-weight-semibold;\n                font-size: $font-size-15;\n                img{\n                    width:50px;\n                    height:50px;\n                    border-radius: 5px;\n                }\n            }\n        }\n    }\n}\n",".avatar {\n    position: relative;\n    height: 2.625rem;\n    width: 2.625rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: $border-radius;\n    color: $white;\n    font-weight: $font-weight-medium;\n    a.badge:hover {\n        color: $white;\n    }\n    img {\n        width: 100%;\n        height: 100%;\n        border-radius: $border-radius;\n    }\n    &.avatar-rounded {\n        border-radius: 50%;\n        img {\n            border-radius: 50%;\n        }\n    }\n    &.avatar-radius-0 {\n        border-radius: 0;\n        img {\n            border-radius: 0;\n        }\n    }\n    .avatar-badge {\n        position: absolute;\n        inset-block-start: -4%;\n        inset-inline-end: -0.375rem;\n        width: 1.4rem;\n        height: 1.4rem;\n        font-size: 0.625rem;\n        border: 2px solid $white;\n        border-radius: 50% !important;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    &.online,&.offline {\n        &:before {\n            position: absolute;\n            content: \"\";\n            width: 0.5rem;\n            height: 0.5rem;\n            border-radius: 50%;\n            inset-inline-end: 0;\n            inset-block-end: 0;\n            border: 2px solid $white !important;\n            z-index: 1;\n        }\n    }\n    &.online:before {\n        background-color: $success;\n    }\n    &.offline:before {\n        background-color: $gray-500;\n    }\n    &.avatar-xs {\n        width: 1.25rem;\n        height: 1.25rem;\n        line-height: 1.25rem;\n        font-size: 0.65rem;\n        .avatar-badge {\n            padding: 0.25rem;\n            width:  1rem;\n            height: 1rem;\n            line-height: 1rem;\n            font-size: 0.5rem;\n            inset-block-start: -25%;\n            inset-inline-end: -0.5rem;\n        }\n    }\n    &.avatar-sm {\n        width: 2rem;\n        height: 2rem;\n        line-height: 2rem;\n        font-size: 0.65rem;\n        .avatar-badge {\n            padding: 0.3rem;\n            width:  1.1rem;\n            height: 1.1rem;\n            line-height: 1.1rem;\n            font-size: 0.5rem;\n            inset-block-start: -28%;\n            inset-inline-end: -0.45rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.5rem;\n                height: 0.5rem;\n            }\n        }    \n    }\n    &.avatar-md {\n        width: 2.5rem;\n        height: 2.5rem;\n        line-height: 2.5rem;\n        font-size: 0.8rem;\n        .avatar-badge {\n            padding: 0.4rem;\n            width:  1.2rem;\n            height: 1.2rem;\n            line-height: 1.2rem;\n            font-size: 0.65rem;\n            inset-block-start: -6%;\n            inset-inline-end: -13%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.75rem;\n                height: 0.75rem;\n            }\n        }    \n        svg {\n            width: 1.5rem;\n            height: 1.5rem;\n        }\n    }\n    &.avatar-lg {\n        width: 3rem;\n        height: 3rem;\n        line-height: 3rem;\n        font-size: 1rem;\n        .avatar-badge {\n            inset-block-start: -15%;\n            inset-inline-end: -0.25%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.8rem;\n                height: 0.8rem;\n            }\n        }    \n        svg {\n            width: 1.8rem;\n            height: 1.8rem;\n        }\n    }\n    &.avatar-xl {\n        width: 4rem;\n        height: 4rem;\n        line-height: 4rem;\n        font-size: 1.25rem;\n        .avatar-badge {\n            inset-block-start: -8%;\n            inset-inline-end: -0.2%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.95rem;\n                height: 0.95rem;\n            }\n        }    \n    }\n    &.avatar-xxl {\n        width: 5rem;\n        height: 5rem;\n        line-height: 5rem;\n        font-size: 1.5rem;\n        .avatar-badge {\n            inset-block-start: -4%;\n            inset-inline-end: 0rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 1.05rem;\n                height: 1.05rem;\n                inset-block-end: 0.25rem;\n            }\n            &.online-sm {\n                &:before {\n                    width: 10px;\n                    height: 10px;\n                    inset-block-end: 0rem;\n                }\n            }\n        }    \n    }\n    &.avatar-xxxl {\n        width: 6rem;\n        height: 6rem;\n        line-height: 6rem;\n        font-size: 1.75rem;\n        .avatar-badge {\n            inset-block-start: -4%;\n            inset-inline-end: 0rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 1.05rem;\n                height: 1.05rem;\n                inset-block-end: 0.25rem;\n            }\n        }    \n    }\n}\n.avatar-list-stacked {\n    padding: 0;\n    &.avatar-group-overlapped {\n        .avatar {\n            margin-right: -.875rem;\n            &:hover{\n                z-index:1;\n            }\n        }\n    }\t\n    &.avatar-group-lg {\n        .avatar { \n            width: 3.25rem;\n            height: 3.25rem;\n            >.initial-wrap {\n                font-size: .95rem;\n            }\n        }\n        &.avatar-group-overlapped .avatar {\n            margin-right: -1rem;\n        }\t\n    }\n    &.avatar-group-sm {\n        .avatar { \n            width: 2rem;\n            height: 2rem;\n            >.initial-wrap {\n                font-size: .6rem;\n            }\n        }\n        &.avatar-group-overlapped .avatar {\n            margin-right: -0.625rem;\n        }\t\n    }\n    &.avatar-group-xs {\n        .avatar {\n            width: 1.50rem;\n            height: 1.50rem;\n            >.initial-wrap {\n                font-size: .6rem;\n            }\n        }\n    }\n    .avatar {\n        margin-inline-end: -0.875rem !important;\n        border: 1px solid rgba(0,0,0,0.05);\n        vertical-align: middle;\n        transition: transform ease 200ms;\n        &:last-child {\n            margin-inline-end: 0 !important;\n        }\n        &:hover {\n            z-index: 1;\n            transform: translateY(-0.188rem);\n        }\n    }\n}\n.avatar-group {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t.avatar { \n\t\twidth: 2.625rem;\n\t\theight: 2.625rem;\n\t\t.avatar-img,\n\t\t>.initial-wrap {\n\t\t\tborder:2px solid $white;\n\t\t\tfont-size: .9rem;\n\t\t}\n\t}\n\t&.avatar-group-overlapped {\n\t\t.avatar {\n\t\t\tmargin-right: -.875rem;\n\t\t\t&:hover{\n\t\t\t\tz-index:1;\n\t\t\t}\n\t\t}\n\t}\t\n\t&.avatar-group-lg {\n\t\t.avatar { \n\t\t\twidth: 3.25rem;\n\t\t\theight: 3.25rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .95rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -1rem;\n\t\t}\t\n\t}\n\t&.avatar-group-sm {\n\t\t.avatar { \n\t\t\twidth: 2rem;\n\t\t\theight: 2rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .6rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -0.625rem;\n\t\t}\t\n\t}\n}\n.avatar-xxs {\n    width: 16px;\n    height: 16px;\n}",".bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n\tbackground-color: $warning;\n\ttext-shadow: unset;\n}\n.bootstrap-datetimepicker-widget table td.today:before {\n\tborder-bottom-color: $warning;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\n    background: transparent;\n}\n.bor-b1{\n    border-bottom: 1px solid $gray-300;\n}\n\n.link-purple {\n\tcolor: $purple;\n\t&:hover {\n\t  color: darken($purple, 2);\n\t}\n}\nhr {\n\tborder-color: $light-900;\n}",".btn-primary {\n    color: $white;\n    background-color: $primary;\n    border-color: $primary;\n    font-size: $font-size-14;\n    font-size: $font-size-14;\n}\n.btn-save {\n    background: $primary;\n    color: $white;\n    font-size: $font-size-14;\n    font-size: $font-size-14;\n    border-radius: 5px;\n    @include margin-padding(null, 8px 20px);\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n        padding: 5px 7px;\n    }\n}\n.btn-reset {\n    background: $text-color;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include margin-padding(null, 8px 20px);\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $secondary;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n        padding: 5px 7px;\n    }\n}\n.btn-send {\n    background: $primary;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    .send-mail {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }\n}\n.btn-download {\n    background: $secondary;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $gray-900;\n        color: $white;\n     }\n    .download {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }    \n}\n.btn-barcode {\n    background: $danger;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $danger;\n        color: $white;\n     }\n    .print {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }\n    \n}\n.btn-primary.add-em-payroll {\n    padding: 9px 11px;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    border-radius: 8px;\n    .me-2 {\n        width: 16px;\n        height: 16px;\n    }\n}\n.swal2-actions .swal2-confirm.btn:active {\n    background-color: $primary;\n    border-color: $primary;\n}\n.btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {\n    background-color: $primary;\n    border-color: $primary;\n    color: $white;\n}\n.modal {\n    .card {\n        border: 0;\n    }\n}\n.search-input {\n    .btn-searchset {\n        &:active {\n            background-color: transparent;\n            border-color: transparent;\n            svg {\n                color: $secondary;\n            }\n        }\n    }\n}\n.input-blocks {\n    input[type=text] {\n        &.datetimepicker {\n            padding-left: 35px;\n        }\n    }\n}\n.iti__country-list {\n    z-index: 101;\n}\nbutton {\n    cursor: pointer;\n    &:focus{\n        outline: 0;\n        box-shadow: none;\n    }\n}\n.btn {\n    border-radius: $border-radius-lg;\n    padding: 0.625rem 1.25rem;\n    padding: 0.5rem 0.85rem;\n    font-size: 0.85rem;\n    transition: all 0.5s;\n    font-weight: $font-weight-semibold;\n    &:focus {\n        box-shadow: none !important;\n    }\n    &:hover {\n        transition: all 0.5s;\n    }\n    &.btn-lg {\n        padding: 0.65rem 1rem;\n        font-size: 0.95rem;\n    }\n    &.btn-sm {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.75rem;\n    }\n    @each $color,\n    $value in $theme-colors {\n        &.btn-#{$color} {\n            background-color: #{$value};\n            border: 1px solid #{$value};\n            color: $white;\n            &:hover,\n            &:focus,\n            &.focus,\n            &:active,\n            &.active {\n                background-color: #{darken($value, 7%)};\n                border:1px solid #{darken($value, 7%)};\n                color: $white;\n            }\n        }\n    }\n    &.btn-light {\n        background-color: $light-400;\n        border: 1px solid $light-900;\n        color: $gray-900;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($light-400, 3%);\n            border: 1px solid $light-900;\n            color: $gray-900;\n        }\n    }\n}\n\n.btn-group {\n    .btn {\n      padding: 0.45rem 0.75rem;\n    }\n  }\n  .btn-group-lg {\n    .btn {\n      padding: 0.65rem 1rem;\n    }\n  }\n  .btn-group-sm {\n    .btn {\n      padding: 0.25rem 0.5rem;\n    }\n  }\n.btn {\n    &.btn-w-xs {\n      min-width: 5.625rem;\n    }\n    &.btn-w-sm {\n      min-width: 6.975rem;\n    }\n    &.btn-w-md {\n      min-width: 8.125rem;\n    }\n    &.btn-w-lg {\n      min-width: 9.375rem;\n    }\n  }\n  .btn-icon {\n    i {\n      padding: 0rem;\n      margin: -0.5rem;\n    }\n    &.btn-sm {\n      width: 1.75rem;\n      height: 1.75rem;\n      font-size: 0.8rem;\n    }\n    &.btn-lg {\n      width: 2.75rem;\n      height: 2.75rem;\n      font-size: 1.2rem;\n    }\n  }\n  .btn-list {\n    > button, > a {\n      margin: 0 0.375rem 0.375rem 0;\n    }\n  }\n  [dir=\"rtl\"] {\n    .btn-list {\n      button,\n      div,\n      a,\n      input {\n        margin: 0 0 0.375rem 0.375rem;\n      }\n    }\n  }\n  \n  .btn-list {\n    margin-block-end: -0.5rem;\n  }\n  .btn-square {\n    border-radius: 0;\n}\n.btn-group-pill .btn:first-child {\n    border-radius: 60px 0 0 60px;\n  }\n  .btn-group-pill .btn:last-child {\n    border-radius: 0 60px 60px 0;\n  }\n  \n  .btn-group-square .btn:first-child {\n    border-radius: 0px 0 0 0px;\n  }\n  .btn-group-square .btn:last-child {\n    border-radius: 0 0px 0px 0;\n  }\n.btn {\n  &.btn-primary-light {\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $primary;\n      color: $white;\n      border-color: $primary;\n    }\n  }\n \n  &.btn-secondary-light {\n    background-color: rgba($secondary, 0.1);\n    color: $secondary;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $secondary;\n      color: $white;\n      border-color: $secondary;\n    }\n  }\n  &.btn-warning-light {\n    background-color: rgba($warning, 0.1);\n    color: $warning;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $warning;\n      color: $white;\n      border-color: $warning;\n    }\n  }\n  &.btn-info-light {\n    background-color: rgba($info, 0.1);\n    color: $info;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $info;\n      color: $white;\n      border-color: $info;\n    }\n  }\n  &.btn-success-light {\n    background-color: rgba($success, 0.1);\n    color: $success;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $success;\n      color: $white;\n      border-color: $success;\n    }\n  }\n  &.btn-danger-light {\n    background-color: rgba($danger, 0.1);\n    color: $danger;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $danger;\n      color: $white;\n      border-color: $danger;\n    }\n  }\n}\n.btn {\n  &.btn-primary-ghost {\n    background-color: transparent;\n    color: $primary;\n    border: 1px solid $primary;\n    &:active {\n      color: $primary;\n      border: 1px solid $primary;\n      background-color: transparent;\n    }\n  }\n  &.btn-dark{\n    background: #131022 !important;\n    border-color: #131022 !important;\n    box-shadow: none;\n    color: #fff;\n    &:hover{\n      background: $primary;\n    }\n  }\n  &.btn-secondary-ghost {\n    background-color: transparent;\n    color: $secondary;\n    border: 1px solid $secondary;\n    &:active {\n      color: $secondary;\n      border: 1px solid $secondary;\n      background-color: transparent;\n    }\n  }\n  &.btn-warning-ghost {\n    background-color: transparent;\n    color: $warning;\n    border: 1px solid $warning;\n    &:active {\n      color: $warning;\n      border: 1px solid $warning;\n      background-color: transparent;\n    }\n  }\n  &.btn-info-ghost {\n    background-color: transparent;\n    color: $info;\n    border: 1px solid $info;\n    &:active {\n      color: $info;\n      border: 1px solid $info;\n      background-color: transparent;\n    }\n  }\n  &.btn-success-ghost {\n    background-color: transparent;\n    color: $success;\n    border: 1px solid $success;\n    &:active {\n      color: $success;\n      border: 1px solid $success;\n      background-color: transparent;\n    }\n  }\n  &.btn-danger-ghost {\n    background-color: transparent;\n    color: $danger;\n    border: 1px solid $danger;\n    &:active {\n      color: $danger;\n      border: 1px solid $danger;\n      background-color: transparent;\n    }\n  }\n}\n.btn-list {\n  button {\n    margin: 0 0.375rem 0.375rem 0;\n  }\n}\n.btn-outline-primary {\n    border: 1px solid $primary !important;\n    color: $primary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $primary !important;\n        border:1px solid $primary !important;\n        box-shadow: 0 3px 10px rgba($primary, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-secondary {\n    border: 1px solid $secondary !important;\n    color: $secondary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $secondary !important;\n        border:1px solid $secondary !important;\n        box-shadow: 0 3px 10px rgba($secondary, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-success {\n    border: 1px solid $success !important;\n    color: $success !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $success !important;\n        border:1px solid $success !important;\n        box-shadow: 0 3px 10px rgba($success, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-danger {\n    border: 1px solid $danger !important;\n    color: $danger !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $danger !important;\n        border:1px solid $danger !important;\n        box-shadow: 0 3px 10px rgba($danger, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-warning {\n    border: 1px solid $warning !important;\n    color: $warning !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $warning !important;\n        border:1px solid $warning !important;\n        box-shadow: 0 3px 10px rgba($warning, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-info {\n    border: 1px solid $info !important;\n    color: $info !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $info !important;\n        border:1px solid $info !important;\n        box-shadow: 0 3px 10px rgba($info, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-light {\n    border: 1px solid $light;\n    color: $gray-800 !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $light;\n        border: 1px solid $light;\n        color: $dark !important;\n    }\n}\n.btn-outline-dark {\n    border: 1px solid $dark !important;\n    color: $dark !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $dark !important;\n        border:1px solid $dark !important;\n        box-shadow: 0 3px 10px rgba($dark, 0.5);\n        color: $white !important;\n    }\n}\n.btn-soft-primary {\n    background-color: $primary-300 !important;\n    color: $primary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($primary, .2);\n       border-color: $primary;\n    }    \n}\n.btn-soft-secondary {\n    background-color: $secondary-300 !important;\n    color: $secondary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($secondary, .2);\n       border-color: $secondary;\n    }    \n}\n.btn-soft-success {\n    background-color: $success-300 !important;\n    color: $success !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($success, .2);\n       border-color: $success;\n    }    \n}\n.btn-soft-danger {\n    background-color: $danger-300 !important;\n    color: $danger !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($danger, .2);\n       border-color: $danger;\n    }    \n}\n.btn-soft-warning {\n    background-color: $warning-300 !important;\n    color: $warning !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($warning, .2);\n       border-color: $warning;\n    }    \n}\n.btn-soft-info {\n    background-color: rgba($info, 0.3) !important;\n    color: $info !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($info, .2);\n       border-color: $info;\n    }    \n}\n.btn-soft-light {\n    background-color: rgba($light, .9) !important;\n    color: $text-color !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($light, .2);\n       border-color: $light;\n       border-color: $text-color;\n    }    \n}\n.btn-soft-dark {\n    background-color: rgba($dark, 0.3) !important;\n    color: $white !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($dark, .2);\n       border-color: $dark;\n    }    \n}\n.custom-btn-close {\n  &.btn-close {\n    background-image: none;\n    transition: 0.5s all;\n    &:hover {\n      background: $danger;\n      color: $white;\n      border-color: $danger !important;\n      transition: 0.5s all;\n      transform: rotateZ(360deg);\n    }\n  }\n}\n.modal {\n  .custom-btn-close {\n    &.btn-close {\n      background-image: none;\n      transition: 0.5s all;\n      width: auto !important;\n      height: auto !important;\n      &:hover {\n        background: $danger !important;\n        color: $white !important;\n        border-color: $danger !important;\n        transition: 0.5s all;\n        transform: rotateZ(360deg);\n      }\n    }\n  }\n}\n.btn-purple-light {\n  background-color: $purple-100;\n  border-color: $purple-100;\n  color: $purple;\n  font-size: $font-size-14;\n  font-weight: $font-weight-medium;\n  border-radius: 5px;\n  @include margin-padding(null, 9px 20px);\n  @include transition(all 0.2s ease);\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;        \n  @include respond-below(custom991) {\n      @include margin-padding(null, 9px 14px);\n  }\n}\n.btn-primary {\n  background: $primary;\n  border: 1px solid $primary;\n  @include transition(all 0.2s ease);\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  &:hover,\n  &:active,\n  &:focus {\n      background: $primary-hover;\n      border-color: $primary-hover;\n      color: $white;\n      box-shadow: 0 0 0 0.2rem rgba(232, 91, 40, 0.16);\n  }\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n\n  @include respond-below(custom991) {\n      min-width: auto;\n  }\n}\n\n.btn-secondary {\n  background: #475569;\n  border: 1px solid #475569;\n  color: #fff;\n  transition: all 0.2s ease;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background: #334155;\n    border-color: #334155;\n    color: #fff;\n    box-shadow: 0 0 0 0.2rem rgba(71, 85, 105, 0.18);\n  }\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n}\n\n.btn-light {\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  color: #64748b;\n  border-radius: 10px;\n  transition: all 0.2s;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #475569;\n    box-shadow: none;\n  }\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.btn-outline-secondary {\n  border: 1.5px solid #cbd5e1 !important;\n  color: #64748b !important;\n\n  &:hover,\n  &:focus,\n  &.focus,\n  &:active,\n  &.active {\n    background-color: #f8fafc !important;\n    border: 1.5px solid #94a3b8 !important;\n    box-shadow: 0 0 0 0.2rem rgba(148, 163, 184, 0.16) !important;\n    color: #334155 !important;\n  }\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.45;\n    box-shadow: none !important;\n  }\n}\n\n.btn-primary:focus-visible,\n.btn-secondary:focus-visible,\n.btn-light:focus-visible,\n.btn-success:focus-visible,\n.btn-outline-secondary:focus-visible {\n  outline: none;\n}\n\n/* Shared emp button classes for reusable form components */\n.emp-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px 24px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  text-decoration: none;\n  outline: none;\n\n  &:focus-visible {\n    box-shadow: 0 0 0 0.22rem rgba(232, 91, 40, 0.2);\n  }\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    box-shadow: none;\n    transform: none;\n  }\n}\n\n.emp-btn--ghost {\n  background: #fff;\n  color: #64748b;\n  border: 1.5px solid #e2e8f0;\n}\n\n.emp-btn--ghost:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  color: #475569;\n}\n\n.emp-btn--ghost:active:not(:disabled) {\n  background: #f1f5f9;\n  border-color: #94a3b8;\n}\n\n.emp-btn--secondary {\n  background: #475569;\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(71, 85, 105, 0.28);\n}\n\n.emp-btn--secondary:hover:not(:disabled) {\n  background: #334155;\n  box-shadow: 0 6px 18px rgba(51, 65, 85, 0.35);\n  transform: translateY(-1px);\n}\n\n.emp-btn--secondary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.emp-btn--primary {\n  background: linear-gradient(135deg, #e85b28, #f59e0b);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(232, 91, 40, 0.3);\n}\n\n.emp-btn--primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #d4501f, #e85b28);\n  box-shadow: 0 6px 18px rgba(232, 91, 40, 0.38);\n  transform: translateY(-1px);\n}\n\n.emp-btn--success {\n  background: linear-gradient(135deg, #059669 0%, #10b981 100%);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);\n}\n\n.emp-btn--success:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(5, 150, 105, 0.38);\n}",".badge {\n    &.badge-primary {\n        background: rgba($primary, 0.1);\n        box-shadow: 0 1px 1px rgba($primary, 0.5);\n        color: $primary;\n        \n    }\n}\n@each $color, $value in $theme-colors {\n    .badge {\n        &.badge-#{$color} {\n            background: #{$value};\n            box-shadow: 0 1px 1px rgba($value, 0.5);\n            color: $white;\n        }\n        &.badge-soft-#{$color} {\n            background: rgba($value, 0.1);\n            box-shadow: 0 1px 1px rgba($value, 0.5);\n            color: $value;\n        }\n    }\n}\n.badge{\n    padding: .25rem .45rem;\n    text-transform:capitalize;\n    font-weight: $font-weight-semibold;\n    letter-spacing: 0.5px;\n    border-radius: $border-radius;\n    color: $gray-900;\n    &.badge-xs {\n        font-size: 10px;\n        padding: 0px 5px;\n        line-height: 18px;\n    }\n    &.badge-sm {\n        font-size: 11px;\n        padding: 5px 8px;\n        line-height: 11px;\n    }\n    &.badge-md {\n        font-size: 12px;\n        padding: 5px 12px;\n        line-height: 1.5;\n    }\n    &.badge-lg {\n        font-size: $font-size-14;\n        padding: 0px 10px;\n        line-height: 30px;\n    }\n    &.badge-xl {\n        font-size: $font-size-16;\n        padding: 0px 15px;\n        line-height: 35px;\n    }\n}\n\n.badge-soft-purple {\n    background: $purple-100;\n    color: $purple;\n    \n}\n.bg-light-danger {\n    background-color: $danger-100 !important;\n    .badge-dots{\n        background-color: $danger-900;\n    }\n}\n.bg-light-success {\n    background-color: $success-100 !important;\n    .badge-dots{\n        background-color: $success-900;\n    }\n}\n.bg-light-info {\n    background-color:$info-100 !important;\n    .badge-dots{\n        background-color: $info-900;\n    }\n}\n.bg-light-warning {\n    background-color: $warning-100 !important;\n    .badge-dots{\n        background-color: $warning-900;\n    }\n}\n.badge-danger-light{\n    background-color: $danger-100 !important;\n    color: $danger-900;\n}\n.badge-pending{\n\tbackground: #676DFF !important;\n    color: $white !important;\n}\n.badge-tertiary {\n    background: $tertiary;\n    color: $white;\n}\n.badge-status {\n    border-radius: 5px;\n    font-size: $font-size-12;\n    padding: 4px 8px;\n    min-width: 64px;\n    color: $white;\n}\n.badge-tag {\n    border-radius: 5px;\n    font-size: $font-size-12;\n    padding: 4px 4px;    \n    font-weight: $font-weight-normal;\n    &.badge-success-light {\n        background: $success-200;\n        color: $success;\n    }\n    &.badge-warning-light {\n        background: $warning-100;\n        color: $warning;\n    }\n    &.badge-purple-light {\n        background: $purple-100;\n        color: $purple;\n    }\n    &.badge-danger-light {\n        background: $danger-100;\n        color: $danger;\n    }\n}",".border-container {\n    display: inline-block;\n    width: 5rem;\n    height: 5rem;\n    margin: 0.25rem;\n    background-color: $light;\n}\n.border {\n    border: 1px solid $border-color !important;\n    &.border-dashed {\n        border-style: dashed !important;\n    }\n    &.border-dotted {\n        border-style: dotted !important;\n    }\n    &.border-primary {\n        border: 1px solid $primary !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($primary, 0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($primary, 0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($primary, 0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($primary, 0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($primary,1) !important;\n        }\n    }\n    &.border-secondary {\n        border: 1px solid $secondary !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($secondary,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($secondary,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($secondary,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($secondary,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($secondary,1) !important;\n        }\n    }\n    &.border-info {\n        border: 1px solid $info !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($info,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($info,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($info,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($info,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($info,1) !important;\n        }\n    }\n    &.border-success {\n        border: 1px solid $success !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($success,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($success,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($success,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($success,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($success,1) !important;\n        }\n    }\n    &.border-warning {\n        border: 1px solid $warning !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($warning,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($warning,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($warning,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($warning,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($warning,1) !important;\n        }\n    }\n    &.border-danger {\n        border: 1px solid $danger !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($danger,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($danger,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($danger,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($danger,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($danger,1) !important;\n        }\n    }\n    &.border-white {\n        border: 1px solid $white !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($white,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($white,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($white,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($white,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($white,1) !important;\n        }\n    }\n    &.border-light {\n        border: 1px solid $light !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($light,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($light,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($light,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($light,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($light,1) !important;\n        }\n    }\n    &.border-dark {\n        border: 1px solid $dark !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($dark,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($dark,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($dark,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($dark,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($dark,1) !important;\n        }\n    }\n    &.border-orange {\n        border: 1px solid $orange !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($orange,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($orange,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($orange,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($orange,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($orange,1) !important;\n        }\n    }\n    &.border-opacity-10 {\n        --bs-border-opacity: 0.1 !important;\n    }\n    &.border-opacity-25 {\n        --bs-border-opacity: 0.25 !important;\n    }\n    &.border-opacity-50 {\n        --bs-border-opacity: 0.5 !important;\n    }\n    &.border-opacity-75 {\n        --bs-border-opacity: 0.75 !important;\n    }\n    &.border-opacity-100 {\n        --bs-border-opacity: 1 !important;\n    }\n    &.border-1 {\n        border-width: 1px !important;\n    }\n    &.border-2 {\n        border-width: 2px !important;\n    }\n    &.border-3 {\n        border-width: 3px !important;\n    }\n    &.border-4 {\n        border-width: 4px !important;\n    }\n    &.border-5 {\n        border-width: 5px !important;\n    }\n    &.border-block-start-dashed {\n        border-top-style: dashed;\n    }\n    &.border-block-start-dotted {\n        border-top-style: dotted;\n    }\n    &.border-inline-end-dashed {\n        border-inline-end-style: dashed;\n    }\n    &.border-inline-end-dotted {\n        border-inline-end-style: dotted;\n    }\n    &.border-block-end-dashed {\n        border-bottom-style: dashed;\n    }\n    &.border-block-end-dotted {\n        border-bottom-style: dotted;\n    }\n    &.border-inline-start-dashed {\n        border-inline-start-style: dashed;\n    }\n    &.border-inline-start-dotted {\n        border-inline-start-style: dotted;\n    }\n    &.border-0 {\n        border: 0 !important;\n    }\n    &.border-top-0 {\n        border-block-start: 0 !important;\n    }\n    &.border-end-0 {\n        border-inline-end: 0 !important;\n    }\n    &.border-bottom-0 {\n        border-block-end: 0 !important;\n    }\n    &.border-start-0 {\n        border-inline-start: 0 !important;\n    }\n}\n.border-top {\n    border-top: 1px solid $border-color !important;\n    &.border-block-start-dashed {\n        border-top-style: dashed !important;\n    }\n    &.border-block-start-dotted {\n        border-top-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-end {   \n    border-inline-end: 1px solid $border-color !important;\n    &.border-inline-end-dashed {\n        border-inline-end-style: dashed !important;\n    }\n    &.border-inline-end-dotted {\n        border-inline-end-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-bottom {\n    border-bottom: 1px solid $border-color !important;\n    &.border-block-end-dashed {\n        border-bottom-style: dashed !important;\n    }\n    &.border-block-end-dotted {\n        border-bottom-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-start {\n    border-inline-start: 1px solid $border-color !important;\n    &.border-inline-start-dashed {\n        border-inline-start-style: dashed !important;\n    }\n    &.border-inline-start-dotted {\n        border-inline-start-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.br-1 {\n    border-radius: 0.0625rem;\n}\n.br-2 {\n    border-radius: 0.125rem;\n}\n.br-3 {\n    border-radius: 0.1875rem;\n}\n.br-4 {\n    border-radius: 0.25rem;\n}\n.br-5 {\n    border-radius: 0.3125rem;\n}\n.br-6 {\n    border-radius: 0.375rem;\n}\n.br-7 {\n    border-radius: 0.4375rem;\n}\n.br-8 {\n    border-radius: 0.5rem;\n}\n.br-9 {\n    border-radius: 0.5625rem;\n}\n.br-10 {\n    border-radius: 0.625rem;\n}\n.br-15 {\n    border-radius: 0.9375rem;\n}\n.br-20 {\n    border-radius: 1.25rem;\n}\n.rounded {\n    border-radius: $border-radius !important;\n}\n\n",".calendar-events {\n    border: 1px solid transparent;\n    cursor: move;\n\t@include margin-padding(null, 10px 15px);\n}\n.calendar-events:hover {\n\tborder-color: $gray-300;\n    background-color: $white;\n}\n.calendar-events i {\n    margin-right: 8px;\n}\n.calendar {\n\tfloat: left;\n\tmargin-bottom: 0;\n}\n.fc-toolbar.fc-header-toolbar {\n    margin-bottom: 1.5rem;\n}\n.none-border .modal-footer {\n\tborder-top: none;\n}\n.fc-toolbar h2 {\n\tfont-size: $font-size-18;\n\tfont-weight: $font-weight-semibold;\n\tfont-family: 'Roboto', sans-serif;\n\tline-height: 30px;\n\ttext-transform: uppercase;\n}\n.fc-day-grid-event .fc-time {\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-day {\n\tbackground: $white;\n}\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 0;\n}\n.fc th.fc-widget-header {\n\tbackground: $light-500;\n\tfont-size: $font-size-14;\n\tline-height: 20px;\n\tpadding: 10px 0;\n\ttext-transform: uppercase;\n}\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #f3f3f3;\n}\n.fc-basic-view .fc-day-number, \n.fc-basic-view .fc-week-number {\n    padding: 2px 5px;\n}\n.fc-button {\n\tbackground: #f1f1f1;\n\tborder: none;\n\tcolor: #797979;\n\ttext-transform: capitalize;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n\tmargin: 0 3px !important;\n\tpadding: 6px 12px !important;\n\theight: auto !important;\n}\n.fc-text-arrow {\n\tfont-family: inherit;\n\tfont-size: $font-size-16;\n}\n.fc-state-hover {\n\tbackground: #f3f3f3;\n}\n.fc-state-highlight {\n\tbackground: #f0f0f0;\n}\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n\tbackground-color: $primary !important;\n\tcolor: $white !important;\n\ttext-shadow: none !important;\n}\n.fc-cell-overlay {\n\tbackground: #f0f0f0;\n}\n.fc-unthemed .fc-today {\n\tbackground: $white;\n}\n.fc-event {\n\tborder-radius: 2px;\n\tborder: none;\n\tcolor: $white !important;\n\tcursor: move;\n\tfont-size: 13px;\n\tmargin: 1px 7px;\n\tpadding: 5px 5px;\n\ttext-align: center;\n}\n.fc-basic-view td.fc-week-number span {\n\tpadding-right: 8px;\n\tfont-weight: $font-weight-bold;\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-basic-view td.fc-day-number {\n\tpadding-right: 8px;\n\tfont-weight: $font-weight-bold;\n\tfont-family: 'Roboto', sans-serif;\n}\n.event-form .input-group .form-control {\n\theight: 40px;\n}\n.submit-section {\n\ttext-align: center;\n\tmargin-top: 40px;\n}\n.submit-btn {\n    border-radius: 50px;\n    font-size: $font-size-18;\n    font-weight: $font-weight-semibold;\n    min-width: 200px;\n    padding: 10px 20px;\n}",".apexcharts-legend.apexcharts-align-center.position-right {\n    display: none;\n}\n.apexcharts-toolbar {\n    display: none !important;\n}\n#sales_charts,\n.chart-set{\n    overflow: hidden;\n}\n.apexcharts-canvas {\n    width: 100% !important;\n}\n.h-250 {\n    height: 250px;\n}\n",".chat-user-actives {\n    .call-meet-blk {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $white;\n        border-radius: 5px;\n        margin-bottom: 15px;\n        padding: 10px;\n        @include transition(all 0.5s ease);\n        &:hover {\n            background-color: $black;\n            @include transition(all 0.5s ease);\n        }\n        .meet-border {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            width: 39px;\n            height: 39px;\n            background: $white;\n            border: 0.5px solid $gray-300;\n            border-radius: 10px;\n            margin-right: 10px;\n            svg {\n                width: 16px;\n                color: $blue;\n            }\n        }\n        .recent-user-titles {\n            h5 {\n                font-size: $font-size-base;\n                font-weight: $font-weight-semibold;\n                color: $black;\n                margin-bottom: 5px;\n                width: 150px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n            p {\n                font-size: $font-size-10;\n                color: $text-color;\n            }\n        }\n    }\n}\n.new-join-link {\n    .chat-user-actives {\n        .meet-border {\n            background: gray;\n            border: 0;\n            border-radius: 6px;\n            &:hover {\n                background: $primary;\n                svg {\n                    color: $white;\n                }\n            }\n            svg {\n                color: $primary;\n            }\n        }\n        .recent-user-titles {\n            h5 {\n                color: $primary;\n                width: 100%;\n                margin-bottom: 0;\n                font-size: $font-size-15;\n            }\n        }\n    }\n}\n.meet-chat-blk {\n    .join-call {\n        .join-video {\n            position: relative;\n            margin-bottom: 25px;\n            img {\n                border-radius: 10px;\n            }\n            .video-avatar {\n                color: $white;\n                background: #5D5D5D;\n                font-size: 50px;\n                border-radius: 10px;\n                height: 100%;\n                width: 100%;\n                position: absolute;\n                top: 0;\n                left: 0;\n                display: none;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                &.active {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    position: relative;\n                    height: 426px;\n                }\n            }\n            .call-icons {\n                text-align: center;\n                position: absolute;\n                width: 100%;\n                height: 100%;\n                top: 0;\n                .call-items {\n                    border-radius: 5px;\n                    padding: 0;\n                    margin: 0;\n                    list-style: none;\n                    display: -webkit-inline-box;\n                    display: -ms-inline-flexbox;\n                    display: inline-flex;\n                    position: absolute;\n                    bottom: 30px;\n                    left: 50%;\n                    transform: translate(-50%, 0);\n                    .call-item {\n                        display: inline-block;\n                        text-align: center;\n                        margin-right: 15px;\n                        &:last-child {\n                            margin-right: 0px;\n                        }\n                        a {\n                            color: $white;\n                            background: $white;\n                            border-radius: 10px;\n                            width: 54px;\n                            height: 54px;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            justify-content: center;\n                            -webkit-justify-content: center;\n                            -ms-flex-pack: center;\n                            font-size: $font-size-20;\n                            white-space: nowrap;\n                            @include respond-below(custom767) {\n                                width: 45px;\n                                height: 45px;\n                            }\n                            i {\n                                color: $text-color;\n                            }\n                            &.stop {\n                                color: $white;\n                                background: $danger;\n                                i {\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .meet-drop {\n                ul {\n                    li {\n                        i {\n                            font-size: $font-size-18;\n                        }\n                    }\n                }\n            }\n            \n        }\n        .join-content {\n            text-align: center;\n            max-width: 500px;\n            margin: auto;\n            h4 {\n                font-size: $font-size-22;\n                font-weight: $font-weight-semibold;\n                margin-bottom: 20px;\n                @include respond-below(custom767) {\n                    font-size: $font-size-18;\n                }\n            }\n            .event-user-group {\n                margin-bottom: 10px;\n                .avatar-group {\n                    .avatar {\n                        width: 38px;\n                        height: 38px;\n                        border: 3px solid $white;\n                        &+.avatar {\n                            margin-left: -20px;\n                        }\n                        .avatar-title {\n                            color: $black;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            background: gray;\n                        }\n                    }\n                }\n            }\n            p {\n                font-size: $font-size-13;\n                color: $text-color;\n            }\n            .btn-join-call {\n                .btn-primary {\n                    background: $primary;\n                    border-radius: 6px 6px 6px 6px;\n                    color: $white;\n                    font-size: $font-size-base;\n                    border: 1px solid $primary;\n                    font-weight: $font-weight-semibold;\n                    min-width: 105px;\n                    padding: 8px 15px;\n                    &:hover {\n                        background: $danger;\n                        border: 1px solid gray;\n                        color: $primary;\n                    }\n                }\n            }\n        }\n    }\n}\n.conference-meet-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    .meeting-list {\n        width: 100%;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        &.add-meeting {\n            width: 65%;\n            margin-right: 24px;\n            @include respond-below(custom767) {\n                display: none;\n                margin-right: 0px;\n            }\n        }\n    }\n    .right-user-side {\n        width: 0;\n        opacity: 0;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        &.right-side-party {\n            width: 0;\n            opacity: 0;\n            transition: all 0.5s ease;\n            -moz-transition: all 0.5s ease;\n            -o-transition: all 0.5s ease;\n            -ms-transition: all 0.5s ease;\n            -webkit-transition: all 0.5s ease;\n            .party-msg-blk  {\n                .last-call-time {\n                    .call-recent {\n                        background: none;\n                        svg {\n                            color: $primary;\n                            width: 14px;\n                        }\n                    }\n                }\n            }\n        }\n        &.chat-rooms {\n            width: 0;\n            opacity: 0;\n            transition: all 0.5s ease;\n            -moz-transition: all 0.5s ease;\n            -o-transition: all 0.5s ease;\n            -ms-transition: all 0.5s ease;\n            -webkit-transition: all 0.5s ease;\n            .slime-grp {\n                padding: 0;\n                .left-chat-title {\n                    padding: 20px;\n                    border-bottom: 1px solid #E1E8ED;\n                    border-radius: 10px 10px 0 0;\n                }\n            }\n            &.open-chats {\n                width: 35%;\n                opacity: 1;\n                @include respond-below(custom767) {\n                    width: 100%;\n                }\n            }\n        }\n        &.open-message {\n            width: 35%;\n            opacity: 1;\n            @include respond-below(custom767) {\n                width: 100%;\n            }\n        }\n    }\n}\n.meet-drop {\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 10px;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    ul {\n        li {\n            .chats-dot {\n                a {\n                    width: 50px;\n                    height: 50px;\n                    color: #6B7280;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    @include respond-below(custom767) {\n                        width: 38px;\n                        height: 38px;\n                    }\n                }\n            }\n        }\n    }\n    &.meet-mutes {\n        background: $primary;\n        right: inherit;\n        left: 20px;\n        ul {\n            li {\n                a {\n                    color: $white;\n                    width: 50px;\n                    height: 50px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    @include respond-below(custom767) {\n                        width: 38px;\n                        height: 38px;\n                    }\n                }\n            }\n        }\n    }\n    &.meet-mutes-bottom {\n        background: $primary;\n        bottom: 20px;\n        border-radius: 50px;\n        top: inherit;\n        ul {\n            li {\n                a {\n                    color: $white;\n                    width: 50px;\n                    height: 50px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    @include respond-below(custom767) {\n                        width: 38px;\n                        height: 38px;\n                    }\n                    i {\n                        font-size: $font-size-20;\n                    }\n                }\n            }\n        }\n    }\n}\n.meet-call-menu-blk {\n    .video-call-action {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        @include respond-below(custom767) {\n            display: block;\n        }\n        ul {\n\t\t\tdisplay: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            li {\n                margin-right: 5px;\n                &:last-child {\n                    margin-right: 0;\n                }\n                a {\n                    width: 40px;\n                    height: 40px;\n                    border-radius: 50px;\n                    background: #D9D9D9;\n                    border: 1px solid #D9D9D9;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    color: $black;\n\t\t\t\t\tfont-size: $font-size-18;\n                    &.call-end {\n                        background-color: $danger;\n                        border-color: $danger;\n                        color: $white;\n\t\t\t\t\t\twidth: 60px;\n                    \theight: 60px;\n\t\t\t\t\t\trotate: 135deg;\n\t\t\t\t\t\tfont-size: $font-size-20;\n                    }\n                    &.stop {\n                        color: $white;\n                        background: $danger;\n                        border-color: $danger;\n                        i {\n                            color: $white;\n                        }\n                    }\n                }\n                &.active {\n                    a {\n                        background: $primary;\n                        border-color: $primary;\n                        color: $white;\n                        img {\n                            filter: invert(1) brightness(100);\n                        }\n                    }\n                }\n            }\n            @include respond-below(custom767) {\n                margin-bottom: 5px;\n                justify-content: center;\n            }\n            &:last-child {\n                @include respond-below(custom767) {\n                    margin-bottom: 0px;\n                }\n            }\n        }\n    }\n}\n.recession-meet-blk {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 30px;\n    @include respond-below(custom767) {\n        display: block;\n    }\n    .reccession-head {\n        @include respond-below(custom767) {\n            margin-bottom: 5px;\n        }\n        h5 {\n            font-size: $font-size-20;\n            font-weight: $font-weight-bold;\n\t\t\tcolor: $gray-900;\n            margin-bottom: 0px;\n            @include respond-below(custom767) {\n                font-size: $font-size-18;\n            }\n        }\n        ul {\n            li {\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n                color: $text-color;\n                margin-right: 25px;\n                &:last-child {\n                    margin-right: 0px;\n                }\n                @include respond-below(custom767) {\n                    margin-bottom: 10px\n                }\n            }\n        }\n    }\n    .partispant-blk {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        .btn-primary {\n            background: #1b2950;\n            border-radius: 6px;\n            color: $white;\n            border: 1px solid #1b2950;\n            margin-right: 10px;\n            font-weight: $font-weight-bold;\n            font-size: $font-size-base;\n\t\t\t&:hover {\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder: 1px solid $primary;\n\t\t\t}\n            @include respond-below(custom767) {\n                font-size: $font-size-13;\n            }\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n        span {\n            a {\n                width: 42px;\n                height: 42px;\n                background: $light-900;\n                border-radius: 5px;\n                color: $text-color;\n\t\t\t\tfont-size: $font-size-18;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: $primary;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t}\n            }\n        }\n    }\n}\n.recording-time {\n    position: relative;\n    padding-left: 20px;\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0px;\n        top: 4px;\n        background-color: $danger;\n        width: 13px;\n        height: 13px;\n        border-radius: 50px;\n    }\n    &::after {\n        content: \"\";\n        position: absolute;\n        left: 3px;\n        top: 7px;\n        background-color: $white;\n        width: 7px;\n        height: 7px;\n        border-radius: 50px;\n        animation: blink-animation 1.5s steps(5, start) infinite;\n        -webkit-animation: blink-animation 1.5s steps(5, start) infinite;\n    }\n}\n\n.page-content {\n\twidth: 100%;\n}\n.join-call {\n    width: 100%;\n    margin: 0 auto;\n}\n.join-video {\n\tposition: relative;\n\tmargin-bottom: 25px;\n    img {\n        border-radius: 10px;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    &.join-video-front {\n        img {\n            height: 423px;\n        }      \n    }\n}\n.video-avatar {\n    color: $white;\n    background: #5D5D5D;\n    font-size: 50px;\n    border-radius: 10px;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: none;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    h4 {\n        font-weight: $font-weight-bold;\n        font-size: $font-size-24;\n        color: $white;\n    }\n}\n.video-avatar.active {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.join-video.video-hide > img, \n.video-wrap.video-hide > video {\n    display: none;\n}\n.join-content {\n    p {\n        font-weight: $font-weight-normal;\n        font-size: $font-size-14;\n        margin-bottom: 25px;\n        color: $black;\n    }\n    label {\n        font-size: $font-size-18;\n        margin-bottom: 0;\n        color: $black;\n        font-weight: $font-weight-bold;\n    }\n}\n.part-name {\n\tposition: absolute;\n\ttop: 20px;\n\tleft: 12px;\n\ttext-align: left;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 50px;\n    padding: 5px 15px;\n    h4 {\n        font-weight: $font-weight-medium;\n        font-size: $font-size-15;\n        color: $text-color; \n        margin-bottom: 0;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        @include respond-below(custom767) {\n            font-size: $font-size-13;\n        }\n    }\n    &.sub-part-name {\n        background: $white;\n        bottom: 10px;\n        top: inherit;\n        h4 {\n            color: $gray-900;\n            font-size: $font-size-12;\n        }\n    }\n}\n.grid-join {\n    .part-name {\n        background: rgba(0, 0, 0, 0.3);\n        top: inherit;\n        bottom: 20px;\n        h4 {\n            color: $white;\n        }\n    }\n}\n.join-hover-img {\n    position: absolute;\n    @include position-alignment(both);\n    .event-user-group {\n        .avatar-group {\n            background: rgba(0, 0, 0, 0.3);\n            padding: 2px 10px;\n            border-radius: 50px;\n            .avatar {\n                width: 26px;\n                height: 26px;\n                border: 1px solid $white;\n                &+.avatar {\n                    margin-left: -16px;\n                }\n                &:last-child {\n                    margin-right: 0px;\n                }\n                .avatar-title {\n                    color: #1F2937;\n                    font-size: 12px;\n                    font-weight: $font-weight-semibold;\n                    background: #F3F4F6;\n                }\n            }\n        }\n    }\n}\n.more-icon {\n\tposition: absolute;\n\tbottom: 10px;\n\tright: 12px;\n    @include respond-below(custom767) {\n        bottom: 8px;\n        right: 13px;\n    }\n    a {\n        color: $text-color;\n        width: 30px;\n        height: 30px;\n        background: $white;\n        border-radius: 50px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        &:hover {\n            opacity: 0.8;\n        }\n        &.other-mic-off {\n            &.stop {\n                i {\n                    color: $danger;\n                }\n            }\n        }\n    }\n    &.audio-more-icon {\n        a {\n            &.other-mic-off {\n                &.stop {\n                    background-color: $danger !important;\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}\n.call-recent {\n    &.recent-part {\n        a {\n            &.other-mic-off, &.other-video-off {\n                &.stop {\n                    background: $danger !important;\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}\n.meeting {\n    .part-name {\n        top: 15px;\n        left: 15px;\n    }\n    .more-icon {\n        top: 15px;\n        right: 15px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n}\n.vertical-view {\n    .vertical-sec {\n        .part-name {\n            h4 {\n                font-size: $font-size-14;\n\t            font-weight: $font-weight-normal;\n            }\n        }\n    }\n}\n.horizontal-view {\n    .join-video {\n        &.single-user {\n            .part-name h4 {\n                font-size: $font-size-14;\n                font-weight: $font-weight-normal;\n            }\n        }\n    }\n}\n.meeting-wrapper, .meeting {\n\twidth: inherit;\n\tmax-width: inherit;\n}\n.meet-footer {\n\tposition: fixed;\n\tbottom: 25px;    \n\twidth: 100%;\n\tmax-width: 950px;\n\tleft: 50%;\n    transform: translate(-50%, 0);\n\tz-index: 3;\n}\n.show-chat-list, .show-invite-list,\n.show-chat-list .user-sidebar-right,\n.show-invite-list .invite-sidebar-right {\n    transition: all 0.8s ease;\n}\n.user-sidebar-right, .invite-sidebar-right {\n    background: #dedede;\n\tborder-radius: 10px;\n    width: 410px;\n    position: absolute;\n    top: 105px;\n    bottom: 117px;\n    right: 0;\n    margin-right: -410px;\n    transition: all 0.8s ease;\n    overflow: hidden;\n    font-size: 13px;\n\tz-index: 3;\n}\n.join-contents {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-content: flex-start;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tmargin: 0 auto;\n\toverflow: hidden;\n    &.grid-view {\n        align-content: center;\n    }\n}\n.ripple {\n\twidth: 114px;\n    height: 114px;\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n.multigrid-view {\n    .text-box {\n        height: 61px;\n        width: 61px;\n    }\n}\n.multigrid-view {\n    .ripple {\n        width: 80px;\n        height: 80px;\n        background: rgba(0, 0, 0, 0.2);\n        border-radius: 50%;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n    }\n}\n.meeting {\n    .join-video {\n        margin: 0 5px 10px;\t\n        width: 100%;\n    }\n}\n.join-video {\n    &.user-active {\n        background: #415B6A;\n        border-radius: 10px;\n        width: 100%;\n        height: 370px;\n        &.audio-calls {\n            height: 520px;\n        }\n    }\n    &.vertical-active {\n        margin-right: 24px;\n    }\n    &.single-user {\n        width: 100%;\t\n        min-height: 230px;\n        box-sizing: border-box;\n        margin-right: 24px;\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        justify-content: space-between;\n        text-align: center;\n        height: auto;\n        background: #415B6A;\n        border-radius: 10px;\n        padding: 0;\n        flex-grow: 1;\n        @include respond-below(custom1280) {\n            width: 100%;\n        }\n        @include respond-below(custom1199) {\n            min-height: 203px;\n        }\n        @include respond-below(custom991) {\n            min-height: 230px;\n        }\n        &:nth-child(even) {\n            margin-right: 0px;\n            @include respond-below(custom767) {\n                margin-right: 10px;\n            }\n        }\n        @include respond-below(custom767) {\n            width: 100%;\n            min-height: 257px;\n        }\n    }\n\n}\n.multi-grid {\n    .join-video.single-user {\n        @include respond-below(custom767) {\n           width: 45%;\n        }\n        &:nth-child(even) {\n            margin-right: 24px;\n            @include respond-below(custom767) {\n                margin-right: 0px;\n            }\n        }\n        &:nth-child(4n) {\n            margin-right: 0px;\n            @include respond-below(custom767) {\n                &:nth-child(4n) {\n                    margin-right: 0px;\n                }\n            }\n        }\n    }\n}\n.multigrid-view {\n    .join-video {\n        &.single-user {\n            flex-grow: 0;\n        }\n    }\n}\n.horizontal-view {\n    .join-video.single-user {\n        &:nth-child(even) {\n            margin-right: 24px;\n        }\n        &:nth-child(5) {\n            margin-right: 0px;\n        }\n        &:nth-child(3n) {\n            @include respond-below(custom767) {\n                margin-right: 0\n            }\n        }\n    }\n}\n.text-avatar {\n\tcolor: $white;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    h4 {\n        color: $white;\n    }\n}\n.text-box {\n    height: 86px;\n    width: 86px;\t\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.2);\n    font-size: $font-size-36;\n\tfont-weight: $font-weight-bold;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n.more-icon.mic-view .mic-on, .more-icon .mic-off {\n\tdisplay: none;\n}\n.more-icon.mic-view .mic-off {\n    display: inline-flex;\n}\n.grid-view .join-video.single-user {\n    width: 47%;\t\n    @include respond-below(custom767) {\n        width: 40%;\t\n    }\n    &:nth-child(2n) {\n        @include respond-below(custom767) {\n            margin-right: 0px;\n        }\n    }\n    &:nth-child(3n) {\n        @include respond-below(custom767) {\n            margin-right: 24px;\n        }\n    }\n}\n\n.join-contents.multigrid-view {\n\tmax-width: 100%;\n\tjustify-content: center;\n}\n.meeting {\t\n\tposition: absolute;\n\ttop: 80px;\n\tbottom: 107px;\n\tleft: 0;\n\tright: 0;\n}\n.meeting-list {\n\tflex-direction: column;\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n}\n.user-active {\n    .more-icon {\n        .handraise-on {\n            display: none;\n            &.active {\n                display: block;\n                animation: mymove 5s;\n            }\n        }\n    }\n}\n.user-active .more-icon .handraise-on.active .meeting .join-video.user-active::before {\n\tanimation: mymove 5s infinite;\n\topacity: 1;\n}\n@keyframes mymove {\n\tfrom {color: #0074E0;}\n\tto {color: transparent;}\n}\n.join-contents {\n    &.vertical-view {\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        align-content: center;\n        max-width: 1300px;\n        @include respond-below(custom767) {\n            display: block;\n        }\n        .join-video {\n            &.user-active {\n                flex: 1;\n                margin-bottom: 24px;;\n            }\n            &.single-user {\n                width: 97%;\n                flex-grow: 1;\n                display: flex;\n                @include respond-below(custom767) {\n                    width: 100%;\n                }\n            }\n        }\n        .vertical-sec {\n            width: 20%;\n            @include respond-below(custom991) {\n                width: 30%;\n            }\n            @include respond-below(custom767) {\n                width: 100%;\n            }\n        }\n    }\n    &.vertical {\n        flex-direction: column;\n        height: 200px;\n    }\n}\n.meeting .join-contents.vertical .join-video.user-active {\n\tflex: 1 0 100%;\n}\n.meeting .join-contents.vertical .join-video.single-user {\n\tflex: 0;\n}\n.meeting .join-contents.vertical .join-video {\n\twidth: auto;\n}\n.chat-footer .btn:hover {\n\tbackground: #0066c5;\n\tcolor: $white;\n}\n.join-contents {\n    &.show-whiteboard {\n        display: none;\n    }\n    &.single-view {\n        padding-top: 0;\n        margin-top: 25px;\n        position: relative;\n        .single-user {\n            position: absolute;\n            right: 8px;\n            top: 40px;\n            width: 130px;\n            height: 130px ;\n            min-height: 130px ;\n            img {\n                height: 130px ;\t\n            }\n        }\n    }\n}\n.record-time {\n    position: absolute;\n    top: 20px;\n    z-index: 1;\n    position: absolute;\n    left: 20px;\n\tspan {\n\t\tbackground-color: rgba(255, 255, 255, 0.2);\n\t\tdisplay: inline-block;\n\t\tborder-radius: 130px;\n\t\tcolor: $white;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-semibold;\n\t\twidth: 80px;\n\t\theight: 30px;\n\t\ttext-align: center;\n\t\tline-height: 34px;\n\t\tposition: relative;\n\t\tpadding-left: 15px;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 7px;\n\t\t\ttop: 7px;\n\t\t\tbackground-color: $white;\n\t\t\twidth: 18px;\n\t\t\theight: 18px;\n\t\t\tborder-radius: 50px;\n\t\t}\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 12px;\n\t\t\ttop: 12px;\n\t\t\tbackground-color: $danger;\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tborder-radius: 50px;\n\t\t\tanimation: blink-animation 1.5s steps(5, start) infinite;\n\t\t\t-webkit-animation: blink-animation 1.5s steps(5, start) infinite;\n\t\t}\n\t}\n}\n\n@keyframes blink-animation {\n\tto {\n\t\tvisibility: hidden;\n\t}\n}\n\n@-webkit-keyframes blink-animation {\n\tto {\n\t\tvisibility: hidden;\n\t}\n}\n.volume-col {\n\tposition: absolute;\n\tleft: 20px;\n\tbottom: 20px;\n}\n.volume-col .inner-volume-col {\n\tbackground-color: $gray-300;\n    border-radius: 130px;\n    width: 30px;\n    height: 120px;\n    position: relative;\n    z-index: 9;\n}\n.volume-col #volume {\n\tposition: absolute;\n    left: 50%;\n    top: 15px;\n    margin: 0 auto;\n    height: 80px;\n    width: 5px;\n    background: $white;\n    border-radius: 15px;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n}\n.volume-col #volume .ui-slider-range-min {\n\theight: 5px;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    background: $primary;\n    border: none;\n    border-radius: 10px;\n    outline: none;\n}\n.volume-col #volume .ui-slider-handle {\n\twidth: 20px;\n    height: 20px;\n    border-radius: 20px;\n    background: $primary;\n    position: absolute;\n    left: 50%;\n    margin-top: -8px;\n    cursor: pointer;\n    outline: none;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n}\n.volume-col #player {\n\twidth: auto;\n    height: 104px;\n    position: relative;\n    margin: 0 auto;\n    top: 0px;\n}\n\n.volume-col #player i {\n\tposition: absolute;\n\tmargin-top: -6px;\n\tcolor: #666;\n}\n\n.volume-col .volume-icons {\n\tcolor: $white;\n\tmargin-left: 0px;\n\tfont-size: $font-size-18;\n\tmargin-top: 22px;\n}\n.chat-msg-blk {\n    padding: 15px;\n    .chats {\n        max-width: 100%;\n        margin-bottom: 1.5rem;\n        display: flex;\n        display: -webkit-flex;\n        @include respond-below(custom767) {\n            max-width: 100%;\n        }\n        .chat-action-btns {\n            .chat-user-time {\n                .chats-dot {\n                    a {\n                        color: $green;\n                    }\n                }\n            }\n        }\n        &.chats-right {\n            margin-left: auto;\n            flex-direction: row-reverse;\n            -webkit-flex-direction: row-reverse;\n            .chat-content {\n                order: 1;\n                -webkit-order: 1;\n                .message-content {\n                    background-color: $light-900;\n                    border-radius: 8px;\n                    .chat-time {\n                        justify-content: flex-start;\n                        -webkit-justify-content: flex-start;\n                    }\n                    .download-col {\n                        position: relative;\n                         ul {\n                            li {\n                                margin-right: 8px;\n                                &:last-child {\n                                    margin-right: 0px;\n                                }\n                                .image-download-col {\n                                    position: relative;\n                                    &.image-not-download {\n                                        a {\n                                            img {\n                                                -webkit-filter: blur(4px);\n                                                filter: blur(1px);\n                                                border-color: $black;\n                                            }\n                                        }\n                                        span {\n                                            position: absolute;\n                                            @include position-alignment(both);\n                                            i {\n                                                color: $white;\n                                            }\n                                        }\n                                    }\n                                    .download-action {\n                                        position: absolute;\n                                        right: 8px;\n                                        bottom: 8px;\n                                        line-height: 0;\n                                        a {\n                                            color: $white;\n                                            font-size: 10px;\n                                        }\n                                    }\n                                    img {\n                                        border-radius: 5px;\n                                    }\n                                }\n                            }\n                         }\n                    }\n                    &::before {\n                        border-bottom: 6px solid transparent;\n                        border-left: 6px solid $light-900;\n                        border-right: 0;\n                        border-top: 6px solid transparent;\n                        content: \"\";\n                        height: 0;\n                        width: 0;\n                        position: absolute;\n                        top: 8px;\n                        right: -4px;\n                        left: auto;\n                    }\n                }\n            }\n            .chat-avatar {\n                padding: 8px 0px 0 15px;\n            }\n            .chat-action-btns {\n                order: 2;\n                -webkit-order: 2;\n                display: flex;\n                display: -webkit-flex;\n                flex-wrap: wrap;\n                -webkit-flex-wrap: wrap;\n                justify-content: center;\n                -webkit-justify-content: center;\n                .chat-user-time {\n                    .chats-dot {\n                        a {\n                            color: $green;\n                        }\n                    }\n                }\n            }\n        }\n        .chat-avatar {\n            padding: 8px 15px 0 8px;\n            display: flex;\n            display: -webkit-flex;\n            align-items: flex-start;\n            -webkit-align-items: flex-start;\n            flex-shrink: 0;\n            .dreams_chat {\n                width: 40px;\n                height: 40px;\n                object-fit: cover;\n            }\n        }\n        .message-content {\n            background-color: $light-900;\n            border-radius: 8px;\n            padding: 10px 20px;\n            font-weight: $font-weight-medium;\n            margin-bottom: 5px;\n            position: relative;\n            h4 {\n                font-size: $font-size-13;\n                color: $gray-900;\n                margin-bottom: 0px;\n                line-height: 1.4;\n                font-weight: $font-weight-medium;\n            }\n            .chat-time {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                font-size: $font-size-10;\n                font-weight: $font-weight-medium;\n                color: $green;\n                margin-bottom: 0;\n                svg {\n                    width: 10px;\n                }\n            }\n            &::before {\n                border-bottom: 6px solid transparent;\n                border-right: 6px solid $light-900;\n                border-top: 6px solid transparent;\n                content: \"\";\n                height: 0;\n                width: 0;\n                position: absolute;\n                top: 8px;\n                left: -4px;\n                right: auto;\n            }\n        }\n        .chat-profile-name {\n            h6 {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: left;\n                -webkit-justify-content: left;\n                -ms-flex-pack: left;\n                font-size: 8px;\n                font-weight: $font-weight-medium;\n                color: $text-color;\n\t\t\t\ti {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tcolor: #008024;\n\t\t\t\t}\n            }\n        }\n    }\n    .chat-line {\n        margin: 0px 0 20px;\n        position: relative;\n        text-align: center;\n        width: 100%;\n        &:before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            background-color: $green;\n            width: 100%;\n            height: 1px;\n        }\n        .chat-date {\n            background-color: $green;\n            color: $green;\n            font-size: $font-size-13;\n            padding: 7px 14px;\n            border-radius: 3px;\n            display: inline-block;\n            font-weight: $font-weight-semibold;\n            position: relative;\n        }\n    }\n}\n.right-user-side {\n    &.call-user-side {\n        .slime-grp {\n            .right-sidebar-profile {\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n                border-bottom: 0;\n                padding-bottom: 10px;\n                .profile-call-blk {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                }\n                .edit-group {\n                    svg {\n                        width: 16px;\n                        color: $green;\n                    }\n                }\n            }\n            .chat-options {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                border-bottom: 1px solid $green;\n                padding-bottom: 20px;\n                ul {\n                    li {\n                        a {\n                            color: $green;\n                            width: 30px;\n                            height: 30px;\n                            background-color: gray;\n                            padding: 0;\n                            border-radius: 50px;\n                            &:hover {\n                                background: $primary;\n                                border-color: $primary;\n                                svg {\n                                    color: $white;\n                                }\n                            }\n                            svg {\n                                width: 15px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.right-side-party {\n        .slime-grp {\n            padding: 0px;\n            .left-chat-title {\n                padding: 20px;\n                margin-bottom: 0;\n                background-color: $body-bg;\n                border-radius: 10px 10px 0 0;\n                h4 {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    span {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                        width: 25px;\n                        height: 25px;\n                        background-color: $warning;\n                        border-radius: 50px;\n                        font-size: $font-size-14;\n                        color: $white;\n                        margin-left: 10px;\n                    }\n                }\n            }\n            .card-body-blk {\n                padding: 20px;\n                .user-list {\n                    border-radius: .25rem;\n                    display: flex;\n                    display: -webkit-flex;\n                    -ms-flex-direction: column;\n                    flex-direction: column;\n                    padding-left: 0;\n                    margin-bottom: 0;\n                    .user-list-item {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        padding: 5px;\n                        display: flex;\n                        display: -webkit-flex;\n                        border-radius: 6px;\n                        background-color: #F6F7F8;\n                        margin-bottom: 10px;\n                        border: 0;\n                        &:hover {\n                            background-color: #F6F7F8;\n                            transition: ease all 0.5s;\n                            -webkit-transition: ease all 0.5s;\n                            -ms-transition: ease all 0.5s;\n                        }\n                        .avatar {\n                            margin-right: 0.8rem;\n                            display: inline-block;\n                            margin-bottom: 0;\n                            height: 40px;\n                            width: 40px;\n                            position: relative;\n                            flex-shrink: 0;\n                            &::before {\n                                top: 0;\n                                bottom: inherit;\n                            }\n                            img {\n                                border-radius: 0px;\n                            }\n                        }\n                        .users-list-body {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            justify-content: space-between;\n                            -webkit-justify-content: space-between;\n                            -ms-flex-pack: space-between;\n                            flex-grow: 1;\n                            .name-list-user {\n                                display: grid;\n                                display: -webkit-box;\n                                display: -ms-flexbox;\n                                display: flex;\n                                align-items: center;\n                                -webkit-box-align: center;\n                                -ms-flex-align: center;\n                                h5 {\n                                    font-size: $font-size-15;\n                                    font-weight: $font-weight-normal;\n                                    margin-bottom: 2px;\n                                    color: $text-color;\n                                    white-space: nowrap;\n                                    overflow: hidden;\n                                    text-overflow: ellipsis;\n                                }\n                                p {\n                                    font-size: $font-size-12;\n                                    color: $danger;\n                                    display: -webkit-box;\n                                    display: -ms-flexbox;\n                                    display: flex;\n                                    align-items: center;\n                                    -webkit-box-align: center;\n                                    -ms-flex-align: center;\n                                    svg {\n                                        width: 14px;\n                                        height: 14px;\n                                    }\n                                }\n                            }\n                            .chat-user-time {\n                                .chats-dot {\n                                    a {\n                                        color: $danger;\n                                    }\n                                }\n                            }\n                            .last-chat-time {\n                                .text-muted {\n                                    font-size: $font-size-10;\n                                    color: $gray-900;\n                                    font-weight: $font-weight-medium;\n                                }\n                                .new-message-count {\n                                    width: 20px;\n                                    height: 20px;\n                                    display: flex;\n                                    display: -webkit-flex;\n                                    align-items: center;\n                                    -webkit-align-items: center;\n                                    justify-content: center;\n                                    -webkit-justify-content: center;\n                                    line-height: 0;\n                                    font-size: 11px;\n                                    background-color: $primary;\n                                    color: $white;\n                                    border-radius: 50%;\n                                    margin-left: auto;\n                                    margin-top: 5px;\n                                }\n                            }\n                            .last-call-time {\n                                display: -webkit-box;\n                                display: -ms-flexbox;\n                                display: flex;\n                                align-items: center;\n                                -webkit-box-align: center;\n                                -ms-flex-align: center;\n                                .call-recent {\n                                    a {\n                                        display: -webkit-box;\n                                        display: -ms-flexbox;\n                                        display: flex;\n                                        align-items: center;\n                                        -webkit-box-align: center;\n                                        -ms-flex-align: center;\n                                        justify-content: center;\n                                        -webkit-justify-content: center;\n                                        -ms-flex-pack: center;\n                                        width: 30px;\n                                        height: 30px;\n                                        background: #B8BCC9;\n                                        color: $gray-900;\n                                        border-radius: 50px;\n                                        svg {\n                                            color: $gray-900;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .slimScrollDiv {\n        height: calc(100vh - 110px) !important;\n        .slimscroll {\n            height: calc(100vh - 110px) !important;\n        }\n    }\n    .slime-grp {\n        background: $white;\n\t\tbox-shadow: 0px 4px 60px 0px #E7E7E778;\n\t\tborder: 1px solid #E1E8ED;\n        border-radius: 10px;\n        padding: 15px;\n        .left-chat-title {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin-bottom: 20px;\n\t\t\tbackground-color: $body-bg;\n            .chat-title {\n                h4 {\n                    font-size: $font-size-18;\n                    font-weight: $font-weight-semibold;\n                    color: $gray-900;\n                    margin-bottom: 0;\n                }\n            }\n            .contact-close_call {\n                .close_profile {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    width: 26px;\n                    height: 26px;\n                    background: transparent;\n                    border-radius: 50px;\n                    &:hover {\n                        background: $primary;\n                        svg {\n                            color: $white;\n                        }\n                    }\n                    svg {\n                        width: 16px;\n                        color: $danger;\n                    }\n                }\n            }\n        }\n\t\t.chat-footer {\n\t\t\tposition: sticky;\n\t\t\tleft: 0px;\n\t\t\tright: 0px;\n\t\t\tbottom: 0px;\n\t\t\tpadding: 15px;\n\t\t\tbackground: $white;\n\t\t\tform {\n\t\t\t\tdisplay: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n\t\t\t\tposition: relative;\n\t\t\t\t.comman-icon {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t-webkit-transform: translateY(-50%);\n\t\t\t\t\t-ms-transform: translateY(-50%);\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $text-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.smile-col {\n\t\t\t\t\tright: inherit;\n\t\t\t\t\tleft: 15px;\n\t\t\t\t}\n\t\t\t\t.attach-col {\n\t\t\t\t\tright: inherit;\n\t\t\t\t\tleft: 45px;\n\t\t\t\t}\n\t\t\t\t.micro-col {\n\t\t\t\t\tright: 50px;\n\t\t\t\t\tleft: inherit;\n\t\t\t\t\ta {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.send-chat {\n\t\t\t\t\tright: 5px;\n\t\t\t\t\ta {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n\t\t\t\t\t\twidth: 34px;\n\t\t\t\t\t\theight: 34px;\n\t\t\t\t\t\tbackground: $primary;\n\t\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: #1b2950;\n\t\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\twidth: 14px;\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat_form {\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t\tbackground: $white;\n\t\t\t\t\tborder: 1px solid rgba(145, 158, 171, 0.3);\n\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\theight: 48px;\n\t\t\t\t\tpadding: 10px 70px;\n\t\t\t\t\t&::placeholder {\n\t\t\t\t\t\tfont-size: $font-size-base;\n\t\t\t\t\t\tcolor: rgba(0, 0, 0, 0.2);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n    }\n}\n.owl-carousel.video-slide {\n    .owl-nav.disabled {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        width: 100%;\n    }\n    .owl-nav {\n        top: 50%;\n        -webkit-transform: translate(0, -50%);\n        -ms-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n        @include respond-below(custom1280) {\n            width: 100%;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n        }\n        button.owl-next, button.owl-prev {\n            background-color: #D9D9D9;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &:hover {\n                background-color: $primary;\n                i {\n                    color: $white;\n                }\n            }\n            i {\n                color: $text-color;\n            }\n        }\n    }\n}\n.audio-call-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    height: 100%;\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: space-evenly;\n        -webkit-justify-content: space-evenly;\n        -ms-flex-pack: space-evenly;\n        width: 100%;\n        li {\n            position: relative;\n            &.active {\n                .avatar {\n                    &::before {\n                        content: \"\";\n                        width: 250px;\n                        height: 250px;\n                        position: absolute;\n                        border: 1px solid $primary;\n                        border-radius: 50%;\n                        left: -25px;\n                        top: -25px;\n                        @include respond-below(custom991) {\n                            width: 150px;\n                            height: 150px;\n                            left: -10px;\n                            top: -10px;\n                        }\n                        @include respond-below(custom767) {\n                            width: 100px;\n                            height: 100px;\n                            left: -5px;\n                            top: -5px;\n                        }\n                    }\n                }\n            }\n            .avatar {\n                width: 200px;\n                height: 200px;\n                margin: 0;\n                position: relative;\n                @include respond-below(custom991) {\n                    width: 130px;\n                    height: 130px;\n                }\n                @include respond-below(custom767) {\n                    width: 90px;\n                    height: 90px;\n                }\n                img {\n                    width: 100%;\n                    position: relative;\n                }\n            }\n            .user-audio-call {\n                h5 {\n                    font-size: $font-size-14;\n                    color: $white;\n                    font-weight: $font-weight-normal;\n                    text-transform: capitalize;\n                    text-align: center;\n                    margin-top: 35px;\n                    @include respond-below(custom767) {\n                        margin-top: 15px;\n                    }\n                }\n            }\n            .more-icon {\n                position: absolute;\n                bottom: 10px;\n                right: inherit;\n                left: 50%;\n                -webkit-transform: translate(-50%, -50%);\n                -ms-transform: translate(-50%, -50%);\n                transform: translate(-50%, -50%);\n                z-index: 9;\n                @include respond-below(custom767) {\n                    bottom: 0px;\n                }\n                a {\n                    background-color: $primary;\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n.audio-volume {\n    position: absolute;\n    width: fit-content;\n    height: 134px;\n    bottom: 20px;\n    left: 20px;\n    background: $gray-300;\n    border-radius: 50px;\n    padding: 10px 14px;\n    width: 30px;\n    padding-bottom: 30px;\n    .volume-icons {\n        a {\n            position: absolute;\n            bottom: 0;\n            width: 30px;\n            height: 30px;\n            left: 0;\n            border-radius: 50px;\n            background: $white;\n            border: 1px solid $warning;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n}\n.custom-input {\n    width: 100%;\n    height: 4px;\n    width: 3px;\n    height: 100%;\n    background: $white;\n    border-radius: 5px;\n    writing-mode: vertical-lr;\n}\n.custom-input::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 12px;\n    height: 12px;\n    background: $primary !important;\n    border-radius: 50%;\n    cursor: pointer;\n}\n.custom-input::-moz-range-thumb {\n    width: 12px;\n    height: 12px;\n    background: $primary !important;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.table-top-head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    &.low-stock-top-head {\n        @include respond-below(custom575) {\n            flex-wrap: wrap;  \n           justify-content: start;\n        }\n        li {\n            margin-bottom: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n    li {\n        margin-right: 10px;\n        flex-shrink: 0;\n        &:last-child {\n            margin-right: 0;\n        }\n        #collapse-header {\n            margin-right: 0;\n            @include respond-below(custom991) {\n                display: none;\n            }\n        }\n        a {\n            height: 38px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $gray-300;\n            background: $white;\n            border-radius: 8px;\n            padding: 6px;\n            svg {\n                color: $gray-900;\n            }\n            &:hover {\n                background: #e3e3e3;\n            }\n            label {\n                margin-right: 10px;\n            }\n            &.btn-secondary {\n                background-color: $gray-900;\n                color: $white;\n                padding: 10px;\n                font-weight: $font-weight-bold;\n                font-size: $font-size-base;\n                &:hover {\n                    background-color: $primary;\n                }\n                svg {\n                    width: 16px;\n                    margin-right: 5px;\n                    color: $white;\n                }\n                @include respond-below(custom767) {\n                    padding: 5px;\n                    font-size: $font-size-base;\n                }\n            }\n            .action-edit.sales-action {\n                color: $blue;\n            }\n        }\n        .status-toggle {\n            height: 38px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $gray-100;\n            background: $white;\n            border-radius: 8px;\n            padding: 6px 10px;\n            label {\n                margin-right: 10px;\n            }\n        }\n    }\n}",".main-chat-blk {\n    .slimscroll {\n\t\theight: calc(100vh - 60px) !important;\n    }\n    .slimscroll-active-sidebar {\n        a {\n            color: $text-color;\n        }\n    }\n\n    .emoj-group ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n    }\n    .emoj-group ul li+li {\n        margin-left: 10px;\n    }\n    .emoj-group ul li a {\n        width: 34px;\n        height: 34px;\n        background: #f6f7f8;\n        border-radius: 50px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n    }\n    .emoj-group ul li a i {\n        color: #424242;\n    }\n    .message-content {\n        position: relative;\n    }\n    .message-content:hover .emoj-group {\n        opacity: 1;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        \n    }\n    .emoj-group {\n        position: absolute;\n        top: 50%;\n        right: -100px;\n        opacity: 0;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        -webkit-transform: translate(0, -50%);\n        -ms-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n    }\n    .rig-emoji-group {\n        position: absolute;\n        right: 210px;\n    }\n    .wrap-emoji-group {\n        position: absolute;\n        right: 290px;\n    }\n    .emoj-group-list-foot {\n        display: none;\n        position: absolute;\n        top: -50px;\n        left: -90px;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n    }\n    .emoj-group-list-foot ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        background: #f6f7f8;\n        border-radius: 50px;\n        padding: 5px;\n    }\n    .emoj-group-list-foot ul li a {\n        padding: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n    }\n    .emoj-group-list-foot ul li.add-emoj a {\n        background: #EDEDED;\n    }\n    .emoj-group-list-foot ul li.add-emoj a i {\n        font-size: $font-size-20;\n        color: #424242;\n    }\n\n    .down-emoji-circle {\n        position: absolute;\n        left: 10px !important;\n        top: -38px !important;\n    }\n    .emoj-action-foot .down-emoji-circle ul {\n        padding: 10px;\n    }\n    .down-emoji-circle ul li + li {\n        margin-left: 14px\t;\n    }\n    .emoj-action-foot .down-emoji-circle ul li:last-child a {\n        width: 34px;\n        height: 34px;\n        border-radius: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\t.chat-page-wrapper {\n\t\t.content {\n\t\t\tpadding: 24px 0 0 24px;\n\t\t}\n\t\t.sidebar {\n\t\t\tposition: initial;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t\t.left-chat-title {\n\t\t\tpadding: 12px;\n\t\t\tborder-bottom: 1px solid #E0E0E0;\n\t\t\tmin-height: 72px;\n\t\t}\n\t\t.setting-title-head {\n\t\t\th4 {\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t}\n\t\t}\n\t\t.chat .slimscroll {\n\t\t\theight: calc(100vh - 135px) !important;\n\t\t}\n\t\t.dropdown-menu .dropdown-item {\n\t\t\tfont-size: $font-size-14;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 7px 14px;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t.dropdown-menu .dropdown-item i {\n\t\t\tfont-size: $font-size-16;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item span {\n\t\t\tfloat: right;\n\t\t\tfont-size: $font-size-18;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item.active {\n\t\t\tbackground: none;\n\t\t\tcolor: inherit;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item:focus,\n\t\t.dropdown-menu .dropdown-item:hover,\n\t\t.dropdown-menu .dropdown-item:active {\n\t\t\tbackground-color: #e6e6e6;\n\t\t}\n\t\t.dropdown-menu {\n\t\t\tbackground: $white;\n\t\t\tborder: 1px solid #E5E7EB;\n\t\t\tbox-sizing: border-box;\n\t\t\tbox-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);\n\t\t\tborder-radius: 8px;\n\t\t\tmin-width: 173px;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item {\n\t\t\tmargin: 0;\n\t\t\tposition: relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t\t.dropdown-menu.chat-drop-menu .dropdown-item i {\n\t\t\tfont-size: $font-size-16;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t.dropdown-menu .dropdown-item:hover,\n\t\t.dropdown-menu .dropdown-item:focus,\n\t\t.dropdown-menu .dropdown-item:active {\n\t\t\tbackground-color: #F8ECFF;\n\t\t}\n\t\t.dropdown-menu .dropdown-item span {\n\t\t\tmargin-right: 10px;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t\t.contact-close_call {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t}\n    \t\t\n@-webkit-keyframes wave {\n\t0%,100%,60% {\n\t\t-webkit-transform: initial;\n\t\ttransform: initial;\n\t}\n\t30% {\n\t\t-webkit-transform: translateY(-5px);\n\t\ttransform: translateY(-5px);\n\t}\n}\n@keyframes wave {\n\t0%,100%,60% {\n\t\t-webkit-transform: initial;\n\t\ttransform: initial;\n\t}\n\t30% {\n\t\t-webkit-transform: translateY(-5px);\n\t\ttransform: translateY(-5px);\n\t}\n}\n.chat {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\tbackground: $white;\n\t.chat-header {\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\tpadding: 15px 24px;\n\t\talign-items: center;\n        border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n        background: var(--White, #FFF);\n        box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n\t\tposition: relative;\n\t\t.user-details {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\tfigure {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t\th5 {\n\t\t\t\tfont-size: $font-size-15;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tmargin-bottom: 4px;\n\t\t\t\tline-height: 1;\n\t\t\t\tcolor: $gray-900;\n\t\t\t}\n\t\t}\n\t\t.chat-options {\n\t\t\tul {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\t>li {\n\t\t\t\t\t>a {\n\t\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\twidth: 40px;\n\t\t\t\t\t\theight: 40px;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:not(.no-bg) {\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground-color: $gray-100;\n\t\t\t\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chat-body {\n\t\tflex: 1;\n\t\tpadding: 24px;\n\t\tpadding-bottom: 40px;\n\t\t&:not(.no-message) {\n\t\t\toverflow: hidden;\n\t\t}\n\t\t.messages {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tflex-direction: column;\n\t\t\t-webkit-flex-direction: column;\n\t\t\talign-items: flex-start;\n\t\t\t-webkit-align-items: flex-start;\n\t\t\t.chats {\n\t\t\t\tmax-width: 75%;\n\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\t.chat-time {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t.avatar {\n\t\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t\t}\n\t\t\t\t\th5 {\n\t\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\t\t\t\t\t.time {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tmargin-top: 2px;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: rgba(247, 247, 247, 0.5);\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\twidth: 14px;\n\t\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\t\tmargin-left: 2px;\n\t\t\t\t\t\t\t\tvertical-align: 0px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content {\n\t\t\t\t\tborder-radius: 0px 15px 15px 15px;\n                    background: var(--light-color, #F6F7F8);\n\t\t\t\t\tpadding: 14px 20px;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tbox-shadow: 0px 6px 12px 0px #00000008;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $cyan;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.award-link {\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t\timg {\n\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.chat-award-link {\n\t\t\t\t\ta {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.fancy-msg-box {\n\t\t\t\t\t.image-not-download {\n\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\t\t\t-ms-transform: translate(-50%, -50%);\n\t\t\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chat-profile-name {\n\t\t\t\th6 {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chats.chats-right {\n\t\t\t\tmargin-left: auto;\n\t\t\t\t.chat-time {\n\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t}\n\t\t\t\t.message-content {\n\t\t\t\t\tborder-radius: 15px 0px 15px 15px;\n                    background: rgba(255, 159, 67, 0.12);\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tpadding: 15px;\n\t\t\t\t\t.chat-time {\n\t\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t\t-webkit-justify-content: flex-start;\n\t\t\t\t\t\t.time {\n\t\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\t\ti {\n\t\t\t\t\t\t\t\tcolor: $cyan;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-action-btns {\n\t\t\t\t\torder: 2;\n\t\t\t\t\t-webkit-order: 2;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\t-webkit-flex-wrap: wrap;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t.chat-action-col {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t}\n\t\t\t\t\t.chat-read-col {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\t\talign-items: flex-end;\n\t\t\t\t\t\t-webkit-align-items: flex-end;\n\t\t\t\t\t\tpadding-bottom: 22px;\n\t\t\t\t\t\tcolor: $gray-600;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-content {\n\t\t\t\t\torder: 1;\n\t\t\t\t\t-webkit-order: 1;\n\t\t\t\t}\n\t\t\t\t.chat-avatar {\n\t\t\t\t\tpadding: 8px 0px 0 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.download-col {\n\t\t\t\tposition: relative;\n\t\t\t\tul {\n\t\t\t\t\tlist-style: none;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 0 0 5px 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tli+li {\n\t\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.image-download-col {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ta {\n\t\t\t\t\t\t>img {\n\t\t\t\t\t\t\tborder: 1px solid transparent;\n\t\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.image-download-col.image-not-download {\n\t\t\t\t\ta {\n\t\t\t\t\t\t>img {\n\t\t\t\t\t\t\t-webkit-filter: blur(1px);\n\t\t\t\t\t\t\tfilter: blur(1px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.download-action {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 8px;\n\t\t\t\t\tbottom: 8px;\n\t\t\t\t\tline-height: 0;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv+div {\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv {\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.file-download {\n\t\t\t\t.download-action {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 8px;\n\t\t\t\t\tbottom: 8px;\n\t\t\t\t\tline-height: 0;\n\t\t\t\t\tbottom: 14px;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t}\n\t\t\t\t\tdiv+div {\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv {\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tposition: relative;\n\t\t\t\tbackground: $light-900;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tpadding: 10px;\n\t\t\t\tmargin-bottom: 7px;\n\t\t\t\t.file-type {\n\t\t\t\t\twidth: 54px;\n\t\t\t\t\theight: 54px;\n\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\ti {\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tfont-size: $font-size-24;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.file-details {\n\t\t\t\t\tspan.file-name {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t}\n\t\t\t\t\tspan.file-size {\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\tul {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\tlist-style: none;\n\t\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\t\theight: 13px;\n\t\t\t\t\t\t\t\tbackground: #C2C2C2;\n\t\t\t\t\t\t\t\tright: -8px;\n\t\t\t\t\t\t\t\ttop: 5px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tli+li {\n\t\t\t\t\t\t\tpadding-left: 15px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chat-body.no-message {\n\t\tuser-select: none;\n\t}\n\t.chat-footer {\n\t\tposition: relative;\n\t\tform {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tpadding: 24px;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tpadding-bottom: 15px;\n\t\t\t}\n\t\t\t.form-buttons {\n\t\t\t\t.btn {\n\t\t\t\t\tmargin-left: 0px;\n\t\t\t\t\tcolor: $gray-400;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.btn.send-btn {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tborder-radius: 6px;\n                    background: $primary;\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\t\tborder-color: $gray-800;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.specker-col {\n\t\t\t\tspan {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.attach-col {\n\t\t\t\ti {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t}\n\t\t\t\tright: inherit;\n\t\t\t\tleft: 60px;\n\t\t\t}\n\t\t\t.smile-col {\n\t\t\t\ti {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\tfont-size: $font-size-22;\n\t\t\t\t}\n\t\t\t\tright: inherit;\n\t\t\t\tleft: 15px;\n\t\t\t}\n\t\t\t.smile-foot {\n\t\t\t\tmargin-right: 10px;\n\t\t\t\t.action-circle {\n\t\t\t\t\twidth: 38px;\n\t\t\t\t\theight: 38px;\n\t\t\t\t\tbackground: $white;\n\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: $gray-100;\n\t\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t\t}\n\t\t\t\t\ti {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tfont-size: $font-size-18;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.form-control {\n\t\t\t\t&::-webkit-input-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&::-moz-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&:-ms-input-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&:-moz-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n}\n.chat-options {\n\tul.list-inline {\n\t\t.list-inline-item {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n.last-seen {\n\tcolor: $gray-900;\n\tfont-size: $font-size-14;\n}\n.user_callog {\n\tdisplay: flex;\n\tmargin-top: 0px;\n}\n.calllog_p {\n\tmargin-left: 5px;\n}\n.chat-options.chat-option-profile {\n\t.list-inline-item {\n\t\ta {\n\t\t\tbackground: $primary;\n\t\t\twidth: 38px;\n\t\t\theight: 38px;\n\t\t\tborder-radius: 50px;\n\t\t\tcolor: $gray-900;\n\t\t\tpadding: 0;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tcolor: $white !important; \n\t\t\t&:hover {\n\t\t\t\tbackground: #1b2950;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n\t.list-inline {\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tmargin-bottom: 0;\n\t\tpadding-bottom: 15px;\n\t}\n}\n.last-seen-profile {\n\tspan {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-normal;\n\t\tmargin-bottom: 12px;\n\t\tdisplay: block;\n\t}\n}\n.header_button {\n\tposition: absolute;\n\tright: 5px;\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 20px;\n\tfont-size: $font-size-14;\n\tcolor: $white;\n\ttext-align: center;\n\tbackground: #ffa977;\n\tbottom: 40px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n}\n.btn-warning {\n\t&:hover {\n\t\tcolor: $white;\n\t\tbackground-color: $primary-800;\n\t\tborder-color: $primary-900;\n\t}\n}\n.right_sidebar_profile {\n\tmargin-top: 0px;\n}\n.account_details {\n\tbackground-color: $gray-300;\n\tborder-color: $gray-400;\n\tborder-radius: 5px !important;\n\tborder-bottom: 0 !important;\n}\n.security_details {\n\tbackground-color: $gray-300;\n\tborder-color: $gray-400;\n\tborder-radius: 5px !important;\n\tborder-bottom: 0 !important;\n}\n.close_icon {\n\tfont-size: $font-size-18;\n}\n.button_plus {\n\tmargin-left: 0px;\n}\n.chat-search {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\topacity: 0;\n\tvisibility: hidden;\n\tinput[type=\"text\"] {\n\t\tpadding: 8px 8px 8px 35px;\n\t\twidth: 100%;\n\t\tmin-height: 47px;\n\t\tborder-radius: 0px 0px 5px 5px;\n\t\tborder: 1px solid #E5E7EB;\n\t\tfont-size: 13px;\n\t\tbackground-color: $white;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\t&:hover {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus-visible {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t}\n}\n.chat-search.visible-chat {\n\topacity: 1;\n\tvisibility: visible;\n\ttop: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\tz-index: 9;\n}\n.form-control-feedback {\n\tz-index: 2;\n\tdisplay: block;\n\ttext-align: center;\n\tpointer-events: none;\n\tcolor: rgba(0, 0, 0, 0.4);\n\tposition: absolute;\n\tleft: 13px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ti {\n\t\tfont-size: $font-size-16;\n\t\tcolor: $gray-900;\n\t}\n}\n.user-chat-search {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\topacity: 0;\n\tvisibility: hidden;\n\tinput[type=\"text\"] {\n\t\tpadding: 8px 8px 8px 35px;\n\t\twidth: 100%;\n\t\tmin-height: 47px;\n\t\tborder-radius: 0px 0px 5px 5px;\n\t\tborder: 1px solid #E5E7EB;\n\t\tfont-size: 13px;\n\t\tbackground-color: $white;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\t&:hover {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus-visible {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t}\n}\n.user-chat-search.visible-chat {\n\topacity: 1;\n\tvisibility: visible;\n\ttop: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\tz-index: 9;\n}\n.all-chats {\n\tposition: relative;\n}\n.close-btn-chat {\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 25px;\n\tcolor: $gray-900;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 9px;\n\tcursor: pointer;\n}\n.user-close-btn-chat {\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 25px;\n\tcolor: $gray-900;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 9px;\n\tcursor: pointer;\n}\n.main_content {\n\twidth: 100% !important;\n}\n.avatar-main {\n\theight: 50px;\n\twidth: 50px;\n}\n.archive-btn {\n\tborder: 1px solid #008024;\n\tcolor: $gray-600;\n\tborder-radius: 4px;\n\tfont-size: 11px;\n\tfont-weight: $font-weight-medium;\n\tpadding: 2px 6px;\n\tmargin-right: 1.5rem;\n}\n.archive-btn-grey {\n\tborder: 1px solid #909090;\n\tcolor: $gray-500;\n\tborder-radius: 4px;\n\tfont-size: 9px;\n\tfont-weight: $font-weight-medium;\n\tpadding: 2px 6px;\n\tmargin-top: .25rem;\n}\n.right_sidebar_icon {\n\tlist-style: none;\n}\n.btn.btn-outline-light {\n\t&:hover {\n\t\tbackground: #e6e6e6;\n\t}\n}\n.chat-avatar {\n\tpadding: 8px 15px 0 8px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: flex-start;\n\t-webkit-align-items: flex-start;\n\tflex-shrink: 0;\n}\n.chat-profile-name {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 5px;\n\t.chat-action-col {\n\t\ta {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n}\n.delete-pop-btn {\n\t.btn-primary {\n\t\tmargin: 0 0 0 10px;\n\t}\n}\n.delete-model-head {\n\tpadding: 40px;\n\t.modal-header {\n\t\tpadding: 0;\n\t\tmargin-bottom: 32px;\n\t}\n\t.modal-body {\n\t\tpadding: 0;\n\t}\n}\n.delete-chat-notify {\n\tmargin-bottom: 32px;\n\t.form-check {\n\t\tmargin-bottom: 14px;\n\t}\n}\n.chats.chats-right {\n\tflex-direction: row-reverse;\n\t-webkit-flex-direction: row-reverse;\n}\n.message-star {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t.avatar {\n\t\twidth: 26px;\n\t\theight: 26px;\n\t\tmargin-right: 10px;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\th6 {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tmargin-bottom: 0;\n\t\tspan {\n\t\t\ti {\n\t\t\t\tcolor: $warning-700;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat-voice-group {\n\tul {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tli {\n\t\t\tspan {\n\t\t\t\twidth: 28px;\n\t\t\t\theight: 28px;\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t}\n\t\t}\n\t}\n\tli {\n\t\tmargin-bottom: 0;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-normal;\n\t\tlist-style: none;\n\t}\n\tli+li {\n\t\tpadding-left: 10px;\n\t}\n}\n.file-download-col {\n\t.download-action {\n\t\tposition: absolute;\n\t\tright: 8px;\n\t\tbottom: 8px;\n\t\tline-height: 0;\n\t\ta {\n\t\t\tcolor: $white;\n\t\t\tfont-size: 10px;\n\t\t}\n\t\tdiv+div {\n\t\t\tmargin-left: 8px;\n\t\t}\n\t\tdiv {\n\t\t\timg {\n\t\t\t\twidth: 13px;\n\t\t\t}\n\t\t}\n\t}\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tfloat: left;\n\t\t\twidth: 50%;\n\t\t\tpadding: 5px;\n\t\t\t.image-download-col {\n\t\t\t\tposition: relative;\n\t\t\t\ta {\n\t\t\t\t\t>img {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli.full-width {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n.chat-select {\n\t.select2-container {\n\t\t.select2-selection--single {\n\t\t\tborder: 0;\n\t\t\theight: 24px;\n\t\t\t.select2-selection__rendered {\n\t\t\t\tpadding-right: 40px;\n\t\t\t\tpadding-left: 0px;\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--default {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__rendered {\n\t\t\t\tcolor: $gray-500;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tline-height: 24px;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t}\n\t\t\t.select2-selection__arrow {\n\t\t\t\theight: 24px;\n\t\t\t\tright: 7px;\n\t\t\t\tb {\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t\theight: 0;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\tmargin-left: -5px;\n\t\t\t\t\tmargin-top: -5px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\twidth: 0;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t-webkit-transform: rotate(45deg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.select2-results__option--highlighted[aria-selected] {\n\t\t\tbackground-color: $gray-900;\n\t\t}\n\t\t.select2-selection--multiple {\n\t\t\tborder: 1px solid #ddd;\n\t\t\tmin-height: 40px;\n\t\t}\n\t}\n\t.select2-container--default.select2-container--open {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__arrow {\n\t\t\t\tb {\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-width: 2px 0 0 2px;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t\tmargin-top: -5px;\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--default.form-control-sm {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__arrow {\n\t\t\t\ttop: 7px;\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--open {\n\t\t.select2-dropdown--below {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n}\n.success-pass {\n\tmargin-bottom: 40px;\n\ttext-align: center;\n}\n.review-files {\n\tp {\n\t\tmargin-bottom: 5px;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t}\n}\n.like-chat-grp {\n\tul {\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\tmargin-top: 10px;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\ta {\n\t\t\t\tborder: 1px solid #E0E0E0;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tpadding: 3px 12px;\n\t\t\t\tdisplay: block;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\tfont-size: $font-size-14;\n\t\t\t\timg {\n\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\tli.like-chat {\n\t\t\ta {\n\t\t\t\tbackground: #FEF6DC;\n\t\t\t}\n\t\t}\n\t\tli.comment-chat {\n\t\t\ta {\n\t\t\t\tbackground: #FFE8E9;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat-line {\n\tmargin: 0px 0 20px;\n\tposition: relative;\n\ttext-align: center;\n\twidth: 100%;\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\t-webkit-transform: translateY(-50%);\n\t\t-ms-transform: translateY(-50%);\n\t\tbackground-color: $light-900;\n\t\twidth: 100%;\n\t\theight: 1px;\n\t}\n}\n.chat-date {\n\tborder-radius: 100px;\n    background: $light-900;\n\tcolor: $gray-900;\n\tfont-size: $font-size-14;\n\tpadding: 4px 20px;\n\tdisplay: inline-block;\n\tfont-weight: $font-weight-normal;\n\tposition: relative;\n\tborder: 1px solid #E0E0E0;\n}\n.chat+.sidebar-group {\n\tmargin-right: 0px;\n\t.sidebar {\n\t\tmargin-right: 0px;\n\t}\n}\n.group-comman-theme {\n\tpadding: 0 24px;\n\th6 {\n\t\tmargin-bottom: 15px;\n\t}\n\tul {\n\t\tpadding: 0;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 15px;\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tli {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tlist-style: none;\n\t\t\tborder: 1px solid #E0E0E0;\n\t\t\tborder-radius: 5px;\n\t\t\tpadding: 5px;\n\t\t\tmargin-bottom: 10px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t\t.avatar {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t}\n}\n.theme-content {\n\th6 {\n\t\tmargin-bottom: 6px;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t}\n\tp {\n\t\tmargin-bottom: 0;\n\t\ttext-align: start;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: -webkit-box;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t}\n}\n.chat-message-grp {\n\tpadding: 24px;\n\tpadding-top: 0;\n\tul {\n\t\tpadding: 0;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tmargin-bottom: 15px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t\ta {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t&:hover {\n\t\t\t\t\t.stared-group {\n\t\t\t\t\t\th6 {\n\t\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.stared-group {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tborder-radius: 6px;\n\t\tmargin-right: 10px;\n\t\tbackground: #F6F7F8;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\ti {\n\t\t\tfont-size: $font-size-16;\n\t\t}\n\t}\n\th6 {\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tcolor: $text-color;\n\t\tmargin-bottom: 0;\n\t}\n}\n.star-message {\n\tbackground: #FEF6DC;\n\ti {\n\t\tcolor: $warning-700;\n\t}\n}\n.mute-message {\n\tbackground: #EBFDFFFA;\n\ti {\n\t\tcolor: $cyan;\n\t}\n}\n.block-message {\n\tbackground: #FFE8E9;\n\ti {\n\t\tcolor: $purple;\n\t}\n}\n.report-message {\n\tbackground: #F8ECFF;\n\ti {\n\t\tcolor: $gray-900;\n\t}\n}\n.delete-message {\n\tbackground: #FFE8E9;\n\ti {\n\t\tcolor: $danger-800;\n\t}\n}\n.count-group {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tborder-radius: 50px;\n\t\tcolor: $white;\n\t\tfont-size: 10px;\n\t\tbackground: $primary;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tmargin-right: 5px;\n\t}\n\ti {\n\t\tcolor: #424242;\n\t\tfont-size: $font-size-16;\n\t}\n}\n.nav.nav-tabs.chat-tabs {\n\t.nav-item {\n\t\t.nav-link {\n\t\t\tfont-size: $font-size-16;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: $white;\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t}\n\t\t.nav-link.active {\n\t\t\tfont-size: $font-size-16;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: $primary-800;\n\t\t}\n\t}\n}\n.header-top {\n\tul {\n\t\tli {\n\t\t\ta {\n\t\t\t\tcolor: $black;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t}\n\t\t}\n\t}\n}\n.set-search {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: $font-size-16;\n\tborder-radius: 50px;\n\twidth: 28px;\n\theight: 28px;\n\t&:hover {\n\t\tbackground: #F5F5F5;\n\t\tborder-color: $gray-100;\n\t}\n}\n.header-action {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tli {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 10px;\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-18;\n\t\t}\n\t}\n}\n.user-list {\n\tborder-radius: .25rem;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tpadding-left: 0;\n\tmargin-bottom: 0;\n\tli {\n\t\ta {\n\t\t\tpadding: 17px 20px;\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 6px;\n\t\t\tmargin-bottom: 10px;\n\t\t\tborder: 0;\n\t\t\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-right: 0.8rem;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-bottom: 0;\n\t\t\theight: 46px;\n\t\t\twidth: 46px;\n\t\t\tborder-radius: 50%;\n\t\t\tposition: relative;\n\t\t\tz-index: 0;\n\t\t\t.letter-avatar {\n\t\t\t\twidth: 45px;\n\t\t\t\theight: 45px;\n\t\t\t\tborder-radius: 45px;\n\t\t\t\tmargin-right: 0.8rem;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\tbackground-color: $gray-400;\n\t\t\t\tfont-size: $font-size-16;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tcolor: $violet;\n\t\t\t}\n\t\t}\n\t\ta.admin-shade {\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n\t.avatar {\n\t\t>a {\n\t\t\t>img {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\t\t>img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n}\n.avatar-away {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t\tbackground-color: $yellow;\n\t}\n}\n.avatar-offline {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t}\n}\n.avatar-online {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t\tbackground-color: $green;\n\t}\n}\n.animate-typing-col {\n\tcolor: $success;\n\t.dot {\n\t\tdisplay: inline-block;\n\t\twidth: 4px;\n\t\theight: 4px;\n\t\tborder-radius: 50%;\n\t\tmargin-right: -1px;\n\t\tbackground: #0D9B35;\n\t\t-webkit-animation: wave 1.3s linear infinite;\n\t\tanimation: wave 1.3s linear infinite;\n\t\topacity: .6;\n\t\t&:nth-child(2) {\n\t\t\t-webkit-animation-delay: -1.1s;\n\t\t\tanimation-delay: -1.1s;\n\t\t}\n\t\t&:nth-child(3) {\n\t\t\t-webkit-animation-delay: -.9s;\n\t\t\tanimation-delay: -.9s;\n\t\t}\n\t}\n}\n.chat_form {\n\tborder-radius: 20px;\n\tmargin-right: 0px;\n\tbackground: $white;\n\tborder: 1px solid #C2C2C2;\n\tbox-shadow: 0px 4px 4px #F5F8FF;\n\tborder-radius: 6px;\n\theight: 40px;\n\tpadding: 10px 10px;\n}\n.contact-close {\n\ta {\n\t\tcolor: $gray-900;\n\t\topacity: 0.5;\n\t\tborder-color: $gray-300;\n\t}\n}\n.main-wrapper {\n\t.content {\n\t\t.sidebar-group.right-sidebar {\n\t\t\t.sidebar {\n\t\t\t\twidth: 310px;\n\t\t\t}\n\t\t}\n\t}\n}\n.primary-title {\n\tcolor: $primary-800;\n\tfont-size: $font-size-14;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 0;\n\ti {\n\t\tfont-size: $font-size-14;\n\t}\n}\n.contact-action {\n\tpadding: 0;\n\tmargin: 0;\n\tlist-style: none;\n\tli {\n\t\tpadding: 11px 0;\n\t\tborder-bottom: 1px solid #f1f1f1;\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: bold;\n\t\t}\n\t}\n\tli.report-contact {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n\tli.delete-chat {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n\tli.sign-out {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n}\n.left-sidebar {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n}\n.left-sidebar-wrap {\n\tbackground: #FBFBFB;\n\toverflow: hidden;\n\twidth: 448px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tflex: 1;\n}\n.right-sidebar {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tbackground-color: $light;\n\topacity: 100%;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\tposition: relative;\n\twidth: 320px;\n\t.right-sidebar-wrap {\n\t\tbackground-color: $white;\n\t\tborder-left: 1px solid #E0E0E0;\n\t\tborder-radius: 0px;\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t\theight: calc(100vh - 0px);\n\t\t.sidebar-body {\n\t\t\tpadding: 0;\n\t\t}\n\t\t.right-sidebar-profile {\n\t\t\tpadding: 24px;\n\t\t\tpadding-bottom: 0;\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t}\n\t.contact-close_call {\n\t\t.close_profile {\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\tborder-radius: 25px;\n\t\t\tcolor: $gray-900;\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\t&.close-star {\n\t\t\t\tcolor: $warning;\n\t\t\t}\n\t\t\t&.close-trash {\n\t\t\t\tcolor: $danger;\n\t\t\t}\n\t\t}\n\t}\n}\n.right-sidebar.video-right-sidebar {\n\twidth: 371px;\n\t.chat {\n\t\t.chat-body {\n\t\t\tpadding-bottom: 110px;\n\t\t}\n\t\tmargin-left: 0 !important;\n\t\tdisplay: block;\n\t}\n}\n.video-call-chat {\n\t.left-chat-title.with-bg {\n\t\tbackground: transparent;\n\t}\n\t.left-chat-title {\n\t\tborder: 0;\n\t}\n\t.chat-title {\n\t\th4 {\n\t\t\tfont-size: $font-size-18;\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t}\n}\n.chat.video-call-chat {\n\t.chat-body {\n\t\tbackground-image: none;\n\t\t.messages {\n\t\t\t.chats {\n\t\t\t\t.message-content {\n\t\t\t\t\tbackground: #F5F5F5;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chats.chats-right {\n\t\t\t\t.message-content {\n\t\t\t\t\tbackground: #F8ECFF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.member-details {\n\tmargin-bottom: 10px;\n}\n.chat-member-details {\n\tpadding: 0 24px;\n\t.member-details {\n\t\tul {\n\t\t\tpadding: 0;\n\t\t\tborder-bottom: 1px solid #EDEDED;\n\t\t\tli {\n\t\t\t\tlist-style: none;\n\t\t\t\tmargin-bottom: 15px;\n\t\t\t\th6 {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t}\n\t\t\t\th5 {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t}\n\t\t\t\ta {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tborder-radius: 100px;\n\t\t\t\t\tpadding: 5px;\n\t\t\t\t\tbackground: #F5F5F5;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\ta+a {\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.right-sidebar.show-right-sidebar {\n\tmargin-right: 0;\n}\n.right-sidebar.video-right-sidebar.show-right-sidebar {\n\tmargin-right: 0;\n}\n.right-sidebar.hide-right-sidebar {\n\tmargin-right: -320px;\n}\n.right-sidebar.video-right-sidebar.hide-right-sidebar {\n\tmargin-right: -371px;\n}\n.status-modal {\n\t.custom-status-close {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tborder-radius: 25px;\n\t\tcolor: $gray-900;\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\talign-items: center;\n\t\t-webkit-align-items: center;\n\t\tbackground-color: $gray-100;\n\t\tborder-color: $gray-100;\n\t}\n}\n.group-description {\n\t.description-sub {\n\t\th5 {\n\t\t\tspan {\n\t\t\t\ta {\n\t\t\t\t\twidth: 25px;\n\t\t\t\t\theight: 25px;\n\t\t\t\t\tborder-radius: 25px;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.list_group_notread {\n\tcolor: $primary-800 !important;\n}\n.chat-cont-type {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t.chat-type-wrapper {\n\t\tmargin-bottom: 0;\n\t\tp {\n\t\t\tcolor: $gray-500;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n.group-type-radio {\n\tdisplay: block;\n\tposition: relative;\n\tpadding-left: 35px;\n\tcursor: pointer;\n\tfont-size: $font-size-22;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n\tcolor: $gray-900;\n\tmargin-right: 24px;\n\tinput {\n\t\tposition: absolute;\n\t\topacity: 0;\n\t\tcursor: pointer;\n\t\t&:checked {\n\t\t\t~ {\n\t\t\t\t.checkmark {\n\t\t\t\t\tbackground-color: $gray-800;\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.checkmark {\n\t\t&:after {\n\t\t\ttop: 4px;\n\t\t\tleft: 4px;\n\t\t\twidth: 12px;\n\t\t\theight: 12px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: white;\n\t\t}\n\t}\n}\n.checkmark {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 22px;\n\twidth: 22px;\n\tbackground-color: $white;\n\tborder: 1px solid #E4E4E4;\n\tborder-radius: 50%;\n\t&:after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: none;\n\t}\n}\n.pass-login {\n\tlabel {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.select2-container--default {\n\t.select2-results__option--highlighted[aria-selected] {\n\t\tbackground-color: $gray-800 !important;\n\t}\n}\n.right-sidebar-profile {\n\t>.avatar {\n\t\tbackground: rgba(66, 11, 161, 0.1);\n\t}\n}\n.group_img {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n.group-name-search {\n\tmargin-bottom: 14px;\n}\n.parti-wrapper {\n\tmargin-bottom: 14px;\n\tdisplay: flex;\n\talign-items: center;\n}\n.group_header {\n\twidth: 38px !important;\n\theight: 38px !important;\n\tborder: 2px solid $white;\n}\n.last-chat-time {\n\ti.missed-col {\n\t\twidth: 17px;\n\t\tdisplay: inline-block;\n\t\tmargin-top: 10px;\n\t\timg {\n\t\t\tmax-width: 100%;\n\t\t\theight: auto;\n\t\t}\n\t}\n}\n.right-sidebar-head {\n\tpadding: 0px 24px;\n\th5 {\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 0px;\n\t}\n}\n.right-sidebar-head.share-media {\n\t.share-media-blk {\n\t\tmargin-bottom: 20px;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t}\n\t.about-media-tabs {\n\t\t.nav-tabs {\n\t\t\tmargin-bottom: 15px;\n\t\t\tpadding: 5px;\n\t\t\tborder-radius: 8px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t}\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tpadding-bottom: 10px;\n\t\tmargin-bottom: 15px;\n\t\t.nav {\n\t\t\t.nav-item.active {\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t\t.nav-item {\n\t\t\t\tpadding: 2px 10px;\n\t\t\t\tfont-size: $font-size-14;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\tborder: 0;\n\t\t\t\tmargin-right: 10px;\n\t\t\t\tbackground: $body-bg;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.share-media-img {\n\t\t\tli {\n\t\t\t\tmargin: 0px 6px 6px 0px;\n\t\t\t\tposition: relative;\n\t\t\t\timg {\n\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\twidth: 84px;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\ti {\n\t\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\t-ms-transform: translate(-50%, -50%);\n\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\tspan {\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: $gray-300;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tli.blur-media {\n\t\t\t\timg {\n\t\t\t\t\tfilter: blur(2px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.media-file {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\tmargin-bottom: 15px;\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n.media-doc-blk {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tborder-radius: 5px;\n\t\tbackground: #F5F5F5;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tmargin-right: 10px;\n\t\ti {\n\t\t\tfont-size: $font-size-24;\n\t\t}\n\t}\n}\n.document-detail {\n\tul {\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tposition: relative;\n\t\t\t&::before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 1px;\n\t\t\t\theight: 13px;\n\t\t\t\tbackground: #C2C2C2;\n\t\t\t\tright: -8px;\n\t\t\t\ttop: 5px;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tpadding-left: 15px;\n\t\t}\n\t}\n\th6 {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.media-download {\n\ta {\n\t\tcolor: $gray-900;\n\t}\n}\n.social-media-col {\n\tmargin-top: 35px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tfloat: left;\n\t\t\ta {\n\t\t\t\tcolor: $violet;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n\th6 {\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $black;\n\t\tfont-size: $font-size-15;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.media-link-grp {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 15px;\n}\n.media-link-detail {\n\th6 {\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-15;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t}\n\tspan {\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tword-break: break-all;\n\t\t}\n\t}\n\ta {\n\t\t&:hover {\n\t\t\tcolor: $gray-800;\n\t\t}\n\t}\n}\n.share-media-blk {\n\ta {\n\t\tcolor: $gray-800;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.link-img {\n\tflex-shrink: 0;\n\timg {\n\t\tborder-radius: 4px;\n\t\tmargin-right: 10px;\n\t}\n}\n.settings-col {\n\th6 {\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $black;\n\t\tfont-size: $font-size-15;\n\t\tmargin-bottom: 20px;\n\t}\n\tmargin-top: 35px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tcolor: $gray-600;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 15px;\n\t\t}\n\t}\n\t.switch {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\twidth: 40px;\n\t\theight: 23px;\n\t\tmargin-bottom: 0;\n\t\tmargin-right: 10px;\n\t\tinput {\n\t\t\topacity: 0;\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t}\n\t.slider {\n\t\tposition: absolute;\n\t\tcursor: pointer;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tbackground-color: $gray-500;\n\t\t-webkit-transition: .4s;\n\t\ttransition: .4s;\n\t\t&:before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\theight: 15px;\n\t\t\twidth: 15px;\n\t\t\tleft: 4px;\n\t\t\tbottom: 4px;\n\t\t\tbackground-color: $white;\n\t\t\t-webkit-transition: .4s;\n\t\t\ttransition: .4s;\n\t\t}\n\t}\n\tinput {\n\t\t&:checked+.slider {\n\t\t\tbackground-color: $blue;\n\t\t\t&:before {\n\t\t\t\t-webkit-transform: translateX(16px);\n\t\t\t\t-ms-transform: translateX(16px);\n\t\t\t\ttransform: translateX(16px);\n\t\t\t}\n\t\t}\n\t\t&:focus+.slider {\n\t\t\tbox-shadow: 0 0 1px #2196F3;\n\t\t}\n\t}\n\t.slider.round {\n\t\tborder-radius: 34px;\n\t\t&:before {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n}\n.report-col {\n\tmargin-top: 35px;\n\tpadding: 12px;\n\tpadding-bottom: 50px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: table;\n\t\t\tclear: both;\n\t\t}\n\t\tli {\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tposition: relative;\n\t\t\ta {\n\t\t\t\tcolor: $danger;\n\t\t\t\tpadding-left: 25px;\n\t\t\t\tspan {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 19px;\n\t\t}\n\t}\n}\n.load-more-btn {\n\tfont-weight: $font-weight-semibold;\n\tmargin-top: 10px;\n\ti {\n\t\tbackground: #0057FF;\n\t\tborder-radius: 50%;\n\t\theight: 12px;\n\t\twidth: 12px;\n\t\tcolor: $white;\n\t\tline-height: 8px;\n\t\tfont-size: 12px;\n\t\tvertical-align: top;\n\t}\n}\n.chat-message-grp.chat-encrypt {\n\tpadding-bottom: 0;\n\tul {\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 15px;\n\t}\n}\n.participants-list {\n\tpadding: 0px 24px;\n\t.participants-list-group {\n\t\th6.parti-search {\n\t\t\tfont-size: 20px !important;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tborder: 1px solid #E0E0E0;\n\t\t\tborder-radius: 5px;\n\t\t\tbackground-color: $white;\n\t\t\tpadding: 10px;\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n\t.users-list-body {\n\t\th5 {\n\t\t\twhite-space: nowrap;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\tfont-size: $font-size-15;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tmargin-bottom: 5px;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t\tp {\n\t\t\twhite-space: nowrap;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\tmargin-bottom: 0;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t}\n\t\tflex: 1;\n\t\tposition: relative;\n\t\tmin-width: 0px;\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\twidth: 100%;\n\t}\n\t.admin-profiles {\n\t\tdisplay: inline-block;\n\t\tcolor: $gray-800;\n\t\tborder-radius: 6px;\n\t\tfont-size: 12px;\n\t\tpadding: 2px 10px;\n\t\tfont-weight: $font-weight-medium;\n\t\tbackground: #F8ECFF;\n\t\t&:hover {\n\t\t\tbackground: #680A83;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n}\n.participants-list-group {\n\tborder-bottom: 1px solid #EDEDED;\n\tpadding-bottom: 15px;\n\tmargin-bottom: 15px;\n\th6 {\n\t\tmargin-bottom: 15px;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tcolor: $gray-900;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t}\n}\n.chat-message-grp.group-exits {\n\tpadding: 0px 24px;\n\tpadding-bottom: 30px;\n}\n.grp-delete {\n\t.chat-action-col {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 100%;\n\t\t>a {\n\t\t\tcolor: $gray-500;\n\t\t}\n\t}\n}\n.chat-action-col {\n\t>a {\n\t\tcolor: $gray-900;\n\t}\n}\n.darkmode-btn {\n\twidth: 35px;\n\theight: 32px;\n\tbackground-color: $blue;\n\tborder: 1px solid #FBFBFB;\n\tborder-radius: 5px;\n\tcolor: $white;\n\tfont-size: $font-size-16;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tmargin: 0 auto;\n\t&:hover {\n\t\tcolor: $white;\n\t}\n\t&:focus {\n\t\tcolor: $white;\n\t}\n}\n.add-contacts-btn {\n\t&:hover {\n\t\tcolor: $white;\n\t}\n\t&:focus {\n\t\tcolor: $white;\n\t}\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 30px;\n\tbackground-color: $gray-800;\n\tcolor: $white;\n\tfont-size: 10px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tmargin: 0 auto;\n}\n.group-call-tab {\n\t.nav-tabs {\n\t\t.nav-link {\n\t\t\tcolor: $gray-800;\n\t\t\tborder: 0;\n\t\t\tborder-radius: 10px;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tpadding: 6px 25px;\n\t\t\t&:hover {\n\t\t\t\tcolor: $gray-800;\n\t\t\t}\n\t\t}\n\t\t.nav-link+.nav-link {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t.nav-link.active {\n\t\t\tbackground-color: rgba(90, 7, 139, 0.1);\n\t\t\tcolor: $gray-800;\n\t\t}\n\t}\n\tnav {\n\t\tpadding: 0 15px 20px;\n\t\tposition: relative;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\tbottom: 0;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: $gray-400;\n\t\t\theight: 1px;\n\t\t}\n\t}\n}\n\n.header_image {\n\twidth: 195px;\n}\n\n.chat_avator_img {\n\tposition: relative;\n}\n\n.group_img {\n\twidth: 40px;\n\theight: 40px;\n\tobject-fit: cover;\n}\n\n.dreams_chat {\n\twidth: 40px;\n\theight: 40px;\n\tobject-fit: cover;\n}\n\n.voice_pop {\n\tpadding-right: 17px;\n}\n\n.status_carousel {\n\tmargin-top: 50px;\n}\n\n.carousel_img {\n\twidth: 650px;\n\theight: 434px;\n}\n\n.video_content {\n\tmin-height: 200px;\n\tmargin-top: 70px;\n}\n\n.voice-call-content {\n\tmin-height: 200px;\n}\n\n.chatimage img {\n\twidth: 120px;\n\theight: 120px;\n}\n\n.send-btn_status {\n\twidth: 52px;\n\theight: 52px;\n\tborder-radius: 50%;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: $white !important;\n\tbackground-color: #FFA977 !important;\n\tmargin-left: 15px;\n\tfont-size: $font-size-22;\n}\n\n.status_telegram {\n\tcolor: $white;\n}\n\n.media-lists {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tmargin: 0 -5px 0px;\n\tflex-wrap: wrap;\n}\n\n.media-lists .media-image {\n\tmargin: 5px;\n\tflex-basis: 74px;\n\tmin-width: 74px;\n}\n\n.media-lists .media-image img {\n\tmax-width: 100%;\n}\n\n.avatar-group .avatar+.avatar {\n\tmargin-left: -.75rem;\n}\n\n.list-group-item {\n\tbackground-color: inherit;\n\tborder-color: #ebebeb;\n}\n\nul.list-inline .list-inline-item {\n\tmargin-bottom: .5rem;\n}\n\n.form-control {\n\tborder-radius: 5px;\n}\n\n.form-control:focus {\n\tbox-shadow: none;\n\tborder-color: #e6e6e6;\n}\n\n.custom-control-label {\n\tline-height: 25px;\n}\n\n.custom-control-input:checked~.custom-control-label::before {\n\tbackground-color: #0a80ff;\n}\n\n.open_drop {\n\tcolor: $white !important;\n}\n\n.send-btn_status:focus {\n\tbox-shadow: none !important;\n\tborder-color: #ffa977 !important;\n}\n\n.avatar {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\theight: 48px;\n\twidth: 48px;\n\tborder-radius: 50%;\n}\n\n.avatar .avatar-title {\n\tcolor: $white;\n\tbackground: #680A83;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-transform: uppercase;\n\tfont-size: 19px;\n\tfont-weight: $font-weight-semibold;\n}\n\n.avatar > a {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\ttransition: color .3s;\n\tcolor: #0a80ff;\n}\n\n.avatar > a > img,\n.avatar > img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.avatar.avatar-sm {\n\theight: 1.3rem;\n\twidth: 1.3rem;\n}\n\n.avatar.avatar-sm .avatar-title {\n\tfont-size: $font-size-14;\n}\n\n.avatar.avatar-lg {\n\theight: 3.8rem;\n\twidth: 3.8rem;\n}\n\n.avatar.avatar-lg .avatar-title {\n\tfont-size: 29px;\n}\n\n.avatar.avatar-xl {\n\theight: 100px;\n\twidth: 100px;\n}\n\n.header_drop_icon {\n\tborder-radius: 6px;\n}\n\n.accordion-col .accordion-title {\n\tcursor: pointer;\n\tpadding: 15px 0 8px;\n}\n\n.accordion-col .accordion-title .primary-title i {\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\ttransform: rotate(90deg);\n\t-webkit-transform: rotate(90deg);\n\t-ms-transform: rotate(90deg);\n}\n\n.accordion-col .accordion-title.active .primary-title i {\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\ttransform: rotate(270deg);\n\t-webkit-transform: rotate(270deg);\n\t-ms-transform: rotate(270deg);\n}\n\n.accordion-col .accordion-content {\n\tborder-bottom: 1px solid #e6e6e6;\n\tpadding-bottom: 15px;\n}\n\n.accordion-col .accordion-content:last-child {\n\tborder-bottom: 0;\n}\n\n.accordion-col .accordion-content h6 {\n\tfont-size: $font-size-14;\n}\n\n\n\n.status-right {\n\tfont-weight: $font-weight-medium;\n\tcolor: #444444;\n\tfont-size: $font-size-16;\n\ttext-align: center;\n}\n\n.status-right p {\n\tmargin-top: 20px;\n\tmargin-bottom: 0;\n}\n\n.star-drop .btn-outline-light {\n\tcolor: #424242;\n\tborder: 0;\n\tpadding: 0;\n}\n\n.star-drop .btn-outline-light i {\n\tfont-size: $font-size-20;\n}\n\n.star-drop .btn.btn-outline-light:hover {\n\tbackground: transparent;\n\tborder: 0;\n}\n\n.chat.star-chat-group {\n\tbackground-image: none;\n}\n\n.chat.star-chat-group .chat-body {\n\tbackground-image: none;\n}\n\n.chat.star-chat-group .chat-body .messages .chats {\n    max-width: 100%;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content {\n\tbackground: #F5F5F5;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {\n    word-break: break-all;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {\n    max-width: 100%;\n}\n.chat .chat-body .messages .chats.forward-chat-msg {\n\tdisplay: none;\n}\n.chats.forward-chat-msg {\n\tbackground: #EDEDED;\n\tborder-radius: 15px;\n\tpadding: 20px;\n\tborder-left: 2px solid #680A83;\n}\n.chats.forward-chat-msg .chat-avatar {\n\tpadding: 0;\n\tpadding-right: 15px;\n}\n\n.chat-title h4 a {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-bold;\n\ttext-transform: uppercase;\n\tcolor: #4B0973;\n\tmargin-bottom: 0;\n}\n\n.left-chat-title .add-section > a {\n\twidth: 30px;\n\theight: 30px;\n\tbackground-color: #680A83;\n\tborder-radius: 30px;\n\tcolor: $white;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tfont-size: 13px;\n}\n\n.add-section ul {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.add-section ul li {\n\tfloat: left;\n\tborder-radius: 50px;\n\twidth: 28px;\n\theight: 28px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\t\n    justify-content: center;\n    -webkit-justify-content: center;\n}\n\n.add-section ul li+li {\n\tmargin-left: 10px;\n}\n\n.add-section ul li a {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tfont-size: $font-size-20;\n}\n.all-chats .add-section ul li:hover{\n  background-color: #F5F5F5;\n  border-color: #F5F5F5;\n}\n\n.online {\n\tcolor: #008024;\n\tfont-weight: $font-weight-medium;\n}\n\n.top-online-contacts {\n\tpadding: 24px 24px 0px;\n}\n.fav-title {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\tmargin-bottom: 15px;\n}\n.fav-title h6 {\n\tmargin-bottom: 0;\n\tfont-size: $font-size-18;\n\tfont-weight: $font-weight-semibold;\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n.fav-title h6 i {\n\tfont-size: $font-size-22;\n}\n.fav-title a {\n\tmargin-bottom: 0;\n\tcolor: $primary;\n\tfont-weight: $font-weight-medium;\n}\n.fav-title a:hover {\n\tcolor: #0A0A0A;\n}\n\n.top-contacts-box .profile-img {\n\tposition: relative;\n\twidth: 46px;\n\theight: 46px;\n}\n\n.top-contacts-box .profile-img img {\n\tmax-width: 100%;\n\theight: auto;\n\tborder-radius: 50px;\n}\n\n.profile-name span {\n\tcolor: #585858;\n\tfont-size: 12px;\n\tdisplay: inline-block;\n\tmargin-top: 9px;\n}\n\n.top-contacts-box .profile-img.online:before {\n\tcontent: \"\";\n\tposition: absolute;\n\tright: 0;\n\ttransform: translateX(-50%);\n\t-webkit-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\ttop: 0px;\n\tbackground-color: #49E073;\n\twidth: 10px;\n\theight: 10px;\n\tborder: 2px solid $white;\n\tborder-radius: 50px;\n}\n\n.dropdown-menu .dropdown-item span.edit-profile-icon,\n.dropdown-menu .dropdown-item span.profile-icon-col {\n\tfont-size: $font-size-15;\n}\n\n.avatar {\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 46px;\n\theight: 46px;\n\tflex-shrink: 0;\n}\n\n.avatar > img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.avatar-title {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: #650681;\n\tcolor: $white;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.avatar-away::before,\n.avatar-offline::before,\n.avatar-online::before {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\twidth: 25%;\n\theight: 25%;\n\tborder-radius: 50%;\n\tcontent: '';\n\tborder: 2px solid $white;\n}\n\n.avatar-online::before {\n\tbackground-color: #00e65b;\n}\n\n.avatar-offline::before {\n\tbackground-color: #ff0100;\n}\n\n.avatar-away::before {\n\tbackground-color: #ffbc34;\n}\n\n.avatar .border {\n\tborder-width: 3px !important;\n}\n\n.avatar .rounded {\n\tborder-radius: 6px !important;\n}\n\n.avatar .avatar-title {\n\tfont-size: $font-size-18;\n}\n\n.avatar-xs {\n\twidth: 1.65rem;\n\theight: 1.65rem;\n}\n\n.avatar-xs .border {\n\tborder-width: 2px !important;\n}\n\n.avatar-xs .rounded {\n\tborder-radius: 4px !important;\n}\n\n.avatar-xs .avatar-title {\n\tfont-size: 10px;\n}\n\n.avatar-xs.avatar-away::before,\n.avatar-xs.avatar-offline::before,\n.avatar-xs.avatar-online::before {\n\tborder-width: 1px;\n}\n\n.avatar-sm {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n}\n\n.avatar-sm .border {\n\tborder-width: 3px !important;\n}\n\n.avatar-sm .rounded {\n\tborder-radius: 4px !important;\n}\n\n.avatar-sm .avatar-title {\n\tfont-size: $font-size-15;\n}\n\n.avatar-sm.avatar-away::before,\n.avatar-sm.avatar-offline::before,\n.avatar-sm.avatar-online::before {\n\tborder-width: 2px;\n}\n\n.avatar-lg {\n\twidth: 3.75rem;\n\theight: 3.75rem;\n}\n\n.avatar-lg .border {\n\tborder-width: 3px !important;\n}\n\n.avatar-lg .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-lg .avatar-title {\n\tfont-size: $font-size-24;\n}\n\n.avatar-lg.avatar-away::before,\n.avatar-lg.avatar-offline::before,\n.avatar-lg.avatar-online::before {\n\tborder-width: 3px;\n}\n\n.avatar-xl {\n\twidth: 5rem;\n\theight: 5rem;\n}\n\n.avatar-xl .border {\n\tborder-width: 4px !important;\n}\n\n.avatar-xl .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-xl .avatar-title {\n\tfont-size: $font-size-28;\n}\n\n.avatar-xl.avatar-away::before,\n.avatar-xl.avatar-offline::before,\n.avatar-xl.avatar-online::before {\n\tborder-width: 4px;\n}\n\n.avatar-xxl {\n\twidth: 5.125rem;\n\theight: 5.125rem;\n}\n\n.avatar-xxl .border {\n\tborder-width: 6px !important;\n}\n\n.avatar-xxl .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-xxl .avatar-title {\n\tfont-size: $font-size-30;\n}\n\n.avatar-xxl.avatar-away::before,\n.avatar-xxl.avatar-offline::before,\n.avatar-xxl.avatar-online::before {\n\tborder-width: 4px;\n}\n\n.avatar-group {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tpadding-left: 15px;\n\tmargin-left: auto;\n\tmargin-right: 15px;\n\tcursor: pointer;\n}\n\n.avatar-group .avatar+.avatar {\n\tmargin-left: -.75rem;\n}\n\n.avatar-group .avatar-xs+.avatar-xs {\n\tmargin-left: -15px;\n}\n\n.avatar-group .avatar-sm+.avatar-sm {\n\tmargin-left: -.625rem;\n}\n\n.avatar-group .avatar-lg+.avatar-lg {\n\tmargin-left: -1rem;\n}\n\n.avatar-group .avatar-xl+.avatar-xl {\n\tmargin-left: -1.28125rem;\n}\n\n.avatar-group .avatar:hover {\n\tz-index: 1;\n}\n\n.avatar-group.group-col {\n\tdisplay: block;\n}\n\n.avatar-group.group-col > div {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tpadding-bottom: 5px;\n}\n\n.avatar-group.group-col .avatar {\n\tmargin-right: 0;\n}\n\n.contact-close {\n\tfloat: right;\n\tleft: 95%;\n\tright: 0px;\n\tposition: relative;\n\ttop: 5%;\n}\n\n.status_contactclose {\n\tfloat: right;\n\tleft: 95%;\n\tright: 0px;\n\tposition: relative;\n\ttop: 1%;\n}\n\n.status-active {\n\tborder: 4px solid #650681;\n}\n\n.avatar.avatar-xl .avatar-title {\n\tfont-size: 39px;\n}\n\n.nav.nav-tabs {\n\tborder: none;\n\tline-height: 2;\n}\n\n.badge {\n\tpadding: 5px 10px;\n\tfont-size: 11px;\n}\n\n.badge.badge-success {\n\tbackground: #0abb87;\n}\n\n.badge.badge-danger {\n\tbackground: #fd397a;\n}\n\n.badge.badge-secondary {\n\tbackground: dimgray;\n}\n\n.badge.badge-info {\n\tbackground: #00bcd4;\n}\n\n.badge.badge-warning {\n\tbackground: #ffb822;\n}\n\n.badge.badge-dark {\n\tbackground: #3a3f51;\n}\n\n.badge.badge-primary {\n\tbackground: #0a80ff;\n}\n\n.badge.badge-light {\n\tbackground: #e6e6e6;\n}\n\n.btn {\n\tposition: relative;\n}\n\n.btn .badge {\n\tpadding: 2px 6px;\n\tright: 7px;\n\ttop: -7px;\n\tposition: absolute;\n}\n\n.input-group .input-group-text {\n\tfont-size: $font-size-14;\n}\n\n.tooltip > .tooltip-inner {\n    text-align: left;\n    max-width: 500px;\n    --bs-tooltip-bg: $primary;\n}\n.tooltip {\n    --bs-tooltip-bg: $primary;\n}\n.tooltip .arrow {\n\tdisplay: none;\n\tbackground-color: $primary;\n}\n.tooltip .tooltip-inner {\n\tbackground-color: $primary;\n}\n\n.sticky-top {\n\tz-index: auto;\n}\n\n.tab-content {\n\tpadding-top: 30px;\n}\n\n.tab-content .form-item {\n\tmargin-bottom: .8rem;\n}\n\n.main-wrapper {\n\theight: 100vh;\n\toverflow: hidden;\n}\n\n.main-wrapper .content {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\t@include respond-below(custom991) {\n\t\tdisplay: block;\n\t}\n}\n\n.main-wrapper .content .sidebar-group {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\tposition: relative;\n\tz-index: 99;\n\twidth: 340px;\n\t@include respond-below(custom991) {\n\t\twidth: 100%;\n\t}\n}\n\n.chats {\n\t.chat-content {\n\t\t@include respond-below(custom575) {\n\t\t\twidth: calc(100% - 55px);\n\t\t}\n\t}\n}\n.main-wrapper .content .sidebar-group .sidebar {\n\tbackground: $white;\n\toverflow: hidden;\n\twidth: 340px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tborder-right: 1px solid rgba(224, 224, 224, 1);\n\t@include respond-below(custom991) {\n\t\twidth: 100%!important;\n\t}\n}\n\n.main-wrapper .content .sidebar-group .sidebar:not(.active) {\n\tdisplay: none;\n}\n\n.header-top {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 30px;\n\tfont-weight: $font-weight-semibold;\n\tbackground-color: #680A83;\n}\n\n.header-top .logo {\n\tmargin-top: 0 !important;\n}\n\n.header-top > span {\n\tfont-size: $font-size-22;\n}\n\n.header-top ul {\n\tmargin-bottom: 0;\n\tdisplay: flex;\n}\n\n.header-top ul.header-action {\n\tmargin-top: 14px !important;\n}\n\n.chat-header ul {\n\tmargin-bottom: 0;\n}\n\n.chat-header ul li:not(.list-inline-item) {\n\tmargin-bottom: 0;\n\twidth: 48px;\n\tmargin-right: 15px !important;\n}\n\n.chat-header ul li:last-child {\n\tmargin-right: 0 !important;\n}\n\n.sidebar-body {\n\tflex: 1;\n\toverflow: auto;\n\tpadding: 24px 24px 10px;\n\twidth: 100%;\n}\n.pin-chat img {\n\tmargin-right: 6px;\n}\n.sidebar-body .profile-name {\n\tfont-weight: $font-weight-semibold;\n\tcolor: #0A0A0A;\n\tfont-size: $font-size-18;\n\tmargin-bottom: 0;\n}\n\n.online-profile {\n\tposition: relative;\n}\n\n.online-profile span {\n\tposition: relative;\n\tcolor: #565656;\n\tfont-size: 13px;\n\tpadding-left: 10px;\n}\n\n.online-profile span:before {\n\tcontent: \"\";\n\tposition: absolute;\n\tleft: 0;\n\ttop: 7px;\n\tbackground-color: #49E073;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 50px;\n}\n\n.close_profile4 {\n\tcolor: $black;\n\tborder-color: #e6e6e6;\n}\n\n.sidebar .user-list li a {\n\tpadding: 10px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tcursor: pointer;\n\tmargin-bottom: 15px;\n\tborder: 1px solid #E0E0E0;\n\tbox-shadow: none;\n\tborder-radius: 5px;\n\tposition: relative;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n}\n\n.sidebar .user-list li a:hover {\n\tbackground-color: rgba(254, 159, 67, 0.08);\n\tborder: 1px solid rgba(254, 159, 67, 0.08);\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n}\n\n.sidebar .user-list li.item-typing {\n\tbackground-color: #F1F6FF;\n}\n\n.sidebar .user-list li figure {\n\tmargin-right: 1rem;\n}\n\n.sidebar .user-list li .users-list-body {\n\tflex: 1;\n\tposition: relative;\n\tmin-width: 0px;\n\tdisplay: flex;\n}\n\n.lock-icon {\n\tcolor: #000000;\n}\n\n.sidebar .user-list li .users-list-body > div:first-child {\n\tmin-width: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n}\n.parti-notify-check {\n\tmargin-bottom: 0 !important;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.sidebar .user-list li .users-list-body h5 {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tmargin-bottom: 3px;\n\tcolor: #0A0A0A;\n}\n\n.sidebar .user-list li .users-list-body p {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tmargin-bottom: 0;\n\tcolor: #232323;\n\tfont-size: $font-size-14;\n}\n.sidebar .user-list li .users-list-body p.missed-call-col {\n\tcolor: #DE3E44;\n}\n.sidebar .user-list li .users-list-body .last-chat-time {\n\tpadding-left: 15px;\n\tposition: relative;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .text-muted {\n\tcolor: #424242 !important;\n\tfont-weight: $font-weight-normal;\n\tfont-size: 12px;\n\tmargin-bottom: 5px;\n\tdisplay: block;\n\ttext-align: right;\n}\n.sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {\n\tcolor: #680A83;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .new-message-count {\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tline-height: 0;\n\tfont-size: 11px;\n\tbackground-color: $primary;\n\tcolor: $white;\n\tborder-radius: 50%;\n\tmargin-left: auto;\n\tmargin-top: 10px;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\topacity: 0;\n\ttext-align: right;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\twidth: 18px;\n\theight: 24px;\n}\n\n.sidebar .user-list li.unread h5 {\n\tcolor: $white;\n}\n\n.sidebar .user-list li.unread p {\n\tcolor: $white;\n}\n\n.sidebar .user-list li.unread .text-muted {\n\tcolor: rgba(255, 255, 255, 0.4) !important;\n}\n\n.sidebar .user-list li.user-list-item.item-typing .users-list-body p {\n\tcolor: #0D9B35;\n}\n\n.rightside_tab {\n\tpadding-top: 5px !important;\n}\n.chat-pin {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: end;\n\t-webkit-justify-content: end;\n\t-ms-flex-pack: end;\n\t.green-check {\n\t\tcolor: #0D9B35;\n\t}\n}\n.chat-pin img {\n\twidth: 10px;\n}\n.chat-pin .check {\n\tcolor: #53BDEB;\n}\n.select-message-box {\n\tmargin-top: 50px;\n}\n.select-message-box h4 {\n\tmargin-bottom: 5px;\n}\n.select-message-box p {\n\tmargin-top: 0;\n\tmargin-bottom: 24px;\n\tcolor: #424242;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n}\n.select-message-box .btn i {\n\tfont-size: $font-size-15;\n}\n\n.group-description {\n\tpadding: 0px 24px;\n}\n.group-description .description-sub {\n\tborder-bottom: 1px solid #EDEDED;\n\tpadding-bottom: 15px;\n\tmargin-bottom: 15px;\n}\n.group-description h5 {\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tcolor: #0A0A0A;\n\tmargin-bottom: 10px;\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n}\n.group-description h5 a:hover {\n\tcolor: #650681 !important;\n}\n.group-description p { \n\tcolor: #424242;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 10px;\n}\n.group-description p.description-date { \n\tcolor: #424242;\n\tfont-size: 12px;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 0px;\n}\n.encrypted-message p {\n\tfont-size: 12px;\n\tcolor: #424242;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 0;\n}\n.group-view-all {\n\tmargin-top: 10px;\n}\n.group-view-all a {\n\tcolor: #680A83;\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-medium;\n}\n.group-view-all a:hover {\n\tcolor: #0A0A0A;\n}\n.exit-bg-message {\n\tbackground: #FFE8E9;\n}\n.exit-bg-message i {\n\tcolor: #DE3E44;\n}\n.disapper-message {\n\tbackground: #E7FAF2;\n}\n.disapper-message i {\n\tcolor: #1BA345;\n}\n.group-setting-msg {\n\tbackground: #F8ECFF;\n}\n.group-setting-msg i {\n\tcolor: #680A83;\n}\n.group-setting .stared-group span {\n\twidth: 50px;\n\theight: 50px;\n}\n.edit-set-details p {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n\tcolor: #424242;\n\tmargin-bottom: 0;\n}\n.group-send-msg {\n\tbackground: #FEF6DC;\n}\n.parcipant-check p a {\n\tcolor: #680A83;\n}\n.select-group-chat .dropdown-toggle::after {\n\tdisplay: none;\n}\n.select-group-chat .dropdown-toggle i {\n\tmargin-left: 15px;\n}\n.select-group-chat .dropdown-toggle:hover {\n\tcolor: #0A0A0A;\n}\n.select-group-chat .dropdown-toggle {\n\tfont-weight: $font-weight-semibold;\n\tcolor: #0A0A0A;\n\tfont-size: $font-size-18;\n}\n.select-group-chat .dropdown-menu .dropdown-item {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n\tcolor: #0A0A0A;\n}\n.select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {\n\tborder-radius: 5px 5px 0 0;\n}\n.select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {\n\tborder-radius: 0 0 5px 5px;\n}\n.dropzone {\n\tbackground: $white;\n\tborder: 1px dashed #C2C2C2;\n\tborder-radius: 5px;\n\tpadding: 10px;\n\tmin-height: 70px;\n\ttext-align: center;\n}\n.dropzone.dz-clickable .dz-message {\n\tdisplay: none;\n}\n.dropzone p {\n\tmargin-bottom: 10px;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-medium;\n\tcolor: #0A0A0A;\n}\n.dropzone span {\n\tcolor: #424242;\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n}\n.uplaod-image img {\n\tborder-radius: 20px;\n}\n.upload-img-file .modal-body {\n\tpadding: 0;\n}\n.upload-img-file .modal-content {\n\tposition: relative;\n}\n.upload-img-file .modal-header {\n\tposition: absolute;\n\ttop: 0;\n\tz-index: 9;\n\tleft:0;\n\tright: 0;\n}\n.upload-image-list {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n.upload-image-list li+li {\n\tmargin-left: 10px;\n}\n.upload-img-file .modal-header .close {\n\tbackground-color: transparent;\n\tcolor: $white;\n}\n.check-star i {\n\tcolor: #FEC001;\n}\n.emoj-group-list {\n\tdisplay: none;\n\tposition: absolute;\n\ttop: -50px;\n\tleft: -90px;\n\ttransition: all 0.5s ease;\n    -moz-transition: all 0.5s ease;\n    -o-transition: all 0.5s ease;\n    -ms-transition: all 0.5s ease;\n    -webkit-transition: all 0.5s ease;\n}\n.emoj-group-list ul {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tbackground: #f6f7f8;\n\tborder-radius: 50px;\n\tpadding: 5px;\n}\n.emoj-group-list ul li a {\n\tpadding: 0;\n}\n.emoj-group-list ul li.add-emoj a {\n\tbackground: #EDEDED;\n}\n.emoj-group-list ul li.add-emoj a i {\n\tfont-size: $font-size-20;\n\tcolor: #424242;\n}\n.chat .slimscroll {\n\theight: calc(100vh - 60px) !important;\n}\n.settings-option {\n\tdisplay: none;\n\ttext-align: right;\n}\n.settings-option a {\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tcolor: #680A83;\n}\n.empty-dark-img {\n\tdisplay: none;\n}\n.bootstrap-datetimepicker-widget span {\n\tposition: relative;\n}\n\n}\n.chat-window{\n    .card{\n        .card-header {\n            background-color: $white;\n            border-bottom: 1px solid $gray-300;\n        }\n    }\n    .badge-success {\n        background-color: $success !important;\n    }\n}\n.chat-page {\n    .footer {\n        display: none;\n    }\n}\n.chat-search{\n    .input-group {\n        .form-control{\n            @include margin-padding(0,0 0 0 36px);\n            height: 46px;\n        }\n        .input-group-prepend {\n        \tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n            color: $gray-700;\n            pointer-events: none;\n            z-index: 4;\n            @include position(absolute,0,15px,0,null);\n        }\n    }\n}\n.chat-cont-left {\n    .chat-scroll {\n        max-height: calc(100vh - 200px);\n        overflow-y: auto;\n        padding: 0;\n        .media {\n            border-bottom: 1px solid $gray-300;\n            @include margin-padding(0,10px);\n            @include transition(all .2s);\n            &.active {\n                background-color:  $gray-100;\n            }\n            &:hover{\n                background-color:  $gray-100;\n            }\n            .media-img-wrap {\n                @include margin-padding(0  15px 0 0,null);\n                position: relative;\n                .avatar > img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n            .media-body {\n                display: -webkit-box;\n\t\t        display: -ms-flexbox;\n\t\t        display: flex;\n\t\t        justify-content: space-between;\n    \t\t\t-webkit-justify-content: space-between;\n    \t\t\t-ms-flex-pack: space-between;\n                .user-name{\n                    max-width: 170px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                    color: $gray-900;\n                    font-size: $font-size-16;\n                    font-weight: $font-weight-bold;\n                }\n                .user-last-chat {\n                    color: $gray-800;\n                    font-size: $font-size-base;\n                    line-height: 24px;\n                    max-width: 170px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                }\n                .last-chat-time {\n                    color: $gray-600;\n                    font-size:$font-size-13;\n                }\n                 div{\n                    &:last-child {\n                        text-align: right;\n                    }\n                }\n            }\n        }\n    }\n    \n}\n.chat-cont-right {\n    @include transition(all 0.4s);\n    .chat-scroll {\n        max-height: calc(100vh - 293px);\n        overflow-y: auto;\n        \n    }\n    .msg_head {\n        .back-user-list {\n            display: none;\n            @include margin-padding(0 0 0 -10px ,0 10px);\n        }\n    }\n    .img_cont {\n        position: relative;\n        height: 45px;\n        width: 45px;\n        .user_img {\n            height: 45px;\n            min-width: 45px;\n            width: 45px;\n            border: 1.5px solid $primary;\n        }\n    }\n    .user_info {\n        @include margin-padding(0 auto 0 15px,0);\n        width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    ul.list-unstyled {\n        @include margin-padding(0 auto,0);\n        width: 100%;\n        .media{\n            &.sent {\n                margin-bottom: 20px;\n                .avatar {\n                    order: 3;\n                    height: 30px;\n                    width: 30px;\n                }\n                .media-body {\n                \tdisplay: -webkit-box;\n\t\t\t        display: -ms-flexbox;\n\t\t\t        display: flex;\n                    -webkit-box-align: flex-end;\n  \t\t\t\t\t-ms-flex-align: flex-end;\n  \t\t\t\t\talign-items: flex-end;\n                    -ms-flex-direction: column;\n  \t\t\t\t\tflex-direction: column;\n                    @include margin-padding(0 20px 0 0 ,0);\n                    .msg-box {\n                        @include margin-padding(0,0 0 0 50px);\n                        position: relative;\n                        + .msg-box{\n                            @include margin-padding(5px 0 0,0);\n                        }\n                        p{\n                            @include margin-padding(0,0);\n                        }\n                        &:first-child::before {\n                            border-bottom: 6px solid transparent;\n                            border-left: 6px solid #e3e3e3;\n                            border-top: 6px solid #e3e3e3;\n                            border-right: 6px solid transparent;\n                            content: \"\";\n                            height: 0;\n                            width: 0;\n                            @include position(absolute,0,-12px,null,auto);\n                        }\n                       > div {\n                            @include margin-padding(0,10px 15px);\n                            @include rounded(10px);\n                            background-color: #e3e3e3;\n                            display: inline-block;\n                            position: relative;\n                        }\n                        &:first-child > div {\n                            @include rounded(10px 0 10px 10px) ;\n                        }\n                    }\n                    .chat-msg-attachments {\n                    \tdisplay: -webkit-box;\n\t\t\t\t        display: -ms-flexbox;\n\t\t\t\t        display: flex;\n                        @include margin-padding(0 -1px,4px 0);\n                        width: 100%;\n                        .chat-attachment {\n                            position: relative;\n                            max-width: 130px;\n                            overflow: hidden;\n                            &:before {\n                                @include position(absolute,0,0,0,0);\n                                background: $black;\n                                content: \"\";\n                                opacity: 0.4;\n                                @include transition(all .4s);\n                            }\n                            &:hover{\n                                .chat-attach-download{\n                                    opacity: 1\n                                }\n                            }\n                        }\n                       > div {\n                            margin: 0 1px;\n                        }\n                        \n                        img {\n                            max-width: 100%;\n                        }\n                        .chat-attach-download {\n                            @include position(absolute,50%,null,null,50%);\n                            transform: translate(-50%, -50%);\n                            opacity: 0;\n                            @include transition(all .4s);\n                            color: $white;\n                            width: 32px;\n                            line-height: 32px;\n                            background: rgba(255, 255, 255, 0.2);\n                            text-align: center;\n                        }\n                    }\n                    .chat-msg-info {\n                    \tdisplay: -webkit-box;\n  \t\t\t\t\t\tdisplay: -ms-flexbox;\n  \t\t\t\t\t\tdisplay: flex;\n                    \talign-items: center;\n  \t\t\t\t\t\t-webkit-box-align: center;\n  \t\t\t\t\t\t-ms-flex-align: center;\n                        @include margin-padding(5px 0 0,0);\n                        -ms-flex-wrap: wrap;\n  \t\t\t\t\t\tflex-wrap: wrap;\n                        clear: both;\n                        flex-direction: row-reverse;\n                        list-style: none;\n                        li{\n                            @include margin-padding(0,0 0 0 16px);\n                            position: relative;\n\n                            &:not(:last-child)::after {\n                                @include position(absolute,50%,auto,null,8px);\n                                transform: translate(-50%, -50%);\n                                background: $primary;\n                                content: '';\n                                height: 4px;\n                                width: 4px;\n                            }\n                        }\n                        .chat-time {\n                            color: rgba(50, 65, 72, 0.4);\n                        }\n                        a {\n                            color: $gray-800;\n                        }\n                    }\n                }\n            }\n            &.received {\n                position: relative;\n                margin-bottom: 20px;\n                .media-body{\n                    position: relative;\n                    @include margin-padding(0 0 0 20px,0);\n                    &::before {\n                        border-bottom: 6px solid transparent;\n                        border-right: 6px solid $primary;\n                        border-top: 6px solid $primary;\n                        border-left: 6px solid transparent;\n                        content: \"\";\n                        height: 0;\n                        @include position(absolute,0px,auto,null,-6px);\n                        width: 0;\n                    }\n                    > div {\n                        @include margin-padding(0,10px 15px);\n                        @include rounded(10px);\n                        background-color: $primary;\n                        display: table;\n                        position: relative;\n                        p {\n                            color: $white;\n                            @include margin-padding(0,0);\n                        }\n                    }\n                }\n                .msg-box {\n                    display: block;\n                    + .msg-box {\n                        margin-top: 5px;\n                    }\n                    \n            }\n            .chat-msg-info {\n                display: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n        \t\talign-items: center;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n                -ms-flex-wrap: wrap;\n  \t\t\t\tflex-wrap: wrap;\n                @include margin-padding(5px 0 0,0);\n                clear: both;\n                list-style: none;\n                .chat-time {\n                    color: rgba(255,255,255,.8);\n                }\n            }\n            .chat-msg-attachments {\n            \tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n                @include margin-padding(0 -1px,4px 0);\n                width: 100%;\n                .chat-attachment {\n                    position: relative;\n                    max-width: 130px;\n                    overflow: hidden;\n                    &:before {\n                        @include position(absolute,0,0,0,0);\n                        background: $black;\n                        content: \"\";\n                        opacity: 0.4;\n                        @include transition(all .4s);\n                    }\n                    &:hover{\n                        .chat-attach-download{\n                            opacity: 1\n                        }\n                    }\n                }\n               > div {\n                    margin: 0 1px;\n                }\n                \n                img {\n                    max-width: 100%;\n                }\n                .chat-attach-download {\n                    @include position(absolute,50%,null,null,50%);\n                    @include transform(translate(-50%, -50%));\n                    @include transition(all .4s);\n                    opacity: 0;\n                    color: $white;\n                    width: 32px;\n                    line-height: 32px;\n                    background: rgba(255, 255, 255, 0.2);\n                    text-align: center;\n                }\n            }\n        }\n           \n        }\n        .chat-date {\n            font-size: $font-size-base;\n            margin: 1.875rem 0;\n            overflow: hidden;\n            position: relative;\n            text-align: center;\n            text-transform: capitalize;\n            &:before {\n                background-color: #e0e3e4;\n                content: \"\";\n                height: 1px;\n                margin-right: 28px;\n                @include position(absolute,50%,50%,null,null);\n                width: 100%;\n            }\n            &:after {\n                background-color: #e0e3e4;\n                content: \"\";\n                height: 1px;\n                @include margin-padding(0 0 0 28px,null);\n                @include position(absolute,50%,null,null,50%);\n                width: 100%;\n            }\n        }\n    }\n    \n}\n.card-footer {\n    background-color: $white;\n    border-top: 1px solid $gray-300;\n    @include margin-padding(0,1rem 1.5rem);\n    .type_msg {\n        background-color: rgba(0,0,0,0.1) !important;\n        border: 0 !important;\n        overflow-y: auto;\n    }\n}\n@include respond-below(custom992) {\n    .chat-window.chat-slide .chat-cont-right {\n        right: 0;\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .chat-cont-right {\n        @include position(absolute, null, -100px, null, null);\n        opacity: 0;\n        visibility: hidden;\n        z-index: 99;\n    }\n    .chat-cont-right .msg_head .back-user-list {\n        display: flex;\n        align-items: center;\n    }\n}\n.page-header {\n    .breadcrumb {\n        margin-bottom: 0;\n    }\n    h3{\n        font-weight: $font-weight-bold;\n        color: $gray-900;\n        font-size: $font-size-18;\n        @include respond-below(custom991) {\n            font-size: $font-size-base;\n        }\n    }\n    h4 {\n        font-weight: $font-weight-bold;\n        color: $gray-900;\n        font-size: $font-size-18;\n        margin-bottom: 5px;\n        @include respond-below(custom991) {\n            font-size: $font-size-18;\n        }\n    }\n    h6 {\n        font-size: $font-size-base;\n        color: $gray-700;\n        font-weight: $font-weight-normal;\n        @include respond-below(custom991) {\n            font-size: $font-size-12;\n        }\n        @include respond-below(custom575) {\n            font-size: $font-size-12;\n            margin-bottom: 20px;\n        }\n    }\n    .btn-filter {\n        background: $primary;\n        width: 34px;\n        height: 34px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        padding: 0;\n        &:hover{\n            background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n        }\n    }\n    .page-btn {\n        margin-left: 10px;\n        @include respond-below(custom575) {\n            margin-left: 0;\n            margin-top: 20px;\n        }\n    }\n    .btn-added {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $primary;\n        padding: 8px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n\t\theight: 40px;\n        border-radius: 5px;\n        &:active {\n            color: $white;\n        }\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $title-color;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .btn-added.downloader {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $gray-900;\n        padding: 9px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n        border-radius: 8px;\n        margin: 0 15px 0 15px;\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $primary;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .btn-added.printer {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $danger;\n        padding: 9px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n        border-radius: 8px;\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $gray-900;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .add-item {\n        @include respond-below(custom767) {\n            display: block !important;\n            .page-btn {\n                margin-left: 0;\n            }\n        }\n        .page-btn {\n            @include respond-below(custom575) {\n                 margin-left: 0;\n                 margin-bottom: 24px;\n            }\n        }\n        .page-title.modal-datail {\n            line-height: 2;\n        }\n    }\n    .add-item.d-flex {\n        margin-right: auto;\n    }\n    .add-item.payslip-list {\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        width: 100%;\n    }\n}\n.page-wrapper.details-blk {\n    padding: 0;\n    margin: 0;\n}\n.history-modal-profile {\n\t.content {\n\t\tpadding: 24px;\n\t}\n\t.right-sidebar-profile {\n\t\tbackground: $body-bg;\n\t\tborder-radius: 8px;\n\t\tpadding: 24px;\n\t\t.list-inline-item {\n\t\t\ta {\n\t\t\t\tbackground: $primary;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #1b2950;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-bottom: 24px;\n\t\t\twidth: 150px;\n\t\t\theight: 150px;\n\t\t\timg {\n\t\t\t\tborder-radius: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n.msg-typing {\n    width: auto;\n    height: 24px;\n    padding-top: 8px;\n\tspan {\n\t\theight: 8px;\n\t\twidth: 8px;\n\t\tfloat: left;\n\t\tbackground-color: $white;\n\t\tdisplay: block;\n\t\topacity: .4;\n\t\t@include margin-padding(0 1px, null);\n\t\t@include rounded(50%);\n\t\t&:nth-of-type(1) {\n\t\t\tanimation: 1s blink infinite .33333s;\n\t\t}\n\t\t&:nth-of-type(2) {\n\t\t\tanimation: 1s blink infinite .66666s;\n\t\t}\n\t\t:nth-of-type(3) {\n\t\t\tanimation: 1s blink infinite .99999s;\n\t\t}\n\t}\n}\n@keyframes blink {\n\t50% {\n\t\topacity: 1\n\t}\n}\n\n.phone-call-icon {\n\tsvg {\n\t\twidth: 18px;\n\t}\n\t.income-success {\n\t\tcolor: $success;\n\t}\n\t.income-success-missed {\n\t\tcolor: $danger;\n\t}\n}\n.history-modal-profile {\n\t.content {\n\t\tpadding: 24px;\n\t}\n\t.right-sidebar-profile {\n\t\tbackground: $body-bg;\n\t\tborder-radius: 8px;\n\t\tpadding: 24px;\n\t\t.list-inline-item {\n\t\t\ta {\n\t\t\t\tbackground: $primary;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n\t\t\t\tcolor: $white !important;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #1b2950;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-bottom: 24px;\n\t\t\twidth: 150px;\n\t\t\theight: 150px;\n\t\t\timg {\n\t\t\t\tborder-radius: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n.modal-profile-detail {\n\t.modal-userlist {\n\t\tli {\n\t\t\tfont-size: $font-size-14;\n\t\t\tcolor: $black;\n\t\t\tmargin-bottom: 10px;\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: $text-color;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat_sidebar.hide-left-sidebar {\n\t@include respond-below(custom991) {\n\t\t display: none !important;\n\t}   \n}\n.left-sidebar.hide-left-sidebar {\n\t@include respond-below(custom991) {\n\t\t margin-left: -991px;\n\t}      \n}\n\n\n",".img-cropper {\n\t.dropup {\n\t\t.dropdown-toggle {\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n.dropdown-auto {\n\toverflow: auto;\n}\n.dropdown-divider {\n\tmargin: 0;\n}\n.dropdown {\n\t.dropdown-toggle {\n\n\t\t&:after {\n      display: inline-block;\n      margin-inline-start: 0.25rem;\n      vertical-align: 0;\n      content: \"\\f078\";\n      font-family: \"Font Awesome 5 Free\";\n      border: 0;\n      font-size: 0.6rem;\n      font-weight: $font-weight-semibold;\n\t\t}\n\n\t\t&.btn-primary {\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.dropdown-menu {\n\t\tfont-family: $font-family-primary;\n\t}\n}\n.dropdown {\n  & > a {\n      color: $gray-900;\n      border: 1px solid $light-900;\n      padding: 9px 15px;\n      border-radius: $border-radius-lg;\n      display: flex;\n      align-items: center;\n      box-shadow: 0px 4px 4px 0px #DBDBDB40;\n    }\n}\n.dropdown-menu {\n  border-color: $border-color;\n  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);\n  font-size: 0.875rem;\n  color: $text-color;\n  background-color: $white;\n  padding: 0;\n  z-index: 10;\n}\n.dropdown-divider {\n  border-color: $border-color;\n}\n\n.dropdown-item-text {\n  color: $text-color;\n}\n.dropdown-header {\n  color: $text-color;\n}\n.dropdown-item {\n  color: $text-color;\n  white-space: unset;\n  padding: 0.5rem 0.9375rem;\n  font-size: 0.8125rem;\n\n  &.disabled,\n  &:disabled {\n    color: $text-color;\n    opacity: 0.5;\n  }\n  &:not(.active) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: $primary;\n      background-color: rgba($primary, 0.05);\n    }\n  }\n  &.active {\n    background-color: $primary !important;\n  }\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f078\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f078\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f077\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f053\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.btn.dropdown-toggle-split {\n  opacity: 0.85;\n}\n\n.dropdown-menu-dark {\n  background-color: $dark;\n  border-color: rgba(255, 255, 255, 0.1);\n  li a {\n    color: $white;\n  }\n}\n.btn-list {\n\ta.dropdown-item {\n\t\tmargin-block-end: 0;\n\t}\n\t.btn-soft-success  {\n\t\t&:hover {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\t.btn-soft-danger  {\n\t\t&:hover {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t\t&:active {\n\t\t\n\t\t}\n\t}\n}\n\n.dropdown-menu {\n  @mixin dropdown-menu-color($color) {\n    background-color: $color;\n    li a {\n      color: rgba(255, 255, 255, 0.9);\n    }\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        color: $white;\n      }\n    }\n  }\n  &.dropdown-menu-primary {\n    @include dropdown-menu-color($primary);\n  }\n  &.dropdown-menu-secondary {\n    @include dropdown-menu-color($secondary);\n  }\n  &.dropdown-menu-warning {\n    @include dropdown-menu-color($warning);\n  }\n  &.dropdown-menu-info {\n    @include dropdown-menu-color($info);\n  }\n  &.dropdown-menu-success {\n    @include dropdown-menu-color($success);\n  }\n  &.dropdown-menu-danger {\n    @include dropdown-menu-color($danger);\n  }\n}\n.dropdown-menu {\n  &.dropmenu-item-primary {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($primary, 0.1) !important;\n        color: $primary;\n      }\n    }\n  }\n  &.dropmenu-item-secondary {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($secondary, 0.1) !important;\n        color: $secondary;\n      }\n    }\n  }\n  &.dropmenu-item-warning {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($warning, 0.1) !important;\n        color: $warning;\n      }\n    }\n  }\n  &.dropmenu-item-info {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($info, 0.1) !important;\n        color: $info;\n      }\n    }\n  }\n  &.dropmenu-item-success {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba(var(--success-rgb), 0.1) !important;\n        color: $success;\n      }\n    }\n  }\n  &.dropmenu-item-danger {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba(var(--danger-rgb), 0.1) !important;\n        color: $danger;\n      }\n    }\n  }\n}\n.dropdown-menu {\n  @mixin dropmenu-light-color($color) {\n    backdrop-filter: blur(2rem);\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        color: $white;\n        background-color: $color !important;\n      }\n    }\n  }\n  &.dropmenu-light-primary {\n    background-color: rgba(var($secondary), 0.1);\n    @include dropmenu-light-color($primary);\n  }\n  &.dropmenu-light-secondary {\n    background-color: rgba(var($secondary), 0.1);\n    @include dropmenu-light-color($secondary);\n  }\n  &.dropmenu-light-info {\n    background-color: rgba($info, 0.1);\n    @include dropmenu-light-color($info);\n  }\n  &.dropmenu-light-warning {\n    background-color: rgba($warning, 0.1);\n    @include dropmenu-light-color($warning);\n  }\n  &.dropmenu-light-success {\n    background-color: rgba($success, 0.1);\n    @include dropmenu-light-color($success);\n  }\n  &.dropmenu-light-danger {\n    background-color: rgba(var(--danger-rgb), 0.1);\n    @include dropmenu-light-color($danger);\n  }\n}\n.dropdown-divider {\n  margin: 0;\n}\n.bd-example > .dropdown-menu {\n  position: static;\n  display: block;\n}\n\n.dropdown-md {\n  min-width: 315px;\n}\n.table-action {\n  .action-icon {\n      width: 33px;\n      height: 33px;\n      background: $light-300;\n      border: 1px solid $light-900;\n      border-radius: 5px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      color: $gray-900;\n      &:hover {\n          color: $gray-900;\n          i {\n              color: $gray-900;\n          }\n      }\n  }\n  .dropdown-toggle {\n      &::after {\n          display: none;\n      }\n  }\n  .dropdown-menu {       \n          a {\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n              -ms-flex-align: center;\n              align-items: center;\n              @include margin-padding(null, 5px);\n              border-radius: 5px;\n              color: $title-color;\n              white-space: nowrap;\n              i {\n                  margin-right: 8px;\n              }\n              &:hover {\n                  background: $light-300;\n                  color: $title-color;\n              }\n          }       \n  } \n}\n.daterangepicker {\n  font-family: $font-family-primary;\n  .calendar-table {\n      th {\n          color: $gray-900;\n      }\n      td {\n          color: $gray-900;\n      }\n\n  }\n}\n.daterangepicker td.active, .daterangepicker td.active:hover {\n  background-color: #e85b28;\n  color: #fff;\n}\n.daterangepicker .ranges li.active {\n  background-color: $green;\n}\n.sort-dropdown.drop-down {\n  .dropdown-menu li a {\n      white-space: nowrap;\n  }\n}\n.drop-down {\n  position: relative;\n  & > a {\n      border: 1px solid $light-900;\n      border-radius: 5px;\n      box-shadow: 0px 4px 4px 0px #DBDBDB40;\n      background: $white;\n      font-weight: $font-weight-medium;\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      min-height: 42px;\n      @include margin-padding(null, 9px 15px);\n      i {\n          margin-right: 8px;\n      }   \n      &:hover {\n          color: $title-color;\n      }\n      &.show {\n          border: 1px solid #e85b28;\n      }  \n      &::after {\n          font-size: $font-size-14;\n          margin-left: 8px;\n      }\n      &[aria-expanded=true] {\n          &::after {\n              @include transition(all 0.2s ease);\n              @include transform(rotate(180deg));\n          }\n      } \n  }  \n  .dropdown-menu {\n      li {\n          a {\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n              -ms-flex-align: center;\n              align-items: center;\n              @include margin-padding(null, 5px);\n              border-radius: 5px;\n              i {\n                  margin-right: 8px;\n              }\n              &:hover {\n                  background: $light-300;\n                  color: $title-color;\n              }\n          }\n      }\n  } \n}\n.dropdown-menu {\n  border: 1px solid $light-900;\n  padding: 15px;\n  box-shadow: $box-shadow-sm;\n}\n\n/* ------------------------------------------------------------\n   Unified dropdown item styling (website-wide)\n   ------------------------------------------------------------ */\n.dropdown-menu,\n.dropdown-menu.show {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 8px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);\n}\n\n.dropdown-menu ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.dropdown-menu .dropdown-item,\n.dropdown-menu a.dropdown-item,\n.dropdown-menu button.dropdown-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 8px;\n  padding: 9px 10px;\n  color: #334155;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;\n}\n\n.dropdown-menu .dropdown-item i,\n.dropdown-menu a.dropdown-item i,\n.dropdown-menu button.dropdown-item i {\n  font-size: 15px;\n}\n\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus,\n.dropdown-menu .dropdown-item:active,\n.dropdown-menu a.dropdown-item:hover,\n.dropdown-menu a.dropdown-item:focus,\n.dropdown-menu a.dropdown-item:active,\n.dropdown-menu button.dropdown-item:hover,\n.dropdown-menu button.dropdown-item:focus,\n.dropdown-menu button.dropdown-item:active {\n  background: #fff7ed;\n  color: #e85b28;\n  transform: translateX(1px);\n}\n\n.dropdown-menu .dropdown-item:focus-visible,\n.dropdown-menu a.dropdown-item:focus-visible,\n.dropdown-menu button.dropdown-item:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.14);\n}\n\n.dropdown-menu .dropdown-item.active,\n.dropdown-menu a.dropdown-item.active,\n.dropdown-menu button.dropdown-item.active {\n  background: #e85b28;\n  color: #fff;\n}\n\n.dropdown-menu .dropdown-item.text-danger:hover,\n.dropdown-menu a.dropdown-item.text-danger:hover,\n.dropdown-menu button.dropdown-item.text-danger:hover {\n  background: rgba(239, 68, 68, 0.08);\n  color: #dc2626;\n}\n\n.dropdown-menu .dropdown-item.disabled,\n.dropdown-menu .dropdown-item:disabled,\n.dropdown-menu a.dropdown-item.disabled,\n.dropdown-menu button.dropdown-item:disabled {\n  opacity: 0.48;\n  pointer-events: none;\n}\n\n.table-action .action-icon {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.table-action .action-icon:hover,\n.table-action .action-icon:focus {\n  border-color: #e85b28;\n  color: #e85b28;\n  box-shadow: 0 6px 16px rgba(232, 91, 40, 0.14);\n}",".inbox-menu {\n    display: inline-block;\n    \n    width: 100%;\n    @include margin-padding(0 0 20px,0 );\n    li {\n        display: inline-block;\n        width: 100%;\n        a {\n            color: #333;\n            display: inline-block;\n            padding: 10px 15px;\n            width: 100%;\n            font-weight: $font-weight-semibold;\n            text-transform: capitalize;\n            -webkit-transition: 0.3s ease;\n            -moz-transition: 0.3s ease;\n            transition: 0.3s ease;\n            &:hover{\n                background: rgba(33, 33, 33, 0.05);\n            }\n            i {\n                font-size: $font-size-16;\n                padding-right: 10px;\n                color: #878787;\n            }\n        }\n    }\n}\n.compose-btn {\n    margin-bottom: 25px;\n}\n.top-action-left{\n    .btn-group {\n        margin-bottom: 5px;\n    }\n    .dropdown-toggle{\n        height: 40px;\n        &::after{\n            display: none;\n        }\n    }\n}\n.table-inbox {\n    .starred.fas.fa-star {\n        color: $warning;\n    }\n    .checked {\n        background-color: $gray-300;\n    }\n    th{\n        border-color: $light-700;  \n    }\n    tbody{\n        tr{\n            td{\n                font-size: $font-size-14;\n                color: $secondary;\n                border-color: $light-900;\n            }\n        }\n    }\n}\n.unread{\n    .name,\n    .subject,\n    .mail-date{\n        color: $black;\n        font-weight: $font-weight-bold;\n    }\n}\n.email-header{\n    .btn-white{\n        min-width: auto;\n        height: 38px;\n        border: 1px solid $light-900;\n        i{\n            margin-left:5px;\n        }\n    }\n}",".file-manager {\n    color:  $text-color;\n    .search-dropdown {\n        height: auto;\n    }\n    .form-sort {\n        width:  auto;\n        .select2-container--default .select2-selection--single .select2-selection__rendered {\n            padding-right: 27px;\n        }\n        &.owned-by {\n            margin-right: 10px;\n        }\n    }\n    &.notes-page-wrapper { \n        .content {\n            .page-add-notes {\n                padding-bottom: 30px;\n                margin-bottom: 30px;\n            }\n            .section-bulk-wrap {\n                margin-top: 0;\n                .form-sort {\n                    svg {\n                        &.fa-filter {\n                            top: 50%;\n                            @include transform(translateY(-50%));                            \n                        }\n                    }\n                }\n                .bulk-action-type {\n                    .select-bluk {\n                        margin-right: 15px;\n                    }\n                }\n            }\n        }\n    }\n    .page-header {\n        .btn-added {\n            margin-left: 10px;\n        }\n        .form-sort {\n            @include respond-below(custom575) {\n                margin-top: 0;\n                margin-bottom:  15px;\n            }\n        }\n        .table-top-head {\n            @include respond-below(custom575) {\n                margin-bottom: 15px;\n            }\n            li {\n                &:last-child {\n                    @include respond-below(custom991) {\n                        margin-right: 0;\n                    }\n                }\n            }\n        }\n    }\n    .bulk-action-type {\n        @include respond-below(custom767) {\n            align-items: start!important;\n        }\n        @include respond-below(custom575) {\n            display: block!important;\n        }\n        @include respond-below(custom767) {\n            .form-sort {\n                margin-top: 0;\n                margin-bottom: 15px;\n                width: 100%;\n            }\n        }\n    }\n    aside {\n        border: 1px solid $light-900;\n        box-shadow: $box-shadow;\n        @include rounded(8px);\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            border-bottom:  1px solid $gray-100;\n            @include margin-padding(0 0 15px 0, 0 0 15px 0);\n        }\n        .btn {\n            font-weight: $font-weight-bold;\n        }\n        .dropdown {\n            > a { \n                width: auto;\n                height: 40px;\n                color:  $white;\n                @include rounded(5px);\n                &:hover, &:focus {\n                    border-color: $gray-400;\n                    background: $gray-400;\n                }\n            }\n            ul {\n                width: 100%;\n                li {\n                    a {\n                        font-size: $font-size-15;\n                    }\n                }\n            }\n        }\n        ul {\n            li {\n                a {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    color: $text-color;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-semibold;\n                    @include margin-padding(0 0 5px 0, 7px 10px);\n                    @include rounded(5px);\n                    height: 40px;\n                    span {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        width: auto;\n                    }\n                    &:hover, &.active {\n                        background: $gray-400;\n                        color: $white;\n                    }\n                }\n            }\n        }\n        span {\n            font-size: $font-size-13;\n            font-weight: $font-weight-medium; \n            width: auto;\n            height: auto;\n        }\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            position: relative;\n            z-index: 2;\n        }\n        .space-manager {\n            color:  $white;\n            background: $gray-400;\n            @include rounded(8px);\n            position: relative;\n            img {\n                @include position(absolute,0,0,null,null);\n            }\n            h6 {\n                a {\n                    color:  $white;\n                }\n            }\n            p {\n                color:  $sub-title;\n            }\n        }\n    }\n    .progress {\n        height: 6px;\n        @include rounded(5px);\n    }\n    .search-set {\n         .search-input {\n            input[type=search] {\n                width:  170px;\n                height: 40px;\n            }\n\n         }\n\n    }\n    .budgeted-role-notes {\n        .search-set {\n            .search-input {\n                input[type=search] {\n                    width:  298px;\n                }\n            }\n        }\n    }\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-semibold;\n    }\n    h6 {\n        font-size: $font-size-16;\n        font-weight: $font-weight-semibold;\n        a {\n            color: $gray-400;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .overview {\n        .detail {\n            a {\n                &.bg {\n                    @include rounded(8px 8px 0 0);\n                    span {\n                        width: 66px;\n                        height: 66px;\n                        @include rounded(100%);\n                        img {\n                            @include transition(all 0.5s ease);\n                        }\n                    }\n                }\n                &:hover {\n                    img {\n                        transform: scale(1.2);\n                    }\n                }\n            }\n        }\n    }\n    .info {\n        @include rounded(0 0 8px 8px);\n        padding: 15px;\n        background: $white;\n        box-shadow: $box-shadow;\n        span {\n            color:  $text-color;\n            font-size: $font-size-13;\n        }\n    }\n    .folders {\n        border: 1px solid $light-900;\n        box-shadow: $box-shadow;\n        @include rounded(8px);\n        background: $white;\n        h6 {\n            width: 100%;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-right: 8px;\n        }\n    }\n\n    .dropdown {\n        > a {\n            color: $gray-400;\n            width: 25px;\n            height: 25px;\n            @include transition(all 0.5s ease);\n            @include rounded(100%);\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &:hover {\n                background: $primary;\n                i {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .project-plan {\n        font-size: $font-size-13;\n        font-weight: $font-weight-semibold;\n        margin-top: 10px;\n        label {\n            color: $gray-400;\n            margin-right: 9px;\n            font-size: $font-size-13;\n        }\n        ul {\n            li {\n                font-size: $font-size-13;\n                position: relative;\n                padding: 0 9px 0 14px;\n                color:  $text-color;\n                &:before {\n                    content:  '';\n                    @include position(absolute,50%,null,null,0);\n                    @include transform(translateY(-50%));\n                    width: 5px;\n                    height: 5px;\n                    background: $gray-400;\n                    @include rounded(5px);\n                }\n            }\n        }\n    }\n    .avatar-wrap {\n        a {\n            svg {\n                color: $text-color;\n                width: 18px;\n            }\n            &:hover {\n                svg {\n                    color: $primary; \n                    \n                }\n            }\n        }\n    }\n    .accordion {\n        border:  none;\n        --bs-accordion-border-width: none;\n        .accordion-item {\n            border:  none;\n            border-bottom: 1px solid $light-900;\n            background: none;\n            &:last-of-type {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n                border-bottom: none;\n            }\n            .accordion-button {\n                background: none;\n                border:  none;\n                font-size: $font-size-18;\n                font-weight: $font-weight-semibold;\n                color: $gray-400;\n                padding: 0;\n                display: inline-block;\n                width: auto;\n                &:after {\n                    @include transition(all 0.8s ease);\n                    background-image: none;\n                    content: \"View All\";\n                    font-family: \"Nunito\", sans-serif;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-bold;\n                    color: $text-color;\n                    transform:  none;\n                    width: 60px;\n                    text-align: right;\n                }\n                &:not(.collapsed)::after {\n                    content: \"Hide\";\n                }\n                &.collapsed {\n                    padding: 0;\n                }\n                &:hover {\n                    &:after {\n                        color: $primary;\n                    }\n                }\n            }\n            .accordion-body {\n                border: none;\n                padding: 0;\n                .head {\n                    img {\n                        min-width: 32px;\n                        width:  32px;\n                        height: 32px;\n                    }\n                }\n                .owl-carousel {\n                    padding-top: 15px;\n                }\n            }\n\n        }\n    }\n    .owl-carousel {\n        .owl-item {\n            margin-left: -0.1px!important;\n        }\n        .dropdown-menu {\n            left: auto !important;\n            right: 0 !important;\n            top:  27px !important;\n            transform: none !important;\n            background: $white !important;\n            box-shadow: $box-shadow;\n            z-index: 99999 !important;\n        }\n        .owl-nav {\n            top: -20px;\n            left: 43px;\n            display: inline-table;\n            button {\n                margin-top: 0;\n                margin-bottom: 0;\n                background: none;\n                cursor: pointer;\n                &.owl-next, &.owl-prev {\n                    position: relative;\n                    width: 15px;\n                    i {\n                        color: $text-color;\n                    }\n                    &:hover {\n                        background: none;\n                        i {\n                           color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        &.folders-carousel {\n           .owl-nav {\n                left:  75px;\n            } \n        }\n        &.video-section {\n            .owl-nav {\n                left:  60px;\n            }\n            .info {\n                a {\n                    svg {\n                        color: $text-color;\n                        width: 18px;\n                    }\n                }\n            }\n        }\n    }\n    .all-files {\n        box-shadow: $box-shadow;\n        border: none;\n        .btn-grp {\n            a {\n                padding: 6px 8px;\n                @include rounded(8px);\n                cursor: pointer;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                @include respond-below(custom575) {\n                    margin-bottom: 15px;\n                    display: inline-block;\n                }\n                &.btn-outline-secondary {\n                    color:  $text-color;\n                    background: $body-bg;\n                    border-color: $body-bg;\n                }\n                &:hover {\n                    background: $gray-400;\n                    border-color: $gray-400;\n                    color: $white;\n                }\n            }\n        }\n        .table { \n            thead {\n                tr {\n                    th {\n                        border-color: $light-900;\n                    }\n                }\n            }\n            tbody {\n                tr { \n                    td {  \n                        display: table-cell;\n                        font-size: $font-size-base;\n                        font-weight: $font-weight-medium;\n                        white-space: nowrap;\n                        border-color: $light-900;\n                        a {\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-medium;\n                            &.product-img { \n                                img {\n                                    width: 32px;\n                                    height: 32px;\n                                    border: 0;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    #file-delete {\n        font-size: $font-size-base;\n    }\n}\naside {\n    padding: 24px;\n}\n.color-primary {\n    color:  $text-color;\n}\n.icon-select {\n    position: relative;\n    width: 149px;\n    height: 38px;\n\n    .icon {\n        @include position(absolute,50%,null,null,10px);\n        @include transform(translateY(-50%));\n        z-index: 100;\n    }\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 30px;\n    }\n}\n.bg-light-orange {\n    background: $primary-200;\n    span {\n        background: $primary-200;\n    }\n}\n.bg-light-red {\n    background: $danger-200;\n    span {\n        background: $danger-200;\n    }\n}\n.bg-light-green {\n    background: $success-300;\n    span {\n        background: $success-300;\n    }\n}\n.seprator-sm {\n    @include margin-padding(0 0 24px 0, 0 0 9px 0);\n    border-bottom: 1px solid $gray-100;\n}\n.seprator-lg {\n    @include margin-padding(0 0 24px 0, 0 0 24px 0);\n    border-bottom: 1px solid $light-900;\n}\n.group-avatar {\n    .avatar {\n        position: relative;\n        width: 43px;\n        height: 43px;\n        line-height: 43px;\n        margin: 0;\n    \n         & +.avatar {\n            margin-left: -1.2rem;\n        }\n        &:hover {\n            z-index: 1;\n        }\n    }\n    .count {\n        a { \n            color: $success;\n            line-height: 27px;\n            font-size: $font-size-13;\n            font-weight: $font-weight-medium;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .avatar img {\n      display: block;\n      border-radius: 100%;\n      width: 100%;\n      border: 2px solid $white;\n    }\n}\n\n.video-section .item{\n  opacity:0.4;\n  transition:.4s ease all;\n  transform:scale(.8);\n}\n\n@media(max-width:1000px){\n  .video-section .item{margin:0; transform:scale(.9)}\n}\n\n.video-section .active .item{\n  opacity:1;\n  transform:scale(1);\n} \n\n.video-section .owl-item {\n    -webkit-backface-visibility: hidden;\n    -webkit-transform: translateZ(0) scale(1.0, 1.0);\n}\n\n.video-section video{\n  max-width:100%;\n  height:100%;\n  @include rounded(10px 10px 0 0);\n}\n.delete-alert {\n    padding: 10px 20px;\n    background: $danger-200;\n    border:  none;\n    @include rounded(8px);\n    p {\n        font-size: $font-size-15;\n    }\n    .btn {\n        font-weight: $font-weight-bold;\n    }\n}\n.deleted-info {\n    display: none;\n    .bin-bg {\n        width: 184px;\n        height: 184px;\n        @include rounded(100%);\n        background: $light;\n        margin: 0 auto;\n    }\n}\n.popup-toggle {\n    cursor: pointer;\n}\n.toggle-sidebar {\n    width: 456px;\n    padding: 25px;\n    position: fixed;\n    right: -456px;\n    top: 0;\n    height: 100%;\n    background: $white;\n    z-index: 100001;\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\n    overflow-y: auto;\n    @include transition(all 0.5s ease);\n    @include respond-below(custom575) {\n        width: 320px;\n        right: -320px;\n    }\n    &.open-sidebar {\n        right: 0;\n        @include transition(all 0.5s ease);\n    }\n    .head {\n        .color-primary {\n            &:hover {\n                color: $danger;\n            }\n        }\n    } \n    h4, h5 {\n        font-weight: $font-weight-bold;\n    }\n    h4 {\n        font-size: $font-size-20;\n    }\n    h5 {\n        font-size: $font-size-18;\n    }\n    h6 {\n         font-size: $font-size-15;\n        font-weight: $font-weight-semibold;\n    }\n    .nav-tabs {\n        border-bottom: 1px solid $gray-100;\n        .nav-link {\n            padding: 8px 20px;\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            @include rounded(8px);\n            border: none;\n            background: $body-bg;\n            color: $gray-400;\n            &:hover, &.active {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n    .tab-content {\n        .tab-pane {\n            ul {\n                li {\n                    h6 {\n                        margin-bottom: 5px;\n                    }\n                    p {\n                        &.location {\n                            background: $body-bg;\n                            border: 1px solid $gray-100;\n                            @include rounded(5px);\n                            padding: 5px;\n                            display: inline-block;\n                            img {\n                                width: 20px;\n                                height: 20px;\n                            }\n                        }\n                    }\n                    .note-editor.note-airframe .note-statusbar, .note-editor.note-frame .note-statusbar {\n                        border-top: none;\n                    }\n                }\n            }\n            .avatar-access {\n                span {\n                    a {\n                        display: inline-flex; \n                        margin-right: 3px;\n                        padding-right: 3px;\n                    }\n                    &:first-child {\n                        a {\n                            margin-right: 10px;\n                            padding-right: 10px;\n                            border-right: 1px solid $gray-100;\n                        }\n                    }\n                    &:last-child {\n                        a {\n                            margin-right: 0;\n                            padding-right: 0;\n                        }\n                    }\n                    .add {\n                        background: $primary;\n                        color:  $white;\n                        &:hover {\n                            background: $gray-400;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    p {\n        color: $text-color;\n        font-size: $font-size-15;\n    }\n    .show-all {\n        font-weight: $font-weight-bold;\n        &:hover {\n            color: $gray-400;\n        }\n    }\n\n}\n.text-danger {\n    color: $danger!important;\n}\n.avatar-md {\n    width: 45px;\n    height: 45px;\n    @include rounded(45px);\n}\n.text-secondary {\n    color: $gray-400!important;\n}\n.text-primary {\n    color: $primary!important;\n}\n.text-default {\n    color: $text-color;\n}\n.btn-icon {\n    svg {\n        width: 18px;\n}\n}\n\n.file-manager-modal {\n    .modal-header {\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n        }\n    }\n    &#hold-order {\n        h2 {\n            font-size: $font-size-36;\n            font-weight: $font-weight-bold;\n            color: $gray-900;\n            margin-bottom: 10px;\n            background-color: $body-bg;\n            @include rounded(10px);\n        }\n        .input-block {\n            label {\n                margin-bottom: 5px;\n            }\n        }\n        p {\n            margin-top: 20px;\n        }\n    }\n    &#recents {\n        .table {\n            tbody {\n                tr {\n                    td {\n                        padding: 10px 15px;\n                    }\n                }\n            }\n\n        }\n    }\n    .badge {\n        padding: 5px 10px;\n        font-size: $font-size-15;\n        font-weight: normal;\n    }\n    &#orders {\n        .modal-dialog {\n            max-width: 575px;\n        }\n        .order-body{\n            height: 50vh;\n            overflow: auto;\n            .default-cover {\n                border: 1px solid $gray-100;\n                box-shadow: $box-shadow;\n                @include rounded(8px);\n            }\n            .record {\n                font-size: $font-size-15;\n                td {\n                    padding-bottom: 15px;\n                }\n                tr {\n                    &:last-child {\n                        td {\n                            padding-bottom: 0;\n                        }\n                    }\n                }\n                .colon {\n                    padding: 0 10px;\n                    color: $secondary;\n                }\n                .text {\n                    color: $text-color;\n                    white-space: nowrap;\n                }\n            }\n            p {\n                font-size: $font-size-15;\n                background-color: $body-bg;\n                @include rounded(8px);\n            }\n            .search-set {\n                .search-input {\n                    width: 100%;\n                    label {\n                        width: 100%;\n                        input {\n                            width: 100%;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.upload-modal {\n        .modal-body{ \n            .drag-drop {\n                position: relative;\n                padding: 20px;\n                border:  1px dashed $sub-title;\n                input[type=\"file\"] {\n                    @include position(absolute,0,0,null,0);\n                    width: 100%;\n                    height: 100%;\n                    opacity: 0;\n                    cursor: pointer;\n                }\n            }\n            span {\n                font-size: $font-size-13;\n                font-weight: $font-weight-medium;\n                color: $text-color;\n            }\n            p {\n                font-size: $font-size-16;\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n                margin-bottom: 0;\n            }\n            .progress {\n                height: 6px;\n                @include rounded(5px);\n            }\n            ul {\n                li {\n                    @include margin-padding(0 0 15px 0, 15px);\n                    @include rounded(8px);\n                    border: 1px solid $gray-100;\n                    svg {\n                        width: 18px;\n                    }\n                    h6 {\n                        a {\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            color: $secondary;\n                            svg {\n                                color:  $success;\n                            }\n                        }\n                        &:hover {\n                            a {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n    &#upload-message {\n        .modal-dialog {\n            position:fixed;\n            bottom:0px;\n            right:24px;\n            margin:0px;\n            left:  auto;\n            top: calc(100% - 300px); \n            width: 600px;\n        }\n        .progress {\n            height: 6px;\n            @include rounded(5px);\n        }\n    }\n}\n.datanew {\n    tr {\n        td {\n            svg {\n                width: 18px;\n            }\n        }\n    }\n}",".icons-list {\n    padding: 0;\n    display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n      li {\n        display: block;\n        width: 40px;\n        height: 40px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        font-size: $font-size-18;\n        @include rounded(50px);\n        border: 1px solid #e6ebf1;\n        color: $primary;\n        @include margin-padding(5px, null);\n        @include box-shadow(null, 0, 2px, 3px, null, rgb(215, 197, 255));\n    }\n}\n\n// Tabler Icons spin animation\n.ti-spin {\n  animation: ti-spin 1s linear infinite;\n}\n\n@keyframes ti-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n",".progress {\n    background-color: $light-900;\n    height: 0.75rem;\n    border-radius: 0.25rem;\n}\n.progress-stacked {\n    background-color: $light-900;\n}\n.progress-bar {\n    color: $white;\n    background-color: $primary;\n}\n\n@keyframes progress-animate {\n    0% {\n        width: 0;\n    }\n}\n.progress-animate {\n    position: relative;\n    border-radius: 0.625rem;\n    .progress-bar {\n        position: relative;\n        border-radius: 0.625rem;\n        animation:  2s progress-animate;\n    }\n}\n.progress,.progress-stacked {\n    &.progress-xs {\n        height: .3125rem;\n    }\n    &.progress-sm {\n        height: 0.5rem;\n    }\n    &.progress-lg {\n        height: 1rem;\n    }\n    &.progress-xl {\n        height: 1.25rem;\n    }\n}\n.progress-vertical {\n    min-height: 250px;\n    height: 250px;\n    width: 10px;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-sm {\n        width: 8px;\n    }\n\n    &.progress-xs {\n        width: 5px;\n    }\n}\n.progress-vertical-bottom {\n    min-height: 250px;\n    height: 250px;\n    position: relative;\n    width: 10px;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n        bottom: 0;\n        position: absolute;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-sm {\n        width: 8px;\n    }\n\n    &.progress-xs {\n        width: 5px;\n    }\n}\n.progress-custom {\n    overflow: visible;\n    position: relative;\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n        &:after {\n            content: \"\";\n            width: 1.15rem;\n            height: 1.15rem;\n            border-radius: 50%;\n            box-shadow: 0 0.313rem 0.313rem rgba($primary, 0.5);\n            background: $white;\n            position: absolute;\n            inset-inline-end: -0.375rem;\n            inset-block-start: -0.375rem;\n            border: 0.25rem solid $primary;\n        }\n        &.bg-secondary:after {\n            border: 0.25rem solid $secondary;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb),0.2);\n        }\n        &.bg-warning:after {\n            border: 0.25rem solid $warning;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb),0.2);\n        }\n        &.bg-info:after {\n            border: 0.25rem solid $info;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb),0.2);\n        }\n        &.bg-success:after {\n            border: 0.25rem solid $success;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb),0.2);\n        }\n        &.bg-danger:after {\n            border: 0.25rem solid $danger;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb),0.2);\n        }\n    }\n    .progress-bar-value{\n        width: 1.875rem;\n        height: 1.25rem;\n        line-height: 1.25rem;\n        border-radius: 0.188rem;\n        background: $primary;\n        box-shadow: 0 0.313rem 0.313rem rgba(0,0,0,0.4);\n        font-size: 0.625rem;\n        font-weight: $font-weight-semibold;\n        color: $white;\n        text-align: center;\n        position: absolute;\n        inset-block-end: 1.5rem;\n        inset-inline-end: -0.688rem;\n        &:after{\n            content: \"\";\n            border-block-start: 0.438rem solid $primary;\n            border-inline-start: 0.438rem solid transparent;\n            border-inline-end: 0.438rem solid transparent;\n            position: absolute;\n            inset-block-end: -0.375rem;\n            inset-inline-start: 28%;\n        }\n        &.bg-secondary {\n            background-color: $secondary;\n            &:after {\n                border-block-start: 0.438rem solid $secondary;\n            }\n        }\n        &.bg-success {\n            background-color: $success;\n            &:after {\n                border-block-start: 0.438rem solid $success;\n            }\n        }\n        &.bg-warning {\n            background-color: $warning;\n            &:after {\n                border-block-start: 0.438rem solid $warning;\n            }\n        }\n        &.bg-danger {\n            background-color: $danger;\n            &:after {\n                border-block-start: 0.438rem solid $danger;\n            }\n        }\n        &.bg-info {\n            background-color: $info;\n            &:after {\n                border-block-start: 0.438rem solid $info;\n            }\n        }\n    }\n}\n[dir=\"rtl\"] {\n    .progress-bar-title{ \n        border-radius: 0 0.313rem 0.313rem 0;\n    }\n}\n.progress-item-1, .progress-item-2, .progress-item-3{\n    position:absolute;\n\tmargin-block-start:-0.25rem;\n\tz-index:1;\n\theight:0.938rem;\n\twidth:0.938rem;\n\tborder-radius:1.563rem;\n    background-color: $light;\n}\n.progress-item-1{\n\tinset-inline-start:25%;\n}\n.progress-item-2{\n\tinset-inline-start:50%;\n}\n.progress-item-3{\n\tinset-inline-start:75%;\n}\n.custom-progress-3 {\n    overflow: visible;\n    border-radius: 0.625rem;\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n        margin: 0.313rem;\n        border-radius: 0.25rem;\n        &:before {\n            content: \"\";\n            position: absolute;\n            width: 0.25rem;\n            height: 0.25rem;\n            inset-inline-start: 0.125rem;\n            background-color: $white;\n            border-radius: 50%;\n        }\n        .progress-bar-value{\n            border: 0.125rem solid $primary;\n            width: 2.5rem;\n            height: 1.563rem;\n            line-height: 1.313rem;\n            border-radius: 3.125rem;\n            background: $white;\n            font-size: 0.625rem;\n            font-weight: $font-weight-semibold;\n            color: $primary;\n            text-align: center;\n            position: absolute;\n            inset-inline-end: -0.625rem;\n            &.secondary {\n                border: 0.125rem solid $secondary;\n                color: $secondary;\n            }\n            &.warning {\n                border: 0.125rem solid $warning;\n                color: $warning;\n            }\n            &.info {\n                border: 0.125rem solid $info;\n                color: $info;\n            }\n            &.success {\n                border: 0.125rem solid $success;\n                color: $success;\n            }\n            &.danger {\n                border: 0.125rem solid $danger;\n                color: $danger;\n            }\n        }\n    }\n}\n.custom-progress-4 {\n    &.progress {\n        background-color: rgba($primary, 0.1);\n        border-radius: 0.25rem;\n        &.secondary {\n            background-color: rgba($secondary, 0.1);\n            .progress-bar-label {\n                color: $secondary;\n            }\n        }\n        &.warning {\n            background-color: rgba($warning, 0.1);\n            .progress-bar-label {\n                color: $warning;\n            }\n        }\n        &.info {\n            background-color: rgba($info, 0.1);\n            .progress-bar-label {\n                color: $info;\n            }\n        }\n        &.success {\n            background-color: rgba($success, 0.1);\n            .progress-bar-label {\n                color: $success;\n            }\n        }\n        &.danger {\n            background-color: rgba($danger, 0.1);\n            .progress-bar-label {\n                color: $danger;\n            }\n        }\n        .progress-bar {\n            border-radius: 0.25rem;\n        }\n        .progress-bar-label {\n            position: absolute;\n            inset-inline-end: 0.313rem;\n            font-weight: $font-weight-semibold;\n            font-size: 0.813rem;\n            color: $primary;\n        }\n    }\n}",".page-link {\n    color: $text-color;\n    background-color: $white;\n    border: 1px solid $border-color;\n    &:focus {\n        box-shadow: none;\n        background-color: $light;\n    }\n    &:hover {\n        color: $primary;\n        background-color: $light;\n        border-color: $border-color;\n    }\n}\n.page-item.active .page-link {\n    color: $white;\n    background-color: $primary;\n    border-color: $primary;\n}\n.disabled>.page-link, .page-link.disabled {\n    color: $text-color;\n    background-color: $white;\n    border-color: $border-color;\n    opacity: 0.7;\n}\n\n[dir=\"rtl\"] { \n    .pagination{\n        .page-link{\n            .bx-chevron-left::before{\n                content: \"\\ea50\";\n            }\n            .bx-chevron-right::before{\n                content: \"\\ea4d\";\n            }\n            .ri-arrow-right-s-line:before{\n                content: \"\\ea64\";\n            }\n            .ri-arrow-left-s-line:before{\n                content: \"\\ea6e\";\n            }\n        }\n    }\n}\n.pagination-style-1 .pagination {\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0;\n            border-radius: $border-radius;\n            font-size: 0.8125rem;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                border-radius: $border-radius;\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    border-radius: $border-radius;\n                    background-color: $primary;\n                    color: $white;\n                }\n            } \n        }\n        &:hover {\n            .page-link {\n                background-color: $light;\n                color: $primary;\n            }\n        }\n    }\n}\n.pagination-style-2 .pagination {\n    border-radius: $border-radius;\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0 !important;\n            font-size: 0.8125rem;\n        }\n        &.active {\n            .page-link {\n                background-color: $white;\n                color: $primary;\n                position: relative;\n                font-weight: bold;\n                &:before {\n                    position: absolute;\n                    content: \"\";\n                    inset-block-end: 0;\n                    inset-inline-start: 0;\n                    width: 100%;\n                    height: 0.1rem;\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: transparent;\n            }\n        }\n    }\n}\n.pagination-style-3 .pagination {\n    border-radius: 50px;\n    padding: 0.25rem;\n    align-items: center;\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0;\n            border-radius: 50px;\n            font-size: 0.8125rem;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: $light;\n            }\n        }\n    }\n}\n.pagination-style-4 .pagination {\n    .page-item {\n        .page-link {\n            border: 0 !important;\n            font-size: 0.8125rem;\n            border-radius: $border-radius;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                border: 0;\n                border-radius: $border-radius;\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: transparent;\n            }\n        }\n    }\n}","h1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  color: $title-color;\n  font-family: $font-family-primary;\n  font-weight: $font-weight-bold;\n  margin-bottom: 0;\n}\nh1,\n.h1 {\n  font-size: 2rem;\n}\nh2,\n.h2 {\n  font-size: 1.75rem;\n}\nh3,\n.h3 {\n  font-size: 1.5rem;\n}\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\nh5,\n.h5 {\n  font-size: 1rem;\n}\nh6,\n.h6 {\n  font-size: 0.875rem;\n}\n.fs-sm {\n  font-size: 0.6875rem; //11px\n}\n.fs-base {\n  font-size: 0.875rem; //14px\n}\n.fs-lg {\n  font-size: 1.125rem; //18px\n}\n\n// (1px-30px are linear, above 30px are step increment of 1)\n.fs-1 {\n  font-size: 0.0625rem; //1px\n}\n.fs-2 {\n  font-size: 0.125rem; //2px\n}\n.fs-3 {\n  font-size: 0.1875rem; //3px\n}\n.fs-4 {\n  font-size: 0.25rem; //4px\n}\n.fs-5 {\n  font-size: 0.3125rem; //5px\n}\n.fs-6 {\n  font-size: 0.375rem; //6px\n}\n.fs-7 {\n  font-size: 0.4375rem; //7px\n}\n.fs-8 {\n  font-size: 0.5rem; //8px\n}\n.fs-9 {\n  font-size: 0.5625rem; //9px\n}\n.fs-10 {\n  font-size: 0.625rem; //10px\n}\n.fs-11 {\n  font-size: 0.6875rem; //11px\n}\n.fs-12 {\n  font-size: 0.75rem; //12px\n}\n.fs-13 {\n  font-size: 0.8125rem; //13px\n}\n.fs-14 {\n  font-size: 0.875rem; //14px\n}\n.fs-15 {\n  font-size: 0.9375rem; //15px\n}\n.fs-16 {\n  font-size: 1rem; //16px\n}\n.fs-17 {\n  font-size: 1.0625rem; //17px\n}\n.fs-18 {\n  font-size: 1.125rem; //18px\n}\n.fs-19 {\n  font-size: 1.1875rem; //19px\n}\n.fs-20 {\n  font-size: 1.25rem; //20px\n}\n.fs-21 {\n  font-size: 1.3125rem; //21px\n}\n.fs-22 {\n  font-size: 1.375rem; //22px\n}\n.fs-23 {\n  font-size: 1.4375rem; //23px\n}\n.fs-24 {\n  font-size: 1.5rem; //24px\n}\n.fs-25 {\n  font-size: 1.5625rem; //25px\n}\n.fs-26 {\n  font-size: 1.625rem; //26px\n}\n.fs-27 {\n  font-size: 1.6875rem; //27px\n}\n.fs-28 {\n  font-size: 1.75rem; //28px\n  @include respond-below(custom575) {\n    font-size: 1.25rem;\n  }\n}\n.fs-29 {\n  font-size: 1.8125rem; //29px\n \n}\n.fs-30 {\n  font-size: 1.875rem; //30px\n}\n.fs-32 {\n  font-size: 2rem; //32px\n}\n.fs-34 {\n  font-size: 2.125rem; //34px\n}\n.fs-36 {\n  font-size: 2.25rem; //36px\n}\n.fs-38 {\n  font-size: 2.375rem; //38px\n}\n.fs-40 {\n  font-size: 2.5rem; //40px\n}\n.fs-60 {\n  font-size: 3.75rem; //60px\n  @include respond-below(custom991) {\n    font-size: 2.125rem;\n  }\n  @include respond-below(custom575) {\n    font-size: 1.125rem;\n  }\n}\n.text-default {\n  color: $text-color !important;\n}\n.text-muted {\n  color: $text-muted !important;\n}\n.text-primary {\n  color: $primary !important;\n  opacity: 1;\n  &.text-opacity-75 {\n    color: rgba($primary, 0.75) !important;\n  }\n  &.text-opacity-25 {\n    color: rgba($primary, 0.25) !important;\n  }\n  &.text-opacity-50 {\n    color: rgba($primary, 0.50) !important;\n  }\n}\n.text-secondary {\n  color: $secondary !important;\n  opacity: 1;\n}\n.text-info {\n  color: $info !important;\n  opacity: 1;\n}\n.text-success {\n  color: $success !important;\n  opacity: 1;\n}\n.text-warning {\n  color: $warning !important;\n  opacity: 1;\n}\n.text-danger {\n  color: $danger !important;\n  opacity: 1;\n}\n.text-blue {\n  color: $blue !important;\n}\n.text-green {\n  color: $green !important;\n}\n.text-pink {\n  color: $pink !important;\n}\n.text-teal {\n  color: $teal !important;\n}\n.text-orange {\n  color: $orange !important;\n}\n.text-indigo {\n  color: $indigo !important;\n}\n.text-purple {\n  color: $purple !important;\n}\n.text-dark {\n  color: $dark !important;\n}\n.text-light {\n  color: $light !important;\n}\n.text-gray {\n  color: $gray-500 !important;\n}\n.text-black {\n  color: $black !important;\n}\n.text-white {\n  color: $white !important;\n}\n.text-fixed-white {\n  color: $white !important;\n}\n.text-fixed-black {\n  color: $black !important;\n}\n.text-gray-1 {\n  color: $gray-100;\n}\n.text-gray-2 {\n  color: $gray-200;\n}\n.text-gray-3 {\n  color: $gray-300;\n}\n.text-gray-4 {\n  color: $gray-400;\n}\n.text-gray-5 {\n  color: $gray-500;\n}\n.text-gray-6 {\n  color: $gray-600;\n}\n.text-gray-7 {\n  color: $gray-700;\n}\n.text-gray-8 {\n  color: $gray-800;\n}\n.text-gray-9 {\n  color: $gray-900;\n}\na {\n  color: $gray-900;\n  cursor: pointer;\n  text-decoration: none;\n  @include transition(all 0.5s ease);\n  &:hover {\n    color: $primary;\n    @include transition(all 0.5s ease);\n  }\n  &:focus {\n    outline: 0;\n  }\n}\n.link-primary {\n  color: $primary !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $primary !important;\n  }\n}\n.link-secondary {\n  color: $secondary !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $secondary !important;\n  }\n}\n.link-success {\n  color: $success !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $success !important;\n  }\n}\n.link-danger {\n  color: $danger !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $danger !important;\n  }\n}\n.link-warning {\n  color: $warning !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $warning !important;\n  }\n}\n.link-info {\n  color: $info !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $info !important;\n  }\n}\n.link-light {\n  color: $light !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $light !important;\n  }\n}\n.link-dark {\n  color: $dark !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $dark !important;\n  }\n}\nhr {\n  &.text-danger {\n    border-color: $danger !important;\n  }\n}\n\n.text-purple {\n  color: $purple !important;\n}\n.blockquote-container {\n  padding: 1.25rem;\n  border-left: 4px solid $default-border;\n  position: relative;\n  &.text-end {\n    border-right: 4px solid $default-border;\n    border-left: 0;\n  }\n}\n.blockquote.custom-blockquote {\n  font-size: 0.85rem;\n  font-weight: $font-weight-semibold;\n  padding: 1rem;\n  border-radius: $border-radius;\n  position: relative;\n  &:before {\n    content: \"\\f10d\";\n    font-family: $font-awesome;\n    z-index: 0;\n    font-size: 2rem;\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-start: 0.5rem;\n  }\n  &.primary {\n    background-color: rgba($primary, 0.1);\n    border-inline-start: 2px solid $primary;\n    &:before {\n      color: rgba($primary, 0.1);\n    }\n  }\n  &.secondary {\n    background-color: rgba($secondary, 0.1);\n    border-inline-start: 2px solid $secondary;\n    &:before {\n      color: rgba($secondary, 0.1);\n    }\n  }\n  &.info {\n    background-color: rgba($info, 0.1);\n    border-inline-start: 2px solid $info;\n    &:before {\n      color: rgba($info, 0.1);\n    }\n  }\n  &.warning {\n    background-color: rgba($warning, 0.1);\n    border-inline-start: 2px solid $warning;\n    &:before {\n      color: rgba($warning, 0.1);\n    }\n  }\n  &.success {\n    background-color: rgba($success, 0.1);\n    border-inline-start: 2px solid $success;\n    &:before {\n      color: rgba($success, 0.1);\n    }\n  }\n  &.danger {\n    background-color: rgba($danger, 0.1);\n    border-inline-start: 2px solid $danger;\n    &:before {\n      color: rgba($danger, 0.1);\n    }\n  }\n}\n\n[data-theme-mode=\"dark\"] {\n  .shadow-sm {\n    box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;\n  }\n  .shadow {\n    box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;\n  }\n  .shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;\n  }\n}\n\n@media screen and (min-width: 576px) {\n  .w-sm-auto {\n    width: auto;\n  }\n}\n\n[dir=\"rtl\"] {\n  .text-break {\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n  }\n}\n.transform-none {\n  transform: none !important;\n}\n.w-9 {\n  width: 9px;\n}\n.h-9 {\n  height: 9px;\n}\n.list-circle {\n    list-style: circle;\n    padding-left: 2rem;\n}\n",".alert {\n  padding: 0.625rem 0.85rem;\n  border-radius: $border-radius;\n  font-size: 0.8125rem;\n  &.alert-dismissible {\n    padding: 0.625rem 2.25rem 0.625rem 0.85rem;\n  }\n  i {\n    font-size: $font-size-20;\n  }\n  .btn-close {\n    background-image: none;\n    padding: 0.85rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    i {\n      font-size: $font-size-18;\n      line-height: 18px;\n    }\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n  .alert-link {\n    font-weight: $font-weight-semibold;\n  }\n}\n[dir=\"rtl\"] {\n  .alert.alert-dismissible {\n    padding: 0.625rem 0.85rem 0.625rem 2.25rem;\n  }\n}\n@mixin custom-close($color) {\n  background-color: $color;\n  color: $white;\n  opacity: 1;\n  border-radius: 50px;\n  box-shadow: $box-shadow;\n  padding: 0.85rem;\n}\n.alert-warning {\n  background-color: rgba($warning, 0.1);\n  color: $warning;\n  border-color: rgba($warning, 0.1);\n  .alert-link {\n    color: $warning;\n  }\n  .btn-close {\n    color: $warning;\n    &.custom-close {\n      @include custom-close($warning);\n    }\n  }\n}\n.alert-primary {\n  background-color: rgba($primary, 0.1);\n  color: $primary;\n  border-color: rgba($primary, 0.1);\n  .alert-link {\n    color: $primary;\n  }\n  .custom-alert-icon {\t\n\tcolor: $primary;\n  }\n  .btn-close {\n    color: $primary;\n    &.custom-close {\n      @include custom-close($primary);\n    }\n  }\n}\n.alert-secondary {\n  background-color: rgba($secondary, 0.1);\n  color: $secondary;\n  border-color: rgba($secondary, 0.1);\n  .alert-link {\n    color: $secondary;\n  }\n  .btn-close {\n    color: $secondary;\n    &.custom-close {\n      @include custom-close($secondary);\n    }\n  }\n}\n.alert-success {\n  background-color: rgba($success, 0.1);\n  color: $success;\n  border-color: rgba($success, 0.1);\n  .alert-link {\n    color: $success;\n  }\n  .btn-close {\n    color: $success;\n    &.custom-close {\n      @include custom-close($success);\n    }\n  }\n}\n.alert-info {\n  background-color: rgba($info, 0.1);\n  color: $info;\n  border-color: rgba($info, 0.1);\n  .alert-link {\n    color: $info;\n  }\n  .btn-close {\n    color: $info;\n    &.custom-close {\n      @include custom-close($info);\n    }\n  }\n}\n.alert-danger {\n  background-color: rgba($danger, 0.1);\n  color: $danger;\n  border-color: rgba($danger, 0.1);\n  .alert-link {\n    color: $danger;\n  }\n  .btn-close {\n    color: $danger;\n    &.custom-close {\n      @include custom-close($danger);\n    }\n  }\n}\n.alert-light {\n  background-color: $light;\n  color: $text-color;\n  border-color: $light;\n  .alert-link {\n    color: $text-color;\n  }\n  .btn-close {\n    color: $text-color;\n    &.custom-close {\n      @include custom-close($light);\n    }\n  }\n}\n.alert-dark {\n  background-color: rgba($dark, 0.1);\n  color: $text-color;\n  border-color: rgba($dark, 0.1);\n  .alert-link {\n    color: $text-color;\n  }\n  .btn-close {\n    color: $white;\n    &.custom-close {\n      @include custom-close($dark);\n    }\n  }\n}\n@mixin alert-solid-color($color) {\n  background-color: $color;\n  color: $white;\n  border-color: $color;\n  .btn-close {\n    color: $white;\n  }\n}\n.alert-solid-primary {\n  @include alert-solid-color($primary);\n}\n.alert-solid-secondary {\n  @include alert-solid-color($secondary);\n}\n.alert-solid-warning {\n  @include alert-solid-color($warning);\n}\n.alert-solid-info {\n  @include alert-solid-color($info);\n}\n.alert-solid-success {\n  @include alert-solid-color($success);\n}\n.alert-solid-danger {\n  @include alert-solid-color($danger);\n}\n.alert-solid-light {\n  background-color: $light;\n  color: $text-color;\n  border-color: $default-border;\n}\n.alert-solid-dark {\n  @include alert-solid-color($dark);\n}\n@mixin outline-alert($color) {\n  background-color: $white;\n  color: $color;\n  border-color: $color;\n  .btn-close {\n    color: $color;\n  }\n}\n.alert-outline-primary {\n  @include outline-alert($primary);\n}\n.alert-outline-secondary {\n  @include outline-alert($secondary);\n}\n.alert-outline-info {\n  @include outline-alert($info);\n}\n.alert-outline-warning {\n  @include outline-alert($warning);\n}\n.alert-outline-success {\n  @include outline-alert($success);\n}\n.alert-outline-danger {\n  @include outline-alert($danger);\n}\n.alert-outline-light {\n  background-color: $white;\n  color: $text-color;\n  border-color: $light;\n}\n.alert-outline-dark {\n  @include outline-alert($dark);\n}\n@mixin custom-alert($color) {\n  border-inline-start: 0.313rem solid $color !important;\n  color: $text-muted;\n  background-color: $white;\n  border: 1px solid $default-border;\n  font-size: 0.813rem;\n  .btn-close {\n    color: $text-color;\n  }\n}\n.alert-primary.custom-alert-icon {\n  @include custom-alert($primary);\n  & > i {\n\tcolor: $primary;\n  }\n}\n.alert-secondary.custom-alert-icon {\n  @include custom-alert($secondary);\n  & > i {\n\tcolor: $secondary;\n  }\n}\n.alert-warning.custom-alert-icon {\n  @include custom-alert($warning);\n  & > i {\n\tcolor: $warning;\n  }\n}\n.alert-danger.custom-alert-icon {\n  @include custom-alert($danger);\n  & > i {\n\tcolor: $danger;\n  }\n}\n.alert-success.custom-alert-icon {\n  @include custom-alert($success);\n}\n.alert-info.custom-alert-icon {\n  @include custom-alert($info);\n}\n.alert-light.custom-alert-icon {\n  @include custom-alert($light);\n}\n.alert-dark.custom-alert-icon {\n  @include custom-alert($dark);\n}\n.custom-alert1 {\n  margin-block-end: 0;\n  background-color: $white;\n  border: 0;\n  padding: 1.25rem;\n  color: $text-color;\n  p {\n    margin-block-end: 2.5rem;\n    color: $text-muted;\n    font-size: 0.8rem;\n  }\n  .custom-alert-icon {\n\tfont-size: $font-size-40;\n    margin-bottom: 0.85rem;\n\ti {\t\t\n\t\tfont-size: $font-size-40;\n\t}\n  }\n  .btn-close {\n    padding: 0;\n    margin-block-end: 1rem;\n  }\n  &.alert-primary {\n    border-block-start: 0.313rem solid $primary;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $primary;\n\t}\n  }\n  &.alert-secondary {\n    border-block-start: 0.313rem solid $secondary;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $secondary;\n\t}\n  }\n  &.alert-warning {\n    border-block-start: 0.313rem solid $warning;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $warning;\n\t}\n  }\n  &.alert-danger {\n    border-block-start: 0.313rem solid $danger;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $danger;\n\t}\n  }\n}\n.alert-img {\n  display: flex;\n  align-items: center;\n  .avatar {\n    border: 1px solid rgba(0, 0, 0, 0.1);\n  }\n}\n@media screen and (max-width: 400px) {\n  .btn-close.custom-close {\n    margin: 9px 9px 9px 0;\n  }\n}\n.op-1-1 {\n    opacity: 1;\n}\n.op-0 {\n    opacity: 0;\n}\n.op-1 {\n    opacity: 0.1;\n}\n.op-2 {\n    opacity: 0.2;\n}\n.op-3 {\n    opacity: 0.3;\n}\n.op-4 {\n    opacity: 0.4;\n}\n.op-5 {\n    opacity: 0.5;\n}\n.op-6 {\n    opacity: 0.6;\n}\n.op-7 {\n    opacity: 0.7;\n}\n.op-8 {\n    opacity: 0.8;\n}\n.op-9 {\n    opacity: 0.9;\n}\n",".custom-popover {\n  --bs-popover-max-width: 12.5rem;\n  --bs-popover-border-color: #{$primary};\n  --bs-popover-header-bg: #{$primary};\n  --bs-popover-header-color: #{$white};\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 0.5rem;\n}\n.popover {\n  background-color: $white;\n  border: 1px solid $default-border;\n  box-shadow: $box-shadow;\n  font-size: 0.8rem;\n  border-radius: $border-radius;\n  z-index: 999;\n  .popover-header {\n    background-color: $white;\n    border-block-end: 1px solid $default-border;\n  }\n  .popover-body {\n    color: $text-color;\n  }\n  &.only-body {\n    border-radius: 0.3rem;\n  }\n}\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n.bs-popover-top > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n.bs-popover-top > .popover-arrow::before {\n  border-top-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n.bs-popover-end > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n.bs-popover-end > .popover-arrow::before {\n  border-right-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n.bs-popover-start > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n.bs-popover-start > .popover-arrow::before {\n  border-left-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n.bs-popover-bottom > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n.bs-popover-bottom > .popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n.bs-popover-bottom .popover-header::before {\n  border-bottom-color: $light;\n}\n\n@mixin pop-header-color($color) {\n  .popover-header {\n    background-color: $color;\n    color: $white;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before {\n    border-bottom-color: $color;\n  }\n}\n.header-primary {\n  @include pop-header-color($primary);\n}\n.header-secondary {\n  @include pop-header-color($secondary);\n}\n.header-warning {\n  @include pop-header-color($warning);\n}\n.header-info {\n  @include pop-header-color($info);\n}\n.header-success {\n  @include pop-header-color($success);\n}\n.header-danger {\n  @include pop-header-color($danger);\n}\n@mixin pop-bgcolor($color) {\n  &.popover {\n      border: 1px solid $color;\n    .popover-header {\n      background-color: $color;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\n      color: $white;\n      border-radius: 0.3rem 0.3rem 0 0;\n    }\n    .popover-body {\n      background-color: $color;\n      color: $white;\n      border-radius: 0 0 0.3rem 0.3rem;\n    }\n  }\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n  &.bs-popover-top > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n  &.bs-popover-top > .popover-arrow::before {\n    border-top-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n  &.bs-popover-end > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n  &.bs-popover-end > .popover-arrow::before {\n    border-right-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n  &.bs-popover-start > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n  &.bs-popover-start > .popover-arrow::before {\n    border-left-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n  &.bs-popover-bottom > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n  &.bs-popover-bottom > .popover-arrow::before,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n  &.bs-popover-bottom .popover-header::before {\n    border-bottom-color: $color;\n  }\n}\n.popover-primary {\n  @include pop-bgcolor($primary);\n}\n.popover-secondary {\n  @include pop-bgcolor($secondary);\n}\n.popover-warning {\n  @include pop-bgcolor($warning);\n}\n.popover-info {\n  @include pop-bgcolor($info);\n}\n.popover-success {\n  @include pop-bgcolor($success);\n}\n.popover-danger {\n  @include pop-bgcolor($danger);\n}\n.popover-purple {\n  @include pop-bgcolor($purple);\n}\n.popover-teal {\n  @include pop-bgcolor($teal);\n}\n\n.popover-primary-light {\n    &.popover {\n        border: 1px solid rgba($primary, 0.1);\n      .popover-header {\n        background-color: rgba($primary, 0.1);\n        border-block-end: 1px solid rgba($primary, 0.1);\n        color: $primary;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($primary, 0.1);\n    }\n}\n.popover-secondary-light {\n    &.popover {\n        border: 1px solid rgba($secondary,0.1);\n      .popover-header {\n        background-color: rgba($secondary,0.1);\n        border-block-end: 1px solid rgba($secondary,0.1);\n        color: $secondary;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($secondary,0.1);\n        color: $secondary;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--secondary-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($secondary,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--secondary-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--secondary-rgb),0.1);\n    }\n}\n.popover-warning-light {\n    &.popover {\n        border: 1px solid rgba($warning,0.1);\n      .popover-header {\n        background-color: rgba($warning,0.1);\n        border-block-end: 1px solid rgba($warning,0.1);\n        color: $warning;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($warning,0.1);\n        color: $warning;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($warning,0.1);\n    }\n}\n.popover-info-light {\n    &.popover {\n        border: 1px solid rgba($info,0.1);\n      .popover-header {\n        background-color: rgba($info,0.1);\n        border-block-end: 1px solid rgba($info,0.1);\n        color: $info;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($info,0.1);\n        color: $info;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($info,0.1);\n    }\n}\n.popover-success-light {\n    &.popover {\n        border: 1px solid rgba($success,0.1);\n      .popover-header {\n        background-color: rgba($success,0.1);\n        border-block-end: 1px solid rgba($success,0.1);\n        color: $success;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($success,0.1);\n        color: $success;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($success,0.1);\n    }\n}\n.popover-danger-light {\n    &.popover {\n        border: 1px solid rgba($danger,0.1);\n      .popover-header {\n        background-color: rgba($danger,0.1);\n        border-block-end: 1px solid rgba($danger,0.1);\n        color: $danger;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($danger,0.1);\n        color: $danger;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($danger,0.1);\n    }\n}\n.popover-purple-light {\n    &.popover {\n        border: 1px solid rgba(var(--purple-rgb),0.1);\n      .popover-header {\n        background-color: rgba(var(--purple-rgb),0.1);\n        border-block-end: 1px solid rgba(var(--purple-rgb),0.1);\n        color: $purple;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba(var(--purple-rgb),0.1);\n        color: $purple;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--purple-rgb),0.1);\n    }\n}\n.popover-teal-light {\n    &.popover {\n        border: 1px solid rgba(var(--teal-rgb),0.1);\n      .popover-header {\n        background-color: rgba(var(--teal-rgb),0.1);\n        border-block-end: 1px solid rgba(var(--teal-rgb),0.1);\n        color: $teal;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba(var(--teal-rgb),0.1);\n        color: $teal;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--teal-rgb),0.1);\n    }\n}\n.timeline {\n    position: relative;\n    list-style: none;\n    max-width: 1200px;\n    @include margin-padding(0 auto, 20px 0 20px);\n    &:before {\n      content: \" \";\n      position: absolute;\n      width: 3px;\n      margin-left: -1.5px;\n      background-color: $gray-300;\n        @include position(absolute,0,null,0,50%);\n    }\n    > li {\n      position: relative;\n      margin-bottom: 20px;\n      &::before, &::after {\n          content: \" \";\n         display: table;\n      }\n      >.timeline-panel {\n          float: left;\n          position: relative;\n          width: 46%;\n          padding: 20px;\n          border: 1px solid $gray-500;\n            @include rounded(0.25rem);\n            @include box-shadow(null, 0, 1px, 6px, null, rgba(0, 0, 0, .05));\n            &::before {\n                content: \" \";\n                display: inline-block;\n                position: absolute;\n                border-top: 8px solid transparent;\n                border-right: 0 solid $gray-500;\n                border-bottom: 8px solid transparent;\n                border-left: 8px solid $gray-500;\n                  @include position(absolute,26px,-8px,null,null);\n              }\n              &::after {\n                  content: \" \";\n                  display: inline-block;\n                    @include position(absolute,27px,-7px,null,null);\n                  border-top: 7px solid transparent;\n                  border-right: 0 solid $white;\n                  border-bottom: 7px solid transparent;\n                  border-left: 7px solid $white;\n                }\n        }\n    }\n}\n.timeline > li:after {\n  clear: both; \n}\n.timeline>li>.timeline-badge {\n  z-index: 1;\n  width: 50px;\n  height: 50px;\n  margin-left: -25px;\n  text-align: center;\n  font-size: 1.4em;\n  line-height: 50px;\n  color: $white;\n  overflow: hidden;\n    @include rounded(50%);\n    @include position(absolute,16px,null,null,50%);\n}\n.timeline>li.timeline-inverted>.timeline-panel {\n  float: right;\n  &::before {\n      right: auto;\n      left: -8px;\n      border-right-width: 8px;\n      border-left-width: 0;\n    }\n    &::after {\n        right: auto;\n        left: -7px;\n        border-right-width: 7px;\n        border-left-width: 0;\n      }\n}\n.timeline-badge.primary {\n  background-color: $primary;\n}\n.timeline-badge.success {\n  background-color: $success;\n}\n.timeline-badge.warning {\n  background-color: $warning; \n}\n.timeline-badge.danger {\n  background-color: $danger; \n}\n.timeline-badge.info {\n  background-color: $info; \n}\n.timeline-title {\n  margin-top: 0;\n  color: inherit;\n  font-weight: regular; \n}\n.timeline-body > p,\n.timeline-body > ul {\n  margin-bottom: 0; \n}\n.timeline-body > p + p {\n  margin-top: 5px; \n}\n",".form-wrap {\n    margin-bottom: 24px;\n}\n.col-form-label {\n    font-size: $font-size-14;\n    font-weight: $font-weight-medium;\n    color: $title-color;\n}\n.form-control {\n  border-color: $input-border;\n  color: #1e293b;\n  background-color: $form-control-bg;\n  font-size: 14px;\n  font-weight: $font-weight-normal;\n  line-height: 1.6;\n  border-radius: 10px;\n  padding: 10px 14px;\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\n  min-height: 42px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  &:focus {\n    border-color: #e85b28;\n    background-color: $white;\n    box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08);\n    color: #1e293b;\n  }\n\n  &::placeholder {\n    color: #94a3b8;\n    opacity: 1;\n  }\n\n  &.is-invalid {\n    border-color: #ef4444;\n  }\n\n  &.is-invalid:focus {\n    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);\n  }\n\n  &:disabled,\n  &[readonly] {\n    border-color: #e2e8f0;\n    background-color: #f8fafc;\n    color: #94a3b8;\n    box-shadow: none;\n    cursor: not-allowed;\n  }\n}\n.form-control[type=\"file\"] {\n  padding: 0.3rem 0.5rem;\n  line-height: 2.2;\n  &.form-control-sm {\n    padding: 0.25rem 0.5rem !important;\n  }\n  &.form-control-lg {\n    padding: 0.5rem 1rem !important;\n  }\n}\n.col-form-label {\n    font-size: $font-size-14;\n    font-weight: $font-weight-medium;\n    color: $title-color;\n    @include margin-padding(null, 0 0 5px);\n}\n.form-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #475569;\n  letter-spacing: 0.1px;\n}\n.form-text {\n  color: $text-muted;\n}\n\n.form-control-light {\n  background-color: $light;\n  border: 0;\n\n  &:focus {\n    background-color: $light;\n  }\n}\n.form-control-primary {\n  background-color: rgba($primary, 0.1);\n  border: 0;\n  color: $primary;\n\n  &:focus {\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n  }\n}\n.form-input-color {\n  height: 2.25rem;\n  width: 2.25rem;\n  border-radius: $border-radius;\n  overflow: hidden;\n  padding: 0;\n}\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n  color: $text-muted;\n}\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after {\n  background-color: transparent;\n}\n.input-group-text {\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\n } \n.form-select {\n  background-color: $form-control-bg;\n  border: 1.5px solid #e2e8f0;\n  color: #1e293b;\n  font-size: 14px;\n  min-height: 42px;\n  border-radius: 10px;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n  background-size: 1.25rem;\n  line-height: 1.6;\n  box-shadow: 0px 4px 4px 0px #DBDBDB40; \n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    border-color: #e85b28;\n    box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08);\n  }\n\n  &.is-invalid {\n    border-color: #ef4444;\n  }\n\n  &.is-invalid:focus {\n    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);\n  }\n\n  &:disabled {\n    border-color: #e2e8f0;\n    background-color: #f8fafc;\n    color: #94a3b8;\n    box-shadow: none;\n    cursor: not-allowed;\n  }\n\n  option {\n    background-color: $white;\n    padding: 0.35rem 0.75rem;\n    border-radius: 0.25rem;\n    margin-block-end: 0.25rem;\n    &:last-child {\n      margin-block-end: 0;\n    }\n  }\n  option:checked,\n  option:selected {\n    background-color: #e85b28 !important;\n    color: #ffffff !important;\n  }\n  option:hover,\n  option:focus {\n    background-color: #fff7ed !important;\n    color: #e85b28 !important;\n  }\n}\ninput[type=\"checkbox\"] {\n  accent-color: $primary;\n}\n\n.form-check-input {\n  width: 1rem;\n  height: 1rem;\n  background-color: $white;\n  border: 1.5px solid #e2e8f0;\n  transition: all 0.2s;\n\n  &:focus {\n    border-color: $primary;\n    box-shadow: 0 0 0 3px rgba($primary, 0.12);\n  }\n\n  &:checked {\n    background-color: $primary;\n    border-color: $primary;\n  }\n  &.form-checked-outline {\n    &:checked {\n      background-color: transparent;\n      border-color: $primary;\n    }\n  }\n  &.form-checked-secondary {\n    &:checked {\n      background-color: $secondary;\n      border-color: $secondary;\n    }\n  }\n  &.form-checked-warning {\n    &:checked {\n      background-color: $warning;\n      border-color: $warning;\n    }\n  }\n  &.form-checked-info {\n    &:checked {\n      background-color: $info;\n      border-color: $info;\n    }\n  }\n  &.form-checked-success {\n    &:checked {\n      background-color: $success;\n      border-color: $success;\n    }\n  }\n  &.form-checked-danger {\n    &:checked {\n      background-color: $danger;\n      border-color: $danger;\n    }\n  }\n  &.form-checked-light {\n    &:checked {\n      background-color: $light;\n      border-color: $light;\n    }\n  }\n  &.form-checked-dark {\n    &:checked {\n      background-color: $dark;\n      border-color: $dark;\n    }\n  }\n  &:focus {\n    border-color: $primary;\n    box-shadow: 0 0 0 3px rgba($primary, 0.12);\n  }\n}\n\n.form-check-label {\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n}\n.form-checked-outline:checked[type=\"checkbox\"] {\n  background-image: none;\n  position: relative;\n  background-color: transparent;\n\n  &:before {\n    content: \"\\F633\";\n    font-family: bootstrap-icons !important;\n    position: absolute;\n    color: $primary;\n    width: 0.625rem;\n    height: 0.625rem;\n    inset-block-start: -1px;\n    inset-inline-start: 0px;\n    font-size: 0.688rem;\n  }\n\n  &.form-checked-secondary {\n    &:before {\n      color: $secondary;\n    }\n  }\n\n  &.form-checked-warning {\n    &:before {\n      color: $warning;\n    }\n  }\n\n  &.form-checked-info {\n    &:before {\n      color: $info;\n    }\n  }\n\n  &.form-checked-success {\n    &:before {\n      color: $success;\n    }\n  }\n\n  &.form-checked-danger {\n    &:before {\n      color: $danger;\n    }\n  }\n\n  &.form-checked-light {\n    &:before {\n      color: $light;\n    }\n  }\n\n  &.form-checked-dark {\n    &:before {\n      color: $dark;\n    }\n  }\n}\n.form-checked-outline:checked[type=\"radio\"] {\n  background-image: none;\n  position: relative;\n  background-color: transparent;\n\n  &:before {\n    content: \"\\F309\";\n    font-family: bootstrap-icons !important;\n    position: absolute;\n    color: $primary;\n    width: 0.625rem;\n    height: 0.625rem;\n    inset-block-start: -1.13rem;\n    inset-inline-start: -0.6rem;\n    font-size: 2rem;\n  }\n\n  &.form-checked-secondary {\n    &:before {\n      color: $secondary;\n    }\n  }\n\n  &.form-checked-warning {\n    &:before {\n      color: $warning;\n    }\n  }\n\n  &.form-checked-info {\n    &:before {\n      color: $info;\n    }\n  }\n\n  &.form-checked-success {\n    &:before {\n      color: $success;\n    }\n  }\n\n  &.form-checked-danger {\n    &:before {\n      color: $danger;\n    }\n  }\n\n  &.form-checked-light {\n    &:before {\n      color: $light;\n    }\n  }\n\n  &.form-checked-dark {\n    &:before {\n      color: $dark;\n    }\n  }\n}\nfieldset:disabled .btn {\n  color: $white;\n  background-color: $primary;\n  border-color: $primary;\n}\n.form-select:focus {\n  border-color: rgba(var($primary), 0.5);\n  outline: 0;\n  box-shadow: none;\n}\n.btn-check:focus + .btn,\n.btn:focus {\n  background-color: none;\n  border-color: none;\n  outline: 0;\n}\n.btn-check:active + .btn:focus,\n.btn-check:checked + .btn:focus,\n.btn.active:focus,\n.btn.show:focus,\n.btn:active:focus {\n  box-shadow: none;\n}\n.form-control,\n.form-select {\n    &:disabled {\n      background-color: $light;\n      color: $text-color;\n  }\n}\n.form-control-plaintext {\n  color: $text-color;\n}\n.form-control::-webkit-file-upload-button {\n  color: $text-color;\n  background-color: $default-background;\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: $default-background;\n}\n.form-control {\n  &:focus {\n    &::-webkit-input-placeholder,\n    &::placeholder {\n      padding-inline-start: 0.3rem;\n      transition: padding-inline-start 0.1s ease-in;\n    }\n  }\n  &::-webkit-input-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.7;\n    color: $text-color;\n    padding-inline-start: 0px;\n    transition: padding-inline-start 0.1s ease-in;\n  }\n  &:-moz-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n  &::-moz-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n  &:-ms-input-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n}\n.form-control-sm {\n  font-size: 0.8rem;\n  padding: 0.25rem 0.8rem;\n}\n.form-control-lg {\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n}\n\n.form-check-md {\n  .form-check-input {\n    width: 1.15rem;\n    height: 1.15rem;\n  }\n\n  &.form-switch {\n    .form-check-input {\n      width: 2.25rem;\n    }\n  }\n\n  label {\n    margin-inline-start: 0.5rem;\n    font-size: 0.95rem;\n    margin-block-start: 3px;\n  }\n}\n\n.form-check-lg {\n  .form-check-input {\n    width: 1.35rem;\n    height: 1.35rem;\n  }\n\n  &.form-switch {\n    .form-check-input {\n      width: 2.5rem;\n    }\n  }\n\n  label {\n    margin-inline-start: 0.5rem;\n    font-size: 1rem;\n    margin-block-start: 3px;\n  }\n}\n.toggle {\n  width: 3.75rem;\n  height: 1.563rem;\n  background-color: $light;\n  margin-inline-start: 0.625rem;\n  margin-block-end: 0.313rem;\n  padding: 0.125rem;\n  border-radius: 0.188rem;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.2s ease;\n\n  span {\n    position: absolute;\n    inset-block-start: 0.188rem;\n    inset-block-end: 0.25rem;\n    inset-inline-start: 0.188rem;\n    display: block;\n    width: 1.25rem;\n    border-radius: 0.125rem;\n    background-color: $white;\n    box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &::before {\n      content: \"on\";\n      inset-inline-start: -1.563rem;\n    }\n\n    &::after {\n      content: \"off\";\n      inset-inline-end: -1.813rem;\n      color: $text-muted;\n    }\n\n    &::before,\n    &::after {\n      position: absolute;\n      font-size: 0.625rem;\n      font-weight: $font-weight-medium;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n      inset-block-start: 0.188rem;\n      line-height: 1.38;\n      transition: all 0.2s ease;\n    }\n  }\n\n  &.on {\n    background-color: rgba(var($primary), 0.3);\n\n    span {\n      background-color: $primary;\n\n      &::before {\n        color: $primary;\n      }\n    }\n\n    &.toggle-secondary {\n      background-color: rgba($secondary, 0.4);\n\n      span {\n        background-color: $secondary;\n\n        &::before {\n          color: $secondary;\n        }\n      }\n    }\n\n    &.toggle-warning {\n      background-color: rgba($warning, 0.4);\n\n      span {\n        background-color: $warning;\n\n        &::before {\n          color: $warning;\n        }\n      }\n    }\n\n    &.toggle-info {\n      background-color: rgba($info, 0.4);\n\n      span {\n        background-color: $info;\n\n        &::before {\n          color: $info;\n        }\n      }\n    }\n\n    &.toggle-success {\n      background-color: rgba($success, 0.4);\n\n      span {\n        background-color: $success;\n\n        &::before {\n          color: $success;\n        }\n      }\n    }\n\n    &.toggle-danger {\n      background-color: rgba($danger, 0.4);\n\n      span {\n        background-color: $danger;\n\n        &::before {\n          color: $danger;\n        }\n      }\n    }\n\n    &.toggle-light {\n      background-color: rgba($light, 0.4);\n\n      span {\n        background-color: $light;\n\n        &::before,\n        &::after {\n          color: $text-muted;\n        }\n      }\n    }\n\n    &.toggle-dark {\n      background-color: rgba($dark, 0.4);\n\n      span {\n        background-color: $dark;\n\n        &::before {\n          color: $white;\n        }\n      }\n    }\n\n    span {\n      inset-inline-start: 2.313rem;\n    }\n\n    &.toggle-sm span {\n      inset-inline-start: 2.313rem;\n\n      &::before {\n        inset-block-start: -1px;\n        inset-inline-start: -1.563rem;\n      }\n    }\n\n    &.toggle-lg span {\n      inset-inline-start: 2.563rem;\n\n      &::before {\n        inset-block-start: 0.5rem;\n        inset-inline-start: -1.75rem;\n      }\n    }\n  }\n\n  &.toggle-sm {\n    height: 1.063rem;\n    width: 3.125rem;\n\n    span {\n      width: 0.625rem;\n      height: 0.625rem;\n\n      &::after {\n        inset-inline-end: -1.875rem;\n        inset-block-start: -1px;\n      }\n    }\n  }\n\n  &.toggle-lg {\n    height: 2.125rem;\n    width: 4.5rem;\n\n    span {\n      width: 1.75rem;\n\n      &::after {\n        inset-block-start: 0.5rem;\n        inset-inline-end: -1.938rem;\n      }\n    }\n  }\n}\n.custom-toggle-switch > input[type=\"checkbox\"] {\n  display: none;\n}\n.custom-toggle-switch > label {\n  cursor: pointer;\n  height: 0;\n  position: relative;\n  width: 2.5rem;\n}\n\n.label-primary {\n  background: $primary;\n  color: $white;\n}\n\n.label-secondary {\n  background: $secondary;\n  color: $white;\n}\n\n.label-warning {\n  background: $warning;\n  color: $white;\n}\n\n.label-info {\n  background: $info;\n  color: $white;\n}\n\n.label-success {\n  background: $success;\n  color: $white;\n}\n\n.label-danger {\n  background: $danger;\n  color: $white;\n}\n\n.label-light {\n  background: $light;\n  color: $white;\n}\n\n.label-dark {\n  background: $dark;\n  color: $white;\n}\n\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::before {\n  background: inherit;\n  opacity: 0.5;\n}\n.custom-toggle-switch > label {\n  &::before {\n    background: $text-muted;\n    box-shadow: inset 0px 0px 0.625rem rgba(255,255,255, 0.5);\n    border-radius: 0.5rem;\n    content: \"\";\n    height: 1rem;\n    margin-block-start: -0.5rem;\n    position: absolute;\n    opacity: 0.3;\n    transition: all 0.4s ease-in-out;\n    width: 2.5rem;\n  }\n\n  &::after {\n    background: $white;\n    border-radius: 1rem;\n    box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);\n    content: \"\";\n    height: 1.5rem;\n    inset-inline-start: -0.25rem;\n    margin-block-start: -0.5rem;\n    position: absolute;\n    inset-block-start: -0.25rem;\n    transition: all 0.3s ease-in-out;\n    width: 1.5rem;\n  }\n}\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::after {\n  background: inherit;\n  inset-inline-start: 50%;\n}\n\n.custom-toggle-switch.toggle-sm > label::before {\n  height: 10px;\n  width: 27px;\n  border-radius: 10px;\n}\n\n.custom-toggle-switch.toggle-sm input[type=\"checkbox\"]:checked + label::after {\n  inset-inline-start: 13px;\n}\n\n.custom-toggle-switch.toggle-sm > label::after {\n  height: 17px;\n  width: 17px;\n  border-radius: 50%;\n}\n\n.custom-toggle-switch.toggle-lg > label::before {\n  height: 27px;\n  width: 55px;\n  border-radius: 20px;\n}\n\n.custom-toggle-switch.toggle-lg input[type=\"checkbox\"]:checked + label::after {\n  inset-inline-start: 77%;\n}\n\n.custom-toggle-switch.toggle-lg > label::after {\n  height: 35px;\n  width: 35px;\n  margin-block-start: -8px;\n  border-radius: 50%;\n}\n.form-floating > {\n  .form-control-plaintext,\n  .form-control {\n    &::placeholder {\n      color: transparent !important;\n    }\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem - 4px);\n}\n.form-floating {\n  &.floating-primary {\n    label {\n      color: $primary;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $primary;\n    }\n    & > .form-control:focus ~ label {\n      color: $primary !important;\n    }\n  }\n\n  &.floating-secondary {\n    label {\n      color: $secondary;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $secondary;\n    }\n    & > .form-control:focus ~ label {\n      color: $secondary !important;\n    }\n  }\n\n  &.floating-warning {\n    label {\n      color: $warning;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $warning;\n    }\n    & > .form-control:focus ~ label {\n      color: $warning !important;\n    }\n  }\n\n  &.floating-info {\n    label {\n      color: $info;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $info;\n    }\n    & > .form-control:focus ~ label {\n      color: $info !important;\n    }\n  }\n\n  &.floating-success {\n    label {\n      color: $success;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $success;\n    }\n    & > .form-control:focus ~ label {\n      color: $success !important;\n    }\n  }\n\n  &.floating-danger {\n    label {\n      color: $danger;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $danger;\n    }\n    & > .form-control:focus ~ label {\n      color: $danger !important;\n    }\n  }\n}\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-select ~ label::after {\n  background-color: $white;\n  border-radius: $border-radius;\n}\n.form-wizard-1 {\n  border-bottom: 0;\n  border-radius: 50px;\n\n  .nav-link {\n    border: 0;\n  }\n\n  &.nav-tabs {\n    .nav-item {\n      margin-inline-end: 1rem;\n      position: relative;\n    }\n\n    .nav-link {\n      padding: 0.25rem 0.4rem;\n      color: $text-muted;\n      display: flex;\n      align-items: center;\n      border-radius: 50px;\n      border: 2px solid transparent;\n\n      i {\n        font-size: 12px;\n        padding: 4px;\n        line-height: 1;\n        border-radius: 50px;\n        border: 2px solid $default-border;\n      }\n\n      &:focus,\n      &:hover {\n        border: 2px solid transparent;\n      }\n\n      &.active {\n        border: 2px solid $primary;\n        border-radius: 50px;\n        color: $primary;\n        background-color: transparent;\n\n        i {\n          border: 2px solid $primary;\n        }\n      }\n    }\n  }\n\n  .nav-item:focus-visible {\n    outline: none;\n  }\n}\n.form-control.is-valid:focus,\n.was-validated .form-control:valid:focus {\n  border-color: $success;\n  box-shadow: none;\n}\n.form-control.is-valid,\n.was-validated .form-control:valid {\n  border-color: $success;\n}\n.form-control-color {\n  width: 1.75rem;\n  height: 1.75rem;\n  overflow: hidden;\n  padding: 0;\n}\n.example-picker {\n  .pcr-button {\n    border-radius: 0.35rem !important;\n    overflow: hidden;\n  }\n}\n[dir=\"rtl\"] {\n  [type=\"email\"],\n  [type=\"number\"],\n  [type=\"tel\"],\n  [type=\"url\"] {\n    direction: rtl;\n  }\n}\n.form-select.is-invalid:not([multiple]):not([size]) {\n  padding-right: 1.125rem;\n  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.invoice-quantity-container\n  .input-group\n  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(\n    .valid-feedback\n  ):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: 0;\n}\ninput[type=\"range\"]::-webkit-slider-runnable-track {\n  background-color: $light;\n}\n[dir=\"rtl\"] {\n  .form-checked-outline:checked[type=\"checkbox\"]:before {\n    inset-inline-start: 1px;\n  }\n}\n\n.is-invalid~.invalid-feedback, .is-invalid~.invalid-tooltip, .was-validated :invalid~.invalid-feedback, .was-validated :invalid~.invalid-tooltip{\n  display: inline-block;\n}\n.is-valid~.valid-feedback, .is-valid~.valid-tooltip, .was-validated :valid~.valid-feedback, .was-validated :valid~.valid-tooltip{\n  display: inline-block;\n}\n.invalid-tooltip,.valid-tooltip{\n  position: relative;\n  top: 0;\n}\n\n/* ── Global react-select error state ── */\n/* Covers classNamePrefix=\"react-select\" and classNamePrefix=\"select\" */\n.is-invalid .react-select__control,\n.is-invalid .react-select__control:hover,\n.is-invalid .select__control,\n.is-invalid .select__control:hover {\n  border-color: #ef4444 !important;\n  box-shadow: none !important;\n}\n.is-invalid .react-select__control--is-focused,\n.is-invalid .select__control--is-focused {\n  border-color: #ef4444 !important;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;\n}\n\n/* ── Shared emp-select style system ── */\n.emp-select__control {\n  border: 1.5px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  min-height: 42px !important;\n  box-shadow: none !important;\n  transition: border-color 0.2s, box-shadow 0.2s !important;\n}\n\n.emp-select__control:hover {\n  border-color: #cbd5e1 !important;\n}\n\n.emp-select__control--is-focused {\n  border-color: #e85b28 !important;\n  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08) !important;\n}\n\n.emp-select__menu,\n.react-select__menu,\n.select2__menu,\n.select__menu {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 12px !important;\n  overflow: hidden !important;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12) !important;\n  z-index: 9999 !important;\n}\n\n.emp-select__menu-list,\n.react-select__menu-list,\n.select2__menu-list,\n.select__menu-list {\n  padding: 6px !important;\n}\n\n.emp-select__option,\n.react-select__option,\n.select2__option,\n.select__option {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #334155 !important;\n  border-radius: 8px !important;\n  padding: 9px 10px !important;\n  transition: background-color 0.15s ease, color 0.15s ease !important;\n}\n\n.emp-select__option--is-focused,\n.react-select__option--is-focused,\n.select2__option--is-focused,\n.select__option--is-focused {\n  background: #fff7ed !important;\n  color: #e85b28 !important;\n}\n\n.emp-select__option--is-selected,\n.react-select__option--is-selected,\n.select2__option--is-selected,\n.select__option--is-selected {\n  background: #e85b28 !important;\n  color: #fff !important;\n}\n\n/* Fallback for react-select instances rendered without classNamePrefix */\n[class^=\"css-\"][class$=\"-menu\"] {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 12px !important;\n  overflow: hidden !important;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12) !important;\n  z-index: 9999 !important;\n}\n\n[class^=\"css-\"][class$=\"-menu\"] > [class^=\"css-\"][class$=\"-menu-list\"] {\n  padding: 6px !important;\n}\n\n[class^=\"css-\"][class$=\"-menu\"] > [class^=\"css-\"][class$=\"-menu-list\"] > [class^=\"css-\"][class$=\"-option\"] {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #334155 !important;\n  border-radius: 8px !important;\n  padding: 9px 10px !important;\n  transition: background-color 0.15s ease, color 0.15s ease !important;\n}\n\n[class^=\"css-\"][class$=\"-menu\"] > [class^=\"css-\"][class$=\"-menu-list\"] > [class^=\"css-\"][class$=\"-option\"][aria-selected=\"false\"]:hover {\n  background: #fff7ed !important;\n  color: #e85b28 !important;\n}\n\n[class^=\"css-\"][class$=\"-menu\"] > [class^=\"css-\"][class$=\"-menu-list\"] > [class^=\"css-\"][class$=\"-option\"][aria-selected=\"true\"] {\n  background: #e85b28 !important;\n  color: #fff !important;\n}\n\n.emp-select__option--is-disabled,\n.react-select__option--is-disabled,\n.select2__option--is-disabled,\n.select__option--is-disabled {\n  color: #cbd5e1 !important;\n  cursor: not-allowed !important;\n}\n\n.emp-select__indicator,\n.react-select__indicator,\n.select2__indicator,\n.select__indicator {\n  color: #94a3b8 !important;\n}\n\n.emp-select__indicator:hover,\n.react-select__indicator:hover,\n.select2__indicator:hover,\n.select__indicator:hover {\n  color: #e85b28 !important;\n}\n\n.emp-select__indicator-separator,\n.react-select__indicator-separator,\n.select2__indicator-separator,\n.select__indicator-separator {\n  display: none !important;\n}\n\n.react-select__control,\n.select2__control,\n.select__control {\n  border: 1.5px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  min-height: 42px !important;\n  box-shadow: none !important;\n  transition: border-color 0.2s, box-shadow 0.2s !important;\n}\n\n.react-select__control:hover,\n.select2__control:hover,\n.select__control:hover {\n  border-color: #cbd5e1 !important;\n}\n\n.react-select__control--is-focused,\n.select2__control--is-focused,\n.select__control--is-focused {\n  border-color: #e85b28 !important;\n  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08) !important;\n}\n\n.emp-select__placeholder {\n  color: #cbd5e1 !important;\n  font-size: 14px;\n}\n\n.emp-select__single-value {\n  color: #1e293b !important;\n  font-size: 14px;\n}\n\n.emp-select__multi-value {\n  background: #fff5f2 !important;\n  border-radius: 6px !important;\n}\n\n.emp-select__multi-value__label {\n  color: #e85b28 !important;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.emp-select__multi-value__remove {\n  color: #e85b28 !important;\n}\n\n.emp-select__multi-value__remove:hover {\n  background: #e85b28 !important;\n  color: #fff !important;\n}\n\n.is-invalid .emp-select__control,\n.is-invalid .emp-select__control:hover,\n.is-invalid .select2__control,\n.is-invalid .select2__control:hover,\n.is-invalid .react-select__control,\n.is-invalid .react-select__control:hover,\n.is-invalid .select__control,\n.is-invalid .select__control:hover {\n  border-color: #ef4444 !important;\n  box-shadow: none !important;\n}\n\n.is-invalid .select2__control--is-focused,\n.is-invalid .react-select__control--is-focused,\n.is-invalid .select__control--is-focused,\n.is-invalid .emp-select__control--is-focused {\n  border-color: #ef4444 !important;\n  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08) !important;\n}\n\n/* ── Consistent field error message style (app-wide) ── */\n.invalid-feedback,\n.field-error {\n  display: none;\n  width: 100%;\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #ef4444;\n}\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .field-error {\n  display: block;\n}\n/* text-danger used on react-select errors — normalise size */\n.text-danger {\n  font-size: 12px !important;\n  font-weight: 500;\n}\n\n.emp-switch input:disabled + .emp-switch-slider {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.emp-switch input:disabled + .emp-switch-slider::before {\n  box-shadow: none;\n}\n\n.emp-form-field {\n  margin-bottom: 1rem;\n}\n\n.emp-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.emp-check-label {\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.emp-check input:disabled + .emp-check-label {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.emp-phone-input {\n  width: 100%;\n}\n\n.emp-phone-input .emp-phone-field,\n.react-tel-input .emp-phone-field {\n  width: 100% !important;\n  height: 42px !important;\n  border: 1.5px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  padding-left: 52px !important;\n  color: #1e293b !important;\n  font-size: 14px !important;\n  box-shadow: none !important;\n  transition: border-color 0.2s, box-shadow 0.2s !important;\n}\n\n.emp-phone-input .emp-phone-field:focus,\n.react-tel-input .emp-phone-field:focus {\n  border-color: #e85b28 !important;\n  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08) !important;\n}\n\n.emp-phone-input .emp-phone-btn,\n.react-tel-input .emp-phone-btn {\n  border: 1.5px solid #e2e8f0 !important;\n  border-right: none !important;\n  border-radius: 10px 0 0 10px !important;\n  background: #fff !important;\n}\n\n.emp-phone-input .emp-phone-dropdown,\n.react-tel-input .emp-phone-dropdown {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 12px !important;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12) !important;\n}\n\n.emp-phone-input .emp-phone-dropdown .country,\n.react-tel-input .emp-phone-dropdown .country {\n  font-size: 13px !important;\n  color: #334155 !important;\n}\n\n.emp-phone-input .emp-phone-dropdown .country:hover,\n.emp-phone-input .emp-phone-dropdown .country.highlight,\n.react-tel-input .emp-phone-dropdown .country:hover,\n.react-tel-input .emp-phone-dropdown .country.highlight {\n  background: #fff7ed !important;\n  color: #e85b28 !important;\n}\n\n.emp-phone-input--error .emp-phone-field {\n  border-color: #ef4444 !important;\n}\n\n.emp-phone-input--error .emp-phone-field:focus {\n  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08) !important;\n}\n.form-check {\n  min-height: inherit !important;\n}\n.col-form-label-lg,\n.col-form-label-sm,\n.col-form-label {\n  font-weight: $font-weight-medium;\n}\n#exampleColorInput::-webkit-color-swatch-wrapper {\n  direction: rtl; \n}\n[data-theme-mode=\"dark\"] {\n  input {\n    &[type=\"week\"],\n    &[type=\"month\"],\n    &[type=\"date\"],\n    &[type=\"datetime-local\"],\n    &[type=\"time\"] {\n      &::-webkit-calendar-picker-indicator {\n        filter: invert(1);\n      }\n    }\n  }\n}\n[dir=\"rtl\"] {\n  input {\n    &[type=\"week\"],\n    &[type=\"month\"],\n    &[type=\"date\"],\n    &[type=\"datetime-local\"],\n    &[type=\"time\"] {\n      text-align: end;\n    }\n  }\n}\n.form-control {\n  &.form-control-lg {\n    height: 46px;\n  }\n  &.form-control-sm {\n    height: 30px;\n    min-height: 30px;\n  }\n}\n.input-group-sm {\n  .input-group-text {\n    height: 35px;\n  }\n  .form-control {\n    height: 35px;\n    min-height: 35px;\n  }\n}\n.input-icon-addon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.5rem;\n  color: #515B73;\n  pointer-events: none;\n  font-size: 1.2em;\n}\n\n.icon-form {\n  transition: color 0.2s;\n}\n\n.icon-form .form-icon,\n.input-icon-addon {\n  color: #94a3b8;\n}\n\n.icon-form:focus-within .form-icon {\n  color: #e85b28;\n}\n.checkboxs {\n  display: block;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  padding-left: 25px;\n  input {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0;\n  }\n}\n.checkboxs input ~ .checkmarks {\n  border: 1px solid $light-900;\n  border-radius: 5px;\n}\n.checkboxs input:checked ~ .checkmarks {\n  background-color: $primary;\n  border-color: $primary;\n}\n    .checkboxs input:checked ~ .checkmarks:after {\n      display: block;\n    }\n    .checkboxs .checkmarks {\n      height: 16px;\n      width: 16px;\n      @include position(absolute, 0, null, null, 0);\n    }\n    .checkboxs .checkmarks:after {\n      content: \"\";\n      position: absolute;\n      display: none;\n    }\n    .checkboxs .checkmarks:after {\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      content: \"\\f00c\";\n      font-family: 'Font Awesome 5 Free';\n      color: $white;\n      font-weight: $font-weight-semibold;\n      font-size: 10px;\n  }\n.status-radio:checked,\n.status-radio:not(:checked) {\n  position: absolute;\n  left: -9999px;\n}\n.status-radio:checked + label,\n.status-radio:not(:checked) + label\n{\n  position: relative;\n  padding-left: 24px;\n  cursor: pointer;\n  line-height: 16px;\n  display: inline-block;\n  color: $gray-900;\n}\n.status-radio:checked + label:before,\n.status-radio:not(:checked) + label:before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 16px;\n  height: 16px;\n  border: 1px solid $light-900;\n  border-radius: 100%;\n  background: $white;\n}\n.status-radio:checked + label:before {\n  background: $indigo;\n  border-color: $indigo;\n}\n.status-radio[type=\"radio\"]:checked + label:after,\n.status-radio[type=\"radio\"]:not(:checked) + label:after {\n  content: '';\n  width: 8px;\n  height: 8px;\n  background: $white;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  border-radius: 100%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n[type=\"radio\"]:not(:checked) + label:after {\n  opacity: 0;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n}\n[type=\"radio\"]:checked + label:after {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n.bootstrap-tagsinput {\n  border-color: $light-300;\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\n  border-radius: 5px;\n  font-size:  $font-size-14;\n  color: $text-color;\n  min-height: 42px;\n  line-height: 2;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  max-height: 42px;\n  overflow-y: auto;\n  .tag {\n      background: $light-300;\n      color: $text-color;\n      padding: 2px 5px;\n      line-height: normal;\n      border-radius: 5px;\n      font-size: $font-size-14;\n  }\n}\n\n/* Shared emp classes used by reusable form primitives */\n.emp-label {\n  display: block;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 6px;\n  letter-spacing: 0.1px;\n}\n\n.emp-label .req {\n  color: #e85b28;\n  margin-left: 2px;\n}\n\n.emp-label-hint {\n  font-weight: 400;\n  font-size: 11px;\n  color: #94a3b8;\n  margin-left: 4px;\n}\n\n.emp-input {\n  display: block;\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #1e293b;\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  outline: none;\n}\n\n.emp-input::placeholder {\n  color: #94a3b8;\n  opacity: 1;\n}\n\n.emp-input:focus {\n  border-color: #e85b28;\n  box-shadow: 0 0 0 4px rgba(232, 91, 40, 0.08);\n}\n\n.emp-input.is-invalid {\n  border-color: #ef4444;\n}\n\n.emp-input.is-invalid:focus {\n  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.08);\n}\n\n.emp-input:disabled,\n.emp-input[readonly] {\n  border-color: #e2e8f0;\n  background-color: #f8fafc;\n  color: #94a3b8;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\ntextarea.emp-input {\n  resize: vertical;\n  min-height: 90px;\n}\n\n.emp-field-error {\n  font-size: 11.5px;\n  color: #e85b28;\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.emp-field-error::before {\n  content: \"⚠\";\n  font-size: 10px;\n}\n\n.emp-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.emp-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.emp-switch-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #cbd5e1;\n  border-radius: 24px;\n  transition: 0.25s;\n}\n\n.emp-switch-slider::before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: #fff;\n  border-radius: 50%;\n  transition: 0.25s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n.emp-switch input:checked + .emp-switch-slider {\n  background-color: #e85b28;\n}\n\n.emp-switch input:checked + .emp-switch-slider::before {\n  transform: translateX(20px);\n}\n",".notes-page-wrapper {\n    .content {\n        padding: 24px;\n        .page-add-notes {\n            border-bottom: 1px solid $light-900;\n            padding-bottom: 25px;\n            position: relative;\n            margin-bottom: 0;\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: start;\n            }\n            .notes-tog {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                position: absolute;\n                bottom: -12px;\n                border-radius: 30px;\n                background: #1B2850;\n                color: $white;\n                width: 24px;\n                height: 24px;\n                padding: 5px;\n                @include respond-below(custom991) {\n                    display: none;\n                }\n            }\n        }\n        .section-bulk-wrap {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin: 30px 0 24px 0;\n            padding: 20px;\n            border-radius: 8px;\n            background:  $white;\n            box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: start;\n            }\n            .bulk-action-type {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                @include respond-below(custom767) {\n                    margin-bottom: 20px;\n                }\n                @include respond-below(custom575) {\n                    margin-bottom: 0;\n                    flex-direction: column;\n                    align-items: self-start;\n                }\n                .select-bluk {\n                    margin-right: 8px;\n                    height: 40px;\n                    .select2-container {\n                        .selection {\n                            .select2-selection {\n                                .select2-selection__rendered {\n                                    padding-left: 10px!important;\n                                }\n                            }\n                        }\n                        \n                    }\n                }\n                .btn-added {\n                    background: $gray-500;\n                    padding: 8px 20px;\n                    color: $white;\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-normal;  \n                    margin-right: 15px; \n                    height: 40px; \n                    line-height: normal;\n                    &:hover {\n                        background: $primary;\n                    }    \n                    @include respond-below(custom575) {\n                        margin: 20px 0;\n                    }           \n                }   \n            }  \n            .form-sort {\n                .fa-filter {\n                    z-index:100!important;\n                    position: absolute;\n                    top: 15px;\n                    left: 15px;\n                    width: 16px;\n                    height: 16px;\n                }\n            } \n        }\n        .section-notes-slider {\n            position: relative;\n            padding-bottom: 40px;\n            border-bottom: 1px solid $light-900;\n            .notes-content {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n                margin-bottom: 20px;\n                .notes-close {\n                    a {\n                        color: $danger;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        i {\n                            margin-right: 6px;\n                        }\n                    }\n                }\n            }\n            .notes-card {\n                padding: 24px;\n                border-radius: 8px;\n                background: rgba(255, 159, 67, 0.03);\n                &.medium {\n                    background: rgba(116, 41, 248, 0.03);\n                }\n                &.high {\n                    background: rgba(234, 84, 85, 0.03);\n                }\n                .notes-card-body {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    p {\n                        &.badged  {\n                            border-radius: 8px;\n                            border: 1px solid  $warning;\n                            padding: 4px 10px; \n                            margin-bottom: 0;\n                            color:$warning;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            display: flex;\n                            align-items: center;\n                            i {\n                                font-size: 7px;\n                                margin-right: 4px;\n                            }\n                            &.medium {\n                                color: #7429F8;\n                                border: 1px solid #7429F8;\n                            }\n                            &.high {\n                                color: $danger;\n                                border: 1px solid $danger;\n                            }\n                        }\n                    }\n                    a {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        color: $gray-500;\n                        &.dropdown-item {\n                            &:hover {\n                                color: $gray-900;\n                                svg {\n                                    color: $gray-900;\n                                }\n                            }\n                        }   \n                    }\n                \n                }\n                .notes-slider-content {\n                    margin: 24px 0;\n                    h4 {\n                        a {\n                            margin-bottom: 10px;\n                            color:$gray-500;\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            display: -webkit-box;\n                            -webkit-line-clamp: 1;\n                            -webkit-box-orient: vertical;\n                            overflow: hidden;\n                            &:hover {\n                                color: $warning;\n                            }\n                        }                      \n                    }\n                    p {\n                        color: $text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 0px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                    }\n                }\n                .notes-slider-widget {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    .notes-logo {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        a {\n                            margin-right: 15px;\n                            span {\n                                width: 32px;\n                                height: 32px;\n                                display: flex;                                \n                                img {\n                                    border-radius: 100px;\n                                }\n                                \n                            }                           \n                        }   \n                        span {\n                            &.medium-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $success;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.high-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $warning;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.low-square {\n                                margin-right: 5px;\n                                i {\n                                    color: #288EC7;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                        }                     \n                        p {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            color:#288EC7;\n                            font-size: $font-size-15;\n                            font-weight: $font-weight-normal;\n                            margin-bottom: 0px;\n                            i {\n                                &.fa-draw-polygon {\n                                    margin-right: 5px;\n                                }\n                            }\n                            &.medium {\n                                color: $success;\n                            }\n                            &.high {\n                                color: $warning;\n                            }\n                        }\n                    }\n                    .notes-star-delete {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        span {\n                            .fa-star {\n                                color: $warning;\n                                width: 16px;\n                                height: 16px;\n                                margin-right: 10px;\n                            }\n                            .feather-trash-2 {\n                                color: $danger;\n                                width: 16px;\n                                height: 16px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .section-card-body {\n            padding-top: 40px;\n            .notes-card-details {\n                border-radius: 8px;\n                border: 1px solid  rgba(145, 158, 171, 0.30);\n                background: $white;\n                box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n                padding: 24px;\n                margin-bottom: 24px;\n                .notes-card-body {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    p {\n                        &.badged  {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            border-radius: 8px;\n                            border: 1px solid  $warning;\n                            padding: 4px 10px; \n                            margin-bottom: 0;\n                            color:$warning;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            i {\n                                font-size: 7px;\n                                margin-right: 4px;\n                            }\n                            &.medium {\n                                color: #7429F8;\n                                border: 1px solid #7429F8;\n                            }\n                            &.high {\n                                color: $danger;\n                                border: 1px solid $danger;\n                            }\n                        }\n                    }\n                    .dropdown-item {\n                        span {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            color: $gray-500;\n                            svg {\n                                width: 14px;\n                                height: 14px;\n                                color: $text-color;\n                            }\n                        }\n                        &:hover {\n                            span {\n                                svg {\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n                .notes-wrap-content {\n                    padding: 20px 0;\n                    border-bottom: 1px solid $light-900;\n                    h4 {\n                        a {\n                            color:$gray-500;\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            margin-bottom: 5px;\n                            display: -webkit-box;\n                            -webkit-line-clamp: 1;\n                            -webkit-box-orient: vertical;\n                            overflow: hidden;\n                            &:hover {\n                                color: $warning;\n                            }\n                        }                    \n                    }\n                    .wrap-cal {\n                        color:$text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 20px;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        svg {\n                            margin-right: 5px;\n                            width: 16px;\n                            height: 16px;\n                        }\n                    }\n                    p {\n                        color:$text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 0px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                    }\n                }\n                .notes-slider-widget {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    &.notes-widget-profile {\n                        padding-top: 20px;\n                    }\n                    .notes-logo {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        a{\n                            margin-right: 15px;\n                            span {                            \n                                img {\n                                    border-radius: 100px;\n                                }\n                            } \n                        }                                            \n                        span {\n                            &.medium-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $success;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.high-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $warning;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.low-square {\n                                margin-right: 5px;\n                                i {\n                                    color: #288EC7;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                        }\n                        p {\n                            color:#288EC7;\n                            font-size: $font-size-15;\n                            font-weight: $font-weight-normal;\n                            margin-bottom: 0px;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            i {\n                                &.fa-draw-polygon {\n                                    margin-right: 5px;\n                                }\n                            }\n                            &.medium {\n                                color: $success;\n                            }\n                            &.high {\n                                color: $warning;\n                            }\n                        }\n                    }\n                    .notes-star-delete {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        span {\n                            .feather-star {\n                                color: $text-color;\n                                width: 16px;\n                                height: 16px;\n                                margin-right: 10px;\n                            }\n                            .feather-trash-2 {\n                                color: $danger;\n                                width: 16px;\n                                height: 16px;\n                            }\n                        }\n                    }\n                }\n            }\n        }      \n    }\n}\n.notes-card-details {\n    .notes-card-body {\n        a {\n            color: $gray-500;\n        }\n    }\n\n}\n.star-todo-inbox {\n    svg {\n        width: 13px;\n        height: 13px;\n        color: $text-color;\n    }\n}\n.inbox-call-profile {\n    border-radius: 5px;\n    background: #E92990;\n    border: 1px solid #E92990;\n    padding: 4px 10px;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    color: $white;\n    margin: 0 20px;\n    &:hover  {\n        color: #E92990;\n        background: $white;\n    }\n}\n.notes-tog {\n    i {\n        transform: rotate(180deg);\n    }\n    &.active {\n        i {\n            transform: rotate(0deg);\n        }\n    }\n}\n.section-bulk-wrap {\n    .form-sort {\n        position: relative;\n        svg {\n            &.feather-filter {\n                position: absolute;\n                z-index: 101;\n                width: 16px;\n                height: 16px;\n                top: 12px;\n                left: 10px;\n            }\n            \n        }\n    }\n}\n\n.page-add-notes.active svg {\n    transform: rotate(0) !important;\n}\n.dropdown-menu {\n    &.notes-menu {\n        z-index: 99999;\n        a {\n            &.dropdown-item {\n                color: $gray-500;\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n                display: flex;\n                align-items: center; \n                padding: 5px;   \n                border-radius: 5px;\n                &:hover {\n                    background: $light-300;\n                    color: $gray-900;\n                    svg {\n                        color: $gray-900;\n                    }\n                }                          \n            }\n            \n        }   \n        span {\n            margin-right: 8px;\n        }\n        svg {\n            width: 14px;\n            height: 14px;\n            color: $text-color;\n        }\n    } \n}\n.edit-note-head {\n    a {\n        border-radius: 30px;\n        border: 1px solid rgba(145, 158, 171, 0.30);\n        background:  $white;\n        color: $gray-500;\n        padding: 15px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        &:hover {\n            border-radius: 20px;\n            background:  $primary;\n            color: $white;\n        }\n    }\n}\n.custom-modal-body {\n    .select2-container {\n        .selection {\n            .select2-selection {\n                .select2-selection__rendered {\n                    padding-left: 10px!important;\n                }\n            }\n        }\n        \n    }\n}\n.bulk-con-wrap {\n    width: 100%;\n}\n.section-bulk-widget {\n    transition: 0.6s all\n}\n.section-notes-dashboard {\n    display: none;\n    transition: 0.6s all\n}\n.notes-tog {\n    i {\n        transition: 0.5s all;\n    }\n}\n.notes-tag-left {\n    .notes-tog {\n        i {\n            transform: rotate(360deg);\n            transition: 0.5s all;\n        }\n    }\n}\n.budgeted-role-notes {\n    width: 100%;\n}\n.notes-summernote .card{\n    margin-bottom: 0 !important;\n}\n.dropdown-item:active {\n    background: transparent;\n}\n.notes-summernote p {\n    color: $text-color;\n    font-size: $font-size-15;\n    font-weight: $font-weight-normal;\n}\n.budget-role-notes {\n    .owl-carousel .owl-nav {\n        margin: 0;\n        position: absolute;\n    }\n}\n.notes-dash {\n    margin-top: 30px;\n    padding: 24px;\n    border-radius: 8px;\n    border: 1px solid  rgba(145, 158, 171, 0.30);\n    background: $white;\n    transition: 0.6s all;\n    .notes-top-head {       \n        border-bottom: 1px solid $light-900;\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            color: $gray-500;\n            margin-bottom: 15px;\n            display: flex;\n            align-items: center;\n            svg {\n                width: 19px;\n                height: 19px;\n                margin-right: 6px;\n                color: $text-color;\n            }\n        }\n    }\n    .notes-top-head-submenu {\n        padding: 15px 0;\n        border-bottom: 1px solid $light-900;\n        ul {\n            padding: 15px 0;\n            li {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;               \n                padding: 10px;\n                &.active {\n                    border-radius: 10px;\n                    background:  $gray-500;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                    p {\n                        color: $white;                        \n                    }\n                }\n\n                p {\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-semibold;\n                    color: $text-color;\n                    margin-bottom: 0;\n                    display: flex;\n                    align-items: center;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                }\n                span {\n                    display: flex;\n                    width: 18px;\n                    height: 18px;\n                    padding: 0px 3px;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 12px;\n                    background:  $primary;\n                    color: $white;\n                }\n\n            }\n        }\n    }\n    .content-submenu-tag {\n        margin-top: 15px;\n        padding: 10px;\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            color: $gray-500;\n        }\n        ul {\n            padding: 10px 0;\n            &.tags-list {\n                margin-bottom: 24px;\n            }\n            li {\n                &.personal {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: #288EC7;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.social {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: $warning;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.work {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a{\n                        color: $success;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.public {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                     a{\n                        color: #A02F7A;\n                        display: flex;\n                        align-items: center;\n                     }\n                    \n                }\n                &.medium {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    } \n                     a {\n                        color: $purple;\n                        display: flex;\n                        align-items: center;\n                     }\n                   \n                }\n                &.high {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: $danger;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.low {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a  {\n                        color: $warning;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                   font-size: $font-size-15;\n                   font-weight: $font-weight-normal;\n                   display: flex;\n                   align-items: center;\n                +li {\n                    margin-top: 10px;\n                }\n            }\n        }\n    }\n}\n.notes-logo {\n    a {\n        display: flex;\n        align-items: center;\n        span {\n            width: 32px;\n            height: 32px;  \n            img {\n                border-radius: 32px;               \n            }\n        }\n    }\n}\n.notes-top-head-submenu {\n    padding: 15px 0;\n    border-bottom: 1px solid $gray-400;\n    .nav {\n        &.todo-inbox {\n            button.todo-inbox {\n               display:flex;\n               justify-content: start; \n               align-items: center;             \n                padding: 10px;\n                font-size: $font-size-15;\n                font-weight: $font-weight-semibold;\n                color: $text-color;\n                margin-bottom: 0;\n                display: flex;\n                align-items: center;\n                margin-bottom: 5px;\n                border-radius: 5px;\n                &.active {\n                    border-radius: 5px;\n                    background:  #212B36;\n                    padding: 10px;\n                    color: $white;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }               \n                }\n                &:hover {\n                    background:  #212B36;\n                    color: $white;\n                }\n               \n                svg {\n                    width: 16px;\n                    height: 16px;\n                    margin-right: 8px;\n                }\n                span {\n                    display: flex;\n                    width: 20px;\n                    height: 20px;\n                    padding: 0px 3px;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 12px;\n                    background:  $primary;\n                    color: $white;\n                }\n                  \n            }            \n        }\n    }\n    \n}\n.notes-trash-btn {\n    background: $danger;\n    color: $white;\n    border-radius: 8px;\n    margin: 4px 0 20px 0;\n    padding: 10px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    span {\n        display: flex;\n        align-items: center;\n        svg {\n            width: 16px;\n            height: 16px;\n            margin-right: 10px;\n        }\n    }\n}\n.delete-popup {\n    padding: 24px;\n    border-radius: 8px;\n    background: $white;\n    .delete-image {\n        margin-bottom: 20px;\n    }\n    .delete-heads {\n        text-align: center;\n        h4 {\n            color: $gray-500;\n            font-size: $font-size-20;\n            font-weight: $font-weight-bold;\n            margin-bottom: 5px;\n        }\n        p {\n            color: $text-color;\n            font-size: $font-size-15;\n            font-weight: $font-weight-normal;\n            margin-bottom: 0px;\n        }       \n    }\n    .delete-footer {\n        text-align: center;\n    }\n}\n.edit-page-title {\n    display: flex;\n    align-items: center;\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n        color: $gray-500;\n        margin-bottom: 0;\n        margin-right: 10px;\n    }\n    p {\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n        color: #288EC7;\n    }\n}\n.edit-head-view {\n    margin-bottom: 20px;\n    border-bottom: rgba(145, 158, 171, 0.30);\n    h6 {\n        font-size: $font-size-16;\n        font-weight: $font-weight-semibold;\n        color: $gray-500;\n        margin-bottom: 15px;\n    }\n    p {\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n        color: $text-color;\n        margin-bottom: 15px;\n    }\n    p {\n        &.badged {\n            i {\n                font-size: 7px;\n                margin-right: 7px;\n            }\n            border-radius: 8px;\n            border: 1px solid $warning;\n            padding: 4px 10px;\n            margin-bottom: 0;\n            color: $warning;\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n            display: inline-flex;\n            align-items: center;\n        }\n    }\n}\n.edit-footer-menu a {\n    background-color: $danger;\n}\n.edit-noted-head {\n    a {\n        span {\n            i{\n                 &.fa-trash-alt {\n                    color: $danger;\n                    margin-right: 10px;\n                 }\n                 &.fa-star {\n                    color: $warning;\n                 }\n            }\n        }\n    }\n}\n.edit-head-view {   \n    p {\n        &.badged.high {\n            i {\n                font-size: 7px;\n                margin-right: 7px;\n            }\n            border-radius: 8px;\n            border: 1px solid $danger;\n            padding: 4px 10px;\n            margin-bottom: 0;\n            color: $danger;\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n            display: inline-flex;\n            align-items: center;\n        }\n    }\n}\n.people-profile-pic {\n    border: none !important;\n    margin-left: 14px;\n    position: relative;\n    img {\n        border-radius: 10px;\n    }\n    a {\n        position: absolute;\n        top: 15px;\n        right: 7px;\n        .x-square-add {\n            border-radius: 3px;\n            background:$danger;\n            color: $white;\n        }       \n    }\n}\n\n.people-customer-walk {\n    max-width: 35px;\n}\n.custom-pagination {\n    .paginations {\n        align-items: center;\n        span {\n            display: flex;\n            align-items: center;\n            color: $text-color;\n            width: 16px;\n            height: 16px;\n            .fa-chevron-left {\n                margin-right: 8px;\n            }\n        }\n        .page-wrap {\n            li {\n                a {\n                    margin-right: 8px;\n                    border-radius: 85px;\n                    color:$text-color;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-medium;                    \n                    display: flex;\n                    width: 30px;\n                    height: 30px;\n                    padding: 5px;\n                    justify-content: center;\n                    align-items: center;\n                    &.active {\n                        background: $primary;\n                        color: $white;\n                    }                         \n                }  \n                :hover {\n                    background: $primary;\n                    color: $white;\n                    transition: .3s all;\n                }                                   \n            }                \n        }\n    } \n}\n.section-notes-slider {\n    .notes-slider {\n        &.owl-carousel {\n            .owl-nav {\n                top: -42px;\n                right: unset;\n                left: 170px;\n                button {\n                    background-color: transparent;\n                    width: 15px;\n                    height: auto;\n                    i {\n                        color: $gray-500;\n                    }\n                    &:hover {\n                        background-color: transparent;\n                        i {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.form-sort {\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 99;\n    }\n}\n.accordion-button:after, .accordion-button:not(.collapsed)::after{\n    display:none;\n}\n.todo-accordion .accordion-item {\n    background: transparent;\n    margin-bottom: 10px;\n    border: 0;\n    padding: 0;\n}\n.search-set {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    .search-input{\n        position: relative;\n        margin-right: 15px;    \n        input[type=\"search\"] {\n            height: 38px;\n            border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n            background: var(--White, #FFF);\n            width: 298px;\n            @include rounded(5px);\n            padding: 10px;\n            &::placeholder {\n                color: $black;\n            }\n            @include respond-below(custom1199) {\n                width: 220px;\n            }\n            @include respond-below(custom991) {\n                width: 200px;\n            }\n            @include respond-below(custom575) {\n                width: auto;\n            }\n        }\n        .btn-searchset {\n            @include margin-padding(null, null);\n            @include rounded(50px);\n            @include position(absolute,0,0,null,null);\n            border: 0;\n            .feather-search {\n                width: 14px;\n                height: 14px;\n            }\n        }\n    }\n}\n.page-add-notes {\n    display: flex;\n    flex-wrap: wrap;\n}",".todo-inbox-check {\n    margin-right: 15px;\n    .checkboxs {\n        margin-bottom: 0;\n        padding-left: 25px;\n        display: flex;\n        align-items: center;\n        input ~ .checkmarks {\n            border-color: rgba(145, 158, 171, 0.30);\n            border-radius: 5px;\n            margin-top: 2px;\n            width: 20px;\n            height: 20px;\n        }\n        input {\n            &:checked {\n                ~ .checkmarks{\n                    border-color: $primary;\n                    background-color:$primary;\n                }\n            }\n        }\n    }    \n}\n.btn-cancel {\n    background: $gray-600;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include transition(all 0.5s ease);\n    &:hover{\n        background: #424b52;\n        color: $white;\n     }\n    @include respond-below(custom991) {\n        min-width: auto;\n    }\n}\n.swal2-confirm{\n    margin-right: 5px;\n}\n.btn-submit {\n    background: $primary;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n    }\n}\n.sections-notes-slider{\n    .accordion-button:after{\n        display: none;\n    }\n}\n.todo-wrapper-list-content {\n    margin-left: 5px;\n}\n.notes-header h3 {\n    color: $gray-500;\n    font-size: $font-size-18;\n    font-weight: $font-weight-bold;\n    margin-bottom: 0;\n}\n.todo-inbox-check .checkboxs .checkmarks:after {\n    left: 9px;\n    top: 10px;\n}\n.checkboxs input:checked ~ .checkmarks:after {\n    display: block;\n}\n.todo-widget {\n    margin-bottom: 25px;\n}\n.todo-today-content {\n    margin-bottom: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .todo-drop-down {\n        span {\n            i {\n                color: $gray-500;\n            }\n        }\n    }\n    .todo-today-header {\n        display: flex;\n        align-items: center;\n        span {\n            margin-right: 5px;\n            display: flex;\n            align-items: center;\n            svg {\n                width: 16px;\n                height: 16px;\n                color: $text-color;\n            }\n        }\n        h3 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            color: $gray-500;\n            margin-bottom: 0;\n            margin-right: 5px;\n        }\n        h6 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 18px;\n            height: 18px;\n            background-color: $primary;\n            border-radius: 50px;\n            color: $white;\n            font-size: 10px;\n            font-weight: $font-weight-semibold;\n            margin-bottom: 0;\n        }\n    }\n}\n.todo-wrapper-list {\n    padding: 15px;\n    border-radius: 8px;\n    border: 1px solid  rgba(145, 158, 171, 0.30);\n    background:  $white;\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n    @include respond-below(custom575) {\n        flex-direction: column;\n    }\n    .todo-inbox-check {\n        display: flex;\n        align-items: center;\n        .todo-wrapper-list-content {\n            h4 {\n                font-size: $font-size-16;\n                font-weight: $font-weight-bold;\n                color: $gray-500;\n                margin-bottom: 5px;\n            }\n            p {\n                font-size: 13px;\n                font-weight: $font-weight-medium;\n                color: $text-color;\n                margin-bottom: 0;\n            }\n        }\n        &.todo-inbox-check-list {\n            width: 45%;\n            @include respond-below(custom575) {\n                width: auto;\n            }\n            .checkboxs {\n                margin-bottom: 12px;\n                input ~ .checkmarks {\n                    border-radius: 5px;\n                    margin-top: 0;                    \n                }\n            }    \n        }\n    }   \n    .notes-card-body {\n        width: 35%;\n        @include respond-below(custom575) {\n            width: auto;\n            margin: 20px 0;\n        }\n        p {\n            display: flex;\n            align-items: center;\n            &.high {\n                border-radius: 8px;\n                border: 1px solid $danger;\n                padding: 4px 10px;\n                font-size: $font-size-14;\n                font-weight: $font-weight-semibold;\n                color: $danger;\n                margin-right: 10px;\n            }\n            &.medium {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid #423B93;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: #423B93;\n            }\n            &.pending {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid #288EC7;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: #288EC7;\n            }\n            &.low {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid $warning;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: $warning;                \n            }\n            &.success {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid $success;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: $success;                \n            }\n            i {\n                &.fa-circle{\n                    font-size: 7px;\n                    margin-right: 4px;\n                }\n            }\n            \n        }\n    }\n    .todo-strike-content {\n        h4 {\n            text-decoration-line: line-through;\n        }\n        p {\n            text-decoration-line: line-through;\n        }\n    }\n    .todo-profile {\n        width: 20%;\n        justify-content: end;\n        img {\n            border-radius: 30px;\n            margin-right: 16px;\n            width: 30px;\n            height: 30px;\n        }\n        a {\n            .fa-ellipsis-v {\n                color: $gray-500;\n            }\n        }\n    }\n}\n.datanew{\n    tbody{\n        border-top: 1px solid $light-900;\n    }\n}\n.form-sort {\n    position: relative;\n    width: 149px;\n    height: 40px;\n    .info-img {\n        position: absolute;\n        top: 52%;\n        z-index: 100;\n        width: 16px;\n        height: 16px;\n        left: 0;\n        margin-left: 10px;\n        color: $text-color;\n        transform: translateY(-50%);\n        line-height: normal;\n    }\n    @include respond-below(custom575) {\n        margin-top: 24px;\n    }\n}\n.todo-calendar  .input-groupicon.calender-input input {\n    padding-left: 10px;\n}\n.todo-calendar {\n    position: relative;\n    .calender-input {\n        position: relative;\n        .info-img {\n            position: absolute;\n            top: 11px;\n            z-index: 100;\n            width: 16px;\n            height: 16px;\n            right: 5px !important;\n            color: $text-color;\n        } \n    }   \n}\n.todo-accordion {\n    .accordion-item {\n        background: transparent;\n        margin-bottom: 20px;\n        .accordion-header {\n            cursor: pointer;\n            .accordion-button {\n                background: transparent;\n                padding: 0;\n                &.collapsed {\n                    .todo-today-content {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n            .todo-today-content {\n                width: 100%;\n            }\n            .todo-drop-down {\n                a {\n                    span {\n                        i {\n                            color: $text-color;\n                        }\n                    }\n                }\n            }\n        }\n        .accordion-body {\n            padding: 0;\n        }\n        .todo-widget {\n            margin-bottom: 0;\n            .todo-wrapper-list {\n                &:last-child {\n                    margin-bottom: 0;\n                }\n               \n            }\n        }\n\n    }\n}","@mixin tablecolor($color-bg) {\n  background-color: $white;\n  color: $black;\n  --bs-table-color-state: $black;\n  border-color: var(--bs-table-border-color);\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.05);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.2);\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.2);\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.2);\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.2);\n    color: $black;\n  }\n  &.table.table-hover > tbody > tr:hover > * {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.4);\n    color: $white;\n  }\n  .table-active {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgb(#{$color-bg});\n    color: $white;\n  }\n}\ncaption {\n  color: $text-muted;\n}\n.table-active{\n  --bs-table-color-state: var(--default-text-color);\n}\n@mixin tablehead($color-bg) {\n  background-color: $white;\n  color: var(--bs-table-color);\n  --bs-table-color-state: #000;\n  --bs-table-color: #{$black};\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.5);\n  --bs-table-striped-color: #{$black};\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.5);\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.5);\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n@mixin table-color($color-bg) {\n  --bs-table-color: #{$black};\n  --bs-table-color-state: $black;\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-striped-color: #{$black};\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-active-color: #{$black};\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-hover-color: #{$black};\n  color: #{$black};\n  border-color: rgba(#{$color-bg}, 0.1);\n  background-color: #{$white};\n}\n.table {\n  color: $text-color;\n  border-color: $default-border;\n  margin-block-end: 0;\n  .checkboxs {\n    margin-bottom: 15px;\n  }\n  tbody {\n    tr {\n      th {\n        font-weight: $font-weight-medium;\n      }\n    }\n  }\n  th,\n  td {\n    padding: 0.75rem;\n    vertical-align: middle;\n    line-height: 1.462;\n    font-size: 0.813rem;\n    white-space: nowrap;\n  }\n  thead tr th {\n    font-weight: $font-weight-semibold;\n    font-size: 15px;\n  }\n  &.table-sm > :not(caption) > * > * {\n    padding: 0.3rem;\n  }\n  &.table-dark {\n    color: $light-700;\n    border-color: rgba($white, 0.1);\n  }\n  .thead-primary th {\n      background-color: $primary;\n      color: $white;\n  }\n  .thead-secondary th {\n      background-color: $secondary;\n      color: $white;\n  }\n  .thead-info th {\n      background-color: $info;\n      color: $white;\n  }\n  .thead-warning th {\n      background-color: $warning;\n      color: $white;\n  }\n  .thead-danger th {\n      background-color: $danger;\n      color: $white;\n  }\n  .thead-success th {\n      background-color: $success;\n      color: $white;\n  }\n  .thead-dark th {\n      background-color: $dark;\n      color: $white;\n  }\n  .thead-light th {\n      background-color: $light-100;\n      color: $dark;\n  }\n  &.table-primary {\n    @include tablecolor(var(--primary-rgb));\n  }\n  &.table-secondary {\n    @include tablecolor(var(--secondary-rgb));\n  }\n  &.table-warning {\n    @include tablecolor(var(--warning-rgb));\n  }\n  &.table-success {\n    @include tablecolor(var(--success-rgb));\n  }\n  &.table-danger {\n    @include tablecolor(var(--danger-rgb));\n  }\n  &.table-info {\n    @include tablecolor(var(--info-rgb));\n  }\n  &.table-light {\n    @include tablecolor(var(--light-rgb));\n  }\n  &.table-dark {\n    @include tablecolor(var(--dark-rgb));\n  }\n  &.table-bordered {\n    &.border-primary {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($primary, 0.1);\n      }\n    }\n    &.border-info {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($info, 0.1);\n      }\n    }\n    &.border-secondary {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($secondary, 0.1);\n      }\n    }\n    &.border-warning {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($warning, 0.1);\n      }\n    }\n    &.border-success {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($success, 0.1);\n      }\n    }\n    &.border-danger {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($danger, 0.1);\n      }\n    }\n  }\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);\n    color: $text-color;\n  }\n  &.table-striped-columns > :not(caption) > tr > :nth-child(2n) {\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);\n    color: $text-color;\n  }\n  tbody.table-group-divider {\n    border-top: 1px solid $default-border;\n  }\n  &.table-hover > tbody > tr:hover > * {\n    --bs-table-accent-bg: #{$default-background};\n    color: $text-color;\n  }\n  .table-active {\n    --bs-table-accent-bg: #{$light};\n    color: $text-color;\n  }\n  thead {\n    &.table-primary {\n      @include tablehead(var(--primary-rgb));\n    }\n    &.table-secondary {\n      @include tablehead(var(--secondary-rgb));\n    }\n    &.table-warning {\n      @include tablehead(var(--warning-rgb));\n    }\n    &.table-success {\n      @include tablehead(var(--success-rgb));\n    }\n    &.table-danger {\n      @include tablehead(var(--danger-rgb));\n    }\n    &.table-info {\n      @include tablehead(var(--info-rgb));\n    }\n    &.table-light {\n      @include tablehead(var(--light-rgb));\n    }\n    &.table-dark {\n      @include tablehead(var(--dark-rgb));\n    }\n  }\n}\n.table-primary {\n  @include table-color(var(--primary-rgb));\n}\n.table-secondary {\n  @include table-color(var(--secondary-rgb));\n}\n.table-warning {\n  @include table-color(var(--warning-rgb));\n}\n.table-success {\n  @include table-color(var(--success-rgb));\n}\n.table-info {\n  @include table-color(var(--info-rgb));\n}\n.table-danger {\n  @include table-color(var(--danger-rgb));\n}\n.table-dark {\n  @include table-color(var(--dark-rgb));\n}\n.table-light {\n  @include table-color(var(--light-rgb));\n}\n[data-theme-mode=\"dark\"] {\n  .table-dark {\n    border-color: rgba(0,0,0,0.025);\n  }\n}\n[dir=\"rtl\"] {\n  .table {\n    margin-inline-end: 1px;\n  }\n}\n.table{\n    margin: 0;\n    tbody{\n        tr{\n            td{\n                color: $gray-700;\n                font-size: $font-size-14; \n                .product-img{\n                    img{\n                        border: 0;\n                    }\n                }\n                .userslist-img {\n                    width:35px;\n                    height: 35px;\n                    margin-right: 8px;\n                    img {\n                        border-radius: 0;\n                    }\n                }\n                .userslist-img.bg-img {\n                    img {\n                        border: 1px solid var(--stroke-table, #E8EBED);\n                        // background: url(<path-to-image>), lightgray 50% / cover no-repeat;\n                    }\n                }\n                a {\n                    color: $secondary;\n                    font-size: $font-size-14;\n                    font-weight: $font-weight-normal;\n                    line-height: normal;\n                    &.product-img{\n                        margin-right: 5px;\n                        flex-shrink: 0;\n                    }\n                    .info-img {\n                        margin-right: 8px;\n                        width: 16px;\n                        height: 16px;\n                    }\n                    &:hover {\n                        color: $primary;\n                    }\n                }\n                .emp-name {\n                    line-height: 1;\n                    a {\n                        color: $secondary;\n                    }\n                    p {\n                        line-height: 2;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-medium;\n                        color: $text-color;\n                    }\n                    .role {\n                        line-height: unset;\n                    }\n                }\n                .product-imgs{\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    width:40px;\n                    height:40px;\n                    background: #FFEBD8;\n                    font-size: $font-size-14;\n                    color: #FF9F43 !important;\n                    font-weight: $font-weight-medium;\n                    margin-right:10px;\n                }\n            }\n            .data-header {\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n                font-size: $font-size-15;\n                border-bottom: none;\n            }\n            .ref-number {\n                color: $purple;\n            }\n            &.active{\n                border-bottom: 0;\n                td{\n                    font-size: $font-size-18;\n                    color: $gray-700;\n                    font-weight: $font-weight-semibold;\n                    border-bottom: 0;\n                }\n            }\n        }\n        .loss-highlight {\n            td {\n                font-weight: $font-weight-bold;\n                color: $secondary;\n                font-size: $font-size-base;\n                border-top: 1px solid $gray-300;\n            }\n        }\n        .userimgname {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            img {\n                margin-right: 8px;\n                border-radius: 6px;\n                \n            }\n        }\n        .purchase-count {\n            td {\n                padding-bottom: 20px;\n            }\n        }\n        \n    }\n    .Expense-list {\n       tr {\n        td {\n            padding: 15px 17px;\n            a {\n                margin-bottom: 0;\n            }\n        }\n       }\n    }\n    .sales-list {\n        tr {\n            td {\n                padding: 20px 17px;\n            }\n        }\n    }\n    .Expense-list-blk {\n        tr {\n            td {\n                padding: 20px 17px;\n            }\n        }\n    }\n        \n    \n}\n.new {\n    tbody {\n        tr {\n            td {\n                border-bottom: none;\n            }\n        }\n    }\n}\n.table-height{\n    min-height: 300px;\n    @include respond-below(custom991) {\n        min-height: auto;\n        margin-bottom: 15px;\n    }\n}\n.max-widthauto{\n    max-width: 100% !important;\n}\n.dataTables_filter {\n    & + .dataTables_filter {\n        display: none;\n    }\n}\n.dataview {\n    .dataTables_length,\n    .dataTables_info,\n    .dataTables_paginate{\n        display: none !important;\n    }\n}\n.dataTables_length {\n    font-size: $font-size-12;\n}\n.productimgname {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    a{\n        color: $secondary;\n        font-weight: $font-weight-medium;\n    }\n    .view-product {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        width: 50px;\n        height: 50px;\n        border-radius: 6px;\n        background: #F8F8F8;\n    }\n}\n.input-blocks{\n    .calc-no{\n        width: 50px !important;\n        text-align: center;\n    }\n}\n.table {\n    .input-blocks {\n        input[type=text] {\n            height:40px;\n        }\n    }\n    .scanner-set{\n        width:40px;\n        height:40px;\n    }\n}\n.card.table-list-card {\n    .card-body {\n        padding: 0;\n    }\n    .table-top {\n        padding: 24px 24px 0;\n    }\n    .table-responsive {\n        padding: 24px;\n        .dataTables_wrapper {\n            border: 0;\n            padding: 0;\n        }\n    }\n    .tabs-set {\n        .nav-tabs {\n            padding: 24px 24px 0;\n            margin-bottom: 0;\n        }\n    }\n}\n.table.profit-table {\n    thead {\n        background-color: #FAFBFE;\n        border-radius: 8px 8px 0px 0px;\n        tr {\n            &:hover {\n                background-color: #FAFBFE;\n            }\n        }\n\n    }\n    tbody {\n        td {\n            border-bottom: 0;\n        }\n        .profit-table-bg { \n            td {\n                color: $secondary;\n                font-weight: $font-weight-bold;\n                border-top: 1px solid $gray-100;\n                background-color: #FAFBFE;\n            }\n        }\n        .table-heading {\n            &:hover {\n                background-color: $white;\n            }\n            td {\n                color: $secondary;\n                font-weight: $font-weight-bold;\n            }\n        }\n    }\n} \n.profit-table-top {\n    .daterange-wraper {\n        margin: 0 10px;\n        input {\n            padding-left: 35px;\n        }\n    }\n}\ntable {\n    td {\n        .shield {\n            width: 14px;\n            height: 14px;\n        }\n    }\n}\n.paysilp-table-border {\n    border: 1px solid $gray-100;\n    th {\n        border-right: 1px solid $gray-100;\n        border-left: 1px solid $gray-100;\n        padding: 15px;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-16;\n    }\n}\n.paysilp-table-borders {\n    td {\n        border-right: 1px solid $gray-100;\n        border-left: 1px solid $gray-100;\n        padding: 5px 15px;\n        color: $text-color;\n    }\n}\n.payslip-border-bottom {\n    border: 1px solid $gray-100;\n    th {\n        padding: 5px 15px;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-16;\n    }\n    td {\n        color: $text-color;\n    }\n}\n.emp-details {\n    margin: 20px 0;\n    .pay-slip-salery {\n        h6 {\n            font-weight: $font-weight-bold !important;\n            margin-bottom: 10px;\n            font-size: $font-size-18 !important;\n        }\n    }\n    .emp-name-id.pay-slip-salery {\n        margin-right: 30px;\n    }\n}\n.slip-logo {\n    @include respond-below(custom575) {\n        flex-shrink: 0;\n        margin-right: 15px;\n    }\n}\n.product-name-slip {\n    h4 {\n        color: $primary;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-18;\n    }\n}\n.pay-slip-box {\n    .modal-header {\n        border-radius: 8px 8px 0 0;\n    }\n    .custom-modal-body {\n        padding: 0;\n    }\n    .card {\n        border: 0;\n        border-radius: 0 0 10px 10px;\n        .card-body {\n            padding: 20px;\n            .emp-details.justify-content-start {\n                max-width: 760px;\n                margin: 20px auto 20px;\n            }\n        }\n    }\n}\n.table{\n  margin: 0;\n  tbody{\n      tr{\n          td{\n              color: $gray-700;\n              font-size: $font-size-14; \n              .product-img{\n                  img{\n                      border: 0;\n                  }\n              }\n              .userslist-img {\n                  width:35px;\n                  height: 35px;\n                  margin-right: 8px;\n                  img {\n                      border-radius: 0;\n                  }\n              }\n              .userslist-img.bg-img {\n                  img {\n                      border: 1px solid var(--stroke-table, #E8EBED);\n                    //   background: url(<path-to-image>), lightgray 50% / cover no-repeat;\n                  }\n              }\n              a {\n                  color: $title-color;\n                  font-size: $font-size-14;\n                  font-weight: $font-weight-normal;\n                  line-height: normal;\n                  &.product-img{\n                      margin-right: 5px;\n                      flex-shrink: 0;\n                  }\n                  .info-img {\n                      margin-right: 8px;\n                      width: 16px;\n                      height: 16px;\n                  }\n                  &:hover {\n                      color: $primary;\n                      i {\n                          color: $primary;\n                      }\n                  }\n              }\n              .emp-name {\n                  line-height: 1;\n                  a {\n                      color: $secondary;\n                  }\n                  p {\n                      line-height: 2;\n                      font-size: $font-size-15;\n                      font-weight: $font-weight-medium;\n                      color: $text-color;\n                  }\n                  .role {\n                      line-height: unset;\n                  }\n              }\n              .product-imgs{\n                  display: -webkit-box;\n                  display: -ms-flexbox;\n                  display: flex;\n                  align-items: center;\n                  -webkit-box-align: center;\n                  -ms-flex-align: center;\n                  justify-content: center;\n                  -webkit-justify-content: center;\n                  -ms-flex-pack: center;\n                  width:40px;\n                  height:40px;\n                  background: #FFEBD8;\n                  font-size: $font-size-14;\n                  color: #FF9F43 !important;\n                  font-weight: $font-weight-medium;\n                  margin-right:10px;\n              }\n          }\n          .data-header {\n              font-weight: $font-weight-semibold;\n              color: $secondary;\n              font-size: $font-size-15;\n              border-bottom: none;\n          }\n          .ref-number {\n              color: $purple;\n          }\n          &.active{\n              border-bottom: 0;\n              td{\n                  font-size: $font-size-18;\n                  color: $gray-700;\n                  font-weight: $font-weight-semibold;\n                  border-bottom: 0;\n              }\n          }\n      }\n      .loss-highlight {\n          td {\n              font-weight: $font-weight-bold;\n              color: $secondary;\n              font-size: $font-size-base;\n              border-top: 1px solid $gray-300;\n          }\n      }\n      .userimgname {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          align-items: center;\n          -webkit-box-align: center;\n          -ms-flex-align: center;\n          img {\n              margin-right: 8px;\n              border-radius: 6px;\n              \n          }\n      }\n      .purchase-count {\n          td {\n              padding-bottom: 20px;\n          }\n      }\n      \n  }\n  .Expense-list {\n     tr {\n      td {\n          padding: 15px 17px;\n          a {\n              margin-bottom: 0;\n          }\n      }\n     }\n  }\n  .sales-list {\n      tr {\n          td {\n              padding: 20px 17px;\n          }\n      }\n  }\n  .Expense-list-blk {\n      tr {\n          td {\n              padding: 20px 17px;\n          }\n      }\n  }\n  .userimgname .product-img {\n    display: inherit;\n    width: 35px;\n    height: 35px;\n    margin-right: 8px;\n  }\n  \n}\ntable {\n  tbody {\n      td {\n          &.action-table-data {\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              a {\n                  border: 1px solid rgba(145, 158, 171, 0.30);\n        background-color: $white;\n                  border-radius: 8px;\n                  display: -webkit-box;\n                  display: -ms-flexbox;\n                  display: flex;\n                  align-items: center;\n                  -webkit-box-align: center;\n                  -ms-flex-align: center;\n                  justify-content: center;\n                  -webkit-justify-content: center;\n                  -ms-flex-pack: center;\n                  padding: 8px;\n                  .feather-edit {\n                      color: $blue;\n                      width: 14px;\n                      height: 14px;\n                  }\n                  .action-edit {\n                     color: $text-color;\n                     width: 14px;\n                      height: 14px;\n                  }\n                  .feather-trash-2 {\n                      color: $danger;\n                      width: 14px;\n                      height: 14px;\n                  }\n                  .feather-eye {\n                      width: 14px;\n                      height: 14px;\n                  }\n                  .action-download {\n                      color: $blue;\n                      width: 14px;\n                      height: 14px;\n                      \n                  }\n                  .action-eye {\n                      color: $secondary;\n                      width: 14px;\n                      height: 14px;\n                  }\n              }\n             \n          }\n      }\n      .productimgname {\n          min-width: 200px;\n          a {\n              &.stock-img.product-img {\n                  display: -webkit-box;\n                  display: -ms-flexbox;\n                  display: flex;\n                  align-items: center;\n                  -webkit-box-align: center;\n                  -ms-flex-align: center;\n                  justify-content: center;\n                  -webkit-justify-content: center;\n                  -ms-flex-pack: center;\n                  margin-right: 8px;\n                  img {\n                      width: 50px;\n                      height: 50px;\n                      max-width: 100%;\n                      margin-right: 0;\n                  }\n              }\n          }\n      }\n  }\n  .edit-delete-action {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      align-items: center;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      justify-content: center;\n      -webkit-justify-content: center;\n      -ms-flex-pack: center;\n      height: 50px;\n      a {\n          padding: 0;\n      }\n\n  }\n  .edit-delete-action.data-view {\n      min-height: 52px;\n  }\n  .edit-delete-action.data-row {\n      height: auto;\n  }\n  .edit-delete-action.data {\n      height: 44px;\n  }\n}\n.custom-table {\n    table {\n        td {\n            ul {\n                &.social-links {\n                    li {\n                        a {\n                            width: 24px;\n                            height: 24px;\n                            border-radius: 50%;\n                            display: inline-flex;\n                            align-items: center;\n                            justify-content: center;\n                            margin-right: 5px;\n                            color: $text-color;\n                            &:hover {\n                                background: $light-900;\n                                color: $text-color;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}",".accordion-button {\n    background-color: $white;\n    color: $text-color;\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n    font-weight: $font-weight-medium;\n    &.accordion-custom-button {\n        &:after {\n            content: \"\\f054\";\n        }\n        &:not(.collapsed) {\n            color: $text-color;\n            background-color: $default-background;\n            box-shadow: none;\n            &:after {\n                content: \"\\f078\";\n                display: block;\n                transform: none;\n            }\n        }\n    }\n    &:not(.collapsed) {\n        color: $text-color;\n        background-color: $default-background;\n        box-shadow: none;\n    }\n    &:focus {\n        border-color: rgba($primary, 0.3);\n        box-shadow: none;\n    }\n    &:after,&:not(.collapsed)::after {\n        background-image: none;\n    }\n    &:after {\n        content: \"\\f078\";\n        font-family: $font-awesome;\n        font-size: $font-size-12;\n        line-height: 1;\n        background-color: $white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 3.125rem;\n        color: $text-color;\n    }\n}    \n.accordion-body {\n    padding: 0.75rem 1rem;\n    font-size: 0.8125rem;\n    color: $text-muted;\n}\n.accordion-item {\n    color: $text-color;\n    background-color: $white;\n    border: 1px solid $light-900;\n}\n.accordions-items-seperate {\n    .accordion-item:not(:first-of-type) {\n        margin-block-start: 0.5rem;\n    }\n    .accordion-item {\n        border-block-start: 1px solid $light-900;\n        border-radius: $border-radius;\n        overflow: hidden;\n    }\n}\n.accordion-item:last-of-type {\n    border-bottom-right-radius: 0.35rem;\n    border-bottom-left-radius: 0.35rem;\n}\n.accordion-item:first-of-type {\n    border-top-left-radius: 0.35rem;\n    border-top-right-radius: 0.35rem;\n}\n.accordion {\n    &.accordion-primary {\n        .accordion-button {\n            background-color: rgba($primary, 0.1);\n            color: $primary;\n            &:after { \n                background-color: $primary;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-secondary {\n        .accordion-button {\n            background-color: rgba($secondary,0.1);\n            color: $secondary;\n            &:after { \n                background-color: $secondary;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-success {\n        .accordion-button {\n            background-color: rgba($success,0.1);\n            color: $success;\n            &:after { \n                background-color: $success;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-danger {\n        .accordion-button {\n            background-color: rgba($danger,0.1);\n            color: $danger;\n            &:after { \n                background-color: $danger;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-warning {\n        .accordion-button {\n            background-color: rgba($warning,0.1);\n            color: $warning;\n            &:after { \n                background-color: $warning;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-info {\n        .accordion-button {\n            background-color: rgba($info,0.1);\n            color: $info;\n            &:after { \n                background-color: $info;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-solid-primary {\n        .accordion-button {\n            background-color: $primary;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $primary;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-secondary {\n        .accordion-button {\n            background-color: $secondary;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $secondary;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-success {\n        .accordion-button {\n            background-color: $success;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $success;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-danger {\n        .accordion-button {\n            background-color: $danger;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $danger;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-warning {\n        .accordion-button {\n            background-color: $warning;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $warning;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-info {\n        .accordion-button {\n            background-color: $info;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $info;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-border-primary {\n        .accordion-item {\n            border: 1px solid $primary;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $primary;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $primary;\n                border: 1px solid $primary;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $primary;\n            }\n        }\n    }\n    &.accordion-border-secondary {\n        .accordion-item {\n            border: 1px solid $secondary;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $secondary;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $secondary;\n                border: 1px solid $secondary;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $secondary;\n            }\n        }\n    }\n    &.accordion-border-success {\n        .accordion-item {\n            border: 1px solid $success;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $success;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $success;\n                border: 1px solid $success;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $success;\n            }\n        }\n    }\n    &.accordion-border-danger {\n        .accordion-item {\n            border: 1px solid $danger;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $danger;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $danger;\n                border: 1px solid $danger;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $danger;\n            }\n        }\n    }\n    &.accordion-border-warning {\n        .accordion-item {\n            border: 1px solid $warning;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $warning;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $warning;\n                border: 1px solid $warning;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $warning;\n            }\n        }\n    }\n    &.accordion-border-info {\n        .accordion-item {\n            border: 1px solid $info;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $info;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $info;\n                border: 1px solid $info;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $info;\n            }\n        }\n    }\n}\n.accordion {\n    &.accordionicon-none {\n        .accordion-button:after {\n            display: none;\n        }\n    }\n}\n.accordion {\n    &.accordionicon-left {\n        .accordion-button {\n            padding-inline-start: 2.5rem;\n            &:after {\n                position: absolute;\n                inset-inline-start: 0.625rem;\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-customicon1 {\n        .accordion-button {\n            &:after {\n                content: \"\\2b\";\n                font-family: $font-awesome;\n                background-color: $default-background;\n            }\n            &:not(.collapsed)::after {\n                content: \"\\f068\";\n\t\t\t\tfont-family: $font-awesome;\n                background-color: $white;\n            }\n        }\n    }\n}\n.customized-accordion {\n    .accordion-item{\n        &.custom-accordion-primary {\n            .accordion-button {\n                background-color: rgba($primary, 0.1);\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\n                &:after {\n                    background-color: rgba($primary, 0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($primary, 0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\n            }\n        }\n        &.custom-accordion-secondary {\n            .accordion-button {\n                background-color: rgba($secondary,0.1);\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\n                &:after {\n                    background-color: rgba($secondary,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($secondary,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\n            }\n        }\n        &.custom-accordion-warning {\n            .accordion-button {\n                background-color: rgba($warning,0.1);\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\n                &:after {\n                    background-color: rgba($warning,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($warning,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\n            }\n        }\n        &.custom-accordion-info {\n            .accordion-button {\n                background-color: rgba($info,0.1);\n                border-inline-start: 0.25rem solid rgba($info,0.6);\n                &:after {\n                    background-color: rgba($info,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($info,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($info,0.6);\n            }\n        }\n        &.custom-accordion-success {\n            .accordion-button {\n                background-color: rgba($success,0.1);\n                border-inline-start: 0.25rem solid rgba($success,0.6);\n                &:after {\n                    background-color: rgba($success,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($success,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($success,0.6);\n            }\n        }\n        &.custom-accordion-danger {\n            .accordion-button {\n                background-color: rgba($danger,0.1);\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\n                &:after {\n                    background-color: rgba($danger,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($danger,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\n            }\n        }\n    }\n}",".page-header-breadcrumb {\n  .breadcrumb-item+.breadcrumb-item::before {\n    content: var(--bs-breadcrumb-divider, \"\\ea65\");\n    font-family: \"tabler-icons\" !important;\n  }\n}\n[dir=\"rtl\"] {\n  .page-header-breadcrumb {\n    .breadcrumb-item+.breadcrumb-item::before {\n      content: var(--bs-breadcrumb-divider, \"\\ea64\");\n      font-family: \"tabler-icons\" !important;\n    }\n  }\n}\n.breadcrumb {\n  .breadcrumb-item {\n    a {\n      color: $text-muted;\n    }\n\n    &.active {\n      color: $primary;\n    }\n  }\n}\n.breadcrumb-item+.breadcrumb-item::before {\n  color: $text-muted;\n  opacity: 0.4;\n}\n.breadcrumb-arrow {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f101\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-pipe {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f061\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-line {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"-\";\n  }\n}\n.breadcrumb-dot {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"•\";\n  }\n}\n.breadcrumb-divide {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f054\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-separatorless {\n  .breadcrumb-item+.breadcrumb-item::before {\n    content: \"\";\n    display: none;\n  }\n}\n.breadcrumb-colored {\n  padding: 12px 15px;\n  border-radius: $border-radius;\n\tli {\n\t\ta {\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.breadcrumb-item {\n    a {\n\t\t\tcolor: $white;\n    }\n\t\t&.active {\n\t\t\tcolor: $white;\n\t\t\topacity: 0.8;\n\t\t}\n\t\t& + .breadcrumb-item {\n      a {\n        color: $white;\n      }\n\t\t\t&::before {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n}\n.embedded-breadcrumb:before {\n  opacity: 0.7;\n}\n[data-theme-mode=\"dark\"] {\n  .embedded-breadcrumb:before {\n    filter: invert(1);\n  }\n}",".card {\n    margin-bottom: 24px;\n    background-color: $white;\n    transition: all .5s ease-in-out;\n    position: relative;\n    border-radius: $border-radius-lg;\n    border: 0;\n    box-shadow: $box-shadow-sm;\n    color: inherit;\n    .card-body {\n        padding: 1rem;\n    }\n    .card-title {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n        text-transform: capitalize;\n    }\n    .card-header {\n        border-color: $light-900;\n        position: relative;\n        background: transparent;\n        padding: 1rem;\n        .card-title {\n            margin-bottom: 0rem;\n        }\n        .subtitle {\n            padding-top: 0.3125rem;\n            font-size: 0.875rem;\n            line-height: 1.5; \n        }\n    }\n    .card-footer {\n        border-color: $light-900;\n        background: transparent;\n        padding: 1rem 1.25rem 1rem;\n    }    \n}\n.card-group {\n  .card {    \n      margin-bottom: 1.5rem;\n  }\n}\n.card {\n  &.custom-card {\n  border-radius: $border-radius;\n  border: 0;\n  background-color: $white;\n  position: relative;\n  margin-block-end: 1.5rem;\n  width: 100%;\n  .card-header {\n    padding: 1rem 1.25rem;\n    background-color: transparent !important;\n    border-block-end: 1px solid $default-border;\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n    &:first-child {\n      border-radius: 0.625rem 0.625rem 0 0;\n    }\n    .card-title {\n      position: relative;\n      margin-block-end: 0;\n      font-size: 0.9375rem;\n      font-weight: $font-weight-bold;\n      text-transform: capitalize;\n      .subtitle {\n        margin-block-end: 0;\n        text-transform: initial;\n      }\n    }\n  }\n  .card-footer {\n    background-color: transparent !important;\n    border-block-start: 1px solid $default-border;\n    padding: 1rem 1.5rem;\n    font-size: $font-size-base;\n  }\n  .card-body {\n    padding: 1.5rem;\n    color: $text-color;\n  }\n  .card-link {\n    font-size: 0.75rem;\n  }\n  }\n  .card-text {\n    font-size: 0.813rem;\n  }\n  .footer-card-icon {\n    width: 60px;\n    height: 60px;\n  }\n  &.overlay-card {\n    position: relative;\n    overflow: hidden;\n    color: rgba(255, 255, 255, 0.9);\n    .card-header {\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\n    }\n    .card-footer {\n      border-block-start: 1px solid rgba(255, 255, 255, 0.1);\n    }\n    .over-content-bottom {\n      top: auto;\n    }\n    &:before {\n      content: \"\";\n      inset-inline-start: 0;\n      inset-inline-end: 0;\n      inset-block-start: 0;\n      inset-block-end: 0;\n      background-color: rgba(0, 0, 0, 0.2);\n      position: absolute;\n    }\n  }\n  &.card-bg-primary {\n    background-color: $primary;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-secondary {\n    background-color: $secondary;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-warning {\n    background-color: $warning;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-info {\n    background-color: $info;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-success {\n    background-color: $success;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-danger {\n    background-color: $danger;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-light {\n    background-color: $light;\n    color: $text-color;\n    .card-header {\n      background-color: rgba(0, 0, 0, 0.05) !important;\n      color: $text-color;\n      border-block-end: $default-border;\n    }\n    .card-body {\n      color: $text-color;\n    }\n    .card-footer {\n      background-color: rgba(0, 0, 0, 0.05) !important;\n      color: $text-color;\n      border-block-start: $default-border;\n    }\n  }\n  &.card-bg-dark {\n    background-color: $dark;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  .card-anchor {\n    position: absolute;\n    top: 0;\n    inset-inline-end: 0;\n    bottom: 0;\n    inset-inline-start: 0;\n    z-index: 1;\n    pointer-events: auto;\n    content: \"\";\n  }\n  .collapse-close {\n    display: none;\n  }\n  &.card .collapsed {\n    .collapse-close {\n      display: block;\n    }\n    .collapse-open {\n      display: none;\n    }\n  }\n  &.card-fullscreen {\n    position: fixed;\n    top: 0;\n    inset-inline-start: 0;\n    inset-inline-start: 0;\n    bottom: 0;\n    z-index: 9999;\n    margin: 0;\n  }\n}\n.cals-icon {\n    font-size: $font-size-50;\n    color: $gray-500;\n}\n.callout {\n  padding: 1.25rem;\n  margin-block-start: 1.25rem;\n  margin-block-end: 1.25rem;\n  background-color: $light;\n  border-inline-start: 0.25rem solid $default-border;\n}\n.callout-info {\n  background-color: rgba($info, 0.075);\n  border-color: rgba($info, 0.5);\n}\n.callout-warning {\n  background-color: rgba($warning, 0.075);\n  border-color: rgba($warning, 0.5);\n}\n.callout-danger {\n  background-color: rgba($danger, 0.075);\n  border-color: rgba($danger, 0.5);\n}\n.btn-facebook {\n  background-color: $facebook;\n  color: $white;\n  border: 1px solid $facebook;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $facebook !important;\n    color: $white !important;\n    border: 1px solid $facebook !important;\n  }\n}\n.btn-instagram {\n  background: #f09433;\n  background: -moz-linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  background: -webkit-linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  background: linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );\n  color: $white;\n  border: 1px solid transparent;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $white;\n    border: 1px solid transparent;\n  }\n}\n.btn-twitter {\n  background-color: $twitter;\n  color: $white;\n  border: 1px solid $twitter;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $twitter !important;\n    color: $white !important;\n    border: 1px solid $twitter !important;\n  }\n}\n.btn-icon {\n    width: 2.313rem;\n    height: 2.313rem;\n    font-size: .95rem;\n    flex-shrink: 0;\n}\n.btn-wave {\n    display: inline-block !important;\n}\n\n@media (max-width: 575px) {\n  .overlay-card {\n      .card-text {\n          font-size: .613rem !important;\n      }\n  }\n}\n@media (max-width: 400px) {\n  .overlay-card {\n      .card-text {\n          font-size: .413rem !important;\n      }\n  }\n}",".tooltip {\n  @mixin tooltip-color($color) {\n    .tooltip-inner {\n      background-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\n    &.bs-tooltip-top .tooltip-arrow::before {\n      border-top-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"right\"] .tooltip-arrow::before,\n    &.bs-tooltip-end .tooltip-arrow::before {\n      border-right-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"left\"] .tooltip-arrow::before,\n    &.bs-tooltip-start .tooltip-arrow::before {\n      border-left-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"bottom\"] .tooltip-arrow::before,\n    &.bs-tooltip-end .tooltip-arrow::before {\n      border-bottom-color: $color;\n    }\n  }\n  &.tooltip-primary {\n    @include tooltip-color($primary);\n  }\n  &.tooltip-secondary {\n    @include tooltip-color($secondary);\n  }\n  &.tooltip-warning {\n    @include tooltip-color($warning);\n  }\n  &.tooltip-info {\n    @include tooltip-color($info);\n  }\n  &.tooltip-success {\n    @include tooltip-color($success);\n  }\n  &.tooltip-danger {\n    @include tooltip-color($danger);\n  }\n  &.tooltip-dark {\n    @include tooltip-color($dark);\n    .tooltip-inner {\n      color: $white;\n    }\n  }\n  &.tooltip-light {\n    @include tooltip-color($light);\n    .tooltip-inner {\n      color: $text-color;\n    }\n  }\n}\n",".nav-item {\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n}\n.nav-link {\n  color: $text-color;\n  border-radius: $border-radius;\n  font-weight: $font-weight-semibold;\n  &.active {\n    background-color: rgba($primary,0.1);\n    color: $primary;\n  }\n}\n.navbar-brand {\n  color: $text-color;\n  &:focus ,&:hover {\n    color: $text-color;\n    opacity: 0.9;\n  }\n}\n.navbar-nav .nav-link.active,\n.navbar-nav .show > .nav-link {\n  color: $primary;\n}\n.nav-link.disabled {\n  color: $text-color;\n  opacity: 0.3;\n}\n.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {\n  color: rgba($dark,0.5);\n}\n.navbar-text {\n  color: $text-color;\n}\n.navbar-dark {\n  &.bg-dark {\n    .nav-link,\n    .navbar-brand {\n      color: $white;\n    }\n  }\n  .navbar-nav .nav-link.active,\n  .navbar-nav .show > .nav-link {\n    color: $white;\n  }\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: $white;\n  background-color: $primary;\n}\n\n.nav.nav-style-1 {\nborder: 0;\n.nav-item {\n  margin-inline-end: 0.25rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n}\n.nav-link {\n  &.active {\n      background-color: rgba($primary, 0.1);\n      color: $primary;\n      &:hover {        \n        background: rgba($primary, 0.1);\n      }\n  }\n  &:hover {        \n      background: transparent;\n      color: $primary;\n  }\n}\n}\n.nav.nav-style-2 {\n.nav-item .nav-link {\n  border-block-start: 3px solid transparent;\n  &.active {\n    background-color: rgba($primary, 0.1);\n    border-block-start: 3px solid $primary;\n    color: $primary;\n  }\n}\n}\n.nav.nav-style-3 {\n.nav-link {\n  border-radius: 0;\n}\n.nav-link {\n  border-block-end: 3px solid transparent;\n}\n.nav-link.active {\n  background-color: transparent;\n  border-block-end: 3px solid $primary;\n  color: $primary;\n}\n}\n.nav.nav-style-4 {\nborder: 0;\n.nav-link {\n  color: $text-muted;\n  border: 0;\n}\n.nav-link {\n  margin-bottom: 3px;\n  &.active {\n    background-color: $light;\n    color: $text-color;\n    border: 0;\n  }\n  &:hover,\n  &:focus {\n    border: 0;\n  }\n  &:hover {\n      background-color: $light;\n      color: $text-color;   \n  }\n}\n}\n.nav-tabs.nav-style-5 {\nborder: 0;\n.nav-link {\n  color: $text-muted;\n  border: 0;\n  margin-bottom: 3px;\n}\n.nav-link {\n  &.active {\n    background-color: $primary;\n    color: $white;\n    border: 0;\n  }\n  &:hover,\n  &:focus {\n    border: 0;\n    background-color: $primary;\n    color: $white;\n  }\n}\n}\n.nav-style-6 {\nborder: 0;\n&.nav-pills .nav-link {\n  &.active {\n    border: 1px solid $primary;\n    border-block-end: 2px solid $primary;\n    background-color: transparent;\n    color: $primary;\n  }\n}\n}\n.nav-tabs-header {\nborder: 0 !important;\n.nav-item {\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link {\n    border: 1px solid transparent;\n    font-size: 0.8rem;\n    padding: 0.4rem 0.5rem;\n    font-weight: $font-weight-medium;\n    &.active {\n      background: rgba($primary, 0.1);\n      color: $primary;\n      border: 1px solid transparent;\n    }\n    &:hover,&:focus {\n      border: 1px solid transparent;\n      background-color: transparent;\n      color: $primary;\n    } \n  }\n}\n}\n.nav-tabs-footer {\nborder: 0;\n.nav-item {\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link {\n    background-color: transparent;\n    color: $primary;\n    border: 1px solid $primary;\n    font-size: 0.8rem;\n    &.active {\n      background: $primary;\n      color: $white;\n      border: 1px solid $primary;\n    }\n    &:hover,&:focus {\n      border: 1px solid $primary;\n      background-color: transparent;\n       color: $primary;\n    } \n  }\n}\n}\n.vertical-tabs-2 {\nborder: 0;\n.nav-item {\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link {\n    min-width: 7.5rem;\n    max-width: 7.5rem;\n    text-align: center;\n    border: 1px solid $default-border;\n    margin-bottom: 0.5rem;\n    color: $text-muted;\n    background-color: $light;\n    i {\n      font-size: 1rem;\n    }\n    &.active {\n      background-color: $primary;\n      color: $white;\n      position: relative;\n      &:before {\n        content: \"\";\n        position: absolute;\n        inset-inline-end: -0.5rem;\n        inset-block-start: 38%;\n        transform: rotate(45deg);\n        width: 1rem;\n        height: 1rem;\n        background-color: $primary;\n      }\n      &:hover {\n        color: $white;\n      }\n    }\n    &:hover {\n      color: $primary;\n    }\n  }\n}\n}\n.vertical-tabs-3 {\nborder: 0;\n.nav-item {\n  border: 0;\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link {\n    min-width: 160px;\n    max-width: 160px;\n    border: 1px solid $primary;\n    padding: 1.3rem;\n    margin-block-end: 0.5rem;\n    i {\n      width: 2rem;\n      height: 2rem;\n      line-height: 2rem;\n      text-align: center;\n      font-size: 1rem;\n      background: $primary;\n      color: $white;\n      border-radius: 3.125rem;\n      font-weight: $font-weight-medium;\n    }\n    &.active {\n      background: $primary;\n      border: 1px solid $primary;\n      color: $white;\n      &:hover {\n        background: $primary;\n        border: 1px solid $primary;\n        color: $white;          \n      }\n      i {\n        background: $white;\n        color: $primary;\n      }\n    }\n    &:hover,&:focus {\n      border: 1px solid $primary;\n      color: $primary;\n        background: transparent;\n    }\n  }\n}\n}\n.nav.tab-style-1 {\nborder-block-end: 0;\npadding: 0.65rem;\nbackground-color: $light;\nborder-radius: 7px;\nmargin-block-end: 1rem;\n.nav-item {\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n}\n.nav-link {\n  border-radius: 7px;\n  padding: 0.35rem 1rem;\n  &.active {\n    background-color: $primary !important;\n    color: $white !important;\n    box-shadow: $box-shadow;\n    transition: color 0.15s ease-in;\n  }\n}\n}\n.nav-tabs.tab-style-1 {\n  .nav-link {\n      &:hover {\n      background: transparent;\n      color: $primary;\n    }  \n\n  }\n\n}\n.tab-style-2 {\nborder-block-end: 0;\n.nav-item {\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link {\n    border: 0;\n    i { \n      width: 1.875rem;\n      height: 1.875rem;\n      padding: 0.4rem;\n      border-radius: 50px;\n      background-color: $light;\n      color: $text-color;\n      display: inline-block;\n    }\n    &:hover {\n      border: 0;\n      background: transparent;\n      color: $primary;\n      i {\n        color: $primary;          \n      }\n    }\n    &.active {\n      background-color: transparent;\n      position: relative;\n      border: 0;\n      color: $primary;\n      i { \n        background-color: rgba($primary, 0.1);\n        color: $primary;\n      }\n      &:before {\n        content: \"\";\n        position: absolute;\n        inset-inline-start: 0;\n        inset-inline-end: 0;\n        inset-block-end: 0;\n        width: 100%;\n        height: 0.175rem;\n        background-color: $primary;\n        border-radius: 50px;\n      }\n    }\n  }\n}\n}\n.tab-style-3 {\nborder-block-end: 0;\n.nav-item {\n  position: relative;\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link {\n    position: relative;\n    border: 0;\n    font-size: 0.75rem;\n    &:before {\n      position: absolute;\n      content: \"\";\n      inset-block-end: -1.063rem;\n      inset-inline-end: 0;\n      inset-inline-start: 0;\n      width: 100%;\n      height: 0.1rem;\n      background-color: $light;\n      border-radius: 50%;\n    }\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-block-end: -2rem;\n      inset-inline-start: 1.75rem;\n      inset-inline-end: 0;\n      inset-inline-start: 30%;\n      width: 2rem;\n      height: 2rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: $white;\n      border-radius: 50%;\n      border: 2px solid $default-border;\n    }\n    &.home:after {\n      content: \"1\";\n    }\n    &.about:after {\n      content: \"2\";\n    }\n    &.services:after {\n      content: \"3\";\n    }\n    &:hover {\n      border: 0;\n      background: transparent;\n      color: $primary;\n    }\n    &.active {\n      background-color: transparent;\n      border: 0;\n      color: $primary;\n      &:before {\n        background-color: $primary;\n      }\n      &:after {\n        border-color: $primary;\n        color: $primary;\n      }\n    }\n  }\n}\n}\n.tab-style-4 {\n&.nav-tabs {\n  border: 0;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n  }\n  .nav-link {\n    border: 0;\n    &:hover {\n      border: 0;\n      background: transparent;\n      color: $primary;\n    }\n    &.active {\n      background-color: transparent;\n      border: 0;\n      color: $primary;\n      position: relative;\n      overflow: hidden;\n      &::before {\n        position: absolute;\n        content: \"\";\n        width: 0.75rem;\n        inset-block-start: 31px;\n        transform: rotate(45deg);\n        inset-inline-start: 47%;\n        overflow: hidden;\n        z-index: 1;\n        height: 0.75rem;\n        background-color: $primary;\n        border: 1px solid $primary;\n      }\n      &:after {\n        position: absolute;\n        content: \"\";\n        width: 40%;\n        height: 1px;\n        inset-inline-start: 30%;\n        inset-block-end: 0;\n        background-color: $primary;\n      }\n    }\n  }\n}\n}\n#tab-style-4 .tab-pane.active {\nborder: 1px solid $primary;\nbackground-color: $primary;\ncolor: $white;\npadding: 16px;\n  border-radius: 7px;\n}\n.tab-style-5 {\n.nav-item {\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link.active {\n    background: $primary;\n  }\n}\n}\n.tab-style-6 {\nborder: 0;\nbackground-color: $white;\nborder-radius: 7px;\ncolor: $primary;\npadding: 0.5rem;\n.nav-item {\n  border: 0;\n  margin-inline-end: 0.5rem;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n  .nav-link {\n    color: $primary;\n    padding: 0.5rem 1rem;\n    font-size: 0.813rem;\n    border: 0;\n    font-weight: $font-weight-medium;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    &.active {\n      border: 0;\n      background-color: $primary;\n      color: $white;\n      border: 0;\n      box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb),0.05);\n    }\n    &:hover,\n    &:focus {\n      border: 0;\n    }\n  }\n}\n}\n.tab-style-7 {\n.nav-link {\n  margin-block-end: 0.5rem;\n  font-size: 0.813rem;\n  color: $text-muted;\n  text-align: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  &:active,\n  &.active {\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n  }\n}\n}\n.nav-style-1 {\n.nav-item {\n  .nav-link {\n    &.active {\n      background-color: rgba($primary, 0.1);\n      color: $primary;\n    }\n  }\n}\n}\n@media screen and (max-width:400px) {\n.tab-style-4 {\n  .nav-link{\n    padding-inline: 0.5rem;\n  }\n}\n}\n\n.nav-tabs {\n  border-bottom: 0;\n  &.nav-tabs-bottom {\n      li {\n          margin-bottom: -1px;\n      }\n  }\n  .nav-link {\n      margin-bottom: -1px;\n      background: 0 0;\n      border: 1px solid transparent;\n      border-top-left-radius: 0.25rem;\n      border-top-right-radius: 0.25rem;\n      &.active {\n        border-color: $gray-300;\n      }\n  }\n  li{\n      a{\n          color: $gray-600;\n          border-bottom-width: 2px;\n          &.active{\n              border-color: transparent;\n              border-bottom-color: $primary;\n              background-color: transparent;\n              @include transition(all 0.2s ease);\n          }\n      }\n  }\n}\n.nav-tabs{\n  .nav-tabs-solid {\n      background-color: $white;\n      border: 0;\n      .active{\n          background-color: $primary;\n          border-color: $primary;\n          color: $white;\n      }\n  }\n}\n.nav-tabs{\n  .nav-link{\n      &:hover{\n          border-color: transparent;\n          color: $primary;\n      }\n  }\n  &.nav-tabs-top{\n      li{\n          a{\n              border-width: 2px 0 0 0;\n              &.active{\n                  border-top-color: $primary;                    \n                  @include rounded(0);\n              }\n              &:hover {\n                  border-top-color: $primary;  \n                  background-color: transparent;                    \n                  @include rounded(0);\n              }\n          }\n      }\n  }\n  &.nav-tabs-bottom{\n      li{\n          a{\n              border-width:0 0 2px  0;\n              &.active, &:hover {\n                  border-bottom-color: $primary;\n                  background: transparent;\n                  @include rounded(0);\n              }\n          }\n      }\n  }\n  &.nav-tabs-solid{\n      background-color: $white;\n      border: 0;\n      &.nav-tabs-rounded{\n          li{\n              a{\n                  &.active {\n                      background-color: $primary;\n                      border-color: $primary;\n                      color: $white;\n                      @include rounded(50px);\n                  }\n              }\n          }  \n      }\n      li{\n          a{\n              &.active{\n                  background-color: $primary;\n                  border-color: $primary;\n                  color: $white;\n                  @include rounded(0);\n              }\n          }\n      }   \n  }\n}\n.nav-link{\n  &:hover{\n      color: $primary;\n  }\n}\n.page-menu{\n  .nav-tabs {\n      li{\n          a{\n              font-size: $font-size-16;\n          }\n      }\n  }\n}\n.tabs-set{\n  .nav-tabs {\n      border-bottom: 0;\n      margin-bottom: 20px;\n      .nav-link{\n          color: $secondary;\n          @include margin-padding(null, 8px 15px);\n          font-size: $font-size-16;\n          font-weight: $font-weight-bold;\n          border: 0;\n          min-width: 120px;\n          margin-right: 10px;\n          border-radius: 8px;\n          background: var(--Stroke, rgba(145, 158, 171, 0.30));\n          @include margin-padding(null, null);\n          &:focus{\n              border-color: transparent;\n          }\n          &:hover{\n              border-color: transparent;\n          }\n          &.active{\n              border:0;\n              border-bottom:2px solid $primary;\n              background: $primary;\n              color: $white;\n          }\n      }\n  }\n}\n.tabs-sets{\n  .nav-tabs {\n      border-bottom: 0;\n      @include margin-padding(0 0 40px, null);\n      .nav-link{\n          color: $black;;\n          font-size: $font-size-base;\n          font-weight: $font-weight-bold;\n          border: 0;\n          background: $gray-300;\n          margin-right:10px;\n          @include margin-padding(null, 8px 15px);\n          @include rounded(8px);\n          @include transition(all 0.5s ease);\n          &:focus, &:hover, &.active{\n              background: $primary;\n              color: $white;\n          }\n      }\n  }\n}\n@include respond-below(custom768) {\n  .nav-tabs {\n      border-bottom: 0;\n      position: relative;\n      background-color: $white;\n      @include margin-padding(null, 5px 0);\n      @include rounded(3px);\n  }\n}",".ribbon1 {\n  position: absolute;\n  inset-block-start: -6.1px;\n  inset-inline-end: 10px;\n  color: $white;\n  z-index: 1;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 20px solid transparent;\n    border-inline-end: 24px solid transparent;\n    border-block-start: 13px solid $danger;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: $font-size-14;\n    line-height: 1;\n    padding: 12px 8px 10px;\n    border-start-end-radius: 8px;\n    &:before,\n    &:after {\n      position: absolute;\n      content: \"\";\n    }\n    &:before {\n      height: 6px;\n      width: 6px;\n      inset-inline-start: -6px;\n      inset-block-start: 0;\n      background: $danger;\n    }\n    &:after {\n      height: 6px;\n      width: 8px;\n      inset-inline-start: -8px;\n      inset-block-start: 0;\n      border-radius: 8px 8px 0 0;\n      background: $danger;\n    }\n  }\n}\n.ribbone {\n  width: 100%;\n  position: relative;\n  background-size: cover;\n  text-transform: uppercase;\n  color: $white;\n  width: 150px;\n  height: 150px;\n  overflow: hidden;\n  position: absolute;\n  z-index: 6;\n  &::after {\n    position: absolute;\n    z-index: -1;\n    content: \"\";\n    display: block;\n    border: 5px solid;\n  }\n  &::before {\n    position: absolute;\n    z-index: -1;\n    content: \"\";\n    display: block;\n    border: 5px solid;\n  }\n  span {\n    position: absolute;\n    display: block;\n    width: 225px;\n    padding: 3px 0;\n    box-shadow: 0 5px 10px rgba(0,0,0, 0.1);\n    color: $white;\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\n    text-transform: capitalize;\n    text-align: center;\n    font-size: 11px;\n  }\n}\n.ribbone1 {\n  position: absolute;\n  inset-block-start: -6.1px;\n  inset-inline-start: 10px;\n  z-index: 1;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 20px solid transparent;\n    border-inline-end: 24px solid transparent;\n    border-block-start: 13px solid $danger;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: $font-size-14;\n    line-height: 1;\n    padding: 12px 8px 10px;\n    border-start-end-radius: 8px;\n    &:after {\n      position: absolute;\n      content: \"\";\n      height: 6px;\n      width: 8px;\n      inset-inline-start: -8px;\n      inset-block-start: 0;\n      border-radius: 8px 8px 0 0;\n      background: $danger;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 6px;\n      width: 6px;\n      inset-inline-start: -6px;\n      inset-block-start: 0;\n      background: $danger;\n    }\n  }\n}\n.arrow-ribbone-left {\n  color: $white;\n  padding: 2px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-start: 0;\n  z-index: 6;\n  font-size: 13px;\n}\n.arrow-ribbone-left.bg-purple {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $purple;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-danger {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 112px solid transparent;\n    border-inline-start: 12px solid $danger;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-primary {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-secondary {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $secondary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-success {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $primary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-info {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $info;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-warning {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $warning;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-pink {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $pink;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-teal {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $teal;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right {\n  color: $white;\n  padding: 2px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-end: 0;\n  z-index: 6;\n  font-size: 13px;\n}\n.arrow-ribbone-right.bg-purple {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $purple;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-danger {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $danger;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-primary {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-secondary {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $secondary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-success {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $primary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-info {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $info;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-warning {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $warning;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-pink {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $pink;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-teal {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $teal;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone2 {\n  color: $white;\n  padding: 3px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-start: -1px;\n  z-index: 6;\n  font-size: $font-size-30;\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -24px;\n    border-block-start: 24px solid transparent;\n    border-block-end: 24px solid transparent;\n    width: 0;\n  }\n}\n.power-ribbone {\n  width: 56px;\n  height: 56px;\n  overflow: hidden;\n  position: absolute;\n  z-index: 6;\n  span {\n    position: absolute;\n    display: block;\n    width: 82px;\n    padding: 8px 0;\n    color: $white;\n    font: 500 16px/1 Lato, sans-serif;\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\n    text-transform: capitalize;\n    text-align: center;\n  }\n}\n.power-ribbone-top-left {\n  inset-block-start: -6px;\n  inset-inline-start: -9px;\n  span {\n    inset-inline-end: -5px;\n    inset-block-start: 1px;\n    transform: rotate(-45deg);\n    i {\n      transform: rotate(45deg);\n      padding-block-start: 2px;\n      padding-inline-start: 7px;\n    }\n  }\n}\n.power-ribbone-bottom-left {\n  inset-block-end: -6px;\n  inset-inline-start: -9px;\n  span {\n    inset-inline-end: -5px;\n    inset-block-end: 1px;\n    transform: rotate(45deg);\n    i {\n      transform: rotate(-45deg);\n      padding-block-end: 2px;\n      padding-inline-start: 7px;\n    }\n  }\n}\n.power-ribbone-top-right {\n  inset-block-start: -6px;\n  inset-inline-end: -9px;\n  span {\n    inset-inline-start: -5px;\n    inset-block-start: 1px;\n    transform: rotate(45deg);\n    i {\n      transform: rotate(-45deg);\n      padding-block-start: 2px;\n      padding-inline-end: 7px;\n    }\n  }\n}\n.power-ribbone-bottom-right {\n  inset-block-end: -6px;\n  inset-inline-end: -9px;\n  span {\n    inset-inline-start: -5px;\n    inset-block-end: 1px;\n    transform: rotate(-45deg);\n    i {\n      transform: rotate(45deg);\n      padding-block-end: 2px;\n      padding-inline-end: 7px;\n    }\n  }\n}\n.ribbone-top-left {\n  inset-block-start: -10px;\n  inset-inline-start: -10px;\n  &::after {\n    border-block-start-color: transparent;\n    border-inline-start-color: transparent;\n    inset-block-end: 50px;\n    inset-inline-start: 0;\n  }\n  &::before {\n    border-block-start-color: transparent;\n    border-inline-start-color: transparent;\n    inset-block-start: 0;\n    inset-inline-end: 50px;\n  }\n  span {\n    inset-inline-end: 0px;\n    inset-block-start: 24px;\n    transform: rotate(-45deg);\n  }\n}\n.ribbone-top-right {\n  inset-block-start: -10px;\n  inset-inline-end: -10px;\n  &::after {\n    border-block-start-color: transparent;\n    border-inline-end-color: transparent;\n    inset-block-end: 50px;\n    inset-inline-end: 0;\n  }\n  &::before {\n    border-block-start-color: transparent;\n    border-inline-end-color: transparent;\n    inset-block-start: 0;\n    inset-inline-start: 50px;\n  }\n  span {\n    inset-inline-start: 0px;\n    inset-block-start: 24px;\n    transform: rotate(45deg);\n  }\n}\n.ribbone-warning-right {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-end: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $warning;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $warning;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-end-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $warning;\n      height: 6px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 50px;\n      border-start-end-radius: 0;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 3px;\n      background: $warning;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-danger-right {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-end: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $danger;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-end-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $danger;\n      height: 6px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 50px;\n      border-start-end-radius: 0;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 3px;\n      background: $danger;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-success-left {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $success;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-start-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $success;\n      height: 6px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 0;\n      border-start-end-radius: 50px;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 3px;\n      background: $success;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-info-left {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $info;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $info;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-start-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $info;\n      height: 6px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 0;\n      border-start-end-radius: 50px;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 3px;\n      background: $info;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-success-left {\n  position: absolute;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-start: 0;\n    border-inline-start: 18px solid $success;\n    border-inline-end: 18px solid $success;\n    border-block-end: 10px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 13px;\n    line-height: 1;\n    padding: 12px 3px 20px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-danger-left {\n  position: absolute;\n  inset-inline-start: 10px;\n  color: $white;\n  width: 30px;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-start: 0;\n    border-inline-start: 15px solid $danger;\n    border-inline-end: 15px solid $danger;\n    border-block-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: 12px;\n    line-height: 1;\n    padding: 12px 0px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-secondary-right {\n  position: absolute;\n  inset-inline-end: 10px;\n  color: $white;\n  width: 30px;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-end: 0;\n    border-inline-start: 15px solid $secondary;\n    border-inline-end: 15px solid $secondary;\n    border-block-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $secondary;\n    font-size: 11px;\n    line-height: 1;\n    padding: 12px 0px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-sideleft-ribbone-success-left {\n  position: absolute;\n  inset-block-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-block-start: 0;\n    inset-inline-end: -8px;\n    border-block-start: 13px solid $success;\n    border-block-end: 13px solid $success;\n    border-inline-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 11px;\n    padding: 5px 13px;\n    z-index: 6;\n    height: 26px;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-sideright-ribbone-primary-right {\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-end: 0;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-block-start: 0;\n    inset-inline-start: -8px;\n    border-block-start: 13px solid $primary;\n    border-block-end: 13px solid $primary;\n    border-inline-start: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $primary;\n    font-size: 11px;\n    padding: 5px 13px;\n    z-index: 6;\n    height: 26px;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-1 {\n  span {\n    &:after {\n      position: absolute;\n      content: \"\";\n    }\n  }\n}\n.arrow-ribbone-2 {\n  color: $white;\n  padding: 3px 8px;\n  position: absolute;\n  z-index: 6;\n  font-size: $font-size-20;\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -24px;\n    border-block-start: 16px solid transparent;\n    border-inline-start: 24px solid $purple;\n    border-block-end: 16px solid transparent;\n    width: 0;\n  }\n}\n.ribbone-card {\n  overflow: hidden;\n}\n.fullwidth-primary-ribbons {\n  .bar {\n    color: $white;\n    background-color: $primary;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-color: $primary $primary $primary transparent;\n        border-block-start-color: $primary;\n        border-inline-end-color: $primary;\n        border-block-end-color: $primary;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $primary;\n        border-inline-end-color: transparent;\n        border-block-end-color: $primary;\n        border-inline-start-color: $primary;\n        inset-inline-end: -30px;\n      }\n    }\n  }\n}\n.fullwidth-secondary-ribbons {\n  .bar {\n    color: $white;\n    background-color: $secondary;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $secondary;\n        border-inline-end-color: $secondary;\n        border-block-end-color: $secondary;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $secondary;\n        border-inline-end-color: transparent;\n        border-block-end-color: $secondary;\n        border-inline-start-color: $secondary;\n        inset-inline-end: -30px;\n      }\n    }\n  }\n}\n.fullwidth-arrow-warning-ribbons {\n  .bar {\n    color: $white;\n    background-color: $warning;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $warning;\n        border-inline-end-color: $warning;\n        border-block-end-color: $warning;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start: 18px solid transparent;\n        border-inline-start: 18px solid $warning;\n        border-block-end: 18px solid transparent;\n        border-inline-end: transparent;\n        inset-inline-end: -20px;\n        inset-block-start: -2px;\n      }\n    }\n  }\n}\n.fullwidth-arrow-danger-ribbons-right {\n  .bar {\n    color: $white;\n    background-color: $danger;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $danger;\n        border-inline-end-color: transparent;\n        border-block-end-color: $danger;\n        border-inline-start-color: $danger;\n        inset-inline-end: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start: 18px solid transparent;\n        border-inline-end: 18px solid $danger;\n        border-block-end: 18px solid transparent;\n        border-inline-start: transparent;\n        inset-inline-start: -20px;\n        inset-block-start: -2px;\n      }\n    }\n  }\n}\n.power-ribbone {\n  span {\n    svg {\n      width: 15px;\n      height: 15px;\n    }\n  }\n}\n.ribbone-card {\n  .card-body {\n    padding: 25px;\n  }\n}\n.ribbone-row {\n  .feather-zap {\n    width: 15px;\n    height: 15px;\n  }\n}\n[data-bs-toggle=\"card-fullscreen\"] {\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n} \n[data-bs-toggle=\"card-remove\"] {\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n} \nsvg {\n  &.collapse-open,&.collapse-close {\n    width: 15px;\n    height: 15px;\n  }\n}\n.btn-icon {\n  &.btn-danger-light {\n    color: $danger-900;\n    background: $danger-100;\n  }\n}\n.live-rating {\n  &.badge {\n    background: $success-200;\n    color: $success-900;\n  }\n}\n@media (min-width: 576px) {\n  .mx-sm-7 {\n    margin-inline: 3rem !important;\n  }\n}\n[dir=\"rtl\"] {\n  .power-ribbone-top-left span {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-top-left span i {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-bottom-left span {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-bottom-left span i {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-top-right span {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-top-right span i {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-bottom-right span {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-bottom-right span i {\n    transform: rotate(-45deg);\n  }\n\n  .ribbone-top-left span {\n    transform: rotate(45deg);\n  }\n\n  .ribbone-top-right span {\n    transform: rotate(-45deg);\n  }\n\n  .ribbon-price .badge {\n    transform: rotate(-45deg);\n  }\n}\n",".modal-barcode {\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li {\n            @include rounded(7px);\n            width: 25%;\n            margin-bottom: 10px;\n            padding: 0 5px;\n            @include respond-below(custom991) {\n                width: 50%;\n            }\n            a {\n                border: 1px solid $gray-400;\n                @include rounded(10px);\n                display: block;\n                padding: 10px;\n                text-align: center;\n            }\n        }\n    }\n}\n\n.modal {\n    .modal-content {\n        border: 1px solid $light-900;\n        box-shadow: 0px 4px 74px 0px #D0D0D040;\n        border-radius: 5px;\n    }\n    .modal-title {\n        font-weight: $font-weight-bold;\n        @include respond-below(custom991) {\n            font-size: $font-size-16;\n        }\n    }\n\t.logo-lg {\n\t\timg {\n\t\t\twidth: 150px;\n\t\t}\n\t}\n    .modal-header {\n        border-color: $light-900;        \n        border-bottom: 1px solid $light-900;\n        justify-content: space-between;\n        .close,\n        .btn-close {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            color: $danger-700;\n            opacity: 1;\n            font-size: $font-size-12;\n            width: 22px;\n            height: 22px;\n            border: 0;\n            font-weight: $font-weight-bold;\n            background-color: transparent;\n            @include rounded(50px);\n            &:hover{\n                background-color: transparent;\n                color:$white;\n            }\n        }\n    }\n    .modal-footer{\n        .btn-print {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $primary;\n            color: $primary;\n            img{\n                margin-left: 10px;\n            }\n            &:hover{\n                background: $primary;\n                color: $white;\n                img{\n                    filter: brightness(0) invert(1);\n                }\n            }\n        }\n        .btn-secondary{\n            background: $secondary;\n            &:hover{\n                @include box-shadow(inset, 0, 0px, 0px, 100px, $white);\n                color: $secondary !important;\n            }\n        }\n    }\n    \n    .modal-dialog.right-slider-modal {\n        margin: 0;\n        margin-left: auto;\n        max-width: 1102px;\n    }\n    \n    .modal-dialog.add-centered {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        max-width: 1192px;\n    }\n    .modal-dialog.sales-details-modal {\n        max-width: 1192px;\n    }\n    .modal-dialog.edit-sales-modal {\n        max-width: 1192px;\n    }\n    .edit-add.card.edit-expense {\n        border: 1px solid rgba(0,0,0,.2);\n    }\n    .note-editor.note-frame.card {\n        border: 1px solid rgba(0,0,0,.2) !important; \n    }\n}\n.offcanvas.offcanvas-end {\n    width: auto !important;\n}\n.offcanvas.offcanvas-end.em-payrol-add {\n    max-width: 1192px !important;\n}\n\n.modal {\n    &.animated .modal-dialog {\n        transform: translate(0, 0);\n    }\n    &.effect-scale {\n        .modal-dialog {\n            transform: scale(0.7);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1);\n            opacity: 1;\n        }\n    }\n    &.effect-slide-in-right {\n        .modal-dialog {\n            transform: translateX(20%);\n            opacity: 0;\n            transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);\n        }\n        &.show .modal-dialog {\n            transform: translateX(0);\n            opacity: 1;\n        }\n    }\n    &.effect-slide-in-bottom {\n        .modal-dialog {\n            transform: translateY(20%);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: translateY(0);\n            opacity: 1;\n        }\n    }\n    &.effect-newspaper {\n        .modal-dialog {\n            transform: scale(0) rotate(720deg);\n            opacity: 0;\n        }\n        &.show~.modal-backdrop, .modal-dialog {\n            transition: all 0.5s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1) rotate(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-fall {\n        -webkit-perspective: 1300px;\n        -moz-perspective: 1300px;\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateZ(600px) rotateX(20deg);\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transition: all 0.3s ease-in;\n            transform: translateZ(0px) rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-flip-horizontal {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateY(-70deg);\n            transition: all 0.3s;\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transform: rotateY(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-flip-vertical {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateX(-70deg);\n            transition: all 0.3s;\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transform: rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-super-scaled {\n        .modal-dialog {\n            transform: scale(2);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1);\n            opacity: 1;\n        }\n    }\n    &.effect-sign {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateX(-60deg);\n            transform-origin: 50% 0;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-rotate-bottom {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateY(100%) rotateX(90deg);\n            transform-origin: 0 100%;\n            opacity: 0;\n            transition: all 0.3s ease-out;\n        }\n        &.show .modal-dialog {\n            transform: translateY(0%) rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-rotate-left {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateZ(100px) translateX(-30%) rotateY(90deg);\n            transform-origin: 0 100%;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: translateZ(0px) translateX(0%) rotateY(0deg);\n            opacity: 1;\n        }\n    }\n}\n.offcanvas-end.offcanvas-large {\n    width: 700px !important;\n}\n.modal {\n    z-index: 1050 !important;\n}\n.modal-backdrop {\n    z-index: 1001 !important;\n}\n.status-toggle {\n    &.small-toggle-btn {\n        float: unset;\n        .label-text {\n            color: $text-color;\n            font-size: $font-size-14;\n            font-weight: $font-weight-normal;\n        }\n        .checktoggle {\n            width: 24px;\n            height: 12px;\n            &:after {\n                width: 8px;\n                height: 8px;\n            }\n        }\n        .check {\n            &:checked{\n                & + .checktoggle {\n                    &:after {\n                        right: 0;\n                        width: 8px;\n                        height: 8px;\n                    }\n                }\n            }\n           \n        }\n    }\n    .check {\n        display: block;\n        height: 0;\n        visibility: hidden;\n        opacity: 0;\n        pointer-events: none;\n        position: absolute;\n        margin: 0;\n        padding: 0;\n        &:checked + .checktoggle:after {\n            left: 100%;\n            transform: translate(calc(-100% - 3px), -50%);\n             right: 0;\n            width: 10px;\n            height: 10px;\n        }\n        &:checked + .checktoggle {\n            background: #1ABE17;\n        }\n    }\n   .checktoggle {\n        background: #CDCDCD;\n        cursor: pointer;\n        display: block;\n        font-size: 0;\n        margin-bottom: 0;\n        position: relative;\n        border-radius: 12px;\n        width: 30px;\n        height: 14px;\n        &:after {\n            content: \" \";\n            display: block;\n            width: 10px;\n            height: 10px;\n            background-color: #FFF;\n            -webkit-transition: all 0.2s ease;\n            -ms-transition: all 0.2s ease;\n            transition: all 0.2s ease;\n            transform: translate(3px, -50%);\n            -webkit-transform: translate(3px, -50%);\n            -ms-transform: translate(3px, -50%);\n            position: absolute;\n            top: 50%;\n            left: 0;\n            border-radius: 50%;\n        }\n    }\n}\n.modal-btn {\n    .btn {\n        @include margin-padding(0 10px 0 0, 7px 15px);\n        &:last-child {\n            margin-right: 0;\n        }\n    } \n}\n.custom-modal {\n    .modal-header {        \n        .btn-close {\n            @include margin-padding(0, 0);\n            background: $white;\n            border: 1px solid $light-900;\n            border-radius: 50%;\n            color: $gray-400;\n            font-weight: $font-weight-normal;\n            font-size: $font-size-14;\n            box-shadow: 0px 4px 4px 0px #DBDBDB40;\n            height: 26px;\n            width: 26px;\n            display: flex;\n            display: -webkit-flex;\n            align-items: center;\n            -webkit-align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -webkit-transition: all 0.7s;\n            -moz-transition: all 0.7s;\n            -o-transition: all 0.7s;\n            transition: all 0.7s;\n            &:hover {\n                border: 1px solid $primary;\n                background: $primary;\n                color: $white;\n                -webkit-transition: all 0.7s;\n                -moz-transition: all 0.7s;\n                -o-transition: all 0.7s;\n                transition: all 0.7s;\n                -webkit-transform: rotateZ(360deg);\n                -moz-transform: rotateZ(360deg);\n                transform: rotateZ(360deg);\n            }    \n        }\n    }\n\n}",".grid-showcase {\n  margin-bottom: -10px;\n  span, .grid-wrapper {\n    display: block;\n    padding: 10px;\n    margin-bottom: 10px;\n    text-align: center;\n    background-color: rgba(242, 243, 247, 0.7);\n  }\n}\n.grid-align {\n  margin-bottom: -16px;\n}\n.grid-align .row {\n  padding: 15px 0;\n  min-height: 7rem;\n  margin-bottom: 16px;\n}\n.grid-vertical {\n  min-height: 150px;\n  padding: 10px;\n  color: $black;\n}\ntable.table-bordered thead tr th p {\n  margin-bottom: 0;\n}","body {\n\tfont-family: $font-family-primary;\n\tfont-size: $font-size-14;\n\tcolor: $text-color;\n\tline-height: 1.5;\n\tbackground-color: $body-bg;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\nhtml{\n\tfont-family: $font-family-primary;\t\n}\n::selection {\n  background: $primary;\n  color: $white;\n  text-shadow: none;\n}\nimg {\n\tmax-width: 100%;\n\theight: auto;\n\tvertical-align: inherit;\n}\n*{\n\toutline: none;\n}\nbutton {\n\t@include transition(all 0.5s ease);\n\t&:focus {\n\t\tbox-shadow: none !important;\n\t}\n}\np {\n\tmargin-bottom:20px;\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\nstrong {\n\tfont-weight: $font-weight-bold;\n}\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n  \tcolor: $title-color;\n  \tfont-family: $font-family-primary;\n\tfont-weight: $font-weight-bold;\n  \tmargin-bottom: 0;\n}\nol, ul {\n  list-style: none;\n  margin-block-end: 0;\n  padding: 0;\n}\nul {\n  list-style: none;\n\t&.list-disc {\n\t  list-style: disc;\n\t  padding-left: 15px;\n\t  ul {\n\t    list-style-type: circle;\n\t  }\n\t}\n\t&.list-decimal {\n\t  list-style: decimal;\n\t  padding-left: 15px;\n\t  ul{\n\t    list-style-type: decimal;\n\t  }\n\t}\n\t&.list-icon {\n\t  list-style: none;\n\t  padding-left: 0;\n\t  > li {\n\t    padding-left: 1.875rem;\n\t    counter-increment: li;\n\t    i,\n\t    .feather-icon,\n\t    .svg-icon {\n\t      display: inline-block;\n\t      height: 20px;\n\t      width: 20px;\n\t      text-align: center;\n\t      margin-left: -1.25rem;\n\t      position: relative;\n\t      left: -10px;\n\t      padding: 1px;\n\t      top: -1px;\n\t      \n\t    }\n\t    i {\n\t      font-size: $font-size-20;\n\t      top: 5px;\n\t    }\n\t  }\n\t}\n\t.btn {\n\t  &-primary {\n\t      &:not(:disabled):not(.disabled) {\n\t          &:active,\n\t          &.active {\n\t              &:focus {\n\t                  box-shadow: none;\n\t              \t}\n\t          \t}\n\t      \t}\n\t  \t}\n\t}\n}\n",".bg-primary {\n    background-color: $primary !important;\n}\n.bg-secondary {\n    background-color: $secondary !important;\n}\n.bg-info {\n    background-color: $info !important;\n}\n.bg-success {\n    background-color: $success !important;\n    color: $white !important;\n}\n.bg-warning {\n    background-color: $warning !important;\n    color: $white !important;\n}\n.bg-danger {\n    background-color: $danger !important;\n    color: $white !important;\n}\n.bg-dark {\n    background-color: $dark !important;\n}\n.bg-light {\n    background-color: $light !important;\n}\n.bg-light-300 {\n    background-color: $light-300 !important;\n}\n.bg-light-400 {\n    background: $light-400;\n}\n.bg-light-600 {\n    background-color: $light-600 !important;\n}\n.bg-white {\n    background-color: $white !important;\n}\n.bg-pink {\n    background-color: $pink !important;\n}\n.bg-purple {\n    background-color: $purple !important;\n}\n.bg-teal {\n    background-color: $teal !important;\n}\n.bg-blue {\n    background-color: $blue !important;\n}\n.bg-tertiary {\n    background-color: $tertiary !important;\n}\n.bg-violet {\n    background-color: $violet !important;\n}\n.bg-green {\n    background-color: $green !important;\n}\n.bg-gray {\n    background: $background-3;\n}\n.bg-darkgreen {\n    background-color: $dark-green !important;\n}\n.bg-nightblue {\n    background-color: $night-blue !important;\n}\n.bg-royalblue {\n    background-color: $royal-blue !important;\n}\n.bg-darkgray {\n    background-color: $dark-gray !important;\n}\n.bg-indigo {\n    background-color: $indigo !important;\n}\n.bg-primary {\n    background-color: $primary !important;\n    &.bg-opacity-10 {\n        background-color: rgba($primary,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($primary,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($primary,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($primary,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($primary,1) !important;\n    }\n}\n.bg-secondary {\n    background-color: $secondary !important;\n    &.bg-opacity-10 {\n        background-color: rgba($secondary,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($secondary,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($secondary,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($secondary,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($secondary,1) !important;\n    }\n}\n.bg-info {\n    background-color: $info !important;\n    &.bg-opacity-10 {\n        background-color: rgba($info,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($info,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($info,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($info,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($info,1) !important;\n    }\n}\n.bg-success {\n    background-color: $success !important;\n    &.bg-opacity-10 {\n        background-color: rgba($success,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($success,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($success,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($success,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($success,1) !important;\n    }\n}\n.bg-warning {\n    background-color: $warning !important;\n    &.bg-opacity-10 {\n        background-color: rgba($warning,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($warning,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($warning,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($warning,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($warning,1) !important;\n    }\n}\n.bg-danger {\n    background-color: $danger !important;\n    &.bg-opacity-10 {\n        background-color: rgba($danger,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($danger,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($danger,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($danger,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($danger,1) !important;\n    }\n}\n.bg-dark {\n    background-color: $dark !important;\n    &.bg-opacity-10 {\n        background-color: rgba($dark,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($dark,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($dark,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($dark,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($dark,1) !important;\n    }\n}\n.bg-light {\n    background-color: $light !important;\n    &.bg-opacity-10 {\n        background-color: rgba($light,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($light,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($light,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($light,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($light,1) !important;\n    }\n}\n@each $color,\n$value in $theme-colors {\n    .bg-#{$color} {\n        background-color: #{$value} !important;\n        border: 1px solid #{$value} !important;\n        color: $white;\n    }\n}\n.bg-soft-primary {\n    background-color: $primary-300;\n    color: $primary;\n}\n.bg-soft-secondary {\n    background-color: $secondary-300;\n    color: $secondary;\n}\n.bg-soft-success {\n    background-color: $success-300;\n    color: $success;\n}\n.bg-soft-danger {\n    background-color: $danger-300;\n    color: $danger;\n}\n.bg-soft-warning {\n    background-color: $warning-300;\n    color: $warning;\n}\n.bg-soft-info {\n    background-color: rgba($info, 0.3);\n    color: $info;\n}\n.bg-soft-light {\n    background-color: rgba($light, 0.9);\n    color: $text-color;\n}\n.bg-soft-dark {\n    background-color: rgba($dark, 0.3);\n    color: $white;\n}\n.bg-light {\n  color: $text-color;\n}\n\n.bg-primary-gradient {\n  background: $primary-gradient !important;\n  color: $white;\n}\n.bg-secondary-gradient {\n  background: $secondary-gradient !important;\n  color: $white;\n}\n.bg-warning-gradient {\n  background: $warning-gradient !important;\n  color: $white;\n}\n.bg-info-gradient {\n  background: $info-gradient !important;\n  color: $white;\n}\n.bg-success-gradient {\n  background: $success-gradient !important;\n  color: $white;\n}\n.bg-danger-gradient {\n  background: $danger-gradient !important;\n  color: $white;\n}\n.bg-orange-gradient {\n  background: $orange-gradient !important;\n  color: $white;\n}\n.bg-purple-gradient {\n  background: $purple-gradient !important;\n  color: $white;\n}\n.bg-teal-gradient {\n  background: $teal-gradient !important;\n  color: $white;\n}\n.bg-light-gradient {\n  background: $light-gradient !important;\n  color: $black;\n}\n.bg-dark-gradient {\n  background: $dark-gradient !important;\n  color: $white;\n}\n.bg-outline-primary {\n  background-color: $white;\n  border: 1px solid $primary;\n  color: $primary;\n}\n.bg-outline-secondary {\n  background-color: $white;\n  border: 1px solid $secondary;\n  color: $secondary;\n}\n.bg-outline-warning {\n  background-color: $white;\n  border: 1px solid $warning;\n  color: $warning;\n}\n.bg-outline-info {\n  background-color: $white;\n  border: 1px solid $info;\n  color: $info;\n}\n.bg-outline-success {\n  background-color: $white;\n  border: 1px solid $success;\n  color: $success;\n}\n.bg-outline-danger {\n  background-color: $white;\n  border: 1px solid $danger;\n  color: $danger;\n}\n.bg-outline-dark {\n  background-color: $white;\n  border: 1px solid $dark;\n  color: $dark;\n}\n.bg-outline-light {\n  background-color: $white;\n  border: 1px solid $light !important;\n  color: $black !important;\n}\n.bg-primary-transparent {\n    background-color: rgba($primary, 0.1) !important;\n    color: $primary !important;\n    &:hover {\n        background-color: rgba($primary, 0.1) !important;\n        color: $primary !important;\n    }\n}\n.bg-secondary-transparent {\n    background-color: rgba($secondary, 0.1) !important;\n    color: $secondary !important;\n    &:hover {\n        background-color: rgba($secondary, 0.1) !important;\n        color: $secondary !important;\n    }\n}\n.bg-info-transparent {\n    background-color: rgba($info, 0.1) !important;\n    color: $info !important;\n    &:hover {\n        background-color: rgba($info, 0.1) !important;\n        color: $info !important;\n    }\n}\n.bg-success-transparent {\n    background-color: rgba($success, 0.1) !important;\n    color: $success !important;\n    &:hover {\n        background-color: rgba($success, 0.1) !important;\n        color: $success !important;\n    }\n}\n.bg-warning-transparent {\n    background-color: rgba($warning, 0.1) !important;\n    color: $warning !important;\n    &:hover {\n        background-color: rgba($warning, 0.1) !important;\n        color: $warning !important;\n    }\n}\n.bg-danger-transparent {\n    background-color: rgba($danger, 0.1) !important;\n    color: $danger !important;\n    &:hover {\n        background-color: rgba($danger, 0.1) !important;\n        color: $danger !important;\n    }\n}\n.bg-light-transparent {\n    background-color: rgba($light, 0.5) !important;\n    color: $light !important;\n    &:hover {\n        background-color: rgba($light, 0.5) !important;\n        color: $text-color !important;\n    }\n}\n.bg-gray-100 {\n    background-color: $gray-100; \n}\n.bg-gray-200 {\n    background-color: $gray-200;\n}\n.bg-gray-300 {\n    background-color: $gray-300;\n}\n.bg-gray-400 {\n    background-color: $gray-400;\n}\n.bg-gray-500 {\n    background-color: $gray-500;\n}\n.bg-gray-600 {\n    background-color: $gray-600;\n}\n.bg-gray-700 {\n    background-color: $gray-700;\n}\n.bg-gray-800 {\n    background-color: $gray-800;\n}\n.bg-gray-900 {\n    background-color: $gray-900;\n}\n.svg-primary {\n    fill: $primary;\n}\n.svg-secondary {\n    fill: $secondary;\n}\n.svg-success {\n    fill: $success;\n}\n.svg-danger {\n    fill: $danger;\n}\n.svg-warning {\n    fill: $warning;\n}\n.svg-white {\n    fill: $white;\n}\n.svg-black {\n    fill: $black;\n}\n.svg-pink {\n    fill: $pink;\n}\n.svg-orange {\n    fill: $orange;\n}\n.svg-purple {\n    fill: $purple;\n}\n.svg-indigo {\n    fill: $indigo;\n}\n.svg-info {\n    fill: $info;\n}\n.svg-yellow {\n    fill: $yellow;\n}\n.svg-light {\n  fill: $light;\n}\n.svg-dark {\n  fill: $dark;\n}\n.svg-teal {\n  fill: $teal;\n}\n.svg-default {\n  fill: $text-color;\n}\n.color-container {\n  width: 5rem;\n  height: 5rem;\n  border-radius: $border-radius;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 3rem;\n}\n.text-container {\n  padding: 0.25rem 0.5rem;\n  border-radius: $border-radius;\n  box-shadow: $box-shadow;\n}\n.color-box {\n    width: 80px;\n    height: 80px;\n    border-radius: $border-radius;\n    margin-right: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n.bg-soft-purple {\n    background: $purple-100 !important;\n    border-color: $purple-100 !important;\n}\n.text-purple {\n    color: $purple;\n}\n.bg-light-200 {\n    background: $light-200;\n}\n.bg-light-100 {\n    background: $light-100;\n}\n.bg-danger-light {\n    background: $danger-100;\n}\n.bg-pending {\n    background: $violet !important;\n    color: $white !important;\n}\n.bg-secondary-success {\n    background: $green !important;\n}\n.bg-orange {\n    background: $orange;\n}\n.text-blue {\n    color: $purple !important;\n}\n.text-blue-light {\n    color: $indigo !important;\n}",".page-header {\n    margin-bottom: 14px;\n\n    .page-title {\n        font-weight: $font-weight-semibold;\n        margin-bottom: 10px;\n\n        @include respond-below(custom991) {\n            font-size: $font-size-18;\n        }\n\n        @include respond-below(custom767) {\n            margin-bottom: 14px;\n        }\n\n        .count-title {\n            background: #F3EDFF;\n            border-radius: 5px;\n            @include margin-padding(0 0 0 8px, 5px);\n            color: $orange;\n            font-size: $font-size-12;\n            font-weight: $font-weight-semibold;\n        }\n    }\n\n    .title-head {\n        @include respond-below(custom991) {\n            margin-top: 0;\n        }\n    }\n\n    .head-icons {\n        margin-bottom: 10px;\n\n        @include respond-below(custom991) {\n            display: none;\n        }\n\n        a {\n            width: 32px;\n            height: 32px;\n            background: $white;\n            color: $gray-900;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $light-900;\n            border-radius: 5px;\n            margin-right: 8px;\n\n            &.active,\n            &:hover {\n                background: $green;\n                color: $white;\n            }\n\n            &:last-child {\n                margin-right: 0;\n            }\n\n            @include respond-below(custom991) {\n                margin-right: 4px !important;\n\n                &:last-child {\n                    margin-right: 0 !important;\n                }\n            }\n        }\n    }\n\n    .form-sort {\n        margin-top: 0;\n    }\n}\n\n.count-available-member {\n    background: #F3EDFF;\n    border-radius: 5px;\n    @include margin-padding(0 0 0 8px, 5px);\n    color: $orange;\n    font-size: $font-size-12;\n    font-weight: $font-weight-semibold;\n}\n\n.set-star {\n    i {\n        color: $light-900;\n\n        &.filled {\n            color: $orange;\n        }\n    }\n}\n\n.rating-select {\n    &.filled {\n        i {\n            color: $orange;\n        }\n    }\n}\n\n.icon-form {\n    position: relative;\n\n    .form-icon {\n        position: absolute;\n        top: 50%;\n        left: 15px;\n        transform: translateY(-50%);\n        color: $gray-900;\n    }\n\n    .form-control {\n        @include margin-padding(null, 8px 15px 8px 35px);\n\n        &:focus {\n            @include margin-padding(null, 8px 15px 8px 35px);\n        }\n    }\n}\n\n.icon-form-end {\n    position: relative;\n\n    .form-icon {\n        position: absolute;\n        top: 50%;\n        right: 15px;\n        transform: translateY(-50%);\n        color: $gray-900;\n    }\n\n    .form-control {\n        @include margin-padding(null, 8px 34px 8px 15px);\n    }\n}\n\n.view-icons {\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    @include margin-padding(null, 2px);\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n\n    a {\n        width: 34px;\n        height: 36px;\n        background: $white;\n        color: $gray-900;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n\n        &:first-child {\n            border-radius: 5px 0 0 5px;\n        }\n\n        &:last-child {\n            border-radius: 0 5px 5px 0;\n        }\n\n        &.active,\n        &:hover {\n            background: $green;\n            color: $white;\n        }\n    }\n}\n\n.sidebar-popoverlay {\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.75);\n    top: 0;\n    left: -100%;\n    z-index: 1003;\n\n    &.open {\n        left: 0;\n    }\n}\n\n.sidebar-popoverlay-sign {\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.75);\n    top: 0;\n    left: -100%;\n    z-index: 1003;\n\n    &.open {\n        left: 0;\n    }\n}\n\n.profile-pic-upload {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 5px;\n\n    .profile-pic {\n        border: 2px dashed $light-900;\n        margin: 0 15px 10px 0;\n        width: 100px;\n        height: 100px;\n        border-radius: 5px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        position: relative;\n\n        span {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n        }\n\n        img {\n            width: 70px;\n            height: 70px;\n            border-radius: 5px;\n        }\n\n        .close-img {\n            background: $danger;\n            color: $white;\n            width: 14px;\n            height: 14px;\n            border-radius: 2px;\n            border-radius: 5px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            @include position(absolute, 10px, 10px, null, null);\n        }\n    }\n\n    .upload-content {\n        p {\n            margin-bottom: 10px;\n        }\n    }\n\n    .upload-btn {\n        background: $purple-100;\n        border-radius: 5px;\n        position: relative;\n        margin-bottom: 10px;\n        display: inline-block;\n\n        span {\n            @include margin-padding(null, 9px 12px);\n            cursor: pointer;\n            color: $purple;\n            display: inline-block;\n\n            i {\n                margin-right: 10px;\n            }\n        }\n\n        input {\n            opacity: 0;\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            z-index: 1;\n            cursor: pointer;\n        }\n    }\n}\n\n.user-accordion-item {\n    background: $white;\n    border: 1px solid #E8E8E8;\n    border-radius: 5px;\n    box-shadow: 0px 4px 74px 0px #D0D0D040;\n    margin-bottom: 15px;\n\n    .accordion-wrap {\n        @include margin-padding(null, 10px 25px 10px 10px);\n        font-weight: $font-weight-medium;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        position: relative;\n\n        span {\n            width: 36px;\n            height: 36px;\n            border-radius: 5px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-right: 8px;\n        }\n\n        &:hover {\n            color: $gray-900;\n        }\n\n        &::before {\n            content: \"\\f054\";\n            font-family: 'Font Awesome 5 Free';\n            @include position(absolute, 50%, 10px, null, null);\n            @include transform(translateY(-50%));\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n        }\n\n        &:not(.collapsed) {\n            &::before {\n                content: \"\\f078\";\n            }\n\n            span {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n\n    .content-collapse {\n        border-top: 1px solid $light-900;\n        @include margin-padding(5px 10px 10px, 15px 0 0);\n    }\n\n    .accordion-collapse {\n        .form-wrap {\n            margin-bottom: 24px;\n\n            &.mb-wrap {\n                margin-bottom: 0;\n\n                @include respond-below(custom767) {\n                    margin-bottom: 24px;\n                }\n            }\n        }\n    }\n}\n\n.submit-button {\n    .btn {\n        font-size: $font-size-14;\n        font-weight: $font-weight-semibold;\n        border-radius: $border-radius-lg;\n        @include margin-padding(0 10px 0 0, 7px 15px);\n\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n\n.radio-wrap {\n    .col-form-label {\n        padding-bottom: 12px;\n    }\n\n    .radio-btn {\n        margin-right: 15px;\n\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n\n.success-message {\n    h3 {\n        margin-bottom: 10px;\n        font-size: $font-size-20;\n    }\n\n    .del-info {\n        max-width: 300px;\n        @include margin-padding(0 auto, null);\n    }\n\n    p {\n        font-size: $font-size-16;\n        margin-bottom: 0;\n\n        @include respond-below(custom767) {\n            font-size: $font-size-14;\n        }\n    }\n\n    .modal-btn {\n        margin-top: 40px;\n    }\n}\n\n.success-popup-icon {\n    background: $danger-100;\n    color: $danger;\n    width: 65px;\n    height: 65px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 15px;\n    font-size: $font-size-42;\n\n    &.bg-light-blue {\n        background: $purple-100;\n        color: $purple;\n    }\n}\n\n.access-wrap {\n    border-radius: 5px;\n    @include margin-padding(0 0 20px, 10px);\n    box-shadow: $box-shadow-sm;\n\n    li {\n        @include margin-padding(0 0 5px, 0);\n\n        &.checkbox-checked {\n            label {\n                background: $light-300;\n            }\n        }\n\n        label {\n            width: 100%;\n            position: relative;\n            @include margin-padding(null, 5px);\n            background: transparent;\n\n            &.checkboxs {\n                .checkmarks {\n                    right: 10px;\n                    left: unset;\n                    top: 50%;\n                    transform: translatey(-50%);\n                }\n\n                input:checked~.checkmark {\n                    background: $primary;\n                    border-color: $primary;\n                }\n            }\n\n            .people-profile {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n\n                img {\n                    width: 32px;\n                    height: 32px;\n                    border-radius: 50%;\n                    margin-right: 10px;\n                }\n\n                a {\n                    color: $text-color;\n                    font-size: $font-size-14;\n                }\n            }\n        }\n\n        &:hover {\n            background-color: $light-300;\n        }\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n\n.load-btn {\n    .btn {\n        i {\n            margin-left: 4px;\n            animation: spin 3000ms linear infinite;\n        }\n    }\n}\n\n@keyframes spin {\n    to {\n        @include transform(rotate(360deg));\n    }\n}\n\n.img-select {\n    position: relative;\n\n    .select-box-img {\n        width: 24px;\n        height: 24px;\n        position: absolute;\n        top: 50%;\n        left: 10px;\n        z-index: 9999;\n    }\n\n    .select2-selection__rendered {\n        padding-left: 40px !important;\n    }\n}\n\n.users-group {\n    ul {\n        display: flex;\n        align-items: center;\n\n        li {\n            a {\n                width: 24px;\n                height: 24px;\n                border-radius: 50%;\n                border: 1px solid $white;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                line-height: normal;\n                margin-left: -11px;\n\n                img {\n                    width: 24px;\n                    height: 24px;\n                    border-radius: 50%;\n                }\n\n                &.total-group-member {\n                    background: $primary;\n                    color: $white;\n                    font-size: $font-size-10;\n                }\n\n                &:hover {\n                    position: relative;\n                }\n            }\n\n            &:first-child {\n                a {\n                    margin-left: 0;\n                }\n            }\n        }\n    }\n}\n\n.add-new {\n    color: $danger;\n}\n\n.contact-head {\n    margin-bottom: 5px;\n\n    .contact-breadcrumb {\n        margin-bottom: 5px;\n\n        li {\n            color: $text-color;\n            position: relative;\n            display: inline-block;\n            @include margin-padding(0 2px 5px 0, 0 0 0 10px);\n\n            a {\n                color: $text-color;\n\n                i {\n                    color: $primary;\n                    margin-right: 8px;\n                }\n\n                &:hover {\n                    color: $primary;\n                }\n            }\n\n            &:last-child {\n                margin-right: 0;\n            }\n\n            &:first-child {\n                padding-left: 0;\n\n                &::before {\n                    content: none;\n                }\n            }\n\n            &::before {\n                content: \"/\";\n                @include position(absolute, 0, null, null, 0);\n            }\n\n            &.before-none {\n                padding-left: 5px;\n\n                &::before {\n                    content: none;\n                }\n            }\n\n            .btn {\n                i {\n                    color: $white;\n                }\n\n                color: $white;\n\n                &:hover {\n                    color: $white;\n                }\n            }\n        }\n    }\n\n    .contact-pagination {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        margin-bottom: 10px;\n\n        p {\n            @include margin-padding(0 15px 0 0, null);\n        }\n\n        ul {\n            li {\n                display: inline-block;\n                margin-right: 5px;\n\n                a {\n                    width: 26px;\n                    height: 26px;\n                    border-radius: 50%;\n                    background: $white;\n                    color: $title-color;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n\n                    &:hover {\n                        background: $primary;\n                        color: $white;\n                    }\n                }\n\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n}\n\n.contacts-action {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    flex-wrap: wrap;\n\n    &>a {\n        margin: 0 8px 8px 0;\n\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n\n    .badge {\n        @include margin-padding(0 8px 10px 0, 7px 6px);\n        font-size: $font-size-14;\n        font-weight: $font-weight-normal;\n\n        &.badge-light {\n            background: $light-600;\n            color: $gray-400;\n        }\n\n        i {\n            margin-right: 8px;\n        }\n    }\n\n    .action-drops {\n        margin-bottom: 10px;\n\n        .dropdown-toggle {\n            font-weight: $font-weight-semibold;\n            color: $white;\n            display: inline-block;\n\n            span {\n                display: inline-block;\n                border-radius: 5px;\n                @include margin-padding(null, 4px 10px);\n                color: $white;\n            }\n        }\n    }\n\n    .dropdown-toggle {\n        margin-right: 0;\n        color: $secondary-900;\n\n        &::after {\n            content: none;\n        }\n    }\n\n    .btn {\n        border-radius: 5px;\n        padding: 6px 13px;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        font-size: $font-size-15;\n        font-weight: $font-weight-medium;\n\n        i {\n            margin-right: 5px;\n        }\n    }\n\n    .btn-icon {\n        width: 36px;\n        height: 36px;\n        border-radius: 5px;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $light-300;\n        border: 1px solid $light-300;\n        color: $title-color;\n\n        &:hover {\n            background: $primary;\n            color: $white;\n        }\n\n        &.rating {\n            border-radius: 50%;\n            background: $white;\n            border: 1px solid $light-900;\n            color: $orange;\n        }\n    }\n\n    .act-dropdown {\n        margin-bottom: 10px;\n\n        &>a {\n            width: 34px;\n            height: 34px;\n            border-radius: 5px;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            background: $white;\n            border: 1px solid $light-900;\n\n            &:hover {\n                background: $light-900;\n                color: $gray-900;\n            }\n        }\n\n        .dropdown-item {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            @include margin-padding(null, 5px);\n            border-radius: 5px;\n            color: $title-color;\n\n            i {\n                margin-right: 8px;\n            }\n\n            &:hover {\n                background: $light-300;\n                color: $title-color;\n            }\n        }\n    }\n}\n\n.basic-info li {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    font-size: $font-size-14;\n\n    span {\n        width: 26px;\n        height: 26px;\n        border-radius: 50%;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $light-300;\n        color: $title-color;\n        margin-right: 10px;\n        flex-shrink: 0;\n    }\n}\n\n.set-info {\n    li {\n        a {\n            color: $gray-400;\n\n            &:hover {\n                color: $primary;\n            }\n        }\n\n        i {\n            margin-right: 5px;\n        }\n    }\n}\n\n.other-info {\n    li {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n\n        .other-title {\n            min-width: 110px;\n            display: inline-block;\n        }\n\n        .avatar-xs {\n            width: 16px;\n            height: 16px;\n            border-radius: 5px;\n        }\n    }\n}\n\n.con-sidebar-title {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    flex-wrap: wrap;\n\n    a {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        color: $purple;\n\n        &:hover {\n            color: $primary;\n        }\n    }\n}\n\n.company-info {\n    li {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n\n        span {\n            width: 52px;\n            height: 52px;\n            border-radius: 5px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $light-900;\n            margin-right: 10px;\n        }\n\n        h6 {\n            font-size: $font-size-14;\n            font-weight: $font-weight-medium;\n            margin-bottom: 2px;\n\n        }\n\n        p {\n            font-size: $font-size-14;\n            margin-bottom: 0;\n        }\n    }\n\n    &.com-info {\n        li {\n            span {\n                width: 32px;\n                height: 32px;\n                margin-right: 8px;\n                border-radius: 50%;\n            }\n\n            p {\n                i {\n                    margin-right: 5px;\n                    color: $warning;\n                }\n            }\n        }\n    }\n}\n\n.deals-info {\n    li {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n\n        img {\n            width: 32px;\n            height: 32px;\n            border-radius: 5px;\n            margin-right: 10px;\n        }\n\n        p {\n            margin-bottom: 0;\n        }\n    }\n}\n\n.social-info {\n    li {\n        display: inline-block;\n\n        a {\n            width: 32px;\n            height: 32px;\n            border-radius: 50%;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            background: $white;\n            color: $gray-900;\n\n            &:hover {\n                background: $gray-900;\n                color: $white;\n            }\n        }\n    }\n}\n\n.tag-info {\n    li {\n        margin-right: 5px;\n        display: inline-block;\n\n        a {\n            font-size: $font-size-12;\n            font-weight: $font-weight-medium;\n            border-radius: 5px;\n            @include margin-padding(null, 5px 10px);\n            display: inline-block;\n        }\n\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n\n.star-icon {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    border: 1px solid $light-900;\n    color: $orange;\n\n    i {\n        font-size: $font-size-14;\n    }\n}\n\n.contact-nav {\n    @include respond-below(custom575) {\n        display: block;\n    }\n\n    li {\n        display: inline-block;\n        @include margin-padding(0 20px 0 0, null);\n\n        a {\n            color: $gray-400;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            font-size: $font-size-14;\n            font-weight: $font-weight-medium;\n            border-bottom: 3px solid $white;\n            text-align: center;\n            @include margin-padding(null, 5px 5px 10px 5px);\n\n            &:hover,\n            &.active {\n                color: $primary;\n                border-color: $primary;\n            }\n\n            i {\n                margin-right: 5px;\n            }\n        }\n\n        @include respond-below(custom575) {\n            display: block;\n        }\n    }\n}\n\n.form-sort {\n    position: relative;\n\n    i {\n        position: absolute;\n        z-index: 101;\n        width: 16px;\n        height: 16px;\n        top: 14px;\n        left: 7px;\n    }\n\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 99;\n    }\n}\n\n.badge-day {\n    background: $purple-100;\n    color: $purple;\n    border-radius: 5px;\n    display: inline-block;\n    font-size: $font-size-14;\n    @include margin-padding(0 0 20px, 4px 8px);\n\n    i {\n        margin-right: 5px;\n    }\n}\n\n.contact-activity {\n    ul {\n        &:last-child {\n            .activity-wrap {\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n}\n\n.upcoming-info {\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    @include margin-padding(10px 0 0, 15px 15px 5px);\n\n    p {\n        font-weight: $font-weight-medium;\n        margin-bottom: 8px;\n    }\n\n    .dropdown {\n        margin-bottom: 10px;\n\n        .dropdown-toggle {\n            color: $gray-900;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            font-size: $font-size-14;\n\n            &::after {\n                content: none;\n            }\n        }\n\n        .avatar-xs {\n            width: 16px;\n            height: 16px;\n            border-radius: 5px;\n            margin-right: 10px;\n        }\n\n        .circle {\n            font-size: 10px;\n        }\n\n        .dropdown-menu {\n            a {\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                font-size: $font-size-14;\n                color: $gray-900;\n            }\n        }\n    }\n}\n\n.notes-editor {\n    .dropdown-toggle::after {\n        content: none;\n    }\n}\n\n.note-edit-wrap {\n    display: none;\n    margin-bottom: 15px;\n}\n\n.notes-activity {\n    .note-download {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        border: 1px solid $light-900;\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\n        @include margin-padding(0 0 15px, 15px);\n        border-radius: 5px;\n\n        .note-info {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin-right: 24px;\n\n            h6 {\n                font-weight: $font-weight-medium;\n                margin-bottom: 5px;\n            }\n\n            p {\n                margin-bottom: 0;\n            }\n\n            @include respond-below(custom767) {\n                margin-right: 15px;\n            }\n        }\n\n        .note-icon {\n            width: 44px;\n            height: 44px;\n            border-radius: 5px;\n            color: $white;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-right: 8px;\n            flex-shrink: 0;\n\n            img {\n                width: 44px;\n                height: 44px;\n                border-radius: 50%;\n            }\n        }\n\n        &:hover {\n            background: $light-300;\n\n            a {\n                background: $white;\n            }\n        }\n\n        a {\n            width: 24px;\n            height: 24px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border-radius: 50%;\n            color: $title-color;\n            background: $light-300;\n        }\n\n        @include respond-below(custom767) {\n            @include margin-padding(0 0 15px, 10px);\n        }\n    }\n\n    .reply-box {\n        background: $light-200;\n        border-radius: 5px;\n        @include margin-padding(0 0 15px, 15px);\n\n        p {\n            margin-bottom: 10px;\n        }\n\n        .btn {\n            background: $white;\n            border-color: $white;\n            border-radius: 5px;\n            color: $gray-900;\n            font-size: $font-size-16;\n            font-weight: $font-weight-normal;\n            @include margin-padding(0, 5px 10px);\n\n            i {\n                margin-right: 3px;\n            }\n\n            &:hover {\n                background: $light-100;\n            }\n        }\n    }\n}\n\n.note-btns {\n    margin-top: 5px;\n\n    .btn {\n        @include margin-padding(10px 10px 0 0, 7px 15px);\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        &.btn-primary {\n            min-width: 110px;\n        }\n    }\n}\n\n.drag-attach {\n    border: 1px dashed $light-900;\n    border-radius: 5px;\n    position: relative;\n    text-align: center;\n    width: 100%;\n    overflow: hidden;\n\n    input {\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    .img-upload {\n        background: $purple-100;\n        color: $purple;\n        font-size: $font-size-14;\n        display: inline-block;\n        text-align: center;\n        @include margin-padding(24px 0, 9px 17px);\n        border-radius: 5px;\n\n        i {\n            margin-right: 10px;\n        }\n    }\n}\n\n.drag-upload {\n    background: $light-100;\n    border: 1px dashed $secondary-200;\n    border-radius: 5px;\n    position: relative;\n\n    input {\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    i {\n        font-size: $font-size-24;\n        margin-bottom: 10px;\n    }\n\n    p {\n        font-size: $font-size-14;\n        margin-bottom: 0;\n    }\n\n    .img-upload {\n        text-align: center;\n        @include margin-padding(null, 36px 20px);\n    }\n}\n\n.upload-file {\n    background: $light-200;\n    border: 1px solid $light-900;\n    @include margin-padding(0 0 5px, 15px);\n    border-radius: 5px;\n\n    h6 {\n        font-size: $font-size-14;\n        font-weight: $font-weight-medium;\n        margin-bottom: 2px;\n    }\n\n    p {\n        font-size: $font-size-14;\n        margin-bottom: 0;\n\n        &.black-text {\n            color: $gray-900;\n        }\n    }\n\n    .progress {\n        height: 3px;\n        @include margin-padding(15px 0 4px, null);\n    }\n\n    &.upload-list {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n    }\n}\n\n.form-title {\n    font-weight: $font-weight-semibold;\n    margin-bottom: 15px;\n}\n\n.sync-radio {\n    .radio-item {\n        margin-bottom: 15px;\n\n        label {\n            font-size: $font-size-14;\n        }\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n\n.signature-wrap {\n    background: $light-700;\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    @include margin-padding(0 0 15px, 15px 15px 0);\n\n    h4,\n    p {\n        margin-bottom: 15px;\n    }\n\n    h4 {\n        font-weight: $font-weight-semibold;\n\n        @include respond-below(custom767) {\n            font-size: $font-size-16;\n        }\n    }\n}\n\n.add-sign {\n    font-size: $font-size-16;\n    color: $warning;\n}\n\n.sign-item {\n    li {\n        margin-bottom: 15px;\n\n        .sign-title {\n            display: block;\n            font-weight: $font-weight-medium;\n            margin-bottom: 3px;\n        }\n    }\n}\n\n.trash-sign {\n    color: $danger;\n}\n\n.send-success {\n    border: 1px solid $success;\n    background: $success-300;\n    border-radius: 5px;\n    @include margin-padding(0 0 15px, 15px);\n\n    p {\n        color: $gray-900;\n        margin-bottom: 0;\n\n        i {\n            margin-right: 5px;\n        }\n    }\n}\n\nfieldset {\n    display: none;\n\n    &#first-field-file {\n        display: block;\n    }\n}\n\n.add-details-wizard {\n    ul {\n        display: flex;\n        align-items: center;\n        margin-bottom: 15px;\n\n        @include respond-below(custom575) {\n            flex-direction: column;\n        }\n\n        li {\n            line-height: normal;\n            background: $light-300;\n            padding: 10px 20px;\n            display: flex;\n            align-items: center;\n\n            @include respond-below(custom575) {\n                width: 100%;\n                margin-bottom: 10px;\n            }\n\n            span {\n                margin-right: 5px;\n            }\n\n            .multi-step-info {\n                h6 {\n                    margin-bottom: 0;\n                    font-weight: $font-weight-medium;\n                    font-size: $font-size-14;\n                    color: $gray-400;\n                }\n            }\n\n            &.active {\n                background: $primary;\n                color: $white;\n\n                h6 {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n.pipeline-item {\n    border: 1px solid $light-900;\n    @include margin-padding(0 0 5px, 15px 15px 5px);\n    border-radius: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    position: relative;\n\n    &::before {\n        @include position(absolute, 0, null, null, 0);\n        content: \"\";\n        width: 2px;\n        height: 100%;\n        background: $secondary;\n    }\n\n    p {\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n        margin-bottom: 10px;\n    }\n\n    .action-pipeline {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        flex-wrap: wrap;\n\n        a {\n            @include margin-padding(0 15px 10px 0, null);\n\n            i {\n                margin-right: 5px;\n            }\n\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.access-item {\n    .radio-btn {\n        margin-right: 15px;\n\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n\n.access-wrapper {\n    margin-top: 20px;\n}\n\n.access-view {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    border: 1px solid $light-900;\n    @include margin-padding(0 0 5px, 15px 15px 15px);\n    border-radius: 5px;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n\n    .access-img {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n\n        img {\n            width: 32px;\n            height: 32px;\n            border-radius: 5px;\n            margin-right: 10px;\n        }\n    }\n\n    a {\n        font-weight: $font-weight-semibold;\n        color: $danger;\n    }\n}\n\n.header-collapse {\n    .header-user {\n        display: none;\n        height: 0;\n    }\n\n    .page-wrapper {\n        padding-top: 0;\n    }\n\n    .header {\n        border-bottom: none;\n        background: transparent;\n        width: 260px;\n\n        .header-left {\n            background: white;\n        }\n    }\n\n    #collapse-header {\n        i {\n            transform: rotate(180deg);\n            -webkit-transform: rotate(180deg);\n            -ms-transform: rotate(180deg);\n        }\n    }\n}\n\n.bootstrap-datetimepicker-widget {\n    z-index: 99999;\n\n    table {\n        td {\n\n            &.active,\n            &:hover {\n                background-color: $green\n            }\n        }\n    }\n}\n\n.note-modal-backdrop {\n    z-index: 9;\n}\n\n.note-modal-footer {\n    height: 57px;\n}\n\n.table tbody tr td a {\n    &.title-name {\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n\n        &:hover {\n            color: $primary;\n            text-decoration: underline;\n        }\n    }\n}\n\n.title-name {\n    color: $gray-900;\n    font-weight: $font-weight-medium;\n}\n\n.export-list {\n    >ul {\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        flex-wrap: wrap;\n\n        @include respond-below(custom575) {\n            justify-content: start;\n        }\n    }\n}\n\n.grid-social-links {\n    a {\n        &:hover {\n            background: $primary-100 !important;\n        }\n    }\n}",".daterange-picker{\n    .form-sort{\n        margin-left: 10px;\n       input{\n            padding-left: 25px;\n            height:38px;\n       }\n       .select2-container {\n            .select2-selection.select2-selection--single {\n                height: 38px;\n                .select2-selection__rendered{\n                    line-height: 38px;\n                }\n                .select2-selection__arrow {\n                    height: 38px;\n                }\n            }\n\n        }\n    }\n}\n.card-select {\n    ul {\n        display: flex;\n        align-items: center;\n        li{\n            + li{\n                margin-left: 12px;\n                \n            }\n        }\n    }        \n}\n.view-icons {\n    float: right;\n    @include respond-below(custom767) {\n        margin-right: 0;\n    }\n    .btn{\n        background-color: $white;\n        border: 1px solid $light-900;\n        color: $secondary-800;\n        font-size: $font-size-18;\n        min-width: 40px;\n        @include margin-padding(0 5px 0 0, 7px 0 3px 0);\n        &.active {\n            color: $secondary-900;\n        }\n        @include respond-below(custom767) {\n            min-width: 37px;\n            @include margin-padding(0 5px 0 0, 5px 0 3px 0);\n        }\n    }\n}\n.page-header {\n    .view-icons {\n        @include respond-below(custom767) {\n            margin-right: 10px;\n        }\n        @include respond-below(custom575) {\n            margin-right: 0;\n        }\n    }\n}\n.title-head {\n    justify-content: end;\n    align-items: center;\n    @include respond-below(custom767) {\n        justify-content: start;\n        margin-top: 20px;\n    }\n    @include respond-below(custom575) {\n        flex-direction: column;\n        row-gap: 20px;\n        align-items: start;\n    }\n    .add-btn {\n        margin-left: 10px;\n        border-radius: 5px;\n        @include respond-below(custom575) {\n            margin-left: 0;\n        }\n    }\n    .form-sort {\n        .list-view {\n            padding: 10px 10px 10px 30px;\n            background-color: $white;\n            border: 1px solid $light-900;\n            color: $secondary-600;\n            font-size: $font-size-14;\n            text-decoration: none;\n            line-height: normal;\n        }\n    }\n}\n.daterange-picker {\n    .form-sort {\n        min-width: 200px;\n    }\n}\n.statistic-dropdown {\n    .btn-primary{\n        padding: 6px 15px;\n        height: 35px;\n    }\n}\ntd {\n    .badge-pill {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n.badge-dots {\n    width:12px; \n    height:12px;\n    border-radius: 5px;\n    margin-right:5px;\n    display: inline-flex;\n}\n.title-head {\n    .daterange-picker {\n        .form-sort {\n            height: auto;\n            min-width: 212px;\n            i {\n                left: 15px;\n                top: 9px;\n            }\n            input {\n                height: 32px;\n                min-height: 32px;\n            }\n        }\n        .bookingrange {\n            padding-left: 35px;\n        }\n    }\n}",".error-page {\n    background: $white;\n}\n.comming-shapes {\n    position: relative;\n    @include respond-below(custom991) {\n        display: none;\n    }\n    .comming-right-shape {\n        position: fixed;\n        top: 0;\n        left: 0;\n    }\n    .comming-left-shape {\n        position: fixed;\n        bottom: -5px;\n        right: 0;\n    }\n    img {\n        width: 500px;\n    }\n}\n.error-img {\n    max-width: 500px;\n }",".account-page {\n    background: $white;\n}\n.form-wrap {\n    .form-wrap-icon {\n        position: relative;\n        i {\n            font-size: $font-size-18;\n            @include position(absolute,50%,15px,null,null);\n            transform: translateY(-50%);\n        }\n    }\n}\n.form-wrap-checkbox {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 20px;\n    .check {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        cursor: pointer;\n        color: $gray-900;\n        margin-bottom: 0;\n        input {\n            display: none;\n            &:checked + .box {\n                background: $secondary;\n                &:after {\n                    top: 0;\n                }\n            }\n        }\n        .box {\n            width: 20px;\n            height: 20px;\n            display: block;\n            margin-right: 8px;\n            transition: all 1.1s cubic-bezier(.19,1,.22,1);\n            background: $light-200;\n            position: relative;\n            overflow: hidden;\n            cursor: pointer;\n            border: 1px solid $light-900;\n            border-radius: $border-radius-lg;\n            &:after {\n                width: 12px;\n                height: 6px;\n                content: \"\";\n                position: absolute;\n                border-left: 2px solid;\n                border-bottom: 2px solid;\n                border-color: $white;\n                transform: rotate(-45deg) translate3d(0, 0, 0);\n                transform-origin: center center;\n                transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);\n                left: 0;\n                right: 0;\n                top: 200%;\n                bottom: 3px;\n                margin: auto;\n            }\n        }\n    }\n}\n.hover-a {\n    position: relative;\n    color: $purple;\n    &:after {\n        content:\"\";\n        height: 2px;\n        width: 100%;\n        background: $purple;\n        @include transform(scale(0));\n        @include transition(all 0.3s ease);\n        @include position(absolute,null,null,-3px,0);\n    }\n    &:hover:after {\n        @include transform(scale(1));\n    }\n    &:hover {\n        color: $purple;\n    }\n}\n.account-bg-01 {\n    background-image: url(../../../../public/assets/img/authentication/Login_cover.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n.account-bg-02 {\n    background-image: url(../../../../public/assets/img/authentication/register-bg.jpg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n.account-bg-03 {\n    background-image: url(../../../../public/assets/img/authentication/forgot-bg.jpg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n.account-bg-04 {\n    background-image: url(../../../../public/assets/img/authentication/reset-bg.jpg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n.link-hover {\n    position: relative;\n    color: $primary;\n    font-weight: $font-weight-medium;\n    &:after {\n        content:\"\";\n        height: 2px;\n        width: 100%;\n        background: $primary;\n        @include transform(scale(0));\n        @include transition(all 0.3s ease);\n        @include position(absolute,null,null,-3px,0);\n    }\n    &:hover:after {\n        @include transform(scale(1));\n    }\n    &:hover {\n        color: $primary !important;\n    }\n}\n.bg-backdrop {\n    background: #FFFFFFF2;\n    backdrop-filter: blur(10px);\n    @include respond-below(custom767) {\n        width: 100% !important;\n    }\n}\n.form-set-login.or-text {\n    max-width: 365px;\n     margin: auto;\n}\n.toggle-password {\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    color: $gray-900;\n    font-size: $font-size-18;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    @include rounded(50%);\n    @include transform(translateY(-50%));\n    @include position(absolute,50%,10px,null,null);\n    &:hover{\n        color: $primary;\n    }\n}\n.toggle-passwords {\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    color: $gray-900;\n    font-size: $font-size-18;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    @include rounded(50%);\n    @include transform(translateY(-50%));\n    @include position(absolute,50%,10px,null,null);\n    &:hover{\n        color:$primary;\n    }\n}\n.toggle-password-new {\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    color: $gray-900;\n    font-size: $font-size-18;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    @include rounded(50%);\n    @include transform(translateY(-50%));\n    @include position(absolute,50%,10px,null,null);\n    &:hover{\n        color:$primary;\n    }\n}\n.pass-group {\n    position: relative;\n    font-size: $font-size-base;\n}\n.form-set-login {\n    text-align: center;\n    position: relative;\n    color: $sub-title;\n    font-size: $font-size-base;\n    font-weight: $font-weight-normal;\n    margin-bottom: 23px;\n    h4 {\n        position: relative;\n        font-size: $font-size-base;\n        color: $text-color;\n        font-weight: $font-weight-bold;\n        &:after{\n            content: \"\";\n            background: $sub-title;\n            width:21px;\n            height: 1px;\n            @include position(absolute,10px,null,null,200px);\n            @include respond-below(custom991) {\n                height: 0px;\n            }\n        }\n        &:before{\n            content: \"\";\n            background:$sub-title;\n            width:21px;\n            height: 1px;\n            @include position(absolute,10px,200px,null,null);\n            @include respond-below(custom991) {\n                height: 0px;\n            }\n        }\n    }\n}\n.mw-450 {\n    max-width: 450px;\n}\n.wh-85 {\n    width: 85px;\n    height: 85px;\n    @include respond-below(custom575) {\n        width: 50px;\n        height: 50px;\n    }\n}\n.login-shapes {\n    position: relative;\n    @include respond-below(custom991) {\n        display: none;\n    }\n    .login-right-shape {\n        position: fixed;\n        top: 0;\n        left: 0;\n    }\n    .login-left-shape {\n        position: fixed;\n        bottom: 0;\n        right: 0;\n        line-height: 0;\n    }\n}",".settings-sidebar {\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-semibold;\n        margin-bottom: 24px;\n        @include respond-below(custom767) {\n            font-size: $font-size-16;\n             margin-bottom: 15px;\n        }\n    }\n    a {\n        color: $gray-400;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        border-radius: $border-radius-lg;\n        padding: 10px;\n        width: 100%;\n        position: relative;\n        &.active {\n            background: $light-300;\n            color: $gray-900;\n            &:before {\n                position: absolute;\n                content: '\\f054';\n                font-family: 'FontAwesome';\n                font-size: $font-size-12;\n                top: 50%;\n                transform: translateY(-50%);\n                right: 10px;\n            }\n        }\n        &:hover {\n            color: $gray-900;  \n        }\n    }\n}\n.profile-upload {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    .profile-upload-img {\n        width: 100px;\n        min-width: 100px;\n        height: 100px;\n        position: relative;\n        margin-right: 15px;\n        border-radius: $border-radius-lg;\n        border: 2px dashed $light-900;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        span {\n            color: $gray-400;\n            position: absolute;\n        }\n    }\n    .profile-upload-content {\n        .profile-upload-btn {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            position: relative;\n            overflow: hidden;\n            color: $purple;\n            background: $purple-100;\n            border: 1px solid $purple-100;\n            border-radius: $border-radius-lg;\n            padding: 8px 10px;\n            margin-bottom: 15px;\n            cursor: pointer;\n            transition: all 0.5s;\n            &:hover {\n                color: $white;\n                background: $purple;\n                border: 1px solid $purple;\n                transition: all 0.5s;\n            }\n            i {\n                font-size: $font-size-16;\n                margin-right: 8px;\n            }\n            input[type=\"file\"] {\n                position: absolute;\n                top: 0;\n                right: 0;\n                min-width: 100%;\n                min-height: 100%;\n                text-align: right;\n                filter: alpha(opacity = 0);\n                opacity: 0;\n                outline: none;\n                cursor: inherit;\n                display: block;\n            }\n        }\n        p {\n            font-weight: $font-weight-medium;\n            color: $gray-400;\n        }\n    }\n    .preview1 {\n        display: none;\n    }\n    .it {\n        width: 70px;\n        height: 70px;\n        border-radius: $border-radius-lg;\n        display: block;\n        position: relative;\n        background: $white;\n        object-fit: cover;\n    }\n    .profile-remove {\n        display: none;\n    }\n    .profile-remove-btn {\n        width: 14px;\n        height: 14px;\n        font-size: $font-size-10;\n        color: $white;\n        background: $danger;\n        border: 1px solid $danger;\n        border-radius: $border-radius-lg;\n        padding: 0;\n        display: inline-block;\n        position: absolute;\n        top: 8px;\n        right: 8px;\n    }\n    .profile-remove-btn:hover {\n        background: $danger-hover;\n        border: 1px solid $danger-hover;\n    }\n}\n.notificaion-table {\n    .table {\n        thead {\n            tr {                \n                &:first-child {\n                    th {\n                        padding-top: 0;\n                    }\n                }\n                th {\n                    font-size: $font-size-16;\n                    padding: 10px;\n                }\n            }\n        }\n        tbody {\n            tr {\n                td {\n                    font-weight: $font-weight-medium;\n                    color: $gray-900;\n                    padding: 10px;\n                }\n                &:last-child {\n                    td {\n                        padding-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n}\n.mod-toggle {\n    .status-toggle {\n        margin-right: 20px;\n    }\n}\n.btn-add {\n    width: 32px;\n    height: 32px;\n    background: $white;\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: $gray-900;\n    &:hover {\n        background: $green;\n        color: $white;\n    }\n}\n.settings-form {\n    .setting-title {\n        margin-bottom: 15px;\n        h6 {\n            font-size: $font-size-14;\n            font-weight: $font-weight-medium;\n        }\n        p {\n            font-size: $font-size-12;\n        }\n    }\n    .form-wrap {\n        margin-bottom: 15px;\n    }\n    .submit-button {\n        margin-top: 14px;\n    }\n}\n.bank-box {\n    background: $light-200;\n    border-radius: 5px;\n    border: 1px solid $light-200;\n    position: relative;\n    @include margin-padding(0 0 24px, 40px);\n    @include respond-below(custom991) {\n        @include margin-padding(0 0 24px, 20px);\n    }\n    &.active {\n        border-color: $success;\n        &::after {\n            position: absolute;\n            top: -8px;\n            right: -8px;\n            content: \"\\f058\";\n            font-family: \"Font Awesome 5 Free\";\n            font-weight: 900;\n            color: $success-900;\n            width: 22px;\n            height: 22px;\n            border-radius: 50%;\n            background-color: $white;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n    .table-action {\n        .action-icon {\n            background-color: transparent;\n            &:hover {\n                background-color: $light-300;\n            }\n        }\n    }\n}\n.inv-days {\n    .select2-container {\n        min-width: 62px !important;\n    }\n    p {\n        color: $black;\n        margin-left: 10px;\n    }\n}\n.lang-type {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    li {\n        margin-right: 5px;\n        a {\n            background-color: $light-300;\n            @include rounded(5px);\n            color: $gray-400;\n            font-weight: $font-weight-medium;\n            @include margin-padding(null, 8px 15px);\n            display: inline-block;\n            &:hover {\n                background-color: $green;\n                color: $white !important;\n            }\n        }\n    }\n}\n.theme-type-images {\n    flex-wrap: wrap;\n    .theme-image {\n        background: $white;\n        border-radius: 5px;\n        border: 1px solid $light-900;\n        padding: 10px;\n        margin: 0 24px 15px 0;\n        text-align: center;\n        img {\n            width: 150px;\n             @include respond-below(custom1399) {\n               width: 130px;      \n            }\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n        span {\n            font-weight: $font-weight-medium;\n            font-size: $font-size-14;\n            color: $gray-900;\n            margin-top: 10px;\n            display: block;\n        }\n        &.active {\n            border-color: $primary;\n            span {\n                color: $primary;\n            }\n        }\n    }\n}\n.theme-colors {\n    ul {\n        display: flex;\n        align-items: center;\n        li {\n            margin-right: 10px;\n            span {\n                width: 30px;\n                height: 30px;\n                border-radius: 50%;\n                background-color: $primary;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                cursor: pointer;\n                position: relative;\n                &.active {\n                    background-color: $primary-100;\n                    &:after {\n                        content: \"\";\n                        width: 25px;\n                        height: 25px;\n                        background-color: $primary;\n                        border-radius: 50%;\n                        opacity: 1;\n                    }\n                }\n                &.theme-secondary {\n                    background-color: $secondary;\n                    &.active {\n                        background-color: $secondary-100;\n                        &:after {\n                            background-color: $secondary;\n                        }\n                    }\n                }\n                &.theme-violet {\n                    background-color: $tertiary;\n                    &.active {\n                        background-color: rgba($tertiary, 0.1);\n                        &:after {\n                            background-color: $tertiary;\n                        }\n                    }\n                }\n                &.theme-blue {\n                    background-color: $indigo;\n                    &.active {\n                        background-color: $indigo-100;\n                        &:after {\n                            background-color: $indigo;\n                        }\n                    }\n                }\n                &.theme-brown {\n                    background-color: $purple;\n                    &.active {\n                        background-color: $purple-100;\n                        &:after {\n                            background-color: $purple;\n                        }\n                    }\n                }\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n}\n.lang-wrap {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n}\n.lang-flag {\n    margin-right: 15px;\n    a {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        border: 1px solid $light-900;\n        @include rounded(8px);\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n        @include margin-padding(null, 8px 8px);\n        img {\n            margin-right: 8px;\n            @include rounded(50%);\n            width: 20px;\n            height: 20px;\n        }\n    }\n}\n.lang-direct { \n    li {\n        @include margin-padding(0 8px 0 0, null);\n        a {\n            background-color: $gray-200;\n            color: $gray-900;\n            @include rounded(5px);\n            @include margin-padding(null, 8px 15px);\n            display: inline-block;\n            &:hover, &.active {\n                background-color: $tertiary;\n                color: $white;\n            }\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n.translate-wrap {\n    h6 {\n        font-weight: $font-weight-medium;\n        margin-bottom: 15px;\n    }\n    .form-wrap {\n        margin-bottom: 15px;\n    }\n    &.translate-title {\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n        }\n    }\n}\n.translate-item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center; \n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    flex-wrap: wrap;\n    margin-bottom: 24px;\n    .btn, .lang-flag  {\n        margin-bottom: 24px;\n    }\n}\n.lang-flag {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center; \n}\n.lang-progress {\n    margin-bottom: 24px;\n    p {\n        font-weight: $font-weight-medium;\n    }\n    .progress {\n        min-width: 100px;\n        max-width: 150px;\n        height: 7px;\n    }\n}\n.black-text {\n    color: $gray-900 !important;\n}\n.settings-tab {\n    .card-body {\n        padding-top: 0;\n         @include respond-below(custom767) {\n            padding-top: 16px;        \n        }\n        li {\n            a {\n                padding-top: 24px;                \n                @include respond-below(custom767) {\n                     padding-top: 8px; \n                     padding-bottom: 8px;           \n                }\n            }\n        }\n    }\n}\n.payment-img {\n    width: 80px;\n    height: 40px;\n}\n\n\n",".source-report {\n    color: #00918E;\n    font-weight: 500;\n}\n\n.dropdown {\n    &.table-action {\n        .dropdown-toggle {\n            &::after {\n                display: none;\n            }\n        }\n    }\n    .dropdown-toggle {\n        color: $gray-900;\n        border: 1px solid $light-900;\n        padding: 9px 15px;\n        border-radius: $border-radius-lg;\n        display: flex;\n        align-items: center;\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\n        &:after {\n            border-top: 0;\n            border-left: 0;\n            border-bottom: 2px solid $gray-900;\n            border-right: 2px solid $gray-900;\n            content: '';\n            display: inline-block;\n            pointer-events: none;\n            width: 8px;\n            height: 8px;\n            vertical-align: 2px;\n            @include transform-origin(66% 66%);\n            @include transition(all 0.2s ease);\n            @include transform(rotate(45deg));\n        }\n        &[aria-expanded=\"true\"]:after {\n            @include transform(rotate(-135deg));\n        }\n    }\n    .dropdown-menu {\n        padding: 10px;\n        background: $white;\n        box-shadow: $box-shadow-lg;\n        border: 1px solid $light-900;\n        .dropdown-item {\n            padding: 1px 10px;\n            color: $gray-800;\n            background: $white;\n            border-radius: $border-radius-lg;\n            &:hover {\n                color: $gray-900;\n                background: $light-300;\n            }\n        }\n    }\n}",".time-text {\n\tp {\n\t\tfont-weight: $font-weight-medium;\n\t\twhite-space: nowrap;\n\t\tmargin-left: 15px;\n\t}\n}\n.activity-title {\n\tmargin-bottom: 10px;\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\th4 {\n\t\tfont-weight: $font-weight-semibold;\n\t\t@include margin-padding(0 15px 10px 0, 0 15px 0 0);\n\t\tposition: relative;\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tbackground-color: $light-900;\n\t\t\twidth: 1px;\n\t\t\theight: 24px;\n\t\t\t@include position(absolute, 0, 0, null, null);\n\t\t\t@include respond-below(custom767) {\n\t\t\t\tcontent: none;\n\t\t\t}\n\t\t}\n\t}\n\t@include respond-below(custom767) {\n\t\tdisplay: block;\n\t}\n}\n.active-list {\n\tul {\n\t\tmargin-bottom: 10px;\n\t\tli {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-right: 10px;\n\t\t\ta {\n\t\t\t\twidth: 34px;\n\t\t\t\theight: 34px;\n\t\t\t\t@include rounded(5px);\n\t\t\t\tborder: 1px solid $light-900;\n\t            display: -webkit-inline-box;\n\t            display: -ms-inline-flexbox;\n\t            display: inline-flex;\n\t            -webkit-box-align: center;\n\t            -ms-flex-align: center;\n\t            align-items: center;\n\t            justify-content: center;\n\t            -webkit-justify-content: center;\n\t            -ms-flex-pack: center;\n\t            color: $gray-900;\n\t            &:hover, &.active {\n\t            \tbackground-color: $green;\n\t            \tborder-color: $green;\n\t            \tcolor: $white;\n\t            }\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.radio-activity {\n\t li {\n\t \tdisplay: inline-block;\n\t \t.active-type {\n\t \t\tinput[type=\"radio\"] {\n\t \t\t\tdisplay: none;\n\t \t\t\t~ label {\n\t \t\t\t\tborder: 1px solid $light-900;\n\t \t\t\t\tbox-shadow: 0px 4px 4px 0px #DBDBDB40;\n\t \t\t\t\t@include margin-padding(0 10px 5px 0, 8px 20px);\n\t \t\t\t\t@include rounded(5px);\n\t \t\t\t\tcolor: $gray-900;\n\t \t\t\t\tcursor: pointer;\n\t \t\t\t\ti {\n\t \t\t\t\t\tmargin-right: 5px;\n\t \t\t\t\t}\n\t \t\t\t}\n\t \t\t\t&:checked {\n\t \t\t\t\t~ label {\n\t \t\t\t\t\tborder-color: $green;\n\t \t\t\t\t\tcolor: $green;\n\t \t\t\t\t}\n\t \t\t\t}\n\t \t\t}\n\t \t}\n\t \t&:last-child {\n\t \t\tmargin-right: 0;\n\t \t}\n\t }\n}\n.label-add {\n\tcolor: $primary;\n\tmargin-bottom: 5px;\n\tfont-weight: $font-weight-medium;\n\ti {\n\t\tmargin-right: 8px;\n\t}\n\t&:hover {\n\t\tcolor: $primary-hover;\n\t}\n}\n.tab-activity {\n\t@include rounded(5px);\n\t@include margin-padding(0 0 20px, 15px 15px 0);\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\t\n\tul {\n\t\tli {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-right: 20px;\n\t\t\ta {\n\t\t\t\t@include margin-padding(null, 10px 5px 10px);\n\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\tborder-bottom: 4px solid $white;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tspan {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\t@include rounded(50%);\n\t \t\t\t\tborder: 1px solid $light-900;\n\t\t            display: -webkit-inline-box;\n\t\t            display: -ms-inline-flexbox;\n\t\t            display: inline-flex;\n\t\t            -webkit-box-align: center;\n\t\t            -ms-flex-align: center;\n\t\t            align-items: center;\n\t\t            justify-content: center;\n\t\t            -webkit-justify-content: center;\n\t\t            -ms-flex-pack: center;\n\t\t            margin-left: 10px;\n\t\t            color: $gray-900;\n\t\t            font-weight: $font-weight-semibold;\n\t\t            font-size: $font-size-10;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: $primary;\n\t\t\t\t\tborder-color: $primary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.comment-wrap {\n\t@include margin-padding(0 0 15px, 15px);\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\n\tborder: 1px solid $light-900;\n\t@include rounded(5px);\n\th6 {\n\t\tfont-size: $font-size-16;\n\t\tfont-weight: $font-weight-normal;\n\t\tmargin-bottom: 10px;\n\t\tcolor: $gray-400;\n\t}\n\tp {\n\t\tspan {\n\t\t\tcolor: $purple;\n\t\t}\n\t}\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n.activity-badge {\n\tcolor: $white;\n\t@include margin-padding(null, 5px 7px);\n\tfont-size: $font-size-12;\n\t@include rounded(5px);\n\ti {\n\t\tmargin-right: 5px;\n\t}\n}\n.title-head {\n\tfont-weight: $font-weight-medium;\n\tcolor: $gray-900;\n}",".tasks-activity {\n\t&.tasks {\n\t\t& > ul {\n\t\t\tmargin-top: 15px;\n\t\t\t.task-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\t&.pending {\n\t\t\t\t\t&::before { \n\t\t\t\t\t\tbackground-color: $violet;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.warning {\n\t\t\t\t\t&::before { \n\t\t\t\t\t\tbackground-color: $warning;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.success {\n\t\t\t\t\t&::before { \n\t\t\t\t\t\tbackground-color: $success;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.task-info {\n\t\t\t\t\t.task-icon {\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\n\t\t\t\t\t}\n\t\t\t\t\t.task-checkbox {\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\n\t\t\t\t\t\t.checkboxs .checkmarks {\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\t@include transform(translateY(-50%));\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.set-star {\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\n\t\t\t\t\t}\n\t\t\t\t\tp {\n\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t}\n\t\t\t\t\t.badge {\n\t\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t\t\tfont-size: $font-size-12;\n\t\t\t\t\t\t@include margin-padding(0 5px 10px 0, 5px 7px);\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t.task-actions {\n\t\t\t\t\tul {\t\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t@include margin-padding(0 10px 10px 0, null);\n\t\t\t\t\t\t\t.badge-tag {\n\t\t\t\t\t\t\t\tpadding: 5px 4px; \n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\t\t\n\t\t\t}\t\t\t\n\t\t}\n\t}\n}\n.all-read {\n\t.checkboxs {\n\t\t.checkmarks {\n\t\t\ttop: 50%;\n\t\t\t@include transform(translateY(-50%));\n\t\t}\n\t}\n}\n.task-drops {\n\t.dropdown-toggle {\n\t\tborder: 0;\n\t\tpadding: 0;\n\t\tfont-size: $font-size-18;\n\t\tfont-weight: $font-weight-semibold;\n\t\tbox-shadow: none;\n\t\t&.show {\n\t\t\tborder: 0;\n\t\t}\n\t\t@include respond-below(custom767) {\n\t\t\tfont-size: $font-size-16;\n\t\t}\n\t}\n}\n.badge-purple-light{\n\tcolor: #4A00E5 !important;\n\tbackground: #F3EDFF !important;\n}\n.task-wrapper {\n\tborder-bottom: 1px solid $light-900;\n\tmargin-bottom: 15px;\n\tpadding-bottom: 15px;\n\t.tasks-activity {\n\t\t\t&.tasks {\t\t\t\n\t\t\t\t& > ul {\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t&:last-child {\n\t\tpadding-bottom: 0;\n\t\t.tasks-activity {\n\t\t\t&.tasks {\t\t\t\n\t\t\t\t& > ul {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.task-accordion {\n\t\tfont-size: $font-size-18;\n\t\tfont-weight: $font-weight-semibold;\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\th4 {\n\t\t\t@include respond-below(custom767) {\n\t\t\t\tfont-size: $font-size-16;\n\t\t\t}\n\t\t}\n\t\tspan {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\t@include rounded(50%);\n\t\t\tborder: 1px solid $light-900;\n\t\t\tdisplay: -webkit-inline-box;\n\t\t\tdisplay: -ms-inline-flexbox;\n\t\t\tdisplay: inline-flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tmargin-left: 10px;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t\tfont-size: $font-size-10;\n\t\t}\n\t\t&::before {\n            content: \"\\f054\";\n            font-family: 'Font Awesome 5 Free';\n            @include position(absolute, 50%, 10px, null, null);\n            @include transform(translateY(-50%));\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n        } \n        &:not(.collapsed) {                 \n            &::before {\n                content: \"\\f078\";\n            }           \n        }\n\t}\n\t&:last-child {\n\t\tborder: 0;\n\t\tmargin-bottom: 0;\n\t}\n}\n\n\n// .preloader {\n// \tposition: fixed;\n// \ttop: 0;\n// \tleft: 0;\n// \tz-index: 999999;\n// \twidth: 100%;\n// \theight: 100%;\n// \tbackground: #FFF;\n// \tdisplay: flex;\n// \talign-items: center;\n// \tjustify-content: center;\n// \t.loader {\n// \t\twidth: 64px;\n// \t\theight: 64px;\n// \t\tposition: relative;\n// \t\tanimation: rotate 1.5s ease-in infinite alternate;\n// \t  }\n// \t  .loader::before {\n// \t\tcontent: '';\n// \t\tposition: absolute;\n// \t\tleft: 0;\n// \t\tbottom: 0;\n// \t\tcolor: $tertiary;\n// \t\tbackground: currentColor;\n// \t\twidth: 64px;\n// \t\theight: 32px;\n// \t\tborder-radius: 0 0 50px 50px;\n// \t  }\n// \t  .loader::after {\n// \t\tcontent: '';\n// \t\tposition: absolute;\n// \t\tleft: 50%;\n// \t\ttop: 10%;\n// \t\tbackground: $green;\n// \t\twidth: 8px;\n// \t\theight: 64px;\n// \t\tanimation: rotate 1.2s linear infinite alternate-reverse;\n// \t  }\n\t\t\t \n//   }\n\n  @keyframes rotate {\n\t100% { transform: rotate(360deg)}\n  }\n  \n.toggle-content-view {\n    margin-bottom: 24px;\n\th5{\n\t\tfont-size: 20px;\n\t\tfont-weight: 700;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 5px;\n\t}\n\tp{\n\t\tcolor: $gray-400;\n\t\tfont-size: 14px;\n\t}\n}\n.details-propsal{\n\th4 {\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tmargin-bottom: 24px;\n\t}\n\th6{\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 12px;\n\t}\n\th3{\n\t\tcolor: #3C2371;\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tmargin-bottom: 12px;\n\t}\n\tspan{\n\t\tcolor: #6F6F6F;\n\t\tfont-size: 14px;\n\t\tdisplay: block;\n\t}\n\t&.details-propsals{\n\t\tul{\n\t\t\tli{\n\t\t\t\twidth: 33.3%;\n\t\t\t}\n\t\t}\n\t}\n\tul{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\tborder-bottom: 1px solid $light-900;\n\t\tmargin-bottom: 20px;\n\t\tli{\n\t\t\twidth: 25%;\n\t\t\tmargin-bottom: 10px;\n\t\t\th5{\n\t\t\t\tcolor: $gray-600;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t}\n\t\t\th6{\n\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\t\t\timg{\n\t\t\t\twidth: 16px;\n\t\t\t\theight: 16px;\n\t\t\t\tmargin-right: 8px;\n\t\t\t\tborder-radius: 5px;\n\t\t\t}\n\t\t\t.btn{\n\t\t\t\tpadding: 3px 15px;\n\t\t\t}\n\t\t}\n\t}\n}\n.attached-div{\n\th5 {\n\t\tfont-size: 16px;\n\t\tmargin-bottom: 12px;\n\t}\n}\n.attached-div{\n\tpadding-bottom: 15px;\n}\n.attachement-download {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid #E8E8E8;\n    padding: 15px;\n    border-radius: 5px;\n\tmargin-bottom: 12px;\n}\n.attachement-download-icon {\n\tspan {\n\t\tbackground: #e85b28;\n\t\twidth: 44px;\n\t\theight: 44px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-size: 22px;\n\t\tcolor: #fff;\n\t\tborder-radius: 5px;\n\t}\n}\n.attachement-download-img {\n    display: flex;\n    align-items: center;\n}\n.attachement-download-content {\n    margin-left: 10px;\n\th5 {\n\t\tfont-size: 14px;\n\t\tmargin-bottom: 3px;\n\t\tfont-weight: 600;\n\t}\n\th6 {\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t}\n}\n\n.table-view {\n    margin-bottom: 24px;\n    border: 1px solid #E8E8E8;\n    border-radius: 10px;\n\tth {\n\t\tbackground: #E8E8E8;\n\t}\n}\n.table-view{\n\tmargin-bottom: 24px;\n    border: 1px solid #E8E8E8;\n    border-radius: 10px;\n\tth {\n\t\tbackground: #E8E8E8;\n\t}\n} \n.subtotal-div {\n    background: #F9F9FC;\n    padding: 24px;\n\tul {\n\t\tli {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\th5{\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: $gray-400;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t\th6{\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t\t+ li{\n\t\t\t\tmargin-top: 15px;\n\t\t\t}\n\t\t}\n\t}\n}\n.terms-condition{\n\tmargin-top: 15px;\n\tpadding-top: 15px;\n\tborder-top: 1px solid #E8E8E8;\n\th2{\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 15px;\n\t}\n\tp{\n\t\tcolor: $gray-400;\n\t\tfont-size: 14px;\n\t\tpadding-bottom: 15px;\n\t}\n}\n.contact-type{\n\th6{\n\t\tfont-weight: 600;\n\t}\n\tul{\n\t\tborder: 0;\n\t\tdisplay: inline;\n\t\tli{\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 5px;\n\t\t\th5{\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 40%;\n\t\t\t\tcolor: $gray-400;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tmargin: 0;\n\t\t\t\t&:after{\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \":\";\n\t\t\t\t\tright: 8px;\n\t\t\t\t\ttop: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t\th6{\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 60%;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.renewal-history{\n\th4{\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tmargin-bottom: 15px;\n\t}\n}\n.renewal-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    border: 1px solid #E8E8E8;\n    padding: 24px;\n    box-shadow: 0px 4px 74px 0px #D0D0D040;\n    border-radius: 5px;\n\tmargin-bottom: 15px;\n\t.renewal-content-history{\n\t\twidth: 80%;\n\t}\n\t.contact-type{\n\t\th6{\n\t\t\tcolor: $gray-700;\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t\tul{\n\t\t\tflex-wrap: wrap;\n\t\t\tdisplay: flex;\n\t\t\tli{\n\t\t\t\twidth: 50%;\n\t\t\t\th6{\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\t\t\t\th5{\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.toogle-header-select{\n\t.select2-container{\n\t\tmin-width: 150px !important;\n\t}\n\t.select2-container--default .select2-results__option--selected {\n\t\tcolor: #fff;\n\t}\n\t.toggle-btn{\n\t\tmin-width: 26px;\n\t}\n}\n.btn-downloads{\n\tfont-size: 14px !important;\n\tborder: 1px solid #E8E8E8;\n\tpadding: 10px 15px;\n\tcolor: $gray-900 !important;\n\tfont-weight: 500;\n\tborder-radius: 5px;\n\t&:hover{\n\t\tbackground: $primary;\n\t\tcolor: $white !important;\n\t}\n\n}\n.input-table {\n\t&.input-table-descripition{\n\t\tinput{\n\t\t\twidth: 130px;\n\t\t}\n\t}\n\tinput {\n\t\tborder: 1px solid #E8E8E8;\n\t\theight: 30px;\n\t\tborder-radius: 5px;\n\t\twidth: 75px;\n\t\tpadding: 5px;\n\t}\n\tselect{\n\t\tborder: 1px solid #E8E8E8;\n\t\theight: 30px;\n\t\tborder-radius: 5px;\n\t\twidth: 75px;\n\t}\n}\n.upload-signature{\n\tposition: relative;\n\tinput{\n\t\twidth: 100%;\n\t\theight: 42px;\n\t\topacity: 0;\n\t\tz-index: 9;\n\t}\n\ta{\n\t\tborder: 1px dashed #E8E8E8;\n\t\tborder-radius: 5px;\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: 42px;\n\t\ttext-align: center;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tcolor: $gray-400;\n\t\tleft: 0;\n\t\tpadding: 10px;\n\t\tbackground: #fff;\n\t}\n}\n.toggle-header-popup{\n\t.btn-dropdowns{\n\t\tmin-width: 125px;\n\t\tborder: 1px solid #E8E8E8;\n\t\tpadding: 8px 12px;\n\t\tfont-size: 14px !important;\n\t\tcolor: $gray-400 !important;\n\t\t&.dropdown-toggle:after{\n\t\t\ttop: -2px;\n\t\t\tposition: relative;\n\t\t\tfont-size: 12px;\n\t\t}\n\t\t&.dropdown-toggle-contract{\n\t\t\tmin-width: 150px;\n\t\t}\n\t\t&:hover{\n\t\t\tcolor: $white !important;\n\t\t\tbackground: $primary;\n\t\t}\n\t\t&:active,&:focus{\n\t\t\tcolor: $white !important;\n\t\t}\n\t}\n\t.dropdown-item{\n\t\tfont-size: 14px !important;\n\t\tcolor: $gray-400 !important;\n\t}\n}\n\n.toggle-popup-sent ,.toggle-popup-draft , .toggle-popup-declined{\n\t.sidebar-layout .sidebar-header a{\n\t\tfont-size: 14px;\n\t\tcolor: #fff;\n\t}\n}\n\n.signature-contant{\n\tpadding: 15px 0;\n\tborder-top: 1px solid #E8E8E8;\n\tborder-bottom: 1px solid #E8E8E8;\n\tp{\n\t\tcolor: #B5B5B5;\n\t\tmargin: 0;\n\t}\n}\n.pay-now{\n\t.btn{\n\t\theight: 42px;\n\t}\n}\n.sidebar {\n\t.sidebar-inner {\n\t\twidth: 100% !important;\n\t}\n}",".activities-list {\n    ul {\n        li {\n            background: $light-300;\n            padding: 15px 10px;\n            margin-bottom: 20px;\n            &:last-child {\n                margin-bottom: 0;\n            }\n            .activity-name {\n                h5 {\n                    font-size: $font-size-14;\n                    font-weight: $font-weight-medium;\n                    color: $gray-900;\n                    margin-bottom: 5px;\n                    -webkit-line-clamp: 1;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    display: -webkit-box;\n                }\n                p {\n                    font-size: $font-size-14;\n                    margin-bottom: 15px;\n                    -webkit-line-clamp: 1;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    display: -webkit-box;\n                }\n                .badge {\n                    color: $white;\n                    @include margin-padding(null, 5px 7px);\n                    font-size: $font-size-12;\n                    @include rounded(5px);\n                    i {\n                        margin-right: 5px;\n                    }\n                }\n            }\n            .user-activity {\n                display: flex;\n                align-items: center;\n                @include respond-below(custom767) {\n                    margin: 20px 0;\n                }\n               \n                span {\n                    flex-shrink: 0;\n                    display: inline-flex;\n                    margin-right: 5px;\n                    img {\n                        width: 32px;\n                        height: 32px;\n                        border-radius: 50%;\n                    }\n                }\n                h6 {\n                    margin-bottom: 0;\n                    -webkit-line-clamp: 1;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    display: -webkit-box;\n                }\n            }\n        }\n    }\n}\n.card-select {\n    ul {\n        @include respond-below(custom575) {\n            align-items: start !important;\n        }\n    }\n}\n.campaign-card {\n    overflow-x: auto;\n    ul {\n        width: max-content;\n        .campaign-wrap {\n            background-color: $light-200;\n            @include margin-padding(0 0 15px, 15px 15px 5px);\n            .campaign-info {\n                display: flex;\n                display: -webkit-flex;\n                align-items: center;\n                -webkit-align-items: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                white-space: nowrap;\n                border-bottom: 1px solid $light-900;\n                margin: 0 0 15px 0;\n                h5 {\n                    font-weight: $font-weight-semibold;\n                    margin-bottom: 5px;\n                }\n                .campaign-name {\n                    margin: 0 50px 10px 0;\n                }\n                .list-progress {\n                    margin-bottom: 10px;\n                }\n            }\n            .campaign-action {\n                display: flex;\n                display: -webkit-flex;\n                align-items: center;\n                -webkit-align-items: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                flex-wrap: wrap;\n                .project-mem {\n                    margin-bottom: 10px;\n                }\n            }\n            .campaign-date {\n                margin-bottom: 10px;\n                display: flex;\n                display: -webkit-flex;\n                align-items: center;\n                -webkit-align-items: center;\n                .badge {\n                    margin: 0 15px 0 0;\n                }\n            }\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}",".priority {\n\t&.badge-tag {\n\t\tcolor: $gray-900;\n\t\tmin-width: 80px;\n\t\ttext-align: left;\n\t\tfont-weight: $font-weight-semibold;\n\t\ti {\n\t\t\tmargin-right: 4px;\n\t\t}\n\t\t&.badge-danger-light {\n\t\t\ti {\n\t\t\t\tcolor: $danger;\n\t\t\t}\n\t\t}\n\t\t&.badge-success-light {\n\t\t\ti {\n\t\t\t\tcolor: $success;\n\t\t\t}\n\t\t}\n\t\t&.badge-warning-light {\n\t\t\ti {\n\t\t\t\tcolor: $warning;\n\t\t\t}\n\t\t}\n\t}\n}\n.task-wrap {\n\tborder: 1px solid $light-900;\n\t@include margin-padding(0 0 10px, 15px 15px 5px);\n\tposition: relative;\n\t@include rounded(5px);\n\t&::before {\n\t\tcontent: \"\";\n\t\tbackground-color: $danger;\n\t\twidth: 3px;\n\t\theight: 100%;\n\t\t@include rounded(5px);\n\t\t@include position(absolute, 0, null, null, 0);\n\t}\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n.task-info {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tflex-wrap: wrap;\n\tp {\n\t\tdisplay: inline-block;\n\t\tmargin: 0 24px 10px 0;\n\t\ti {\n\t\t\tcolor: $gray-400;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t \tcolor: $gray-900;\n\t}\n\t.badge {\n\t\tmargin: 0 10px 10px 0;\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t\t&.badge-pill {\n\t\t\ti {\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t}\n\t}\n}\n.task-actions {\n\tfloat: right;\n\tul {\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\talign-items: center;\n\t\t-webkit-align-items: center;\n\t\tflex-wrap: wrap;\n\t\tli {\n\t\t\tmargin: 0 24px 10px 0;\n\t\t\tcolor: $gray-900;\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t\t&.task-time {\n\t\t\t\ti {\n\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.task-date {\n\t\t\t\ti {\n\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t}\n\n\t\t\t}\n\t\t\t&.task-owner {\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\t.task-user {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\theight: 24px;\n\t\t\t\t\timg {\n\t\t\t\t\t\twidth: 24px;\n\t\t\t\t\t\theight: 24px;\n\t\t\t\t\t\t@include rounded(50%);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t@include respond-below(custom767) {\n\t\tfloat: left;\n\t}\n}\n.select-priority {\n\tposition: relative;\n\t.select-icon {\n\t\t@include position(absolute, 50%, null, null, 10px);\n\t\t@include transform(translateY(-50%));\n\t\tz-index: 99999;\n\t\tcolor: $primary;\n\t}\n\t.select2-container--default .select2-selection--single .select2-selection__rendered {\n\t\tpadding-left: 30px;\n\t}\n}\n.project-name {\n\tmargin-bottom: 15px;\n\tp {\n\t\tfont-weight: $font-weight-medium;\n\t\tmargin-bottom: 5px;\n\t}\n\th4 {\n\t\tfont-weight: $font-weight-semibold;\n\t}\n}\n.con-sidebar-title {\n\t.priority {\n\t\tmargin-bottom: 15px;\n\t}\n\tp {\n\t\tfont-weight: $font-weight-medium;;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 15px;\n\t}\n\t&.border-line {\n\t\tborder-bottom: 1px solid $light-900;\n\t\tmargin-bottom: 20px;\n\t}\n}",".kanban-list-items {\n    border: 1px solid $light-900;\n    box-shadow: 0px 4px 4px 0px #DBDBDB40;\n    border-radius: 5px;\n    @include margin-padding(0 20px 20px 0, 15px);\n    width: 100%;\n    min-width: 315px;\n    &:last-child {\n        margin-right: 0;\n    }\n}\n.icons-social {\n    a {\n        width: 30px;\n        height: 30px;\n        background: $light-500;\n        border-radius: 50%;\n        color: $title-color;\n        &:hover {\n            background: $danger-100;\n            color: $primary;\n        }\n    }\n}\n.kanban-drag-wrap {\n    > div {\n        &:last-child {\n            .kanban-card {\n                margin-bottom: 0;\n            }\n        }\n       \n    }\n}\n.pipeline-progress {\n    .progress {\n        background: transparent;\n        width: 70px;\n        height: 5px;\n        .progress-bar {\n            width: 70px;\n            height: 5px;\n            border-radius: 5px;\n            &.progress-bar-success {\n                background: $success;\n            }\n            &.progress-bar-violet {\n                background: $purple;\n            }\n            &.progress-bar-info {\n                background: $info;\n            }\n            &.progress-bar-warning {\n                background: $warning;\n            }\n            &.progress-bar-green {\n                background: $green;\n            }\n            &.progress-bar-danger {\n                background: $danger;\n            }\n        }\n    }\n    span {\n        margin-left: 10px;\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n    }\n}\n.pipe-title {\n    .add-stage {\n        color: $primary;\n        font-weight: $font-weight-medium;\n        margin-bottom: 15px;\n        display: inline-block;\n        i {\n            margin-right: 8px;\n        }\n    }\n}\n.priority-info {\n    .dropdown {\n        .dropdown-toggle {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            border: 1px solid $light-900;\n            box-shadow: 0px 4px 4px 0px #DBDBDB40;\n            border-radius: 5px;\n            @include margin-padding(null, 5px 10px);\n            font-weight: $font-weight-medium;\n            &[aria-expanded=true] {\n                & > i {\n                    @include transition(all 0.2s ease);\n                    @include transform(rotate(180deg));\n                }\n            }\n            &::after {\n                content: none;\n            }\n            span{\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                i {\n                    font-size: $font-size-10;\n                }                \n            }\n        }\n        a {\n            font-size: $font-size-14;\n            color: $gray-900;\n            span{\n               display: -webkit-inline-box;\n               display: -ms-inline-flexbox;\n               display: inline-flex;\n               align-items: center;\n               -webkit-box-align: center;\n               -ms-flex-align: center;\n               i {\n                   font-size: 10px;\n               }                \n            }\n        }\n        .dropdown-menu {\n            width: 100%;\n        }\n    }\n}\n.select-pipeline {\n    position: relative;\n    margin-right: 8px;\n    .pipe-icon {\n        @include position(absolute, 50%, null, null, 10px);\n        z-index: 99999;\n        transform: translateY(-50%);\n        color: $gray-900;\n    }\n    .select2-container {\n        .select2-selection {\n            &.select2-selection--single {\n                height: 40px;\n                border-radius: 5px;\n                color: $gray-900;\n                font-weight: $font-weight-medium;\n                .select2-selection__rendered {\n                    padding-left: 30px;\n                    line-height: 40px;\n                    color: $gray-900;\n                    font-weight: $font-weight-medium;\n                    padding-right: 30px;\n                }\n                .select2-selection__arrow {\n                    height: 40px;\n                }\n            }\n        }\n    }\n}\n.pipeline-list {\n    border-bottom: 1px solid $light-900;\n    margin-bottom: 15px;\n    ul {\n        margin-bottom: 15px;\n        li {\n            display: inline-block;\n            &:first-child {\n                a {\n                    border-radius: 10px 0 0 10px;\n                }\n            }\n            &:last-child {\n                a {\n                    border-radius: 0;\n                }\n            }\n            a {\n                @include margin-padding(0 0 3px, 12px 25px 12px 50px);\n                font-size: $font-size-14;\n                font-weight: $font-weight-medium;\n                display: inline-block;\n                text-align: center;\n                background: $light-300;\n                color: $title-color;\n                position: relative;\n                min-width: 185px;\n                &::after {\n                    content: '';\n                    @include position(absolute, 0,-23px, null, null);\n                    width: 45px;\n                    height: 45px;\n                    -webkit-transform: scale(.707) rotate(45deg);\n                    -ms-transform: scale(.707) rotate(45deg);\n                    -moz-transform: scale(.707) rotate(45deg);\n                    -transform: scale(.707) rotate(45deg);\n                    z-index: 1;\n                    background: $light-300;\n                    -webkit-box-shadow: 2px -2px 0 1px #fff,3px -3px 0 2px rgba(255,255,255,.1);\n                    box-shadow: 2px -2px 0 1px #fff,3px -3px 0 2px rgba(255,255,255,.1);\n                    border-radius: 0 5px 0 50px;\n                } \n                &.bg-info {\n                    color: $white;\n                    &::after {\n                        background: $info;\n                    }\n                    &:hover {\n                        background: $info !important;\n                    }\n                }    \n                &.bg-warning {\n                    color: $white;\n                    &::after {\n                        background: $warning;\n                    }\n                    &:hover {\n                        background: $warning !important;\n                    }\n                }     \n                &.bg-pending {\n                    color: $white;\n                    background: $purple !important;\n                    &::after {\n                        background: $purple;\n                    }\n                    &:hover {\n                        background: $purple !important;\n                    }\n                }      \n                &.bg-pink {\n                    color: $white;\n                    &::after {\n                        background: $pink;\n                    }\n                    &:hover {\n                        background: $pink !important;\n                    }\n                }        \n                &.bg-success {\n                    color: $white;\n                    &::after {\n                        background: $success;\n                    }\n                    &:hover {\n                        background: $success !important;\n                    }\n                }         \n                &.bg-danger {\n                    color: $white;\n                    &::after {\n                        background: $danger;\n                    }\n                    &:hover {\n                        background: $danger !important;\n                    }\n                }          \n                &.bg-gray {\n                    color: $white;\n                    background: $background-3;\n                    &::after {\n                        background: $background-3;\n                    }\n                    &:hover {\n                        background: $background-3 !important;\n                    }\n                }   \n                @include respond-below(custom575) {  \n                    width: calc(100% - 25px);\n                }       \n            }               \n            @include respond-below(custom575) {  \n                display: block;\n            }  \n        }\n    }\n}",".campaign-box {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\t@include margin-padding(0 0 24px, 24px);\n\t@include rounded(5px);\n\t@include respond-below(custom1399) {\n\t\t@include margin-padding(0 0 24px, 15px);\n\t}\n\t.campaign-img {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tspan {\n\t\t\twidth: 44px;\n\t\t\theight: 44px;\n\t\t\t@include rounded(5px);\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tcolor: $white;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\tp {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t}\t\t\n\t}\n\th2 {\n\t\tcolor: $gray-400;\n\t\t@include respond-below(custom1399) {\n\t\t\tfont-size: $font-size-24;\n\t\t}\n\t\t@include respond-below(custom991) {\n\t\t\tfont-size: $font-size-20;\n\t\t}\n\t}\n\t&.bg-danger-light {\n\t\tbackground-color: $danger-100;\n\t\tspan {\n\t\t\tbackground-color: $danger;\n\t\t}\n\t}\n\t&.bg-warning-light {\n\t\tbackground-color: $warning-100;\n\t\tspan {\n\t\t\tbackground-color: $secondary;\n\t\t}\n\t}\n\t&.bg-purple-light {\n\t\tbackground-color: $purple-100;\n\t\tspan {\n\t\t\tbackground-color: $tertiary;\n\t\t}\n\t}\n\t&.bg-success-light {\n\t\tbackground-color: $success-200;\n\t\tspan {\n\t\t\tbackground-color: $green;\n\t\t}\n\t}\n}\n.campaign-tab {\n\t@include margin-padding(0 0 20px, 15px 15px 0);\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\n\tbackground-color: $white;\n\t@include rounded(5px);\n\tul {\n\t\tli {\n\t\t\tmargin-right: 15px;\n\t\t\ta {\n\t\t\t\tposition: relative;\n\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\tborder-bottom: 4px solid $white;\n\t\t\t\t@include margin-padding(null, 10px 10px 20px);\n\t\t\t\tdisplay: -webkit-inline-box;\n\t\t\t\tdisplay: -ms-inline-flexbox;\n            \tdisplay: inline-flex;\n\t\t\t    -webkit-box-align: center;\n\t\t\t    -ms-flex-align: center;\n\t\t\t    align-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t    -webkit-justify-content: center;\n\t\t\t    -ms-flex-pack: center;\n\t\t\t\t&.active {\n\t\t\t\t\tborder-color: $primary;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\tdisplay: -webkit-inline-box;\n\t\t\t        display: -ms-inline-flexbox;\n            \t\tdisplay: inline-flex;\n\t\t\t        -webkit-box-align: center;\n\t\t\t        -ms-flex-align: center;\n\t\t\t        align-items: center;\n\t\t\t        justify-content: center;\n\t\t\t        -webkit-justify-content: center;\n\t\t\t        -ms-flex-pack: center;\n\t\t\t        border: 1px solid $light-900;\n\t\t\t        @include rounded(50%);\n\t\t\t        margin-left: 10px;\n\t\t\t        font-size: $font-size-10;\n\t\t\t        font-weight: $font-weight-semibold;\n\t\t\t        color: $gray-400;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}\nul.project-mem {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n  \tli {\n  \t\tmargin-left: -10px;\n\t\tdisplay: inline-flex;\n\t\ta {\n\t\t\twidth: 24px;\n\t\t\theight: 24px;\n\t\t}\n  \t\t&:first-child {\n  \t\t\tmargin-left: 0;\n  \t\t}\n  \t\ta {\n  \t\t\timg {\n  \t\t\t\twidth: 24px;\n  \t\t\t\theight: 24px;\n  \t\t\t\tborder-radius: 50%;\n  \t\t\t\tborder: 1px solid $white;\n  \t\t\t}\n  \t\t}\n  \t\t&.more-set {\n  \t\t\ta {\n  \t\t\t\twidth: 24px;\n  \t\t\t\theight: 24px;\n  \t\t\t\tborder-radius: 50%;\n  \t\t\t\tbackground-color: $white;\n  \t\t\t\tborder: 1px solid $light-900;\n  \t\t\t\tdisplay: -webkit-inline-box;\n\t\t\t\tdisplay: -ms-inline-flexbox;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t\tfont-size: $font-size-12;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tcolor: $gray-400;\n  \t\t\t}\n  \t\t}\n  \t}\n}\n.list-progress {\n\tli {\n\t\tdisplay: inline-block;\n\t\tmargin-right: 15px;\n\t\th6 {\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t}\n\t\tp {\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t\tcolor: $gray-400;\n\t\t}\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n}",".form-wrap {\n\t.checkmarks.mem-plane-check {\n\t\ttop: 3px;\n\t}\n}\n.table-imgname.flag-image img {\n\twidth: 24px;\n\theight: 18px;\n\tborder-radius: 5px;\n}\n.table-imgname.flag-image {\n\tdisplay: flex;\n\talign-items: center;\n\t\n}\n.location-flag-img {\n\tborder: 1px solid #E8E8E8;\n\tborder-radius: 5px;\n\twidth: 32px;\n\theight: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-right: 8px;\n}\n.table-imgname.flag-image span {\n\tfont-weight: 500;\n\tcolor: #262A2A;\n}\n#delete_request {\n\ttd {\n\t\tspan {\n\t\t\t&.badge {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t}\n\t}\n}\n.wh-14 {\n\twidth: 14px;\n\theight: 14px;\n}",".flatpickr-current-month {\n\t.flatpickr-monthDropdown-months {\n\t\t.flatpickr-monthDropdown-month {\n\t\t\tbackground-color: #FFF ;\n\t\t\tfont-size: 0.813rem;\n\t\t}\n\t}\n}\n.flatpickr-current-month {\n\t.flatpickr-monthDropdown-months {\n\t\tborder-radius: 0.25rem ;\n\t\tborder: 1px dashed rgba(242, 101, 34, 0.3) ;\n\t\t&:hover {\n\t\t\tbackground: transparent ;\n\t\t}\n\t}\n\t.numInputWrapper {\n\t\tspan {\n\t\t\t&.arrowUp {\n\t\t\t\t&:after {\n\t\t\t\t\tborder-bottom-color: #677788 ;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.flatpickr-current-month .numInputWrapper span.arrowDown:after,\n.flatpickr-calendar.arrowBottom:before {\n\tborder-top-color: #677788 ;\n}\n\n.flatpickr-months .flatpickr-prev-month:hover,\n.flatpickr-months .flatpickr-next-month:hover {\n\tstroke: $primary;\n}\n.flatpickr-months,\n.flatpickr-weekdays {\n  background-color: rgba(242, 101, 34, 0.1) ;\n}\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n\tinset-block-start: 0 ;\n\tpadding-block-start: 0.313rem ;\n\tpadding-inline: 0.313rem ;\n\tpadding-block-end: 0 ;\n\tcolor: $primary ;\n\tfill: $primary ;\n}\n.flatpickr-months .flatpickr-month {\n    color: $primary ;\n    fill: $primary ;\n  }\n  span.flatpickr-weekday {\n    color: rgba(242, 101, 34, 0.8) ;\n    font-weight: 700 ;\n}\n.flatpickr-day.today {\n    border-color: $primary ;\n    background-color: $primary ;\n    color: #FFF ;\n}\n.flatpickr-day {\n    border-radius: 4px ;\n}\n.icons-list {\n    padding: 0;\n    display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n      li {\n        display: block;\n        width: 40px;\n        height: 40px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        font-size: $font-size-18;\n        @include rounded(50px);\n        border: 1px solid $gray-200;\n        margin: 5px;\n        @include box-shadow(null, 0, 2px, 3px, null, rgb(215, 197, 255));\n    }\n    .icons-list-item {\n      \n      display: block;\n      width: 50px;\n      height: 50px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      align-items: center;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      justify-content: center;\n      -webkit-justify-content: center;\n      -ms-flex-pack: center;\n      font-size: $font-size-18;\n      @include rounded(50px);\n      border: 1px solid $gray-200;\n      margin: 5px;\n        &:hover {\n            background-color: $gray-200;\n            color: $primary;\n            font-size: 24px;\n        }\n    }\n}\n\n\n/* Start:: sortable js */\nul,ol{\n    &.sortable-list {\n      li {\n        background-color: $primary;\n        margin: 3px 0;\n        border: 1px solid $primary;\n        border-radius: 0.3rem;\n        font-weight: 500;\n        &.filtered {\n          background-color: $danger;\n          color: $white;\n        }\n        &.selected {\n          background-color: $primary;\n          border: 1px solid $primary;\n          color: $white;\n        }\n      }\n      .list-group-item{\n        background-color:rgba(242, 101, 34, 0.05) ;\n      }\n      .list-group-item+.list-group-item {\n        border-top-width: 1px;\n        background-color:rgba(242, 101, 34, 0.05) ;\n      }\n    }\n    &#shared-right,&#cloning-right,&#disabling-sorting-right {\n      li {\n        background-color: rgba($secondary, 0.05);\n        border: 1px solid rgba($secondary, 0.05);\n      }\n    }\n    .handle {\n      cursor: grab;\n    } \n  }\n  .grid-square {\n    width: 100px;\n    height: 100px;\n    display: inline-block;\n    background-color: $white;\n    border: 1px solid $default-border;\n    border-radius: 0.5rem;\n    margin-block-end: 1.5rem;\n    margin-inline-end: 1.5rem;\n    padding: 20px;\n  }\n  .nested-sortable, .nested-1, .nested-2, .nested-3 {\n    margin-top: 5px;\n    .list-group-item+.list-group-item {\n      border-top-width: 1px;\n    }\n  }\n  .nested-1, .nested-2, .nested-3 {\n    border: 1px solid rgba($secondary, 0.05);\n    font-weight: 500;\n  }\n  /* End:: sortable js */\n  \n  \n  /* Start::Leaflet Maps */\n  #map,\n  #map1,\n  #map-popup,\n  #map-custom-icon,\n  #interactive-map {\n    height: 18.75rem;\n    z-index: 10;\n  }\n  \n  /* End::Leaflet Maps */\n  \n  /* Start::Vector Maps */\n  .jvm-zoom-btn {\n    background-color: $light ;\n    color: $text-color ; \n    border: 1px solid $default-border ;\n    font-size: 20px;\n  }\n  #vector-map,\n  #marker-map,\n  #marker-image-map,\n  #lines-map,\n  #us-map,\n  #canada-map,\n  #spain-map,\n  #russia-map {\n    height: 21.875rem;\n  }\n  \n  .jvm-tooltip {\n    background-color: #1a1c1e ;\n  }\n  \n  #vector-map,\n  #marker-map,\n  #marker-image-map,\n  #lines-map,\n  #users-map {\n    #jvm-regions-group path {\n      fill: #f8f9fa ;\n    }\n  }\n  \n  .jvm-zoom-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px ;\n    height: 20px ;\n    line-height: 20px ;\n  }\n  \n  .jvm-zoom-btn.jvm-zoomin {\n    inset-block-start: 5px ;\n  }\n  \n  #jvm-markers-labels-group text {\n    fill: $text-muted;\n  }\n  \n  /* End::Vector Maps */\n  \n  /* Start::Google Maps */\n  #google-map,\n  #google-map-overlay,\n  #map-layers,\n  #map-markers,\n  #streetview-map,\n  #map-geofencing {\n    height: 18.75rem;\n  }\n  \n  .google-map-overlay {\n    display: block;\n    text-align: center;\n    color: $white;\n    font-size: 1.25rem;\n    line-height: 0.875rem;\n    opacity: 0.8;\n    background: $primary;\n    border: solid 0.188rem $primary;\n    border-radius: 0.25rem;\n    padding: 0 0.25rem;\n  }\n  \n  .google-overlay_arrow {\n    inset-inline-start: 50%;\n    margin-inline-start: -1rem;\n    width: 0;\n    height: 0;\n    position: absolute;\n  }\n  \n  .google-overlay_arrow.above {\n    inset-block-end: -0.938rem;\n    border-inline-start: 0.938rem solid transparent;\n    border-inline-end: 1rem solid transparent;\n    border-block-start: 1rem solid #336699;\n  }\n  \n  .google-overlay_arrow.below {\n    inset-block-start: -0.938rem;\n    border-inline-start: 1rem solid transparent;\n    border-inline-end: 1rem solid transparent;\n    border-block-end: 1rem solid #336699;\n  }\n  \n  /* End::Google Maps */\n  \n  \n  /* Start:Pickers */\n  .flatpickr-time .flatpickr-am-pm {\n    width: 36% ;\n  } \n  [dir=\"rtl\"] {\n    .flatpickr-input {\n      text-align: start;\n    }\n  }\n  \n  .flatpickr-calendar {\n    background-color: $white ;\n    box-shadow: $box-shadow ;\n    border: 1px solid $default-border ;\n    font-size: $font-size-base ;\n  }\n  \n  .flatpickr-months .flatpickr-prev-month,\n  .flatpickr-months .flatpickr-next-month {\n    color: $black ;\n    fill: $black ;\n  }\n  .rangeMode .flatpickr-day {\n    margin-top: 4px ;\n  }\n  .flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange {\n    border-radius: 50px 0 0 50px ;\n  }\n  .flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {\n    border-radius: 0 50px 50px 0 ;\n  }\n  .flatpickr-monthDropdown-months,\n  .numInput {\n    color: $black ;\n  }\n  \n  .flatpickr-day.today.inRange {\n    color: $primary ;\n  }\n  \n  .dayContainer {\n    padding: 0.25rem ;\n  }\n  \n  .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n    background-color: $white ;\n    font-size: 0.813rem;\n  }\n  \n  .flatpickr-months .flatpickr-prev-month svg,\n  .flatpickr-months .flatpickr-next-month svg {\n    width: 1.25rem ;\n    height: 1.25rem ;\n    padding: 0.25rem;\n    fill: $primary;\n  }\n  \n  .flatpickr-day.inRange {\n    box-shadow: none ;\n  }\n  \n  .flatpickr-calendar.open {\n    z-index: 105 ;\n  }\n  \n  .flatpickr-current-month .flatpickr-monthDropdown-months {\n    border-radius: 0.25rem ;\n    border: 1px dashed $primary ;\n  }\n  \n  .flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n    background: transparent ;\n  }\n  \n  .flatpickr-current-month .numInputWrapper span.arrowDown:after,\n  .flatpickr-calendar.arrowBottom:before {\n    border-top-color: $text-muted ;\n  }\n  \n  .flatpickr-current-month .numInputWrapper span.arrowUp:after {\n    border-bottom-color: $text-muted ;\n  }\n  \n  .flatpickr-day.selected.startRange+.endRange:not(:nth-child(7n + 1)),\n  .flatpickr-day.startRange.startRange+.endRange:not(:nth-child(7n + 1)),\n  .flatpickr-day.endRange.startRange+.endRange:not(:nth-child(7n + 1)) {\n    box-shadow: none ;\n  }\n  \n  .flatpickr-day {\n    color: $gray-600 ;\n    font-weight: 500 ;\n  \n    &.nextMonthDay,\n    &.prevMonthDay {\n      opacity: 0.5 ;\n    }\n  }\n  \n  .flatpickr-day.today {\n    border-color: $primary ;\n    background-color: $primary ;\n    color: $white ;\n  }\n  \n  .flatpickr-day.selected,\n  .flatpickr-day.startRange,\n  .flatpickr-day.endRange,\n  .flatpickr-day.selected.inRange,\n  .flatpickr-day.startRange.inRange,\n  .flatpickr-day.endRange.inRange,\n  .flatpickr-day.selected:focus,\n  .flatpickr-day.startRange:focus,\n  .flatpickr-day.endRange:focus,\n  .flatpickr-day.selected:hover,\n  .flatpickr-day.startRange:hover,\n  .flatpickr-day.endRange:hover,\n  .flatpickr-day.selected.prevMonthDay,\n  .flatpickr-day.startRange.prevMonthDay,\n  .flatpickr-day.endRange.prevMonthDay,\n  .flatpickr-day.selected.nextMonthDay,\n  .flatpickr-day.startRange.nextMonthDay,\n  .flatpickr-day.endRange.nextMonthDay {\n    background: $primary ;\n    color: $white ;\n    border-color: $primary ;\n  }\n  \n  .flatpickr-day.inRange,\n  .flatpickr-day.prevMonthDay.inRange,\n  .flatpickr-day.nextMonthDay.inRange,\n  .flatpickr-day.today.inRange,\n  .flatpickr-day.prevMonthDay.today.inRange,\n  .flatpickr-day.nextMonthDay.today.inRange,\n  .flatpickr-day:hover,\n  .flatpickr-day.prevMonthDay:hover,\n  .flatpickr-day.nextMonthDay:hover,\n  .flatpickr-day:focus,\n  .flatpickr-day.prevMonthDay:focus,\n  .flatpickr-day.nextMonthDay:focus {\n    background: $default-background ;\n    border-color: $default-border ;\n  }\n  \n  .flatpickr-day.today:hover {\n    background-color: $primary ;\n    border-color: $primary ;\n    color: $white ;\n  }\n  \n  .flatpickr-calendar.hasTime .flatpickr-time {\n    border-top: 1px solid $default-border ;\n  }\n  \n  .flatpickr-calendar.arrowTop:after,\n  .flatpickr-calendar.arrowTop:before {\n    border-bottom-color: $default-border ;\n  }\n  \n  .flatpickr-calendar.arrowBottom:after,\n  .flatpickr-calendar.arrowBottom:before {\n    border-top-color: $default-border ;\n  }\n  \n  .flatpickr-time input:hover,\n  .flatpickr-time .flatpickr-am-pm:hover,\n  .flatpickr-time input:focus,\n  .flatpickr-time .flatpickr-am-pm:focus {\n    background: $default-background ;\n  }\n  \n  .flatpickr-time .flatpickr-time-separator,\n  .flatpickr-time .flatpickr-am-pm {\n    color: $text-muted ;\n  }\n  \n  .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {\n    inset-inline-start: 0 ;\n  }\n  \n\n  .flatpickr-months .flatpickr-prev-month,\n  .flatpickr-months .flatpickr-next-month {\n    inset-block-start: 0 ;\n    padding-block-start: 0.313rem ;\n    padding-inline: 0.313rem ;\n    padding-block-end: 0 ;\n    color: $primary ;\n    fill: $primary ;\n  }\n  \n  @media (min-width: 420px) {\n    .flatpickr-time .flatpickr-am-pm {\n      padding: 0 1.875rem 0 0.5rem;\n    }\n  }\n  \n  .flatpickr-weekdays {\n    border-block-end: 1px solid $default-border ;\n  }\n  \n  .numInputWrapper span.arrowUp {\n    top: -0.125rem ;\n  }\n  \n  .flatpickr-current-month .numInputWrapper {\n    width: 3.5rem ;\n  }\n  \n  .flatpickr-calendar.hasTime {\n    width: auto;\n  }\n  \n  [dir=\"rtl\"] {\n    .flatpickr-months {\n      .numInputWrapper span {\n        left: 0 ;\n        right: inherit ;\n      }\n    }\n  }\n  \n  @media (max-width: 575.98) {\n    .flatpickr-calendar {\n      width: 250px ;\n    }\n  }\n  \n  .flatpickr-current-month .flatpickr-monthDropdown-months {\n    margin: -1px 2.25rem 0 0 ;\n  }\n  \n  .flatpickr-current-month .flatpickr-monthDropdown-months,\n  .flatpickr-current-month input.cur-year {\n    padding-block: 0 ;\n    padding-inline-start: 0 ;\n    padding-inline-end: 0.5ch ;\n    font-size: 0.875rem ;\n    font-weight: 500 ;\n  }\n  \n  .flatpickr-months .flatpickr-prev-month:hover,\n  .flatpickr-months .flatpickr-next-month:hover {\n    stroke: $primary;\n  }\n  \n  .flatpickr-day {\n    border-radius: 4 ;\n  }\n  \n  .numInputWrapper:hover {\n    background: transparent ;\n  }\n  \n  .numInputWrapper span {\n    border: 0px ;\n  }\n  \n  .flatpickr-current-month .numInputWrapper span.arrowUp:after {\n    border-block-end-color: $primary ;\n  }\n  \n  .flatpickr-months .flatpickr-prev-month:hover svg,\n  .flatpickr-months .flatpickr-next-month:hover svg {\n    fill: $white ;\n  }\n  \n  .numInputWrapper span:hover {\n    background: transparent ;\n  }\n  \n  .numInputWrapper span.arrowUp:after {\n    border-inline-start: 0.25rem solid transparent ;\n    border-inline-end: 0.25rem solid transparent ;\n    border-block-end: 0.25rem solid $primary ;\n    inset-block-start: 75% ;\n  }\n  \n  .flatpickr-current-month .numInputWrapper span.arrowDown:after {\n    border-block-start-color: $primary ;\n  }\n  \n  .numInputWrapper span.arrowDown:after {\n    border-inline-start: 0.25rem solid transparent ;\n    border-inline-end: 0.25rem solid transparent ;\n    border-block-start: 0.25rem solid $primary ;\n    inset-block-start: 15% ;\n  }\n  \n  span.flatpickr-weekday {\n    color: $primary ;\n    font-weight: 700 ;\n  }\n  \n  .flatpickr-months .flatpickr-month {\n    color: $primary ;\n    fill: $primary ;\n  }\n  \n  .flatpickr-monthDropdown-months,\n  .numInput {\n    color: $primary ;\n  }\n  \n  .pcr-app {\n    background: $white ;\n  }\n  \n  .pcr-app .pcr-interaction .pcr-result {\n    color: $gray-600 ;\n    background: $default-background ;\n  }\n  \n  .theme-container,\n  .theme-container1,\n  .theme-container2 {\n    button {\n      display: none;\n    }\n  }\n  \n  .pcr-app[data-theme=\"classic\"] .pcr-selection .pcr-color-preview {\n    margin-inline-end: 0.75em ;\n  }\n  \n  .pcr-app[data-theme=\"classic\"] .pcr-selection .pcr-color-chooser,\n  .pcr-app[data-theme=\"classic\"] .pcr-selection .pcr-color-opacity {\n    margin-inline-start: 0.75em ;\n  }\n  \n  .flatpickr-weekwrapper .flatpickr-weeks {\n    box-shadow: 1px 0 0 $default-border ;\n  }\n  \n  /* End:Pickers */\n\n  /* Start:: swiper js */\n.swiper {\n    border-radius: 5px;\n  }\n  \n  [dir=\"rtl\"] {\n    .swiper {\n      direction: ltr;\n    }\n  \n    .swiper-backface-hidden .swiper-slide {\n      direction: rtl;\n    }\n  }\n  \n  .swiper-slide img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .swiper-button-next,\n  .swiper-button-prev {\n    width: 1.563rem ;\n    height: 1.563rem ;\n    color: $white ;\n    background-color: rgba(255, 255, 255, 0.3);\n    border-radius: 5px;\n  }\n  \n  .swiper-button-next:after,\n  .swiper-button-prev:after {\n    font-size: 0.75rem ;\n    font-weight: 800 ;\n  }\n  \n  .swiper-horizontal1 .swiper-slide {\n    height: auto;\n  }\n  \n  .swiper-pagination-bullet {\n    width: 1.25rem ;\n    height: 0.25rem ;\n    border-radius: 5px ;\n    background: $white ;\n  }\n  \n  .swiper-pagination-bullet-active {\n    background: $white ;\n  }\n  \n  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    background: $success ;\n  }\n  \n  .swiper-pagination {\n    color: $white;\n  }\n  \n  .custom-pagination {\n    .swiper-pagination-bullet {\n      width: 1.5rem ;\n      height: 1.5rem ;\n      padding: 0.188rem;\n      background-color: rgba(255, 255, 255, 0.3) ;\n      color: $white ;\n      opacity: 1 ;\n  \n      &.swiper-pagination-bullet-active {\n        background-color: $white ;\n        color: $black ;\n      }\n    }\n  }\n  \n  .swiper-scrollbar {\n    background-color: rgba(255, 255, 255, 0.3) ;\n  }\n  \n  .swiper-scrollbar-drag {\n    background-color: $white ;\n  }\n  \n  .swiper.vertical {\n    height: 21.875rem;\n  }\n  \n  .swiper-preview {\n    height: 80%;\n    width: 100%;\n  }\n  \n  .swiper-view {\n    height: 20%;\n    box-sizing: border-box;\n    padding: 10px 0;\n  }\n  \n  .swiper-view .swiper-slide {\n    width: 25%;\n    height: 100%;\n    opacity: 0.4;\n  }\n  \n  .swiper-view .swiper-slide-thumb-active {\n    opacity: 1;\n  }\n  \n  .swiper-preview .swiper-wrapper {\n    margin-block-end: 0.65rem;\n  }\n  \n  .swiper-thumbs .swiper-slide img {\n    border-radius: 5px;\n  }\n  \n  /* End:: swiper js */",".files-list {\n    a.active {\n      background: $primary-100;\n    }\n}\n.files-list {\n    a {\n        @include rounded(5px);\n        &:hover, &.active {\n            background: $primary-100;\n            color: $gray-900 !important;\n        }\n    }\n}\n.social-gallery-slider,.email-attach {\n    a {\n        position: relative;\n        transition: 0.5s all;\n        span {\n        position: absolute;\n        top: 0;\n        left: 50%;\n        transform: translatex(-50%);\n        transition: 0.5s all;\n        background: $white;\n        opacity: 0;\n        i {\n            color: $dark;\n            opacity: 1;\n        }\n        }\n        &:hover {\n        transition: 0.5s all;\n        span {\n            top: 50%;\n            transform: translate(-50%,-50%);\n            transition: 0.5s all;\n            opacity: 0.5;\n            \n        }\n        &::before {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            border-radius: 5px;\n            background: $gray-900;\n            opacity: 0.8;\n            position: absolute;\n            transition: 0.5s all;\n            left: 0;\n            top: 0;\n            right: 0;\n            bottom: 0;\n        }\n        }\n        img {\n        transition: 0.5s all;\n        }\n    }\n}\n.post-textarea {\n    padding-top: 60px;\n    padding-left: 68px;\n}\n.text-area-avatar {\n    position: absolute;\n    top: 50%;\n    left: 15px;\n    transform: translateY(-50%);\n}\n.template-more-links {\n    a {\n      position: relative;\n      & + a {\n        margin-left: 10px;\n        padding-left: 10px;\n        &::before {\n          content: \"/\";\n          position: absolute;\n          left: -2px;\n          top: 50%;\n          transform: translateY(-50%);\n        }\n      }\n    }\n}\n.custom-nav {\n    display: flex;\n    align-items: center;\n    button {\n      width: 16px;\n      height: 16px;\n      background: $white;\n      border: 0;\n      border-radius: 5px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      &:hover {\n        background: $dark;\n        color: $white;\n      }\n    }\n}\n.fs-5 {\n    font-size: 5px !important;\n}\n.fs-6 {\n    font-size: 6px !important;\n}\n.btn.btn-icon:hover {\n    background: $light-800;\n    color: $dark;\n}\n.kanban-drag-wrap {\n    min-width: 260px;\n    min-height: 50px;\n}\n.dropdown-toggle.btn.btn-white.text-dark {\n    color: $dark !important;\n}\n.bg-transparent-secondary {\n    background: #EDF2F4;\n}\n.bg-soft-skyblue {\n    background: #D3F5FC;\n}\n.bg-soft-pink {\n    background: #FFDBEC;\n    color: #FD3995;\n}\n.bg-skyblue {\n    background-color: #0DCAF0 !important;\n}\n.btn-white {\n    background: $white;\n}",".welcome-wrap {\n    padding: 40px 40px 24px;\n    background: $tertiary;\n    @include rounded(5px);\n    position: relative;\n    z-index: 1;\n    @include respond-below(custom767) {\n        padding: 20px 20px 4px;\n    }\n    .welcome-bg-01 {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    .welcome-bg-01 {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n    }\n    .welcome-bg-02 {\n        position: absolute;\n        top: 20%;\n        left: 40%;\n        z-index: -1;\n    }\n    .welcome-bg-03 {\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        z-index: -1;\n    }\n}\n#company-chart {\n    .apexcharts-bar-series {\n        .apexcharts-series path {\n            &:hover {\n                fill: $primary;\n            }\n        }\n    }\n}\n.fs-4 {\n    font-size: 4px !important;\n}",".pricing-content{\n    padding: 15px;\n    .price-hdr{\n        margin: 0 0 14px 0;\n        display: flex;\n        align-items: center;\n        &::after{\n            content: \"\";\n            width: 90%;\n            height: 1px;\n            background: $gray-200;\n        }\n    }\n}\n.timeline-hrline {\n    position: relative;\n    z-index: 1;\n    &::before {\n        content: \"\";\n        width: 1px;\n        height: 100%;\n        border-left: 1px solid $gray-200;\n        position: absolute;\n        left: -12px;\n        top: 5px;\n        z-index: -1;\n    }\n}\n.schedule-timeline {\n    > div {\n        &:last-child {\n            .timeline-hrline {\n                &::before {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n.timeline-border{\n    width: 24px;\n    height: 24px;\n    border: 1px solid $gray-200;\n    border-radius: 12px;\n}\n.timeline-date{\n    margin-right: 21px;\n}",".select2-container {\n    min-width: 100% !important;\n    z-index: 99;\n    .select2-selection--single {\n        height: 40px;\n    }\n}\n.select2-container--default {\n    .select2-selection--single {\n        border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n        @include rounded(5px);\n        .select2-selection__rendered {\n            color: $text-color;\n            line-height: 38px;\n            @include rounded(5px);\n            padding-left: 10px;\n            font-size: $font-size-14;\n            font-weight: $font-weight-normal;\n            padding-right: 25px;\n             span {\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n                img {\n                    width: 16px;\n                    height: 16px;\n                    border-radius: 5px;\n                    margin-right: 5px;\n                }\n            }\n        }\n        .select {\n            width: 219px;\n        }\n        .select2-selection__arrow {\n            height: 40px;\n            right: 6px;\n        }\n    }\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n    @include position(absolute,50%,null,null,50%);\n    border-color: #637381;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    height: 0;\n    margin-left: -6px;\n    margin-top: -3px;\n    width: 0;\n    @include transform(rotate(45deg) translateY(-50%));\n}\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n    border-color: $black;;\n    border-width: 2px 0 0 2px;\n    margin-top: 3px;\n    @include margin-padding(null, 3px);\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background: $primary;\n    color: $white;\n}\n.select2-container--focus  {\n    .select2-selection--single{\n        background: $white !important;\n        border-color: $primary;\n    }\n}\nspan.select2-container.select2-container--default.select2-container--open {\n    z-index: 9999;\n}\n.select2-container--default .select2-selection--single .select2-selection__rendered,\n.select2-container--default .select2-selection--multiple {\n    box-shadow: 0px 4px 4px 0px #DBDBDB40;\n}\n.select2-container--classic .select2-selection--single,\n.select2-container--default .select2-selection--single,\n.select2-container--default .select2-selection--single .select2-selection__rendered,\n.select2-container--default .select2-selection--single .select2-selection__arrow,\n.select2-container--default .select2-selection--multiple,\n.select2-container--classic .select2-selection--single .select2-selection__arrow,\n.select2-container--classic .select2-selection--single .select2-selection__rendered {\n    border-color: $light-900;\n    color: $text-color;\n    height: 40px;\n    line-height: 40px;\n}\n.select2-container--default .select2-selection--multiple {\n    line-height: 27px;\n    height: auto;\n    min-height: 40px;\n    .select2-selection__choice {\n        padding-left: 5px;\n        padding-right: 20px;\n    }\n    .select2-selection__choice__display {\n        span {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            img {\n                width: 16px;\n                height: 16px;\n                border-radius: 5px;\n                margin-right: 5px;\n            }\n        }\n    }\n    .select2-selection__choice__remove {\n        right: 0;\n        left: auto;\n    }\n}\n.select2-results__option {\n    span {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            img {\n                width: 16px;\n                height: 16px;\n                border-radius: 5px;\n                margin-right: 5px;\n            }\n        }\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n    background-color: $light-300;\n    border-color: $light-300;\n    color: $gray-400;\n    border-radius: 5px;\n}\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n    border-color: $light-900;\n}","table.dataTable {\n    margin: 0 !important;\n    width: 100% !important;\n}\ntable.dataTable>thead .sorting:after, \ntable.dataTable>thead .sorting_asc:after,\ntable.dataTable>thead .sorting_desc:after,\ntable.dataTable>thead .sorting_asc_disabled:after, \ntable.dataTable>thead .sorting_desc_disabled:after {\n    right: 0.5em !important;\n    content: \"\\f175\" !important;\n    font-family: 'Font Awesome 5 Free';\n    bottom: 12px !important;\n    color: #BABFC7 !important;\n    font-size: 12px !important;\n    opacity: 1 !important;\n    position: absolute;\n    font-weight: $font-weight-semibold;\n    line-height: 1px !important;\n}\ntable.dataTable>thead .sorting:before, \ntable.dataTable>thead .sorting_asc:before, \ntable.dataTable>thead .sorting_desc:before, \ntable.dataTable>thead .sorting_asc_disabled:before, \ntable.dataTable>thead .sorting_desc_disabled:before {\n    right: 13px !important;\n    content: \"\\f176\" !important;\n    font-family: 'Font Awesome 5 Free';\n    top: 50% !important;\n    transform: translateY(-50%);\n    color: #BABFC7 !important;\n    font-size: 12px !important;\n    opacity: 1 !important;\n    position: absolute;\n    font-weight: $font-weight-semibold;\n    line-height: 1px !important;\n}\n.dataTables_paginate, #dataTables_paginate {\n    .paging_numbers {\n        float: right;\n    }\n}\n.dataTables_info {\n    padding-right: 15px;\n    font-size: $font-size-12;\n    color: $gray-700;\n    font-weight: $font-weight-semibold;\n}\n.custom-select {\n    min-width: 80px;\n    // background: url(../img/icons/dropdown.svg) no-repeat 95% 50%;\n}\n.dataTables_paginate, #dataTables_paginate {\n    .pagination{\n        justify-content: end;\n        -webkit-justify-content: end;\n        -ms-flex-pack: end;\n        li{\n            @include margin-padding(0 2px, null);\n            a {\n                background: $white;\n                border-color: transparent;\n                border-radius: 5px !important;\n                width: 25px;\n                height: 25px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: $gray-400;\n                &:hover{\n                    background: $green;\n                    color: $white;\n                }\n            }\n            &.active a.page-link{\n                background: $green;\n                border-color: $green;\n                @include rounded(5px);\n                width: 25px;\n                height: 25px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n            &.previous.disabled, &.previous {\n                width: auto;\n                margin: 0 13px 0 0;\n                a {\n                    background-color: transparent;\n                    border: 0;\n                    width: auto;\n                    padding: 0;\n                    i {\n                        margin-right: 8px;\n                    }\n                    &:hover {\n                        color: $green;\n                    }\n                }\n            }\n            &.next.disabled, &.next {\n                width: auto;\n                margin: 0 0 0 13px;\n                a {\n                    background-color: transparent;\n                    border: 0;\n                    width: auto;\n                    padding: 0;\n                    i {\n                        margin-left: 8px;\n                    }\n                    &:hover {\n                        color: $green;\n                    }\n                }\n            }\n        }\n        @include respond-below(custom767) {\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n}\n.dataTables_length, #dataTables_length\n.dataTables_paginate, #dataTables_paginate {\n    margin-top:15px !important;\n}\n.dataTables_length, #dataTables_length {\n    label {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        color: $text-color;\n        font-size: $font-size-14;\n        .form-select {\n            width: 73px;\n            border: 1px solid #E8E8E8;\n            border-radius: 5px;\n            color: $gray-900;\n            margin: 0 8px;\n        }\n        @include respond-below(custom767) {\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-bottom: 10px;\n        }\n    }\n}\n.datatable-length {\n    @include respond-below(custom767) {\n        text-align: center;\n    }\n\n}\ndiv.dataTables_wrapper div.dataTables_info {\n    padding-top: 23px;\n}\ntable.dataTable thead>tr>th.no-sort.sorting_asc:before {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting_asc::after {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting:before {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting::after {\n    display: none;\n}\n.custom-table .table-responsive {\n    border: 1px solid $light-900;\n    border-radius: 6px;\n}\ntable.table.dataTable {\n    & > tbody {\n        > tr {\n            border-color: $light-900;\n            td {\n                color: $gray-400;\n            }\n        } \n    }\n    & > thead > tr {\n        border-color: $light-900;\n            th {\n                color: $gray-900;\n                font-size: $font-size-14;\n                font-weight: $font-weight-medium;\n            }\n    }\n}\n.active>.page-link, .page-link.active {\n    z-index: unset;\n}","/**\n * Swiper 11.2.8\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2025 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: May 23, 2025\n */\n\n/* FONT_START */\n@font-face {\n  font-family: 'swiper-icons';\n  src: url('data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA');\n  font-weight: 400;\n  font-style: normal;\n}\n/* FONT_END */\n:root {\n  --swiper-theme-color: #007aff;\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  --swiper-wrapper-transition-timing-function: initial;\n  */\n}\n:host {\n  position: relative;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1;\n}\n.swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n  display: block;\n}\n.swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);\n  box-sizing: content-box;\n}\n.swiper-android .swiper-slide,\n.swiper-ios .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-horizontal {\n  touch-action: pan-y;\n}\n.swiper-vertical {\n  touch-action: pan-x;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n  display: block;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-autoheight,\n.swiper-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n.swiper-backface-hidden .swiper-slide {\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* 3D Effects */\n.swiper-3d.swiper-css-mode .swiper-wrapper {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-wrapper {\n  transform-style: preserve-3d;\n}\n.swiper-3d {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-slide,\n.swiper-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n/* CSS Mode */\n.swiper-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-css-mode.swiper-horizontal > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-css-mode.swiper-vertical > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper {\n  scroll-snap-type: none;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: none;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper::before {\n  content: '';\n  flex-shrink: 0;\n  order: 9999;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: center center;\n  scroll-snap-stop: always;\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {\n  margin-inline-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before {\n  height: 100%;\n  min-height: 1px;\n  width: var(--swiper-centered-offset-after);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {\n  margin-block-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before {\n  width: 100%;\n  min-width: 1px;\n  height: var(--swiper-centered-offset-after);\n}\n/* Slide styles start */\n/* 3D Shadows */\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-3d .swiper-slide-shadow {\n  background: rgba(0, 0, 0, 0.15);\n}\n.swiper-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,\n.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {\n  animation: swiper-preloader-spin 1s infinite linear;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* Slide styles end */\n.swiper-virtual .swiper-slide {\n  -webkit-backface-visibility: hidden;\n  transform: translateZ(0);\n}\n.swiper-virtual.swiper-css-mode .swiper-wrapper::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n}\n.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after {\n  height: 1px;\n  width: var(--swiper-virtual-size);\n}\n.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after {\n  width: 1px;\n  height: var(--swiper-virtual-size);\n}\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-top-offset: 50%;\n  --swiper-navigation-sides-offset: 10px;\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: var(--swiper-navigation-top-offset, 50%);\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev.swiper-button-hidden,\n.swiper-button-next.swiper-button-hidden {\n  opacity: 0;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-navigation-disabled .swiper-button-prev,\n.swiper-navigation-disabled .swiper-button-next {\n  display: none !important;\n}\n.swiper-button-prev svg,\n.swiper-button-next svg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transform-origin: center;\n}\n.swiper-rtl .swiper-button-prev svg,\n.swiper-rtl .swiper-button-next svg {\n  transform: rotate(180deg);\n}\n.swiper-button-prev,\n.swiper-rtl .swiper-button-next {\n  left: var(--swiper-navigation-sides-offset, 10px);\n  right: auto;\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  right: var(--swiper-navigation-sides-offset, 10px);\n  left: auto;\n}\n.swiper-button-lock {\n  display: none;\n}\n/* Navigation font start */\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n}\n.swiper-button-prev:after,\n.swiper-rtl .swiper-button-next:after {\n  content: 'prev';\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  right: var(--swiper-navigation-sides-offset, 10px);\n  left: auto;\n}\n.swiper-button-next:after,\n.swiper-rtl .swiper-button-prev:after {\n  content: 'next';\n}\n/* Navigation font end */\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  --swiper-pagination-left: auto;\n  --swiper-pagination-right: 8px;\n  --swiper-pagination-bottom: 8px;\n  --swiper-pagination-top: auto;\n  --swiper-pagination-fraction-color: inherit;\n  --swiper-pagination-progressbar-bg-color: rgba(0,0,0,0.25);\n  --swiper-pagination-progressbar-size: 4px;\n  --swiper-pagination-bullet-size: 8px;\n  --swiper-pagination-bullet-width: 8px;\n  --swiper-pagination-bullet-height: 8px;\n  --swiper-pagination-bullet-border-radius: 50%;\n  --swiper-pagination-bullet-inactive-color: #000;\n  --swiper-pagination-bullet-inactive-opacity: 0.2;\n  --swiper-pagination-bullet-opacity: 1;\n  --swiper-pagination-bullet-horizontal-gap: 4px;\n  --swiper-pagination-bullet-vertical-gap: 6px;\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n.swiper-pagination-disabled > .swiper-pagination,\n.swiper-pagination.swiper-pagination-disabled {\n  display: none !important;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-horizontal > .swiper-pagination-bullets,\n.swiper-pagination-bullets.swiper-pagination-horizontal {\n  bottom: var(--swiper-pagination-bottom, 8px);\n  top: var(--swiper-pagination-top, auto);\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));\n  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));\n  display: inline-block;\n  border-radius: var(--swiper-pagination-bullet-border-radius, 50%);\n  background: var(--swiper-pagination-bullet-inactive-color, #000);\n  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n          appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet:only-child {\n  display: none !important;\n}\n.swiper-pagination-bullet-active {\n  opacity: var(--swiper-pagination-bullet-opacity, 1);\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n.swiper-vertical > .swiper-pagination-bullets,\n.swiper-pagination-vertical.swiper-pagination-bullets {\n  right: var(--swiper-pagination-right, 8px);\n  left: var(--swiper-pagination-left, auto);\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;\n  display: block;\n}\n.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  transition: 200ms transform,\n        200ms top;\n}\n.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);\n}\n.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform,\n        200ms left;\n}\n.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform,\n    200ms right;\n}\n/* Fraction */\n.swiper-pagination-fraction {\n  color: var(--swiper-pagination-fraction-color, inherit);\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, 0.25));\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transform-origin: left top;\n}\n.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  transform-origin: right top;\n}\n.swiper-horizontal > .swiper-pagination-progressbar,\n.swiper-pagination-progressbar.swiper-pagination-horizontal,\n.swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: var(--swiper-pagination-progressbar-size, 4px);\n  left: 0;\n  top: 0;\n}\n.swiper-vertical > .swiper-pagination-progressbar,\n.swiper-pagination-progressbar.swiper-pagination-vertical,\n.swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {\n  width: var(--swiper-pagination-progressbar-size, 4px);\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n:root {\n  /*\n  --swiper-scrollbar-border-radius: 10px;\n  --swiper-scrollbar-top: auto;\n  --swiper-scrollbar-bottom: 4px;\n  --swiper-scrollbar-left: auto;\n  --swiper-scrollbar-right: 4px;\n  --swiper-scrollbar-sides-offset: 1%;\n  --swiper-scrollbar-bg-color: rgba(0, 0, 0, 0.1);\n  --swiper-scrollbar-drag-bg-color: rgba(0, 0, 0, 0.5);\n  --swiper-scrollbar-size: 4px;\n  */\n}\n.swiper-scrollbar {\n  border-radius: var(--swiper-scrollbar-border-radius, 10px);\n  position: relative;\n  touch-action: none;\n  background: var(--swiper-scrollbar-bg-color, rgba(0, 0, 0, 0.1));\n}\n.swiper-scrollbar-disabled > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-disabled {\n  display: none !important;\n}\n.swiper-horizontal > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-horizontal {\n  position: absolute;\n  left: var(--swiper-scrollbar-sides-offset, 1%);\n  bottom: var(--swiper-scrollbar-bottom, 4px);\n  top: var(--swiper-scrollbar-top, auto);\n  z-index: 50;\n  height: var(--swiper-scrollbar-size, 4px);\n  width: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));\n}\n.swiper-vertical > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-vertical {\n  position: absolute;\n  left: var(--swiper-scrollbar-left, auto);\n  right: var(--swiper-scrollbar-right, 4px);\n  top: var(--swiper-scrollbar-sides-offset, 1%);\n  z-index: 50;\n  width: var(--swiper-scrollbar-size, 4px);\n  height: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: var(--swiper-scrollbar-drag-bg-color, rgba(0, 0, 0, 0.5));\n  border-radius: var(--swiper-scrollbar-border-radius, 10px);\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n/* Zoom container styles start */\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n/* Zoom container styles end */\n.swiper-slide-zoomed {\n  cursor: move;\n  touch-action: none;\n}\n/* a11y */\n.swiper .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-grid > .swiper-wrapper {\n  flex-wrap: wrap;\n}\n.swiper-grid-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n.swiper-fade.swiper-free-mode .swiper-slide {\n  transition-timing-function: ease-out;\n}\n.swiper-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity;\n}\n.swiper-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-fade .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper.swiper-cube {\n  overflow: visible;\n}\n.swiper-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-cube.swiper-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n.swiper-cube .swiper-slide-active,\n.swiper-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-cube .swiper-slide-active,\n.swiper-cube .swiper-slide-next,\n.swiper-cube .swiper-slide-prev {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n  z-index: 0;\n}\n.swiper-cube .swiper-cube-shadow:before {\n  content: '';\n  background: #000;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  filter: blur(50px);\n}\n.swiper-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n/* Cube slide shadows start */\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-top,\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-bottom,\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-left,\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* Cube slide shadows end */\n.swiper.swiper-flip {\n  overflow: visible;\n}\n.swiper-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-flip .swiper-slide-active,\n.swiper-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n/* Flip slide shadows start */\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-top,\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-bottom,\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-left,\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* Flip slide shadows end */\n.swiper-creative .swiper-slide {\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  overflow: hidden;\n  transition-property: transform, opacity, height;\n}\n.swiper.swiper-cards {\n  overflow: visible;\n}\n.swiper-cards .swiper-slide {\n  transform-origin: center bottom;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
